const mobile_translations = {};mobile_translations.id_ID = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Semua",
    "mobile_common_button_apply_filters": "Terapkan Filter",
    "mobile_common_button_done": "Selesai",
    "mobile_common_button_edit": "Edit",
    "mobile_common_button_archive": "Arsipkan",
    "mobile_common_button_save": "Simpan",
    "mobile_common_button_retake": "Ambil Ulang",
    "mobile_common_button_save_draft": "Simpan Rancangan",
    "mobile_common_button_discard": "Buang",
    "mobile_common_button_submit": "Serahkan",
    "mobile_common_button_no": "Tidak",
    "mobile_common_button_yes": "Ya",
    "mobile_common_button_na": "T/A",
    "mobile_common_created_by_me": "Dibuat oleh Saya",
    "mobile_common_email": "Email Perusahaan",
    "mobile_common_first_name": "Nama Depan",
    "mobile_common_last_name": "Nama Belakang",
    "mobile_common_location": "Lokasi",
    "mobile_common_locations": "Lokasi",
    "mobile_common_logout_message": "Anda yakin ingin keluar?",
    "mobile_common_password": "Kata Sandi",
    "mobile_common_permission_required": "Perlu Izin",
    "mobile_common_status": "Status",
    "mobile_common_task": "Tugas",
    "mobile_common_tasks": "Tugas",
    "mobile_common_tasks_my": "Tugas Saya",
    "mobile_common_projects": "Proyek",
    "mobile_common_filter_team": "Tim",
    "mobile_common_filter_var_in": " dalam {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Tidak ada tim yang dipilih",
    "mobile_common_filter_no_user_selected": "Tidak ada pengguna yang dipilih",
    "mobile_common_filter_no_role_selected": "Tidak ada peran yang dipilih",
    "mobile_common_placeholder_date": "Tanggal",
    "mobile_common_message_task_creator_error_save": "<b>Tidak bisa membuat tugas.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "untuk",
    "mobile_common_reload": "Muat Ulang",
    "mobile_common_override": "Kesampingkan",
    "mobile_common_notifications": "Notifikasi",
    "mobile_common_chat_unavailable": "Obrolan Tak Tersedia. Cobalah lagi nanti.",
    "mobile_common_chat_ending_dialog_title": "Anda sudah selesai dengan percakapan ini?",
    "mobile_common_chat_ending_dialog_description": "Beri tahu kami jika masalah Anda telah diselesaikan atau jika hanya ingin melanjutkan nanti.",
    "mobile_common_chat_ending_dialog_confirm": "Ya, saya sudah selesai",
    "mobile_common_chat_ending_dialog_cancel": "Saya akan melanjutkan nanti",
    "mobile_common_continue_editing": "Lanjutkan Mengedit",
    "mobile_privacy_policy": "Kebijakan Privasi",
    "wootric_recommend_target": "teman atau kolega di industri Anda",
    "wootric_followup_detractor_question": "Perubahan apa yang bisa kami lakukan untuk Anda agar memberi kami peringkat lebih tinggi di saat berikutnya?",
    "wootric_followup_passive_question": "Terima kasih! Apa yang bisa kami lakukan untuk membuat alat ini lebih baik lagi?",
    "wootric_followup_promoter_question": "Terima kasih! Apa yang Anda sukai dari Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Terima kasih! Apa yang Anda sukai dari Zenput?",
    "wootric_default_followup_question": "Terima kasih! Bisa ceritakan alasannya?",
    "wootric_default_placeholder_text": "Bantu kami dengan menjelaskan skor Anda.",
    "wootric_default_thankyou_text": "Terima kasih untuk respons dan masukan Anda!",
    "mobile_login_placeholder_login_as": "Login Sebagai ID Pengguna",
    "mobile_login_button_forgot_password": "Lupa Kata Sandi?",
    "mobile_login_button_sign_up": "Buat Akun",
    "mobile_login_button_finish_setup": "Selesaikan Penyiapan",
    "mobile_login_button": "Login",
    "mobile_login_continue_button": "Lanjutkan",
    "mobile_login_continue_transition": "membawa Anda ke halaman login organisasi Anda...",
    "mobile_login_no_email_error": "Anda harus memasukkan email.",
    "mobile_login_change_email": "Login dengan email berbeda",
    "mobile_login_with_sso": "Masuk dengan SSO",
    "mobile_oauth_no_user_error_message": "Sepertinya Anda belum punya akun Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Sepertinya Anda tidak mempunyai Akun Zenput!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> kini menjadi <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} kini menjadi {{- product }} di bulan September. {{- cta }}",
    "mobile_rebrand_warning_cta": "Pelajari cara mempersiapkan.",
    "mobile_oauth_no_user_error_sub_message": "Hubungi admin Anda untuk mendapatkan akses atau cobalah masuk dengan email berbeda.",
    "mobile_oauth_generic_error_message": "Sepertinya ada masalah untuk masuk, cobalah lagi.",
    "mobile_oauth_force_logout_msg": "Jika masih bermasalah, keluar saja dari provider Anda dengan ",
    "mobile_oauth_force_logout_click": "mengklik di sini.",
    "mobile_sign_up_placeholder_phone": "Nomor Ponsel",
    "mobile_sign_up_placeholder_password_confirm": "Konfirmasi Kata Sandi",
    "mobile_sign_up_button_sign_in": "Masuk",
    "mobile_sign_up_disclaimer_part_1": "Dengan mengklik Buat Akun, berarti Anda menyetujui",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Dengan mengeklik Selesaikan Penyiapan, berarti Anda menyetujui",
    "mobile_sign_up_disclaimer_link_title": " Perjanjian Lisensi",
    "mobile_sign_up_disclaimer_part_2": ", yang menyertakan informasi privasi penting",
    "mobile_dialog_benefits_work_offline": "Bekerja Offline",
    "mobile_dialog_benefits_faster_uploads": "Pengunggahan Lebih Cepat",
    "mobile_dialog_benefits_better_experience": "Pengalaman Lebih Baik",
    "mobile_dialog_benefits_button_download": "Unduh",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution untuk ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput untuk ",
    "mobile_dialog_benefits_button_have": "Saya punya aplikasinya!",
    "mobile_dialog_benefits_button_no_thanks": "Tidak, terima kasih, nanti saja.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Gagal memuat gambar.",
    "mobile_dialog_signature_sign": "Tanda Tangan Di Sini",
    "mobile_dialog_signature_button_clear": "Kosongkan",
    "mobile_account_placeholder_name": "Lokasi/Nama Toko",
    "mobile_account_placeholder_phone": "Telepon",
    "mobile_account_placeholder_address": "Alamat",
    "mobile_account_placeholder_city": "Kota",
    "mobile_account_placeholder_region": "Wilayah",
    "mobile_account_placeholder_zipcode": "Kode Pos",
    "mobile_account_option_select_country": "Pilih Negara",
    "mobile_account_oprion_us": "Amerika Serikat",
    "mobile_account_oprion_select_state": "Pilih Negara Bagian",
    "mobile_account_button_create_location": "Buat Lokasi",
    "mobile_form_message_no_form": "Tidak ada formulir tersedia",
    "mobile_batch_task_message": "Memuat ...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Telepon Seluler",
    "mobile_settings_profile_language": "Bahasa",
    "mobile_settings_profile_temperature_unit": "Satuan Suhu",
    "mobile_settings_profile_use_company_default": "Gunakan default perusahaan",
    "mobile_settings_profile_celsius": "Celcius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Pesan Teks",
    "mobile_settings_notifications_option_push": "Notifikasi Otomatis",
    "mobile_settings_notifications_option_push_email": "Email & Notifikasi Otomatis",
    "mobile_settings_notifications_option_do_not": "Jangan beri tahu",
    "mobile_settings_notifications_category_communication": "Komunikasi",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulir & Pencetus",
    "mobile_settings_devices": "Perangkat",
    "mobile_settings_notifications_sub_category_alerts": "Peringatan",
    "mobile_settings_notifications_sub_category_new_forms_available": "Tersedia Formulir Baru",
    "mobile_settings_notifications_sub_category_task_assigned": "Tugas Diserahkan",
    "mobile_settings_notifications_sub_category_task_completed": "Tugas Diselesaikan",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Pengingat tugas akan jatuh tempo",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Pengingat tugas terlambat",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Peringatan Sensor",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Peringatan Sensor Kritis",
    "mobile_drafts_message": "Anda belum memiliki rancangan.",
    "mobile_drafts_button_delete": "Hapus",
    "mobile_tasks_filter_location_no": "Tidak ada lokasi yang dipilih",
    "mobile_tasks_filter_group_by": "Kelompokkan Menurut",
    "mobile_tasks_filter_sort_by": "Sortir Menurut",
    "mobile_tasks_filter_sorted_by": "Disortir Menurut",
    "mobile_tasks_filter_due_time": "Waktu Jatuh Tempo",
    "mobile_tasks_filter_open_time": "Waktu Buka",
    "mobile_tasks_bucket_due_next_24_hours": "Jatuh Tempo dalam 24 Jam Berikutnya",
    "mobile_tasks_bucket_due_next_7_days": "Jatuh Tempo dalam 7 Hari Berikutnya",
    "mobile_tasks_bucket_open_tasks": "{{type}} Terbuka Tambahan",
    "mobile_tasks_bucket_open_at": "Dibuka: {{- date }} pukul {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Jatuh tempo: {{- date }} pukul {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Tersedia dalam 1 menit",
    "mobile_tasks_bucket_available_in_one_hour": "Tersedia dalam 1 jam",
    "mobile_tasks_bucket_available_in_one_day": "Tersedia dalam 1 hari",
    "mobile_tasks_bucket_available_in_one_week": "Tersedia dalam 1 minggu",
    "mobile_tasks_bucket_available_in_one_month": "Tersedia dalam 1 bulan",
    "mobile_tasks_bucket_available_in_one_year": "Tersedia dalam 1 tahun",
    "mobile_tasks_bucket_available_in_minutes": "Tersedia dalam {{ minutes }} menit",
    "mobile_tasks_bucket_available_in_hours": "Tersedia dalam {{ hours }} jam",
    "mobile_tasks_bucket_available_in_days": "Tersedia dalam {{ days }} hari",
    "mobile_tasks_bucket_available_in_weeks": "Tersedia dalam {{ weeks }} minggu",
    "notification_task_due_in_minutes": "Jatuh tempo dalam waktu {{ minutes }} menit",
    "mobile_tasks_bucket_available_in_months": "Tersedia dalam {{ months }} bulan",
    "mobile_tasks_bucket_available_in_years": "Tersedia dalam {{ years }} tahun",
    "mobile_tasks_follow_up": "Tindak Lanjuti Tugas",
    "mobile_tasks_due_soon": "Segera jatuh tempo",
    "mobile_tasks_bucket_completed_today": "Selesai Hari Ini",
    "mobile_tasks_bucket_completed_this_week": "Selesai Minggu Ini",
    "mobile_tasks_bucket_completed_last_week": "Selesai Minggu Lalu",
    "mobile_tasks_bucket_missed_today": "Terlewat Hari Ini",
    "mobile_tasks_bucket_missed_this_week": "Terlewat Minggu Ini",
    "mobile_tasks_bucket_missed_last_week": "Terlewat Minggu Lalu",
    "mobile_tasks_bucket_no_location": "Tidak Ada Lokasi",
    "mobile_tasks_cannot_submit_missed": "Tugas terlewat yang tidak dapat diselesaikan",
    "mobile_tasks_cannot_submit_missed_after": "Tugas ini tidak dapat diselesaikan setelah {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Tugas ini belum dimulai.",
    "mobile_tasks_cannot_submit_processing": "Serahan ini sedang diproses",
    "mobile_tasks_toolbarnav_header_no_due_date": "Tanpa Tanggal Batas",
    "mobile_tasks_toolbarnav_header_overdue": "Lewat Batas Waktu",
    "mobile_tasks_toolbarnav_header_yesterday": "Kemarin",
    "mobile_tasks_toolbarnav_header_today": "Hari Ini",
    "mobile_tasks_toolbarnav_header_tomorrow": "Besok",
    "mobile_tasks_toolbarnav_header_last_week": "Minggu Lalu",
    "mobile_tasks_toolbarnav_header_this_week": "Minggu Ini",
    "mobile_tasks_toolbarnav_header_next_week": "Minggu Depan",
    "mobile_tasks_toolbarnav_header_this_month": "Bulan Ini",
    "mobile_tasks_toolbarnav_header_next_year": "Tahun Depan",
    "mobile_tasks_toolbarnav_header_over_year": "Lebih Dari Setahun",
    "mobile_tasks_toolbarnav_title_edit_task": "Edit Tugas",
    "mobile_task_placeholder_title": "Sebutan *",
    "mobile_task_placeholder_description": "Deskripsi (opsional)",
    "mobile_task_button_single_task": "Tugas Tunggal",
    "mobile_task_button_project": "Proyek",
    "mobile_task_button_create": "Buat",
    "mobile_task_tab_basic": "Dasar",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formulir",
    "mobile_task_details_description_message_please": "Silakan isi ",
    "mobile_task_details_description_message_below": "di bawah ini.",
    "mobile_task_details_description_message_instructions": "Instruksi untuk tugas ini tidak tersedia.",
    "mobile_task_details_reason_title": "Tindak Lanjut Dicetuskan oleh",
    "mobile_task_detials_button_goto_form": "Ke Formulir",
    "mobile_task_detials_button_complete": " Selesaikan Tugas",
    "mobile_task_detials_completed": "Selesai ",
    "mobile_task_detials_completed_by": "oleh ",
    "mobile_task_detials_completed_on": "pada ",
    "mobile_task_details_view_form_submission": "Lihat Serahan Formulir",
    "mobile_task_task_updated": "Tugas telah diperbarui",
    "mobile_task_task_archived": "Tugas telah diarsipkan",
    "mobile_task_task_deleted": "Tugas telah dihapus",
    "mobile_task_error_archiving_task": "Tidak dapat mengarsipkan tugas.",
    "mobile_task_error_deleting_task": "Tidak dapat menghapus tugas.",
    "mobile_task_error_updating_task": "Tidak dapat memperbarui tugas.",
    "mobile_task_archive_task": "Arsipkan Tugas",
    "mobile_task_archive_task_confirm": "Anda yakin ingin mengarsipkan Tugas ini?\n\nTugas yang diarsipkan akan diperhitungkan terhadap tingkat penyelesaian dan akan tetap disertakan dalam pelaporan.\n\nIni tidak bisa diurungkan.",
    "mobile_task_delete_task_confirm": "Anda yakin ingin menghapus tugas ini?\n\nTugas yang telah dihapus tidak akan diperhitungkan terhadap tingkat penyelesaian maupun disertakan dalam pelaporan.\n\nIni tidak bisa diurungkan.",
    "mobile_task_edition_already_in_progress": "Tugas ini memiliki editan yang menunggu. Pengeditan lebih lanjut saat ini tidak diizinkan.",
    "mobile_projects_filter_type": "Tipe",
    "mobile_projects_filter_status": "Status proyek",
    "mobile_projects_filter_project_type": "Tipe proyek",
    "mobile_projects_due_date_required": "Tanggal jatuh tempo harus diisi.",
    "mobile_projects_team_required": "Tim harus diisi.",
    "mobile_projects_user_role_required": "Penerima tugas harus diisi.",
    "mobile_projects_title_required": "Judul harus diisi.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Multi Tugas per Hari",
    "mobile_project_tasks_complete": " Selesaikan",
    "mobile_project_tasks_remaining": " Tersisa",
    "mobile_esitmate_message_tasks": "0 tugas akan dibuat",
    "mobile_esitmate_message_criteria": "Sesuaikan Kriteria Di Atas",
    "mobile_esitmate_message_created_for": "akan dibuat untuk",
    "mobile_left_menu_dashboard": "Dasbor",
    "mobile_left_menu_my_forms": "Formulir Saya",
    "mobile_left_menu_announcements": "Pengumuman",
    "mobile_left_menu_my_submissions": "Penyerahan Saya",
    "mobile_left_menu_drafts": "Rancangan",
    "mobile_left_menu_pending_uploads": "Unggahan Menunggu",
    "mobile_left_menu_open": "Buka Di Aplikasi",
    "mobile_left_menu_settings": "Pengaturan",
    "mobile_left_menu_log_out": "Logout",
    "mobile_left_menu_debug": "Debug",
    "mobile_left_menu_support": "Dukungan",
    "mobile_left_menu_documentation": "Dokumentasi",
    "mobile_left_menu_chat": "Obrolan",
    "mobile_field_textarea_placeholder_note": "Catatan atau keterangan",
    "mobile_field_option_select": "Pilih",
    "mobile_field_text_placeholder_text": "Teks",
    "mobile_field_email_placehoder_email": "Email",
    "mobile_filed_number_placeholder_number": "Nomor",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Tidak Terhubung",
    "mobile_field_sensor_offline_battery": "Sensor Offline - Baterai",
    "mobile_field_video_button_add": "Tambah Video",
    "mobile_field_video_picker_dialog_title": "Tambahkan video dari",
    "mobile_field_video_button_change": "Ubah Video",
    "mobile_field_image_button_add": "Tambah Gambar",
    "mobile_field_image_low_quality_warning": "Beberapa foto mungkin terlalu gelap atau kabur. Tinjau foto yang disorot dan ganti jika perlu.",
    "mobile_field_image_picker_dialog_title": "Tambahkan foto dari",
    "mobile_field_image_picker_edit_failed": "Kami tidak dapat menyimpan gambar. Cobalah lagi.",
    "mobile_field_signature_button_add": "Tambah Tanda Tangan",
    "mobile_field_signature_button_change": "Ubah Tanda Tangan",
    "mobile_field_account_select_location": "Pilih Lokasi",
    "mobile_field_account_prefill": "Isi otomatis formulir dengan data dari Kunjungan terakhir?",
    "mobile_field_account_message_overwrite": "Ini akan menimpa bidang apa pun yang sudah Anda isi.",
    "mobile_forms_task_on_behalf": "Ada tugas yang harus diselesaikan di lokasi ini yang diberikan kepada <b>{{user}}</b>. Anda ingin menyelesaikan tugas ini?",
    "mobile_forms_complete_task": "Selesaikan Tugas?",
    "mobile_field_account_prefill_button_yes": "Ya, isi otomatis",
    "mobile_field_barcode_placeholder_scan": "Pindai atau ketikkan kode batang",
    "mobile_field_sensor_qr_code_placeholder_scan": "Pindai atau ketikkan kode",
    "mobile_field_gateway_id_code_placeholder": "Ketikkan ID Simpul",
    "mobile_field_scan_qr_or_enter_dev_eui": "Pindai Kode QR atau Masukkan DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Pindai Kode QR atau Masukkan Nomor ID",
    "mobile_field_scan_qr_or_enter_sc": "Pindai Kode QR atau Masukkan Kode SC",
    "mobile_field_barcode_select_date": "Pilih Tanggal ",
    "mobile_field_datetime_allow_time": "Waktu",
    "mobile_field_stopwatch_button_caption": "Stopwatch",
    "mobile_field_stopwatch_common_start": "Mulai",
    "mobile_field_stopwatch_common_stop": "Hentikan",
    "mobile_field_stopwatch_common_reset": "Reset",
    "mobile_field_stopwatch_stop_stopwatches": "Hentikan Stopwatch",
    "mobile_field_document_title": "Tambah Dokumen",
    "mobile_field_document_message_delete": "Anda yakin ingin menghapus dokumen ini?",
    "mobile_field_document_alret_button_view": "Lihat",
    "mobile_field_document_alert_error": "Ada kesalahan saat melampirkan dokumen ini. Cobalah lagi.",
    "mobile_field_document_alert_file_size_error": "File tidak boleh melebihi {{count}} MB.",
    "mobile_field_temperature_greater_range": "lebih dari {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "lebih dari atau sama dengan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "kurang dari {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "kurang dari atau sama dengan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "lebih dari atau sama dengan {{ min_temp_value }} °{{ temp_unit }} dan kurang dari {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "lebih dari atau sama dengan {{ min_temp_value }} °{{ temp_unit }} dan kurang dari atau sama dengan {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " dan ",
    "mobile_field_text_limit_error": "Mencapai batas maksimum 8000 karakter.",
    "mobile_forms_required_questions_complete": "Yang Diperlukan Selesai",
    "mobile_forms_required_remaining": "{{count}} Yang Diperlukan Tersisa",
    "mobile_forms_required_questions_back": "Kembali",
    "mobile_forms_required_questions_next": "Berikutnya",
    "mobile_forms_required_questions_skip": "Lewati",
    "mobile_forms_leaving_form": "Meninggalkan Formulir",
    "mobile_message_reordering_confirm": "Anda ingin menyimpan urutan pertanyaan baru ini?",
    "mobile_forms_leaving_reordering": "Meninggalkan Pengurutan Ulang Pertanyaan",
    "mobile_forms_reordering_button_save": "Simpan Urutan Pertanyaan Baru",
    "mobile_forms_reordering_instructions": "Untuk menyusun kembali pertanyaan atau bagian, seret-dan-letakkan ke tempat akan menampilkan bidang dalam formulir",
    "mobile_toolbarnav_title_my_setttings": "Pengaturan Saya",
    "mobile_toolbarnav_title_profile_settings": "Pengaturan Profil",
    "mobile_toolbarnav_title_notification": "Pengaturan Notifikasi",
    "mobile_toolbarnav_title_form_history": "Riwayat Formulir",
    "mobile_toolbarnav_title_form_not_available": "Formulir Tidak Tersedia",
    "mobile_toolbarnav_title_add_location": "Tambah Lokasi",
    "mobile_toolbarnav_title_add_task_or_project": "Tambah Tugas atau Proyek",
    "mobile_toolbarnav_title_select_location": "Pilih Lokasi",
    "mobile_toolbarnav_title_select_project": "Pilih Proyek",
    "mobile_toolbarnav_title_select_tag": "Pilih Tag",
    "mobile_toolbarnav_title_select_user": "Pilih Pengguna",
    "mobile_toolbarnav_title_select_template": "Pilih Template",
    "mobile_toolbarnav_title_select_one": "Pilih Satu",
    "mobile_toolbarnav_title_select_multiple": "Pilih Salah Satu atau Beberapa",
    "mobile_toolbarnav_title_select_team": "Pilih Tim",
    "mobile_toolbarnav_title_select_team_or_location": "Pilih Tim atau Lokasi",
    "mobile_toolbarnav_title_filter_tasks": "Filter Tugas",
    "mobile_toolbarnav_title_filter_projects": "Filter Proyek",
    "mobile_toolbarnav_title_filter_project_tasks": "Filter Tugas Proyek",
    "mobile_placeholder_search_bar": "Cari",
    "mobile_placeholder_user_select_role": "Pilih Peran Pengguna",
    "mobile_placeholder_filter_by_team": "Filter menurut tim",
    "mobile_placeholder_assign_to_user_role": "Berikan ke Peran Pengguna",
    "mobile_placeholder_select": "-- Pilih --",
    "mobile_placeholder_account_location_name": "Nama Lokasi",
    "mobile_placeholder_tag_filter_by": "Filter menurut Tag Lokasi",
    "mobile_placeholder_user_type": "Berikan ke Pengguna",
    "mobile_placeholder_acount_type_loading": "Memuat... ",
    "mobile_placeholder_therm_no_bluetooth": "Suhu",
    "mobile_placeholder_blue_therm_connecting": "Menghubungkan ke perangkat...",
    "mobile_placeholder_blue_therm_please_wait": "Silakan tunggu...",
    "mobile_placeholder_blue_therm_tap": "Ketuk untuk membaca.",
    "mobile_placeholder_blue_therm_not_connected": "Tidak terhubung.",
    "mobile_placeholder_testo_tap": "Tahan ▼▲ diikuti dengan ⬆",
    "mobile_message_error_create_task": "Anda harus online untuk menambah tugas.",
    "mobile_message_error_fill_out_form": "Isilah formulir.",
    "mobile_message_error_fill_require_fields": "Isilah bidang yang diperlukan.",
    "mobile_message_error_stop_stopwatch_before_submit": "Hentikan stopwatch sebelum menyerahkan",
    "mobile_message_error_stopwatch_field_required": "Bidang stopwatch harus diisi",
    "mobile_message_error_stopwatch_field_running": "Bidang stopwatch sedang berjalan",
    "mobile_message_error_invalid_equipment_temperature": "Suhu peralatan tidak valid",
    "mobile_message_error_invalid_ingredient_temperature": "Suhu bahan tidak valid",
    "mobile_message_error_location_attributes_unavailable": "Sebagian pertanyaan mungkin tidak tersedia, hubungkan ke internet",
    "mobile_message_alert_running_stopwatches": "Anda memiliki stopwatch yang sedang berjalan.\n\nAnda ingin mengosongkannya?",
    "mobile_message_blue_therm_error": "Koneksi ke Perangkat Bluetooth Putus",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Akses lokasi diperlukan. Aktifkan fitur ini di pengaturan Android Anda.",
    "mobile_message_blue_therm_no_permission_android": "Akses Perangkat Terdekat diperlukan. Aktifkan fitur ini di pengaturan Android Anda.",
    "mobile_message_blue_therm_error_code": "Gagal Menghubungkan:",
    "mobile_message_blue_therm_error_bluetooth": "Aktifkan Bluetooth.",
    "mobile_message_blue_therm_error_device": "Perangkat tidak ditemukan.",
    "mobile_message_blue_therm_error_try_again": "Cobalah Lagi",
    "mobile_message_blue_therm_success": "Perangkat Bluetooth Telah Terhubung!",
    "mobile_message_bluetooth_device_press_button_field": "Tekan tombol di perangkat Anda untuk menghubungkan.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Tekan tombol di perangkat Anda<br />jika tidak melihatnya dicantumkan di sini.",
    "mobile_bluetooth_scan": "Pindai",
    "mobile_bluetooth_scanning": "Memindai",
    "mobile_message_drafts_confirm": "Anda ingin menyimpannya sebagai rancangan?",
    "mobile_message_drafts_toast_saved": "Rancangan Telah Disimpan.",
    "mobile_message_drafts_request_update": "Anda ingin memperbarui rancangan ini?",
    "mobile_message_drafts_form_confirm": "Anda yakin ingin menghapus rancangan ini?",
    "mobile_message_drafts_confirm_delete": "Hapus Rancangan",
    "mobile_message_streams_error_switch": "Tidak bisa mengubah aliran di web",
    "mobile_message_settings_success_saved": "Pengaturan Telah Disimpan",
    "mobile_message_settings_error": "Terjadi kesalahan yang tidak diketahui. Cobalah lagi nanti",
    "mobile_message_profile_settings_error_fields": "Koreksilah bidang yang ditandai.",
    "mobile_message_media_perimission_denied": "Anda ",
    "mobile_message_media_perimission_denied_device": "Penyimpanan Perangkat",
    "mobile_message_image_confirm_remove_image": "Anda yakin ingin menghapus foto ini?",
    "mobile_message_create_account_error_fields": "Isilah bidang yang ditandai.",
    "mobile_message_create_account_success_location_created": "Lokasi Telah Dibuat",
    "mobile_message_task_error_get_location": "Gagal mendapatkan lokasi. Mengurutkan menurut tanggal.",
    "mobile_message_typehead_confirm_save_message": "Anda ingin menyimpan pilihan ini?",
    "mobile_message_typehead_confirm_save_title": "Simpan?",
    "mobile_message_task_creator_error_save_select_form": "Anda harus memilih formulir.",
    "mobile_message_task_creator_error_save_required_fields": "Isilah bidang yang diperlukan.",
    "mobile_message_task_creator_error_save_batch_change": "Ubahlah kriteria supaya cocok dengan satu atau beberapa pengguna",
    "mobile_message_task_detials_error_not_assigned_to_you": "Tugas ini tidak diberikan kepada Anda.<br />Anda tidak bisa menyelesaikannya.",
    "mobile_message_task_detials_error_assigned_to": "Tugas ini diberikan kepada {{user}}.<br />Anda tidak bisa menyelesaikannya.",
    "mobile_message_task_detials_confirm_title": "Meninggalkan Tugas",
    "mobile_message_task_detials_confirm_save_task": "Simpan Tugas",
    "mobile_message_task_detials_confirm_message": "Anda yakin? Perubahan akan hilang.",
    "mobile_message_task_detials_error_view_account": "Tidak Dapat Mengakses Lokasi.",
    "mobile_message_task_detials_error_submit_task": "Tambahkan foto untuk menyelesaikan tugas ini.",
    "mobile_message_task_detials_error_submit_task_project": "Tidak dapat menyimpan proyek. Cobalah lagi nanti.",
    "mobile_message_task_detials_wait_submit_task_created": "Tugas sedang dibuat.<br />Tunggulah beberapa menit sampai tugas terisi.",
    "mobile_message_task_detials_error_submit_task_pending": "Kesalahan, cobalah lagi nanti",
    "mobile_message_task_detials_success_task_complete": "Tugas Selesai",
    "mobile_message_task_error_save_single_task": "Tidak dapat menyimpan tugas. Cobalah lagi nanti.",
    "mobile_message_task_success_save_single_task": "Tugas Telah Dibuat.",
    "mobile_message_show_error_message": "Ada yang salah.",
    "mobile_message_show_success_message": "Berhasil!",
    "mobile_message_show_offline_message": "Anda sedang offline.",
    "mobile_message_show_permission_denied_message": "<b>Perlu Izin.</b> Izinkan Zenput mengakses {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Perlu Izin.</b> Izinkan Zenput dan Browser Anda mengakses {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Sedang Mengunggah",
    "mobile_message_show_upload_in_progress_message": "Unggahan sedang berlangsung",
    "mobile_message_show_form_id_error": "Tidak bisa mengakses formulir yang ditetapkan.",
    "mobile_message_show_single_task_error": "Tidak bisa mengakses tugas yang ditetapkan.",
    "mobile_message_show_submissions_error": "Tidak bisa mengakses serahan yang ditetapkan.",
    "mobile_message_show_submissions_access_denied": "Maaf, Anda tidak memiliki akses ke formulir ini.",
    "mobile_message_send_data_success": "Data telah diunggah ",
    "mobile_message_start_upload_success": "Unggahan Selesai",
    "mobile_message_start_upload_error": "<b>Tidak bisa menyelesaikan unggahan.</b><br>Serahan telah disimpan. Cobalah lagi nanti",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Pembaruan Tersedia",
    "mobile_message_store_upgrade_confirm_message_one": "Harap perbarui aplikasi Ops Execution dari ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Perbaruilah Zenput dari ",
    "mobile_message_store_upgrade_confirm_message_two": " untuk mendapatkan semua fitur terbaru dan perbaikan bug",
    "mobile_message_store_upgrade_confirm_now": "Sekarang",
    "mobile_message_store_upgrade_confirm_later": "Nanti",
    "mobile_message_redirect_confirm_message": "Anda sedang mengisi formulir. Anda ingin menyimpannya sebagai rancangan sebelum melanjutkan?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Anda memiliki {{count}} rancangan yang belum diunggah. Ini akan hilang jika Anda melanjutkan. Anda yakin?",
    "mobile_message_draft_override_message": "Rancangan ini disimpan dari perangkat lain di {{date}}, dan perubahan pada perangkat ini bertentangan. Anda bisa memilih mengesampingkan versi yang ada, atau memuat ulang ke versi terbaru, dan perubahan akan dibuang.",
    "mobile_html_submitting": "Menyerahkan...",
    "mobile_html_offline": "Anda sedang offline!",
    "mobile_html_offline_try_again": "Anda sedang offline. <br/><br/>Cobalah lagi setelah Anda terhubung",
    "mobile_html_something_went_wrong": "Oh oh. Ada yang salah.",
    "mobile_html_something_went_wrong_try_again": "Oh oh. Ada yang salah. Cobalah lagi.",
    "mobile_html_failed_loading_roles": "Gagal memuat peran.",
    "mobile_alert_please_install_for_native": "Harap instal aplikasi Ops Execution untuk menggunakan fitur ini. ",
    "mobile_alert_please_install_for_native_old": "Instal aplikasi asli Zenput untuk menggunakan fitur ini.",
    "mobile_tso_filter_all_tasks": "Semua {{type}}",
    "mobile_tso_filter_my_tasks": "{{type}} Saya",
    "mobile_tso_filter_due_date": "Tanggal Batas Waktu",
    "mobile_tso_filter_date_completed": "Tanggal Selesai",
    "mobile_tso_filter_completed": "Selesai",
    "mobile_tso_filter_completed_late": "Selesai Terlambat",
    "mobile_tso_filter_incomplete": "Belum Selesai",
    "mobile_tso_filter_var_my_tasks": "{{filter_type}} {{type}} Saya",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} yang Dibuat oleh Saya",
    "mobile_tso_filter_var_all_tasks": "Semua {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Tindak Lanjut",
    "mobile_tso_type_all": "Tugas dan Tindak Lanjut",
    "mobile_tso_filter_var_at": " di {{location}}",
    "mobile_tso_filter_group_date_due": ", diurutkan menurut Tanggal Batas Waktu",
    "mobile_tso_filter_group_distance": ", dikelompokkan menurut Lokasi",
    "mobile_tso_filter_start_date": "Tanggal Mulai",
    "mobile_tso_filter_none": "Tidak Ada",
    "mobile_pso_filter_all_projects": "Semua Proyek",
    "mobile_pso_filter_my_projects": "Proyek Saya",
    "mobile_pso_filter_active": "Aktif",
    "mobile_pso_filter_archived": "Diarsipkan",
    "mobile_pso_filter_recurring": "Berulang",
    "mobile_pso_filter_non_recurring": "Tidak Berulang",
    "mobile_pso_filter_var_my_projects": "Proyek {{project_type}} {{active_description}} Saya",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Proyek yang Dibuat oleh Saya",
    "mobile_pso_filter_var_all_projects": "Semua Proyek {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Sepertinya Anda sedang offline. Silakan online untuk melihat hasil.",
    "mobile_empty_list_message_no_submissions": "Tidak Ada Serahan",
    "mobile_empty_list_message_no_activity": "Tidak Ada Aktivitas",
    "mobile_empty_list_message_no_tasks": "Tidak Ada Tugas",
    "mobile_empty_list_message_no_tasks_overdue": "Tidak Ada {{type}} yang Lewat Batas Waktu",
    "mobile_empty_list_message_no_accounts": "Tidak Ada Lokasi",
    "mobile_empty_list_message_no_projects": "Tidak Ada Proyek",
    "mobile_empty_list_message_no_results_found": "Tidak Ditemukan Hasil",
    "mobile_empty_list_message_no_forms_available": "Tidak Ada Formulir Tersedia",
    "mobile_empty_list_message_connection_error": "Kesalahan Koneksi<br />Cobalah lagi.",
    "mobile_empty_list_message_dashboard_error": "Tidak Dapat Memuat Dasbor",
    "mobile_empty_list_message_user_offline": "Anda sedang offline",
    "mobile_action_sheet_media_gallery": "Galeri",
    "mobile_action_sheet_cancel": "Batalkan",
    "mobile_image_preview_text": "Hapus Foto",
    "mobile_mobileform_text": "Serahan Sebelumnya",
    "mobile_mobileform_reorder_fields": "Urutkan Ulang Pertanyaan",
    "mobile_mobileform_follow_up_actions": "Bentuk Tindak Lanjut",
    "mobile_mobileform_follow_up_actions_assign_title": "Tetapkan tindak lanjut",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Tambahkan tindak lanjut berdasarkan pengamatan Anda untuk memastikan masalah tertangani.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Tambahkan Tindak Lanjut",
    "mobile_mobileform_follow_up_actions_assign_button": "Tetapkan Tindak Lanjut",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Lanjutkan Tanpa Menetapkan",
    "mobile_mobileform_follow_up_actions_dialog_title": "Lanjutkan Tanpa Menetapkan Tindak Lanjut?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Jika meneruskan tanpa menetapkan tindak lanjut, Anda tidak akan dapat menambahkannya nanti.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Tetap Lanjutkan",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Bidang ini harus diisi",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Terlalu banyak karakter",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Bidang ini tidak valid",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Kesalahan saat memuat lokasi",
    "mobile_mobileform_add_follow_up_actions_error_users": "Kesalahan saat memuat pengguna",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Tambahkan Tindak Lanjut",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Judul",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Deskripsi",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Perlu Foto",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Jatuh Tempo",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Perbarui Tindak Lanjut",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Hapus Tindak Lanjut?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Ini tidak akan dihapus dan tidak akan ditetapkan.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Hapus Tindak Lanjut",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Anda yakin ingin menghapus Tindak Lanjut ini?\n\nHal ini tidak dapat diurungkan.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Lanjutkan ke Tindak Lanjut",
    "mobile_mobileform_follow_up_actions_completed_notification": "Tindak Lanjut Selesai",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Tindak Lanjut Dihapus",
    "mobile_mobileform_follow_up_actions_update_notification": "Tindak Lanjut Diperbarui",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Tambahkan foto untuk menyelesaikan tindak lanjut ini",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Arahkan ke serahan",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Arahkan ke sumber",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Sumber",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Selesaikan Tindak Lanjut",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Jika Anda membuka serahan, foto dan catatan yang tidak tersimpan akan hilang.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Jika Anda meninggalkan layar ini, semua foto dan catatan yang belum disimpan akan hilang.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Tetap di sini",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Buka serahan",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Buka sumber",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Tinggalkan tindak lanjut ini?",
    "mobile_mobileform_follow_up_actions_submission": "Serahan",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Tindak Lanjut ini ditetapkan kepada {{user}}.<br />Anda tidak dapat menyelesaikannya.",
    "mobile_mobileform_follow_up_actions_leave_description": "Jika Anda meninggalkan layar ini, semua perubahan yang belum disimpan akan hilang.",
    "mobile_mobileform_follow_up_actions_leave": "Tinggalkan",
    "mobile_forms_drafts_text": "Hapus Rancangan",
    "mobile_batch_estimate_user": "Pengguna",
    "mobile_batch_estimate_users": "Pengguna",
    "mobile_table_of_contents": "Daftar Isi",
    "mobile_table_of_contents_required": "Diperlukan",
    "mobile_table_of_contents_optional": "Opsional",
    "mobile_dialog_alert_title": "Peringatan",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Perangkat Bluetooth belum didukung di Windows",
    "mobile_windows_deprecated_message_content_announcement": "Pengumuman",
    "mobile_windows_deprecated_message_title": "Diperlukan pembaruan aplikasi",
    "mobile_windows_deprecated_message_description": "Segera instal Aplikasi Zenput baru di Microsoft Store untuk memastikan pembaruan fungsionalitas penting dan pengalaman Zenput yang optimal.",
    "mobile_dashboard_tcr_graph_name": "Tingkat Penyelesaian Tugas",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 Minggu Terakhir",
    "mobile_dashboard_tcr_legend_company_average": "Rata-rata Perusahaan",
    "mobile_dashboard_tcr_legend_team_average": "Rata-rata Tim",
    "mobile_dashboard_tab_title_summary": "Rangkuman",
    "mobile_dashboard_tab_title_activity": "Aktivitas",
    "mobile_dashboard_card_title_top_triggered_workflows": "Pencetus Teratas",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Kepatuhan",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Minggu Dari",
    "mobile_dashboard_card_filter_form_template_placeholder": "Semua Formulir",
    "mobile_dashboard_card_title_forms_top_nos": "\"No\" yang Sering",
    "mobile_dashboard_zenput_code_no_data_in_range": "Tidak ada data dalam rentang waktu ini.",
    "mobile_dashboard_zenput_code_permission_denied": "Anda tidak memiliki izin untuk melihat ini.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Pilih formulir dari daftar di atas.",
    "mobile_dashboard_zenput_code_unknown_error": "Kami tidak bisa menampilkan data pada saat ini.",
    "mobile_dashboard_tap_to_retry": "Ketuk untuk Coba Lagi",
    "mobile_dashboard_reporting_delay_disclaimer": "Pembaruan tugas mungkin perlu waktu hingga 15 menit",
    "mobile_dashboard_configuration_down_state_postfix_msg": "telah dikonfigurasi oleh administrator Anda.",
    "mobile_tasks_tag": "tugas",
    "mobile_workflows_tag": "pencetus",
    "mobile_projects_tag": "proyek berulang",
    "mobile_forms_tag": "formulir",
    "mobile_dashboard_card_ongoing_projects_title": "Proyek Yang Berlangsung",
    "mobile_dashboard_card_ongoing_projects_show_more": "Tampilkan Minimal",
    "mobile_dashboard_card_ongoing_projects_show_less": "Tampilkan Maksimal",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Ke Proyek",
    "mobile_dashboard_card_title_recurring_projects": "Proyek Berulang",
    "mobile_dashboard_card_filter_daily": "Harian",
    "mobile_dashboard_card_filter_weekly": "Mingguan",
    "mobile_dashboard_card_filter_monthly": "Bulanan",
    "mobile_task_status_title_open": "Buka",
    "mobile_task_status_title_upcoming": "Mendatang",
    "mobile_task_status_title_complete": "Selesaikan",
    "mobile_task_status_title_processing": "Pemrosesan Serahan",
    "mobile_task_status_title_complete_with_exceptions": "Selesaikan dengan Tugas atau Peringatan Tindak Lanjut",
    "mobile_task_status_title_completed_late_with_exceptions": "Selesai Terlambat dengan Tugas Tindak Lanjut atau Peringatan",
    "mobile_task_status_title_incomplete_and_closed": "Terlewat",
    "mobile_tasks_legend_modal_title": "Keterangan",
    "mobile_tasks_legend_modal_footer_button_title": "Tutup",
    "mobile_common_assigned_to": "Diberikan Kepada",
    "mobile_common_created_by": "Dibuat oleh",
    "mobile_common_tasks_for": "Tugas untuk",
    "mobile_common_go_back": "Kembali",
    "mobile_oh_no": "Oh, Tidak!",
    "mobile_user_not_in_groups": "Maaf, sepertinya Anda belum ditetapkan ke suatu tim. Hubungi administrator Anda untuk mendapat akses ke dashboard Anda.",
    "mobile_tasks_select_followers": "Pilih Pengikut",
    "mobile_tasks_assign_tasks": "Berikan {{count}} Tugas",
    "mobile_tasks_add_followers": "Tambah Pengikut",
    "mobile_tasks_followers": "Pengikut",
    "mobile_tasks_delete_task": "Hapus Tugas",
    "mobile_tasks_create_task": "Buat Tugas",
    "mobile_tasks_tab_title_comments": "Komentar",
    "mobile_tasks_see_more": "Lihat selengkapnya",
    "mobile_projects_create_project": "Buat Proyek",
    "mobile_common_button_send": "Kirim",
    "mobile_common_button_schedule": "Jadwal",
    "mobile_announcements_create": "Buat Pengumuman",
    "mobile_announcements_read_rate": "{{opened_count}} dari {{recipients_count}} telah Membuka",
    "mobile_announcements_empty_message": "Anda belum membuat pengumuman! Buat pengumuman di bawah ini untuk menyiarkan berita penting, informasi, dan kabar terbaru untuk organisasi Anda.",
    "mobile_announcement_message_placeholder": "Tambahkan pesan...",
    "mobile_announcement_title_placeholder": "Judul Pengumuman",
    "mobile_announcement_leaving_announcement": "Pengumuman Berhenti",
    "mobile_announcement_confirm_recipients_team": "Anda ingin menyiarkan pengumuman ini kepada {{count}} pengguna di {{teams}} tim yang dipilih?",
    "mobile_announcement_confirm_recipients_role": "Anda ingin menyiarkan pengumuman ini kepada {{count}} pengguna di {{roles}} peran pengguna yang dipilih?",
    "mobile_announcement_confirm_recipients_user": "Anda ingin menyiarkan pengumuman ini kepada {{count}} pengguna?",
    "mobile_announcement_confirm_scheduled": "Pada {{timestamp}}",
    "mobile_announcement_sending_announcement": "Mengirim Pengumuman",
    "mobile_announcement_send_to": "Kirim Kepada",
    "mobile_announcement_sent_to": "Dikirim Kepada",
    "mobile_announcement_send_to_role": "Peran",
    "mobile_announcement_attachment_download": "Mengunduh {{filename}}",
    "mobile_announcement_attachment_validation_error": "Lampiran yang dapat ditambahkan maksimal {{maxCount}}",
    "mobile_announcement_details_sent": "Dikirim",
    "mobile_announcement_details_total_recipients": "Total Penerima",
    "mobile_announcement_details_cancel": "Batalkan Pengumuman",
    "mobile_announcement_details_not_editable": "Pengumuman hanya dapat diedit di aplikasi web Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Pengumuman hanya dapat diedit di Zenput Web",
    "mobile_announcement_details_open_count": "Hitungan Dibuka",
    "mobile_announcement_details_open_rate": "Kecepatan Dibuka",
    "mobile_announcement_details_resend": "Kirim ulang kepada yang belum membuka",
    "mobile_announcement_confirm_resend": "{{count}} pengguna belum membaca pengumuman. Anda ingin mengirim pengingat?",
    "mobile_announcement_confirm_resend_title": "Kirim Pengingat?",
    "mobile_announcement_recipients_opened": "Dibuka",
    "mobile_recipients_opened_empty_message": "Sepertinya belum seorang pun membuka pesan Anda. Kembali lagi nanti untuk melihat hasilnya.",
    "mobile_announcement_recipients_unopened": "Belum Dibuka",
    "mobile_recipients_unopened_empty_message": "Kabar baik! Tidak ada pesan yang belum dibuka!",
    "mobile_scheduled_announcements_delivery_section_header": "Waktu Pengiriman",
    "mobile_scheduled_announcements_send_immediately_label": "Kirim segera",
    "mobile_scheduled_announcements_scheduled_label": "Kirim pada waktu tertentu",
    "mobile_scheduled_announcements_scheduled_tab_label": "Terjadwal",
    "mobile_scheduled_announcements_dialog_header": "Batalkan Pengumuman?",
    "mobile_scheduled_announcements_dialog_message": "Membatalkan pengumuman Anda akan menghentikan pengirimannya dan menghapusnya dari daftar Anda. Hal ini tidak dapat diurungkan. Untuk mengedit, masuklah ke Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Anda belum memiliki pengumuman terjadwal. Jadwalkan pengumuman untuk menyiarkan berita penting, informasi, dan kabar terbaru untuk organisasi Anda.",
    "mobile_scheduled_announcements_validation_error": "Waktu pengiriman harus setelah {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Jadwalkan Pengumuman",
    "mobile_projects_auto_archive": "Arsipkan Otomatis",
    "mobile_common_unassigned": "Tidak Diberikan",
    "mobile_tasks_title_placeholder": "Tugas Atau Formulir Baru",
    "mobile_projects_leaving_project": "Meninggalkan Proyek",
    "mobile_projects_save_project": "Simpan Proyek",
    "mobile_top_triggers_tasks": "Tugas Yang Dicetuskan Teratas",
    "mobile_top_triggers_alerts": "Peringatan Yang Dicetuskan Teratas",
    "mobile_projects_not_started": "Belum Dimulai",
    "mobile_empty_list_message_no_photos": "Tidak Ada Foto",
    "mobile_webfilestore_message_error": "Pilih tipe file yang valid",
    "mobile_notifications_empty_title": "Tidak Ada Notifikasi",
    "mobile_notifications_empty_message": "Aktivitas pada tugas Anda atau aktivitas yang diikuti akan muncul di sini.",
    "mobile_comments_comment_deleted": "Komentar ini telah dihapus.",
    "mobile_comments_comment_placeholder": "Komentar",
    "mobile_comments_task_submitted_at": "Tugas diserahkan pada tanggal {{ date }} pukul {{ time }}",
    "mobile_comments_discard_comment_title": "Buang Komentar?",
    "mobile_comments_discard_confirm_message": "Anda yakin? Komentar Anda akan dihapus.",
    "mobile_comments_delete_comment_title": "Hapus Komentar?",
    "mobile_comments_delete_confirm_message": "Hal ini tidak dapat diurungkan.",
    "mobile_comments_delete_button": "Hapus Komentar",
    "mobile_comments_delete_success_message": "Komentar telah Dihapus",
    "mobile_comments_empty_message_tasks": "Belum ada komentar \n Mulai percakapan mengenai tugas ini.",
    "mobile_comments_empty_message_submissions": "Belum ada komentar \n Mulai percakapan mengenai penyerahan ini.",
    "mobile_comments_empty_message_default": "Belum ada komentar \n Mulai percakapan.",
    "mobile_comments_no_matching_users": "Tidak ada pengguna yang cocok.",
    "mobile_comments_empty_users_to_notify": "Tidak ada pengguna untuk diberi tahu.",
    "mobile_comments_users_cant_view_message": "Pengguna ini tidak dapat melihat komentar ini.",
    "mobile_comments_users_to_notify_title": "Pengguna Yang Akan Diberi Tahu",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} pengguna</a> akan diberi tahu.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} pengguna</a> akan diberi tahu.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> beberapa pengguna untuk memberi tahu mereka.",
    "mobile_comments_mark_read": "Tandai semua sebagai dibaca",
    "mobile_comments_author_mentioned_message": "menyebut Anda di",
    "mobile_comments_author_commented_message": "berkomentar di",
    "mobile_view_pdf": "Lihat PDF",
    "mobile_no_pdf_generated_message": "Tidak ditemukan PDF untuk penyerahan ini. Salinan akan dikirim lewat email kepada Anda sebentar lagi.",
    "mobile_clipboard_copied_success": "Tautan ini disalin ke clipboard Anda.",
    "mobile_share_link": "Bagikan Tautan",
    "mobile_zencam_share": "Bagikan",
    "mobile_zencam_view_details": "Lihat detail",
    "mobile_zencam_details_drawer_header": "Detail",
    "mobile_zencam_submitted_by": "Diserahkan oleh",
    "mobile_zencam_form_title": "Judul Formulir",
    "mobile_zencam_date_submitted": "Tanggal Diserahkan",
    "mobile_oil_quality_warning_message": "Oli hampir kedaluwarsa",
    "mobile_oil_quality_warning_message_subtitle": "Usahakan segera menggantinya",
    "mobile_oil_quality_failure_message": "Kualitas oli menurun",
    "mobile_oil_quality_failure_message_subtitle": "Segera ganti oli",
    "mobile_sensors_set_up_gateway": "Siapkan Gateway",
    "mobile_sensors_set_up_gateway_message": "Sepertinya belum ada perangkat yang disiapkan. Mulailah dengan menambahkan gateway.",
    "mobile_sensors_gateway_plugged_in": "Pastikan steker gateway Anda telah dihubungkan ke stopkontak listrik",
    "mobile_sensors_add_device": "Tambah perangkat",
    "mobile_sensors_name_this_gateway": "Namai gateway ini.",
    "mobile_sensors_name_this_sensor": "Namai sensor ini.",
    "mobile_sensors_device_barcode_information": "Pindai Kode QR atau masukkan ID dan nomor SC dari label perangkat",
    "mobile_sensors_device_eui_information": "Pindai Kode QR atau masukkan DevEUI dari label perangkat",
    "mobile_sensors_gateway_id_information": "Masukkan ID Simpul dari label Gateway",
    "mobile_sensors_id_number": "Nomor {{untranslatedID}}",
    "mobile_sensors_sc_code": "Kode {{untranslatedSCCode}}",
    "mobile_sensors_sensors": "Sensor",
    "mobile_sensors_sensor_deveui_error": "Tidak bisa mendapatkan DevEUI dari QR. Masukkan secara manual.",
    "mobile_sensors_gateways": "Gateway",
    "mobile_sensors_add_sensor": "Tambah Sensor",
    "mobile_sensors_add_gateway": "Tambah Gateway",
    "mobile_sensor_placement_description": "Area apa yang akan dipantau oleh sensor ini?",
    "mobile_sensors_equipment_placement": "Area atau peralatan apa yang akan dipantau oleh sensor ini?",
    "mobile_sensors_equipment": "Peralatan apa yang akan dipantau oleh sensor ini?",
    "mobile_sensors_select_gateway_type": "Pilih tipe gateway",
    "mobile_sensors_select_placement": "Pilih Penempatan",
    "mobile_sensors_select_equipment": "Pilih Peralatan",
    "mobile_sensors_placement": "Penempatan",
    "mobile_sensors_nickname_tip": "Penamaan sensor berdasarkan sebutan pada penempatannya.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Pindai Kode QR",
    "mobile_sensors_enter_manually": "Masukkan Secara Manual",
    "mobile_sensors_wizard_step_one": "Langkah 1",
    "mobile_sensors_wizard_step_two": "Langkah 2",
    "mobile_sensors_wizard_step_three": "Langkah 3",
    "mobile_sensors_wizard_step_four": "Langkah 4",
    "mobile_sensors_wizard_step_five": "Langkah 5",
    "mobile_sensors_wizard_step_six": "Langkah 6",
    "mobile_sensors_initializing": "Sedang inisialisasi...",
    "mobile_sensors_nickname": "Nama Sebutan",
    "mobile_sensors_field_not_blank": "{{field}} tidak boleh kosong.",
    "mobile_sensors_nothing_to_see_here": "Tidak Ada Yang Dilihat Di Sini",
    "mobile_sensors_missing_integration": "Integrasi Sensor Tidak Ada",
    "mobile_sensors_contact_zenput_admin": "Harap hubungi admin Ops Execution di perusahaan Anda.",
    "mobile_sensors_contact_zenput_admin_old": "Hubungi administrator Zenput Anda.",
    "mobile_sensors_contact_manager": "Hubungi pengelola akun Anda untuk menambahkan sensor.",
    "mobile_sensors_device_success_message": "Data sensor mungkin perlu waktu hingga 15 menit untuk memuatnya",
    "mobile_sensors_last_reading": "Pembacaan Terakhir",
    "mobile_sensors_remove_device": "Hapus Perangkat",
    "mobile_sensors_one_day": "1 H",
    "mobile_sensors_one_week": "1 M",
    "mobile_sensors_one_month": "1 B",
    "mobile_sensors_three_months": "1 B",
    "mobile_sensors_six_months": "6 M",
    "mobile_sensors_one_year": "1 T",
    "mobile_sensors_sensor_settings": "Pengaturan Sensor",
    "mobile_sensors_remove_confirm_message": "Anda yakin ingin menghapus perangkat ini?\nHal ini tidak dapat diurungkan.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Nama Peralatan yang Ditautkan",
    "mobile_sensor_cooldown_process": "Proses Pendinginan",
    "mobile_sensor_last_12_hours": "12 Jam Terakhir",
    "mobile_sensor_start_cooldown_process": "Mulai Proses Pendinginan Baru",
    "mobile_sensor_cooldown_process_title": "Proses Pendinginan Dua Tahap",
    "mobile_sensor_cooldown_process_description": "Proses pendinginan dua tahap terdiri dari mendinginkan makanan dari suhu di atas {{ stage1_start_temperature }} menjadi {{ stage1_end_temperature }} dalam waktu dua jam atau kurang, kemudian dari {{ stage1_end_temperature }} menjadi {{ stage2_end_temperature }} dalam waktu empat jam atau kurang.",
    "mobile_sensor_cooldown_process_place_food": "Tempatkan produk makanan dalam kulkas.",
    "mobile_sensor_cooldown_process_insert_sensor": "Masukkan ujung sensor ke dalam produk makanan.",
    "mobile_sensor_cooldown_process_enter_information": "Masukkan informasi di bawah ini.",
    "mobile_sensor_cooldown_process_food_product": "Produk Makanan yang akan didinginkan",
    "mobile_sensor_cooldown_cool_down": "Pendinginan",
    "mobile_sensor_cooldown_select_sensor": "Pilih Sensor",
    "mobile_sensors_cooldown_start_cooldown": "Mulai Pendinginan",
    "mobile_sensors_cooldown_please_enter_food": "Masukkan Produk Makanan",
    "mobile_sensors_cooldown_please_select_sensor": "Pilih Sensor",
    "mobile_sensors_cooldown_status_in_progress": "Sedang Diproses",
    "mobile_sensors_cooldown_status_failed": "Gagal",
    "mobile_sensors_cooldown_status_success": "Berhasil",
    "mobile_sensors_cooldown_stage": "Tahap",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Suhu awal di luar kisaran",
    "mobile_sensors_cooldown_failed_cooldown_process": "Proses Pendinginan Gagal",
    "mobile_sensors_cooldown_cooldown_successful": "Pendinginan Berhasil",
    "mobile_sensors_cooldown_started_cooldown_process": "Memulai Proses Pendinginan",
    "mobile_sensors_cooldown_hour": "jam",
    "mobile_sensors_cooldown_hour_plural": "jam",
    "mobile_sensors_cooldown_minute": "menit",
    "mobile_minutes_plural": "menit",
    "mobile_sensors_last_reading_max_date": "> 1 tahun yang lalu",
    "mobile_sensors_minute_count_ago": "{{count}} menit yang lalu",
    "mobile_sensors_minute_count_ago_plural": "{{count}} menit yang lalu",
    "mobile_sensors_hour_count_ago": "{{count}} jam yang lalu",
    "mobile_sensors_hour_count_ago_plural": "{{count}} jam yang lalu",
    "mobile_sensors_day_count_ago": "{{count}} hari yang lalu",
    "mobile_sensors_day_count_ago_plural": "{{count}} hari yang lalu",
    "mobile_sensors_chart_settings": "Pengaturan Obrolan",
    "mobile_announcement_banner_continue_reading": "Lanjutkan membaca",
    "mobile_compliance_submissions_report": "Laporan Serahan",
    "mobile_compliance_submissions_report_subtitle": "Ekspor data penyelesaian proyek untuk toko ini",
    "mobile_compliance_send_submissions": "Kirim Penyerahan",
    "mobile_compliance_completion_rate_in_last_days": "Kecepatan Penyelesaian dalam {{ days }} Hari Terakhir",
    "mobile_compliance_last_days": "{{ days }} Hari Terakhir",
    "mobile_compliance_send_submissions_to": "Kirim Penyerahan ke",
    "mobile_compliance_send_to_different_email": "Kirim ke Email yang Berbeda",
    "mobile_compliance_email_input_placeholder": "Alamat Email",
    "mobile_compliance_send_submissions_to_legend_title": "Penyerahan",
    "mobile_compliance_send_submissions_to_legend_description_days": "Laporan berisi serahan Anda dari lokasi ini dalam {{ days }} hari terakhir akan dikirim ke email yang dipilih.",
    "mobile_compliance_time_frame": "Jangka Waktu",
    "mobile_compliance_sensor_temperature_log_report": "Laporan Log Suhu Sensor",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Ekspor log suhu untuk toko ini",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kriteria",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Tetapkan kriteria untuk laporan Anda di bawah ini.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Catatan: Sensor yang dinonaktifkan tidak akan ditampilkan dalam laporan",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Pilih jangka waktu. Data log dibatasi maks 30 hari",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Kirim Laporan",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Bulan Ini (Hari ke-1-Hari Ini)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Bulan Lalu",
    "mobile_compliance_sensor_temperature_log_email_title": "Kirim Laporan Ke",
    "mobile_pwa_update_prompt_title": "Perbarui Aplikasi",
    "mobile_pwa_update_prompt_description": "Versi baru aplikasi telah tersedia. Perbaruilah ke versi terbaru.",
    "mobile_pwa_update_prompt_confirm": "Perbarui dan Muat Ulang",
    "mobile_pwa_update_prompt_cancel": "Ingatkan Saya Nanti",
    "notification_title_due_in_one_hour": "Jatuh tempo dalam waktu 1 jam",
    "task_is_due_soon": "\"{{ task_title }}\" akan segera jatuh tempo. Sisihkan waktu sebentar untuk menyelesaikannya.",
    "mobile_photo_quality_warning_header": "Masalah kualitas foto",
    "mobile_photo_quality_dialog_message": "Foto ini mungkin terlalu gelap atau kabur. Anda ingin mengambil foto baru atau melanjutkan dengan yang ini?",
    "mobile_take_new_photo": "Ambil foto baru",
    "mobile_use_this_photo": "Gunakan foto ini"
}};
mobile_translations.ar_SA = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "الكل",
    "mobile_common_button_apply_filters": "تطبيق الفلاتر (المرشحات)",
    "mobile_common_button_done": "تم",
    "mobile_common_button_edit": "تعديل",
    "mobile_common_button_archive": "أرشيف",
    "mobile_common_button_save": "حفظ",
    "mobile_common_button_retake": "إعادة",
    "mobile_common_button_save_draft": "حفظ المسودة",
    "mobile_common_button_discard": "تجاهل",
    "mobile_common_button_submit": "إرسال",
    "mobile_common_button_no": "لا",
    "mobile_common_button_yes": "نعم",
    "mobile_common_button_na": "لا يوجد",
    "mobile_common_created_by_me": "تم إنشاؤها بواسطتي",
    "mobile_common_email": "إيميل الشركة",
    "mobile_common_first_name": "الاسم الأول",
    "mobile_common_last_name": "الاسم الأخير",
    "mobile_common_location": "الموقع",
    "mobile_common_locations": "المواقغ",
    "mobile_common_logout_message": "هل أنت متأكد أنك تود تسجيل الخروج؟",
    "mobile_common_password": "كلمة المرور",
    "mobile_common_permission_required": "الإذن مطلوب",
    "mobile_common_status": "الحالة",
    "mobile_common_task": "مهمة",
    "mobile_common_tasks": "مهام",
    "mobile_common_tasks_my": "مهامي",
    "mobile_common_projects": "مشاريع",
    "mobile_common_filter_team": "فريق",
    "mobile_common_filter_var_in": " في {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "لم يتم اختيار فريق",
    "mobile_common_filter_no_user_selected": "لم يتم تحديد مستخدم",
    "mobile_common_filter_no_role_selected": "لم يتم تحديد دور",
    "mobile_common_placeholder_date": "التاريخ",
    "mobile_common_message_task_creator_error_save": "<b>تعذر إنشاء المهام.</b>",
    "mobile_common_camera": "كاميرا",
    "mobile_common_microphone": "الميكروفون",
    "mobile_common_for": "ل",
    "mobile_common_reload": "أعادة تحميل",
    "mobile_common_override": "تجاوز",
    "mobile_common_notifications": "إشعارات",
    "mobile_common_chat_unavailable": "المحادثة غير متوفرة، برجاء المحاولة لاحقًا.",
    "mobile_common_chat_ending_dialog_title": "هل أنهيت هذه المحادثة؟",
    "mobile_common_chat_ending_dialog_description": "أخبرنا إذا تم حل مشكلتك أو أنك تريد المتابعة لاحقًا.",
    "mobile_common_chat_ending_dialog_confirm": "نعم انهيت الأمر",
    "mobile_common_chat_ending_dialog_cancel": "سأواصل لاحقًا",
    "mobile_common_continue_editing": "متابعة التحرير",
    "mobile_privacy_policy": "سياسة الخصوصية",
    "wootric_recommend_target": "صديق أو زميل في مجال عملك",
    "wootric_followup_detractor_question": "ما التغييرات التي يمكننا إجراؤها لك لمنحنا تصنيفًا أعلى في المرة القادمة؟",
    "wootric_followup_passive_question": "شكرا لك! ما الذي يمكننا القيام به لجعل الأداة أفضل؟",
    "wootric_followup_promoter_question": "شكرًا! ما الذي يعجبك بشأن Crunchtime Ops Execution؟",
    "wootric_followup_promoter_question_old": "شكرا لك! ماذا تحب في Zenput؟",
    "wootric_default_followup_question": "شكرا لك! تهتم لتخبرنا لماذا؟",
    "wootric_default_placeholder_text": "ساعدنا من خلال شرح درجاتك.",
    "wootric_default_thankyou_text": "شكرًا لك على ردك وتعليقاتك!",
    "mobile_login_placeholder_login_as": "تسجيل الدخول كمعرف مستخدم",
    "mobile_login_button_forgot_password": "هل نسيت كلمة السر؟",
    "mobile_login_button_sign_up": "إنشاء حساب",
    "mobile_login_button_finish_setup": "إنهاء الإعداد",
    "mobile_login_button": "تسجيل الدخول",
    "mobile_login_continue_button": "يكمل",
    "mobile_login_continue_transition": "نقلك إلى صفحة تسجيل الدخول الخاصة بمؤسستك...",
    "mobile_login_no_email_error": "يجب إدخال البريد الإلكتروني.",
    "mobile_login_change_email": "تسجيل الدخول باستخدام بريد إلكتروني مختلف",
    "mobile_login_with_sso": "تسجيل الدخول عبر الدخول الموحد",
    "mobile_oauth_no_user_error_message": "يبدو أنك لا تملك حسابًا في Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "يبدو أنه ليس لديك حساب Zenput!",
    "mobile_rebrand_announcement_banner": "تم تغيير اسم <b>Zenput</b> ليصبح الآن <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "سيتحول {{- brand }} إلى {{- product }} في سبتمبر. {{- cta }}",
    "mobile_rebrand_warning_cta": "تعرّف على كيفية الاستعداد.",
    "mobile_oauth_no_user_error_sub_message": "اتصل بالمسؤول للوصول أو حاول تسجيل الدخول باستخدام بريد إلكتروني مختلف.",
    "mobile_oauth_generic_error_message": "يبدو أن هناك مشكلة في تسجيل الدخول ، يرجى المحاولة مرة أخرى.",
    "mobile_oauth_force_logout_msg": "إذا كنت لا تزال تواجه مشكلات ، فقم بتسجيل الخروج من المزود الخاص بك عن طريق ",
    "mobile_oauth_force_logout_click": "النقر هنا.",
    "mobile_sign_up_placeholder_phone": "رقم الخلوي",
    "mobile_sign_up_placeholder_password_confirm": "تأكيد كلمة المرور",
    "mobile_sign_up_button_sign_in": "تسجيل الدخول",
    "mobile_sign_up_disclaimer_part_1": "بالنقر فوق \"إنشاء حساب\" ، فإنك توافق على",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "بالنقر فوق \"إنهاء الإعداد\"، فإنك توافق على",
    "mobile_sign_up_disclaimer_link_title": " اتفاقية الترخيص",
    "mobile_sign_up_disclaimer_part_2": "، والتي تتضمن معلومات خصوصية مهمة",
    "mobile_dialog_benefits_work_offline": "العمل دون اتصال",
    "mobile_dialog_benefits_faster_uploads": "تحميلات أسرع",
    "mobile_dialog_benefits_better_experience": "تجربة أفضل",
    "mobile_dialog_benefits_button_download": "تحميل",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution لـ ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput لـ ",
    "mobile_dialog_benefits_button_have": "لدي التطبيق!",
    "mobile_dialog_benefits_button_no_thanks": "لا شكرا, من الممكن لاحقا",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "فشل في تحميل الصورة",
    "mobile_dialog_signature_sign": "وقع هنا",
    "mobile_dialog_signature_button_clear": "مسح",
    "mobile_account_placeholder_name": "الموقع / اسم المتجر",
    "mobile_account_placeholder_phone": "الهاتف",
    "mobile_account_placeholder_address": "العنوان",
    "mobile_account_placeholder_city": "المدينة",
    "mobile_account_placeholder_region": "المنطقة",
    "mobile_account_placeholder_zipcode": "الرقم البريدي",
    "mobile_account_option_select_country": "اختر الدولة",
    "mobile_account_oprion_us": "الولايات المتحدة",
    "mobile_account_oprion_select_state": "اختر الولاية",
    "mobile_account_button_create_location": "انشاء العنوان",
    "mobile_form_message_no_form": "لا نماذج متاحة",
    "mobile_batch_task_message": "انتظر...",
    "mobile_settings_profile": "الملف الشخصي",
    "mobile_settings_profile_number": "الهاتف الخلوي",
    "mobile_settings_profile_language": "اللغة",
    "mobile_settings_profile_temperature_unit": "وحدة درجة الحرارة",
    "mobile_settings_profile_use_company_default": "استخدام الإعداد الافتراضي للشركة",
    "mobile_settings_profile_celsius": "درجة مئوية",
    "mobile_settings_profile_fahrenheit": "فهرنهايت",
    "mobile_settings_notifications_option_sms": "رسالة نصية",
    "mobile_settings_notifications_option_push": "اشعارات منبثقة",
    "mobile_settings_notifications_option_push_email": "الايميل و اشعارات منبثقة",
    "mobile_settings_notifications_option_do_not": "لا اشعار",
    "mobile_settings_notifications_category_communication": "التواصل",
    "mobile_settings_notifications_category_forms_and_triggers": "النماذج & الحوافز",
    "mobile_settings_devices": "الاجهزة",
    "mobile_settings_notifications_sub_category_alerts": "الإنذارات",
    "mobile_settings_notifications_sub_category_new_forms_available": "النماذج الجديدة متوفرة",
    "mobile_settings_notifications_sub_category_task_assigned": "تم تعيين المهمة",
    "mobile_settings_notifications_sub_category_task_completed": "تم إكمال المهمة",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "تذكير بالمهام المستحقة قريبًا",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "تذكير بالمهام المتأخرة",
    "mobile_settings_notifications_sub_category_sensor_alerts": "إنذارات المستشعر",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "انبيهات المستشعر الهامة",
    "mobile_drafts_message": "ليس لديك أي مسودات بعد",
    "mobile_drafts_button_delete": "حذف",
    "mobile_tasks_filter_location_no": "لا يوجد موقع تم اختياره",
    "mobile_tasks_filter_group_by": "التجميع حسب",
    "mobile_tasks_filter_sort_by": "فرز حسب",
    "mobile_tasks_filter_sorted_by": "تم الفرز حسب",
    "mobile_tasks_filter_due_time": "الموعد المستحق",
    "mobile_tasks_filter_open_time": "الوقت المتاح",
    "mobile_tasks_bucket_due_next_24_hours": "مستحق خلال 24 ساعة القادمة",
    "mobile_tasks_bucket_due_next_7_days": "مستحق خلال 7 أيام القادمة",
    "mobile_tasks_bucket_open_tasks": "المهام المفتوحة الإضافية {{type}}",
    "mobile_tasks_bucket_open_at": "فتح: {{- date }} في {{- time }}",
    "mobile_tasks_bucket_due_by_at": "مستحق في: {{- date }} في {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "متاح خلال دقيقة واحدة",
    "mobile_tasks_bucket_available_in_one_hour": "متاح خلال ساعة واحدة",
    "mobile_tasks_bucket_available_in_one_day": "متاح خلال يوم واحد",
    "mobile_tasks_bucket_available_in_one_week": "متاح خلال أسبوع واحد",
    "mobile_tasks_bucket_available_in_one_month": "متاح خلال شهر واحد",
    "mobile_tasks_bucket_available_in_one_year": "متاح خلال عام واحد",
    "mobile_tasks_bucket_available_in_minutes": "متاح خلال {{ minutes }} دقيقة",
    "mobile_tasks_bucket_available_in_hours": "متاح خلال {{ hours }} ساعة",
    "mobile_tasks_bucket_available_in_days": "متاح خلال {{ days }} يومًا",
    "mobile_tasks_bucket_available_in_weeks": "متاح خلال {{ weeks }} أسبوعًا",
    "notification_task_due_in_minutes": "سيحين موعده بعد {{ minutes }} دقائق",
    "mobile_tasks_bucket_available_in_months": "متاح خلال {{ months }} شهرًا",
    "mobile_tasks_bucket_available_in_years": "متاح خلال {{ years }} عامًا",
    "mobile_tasks_follow_up": "متابعة المهمة",
    "mobile_tasks_due_soon": "مستحق قريبًا",
    "mobile_tasks_bucket_completed_today": "اكتمل اليوم",
    "mobile_tasks_bucket_completed_this_week": "اكتمل هذا الاسبوع",
    "mobile_tasks_bucket_completed_last_week": "اكتمل في اخر اسبوع",
    "mobile_tasks_bucket_missed_today": "غاب اليوم",
    "mobile_tasks_bucket_missed_this_week": "غاب هذا الاسبوع",
    "mobile_tasks_bucket_missed_last_week": "غاب في اخر اسبوع",
    "mobile_tasks_bucket_no_location": "لا موقع",
    "mobile_tasks_cannot_submit_missed": "المهام الفائتة لا يمكن اتمامها",
    "mobile_tasks_cannot_submit_missed_after": "هذه المهمة لا يمكن اتمامتها لاحقا {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "هذه المهمة لم تبدأ",
    "mobile_tasks_cannot_submit_processing": "هذا الاجراء يتم معالجته",
    "mobile_tasks_toolbarnav_header_no_due_date": "لا تاريخ مقرر",
    "mobile_tasks_toolbarnav_header_overdue": "متأخر",
    "mobile_tasks_toolbarnav_header_yesterday": "الأمس",
    "mobile_tasks_toolbarnav_header_today": "اليوم",
    "mobile_tasks_toolbarnav_header_tomorrow": "الغد",
    "mobile_tasks_toolbarnav_header_last_week": "الأسبوع الفائت",
    "mobile_tasks_toolbarnav_header_this_week": "هذا الأسبوع",
    "mobile_tasks_toolbarnav_header_next_week": "الأسبوع المقبل",
    "mobile_tasks_toolbarnav_header_this_month": "هذا الشهر",
    "mobile_tasks_toolbarnav_header_next_year": "السنة المقبلة",
    "mobile_tasks_toolbarnav_header_over_year": "أكثر من عام",
    "mobile_tasks_toolbarnav_title_edit_task": "تعديل مهام",
    "mobile_task_placeholder_title": "العنوان",
    "mobile_task_placeholder_description": "الوصف(اختياري)",
    "mobile_task_button_single_task": "مهمة وحيدة",
    "mobile_task_button_project": "مشروع",
    "mobile_task_button_create": "انشاء",
    "mobile_task_tab_basic": "أساسي",
    "mobile_task_tab_photo": "صورة",
    "mobile_task_tab_form": "نموذج",
    "mobile_task_details_description_message_please": "الرجاء التعبئة ",
    "mobile_task_details_description_message_below": "الأسفل",
    "mobile_task_details_description_message_instructions": "لا تعليمات هذا الأسبوع",
    "mobile_task_details_reason_title": "المتابعة ناجمة عن",
    "mobile_task_detials_button_goto_form": "اذهب للنموذج",
    "mobile_task_detials_button_complete": " مهمة مكتملة",
    "mobile_task_detials_completed": "مكتملة ",
    "mobile_task_detials_completed_by": "بواسطة ",
    "mobile_task_detials_completed_on": "على ",
    "mobile_task_details_view_form_submission": "عرض النموذج المقدم",
    "mobile_task_task_updated": "تم تحديث المهمة",
    "mobile_task_task_archived": "تم أرشفة المهمة",
    "mobile_task_task_deleted": "تم حذف المهمة",
    "mobile_task_error_archiving_task": "لا يمكن أرشفة المهمة",
    "mobile_task_error_deleting_task": "لا يمكن حذف المهمة",
    "mobile_task_error_updating_task": "لا يمكن تحديث المهمة",
    "mobile_task_archive_task": "أرشيف المهمة",
    "mobile_task_archive_task_confirm": "هل أنت متأكد أنك تريد أرشفة هذه المهمة؟\n\nسيتم احتساب المهام المؤرشفة ضمن معدلات الإكمال وسيستمر تضمينها في التقارير.\n\nلا يمكن التراجع عن هذا",
    "mobile_task_delete_task_confirm": "هل أنت متأكد أنك تريد حذف هذه المهمة؟\n\nسيتم احتساب المهام المحذوفة ضمن معدلات الإكمال وسيستمر تضمينها في التقارير.\n\nلا يمكن التراجع عن هذا",
    "mobile_task_edition_already_in_progress": "هذه المهمة لديها تعديل معلق. مزيد من التحرير غير مسموح به حاليا",
    "mobile_projects_filter_type": "النوع",
    "mobile_projects_filter_status": "حالات المشروع",
    "mobile_projects_filter_project_type": "نوع المشروع",
    "mobile_projects_due_date_required": "تاريخ الاستحقاق مطلوب",
    "mobile_projects_team_required": "الفريق مطلوب",
    "mobile_projects_user_role_required": "المحال إليه مطلوب",
    "mobile_projects_title_required": "العنوان مطلوب",
    "mobile_projects_recurring_multiple_tasks_per_day": "مهام متعددة يوميًا",
    "mobile_project_tasks_complete": " اكمال",
    "mobile_project_tasks_remaining": " متبقي",
    "mobile_esitmate_message_tasks": "0 مهام سيتم انشائها",
    "mobile_esitmate_message_criteria": "ضبط المعايير أعلاه",
    "mobile_esitmate_message_created_for": "سيتم إنشائها من أجل",
    "mobile_left_menu_dashboard": "لوحة القيادة",
    "mobile_left_menu_my_forms": "نماذجي",
    "mobile_left_menu_announcements": "الإعلانات",
    "mobile_left_menu_my_submissions": "التقديمات",
    "mobile_left_menu_drafts": "المسودات",
    "mobile_left_menu_pending_uploads": "التحميلات المعلقة",
    "mobile_left_menu_open": "فتح في تطبيق",
    "mobile_left_menu_settings": "الإعدادات",
    "mobile_left_menu_log_out": "تسجيل خروج",
    "mobile_left_menu_debug": "تصحيح",
    "mobile_left_menu_support": "دعم",
    "mobile_left_menu_documentation": "توثيق",
    "mobile_left_menu_chat": "محادثة",
    "mobile_field_textarea_placeholder_note": "ملاحظة أو تسمية توضيحية",
    "mobile_field_option_select": "تحديد",
    "mobile_field_text_placeholder_text": "نص",
    "mobile_field_email_placehoder_email": "بريد إلكتروني",
    "mobile_filed_number_placeholder_number": "الرقم",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "غير متصل",
    "mobile_field_sensor_offline_battery": "بطارية بجهاز مستشعر غير متصل",
    "mobile_field_video_button_add": "اضف مقطع فيديو",
    "mobile_field_video_picker_dialog_title": "إضافة فيديو من",
    "mobile_field_video_button_change": "تغيير الفيديو",
    "mobile_field_image_button_add": "اضافة صورة",
    "mobile_field_image_low_quality_warning": "قد تكون بعض الصور مظلمة أو غير واضحة. يرجى مراجعة الصور المميزة واستبدالها إذا لزم الأمر.",
    "mobile_field_image_picker_dialog_title": "إضافة صورة من",
    "mobile_field_image_picker_edit_failed": "تعذَّر حفظ الصورة. الرجاء المحاولة مرة أخرى.",
    "mobile_field_signature_button_add": "اضافة توقيع",
    "mobile_field_signature_button_change": "تغيير التوقيع",
    "mobile_field_account_select_location": "اختيار موقع",
    "mobile_field_account_prefill": "نموذج التعبئة المسبقة مع تاريخ النموذج في اخر زيارة ؟",
    "mobile_field_account_message_overwrite": "هذا سيكون زائد عن الحقول التي قمت بتعبئتها بالفعل",
    "mobile_forms_task_on_behalf": "توجد مهمة يجب تعبئتها في هذا الموقع المخصص ل <b>{{user}}</b>. هل ترغب في اكمال هذه المهمة؟",
    "mobile_forms_complete_task": "اكمال المهمة ؟",
    "mobile_field_account_prefill_button_yes": "نعم, إملأ",
    "mobile_field_barcode_placeholder_scan": "امسح أو اكتب الرمز الشريطي",
    "mobile_field_sensor_qr_code_placeholder_scan": "مسح الكود ضوئيًا أو كتابته",
    "mobile_field_gateway_id_code_placeholder": "اكتب معرّف العقدة",
    "mobile_field_scan_qr_or_enter_dev_eui": "مسح كود QR ضوئيًا أو إدخال DevEUI",
    "mobile_field_scan_qr_or_enter_id": "مسح كود QR ضوئيًا أو إدخال رقم المعرف",
    "mobile_field_scan_qr_or_enter_sc": "مسح كود QR ضوئيًا أو إدخال كود SC",
    "mobile_field_barcode_select_date": "اختيار تاريخ ",
    "mobile_field_datetime_allow_time": "الوقت",
    "mobile_field_stopwatch_button_caption": "ساعة إيقاف",
    "mobile_field_stopwatch_common_start": "إبدأ",
    "mobile_field_stopwatch_common_stop": "توقف",
    "mobile_field_stopwatch_common_reset": "إعادة",
    "mobile_field_stopwatch_stop_stopwatches": "إيقاف ساعات الإيقاف",
    "mobile_field_document_title": "إضافة مستند",
    "mobile_field_document_message_delete": "هل أنت متأكد أنك تريد حذف هذا المستند",
    "mobile_field_document_alret_button_view": "عرض",
    "mobile_field_document_alert_error": "هنالك خطأ في إرفاق المستند. الرجاء المحاولة مرة أخرى",
    "mobile_field_document_alert_file_size_error": "يجب أن لا يتجاوز الملف {{count}} MB.",
    "mobile_field_temperature_greater_range": "أكبر من {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "أكبر من أو يساوي {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "أقل من {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "أقل من أو يساوي {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "أكبر من أو يساوي {{ min_temp_value }} °{{ temp_unit }} وأقل من {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "أكبر من أو يساوي {{ min_temp_value }} °{{ temp_unit }} وأصغر من أو يساوي {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " و ",
    "mobile_field_text_limit_error": "تم بلوغ الحد الأقصى للحروف وهو 8000.",
    "mobile_forms_required_questions_complete": "مطلوب الاكمال",
    "mobile_forms_required_remaining": "متبقي الاكمال s%{{count}}",
    "mobile_forms_required_questions_back": "الخلف",
    "mobile_forms_required_questions_next": "التالي",
    "mobile_forms_required_questions_skip": "تخطي",
    "mobile_forms_leaving_form": "ترك النموذج",
    "mobile_message_reordering_confirm": "هل تريد حفظ ترتيب السؤال الجديد؟",
    "mobile_forms_leaving_reordering": "مغادرة ترتيب الأسئلة",
    "mobile_forms_reordering_button_save": "حفظ ترتيب السؤال الجديد",
    "mobile_forms_reordering_instructions": "لإعادة ترتيب الأسئلة أو الأقسام، اسحبها وأفلتها حيث ينبغي أن تظهر الحقول في النموذج",
    "mobile_toolbarnav_title_my_setttings": "إعداداتي",
    "mobile_toolbarnav_title_profile_settings": "الإعدادات الشخصية",
    "mobile_toolbarnav_title_notification": "إعدادات الإشعارات",
    "mobile_toolbarnav_title_form_history": "تاريخ النموذج",
    "mobile_toolbarnav_title_form_not_available": "نموذج غير متاح",
    "mobile_toolbarnav_title_add_location": "اضافة موقع",
    "mobile_toolbarnav_title_add_task_or_project": "اضافة مهمة أو مشروع",
    "mobile_toolbarnav_title_select_location": "اختيار موقع",
    "mobile_toolbarnav_title_select_project": "اختيار المشروع",
    "mobile_toolbarnav_title_select_tag": "اختيار علامة",
    "mobile_toolbarnav_title_select_user": "اختيار مستخدم",
    "mobile_toolbarnav_title_select_template": "اختيار قالب",
    "mobile_toolbarnav_title_select_one": "اختيار واحد",
    "mobile_toolbarnav_title_select_multiple": "اختيار واحد أو أكثر",
    "mobile_toolbarnav_title_select_team": "اختيار فريق",
    "mobile_toolbarnav_title_select_team_or_location": "اختيار فريق أو موقع",
    "mobile_toolbarnav_title_filter_tasks": "تصفية المهام",
    "mobile_toolbarnav_title_filter_projects": "تصفية المشاريع",
    "mobile_toolbarnav_title_filter_project_tasks": "تصفية مهام المشروع",
    "mobile_placeholder_search_bar": "بحث",
    "mobile_placeholder_user_select_role": "اختيار دور المستخدم",
    "mobile_placeholder_filter_by_team": "تصفية بواسطة فريق",
    "mobile_placeholder_assign_to_user_role": "منح دور المستخدم",
    "mobile_placeholder_select": "-- اختيار --",
    "mobile_placeholder_account_location_name": "اسم الموقع",
    "mobile_placeholder_tag_filter_by": "تصفية بواسطة علامة موقع",
    "mobile_placeholder_user_type": "منح مستخدم",
    "mobile_placeholder_acount_type_loading": "جار التحميل... ",
    "mobile_placeholder_therm_no_bluetooth": "درجة الحرارة",
    "mobile_placeholder_blue_therm_connecting": "الاتصال بجهاز...",
    "mobile_placeholder_blue_therm_please_wait": "الرجاء الانتظار...",
    "mobile_placeholder_blue_therm_tap": "اضغط للقراءة",
    "mobile_placeholder_blue_therm_not_connected": "لا اتصال",
    "mobile_placeholder_testo_tap": "اضغط باستمرار ▼ ▲ متبوعًا بـ ⬆",
    "mobile_message_error_create_task": "يجب أن تكون متصلا من أجل اضافة مهام",
    "mobile_message_error_fill_out_form": "الرجاء تعبئة النموذج",
    "mobile_message_error_fill_require_fields": "إملأ الحقول المطلوبة",
    "mobile_message_error_stop_stopwatch_before_submit": "أوقف ساعة الإيقاف الخاصة بك قبل التقديم",
    "mobile_message_error_stopwatch_field_required": "حقل ساعة الأيقاف مطلوب",
    "mobile_message_error_stopwatch_field_running": "حقل ساعة الإيقاف يعمل",
    "mobile_message_error_invalid_equipment_temperature": "درجة حرارة المعدات غير صالحة",
    "mobile_message_error_invalid_ingredient_temperature": "درجة حرارة المكون غير صالحة",
    "mobile_message_error_location_attributes_unavailable": "قد تكون بعض الأسئلة غير متوفرة، يُرجى الاتصال بالإنترنت",
    "mobile_message_alert_running_stopwatches": "لديك ساعات إيقاف تعمل.\n\nهل ترغب في مسحها؟",
    "mobile_message_blue_therm_error": "فقد الاتصال بجهاز البلوتوث",
    "mobile_message_blue_therm_no_permission_android_pre_12": "يلزم السماح بالوصول إلى الموقع. قم بتمكين هذه الميزة في إعدادات نظام Android.",
    "mobile_message_blue_therm_no_permission_android": "يلزم السماح بالوصول إلى الأجهزة القريبة. قم بتمكين هذه الميزة في إعدادات نظام Android.",
    "mobile_message_blue_therm_error_code": "فشل في الاتصال",
    "mobile_message_blue_therm_error_bluetooth": "الرجاء تشغيل البلوتوث",
    "mobile_message_blue_therm_error_device": "الجهاز غير موجود",
    "mobile_message_blue_therm_error_try_again": "الرجاء المحاولة مرة أخرى",
    "mobile_message_blue_therm_success": "تم الاتصال بجهاز البلوتوث",
    "mobile_message_bluetooth_device_press_button_field": "اضغط على الزر في جهازك للاتصال",
    "mobile_message_bluetooth_device_press_button_devices_list": "اضغط على الزر الموجود على جهازك <br /> إذا كنت لا ترى أنه مدرج هنا.  ",
    "mobile_bluetooth_scan": "مسح",
    "mobile_bluetooth_scanning": "يمسح",
    "mobile_message_drafts_confirm": "هل ترغب بحفظ هذا كمسودة ؟",
    "mobile_message_drafts_toast_saved": "تم حفظ المسودة",
    "mobile_message_drafts_request_update": "هل ترغب بتحديث هذه المسودة ؟",
    "mobile_message_drafts_form_confirm": "هل أنت متأكد في رغبتك بحذف هذه المسودة ؟",
    "mobile_message_drafts_confirm_delete": "حذف المسودة",
    "mobile_message_streams_error_switch": "لا يمكن تغيير التدفقات على الويب",
    "mobile_message_settings_success_saved": "تم حفظ الإعدادات",
    "mobile_message_settings_error": "حدث خطأ غير معروف. الرجاء المحاولة لاحقا",
    "mobile_message_profile_settings_error_fields": "الرجاء تصحيح الحقول المبرزة",
    "mobile_message_media_perimission_denied": "لك ",
    "mobile_message_media_perimission_denied_device": "تخزين الجهاز",
    "mobile_message_image_confirm_remove_image": "هل أنت متأكد أنك تريد حذف هذه الصورة ؟",
    "mobile_message_create_account_error_fields": "الرجاء تعبئة الحقول المبرزة",
    "mobile_message_create_account_success_location_created": "تم انشاء موقع",
    "mobile_message_task_error_get_location": "فشل في الحصول على موقع. التصنيف حسب التاريخ",
    "mobile_message_typehead_confirm_save_message": "هل تريد حفظ هذه الاختيارات ؟",
    "mobile_message_typehead_confirm_save_title": "حفظ ؟",
    "mobile_message_task_creator_error_save_select_form": "يجب اختيار نموذج",
    "mobile_message_task_creator_error_save_required_fields": "الرجاء تعبئة الحقول المطلوبة",
    "mobile_message_task_creator_error_save_batch_change": "الرجاء تغيير المعايير لمطابقة مستخدم واحد أو أكثر",
    "mobile_message_task_detials_error_not_assigned_to_you": "لم يتم تعيين هذه المهمة لك.<br />لا يمكنك إكمالها.",
    "mobile_message_task_detials_error_assigned_to": "تم تعيين هذه المهمة إلى {{user}}.<br />لا يمكنك إكمالها.",
    "mobile_message_task_detials_confirm_title": "ترك المهمة",
    "mobile_message_task_detials_confirm_save_task": "حفظ المهمة",
    "mobile_message_task_detials_confirm_message": "هل أنت متأكد؟ ستفقد تغييراتك",
    "mobile_message_task_detials_error_view_account": "تعذر الوصول إلى الموقع.",
    "mobile_message_task_detials_error_submit_task": "الرجاء إضافة صورة لإكمال هذه المهمة",
    "mobile_message_task_detials_error_submit_task_project": "تعذر حفظ المشروع. الرجاء المحاولة لاحقا",
    "mobile_message_task_detials_wait_submit_task_created": "يتم الآن إنشاء المهام.<br />الرجاء الانتظار بضع دقائق حتى يتم ملء المهام.",
    "mobile_message_task_detials_error_submit_task_pending": "خطأ. الرجاء المحاولة لاحقا",
    "mobile_message_task_detials_success_task_complete": "المهمة مكتملة",
    "mobile_message_task_error_save_single_task": "تعذر حفظ المهمة. الرجاء المحاولة لاحقا",
    "mobile_message_task_success_save_single_task": "تم إنشاء المهمة",
    "mobile_message_show_error_message": "حدث خطأ ما",
    "mobile_message_show_success_message": "نجاح!",
    "mobile_message_show_offline_message": "أنت حاليا غير متصل",
    "mobile_message_show_permission_denied_message": "<b>إذن مطلوب.</b> الرجاء منح Zenput إذنًا للوصول إلى {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>الإذن مطلوب.</b> الرجاء منح Zenput ومتصفحك إذنًا للوصول إلى {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "يتم التحميل الان",
    "mobile_message_show_upload_in_progress_message": "التحميل قيد التقدم بالفعل",
    "mobile_message_show_form_id_error": "تعذر الوصول الى الحقل المحدد",
    "mobile_message_show_single_task_error": "تعذر الوصول الى المهمة المحددة",
    "mobile_message_show_submissions_error": "تعذر الوصول الى التقديم المحدد",
    "mobile_message_show_submissions_access_denied": "اسف، ليس لديك حق الوصول إلى هذا النموذج.",
    "mobile_message_send_data_success": "تم تحميل البيانات ",
    "mobile_message_start_upload_success": "اكمال التحميل",
    "mobile_message_start_upload_error": "<b>تعذر إكمال التحميل.</b><br>تم حفظ الإرسال. الرجاء معاودة المحاولة في وقت لاحق",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "التحديث متوفر",
    "mobile_message_store_upgrade_confirm_message_one": "يُرجى تحديث تطبيق Ops Execution من ",
    "mobile_message_store_upgrade_confirm_message_one_old": "الرجاء تحديث Zenput من ",
    "mobile_message_store_upgrade_confirm_message_two": " من أجل الحصول على أجدد الميزات واصلاح الاخطاء",
    "mobile_message_store_upgrade_confirm_now": "الان",
    "mobile_message_store_upgrade_confirm_later": "لاحقا",
    "mobile_message_redirect_confirm_message": "أنت حاليا تملأ النموذج. هل ترغب في حفظه كمسودة قبل الاجراء",
    "mobile_message_log_out_confirm_unsynced_drafts": "لديك {{count}} من المسودات التي لم يتم تحميلها بعد. ستفقد هذه إذا واصلت. هل أنت متأكد؟",
    "mobile_message_draft_override_message": "تم حفظ هذه المسودة من جهاز آخر على {{date}} ، والتغييرات على هذا الجهاز متعارضة. يمكنك اختيار تجاوز الإصدار الحالي ، أو إعادة التحميل إلى أحدث إصدار ، وسيتم تجاهل تغييراتك.",
    "mobile_html_submitting": "يتم التقديم...",
    "mobile_html_offline": "انت حاليا غير متصل!",
    "mobile_html_offline_try_again": "أنت حاليا غير متصل. <br/><br/>يرجى المحاولة مرة أخرى بمجرد الاتصال",
    "mobile_html_something_went_wrong": "اوه. حدث خطأ ما",
    "mobile_html_something_went_wrong_try_again": "اوه. حدث خطأ ما. الرجاء المحاولة مرة أخرى",
    "mobile_html_failed_loading_roles": "فشل حفظ الأدوار",
    "mobile_alert_please_install_for_native": "يُرجى تثبيت تطبيق Ops Execution لاستخدام هذه الميزة. ",
    "mobile_alert_please_install_for_native_old": "الرجاء تثبيت تطبيق Zenput الأصلي لاستخدام هذه الميزة",
    "mobile_tso_filter_all_tasks": "كل {{type}}",
    "mobile_tso_filter_my_tasks": "{{type}} الخاص بي",
    "mobile_tso_filter_due_date": "تاريخ الاستحقاق",
    "mobile_tso_filter_date_completed": "تم اكمال التاريخ",
    "mobile_tso_filter_completed": "تم الاكمال",
    "mobile_tso_filter_completed_late": "تم الإكمال في وقت متأخر",
    "mobile_tso_filter_incomplete": "غير مكتمل",
    "mobile_tso_filter_var_my_tasks": "{{filter_type}} {{type}} الخاص بي",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} تم إنشاؤها بواسطتي",
    "mobile_tso_filter_var_all_tasks": "كل {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "إجراءات المتابعة",
    "mobile_tso_type_all": "المهام وإجراءات المتابعة",
    "mobile_tso_filter_var_at": " في s%{{location}}",
    "mobile_tso_filter_group_date_due": "مرتبة حسب تاريخ الاستحقاق",
    "mobile_tso_filter_group_distance": "مجمعة حسب الموقع",
    "mobile_tso_filter_start_date": "تاريخ البدء",
    "mobile_tso_filter_none": "بدون",
    "mobile_pso_filter_all_projects": "جميع المشاريع",
    "mobile_pso_filter_my_projects": "مشاريعي",
    "mobile_pso_filter_active": "نشط",
    "mobile_pso_filter_archived": "مؤرشفة",
    "mobile_pso_filter_recurring": "مكرر",
    "mobile_pso_filter_non_recurring": "غير مكرر",
    "mobile_pso_filter_var_my_projects": "مشاريعي {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} المشاريع التي أنشأتها",
    "mobile_pso_filter_var_all_projects": "جميع المشاريع {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "يبدو أنك غير متصل. الرجاء كن متصلا لتشاهد اي نتيجة",
    "mobile_empty_list_message_no_submissions": "لا تقديمات",
    "mobile_empty_list_message_no_activity": "لا نشاط",
    "mobile_empty_list_message_no_tasks": "لا مهام",
    "mobile_empty_list_message_no_tasks_overdue": "لا توجد مهام متأخرة {{type}}",
    "mobile_empty_list_message_no_accounts": "لا مواقع",
    "mobile_empty_list_message_no_projects": "لا مشاريع",
    "mobile_empty_list_message_no_results_found": "لا نتائج موجودة",
    "mobile_empty_list_message_no_forms_available": "لا نماذج متوفرة",
    "mobile_empty_list_message_connection_error": "خطأ في الاتصال<br />يرجى المحاولة مرة أخرى.",
    "mobile_empty_list_message_dashboard_error": "تعذر تحميل لوحة القيادة",
    "mobile_empty_list_message_user_offline": "أنت حاليا غير متصل",
    "mobile_action_sheet_media_gallery": "المعرض",
    "mobile_action_sheet_cancel": "إلغاء",
    "mobile_image_preview_text": "حذف الصورة",
    "mobile_mobileform_text": "تقديمات سابقة",
    "mobile_mobileform_reorder_fields": "إعادة ترتيب الأسئلة",
    "mobile_mobileform_follow_up_actions": "إجراءات المتابعة",
    "mobile_mobileform_follow_up_actions_assign_title": "تعيين إجراءات المتابعة",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "أضف إجراءات متابعة بناءً على ملاحظاتك لضمان معالجة المشكلات.",
    "mobile_mobileform_follow_up_actions_add_button": "+ إضافة إجراء المتابعة",
    "mobile_mobileform_follow_up_actions_assign_button": "تعيين المتابعات",
    "mobile_mobileform_follow_up_actions_without_assign_button": "المتابعة بدون تعيين",
    "mobile_mobileform_follow_up_actions_dialog_title": "المتابعة بدون تعيين إجراءات المتابعة",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "إذا تابعت دون تعيين أي إجراءات متابعة، فلن تتمكن من إضافتها لاحقًا.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "المتابعة على أي حال",
    "mobile_mobileform_add_follow_up_actions_forms_required": "هذا الحقل مطلوب",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "أحرف كثيرة للغاية",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "هذا الحقل غير صالح",
    "mobile_mobileform_add_follow_up_actions_error_locations": "خطأ أثناء تحميل المواقغ",
    "mobile_mobileform_add_follow_up_actions_error_users": "خطأ أثناء تحميل المسخدمين",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "إضافة متابعة",
    "mobile_mobileform_add_follow_up_actions_forms_title": "العنوان",
    "mobile_mobileform_add_follow_up_actions_forms_description": "الوصف",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "صورة مطلوبة",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "تاريخ الاستحقاق",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "تحديث المتابعة",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "حذف المتابعة؟",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "سيتم حذفها ولن يتم تعيينها.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "حذف المتابعة",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "هل تريد بالفعل حذف إجراء المتابعة هذا؟\n\nلن يمكنك التراجع عن هذه الخطوة.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "الاستمرار في المتابعات",
    "mobile_mobileform_follow_up_actions_completed_notification": "اكتمل إجراء المتابعة",
    "mobile_mobileform_follow_up_actions_deleted_notification": "تم حذف إجراء المتابعة",
    "mobile_mobileform_follow_up_actions_update_notification": "تم تحديث إجراء المتابعة",
    "mobile_mobileform_follow_up_actions_required_photo_error": "يُرجى إضافة صورة لإكمال إجراء المتابعة هذا",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "الانتقال إلى التقديم",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "الانتقال إلى المصدر",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "المصدر",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "استكمال المتابعة",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "إذا فتحت التقديم، فستفقد أي صور أو ملاحظات غير محفوظة.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "إذا غادرت هذه الشاشة، فستفقد أي صور وملاحظات لم يتم حفظها.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "البقاء هنا",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "فتح التقديم",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "المصدر المفتوح",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "مغادرة إجراء المتابعة هذا؟",
    "mobile_mobileform_follow_up_actions_submission": "تقديم",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "تم تعيين إجراء المتابعة هذا إلى {{user}}.<br />لا يمكنك استكماله.",
    "mobile_mobileform_follow_up_actions_leave_description": "إذا غادرت هذه الشاشة، فستفقد أي تغييرات لم يتم حفظها.",
    "mobile_mobileform_follow_up_actions_leave": "مغادرة",
    "mobile_forms_drafts_text": "حذف المسودات",
    "mobile_batch_estimate_user": "المستخدم",
    "mobile_batch_estimate_users": "المستخدمين",
    "mobile_table_of_contents": "جدول جهات الاتصال",
    "mobile_table_of_contents_required": "مطلوب",
    "mobile_table_of_contents_optional": "اختياري",
    "mobile_dialog_alert_title": "إنذار",
    "mobile_dialog_alert_ok": "حسنا",
    "mobile_windows_10_bluetherm_not_supported": "أجهزة Bluetooth غير مدعومة حتى الآن على Windows",
    "mobile_windows_deprecated_message_content_announcement": "إعلان",
    "mobile_windows_deprecated_message_title": "يلزم تحديث التطبيق",
    "mobile_windows_deprecated_message_description": "قم بتثبيت تطبيق Zenput الجديد من متجر Microsoft في أسرع وقت لضمان تثبيت التحديثات المهمة وتجربةٍ مثالية.",
    "mobile_dashboard_tcr_graph_name": "معدل إنجاز المهمة",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 أسابيع ماضية",
    "mobile_dashboard_tcr_legend_company_average": "متوسط الشركة",
    "mobile_dashboard_tcr_legend_team_average": "متوسط الفريق",
    "mobile_dashboard_tab_title_summary": "الملخص",
    "mobile_dashboard_tab_title_activity": "النشاط",
    "mobile_dashboard_card_title_top_triggered_workflows": "أهم المشغلات",
    "mobile_dashboard_tab_title_info": "معلومات",
    "mobile_dashboard_tab_project_audit": "الالتزام",
    "mobile_dashboard_card_task_stats_total": "الاجمالي",
    "mobile_dashboard_top_item_header_week_of": "أسبوع من",
    "mobile_dashboard_card_filter_form_template_placeholder": "جميع النماذج",
    "mobile_dashboard_card_title_forms_top_nos": "المتكررة \"لا\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "لا توجد بيانات في نطاق الوقت هذا",
    "mobile_dashboard_zenput_code_permission_denied": "ليس لديك إذن لرؤية هذا.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "حدد نموذجا من فوق.",
    "mobile_dashboard_zenput_code_unknown_error": "لا يمكننا عرض البيانات في هذا الوقت",
    "mobile_dashboard_tap_to_retry": "اضغط للاعادة",
    "mobile_dashboard_reporting_delay_disclaimer": "قد يستغرق تحديث المهام ما يصل إلى 15 دقيقة",
    "mobile_dashboard_configuration_down_state_postfix_msg": "تم تكوينها من قبل المسؤول الخاص بك.",
    "mobile_tasks_tag": "المهام",
    "mobile_workflows_tag": "حوافز",
    "mobile_projects_tag": "المشاريع المكررة",
    "mobile_forms_tag": "النماذج",
    "mobile_dashboard_card_ongoing_projects_title": "مشاريع تحت التنفيذ",
    "mobile_dashboard_card_ongoing_projects_show_more": "اظهر المزيد",
    "mobile_dashboard_card_ongoing_projects_show_less": "اظهر اقل",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "اذهب للمشاريع",
    "mobile_dashboard_card_title_recurring_projects": "المشاريع المكررة",
    "mobile_dashboard_card_filter_daily": "يومي",
    "mobile_dashboard_card_filter_weekly": "اسبوعي",
    "mobile_dashboard_card_filter_monthly": "شهري",
    "mobile_task_status_title_open": "مفتوح",
    "mobile_task_status_title_upcoming": "القادمة",
    "mobile_task_status_title_complete": "اكمال",
    "mobile_task_status_title_processing": "معالجة التقديم",
    "mobile_task_status_title_complete_with_exceptions": "أكمل مع مهام المتابعة أو التنبيهات",
    "mobile_task_status_title_completed_late_with_exceptions": "تم إكمال مهام المتابعة أو التنبيهات في وقت متأخر",
    "mobile_task_status_title_incomplete_and_closed": "فائت",
    "mobile_tasks_legend_modal_title": "وسيلة ايضاح",
    "mobile_tasks_legend_modal_footer_button_title": "مغلق",
    "mobile_common_assigned_to": "مخصص ل",
    "mobile_common_created_by": "منشأ بواسطة",
    "mobile_common_tasks_for": "مهام من أجل",
    "mobile_common_go_back": "رجوع",
    "mobile_oh_no": "اوه ، لا!",
    "mobile_user_not_in_groups": "عذرًا ، يبدو أنك لم يتم تعيينك لفريق. اتصل بالمسؤول للوصول إلى لوحة المعلومات الخاصة بك.",
    "mobile_tasks_select_followers": "اختيار متابعين",
    "mobile_tasks_assign_tasks": "قم بتعيين مهام {{count}}",
    "mobile_tasks_add_followers": "اضافة متابعين",
    "mobile_tasks_followers": "متابعين",
    "mobile_tasks_delete_task": "حذف مهمة",
    "mobile_tasks_create_task": "انشاء مهام",
    "mobile_tasks_tab_title_comments": "التعليقات",
    "mobile_tasks_see_more": "رؤية المزيد",
    "mobile_projects_create_project": "انشاء مشروع",
    "mobile_common_button_send": "إرسال",
    "mobile_common_button_schedule": "جدولة",
    "mobile_announcements_create": "إنشاء إعلان",
    "mobile_announcements_read_rate": "تم فتح {{opened_count}} من {{recipients_count}}",
    "mobile_announcements_empty_message": "لم تنشئ أي إعلانات بعد! أنشئ إعلانًا أدناه لبث الأخبار المهمة والمعلومات والتحديثات لمؤسستك.",
    "mobile_announcement_message_placeholder": "اضف رسالة...",
    "mobile_announcement_title_placeholder": "عنوان الإعلان",
    "mobile_announcement_leaving_announcement": "ترك الإعلان",
    "mobile_announcement_confirm_recipients_team": "هل تريد بث هذا الإعلان إلى {{count}} مستخدم (مستخدمين) في {{teams}} فريق (فرق) محدد؟",
    "mobile_announcement_confirm_recipients_role": "هل تريد بث هذا الإعلان إلى {{count}} مستخدم (مستخدمين) في {{roles}} دور (أدوار) مستخدم محدد؟",
    "mobile_announcement_confirm_recipients_user": "هل تريد بث هذا الإعلان إلى {{count}} مستخدم (مستخدمين)؟",
    "mobile_announcement_confirm_scheduled": "في {{timestamp}}",
    "mobile_announcement_sending_announcement": "إرسال الإعلان",
    "mobile_announcement_send_to": "إرسال الى",
    "mobile_announcement_sent_to": "أرسل الى",
    "mobile_announcement_send_to_role": "دور",
    "mobile_announcement_attachment_download": "تنزيل {{filename}}",
    "mobile_announcement_attachment_validation_error": "لا يمكن إضافة أكثر من {{maxCount}} المرفقات",
    "mobile_announcement_details_sent": "أرسل",
    "mobile_announcement_details_total_recipients": "إجمالي المستلمين",
    "mobile_announcement_details_cancel": "إلغاء الإعلان",
    "mobile_announcement_details_not_editable": "لا يمكن تعديل الإعلانات إلا في تطبيق Ops Execution للويب ",
    "mobile_announcement_details_not_editable_old": "لا يجوز تحرير الإعلانات إلا على Zenput Web",
    "mobile_announcement_details_open_count": "فتح عد",
    "mobile_announcement_details_open_rate": "فتح معدل",
    "mobile_announcement_details_resend": "اعد ارسال الى لا فتاحين",
    "mobile_announcement_confirm_resend": "{{count}} لم يقرأ المستخدم (المستخدمون) الإعلان. هل تريد إرسال تذكير؟",
    "mobile_announcement_confirm_resend_title": "إرسال تذكير ؟",
    "mobile_announcement_recipients_opened": "تم الفتح",
    "mobile_recipients_opened_empty_message": "يبدو أن لا أحد فتح رسالتك بعد. عد لاحقًا لترى نتائجك",
    "mobile_announcement_recipients_unopened": "لم يتم الفتح",
    "mobile_recipients_unopened_empty_message": "أخبار جيدة! لا يوجد رسائل غير مفتوحة!",
    "mobile_scheduled_announcements_delivery_section_header": "وقت التسليم",
    "mobile_scheduled_announcements_send_immediately_label": "إرسال فورا",
    "mobile_scheduled_announcements_scheduled_label": "إرسال في وقت محدد",
    "mobile_scheduled_announcements_scheduled_tab_label": "مجدول",
    "mobile_scheduled_announcements_dialog_header": "إلغاء الإعلان ؟",
    "mobile_scheduled_announcements_dialog_message": "سيؤدي إلغاء الإعلان إلى إيقاف إرساله وحذفه من قائمتك. هذا لا يمكن التراجع عنها. للتحرير ، انتقل إلى Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "ليس لديك حاليا أي إعلانات مجدولة. حدد موعدًا لإعلان لبث الأخبار الهامة والمعلومات والتحديثات لمؤسستك.",
    "mobile_scheduled_announcements_validation_error": "يجب أن يكون وقت التسليم بعد {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "جدولة الإعلان",
    "mobile_projects_auto_archive": "أرشف تلقائي",
    "mobile_common_unassigned": "غير معين",
    "mobile_tasks_title_placeholder": "نموذج أو مهمة جديدة",
    "mobile_projects_leaving_project": "ترك المشروع",
    "mobile_projects_save_project": "حفظ المشروع",
    "mobile_top_triggers_tasks": "أفضل المهام المحفزة",
    "mobile_top_triggers_alerts": "أفضل التنبيهات المحفزة",
    "mobile_projects_not_started": "لم يبدأ",
    "mobile_empty_list_message_no_photos": "لا صور",
    "mobile_webfilestore_message_error": "الرجاء اختيار نوع ملف صالح",
    "mobile_notifications_empty_title": "لا إشعارات",
    "mobile_notifications_empty_message": "سيظهر هنا النشاط المتعلق بمهامك أو تلك التي تشارك فيها هنا.",
    "mobile_comments_comment_deleted": "هذا التعليق تم حذفه",
    "mobile_comments_comment_placeholder": "تعليق",
    "mobile_comments_task_submitted_at": "تم إرسال المهمة في {{ date }} عند {{ time }}",
    "mobile_comments_discard_comment_title": "تجاهل التعليق؟",
    "mobile_comments_discard_confirm_message": "هل أنت متأكد؟ سيتم حذف تعليقك",
    "mobile_comments_delete_comment_title": "حذف التعليق ؟",
    "mobile_comments_delete_confirm_message": "هذا لا يمكن التراجع عنها",
    "mobile_comments_delete_button": "حذف التعليق",
    "mobile_comments_delete_success_message": "تم حذف التعليق",
    "mobile_comments_empty_message_tasks": "لا توجد تعليقات حتى الآن \n ابدأ محادثة حول هذه المهمة",
    "mobile_comments_empty_message_submissions": "لا توجد تعليقات حتى الآن \n ابدأ محادثة حول هذا التقديم.",
    "mobile_comments_empty_message_default": "لا توجد تعليقات حتى الآن \n ابدأ محادثة.",
    "mobile_comments_no_matching_users": "لا يوجد مستخدمون متطابقون.",
    "mobile_comments_empty_users_to_notify": "لا يوجد مستخدمين لإعلامهم.",
    "mobile_comments_users_cant_view_message": "لا يمكن لهؤلاء المستخدمين عرض هذه التعليقات",
    "mobile_comments_users_to_notify_title": "مستخدمين للاعلام",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} المستخدم</a> سيتم إعلامه.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }}المستخدمين</a> سيتم إعلامهم.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@اذكر</a>المزيد من المستخدمين لإعلامهم.",
    "mobile_comments_mark_read": "اشر عليها بانها قرات",
    "mobile_comments_author_mentioned_message": "ذكرك في",
    "mobile_comments_author_commented_message": "علق على",
    "mobile_view_pdf": "عرض PDF",
    "mobile_no_pdf_generated_message": "لم يتم العثور على ملف PDF لهذا الإرسال. سيتم إرسال نسخة إليك عبر البريد الإلكتروني قريبًا.",
    "mobile_clipboard_copied_success": "يتم نسخ الارتباط إلى الحافظة الخاصة بك.",
    "mobile_share_link": "مشاركة رابط",
    "mobile_zencam_share": "مشاركة",
    "mobile_zencam_view_details": "عرض التفاصيل",
    "mobile_zencam_details_drawer_header": "التفاصيل",
    "mobile_zencam_submitted_by": "الاسم",
    "mobile_zencam_form_title": "عنوان النموذج",
    "mobile_zencam_date_submitted": "تاريخ التحديث",
    "mobile_oil_quality_warning_message": "صلاحية الزيت على وشك الانتهاء",
    "mobile_oil_quality_warning_message_subtitle": "استعد لتغييره في أقرب وقت",
    "mobile_oil_quality_failure_message": "ضعف فعالية وجودة الزيت الحالي",
    "mobile_oil_quality_failure_message_subtitle": "قم بتغيير الزيت على الفور",
    "mobile_sensors_set_up_gateway": "قم بإعداد البوابة",
    "mobile_sensors_set_up_gateway_message": "يبدو أنه لم يتم إعداد أي أجهزة. ابدأ بإضافة بوابة.",
    "mobile_sensors_gateway_plugged_in": "تأكد من أن البوابة الخاصة بك متصلة بمأخذ طاقة",
    "mobile_sensors_add_device": "اضافة جهاز",
    "mobile_sensors_name_this_gateway": "اسم هذه البوابة",
    "mobile_sensors_name_this_sensor": "اسم هذا المستشعر",
    "mobile_sensors_device_barcode_information": "مسح كود QR ضوئيًا أو إدخال المعرف ورقم SC من ملصق الجهاز",
    "mobile_sensors_device_eui_information": "مسح كود QR ضوئيًا أو إدخال DevEUI من ملصق الجهاز",
    "mobile_sensors_gateway_id_information": "أدخِل معرّف العقدة من تسمية البوابة",
    "mobile_sensors_id_number": "رقم{{untranslatedID}}",
    "mobile_sensors_sc_code": "كود{{untranslatedSCCode}}",
    "mobile_sensors_sensors": "المستشعرات",
    "mobile_sensors_sensor_deveui_error": "لم أتمكن من الحصول على DevEUI من رمز QR. يُرجى إدخاله يدويًا.",
    "mobile_sensors_gateways": "البوابات",
    "mobile_sensors_add_sensor": "اضافة مستشعر",
    "mobile_sensors_add_gateway": "اضافة بوابة",
    "mobile_sensor_placement_description": "ما المنطقة التي سيراقبها هذا المستشعر؟",
    "mobile_sensors_equipment_placement": "ما هي المنطقة أو المعدات التي سيراقبها هذا المستشعر؟",
    "mobile_sensors_equipment": "ما المعدات التي سيراقبها هذا المستشعر؟",
    "mobile_sensors_select_gateway_type": "حدد نوع البوابة",
    "mobile_sensors_select_placement": "اختيار المكان المناسب",
    "mobile_sensors_select_equipment": "حدد المعدات",
    "mobile_sensors_placement": "المكان المناسب",
    "mobile_sensors_nickname_tip": "يُحدد اسم المستشعر من خلال الأسماء المعينة في الموضع المحدد.",
    "mobile_sensors_device_online": "متصل",
    "mobile_sensors_device_offline": "غير متصل",
    "mobile_sensors_scan_qrcode": "مسح QR كود",
    "mobile_sensors_enter_manually": "ادخال يدويا",
    "mobile_sensors_wizard_step_one": "الخطوة 1",
    "mobile_sensors_wizard_step_two": "الخطوة 2",
    "mobile_sensors_wizard_step_three": "الخطوة 3",
    "mobile_sensors_wizard_step_four": "الخطوة 4",
    "mobile_sensors_wizard_step_five": "الخطوة 5",
    "mobile_sensors_wizard_step_six": "الخطوة 6",
    "mobile_sensors_initializing": "جار التهيئة...",
    "mobile_sensors_nickname": "اسم الشهرة",
    "mobile_sensors_field_not_blank": "لا يمكن أن يكون {{field}} فارغًا.",
    "mobile_sensors_nothing_to_see_here": "لا شيء تراه هنا",
    "mobile_sensors_missing_integration": "تكامل المستشعر مفقود",
    "mobile_sensors_contact_zenput_admin": "يُرجى الاتصال بمسؤول Ops Execution في شركتك.",
    "mobile_sensors_contact_zenput_admin_old": "يُرجى الاتصال بمسؤول Zenput الخاص بك.",
    "mobile_sensors_contact_manager": "اتصل بمدير حسابك لإضافة أجهزة استشعار.",
    "mobile_sensors_device_success_message": "قد يستغرق تحميل بيانات المستشعر ما يصل إلى 15 دقيقة",
    "mobile_sensors_last_reading": "اخر قراءة",
    "mobile_sensors_remove_device": "حذف جهاز",
    "mobile_sensors_one_day": "يوم 1",
    "mobile_sensors_one_week": "أسبوع 1",
    "mobile_sensors_one_month": "شهر 1",
    "mobile_sensors_three_months": "3 شهور",
    "mobile_sensors_six_months": "6 أشهر",
    "mobile_sensors_one_year": "عام 1",
    "mobile_sensors_sensor_settings": "إعدادات المستشعر",
    "mobile_sensors_remove_confirm_message": "هل تريد بالتأكيد حذف هذا الجهاز؟\nلا يمكن التراجع عن هذا الإجراء.",
    "mobile_sensors_sensor": "المستشعر",
    "mobile_sensors_no_equipment_linked": "لا توجد معدات مرتبطة",
    "mobile_sensor_cooldown_process": "عملية التبريد",
    "mobile_sensor_last_12_hours": "اخر 12 ساعة",
    "mobile_sensor_start_cooldown_process": "ابدأ عملية التبريد الجديدة",
    "mobile_sensor_cooldown_process_title": "عملية التبريد على مرحلتين",
    "mobile_sensor_cooldown_process_description": "تتألف عملية التبريد من مرحلتين، تبدأ من تبريد الطعام في درجة أكبر من {{ stage1_start_temperature }}وحتى{{ stage1_end_temperature }} في ساعتين أو أقل، ثم من درجة {{ stage1_end_temperature }} وحتى{{ stage2_end_temperature }} في غضون أربع ساعات أو أقل.",
    "mobile_sensor_cooldown_process_place_food": "ضع المنتج الغذائي في الثلاجة.",
    "mobile_sensor_cooldown_process_insert_sensor": "أدخل مجس استشعار في المنتج الغذائي.",
    "mobile_sensor_cooldown_process_enter_information": "أدخل المعلومات أدناه.",
    "mobile_sensor_cooldown_process_food_product": "منتج غذائي للتبريد",
    "mobile_sensor_cooldown_cool_down": "تبريد",
    "mobile_sensor_cooldown_select_sensor": "اختيار مستشعر",
    "mobile_sensors_cooldown_start_cooldown": "بدأ التبريد",
    "mobile_sensors_cooldown_please_enter_food": "الرجاء ادخال منتج غذائي",
    "mobile_sensors_cooldown_please_select_sensor": "الرجاء اختيار مستشعر",
    "mobile_sensors_cooldown_status_in_progress": "قيد التنفيذ",
    "mobile_sensors_cooldown_status_failed": "فشل",
    "mobile_sensors_cooldown_status_success": "نجاح",
    "mobile_sensors_cooldown_stage": "مرحلة",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "درجة حرارة البداية خارج النطاق",
    "mobile_sensors_cooldown_failed_cooldown_process": "فشل عملية التبريد",
    "mobile_sensors_cooldown_cooldown_successful": "نجحت عملية التبريد",
    "mobile_sensors_cooldown_started_cooldown_process": "تم بدء عملية التبريد",
    "mobile_sensors_cooldown_hour": "ساعة",
    "mobile_sensors_cooldown_hour_plural": "ساعات",
    "mobile_sensors_cooldown_minute": "دقيقة",
    "mobile_minutes_plural": "دقائق",
    "mobile_sensors_last_reading_max_date": "> 1 سنة مضت",
    "mobile_sensors_minute_count_ago": "قبل دقيقة{{count}}",
    "mobile_sensors_minute_count_ago_plural": "قبل دقائق{{count}}",
    "mobile_sensors_hour_count_ago": "قبل ساعة {{count}}",
    "mobile_sensors_hour_count_ago_plural": "قبل ساعات{{count}}",
    "mobile_sensors_day_count_ago": "قبل يوم{{count}}",
    "mobile_sensors_day_count_ago_plural": "قبل أيام{{count}}",
    "mobile_sensors_chart_settings": "إعدادات المخطط البياني.",
    "mobile_announcement_banner_continue_reading": "متابعة القراءة",
    "mobile_compliance_submissions_report": "تقرير التقديمات",
    "mobile_compliance_submissions_report_subtitle": "تصدير بيانات اكتمال المشروع لهذا المتجر",
    "mobile_compliance_send_submissions": "إرسال التقديمات",
    "mobile_compliance_completion_rate_in_last_days": "معدل الإتمام خلال آخر {{ days }} من الأيام",
    "mobile_compliance_last_days": "آخر {{ days }} من الأيام",
    "mobile_compliance_send_submissions_to": "إرسال التقديمات إلى",
    "mobile_compliance_send_to_different_email": "الإرسال إلى بريدٍ إلكتروني مختلف",
    "mobile_compliance_email_input_placeholder": "بريد إلكتروني",
    "mobile_compliance_send_submissions_to_legend_title": "التقديمات",
    "mobile_compliance_send_submissions_to_legend_description_days": "سيجرى إرسال تقرير مع طلباتك المقدمة من هذا الموقع خلال آخر {{ days }} من الأيام إلى البريد الإلكتروني المحدد.",
    "mobile_compliance_time_frame": "إطار زمني",
    "mobile_compliance_sensor_temperature_log_report": "تقرير سجل درجة الحرارة المستشعر",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "تصدير سجلات درجات الحرارة لهذا المتجر",
    "mobile_compliance_sensor_temperature_log_criteria_title": "المعايير",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "حدد معايير تقريرك أدناه.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "ملاحظة: لن يظهر المستشعر المُعطّل (المستشعرات المُعطّلة) في التقرير",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "حدد إطار زمني. تقتصر بيانات السجل على 30 يومًا كحدٍ أقصى",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "إرسال تقرير",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "هذا الشهر (اليوم الأول-اليوم)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "الشهر الماضي",
    "mobile_compliance_sensor_temperature_log_email_title": "إرسال تقرير إلى",
    "mobile_pwa_update_prompt_title": "تحديث التطبيق",
    "mobile_pwa_update_prompt_description": "يتوفر إصدار جديد من التطبيق. الرجاء التحديث إلى الإصدار الأحدث.",
    "mobile_pwa_update_prompt_confirm": "تحديث وإعادة تحميل",
    "mobile_pwa_update_prompt_cancel": "تذكيري لاحقًا",
    "notification_title_due_in_one_hour": "سيحين موعده بعد 1 ساعة",
    "task_is_due_soon": "\"{{ task_title }}\" سيحين موعده قريبًا. خذ لحظة لإنهائه.",
    "mobile_photo_quality_warning_header": "مشكلة بجودة الصورة",
    "mobile_photo_quality_dialog_message": "قد تكون هذه الصورة مظلمة أو غير واضحة تمامًا. فهل ترغب في التقاط صورة جديدة، أم الاستمرار بهذه الصورة؟",
    "mobile_take_new_photo": "التقط صورة جديدة",
    "mobile_use_this_photo": "استخدم هذه الصورة"
}};
mobile_translations.tr_TR = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Tümü",
    "mobile_common_button_apply_filters": "Filtre Uygula",
    "mobile_common_button_done": "Bitti",
    "mobile_common_button_edit": "Düzenle",
    "mobile_common_button_archive": "Arşivle",
    "mobile_common_button_save": "Kaydet",
    "mobile_common_button_retake": "Yeniden Al",
    "mobile_common_button_save_draft": "Taslağı Kaydet",
    "mobile_common_button_discard": "Vazgeç",
    "mobile_common_button_submit": "Gönder",
    "mobile_common_button_no": "Hayır",
    "mobile_common_button_yes": "Evet",
    "mobile_common_button_na": "Yok",
    "mobile_common_created_by_me": "Benim Oluşturduklarım",
    "mobile_common_email": "Şirket E-postası",
    "mobile_common_first_name": "Ad",
    "mobile_common_last_name": "Soyad",
    "mobile_common_location": "Konum",
    "mobile_common_locations": "Konumlar",
    "mobile_common_logout_message": "Oturumu kapatmak istediğinizden emin misiniz?",
    "mobile_common_password": "Parola",
    "mobile_common_permission_required": "İzin Gerekiyor",
    "mobile_common_status": "Durum",
    "mobile_common_task": "Görev",
    "mobile_common_tasks": "Görevler",
    "mobile_common_tasks_my": "Görevlerim",
    "mobile_common_projects": "Projeler",
    "mobile_common_filter_team": "Ekip",
    "mobile_common_filter_var_in": " {{team_or_location}} içinde",
    "mobile_common_filter_no_team_selected": "Ekip seçilmedi",
    "mobile_common_filter_no_user_selected": "Kullanıcı seçilmedi",
    "mobile_common_filter_no_role_selected": "Rol seçilmedi",
    "mobile_common_placeholder_date": "Tarih",
    "mobile_common_message_task_creator_error_save": "<b>Görev oluşturulamadı.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "işlevi",
    "mobile_common_reload": "Yeniden Yükle",
    "mobile_common_override": "Geçersiz Kıl",
    "mobile_common_notifications": "Bildirimler",
    "mobile_common_chat_unavailable": "Sohbet Kullanılamıyor. Lütfen daha sonra tekrar deneyin.",
    "mobile_common_chat_ending_dialog_title": "Bu konuşmayı tamamladınız mı?",
    "mobile_common_chat_ending_dialog_description": "Sorununuzun çözülüp çözülmediğini veya daha sonra devam etmek isteyip istemediğinizi bize bildirin.",
    "mobile_common_chat_ending_dialog_confirm": "Evet, sorunum çözüldü",
    "mobile_common_chat_ending_dialog_cancel": "Daha sonra devam edeceğim",
    "mobile_common_continue_editing": "Düzenlemeye Devam Et",
    "mobile_privacy_policy": "Gizlilik Politikası",
    "wootric_recommend_target": "sektörünüzdeki bir arkadaş veya meslektaş",
    "wootric_followup_detractor_question": "Bir dahaki sefere bize daha yüksek bir puan vermeniz için sizce ne gibi değişiklikler yapmalıyız?",
    "wootric_followup_passive_question": "Teşekkürler! Aracı geliştirmek için neler yapmalıyız?",
    "wootric_followup_promoter_question": "Teşekkürler! Crunchtime Ops Execution’da neler hoşunuz gidiyor?",
    "wootric_followup_promoter_question_old": "Teşekkürler! Zenput'ta neleri sevdiniz?",
    "wootric_default_followup_question": "Teşekkürler! Bize nedenini söyleyebilir misiniz?",
    "wootric_default_placeholder_text": "Neden bu puanı verdiğinizi açıklayarak bize yardımcı olabilirsiniz.",
    "wootric_default_thankyou_text": "Yanıtınız ve geri bildiriminiz için teşekkürler!",
    "mobile_login_placeholder_login_as": "Kullanıcı Kimliği İle Oturum Aç",
    "mobile_login_button_forgot_password": "Parolanızı mı unuttunuz?",
    "mobile_login_button_sign_up": "Hesap Oluştur",
    "mobile_login_button_finish_setup": "Kurulumu Bitir",
    "mobile_login_button": "Oturum Aç",
    "mobile_login_continue_button": "Devam Et",
    "mobile_login_continue_transition": "sizi kuruluşunuzun oturum açma sayfasına alıyoruz...",
    "mobile_login_no_email_error": "Bir e-posta girmeniz gerekiyor.",
    "mobile_login_change_email": "Başka bir e-posta ile oturum aç",
    "mobile_login_with_sso": "SSO ile Oturum Aç",
    "mobile_oauth_no_user_error_message": "Crunchtime Ops Execution hesabınız yok!",
    "mobile_oauth_no_user_error_message_old": "Bir Zenput Hesabınızın olmadığı anlaşılıyor!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b>‘un yeni adı <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} Eylül ayında {{- product }} oluyor. {{- cta }}",
    "mobile_rebrand_warning_cta": "Bu değişikliğe nasıl hazırlanacağınızı öğrenin.",
    "mobile_oauth_no_user_error_sub_message": "Erişim için yöneticinize başvurun veya başka bir e-posta ile oturum açmayı deneyin.",
    "mobile_oauth_generic_error_message": "Oturumunuz açılırken bir sorun oluştu. Lütfen tekrar deneyin.",
    "mobile_oauth_force_logout_msg": "Hala sorun yaşıyorsanız, sağlayıcı oturumunuzu kapatmak için ",
    "mobile_oauth_force_logout_click": "buraya tıklayın.",
    "mobile_sign_up_placeholder_phone": "Cep Telefonu Numarası",
    "mobile_sign_up_placeholder_password_confirm": "Parolayı Onayla",
    "mobile_sign_up_button_sign_in": "Giriş Yap",
    "mobile_sign_up_disclaimer_part_1": "Hesap Oluştur'a tıklamakla, önemli gizlilik bilgileri içeren",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Kurulumu Bitir'e tıklayarak şunları kabul edersiniz:",
    "mobile_sign_up_disclaimer_link_title": " Lisans Anlaşmasını",
    "mobile_sign_up_disclaimer_part_2": "kabul etmiş olursunuz",
    "mobile_dialog_benefits_work_offline": "Çevrim Dışı Çalış",
    "mobile_dialog_benefits_faster_uploads": "Daha Hızlı Karşıya Yükleme",
    "mobile_dialog_benefits_better_experience": "Daha İyi Deneyim",
    "mobile_dialog_benefits_button_download": "İndir",
    "mobile_dialog_benefits_button_download_bold": "Şunlar için Ops Execution: ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput ile ",
    "mobile_dialog_benefits_button_have": "Uygulamam var!",
    "mobile_dialog_benefits_button_no_thanks": "Hayır, teşekkürler. Belki başka bir zaman.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Görüntü yüklenemedi.",
    "mobile_dialog_signature_sign": "Burayı İmzalayın",
    "mobile_dialog_signature_button_clear": "Temizle",
    "mobile_account_placeholder_name": "Konum/Mağaza Adı",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Adres",
    "mobile_account_placeholder_city": "Şehir",
    "mobile_account_placeholder_region": "Bölge",
    "mobile_account_placeholder_zipcode": "Posta Kodu",
    "mobile_account_option_select_country": "Ülke Seç",
    "mobile_account_oprion_us": "Birleşik Devletler",
    "mobile_account_oprion_select_state": "Eyalet Seç",
    "mobile_account_button_create_location": "Konum Oluştur",
    "mobile_form_message_no_form": "Form yok",
    "mobile_batch_task_message": "Yükleniyor...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Cep Telefonu",
    "mobile_settings_profile_language": "Dil",
    "mobile_settings_profile_temperature_unit": "Sıcaklık Birimi",
    "mobile_settings_profile_use_company_default": "Şirket varsayılanını kullanın",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Metin Mesajı",
    "mobile_settings_notifications_option_push": "Sunucu Bildirimleri",
    "mobile_settings_notifications_option_push_email": "E-posta ve Sunucu Bildirimleri",
    "mobile_settings_notifications_option_do_not": "Bildirme",
    "mobile_settings_notifications_category_communication": "İletişim",
    "mobile_settings_notifications_category_forms_and_triggers": "Formlar & Tetikleyiciler",
    "mobile_settings_devices": "Cihazlar",
    "mobile_settings_notifications_sub_category_alerts": "Uyarılar",
    "mobile_settings_notifications_sub_category_new_forms_available": "Yeni Formlar Mevcut",
    "mobile_settings_notifications_sub_category_task_assigned": "Görev Atandı",
    "mobile_settings_notifications_sub_category_task_completed": "Görev Tamamlandı",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Son tarihi yaklaşan görev hatırlatıcısı",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Son tarihi geçmiş görev hatırlatıcısı",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensör Uyarıları",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Kritik Sensör Uyarıları",
    "mobile_drafts_message": "Henüz bir taslağınız yok.",
    "mobile_drafts_button_delete": "Sil",
    "mobile_tasks_filter_location_no": "Konum seçilmedi",
    "mobile_tasks_filter_group_by": "Gruplama Ölçütü",
    "mobile_tasks_filter_sort_by": "Gruplama Ölçütü",
    "mobile_tasks_filter_sorted_by": "Gruplanma Ölçütü",
    "mobile_tasks_filter_due_time": "Teslimat Zamanı",
    "mobile_tasks_filter_open_time": "Açık Zaman",
    "mobile_tasks_bucket_due_next_24_hours": "Kalan Süre: 24 Saat",
    "mobile_tasks_bucket_due_next_7_days": "Kalan Süre: 7 Gün",
    "mobile_tasks_bucket_open_tasks": "Diğer Açık {{type}}",
    "mobile_tasks_bucket_open_at": "Açılma: {{- date }} - {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Kalan Süre: {{- date }} - {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "1 dakika sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_one_hour": "1 saat sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_one_day": "1 gün sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_one_week": "1 hafta sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_one_month": "1 ay sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_one_year": "1 yıl sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_minutes": "{{ minutes }} dakika sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_hours": "{{ hours }} saat sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_days": "{{ days }} gün sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_weeks": "{{ weeks }} hafta sonra kullanılabilir",
    "notification_task_due_in_minutes": "{{ minutes }} dakika için teslim edilmesi gerek",
    "mobile_tasks_bucket_available_in_months": "{{ months }} ay sonra kullanılabilir",
    "mobile_tasks_bucket_available_in_years": "{{ years }} yıl sonra kullanılabilir",
    "mobile_tasks_follow_up": "İzleme Görevi",
    "mobile_tasks_due_soon": "Son tarihi gelmek üzere",
    "mobile_tasks_bucket_completed_today": "Bugün Tamamlananlar",
    "mobile_tasks_bucket_completed_this_week": "Bu Hafta Tamamlananlar",
    "mobile_tasks_bucket_completed_last_week": "Geçen Hafta Tamamlananlar",
    "mobile_tasks_bucket_missed_today": "Bugünü Kaçıranlar",
    "mobile_tasks_bucket_missed_this_week": "Bu Haftayı Kaçıranlar",
    "mobile_tasks_bucket_missed_last_week": "Geçen Haftayı Kaçıranlar",
    "mobile_tasks_bucket_no_location": "Konum Yok",
    "mobile_tasks_cannot_submit_missed": "Kaçırılan görevler tamamlanamaz",
    "mobile_tasks_cannot_submit_missed_after": "Bu görev {{ date }} tarihinden sonra tamamlanamaz",
    "mobile_tasks_cannot_submit_upcoming": "Bu görev başlamadı.",
    "mobile_tasks_cannot_submit_processing": "Bu gönderim işleniyor",
    "mobile_tasks_toolbarnav_header_no_due_date": "Son Tarih Yok",
    "mobile_tasks_toolbarnav_header_overdue": "Son Tarihi Geçti",
    "mobile_tasks_toolbarnav_header_yesterday": "Dün",
    "mobile_tasks_toolbarnav_header_today": "Bugün",
    "mobile_tasks_toolbarnav_header_tomorrow": "Yarın",
    "mobile_tasks_toolbarnav_header_last_week": "Geçen Hafta",
    "mobile_tasks_toolbarnav_header_this_week": "Bu Hafta",
    "mobile_tasks_toolbarnav_header_next_week": "Gelecek Hafta",
    "mobile_tasks_toolbarnav_header_this_month": "Bu Ay",
    "mobile_tasks_toolbarnav_header_next_year": "Gelecek Yıl",
    "mobile_tasks_toolbarnav_header_over_year": "Bir Yıldan Uzun Bir Süre",
    "mobile_tasks_toolbarnav_title_edit_task": "Görevi Düzenle",
    "mobile_task_placeholder_title": "Başlık *",
    "mobile_task_placeholder_description": "Açıklama (isteğe bağlı)",
    "mobile_task_button_single_task": "Tek Görev",
    "mobile_task_button_project": "Proje",
    "mobile_task_button_create": "Oluştur",
    "mobile_task_tab_basic": "Temel",
    "mobile_task_tab_photo": "Fotoğraf",
    "mobile_task_tab_form": "Form",
    "mobile_task_details_description_message_please": "Lütfen aşağıdaki alanları ",
    "mobile_task_details_description_message_below": "doldurun.",
    "mobile_task_details_description_message_instructions": "Bu görev için bir talimat yok.",
    "mobile_task_details_reason_title": "İzlemeyi Tetikleyen",
    "mobile_task_detials_button_goto_form": "Forma Git",
    "mobile_task_detials_button_complete": " Görevi Tamamla",
    "mobile_task_detials_completed": "Tamamlandı ",
    "mobile_task_detials_completed_by": "kişi ",
    "mobile_task_detials_completed_on": "tarih ",
    "mobile_task_details_view_form_submission": "Form Gönderimini Görüntüle",
    "mobile_task_task_updated": "Görev güncellendi",
    "mobile_task_task_archived": "Görev arşivlendi",
    "mobile_task_task_deleted": "Görev silindi",
    "mobile_task_error_archiving_task": "Görev arşivlenemedi.",
    "mobile_task_error_deleting_task": "Görev silinemedi.",
    "mobile_task_error_updating_task": "Görev güncellenemedi.",
    "mobile_task_archive_task": "Görevi Arşivle",
    "mobile_task_archive_task_confirm": "Bu görevi arşivlemek istediğinizden emin misiniz?\n\nArşivlenen görevler tamamlanma oranına eklenir ve bundan sonra raporlara dahil edilir.\n\nBu işlem geri alınamaz.",
    "mobile_task_delete_task_confirm": "Bu görevi silmek istediğinizden emin misiniz?\n\nSilinen görevler tamamlanma oranına eklenir ve bundan sonra raporlara dahil edilmez.\n\nBu işlem geri alınamaz.",
    "mobile_task_edition_already_in_progress": "Bu görevin bekleyen bir düzenleme işlemi var. Başka düzenleme işlemi yapılamaz.",
    "mobile_projects_filter_type": "Tür",
    "mobile_projects_filter_status": "Proje durumu",
    "mobile_projects_filter_project_type": "Proje türü",
    "mobile_projects_due_date_required": "Son tarih gereklidir.",
    "mobile_projects_team_required": "Ekip gereklidir.",
    "mobile_projects_user_role_required": "Atanan gereklidir.",
    "mobile_projects_title_required": "Başlık gereklidir.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Günlük Çoklu Görevler",
    "mobile_project_tasks_complete": " Tamamlanan",
    "mobile_project_tasks_remaining": " Kalan",
    "mobile_esitmate_message_tasks": "0 görev oluşturulacak",
    "mobile_esitmate_message_criteria": "Yukarıdaki Ölçütleri Ayarla",
    "mobile_esitmate_message_created_for": "şunun için oluşturulacak: ",
    "mobile_left_menu_dashboard": "Pano",
    "mobile_left_menu_my_forms": "Formlarım",
    "mobile_left_menu_announcements": "Duyurular",
    "mobile_left_menu_my_submissions": "Gönderimlerim",
    "mobile_left_menu_drafts": "Taslaklar",
    "mobile_left_menu_pending_uploads": "Bekleyen Karşıya Yüklemeler",
    "mobile_left_menu_open": "Uygulamada Aç",
    "mobile_left_menu_settings": "Ayarlar",
    "mobile_left_menu_log_out": "Oturumu Kapat",
    "mobile_left_menu_debug": "Hata Ayıkla",
    "mobile_left_menu_support": "Destek",
    "mobile_left_menu_documentation": "Belgeler",
    "mobile_left_menu_chat": "Sohbet",
    "mobile_field_textarea_placeholder_note": "Not veya alt başlık",
    "mobile_field_option_select": "Seç",
    "mobile_field_text_placeholder_text": "Metin",
    "mobile_field_email_placehoder_email": "E-posta",
    "mobile_filed_number_placeholder_number": "Numara",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Bağlı Değil",
    "mobile_field_sensor_offline_battery": "Sensör Devre Dışı - Batarya",
    "mobile_field_video_button_add": "Video Ekle",
    "mobile_field_video_picker_dialog_title": "Şuradan video ekle:",
    "mobile_field_video_button_change": "Videoyu Değiştir",
    "mobile_field_image_button_add": "Görüntü Ekle",
    "mobile_field_image_low_quality_warning": "Bazı fotoğraflar çok karanlık ya da bulanık gibi görünüyor. Vurgulanan fotoğrafları gözden geçirip gerekiyorsa değiştirin.",
    "mobile_field_image_picker_dialog_title": "Şuradan fotoğraf ekle:",
    "mobile_field_image_picker_edit_failed": "Resmi kaydedemedik. Lütfen tekrar deneyin.",
    "mobile_field_signature_button_add": "İmza Ekle",
    "mobile_field_signature_button_change": "İmzayı Değiştir",
    "mobile_field_account_select_location": "Konum Seç",
    "mobile_field_account_prefill": "Form son ziyaretin verileriyle doldurulsun mu?",
    "mobile_field_account_message_overwrite": "Bu işlem, doldurmuş olduğunuz alanların üzerine yazar.",
    "mobile_forms_task_on_behalf": "Bu konumda <b>{{user}}</b> adlı kişiye atanmış gerçekleştirilmesi gereken bir görev var. Bu görevi tamamlamak ister misiniz?",
    "mobile_forms_complete_task": "Görevi Tamamlansın mı?",
    "mobile_field_account_prefill_button_yes": "Evet, önceden doldur",
    "mobile_field_barcode_placeholder_scan": "Barkodu tarayın veya yazın",
    "mobile_field_sensor_qr_code_placeholder_scan": "Kodu tara ya da gir",
    "mobile_field_gateway_id_code_placeholder": "Düğüm Numarasını Gir",
    "mobile_field_scan_qr_or_enter_dev_eui": "QR Kodunu Tara ya da DevEUI'ı Gir",
    "mobile_field_scan_qr_or_enter_id": "QR Kodunu Tara ya da Kimlik No. Gir",
    "mobile_field_scan_qr_or_enter_sc": "QR Kodunu Tara ya da SC Kodunu Gir",
    "mobile_field_barcode_select_date": "Tarih Seç ",
    "mobile_field_datetime_allow_time": "Saat",
    "mobile_field_stopwatch_button_caption": "Kronometre",
    "mobile_field_stopwatch_common_start": "Başlat",
    "mobile_field_stopwatch_common_stop": "Durdur",
    "mobile_field_stopwatch_common_reset": "Sıfırla",
    "mobile_field_stopwatch_stop_stopwatches": "Kronometreleri Durdur",
    "mobile_field_document_title": "Belge Ekle",
    "mobile_field_document_message_delete": "Bu belgeyi silmek istediğinizden emin misiniz?",
    "mobile_field_document_alret_button_view": "Görünüm",
    "mobile_field_document_alert_error": "Bu belge eklenirken bir hata oluştu. Lütfen tekrar deneyin.",
    "mobile_field_document_alert_file_size_error": "Dosya {{count}} MB boyutunu aşamaz.",
    "mobile_field_temperature_greater_range": "{{ temp_value }} °{{ temp_unit }} üzeri",
    "mobile_field_temperature_greater_or_equal_range": "{{ temp_value }} °{{ temp_unit }} üzeri veya buna eşit",
    "mobile_field_temperature_less_range": "{{ temp_value }} °{{ temp_unit }} altı",
    "mobile_field_temperature_less_or_equal_range": "{{ temp_value }} °{{ temp_unit }} altı veya buna eşit",
    "mobile_field_temperature_between_range": "{{ min_temp_value }} °{{ temp_unit }} üzeri veya buna eşit ve {{ max_temp_value }} °{{ temp_unit }} altı veya buna eşit",
    "mobile_field_temperature_inclusive_between_range": "{{ min_temp_value }} °{{ temp_unit }} değerinden büyük veya buna eşit ve {{ max_temp_value }} °{{ temp_unit }} değerinden küçük veya buna eşit",
    "mobile_field_temperature_operators_separator": " ve ",
    "mobile_field_text_limit_error": "Maksimum 8000 karakter sınırına ulaşıldı.",
    "mobile_forms_required_questions_complete": "Gereken Tamamlanan",
    "mobile_forms_required_remaining": "{{count}} Doldurulması Gereken Alan",
    "mobile_forms_required_questions_back": "Geri",
    "mobile_forms_required_questions_next": "İleri",
    "mobile_forms_required_questions_skip": "Atla",
    "mobile_forms_leaving_form": "Formdan Çıkılıyor",
    "mobile_message_reordering_confirm": "Yeni soru sıralamasını kaydetmek istiyor musunuz?",
    "mobile_forms_leaving_reordering": "Soruların Yeniden Sıralanmasından Çıkılıyor",
    "mobile_forms_reordering_button_save": "Yeni Soru Sıralamasını Kaydet",
    "mobile_forms_reordering_instructions": "Soruları ya da bölümleri yeniden sıralamak için, alanı formda görünmesi gereken yere sürükleyip bırak",
    "mobile_toolbarnav_title_my_setttings": "Ayarlarım",
    "mobile_toolbarnav_title_profile_settings": "Profil Ayarları",
    "mobile_toolbarnav_title_notification": "Bildirim Ayarları",
    "mobile_toolbarnav_title_form_history": "Form Geçmişi",
    "mobile_toolbarnav_title_form_not_available": "Form Yok",
    "mobile_toolbarnav_title_add_location": "Konum Ekle",
    "mobile_toolbarnav_title_add_task_or_project": "Görev veya Proje Ekle",
    "mobile_toolbarnav_title_select_location": "Konum Seç",
    "mobile_toolbarnav_title_select_project": "Proje Seç",
    "mobile_toolbarnav_title_select_tag": "Etiket Seç",
    "mobile_toolbarnav_title_select_user": "Kullanıcı Seç",
    "mobile_toolbarnav_title_select_template": "Şablon Seç",
    "mobile_toolbarnav_title_select_one": "Birini Seç",
    "mobile_toolbarnav_title_select_multiple": "Birini veya Birkaçını Seç",
    "mobile_toolbarnav_title_select_team": "Ekip Seç",
    "mobile_toolbarnav_title_select_team_or_location": "Ekip veya Konum Seç",
    "mobile_toolbarnav_title_filter_tasks": "Görevi Filtrele",
    "mobile_toolbarnav_title_filter_projects": "Projeleri Filtrele",
    "mobile_toolbarnav_title_filter_project_tasks": "Proje Görevlerini Filtrele",
    "mobile_placeholder_search_bar": "Arama",
    "mobile_placeholder_user_select_role": "Kullanıcı Rolü Seç",
    "mobile_placeholder_filter_by_team": "Ekibe göre filtrele",
    "mobile_placeholder_assign_to_user_role": "Kullanıcı Rolüne Ata",
    "mobile_placeholder_select": "-- Seç --",
    "mobile_placeholder_account_location_name": "Konum Adı",
    "mobile_placeholder_tag_filter_by": "Konum Etiketine göre filtrele",
    "mobile_placeholder_user_type": "Kullanıcıya Ata",
    "mobile_placeholder_acount_type_loading": "Yükleniyor... ",
    "mobile_placeholder_therm_no_bluetooth": "Sıcaklık",
    "mobile_placeholder_blue_therm_connecting": "Cihaza bağlanılıyor...",
    "mobile_placeholder_blue_therm_please_wait": "Lütfen bekleyin...",
    "mobile_placeholder_blue_therm_tap": "Okumak için dokunun.",
    "mobile_placeholder_blue_therm_not_connected": "Bağlı değil.",
    "mobile_placeholder_testo_tap": "Önce ▼▲ sonra ⬆ düğmelerini basılı tutun",
    "mobile_message_error_create_task": "Görev eklemek için çevrim içi olmanız gerekir.",
    "mobile_message_error_fill_out_form": "Lütfen formu doldurun.",
    "mobile_message_error_fill_require_fields": "Gerekli alanları doldurun.",
    "mobile_message_error_stop_stopwatch_before_submit": "Göndermeden önce kronometrenizi durdurun.",
    "mobile_message_error_stopwatch_field_required": "Kronometre alanı gereklidir.",
    "mobile_message_error_stopwatch_field_running": "Kronometre alanı çalışıyor",
    "mobile_message_error_invalid_equipment_temperature": "Geçersiz ekipman sıcaklığı",
    "mobile_message_error_invalid_ingredient_temperature": "Geçersiz bileşen madde sıcaklığı",
    "mobile_message_error_location_attributes_unavailable": "Bazı sorulara ulaşılamıyor, lütfen internete bağlanın.",
    "mobile_message_alert_running_stopwatches": "Çalışan kronometreleriniz var.\n\nBunları temizlemek ister misiniz?",
    "mobile_message_blue_therm_error": "Bluetooth Cihazıyla Bağlantı Koptu",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Konum erişimi gerekli. Android ayarlarınızda bu özelliği etkinleştirin.",
    "mobile_message_blue_therm_no_permission_android": "\"Yakındaki Cihazlar\" erişimi gerekli. Android ayarlarınızda bu özelliği etkinleştirin.",
    "mobile_message_blue_therm_error_code": "Bağlantı Kurulamadı:",
    "mobile_message_blue_therm_error_bluetooth": "Lütfen Bluetooth'u etkinleştirin.",
    "mobile_message_blue_therm_error_device": "Cihaz bulunamadı.",
    "mobile_message_blue_therm_error_try_again": "Lütfen Tekrar Deneyin",
    "mobile_message_blue_therm_success": "Bluetooth Cihazı Bağlandı!",
    "mobile_message_bluetooth_device_press_button_field": "Bağlanmak için cihazınızdaki düğmeye basın.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Bu listede görmüyorsanız<br />cihazınızdaki düğmeye basın.",
    "mobile_bluetooth_scan": "Tara",
    "mobile_bluetooth_scanning": "Taranıyor",
    "mobile_message_drafts_confirm": "Bunu bir taslak olarak kaydetmek ister misiniz?",
    "mobile_message_drafts_toast_saved": "Taslak Kaydedildi.",
    "mobile_message_drafts_request_update": "Bu taslağı güncellemek ister misiniz?",
    "mobile_message_drafts_form_confirm": "Bu taslağı silmek istediğinizden emin misiniz?",
    "mobile_message_drafts_confirm_delete": "Taslağı Sil",
    "mobile_message_streams_error_switch": "Web'de akış değiştirilemez",
    "mobile_message_settings_success_saved": "Ayarlar Kaydedildi",
    "mobile_message_settings_error": "Bilinmeyen bir hata oluştu.  Daha sonra tekrar deneyin",
    "mobile_message_profile_settings_error_fields": "Lütfen vurgulanan alanları düzeltin.",
    "mobile_message_media_perimission_denied": "Sizin ",
    "mobile_message_media_perimission_denied_device": "Cihaz Depolama Alanınız",
    "mobile_message_image_confirm_remove_image": "Bu fotoğrafı silmek istediğinizden emin misiniz?",
    "mobile_message_create_account_error_fields": "Lütfen vurgulanan alanları doldurun.",
    "mobile_message_create_account_success_location_created": "Konum Oluşturuldu",
    "mobile_message_task_error_get_location": "Konum alınamadı. Tarihe göre sıralama.",
    "mobile_message_typehead_confirm_save_message": "Bu seçimleri kaydetmek istiyor musunuz?",
    "mobile_message_typehead_confirm_save_title": "Kaydedilsin mi?",
    "mobile_message_task_creator_error_save_select_form": "Bir form seçmelisiniz.",
    "mobile_message_task_creator_error_save_required_fields": "Lütfen gerekli alanları doldurun.",
    "mobile_message_task_creator_error_save_batch_change": "Lütfen ölçütleri bir veya daha fazla kişiyle eşleşecek şekilde değiştirin",
    "mobile_message_task_detials_error_not_assigned_to_you": "Bu görev size atanmadı.<br />Görevi siz tamamlayamazsınız.",
    "mobile_message_task_detials_error_assigned_to": "Bu görev {{user}} adlı kişiye atandı.<br />Görevi siz tamamlayamazsınız.",
    "mobile_message_task_detials_confirm_title": "Görevden Çıkılıyor",
    "mobile_message_task_detials_confirm_save_task": "Görevi Kaydet",
    "mobile_message_task_detials_confirm_message": "Emin misiniz? Değişiklikleriniz kaybolacak.",
    "mobile_message_task_detials_error_view_account": "Konuma Erişilemiyor.",
    "mobile_message_task_detials_error_submit_task": "Bu görevi tamamlamak için lütfen bir fotoğraf ekleyin.",
    "mobile_message_task_detials_error_submit_task_project": "Proje kaydedilemiyor. Lütfen daha sonra tekrar deneyin.",
    "mobile_message_task_detials_wait_submit_task_created": "Görevler oluşturuluyor.<br />Görevlerin doldurulması için lütfen birkaç dakika bekleyin.",
    "mobile_message_task_detials_error_submit_task_pending": "Hata oluştu. Lütfen daha sonra tekrar deneyin",
    "mobile_message_task_detials_success_task_complete": "Görev Tamamlandı",
    "mobile_message_task_error_save_single_task": "Görev kaydedilemiyor. Lütfen daha sonra tekrar deneyin.",
    "mobile_message_task_success_save_single_task": "Görev Oluşturuldu.",
    "mobile_message_show_error_message": "Bir sorun oluştu.",
    "mobile_message_show_success_message": "Sonuç başarılı!",
    "mobile_message_show_offline_message": "Şu anda çevrim dışı durumdasınız.",
    "mobile_message_show_permission_denied_message": "<b>İzin Gerekiyor.</b> Lütfen {{permission_name}} konumuna erişmesi için Zenput'a izin verin.",
    "mobile_message_show_permission_denied_message_web": "<b>İzin Gerekiyor.</b> Lütfen {{permission_name}} konumuna erişmesi için Zenput'a ve tarayıcınıza izin verin.",
    "mobile_message_show_begin_uploading_message": "Şu Anda Karşıya Yükleniyor",
    "mobile_message_show_upload_in_progress_message": "Karşıya yükleme zaten sürüyor",
    "mobile_message_show_form_id_error": "Belirtilen konuma erişilemiyor.",
    "mobile_message_show_single_task_error": "Belirtilen göreve erişilemiyor.",
    "mobile_message_show_submissions_error": "Belirtilen gönderime erişilemiyor.",
    "mobile_message_show_submissions_access_denied": "Özür dileriz, ancak bu forma erişiminiz yok.",
    "mobile_message_send_data_success": "Veriler yüklendi ",
    "mobile_message_start_upload_success": "Karşıya Yükleme Tamamlandı",
    "mobile_message_start_upload_error": "<b>Karşıya yükleme tamamlanamadı.</b><br>Gönderim kaydedildi. Lütfen daha sonra tekrar deneyin",
    "mobile_message_store_upgrade_store_ios": "Uygulama Mağazası",
    "mobile_message_store_upgrade_store_android": "Oyun Mağazası",
    "mobile_message_store_upgrade_confirm_title": "Güncelleme Var",
    "mobile_message_store_upgrade_confirm_message_one": "Lütfen Ops Execution uygulamasını şuradan güncelleyin: ",
    "mobile_message_store_upgrade_confirm_message_one_old": "En son özellik ve hata düzeltmelerini edinmek için lütfen Zenput'u ",
    "mobile_message_store_upgrade_confirm_message_two": " konumundan güncelleyin",
    "mobile_message_store_upgrade_confirm_now": "Şimdi",
    "mobile_message_store_upgrade_confirm_later": "Daha Sonra",
    "mobile_message_redirect_confirm_message": "Şu anda bir formu dolduruyorsunuz. Devam etmeden önce formu taslak olarak kaydetmek ister misiniz?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Henüz karşıya yüklenmemiş {{count}} taslağınız var. Devam ederseniz bunlar kaybolacak. Emin misiniz?",
    "mobile_message_draft_override_message": "Bu taslak {{date}} tarihinde başka bir cihazdan kaydedildi ve bu cihazdaki değişiklikler çakışıyor. Mevcut sürümü geçersiz kılmayı seçebilirsiniz veya en son sürümü yeniden yükleyebilirsiniz; bu durumda yaptığınız değişiklikler kaydedilmez.",
    "mobile_html_submitting": "Gönderiliyor...",
    "mobile_html_offline": "Şu anda çevrim dışısınız!",
    "mobile_html_offline_try_again": "Şu anda çevrim dışısınız! <br/><br/>Bağlandığınızda lütfen tekrar deneyin",
    "mobile_html_something_went_wrong": "Bir sorun oluştu.",
    "mobile_html_something_went_wrong_try_again": "Bir sorun oluştu. Lütfen tekrar deneyin.",
    "mobile_html_failed_loading_roles": "Roller yüklenemedi.",
    "mobile_alert_please_install_for_native": "Bu özelliği kullanmak için lütfen Ops Execution uygulamasını yükleyin. ",
    "mobile_alert_please_install_for_native_old": "Bu özelliği kullanmak için lütfen yerel Zenput uygulamasını yükleyin.",
    "mobile_tso_filter_all_tasks": "Tüm {{type}}",
    "mobile_tso_filter_my_tasks": "Bana ait {{type}}",
    "mobile_tso_filter_due_date": "Son Tarih",
    "mobile_tso_filter_date_completed": "Tamamlanma Tarihi",
    "mobile_tso_filter_completed": "Tamamlandı",
    "mobile_tso_filter_completed_late": "Geç Tamamlandı",
    "mobile_tso_filter_incomplete": "Eksik",
    "mobile_tso_filter_var_my_tasks": "Bana ait {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "Benim oluşturduğum {{filter_type}} {{type}}",
    "mobile_tso_filter_var_all_tasks": "Tüm {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Takip Adımları",
    "mobile_tso_type_all": "Görevler ve Takip Adımları",
    "mobile_tso_filter_var_at": " (şurada: {{location}})",
    "mobile_tso_filter_group_date_due": "Son Tarihe göre sıralanmış olarak",
    "mobile_tso_filter_group_distance": "Konuma göre gruplanmış olarak",
    "mobile_tso_filter_start_date": "Başlangıç Tarihi",
    "mobile_tso_filter_none": "Hiçbiri",
    "mobile_pso_filter_all_projects": "Tüm Projeler",
    "mobile_pso_filter_my_projects": "Projelerim",
    "mobile_pso_filter_active": "Etkin",
    "mobile_pso_filter_archived": "Arşivlenen",
    "mobile_pso_filter_recurring": "Tekrarlanan",
    "mobile_pso_filter_non_recurring": "Tekrarlanmayan",
    "mobile_pso_filter_var_my_projects": "{{project_type}} {{active_description}} Projelerim",
    "mobile_pso_filter_var_my_created_projects": "Benim Oluşturduğum {{project_type}} {{active_description}} Projeleri",
    "mobile_pso_filter_var_all_projects": "Tüm {{project_type}} {{active_description}} Projeleri",
    "mobile_empty_list_message_must_be_online": "Çevrim dışı olduğunuz görülüyor. Sonuçları görmek için lütfen çevrim içine geçin.",
    "mobile_empty_list_message_no_submissions": "Gönderim Yok",
    "mobile_empty_list_message_no_activity": "Etkinlik Yok",
    "mobile_empty_list_message_no_tasks": "Görev Yok",
    "mobile_empty_list_message_no_tasks_overdue": "{{type}} Arasında Geciken Yok",
    "mobile_empty_list_message_no_accounts": "Konum Yok",
    "mobile_empty_list_message_no_projects": "Proje Yok",
    "mobile_empty_list_message_no_results_found": "Sonuç Bulunamadı",
    "mobile_empty_list_message_no_forms_available": "Form Yok",
    "mobile_empty_list_message_connection_error": "Bağlantı Hatası<br />Lütfen daha sonra tekrar deneyin.",
    "mobile_empty_list_message_dashboard_error": "Pano Yüklenemiyor",
    "mobile_empty_list_message_user_offline": "Şu anda çevrim dışındasınız",
    "mobile_action_sheet_media_gallery": "Galeri",
    "mobile_action_sheet_cancel": "İptal",
    "mobile_image_preview_text": "Fotoğrafı Kaldır",
    "mobile_mobileform_text": "Önceki Gönderimler",
    "mobile_mobileform_reorder_fields": "Soruları Yeniden Sırala",
    "mobile_mobileform_follow_up_actions": "Takip Eylemleri",
    "mobile_mobileform_follow_up_actions_assign_title": "Takip adımları ata",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Gözlemlerinize göre gerekli takip adımlarını ekleyin; böylece sorunların çözüme ulaştığından emin olabilirsiniz.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Takip Adımı Ekle",
    "mobile_mobileform_follow_up_actions_assign_button": "Takip Adımları Ata",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Atamadan Devam Et",
    "mobile_mobileform_follow_up_actions_dialog_title": "Takip Adımları Atamadan Devam Edilsin mi?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Herhangi bir takip adımı atamadan devam ederseniz bunları daha sonra ekleyemezsiniz.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Yine de Devam Et",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Bu alan gereklidir",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Karakter limiti aşıldı",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Bu alan geçerli değil",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Konumlar yüklenirken hata oluştu",
    "mobile_mobileform_add_follow_up_actions_error_users": "Kullanıcılar yüklenirken hata oluştu",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Takip Adımı Ekle",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Başlık",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Açıklama",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Fotoğraf Gerekli",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Son Tarih",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Takip Adımını Güncelle",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Takip Adımı Silinsin mi?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Takip adımı kaldırılacak ve atanmayacak.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Takip Adımını Sil",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Bu takip adımını silmek istediğinizden emin misiniz?\n\nBu işlem geri alınamaz.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Takip Adımlarına Devam Et",
    "mobile_mobileform_follow_up_actions_completed_notification": "Takip Adımı Tamamlandı",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Takip Adımı Silindi",
    "mobile_mobileform_follow_up_actions_update_notification": "Takip Adımı Güncellendi",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Lütfen bu takip adımını tamamlamak için bir fotoğraf ekleyin",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Gönderime git",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Kaynağa git",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Kaynak",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Takip Adımını Tamamla",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Gönderimi açtığınızda, kaydedilmemiş fotoğraf ve notlar silinir.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Bu ekrandan çıkarsanız kaydedilmemiş fotoğrafları ve notları kaybedersiniz.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Burada kal",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Gönderimi aç",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Açık kaynak",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Bu takip adımından çıkılsın mı?",
    "mobile_mobileform_follow_up_actions_submission": "Gönderim",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Bu takip adımı {{user}} adlı kişiye atandı.<br />Takip adımını siz tamamlayamazsınız.",
    "mobile_mobileform_follow_up_actions_leave_description": "Bu ekrandan çıkarsanız kaydedilmemiş değişiklikleri kaybedersiniz.",
    "mobile_mobileform_follow_up_actions_leave": "Çık",
    "mobile_forms_drafts_text": "Taslakları Kaldır",
    "mobile_batch_estimate_user": "Kullanıcı",
    "mobile_batch_estimate_users": "Kullanıcılar",
    "mobile_table_of_contents": "İçindekiler",
    "mobile_table_of_contents_required": "Gerekli",
    "mobile_table_of_contents_optional": "İsteğe Bağlı",
    "mobile_dialog_alert_title": "Uyarı",
    "mobile_dialog_alert_ok": "Tamam",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth cihazlar henüz Windows üzerinde desteklenmemektedir",
    "mobile_windows_deprecated_message_content_announcement": "Duyuru",
    "mobile_windows_deprecated_message_title": "Uygulama güncellemesi gerekiyor",
    "mobile_windows_deprecated_message_description": "Kritik işlevsellik güncellemelerini almak ve en iyi Zenput deneyiminden yararlanmak için yeni Zenput uygulamasını en kısa zamanda Microsoft Store’dan yükleyin.",
    "mobile_dashboard_tcr_graph_name": "Görev Tamamlanma Oranı",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Son 4 Hafta",
    "mobile_dashboard_tcr_legend_company_average": "Şirket Ortalaması",
    "mobile_dashboard_tcr_legend_team_average": "Ekip Ortalaması",
    "mobile_dashboard_tab_title_summary": "Özet",
    "mobile_dashboard_tab_title_activity": "Etkinlik",
    "mobile_dashboard_card_title_top_triggered_workflows": "En Sık Kullanılan Tetikleyiciler",
    "mobile_dashboard_tab_title_info": "Bilgi",
    "mobile_dashboard_tab_project_audit": "Uyumluluk",
    "mobile_dashboard_card_task_stats_total": "Toplam",
    "mobile_dashboard_top_item_header_week_of": "Hafta",
    "mobile_dashboard_card_filter_form_template_placeholder": "Tüm Formlar",
    "mobile_dashboard_card_title_forms_top_nos": "Sık Görülen \"Numaralar\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "Bu zaman aralığında veri yok.",
    "mobile_dashboard_zenput_code_permission_denied": "Bunu görme izniniz yok.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Yukarıdan bir form seçin.",
    "mobile_dashboard_zenput_code_unknown_error": "Şu anda veri görüntüleyemiyoruz.",
    "mobile_dashboard_tap_to_retry": "Tekrar Denemek İçin Dokunun",
    "mobile_dashboard_reporting_delay_disclaimer": "Görevlerin güncellenmesi 15 dakikaya kadar sürebilir",
    "mobile_dashboard_configuration_down_state_postfix_msg": "yöneticiniz tarafından yapılandırıldı.",
    "mobile_tasks_tag": "görevler",
    "mobile_workflows_tag": "tetikleyiciler",
    "mobile_projects_tag": "tekrarlanan projeler",
    "mobile_forms_tag": "formlar",
    "mobile_dashboard_card_ongoing_projects_title": "Süren Projeler",
    "mobile_dashboard_card_ongoing_projects_show_more": "Daha Fazlasını Göster",
    "mobile_dashboard_card_ongoing_projects_show_less": "Daha Azını Göster",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Projelere Git",
    "mobile_dashboard_card_title_recurring_projects": "Tekrarlanan Projeler",
    "mobile_dashboard_card_filter_daily": "Günlük",
    "mobile_dashboard_card_filter_weekly": "Haftalık",
    "mobile_dashboard_card_filter_monthly": "Aylık",
    "mobile_task_status_title_open": "Açık",
    "mobile_task_status_title_upcoming": "Yaklaşan",
    "mobile_task_status_title_complete": "Tamamlanan",
    "mobile_task_status_title_processing": "Gönderim İşleme",
    "mobile_task_status_title_complete_with_exceptions": "İzleme Görevleri veya Uyarılar ile Tamamla",
    "mobile_task_status_title_completed_late_with_exceptions": "Takip Görevleri veya Uyarılarla Geç Tamamlandı",
    "mobile_task_status_title_incomplete_and_closed": "Kaçırıldı",
    "mobile_tasks_legend_modal_title": "Gösterge",
    "mobile_tasks_legend_modal_footer_button_title": "Kapalı",
    "mobile_common_assigned_to": "Atandığı Kişi",
    "mobile_common_created_by": "Oluşturan Kişi",
    "mobile_common_tasks_for": "Şu Kişinin Görevleri",
    "mobile_common_go_back": "Geri Dön",
    "mobile_oh_no": "Olamaz!",
    "mobile_user_not_in_groups": "Özür dileriz, ancak bir ekibe atanmamışsınız. Panonuza erişim elde edebilmek için yöneticinize başvurun.",
    "mobile_tasks_select_followers": "İzleyici Seç",
    "mobile_tasks_assign_tasks": "{{count}} Görevlerini Ata",
    "mobile_tasks_add_followers": "İzleyici Ekle",
    "mobile_tasks_followers": "İzleyiciler",
    "mobile_tasks_delete_task": "Görevi Sil",
    "mobile_tasks_create_task": "Görev Oluştur",
    "mobile_tasks_tab_title_comments": "Yorumlar",
    "mobile_tasks_see_more": "Daha fazlasını göster",
    "mobile_projects_create_project": "Proje Oluştur",
    "mobile_common_button_send": "Gönder",
    "mobile_common_button_schedule": "Zamanlama",
    "mobile_announcements_create": "Duyuru Oluştur",
    "mobile_announcements_read_rate": "{{opened_count}} / {{recipients_count}} Açıldı",
    "mobile_announcements_empty_message": "Henüz duyuru oluşturmadınız! Kuruluşunuzda önemli haber, bilgi ve güncellemeler yayınlamak için aşağıda duyuru oluşturun.",
    "mobile_announcement_message_placeholder": "Mesaj ekleyin...",
    "mobile_announcement_title_placeholder": "Duyuru Başlığı",
    "mobile_announcement_leaving_announcement": "Duyurudan Çıkılıyor",
    "mobile_announcement_confirm_recipients_team": "Bu duyuruyu seçilen {{teams}} ekibindeki {{count}} kullanıcıya yayınlamak istiyor musunuz?",
    "mobile_announcement_confirm_recipients_role": "Bu duyuruyu seçilen {{roles}} ekibindeki {{count}} kullanıcıya yayınlamak istiyor musunuz?",
    "mobile_announcement_confirm_recipients_user": "Bu duyuruyu {{count}} kullanıcıya yayınlamak istiyor musunuz?",
    "mobile_announcement_confirm_scheduled": "{{timestamp}} tarihinde",
    "mobile_announcement_sending_announcement": "Duyuru Gönderiliyor",
    "mobile_announcement_send_to": "Gönderilecekler",
    "mobile_announcement_sent_to": "Gönderilenler",
    "mobile_announcement_send_to_role": "Rol",
    "mobile_announcement_attachment_download": "{{filename}} indiriliyor",
    "mobile_announcement_attachment_validation_error": "En fazla {{maxCount}} dosya eklenebilir",
    "mobile_announcement_details_sent": "Gönderildi",
    "mobile_announcement_details_total_recipients": "Toplam Alıcı",
    "mobile_announcement_details_cancel": "Duyuruyu İptal Et",
    "mobile_announcement_details_not_editable": "Duyurular yalnızca Ops Execution web uygulamasında düzenlenebilir ",
    "mobile_announcement_details_not_editable_old": "Duyurular yalnızca Zenput sitesinde düzenlenebilir",
    "mobile_announcement_details_open_count": "Açık Sayısı",
    "mobile_announcement_details_open_rate": "Açık Oranı",
    "mobile_announcement_details_resend": "Açmayanlara tekrar gönder",
    "mobile_announcement_confirm_resend": "{{count}} kullanıcı duyuruları okumadı. Hatırlatıcı göndermek ister misiniz?",
    "mobile_announcement_confirm_resend_title": "Hatırlatıcı gönderilsin mi?",
    "mobile_announcement_recipients_opened": "Açılanlar",
    "mobile_recipients_opened_empty_message": "Mesajınızı henüz kimsenin açmadığı anlaşılıyor. Sonuçlarınızı görmek için daha sonra tekrar gelin.",
    "mobile_announcement_recipients_unopened": "Açılmayanlar",
    "mobile_recipients_unopened_empty_message": "Haberler iyi! Açılmayan mesaj yok!",
    "mobile_scheduled_announcements_delivery_section_header": "Teslimat Zamanı",
    "mobile_scheduled_announcements_send_immediately_label": "Hemen gönder",
    "mobile_scheduled_announcements_scheduled_label": "Belirli bir zamanda gönder",
    "mobile_scheduled_announcements_scheduled_tab_label": "Zamanlandı",
    "mobile_scheduled_announcements_dialog_header": "Duyuru İptal Edilsin mi?",
    "mobile_scheduled_announcements_dialog_message": "İptal etmek duyurunuzun gönderilmesini engeller ve duyuruyu listeden siler. Bu işlem geri alınamaz. Düzenlemek için Zenput sitesine gidin.",
    "mobile_scheduled_announcements_empty_message": "Şu anda zamanlanmış duyurunuz yok. Kuruluşunuzda önemli haber, bilgi ve güncellemeler yayınlamak için aşağıda duyuru oluşturun.",
    "mobile_scheduled_announcements_validation_error": "Teslimat zamanı {{date}} tarihinden sonra olmalıdır",
    "mobile_scheduled_announcements_empty_state_button": "Duyuruyu Zamanla",
    "mobile_projects_auto_archive": "Otomatik Arşivle",
    "mobile_common_unassigned": "Atanmadı",
    "mobile_tasks_title_placeholder": "Yeni Görev veya Form",
    "mobile_projects_leaving_project": "Projeden Çıkılıyor",
    "mobile_projects_save_project": "Projeyi Kaydet",
    "mobile_top_triggers_tasks": "En Sık Tetiklenen Görevler",
    "mobile_top_triggers_alerts": "En Sık Tetiklenen Uyarılar",
    "mobile_projects_not_started": "Başlamadı",
    "mobile_empty_list_message_no_photos": "Fotoğraf Yok",
    "mobile_webfilestore_message_error": "Lütfen geçerli bir dosya türü seçin",
    "mobile_notifications_empty_title": "Bildirim Yok",
    "mobile_notifications_empty_message": "Görevlerinizde bulunan veya katıldığınız etkinlikler burada görünür.",
    "mobile_comments_comment_deleted": "Bu yorum silindi.",
    "mobile_comments_comment_placeholder": "Yorum",
    "mobile_comments_task_submitted_at": "Görev {{ date }} tarihinde saat {{ time }} itibariyle gönderildi",
    "mobile_comments_discard_comment_title": "Yorumu yazmaktan vaz mı geçiyorsunuz?",
    "mobile_comments_discard_confirm_message": "Emin misiniz? Yorumunuz silinecek.",
    "mobile_comments_delete_comment_title": "Yorum silinsin mi?",
    "mobile_comments_delete_confirm_message": "Bu işlem geri alınamaz.",
    "mobile_comments_delete_button": "Yorumu Sil",
    "mobile_comments_delete_success_message": "Yorum Silindi",
    "mobile_comments_empty_message_tasks": "Henüz yorum yok \n Bu görev hakkında bir söyleşi başlatın.",
    "mobile_comments_empty_message_submissions": "Henüz yorum yok \n Bu gönderim hakkında bir söyleşi başlatın.",
    "mobile_comments_empty_message_default": "Henüz yorum yok \n Bir söyleşi başlatın.",
    "mobile_comments_no_matching_users": "Eşleşen kullanıcı yok.",
    "mobile_comments_empty_users_to_notify": "Bildirim gönderilecek kullanıcı yok.",
    "mobile_comments_users_cant_view_message": "Bu kullanıcılar bu yorumları göremez",
    "mobile_comments_users_to_notify_title": "Bildirim Gönderilecek Kullanıcılar",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} kullanıcıya</a> bildirim gönderilecek.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} kullanıcıya</a> bildirim gönderilecek.",
    "mobile_comments_mention_instructions": "Bildirim gönderilecek başka kullanıcıları<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> ile belirtin.",
    "mobile_comments_mark_read": "Tümünü okundu olarak işaretle",
    "mobile_comments_author_mentioned_message": "sizi şu söyleşide andı:",
    "mobile_comments_author_commented_message": "şunun hakkında yorum yazdı:",
    "mobile_view_pdf": "PDF'yi Görüntüle",
    "mobile_no_pdf_generated_message": "Bu gönderim için bir PDF bulunamadı. Kısa bir süre içinde size bir kopya gönderilecek.",
    "mobile_clipboard_copied_success": "Bağlantı taşıma panosuna kopyalandı.",
    "mobile_share_link": "Bağlantıyı paylaş",
    "mobile_zencam_share": "Paylaş",
    "mobile_zencam_view_details": "Ayrıntıları göster",
    "mobile_zencam_details_drawer_header": "Ayrıntılar",
    "mobile_zencam_submitted_by": "Gönderen:",
    "mobile_zencam_form_title": "Form Başlığı",
    "mobile_zencam_date_submitted": "Gönderme Tarihi",
    "mobile_oil_quality_warning_message": "Yağ SKT yaklaştı",
    "mobile_oil_quality_warning_message_subtitle": "Yakında değiştirmeyi planlayın",
    "mobile_oil_quality_failure_message": "Yağ kalitesi bozuldu",
    "mobile_oil_quality_failure_message_subtitle": "Yağı hemen değiştirin",
    "mobile_sensors_set_up_gateway": "Ağ Geçidi Ayarla",
    "mobile_sensors_set_up_gateway_message": "Kurulu bir cihaz olmadığı anlaşılıyor. Bir ağ geçidi ekleyerek başlayın.",
    "mobile_sensors_gateway_plugged_in": "Ağ geçidinizin bir prize bağlı olduğundan emin olun.",
    "mobile_sensors_add_device": "Cihaz ekle",
    "mobile_sensors_name_this_gateway": "Bu ağ geçidini adlandırın.",
    "mobile_sensors_name_this_sensor": "Bu sensörü adlandırın.",
    "mobile_sensors_device_barcode_information": "QR Kodunu Tara ya da cihaz etiketinden kimlik ve SC numarasını gir",
    "mobile_sensors_device_eui_information": "QR Kodunu Tara ya da cihaz etiketinden DevEUI'ı gir",
    "mobile_sensors_gateway_id_information": "Ağ geçidi etiketinden Düğüm Numarasını girin.",
    "mobile_sensors_id_number": "{{untranslatedID}} Numara",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Kod",
    "mobile_sensors_sensors": "Sensörler",
    "mobile_sensors_sensor_deveui_error": "QR'den DevEUI alınamadı. Lütfen bunu manuel olarak girin.",
    "mobile_sensors_gateways": "Ağ Geçitleri",
    "mobile_sensors_add_sensor": "Sensör Ekle",
    "mobile_sensors_add_gateway": "Ağ Geçidi Ekle",
    "mobile_sensor_placement_description": "Bu sensör hangi bölgeyi izleyecek?",
    "mobile_sensors_equipment_placement": "Bu sensör hangi bölgeyi veya ekipmanı izleyecek?",
    "mobile_sensors_equipment": "Bu sensör hangi ekipmanı izleyecek?",
    "mobile_sensors_select_gateway_type": "Ağ geçidi türünü seç",
    "mobile_sensors_select_placement": "Yerleşim Seç",
    "mobile_sensors_select_equipment": "Ekipman Seç",
    "mobile_sensors_placement": "Yerleşim",
    "mobile_sensors_nickname_tip": "Sensör adlandırması seçili yerleşimde atanan takma adlara göre belirlenir.",
    "mobile_sensors_device_online": "Çevrim İçi",
    "mobile_sensors_device_offline": "Çevrim Dışı",
    "mobile_sensors_scan_qrcode": "QR Kodunu Tara",
    "mobile_sensors_enter_manually": "Elle Gir",
    "mobile_sensors_wizard_step_one": "Adım 1",
    "mobile_sensors_wizard_step_two": "Adım 2",
    "mobile_sensors_wizard_step_three": "Adım 3",
    "mobile_sensors_wizard_step_four": "Adım 4",
    "mobile_sensors_wizard_step_five": "Adım 5",
    "mobile_sensors_wizard_step_six": "Adım 6",
    "mobile_sensors_initializing": "Başlatılıyor...",
    "mobile_sensors_nickname": "Takma Ad",
    "mobile_sensors_field_not_blank": "{{field}} boş bırakılamaz.",
    "mobile_sensors_nothing_to_see_here": "Burada Görecek Bir Şey Yok",
    "mobile_sensors_missing_integration": "Eksik Sensör Entegrasyonu",
    "mobile_sensors_contact_zenput_admin": "Lütfen şirketinizin Ops Execution yöneticisiyle iletişime geçin.",
    "mobile_sensors_contact_zenput_admin_old": "Lütfen Zenput yöneticinizle iletişim kurun.",
    "mobile_sensors_contact_manager": "Sensör eklemek için hesap yöneticinize başvurun.",
    "mobile_sensors_device_success_message": "Sensör verilerinin yüklenmesi 15 dakikaya kadar sürebilir",
    "mobile_sensors_last_reading": "Son Okuma",
    "mobile_sensors_remove_device": "Cihazı Kaldır",
    "mobile_sensors_one_day": "1G",
    "mobile_sensors_one_week": "1H",
    "mobile_sensors_one_month": "1A",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1Y",
    "mobile_sensors_sensor_settings": "Sensör Ayarları",
    "mobile_sensors_remove_confirm_message": "Bu cihazı silmek istediğinizden emin misiniz?\nBu işlem geri alınamaz.",
    "mobile_sensors_sensor": "Sensör",
    "mobile_sensors_no_equipment_linked": "Bağlı Ekipman Yok",
    "mobile_sensor_cooldown_process": "Soğutma İşlemi",
    "mobile_sensor_last_12_hours": "Son 12 Saat",
    "mobile_sensor_start_cooldown_process": "Yeni Soğutma İşlemi Başlat",
    "mobile_sensor_cooldown_process_title": "İki Aşamalı Soğutma İşlemi",
    "mobile_sensor_cooldown_process_description": "İki aşamalı bir soğutma işlemi gıdayı iki saat veya daha kısa bir sürede {{ stage1_start_temperature }} dereceden daha yüksek bir dereceden {{ stage1_end_temperature }} dereceye, sonra da dört saat veya daha kısa bir sürede {{ stage1_end_temperature }} dereceden {{ stage2_end_temperature }} dereceye soğutmayı içerir.",
    "mobile_sensor_cooldown_process_place_food": "Gıda ürününü soğutucuya yerleştirin.",
    "mobile_sensor_cooldown_process_insert_sensor": "Gıda ürününe bir sensörlü sonda koyun.",
    "mobile_sensor_cooldown_process_enter_information": "Aşağıdaki bilgileri girin.",
    "mobile_sensor_cooldown_process_food_product": "Soğutulacak Gıda Ürünü",
    "mobile_sensor_cooldown_cool_down": "Soğutma",
    "mobile_sensor_cooldown_select_sensor": "Sensör Seç",
    "mobile_sensors_cooldown_start_cooldown": "Soğutmayı Başlat",
    "mobile_sensors_cooldown_please_enter_food": "Lütfen bir Gıda Ürünü girin",
    "mobile_sensors_cooldown_please_select_sensor": "Lütfen bir Sensör seçin",
    "mobile_sensors_cooldown_status_in_progress": "Sürüyor",
    "mobile_sensors_cooldown_status_failed": "Başarısız",
    "mobile_sensors_cooldown_status_success": "Başarılı",
    "mobile_sensors_cooldown_stage": "Aşama",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Başlangıç sıcaklığı aralık dışı",
    "mobile_sensors_cooldown_failed_cooldown_process": "Soğutma İşlemi Başarısız",
    "mobile_sensors_cooldown_cooldown_successful": "Soğutma İşlemi Başarılı",
    "mobile_sensors_cooldown_started_cooldown_process": "Soğutma İşlemi Başlatıldı",
    "mobile_sensors_cooldown_hour": "saat",
    "mobile_sensors_cooldown_hour_plural": "saat",
    "mobile_sensors_cooldown_minute": "dakika",
    "mobile_minutes_plural": "dakika",
    "mobile_sensors_last_reading_max_date": "1 yıldan daha önce",
    "mobile_sensors_minute_count_ago": "{{count}} dakika önce",
    "mobile_sensors_minute_count_ago_plural": "{{count}} dakika önce",
    "mobile_sensors_hour_count_ago": "{{count}} saat önce",
    "mobile_sensors_hour_count_ago_plural": "{{count}} saat önce",
    "mobile_sensors_day_count_ago": "{{count}} gün önce",
    "mobile_sensors_day_count_ago_plural": "{{count}} gün önce",
    "mobile_sensors_chart_settings": "Çizelge Ayarları",
    "mobile_announcement_banner_continue_reading": "Okumaya devam et",
    "mobile_compliance_submissions_report": "Gönderim Raporu",
    "mobile_compliance_submissions_report_subtitle": "Bu mağaza için proje tamamlama verilerini dışa aktar",
    "mobile_compliance_send_submissions": "Gönderimleri Yolla",
    "mobile_compliance_completion_rate_in_last_days": "Son {{ days }} Gün İçindeki Tamamlanma Oranı",
    "mobile_compliance_last_days": "Son {{ days }} Gün",
    "mobile_compliance_send_submissions_to": "Gönderimleri Şuraya Yolla",
    "mobile_compliance_send_to_different_email": "Farklı Bir E-posta Adresine Yolla",
    "mobile_compliance_email_input_placeholder": "E-posta Adresi",
    "mobile_compliance_send_submissions_to_legend_title": "Gönderimler",
    "mobile_compliance_send_submissions_to_legend_description_days": "Son {{ days }} gün içinde bu konumdan yapılmış gönderimlerinize ilişkin bir rapor seçilen e-posta adresine gönderilecek.",
    "mobile_compliance_time_frame": "Zaman Çerçevesi",
    "mobile_compliance_sensor_temperature_log_report": "Sensör Sıcaklık Günlüğü Raporu",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Bu mağaza için sıcaklık günlüklerini dışa aktar",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kriterler",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Rapor kriterlerinizi aşağıda tanımlayın.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Not: Etkin olmayan sensör(ler) raporda gösterilmez",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Bir zaman aralığını seçin. Günlük veriler maksimum 30 günle sınırlıdır.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Raporu Gönder",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Bu Ay (1-Bugün)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Geçen Ay",
    "mobile_compliance_sensor_temperature_log_email_title": "Raporu Buraya Gönder:",
    "mobile_pwa_update_prompt_title": "Uygulamayı Güncelle",
    "mobile_pwa_update_prompt_description": "Uygulamanın yeni bir sürümü mevcut. Lütfen son sürüme güncelleyin.",
    "mobile_pwa_update_prompt_confirm": "Güncelle ve Yeniden Yükle",
    "mobile_pwa_update_prompt_cancel": "Daha Sonra Hatırlat",
    "notification_title_due_in_one_hour": "1 saat içinde teslim edilmesi gerek.",
    "task_is_due_soon": "“{{ task_title }}” yakında teslim edilmeli. Tamamlamak için bir dakikanızı ayırın.",
    "mobile_photo_quality_warning_header": "Fotoğraf kalitesi sorunu",
    "mobile_photo_quality_dialog_message": "Bu fotoğraf çok karanlık veya bulanık gibi görünüyor. Yeni bir fotoğraf çekmek ister misiniz, yoksa bununla devam etmek mi istersiniz?",
    "mobile_take_new_photo": "Yeni bir fotoğraf çek",
    "mobile_use_this_photo": "Bu fotoğrafı kullan"
}};
mobile_translations.ms_MY = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Semua",
    "mobile_common_button_apply_filters": "Gunakan Penapis",
    "mobile_common_button_done": "Selesai",
    "mobile_common_button_edit": "Edit",
    "mobile_common_button_archive": "Arkib",
    "mobile_common_button_save": "Simpan",
    "mobile_common_button_retake": "Ambil Semula",
    "mobile_common_button_save_draft": "Simpan Draf",
    "mobile_common_button_discard": "Buang",
    "mobile_common_button_submit": "Hantar",
    "mobile_common_button_no": "Tidak",
    "mobile_common_button_yes": "Ya",
    "mobile_common_button_na": "T/B",
    "mobile_common_created_by_me": "Dicipta oleh Saya",
    "mobile_common_email": "E-mel Syarikat",
    "mobile_common_first_name": "Nama Pertama",
    "mobile_common_last_name": "Nama Keluarga",
    "mobile_common_location": "Lokasi",
    "mobile_common_locations": "Lokasi",
    "mobile_common_logout_message": "Adakah anda pasti mahu log keluar?",
    "mobile_common_password": "Kata Laluan",
    "mobile_common_permission_required": "Kebenaran Diperlukan",
    "mobile_common_status": "Status",
    "mobile_common_task": "Tugas",
    "mobile_common_tasks": "Tugas",
    "mobile_common_tasks_my": "Tugas Saya",
    "mobile_common_projects": "Projek",
    "mobile_common_filter_team": "Pasukan",
    "mobile_common_filter_var_in": " dalam {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Tiada pasukan dipilih",
    "mobile_common_filter_no_user_selected": "Tiada pengguna dipilih",
    "mobile_common_filter_no_role_selected": "Tiada peranan dipilih",
    "mobile_common_placeholder_date": "Tarikh",
    "mobile_common_message_task_creator_error_save": "<b>Tidak dapat mencipta tugas.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "untuk",
    "mobile_common_reload": "Muat semula",
    "mobile_common_override": "Gantikan",
    "mobile_common_notifications": "Pemberitahuan",
    "mobile_common_chat_unavailable": "Ciri Sembang Tidak Tersedia. Cuba lagi nanti.",
    "mobile_common_chat_ending_dialog_title": "Anda sudah selesai dengan perbualan ini?",
    "mobile_common_chat_ending_dialog_description": "Beritahu kami jika isu anda telah diselesaikan atau jika anda hanya ingin meneruskan perbualan kemudian.",
    "mobile_common_chat_ending_dialog_confirm": "Ya, saya sudah selesai",
    "mobile_common_chat_ending_dialog_cancel": "Saya akan meneruskan perbualan kemudian",
    "mobile_common_continue_editing": "Teruskan Mengedit",
    "mobile_privacy_policy": "Dasar Privasi",
    "wootric_recommend_target": "seorang rakan atau rakan sekerja dalam industri anda",
    "wootric_followup_detractor_question": "Apakah perubahan yang kami boleh lakukan untuk anda bagi memberikan kami penarafan lebih tinggi lain kali?",
    "wootric_followup_passive_question": "Terima kasih! Apakah yang kami boleh lakukan untuk menjadikan alat ini lebih baik lagi?",
    "wootric_followup_promoter_question": "Terima kasih! Apakah yang anda suka tentang Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Terima kasih! Apakah hal yang anda suka tentang Zenput?",
    "wootric_default_followup_question": "Terima kasih! Boleh beritahu kami sebabnya?",
    "wootric_default_placeholder_text": "Bantu kami dengan menerangkan skor anda.",
    "wootric_default_thankyou_text": "Terima kasih atas jawapan dan maklum balas anda!",
    "mobile_login_placeholder_login_as": "Log Masuk Sebagai ID Pengguna",
    "mobile_login_button_forgot_password": "Terlupa Kata Laluan?",
    "mobile_login_button_sign_up": "Cipta Akaun",
    "mobile_login_button_finish_setup": "Selesaikan Persediaan",
    "mobile_login_button": "Log Masuk",
    "mobile_login_continue_button": "Teruskan",
    "mobile_login_continue_transition": "membawa anda ke halaman log masuk organisasi anda...",
    "mobile_login_no_email_error": "Anda mesti memasukkan e-mel.",
    "mobile_login_change_email": "Log masuk menggunakan e-mel berlainan",
    "mobile_login_with_sso": "Log Masuk dengan SSO",
    "mobile_oauth_no_user_error_message": "Nampaknya anda tiada akaun Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Nampaknya anda tiada Akaun Zenput!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> kini merupakan <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} akan menjadi {{- product }} pada bulan September. {{- cta }}",
    "mobile_rebrand_warning_cta": "Ketahui cara untuk membuat persediaan.",
    "mobile_oauth_no_user_error_sub_message": "Hubungi pentadbir anda untuk mengakses atau cuba melog masuk menggunakan e-mel berlainan.",
    "mobile_oauth_generic_error_message": "Nampaknya terdapat masalah untuk melog masuk, sila cuba lagi.",
    "mobile_oauth_force_logout_msg": "Jika masalah ini masih berlarutan, log keluar daripada pembekal anda dengan ",
    "mobile_oauth_force_logout_click": "mengklik di sini.",
    "mobile_sign_up_placeholder_phone": "Nombor Sel",
    "mobile_sign_up_placeholder_password_confirm": "Sahkan Kata Laluan",
    "mobile_sign_up_button_sign_in": "Daftar Masuk",
    "mobile_sign_up_disclaimer_part_1": "Dengan mengklik Cipta Akaun, anda bersetuju dengan",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Dengan mengklik Selesaikan Persediaan, anda bersetuju dengan",
    "mobile_sign_up_disclaimer_link_title": " Perjanjian Lesen",
    "mobile_sign_up_disclaimer_part_2": "yang termasuk maklumat privasi penting",
    "mobile_dialog_benefits_work_offline": "Bekerja di Luar Talian",
    "mobile_dialog_benefits_faster_uploads": "Muat Naik dengan Lebih Pantas",
    "mobile_dialog_benefits_better_experience": "Pengalaman yang Lebih Baik",
    "mobile_dialog_benefits_button_download": "Muat Turun",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution untuk ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput untuk ",
    "mobile_dialog_benefits_button_have": "Saya ada apl!",
    "mobile_dialog_benefits_button_no_thanks": "Tidak perlu, mungkin kemudian.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Gagal memuatkan imej.",
    "mobile_dialog_signature_sign": "Tandatangan di Sini",
    "mobile_dialog_signature_button_clear": "Kosongkan",
    "mobile_account_placeholder_name": "Lokasi/Nama Stor",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Alamat",
    "mobile_account_placeholder_city": "Bandar",
    "mobile_account_placeholder_region": "Rantau",
    "mobile_account_placeholder_zipcode": "Poskod",
    "mobile_account_option_select_country": "Pilih Negara",
    "mobile_account_oprion_us": "Amerika Syarikat",
    "mobile_account_oprion_select_state": "Pilih Negeri",
    "mobile_account_button_create_location": "Cipta Lokasi",
    "mobile_form_message_no_form": "Tiada borang yang tersedia",
    "mobile_batch_task_message": "Memuat...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Telefon Bimbit",
    "mobile_settings_profile_language": "Bahasa",
    "mobile_settings_profile_temperature_unit": "Unit Suhu",
    "mobile_settings_profile_use_company_default": "Gunakan tetapan asal syarikat",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Mesej Teks",
    "mobile_settings_notifications_option_push": "Pemberitahuan Tolak",
    "mobile_settings_notifications_option_push_email": "E-mel & Pemberitahuan Tolak",
    "mobile_settings_notifications_option_do_not": "Jangan maklumkan",
    "mobile_settings_notifications_category_communication": "Komunikasi",
    "mobile_settings_notifications_category_forms_and_triggers": "Borang & Pencetus",
    "mobile_settings_devices": "Peranti",
    "mobile_settings_notifications_sub_category_alerts": "Amaran",
    "mobile_settings_notifications_sub_category_new_forms_available": "Borang Baharu Tersedia",
    "mobile_settings_notifications_sub_category_task_assigned": "Tugas Ditugaskan",
    "mobile_settings_notifications_sub_category_task_completed": "Tugas Diselesaikan",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Peringatan tugas genap masa tidak lama lagi",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Peringatan tugas lampau tempoh",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Amaran Penderia",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Amaran Penderia Kritikal",
    "mobile_drafts_message": "Anda belum ada sebarang draf.",
    "mobile_drafts_button_delete": "Padamkan",
    "mobile_tasks_filter_location_no": "Tiada lokasi yang dipilih",
    "mobile_tasks_filter_group_by": "Kumpulkan Mengikut",
    "mobile_tasks_filter_sort_by": "Isih Mengikut",
    "mobile_tasks_filter_sorted_by": "Diisih Mengikut",
    "mobile_tasks_filter_due_time": "Masa Akhir",
    "mobile_tasks_filter_open_time": "Masa Dibuka",
    "mobile_tasks_bucket_due_next_24_hours": "Genap Masa dalam 24 Jam Berikutnya",
    "mobile_tasks_bucket_due_next_7_days": "Genap Masa dalam 7 Hari Berikutnya",
    "mobile_tasks_bucket_open_tasks": "{{type}} Terbuka Tambahan",
    "mobile_tasks_bucket_open_at": "Dibuka: {{- date }} pada {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Genap masa sebelum: {{- date }} pada {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Tersedia dalam 1 minit",
    "mobile_tasks_bucket_available_in_one_hour": "Tersedia dalam 1 jam",
    "mobile_tasks_bucket_available_in_one_day": "Tersedia dalam 1 hari",
    "mobile_tasks_bucket_available_in_one_week": "Tersedia dalam 1 minggu",
    "mobile_tasks_bucket_available_in_one_month": "Tersedia dalam 1 bulan",
    "mobile_tasks_bucket_available_in_one_year": "Tersedia dalam 1 tahun",
    "mobile_tasks_bucket_available_in_minutes": "Tersedia dalam {{ minutes }} minit",
    "mobile_tasks_bucket_available_in_hours": "Tersedia dalam {{ hours }} jam",
    "mobile_tasks_bucket_available_in_days": "Tersedia dalam {{ days }} hari",
    "mobile_tasks_bucket_available_in_weeks": "Tersedia dalam {{ weeks }} minggu",
    "notification_task_due_in_minutes": "Genap masa dalam {{ minutes }} minit",
    "mobile_tasks_bucket_available_in_months": "Tersedia dalam {{ months }} bulan",
    "mobile_tasks_bucket_available_in_years": "Tersedia dalam {{ years }} tahun",
    "mobile_tasks_follow_up": "Tugas Susulan",
    "mobile_tasks_due_soon": "Tarikh akhir hampir tiba",
    "mobile_tasks_bucket_completed_today": "Selesai Hari Ini",
    "mobile_tasks_bucket_completed_this_week": "Selesai Minggu Ini",
    "mobile_tasks_bucket_completed_last_week": "Selesai Minggu Lepas",
    "mobile_tasks_bucket_missed_today": "Terlepas Hari Ini",
    "mobile_tasks_bucket_missed_this_week": "Terlepas Minggu Ini",
    "mobile_tasks_bucket_missed_last_week": "Terlepas Minggu Lepas",
    "mobile_tasks_bucket_no_location": "Tiada Lokasi",
    "mobile_tasks_cannot_submit_missed": "Tugas yang terlepas tidak boleh diselesaikan",
    "mobile_tasks_cannot_submit_missed_after": "Tugas ini tidak boleh diselesaikan selepas {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Tugas ini belum bermula.",
    "mobile_tasks_cannot_submit_processing": "Hantaran ini sedang diproses",
    "mobile_tasks_toolbarnav_header_no_due_date": "Tiada Tarikh Akhir",
    "mobile_tasks_toolbarnav_header_overdue": "Lampau Tempoh",
    "mobile_tasks_toolbarnav_header_yesterday": "Semalam",
    "mobile_tasks_toolbarnav_header_today": "Hari Ini",
    "mobile_tasks_toolbarnav_header_tomorrow": "Esok",
    "mobile_tasks_toolbarnav_header_last_week": "Minggu Lepas",
    "mobile_tasks_toolbarnav_header_this_week": "Minggu Ini",
    "mobile_tasks_toolbarnav_header_next_week": "Minggu Depan",
    "mobile_tasks_toolbarnav_header_this_month": "Bulan Ini",
    "mobile_tasks_toolbarnav_header_next_year": "Tahun Depan",
    "mobile_tasks_toolbarnav_header_over_year": "Lebih Setahun",
    "mobile_tasks_toolbarnav_title_edit_task": "Edit Tugas",
    "mobile_task_placeholder_title": "Rajuk*",
    "mobile_task_placeholder_description": "Penerangan (pilihan)",
    "mobile_task_button_single_task": "Tugas Tunggal",
    "mobile_task_button_project": "Projek",
    "mobile_task_button_create": "Cipta",
    "mobile_task_tab_basic": "Asas",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Borang",
    "mobile_task_details_description_message_please": "Sila isi ",
    "mobile_task_details_description_message_below": "di bawah.",
    "mobile_task_details_description_message_instructions": "Tiada arahan yang tersedia untuk tugas ini.",
    "mobile_task_details_reason_title": "Susulan Dicetuskan oleh",
    "mobile_task_detials_button_goto_form": "Pergi Ke Borang",
    "mobile_task_detials_button_complete": " Selesaikan Tugas",
    "mobile_task_detials_completed": "Selesai ",
    "mobile_task_detials_completed_by": "oleh ",
    "mobile_task_detials_completed_on": "pada ",
    "mobile_task_details_view_form_submission": "Lihat Hantaran Borang",
    "mobile_task_task_updated": "Tugas dikemas kini",
    "mobile_task_task_archived": "Tugas diarkibkan",
    "mobile_task_task_deleted": "Tugas dipadamkan",
    "mobile_task_error_archiving_task": "Tidak dapat mengarkibkan tugas.",
    "mobile_task_error_deleting_task": "Tidak dapat memadamkan tugas.",
    "mobile_task_error_updating_task": "Tidak dapat mengemas kini tugas.",
    "mobile_task_archive_task": "Arkibkan Tugas",
    "mobile_task_archive_task_confirm": "Adakah anda pasti mahu mengarkibkan Tugas ini?\n\nTugas yang diarkibkan akan dikira mengikut kadar selesai dan akan terus dimasukkan dalam pelaporan.\n\nTindakan ini tidak boleh dibuat asal.",
    "mobile_task_delete_task_confirm": "Adakah anda pasti mahu memadamkan Tugas ini?\n\nTugas yang dipadamkan tidak akan dikira mengikut kadar selesai mahupun dimasukkan dalam pelaporan.\n\nTindakan ini tidak boleh dibuat asal.",
    "mobile_task_edition_already_in_progress": "Tugas ini mempunyai edit yang belum selesai. Pengeditan lanjut tidak dibenarkan pada masa ini.",
    "mobile_projects_filter_type": "Jenis",
    "mobile_projects_filter_status": "Status projek",
    "mobile_projects_filter_project_type": "Jenis projek",
    "mobile_projects_due_date_required": "Tarikh akhir diperlukan.",
    "mobile_projects_team_required": "Pasukan diperlukan.",
    "mobile_projects_user_role_required": "Penerima tugas diperlukan.",
    "mobile_projects_title_required": "Tajuk diperlukan.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Berbilang Tugas per Hari",
    "mobile_project_tasks_complete": " Selesai",
    "mobile_project_tasks_remaining": " Baki",
    "mobile_esitmate_message_tasks": "0 tugas akan dicipta",
    "mobile_esitmate_message_criteria": "Laraskan Kriteria Di Atas",
    "mobile_esitmate_message_created_for": "akan dicipta untuk",
    "mobile_left_menu_dashboard": "Papan Pemuka",
    "mobile_left_menu_my_forms": "Borang Saya",
    "mobile_left_menu_announcements": "Pengumuman",
    "mobile_left_menu_my_submissions": "Hantaran Saya",
    "mobile_left_menu_drafts": "Draf",
    "mobile_left_menu_pending_uploads": "Muat Naik yang Belum Selesai",
    "mobile_left_menu_open": "Buka dalam Apl",
    "mobile_left_menu_settings": "Tetapan",
    "mobile_left_menu_log_out": "Log Keluar",
    "mobile_left_menu_debug": "Nyahpepijat",
    "mobile_left_menu_support": "Sokongan",
    "mobile_left_menu_documentation": "Dokumentasi",
    "mobile_left_menu_chat": "Sembang",
    "mobile_field_textarea_placeholder_note": "Nota atau kapsyen",
    "mobile_field_option_select": "Pilih",
    "mobile_field_text_placeholder_text": "Teks",
    "mobile_field_email_placehoder_email": "E-mel",
    "mobile_filed_number_placeholder_number": "Nombor",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Tidak Bersambung",
    "mobile_field_sensor_offline_battery": "Penderia di Luar Talian – Bateri",
    "mobile_field_video_button_add": "Tambah Video",
    "mobile_field_video_picker_dialog_title": "Tambah video daripada",
    "mobile_field_video_button_change": "Tukar Video",
    "mobile_field_image_button_add": "Tambah Imej",
    "mobile_field_image_low_quality_warning": "Sesetengah foto mungkin terlalu gelap atau kabur. Semak foto yang diserlahkan dan gantikannya jika perlu.",
    "mobile_field_image_picker_dialog_title": "Tambah foto daripada",
    "mobile_field_image_picker_edit_failed": "Kami tidak dapat menyimpan imej tersebut. Sila cuba lagi.",
    "mobile_field_signature_button_add": "Tambah Tandatangan",
    "mobile_field_signature_button_change": "Ubah Tandatangan",
    "mobile_field_account_select_location": "Pilih Lokasi",
    "mobile_field_account_prefill": "Praisi borang menggunakan data daripada Lawatan terakhir?",
    "mobile_field_account_message_overwrite": "Ini akan menggantikan mana-mana medan yang anda sudah isi.",
    "mobile_forms_task_on_behalf": "Terdapat satu tugas yang perlu dipenuhi di lokasi ini yang ditugaskan kepada <b>{{user}}</b>. Adakah anda ingin menyelesaikan tugas ini?",
    "mobile_forms_complete_task": "Selesaikan Tugas?",
    "mobile_field_account_prefill_button_yes": "Ya, praisi",
    "mobile_field_barcode_placeholder_scan": "Imbas atau taipkan kod bar",
    "mobile_field_sensor_qr_code_placeholder_scan": "Imbas atau taip kod",
    "mobile_field_gateway_id_code_placeholder": "Taip ID Nod",
    "mobile_field_scan_qr_or_enter_dev_eui": "Imbas Kod QR atau Masukkan DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Imbas Kod QR atau Masukkan Nombor ID",
    "mobile_field_scan_qr_or_enter_sc": "Imbas Kod QR atau Masukkan Kod SC",
    "mobile_field_barcode_select_date": "Pilih Tarikh ",
    "mobile_field_datetime_allow_time": "Masa",
    "mobile_field_stopwatch_button_caption": "Jam randik",
    "mobile_field_stopwatch_common_start": "Mula",
    "mobile_field_stopwatch_common_stop": "Henti",
    "mobile_field_stopwatch_common_reset": "Tetapkan Semula",
    "mobile_field_stopwatch_stop_stopwatches": "Hentikan Jam randik",
    "mobile_field_document_title": "Tambah Dokumen",
    "mobile_field_document_message_delete": "Adakah anda pasti mahu memadamkan dokumen ini?",
    "mobile_field_document_alret_button_view": "Lihat",
    "mobile_field_document_alert_error": "Terdapat ralat semasa melampirkan dokumen ini. Sila cuba lagi.",
    "mobile_field_document_alert_file_size_error": "Fail tidak boleh melebihi {{count}} MB.",
    "mobile_field_temperature_greater_range": "lebih tinggi daripada {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "lebih tinggi atau sama dengan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "kurang daripada {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "kurang daripada atau sama dengan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "lebih tinggi daripada atau sama dengan {{ min_temp_value }} °{{ temp_unit }} dan kurang daripada {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "lebih tinggi daripada atau sama dengan {{ min_temp_value }}°{{ temp_unit }} dan kurang daripada atau sama dengan {{ max_temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " dan ",
    "mobile_field_text_limit_error": "Bilangan aksara telah mencapai had maksimum 8,000.",
    "mobile_forms_required_questions_complete": "Selesai Diperlukan",
    "mobile_forms_required_remaining": "{{count}} Baki Diperlukan",
    "mobile_forms_required_questions_back": "Kembali",
    "mobile_forms_required_questions_next": "Seterusnya",
    "mobile_forms_required_questions_skip": "Langkau",
    "mobile_forms_leaving_form": "Meninggalkan Borang",
    "mobile_message_reordering_confirm": "Anda mahu menyimpan tertib soalan yang baharu?",
    "mobile_forms_leaving_reordering": "Meninggalkan Penyusunan Semula Soalan",
    "mobile_forms_reordering_button_save": "Simpan Tertib Soalan Baharu",
    "mobile_forms_reordering_instructions": "Untuk menyusun semula soalan atau bahagian, seret dan lepaskan ke tempat medan tersebut patut terpapar dalam borang",
    "mobile_toolbarnav_title_my_setttings": "Tetapan Saya",
    "mobile_toolbarnav_title_profile_settings": "Tetapan Profil",
    "mobile_toolbarnav_title_notification": "Tetapan Pemberitahuan",
    "mobile_toolbarnav_title_form_history": "Sejarah Borang",
    "mobile_toolbarnav_title_form_not_available": "Borang Tidak Tersedia",
    "mobile_toolbarnav_title_add_location": "Tambah Lokasi",
    "mobile_toolbarnav_title_add_task_or_project": "Tambah Tugas atau Projek",
    "mobile_toolbarnav_title_select_location": "Pilih Lokasi",
    "mobile_toolbarnav_title_select_project": "Pilih Projek",
    "mobile_toolbarnav_title_select_tag": "Pilih Tag",
    "mobile_toolbarnav_title_select_user": "Pilih Pengguna",
    "mobile_toolbarnav_title_select_template": "Pilih Templat",
    "mobile_toolbarnav_title_select_one": "Pilih Satu",
    "mobile_toolbarnav_title_select_multiple": "Pilih Satu atau Lebih",
    "mobile_toolbarnav_title_select_team": "Pilih Pasukan",
    "mobile_toolbarnav_title_select_team_or_location": "Pilih Pasukan atau Lokasi",
    "mobile_toolbarnav_title_filter_tasks": "Tapis Tugas",
    "mobile_toolbarnav_title_filter_projects": "Tapis Projek",
    "mobile_toolbarnav_title_filter_project_tasks": "Tapis Tugas Projek",
    "mobile_placeholder_search_bar": "Cari",
    "mobile_placeholder_user_select_role": "Pilih Peranan Pengguna",
    "mobile_placeholder_filter_by_team": "Tapis mengikut pasukan",
    "mobile_placeholder_assign_to_user_role": "Tugaskan kepada Peranan Pengguna",
    "mobile_placeholder_select": "-- Pilih --",
    "mobile_placeholder_account_location_name": "Nama Lokasi",
    "mobile_placeholder_tag_filter_by": "Tapis mengikut Tag Lokasi",
    "mobile_placeholder_user_type": "Tugaskan kepada Pengguna",
    "mobile_placeholder_acount_type_loading": "Memuat... ",
    "mobile_placeholder_therm_no_bluetooth": "Suhu",
    "mobile_placeholder_blue_therm_connecting": "Menyambung ke peranti...",
    "mobile_placeholder_blue_therm_please_wait": "Sila tunggu...",
    "mobile_placeholder_blue_therm_tap": "Ketik untuk baca.",
    "mobile_placeholder_blue_therm_not_connected": "Tidak bersambung.",
    "mobile_placeholder_testo_tap": "Tahan ▼▲ diikuti oleh ⬆",
    "mobile_message_error_create_task": "Anda mestilah berada dalam talian untuk menambah tugas.",
    "mobile_message_error_fill_out_form": "Sila isikan borang.",
    "mobile_message_error_fill_require_fields": "Isikan medan yang diperlukan.",
    "mobile_message_error_stop_stopwatch_before_submit": "Hentikan jam randik anda sebelum hantaran",
    "mobile_message_error_stopwatch_field_required": "Medan jam randik diperlukan.",
    "mobile_message_error_stopwatch_field_running": "Medan jam randik sedang berjalan",
    "mobile_message_error_invalid_equipment_temperature": "Suhu peralatan yang tidak sah",
    "mobile_message_error_invalid_ingredient_temperature": "Suhu bahan yang tidak sah",
    "mobile_message_error_location_attributes_unavailable": "Sesetengah soalan mungkin tidak tersedia, sila buat sambungan ke internet",
    "mobile_message_alert_running_stopwatches": "Anda telah menjalankan jam randik.\n\nAdakah anda ingin mengosongkannya?",
    "mobile_message_blue_therm_error": "Sambungan Hilang ke Peranti Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Akses Lokasi diperlukan. Aktifkannya dalam tetapan Android anda.",
    "mobile_message_blue_therm_no_permission_android": "Akses Peranti Berhampiran diperlukan. Aktifkannya dalam tetapan Android anda.",
    "mobile_message_blue_therm_error_code": "Gagal Menyambung:",
    "mobile_message_blue_therm_error_bluetooth": "Sila dayakan Bluetooth.",
    "mobile_message_blue_therm_error_device": "Peranti tidak ditemui.",
    "mobile_message_blue_therm_error_try_again": "Sila Cuba Lagi",
    "mobile_message_blue_therm_success": "Peranti Bluetooth Bersambung!",
    "mobile_message_bluetooth_device_press_button_field": "Tekan butang pada peranti anda untuk bersambung.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Tekan butang pada peranti anda<br />jika anda tidak melihat ia disenaraikan di sini.",
    "mobile_bluetooth_scan": "Imbas",
    "mobile_bluetooth_scanning": "Mengimbas",
    "mobile_message_drafts_confirm": "Adakah anda ingin menyimpan ini sebagai draf?",
    "mobile_message_drafts_toast_saved": "Draf Disimpan.",
    "mobile_message_drafts_request_update": "Adakah anda ingin mengemas kini draf ini?",
    "mobile_message_drafts_form_confirm": "Adakah anda pasti mahu memadamkan draf ini?",
    "mobile_message_drafts_confirm_delete": "Padamkan Draf",
    "mobile_message_streams_error_switch": "Tidak dapat mengubah strim pada web",
    "mobile_message_settings_success_saved": "Tetapan Disimpan",
    "mobile_message_settings_error": "Ralat yang tidak diketahui berlaku. Cuba lagi kemudian",
    "mobile_message_profile_settings_error_fields": "Sila betulkan medan yang diserlahkan.",
    "mobile_message_media_perimission_denied": "Anda Punya ",
    "mobile_message_media_perimission_denied_device": "Storan Peranti",
    "mobile_message_image_confirm_remove_image": "Adakah anda pasti mahu memadamkan foto ini?",
    "mobile_message_create_account_error_fields": "Sila isikan medan yang diserlahkan.",
    "mobile_message_create_account_success_location_created": "Lokasi Dicipta",
    "mobile_message_task_error_get_location": "Gagal untuk mendapatkan lokasi. Menyusun mengikut tarikh",
    "mobile_message_typehead_confirm_save_message": "Adakah anda mahu menyimpan pilihan ini?",
    "mobile_message_typehead_confirm_save_title": "Simpan?",
    "mobile_message_task_creator_error_save_select_form": "Anda mesti memilih borang.",
    "mobile_message_task_creator_error_save_required_fields": "Sila isikan medan yang diperlukan.",
    "mobile_message_task_creator_error_save_batch_change": "Sila ubah kriteria untuk dipadankan dengan seorang atau lebih pengguna",
    "mobile_message_task_detials_error_not_assigned_to_you": "Tugas ini tidak ditugaskan kepada anda.<br />Anda tidak boleh melengkapkannya.",
    "mobile_message_task_detials_error_assigned_to": "Tugas ini ditugaskan kepada {{user}}.<br />Anda tidak boleh melengkapkannya.",
    "mobile_message_task_detials_confirm_title": "Meninggalkan Tugas",
    "mobile_message_task_detials_confirm_save_task": "Simpan Tugas",
    "mobile_message_task_detials_confirm_message": "Adakah anda pasti? Perubahan anda akan hilang.",
    "mobile_message_task_detials_error_view_account": "Tidak Dapat Mengakses Lokasi.",
    "mobile_message_task_detials_error_submit_task": "Sila tambah foto untuk selesaikan tugas ini.",
    "mobile_message_task_detials_error_submit_task_project": "Tida dapat menyimpan projek. Sila cuba lagi kemudian.",
    "mobile_message_task_detials_wait_submit_task_created": "Tugas sedang dicipta.<br />Sila tunggu beberapa minit untuk tugas diisi.",
    "mobile_message_task_detials_error_submit_task_pending": "Ralat, sila cuba lagi kemudian",
    "mobile_message_task_detials_success_task_complete": "Tugas Selesai",
    "mobile_message_task_error_save_single_task": "Tidak dapat menyimpan tugas. Sila cuba lagi kemudian.",
    "mobile_message_task_success_save_single_task": "Tugas Dicipta.",
    "mobile_message_show_error_message": "Masalah telah berlaku.",
    "mobile_message_show_success_message": "Berjaya!",
    "mobile_message_show_offline_message": "Anda kini berada di luar talian.",
    "mobile_message_show_permission_denied_message": "<b>Kebenaran Diperlukan.</b> Sila berikan kebenaran kepada Zenput untuk mengakses {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Keizinan Diperlukan.</b> Sila berikan keizinan kepada Zenput dan Pelayar anda untuk mengakses {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Kini Memuat Naik",
    "mobile_message_show_upload_in_progress_message": "Muat naik sedang dalam proses",
    "mobile_message_show_form_id_error": "Tidak dapat mengakses borang khusus.",
    "mobile_message_show_single_task_error": "Tidak dapat mengakses tugas khusus.",
    "mobile_message_show_submissions_error": "Tidak dapat mengakses serahan khusus.",
    "mobile_message_show_submissions_access_denied": "Maaf, anda tidak mempunyai akses kepada borang ini.",
    "mobile_message_send_data_success": "Data dimuat naik ",
    "mobile_message_start_upload_success": "Muat Naik Selesai",
    "mobile_message_start_upload_error": "<b>Tidak dapat melengkapkan muat naik.</b><br>Hantaran disimpan. Sila cuba lagi kemudian",
    "mobile_message_store_upgrade_store_ios": "Gedung Apl",
    "mobile_message_store_upgrade_store_android": "Gedung Play",
    "mobile_message_store_upgrade_confirm_title": "Kemas Kini Tersedia",
    "mobile_message_store_upgrade_confirm_message_one": "Sila kemas kinikan aplikasi Ops Execution daripada ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Sila kemas kini Zenput daripada ",
    "mobile_message_store_upgrade_confirm_message_two": " untuk mendapatkan semua ciri terbaru dan pembaikan pepijat",
    "mobile_message_store_upgrade_confirm_now": "Sekarang",
    "mobile_message_store_upgrade_confirm_later": "Kemudian",
    "mobile_message_redirect_confirm_message": "Anda sedang mengisi borang. Adakah anda ingin menyimpan sebagai draf sebelum meneruskan?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Anda mempunyai {{count}} draf yang belum dimuat naik. Draf ini akan hilang jika anda teruskan. Adakah anda pasti?",
    "mobile_message_draft_override_message": "Draf ini telah disimpan daripada peranti lain pada {{date}}, dan perubahan pada peranti ini telah bercanggah. Anda boleh memilih untuk menggantikan versi sedia ada atau memuat semula kepada versi terkini, dan perubahan anda akan dibuang.",
    "mobile_html_submitting": "Menghantar...",
    "mobile_html_offline": "Anda kini berada di luar talian!",
    "mobile_html_offline_try_again": "Anda kini berada di luar talian. <br/><br/>Sila cuba lagi setelah anda disambungkan.",
    "mobile_html_something_went_wrong": "Alamak. Masalah telah berlaku.",
    "mobile_html_something_went_wrong_try_again": "Alamak. Masalah telah berlaku. Sila cuba semula.",
    "mobile_html_failed_loading_roles": "Gagal memuatkan peranan.",
    "mobile_alert_please_install_for_native": "Sila pasang aplikasi Ops Execution untuk menggunakan ciri ini. ",
    "mobile_alert_please_install_for_native_old": "Gagal memasang apl Zenput asli untuk menggunakan ciri ini.",
    "mobile_tso_filter_all_tasks": "Semua {{type}}",
    "mobile_tso_filter_my_tasks": "{{type}} Saya",
    "mobile_tso_filter_due_date": "Tarikh Akhir",
    "mobile_tso_filter_date_completed": "Tarikh Selesai",
    "mobile_tso_filter_completed": "Selesai",
    "mobile_tso_filter_completed_late": "Diselesaikan Lewat",
    "mobile_tso_filter_incomplete": "Tidak Selesai",
    "mobile_tso_filter_var_my_tasks": "{{filter_type}} {{type}} Saya",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} Yang Saya Cipta",
    "mobile_tso_filter_var_all_tasks": "Semua {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Tindakan Susulan",
    "mobile_tso_type_all": "Tugas dan Tindakan Susulan",
    "mobile_tso_filter_var_at": " pada {{location}}",
    "mobile_tso_filter_group_date_due": ", disusun mengikut Tarikh Akhir",
    "mobile_tso_filter_group_distance": ". dikumpulkan mengikut Lokasi",
    "mobile_tso_filter_start_date": "Tarikh Mula",
    "mobile_tso_filter_none": "Tiada",
    "mobile_pso_filter_all_projects": "Semua Projek",
    "mobile_pso_filter_my_projects": "Projek Saya",
    "mobile_pso_filter_active": "Aktif",
    "mobile_pso_filter_archived": "Arkib",
    "mobile_pso_filter_recurring": "Berulang",
    "mobile_pso_filter_non_recurring": "Tidak Berulang",
    "mobile_pso_filter_var_my_projects": "Projek {{project_type}} {{active_description}} Saya",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Projek Dicipta oleh Saya",
    "mobile_pso_filter_var_all_projects": "Semua {{project_type}} {{active_description}} Projek",
    "mobile_empty_list_message_must_be_online": "Nampaknya anda berada di luar talian. Sila masuk ke dalam talian untuk melihat hasil.",
    "mobile_empty_list_message_no_submissions": "Tiada Hantaran",
    "mobile_empty_list_message_no_activity": "Tiada Aktiviti",
    "mobile_empty_list_message_no_tasks": "Tiada Tugas",
    "mobile_empty_list_message_no_tasks_overdue": "Tiada {{type}} Lampau Tempoh",
    "mobile_empty_list_message_no_accounts": "Tiada Lokasi",
    "mobile_empty_list_message_no_projects": "Tiada Projek",
    "mobile_empty_list_message_no_results_found": "Hasil Tidak Ditemui",
    "mobile_empty_list_message_no_forms_available": "Tiada Borang yang Tersedia",
    "mobile_empty_list_message_connection_error": "Ralat Sambungan<br />Sila cuba lagi.",
    "mobile_empty_list_message_dashboard_error": "Tidak Dapat Memuatkan Papan Pemuka",
    "mobile_empty_list_message_user_offline": "Anda kini berada di luar talian",
    "mobile_action_sheet_media_gallery": "Galeri",
    "mobile_action_sheet_cancel": "Batalkan",
    "mobile_image_preview_text": "Alih Keluar Foto",
    "mobile_mobileform_text": "Hantaran Sebelumnya",
    "mobile_mobileform_reorder_fields": "Susun Semula Soalan",
    "mobile_mobileform_follow_up_actions": "Tindakan Susulan",
    "mobile_mobileform_follow_up_actions_assign_title": "Tugaskan tindakan susulan",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Tambah tindakan susulan berdasarkan pemerhatian anda untuk memastikan isu ditangani.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Tambah Tindakan Susulan",
    "mobile_mobileform_follow_up_actions_assign_button": "Tugaskan Item Susulan",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Teruskan Tanpa Menugaskan",
    "mobile_mobileform_follow_up_actions_dialog_title": "Teruskan Tanpa Menugaskan Tindakan Susulan?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Jika anda meneruskan langkah tanpa menugaskan sebarang tindakan susulan, anda tidak akan dapat menambahnya kemudian.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Teruskan Juga",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Medan ini diperlukan",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Terlalu banyak aksara",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Medan ini tidak sah",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Ralat ketika memuatkan lokasi",
    "mobile_mobileform_add_follow_up_actions_error_users": "Ralat ketika memuatkan pengguna",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Tambah Item Susulan",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Tajuk",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Penerangan",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Memerlukan Foto",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Tarikh Akhir",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Kemas Kinikan Item Susulan",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Padamkan Item Susulan?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Ia akan dialih keluar dan tidak akan ditugaskan.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Padamkan Item Susulan",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Adakah anda pasti mahu memadamkan Item Susulan ini?\n\nTindakan ini tidak boleh dibuat asal.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Teruskan Ke Item Susulan",
    "mobile_mobileform_follow_up_actions_completed_notification": "Tindakan Susulan Diselesaikan",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Tindakan Susulan Dipadamkan",
    "mobile_mobileform_follow_up_actions_update_notification": "Tindakan Susulan Dikemaskinikan",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Sila tambah foto untuk menyelesaikan tindakan susulan ini",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Navigasi ke serahan",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Navigasi ke sumber",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Sumber",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Selesaikan Item Susulan",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Jika anda membuka serahan tersebut, sebarang foto dan nota yang belum disimpan akan hilang.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Jika anda meninggalkan skrin ini, sebarang foto dan nota yang belum disimpan akan hilang.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Kekal di sini",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Buka serahan",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Buka sumber",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Tinggalkan tindakan susulan ini?",
    "mobile_mobileform_follow_up_actions_submission": "Serahan",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Tindakan Susulan ini ditugaskan kepada {{user}}.<br />Anda tidak boleh menyelesaikannya.",
    "mobile_mobileform_follow_up_actions_leave_description": "Jika anda meninggalkan skrin ini, sebarang perubahan yang belum disimpan akan hilang.",
    "mobile_mobileform_follow_up_actions_leave": "Tinggalkan",
    "mobile_forms_drafts_text": "Alih Keluar Draf",
    "mobile_batch_estimate_user": "Pengguna",
    "mobile_batch_estimate_users": "Pengguna",
    "mobile_table_of_contents": "Isi Kandungan",
    "mobile_table_of_contents_required": "Diperlukan",
    "mobile_table_of_contents_optional": "Pilihan",
    "mobile_dialog_alert_title": "Amaran",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Peranti Bluetooth belum disokong pada Windows",
    "mobile_windows_deprecated_message_content_announcement": "Pengumuman",
    "mobile_windows_deprecated_message_title": "Pengemaskinian aplikasi diperlukan",
    "mobile_windows_deprecated_message_description": "Pasang App Zenput yang baharu dalam Microsoft Store secepat mungkin untuk memastikan pengemaskinian fungsi yang kritikal dan pengalaman Zenput yang optimum.",
    "mobile_dashboard_tcr_graph_name": "Kadar Tugas Selesai",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 Minggu Lepas",
    "mobile_dashboard_tcr_legend_company_average": "Purata Syarikat",
    "mobile_dashboard_tcr_legend_team_average": "Purata Pasukan",
    "mobile_dashboard_tab_title_summary": "Ringkasan",
    "mobile_dashboard_tab_title_activity": "Aktiviti",
    "mobile_dashboard_card_title_top_triggered_workflows": "Pencetus Teratas",
    "mobile_dashboard_tab_title_info": "Maklumat",
    "mobile_dashboard_tab_project_audit": "Pematuhan",
    "mobile_dashboard_card_task_stats_total": "Jumlah",
    "mobile_dashboard_top_item_header_week_of": "Minggu bagi",
    "mobile_dashboard_card_filter_form_template_placeholder": "Semua Borang",
    "mobile_dashboard_card_title_forms_top_nos": "Kekerapan \"Tidak\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "Tiada data dalam julat masa ini.",
    "mobile_dashboard_zenput_code_permission_denied": "Anda tiada kebenaran untuk melihat ini.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Pilih borang daripada atas.",
    "mobile_dashboard_zenput_code_unknown_error": "Kami tidak dapat memaparkan data pada masa ini.",
    "mobile_dashboard_tap_to_retry": "Ketik untuk Cuba Semula",
    "mobile_dashboard_reporting_delay_disclaimer": "Tugas mungkin mengambil masa hingga 15 minit untuk dikemas kini",
    "mobile_dashboard_configuration_down_state_postfix_msg": "telah dikonfigurasikan oleh pentadbir anda.",
    "mobile_tasks_tag": "tugas",
    "mobile_workflows_tag": "pencetus",
    "mobile_projects_tag": "projek berulang",
    "mobile_forms_tag": "borang",
    "mobile_dashboard_card_ongoing_projects_title": "Projek Sedang Berjalan",
    "mobile_dashboard_card_ongoing_projects_show_more": "Tunjukkan Lagi",
    "mobile_dashboard_card_ongoing_projects_show_less": "Tunjukkan Kurang",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Pergi Ke Projek",
    "mobile_dashboard_card_title_recurring_projects": "Projek Berulang",
    "mobile_dashboard_card_filter_daily": "Harian",
    "mobile_dashboard_card_filter_weekly": "Mingguan",
    "mobile_dashboard_card_filter_monthly": "Bulanan",
    "mobile_task_status_title_open": "Buka",
    "mobile_task_status_title_upcoming": "Akan datang",
    "mobile_task_status_title_complete": "Selesai",
    "mobile_task_status_title_processing": "Pemprosesan Hantaran",
    "mobile_task_status_title_complete_with_exceptions": "Selesai dengan Susulan Tugas atau Amaran",
    "mobile_task_status_title_completed_late_with_exceptions": "Diselesaikan Lewat dengan Tugas Susulan atau Amaran",
    "mobile_task_status_title_incomplete_and_closed": "Terlepas",
    "mobile_tasks_legend_modal_title": "Legenda",
    "mobile_tasks_legend_modal_footer_button_title": "Tutup",
    "mobile_common_assigned_to": "Tugaskan Kepada",
    "mobile_common_created_by": "Dicipta oleh",
    "mobile_common_tasks_for": "Tugas untuk",
    "mobile_common_go_back": "Kembali",
    "mobile_oh_no": "Alamak!",
    "mobile_user_not_in_groups": "Maaf, nampaknya anda tidak ditugaskan kepada pasukan. Hubungi pentadbir anda untuk mendapatkan akses ke papan pemuka anda.",
    "mobile_tasks_select_followers": "Pilih Pengikut",
    "mobile_tasks_assign_tasks": "Tugaskan {{count}} Tugas",
    "mobile_tasks_add_followers": "Tambah Pengikut",
    "mobile_tasks_followers": "Pengikut",
    "mobile_tasks_delete_task": "Padamkan Tugas",
    "mobile_tasks_create_task": "Cipta Tugas",
    "mobile_tasks_tab_title_comments": "Komen",
    "mobile_tasks_see_more": "Lihat lagi",
    "mobile_projects_create_project": "Cipta Projek",
    "mobile_common_button_send": "Hantar",
    "mobile_common_button_schedule": "Jadual",
    "mobile_announcements_create": "Cipta Pengumuman",
    "mobile_announcements_read_rate": "{{opened_count}} daripada {{recipients_count}} Dibuka",
    "mobile_announcements_empty_message": "Anda belum mencipta sebarang pengumuman! Cipta pengumuman di bawah untuk menyiarkan berita penting, maklumat dan kemas kini kepada organisasi anda.",
    "mobile_announcement_message_placeholder": "Tambah mesej...",
    "mobile_announcement_title_placeholder": "Tajuk Pengumuman",
    "mobile_announcement_leaving_announcement": "Meninggalkan Pengumuman",
    "mobile_announcement_confirm_recipients_team": "Adakah anda mahu menyiarkan pengumuman ini kepada {{count}} pengguna dalam {{teams}} pasukan terpilih?",
    "mobile_announcement_confirm_recipients_role": "Adakah anda mahu menyiarkan pengumuman ini kepada {{count}} pengguna dalam {{roles}} peranan pengguna terpilih?",
    "mobile_announcement_confirm_recipients_user": "Adakah anda mahu menyiarkan pengumuman ini kepada {{count}} pengguna?",
    "mobile_announcement_confirm_scheduled": "Pada {{timestamp}}",
    "mobile_announcement_sending_announcement": "Menghantar Pengumuman",
    "mobile_announcement_send_to": "Hantar Kepada",
    "mobile_announcement_sent_to": "Dihantar Kepada",
    "mobile_announcement_send_to_role": "Peranan",
    "mobile_announcement_attachment_download": "Memuat Turun {{filename}}",
    "mobile_announcement_attachment_validation_error": "Maksimum {{maxCount}} lampiran boleh ditambah",
    "mobile_announcement_details_sent": "Dihantar",
    "mobile_announcement_details_total_recipients": "Jumlah Penerima",
    "mobile_announcement_details_cancel": "Batalkan Pengumuman",
    "mobile_announcement_details_not_editable": "Pengumuman hanya boleh diedit dalam aplikasi web Ops Execution. ",
    "mobile_announcement_details_not_editable_old": "Pengumuman mungkin hanya diedit pada Web Zenput",
    "mobile_announcement_details_open_count": "Buka Kiraan",
    "mobile_announcement_details_open_rate": "Buka Kadar",
    "mobile_announcement_details_resend": "Hantar semula kepada bukan pembuka",
    "mobile_announcement_confirm_resend": "{{count}} pengguna belum membaca pengumuman. Adakah anda mahu menghantar peringatan?",
    "mobile_announcement_confirm_resend_title": "Hantar Peringatan?",
    "mobile_announcement_recipients_opened": "Dibuka",
    "mobile_recipients_opened_empty_message": "Nampaknya belum ada orang membuka mesej anda. Kembali lagi kemudian untuk melihat hasil anda.",
    "mobile_announcement_recipients_unopened": "Tidak dibuka",
    "mobile_recipients_unopened_empty_message": "Berita baik! Tiada mesej yang belum dibuka!",
    "mobile_scheduled_announcements_delivery_section_header": "Masa Penghantaran",
    "mobile_scheduled_announcements_send_immediately_label": "Hantar dengan segera",
    "mobile_scheduled_announcements_scheduled_label": "Hantar pada masa khusus",
    "mobile_scheduled_announcements_scheduled_tab_label": "Dijadualkan",
    "mobile_scheduled_announcements_dialog_header": "Batalkan Pengumuman?",
    "mobile_scheduled_announcements_dialog_message": "Membatalkan pengumuman anda akan menghentikannya daripada dihantar dan memadamkannya daripada senarai anda. Ini tidak boleh dibuat asal. Untuk edit, pergi ke Web Zenput.",
    "mobile_scheduled_announcements_empty_message": "Anda tiada pengumuman berjadual pada masa ini. Jadualkan pengumuman untuk menyiarkan berita penting, maklumat dan kemas kini kepada organisasi anda.",
    "mobile_scheduled_announcements_validation_error": "Masa penghantaran mestilah selepas {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Pengumuman Jadual",
    "mobile_projects_auto_archive": "Auto Arkib",
    "mobile_common_unassigned": "Tidak Ditugaskan",
    "mobile_tasks_title_placeholder": "Tugas atau Borang Baharu",
    "mobile_projects_leaving_project": "Meninggalkan Projek",
    "mobile_projects_save_project": "Simpan Projek",
    "mobile_top_triggers_tasks": "Tugas Tercetus Teratas",
    "mobile_top_triggers_alerts": "Amaran Tercetus Teratas",
    "mobile_projects_not_started": "Tidak Bermula",
    "mobile_empty_list_message_no_photos": "Tiada Foto",
    "mobile_webfilestore_message_error": "Sila pilih jenis fail yang sah",
    "mobile_notifications_empty_title": "Tiada Pemberitahuan",
    "mobile_notifications_empty_message": "Aktiviti yang ada pada tugas anda atau yang sebahagian daripada tugas anda akan dipaparkan di sini.",
    "mobile_comments_comment_deleted": "Komen ini telah dipadamkan.",
    "mobile_comments_comment_placeholder": "Komen",
    "mobile_comments_task_submitted_at": "Tugas diserahkan pada {{ date }} pada {{ time }}",
    "mobile_comments_discard_comment_title": "Buang Komen?",
    "mobile_comments_discard_confirm_message": "Adakah anda pasti? Komen anda akan dipadamkan.",
    "mobile_comments_delete_comment_title": "Padamkan Komen?",
    "mobile_comments_delete_confirm_message": "Tindakan ini tidak boleh dibuat asal.",
    "mobile_comments_delete_button": "Padamkan Komen.",
    "mobile_comments_delete_success_message": "Komen Dipadamkan",
    "mobile_comments_empty_message_tasks": "Belum ada komen lagi \n Mulakan perbualan pada tugas ini.",
    "mobile_comments_empty_message_submissions": "Belum ada komen lagi \n Mulakan perbualan pada hantaran ini.",
    "mobile_comments_empty_message_default": "Belum ada komen lagi \n Mulakan perbualan.",
    "mobile_comments_no_matching_users": "Tiada padanan pengguna.",
    "mobile_comments_empty_users_to_notify": "Tiada pengguna untuk dimaklumkan.",
    "mobile_comments_users_cant_view_message": "Pengguna ini tidak boleh melihat komen ini",
    "mobile_comments_users_to_notify_title": "Pengguna yang akan Dimaklumkan",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} pengguna</a> akan dimaklumkan.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} pengguna</a> akan dimaklumkan.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@sebut</a> lagi pengguna akan dimaklumkan.",
    "mobile_comments_mark_read": "Tandakan semua sebagai dibaca",
    "mobile_comments_author_mentioned_message": "menyebut anda dalam",
    "mobile_comments_author_commented_message": "komen tentang",
    "mobile_view_pdf": "Lihat PDF",
    "mobile_no_pdf_generated_message": "Tiada PDF ditemui untuk serahan ini. Satu salinan akan dihantar e-mel kepada anda sebentar lagi.",
    "mobile_clipboard_copied_success": "Pautan disalin pada papan klip anda.",
    "mobile_share_link": "Kongsikan Pautan",
    "mobile_zencam_share": "Kongsikan",
    "mobile_zencam_view_details": "Lihat butiran",
    "mobile_zencam_details_drawer_header": "Butiran",
    "mobile_zencam_submitted_by": "Diserahkan oleh",
    "mobile_zencam_form_title": "Tajuk Borang",
    "mobile_zencam_date_submitted": "Tarikh Diserahkan",
    "mobile_oil_quality_warning_message": "Minyak hampir tamat tempoh",
    "mobile_oil_quality_warning_message_subtitle": "Mula merancang untuk menukarnya cepat",
    "mobile_oil_quality_failure_message": "Kualiti minyak terjejas",
    "mobile_oil_quality_failure_message_subtitle": "Tukar minyak dengan segera",
    "mobile_sensors_set_up_gateway": "Sediakan Get Laluan",
    "mobile_sensors_set_up_gateway_message": "Nampaknya tiada peranti disediakan. Bermula dengan menambah get laluan.",
    "mobile_sensors_gateway_plugged_in": "Pastikan get laluan anda dipalamkan ke dalam saluran kuasa",
    "mobile_sensors_add_device": "Tambah peranti",
    "mobile_sensors_name_this_gateway": "Namakan get laluan ini.",
    "mobile_sensors_name_this_sensor": "Namakan penderia ini.",
    "mobile_sensors_device_barcode_information": "Imbas Kod QR atau masukkan ID dan nombor SC daripada label peranti",
    "mobile_sensors_device_eui_information": "Imbas Kod QR atau masukkan DevEUI daripada label peranti",
    "mobile_sensors_gateway_id_information": "Masukkan ID Nod daripada label Get Laluan",
    "mobile_sensors_id_number": "{{untranslatedID}} Nombor",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Kod",
    "mobile_sensors_sensors": "Penderia",
    "mobile_sensors_sensor_deveui_error": "DevEUI tidak berjaya didapatkan daripada QR. Sila masukkannya secara manual.",
    "mobile_sensors_gateways": "Get Laluan",
    "mobile_sensors_add_sensor": "Tambah Penderia",
    "mobile_sensors_add_gateway": "Tambah Get Laluan",
    "mobile_sensor_placement_description": "Apakah kawasan yang akan dipantau oleh penderia ini?",
    "mobile_sensors_equipment_placement": "Apakah kawasan atau peralatan yang akan dipantau oleh penderia ini?",
    "mobile_sensors_equipment": "Apakah peralatan yang akan dipantau oleh penderia ini?",
    "mobile_sensors_select_gateway_type": "Pilih jenis get laluan",
    "mobile_sensors_select_placement": "Pilih Gantian",
    "mobile_sensors_select_equipment": "Pilih Peralatan",
    "mobile_sensors_placement": "Gantian",
    "mobile_sensors_nickname_tip": "Penamaan penderia ditentukan oleh nama ringkas yang diberikan dalam penempatan yang dipilih.",
    "mobile_sensors_device_online": "Dalam Talian",
    "mobile_sensors_device_offline": "Luar Talian",
    "mobile_sensors_scan_qrcode": "Imbas Kod QR",
    "mobile_sensors_enter_manually": "Masukkan Secara Manual",
    "mobile_sensors_wizard_step_one": "Langkah 1",
    "mobile_sensors_wizard_step_two": "Langkah 2",
    "mobile_sensors_wizard_step_three": "Langkah 3",
    "mobile_sensors_wizard_step_four": "Langkah 4",
    "mobile_sensors_wizard_step_five": "Langkah 5",
    "mobile_sensors_wizard_step_six": "Langkah 6",
    "mobile_sensors_initializing": "Memulakan...",
    "mobile_sensors_nickname": "Nama gelaran",
    "mobile_sensors_field_not_blank": "Medan {{field}} tidak boleh kosong.",
    "mobile_sensors_nothing_to_see_here": "Tiada Perkara yang Boleh Dilihat di Sini",
    "mobile_sensors_missing_integration": "Integrasi Penderia Tidak Ada",
    "mobile_sensors_contact_zenput_admin": "Sila hubungi pentadbir Ops Execution di syarikat anda.",
    "mobile_sensors_contact_zenput_admin_old": "Sila hubungi pentadbir Zenput anda.",
    "mobile_sensors_contact_manager": "Hubungi pengurus akaun anda untuk menambah penderia.",
    "mobile_sensors_device_success_message": "Data penderia mungkin mengambil masa hingga 15 minit untuk dimuatkan",
    "mobile_sensors_last_reading": "Bacaan Terakhir",
    "mobile_sensors_remove_device": "Alih Keluar Peranti",
    "mobile_sensors_one_day": "1H",
    "mobile_sensors_one_week": "1M",
    "mobile_sensors_one_month": "1B",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6B",
    "mobile_sensors_one_year": "1T",
    "mobile_sensors_sensor_settings": "Tetapan Penderia",
    "mobile_sensors_remove_confirm_message": "Adakah anda pasti mahu memadamkan peranti ini\nTindakan ini tidak boleh dibuat asal.",
    "mobile_sensors_sensor": "Penderia",
    "mobile_sensors_no_equipment_linked": "Tiada Peralatan Dipautkan",
    "mobile_sensor_cooldown_process": "Proses Penyejukan",
    "mobile_sensor_last_12_hours": "12 Jam Terakhir",
    "mobile_sensor_start_cooldown_process": "Mulakan Proses Penyejukan Baharu",
    "mobile_sensor_cooldown_process_title": "Dua Peringkat Proses Penyejukan",
    "mobile_sensor_cooldown_process_description": "Proses penyejukan dua peringkat mengandungi makanan sejuk dari suhu melebihi {{ stage1_start_temperature }} hingga {{ stage1_end_temperature }} dalam maksimum dua jam, kemudian dari {{ stage1_end_temperature }} hingga {{ stage2_end_temperature }} dalam maksimum empat jam.",
    "mobile_sensor_cooldown_process_place_food": "Letakkan produk makanan di dalam peti sejuk.",
    "mobile_sensor_cooldown_process_insert_sensor": "Masukkan prob penderia di dalam produk makanan.",
    "mobile_sensor_cooldown_process_enter_information": "Masukkan maklumat di bawah.",
    "mobile_sensor_cooldown_process_food_product": "Produk Makanan untuk disejukkan",
    "mobile_sensor_cooldown_cool_down": "Penyejukan",
    "mobile_sensor_cooldown_select_sensor": "Pilih Penderia",
    "mobile_sensors_cooldown_start_cooldown": "Mulakan Penyejukan",
    "mobile_sensors_cooldown_please_enter_food": "Sila masukkan Produk Makanan",
    "mobile_sensors_cooldown_please_select_sensor": "Sila pilih Penderia",
    "mobile_sensors_cooldown_status_in_progress": "Sedang Berjalan",
    "mobile_sensors_cooldown_status_failed": "Gagal",
    "mobile_sensors_cooldown_status_success": "Berjaya",
    "mobile_sensors_cooldown_stage": "Peringkat",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Suhu mula berada di luar julat",
    "mobile_sensors_cooldown_failed_cooldown_process": "Proses Penyejukan Gagal",
    "mobile_sensors_cooldown_cooldown_successful": "Penyejukan Berjaya",
    "mobile_sensors_cooldown_started_cooldown_process": "Proses Penyejukan Bermula",
    "mobile_sensors_cooldown_hour": "jam",
    "mobile_sensors_cooldown_hour_plural": "jam",
    "mobile_sensors_cooldown_minute": "minit",
    "mobile_minutes_plural": "minit",
    "mobile_sensors_last_reading_max_date": "> 1 tahun lalu",
    "mobile_sensors_minute_count_ago": "{{count}} minit lalu",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minit lalu",
    "mobile_sensors_hour_count_ago": "{{count}} jam lalu",
    "mobile_sensors_hour_count_ago_plural": "{{count}} jam lalu",
    "mobile_sensors_day_count_ago": "{{count}} hari lalu",
    "mobile_sensors_day_count_ago_plural": "{{count}} hari lalu",
    "mobile_sensors_chart_settings": "Tetapan Carta",
    "mobile_announcement_banner_continue_reading": "Teruskan bacaan",
    "mobile_compliance_submissions_report": "Laporan Serahan",
    "mobile_compliance_submissions_report_subtitle": "Eksport data penyiapan projek untuk kedai ini",
    "mobile_compliance_send_submissions": "Hantar Serahan",
    "mobile_compliance_completion_rate_in_last_days": "Kadar Penyiapan dalam {{ days }} Hari Lalu",
    "mobile_compliance_last_days": "{{ days }} Hari Lalu",
    "mobile_compliance_send_submissions_to": "Hantar Serahan ke",
    "mobile_compliance_send_to_different_email": "Hantar ke E-mel Berlainan",
    "mobile_compliance_email_input_placeholder": "Alamat E-mel",
    "mobile_compliance_send_submissions_to_legend_title": "Serahan",
    "mobile_compliance_send_submissions_to_legend_description_days": "Satu laporan dengan serahan anda dari lokasi ini dalam {{ days }} hari lalu akan dihantar ke e-mel yang dipilih.",
    "mobile_compliance_time_frame": "Rangka Masa",
    "mobile_compliance_sensor_temperature_log_report": "Laporan Log Suhu Penderia",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Eksport log suhu untuk kedai ini",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kriteria",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Takrifkan kriteria untuk laporan anda di bawah.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Nota: Penderia yang dinyahaktifkan tidak akan ditunjukkan dalam laporan",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Pilih rangka masa. Data log dihadkan kepada maksimum 30 hari.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Hantar Laporan",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Bulan Ini (1 hb. – Hari Ini)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Bulan Lepas",
    "mobile_compliance_sensor_temperature_log_email_title": "Hantar Laporan Kepada",
    "mobile_pwa_update_prompt_title": "Kemas Kinikan Aplikasi",
    "mobile_pwa_update_prompt_description": "Versi baharu aplikasi ini tersedia. Sila kemas kinikannya kepada versi terbaharu.",
    "mobile_pwa_update_prompt_confirm": "Kemas Kinikan Dan Muatkan Semula",
    "mobile_pwa_update_prompt_cancel": "Ingatkan Saya Kemudian",
    "notification_title_due_in_one_hour": "Genap masa dalam 1 jam",
    "task_is_due_soon": "\"{{ task_title }}\" akan genap masa tidak lama lagi. Luangkan sedikit masa untuk menyelesaikannya.",
    "mobile_photo_quality_warning_header": "Isu kualiti foto",
    "mobile_photo_quality_dialog_message": "Foto ini mungkin terlalu gelap atau kabur. Adakah anda ingin mengambil foto baharu, atau teruskan langkah dengan foto ini?",
    "mobile_take_new_photo": "Ambil foto baharu",
    "mobile_use_this_photo": "Gunakan foto ini"
}};
mobile_translations.pt_PT = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Todos",
    "mobile_common_button_apply_filters": "Aplicar filtros",
    "mobile_common_button_done": "Concluído",
    "mobile_common_button_edit": "Editar",
    "mobile_common_button_archive": "Arquivo",
    "mobile_common_button_save": "Guardar",
    "mobile_common_button_retake": "Retomar",
    "mobile_common_button_save_draft": "Guardar plano",
    "mobile_common_button_discard": "Rejeitar",
    "mobile_common_button_submit": "Submeter",
    "mobile_common_button_no": "Não",
    "mobile_common_button_yes": "Sim",
    "mobile_common_button_na": "N/D",
    "mobile_common_created_by_me": "Criado por mim",
    "mobile_common_email": "E-mail da empresa",
    "mobile_common_first_name": "Nome",
    "mobile_common_last_name": "Apelido",
    "mobile_common_location": "Localização",
    "mobile_common_locations": "Localizações",
    "mobile_common_logout_message": "Tem a certeza de que pretende terminar sessão?",
    "mobile_common_password": "Palavra-passe",
    "mobile_common_permission_required": "Permissão necessária",
    "mobile_common_status": "Estado",
    "mobile_common_task": "Tarefa",
    "mobile_common_tasks": "Tarefas",
    "mobile_common_tasks_my": "As minhas tarefas",
    "mobile_common_projects": "Projetos",
    "mobile_common_filter_team": "Equipa",
    "mobile_common_filter_var_in": " em {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Nenhuma equipa selecionada",
    "mobile_common_filter_no_user_selected": "Nenhum utilizador selecionado",
    "mobile_common_filter_no_role_selected": "Nenhuma função selecionada",
    "mobile_common_placeholder_date": "Data",
    "mobile_common_message_task_creator_error_save": "<b>Não foi possível criar tarefas.</b>",
    "mobile_common_camera": "Câmara",
    "mobile_common_microphone": "Microfone",
    "mobile_common_for": "para",
    "mobile_common_reload": "Atualizar",
    "mobile_common_override": "Substituir",
    "mobile_common_notifications": "Notificações",
    "mobile_common_chat_unavailable": "Conversação indisponível. Tente novamente mais tarde.",
    "mobile_common_chat_ending_dialog_title": "Terminou esta conversa?",
    "mobile_common_chat_ending_dialog_description": "Diga-nos se o seu problema foi resolvido ou se pretende apenas continuar mais tarde.",
    "mobile_common_chat_ending_dialog_confirm": "Sim, já terminei",
    "mobile_common_chat_ending_dialog_cancel": "Vou continuar mais tarde",
    "mobile_common_continue_editing": "Continuar a editar",
    "mobile_privacy_policy": "Política de Privacidade",
    "wootric_recommend_target": "um amigo ou colega na indústria",
    "wootric_followup_detractor_question": "Que alterações podemos fazer para nos dar uma avaliação melhor da próxima vez?",
    "wootric_followup_passive_question": "Obrigado! O que poderíamos fazer para tornar a ferramenta ainda melhor?",
    "wootric_followup_promoter_question": "Obrigado! O que é que mais gosta no Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Obrigado! Do que é que gosta no Zenput?",
    "wootric_default_followup_question": "Obrigado! Pode dizer-nos porquê?",
    "wootric_default_placeholder_text": "Ajude-nos explicando a sua classificação.",
    "wootric_default_thankyou_text": "Obrigado pela sua resposta e pelo seu feedback!",
    "mobile_login_placeholder_login_as": "Iniciar sessão como ID de utilizador",
    "mobile_login_button_forgot_password": "Esqueceu-se da palavra-passe?",
    "mobile_login_button_sign_up": "Criar conta",
    "mobile_login_button_finish_setup": "Concluir a configuração",
    "mobile_login_button": "Iniciar sessão",
    "mobile_login_continue_button": "Continuar",
    "mobile_login_continue_transition": "está a ser direcionado para a página de início de sessão da sua organização",
    "mobile_login_no_email_error": "Tem de introduzir um e-mail.",
    "mobile_login_change_email": "Iniciar sessão com um e-mail diferente",
    "mobile_login_with_sso": "Iniciar sessão com SSO",
    "mobile_oauth_no_user_error_message": "Parece que não tem uma conta no Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Parece que não tem uma conta Zenput.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> é agora <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} tornar-se-á {{- product }} em setembro. {{- cta }}",
    "mobile_rebrand_warning_cta": "Saiba como se preparar.",
    "mobile_oauth_no_user_error_sub_message": "Contacte o administrador para obter acesso ou tente iniciar sessão com um e-mail diferente.",
    "mobile_oauth_generic_error_message": "Parece ter ocorrido um problema ao iniciar sessão, tente novamente.",
    "mobile_oauth_force_logout_msg": "Se ainda tiver problemas, termine sessão no fornecedor ",
    "mobile_oauth_force_logout_click": "clicando aqui.",
    "mobile_sign_up_placeholder_phone": "Número de telemóvel",
    "mobile_sign_up_placeholder_password_confirm": "Confirmar palavra-passe",
    "mobile_sign_up_button_sign_in": "Iniciar sessão",
    "mobile_sign_up_disclaimer_part_1": "Ao clicar em Criar conta, concorda com o",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Ao clicar em Concluir a configuração, concorda com a",
    "mobile_sign_up_disclaimer_link_title": " Acordo de licença",
    "mobile_sign_up_disclaimer_part_2": ", que inclui importantes informações de privacidade",
    "mobile_dialog_benefits_work_offline": "Trabalhar offline",
    "mobile_dialog_benefits_faster_uploads": "Carregamentos mais rápidos",
    "mobile_dialog_benefits_better_experience": "Melhor experiência",
    "mobile_dialog_benefits_button_download": "Transferir",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution para ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput para ",
    "mobile_dialog_benefits_button_have": "Tenho a aplicação!",
    "mobile_dialog_benefits_button_no_thanks": "Não, obrigado, talvez mais tarde.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Falha ao carregar imagem.",
    "mobile_dialog_signature_sign": "Assine aqui",
    "mobile_dialog_signature_button_clear": "Apagar",
    "mobile_account_placeholder_name": "Nome da localização/loja",
    "mobile_account_placeholder_phone": "Telefone",
    "mobile_account_placeholder_address": "Endereço",
    "mobile_account_placeholder_city": "Cidade",
    "mobile_account_placeholder_region": "Região",
    "mobile_account_placeholder_zipcode": "Código postal",
    "mobile_account_option_select_country": "Selecionar país",
    "mobile_account_oprion_us": "Estados Unidos",
    "mobile_account_oprion_select_state": "Selecionar estado",
    "mobile_account_button_create_location": "Criar localização",
    "mobile_form_message_no_form": "Nenhum formulário disponível",
    "mobile_batch_task_message": "A carregar...",
    "mobile_settings_profile": "Perfil",
    "mobile_settings_profile_number": "Telemóvel",
    "mobile_settings_profile_language": "Idioma",
    "mobile_settings_profile_temperature_unit": "Unidade de temperatura",
    "mobile_settings_profile_use_company_default": "Utilizar o padrão da empresa",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Mensagem de texto",
    "mobile_settings_notifications_option_push": "Notificações",
    "mobile_settings_notifications_option_push_email": "E-mail e notificações",
    "mobile_settings_notifications_option_do_not": "Não notificar",
    "mobile_settings_notifications_category_communication": "Comunicação",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulários e acionadores",
    "mobile_settings_devices": "Dispositivos",
    "mobile_settings_notifications_sub_category_alerts": "Alertas",
    "mobile_settings_notifications_sub_category_new_forms_available": "Novos formulários disponíveis",
    "mobile_settings_notifications_sub_category_task_assigned": "Tarefa atribuída",
    "mobile_settings_notifications_sub_category_task_completed": "Tarefa concluída",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Lembrete de tarefas vencidas brevemente",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Lembrete de tarefas vencidas",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Alertas de sensor",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alertas de Sensor críticos",
    "mobile_drafts_message": "Ainda não tem planos.",
    "mobile_drafts_button_delete": "Apagar",
    "mobile_tasks_filter_location_no": "Nenhuma localização selecionada",
    "mobile_tasks_filter_group_by": "Agrupar por",
    "mobile_tasks_filter_sort_by": "Ordenar por",
    "mobile_tasks_filter_sorted_by": "Ordenado por",
    "mobile_tasks_filter_due_time": "Hora de vencimento",
    "mobile_tasks_filter_open_time": "Hora de abertura",
    "mobile_tasks_bucket_due_next_24_hours": "Previstos nas próximas 24 horas",
    "mobile_tasks_bucket_due_next_7_days": "Previstos nos próximos 7 dias",
    "mobile_tasks_bucket_open_tasks": "Vagas adicionais {{type}}",
    "mobile_tasks_bucket_open_at": "Abrir: {{- date }} às {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Até: {{- date }} às {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponível dentro de 1 minuto",
    "mobile_tasks_bucket_available_in_one_hour": "Disponível dentro de 1 hora",
    "mobile_tasks_bucket_available_in_one_day": "Disponível dentro de 1 dia",
    "mobile_tasks_bucket_available_in_one_week": "Disponível dentro de 1 semana",
    "mobile_tasks_bucket_available_in_one_month": "Disponível dentro de 1 mês",
    "mobile_tasks_bucket_available_in_one_year": "Disponível dentro de 1 ano",
    "mobile_tasks_bucket_available_in_minutes": "Disponível dentro de {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_hours": "Disponível dentro de {{ hours }} horas",
    "mobile_tasks_bucket_available_in_days": "Disponível dentro de {{ days }} dias",
    "mobile_tasks_bucket_available_in_weeks": "Disponível dentro de {{ weeks }} semanas",
    "notification_task_due_in_minutes": "Entrega em {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_months": "Disponível dentro de {{ months }} meses",
    "mobile_tasks_bucket_available_in_years": "Disponível dentro de {{ years }} anos",
    "mobile_tasks_follow_up": "Tarefa de seguimento",
    "mobile_tasks_due_soon": "Previsto para breve",
    "mobile_tasks_bucket_completed_today": "Conclui hoje",
    "mobile_tasks_bucket_completed_this_week": "Conclui esta semana",
    "mobile_tasks_bucket_completed_last_week": "Concluiu semana passada",
    "mobile_tasks_bucket_missed_today": "Falhou hoje",
    "mobile_tasks_bucket_missed_this_week": "Falhou esta semana",
    "mobile_tasks_bucket_missed_last_week": "Falhou semana passada",
    "mobile_tasks_bucket_no_location": "Sem localização",
    "mobile_tasks_cannot_submit_missed": "Tarefas falhadas não podem ser concluídas",
    "mobile_tasks_cannot_submit_missed_after": "Esta tarefa não pode ser concluída depois de {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Esta tarefa não foi iniciada.",
    "mobile_tasks_cannot_submit_processing": "Esta submissão está a ser processada",
    "mobile_tasks_toolbarnav_header_no_due_date": "Sem data de vencimento",
    "mobile_tasks_toolbarnav_header_overdue": "Vencido",
    "mobile_tasks_toolbarnav_header_yesterday": "Ontem",
    "mobile_tasks_toolbarnav_header_today": "Hoje",
    "mobile_tasks_toolbarnav_header_tomorrow": "Amanhã",
    "mobile_tasks_toolbarnav_header_last_week": "Semana passada",
    "mobile_tasks_toolbarnav_header_this_week": "Esta semana",
    "mobile_tasks_toolbarnav_header_next_week": "Próxima semana",
    "mobile_tasks_toolbarnav_header_this_month": "Este mês",
    "mobile_tasks_toolbarnav_header_next_year": "Próximo ano",
    "mobile_tasks_toolbarnav_header_over_year": "Mais de um ano",
    "mobile_tasks_toolbarnav_title_edit_task": "Editar tarefa",
    "mobile_task_placeholder_title": "Título *",
    "mobile_task_placeholder_description": "Descrição (opcional)",
    "mobile_task_button_single_task": "Tarefa única",
    "mobile_task_button_project": "Projeto",
    "mobile_task_button_create": "Criar",
    "mobile_task_tab_basic": "Básico",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formulário",
    "mobile_task_details_description_message_please": "Preencha ",
    "mobile_task_details_description_message_below": "abaixo.",
    "mobile_task_details_description_message_instructions": "Nenhuma instrução disponível para esta tarefa.",
    "mobile_task_details_reason_title": "Seguimento provocado por",
    "mobile_task_detials_button_goto_form": "Ir para o formulário",
    "mobile_task_detials_button_complete": " Concluir tarefa",
    "mobile_task_detials_completed": "Concluído ",
    "mobile_task_detials_completed_by": "por ",
    "mobile_task_detials_completed_on": "sobre ",
    "mobile_task_details_view_form_submission": "Ver submissão de formulário",
    "mobile_task_task_updated": "Tarefa atualizada",
    "mobile_task_task_archived": "Tarefa arquivada",
    "mobile_task_task_deleted": "Tarefa eliminada",
    "mobile_task_error_archiving_task": "Não foi possível arquivar a tarefa.",
    "mobile_task_error_deleting_task": "Não foi possível eliminar a tarefa.",
    "mobile_task_error_updating_task": "Não foi possível atualizar a tarefa.",
    "mobile_task_archive_task": "Arquivar tarefa",
    "mobile_task_archive_task_confirm": "Tem a certeza de que pretende arquivar esta Tarefa?\n\nTarefas arquivadas irão contar para as taxas de conclusão e serão incluídas nos relatórios.\n\nNão é possível anular esta ação.",
    "mobile_task_delete_task_confirm": "Tem a certeza de que pretende eliminar esta Tarefa?\n\nTarefas eliminadas não irão contar para as taxas de conclusão nem serão incluídas em qualquer relatório.\n\nNão é possível anular esta ação.",
    "mobile_task_edition_already_in_progress": "Esta tarefa tem uma edição pendente. Não são permitidas mais edições.",
    "mobile_projects_filter_type": "Tipo",
    "mobile_projects_filter_status": "Estado do projeto",
    "mobile_projects_filter_project_type": "Tipo de projeto",
    "mobile_projects_due_date_required": "A data de validade é necessária.",
    "mobile_projects_team_required": "A equipa é necessária.",
    "mobile_projects_user_role_required": "O representante é necessário.",
    "mobile_projects_title_required": "O título é necessário.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Várias tarefas por dia",
    "mobile_project_tasks_complete": " Completo",
    "mobile_project_tasks_remaining": " Restante",
    "mobile_esitmate_message_tasks": "0 tarefas serão criadas",
    "mobile_esitmate_message_criteria": "Ajustar critérios acima",
    "mobile_esitmate_message_created_for": "será criado para",
    "mobile_left_menu_dashboard": "Painel de controlo",
    "mobile_left_menu_my_forms": "Os meus formulários",
    "mobile_left_menu_announcements": "Anúncios",
    "mobile_left_menu_my_submissions": "As minhas submissões",
    "mobile_left_menu_drafts": "Planos",
    "mobile_left_menu_pending_uploads": "Carregamentos pendentes",
    "mobile_left_menu_open": "Abrir na aplicação",
    "mobile_left_menu_settings": "Definições",
    "mobile_left_menu_log_out": "Terminar sessão",
    "mobile_left_menu_debug": "Depurar",
    "mobile_left_menu_support": "Suporte",
    "mobile_left_menu_documentation": "Documentação",
    "mobile_left_menu_chat": "Conversação",
    "mobile_field_textarea_placeholder_note": "Nota ou legenda",
    "mobile_field_option_select": "Selecionar",
    "mobile_field_text_placeholder_text": "Texto",
    "mobile_field_email_placehoder_email": "E-mail",
    "mobile_filed_number_placeholder_number": "Número",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Não ligado",
    "mobile_field_sensor_offline_battery": "Sensor offline - Bateria",
    "mobile_field_video_button_add": "Adicionar um vídeo",
    "mobile_field_video_picker_dialog_title": "Adicionar vídeo a partir de",
    "mobile_field_video_button_change": "Alterar vídeo",
    "mobile_field_image_button_add": "Adicionar imagem",
    "mobile_field_image_low_quality_warning": "Algumas fotos podem estar demasiado escuras ou desfocadas. Reveja as fotos assinaladas e substitua-as, se necessário",
    "mobile_field_image_picker_dialog_title": "Adicionar fotografia a partir de",
    "mobile_field_image_picker_edit_failed": "Não foi possível guardar a imagem. Tente outra vez.",
    "mobile_field_signature_button_add": "Adicionar uma assinatura",
    "mobile_field_signature_button_change": "Alterar assinatura",
    "mobile_field_account_select_location": "Selecionar uma localização",
    "mobile_field_account_prefill": "Pré-preencher o formulário com dados da última visita?",
    "mobile_field_account_message_overwrite": "Isto substituirá todos os campos que já tiver preenchido.",
    "mobile_forms_task_on_behalf": "Existe uma tarefa a realizar nesta localização que se encontra atribuída a <b>{{user}}</b>. Gostaria de executar esta tarefa?",
    "mobile_forms_complete_task": "Concluir tarefa?",
    "mobile_field_account_prefill_button_yes": "Sim, pré-preencher",
    "mobile_field_barcode_placeholder_scan": "Digitalizar ou digitar código de barras",
    "mobile_field_sensor_qr_code_placeholder_scan": "Digitalizar ou digitar código",
    "mobile_field_gateway_id_code_placeholder": "Tipo de nó ID",
    "mobile_field_scan_qr_or_enter_dev_eui": "Digitalizar código QR ou introduzir DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Digitalizar código QR ou introduzir número ID",
    "mobile_field_scan_qr_or_enter_sc": "Digitalizar código QR ou introduzir código SC",
    "mobile_field_barcode_select_date": "Selecionar data ",
    "mobile_field_datetime_allow_time": "Hora",
    "mobile_field_stopwatch_button_caption": "Cronómetro",
    "mobile_field_stopwatch_common_start": "Iniciar",
    "mobile_field_stopwatch_common_stop": "Parar",
    "mobile_field_stopwatch_common_reset": "Repor",
    "mobile_field_stopwatch_stop_stopwatches": "Parar cronómetros",
    "mobile_field_document_title": "Adicionar documento",
    "mobile_field_document_message_delete": "Tem a certeza de que pretende apagar este documento?",
    "mobile_field_document_alret_button_view": "Ver",
    "mobile_field_document_alert_error": "Ocorreu um erro ao anexar este documento. Tente novamente.",
    "mobile_field_document_alert_file_size_error": "O ficheiro não pode exceder {{count}} MB.",
    "mobile_field_temperature_greater_range": "maior que {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "maior que ou igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "menor que {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "menor que ou igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "maior que ou igual a {{ min_temp_value }} °{{ temp_unit }} e menor que {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "maior que ou igual a {{ min_temp_value }} °{{ temp_unit }} e menor que ou igual a {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " e ",
    "mobile_field_text_limit_error": "Limite máximo de caracteres de 8000 atingido.",
    "mobile_forms_required_questions_complete": "Necessário completar",
    "mobile_forms_required_remaining": "{{count}} Restante necessário",
    "mobile_forms_required_questions_back": "Voltar",
    "mobile_forms_required_questions_next": "Próximo",
    "mobile_forms_required_questions_skip": "Ignorar",
    "mobile_forms_leaving_form": "A sair do formulário",
    "mobile_message_reordering_confirm": "Pretende guardar a nova ordem das questões?",
    "mobile_forms_leaving_reordering": "A sair do reordenamento das questões",
    "mobile_forms_reordering_button_save": "Guardar nova ordem das questões",
    "mobile_forms_reordering_instructions": "Para reordenar questões ou secções, arraste e largue para onde o campo deve aparecer no formulário",
    "mobile_toolbarnav_title_my_setttings": "As minhas definições",
    "mobile_toolbarnav_title_profile_settings": "Definições de perfil",
    "mobile_toolbarnav_title_notification": "Definições de notificação",
    "mobile_toolbarnav_title_form_history": "Histórico de formulários",
    "mobile_toolbarnav_title_form_not_available": "Formulário não disponível",
    "mobile_toolbarnav_title_add_location": "Adicionar localização",
    "mobile_toolbarnav_title_add_task_or_project": "Adicionar tarefa ou projeto",
    "mobile_toolbarnav_title_select_location": "Selecionar localização",
    "mobile_toolbarnav_title_select_project": "Selecionar projeto",
    "mobile_toolbarnav_title_select_tag": "Selecionar etiqueta",
    "mobile_toolbarnav_title_select_user": "Selecionar utilizador",
    "mobile_toolbarnav_title_select_template": "Selecionar modelo",
    "mobile_toolbarnav_title_select_one": "Selecionar um",
    "mobile_toolbarnav_title_select_multiple": "Selecione um ou mais",
    "mobile_toolbarnav_title_select_team": "Selecionar equipa",
    "mobile_toolbarnav_title_select_team_or_location": "Selecione Equipa ou Local",
    "mobile_toolbarnav_title_filter_tasks": "Filtrar tarefas",
    "mobile_toolbarnav_title_filter_projects": "Filtrar projetos",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrar tarefas do projeto",
    "mobile_placeholder_search_bar": "Pesquisar",
    "mobile_placeholder_user_select_role": "Selecionar função do utilizador",
    "mobile_placeholder_filter_by_team": "Filtrar por uma equipa",
    "mobile_placeholder_assign_to_user_role": "Atribuir à função do utilizador",
    "mobile_placeholder_select": "- Selecionar -",
    "mobile_placeholder_account_location_name": "Nome da localização",
    "mobile_placeholder_tag_filter_by": "Filtrar por etiqueta de localização",
    "mobile_placeholder_user_type": "Atribuir ao utilizador",
    "mobile_placeholder_acount_type_loading": "A carregar... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatura",
    "mobile_placeholder_blue_therm_connecting": "A ligar ao dispositivo...",
    "mobile_placeholder_blue_therm_please_wait": "Aguarde...",
    "mobile_placeholder_blue_therm_tap": "Toque para ler.",
    "mobile_placeholder_blue_therm_not_connected": "Não ligado.",
    "mobile_placeholder_testo_tap": "Prima ▼▲ seguido por ⬆",
    "mobile_message_error_create_task": "Deve estar online para adicionar tarefas.",
    "mobile_message_error_fill_out_form": "Preencha o formulário.",
    "mobile_message_error_fill_require_fields": "Preencha os campos obrigatórios.",
    "mobile_message_error_stop_stopwatch_before_submit": "Pare o cronómetro antes de submeter",
    "mobile_message_error_stopwatch_field_required": "O campo Cronómetro é obrigatório",
    "mobile_message_error_stopwatch_field_running": "O campo Cronómetro está a ser executado",
    "mobile_message_error_invalid_equipment_temperature": "Temperatura do equipamento inválida",
    "mobile_message_error_invalid_ingredient_temperature": "Temperatura do ingrediente inválida",
    "mobile_message_error_location_attributes_unavailable": "Algumas questões podem estar indisponíveis, conecte-se à internet",
    "mobile_message_alert_running_stopwatches": "Tem cronómetros em execução.\n\nGostaria de os apagar?",
    "mobile_message_blue_therm_error": "Ligação perdida ao dispositivo Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "É necessário o acesso à localização. Ative-o nas definições do seu Android.",
    "mobile_message_blue_therm_no_permission_android": "É necessário ativar o acesso a «Dispositivos próximos». Ative-o nas definições do seu Android.",
    "mobile_message_blue_therm_error_code": "Falha ao ligar:",
    "mobile_message_blue_therm_error_bluetooth": "Ative o Bluetooth.",
    "mobile_message_blue_therm_error_device": "Dispositivo não encontrado.",
    "mobile_message_blue_therm_error_try_again": "Tente novamente",
    "mobile_message_blue_therm_success": "O dispositivo Bluetooth está ligado.",
    "mobile_message_bluetooth_device_press_button_field": "Prima o botão no seu dispositivo para estabelecer a ligação.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Prima o botão no seu dispositivo<br />se não estiver listado aqui.",
    "mobile_bluetooth_scan": "Analisar",
    "mobile_bluetooth_scanning": "A analisar",
    "mobile_message_drafts_confirm": "Gostaria de guardar isto como um plano?",
    "mobile_message_drafts_toast_saved": "Plano guardado.",
    "mobile_message_drafts_request_update": "Gostaria de atualizar este plano?",
    "mobile_message_drafts_form_confirm": "Tem certeza de que pretende apagar este plano?",
    "mobile_message_drafts_confirm_delete": "Apagar plano",
    "mobile_message_streams_error_switch": "Não é possível alterar streams na web",
    "mobile_message_settings_success_saved": "Definições guardadas",
    "mobile_message_settings_error": "Ocorreu um erro desconhecido. Tente novamente mais tarde",
    "mobile_message_profile_settings_error_fields": "Corrija os campos assinalados.",
    "mobile_message_media_perimission_denied": "Seus ",
    "mobile_message_media_perimission_denied_device": "Dispositivo de armazenamento",
    "mobile_message_image_confirm_remove_image": "Tem certeza de que pretende apagar esta foto?",
    "mobile_message_create_account_error_fields": "Preencha os campos assinalados.",
    "mobile_message_create_account_success_location_created": "Localização criada",
    "mobile_message_task_error_get_location": "Falha ao obter localização. A ordenar por data.",
    "mobile_message_typehead_confirm_save_message": "Pretende guardar estas seleções?",
    "mobile_message_typehead_confirm_save_title": "Guardar?",
    "mobile_message_task_creator_error_save_select_form": "Deve selecionar um formulário.",
    "mobile_message_task_creator_error_save_required_fields": "Preencha os campos obrigatórios.",
    "mobile_message_task_creator_error_save_batch_change": "Altere os critérios para corresponder a um ou mais utilizadores",
    "mobile_message_task_detials_error_not_assigned_to_you": "Esta tarefa não está atribuída a si.<br />Não pode concluí-la.",
    "mobile_message_task_detials_error_assigned_to": "Esta tarefa está atribuída a {{user}}.<br />Não pode concluí-la.",
    "mobile_message_task_detials_confirm_title": "A sair da tarefa",
    "mobile_message_task_detials_confirm_save_task": "Guardar tarefa",
    "mobile_message_task_detials_confirm_message": "Tem a certeza? As suas alterações ficarão sem efeito.",
    "mobile_message_task_detials_error_view_account": "Não é possível aceder à localização.",
    "mobile_message_task_detials_error_submit_task": "Adicione uma foto para concluir esta tarefa.",
    "mobile_message_task_detials_error_submit_task_project": "Não foi possível guardar o projeto. Tente novamente mais tarde.",
    "mobile_message_task_detials_wait_submit_task_created": "As tarefas estão a ser criadas.<br />Aguarde alguns minutos para que as tarefas sejam povoadas.",
    "mobile_message_task_detials_error_submit_task_pending": "Erro, tente novamente mais tarde",
    "mobile_message_task_detials_success_task_complete": "Tarefa concluída",
    "mobile_message_task_error_save_single_task": "Não foi possível guardar a tarefa. Tente novamente mais tarde.",
    "mobile_message_task_success_save_single_task": "Tarefa criada.",
    "mobile_message_show_error_message": "Algo correu mal.",
    "mobile_message_show_success_message": "Sucesso!",
    "mobile_message_show_offline_message": "Está atualmente offline.",
    "mobile_message_show_permission_denied_message": "<b>Permissão necessária.</b> Dê permissão ao Zenput para aceder {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Permissão necessária.</b> Autorize o Zenput e o seu navegador a aceder a {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "A carregar",
    "mobile_message_show_upload_in_progress_message": "Carregamento já a decorrer",
    "mobile_message_show_form_id_error": "Não é possível aceder ao formulário especificado.",
    "mobile_message_show_single_task_error": "Não é possível aceder à tarefa especificada.",
    "mobile_message_show_submissions_error": "Não é possível aceder à submissão especificada.",
    "mobile_message_show_submissions_access_denied": "Não tem acesso a este formulário.",
    "mobile_message_send_data_success": "Dados carregados ",
    "mobile_message_start_upload_success": "Carregamento concluído",
    "mobile_message_start_upload_error": "<b>Não foi possível concluir o carregamento.</b><br>Submissão guardada. Tente novamente mais tarde",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Atualização disponível",
    "mobile_message_store_upgrade_confirm_message_one": "Atualize a aplicação Ops Execution a partir de ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Atualize o Zenput a partir de ",
    "mobile_message_store_upgrade_confirm_message_two": " para obter todos os recursos mais recentes e correções de erros",
    "mobile_message_store_upgrade_confirm_now": "Agora",
    "mobile_message_store_upgrade_confirm_later": "Mais tarde",
    "mobile_message_redirect_confirm_message": "Está atualmente a preencher um formulário. Gostaria de guardá-lo como um plano antes de prosseguir?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Tem {{count}} planos que não foram ainda carregados. Estes serão perdidos se prosseguir. Tem a certeza?",
    "mobile_message_draft_override_message": "Este rascunho foi guardado a partir de outro dispositivo em {{date}}, e as alterações neste dispositivo estão em conflito. Pode escolher entre substituir pela versão existente ou atualizar para a versão mais recente e as suas alterações serão eliminadas.",
    "mobile_html_submitting": "A submeter...",
    "mobile_html_offline": "Está atualmente offline!",
    "mobile_html_offline_try_again": "Está atualmente offline. <br/><br/>Tente novamente quando estiver ligado",
    "mobile_html_something_went_wrong": "Algo correu mal.",
    "mobile_html_something_went_wrong_try_again": "Algo correu mal. Tente novamente.",
    "mobile_html_failed_loading_roles": "Falha ao carregar funções.",
    "mobile_alert_please_install_for_native": "Instale a aplicação Ops Execution para utilizar esta funcionalidade. ",
    "mobile_alert_please_install_for_native_old": "Instale a aplicação Zenput nativa para usar este recurso.",
    "mobile_tso_filter_all_tasks": "Todos {{type}}",
    "mobile_tso_filter_my_tasks": "O meu {{type}}",
    "mobile_tso_filter_due_date": "Data de vencimento",
    "mobile_tso_filter_date_completed": "Data de conclusão",
    "mobile_tso_filter_completed": "Concluído",
    "mobile_tso_filter_completed_late": "Concluído com atraso",
    "mobile_tso_filter_incomplete": "Incompleto",
    "mobile_tso_filter_var_my_tasks": "O meu {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} Criado por mim",
    "mobile_tso_filter_var_all_tasks": "Todos {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Ações de seguimento",
    "mobile_tso_type_all": "Tarefas e ações de seguimento",
    "mobile_tso_filter_var_at": " em {{location}}",
    "mobile_tso_filter_group_date_due": ", ordenado por Data de vencimento",
    "mobile_tso_filter_group_distance": ", agrupado por Localização",
    "mobile_tso_filter_start_date": "Data de Início",
    "mobile_tso_filter_none": "Nenhuma",
    "mobile_pso_filter_all_projects": "Todos os projetos",
    "mobile_pso_filter_my_projects": "Os meus projetos",
    "mobile_pso_filter_active": "Ativar",
    "mobile_pso_filter_archived": "Arquivado",
    "mobile_pso_filter_recurring": "Recorrente",
    "mobile_pso_filter_non_recurring": "Não recorrente",
    "mobile_pso_filter_var_my_projects": "Os meus {{project_type}} {{active_description}} projetos",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Projetos criados por mim",
    "mobile_pso_filter_var_all_projects": "Todos os {{project_type}} {{active_description}} projetos",
    "mobile_empty_list_message_must_be_online": "Parece que está offline. Deve estar online para ver os resultados.",
    "mobile_empty_list_message_no_submissions": "Nenhuma submissão",
    "mobile_empty_list_message_no_activity": "Sem Atividade",
    "mobile_empty_list_message_no_tasks": "Sem tarefas",
    "mobile_empty_list_message_no_tasks_overdue": "Sem vencimentos {{type}}",
    "mobile_empty_list_message_no_accounts": "Sem localizações",
    "mobile_empty_list_message_no_projects": "Sem projetos",
    "mobile_empty_list_message_no_results_found": "Nenhum resultado encontrado",
    "mobile_empty_list_message_no_forms_available": "Nenhum formulário disponível",
    "mobile_empty_list_message_connection_error": "Erro de ligação<br />Tente novamente.",
    "mobile_empty_list_message_dashboard_error": "Não é possível carregar o painel de controlo",
    "mobile_empty_list_message_user_offline": "Está atualmente offline",
    "mobile_action_sheet_media_gallery": "Galeria",
    "mobile_action_sheet_cancel": "Cancelar",
    "mobile_image_preview_text": "Remover foto",
    "mobile_mobileform_text": "Submissões anteriores",
    "mobile_mobileform_reorder_fields": "Reordenar questões",
    "mobile_mobileform_follow_up_actions": "Ações de seguimento",
    "mobile_mobileform_follow_up_actions_assign_title": "Atribuir ações de seguimento",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Adicione ações de seguimento com base nas suas observações para garantir que os problemas sejam resolvidos.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Adicionar ação de seguimento",
    "mobile_mobileform_follow_up_actions_assign_button": "Atribuir seguimentos",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continuar sem atribuir",
    "mobile_mobileform_follow_up_actions_dialog_title": "Deseja continuar sem atribuir ações de seguimento?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Se continuar sem atribuir quaisquer ações de seguimento, não poderá adicioná-las posteriormente.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continuar, de qualquer forma",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Este campo é obrigatório",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Demasiados caracteres",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Este campo é inválido",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Error ao carregar localizações",
    "mobile_mobileform_add_follow_up_actions_error_users": "Error ao carregar utilizadores",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Adicionar seguimento",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Título",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Descrição",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "É necessário uma foto",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Prazo",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Atualizar seguimento",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Eliminar seguimento",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Será removido e não será atribuído.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Eliminar seguimento",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Tem certeza de que pretende apagar este seguimento?\n\nNão é possível anular esta ação.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continuar para Seguimentos",
    "mobile_mobileform_follow_up_actions_completed_notification": "Ação de seguimento concluída",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Ação de seguimento eliminada",
    "mobile_mobileform_follow_up_actions_update_notification": "Ação de seguimento atualizada",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Adicione uma foto para concluir esta ação de seguimento",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Aceder ao envio",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Aceder à fonte",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Fonte",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Concluir seguimento",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Se abrir o envio, todas as fotografias e notas que não tenham sido guardadas serão perdidas.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Se sair deste ecrã, todas as fotografias e notas que não tenham sido guardadas serão perdidas.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Ficar aqui",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Abrir submissão",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Código aberto",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Abandonar esta ação de seguimento?",
    "mobile_mobileform_follow_up_actions_submission": "Submissão",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Esta ação de seguimento está atribuída a {{user}}.<br />Não pode concluí-la.",
    "mobile_mobileform_follow_up_actions_leave_description": "Se sair deste ecrã, quaisquer alterações não guardadas serão perdidas.",
    "mobile_mobileform_follow_up_actions_leave": "Sair",
    "mobile_forms_drafts_text": "Remover planos",
    "mobile_batch_estimate_user": "Utilizador",
    "mobile_batch_estimate_users": "Utilizadores",
    "mobile_table_of_contents": "Índice",
    "mobile_table_of_contents_required": "Necessário",
    "mobile_table_of_contents_optional": "Opcional",
    "mobile_dialog_alert_title": "Alerta",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Dispositivos Bluetooth ainda não suportados no Windows",
    "mobile_windows_deprecated_message_content_announcement": "Anúncio",
    "mobile_windows_deprecated_message_title": "É necessária uma atualização da aplicação",
    "mobile_windows_deprecated_message_description": "Instale a nova aplicação Zenput na Microsoft Store o mais brevemente possível para garantir atualizações de funcionalidade indispensáveis e a melhor experiência Zenput.",
    "mobile_dashboard_tcr_graph_name": "Taxa de conclusão de tarefas",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Últimas 4 semanas",
    "mobile_dashboard_tcr_legend_company_average": "Média da empresa",
    "mobile_dashboard_tcr_legend_team_average": "Média da equipa",
    "mobile_dashboard_tab_title_summary": "Resumo",
    "mobile_dashboard_tab_title_activity": "Atividade",
    "mobile_dashboard_card_title_top_triggered_workflows": "Acionadores principais",
    "mobile_dashboard_tab_title_info": "Informação",
    "mobile_dashboard_tab_project_audit": "Conformidade",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Semana de",
    "mobile_dashboard_card_filter_form_template_placeholder": "Todos os formulários",
    "mobile_dashboard_card_title_forms_top_nos": "Frequentes \"Não\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "Não estivem dados para este período de tempo.",
    "mobile_dashboard_zenput_code_permission_denied": "Não tem permissão para visualizar isto.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Selecione um formulário acima.",
    "mobile_dashboard_zenput_code_unknown_error": "De momento não é possível apresentar os dados.",
    "mobile_dashboard_tap_to_retry": "Toque para tentar novamente",
    "mobile_dashboard_reporting_delay_disclaimer": "As tarefas podem levar até 15 minutos para serem atualizadas",
    "mobile_dashboard_configuration_down_state_postfix_msg": "foram configurados pelo administrador.",
    "mobile_tasks_tag": "tarefas",
    "mobile_workflows_tag": "acionadores",
    "mobile_projects_tag": "projetos recorrentes",
    "mobile_forms_tag": "formulários",
    "mobile_dashboard_card_ongoing_projects_title": "Projetos a decorrer",
    "mobile_dashboard_card_ongoing_projects_show_more": "Mostrar mais",
    "mobile_dashboard_card_ongoing_projects_show_less": "Mostrar menos",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Ir para Projetos",
    "mobile_dashboard_card_title_recurring_projects": "Projetos recorrentes",
    "mobile_dashboard_card_filter_daily": "Diariamente",
    "mobile_dashboard_card_filter_weekly": "Semanalmente",
    "mobile_dashboard_card_filter_monthly": "Mensalmente",
    "mobile_task_status_title_open": "Abrir",
    "mobile_task_status_title_upcoming": "Brevemente",
    "mobile_task_status_title_complete": "Completo",
    "mobile_task_status_title_processing": "Processamento da submissão",
    "mobile_task_status_title_complete_with_exceptions": "Concluir com tarefas ou alertas de seguimento",
    "mobile_task_status_title_completed_late_with_exceptions": "Concluído com atraso com tarefas de acompanhamento ou alertas",
    "mobile_task_status_title_incomplete_and_closed": "Falhadas",
    "mobile_tasks_legend_modal_title": "Legenda",
    "mobile_tasks_legend_modal_footer_button_title": "Fechar",
    "mobile_common_assigned_to": "Atribuído a",
    "mobile_common_created_by": "Criado por",
    "mobile_common_tasks_for": "Tarefas para",
    "mobile_common_go_back": "Voltar",
    "mobile_oh_no": "Oh, Não!",
    "mobile_user_not_in_groups": "Desculpe, parece que não está designado para uma equipa. Entre em contacto com o administrador para aceder ao painel de controlo.",
    "mobile_tasks_select_followers": "Selecionar seguidores",
    "mobile_tasks_assign_tasks": "Atribuir {{count}} tarefas",
    "mobile_tasks_add_followers": "Adicionar seguidores",
    "mobile_tasks_followers": "Seguidores",
    "mobile_tasks_delete_task": "Eliminar tarefa",
    "mobile_tasks_create_task": "Criar tarefas",
    "mobile_tasks_tab_title_comments": "Comentários",
    "mobile_tasks_see_more": "Ver mais",
    "mobile_projects_create_project": "Criar projeto",
    "mobile_common_button_send": "Enviar",
    "mobile_common_button_schedule": "Agendado",
    "mobile_announcements_create": "Criar Anúncio",
    "mobile_announcements_read_rate": "{{opened_count}} de {{recipients_count}} Aberto",
    "mobile_announcements_empty_message": "Ainda não criou nenhum anúncio! Crie um anúncio abaixo para transmitir notícias, informações e atualizações importantes para a sua organização.",
    "mobile_announcement_message_placeholder": "Adicione uma mensagem...",
    "mobile_announcement_title_placeholder": "Título do Anúncio",
    "mobile_announcement_leaving_announcement": "Deixar Anúncio",
    "mobile_announcement_confirm_recipients_team": "Deseja transmitir este anúncio a {{count}} utilizadores em {{teams}} equipas selecionadas?",
    "mobile_announcement_confirm_recipients_role": "Deseja transmitir este anúncio a {{count}} utilizadores em {{roles}} funções selecionadas?",
    "mobile_announcement_confirm_recipients_user": "Deseja transmitir este anúncio a {{count}} utilizadores?",
    "mobile_announcement_confirm_scheduled": "Em {{timestamp}}",
    "mobile_announcement_sending_announcement": "Enviar Anúncio",
    "mobile_announcement_send_to": "Enviar para",
    "mobile_announcement_sent_to": "Enviar para",
    "mobile_announcement_send_to_role": "Função",
    "mobile_announcement_attachment_download": "Transferindo {{filename}}",
    "mobile_announcement_attachment_validation_error": "Não podem ser adicionados mais de {{maxCount}} anexos",
    "mobile_announcement_details_sent": "Enviar",
    "mobile_announcement_details_total_recipients": "Total de Destinatários",
    "mobile_announcement_details_cancel": "Cancelar Anúncio",
    "mobile_announcement_details_not_editable": "Os anúncios só podem ser editados na aplicação web Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Anúncios só podem ser editados no Zenput Web",
    "mobile_announcement_details_open_count": "Abrir Conta",
    "mobile_announcement_details_open_rate": "Abrir Avaliação",
    "mobile_announcement_details_resend": "Reenviar para não-abridores",
    "mobile_announcement_confirm_resend": "{{count}} o utilizador não leu o anúncio. Deseja enviar um lembrete?",
    "mobile_announcement_confirm_resend_title": "Enviar Lembrete?",
    "mobile_announcement_recipients_opened": "Aberto",
    "mobile_recipients_opened_empty_message": "Parece que ninguém ainda abriu a sua mensagem. Volte mais tarde para ver os seus resultados.",
    "mobile_announcement_recipients_unopened": "Não Aberto",
    "mobile_recipients_unopened_empty_message": "Boas notícias! Não há mensagens não abertas!",
    "mobile_scheduled_announcements_delivery_section_header": "Hora de entrega",
    "mobile_scheduled_announcements_send_immediately_label": "Enviar imediatamente",
    "mobile_scheduled_announcements_scheduled_label": "Enviar num horário específico",
    "mobile_scheduled_announcements_scheduled_tab_label": "Agendado",
    "mobile_scheduled_announcements_dialog_header": "Cancelar Anúncio?",
    "mobile_scheduled_announcements_dialog_message": "Cancelar o seu anúncio impedirá que seja enviado e o apagará da sua lista. Isto não pode ser revertido. Para editar vá para o Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "No momento, não tem anúncios agendados. Agende um anúncio para transmitir notícias, informações e atualizações importantes à sua organização.",
    "mobile_scheduled_announcements_validation_error": "Hora de entrega deve ser após {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Agendar Anúncio",
    "mobile_projects_auto_archive": "Arquivamento automático",
    "mobile_common_unassigned": "Por atribuir",
    "mobile_tasks_title_placeholder": "Nova Tarefa ou Formulário",
    "mobile_projects_leaving_project": "A abandonar projeto",
    "mobile_projects_save_project": "Guardar projeto",
    "mobile_top_triggers_tasks": "Principais tarefas acionadas",
    "mobile_top_triggers_alerts": "Principais alertas acionados",
    "mobile_projects_not_started": "Não Iniciado",
    "mobile_empty_list_message_no_photos": "Sem fotos",
    "mobile_webfilestore_message_error": "Selecione um tipo de ficheiro válido",
    "mobile_notifications_empty_title": "Sem notificações",
    "mobile_notifications_empty_message": "Atividades nas suas tarefas ou aquelas nas quais participa irão surgir aqui.",
    "mobile_comments_comment_deleted": "Este comentário foi eliminado.",
    "mobile_comments_comment_placeholder": "Comentário",
    "mobile_comments_task_submitted_at": "Tarefa enviada a {{ date }} em {{ time }}",
    "mobile_comments_discard_comment_title": "Eliminar comentário?",
    "mobile_comments_discard_confirm_message": "Tem a certeza? O seu comentário irá ser eliminado.",
    "mobile_comments_delete_comment_title": "Eliminar comentário?",
    "mobile_comments_delete_confirm_message": "Isto não pode ser anulado.",
    "mobile_comments_delete_button": "Eliminar comentário",
    "mobile_comments_delete_success_message": "Comentário eliminado",
    "mobile_comments_empty_message_tasks": "Ainda não há comentários \n Inicie uma conversa nesta tarefa.",
    "mobile_comments_empty_message_submissions": "Ainda não há comentários \n Inicie uma conversa nesta submissão.",
    "mobile_comments_empty_message_default": "Ainda não há comentários \n Inicie uma conversa.",
    "mobile_comments_no_matching_users": "Sem correspondência de utilizadores.",
    "mobile_comments_empty_users_to_notify": "Não há utilizadores para notificar.",
    "mobile_comments_users_cant_view_message": "Estes utilizadores não conseguem ver estes comentários",
    "mobile_comments_users_to_notify_title": "Utilizadores a notificar",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilizador</a> irá ser notificado.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilizadores</a> irão ser notificados.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@menciona</a> mais utilizadores para notificar.",
    "mobile_comments_mark_read": "Marcar tudo como lido",
    "mobile_comments_author_mentioned_message": "mencionou-o em",
    "mobile_comments_author_commented_message": "comentou sobre",
    "mobile_view_pdf": "Ver PDF",
    "mobile_no_pdf_generated_message": "Não foi encontrado qualquer PDF para este envio. Ser-lhe-á enviada, em breve, uma cópia por e-mail.",
    "mobile_clipboard_copied_success": "A ligação foi copiada para a sua área de transferência.",
    "mobile_share_link": "Partilhar ligação",
    "mobile_zencam_share": "Partilhar",
    "mobile_zencam_view_details": "Ver detalhes",
    "mobile_zencam_details_drawer_header": "Detalhes",
    "mobile_zencam_submitted_by": "Enviado por",
    "mobile_zencam_form_title": "Título do formulário",
    "mobile_zencam_date_submitted": "Data de envio",
    "mobile_oil_quality_warning_message": "Óleo quase a expirar",
    "mobile_oil_quality_warning_message_subtitle": "Planeie uma mudança em breve",
    "mobile_oil_quality_failure_message": "Qualidade do óleo comprometida",
    "mobile_oil_quality_failure_message_subtitle": "Mude o óleo de imediato",
    "mobile_sensors_set_up_gateway": "Configurar gateway",
    "mobile_sensors_set_up_gateway_message": "Não parecem existir dispositivos configurados. Comece por adicionar um gateway.",
    "mobile_sensors_gateway_plugged_in": "Certifique-se de que o seu gateway está ligado a uma tomada de alimentação.",
    "mobile_sensors_add_device": "Adicionar dispositivo",
    "mobile_sensors_name_this_gateway": "Dar um nome a este gateway.",
    "mobile_sensors_name_this_sensor": "Dar um nome a este sensor.",
    "mobile_sensors_device_barcode_information": "Digitalizar código QR ou introduzir os números ID e SC da etiqueta do dispositivo",
    "mobile_sensors_device_eui_information": "Digitalizar o código QR ou introduzir o DevEUI da etiqueta do dispositivo",
    "mobile_sensors_gateway_id_information": "Inserir a ID de nó a partir da etiqueta do gateway",
    "mobile_sensors_id_number": "{{untranslatedID}} Número",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Código",
    "mobile_sensors_sensors": "Sensores",
    "mobile_sensors_sensor_deveui_error": "Não foi possível obter DevEUI pelo QR. Insira manualmente.",
    "mobile_sensors_gateways": "Gateways",
    "mobile_sensors_add_sensor": "Adicionar sensor",
    "mobile_sensors_add_gateway": "Adicionar gateway",
    "mobile_sensor_placement_description": "Que área vai este sensor monitorizar?",
    "mobile_sensors_equipment_placement": "Que área ou equipamento vai este sensor monitorizar?",
    "mobile_sensors_equipment": "Que equipamento vai este sensor monitorizar?",
    "mobile_sensors_select_gateway_type": "Selecione o tipo de gateway",
    "mobile_sensors_select_placement": "Selecionar colocação",
    "mobile_sensors_select_equipment": "Selecionar equipamento",
    "mobile_sensors_placement": "Colocação",
    "mobile_sensors_nickname_tip": "A nomeação do sensor é determinada pelas alcunhas atribuídas no posicionamento selecionado.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Digitalizar código QR",
    "mobile_sensors_enter_manually": "Inserir manualmente",
    "mobile_sensors_wizard_step_one": "Passo 1",
    "mobile_sensors_wizard_step_two": "Passo 2",
    "mobile_sensors_wizard_step_three": "Passo 3",
    "mobile_sensors_wizard_step_four": "Passo 4",
    "mobile_sensors_wizard_step_five": "Passo 5",
    "mobile_sensors_wizard_step_six": "Passo 6",
    "mobile_sensors_initializing": "A iniciar...",
    "mobile_sensors_nickname": "Apelido",
    "mobile_sensors_field_not_blank": "O {{field}} não pode estar vazio.",
    "mobile_sensors_nothing_to_see_here": "Nada para ver aqui",
    "mobile_sensors_missing_integration": "Integração do sensor em falta",
    "mobile_sensors_contact_zenput_admin": "Contacte o administrador de Ops Execution da sua empresa.",
    "mobile_sensors_contact_zenput_admin_old": "Entre em contacto com o administrador do Zenput.",
    "mobile_sensors_contact_manager": "Entre em contacto com o gestor da sua conta para adicionar sensores.",
    "mobile_sensors_device_success_message": "Os dados do sensor podem levar até 15 minutos a carregar",
    "mobile_sensors_last_reading": "Última Leitura",
    "mobile_sensors_remove_device": "Remover Dispositivo",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1S",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1A",
    "mobile_sensors_sensor_settings": "Configurações do sensor",
    "mobile_sensors_remove_confirm_message": "Tem certeza de que deseja apagar este dispositivo?\nIsto não pode ser anulado.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Nenhum equipamento associado",
    "mobile_sensor_cooldown_process": "Processo de Arrefecimento",
    "mobile_sensor_last_12_hours": "Últimas 12 Horas",
    "mobile_sensor_start_cooldown_process": "Iniciar Novo Processo de Arrefecimento",
    "mobile_sensor_cooldown_process_title": "Processo de Arrefecimento em Duas Etapas",
    "mobile_sensor_cooldown_process_description": "Um processo de arrefecimento em duas etapas consiste em arrefecer alimentos com mais de {{ stage1_start_temperature }} para {{ stage1_end_temperature }} em duas horas ou menos e depois de {{ stage1_end_temperature }} para {{ stage2_end_temperature }} em quatro horas ou menos.",
    "mobile_sensor_cooldown_process_place_food": "Coloque o produto alimentar no frigorífico.",
    "mobile_sensor_cooldown_process_insert_sensor": "Insira uma sonda de sensor no produto alimentar.",
    "mobile_sensor_cooldown_process_enter_information": "Digite as informações abaixo.",
    "mobile_sensor_cooldown_process_food_product": "Produto alimentar a arrefecer",
    "mobile_sensor_cooldown_cool_down": "Arrefecimento",
    "mobile_sensor_cooldown_select_sensor": "Selecionar Sensor",
    "mobile_sensors_cooldown_start_cooldown": "Iniciar Arrefecimento",
    "mobile_sensors_cooldown_please_enter_food": "Introduza um Produto Alimentar",
    "mobile_sensors_cooldown_please_select_sensor": "Selecione um Sensor",
    "mobile_sensors_cooldown_status_in_progress": "Em progresso",
    "mobile_sensors_cooldown_status_failed": "Falhou",
    "mobile_sensors_cooldown_status_success": "Bem-sucedido",
    "mobile_sensors_cooldown_stage": "Etapa",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "A temperatura inicial está fora de alcance",
    "mobile_sensors_cooldown_failed_cooldown_process": "Falha no Processo de Arrefecimento",
    "mobile_sensors_cooldown_cooldown_successful": "Arrefecimento Bem-sucedido",
    "mobile_sensors_cooldown_started_cooldown_process": "Processo de Arrefecimento Iniciado",
    "mobile_sensors_cooldown_hour": "hora",
    "mobile_sensors_cooldown_hour_plural": "horas",
    "mobile_sensors_cooldown_minute": "minuto",
    "mobile_minutes_plural": "minutos",
    "mobile_sensors_last_reading_max_date": "> 1 ano atrás",
    "mobile_sensors_minute_count_ago": "{{count}} minuto atrás",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minutos atrás",
    "mobile_sensors_hour_count_ago": "{{count}} hora atrás",
    "mobile_sensors_hour_count_ago_plural": "{{count}} horas atrás",
    "mobile_sensors_day_count_ago": "{{count}} dia atrás",
    "mobile_sensors_day_count_ago_plural": "{{count}} dias atrás",
    "mobile_sensors_chart_settings": "Definições do gráfico",
    "mobile_announcement_banner_continue_reading": "Continuar a ler",
    "mobile_compliance_submissions_report": "Relatório de submissões",
    "mobile_compliance_submissions_report_subtitle": "Exportar dados da conclusão do projeto para esta loja",
    "mobile_compliance_send_submissions": "Enviar submissões",
    "mobile_compliance_completion_rate_in_last_days": "Taxa de conclusão nos últimos {{ days }} dias",
    "mobile_compliance_last_days": "Últimos {{ days }} dias",
    "mobile_compliance_send_submissions_to": "Enviar submissões para",
    "mobile_compliance_send_to_different_email": "Enviar para um e-mail diferente",
    "mobile_compliance_email_input_placeholder": "Endereço de e-mail",
    "mobile_compliance_send_submissions_to_legend_title": "Submissões",
    "mobile_compliance_send_submissions_to_legend_description_days": "Um relatório com as suas submissões a partir desta localização nos últimos {{ days }} dias será enviado para o e-mail selecionado.",
    "mobile_compliance_time_frame": "Intervalo de tempo",
    "mobile_compliance_sensor_temperature_log_report": "Relatório de registo da temperatura do sensor",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exportar registos da temperatura para esta loja",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Critérios",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Defina os critérios para o seu relatório abaixo.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Nota: o(s) sensor(es) desativado(s) não será(ão) apresentado(s) no relatório",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Selecione um intervalo de tempo. Dados de registo são limitados a um máx. de 30 dias",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Enviar relatório",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Este mês (1.º-Hoje)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Último mês",
    "mobile_compliance_sensor_temperature_log_email_title": "Enviar relatório para",
    "mobile_pwa_update_prompt_title": "Atualizar aplicação",
    "mobile_pwa_update_prompt_description": "Está disponível uma nova versão da aplicação. Faça a atualização para a versão mais recente.",
    "mobile_pwa_update_prompt_confirm": "Atualizar e recarregar",
    "mobile_pwa_update_prompt_cancel": "Lembrar-me mais tarde",
    "notification_title_due_in_one_hour": "Entrega em 1 hora",
    "task_is_due_soon": "“{{ task_title }}” está previsto para breve. Tire um momento para concluir.",
    "mobile_photo_quality_warning_header": "Problema de qualidade da foto",
    "mobile_photo_quality_dialog_message": "Esta foto pode estar demasiado escura ou desfocada. Deseja tirar uma nova foto ou continuar com esta?",
    "mobile_take_new_photo": "Tirar uma nova foto",
    "mobile_use_this_photo": "Utilizar esta foto"
}};
mobile_translations.sv_SE = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Alla",
    "mobile_common_button_apply_filters": "Använd filter",
    "mobile_common_button_done": "Klart",
    "mobile_common_button_edit": "Redigera",
    "mobile_common_button_archive": "Arkivera",
    "mobile_common_button_save": "Spara",
    "mobile_common_button_retake": "Gör om",
    "mobile_common_button_save_draft": "Spara utkast",
    "mobile_common_button_discard": "Avvisa",
    "mobile_common_button_submit": "Sänd",
    "mobile_common_button_no": "Nej",
    "mobile_common_button_yes": "Ja",
    "mobile_common_button_na": "i.u.",
    "mobile_common_created_by_me": "Skapad av mig",
    "mobile_common_email": "Företags e-post",
    "mobile_common_first_name": "Förnamn",
    "mobile_common_last_name": "Efternamn",
    "mobile_common_location": "Plats",
    "mobile_common_locations": "Platser",
    "mobile_common_logout_message": "Är du säker på att du vill logga ut?",
    "mobile_common_password": "Lösenord",
    "mobile_common_permission_required": "Godkännande krävs",
    "mobile_common_status": "Status",
    "mobile_common_task": "Uppgift",
    "mobile_common_tasks": "Uppgifter",
    "mobile_common_tasks_my": "Mina uppgifter",
    "mobile_common_projects": "Projekt",
    "mobile_common_filter_team": "Team",
    "mobile_common_filter_var_in": " i {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Inget team valt",
    "mobile_common_filter_no_user_selected": "Ingen användare vald",
    "mobile_common_filter_no_role_selected": "Ingen roll vald",
    "mobile_common_placeholder_date": "Datum",
    "mobile_common_message_task_creator_error_save": "<b>Uppgift kunde inte skapas.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "för",
    "mobile_common_reload": "Ladda om",
    "mobile_common_override": "Åsidosätt",
    "mobile_common_notifications": "Aviseringar",
    "mobile_common_chat_unavailable": "Chatten ej tillgänglig. Försök igen senare.",
    "mobile_common_chat_ending_dialog_title": "Är du klar med det här samtalet?",
    "mobile_common_chat_ending_dialog_description": "Låt oss veta om ditt problem har lösts eller om du bara vill fortsätta senare.",
    "mobile_common_chat_ending_dialog_confirm": "Ja, jag är klar",
    "mobile_common_chat_ending_dialog_cancel": "Jag fortsätter senare",
    "mobile_common_continue_editing": "Fortsätt redigera",
    "mobile_privacy_policy": "Integritetspolicy",
    "wootric_recommend_target": "en vän eller kollega i din bransch",
    "wootric_followup_detractor_question": "Vilka ändringar kan vi göra för dig så vi får högre betyg nästa gång?",
    "wootric_followup_passive_question": "Tack! Vad kan vi göra för att verktyget ska bli ännu bättre?",
    "wootric_followup_promoter_question": "Tack! Vad är det du gillar mest med Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Tack! Vad gillar du med Zenput?",
    "wootric_default_followup_question": "Tack! Kan du berätta varför?",
    "wootric_default_placeholder_text": "Hjälp oss genom att förklara ditt betyg.",
    "wootric_default_thankyou_text": "Tack för ditt svar och din feedback!",
    "mobile_login_placeholder_login_as": "Logga in som användar-ID",
    "mobile_login_button_forgot_password": "Har du glömt lösenordet?",
    "mobile_login_button_sign_up": "Skapa konto",
    "mobile_login_button_finish_setup": "Slutför installation",
    "mobile_login_button": "Logga in",
    "mobile_login_continue_button": "Fortsätt",
    "mobile_login_continue_transition": "tar dig till vår organisations inloggningssida ...",
    "mobile_login_no_email_error": "Du måste ange en e-postadress.",
    "mobile_login_change_email": "Logga in med en annan e-postadress",
    "mobile_login_with_sso": "Logga in med SSO",
    "mobile_oauth_no_user_error_message": "Det verkar som att du inte har något konto hos Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Det verkar som att du inte har något Zenput-konto!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> är nu <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} byter namn till {{- product }} i september. {{- cta }}",
    "mobile_rebrand_warning_cta": "Ta reda på hur du förbereder dig.",
    "mobile_oauth_no_user_error_sub_message": "Kontakta din administratör för behörighet eller försök att logga in med en annan e-postadress.",
    "mobile_oauth_generic_error_message": "Det verkar vara problem med inloggningen, försök igen.",
    "mobile_oauth_force_logout_msg": "Om du fortfarande har problem loggar du ut ifrån din leverantör genom ",
    "mobile_oauth_force_logout_click": "klicka här.",
    "mobile_sign_up_placeholder_phone": "Mobilnummer",
    "mobile_sign_up_placeholder_password_confirm": "Bekräfta lösenordet",
    "mobile_sign_up_button_sign_in": "Logga in",
    "mobile_sign_up_disclaimer_part_1": "Genom att klicka på skapa konto samtycker du till",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "När du klickar på Slutför installation samtycker du till",
    "mobile_sign_up_disclaimer_link_title": " Licensavtal",
    "mobile_sign_up_disclaimer_part_2": ", vilket inkluderar viktig personlig information",
    "mobile_dialog_benefits_work_offline": "Arbeta offline",
    "mobile_dialog_benefits_faster_uploads": "Snabbare uppladdningar",
    "mobile_dialog_benefits_better_experience": "Bättre användarerfarenhet",
    "mobile_dialog_benefits_button_download": "Ladda ner",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution krävs för ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput för ",
    "mobile_dialog_benefits_button_have": "Jag har appen!",
    "mobile_dialog_benefits_button_no_thanks": "Nej tack, kanske senare.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Bilden kunde inte laddas.",
    "mobile_dialog_signature_sign": "Skriv under här",
    "mobile_dialog_signature_button_clear": "Rensa",
    "mobile_account_placeholder_name": "Plats/butiksnamn",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Adress",
    "mobile_account_placeholder_city": "Stad",
    "mobile_account_placeholder_region": "Region",
    "mobile_account_placeholder_zipcode": "Postnummer",
    "mobile_account_option_select_country": "Välj land",
    "mobile_account_oprion_us": "Förenta staterna",
    "mobile_account_oprion_select_state": "Välj stat",
    "mobile_account_button_create_location": "Skapa plats",
    "mobile_form_message_no_form": "Inga formulär tillgängliga",
    "mobile_batch_task_message": "Laddar ...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Mobiltelefon",
    "mobile_settings_profile_language": "Språk",
    "mobile_settings_profile_temperature_unit": "Temperaturenhet",
    "mobile_settings_profile_use_company_default": "Använd företagets standard",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Textmeddelande",
    "mobile_settings_notifications_option_push": "Push-meddelanden",
    "mobile_settings_notifications_option_push_email": "E-post och push-meddelanden",
    "mobile_settings_notifications_option_do_not": "Avisera inte",
    "mobile_settings_notifications_category_communication": "Kommunikation",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulär och utlösare",
    "mobile_settings_devices": "Enheter",
    "mobile_settings_notifications_sub_category_alerts": "Varningar",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nya formulär tillgängliga",
    "mobile_settings_notifications_sub_category_task_assigned": "Uppgift tilldelad",
    "mobile_settings_notifications_sub_category_task_completed": "Uppgift slutförd",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Påminnelse om uppgifter som snart förfaller",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Påminnelse om försenade uppgifter",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensornätverk varningar",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Kritiska sensornätverk varningar",
    "mobile_drafts_message": "Du har inga utkast ännu.",
    "mobile_drafts_button_delete": "Ta bort",
    "mobile_tasks_filter_location_no": "Ingen plats vald",
    "mobile_tasks_filter_group_by": "Gruppera efter",
    "mobile_tasks_filter_sort_by": "Sortera efter",
    "mobile_tasks_filter_sorted_by": "Sorterad efter",
    "mobile_tasks_filter_due_time": "Leveranstid",
    "mobile_tasks_filter_open_time": "Öppningstid",
    "mobile_tasks_bucket_due_next_24_hours": "Förfaller inom de närmaste 24 timmarna",
    "mobile_tasks_bucket_due_next_7_days": "Förfaller inom de närmaste 7 dagarna",
    "mobile_tasks_bucket_open_tasks": "Ytterligare öppna {{type}}",
    "mobile_tasks_bucket_open_at": "Öppna: {{- date }} kl. {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Senast: {{- date }} kl. {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Tillgänglig om 1 minut",
    "mobile_tasks_bucket_available_in_one_hour": "Tillgänglig om 1 timme",
    "mobile_tasks_bucket_available_in_one_day": "Tillgänglig om 1 dag",
    "mobile_tasks_bucket_available_in_one_week": "Tillgänglig om 1 vecka",
    "mobile_tasks_bucket_available_in_one_month": "Tillgänglig om 1 månad",
    "mobile_tasks_bucket_available_in_one_year": "Tillgänglig om 1 år",
    "mobile_tasks_bucket_available_in_minutes": "Tillgänglig om {{ minutes }} minuter",
    "mobile_tasks_bucket_available_in_hours": "Tillgänglig om {{ hours }} timmar",
    "mobile_tasks_bucket_available_in_days": "Tillgänglig om {{ days }} dagar",
    "mobile_tasks_bucket_available_in_weeks": "Tillgänglig om {{ weeks }} veckor",
    "notification_task_due_in_minutes": "Förfaller om {{ minutes }} minuter",
    "mobile_tasks_bucket_available_in_months": "Tillgänglig om {{ months }} månader",
    "mobile_tasks_bucket_available_in_years": "Tillgänglig om {{ years }} år",
    "mobile_tasks_follow_up": "Uppföljningsuppgift",
    "mobile_tasks_due_soon": "Förfaller snart",
    "mobile_tasks_bucket_completed_today": "Slutfördes idag",
    "mobile_tasks_bucket_completed_this_week": "Slutfördes denna vecka",
    "mobile_tasks_bucket_completed_last_week": "Slutfördes förra veckan",
    "mobile_tasks_bucket_missed_today": "Missade idag",
    "mobile_tasks_bucket_missed_this_week": "Missade denna vecka",
    "mobile_tasks_bucket_missed_last_week": "Missade förra veckan",
    "mobile_tasks_bucket_no_location": "Ingen plats",
    "mobile_tasks_cannot_submit_missed": "Missade uppgifter kan inte slutföras",
    "mobile_tasks_cannot_submit_missed_after": "Denna uppgift kan inte slutföras efter {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Denna uppgift har inte startats.",
    "mobile_tasks_cannot_submit_processing": "Detta inlägg bearbetas.",
    "mobile_tasks_toolbarnav_header_no_due_date": "Inget förfallodatum",
    "mobile_tasks_toolbarnav_header_overdue": "Förfallit",
    "mobile_tasks_toolbarnav_header_yesterday": "Igår",
    "mobile_tasks_toolbarnav_header_today": "Idag",
    "mobile_tasks_toolbarnav_header_tomorrow": "I morgon",
    "mobile_tasks_toolbarnav_header_last_week": "Förra veckan",
    "mobile_tasks_toolbarnav_header_this_week": "Denna vecka",
    "mobile_tasks_toolbarnav_header_next_week": "Nästa vecka",
    "mobile_tasks_toolbarnav_header_this_month": "Denna månad",
    "mobile_tasks_toolbarnav_header_next_year": "Nästa år",
    "mobile_tasks_toolbarnav_header_over_year": "Över ett år",
    "mobile_tasks_toolbarnav_title_edit_task": "Redigera uppgift",
    "mobile_task_placeholder_title": "Rubrik *",
    "mobile_task_placeholder_description": "Beskrivning (valfritt)",
    "mobile_task_button_single_task": "Enkel uppgift",
    "mobile_task_button_project": "Projekt",
    "mobile_task_button_create": "Skapa",
    "mobile_task_tab_basic": "Grundläggande",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formulär",
    "mobile_task_details_description_message_please": "Fyll i ",
    "mobile_task_details_description_message_below": "nedan.",
    "mobile_task_details_description_message_instructions": "Det finns inga instruktioner tillgängliga för denna uppgift.",
    "mobile_task_details_reason_title": "Uppföljning utlöst av",
    "mobile_task_detials_button_goto_form": "Gå till formulär",
    "mobile_task_detials_button_complete": " Slutför uppgift",
    "mobile_task_detials_completed": "Slutfört ",
    "mobile_task_detials_completed_by": "genom ",
    "mobile_task_detials_completed_on": "på ",
    "mobile_task_details_view_form_submission": "Visa inlämning av formulär",
    "mobile_task_task_updated": "Uppgift uppdaterad",
    "mobile_task_task_archived": "Uppgift arkiverad",
    "mobile_task_task_deleted": "Uppgift borttagen",
    "mobile_task_error_archiving_task": "Uppgift kunde inte arkiveras.",
    "mobile_task_error_deleting_task": "Uppgift kunde inte tas bort.",
    "mobile_task_error_updating_task": "Uppgift kunde inte uppdateras.",
    "mobile_task_archive_task": "Arkivera uppgift",
    "mobile_task_archive_task_confirm": "Är du säker att du vill arkivera denna uppgift?\n\nArkiverade uppgifter kommer att räknas till slutförandenivåer och kommer även fortsättningsvis att ingå i rapporteringen.\n\nDetta kan inte ångras.",
    "mobile_task_delete_task_confirm": "Är du säker att du vill arkivera denna uppgift?\n\nBorttagna uppgifter kommer att räknas till slutförandenivåer och kommer även fortsättningsvis att ingå i rapporteringen.\n\nDetta kan inte ångras.",
    "mobile_task_edition_already_in_progress": "Den här uppgifter har en väntande redigering. Ytterligare redigering för närvarande är inte möjligt.",
    "mobile_projects_filter_type": "Typ",
    "mobile_projects_filter_status": "Projektstatus",
    "mobile_projects_filter_project_type": "Projekttyp",
    "mobile_projects_due_date_required": "Förfallodatum krävs.",
    "mobile_projects_team_required": "Team krävs.",
    "mobile_projects_user_role_required": "Tilldelare krävs.",
    "mobile_projects_title_required": "Titel krävs.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Flera uppgifter per dag",
    "mobile_project_tasks_complete": " Slutför",
    "mobile_project_tasks_remaining": " Återstående",
    "mobile_esitmate_message_tasks": "0 uppgifter kommer skapas",
    "mobile_esitmate_message_criteria": "Justera ovanstående kriterier",
    "mobile_esitmate_message_created_for": "kommer att skapas för",
    "mobile_left_menu_dashboard": "Instrumentpanel",
    "mobile_left_menu_my_forms": "Mina formulär",
    "mobile_left_menu_announcements": "Meddelanden",
    "mobile_left_menu_my_submissions": "Mina inlämningar",
    "mobile_left_menu_drafts": "Utkast",
    "mobile_left_menu_pending_uploads": "Väntande uppladdningar",
    "mobile_left_menu_open": "Öppna i app",
    "mobile_left_menu_settings": "Inställningar",
    "mobile_left_menu_log_out": "Logga ut",
    "mobile_left_menu_debug": "Felsök",
    "mobile_left_menu_support": "Support",
    "mobile_left_menu_documentation": "Dokumentation",
    "mobile_left_menu_chat": "Chatt",
    "mobile_field_textarea_placeholder_note": "Anmärkning eller bildtext",
    "mobile_field_option_select": "Välj",
    "mobile_field_text_placeholder_text": "Text",
    "mobile_field_email_placehoder_email": "E-postadress",
    "mobile_filed_number_placeholder_number": "Nummer",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Inte ansluten",
    "mobile_field_sensor_offline_battery": "Sensornätverk Offline - Batteri",
    "mobile_field_video_button_add": "Lägg till en video",
    "mobile_field_video_picker_dialog_title": "Lägg till video från",
    "mobile_field_video_button_change": "Ändra video",
    "mobile_field_image_button_add": "Lägg till en bild",
    "mobile_field_image_low_quality_warning": "Vissa foton kan vara för mörka eller suddiga. Granska de markerade fotona och ersätt dem om det behövs.",
    "mobile_field_image_picker_dialog_title": "Lägg till foto från",
    "mobile_field_image_picker_edit_failed": "Vi kunde inte spara bilden. Försök igen.",
    "mobile_field_signature_button_add": "Lägg till en underskrift",
    "mobile_field_signature_button_change": "Ändra underskrift",
    "mobile_field_account_select_location": "Välj en plats",
    "mobile_field_account_prefill": "Vill du för ifylla formuläret med data från förra besöket?",
    "mobile_field_account_message_overwrite": "Detta kommer att skriva över alla fält du redan har fyllt i.",
    "mobile_forms_task_on_behalf": "Det finns en uppgift att utföra på den här platsen som är tilldelad till <b>{{user}}</b>. Vill du slutföra den här uppgiften?",
    "mobile_forms_complete_task": "Slutför uppgift?",
    "mobile_field_account_prefill_button_yes": "Ja, förifyll",
    "mobile_field_barcode_placeholder_scan": "Skanna eller skriv in streckkod",
    "mobile_field_sensor_qr_code_placeholder_scan": "Skanna eller skriv in kod",
    "mobile_field_gateway_id_code_placeholder": "Nod-id för typ",
    "mobile_field_scan_qr_or_enter_dev_eui": "Skanna QR-kod eller ange DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Skanna QR-kod eller ange ID-nummer",
    "mobile_field_scan_qr_or_enter_sc": "Skanna QR-kod eller ange SC-kod",
    "mobile_field_barcode_select_date": "Välj datum ",
    "mobile_field_datetime_allow_time": "Tid",
    "mobile_field_stopwatch_button_caption": "Tidtagarur",
    "mobile_field_stopwatch_common_start": "Start",
    "mobile_field_stopwatch_common_stop": "Stopp",
    "mobile_field_stopwatch_common_reset": "Återställ",
    "mobile_field_stopwatch_stop_stopwatches": "Stoppa tidtagarur",
    "mobile_field_document_title": "Lägg till dokument",
    "mobile_field_document_message_delete": "Är du säker du vill ta bort det här dokumentet?",
    "mobile_field_document_alret_button_view": "Visa",
    "mobile_field_document_alert_error": "Det här dokumentet kunde inte bifogas. Försök igen.",
    "mobile_field_document_alert_file_size_error": "Filen kan inte överskrida {{count}} MB.",
    "mobile_field_temperature_greater_range": "större än {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "större eller lika med {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "mindre än {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "mindre eller lika med {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "större eller lika med {{ min_temp_value }} °{{ temp_unit }} och mindre än {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "större eller lika med {{ min_temp_value }} °{{ temp_unit }} och mindre än eller lika med{{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " och ",
    "mobile_field_text_limit_error": "Maximal teckengräns på 8000 har nåtts.",
    "mobile_forms_required_questions_complete": "Slutförande krävs",
    "mobile_forms_required_remaining": "{{count}} krav återstår",
    "mobile_forms_required_questions_back": "Tillbaka",
    "mobile_forms_required_questions_next": "Nästa",
    "mobile_forms_required_questions_skip": "Hoppa över",
    "mobile_forms_leaving_form": "Lämna formulär",
    "mobile_message_reordering_confirm": "Vill du spara den nya frågeordningsföljden?",
    "mobile_forms_leaving_reordering": "Lämnar ändring av frågornas ordningsföljd",
    "mobile_forms_reordering_button_save": "Spara ny frågeordningsföljd",
    "mobile_forms_reordering_instructions": "För att ändra frågornas ordningsföljd eller avsnitt, dra och släpp till där fältet ska visas i formuläret",
    "mobile_toolbarnav_title_my_setttings": "Mina inställningar",
    "mobile_toolbarnav_title_profile_settings": "Profilinställningar",
    "mobile_toolbarnav_title_notification": "Aviseringsinställningar",
    "mobile_toolbarnav_title_form_history": "Formulärhistorik",
    "mobile_toolbarnav_title_form_not_available": "Formulär är inte tillgängligt",
    "mobile_toolbarnav_title_add_location": "Lägg till plats",
    "mobile_toolbarnav_title_add_task_or_project": "Lägg till uppgift eller projekt",
    "mobile_toolbarnav_title_select_location": "Välj plats",
    "mobile_toolbarnav_title_select_project": "Välj projekt",
    "mobile_toolbarnav_title_select_tag": "Välj dag",
    "mobile_toolbarnav_title_select_user": "Välj användare",
    "mobile_toolbarnav_title_select_template": "Välj mall",
    "mobile_toolbarnav_title_select_one": "Välj en",
    "mobile_toolbarnav_title_select_multiple": "Välj en eller fler",
    "mobile_toolbarnav_title_select_team": "Välj team",
    "mobile_toolbarnav_title_select_team_or_location": "Välj team eller plats",
    "mobile_toolbarnav_title_filter_tasks": "Filtrera uppgifter",
    "mobile_toolbarnav_title_filter_projects": "Filtrera projekt",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrera projektuppgifter",
    "mobile_placeholder_search_bar": "Sök",
    "mobile_placeholder_user_select_role": "Välj användarroll",
    "mobile_placeholder_filter_by_team": "Filtrera genom ett team",
    "mobile_placeholder_assign_to_user_role": "Tilldela till användarroll",
    "mobile_placeholder_select": "-- Välj --",
    "mobile_placeholder_account_location_name": "Namn på plats",
    "mobile_placeholder_tag_filter_by": "Filtrera genom platstagg",
    "mobile_placeholder_user_type": "Tilldela till användare",
    "mobile_placeholder_acount_type_loading": "Laddar ... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatur",
    "mobile_placeholder_blue_therm_connecting": "Ansluter till enhet ...",
    "mobile_placeholder_blue_therm_please_wait": "Vänta ...",
    "mobile_placeholder_blue_therm_tap": "Tryck för läsning.",
    "mobile_placeholder_blue_therm_not_connected": "Inte ansluten.",
    "mobile_placeholder_testo_tap": "Håll ner ▼▲ åtföljt av ⬆",
    "mobile_message_error_create_task": "Du måste var online för att lägga till uppgifter.",
    "mobile_message_error_fill_out_form": "Fyll i formuläret.",
    "mobile_message_error_fill_require_fields": "Fyll i obligatoriska fält.",
    "mobile_message_error_stop_stopwatch_before_submit": "Stoppa ditt tidtagarur innan du skickar in",
    "mobile_message_error_stopwatch_field_required": "Fältet för tidtagarur obligatoriskt",
    "mobile_message_error_stopwatch_field_running": "Tidtagaruret körs",
    "mobile_message_error_invalid_equipment_temperature": "Felaktig utrustningstemperatur",
    "mobile_message_error_invalid_ingredient_temperature": "Felaktig innehållstemperatur",
    "mobile_message_error_location_attributes_unavailable": "Vissa frågor kan vara otillgängliga. Anslut till internet",
    "mobile_message_alert_running_stopwatches": "Du har tidtagarur som körs.\n\nVill du återställa dem?",
    "mobile_message_blue_therm_error": "Anslutningen förlorad till Bluetooh-enhet",
    "mobile_message_blue_therm_no_permission_android_pre_12": "åtkomst till plats. Aktivera den i dina Android-inställningar.",
    "mobile_message_blue_therm_no_permission_android": "Åtkomst till enheter i närheten krävs. Aktivera den i dina Android-inställningar.",
    "mobile_message_blue_therm_error_code": "Anslutningen misslyckades:",
    "mobile_message_blue_therm_error_bluetooth": "Aktivera Bluetooth.",
    "mobile_message_blue_therm_error_device": "Enheten kunde inte hittas.",
    "mobile_message_blue_therm_error_try_again": "Försök igen",
    "mobile_message_blue_therm_success": "Bluetooth-enhet ansluten!",
    "mobile_message_bluetooth_device_press_button_field": "Tryck på knappen på din enhet för att ansluta.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Tryck på knappen på din enhet<br />om den inte är listad här.",
    "mobile_bluetooth_scan": "Skanna",
    "mobile_bluetooth_scanning": "Skannar",
    "mobile_message_drafts_confirm": "Vill du spara den som ett utkast?",
    "mobile_message_drafts_toast_saved": "Utkast sparat.",
    "mobile_message_drafts_request_update": "Vill du uppdatera det här utkastet?",
    "mobile_message_drafts_form_confirm": "Är du säker du vill ta bort det här utkastet?",
    "mobile_message_drafts_confirm_delete": "Ta bort utkast",
    "mobile_message_streams_error_switch": "Strömmar på webben kan inte ändras",
    "mobile_message_settings_success_saved": "Inställningar sparade",
    "mobile_message_settings_error": "Ett okänt fel uppstod. Försök senare igen",
    "mobile_message_profile_settings_error_fields": "Korrigera de markerade fälten.",
    "mobile_message_media_perimission_denied": "Din ",
    "mobile_message_media_perimission_denied_device": "Enhetslagring",
    "mobile_message_image_confirm_remove_image": "Är du säker du vill ta bort den här bilden?",
    "mobile_message_create_account_error_fields": "Fyll i de markerade fälten.",
    "mobile_message_create_account_success_location_created": "Plats skapad",
    "mobile_message_task_error_get_location": "Platshämtning misslyckades. Sortera efter datum.",
    "mobile_message_typehead_confirm_save_message": "Vill du spara dessa val?",
    "mobile_message_typehead_confirm_save_title": "Spara?",
    "mobile_message_task_creator_error_save_select_form": "Du måste välja ett formulär.",
    "mobile_message_task_creator_error_save_required_fields": "Fyll i de begärda fälten.",
    "mobile_message_task_creator_error_save_batch_change": "Ändra kriterier till att passa till en eller fler användare",
    "mobile_message_task_detials_error_not_assigned_to_you": "Den här uppgiften är inte tilldelad till dig.<br />Du kan inte slutföra den.",
    "mobile_message_task_detials_error_assigned_to": "Den här uppgiften är tilldelad till {{user}}.<br />Du kan inte slutföra den.",
    "mobile_message_task_detials_confirm_title": "Lämna uppgift",
    "mobile_message_task_detials_confirm_save_task": "Spara uppgift",
    "mobile_message_task_detials_confirm_message": "Är du säker? Dina ändringar kommer att gå förlorade.",
    "mobile_message_task_detials_error_view_account": "Det gick inte att komma åt platsen.",
    "mobile_message_task_detials_error_submit_task": "Lägg till en bild för att slutföra den här uppgiften.",
    "mobile_message_task_detials_error_submit_task_project": "Projektet kunde inte sparas. Försök igen senare.",
    "mobile_message_task_detials_wait_submit_task_created": "Uppgifter skapas.<br />Vänta några minuter tills uppgifterna fylls i.",
    "mobile_message_task_detials_error_submit_task_pending": "Fel, försök igen senare",
    "mobile_message_task_detials_success_task_complete": "Uppgift slutförd",
    "mobile_message_task_error_save_single_task": "Uppgiften kunde inte sparas. Försök igen senare.",
    "mobile_message_task_success_save_single_task": "Uppgift skapad.",
    "mobile_message_show_error_message": "Någonting blev fel.",
    "mobile_message_show_success_message": "Lyckades!",
    "mobile_message_show_offline_message": "Du är för tillfället offline.",
    "mobile_message_show_permission_denied_message": "<b>Godkännande krävs.</b> Ge Zenput tillstånd för åtkomst {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Tillstånd krävs.</b> Ge Zenput och din webbläsare tillstånd att komma åt {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Överföring pågår",
    "mobile_message_show_upload_in_progress_message": "Överföring pågår redan",
    "mobile_message_show_form_id_error": "Det gick inte att komma åt specificerat formulär.",
    "mobile_message_show_single_task_error": "Det gick inte att komma åt specificerad uppgift.",
    "mobile_message_show_submissions_error": "Det gick inte att komma åt specificerat inlägg.",
    "mobile_message_show_submissions_access_denied": "Beklagar men du har inte åtkomst till detta formulär.",
    "mobile_message_send_data_success": "Data har laddats upp ",
    "mobile_message_start_upload_success": "Överföring slutförd",
    "mobile_message_start_upload_error": "<b>Överföring kunde inte slutföras.</b><br>Inlämning sparad. Försök igen senare",
    "mobile_message_store_upgrade_store_ios": "Appstore",
    "mobile_message_store_upgrade_store_android": "Playstore",
    "mobile_message_store_upgrade_confirm_title": "Uppdatering är tillgänglig",
    "mobile_message_store_upgrade_confirm_message_one": "Uppdatera gärna appen Ops Execution från ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Uppdatera Zenput från den ",
    "mobile_message_store_upgrade_confirm_message_two": " för att få alla senaste funktioner och felkorrigeringar",
    "mobile_message_store_upgrade_confirm_now": "Nu",
    "mobile_message_store_upgrade_confirm_later": "Senare",
    "mobile_message_redirect_confirm_message": "Du fyller för närvarande i ett formulär. Vill du spara den som ett utkast innan du fortsätter?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Du har {{count}} utkast som ännu inte har överförts. Dessa kommer att försvinna om du fortsätter. Är du säker?",
    "mobile_message_draft_override_message": "Detta utkast sparades från en annan enhet på {{date}} och är i konflikt med ändringarna på den här enheten. Du kan välja att skriva över den befintliga versionen eller ladda om till den senaste versionen så kommer dina ändringar att tas bort.",
    "mobile_html_submitting": "Överför ...",
    "mobile_html_offline": "Du är för tillfället offline!",
    "mobile_html_offline_try_again": "Du är för tillfället offline. <br/><br/>Försök igen när du är ansluten",
    "mobile_html_something_went_wrong": "Hoppsan. Någonting blev fel.",
    "mobile_html_something_went_wrong_try_again": "Hoppsan. Någonting blev fel. Försök igen senare.",
    "mobile_html_failed_loading_roles": "Roller kunde inte laddas.",
    "mobile_alert_please_install_for_native": "Installera appen Ops Execution för att kunna använda den här funktionen. ",
    "mobile_alert_please_install_for_native_old": "Installera den ursprungliga Zenput-appen för att använda den här funktionen.",
    "mobile_tso_filter_all_tasks": "Alla {{type}}",
    "mobile_tso_filter_my_tasks": "Min {{type}}",
    "mobile_tso_filter_due_date": "Förfallodatum",
    "mobile_tso_filter_date_completed": "Datum slutfört",
    "mobile_tso_filter_completed": "Slutfört",
    "mobile_tso_filter_completed_late": "Slutförd sent",
    "mobile_tso_filter_incomplete": "Ofullständigt",
    "mobile_tso_filter_var_my_tasks": "Min {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} skapad av mig",
    "mobile_tso_filter_var_all_tasks": "Alla {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Uppföljningsåtgärder",
    "mobile_tso_type_all": "Uppgifter och uppföljningsåtgärder",
    "mobile_tso_filter_var_at": " vid {{location}}",
    "mobile_tso_filter_group_date_due": ", sorterade efter förfallodatum",
    "mobile_tso_filter_group_distance": ", grupperade efter plats",
    "mobile_tso_filter_start_date": "Startdatum",
    "mobile_tso_filter_none": "Ingen",
    "mobile_pso_filter_all_projects": "Alla projekt",
    "mobile_pso_filter_my_projects": "Mina projekt",
    "mobile_pso_filter_active": "Aktiv",
    "mobile_pso_filter_archived": "Arkiverad",
    "mobile_pso_filter_recurring": "Återkommande",
    "mobile_pso_filter_non_recurring": "Ej återkommande",
    "mobile_pso_filter_var_my_projects": "Mina {{project_type}} {{active_description}} projekt",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Projekt skapade av mig",
    "mobile_pso_filter_var_all_projects": "Alla {{project_type}} {{active_description}} projekt",
    "mobile_empty_list_message_must_be_online": "Du verkar vara offline. Gå online för att se några resultat.",
    "mobile_empty_list_message_no_submissions": "Inga inlämningar",
    "mobile_empty_list_message_no_activity": "Ingen aktivitet",
    "mobile_empty_list_message_no_tasks": "Inga uppgifter",
    "mobile_empty_list_message_no_tasks_overdue": "Inga förfallna {{type}}",
    "mobile_empty_list_message_no_accounts": "Inga platser",
    "mobile_empty_list_message_no_projects": "Inga projekt",
    "mobile_empty_list_message_no_results_found": "Inga resultat hittade",
    "mobile_empty_list_message_no_forms_available": "Inga formulär tillgängliga",
    "mobile_empty_list_message_connection_error": "Anslutningsfel<br />Försök igen senare.",
    "mobile_empty_list_message_dashboard_error": "Instrumentpanel kunde inte laddas",
    "mobile_empty_list_message_user_offline": "Du är för tillfället offline",
    "mobile_action_sheet_media_gallery": "Galleri",
    "mobile_action_sheet_cancel": "Avbryt",
    "mobile_image_preview_text": "Ta bort foton",
    "mobile_mobileform_text": "Tidigare inlämningar",
    "mobile_mobileform_reorder_fields": "Ändra frågornas ordningsföljd",
    "mobile_mobileform_follow_up_actions": "Uppföljande åtgärder",
    "mobile_mobileform_follow_up_actions_assign_title": "Tilldela uppföljningsåtgärder",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Lägg till uppföljningsåtgärder baserat på dina observationer för att säkerställa att problem åtgärdas.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Lägg till uppföljningsåtgärd",
    "mobile_mobileform_follow_up_actions_assign_button": "Tilldela uppföljningar",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Fortsätt utan att tilldela",
    "mobile_mobileform_follow_up_actions_dialog_title": "Fortsätta utan att tilldela uppföljningsåtgärder?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Om du fortsätter utan att tilldela några uppföljningsåtgärder kommer du inte att kunna lägga till dem senare.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Fortsätt ändå",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Detta fält är obligatoriskt",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "För många tecken",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Detta fält är ogiltigt",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Fel vid laddning av platser",
    "mobile_mobileform_add_follow_up_actions_error_users": "Fel vid laddning av användare",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Lägg till uppföljning",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Rubrik",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Beskrivning",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Foto är obligatoriskt",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Förfallodag",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Uppdatera uppföljning",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Radera uppföljning?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Den kommer att tas bort och kommer inte att tilldelas.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Radera uppföljning",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Är du säker du vill radera den här uppföljningen?\n\nDetta kan inte ångras.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Fortsätt till uppföljningar",
    "mobile_mobileform_follow_up_actions_completed_notification": "Uppföljningsåtgärden slutfördes",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Uppföljningsåtgärden raderades",
    "mobile_mobileform_follow_up_actions_update_notification": "Uppföljningsåtgärden uppdaterades",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Lägg till ett foto för att slutföra den här uppföljningsåtgärden",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Gå till inlämning",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Gå till källan",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Källa",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Slutför uppföljning",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Om du öppnar inskickningen kommer alla osparade foton och anteckningar att gå förlorade.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Om du lämnar den här skärmen kommer alla bilder och anteckningar som inte har sparats att gå förlorade.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Stanna här",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Öppna inlämning",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Öppen källkod",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Vill du lämna denna uppföljningsåtgärd?",
    "mobile_mobileform_follow_up_actions_submission": "Inlämning",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Den här uppföljningsåtgärden är tilldelad till {{user}}.<br />Du kan inte slutföra den.",
    "mobile_mobileform_follow_up_actions_leave_description": "Om du lämnar den här skärmen kommer alla ändringar som inte har sparats att gå förlorade.",
    "mobile_mobileform_follow_up_actions_leave": "Lämna",
    "mobile_forms_drafts_text": "Ta bort utkast",
    "mobile_batch_estimate_user": "Användare",
    "mobile_batch_estimate_users": "Användare",
    "mobile_table_of_contents": "Innehållsförteckning",
    "mobile_table_of_contents_required": "Obligatoriskt",
    "mobile_table_of_contents_optional": "Valfritt",
    "mobile_dialog_alert_title": "Varna",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth-enheter som ännu inte stöds i Windows",
    "mobile_windows_deprecated_message_content_announcement": "Meddelande",
    "mobile_windows_deprecated_message_title": "Appen måste uppdateras",
    "mobile_windows_deprecated_message_description": "Installera den nya Zenput-appen i Microsoft Store så fort som möjligt för att vara säker på att få kritiska funktionsuppdateringar och den bästa Zenput-upplevelsen.",
    "mobile_dashboard_tcr_graph_name": "Slutföringsgrad för uppgifter",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Senaste fyra veckorna",
    "mobile_dashboard_tcr_legend_company_average": "Företagsgenomsnitt",
    "mobile_dashboard_tcr_legend_team_average": "Teamgenomsnitt",
    "mobile_dashboard_tab_title_summary": "Sammanfattning",
    "mobile_dashboard_tab_title_activity": "Aktivitet",
    "mobile_dashboard_card_title_top_triggered_workflows": "Topputlösare",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Överensstämmelse",
    "mobile_dashboard_card_task_stats_total": "Totalt",
    "mobile_dashboard_top_item_header_week_of": "Veckor i",
    "mobile_dashboard_card_filter_form_template_placeholder": "Alla formulär",
    "mobile_dashboard_card_title_forms_top_nos": "Frekventa \"Nej\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "Det finns ingen information inom detta tidsintervall.",
    "mobile_dashboard_zenput_code_permission_denied": "Du har inte behörighet att se detta.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Välj ett formulär uppifrån.",
    "mobile_dashboard_zenput_code_unknown_error": "Vi kan inte visa informationen just nu.",
    "mobile_dashboard_tap_to_retry": "Klicka för att försöka igen",
    "mobile_dashboard_reporting_delay_disclaimer": "Det kan ta upp till 15 minuter att uppdatera",
    "mobile_dashboard_configuration_down_state_postfix_msg": "har konfigurerats av din administratör.",
    "mobile_tasks_tag": "uppgifter",
    "mobile_workflows_tag": "utlösare",
    "mobile_projects_tag": "återkommande projekt",
    "mobile_forms_tag": "formulär",
    "mobile_dashboard_card_ongoing_projects_title": "Pågående projekt",
    "mobile_dashboard_card_ongoing_projects_show_more": "Visa mer",
    "mobile_dashboard_card_ongoing_projects_show_less": "Visa mindre",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Gå till projekt",
    "mobile_dashboard_card_title_recurring_projects": "Återkommande projekt",
    "mobile_dashboard_card_filter_daily": "Dagligen",
    "mobile_dashboard_card_filter_weekly": "Veckovis",
    "mobile_dashboard_card_filter_monthly": "Månadsvis",
    "mobile_task_status_title_open": "Öppen",
    "mobile_task_status_title_upcoming": "Kommande",
    "mobile_task_status_title_complete": "Slutför",
    "mobile_task_status_title_processing": "Bearbetning av inlämning pågår",
    "mobile_task_status_title_complete_with_exceptions": "Komplett med uppföljningsuppgifter eller varningar",
    "mobile_task_status_title_completed_late_with_exceptions": "Slutförd sent med uppföljningsuppgifter eller varningar",
    "mobile_task_status_title_incomplete_and_closed": "Missad",
    "mobile_tasks_legend_modal_title": "Förklaring",
    "mobile_tasks_legend_modal_footer_button_title": "Stäng",
    "mobile_common_assigned_to": "Tilldela till",
    "mobile_common_created_by": "Skapad av",
    "mobile_common_tasks_for": "Uppgifter för",
    "mobile_common_go_back": "Gå tillbaka",
    "mobile_oh_no": "Å, nej!",
    "mobile_user_not_in_groups": "Tyvärr, det verkar som om du inte är tilldelad ett team. Kontakta din administratör för att få tillgång till din instrumentpanel.",
    "mobile_tasks_select_followers": "Välj följare",
    "mobile_tasks_assign_tasks": "Tilldela {{count}} uppgifter",
    "mobile_tasks_add_followers": "Lägg till användare",
    "mobile_tasks_followers": "Följare",
    "mobile_tasks_delete_task": "Dela uppgift",
    "mobile_tasks_create_task": "Skapa uppgifter",
    "mobile_tasks_tab_title_comments": "Kommentarer",
    "mobile_tasks_see_more": "Läs mer",
    "mobile_projects_create_project": "Skapa projekt",
    "mobile_common_button_send": "Skicka",
    "mobile_common_button_schedule": "Planera",
    "mobile_announcements_create": "Skapa meddelande",
    "mobile_announcements_read_rate": "{{opened_count}} av {{recipients_count}} öppnat",
    "mobile_announcements_empty_message": "Du har inte skapat några meddelanden ännu! Skapa ett meddelande nedan för att sända viktiga nyheter, information och uppdateringar till din organisation.",
    "mobile_announcement_message_placeholder": "Lägg till ett meddelande ...",
    "mobile_announcement_title_placeholder": "Meddelandetitel",
    "mobile_announcement_leaving_announcement": "Lämna meddelande",
    "mobile_announcement_confirm_recipients_team": "Vill du sända detta tillkännagivande till {{count}} användare i {{teams}} valda team?",
    "mobile_announcement_confirm_recipients_role": "Vill du sända detta meddelande till {{count}} användare i {{roles}} valda användarroller?",
    "mobile_announcement_confirm_recipients_user": "Vill du sända detta meddelande till {{count}} användare?",
    "mobile_announcement_confirm_scheduled": "På {{timestamp}}",
    "mobile_announcement_sending_announcement": "Skicka meddelande",
    "mobile_announcement_send_to": "Skicka till",
    "mobile_announcement_sent_to": "Skickat till",
    "mobile_announcement_send_to_role": "Roll",
    "mobile_announcement_attachment_download": "Laddar ner {{filename}}",
    "mobile_announcement_attachment_validation_error": "Inte fler än {{maxCount}} bilagor kan läggas till",
    "mobile_announcement_details_sent": "Skickat",
    "mobile_announcement_details_total_recipients": "Totalt antal mottagare",
    "mobile_announcement_details_cancel": "Avbryt meddelande",
    "mobile_announcement_details_not_editable": "Meddelanden kan endast redigeras i webbappen Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Meddelandet kan bara redigeras på Zenputs webbplats",
    "mobile_announcement_details_open_count": "Öppna konto",
    "mobile_announcement_details_open_rate": "Öppna ränta",
    "mobile_announcement_details_resend": "Skicka till icke-öppnare",
    "mobile_announcement_confirm_resend": "{{count}} användare har inte läst meddelandet. Vill du skicka en påminnelse?",
    "mobile_announcement_confirm_resend_title": "Skicka påminnelse?",
    "mobile_announcement_recipients_opened": "Öppnade",
    "mobile_recipients_opened_empty_message": "Det verkar som om ingen har öppnat ditt meddelande än. Kom tillbaka senare för att se dina resultat.",
    "mobile_announcement_recipients_unopened": "Oöppnade",
    "mobile_recipients_unopened_empty_message": "Goda nyheter! Det finns inga oöppnade meddelanden!",
    "mobile_scheduled_announcements_delivery_section_header": "Leveranstid",
    "mobile_scheduled_announcements_send_immediately_label": "Skicka omedelbart",
    "mobile_scheduled_announcements_scheduled_label": "Skicka vid en viss tidpunkt",
    "mobile_scheduled_announcements_scheduled_tab_label": "Planerad",
    "mobile_scheduled_announcements_dialog_header": "Avbryta meddelandet?",
    "mobile_scheduled_announcements_dialog_message": "Om du avbryter ditt meddelande kommer det att hindras från att skickas och tas bort det från din lista. Detta kan inte ångras. För att redigera, gå till Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Du har för närvarande inga planerade meddelanden. Planera ett meddelande för att sända viktiga nyheter, information och uppdateringar till din organisation.",
    "mobile_scheduled_announcements_validation_error": "Leveranstiden måste vara efter {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Schemalägg meddelande",
    "mobile_projects_auto_archive": "Autoarkivera",
    "mobile_common_unassigned": "Osignerad",
    "mobile_tasks_title_placeholder": "Ny uppgift eller formulär",
    "mobile_projects_leaving_project": "Lämna projekt",
    "mobile_projects_save_project": "Spara projekt",
    "mobile_top_triggers_tasks": "Topputlösta uppgifter",
    "mobile_top_triggers_alerts": "Topputlösta aviseringar",
    "mobile_projects_not_started": "Ej startat",
    "mobile_empty_list_message_no_photos": "Inga foton",
    "mobile_webfilestore_message_error": "Välj en giltig filtyp",
    "mobile_notifications_empty_title": "Inga aviseringar",
    "mobile_notifications_empty_message": "Aktivitet för dina uppgifter eller dem du är del av visas här.",
    "mobile_comments_comment_deleted": "Den här kommentaren har tagits bort.",
    "mobile_comments_comment_placeholder": "Kommentar",
    "mobile_comments_task_submitted_at": "Uppgift inlämnad den {{ date }} kl {{ time }}",
    "mobile_comments_discard_comment_title": "Avvisa Kommentar?",
    "mobile_comments_discard_confirm_message": "Är du säker? Dina ändringar kommer att tas bort.",
    "mobile_comments_delete_comment_title": "Ta bort kommentar?",
    "mobile_comments_delete_confirm_message": "Detta kan inte göras ogjort.",
    "mobile_comments_delete_button": "Ta bort kommentar",
    "mobile_comments_delete_success_message": "Kommentaren har tagits bort",
    "mobile_comments_empty_message_tasks": "Det finns inga kommentarer ännu \n Starta en konversation om den här uppgiften.",
    "mobile_comments_empty_message_submissions": "Det finns inga kommentarer ännu \n Starta en konversation om den här inlämningen.",
    "mobile_comments_empty_message_default": "Det finns inga kommentarer ännu \n Starta en konversation.",
    "mobile_comments_no_matching_users": "Inga användare som matchar.",
    "mobile_comments_empty_users_to_notify": "Det finns inga användare att avisera.",
    "mobile_comments_users_cant_view_message": "Dessa användare kan inte se dessa kommentarer",
    "mobile_comments_users_to_notify_title": "Användare att meddela",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} användare</a> kommer att aviseras.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} användare</a> kommer att aviseras.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> fler användare att avisera dem.",
    "mobile_comments_mark_read": "Markera allt som läst",
    "mobile_comments_author_mentioned_message": "nämnde dig i",
    "mobile_comments_author_commented_message": "kommenterade",
    "mobile_view_pdf": "Visa PDF",
    "mobile_no_pdf_generated_message": "Ingen PDF hittades för den här inlämningen. En kopia kommer att skickas till dig via e-post inom kort.",
    "mobile_clipboard_copied_success": "Länken kopieras till ditt urklipp.",
    "mobile_share_link": "Dela länk",
    "mobile_zencam_share": "Dela",
    "mobile_zencam_view_details": "Visa information",
    "mobile_zencam_details_drawer_header": "Information",
    "mobile_zencam_submitted_by": "Skickades in av",
    "mobile_zencam_form_title": "Formulärsrubrik",
    "mobile_zencam_date_submitted": "Skickades in den",
    "mobile_oil_quality_warning_message": "Olja nära utgångsdatum",
    "mobile_oil_quality_warning_message_subtitle": "Överväg att byta ut den snart",
    "mobile_oil_quality_failure_message": "Oljekvaliteten äventyrad",
    "mobile_oil_quality_failure_message_subtitle": "Byt olja omedelbart",
    "mobile_sensors_set_up_gateway": "Ställ in ingångar",
    "mobile_sensors_set_up_gateway_message": "Det verkar som om inga enheter är inställda. Kom igång genom att lägga till en ingång.",
    "mobile_sensors_gateway_plugged_in": "Se till att din ingången är ansluten till ett eluttag",
    "mobile_sensors_add_device": "Lägg till en enhet",
    "mobile_sensors_name_this_gateway": "Ge ingången ett namn.",
    "mobile_sensors_name_this_sensor": "Ge sensorn ett namn.",
    "mobile_sensors_device_barcode_information": "Skanna QR-koden eller ange ID och SC-nummer från enhetens etikett",
    "mobile_sensors_device_eui_information": "Skanna QR-koden eller ange DevEUI från enhetsetiketten",
    "mobile_sensors_gateway_id_information": "Ange nod-id från nätslussetiketten",
    "mobile_sensors_id_number": "{{untranslatedID}} Nummer",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Kod",
    "mobile_sensors_sensors": "Sensorer",
    "mobile_sensors_sensor_deveui_error": "Kunde inte få DevEUI från QR. Skriv in den manuellt.",
    "mobile_sensors_gateways": "Ingångar",
    "mobile_sensors_add_sensor": "Lägg till sensor",
    "mobile_sensors_add_gateway": "Lägg till en ingång",
    "mobile_sensor_placement_description": "Vilket område ska detta sensornätverk övervaka?",
    "mobile_sensors_equipment_placement": "Vilket område eller utrustning ska den här sensorn övervaka?",
    "mobile_sensors_equipment": "Vilken utrustning ska detta sensornätverk övervaka?",
    "mobile_sensors_select_gateway_type": "Välj nätslusstypen",
    "mobile_sensors_select_placement": "Välj placering",
    "mobile_sensors_select_equipment": "Välj utrustning",
    "mobile_sensors_placement": "Placering",
    "mobile_sensors_nickname_tip": "Sensornamn bestäms av smeknamnen som tilldelas i den valda placeringen.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Skanna QR-kod",
    "mobile_sensors_enter_manually": "Gå in manuellt",
    "mobile_sensors_wizard_step_one": "Steg 1",
    "mobile_sensors_wizard_step_two": "Steg 2",
    "mobile_sensors_wizard_step_three": "Steg 3",
    "mobile_sensors_wizard_step_four": "Steg 4",
    "mobile_sensors_wizard_step_five": "Steg 5",
    "mobile_sensors_wizard_step_six": "Steg 6",
    "mobile_sensors_initializing": "Initierar ...",
    "mobile_sensors_nickname": "Tillnamn",
    "mobile_sensors_field_not_blank": "{{field}} kan inte stå tomt.",
    "mobile_sensors_nothing_to_see_here": "Inget att se här",
    "mobile_sensors_missing_integration": "Saknar sensorintegration",
    "mobile_sensors_contact_zenput_admin": "Kontakta din företagsadministratör för Ops Execution.",
    "mobile_sensors_contact_zenput_admin_old": "Kontakta din Zenput-administratör.",
    "mobile_sensors_contact_manager": "Välj din kontoadministratör för att lägga till sensorer.",
    "mobile_sensors_device_success_message": "Det kan ta upp till 15 minuter att ladda sensordata",
    "mobile_sensors_last_reading": "Senaste avläsning",
    "mobile_sensors_remove_device": "Ta bort enheten",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1V",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1Å",
    "mobile_sensors_sensor_settings": "Sensorinställningar",
    "mobile_sensors_remove_confirm_message": "Är du säker på att du vill ta bort den här enheten?\nDetta kan inte ångras.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Ingen utrustning kopplad",
    "mobile_sensor_cooldown_process": "Nedkylningsprocess",
    "mobile_sensor_last_12_hours": "Senaste 12 timmarna",
    "mobile_sensor_start_cooldown_process": "Starta ny nedkylningsprocess",
    "mobile_sensor_cooldown_process_title": "Tvåstegs nedkylningsprocess",
    "mobile_sensor_cooldown_process_description": "En tvåstegs nedkylningsprocess består av nedkylning av livsmedel från mer än {{ stage1_start_temperature }} till {{ stage1_end_temperature }} under två timmar eller mindre, och sedan från {{ stage1_end_temperature }} till {{ stage2_end_temperature }} under fyra timmar eller mindre.",
    "mobile_sensor_cooldown_process_place_food": "Placera livsmedelsprodukten i kylskåpet.",
    "mobile_sensor_cooldown_process_insert_sensor": "Sätt i en sensorsond i livsmedelsprodukten.",
    "mobile_sensor_cooldown_process_enter_information": "Ange information nedan.",
    "mobile_sensor_cooldown_process_food_product": "Livsmedelsprodukt som måste svalna",
    "mobile_sensor_cooldown_cool_down": "Kyl ned",
    "mobile_sensor_cooldown_select_sensor": "Välj sensor",
    "mobile_sensors_cooldown_start_cooldown": "Starta nedkylning",
    "mobile_sensors_cooldown_please_enter_food": "Ange en livsmedelsprodukt",
    "mobile_sensors_cooldown_please_select_sensor": "Välj en sensor",
    "mobile_sensors_cooldown_status_in_progress": "Pågår",
    "mobile_sensors_cooldown_status_failed": "Misslyckades",
    "mobile_sensors_cooldown_status_success": "Lyckades",
    "mobile_sensors_cooldown_stage": "Avsnitt",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Starttemperaturen är utanför intervallet",
    "mobile_sensors_cooldown_failed_cooldown_process": "Nedkylningsprocessen misslyckades",
    "mobile_sensors_cooldown_cooldown_successful": "Nedkylningen lyckades",
    "mobile_sensors_cooldown_started_cooldown_process": "Nedkylningsprocessen är startad",
    "mobile_sensors_cooldown_hour": "timme",
    "mobile_sensors_cooldown_hour_plural": "timmar",
    "mobile_sensors_cooldown_minute": "minut",
    "mobile_minutes_plural": "minuter",
    "mobile_sensors_last_reading_max_date": "> 1 år sedan",
    "mobile_sensors_minute_count_ago": "för {{count}} minut sedan",
    "mobile_sensors_minute_count_ago_plural": "för {{count}} minuter sedan",
    "mobile_sensors_hour_count_ago": "för {{count}} timme sedan",
    "mobile_sensors_hour_count_ago_plural": "för {{count}} timmar sedan",
    "mobile_sensors_day_count_ago": "för {{count}} dag sedan",
    "mobile_sensors_day_count_ago_plural": "för {{count}} dagar sedan",
    "mobile_sensors_chart_settings": "Diagraminställningar",
    "mobile_announcement_banner_continue_reading": "Fortsätt läsning",
    "mobile_compliance_submissions_report": "Rapport över inlämningar",
    "mobile_compliance_submissions_report_subtitle": "Exportera data projektslutförande för den här butiken",
    "mobile_compliance_send_submissions": "Skicka inlämningar",
    "mobile_compliance_completion_rate_in_last_days": "Kompletteringsgrad under de senaste {{ days }} dagarna",
    "mobile_compliance_last_days": "Senaste {{ days }} dagar",
    "mobile_compliance_send_submissions_to": "Skicka inlämningar till",
    "mobile_compliance_send_to_different_email": "Skicka till en annan e-postadress",
    "mobile_compliance_email_input_placeholder": "E-postadress",
    "mobile_compliance_send_submissions_to_legend_title": "Inlämningar",
    "mobile_compliance_send_submissions_to_legend_description_days": "En rapport över dina inlämningar från den här platsen de senaste {{ days }} dagarna kommer att skickas till den valda e-posten.",
    "mobile_compliance_time_frame": "Tidsram",
    "mobile_compliance_sensor_temperature_log_report": "Loggrapport för sensornätverk temperatur",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exportera temperaturloggar för den här butiken",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kriterier",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Definiera kriterierna för din rapport nedan.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Obs: Inaktiverad(e) sensor(er) kommer inte att visas i rapporten",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Välj en tidsram. Loggdata är begränsad till högst 30 dagar",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Skicka rapport",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Denna månad (1:a – idag)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Förra månaden",
    "mobile_compliance_sensor_temperature_log_email_title": "Skicka rapport till",
    "mobile_pwa_update_prompt_title": "Uppdatera applikation",
    "mobile_pwa_update_prompt_description": "En ny version av applikationen finns tillgänglig. Uppdatera till den senaste versionen.",
    "mobile_pwa_update_prompt_confirm": "Uppdatera och ladda om",
    "mobile_pwa_update_prompt_cancel": "Påminn mig senare",
    "notification_title_due_in_one_hour": "Förfaller om 1 timme",
    "task_is_due_soon": "”{{ task_title }}” förfaller snart. Ta en stund att slutföra den.",
    "mobile_photo_quality_warning_header": "Problem med fotokvaliteten",
    "mobile_photo_quality_dialog_message": "Det här fotot kan vara för mörkt eller suddigt. Vill du ta ett nytt foto eller fortsätta med det här?",
    "mobile_take_new_photo": "Ta ett nytt foto",
    "mobile_use_this_photo": "Använd det här fotot"
}};
mobile_translations.no_NO = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Alle",
    "mobile_common_button_apply_filters": "Legg til filtre",
    "mobile_common_button_done": "Ferdig",
    "mobile_common_button_edit": "Rediger",
    "mobile_common_button_archive": "Arkiver",
    "mobile_common_button_save": "Lagre",
    "mobile_common_button_retake": "Ta på nytt",
    "mobile_common_button_save_draft": "Lagre utkast",
    "mobile_common_button_discard": "Forkaste",
    "mobile_common_button_submit": "Send inn",
    "mobile_common_button_no": "Nei",
    "mobile_common_button_yes": "Ja",
    "mobile_common_button_na": "I/A",
    "mobile_common_created_by_me": "Opprettet av meg",
    "mobile_common_email": "Bedrifts-e-post",
    "mobile_common_first_name": "Fornavn",
    "mobile_common_last_name": "Etternavn",
    "mobile_common_location": "Sted",
    "mobile_common_locations": "Steder",
    "mobile_common_logout_message": "Er du sikker på at du vil logge av?",
    "mobile_common_password": "Passord",
    "mobile_common_permission_required": "Tillatelse kreves",
    "mobile_common_status": "Status",
    "mobile_common_task": "Oppgave",
    "mobile_common_tasks": "Oppgaver",
    "mobile_common_tasks_my": "Mine oppgaver",
    "mobile_common_projects": "Prosjekter",
    "mobile_common_filter_team": "Team",
    "mobile_common_filter_var_in": " i {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Ingen team valgt",
    "mobile_common_filter_no_user_selected": "Ingen bruker er valgt",
    "mobile_common_filter_no_role_selected": "Ingen rolle er valgt",
    "mobile_common_placeholder_date": "Dato",
    "mobile_common_message_task_creator_error_save": "<b>Kunne ikke opprette oppgaver.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "for",
    "mobile_common_reload": "Laste på ny",
    "mobile_common_override": "Overstyre",
    "mobile_common_notifications": "Varslinger",
    "mobile_common_chat_unavailable": "Chaten er ikke tilgjengelig. Prøv igjen senere.",
    "mobile_common_chat_ending_dialog_title": "Er du ferdig med denne samtalen?",
    "mobile_common_chat_ending_dialog_description": "Gi oss beskjed hvis problemet ditt er løst, eller hvis du bare vil fortsette senere.",
    "mobile_common_chat_ending_dialog_confirm": "Ja, jeg er ferdig",
    "mobile_common_chat_ending_dialog_cancel": "Jeg fortsetter senere",
    "mobile_common_continue_editing": "Fortsett redigering",
    "mobile_privacy_policy": "Retningslinjer for personvern",
    "wootric_recommend_target": "en venn eller kollega i bransjen din",
    "wootric_followup_detractor_question": "Hvilke endringer kan vi gjøre slik at du gir oss en høyere vurdering neste gang?",
    "wootric_followup_passive_question": "Takk! Hvordan kan vi gjøre verktøyet enda bedre?",
    "wootric_followup_promoter_question": "Takk! Hva liker du med Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Takk! Hva liker du med Zenput?",
    "wootric_default_followup_question": "Takk! Kan du fortelle oss hvorfor?",
    "wootric_default_placeholder_text": "Hjelp oss ved å forklare poengsummen din.",
    "wootric_default_thankyou_text": "Takk for svaret og tilbakemeldingen din!",
    "mobile_login_placeholder_login_as": "Brukernavn som bruker-ID",
    "mobile_login_button_forgot_password": "Glemt passordet?",
    "mobile_login_button_sign_up": "Opprett konto",
    "mobile_login_button_finish_setup": "Avslutt oppsett",
    "mobile_login_button": "Brukernavn",
    "mobile_login_continue_button": "Fortsett",
    "mobile_login_continue_transition": "sender deg til organisasjonens påloggingsside ...",
    "mobile_login_no_email_error": "Du må legge inn en e-postadresse.",
    "mobile_login_change_email": "Logg på med en annen e-postadresse",
    "mobile_login_with_sso": "Logg på med SSO",
    "mobile_oauth_no_user_error_message": "Det ser ut til at du ikke har en konto for Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Det ser ut til at du ikke har en Zenput-konto.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> er nå <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} blir til {{- product }} i september. {{- cta }}",
    "mobile_rebrand_warning_cta": "Slik gjør du deg klar.",
    "mobile_oauth_no_user_error_sub_message": "Ta kontakt med administratoren for å få tilgang, eller prøv å logge på med en annen e-postadresse.",
    "mobile_oauth_generic_error_message": "Det ser ut til at det var problemer med påloggingen. Prøv igjen.",
    "mobile_oauth_force_logout_msg": "Hvis du fremdeles har problemer, kan du logge ut av leverandøren ved å ",
    "mobile_oauth_force_logout_click": "klikke her.",
    "mobile_sign_up_placeholder_phone": "Telefonnummer",
    "mobile_sign_up_placeholder_password_confirm": "Bekreft passord",
    "mobile_sign_up_button_sign_in": "Logg på",
    "mobile_sign_up_disclaimer_part_1": "Ved å klikke på Opprett konto, godtar du",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Ved å klikke på Avslutt oppsett, godtar du",
    "mobile_sign_up_disclaimer_link_title": " Lisensavtale",
    "mobile_sign_up_disclaimer_part_2": ", som inneholder viktig personverninformasjon",
    "mobile_dialog_benefits_work_offline": "Jobbe frakoblet",
    "mobile_dialog_benefits_faster_uploads": "Raskere opplastinger",
    "mobile_dialog_benefits_better_experience": "Forbedret opplevelse",
    "mobile_dialog_benefits_button_download": "Last ned",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution for ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput for ",
    "mobile_dialog_benefits_button_have": "Jeg har appen!",
    "mobile_dialog_benefits_button_no_thanks": "Nei, takk. Kanskje senere.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Kunne ikke laste inn bilde.",
    "mobile_dialog_signature_sign": "Signer her",
    "mobile_dialog_signature_button_clear": "Tøm",
    "mobile_account_placeholder_name": "Navn på sted/butikk",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Adresse",
    "mobile_account_placeholder_city": "Sted",
    "mobile_account_placeholder_region": "Region",
    "mobile_account_placeholder_zipcode": "Postnummer",
    "mobile_account_option_select_country": "Velg land",
    "mobile_account_oprion_us": "USA",
    "mobile_account_oprion_select_state": "Velg stat",
    "mobile_account_button_create_location": "Opprett sted",
    "mobile_form_message_no_form": "Ingen skjemaer tilgjengelig",
    "mobile_batch_task_message": "Laster …",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Mobiltelefon",
    "mobile_settings_profile_language": "Språk",
    "mobile_settings_profile_temperature_unit": "Temperaturenhet",
    "mobile_settings_profile_use_company_default": "Bruk selskapets standard",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Tekstmelding",
    "mobile_settings_notifications_option_push": "Push-varsler",
    "mobile_settings_notifications_option_push_email": "E-post- og push-varsler",
    "mobile_settings_notifications_option_do_not": "Ikke varsle",
    "mobile_settings_notifications_category_communication": "Kommunikasjon",
    "mobile_settings_notifications_category_forms_and_triggers": "Skjemaer og utløsere",
    "mobile_settings_devices": "Enheter",
    "mobile_settings_notifications_sub_category_alerts": "Varsler",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nye skjemaer tilgjengelig",
    "mobile_settings_notifications_sub_category_task_assigned": "Oppgave tilordnet",
    "mobile_settings_notifications_sub_category_task_completed": "Oppgave fullført",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Påminnelse om oppgave som forfaller snart",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Påminnelse om forfalte oppgaver",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensorvarsler",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Kritiske sensorvarsler",
    "mobile_drafts_message": "Du har ingen utkast ennå.",
    "mobile_drafts_button_delete": "Slett",
    "mobile_tasks_filter_location_no": "Ingen steder valgt",
    "mobile_tasks_filter_group_by": "Grupper etter",
    "mobile_tasks_filter_sort_by": "Sorter etter",
    "mobile_tasks_filter_sorted_by": "Sortert etter",
    "mobile_tasks_filter_due_time": "Forfallstidspunkt",
    "mobile_tasks_filter_open_time": "Åpningstidspunkt",
    "mobile_tasks_bucket_due_next_24_hours": "Forfaller i løpet av de neste 24 timene",
    "mobile_tasks_bucket_due_next_7_days": "Forfaller i løpet av de neste 7 dagene",
    "mobile_tasks_bucket_open_tasks": "Flere åpne {{type}}",
    "mobile_tasks_bucket_open_at": "Åpen: {{- date }} kl. {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Forfaller innen: {{- date }} kl. {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Tilgjengelig om 1 minutt",
    "mobile_tasks_bucket_available_in_one_hour": "Tilgjengelig om 1 time",
    "mobile_tasks_bucket_available_in_one_day": "Tilgjengelig om 1 dag",
    "mobile_tasks_bucket_available_in_one_week": "Tilgjengelig om 1 uke",
    "mobile_tasks_bucket_available_in_one_month": "Tilgjengelig om 1 måned",
    "mobile_tasks_bucket_available_in_one_year": "Tilgjengelig om 1 år",
    "mobile_tasks_bucket_available_in_minutes": "Tilgjengelig om {{ minutes }} minutter",
    "mobile_tasks_bucket_available_in_hours": "Tilgjengelig om {{ hours }} timer",
    "mobile_tasks_bucket_available_in_days": "Tilgjengelig om {{ days }} dager",
    "mobile_tasks_bucket_available_in_weeks": "Tilgjengelig om {{ weeks }} uker",
    "notification_task_due_in_minutes": "Forfaller om {{ minutes }} minutter",
    "mobile_tasks_bucket_available_in_months": "Tilgjengelig om {{ months }} måneder",
    "mobile_tasks_bucket_available_in_years": "Tilgjengelig om {{ years }} år",
    "mobile_tasks_follow_up": "Oppfølgingsoppgave",
    "mobile_tasks_due_soon": "Forfaller snart",
    "mobile_tasks_bucket_completed_today": "Fullført i dag",
    "mobile_tasks_bucket_completed_this_week": "Fullført denne uken",
    "mobile_tasks_bucket_completed_last_week": "Fullført forrige uke",
    "mobile_tasks_bucket_missed_today": "Ugjort i dag",
    "mobile_tasks_bucket_missed_this_week": "Ugjort denne uken",
    "mobile_tasks_bucket_missed_last_week": "Ugjort forrige uke",
    "mobile_tasks_bucket_no_location": "Ikke noe sted",
    "mobile_tasks_cannot_submit_missed": "Ugjorte oppgaver kan ikke fullføres",
    "mobile_tasks_cannot_submit_missed_after": "Denne oppgaven kan ikke fullføres etter {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Denne oppgaven har ikke startet.",
    "mobile_tasks_cannot_submit_processing": "Denne innsendingen er under behandling",
    "mobile_tasks_toolbarnav_header_no_due_date": "Ingen forfallsdato",
    "mobile_tasks_toolbarnav_header_overdue": "Forfalt",
    "mobile_tasks_toolbarnav_header_yesterday": "I går",
    "mobile_tasks_toolbarnav_header_today": "I dag",
    "mobile_tasks_toolbarnav_header_tomorrow": "I morgen",
    "mobile_tasks_toolbarnav_header_last_week": "Forrige uke",
    "mobile_tasks_toolbarnav_header_this_week": "Denne uken",
    "mobile_tasks_toolbarnav_header_next_week": "Neste uke",
    "mobile_tasks_toolbarnav_header_this_month": "Denne måneden",
    "mobile_tasks_toolbarnav_header_next_year": "Neste år",
    "mobile_tasks_toolbarnav_header_over_year": "Over et år",
    "mobile_tasks_toolbarnav_title_edit_task": "Rediger oppgave",
    "mobile_task_placeholder_title": "Tittel *",
    "mobile_task_placeholder_description": "Beskrivelse (valgfritt)",
    "mobile_task_button_single_task": "Enkeltoppgave",
    "mobile_task_button_project": "Prosjekt",
    "mobile_task_button_create": "Opprett",
    "mobile_task_tab_basic": "Grunnleggende",
    "mobile_task_tab_photo": "Bilde",
    "mobile_task_tab_form": "Skjema",
    "mobile_task_details_description_message_please": "Fyll ut ",
    "mobile_task_details_description_message_below": "nedenfor.",
    "mobile_task_details_description_message_instructions": "Ingen instruksjoner er tilgjengelige for denne oppgaven.",
    "mobile_task_details_reason_title": "Oppfølging utløst av",
    "mobile_task_detials_button_goto_form": "Gå til skjema",
    "mobile_task_detials_button_complete": " Fullfør oppgave",
    "mobile_task_detials_completed": "Fullført ",
    "mobile_task_detials_completed_by": "etter ",
    "mobile_task_detials_completed_on": "på ",
    "mobile_task_details_view_form_submission": "Vis skjemainnsending",
    "mobile_task_task_updated": "Oppgave oppdatert",
    "mobile_task_task_archived": "Oppgave arkivert",
    "mobile_task_task_deleted": "Oppgave slettet",
    "mobile_task_error_archiving_task": "Kunne ikke arkivere denne oppgaven",
    "mobile_task_error_deleting_task": "Kunne ikke slette oppgave.",
    "mobile_task_error_updating_task": "Kunne ikke oppdatere denne oppgaven",
    "mobile_task_archive_task": "Arkiver oppgave",
    "mobile_task_archive_task_confirm": "Er du sikker på at du vil arkivere denne oppgaven?\n\nArkiverte oppgaver regnes med i fullførelsesraten og vil fortsatt være inkludert i rapporteringen.\n\nDette kan ikke angres.",
    "mobile_task_delete_task_confirm": "Er du sikker på at du vil slette denne oppgaven?\n\nSlettede oppgaver regnes ikke med i fullførelsesraten og vil heller ikke være inkludert i rapporteringen.\n\nDette kan ikke angres.",
    "mobile_task_edition_already_in_progress": "Denne oppgaven har en ventende redigering. Videre redigering er for øyeblikket ikke tillat.",
    "mobile_projects_filter_type": "Type",
    "mobile_projects_filter_status": "Prosjektstatus",
    "mobile_projects_filter_project_type": "Prosjekttype",
    "mobile_projects_due_date_required": "Forfallsdato er påkrevd.",
    "mobile_projects_team_required": "Team er påkrevd.",
    "mobile_projects_user_role_required": "Stedfortreder er påkrevd.",
    "mobile_projects_title_required": "Tittel er påkrevd.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Flere oppgaver per dag",
    "mobile_project_tasks_complete": " Fullført",
    "mobile_project_tasks_remaining": " Gjenstår",
    "mobile_esitmate_message_tasks": "0 oppgaver blir opprettet",
    "mobile_esitmate_message_criteria": "Juster kriterier ovenfor",
    "mobile_esitmate_message_created_for": "blir opprettet for",
    "mobile_left_menu_dashboard": "Dashbord",
    "mobile_left_menu_my_forms": "Mine skjemaer",
    "mobile_left_menu_announcements": "Kunngjøringer",
    "mobile_left_menu_my_submissions": "Mine innsendinger",
    "mobile_left_menu_drafts": "Utkast",
    "mobile_left_menu_pending_uploads": "Ventende opplastinger",
    "mobile_left_menu_open": "Åpne i app",
    "mobile_left_menu_settings": "Innstillinger",
    "mobile_left_menu_log_out": "Logg av",
    "mobile_left_menu_debug": "Feilsøk",
    "mobile_left_menu_support": "Support",
    "mobile_left_menu_documentation": "Dokumentasjon",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Notat eller bildetekst",
    "mobile_field_option_select": "Velg",
    "mobile_field_text_placeholder_text": "Tekst",
    "mobile_field_email_placehoder_email": "E-post",
    "mobile_filed_number_placeholder_number": "Nummer",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Ikke tilkoblet",
    "mobile_field_sensor_offline_battery": "Sensor frakoblet – batteri",
    "mobile_field_video_button_add": "Legg til en video",
    "mobile_field_video_picker_dialog_title": "Legg til video fra",
    "mobile_field_video_button_change": "Endre video",
    "mobile_field_image_button_add": "Legg til bilde",
    "mobile_field_image_low_quality_warning": "Noen bilder kan være for mørke eller uskarpe. Se gjennom de uthevede bildene og erstatt dem om nødvendig",
    "mobile_field_image_picker_dialog_title": "Legg til bilde fra",
    "mobile_field_image_picker_edit_failed": "Vi kunne ikke lagre bildet. Prøv på nytt.",
    "mobile_field_signature_button_add": "Legg til en signatur",
    "mobile_field_signature_button_change": "Endre signatur",
    "mobile_field_account_select_location": "Velg et sted",
    "mobile_field_account_prefill": "Vil du forhåndsutfylle skjema med data fra forrige besøk?",
    "mobile_field_account_message_overwrite": "Dette overskriver alle felter du allerede har fylt ut.",
    "mobile_forms_task_on_behalf": "Det er en oppgave å fullføre på denne plasseringen som er tildelt <b>{{user}}</b>. Vil du fullføre denne oppgaven?",
    "mobile_forms_complete_task": "Fullføre oppgave?",
    "mobile_field_account_prefill_button_yes": "Ja, forhåndsutfyll",
    "mobile_field_barcode_placeholder_scan": "Skann eller skriv inn strekkode",
    "mobile_field_sensor_qr_code_placeholder_scan": "Skann eller skriv inn kode",
    "mobile_field_gateway_id_code_placeholder": "Node-ID for type",
    "mobile_field_scan_qr_or_enter_dev_eui": "Skann QR-kode eller angi DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Skann QR-kode eller angi ID-nummer",
    "mobile_field_scan_qr_or_enter_sc": "Skann QR-kode eller angi SC-kode",
    "mobile_field_barcode_select_date": "Velg dato ",
    "mobile_field_datetime_allow_time": "Tid",
    "mobile_field_stopwatch_button_caption": "Stoppeklokke",
    "mobile_field_stopwatch_common_start": "Start",
    "mobile_field_stopwatch_common_stop": "Stopp",
    "mobile_field_stopwatch_common_reset": "Tilbakestill",
    "mobile_field_stopwatch_stop_stopwatches": "Stopp stoppeklokker",
    "mobile_field_document_title": "Legg til dokument",
    "mobile_field_document_message_delete": "Er du sikker på at du vil slette dette dokumentet?",
    "mobile_field_document_alret_button_view": "Vis",
    "mobile_field_document_alert_error": "Det oppstod en feil da vi la til dette dokumentet. Prøv igjen.",
    "mobile_field_document_alert_file_size_error": "Filen kan ikke overstige {{count}} MB.",
    "mobile_field_temperature_greater_range": "mer enn {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "mer enn eller lik {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "mindre enn {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "mindre enn eller lik {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "mer enn eller lik {{ min_temp_value }} °{{ temp_unit }} og mindre enn {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "mer enn eller lik {{ min_temp_value }} °{{ temp_unit }} og mindre enn eller lik {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " og ",
    "mobile_field_text_limit_error": "Maksimal tegngrense på 8000 er nådd.",
    "mobile_forms_required_questions_complete": "Påkrevd fullført",
    "mobile_forms_required_remaining": "{{count}} Gjenværende påkrevde",
    "mobile_forms_required_questions_back": "Tilbake",
    "mobile_forms_required_questions_next": "Neste",
    "mobile_forms_required_questions_skip": "Hopp over",
    "mobile_forms_leaving_form": "Forlater skjemaet",
    "mobile_message_reordering_confirm": "Vil du lagre den nye spørsmålsrekkefølgen?",
    "mobile_forms_leaving_reordering": "Forlater endring av spørsmålsrekkefølge",
    "mobile_forms_reordering_button_save": "Lagre ny spørsmålsrekkefølge",
    "mobile_forms_reordering_instructions": "For å endre rekkefølge på spørsmål eller avsnitt kan du dra og slippe dem der feltet skal vises i skjemaet",
    "mobile_toolbarnav_title_my_setttings": "Mine innstillinger",
    "mobile_toolbarnav_title_profile_settings": "Profilinnstillinger",
    "mobile_toolbarnav_title_notification": "Varslingsinnstillinger",
    "mobile_toolbarnav_title_form_history": "Skjemahistorikk",
    "mobile_toolbarnav_title_form_not_available": "Skjema ikke tilgjengelig",
    "mobile_toolbarnav_title_add_location": "Legg til sted",
    "mobile_toolbarnav_title_add_task_or_project": "Legg til oppgave eller prosjekt",
    "mobile_toolbarnav_title_select_location": "Velg sted",
    "mobile_toolbarnav_title_select_project": "Velg prosjekt",
    "mobile_toolbarnav_title_select_tag": "Velg merke",
    "mobile_toolbarnav_title_select_user": "Velg bruker",
    "mobile_toolbarnav_title_select_template": "Velg mal",
    "mobile_toolbarnav_title_select_one": "Velg én",
    "mobile_toolbarnav_title_select_multiple": "Velg én eller flere",
    "mobile_toolbarnav_title_select_team": "Velg team",
    "mobile_toolbarnav_title_select_team_or_location": "Velg team eller sted",
    "mobile_toolbarnav_title_filter_tasks": "Filtrer oppgaver",
    "mobile_toolbarnav_title_filter_projects": "Filtrer prosjekter",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrer prosjektoppgaver",
    "mobile_placeholder_search_bar": "Søk",
    "mobile_placeholder_user_select_role": "Velg brukerrolle",
    "mobile_placeholder_filter_by_team": "Filtrer etter et team",
    "mobile_placeholder_assign_to_user_role": "Tilordne til brukerrolle",
    "mobile_placeholder_select": "-- Velg --",
    "mobile_placeholder_account_location_name": "Stedsnavn",
    "mobile_placeholder_tag_filter_by": "Filtrer etter stedsmerke",
    "mobile_placeholder_user_type": "Tilordne til bruker",
    "mobile_placeholder_acount_type_loading": "Laster … ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatur",
    "mobile_placeholder_blue_therm_connecting": "Kobler til enhet …",
    "mobile_placeholder_blue_therm_please_wait": "Vent litt …",
    "mobile_placeholder_blue_therm_tap": "Trykk for å lese.",
    "mobile_placeholder_blue_therm_not_connected": "Ikke tilkoblet.",
    "mobile_placeholder_testo_tap": "Hold ▼▲ etterfulgt av ⬆",
    "mobile_message_error_create_task": "Du må være tilkoblet for å legge til oppgaver.",
    "mobile_message_error_fill_out_form": "Fyll ut skjemaet.",
    "mobile_message_error_fill_require_fields": "Fyll inn påkrevde felter.",
    "mobile_message_error_stop_stopwatch_before_submit": "Stopp stoppeklokken før du sender inn",
    "mobile_message_error_stopwatch_field_required": "Stoppeklokkefelt er påkrevd",
    "mobile_message_error_stopwatch_field_running": "Stoppeklokkefelt kjører",
    "mobile_message_error_invalid_equipment_temperature": "Ugyldig utstyrstemperatur",
    "mobile_message_error_invalid_ingredient_temperature": "Ugyldig ingredienstemperatur",
    "mobile_message_error_location_attributes_unavailable": "Noen spørsmål er kanskje ikke tilgjengelig. Koble til internett.",
    "mobile_message_alert_running_stopwatches": "Du har stoppeklokker som kjører.\n\nVil du fjerne dem?",
    "mobile_message_blue_therm_error": "Mistet tilkoblingen til Bluetooth-enhet",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Posisjonstilgang er nødvendig. Aktiver det i Android-innstillingene dine.",
    "mobile_message_blue_therm_no_permission_android": "Tilgang til enheter i nærheten er nødvendig. Aktiver det i Android-innstillingene dine.",
    "mobile_message_blue_therm_error_code": "Kunne ikke koble til:",
    "mobile_message_blue_therm_error_bluetooth": "Aktiver Bluetooth.",
    "mobile_message_blue_therm_error_device": "Enhet ikke funnet.",
    "mobile_message_blue_therm_error_try_again": "Prøv igjen",
    "mobile_message_blue_therm_success": "Bluetooth-enhet tilkoblet!",
    "mobile_message_bluetooth_device_press_button_field": "Trykk på knappen på enheten for å koble den til.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Trykk på knappen på enheten<br />hvis du ikke ser den oppført her.",
    "mobile_bluetooth_scan": "Skann",
    "mobile_bluetooth_scanning": "Skanner",
    "mobile_message_drafts_confirm": "Vil du lagre dette som et utkast?",
    "mobile_message_drafts_toast_saved": "Utkast lagret.",
    "mobile_message_drafts_request_update": "Vil du oppdatere dette utkastet?",
    "mobile_message_drafts_form_confirm": "Er du sikker på at du vil slette dette utkastet?",
    "mobile_message_drafts_confirm_delete": "Slett utkast",
    "mobile_message_streams_error_switch": "Kan ikke endre strømmer på nettet",
    "mobile_message_settings_success_saved": "Innstillinger lagret",
    "mobile_message_settings_error": "En ukjent feil oppstod. Prøv igjen senere",
    "mobile_message_profile_settings_error_fields": "Korriger de uthevede feltene.",
    "mobile_message_media_perimission_denied": "Dine ",
    "mobile_message_media_perimission_denied_device": "Enhetslagring",
    "mobile_message_image_confirm_remove_image": "Er du sikker på at du vil slette dette bildet?",
    "mobile_message_create_account_error_fields": "Fyll ut de uthevede feltene.",
    "mobile_message_create_account_success_location_created": "Sted opprettet",
    "mobile_message_task_error_get_location": "Kunne ikke finne sted. Bestilling etter dato.",
    "mobile_message_typehead_confirm_save_message": "Vil du lagre disse valgene?",
    "mobile_message_typehead_confirm_save_title": "Lagre?",
    "mobile_message_task_creator_error_save_select_form": "Du må velge et skjema.",
    "mobile_message_task_creator_error_save_required_fields": "Fyll inn de påkrevde feltene.",
    "mobile_message_task_creator_error_save_batch_change": "Endre kriteriene slik at de samsvarer med én eller flere brukere",
    "mobile_message_task_detials_error_not_assigned_to_you": "Denne oppgaven er ikke tilordnet deg.<br />Du kan ikke fullføre den.",
    "mobile_message_task_detials_error_assigned_to": "Denne oppgaven er tilordnet {{user}}.<br />Du kan ikke fullføre den.",
    "mobile_message_task_detials_confirm_title": "Forlater oppgave",
    "mobile_message_task_detials_confirm_save_task": "Lagre oppgave",
    "mobile_message_task_detials_confirm_message": "Er du sikker? Endringene går tapt.",
    "mobile_message_task_detials_error_view_account": "Kunne ikke få tilgang til sted.",
    "mobile_message_task_detials_error_submit_task": "Legg til et bilde for å fullføre denne oppgaven.",
    "mobile_message_task_detials_error_submit_task_project": "Kunne ikke lagre prosjektet. Prøv igjen senere.",
    "mobile_message_task_detials_wait_submit_task_created": "Oppgaver blir opprettet.<br />Vent i noen minutter på at oppgavene blir fylt ut.",
    "mobile_message_task_detials_error_submit_task_pending": "Feil, prøv igjen senere",
    "mobile_message_task_detials_success_task_complete": "Oppgave fullført",
    "mobile_message_task_error_save_single_task": "Kan ikke lagre oppgaven. Prøv igjen senere.",
    "mobile_message_task_success_save_single_task": "Oppgave opprettet.",
    "mobile_message_show_error_message": "Noe gikk galt.",
    "mobile_message_show_success_message": "Vellykket!",
    "mobile_message_show_offline_message": "Du er for øyeblikket frakoblet.",
    "mobile_message_show_permission_denied_message": "<b>Tillatelse nødvendig.</b> Gi Zenput tilgang til {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Tillatelse kreves.</b> Gi tilgangstillatelse til Zenput og nettleseren din til {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Lastes opp nå",
    "mobile_message_show_upload_in_progress_message": "Opplasting pågår allerede",
    "mobile_message_show_form_id_error": "Kunne ikke få tilgang til spesifisert skjema.",
    "mobile_message_show_single_task_error": "Kan ikke få tilgang til spesifisert oppgave.",
    "mobile_message_show_submissions_error": "Kan ikke få tilgang til spesifisert innsending.",
    "mobile_message_show_submissions_access_denied": "Beklager, du har ikke tilgang til dette skjemaet.",
    "mobile_message_send_data_success": "Data lastet opp ",
    "mobile_message_start_upload_success": "Opplasting fullført",
    "mobile_message_start_upload_error": "<b>Kunne ikke fullføre opplasting.</b><br>Innsending lagret. Prøv igjen senere",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Oppdatering tilgjengelig",
    "mobile_message_store_upgrade_confirm_message_one": "Oppdater Ops Execution-appen fra ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Oppdater Zenput fra ",
    "mobile_message_store_upgrade_confirm_message_two": " for å få alle de nyeste funksjonene og feilrettingene",
    "mobile_message_store_upgrade_confirm_now": "Nå",
    "mobile_message_store_upgrade_confirm_later": "Senere",
    "mobile_message_redirect_confirm_message": "Du fyller ut et skjema for øyeblikket. Vil du lagre det som et utkast før du fortsetter?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Du har {{count}} utkast som ikke er lastet opp enda. Du vil miste disse hvis du fortsetter. Er du sikker?",
    "mobile_message_draft_override_message": "Dette utkastet ble lagret fra en annen enhet på {{date}}, og endringene på denne enheten er i konflikt. Du kan velge å overstyre den eksisterende versjonen, eller laste den nyeste versjonen på ny, og endringene dine blir forkastet.",
    "mobile_html_submitting": "Sender inn …",
    "mobile_html_offline": "Du er for øyeblikket frakoblet!",
    "mobile_html_offline_try_again": "Du er for øyeblikket frakoblet. <br/><br/>Prøv igjen når du er tilkoblet",
    "mobile_html_something_went_wrong": "Oj, noe gikk galt.",
    "mobile_html_something_went_wrong_try_again": "Oj, noe gikk galt. Prøv igjen.",
    "mobile_html_failed_loading_roles": "Kunne ikke laste inn roller.",
    "mobile_alert_please_install_for_native": "Installer Ops Execution-appen for å bruke denne funksjonen. ",
    "mobile_alert_please_install_for_native_old": "Installer den originale Zenput-appen for å bruke denne funksjonen.",
    "mobile_tso_filter_all_tasks": "Alle {{type}}",
    "mobile_tso_filter_my_tasks": "Mine {{type}}",
    "mobile_tso_filter_due_date": "Forfallsdato",
    "mobile_tso_filter_date_completed": "Dato fullført",
    "mobile_tso_filter_completed": "Fullført",
    "mobile_tso_filter_completed_late": "Fullført for sent",
    "mobile_tso_filter_incomplete": "Ufullstendig",
    "mobile_tso_filter_var_my_tasks": "Mine {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} opprettet av meg",
    "mobile_tso_filter_var_all_tasks": "Alle {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Oppfølgingstiltak",
    "mobile_tso_type_all": "Oppgaver og oppfølgingstiltak",
    "mobile_tso_filter_var_at": " ved {{location}}",
    "mobile_tso_filter_group_date_due": ", bestilt etter forfallsdato",
    "mobile_tso_filter_group_distance": ", gruppert etter sted",
    "mobile_tso_filter_start_date": "Startdato",
    "mobile_tso_filter_none": "Ingen",
    "mobile_pso_filter_all_projects": "Alle prosjekter",
    "mobile_pso_filter_my_projects": "Mine prosjekter",
    "mobile_pso_filter_active": "Aktiv",
    "mobile_pso_filter_archived": "Arkivert",
    "mobile_pso_filter_recurring": "Periodisk",
    "mobile_pso_filter_non_recurring": "Engangstilfelle",
    "mobile_pso_filter_var_my_projects": "Mine {{project_type}} {{active_description}} prosjekter",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Prosjekter opprettet av meg",
    "mobile_pso_filter_var_all_projects": "Alle {{project_type}} {{active_description}} prosjekter",
    "mobile_empty_list_message_must_be_online": "Det ser ut til at du er frakoblet. Koble til for å se resultater.",
    "mobile_empty_list_message_no_submissions": "Ingen innsendinger",
    "mobile_empty_list_message_no_activity": "Ingen aktivitet",
    "mobile_empty_list_message_no_tasks": "Ingen oppgaver",
    "mobile_empty_list_message_no_tasks_overdue": "Ingen forfalte {{type}}",
    "mobile_empty_list_message_no_accounts": "Ingen steder",
    "mobile_empty_list_message_no_projects": "Ingen prosjekter",
    "mobile_empty_list_message_no_results_found": "Ingen resultater funnet",
    "mobile_empty_list_message_no_forms_available": "Ingen skjemaer tilgjengelig",
    "mobile_empty_list_message_connection_error": "Tilkoblingsfeil<br />Prøv igjen.",
    "mobile_empty_list_message_dashboard_error": "Kan ikke laste inn dashbordet",
    "mobile_empty_list_message_user_offline": "Du er for øyeblikket frakoblet",
    "mobile_action_sheet_media_gallery": "Galleri",
    "mobile_action_sheet_cancel": "Avbryt",
    "mobile_image_preview_text": "Fjern bilde",
    "mobile_mobileform_text": "Tidligere innsendinger",
    "mobile_mobileform_reorder_fields": "Endre rekkefølge på spørsmål",
    "mobile_mobileform_follow_up_actions": "Oppfølgingshandlinger",
    "mobile_mobileform_follow_up_actions_assign_title": "Tildel oppfølgingstiltak",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Legg til oppfølgingstiltak basert på observasjonene dine for å sikre at problemer blir tatt hånd om.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Legg til oppfølgingstiltak",
    "mobile_mobileform_follow_up_actions_assign_button": "Tildel oppfølginger",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Fortsett uten å tildele",
    "mobile_mobileform_follow_up_actions_dialog_title": "Vil du fortsette uten å tildele oppfølgingstiltak?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Hvis du fortsetter uten å tildele noen oppfølgingstiltak, vil du ikke kunne legge dem til senere.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Fortsett likevel",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Dette feltet er påkrevd",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "For mange tegn",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Dette feltet er ugyldig",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Feil ved innlasting av steder",
    "mobile_mobileform_add_follow_up_actions_error_users": "Feil ved innlasting av brukere",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Legg til oppfølging",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Tittel",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Beskrivelse",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Krev bilde",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Forfallsdato",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Oppdater oppfølging",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Vil du slette oppfølging?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Den vil bli fjernet og ikke tildelt.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Slett oppfølging",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Er du sikker på at du vil slette denne oppfølgingen?\n\nDette kan ikke angres.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Fortsett til oppfølginger",
    "mobile_mobileform_follow_up_actions_completed_notification": "Oppfølgingstiltak fullført",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Oppfølgingstiltak slettet",
    "mobile_mobileform_follow_up_actions_update_notification": "Oppfølgingstiltak oppdatert",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Legg til et bilde for å fullføre dette oppfølgingstiltaket",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Gå til innsending",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Gå til kilden",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Kilde",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Fullfør oppfølging",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Hvis du åpner innsendingen, vil eventuelle ulagrede bilder og notater gå tapt.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Hvis du lukker dette skjermbildet, vil alle ulagrede bilder og notater gå tapt.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Bli her",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Åpne innsending",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Åpne kilde",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Vil du forlate dette oppfølgingstiltaket?",
    "mobile_mobileform_follow_up_actions_submission": "Innsending",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Dette oppfølgingstiltaket er tildelt {{user}}.<br />Du kan ikke fullføre det.",
    "mobile_mobileform_follow_up_actions_leave_description": "Hvis du lukker dette skjermbildet, vil eventuelle ulagrede endringer gå tapt.",
    "mobile_mobileform_follow_up_actions_leave": "Lukk",
    "mobile_forms_drafts_text": "Fjern utkast",
    "mobile_batch_estimate_user": "Bruker",
    "mobile_batch_estimate_users": "Brukere",
    "mobile_table_of_contents": "Innholdsfortegnelse",
    "mobile_table_of_contents_required": "Påkrevd",
    "mobile_table_of_contents_optional": "Valgfritt",
    "mobile_dialog_alert_title": "Alarm",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth-enheter støttes ikke i Windows ennå",
    "mobile_windows_deprecated_message_content_announcement": "Kunngjøring",
    "mobile_windows_deprecated_message_title": "App-oppdatering kreves",
    "mobile_windows_deprecated_message_description": "Installer den nye Zenput-appen i Microsoft Store så fort som mulig for å sikre kritiske funksjonalitetsoppdateringer og en optimal Zenput-opplevelse.",
    "mobile_dashboard_tcr_graph_name": "Fullførelsesrate for oppgave",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Siste 4 uker",
    "mobile_dashboard_tcr_legend_company_average": "Gjennomsnitt for bedriften",
    "mobile_dashboard_tcr_legend_team_average": "Gjennomsnitt for teamet",
    "mobile_dashboard_tab_title_summary": "Oppsummering",
    "mobile_dashboard_tab_title_activity": "Aktivitet",
    "mobile_dashboard_card_title_top_triggered_workflows": "Beste triggere",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Samsvar",
    "mobile_dashboard_card_task_stats_total": "Totalt",
    "mobile_dashboard_top_item_header_week_of": "Uken",
    "mobile_dashboard_card_filter_form_template_placeholder": "Alle skjemaer",
    "mobile_dashboard_card_title_forms_top_nos": "Hyppige \"Nei\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "Det finnes ingen data for denne tidsperioden.",
    "mobile_dashboard_zenput_code_permission_denied": "Du har ikke tilgang til å se dette.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Velg et skjema fra listen over.",
    "mobile_dashboard_zenput_code_unknown_error": "Vi kan ikke vise data for øyeblikket.",
    "mobile_dashboard_tap_to_retry": "Trykk for å prøve på nytt",
    "mobile_dashboard_reporting_delay_disclaimer": "Det kan ta opptil 15 minutter å oppdatere oppgaver",
    "mobile_dashboard_configuration_down_state_postfix_msg": "er konfigurert av administratoren.",
    "mobile_tasks_tag": "oppgaver",
    "mobile_workflows_tag": "antall triggere",
    "mobile_projects_tag": "løpende prosjekter",
    "mobile_forms_tag": "skjemaer",
    "mobile_dashboard_card_ongoing_projects_title": "Ikke ferdigstilte prosjekter",
    "mobile_dashboard_card_ongoing_projects_show_more": "Vis mer",
    "mobile_dashboard_card_ongoing_projects_show_less": "Vis mindre",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Gå til prosjekter",
    "mobile_dashboard_card_title_recurring_projects": "Løpende prosjekter",
    "mobile_dashboard_card_filter_daily": "Daglig",
    "mobile_dashboard_card_filter_weekly": "Ukentlig",
    "mobile_dashboard_card_filter_monthly": "Månedlig",
    "mobile_task_status_title_open": "Åpent",
    "mobile_task_status_title_upcoming": "Kommende",
    "mobile_task_status_title_complete": "Fullført",
    "mobile_task_status_title_processing": "Innsendingen behandles",
    "mobile_task_status_title_complete_with_exceptions": "Fullfør med oppfølging eller alarmer",
    "mobile_task_status_title_completed_late_with_exceptions": "Fullført for sent med oppfølgingsoppgaver eller varsler",
    "mobile_task_status_title_incomplete_and_closed": "Ugjort",
    "mobile_tasks_legend_modal_title": "Tegnforklaring",
    "mobile_tasks_legend_modal_footer_button_title": "Lukk",
    "mobile_common_assigned_to": "Tilordnet",
    "mobile_common_created_by": "Opprettet av",
    "mobile_common_tasks_for": "Oppgaver for",
    "mobile_common_go_back": "Gå tilbake",
    "mobile_oh_no": "Å nei!",
    "mobile_user_not_in_groups": "Beklager, det ser ut til at du ikke er tilordnet et team. Ta kontakt med administratoren for å få tilgang til dashbordet.",
    "mobile_tasks_select_followers": "Velg følgere",
    "mobile_tasks_assign_tasks": "Tildele {{count}} oppgaver",
    "mobile_tasks_add_followers": "Legg til følgere",
    "mobile_tasks_followers": "Følgere",
    "mobile_tasks_delete_task": "Slett oppgave",
    "mobile_tasks_create_task": "Opprette oppgaver",
    "mobile_tasks_tab_title_comments": "Kommentarer",
    "mobile_tasks_see_more": "Se mer",
    "mobile_projects_create_project": "Opprette prosjekt",
    "mobile_common_button_send": "Send",
    "mobile_common_button_schedule": "Plan",
    "mobile_announcements_create": "Opprett kunngjøring",
    "mobile_announcements_read_rate": "{{opened_count}} av {{recipients_count}} åpnet",
    "mobile_announcements_empty_message": "Du har ikke opprettet noen kunngjøringer ennå! Opprett en kunngjøring nedenfor for å kringkaste viktige nyheter, informasjon og oppdateringer til organisasjonen din.",
    "mobile_announcement_message_placeholder": "Legg til en melding ...",
    "mobile_announcement_title_placeholder": "Kunngjøringens tittel",
    "mobile_announcement_leaving_announcement": "Forlater kunngjøring",
    "mobile_announcement_confirm_recipients_team": "Vil du kringkaste denne kunngjøringen til {{count}} bruker(e) i {{teams}} valgt(e) team?",
    "mobile_announcement_confirm_recipients_role": "Vil du kringkaste denne kunngjøringen til {{count}} bruker(e) i {{roles}} valgt(e) brukerrolle(r)?",
    "mobile_announcement_confirm_recipients_user": "Vil du kringkaste denne kunngjøringen til {{count}} bruker(e)?",
    "mobile_announcement_confirm_scheduled": "På {{timestamp}}",
    "mobile_announcement_sending_announcement": "Sender kunngjøring",
    "mobile_announcement_send_to": "Send til",
    "mobile_announcement_sent_to": "Sendt til",
    "mobile_announcement_send_to_role": "Rolle",
    "mobile_announcement_attachment_download": "Laster ned {{filename}}",
    "mobile_announcement_attachment_validation_error": "Ikke flere enn {{maxCount}} vedlegg kan legges til",
    "mobile_announcement_details_sent": "Sendt",
    "mobile_announcement_details_total_recipients": "Totalt antall mottakere",
    "mobile_announcement_details_cancel": "Avbryt kunngjøring",
    "mobile_announcement_details_not_editable": "Kunngjøringer kan bare redigeres i Ops Execution-nettappen. ",
    "mobile_announcement_details_not_editable_old": "Kunngjøringer kan bare redigeres i Zenput Web",
    "mobile_announcement_details_open_count": "Åpen telling",
    "mobile_announcement_details_open_rate": "Åpen verdi",
    "mobile_announcement_details_resend": "Send på nytt til ikke-åpnere",
    "mobile_announcement_confirm_resend": "{{count}} bruker(e) har ikke lest kunngjøringen. Vil du sende en påminnelse?",
    "mobile_announcement_confirm_resend_title": "Send påminnelse?",
    "mobile_announcement_recipients_opened": "Åpnet",
    "mobile_recipients_opened_empty_message": "Det ser ut til at ingen har åpnet meldingen din ennå. Kom tilbake senere for å se resultatene dine.",
    "mobile_announcement_recipients_unopened": "Uåpnet",
    "mobile_recipients_unopened_empty_message": "Gode nyheter! Det er ingen uåpnede meldinger!",
    "mobile_scheduled_announcements_delivery_section_header": "Leveringstid",
    "mobile_scheduled_announcements_send_immediately_label": "Send umiddelbart",
    "mobile_scheduled_announcements_scheduled_label": "Send på et spesifikt tidspunkt",
    "mobile_scheduled_announcements_scheduled_tab_label": "Planlagt",
    "mobile_scheduled_announcements_dialog_header": "Avbryte kunngjøring?",
    "mobile_scheduled_announcements_dialog_message": "Hvis du avbryter kunngjøringen, blir den ikke sendt, og slettet fra listen din. Dette kan ikke gjøres om. Gå til Zenput Web for å redigere.",
    "mobile_scheduled_announcements_empty_message": "Du har for tiden ingen planlagte kunngjøringer. Planlegg en kunngjøring for å kringkaste viktige nyheter, informasjon og oppdateringer til organisasjonen din.",
    "mobile_scheduled_announcements_validation_error": "Leveringstid må være etter {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Planlegg kunngjøring",
    "mobile_projects_auto_archive": "Autoarkivere",
    "mobile_common_unassigned": "Ikke tildelt",
    "mobile_tasks_title_placeholder": "Ny oppgave eller nytt skjema",
    "mobile_projects_leaving_project": "Forlater prosjektet",
    "mobile_projects_save_project": "Lagre prosjekt",
    "mobile_top_triggers_tasks": "Oftest utløste oppgaver",
    "mobile_top_triggers_alerts": "Oftest utløste varsler",
    "mobile_projects_not_started": "Ikke Startet",
    "mobile_empty_list_message_no_photos": "Ingen bilder",
    "mobile_webfilestore_message_error": "Velg en gyldig filtype",
    "mobile_notifications_empty_title": "Ingen varslinger",
    "mobile_notifications_empty_message": "Aktivitet på oppgavene dine eller oppgaver du er en del av, vises her.",
    "mobile_comments_comment_deleted": "Denne kommentaren er slettet.",
    "mobile_comments_comment_placeholder": "Kommentar",
    "mobile_comments_task_submitted_at": "Oppgave sendt {{ date }} kl. {{ time }}",
    "mobile_comments_discard_comment_title": "Vil du forkaste kommentaren?",
    "mobile_comments_discard_confirm_message": "Er du sikker? Kommentaren din blir slettet.",
    "mobile_comments_delete_comment_title": "Vil du slette kommentaren?",
    "mobile_comments_delete_confirm_message": "Dette kan ikke angres.",
    "mobile_comments_delete_button": "Slett kommentar",
    "mobile_comments_delete_success_message": "Kommentaren er slettet",
    "mobile_comments_empty_message_tasks": "Det er ingen kommentarer ennå \n Start en samtale på denne oppgaven.",
    "mobile_comments_empty_message_submissions": "Det er ingen kommentarer ennå \n Start en samtale på denne innsendingen.",
    "mobile_comments_empty_message_default": "Det er ingen kommentarer ennå \n Start en samtale.",
    "mobile_comments_no_matching_users": "Ingen brukere samsvarer.",
    "mobile_comments_empty_users_to_notify": "Det er ingen brukere å varsle.",
    "mobile_comments_users_cant_view_message": "Disse brukerne kan ikke se disse kommentarene",
    "mobile_comments_users_to_notify_title": "Brukere som skal varsles",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} bruker</a> blir varslet.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} brukere</a> blir varslet.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@nevn</a> flere brukere for å varsle dem.",
    "mobile_comments_mark_read": "Merk alle som lest",
    "mobile_comments_author_mentioned_message": "nevnte deg i",
    "mobile_comments_author_commented_message": "kommenterte",
    "mobile_view_pdf": "Vis PDF",
    "mobile_no_pdf_generated_message": "Fant ingen PDF for denne innsendingen. En kopi sendes til deg på e-post innen kort tid.",
    "mobile_clipboard_copied_success": "Koblingen er kopiert til utklippstavlen.",
    "mobile_share_link": "Del kobling",
    "mobile_zencam_share": "Del",
    "mobile_zencam_view_details": "Vis mer informasjon",
    "mobile_zencam_details_drawer_header": "Mer informasjon",
    "mobile_zencam_submitted_by": "Innsendt av",
    "mobile_zencam_form_title": "Skjematittel",
    "mobile_zencam_date_submitted": "Dato for innsending",
    "mobile_oil_quality_warning_message": "Olje nær utløpsdato",
    "mobile_oil_quality_warning_message_subtitle": "Vurder å skifte den snart",
    "mobile_oil_quality_failure_message": "Oljekvalitet kompromittert",
    "mobile_oil_quality_failure_message_subtitle": "Skift olje umiddelbart",
    "mobile_sensors_set_up_gateway": "Konfigurer gateway",
    "mobile_sensors_set_up_gateway_message": "Det ser ut som det ikke er konfigurert noen enheter.  Kom i gang ved å legge til en gateway.",
    "mobile_sensors_gateway_plugged_in": "Sørg for at gatewayen er koblet til et strømuttak.",
    "mobile_sensors_add_device": "Legg til enhet",
    "mobile_sensors_name_this_gateway": "Gi navn til denne gatewayen.",
    "mobile_sensors_name_this_sensor": "Gi navn til denne sensoren.",
    "mobile_sensors_device_barcode_information": "Skann QR-kode eller angi ID- og SC-nummer fra enhetens merkelapp",
    "mobile_sensors_device_eui_information": "Skann QR-kode eller angi DevEUI fra enhetens merkelapp",
    "mobile_sensors_gateway_id_information": "Skriv inn node-ID fra Gateway-etiketten",
    "mobile_sensors_id_number": "{{untranslatedID}} Nummer",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Kode",
    "mobile_sensors_sensors": "Sensorer",
    "mobile_sensors_sensor_deveui_error": "Kunne ikke hente DevEUI fra QR. Skriv den inn manuelt.",
    "mobile_sensors_gateways": "Gatewayer",
    "mobile_sensors_add_sensor": "Legg til sensor",
    "mobile_sensors_add_gateway": "Legg til gateway",
    "mobile_sensor_placement_description": "Hvilket område vil denne sensoren overvåke?",
    "mobile_sensors_equipment_placement": "Hvilket område eller utstyr vil denne sensoren overvåke?",
    "mobile_sensors_equipment": "Hvilket utstyr vil denne sensoren overvåke?",
    "mobile_sensors_select_gateway_type": "Velg gatewaytype",
    "mobile_sensors_select_placement": "Velg plassering",
    "mobile_sensors_select_equipment": "Velg utstyr",
    "mobile_sensors_placement": "Plassering",
    "mobile_sensors_nickname_tip": "Sensornavn bestemmes av kallenavnene som er tildelt i den valgte plasseringen.",
    "mobile_sensors_device_online": "Tilkoblet",
    "mobile_sensors_device_offline": "Frakoblet",
    "mobile_sensors_scan_qrcode": "Skann QR-kode",
    "mobile_sensors_enter_manually": "Skriv inn manuelt",
    "mobile_sensors_wizard_step_one": "Trinn 1",
    "mobile_sensors_wizard_step_two": "Trinn 2",
    "mobile_sensors_wizard_step_three": "Trinn 3",
    "mobile_sensors_wizard_step_four": "Trinn 4",
    "mobile_sensors_wizard_step_five": "Trinn 5",
    "mobile_sensors_wizard_step_six": "Trinn 6",
    "mobile_sensors_initializing": "Initierer …",
    "mobile_sensors_nickname": "Kallenavn",
    "mobile_sensors_field_not_blank": "{{field}} må fylles ut.",
    "mobile_sensors_nothing_to_see_here": "Ingenting å se her",
    "mobile_sensors_missing_integration": "Mangler sensorintegrering.",
    "mobile_sensors_contact_zenput_admin": "Ta kontakt med bedriftens Ops Execution-administrator.",
    "mobile_sensors_contact_zenput_admin_old": "Ta kontakt med Zenput-administratoren din.",
    "mobile_sensors_contact_manager": "Kontakt din kontoadministrator for å legge til sensorer.",
    "mobile_sensors_device_success_message": "Det kan ta opptil 15 minutter å laste inn sensordata",
    "mobile_sensors_last_reading": "Siste avlesning",
    "mobile_sensors_remove_device": "Fjern enhet",
    "mobile_sensors_one_day": "1 dag",
    "mobile_sensors_one_week": "1 uke",
    "mobile_sensors_one_month": "1 måned",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1 år",
    "mobile_sensors_sensor_settings": "Sensorinnstillinger",
    "mobile_sensors_remove_confirm_message": "Er du sikker på at du vil slette denne enheten?\nDette kan ikke angres.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Intet utstyr er koblet til",
    "mobile_sensor_cooldown_process": "Nedkjølingsprosess",
    "mobile_sensor_last_12_hours": "Siste 12 timer",
    "mobile_sensor_start_cooldown_process": "Start ny nedkjølingsprosess",
    "mobile_sensor_cooldown_process_title": "Nedkjølingsprosess i to trinn",
    "mobile_sensor_cooldown_process_description": "En totrinns nedkjølingsprosess består av avkjøling av mat fra mer enn {{ stage1_start_temperature }} til {{ stage1_end_temperature }} på to timer eller mindre, og deretter fra {{ stage1_end_temperature }} til {{ stage2_end_temperature }} på fire timer eller mindre.",
    "mobile_sensor_cooldown_process_place_food": "Legg matproduktet i kjøleskapet.",
    "mobile_sensor_cooldown_process_insert_sensor": "Sett inn en sensorsonde i matproduktet.",
    "mobile_sensor_cooldown_process_enter_information": "Skriv inn informasjonen nedenfor.",
    "mobile_sensor_cooldown_process_food_product": "Matproduktet som skal kjøles ned",
    "mobile_sensor_cooldown_cool_down": "Nedkjøling",
    "mobile_sensor_cooldown_select_sensor": "Velg sensor",
    "mobile_sensors_cooldown_start_cooldown": "Start nedkjøling",
    "mobile_sensors_cooldown_please_enter_food": "Skriv inn et matprodukt",
    "mobile_sensors_cooldown_please_select_sensor": "Velg en sensor",
    "mobile_sensors_cooldown_status_in_progress": "Under behandling",
    "mobile_sensors_cooldown_status_failed": "Mislykket",
    "mobile_sensors_cooldown_status_success": "Vellykket",
    "mobile_sensors_cooldown_stage": "Trinn",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Starttemperaturen er utenfor området",
    "mobile_sensors_cooldown_failed_cooldown_process": "Mislykket nedkjølingsprosess",
    "mobile_sensors_cooldown_cooldown_successful": "Nedkjøling vellykket",
    "mobile_sensors_cooldown_started_cooldown_process": "Start nedkjølingsprosess",
    "mobile_sensors_cooldown_hour": "time",
    "mobile_sensors_cooldown_hour_plural": "timer",
    "mobile_sensors_cooldown_minute": "minutt",
    "mobile_minutes_plural": "minutter",
    "mobile_sensors_last_reading_max_date": "> 1 år siden",
    "mobile_sensors_minute_count_ago": "{{count}} minutt siden",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minutter siden",
    "mobile_sensors_hour_count_ago": "{{count}} time siden",
    "mobile_sensors_hour_count_ago_plural": "{{count}} timer siden",
    "mobile_sensors_day_count_ago": "{{count}} dag siden",
    "mobile_sensors_day_count_ago_plural": "{{count}} dager siden",
    "mobile_sensors_chart_settings": "Diagraminnstillinger",
    "mobile_announcement_banner_continue_reading": "Fortsett å lese",
    "mobile_compliance_submissions_report": "Rapport for innsendinger",
    "mobile_compliance_submissions_report_subtitle": "Eksporter prosjektfullføringsdata for denne butikken",
    "mobile_compliance_send_submissions": "Send innsendinger",
    "mobile_compliance_completion_rate_in_last_days": "Andel fullført de siste {{ days }} dagene",
    "mobile_compliance_last_days": "Siste {{ days }} dager",
    "mobile_compliance_send_submissions_to": "Send innsendinger til",
    "mobile_compliance_send_to_different_email": "Send til en annen e-postadresse",
    "mobile_compliance_email_input_placeholder": "E-postadresse",
    "mobile_compliance_send_submissions_to_legend_title": "Innsendinger",
    "mobile_compliance_send_submissions_to_legend_description_days": "En rapport med innsendingene dine fra dette stedet de siste {{ days }} dagene blir sendt til den valgte e-postadressen.",
    "mobile_compliance_time_frame": "Tidsrom",
    "mobile_compliance_sensor_temperature_log_report": "Rapport for sensortemperaturlogg",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Eksporter temperaturlogger for denne butikken",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kriterier",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Definer kriteriene for rapporten nedenfor.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Merk: Deaktiverte sensorer vises ikke i rapporten",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Velg et tidsrom. Loggdata er begrenset til maksimum 30 dager",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Send rapport",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Denne måneden (1.-i dag)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Forrige måned",
    "mobile_compliance_sensor_temperature_log_email_title": "Send rapport til",
    "mobile_pwa_update_prompt_title": "Oppdater applikasjonen",
    "mobile_pwa_update_prompt_description": "En ny versjon av applikasjonen er tilgjengelig. Oppdater til den nyeste versjonen.",
    "mobile_pwa_update_prompt_confirm": "Oppdater og last inn på nytt",
    "mobile_pwa_update_prompt_cancel": "Påminn meg senere",
    "notification_title_due_in_one_hour": "Forfaller om 1 time",
    "task_is_due_soon": "«{{ task_title }}» forfaller snart. Ta et øyeblikk til å fullføre den.",
    "mobile_photo_quality_warning_header": "Problem med bildekvalitet",
    "mobile_photo_quality_dialog_message": "Dette bildet kan være for mørkt eller uskarpt. Vil du ta et nytt bilde, eller fortsette med dette?",
    "mobile_take_new_photo": "Ta et nytt bilde",
    "mobile_use_this_photo": "Bruk dette bildet"
}};
mobile_translations.ko_KR = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "모두",
    "mobile_common_button_apply_filters": "필터 적용",
    "mobile_common_button_done": "완료",
    "mobile_common_button_edit": "편집",
    "mobile_common_button_archive": "보관",
    "mobile_common_button_save": "저장",
    "mobile_common_button_retake": "다시 가져오기",
    "mobile_common_button_save_draft": "초안 저장",
    "mobile_common_button_discard": "폐기",
    "mobile_common_button_submit": "제출",
    "mobile_common_button_no": "아니요",
    "mobile_common_button_yes": "예",
    "mobile_common_button_na": "N/A",
    "mobile_common_created_by_me": "내가 만든 항목",
    "mobile_common_email": "회사 이메일",
    "mobile_common_first_name": "이름",
    "mobile_common_last_name": "성",
    "mobile_common_location": "위치",
    "mobile_common_locations": "위치",
    "mobile_common_logout_message": "로그아웃하시겠습니까?",
    "mobile_common_password": "암호",
    "mobile_common_permission_required": "권한 필요",
    "mobile_common_status": "상태",
    "mobile_common_task": "작업",
    "mobile_common_tasks": "작업",
    "mobile_common_tasks_my": "내 작업",
    "mobile_common_projects": "프로젝트",
    "mobile_common_filter_team": "팀",
    "mobile_common_filter_var_in": " {{team_or_location}} 이내",
    "mobile_common_filter_no_team_selected": "선택한 팀 없음",
    "mobile_common_filter_no_user_selected": "선택한 사용자 없음",
    "mobile_common_filter_no_role_selected": "선택한 역할 없음",
    "mobile_common_placeholder_date": "날짜",
    "mobile_common_message_task_creator_error_save": "<b>작업을 생성할 수 없습니다.</b>",
    "mobile_common_camera": "카메라",
    "mobile_common_microphone": "마이크",
    "mobile_common_for": "대상",
    "mobile_common_reload": "다시 불러오기",
    "mobile_common_override": "재정의",
    "mobile_common_notifications": "알림",
    "mobile_common_chat_unavailable": "채팅을 사용할 수 없습니다. 나중에 다시 시도하세요.",
    "mobile_common_chat_ending_dialog_title": "이제 이 대화는 끝내도 될까요?",
    "mobile_common_chat_ending_dialog_description": "문제가 해결되었거나 나중에 다시 진행하고 싶으시면 알려주세요.",
    "mobile_common_chat_ending_dialog_confirm": "예, 완료되었습니다",
    "mobile_common_chat_ending_dialog_cancel": "나중에 계속하겠습니다",
    "mobile_common_continue_editing": "계속 편집",
    "mobile_privacy_policy": "개인정보보호 정책",
    "wootric_recommend_target": "친구 또는 업계 동료",
    "wootric_followup_detractor_question": "다음에 더 높은 평점을 받으려면 저희가 어떤 점을 개선해야 할까요?",
    "wootric_followup_passive_question": "감사합니다! 도구를 향상하려면 어떤 점을 개선할 수 있을까요?",
    "wootric_followup_promoter_question": "감사합니다! Crunchtime Ops Execution에서 마음에 드는 점은 무엇인가요?",
    "wootric_followup_promoter_question_old": "감사합니다! Zenput에서 마음에 드는 점은 무엇인가요?",
    "wootric_default_followup_question": "감사합니다! 이유를 말해주실 수 있을까요?",
    "wootric_default_placeholder_text": "점수에 대한 이유를 설명해 주세요.",
    "wootric_default_thankyou_text": "답변과 피드백에 감사드립니다!",
    "mobile_login_placeholder_login_as": "사용자 ID로 로그인",
    "mobile_login_button_forgot_password": "암호를 잊으셨습니까?",
    "mobile_login_button_sign_up": "계정 생성",
    "mobile_login_button_finish_setup": "설치 마침",
    "mobile_login_button": "로그인",
    "mobile_login_continue_button": "계속",
    "mobile_login_continue_transition": "조직의 로그인 페이지로 이동 중...",
    "mobile_login_no_email_error": "이메일을 입력해야 합니다.",
    "mobile_login_change_email": "다른 이메일로 로그인",
    "mobile_login_with_sso": "SSO로 로그인",
    "mobile_oauth_no_user_error_message": "Crunchtime Ops Execution 계정이 없으신 것 같습니다!",
    "mobile_oauth_no_user_error_message_old": "Zenput 계정이 없는 것 같습니다!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b>, <b>Crunchtime Ops Execution</b>로 변경",
    "mobile_rebrand_warning_banner": "9월에 {{- brand }}이(가) {{- product }}(으)로 바뀔 예정입니다. {{- cta }}",
    "mobile_rebrand_warning_cta": "어떻게 준비해야 할지 자세히 알아보세요.",
    "mobile_oauth_no_user_error_sub_message": "관리자에게 액세스를 문의하거나 다른 이메일로 로그인을 시도하세요.",
    "mobile_oauth_generic_error_message": "로그인에 문제가 발생한 듯합니다. 다시 시도하세요.",
    "mobile_oauth_force_logout_msg": "문제가 계속되는 경우 공급자로부터 로그아웃하려면 ",
    "mobile_oauth_force_logout_click": "여기를 클릭하세요.",
    "mobile_sign_up_placeholder_phone": "휴대폰 번호",
    "mobile_sign_up_placeholder_password_confirm": "암호 확인",
    "mobile_sign_up_button_sign_in": "로그인",
    "mobile_sign_up_disclaimer_part_1": "계정을 생성함으로써",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "설치 마침을 클릭하면 다음에 동의하게 됩니다.",
    "mobile_sign_up_disclaimer_link_title": " 라이선스 계약",
    "mobile_sign_up_disclaimer_part_2": "에 동의하며, 이에 포함된 중요 개인정보보호 정보에도 동의합니다.",
    "mobile_dialog_benefits_work_offline": "오프라인 작업",
    "mobile_dialog_benefits_faster_uploads": "훨씬 더 빠른 업로드",
    "mobile_dialog_benefits_better_experience": "더 나은 경험",
    "mobile_dialog_benefits_button_download": "다운로드",
    "mobile_dialog_benefits_button_download_bold": "다음을 위한 Ops Execution ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput for ",
    "mobile_dialog_benefits_button_have": "앱이 있습니다!",
    "mobile_dialog_benefits_button_no_thanks": "나중에 확인",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "이미지를 불러올 수 없습니다.",
    "mobile_dialog_signature_sign": "여기에 서명",
    "mobile_dialog_signature_button_clear": "지우기",
    "mobile_account_placeholder_name": "위치/매장 이름",
    "mobile_account_placeholder_phone": "전화",
    "mobile_account_placeholder_address": "주소",
    "mobile_account_placeholder_city": "도시",
    "mobile_account_placeholder_region": "지역",
    "mobile_account_placeholder_zipcode": "우편번호",
    "mobile_account_option_select_country": "국가 선택",
    "mobile_account_oprion_us": "미국",
    "mobile_account_oprion_select_state": "주 선택",
    "mobile_account_button_create_location": "위치 생성",
    "mobile_form_message_no_form": "사용 가능한 양식 없음",
    "mobile_batch_task_message": "불러오는 중...",
    "mobile_settings_profile": "프로필",
    "mobile_settings_profile_number": "휴대폰",
    "mobile_settings_profile_language": "언어",
    "mobile_settings_profile_temperature_unit": "온도 단위",
    "mobile_settings_profile_use_company_default": "회사 기본값을 사용하세요",
    "mobile_settings_profile_celsius": "섭씨",
    "mobile_settings_profile_fahrenheit": "화씨",
    "mobile_settings_notifications_option_sms": "문자 메시지",
    "mobile_settings_notifications_option_push": "푸시 알림",
    "mobile_settings_notifications_option_push_email": "이메일 및 푸시 알림",
    "mobile_settings_notifications_option_do_not": "알림을 받지 않음",
    "mobile_settings_notifications_category_communication": "커뮤니케이션",
    "mobile_settings_notifications_category_forms_and_triggers": "양식 및 트리거",
    "mobile_settings_devices": "장치",
    "mobile_settings_notifications_sub_category_alerts": "경보",
    "mobile_settings_notifications_sub_category_new_forms_available": "새로운 양식 사용 가능",
    "mobile_settings_notifications_sub_category_task_assigned": "작업 할당됨",
    "mobile_settings_notifications_sub_category_task_completed": "작업 완료됨",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "작업 기한 임박 알림",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "기한 초과 작업 알림",
    "mobile_settings_notifications_sub_category_sensor_alerts": "센서 경보",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "중요 센서 경보",
    "mobile_drafts_message": "아직 초안이 없습니다.",
    "mobile_drafts_button_delete": "삭제",
    "mobile_tasks_filter_location_no": "선택한 위치 없음",
    "mobile_tasks_filter_group_by": "그룹 기준",
    "mobile_tasks_filter_sort_by": "정렬 기준",
    "mobile_tasks_filter_sorted_by": "정렬 기준",
    "mobile_tasks_filter_due_time": "기한 시간",
    "mobile_tasks_filter_open_time": "열린 시간",
    "mobile_tasks_bucket_due_next_24_hours": "24시간 후 만료",
    "mobile_tasks_bucket_due_next_7_days": "7일 후 만료",
    "mobile_tasks_bucket_open_tasks": "열려 있는 추가 {{type}}",
    "mobile_tasks_bucket_open_at": "열림: {{- date }} {{- time }}",
    "mobile_tasks_bucket_due_by_at": "만료: {{- date }} {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "1분 후 사용 가능",
    "mobile_tasks_bucket_available_in_one_hour": "1시간 후 사용 가능",
    "mobile_tasks_bucket_available_in_one_day": "1일 후 사용 가능",
    "mobile_tasks_bucket_available_in_one_week": "1주 후 사용 가능",
    "mobile_tasks_bucket_available_in_one_month": "1개월 후 사용 가능",
    "mobile_tasks_bucket_available_in_one_year": "1년 후 사용 가능",
    "mobile_tasks_bucket_available_in_minutes": "{{ minutes }}분 후 사용 가능",
    "mobile_tasks_bucket_available_in_hours": "{{ hours }}시간 후 사용 가능",
    "mobile_tasks_bucket_available_in_days": "{{ days }}일 후 사용 가능",
    "mobile_tasks_bucket_available_in_weeks": "{{ weeks }}주 후 사용 가능",
    "notification_task_due_in_minutes": "{{ minutes }}분 남음",
    "mobile_tasks_bucket_available_in_months": "{{ months }}개월 후 사용 가능",
    "mobile_tasks_bucket_available_in_years": "{{ years }}년 후 사용 가능",
    "mobile_tasks_follow_up": "팔로우 업 작업",
    "mobile_tasks_due_soon": "곧 마감 예정",
    "mobile_tasks_bucket_completed_today": "오늘 완료",
    "mobile_tasks_bucket_completed_this_week": "이번 주 완료",
    "mobile_tasks_bucket_completed_last_week": "지난주 완료",
    "mobile_tasks_bucket_missed_today": "오늘 누락",
    "mobile_tasks_bucket_missed_this_week": "이번 주 누락",
    "mobile_tasks_bucket_missed_last_week": "지난주 누락",
    "mobile_tasks_bucket_no_location": "위치 없음",
    "mobile_tasks_cannot_submit_missed": "누락된 작업은 완료할 수 없음",
    "mobile_tasks_cannot_submit_missed_after": "이 작업은 {{ date }} 이후 완료할 수 없음",
    "mobile_tasks_cannot_submit_upcoming": "이 작업은 시작되지 않았습니다.",
    "mobile_tasks_cannot_submit_processing": "이 제출은 처리 중임",
    "mobile_tasks_toolbarnav_header_no_due_date": "기한 없음",
    "mobile_tasks_toolbarnav_header_overdue": "기한 초과",
    "mobile_tasks_toolbarnav_header_yesterday": "어제",
    "mobile_tasks_toolbarnav_header_today": "오늘",
    "mobile_tasks_toolbarnav_header_tomorrow": "내일",
    "mobile_tasks_toolbarnav_header_last_week": "지난주",
    "mobile_tasks_toolbarnav_header_this_week": "이번 주",
    "mobile_tasks_toolbarnav_header_next_week": "다음 주",
    "mobile_tasks_toolbarnav_header_this_month": "이번 달",
    "mobile_tasks_toolbarnav_header_next_year": "내년",
    "mobile_tasks_toolbarnav_header_over_year": "1년 이상",
    "mobile_tasks_toolbarnav_title_edit_task": "작업 편집",
    "mobile_task_placeholder_title": "제목 *",
    "mobile_task_placeholder_description": "설명(선택 사항)",
    "mobile_task_button_single_task": "단일 작업",
    "mobile_task_button_project": "프로젝트",
    "mobile_task_button_create": "생성",
    "mobile_task_tab_basic": "기본",
    "mobile_task_tab_photo": "사진",
    "mobile_task_tab_form": "양식",
    "mobile_task_details_description_message_please": "아래에 ",
    "mobile_task_details_description_message_below": "입력하세요.",
    "mobile_task_details_description_message_instructions": "이 작업에 제공되는 지침은 없습니다.",
    "mobile_task_details_reason_title": "다음을 통해 발동된 후속 조치",
    "mobile_task_detials_button_goto_form": "양식으로 가기",
    "mobile_task_detials_button_complete": " 작업 완료",
    "mobile_task_detials_completed": "완료 ",
    "mobile_task_detials_completed_by": "주체 ",
    "mobile_task_detials_completed_on": "시기 ",
    "mobile_task_details_view_form_submission": "제출에서 보기",
    "mobile_task_task_updated": "작업 업데이트됨",
    "mobile_task_task_archived": "작업 보관됨",
    "mobile_task_task_deleted": "작업 삭제됨",
    "mobile_task_error_archiving_task": "작업을 보관할 수 없습니다.",
    "mobile_task_error_deleting_task": "작업을 삭제할 수 없습니다.",
    "mobile_task_error_updating_task": "작업을 업데이트할 수 없습니다.",
    "mobile_task_archive_task": "작업 보관",
    "mobile_task_archive_task_confirm": "이 작업을 보관하시겠습니까?\n\n보관된 작업은 완료율에 계산되고 보고에도 포함됩니다.\n\n이는 취소할 수 없습니다.",
    "mobile_task_delete_task_confirm": "이 작업을 삭제하시겠습니까?\n\n삭제된 작업은 완료율에 계산되고 보고에도 포함됩니다.\n\n이는 취소할 수 없습니다.",
    "mobile_task_edition_already_in_progress": "이 작업에는 보류 중인 수정 사항이 있습니다. 추가 편집이 현재 허용되지 않습니다.",
    "mobile_projects_filter_type": "유형",
    "mobile_projects_filter_status": "프로젝트 상태",
    "mobile_projects_filter_project_type": "프로젝트 유형",
    "mobile_projects_due_date_required": "기한이 필요합니다.",
    "mobile_projects_team_required": "팀이 필요합니다.",
    "mobile_projects_user_role_required": "할당 대상이 필요합니다.",
    "mobile_projects_title_required": "제목이 필요합니다.",
    "mobile_projects_recurring_multiple_tasks_per_day": "하루에 여러 건의 작업",
    "mobile_project_tasks_complete": " 완료",
    "mobile_project_tasks_remaining": " 잔여",
    "mobile_esitmate_message_tasks": "0개 작업이 생성됨",
    "mobile_esitmate_message_criteria": "상단 기준 조정",
    "mobile_esitmate_message_created_for": "생성 대상",
    "mobile_left_menu_dashboard": "대시보드",
    "mobile_left_menu_my_forms": "내 양식",
    "mobile_left_menu_announcements": "공지",
    "mobile_left_menu_my_submissions": "내 제출",
    "mobile_left_menu_drafts": "초안",
    "mobile_left_menu_pending_uploads": "보류 중인 업로드",
    "mobile_left_menu_open": "앱에서 열기",
    "mobile_left_menu_settings": "설정",
    "mobile_left_menu_log_out": "로그아웃",
    "mobile_left_menu_debug": "디버그",
    "mobile_left_menu_support": "지원",
    "mobile_left_menu_documentation": "문서화",
    "mobile_left_menu_chat": "채팅",
    "mobile_field_textarea_placeholder_note": "메모 또는 캡션",
    "mobile_field_option_select": "선택",
    "mobile_field_text_placeholder_text": "텍스트",
    "mobile_field_email_placehoder_email": "이메일",
    "mobile_filed_number_placeholder_number": "번호",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "연결되지 않음",
    "mobile_field_sensor_offline_battery": "센서 오프라인 - 배터리",
    "mobile_field_video_button_add": "비디오 추가",
    "mobile_field_video_picker_dialog_title": "다음 위치에서 비디오 추가",
    "mobile_field_video_button_change": "비디오 변경",
    "mobile_field_image_button_add": "이미지 추가",
    "mobile_field_image_low_quality_warning": "일부 사진이 너무 어둡거나 흐릴 수 있습니다. 강조 표시된 사진을 검토하고 필요할 경우 교체하세요.",
    "mobile_field_image_picker_dialog_title": "다음 위치에서 사진 추가",
    "mobile_field_image_picker_edit_failed": "이미지를 저장할 수 없습니다. 다시 시도하십시오.",
    "mobile_field_signature_button_add": "서명 추가",
    "mobile_field_signature_button_change": "서명 변경",
    "mobile_field_account_select_location": "A 위치 선택",
    "mobile_field_account_prefill": "지난 방문 데이터로 양식을 미리 작성하시겠습니까?",
    "mobile_field_account_message_overwrite": "이미 입력한 필드를 덮어쓰게 됩니다.",
    "mobile_forms_task_on_behalf": "이 위치에서 수행할 작업이 있으며, <b>{{user}}</b> 님에게 할당되어 있습니다. 이 작업을 완료하시겠습니까?",
    "mobile_forms_complete_task": "작업을 완료하시겠습니까?",
    "mobile_field_account_prefill_button_yes": "예, 미리 입력",
    "mobile_field_barcode_placeholder_scan": "바코드 스캔 또는 입력",
    "mobile_field_sensor_qr_code_placeholder_scan": "코드 스캔 또는 입력",
    "mobile_field_gateway_id_code_placeholder": "노드 ID 입력",
    "mobile_field_scan_qr_or_enter_dev_eui": "QR 코드 스캔 또는 DevEUI 입력",
    "mobile_field_scan_qr_or_enter_id": "QR 코드 스캔 또는 ID 번호 입력",
    "mobile_field_scan_qr_or_enter_sc": "QR 코드 스캔 또는 SC 코드 입력",
    "mobile_field_barcode_select_date": "날짜 선택 ",
    "mobile_field_datetime_allow_time": "시간",
    "mobile_field_stopwatch_button_caption": "스톱워치",
    "mobile_field_stopwatch_common_start": "시작",
    "mobile_field_stopwatch_common_stop": "정지",
    "mobile_field_stopwatch_common_reset": "재설정",
    "mobile_field_stopwatch_stop_stopwatches": "스톱워치 정지",
    "mobile_field_document_title": "문서 추가",
    "mobile_field_document_message_delete": "이 문서를 삭제하시겠습니까?",
    "mobile_field_document_alret_button_view": "보기",
    "mobile_field_document_alert_error": "이 서류를 첨부하는 데 오류가 발생했습니다. 나중에 다시 시도하세요.",
    "mobile_field_document_alert_file_size_error": "파일은 {{count}}MB를 초과할 수 없습니다.",
    "mobile_field_temperature_greater_range": "{{ temp_value }} °{{ temp_unit }} 초과",
    "mobile_field_temperature_greater_or_equal_range": "{{ temp_value }} °{{ temp_unit }} 이상",
    "mobile_field_temperature_less_range": "{{ temp_value }} °{{ temp_unit }} 미만",
    "mobile_field_temperature_less_or_equal_range": "{{ temp_value }} °{{ temp_unit }} 이하",
    "mobile_field_temperature_between_range": "{{ min_temp_value }} °{{ temp_unit }} 이상 및 {{ max_temp_value }} °{{ temp_unit }} 미만",
    "mobile_field_temperature_inclusive_between_range": "{{ min_temp_value }} °{{ temp_unit }} 이상 및 {{ max_temp_value }} °{{ temp_unit }} 이하",
    "mobile_field_temperature_operators_separator": " 그리고 ",
    "mobile_field_text_limit_error": "최대 글자 수 8,000자를 초과했습니다",
    "mobile_forms_required_questions_complete": "필수 완료",
    "mobile_forms_required_remaining": "남은 필수 필드 {{count}}개",
    "mobile_forms_required_questions_back": "뒤로",
    "mobile_forms_required_questions_next": "다음",
    "mobile_forms_required_questions_skip": "건너뛰기",
    "mobile_forms_leaving_form": "양식 나가기",
    "mobile_message_reordering_confirm": "새 질문 순서를 저장하시겠습니까?",
    "mobile_forms_leaving_reordering": "질문 순서 변경 종료",
    "mobile_forms_reordering_button_save": "새 질문 순서 저장",
    "mobile_forms_reordering_instructions": "질문 또는 섹션의 순서를 바꾸려면 양식에서 필드를 표시할 위치로 끌어 놓으십시오.",
    "mobile_toolbarnav_title_my_setttings": "내 설정",
    "mobile_toolbarnav_title_profile_settings": "프로필 설정",
    "mobile_toolbarnav_title_notification": "알림 설정",
    "mobile_toolbarnav_title_form_history": "양식 내역",
    "mobile_toolbarnav_title_form_not_available": "사용 가능한 양식 없음",
    "mobile_toolbarnav_title_add_location": "위치 추가",
    "mobile_toolbarnav_title_add_task_or_project": "작업 또는 프로젝트 추가",
    "mobile_toolbarnav_title_select_location": "위치 선택",
    "mobile_toolbarnav_title_select_project": "프로젝트 선택",
    "mobile_toolbarnav_title_select_tag": "태그 선택",
    "mobile_toolbarnav_title_select_user": "사용자 선택",
    "mobile_toolbarnav_title_select_template": "템플릿 선택",
    "mobile_toolbarnav_title_select_one": "1개 선택",
    "mobile_toolbarnav_title_select_multiple": "1개 이상 선택",
    "mobile_toolbarnav_title_select_team": "팀 선택",
    "mobile_toolbarnav_title_select_team_or_location": "팀 또는 위치 선택",
    "mobile_toolbarnav_title_filter_tasks": "작업 필터링",
    "mobile_toolbarnav_title_filter_projects": "프로젝트 필터링",
    "mobile_toolbarnav_title_filter_project_tasks": "프로젝트 작업 필터링",
    "mobile_placeholder_search_bar": "검색",
    "mobile_placeholder_user_select_role": "사용자 역할 선택",
    "mobile_placeholder_filter_by_team": "팀별로 필터링",
    "mobile_placeholder_assign_to_user_role": "사용자 역할에 할당",
    "mobile_placeholder_select": "-- 선택 --",
    "mobile_placeholder_account_location_name": "위치 이름",
    "mobile_placeholder_tag_filter_by": "위치 태그별로 필터링",
    "mobile_placeholder_user_type": "사용자에게 할당",
    "mobile_placeholder_acount_type_loading": "불러오는 중... ",
    "mobile_placeholder_therm_no_bluetooth": "온도",
    "mobile_placeholder_blue_therm_connecting": "장치에 연결하는 중...",
    "mobile_placeholder_blue_therm_please_wait": "기다려 주세요...",
    "mobile_placeholder_blue_therm_tap": "탭하여 읽으세요.",
    "mobile_placeholder_blue_therm_not_connected": "연결되지 않았습니다.",
    "mobile_placeholder_testo_tap": "⬆ 이후 ▼▲ 길게 누르기",
    "mobile_message_error_create_task": "작업을 추가하려면 온라인 상태여야 합니다.",
    "mobile_message_error_fill_out_form": "양식을 입력하세요.",
    "mobile_message_error_fill_require_fields": "필수 필드를 입력하세요.",
    "mobile_message_error_stop_stopwatch_before_submit": "제출 전에 스톱워치 정지",
    "mobile_message_error_stopwatch_field_required": "스톱워치 필드가 필요함",
    "mobile_message_error_stopwatch_field_running": "스톱워치 필드가 실행 중",
    "mobile_message_error_invalid_equipment_temperature": "잘못된 장비 온도",
    "mobile_message_error_invalid_ingredient_temperature": "잘못된 성분 온도",
    "mobile_message_error_location_attributes_unavailable": "일부 질문을 사용할 수 없습니다. 인터넷에 연결하세요.",
    "mobile_message_alert_running_stopwatches": "실행 중인 스톱워치가 있습니다.\n\n삭제하시겠습니까?",
    "mobile_message_blue_therm_error": "Bluetooth 장치 연결 해제됨",
    "mobile_message_blue_therm_no_permission_android_pre_12": "위치 액세스 권한이 필요합니다. Android 설정에서 이 기능을 활성화하세요.",
    "mobile_message_blue_therm_no_permission_android": "주변 기기 액세스 권한이 필요합니다. Android 설정에서 이 기능을 활성화하세요.",
    "mobile_message_blue_therm_error_code": "연결 실패:",
    "mobile_message_blue_therm_error_bluetooth": "Bluetooth를 활성화하세요.",
    "mobile_message_blue_therm_error_device": "장치가 없습니다.",
    "mobile_message_blue_therm_error_try_again": "다시 시도하세요.",
    "mobile_message_blue_therm_success": "Bluetooth 장치가 연결되었습니다!",
    "mobile_message_bluetooth_device_press_button_field": "장치의 버튼을 눌러 연결하세요.",
    "mobile_message_bluetooth_device_press_button_devices_list": "여기에 나열되지 않은 경우<br />장치에서 버튼을 누르세요.",
    "mobile_bluetooth_scan": "스캔",
    "mobile_bluetooth_scanning": "스캔 중",
    "mobile_message_drafts_confirm": "이를 초안으로 저장하시겠습니까?",
    "mobile_message_drafts_toast_saved": "초안이 저장되었습니다.",
    "mobile_message_drafts_request_update": "이 초안을 업데이트하시겠습니까?",
    "mobile_message_drafts_form_confirm": "이 초안을 삭제하시겠습니까?",
    "mobile_message_drafts_confirm_delete": "초안 삭제",
    "mobile_message_streams_error_switch": "웹에서 스트림을 변경할 수 없음",
    "mobile_message_settings_success_saved": "설정 저장됨",
    "mobile_message_settings_error": "알 수 없는 오류가 발생했습니다. 나중에 다시 시도하세요.",
    "mobile_message_profile_settings_error_fields": "강조 표시된 필드를 수정하세요.",
    "mobile_message_media_perimission_denied": "사용자의 ",
    "mobile_message_media_perimission_denied_device": "장치 저장소",
    "mobile_message_image_confirm_remove_image": "이 사진을 삭제하시겠습니까?",
    "mobile_message_create_account_error_fields": "강조 표시된 필드를 입력하세요.",
    "mobile_message_create_account_success_location_created": "위치 생성됨",
    "mobile_message_task_error_get_location": "위치를 가져올 수 없습니다. 날짜별로 정렬합니다.",
    "mobile_message_typehead_confirm_save_message": "이 선택 사항을 저장하시겠습니까?",
    "mobile_message_typehead_confirm_save_title": "저장하시겠습니까?",
    "mobile_message_task_creator_error_save_select_form": "양식을 선택해야 합니다.",
    "mobile_message_task_creator_error_save_required_fields": "필수 필드를 입력하세요.",
    "mobile_message_task_creator_error_save_batch_change": "하나 이상의 사용자와 일치하도록 기준을 변경하세요.",
    "mobile_message_task_detials_error_not_assigned_to_you": "이 작업이 할당되지 않았습니다.<br />작업을 완료할 수 없습니다.",
    "mobile_message_task_detials_error_assigned_to": "이 작업이 {{user}} 님에게 할당되었습니다.<br />작업을 완료할 수 없습니다.",
    "mobile_message_task_detials_confirm_title": "작업 나가기",
    "mobile_message_task_detials_confirm_save_task": "작업 저장",
    "mobile_message_task_detials_confirm_message": "계속하시겠습니까? 변경 사항이 손실됩니다.",
    "mobile_message_task_detials_error_view_account": "위치에 액세스할 수 없습니다.",
    "mobile_message_task_detials_error_submit_task": "사진을 추가하여 이 작업을 완료하세요.",
    "mobile_message_task_detials_error_submit_task_project": "프로젝트를 저장할 수 없습니다. 나중에 다시 시도하세요.",
    "mobile_message_task_detials_wait_submit_task_created": "작업이 생성되는 중입니다.<br />작업이 입력될 때까지 몇 분 정도 소요됩니다.",
    "mobile_message_task_detials_error_submit_task_pending": "오류 발생. 나중에 다시 시도하세요.",
    "mobile_message_task_detials_success_task_complete": "작업 완료",
    "mobile_message_task_error_save_single_task": "작업을 저장할 수 없습니다. 나중에 다시 시도하세요.",
    "mobile_message_task_success_save_single_task": "작업이 생성되었습니다.",
    "mobile_message_show_error_message": "문제가 발생했습니다.",
    "mobile_message_show_success_message": "성공!",
    "mobile_message_show_offline_message": "현재 오프라인 상태입니다.",
    "mobile_message_show_permission_denied_message": "<b>권한이 필요합니다.</b> Zenput에 {{permission_name}} 액세스 권한을 부여하세요.",
    "mobile_message_show_permission_denied_message_web": "<b>권한이 필요합니다.</b> Zenput 및 브라우저에 {{permission_name}} 액세스 권한을 부여하세요.",
    "mobile_message_show_begin_uploading_message": "현재 업로드 중",
    "mobile_message_show_upload_in_progress_message": "업로드가 이미 진행 중임",
    "mobile_message_show_form_id_error": "지정된 양식에 액세스할 수 없습니다.",
    "mobile_message_show_single_task_error": "지정된 작업에 액세스할 수 없습니다.",
    "mobile_message_show_submissions_error": "지정된 제출에 액세스할 수 없습니다.",
    "mobile_message_show_submissions_access_denied": "죄송합니다. 이 양식에 액세스할 수 없습니다.",
    "mobile_message_send_data_success": "데이터 업로드됨 ",
    "mobile_message_start_upload_success": "업로드 완료",
    "mobile_message_start_upload_error": "<b>업로드를 완료할 수 없습니다.</b><br>제출이 저장됩니다. 나중에 다시 시도하세요.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "업데이트 사용 가능",
    "mobile_message_store_upgrade_confirm_message_one": "다음에서 Ops Execution 앱을 업데이트하세요. ",
    "mobile_message_store_upgrade_confirm_message_one_old": "다음으로부터 Zenput 업데이트 ",
    "mobile_message_store_upgrade_confirm_message_two": " 모든 최신 기능과 버그 수정 확인",
    "mobile_message_store_upgrade_confirm_now": "지금",
    "mobile_message_store_upgrade_confirm_later": "나중에",
    "mobile_message_redirect_confirm_message": "현재 양식을 작성하는 중입니다. 계속하기 전에 초안으로 저장하시겠습니까?",
    "mobile_message_log_out_confirm_unsynced_drafts": "아직 업로드되지 않은 초안 {{count}}개가 있습니다. 계속 진행하는 경우 초안이 손실됩니다. 계속하시겠습니까?",
    "mobile_message_draft_override_message": "이 초안은 {{date}}에 다른 장치에서 저장되었으며, 이 장치의 변경 사항이 충돌됩니다. 기존 버전을 재정의하거나 최신 버전을 다시 불러올 수 있으며, 변경 사항은 폐기됩니다.",
    "mobile_html_submitting": "제출하는 중...",
    "mobile_html_offline": "현재 오프라인 상태입니다!",
    "mobile_html_offline_try_again": "현재 오프라인 상태입니다. <br/><br/>연결되면 다시 시도하세요.",
    "mobile_html_something_went_wrong": "문제가 발생했습니다.",
    "mobile_html_something_went_wrong_try_again": "문제가 발생했습니다. 다시 시도하세요.",
    "mobile_html_failed_loading_roles": "역할을 불러올 수 없습니다.",
    "mobile_alert_please_install_for_native": "이 기능을 사용하려면 Ops Execution 앱을 설치하세요. ",
    "mobile_alert_please_install_for_native_old": "이 기능을 사용하려면 기본 Zenput 앱을 설치하세요.",
    "mobile_tso_filter_all_tasks": "모든 {{type}}",
    "mobile_tso_filter_my_tasks": "내 {{type}}",
    "mobile_tso_filter_due_date": "기한",
    "mobile_tso_filter_date_completed": "완료 날짜",
    "mobile_tso_filter_completed": "완료",
    "mobile_tso_filter_completed_late": "늦게 완료",
    "mobile_tso_filter_incomplete": "미완료",
    "mobile_tso_filter_var_my_tasks": "내 {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "내가 만든 {{filter_type}} {{type}}",
    "mobile_tso_filter_var_all_tasks": "모든 {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "팔로우 업 조치",
    "mobile_tso_type_all": "작업과 팔로우 업 조치",
    "mobile_tso_filter_var_at": " {{location}}에서",
    "mobile_tso_filter_group_date_due": "기한에 따라 정렬",
    "mobile_tso_filter_group_distance": "위치에 따라 그룹화",
    "mobile_tso_filter_start_date": "시작 날짜",
    "mobile_tso_filter_none": "없음",
    "mobile_pso_filter_all_projects": "모든 프로젝트",
    "mobile_pso_filter_my_projects": "내 프로젝트",
    "mobile_pso_filter_active": "활성",
    "mobile_pso_filter_archived": "보관됨",
    "mobile_pso_filter_recurring": "반복",
    "mobile_pso_filter_non_recurring": "반복하지 않음",
    "mobile_pso_filter_var_my_projects": "내 {{project_type}} {{active_description}} 프로젝트",
    "mobile_pso_filter_var_my_created_projects": "내가 만든 프로젝트 {{project_type}} {{active_description}}개",
    "mobile_pso_filter_var_all_projects": "모든 {{project_type}} {{active_description}} 프로젝트",
    "mobile_empty_list_message_must_be_online": "오프라인 상태인 듯합니다. 온라인으로 전환해 결과를 확인하세요.",
    "mobile_empty_list_message_no_submissions": "제출 없음",
    "mobile_empty_list_message_no_activity": "활동 없음",
    "mobile_empty_list_message_no_tasks": "작업 없음",
    "mobile_empty_list_message_no_tasks_overdue": "기한 초과 {{type}} 없음",
    "mobile_empty_list_message_no_accounts": "위치 없음",
    "mobile_empty_list_message_no_projects": "프로젝트 없음",
    "mobile_empty_list_message_no_results_found": "검색 결과 없음",
    "mobile_empty_list_message_no_forms_available": "사용 가능한 양식 없음",
    "mobile_empty_list_message_connection_error": "연결 오류<br />다시 시도하세요.",
    "mobile_empty_list_message_dashboard_error": "대시보드를 불러올 수 없음",
    "mobile_empty_list_message_user_offline": "현재 오프라인 상태임",
    "mobile_action_sheet_media_gallery": "갤러리",
    "mobile_action_sheet_cancel": "취소",
    "mobile_image_preview_text": "사진 제거",
    "mobile_mobileform_text": "이전 제출",
    "mobile_mobileform_reorder_fields": "질문 순서 변경",
    "mobile_mobileform_follow_up_actions": "후속 조치",
    "mobile_mobileform_follow_up_actions_assign_title": "팔로우 업 조치 배정",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "문제를 해결할 수 있도록 관찰 결과를 바탕으로 팔로우 업 조치를 추가합니다.",
    "mobile_mobileform_follow_up_actions_add_button": "+ 팔로우 업 조치 추가",
    "mobile_mobileform_follow_up_actions_assign_button": "팔로우 업 배정",
    "mobile_mobileform_follow_up_actions_without_assign_button": "배정 없이 계속",
    "mobile_mobileform_follow_up_actions_dialog_title": "팔로우 업 조치를 배정하지 않고 계속하시겠습니까?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "팔로우 업 조치를 배정하지 않고 계속하면, 이후에는 추가할 수 없습니다.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "계속하기",
    "mobile_mobileform_add_follow_up_actions_forms_required": "필수 필드입니다.",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "너무 깁니다.",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "잘못된 필드입니다.",
    "mobile_mobileform_add_follow_up_actions_error_locations": "위치를 불러오는 중 오류 발생",
    "mobile_mobileform_add_follow_up_actions_error_users": "사용자를 불러오는 중 오류 발생",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "팔로우 업 추가",
    "mobile_mobileform_add_follow_up_actions_forms_title": "제목",
    "mobile_mobileform_add_follow_up_actions_forms_description": "설명",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "사진 필요",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "만기일",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "팔로우 업 업데이트",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "팔로우 업을 삭제하시겠습니까?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "팔로우 업이 제거되고 배정되지 않습니다.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "팔로우 업 삭제",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "이 팔로우 업을 삭제하시겠습니까?\n\n이 작업은 취소할 수 없습니다.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "팔로우 업으로 계속 진행",
    "mobile_mobileform_follow_up_actions_completed_notification": "팔로우 업 조치 완료됨",
    "mobile_mobileform_follow_up_actions_deleted_notification": "팔로우 업 조치 삭제됨",
    "mobile_mobileform_follow_up_actions_update_notification": "팔로우 업 조치 업데이트됨",
    "mobile_mobileform_follow_up_actions_required_photo_error": "사진을 추가하여 이 팔로우 업 작업을 완료하세요.",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "제출로 이동",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "소스로 이동",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "소스",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "팔로우 업 완료",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "제출을 열면 저장되지 않은 사진과 메모가 모두 사라집니다.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "이 화면을 벗어나면 저장되지 않은 사진과 메모가 모두 사라집니다.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "이동 안 함",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "제출 열기",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "오픈 소스",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "이 팔로우 업 조치에서 나가시겠습니까?",
    "mobile_mobileform_follow_up_actions_submission": "제출",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "이 팔로우 업 조치는 {{user}} 님에게 배정되었습니다.<br />조치를 완료할 수 없습니다.",
    "mobile_mobileform_follow_up_actions_leave_description": "이 화면을 벗어나면 저장되지 않은 변경 내용이 모두 사라집니다.",
    "mobile_mobileform_follow_up_actions_leave": "나가기",
    "mobile_forms_drafts_text": "초안 제거",
    "mobile_batch_estimate_user": "사용자",
    "mobile_batch_estimate_users": "사용자",
    "mobile_table_of_contents": "목차",
    "mobile_table_of_contents_required": "필수 사항",
    "mobile_table_of_contents_optional": "선택 사항",
    "mobile_dialog_alert_title": "경보",
    "mobile_dialog_alert_ok": "확인",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth 장치가 아직 Windows에서 지원되지 않음",
    "mobile_windows_deprecated_message_content_announcement": "알림",
    "mobile_windows_deprecated_message_title": "앱 업데이트 필요",
    "mobile_windows_deprecated_message_description": "최대한 빠른 시일 내에 Microsoft Store에서 새 Zenput 앱을 설치해 중요 기능 업데이트를 적용하고 최적의 Zenput 경험을 구현하세요.",
    "mobile_dashboard_tcr_graph_name": "작업 완료율",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "지난 4주",
    "mobile_dashboard_tcr_legend_company_average": "회사 평균",
    "mobile_dashboard_tcr_legend_team_average": "팀 평균",
    "mobile_dashboard_tab_title_summary": "요약",
    "mobile_dashboard_tab_title_activity": "활동",
    "mobile_dashboard_card_title_top_triggered_workflows": "최상위 발동",
    "mobile_dashboard_tab_title_info": "정보",
    "mobile_dashboard_tab_project_audit": "규정 준수",
    "mobile_dashboard_card_task_stats_total": "합계",
    "mobile_dashboard_top_item_header_week_of": "주",
    "mobile_dashboard_card_filter_form_template_placeholder": "모든 양식",
    "mobile_dashboard_card_title_forms_top_nos": "빈번한 \"아니요\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "이 시간 범위에 데이터가 없습니다.",
    "mobile_dashboard_zenput_code_permission_denied": "이를 볼 수 있는 권한이 없습니다.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "위에서 양식을 선택하세요.",
    "mobile_dashboard_zenput_code_unknown_error": "지금은 이 데이터를 표시할 수 없습니다.",
    "mobile_dashboard_tap_to_retry": "탭하여 다시 시도",
    "mobile_dashboard_reporting_delay_disclaimer": "작업 업데이트는 최대 15분이 소요될 수 있습니다.",
    "mobile_dashboard_configuration_down_state_postfix_msg": "이(가) 관리자에 의해 구성되었습니다.",
    "mobile_tasks_tag": "작업",
    "mobile_workflows_tag": "발동",
    "mobile_projects_tag": "반복 프로젝트",
    "mobile_forms_tag": "양식",
    "mobile_dashboard_card_ongoing_projects_title": "진행 중인 프로젝트",
    "mobile_dashboard_card_ongoing_projects_show_more": "더 많이 표시",
    "mobile_dashboard_card_ongoing_projects_show_less": "더 적게 표시",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "프로젝트로 가기",
    "mobile_dashboard_card_title_recurring_projects": "반복 프로젝트",
    "mobile_dashboard_card_filter_daily": "일간",
    "mobile_dashboard_card_filter_weekly": "주간",
    "mobile_dashboard_card_filter_monthly": "월간",
    "mobile_task_status_title_open": "열기",
    "mobile_task_status_title_upcoming": "예정",
    "mobile_task_status_title_complete": "완료",
    "mobile_task_status_title_processing": "제출 처리 중",
    "mobile_task_status_title_complete_with_exceptions": "후속 작업 또는 경보로 완료",
    "mobile_task_status_title_completed_late_with_exceptions": "늦게 완료되었으며 후속 조치 또는 알림 필요",
    "mobile_task_status_title_incomplete_and_closed": "누락됨",
    "mobile_tasks_legend_modal_title": "범례",
    "mobile_tasks_legend_modal_footer_button_title": "닫기",
    "mobile_common_assigned_to": "할당 대상",
    "mobile_common_created_by": "만든 사람",
    "mobile_common_tasks_for": "작업 대상",
    "mobile_common_go_back": "뒤로",
    "mobile_oh_no": "이런!",
    "mobile_user_not_in_groups": "죄송합니다. 팀으로 할당되지 않은 것 같습니다. 관리자에게 문의하여 대시보드 액세스를 요청하세요.",
    "mobile_tasks_select_followers": "팔로워 선택",
    "mobile_tasks_assign_tasks": "{{count}}개의 작업 할당",
    "mobile_tasks_add_followers": "팔로워 추가",
    "mobile_tasks_followers": "팔로워",
    "mobile_tasks_delete_task": "작업 삭제",
    "mobile_tasks_create_task": "작업 생성",
    "mobile_tasks_tab_title_comments": "의견",
    "mobile_tasks_see_more": "더 보기",
    "mobile_projects_create_project": "프로젝트 생성",
    "mobile_common_button_send": "전송",
    "mobile_common_button_schedule": "일정",
    "mobile_announcements_create": "공지 생성",
    "mobile_announcements_read_rate": "{{opened_count}}/{{recipients_count}}개 열림",
    "mobile_announcements_empty_message": "아직 공지를 생성하지 않았습니다! 아래에 공지를 만들고 조직에 대한 중요한 소식, 정보 및 업데이트 사항을 공유하세요.",
    "mobile_announcement_message_placeholder": "메시지 추가...",
    "mobile_announcement_title_placeholder": "공지 제목",
    "mobile_announcement_leaving_announcement": "공지 나가기",
    "mobile_announcement_confirm_recipients_team": "선택한 {{teams}} 팀에 속한 사용자 {{count}}명과 이 공지를 공유하시겠습니까?",
    "mobile_announcement_confirm_recipients_role": "선택한 사용자 역할 {{roles}}에 속한 사용자 {{count}}명과 이 공지를 공유하시겠습니까?",
    "mobile_announcement_confirm_recipients_user": "사용자 {{count}}명과 이 공지를 공유하시겠습니까?",
    "mobile_announcement_confirm_scheduled": "{{timestamp}} 시기",
    "mobile_announcement_sending_announcement": "공지 전송",
    "mobile_announcement_send_to": "다음으로 전송",
    "mobile_announcement_sent_to": "전송됨",
    "mobile_announcement_send_to_role": "역할",
    "mobile_announcement_attachment_download": "{{filename}} 다운로드 중",
    "mobile_announcement_attachment_validation_error": "첨부 파일은 {{maxCount}}개까지 추가할 수 있습니다.",
    "mobile_announcement_details_sent": "전송됨",
    "mobile_announcement_details_total_recipients": "총 수신자",
    "mobile_announcement_details_cancel": "공지 취소",
    "mobile_announcement_details_not_editable": "알림은 Ops Execution 웹 앱에서만 편집할 수 있습니다. ",
    "mobile_announcement_details_not_editable_old": "공지는 Zenput 웹에서만 편집할 수 있습니다.",
    "mobile_announcement_details_open_count": "열린 횟수",
    "mobile_announcement_details_open_rate": "열린 비율",
    "mobile_announcement_details_resend": "열지 않은 사람에게 재전송",
    "mobile_announcement_confirm_resend": "{{count}}명의 사용자가 공지를 읽지 않았습니다. 알림을 보내시겠습니까?",
    "mobile_announcement_confirm_resend_title": "알림을 보내시겠습니까?",
    "mobile_announcement_recipients_opened": "열림",
    "mobile_recipients_opened_empty_message": "아무도 메시지를 열지 않은 듯합니다. 나중에 다시 결과를 확인하세요.",
    "mobile_announcement_recipients_unopened": "열지 않음",
    "mobile_recipients_unopened_empty_message": "좋은 소식입니다! 열지 않은 메시지가 없습니다!",
    "mobile_scheduled_announcements_delivery_section_header": "납품 시간",
    "mobile_scheduled_announcements_send_immediately_label": "즉시 전송",
    "mobile_scheduled_announcements_scheduled_label": "특정 시간에 전송",
    "mobile_scheduled_announcements_scheduled_tab_label": "예약됨",
    "mobile_scheduled_announcements_dialog_header": "공지를 취소하시겠습니까?",
    "mobile_scheduled_announcements_dialog_message": "공지를 취소하면 전송이 중단되고 목록에서 제거됩니다. 이는 취소할 수 없습니다. 편집하려면 Zenput Web으로 이동하세요.",
    "mobile_scheduled_announcements_empty_message": "현재 예약된 공지가 없습니다. 공지를 예약하여 조직에 대한 중요한 소식, 정보 및 업데이트 사항을 공유하세요.",
    "mobile_scheduled_announcements_validation_error": "납품 시간은 {{date}} 이후여야 함",
    "mobile_scheduled_announcements_empty_state_button": "일정 공지",
    "mobile_projects_auto_archive": "자동 보관",
    "mobile_common_unassigned": "할당되지 않음",
    "mobile_tasks_title_placeholder": "새 작업 또는 양식",
    "mobile_projects_leaving_project": "프로젝트 나가기",
    "mobile_projects_save_project": "프로젝트 저장",
    "mobile_top_triggers_tasks": "최상위 발동 작업",
    "mobile_top_triggers_alerts": "최상위 발동 경보",
    "mobile_projects_not_started": "시작되지 않음",
    "mobile_empty_list_message_no_photos": "사진 없음",
    "mobile_webfilestore_message_error": "유효한 파일 형식을 선택하세요.",
    "mobile_notifications_empty_title": "알림 없음",
    "mobile_notifications_empty_message": "속한 작업의 활동이 여기에 표시됩니다.",
    "mobile_comments_comment_deleted": "이 의견은 삭제되었습니다.",
    "mobile_comments_comment_placeholder": "의견",
    "mobile_comments_task_submitted_at": "{{ date }}, {{ time }}에 제출된 작업",
    "mobile_comments_discard_comment_title": "의견을 폐기하시겠습니까?",
    "mobile_comments_discard_confirm_message": "확실합니까? 의견이 삭제됩니다.",
    "mobile_comments_delete_comment_title": "의견을 삭제하시겠습니까?",
    "mobile_comments_delete_confirm_message": "이는 취소할 수 없습니다.",
    "mobile_comments_delete_button": "의견 삭제",
    "mobile_comments_delete_success_message": "의견 삭제됨",
    "mobile_comments_empty_message_tasks": "아직 의견이 없음 \n 이 작업에 관한 대화를 시작하세요.",
    "mobile_comments_empty_message_submissions": "아직 의견이 없음 \n 이 제출에 관한 대화를 시작하세요.",
    "mobile_comments_empty_message_default": "아직 의견이 없음 \n 대화를 시작하세요.",
    "mobile_comments_no_matching_users": "일치하는 사용자가 없습니다.",
    "mobile_comments_empty_users_to_notify": "알림을 보낼 사용자가 없습니다.",
    "mobile_comments_users_cant_view_message": "이 사용자는 이 의견을 볼 수 없습니다.",
    "mobile_comments_users_to_notify_title": "알림을 보낼 사용자",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }}명의 사용자</a>에게 알림이 전달됩니다.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }}명의 사용자</a>에게 알림이 전달됩니다.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a>으로 더 많은 사용자에게 알림을 보내세요.",
    "mobile_comments_mark_read": "모두 읽은 것으로 표시",
    "mobile_comments_author_mentioned_message": "다음에서 언급됨",
    "mobile_comments_author_commented_message": "다음에 의견이 달림",
    "mobile_view_pdf": "PDF 보기",
    "mobile_no_pdf_generated_message": "이 제출에 대한 PDF가 없습니다. 사본이 곧 이메일로 전송됩니다.",
    "mobile_clipboard_copied_success": "링크가 클립보드에 복사됩니다.",
    "mobile_share_link": "링크 공유",
    "mobile_zencam_share": "공유",
    "mobile_zencam_view_details": "세부 정보 보기",
    "mobile_zencam_details_drawer_header": "세부 정보",
    "mobile_zencam_submitted_by": "제출한 사람",
    "mobile_zencam_form_title": "양식 제목",
    "mobile_zencam_date_submitted": "제출 날짜",
    "mobile_oil_quality_warning_message": "오일 사용 기한 만료 임박",
    "mobile_oil_quality_warning_message_subtitle": "오일 사용 기한 만료가 임박했습니다.",
    "mobile_oil_quality_failure_message": "오일 품질이 저하되었습니다.",
    "mobile_oil_quality_failure_message_subtitle": "즉시 오일을 교체하세요.",
    "mobile_sensors_set_up_gateway": "게이트웨이 설정",
    "mobile_sensors_set_up_gateway_message": "설정된 장치가 없는 듯합니다. 게이트웨이를 추가하여 시작하세요.",
    "mobile_sensors_gateway_plugged_in": "게이트웨이가 콘센트에 연결되어야 합니다.",
    "mobile_sensors_add_device": "장치 추가",
    "mobile_sensors_name_this_gateway": "게이트웨이 이름을 지정하세요.",
    "mobile_sensors_name_this_sensor": "센서 이름을 지정하세요.",
    "mobile_sensors_device_barcode_information": "장치 레이블의 QR 코드를 스캔하거나 ID와 SC 번호를 입력하십시오.",
    "mobile_sensors_device_eui_information": "장치 레이블의 QR 코드를 스캔하거나 DevEUI를 입력하십시오.",
    "mobile_sensors_gateway_id_information": "게이트웨이 레이블에서 노드 ID 입력",
    "mobile_sensors_id_number": "{{untranslatedID}} 번호",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} 코드",
    "mobile_sensors_sensors": "센서",
    "mobile_sensors_sensor_deveui_error": "QR에서 DevEUI를 가져올 수 없습니다. 수동으로 입력해 주세요.",
    "mobile_sensors_gateways": "게이트웨이",
    "mobile_sensors_add_sensor": "센서 추가",
    "mobile_sensors_add_gateway": "게이트웨이 추가",
    "mobile_sensor_placement_description": "이 센서가 모니터링하는 영역은 무엇입니까?",
    "mobile_sensors_equipment_placement": "이 센서가 모니터링하는 영역 또는 장비는 무엇입니까?",
    "mobile_sensors_equipment": "이 센서가 모니터링하는 장비는 무엇입니까?",
    "mobile_sensors_select_gateway_type": "게이트웨이 유형 선택",
    "mobile_sensors_select_placement": "배치 선택",
    "mobile_sensors_select_equipment": "장비 선택",
    "mobile_sensors_placement": "배치",
    "mobile_sensors_nickname_tip": "센서 이름은 선택한 위치에 할당된 닉네임에 따라 결정됩니다.",
    "mobile_sensors_device_online": "온라인",
    "mobile_sensors_device_offline": "오프라인",
    "mobile_sensors_scan_qrcode": "QR 스캔",
    "mobile_sensors_enter_manually": "수동으로 입력",
    "mobile_sensors_wizard_step_one": "1단계",
    "mobile_sensors_wizard_step_two": "2단계",
    "mobile_sensors_wizard_step_three": "3단계",
    "mobile_sensors_wizard_step_four": "4단계",
    "mobile_sensors_wizard_step_five": "5단계",
    "mobile_sensors_wizard_step_six": "6단계",
    "mobile_sensors_initializing": "초기화 중...",
    "mobile_sensors_nickname": "별칭",
    "mobile_sensors_field_not_blank": "{{field}}은(는) 비워 둘 수 없습니다.",
    "mobile_sensors_nothing_to_see_here": "여기에 표시될 사항이 없음",
    "mobile_sensors_missing_integration": "센서 통합 기능 없음",
    "mobile_sensors_contact_zenput_admin": "귀사의 Ops Execution 담당자에게 문의하세요.",
    "mobile_sensors_contact_zenput_admin_old": "Zenput 관리자에게 문의하세요.",
    "mobile_sensors_contact_manager": "계정 관리자에게 센서 추가를 문의하세요.",
    "mobile_sensors_device_success_message": "센서를 불러오는 데 최대 15분이 소요될 수 있습니다.",
    "mobile_sensors_last_reading": "마지막 판독값",
    "mobile_sensors_remove_device": "장치 제거",
    "mobile_sensors_one_day": "1일",
    "mobile_sensors_one_week": "1주",
    "mobile_sensors_one_month": "1달",
    "mobile_sensors_three_months": "3개월",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1년",
    "mobile_sensors_sensor_settings": "센서 설정",
    "mobile_sensors_remove_confirm_message": "이 장치를 삭제하시겠습니까?\n이는 취소할 수 없습니다.",
    "mobile_sensors_sensor": "센서",
    "mobile_sensors_no_equipment_linked": "연결된 장비 없음",
    "mobile_sensor_cooldown_process": "쿨다운 프로세스",
    "mobile_sensor_last_12_hours": "지난 12시간",
    "mobile_sensor_start_cooldown_process": "새 쿨다운 프로세스 시작",
    "mobile_sensor_cooldown_process_title": "2단계 쿨다운 프로세스",
    "mobile_sensor_cooldown_process_description": "냉각 공정은 음식의 온도를 2시간 내에 {{ stage1_start_temperature }}에서 {{ stage1_end_temperature }}로 낮춘 다음 4시간 내에 {{ stage1_end_temperature }}에서 {{ stage2_end_temperature }}로 낮추는 2단계로 이루어집니다.",
    "mobile_sensor_cooldown_process_place_food": "냉장고에 식료품을 배치하세요.",
    "mobile_sensor_cooldown_process_insert_sensor": "센서 프로브를 식료품 안에 삽입하세요.",
    "mobile_sensor_cooldown_process_enter_information": "아래에 정보를 입력하세요.",
    "mobile_sensor_cooldown_process_food_product": "쿨다운할 식료품",
    "mobile_sensor_cooldown_cool_down": "쿨다운",
    "mobile_sensor_cooldown_select_sensor": "센서 선택",
    "mobile_sensors_cooldown_start_cooldown": "쿨다운 시작",
    "mobile_sensors_cooldown_please_enter_food": "식료품 입력",
    "mobile_sensors_cooldown_please_select_sensor": "센서를 선택하세요.",
    "mobile_sensors_cooldown_status_in_progress": "진행 중",
    "mobile_sensors_cooldown_status_failed": "실패",
    "mobile_sensors_cooldown_status_success": "성공",
    "mobile_sensors_cooldown_stage": "스테이지",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "시작 온도가 범위를 벗어남",
    "mobile_sensors_cooldown_failed_cooldown_process": "쿨다운 프로세스 실패함",
    "mobile_sensors_cooldown_cooldown_successful": "쿨다운 성공",
    "mobile_sensors_cooldown_started_cooldown_process": "쿨다운 프로세스 시작됨",
    "mobile_sensors_cooldown_hour": "시간",
    "mobile_sensors_cooldown_hour_plural": "시간",
    "mobile_sensors_cooldown_minute": "분",
    "mobile_minutes_plural": "분",
    "mobile_sensors_last_reading_max_date": "1년 전 미만",
    "mobile_sensors_minute_count_ago": "{{count}}분 전",
    "mobile_sensors_minute_count_ago_plural": "{{count}}분 전",
    "mobile_sensors_hour_count_ago": "{{count}}시간 전",
    "mobile_sensors_hour_count_ago_plural": "{{count}}시간 전",
    "mobile_sensors_day_count_ago": "{{count}}일 전",
    "mobile_sensors_day_count_ago_plural": "{{count}}일 전",
    "mobile_sensors_chart_settings": "채팅 설정",
    "mobile_announcement_banner_continue_reading": "판독 계속",
    "mobile_compliance_submissions_report": "제출 보고서",
    "mobile_compliance_submissions_report_subtitle": "이 스토어의 프로젝트 완료 데이터 내보내기",
    "mobile_compliance_send_submissions": "제출 보내기",
    "mobile_compliance_completion_rate_in_last_days": "지난 {{ days }}일 동안의 완료율",
    "mobile_compliance_last_days": "지난 {{ days }}일",
    "mobile_compliance_send_submissions_to": "다음으로 제출물 보내기",
    "mobile_compliance_send_to_different_email": "다른 이메일로 보내기",
    "mobile_compliance_email_input_placeholder": "이메일 주소",
    "mobile_compliance_send_submissions_to_legend_title": "제출",
    "mobile_compliance_send_submissions_to_legend_description_days": "지난 {{ days }}일간 이 위치에서 보낸 제출 건에 대한 보고서가 선택한 이메일로 전송됩니다.",
    "mobile_compliance_time_frame": "기간",
    "mobile_compliance_sensor_temperature_log_report": "센서 온도 로그 보고서",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "이 스토어의 온도 로그 내보내기",
    "mobile_compliance_sensor_temperature_log_criteria_title": "기준",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "아래에서 보고서의 기준을 정의하세요.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "참고: 비활성화된 센서는 보고서에 표시되지 않습니다.",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "시간대를 선택하세요. 로그 데이터는 최대 30일분으로 제한됩니다.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "보고서 전송",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "이번 달(1일~오늘)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "지난달",
    "mobile_compliance_sensor_temperature_log_email_title": "다음으로 보고서 전송",
    "mobile_pwa_update_prompt_title": "애플리케이션 업데이트",
    "mobile_pwa_update_prompt_description": "새로운 버전의 애플리케이션을 사용할 수 있습니다. 최신 버전으로 업데이트하십시오.",
    "mobile_pwa_update_prompt_confirm": "업데이트 및 다시 불러오기",
    "mobile_pwa_update_prompt_cancel": "나중에 알림",
    "notification_title_due_in_one_hour": "1시간 남음",
    "task_is_due_soon": "‘{{ task_title }}’의 마감이 얼마 남지 않았습니다. 잠시 시간을 내어 완료해 주세요.",
    "mobile_photo_quality_warning_header": "사진 품질 문제",
    "mobile_photo_quality_dialog_message": "사진이 너무 어둡거나 흐립니다. 사진을 다시 촬영하시겠습니까, 아니면 이 사진으로 계속 진행하시겠습니까?",
    "mobile_take_new_photo": "다시 촬영",
    "mobile_use_this_photo": "이 사진 사용"
}};
mobile_translations.es_ES = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Todo",
    "mobile_common_button_apply_filters": "Aplicar filtros",
    "mobile_common_button_done": "Hecho",
    "mobile_common_button_edit": "Editar",
    "mobile_common_button_archive": "Archivo",
    "mobile_common_button_save": "Guardar",
    "mobile_common_button_retake": "Retomar",
    "mobile_common_button_save_draft": "Guardar borrador",
    "mobile_common_button_discard": "Descartar",
    "mobile_common_button_submit": "Enviar",
    "mobile_common_button_no": "No",
    "mobile_common_button_yes": "Sí",
    "mobile_common_button_na": "N/D",
    "mobile_common_created_by_me": "Creado por mí",
    "mobile_common_email": "Correo electrónico de la compañía",
    "mobile_common_first_name": "Nombre",
    "mobile_common_last_name": "Apellidos",
    "mobile_common_location": "Ubicación",
    "mobile_common_locations": "Ubicaciones",
    "mobile_common_logout_message": "¿Está seguro de que desea cerrar la sesión?",
    "mobile_common_password": "Contraseña",
    "mobile_common_permission_required": "Permiso obligatorio",
    "mobile_common_status": "Estado",
    "mobile_common_task": "Tarea",
    "mobile_common_tasks": "Tareas",
    "mobile_common_tasks_my": "Mis tareas",
    "mobile_common_projects": "Proyectos",
    "mobile_common_filter_team": "Equipo",
    "mobile_common_filter_var_in": " en {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "No hay ningún equipo seleccionado",
    "mobile_common_filter_no_user_selected": "No hay ningún usuario seleccionado",
    "mobile_common_filter_no_role_selected": "No hay ningún rol seleccionado",
    "mobile_common_placeholder_date": "Fecha",
    "mobile_common_message_task_creator_error_save": "<b>No se han podido crear las tareas.</b>",
    "mobile_common_camera": "Cámara",
    "mobile_common_microphone": "Micrófono",
    "mobile_common_for": "para",
    "mobile_common_reload": "Volver a cargar",
    "mobile_common_override": "Anular",
    "mobile_common_notifications": "Notificaciones",
    "mobile_common_chat_unavailable": "Chat no disponible. Inténtelo de nuevo más tarde.",
    "mobile_common_chat_ending_dialog_title": "¿Ha finalizado con la conversación?",
    "mobile_common_chat_ending_dialog_description": "Háganos saber si su problema se ha resuelto o si simplemente desea continuar más tarde.",
    "mobile_common_chat_ending_dialog_confirm": "Sí, ya terminé",
    "mobile_common_chat_ending_dialog_cancel": "Continuaré más tarde",
    "mobile_common_continue_editing": "Continuar editando",
    "mobile_privacy_policy": "Política de privacidad",
    "wootric_recommend_target": "un amigo o un compañero de trabajo en su sector",
    "wootric_followup_detractor_question": "¿Qué cambios podemos hacer para que la próxima vez nos dé una puntuación más alta?",
    "wootric_followup_passive_question": "¡Gracias! ¿Qué podríamos hacer para mejorar la herramienta todavía más?",
    "wootric_followup_promoter_question": "¡Gracias! ¿Qué es lo que más le gusta de Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "¡Gracias! ¿Qué le gusta de Zenput?",
    "wootric_default_followup_question": "¡Gracias! ¿Quiere explicarnos por qué?",
    "wootric_default_placeholder_text": "Ayúdenos comentando su puntuación.",
    "wootric_default_thankyou_text": "¡Gracias por sus respuestas y por sus comentarios!",
    "mobile_login_placeholder_login_as": "Iniciar sesión como ID de usuario",
    "mobile_login_button_forgot_password": "¿Ha olvidado la contraseña?",
    "mobile_login_button_sign_up": "Crear cuenta",
    "mobile_login_button_finish_setup": "Finalizar configuración",
    "mobile_login_button": "Iniciar sesión",
    "mobile_login_continue_button": "Continuar",
    "mobile_login_continue_transition": "redirigiéndole a la página de inicio de sesión de su organización...",
    "mobile_login_no_email_error": "Debe introducir un correo electrónico.",
    "mobile_login_change_email": "Iniciar sesión con un correo electrónico diferente",
    "mobile_login_with_sso": "Iniciar sesión con SSO",
    "mobile_oauth_no_user_error_message": "¡Parece que no dispone de una cuenta de Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Parece que no dispone de una Cuenta de Zenput.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> pasa a llamarse <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} se convierte en {{- product }} en septiembre. {{- cta }}",
    "mobile_rebrand_warning_cta": "Descubra cómo prepararse.",
    "mobile_oauth_no_user_error_sub_message": "Póngase en contacto con su administrador para acceder o intente iniciar sesión con un correo electrónico diferente.",
    "mobile_oauth_generic_error_message": "Parece que se ha producido un error al iniciar la sesión; inténtelo de nuevo.",
    "mobile_oauth_force_logout_msg": "Si aún tiene problemas, cierre la sesión de su proveedor ",
    "mobile_oauth_force_logout_click": "haciendo clic aquí.",
    "mobile_sign_up_placeholder_phone": "Número de móvil",
    "mobile_sign_up_placeholder_password_confirm": "Confirmar contraseña",
    "mobile_sign_up_button_sign_in": "Registrarse",
    "mobile_sign_up_disclaimer_part_1": "Al hacer clic en Crear cuenta, acepta el",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Al hacer clic en Finalizar configuración, usted acepta la",
    "mobile_sign_up_disclaimer_link_title": " Acuerdo de licencia",
    "mobile_sign_up_disclaimer_part_2": ", que incluye información importante sobre privacidad",
    "mobile_dialog_benefits_work_offline": "Trabajar sin conexión",
    "mobile_dialog_benefits_faster_uploads": "Subidas más rápidas",
    "mobile_dialog_benefits_better_experience": "La mejor experiencia",
    "mobile_dialog_benefits_button_download": "Descargar",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution para ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput para ",
    "mobile_dialog_benefits_button_have": "¡Tengo la aplicación!",
    "mobile_dialog_benefits_button_no_thanks": "No gracias, tal vez más tarde.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "No se ha podido cargar la imagen.",
    "mobile_dialog_signature_sign": "Firmar aquí",
    "mobile_dialog_signature_button_clear": "Borrar",
    "mobile_account_placeholder_name": "Nombre de la ubicación/tienda",
    "mobile_account_placeholder_phone": "Teléfono",
    "mobile_account_placeholder_address": "Dirección",
    "mobile_account_placeholder_city": "Ciudad",
    "mobile_account_placeholder_region": "Región",
    "mobile_account_placeholder_zipcode": "Código postal",
    "mobile_account_option_select_country": "Seleccionar país",
    "mobile_account_oprion_us": "Estados Unidos",
    "mobile_account_oprion_select_state": "Seleccionar estado",
    "mobile_account_button_create_location": "Crear ubicación",
    "mobile_form_message_no_form": "No hay formularios disponibles",
    "mobile_batch_task_message": "Cargando...",
    "mobile_settings_profile": "Perfil",
    "mobile_settings_profile_number": "Teléfono móvil",
    "mobile_settings_profile_language": "Idioma",
    "mobile_settings_profile_temperature_unit": "Unidad de temperatura",
    "mobile_settings_profile_use_company_default": "Utilizar la configuración predeterminada por la empresa",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Mensaje de texto",
    "mobile_settings_notifications_option_push": "Notificaciones automatizadas",
    "mobile_settings_notifications_option_push_email": "Correo electrónico y notificaciones automatizadas",
    "mobile_settings_notifications_option_do_not": "No notificar",
    "mobile_settings_notifications_category_communication": "Comunicación",
    "mobile_settings_notifications_category_forms_and_triggers": "Formularios y factores",
    "mobile_settings_devices": "Dispositivos",
    "mobile_settings_notifications_sub_category_alerts": "Alertas",
    "mobile_settings_notifications_sub_category_new_forms_available": "Hay nuevos formularios disponibles",
    "mobile_settings_notifications_sub_category_task_assigned": "Tarea asignada",
    "mobile_settings_notifications_sub_category_task_completed": "Tarea completada",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Recordatorio de tareas cuyo vencimiento está próximo",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Recordatorio de tareas atrasadas",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Alertas del sensor",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alertas críticas del sensor",
    "mobile_drafts_message": "Aún no tiene ningún borrador.",
    "mobile_drafts_button_delete": "Eliminar",
    "mobile_tasks_filter_location_no": "No hay ninguna ubicación seleccionada",
    "mobile_tasks_filter_group_by": "Agrupar por",
    "mobile_tasks_filter_sort_by": "Ordenar por",
    "mobile_tasks_filter_sorted_by": "Ordenado por",
    "mobile_tasks_filter_due_time": "Hora de vencimiento",
    "mobile_tasks_filter_open_time": "Hora de apertura",
    "mobile_tasks_bucket_due_next_24_hours": "Vence en las próximas 24 horas",
    "mobile_tasks_bucket_due_next_7_days": "Vence en los próximos 7 días",
    "mobile_tasks_bucket_open_tasks": "{{type}} abierta(s) adicional(es)",
    "mobile_tasks_bucket_open_at": "Abierto: {{- date }} a las {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Vence el: {{- date }} a las {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponible en 1 minuto",
    "mobile_tasks_bucket_available_in_one_hour": "Disponible en 1 hora",
    "mobile_tasks_bucket_available_in_one_day": "Disponible en 1 día",
    "mobile_tasks_bucket_available_in_one_week": "Disponible en 1 semana",
    "mobile_tasks_bucket_available_in_one_month": "Disponible en 1 mes",
    "mobile_tasks_bucket_available_in_one_year": "Disponible en 1 año",
    "mobile_tasks_bucket_available_in_minutes": "Disponible en {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_hours": "Disponible en {{ hours }} horas",
    "mobile_tasks_bucket_available_in_days": "Disponible en {{ days }} días",
    "mobile_tasks_bucket_available_in_weeks": "Disponible en {{ weeks }} semanas",
    "notification_task_due_in_minutes": "Vence en {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_months": "Disponible en {{ months }} meses",
    "mobile_tasks_bucket_available_in_years": "Disponible en {{ years }} años",
    "mobile_tasks_follow_up": "Realizar seguimiento de la tarea",
    "mobile_tasks_due_soon": "Vence pronto",
    "mobile_tasks_bucket_completed_today": "Se ha completado hoy",
    "mobile_tasks_bucket_completed_this_week": "Se ha completado esta semana",
    "mobile_tasks_bucket_completed_last_week": "Se ha completado la semana pasada",
    "mobile_tasks_bucket_missed_today": "Sin completar hoy",
    "mobile_tasks_bucket_missed_this_week": "Sin completar esta semana",
    "mobile_tasks_bucket_missed_last_week": "Sin completar la semana pasada",
    "mobile_tasks_bucket_no_location": "No hay ninguna ubicación",
    "mobile_tasks_cannot_submit_missed": "Las tareas sin completar no se pueden realizar",
    "mobile_tasks_cannot_submit_missed_after": "Esta tarea no se pueden completar después del {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Esta tarea no se ha comenzado.",
    "mobile_tasks_cannot_submit_processing": "Este envío se está procesando",
    "mobile_tasks_toolbarnav_header_no_due_date": "No hay fecha de vencimiento",
    "mobile_tasks_toolbarnav_header_overdue": "Atrasado",
    "mobile_tasks_toolbarnav_header_yesterday": "Ayer",
    "mobile_tasks_toolbarnav_header_today": "Hoy",
    "mobile_tasks_toolbarnav_header_tomorrow": "Mañana",
    "mobile_tasks_toolbarnav_header_last_week": "La semana pasada",
    "mobile_tasks_toolbarnav_header_this_week": "Esta semana",
    "mobile_tasks_toolbarnav_header_next_week": "La semana próxima",
    "mobile_tasks_toolbarnav_header_this_month": "Este mes",
    "mobile_tasks_toolbarnav_header_next_year": "El año próximo",
    "mobile_tasks_toolbarnav_header_over_year": "A lo largo de un año",
    "mobile_tasks_toolbarnav_title_edit_task": "Editar tarea",
    "mobile_task_placeholder_title": "Título *",
    "mobile_task_placeholder_description": "Descripción (opcional)",
    "mobile_task_button_single_task": "Tarea individual",
    "mobile_task_button_project": "Proyecto",
    "mobile_task_button_create": "Crear",
    "mobile_task_tab_basic": "Básico",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formulario",
    "mobile_task_details_description_message_please": "Rellene ",
    "mobile_task_details_description_message_below": "a continuación.",
    "mobile_task_details_description_message_instructions": "No hay instrucciones disponibles para esta tarea.",
    "mobile_task_details_reason_title": "Seguimiento desencadenado por",
    "mobile_task_detials_button_goto_form": "Ir a Formulario",
    "mobile_task_detials_button_complete": " Completar tarea",
    "mobile_task_detials_completed": "Completado ",
    "mobile_task_detials_completed_by": "por ",
    "mobile_task_detials_completed_on": "el ",
    "mobile_task_details_view_form_submission": "Ver envío de formulario",
    "mobile_task_task_updated": "Tarea actualizada",
    "mobile_task_task_archived": "Tarea archivada",
    "mobile_task_task_deleted": "Tarea eliminada",
    "mobile_task_error_archiving_task": "No se ha podido archivar la tarea.",
    "mobile_task_error_deleting_task": "No se ha podido eliminar la tarea.",
    "mobile_task_error_updating_task": "No se ha podido actualizar la tarea.",
    "mobile_task_archive_task": "Tarea de archivo",
    "mobile_task_archive_task_confirm": "¿Está seguro de que quiere archivar esta tarea?\n\nLas tareas archivadas contarán en las tasas de finalización y se seguirán incluyendo en los informes.\n\nEsta acción no se podrá deshacer.",
    "mobile_task_delete_task_confirm": "¿Está seguro de que quiere eliminar esta tarea?\n\nLas tareas eliminadas no contarán en las tasas de finalización y no se incluirán en los informes.\n\nEsta acción no se podrá deshacer.",
    "mobile_task_edition_already_in_progress": "Esta tarea tiene una edición pendiente. La edición avanzada no está permitida actualmente.",
    "mobile_projects_filter_type": "Escribir",
    "mobile_projects_filter_status": "Estado del proyecto",
    "mobile_projects_filter_project_type": "Tipo de proyecto",
    "mobile_projects_due_date_required": "La fecha de vencimiento es obligatoria.",
    "mobile_projects_team_required": "El equipo es obligatorio.",
    "mobile_projects_user_role_required": "El destinatario es obligatorio.",
    "mobile_projects_title_required": "El título es obligatorio.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Varias tareas al día",
    "mobile_project_tasks_complete": " Completar",
    "mobile_project_tasks_remaining": " Restante",
    "mobile_esitmate_message_tasks": "Se crearán 0 tareas",
    "mobile_esitmate_message_criteria": "Ajustar los criterios anteriores",
    "mobile_esitmate_message_created_for": "se creará para",
    "mobile_left_menu_dashboard": "Panel de información",
    "mobile_left_menu_my_forms": "Mis formularios",
    "mobile_left_menu_announcements": "Anuncios",
    "mobile_left_menu_my_submissions": "Mis envíos",
    "mobile_left_menu_drafts": "Borradores",
    "mobile_left_menu_pending_uploads": "Subidas pendientes",
    "mobile_left_menu_open": "Abrir en la aplicación",
    "mobile_left_menu_settings": "Ajustes",
    "mobile_left_menu_log_out": "Cerrar sesión",
    "mobile_left_menu_debug": "Depurar",
    "mobile_left_menu_support": "Asistencia",
    "mobile_left_menu_documentation": "Documentación",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Nota o leyenda",
    "mobile_field_option_select": "Seleccionar",
    "mobile_field_text_placeholder_text": "Texto",
    "mobile_field_email_placehoder_email": "Correo electrónico",
    "mobile_filed_number_placeholder_number": "Número",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "No está conectado",
    "mobile_field_sensor_offline_battery": "Sensor sin conexión - Batería",
    "mobile_field_video_button_add": "Añadir un vídeo",
    "mobile_field_video_picker_dialog_title": "Añadir vídeo desde",
    "mobile_field_video_button_change": "Cambiar vídeo",
    "mobile_field_image_button_add": "Añadir imagen",
    "mobile_field_image_low_quality_warning": "Algunas fotos pueden estar oscuras o desenfocadas. Revise las fotos resaltadas y sustitúyalas si es necesario.",
    "mobile_field_image_picker_dialog_title": "Añadir foto desde",
    "mobile_field_image_picker_edit_failed": "No hemos podido guardar la imagen. Inténtelo de nuevo.",
    "mobile_field_signature_button_add": "Añadir una firma",
    "mobile_field_signature_button_change": "Cambiar firma",
    "mobile_field_account_select_location": "Seleccionar una ubicación",
    "mobile_field_account_prefill": "¿Desea rellenar automáticamente el formulario con los datos de la última visita?",
    "mobile_field_account_message_overwrite": "Esta acción sobrescribirá todos los campos que ya haya rellenado.",
    "mobile_forms_task_on_behalf": "Hay una tarea que cumplir en esta ubicación asignada a <b>{{user}}</b>. ¿Desea completar esta tarea?",
    "mobile_forms_complete_task": "¿Completar tarea?",
    "mobile_field_account_prefill_button_yes": "Sí, rellenar automáticamente",
    "mobile_field_barcode_placeholder_scan": "Escanear o escribir el código de barras",
    "mobile_field_sensor_qr_code_placeholder_scan": "Escanea o introduce el código",
    "mobile_field_gateway_id_code_placeholder": "Identificador de nodo de tipo",
    "mobile_field_scan_qr_or_enter_dev_eui": "Escanea el código QR o introduce el DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Escanea el código QR o introduce el número de identificación",
    "mobile_field_scan_qr_or_enter_sc": "Escanea el código QR o introduce el código SC",
    "mobile_field_barcode_select_date": "Seleccionar fecha ",
    "mobile_field_datetime_allow_time": "Hora",
    "mobile_field_stopwatch_button_caption": "Cronómetro",
    "mobile_field_stopwatch_common_start": "Iniciar",
    "mobile_field_stopwatch_common_stop": "Detener",
    "mobile_field_stopwatch_common_reset": "Restablecer",
    "mobile_field_stopwatch_stop_stopwatches": "Detener cronómetros",
    "mobile_field_document_title": "Añadir documento",
    "mobile_field_document_message_delete": "¿Está seguro de que desea eliminar este documento?",
    "mobile_field_document_alret_button_view": "Ver",
    "mobile_field_document_alert_error": "Se ha producido un error al adjuntar este documento. Inténtelo de nuevo.",
    "mobile_field_document_alert_file_size_error": "El archivo no puede superar {{count}} MB.",
    "mobile_field_temperature_greater_range": "superior a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "superior o igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "inferior a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "inferior o igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "superior o igual a {{ min_temp_value }} °{{ temp_unit }} e inferior a {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "superior o igual a {{ min_temp_value }} °{{ temp_unit }} e inferior o igual a {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " y ",
    "mobile_field_text_limit_error": "Se alcanzó el límite de 8000 caracteres.",
    "mobile_forms_required_questions_complete": "Obligatorios completos",
    "mobile_forms_required_remaining": "{{count}} obligatorios restantes",
    "mobile_forms_required_questions_back": "Atrás",
    "mobile_forms_required_questions_next": "Siguiente",
    "mobile_forms_required_questions_skip": "Saltar",
    "mobile_forms_leaving_form": "Saliendo del formulario",
    "mobile_message_reordering_confirm": "¿Desea guardar el nuevo orden de las preguntas?",
    "mobile_forms_leaving_reordering": "Saliendo de la reordenación de preguntas",
    "mobile_forms_reordering_button_save": "Guardar el orden nuevo de preguntas",
    "mobile_forms_reordering_instructions": "Si quieres reordenar las preguntas o las secciones, arrastra y suelta hasta el lugar donde debe aparecer el campo en el formulario",
    "mobile_toolbarnav_title_my_setttings": "Mis ajustes",
    "mobile_toolbarnav_title_profile_settings": "Ajustes del perfil",
    "mobile_toolbarnav_title_notification": "Ajustes de notificación",
    "mobile_toolbarnav_title_form_history": "Historial de formularios",
    "mobile_toolbarnav_title_form_not_available": "Formulario no disponible",
    "mobile_toolbarnav_title_add_location": "Añadir ubicación",
    "mobile_toolbarnav_title_add_task_or_project": "Añadir tarea o proyecto",
    "mobile_toolbarnav_title_select_location": "Seleccionar ubicación",
    "mobile_toolbarnav_title_select_project": "Seleccionar proyecto",
    "mobile_toolbarnav_title_select_tag": "Seleccionar etiqueta",
    "mobile_toolbarnav_title_select_user": "Seleccionar usuario",
    "mobile_toolbarnav_title_select_template": "Seleccionar plantilla",
    "mobile_toolbarnav_title_select_one": "Seleccionar uno",
    "mobile_toolbarnav_title_select_multiple": "Seleccione uno o varios",
    "mobile_toolbarnav_title_select_team": "Seleccionar equipo",
    "mobile_toolbarnav_title_select_team_or_location": "Seleccionar equipo o ubicación",
    "mobile_toolbarnav_title_filter_tasks": "Filtrar tareas",
    "mobile_toolbarnav_title_filter_projects": "Filtrar proyectos",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrar tareas de proyectos",
    "mobile_placeholder_search_bar": "Buscar",
    "mobile_placeholder_user_select_role": "Seleccionar rol de usuario",
    "mobile_placeholder_filter_by_team": "Filtrar por un equipo",
    "mobile_placeholder_assign_to_user_role": "Asignar al rol de usuario",
    "mobile_placeholder_select": "-- Seleccionar --",
    "mobile_placeholder_account_location_name": "Nombre de la ubicación",
    "mobile_placeholder_tag_filter_by": "Filtrar por etiqueta de ubicación",
    "mobile_placeholder_user_type": "Asignar al usuario",
    "mobile_placeholder_acount_type_loading": "Cargando... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatura",
    "mobile_placeholder_blue_therm_connecting": "Conectando al dispositivo...",
    "mobile_placeholder_blue_therm_please_wait": "Espere...",
    "mobile_placeholder_blue_therm_tap": "Puntee para leer.",
    "mobile_placeholder_blue_therm_not_connected": "No está conectado.",
    "mobile_placeholder_testo_tap": "Mantener pulsado ▼▲ y, a continuación, ⬆",
    "mobile_message_error_create_task": "Debe estar conectado en línea para añadir tareas.",
    "mobile_message_error_fill_out_form": "Rellene el formulario.",
    "mobile_message_error_fill_require_fields": "Rellene los campos obligatorios.",
    "mobile_message_error_stop_stopwatch_before_submit": "Detenga su cronómetro antes del envío",
    "mobile_message_error_stopwatch_field_required": "El campo Cronómetro es obligatorio",
    "mobile_message_error_stopwatch_field_running": "El campo Cronómetro se está ejecutando",
    "mobile_message_error_invalid_equipment_temperature": "Temperatura del equipo no válida",
    "mobile_message_error_invalid_ingredient_temperature": "Temperatura del ingrediente no válida",
    "mobile_message_error_location_attributes_unavailable": "Algunas preguntas pueden no estar disponibles, conéctese a Internet",
    "mobile_message_alert_running_stopwatches": "Tiene cronómetros en ejecución.\n\n¿Le gustaría borrarlos?",
    "mobile_message_blue_therm_error": "Se ha perdido la conexión con el dispositivo Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Es necesario tener acceso a la ubicación. Active esta función en los ajustes de su dispositivo Android.",
    "mobile_message_blue_therm_no_permission_android": "Es necesario tener activado el acceso a «Dispositivos cercanos». Active esta función en los ajustes de su Android.",
    "mobile_message_blue_therm_error_code": "No se ha podido conectar:",
    "mobile_message_blue_therm_error_bluetooth": "Habilite el Bluetooth.",
    "mobile_message_blue_therm_error_device": "Dispositivo no encontrado.",
    "mobile_message_blue_therm_error_try_again": "Inténtelo de nuevo",
    "mobile_message_blue_therm_success": "¡Dispositivo Bluetooth conectado!",
    "mobile_message_bluetooth_device_press_button_field": "Pulse el botón de su dispositivo para conectarse.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Pulse el botón de su dispositivo<br />si no lo ve en esta lista.",
    "mobile_bluetooth_scan": "Escanear",
    "mobile_bluetooth_scanning": "Escaneando",
    "mobile_message_drafts_confirm": "¿Le gustaría guardar esto como borrador?",
    "mobile_message_drafts_toast_saved": "Borrador guardado.",
    "mobile_message_drafts_request_update": "¿Le gustaría actualizar este borrador?",
    "mobile_message_drafts_form_confirm": "¿Está seguro de que quiere eliminar este borrador?",
    "mobile_message_drafts_confirm_delete": "Eliminar borrador",
    "mobile_message_streams_error_switch": "No se pueden cambiar las transmisiones en la web",
    "mobile_message_settings_success_saved": "Ajustes guardados",
    "mobile_message_settings_error": "Se ha producido un error desconocido. Inténtelo de nuevo más tarde",
    "mobile_message_profile_settings_error_fields": "Corrija los campos resaltados.",
    "mobile_message_media_perimission_denied": "Su ",
    "mobile_message_media_perimission_denied_device": "Almacenamiento del dispositivo",
    "mobile_message_image_confirm_remove_image": "¿Está seguro de que desea eliminar esta foto?",
    "mobile_message_create_account_error_fields": "Rellene los campos resaltados.",
    "mobile_message_create_account_success_location_created": "Ubicación creada",
    "mobile_message_task_error_get_location": "No se ha podido obtener la ubicación. Se está ordenando por fecha.",
    "mobile_message_typehead_confirm_save_message": "¿Desea guardar estas selecciones?",
    "mobile_message_typehead_confirm_save_title": "¿Desea guardar?",
    "mobile_message_task_creator_error_save_select_form": "Debe seleccionar un formulario.",
    "mobile_message_task_creator_error_save_required_fields": "Rellene los campos obligatorios.",
    "mobile_message_task_creator_error_save_batch_change": "Cambie los criterios para que coincidan con uno o más usuarios",
    "mobile_message_task_detials_error_not_assigned_to_you": "Esta tarea no se le ha asignado.<br />Usted no puede completarla.",
    "mobile_message_task_detials_error_assigned_to": "Esta tarea se ha asignado a {{user}}.<br />Usted no puede completarla.",
    "mobile_message_task_detials_confirm_title": "Saliendo de la tarea",
    "mobile_message_task_detials_confirm_save_task": "Guardar tarea",
    "mobile_message_task_detials_confirm_message": "¿Está seguro? Sus cambios se perderán.",
    "mobile_message_task_detials_error_view_account": "No es posible acceder a la ubicación.",
    "mobile_message_task_detials_error_submit_task": "Añada una foto para completar esta tarea.",
    "mobile_message_task_detials_error_submit_task_project": "No es posible guardar el proyecto. Inténtelo de nuevo más tarde.",
    "mobile_message_task_detials_wait_submit_task_created": "Las tareas se están creando.<br />Espere unos minutos a que las tareas se llenen.",
    "mobile_message_task_detials_error_submit_task_pending": "Error, inténtelo de nuevo más tarde",
    "mobile_message_task_detials_success_task_complete": "Tarea completa",
    "mobile_message_task_error_save_single_task": "No es posible guardar la tarea. Inténtelo de nuevo más tarde.",
    "mobile_message_task_success_save_single_task": "Tarea creada.",
    "mobile_message_show_error_message": "Se ha producido un error.",
    "mobile_message_show_success_message": "¡Correcto!",
    "mobile_message_show_offline_message": "Actualmente está sin conexión.",
    "mobile_message_show_permission_denied_message": "<b>Permiso obligatorio.</b> Conceda un permiso a Zenput para que acceda a {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Permiso obligatorio.</b> Autorice a Zenput y a su explorador el acceso a {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Se está actualizando ahora",
    "mobile_message_show_upload_in_progress_message": "Carga en curso",
    "mobile_message_show_form_id_error": "No es posible acceder al formulario especificado.",
    "mobile_message_show_single_task_error": "No es posible acceder a la tarea especificada.",
    "mobile_message_show_submissions_error": "No es posible acceder al envío especificado.",
    "mobile_message_show_submissions_access_denied": "Lo sentimos, no tiene acceso a este formulario.",
    "mobile_message_send_data_success": "Datos cargados ",
    "mobile_message_start_upload_success": "Subida completa",
    "mobile_message_start_upload_error": "<b>No se ha podido completar la subida.</b><br>El envío se ha guardado. Inténtelo de nuevo más tarde",
    "mobile_message_store_upgrade_store_ios": "Tienda de aplicaciones",
    "mobile_message_store_upgrade_store_android": "Tienda de juegos",
    "mobile_message_store_upgrade_confirm_title": "Actualización disponible",
    "mobile_message_store_upgrade_confirm_message_one": "Actualice la aplicación Ops Execution desde ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Actualice Zenput a partir de ",
    "mobile_message_store_upgrade_confirm_message_two": " para obtener todas las funciones y correcciones de errores más recientes",
    "mobile_message_store_upgrade_confirm_now": "Ahora",
    "mobile_message_store_upgrade_confirm_later": "Más tarde",
    "mobile_message_redirect_confirm_message": "Actualmente está rellenando un formulario. ¿Le gustaría guardarlo como borrador antes de continuar?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Tiene {{count}} borradores que no se han cargado. Se perderán si continúa. ¿Está seguro?",
    "mobile_message_draft_override_message": "Este borrador se guardó desde otro dispositivo en {{date}} y los cambios en este dispositivo están en conflicto. Puede anular la versión existente o volver a cargar a la versión más reciente para descartar los cambios.",
    "mobile_html_submitting": "Enviando...",
    "mobile_html_offline": "¡Actualmente está sin conexión!",
    "mobile_html_offline_try_again": "Actualmente está sin conexión. <br/><br/>Inténtelo de nuevo cuando esté conectado",
    "mobile_html_something_went_wrong": "¡Vaya! Se ha producido un error.",
    "mobile_html_something_went_wrong_try_again": "¡Vaya! Se ha producido un error. Inténtelo de nuevo.",
    "mobile_html_failed_loading_roles": "No se han podido cargar los roles.",
    "mobile_alert_please_install_for_native": "Instale la aplicación Ops Execution para poder utilizar esta función. ",
    "mobile_alert_please_install_for_native_old": "Instale la aplicación nativa de Zenput para utilizar esta función.",
    "mobile_tso_filter_all_tasks": "Todas {{type}}",
    "mobile_tso_filter_my_tasks": "Mis {{type}}",
    "mobile_tso_filter_due_date": "Fecha límite",
    "mobile_tso_filter_date_completed": "Fecha completada",
    "mobile_tso_filter_completed": "Completado",
    "mobile_tso_filter_completed_late": "Completado tarde",
    "mobile_tso_filter_incomplete": "Incompleto",
    "mobile_tso_filter_var_my_tasks": "Mis {{filter_type}}{{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} creadas por mí",
    "mobile_tso_filter_var_all_tasks": "Todas las {{filter_type}}{{type}}",
    "mobile_tso_type_follow_up_actions": "Acciones de seguimiento",
    "mobile_tso_type_all": "Tareas y acciones de seguimiento",
    "mobile_tso_filter_var_at": " en {{location}}",
    "mobile_tso_filter_group_date_due": ", ordenado por Fecha límite",
    "mobile_tso_filter_group_distance": ", agrupado por Ubicación",
    "mobile_tso_filter_start_date": "Fecha Inicial",
    "mobile_tso_filter_none": "Ninguno",
    "mobile_pso_filter_all_projects": "Todos los proyectos",
    "mobile_pso_filter_my_projects": "Mis proyectos",
    "mobile_pso_filter_active": "Activo",
    "mobile_pso_filter_archived": "Archivado",
    "mobile_pso_filter_recurring": "Recurrente",
    "mobile_pso_filter_non_recurring": "No recurrente",
    "mobile_pso_filter_var_my_projects": "Mis proyectos de {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "Proyectos de {{project_type}} {{active_description}} creados por mí",
    "mobile_pso_filter_var_all_projects": "Todos los proyectos de {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Parece que está sin conexión. Conéctese en línea si desea ver los resultados.",
    "mobile_empty_list_message_no_submissions": "No hay envíos",
    "mobile_empty_list_message_no_activity": "No hay actividad",
    "mobile_empty_list_message_no_tasks": "No hay tareas",
    "mobile_empty_list_message_no_tasks_overdue": "{{type}} sin atrasos ",
    "mobile_empty_list_message_no_accounts": "No hay ubicaciones",
    "mobile_empty_list_message_no_projects": "No hay proyectos",
    "mobile_empty_list_message_no_results_found": "No se ha encontrado ningún resultado",
    "mobile_empty_list_message_no_forms_available": "No hay formularios disponibles",
    "mobile_empty_list_message_connection_error": "Error de conexión<br />Inténtelo de nuevo.",
    "mobile_empty_list_message_dashboard_error": "No es posible cargar el panel de información",
    "mobile_empty_list_message_user_offline": "Actualmente está sin conexión",
    "mobile_action_sheet_media_gallery": "Galería",
    "mobile_action_sheet_cancel": "Cancelar",
    "mobile_image_preview_text": "Suprimir foto",
    "mobile_mobileform_text": "Envíos anteriores",
    "mobile_mobileform_reorder_fields": "Reordenar preguntas",
    "mobile_mobileform_follow_up_actions": "Acciones de seguimiento",
    "mobile_mobileform_follow_up_actions_assign_title": "Asignar acciones de seguimiento",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Añada acciones de seguimiento basadas en tus observaciones para asegurar que se resuelvan los problemas.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Añadir acción de seguimiento",
    "mobile_mobileform_follow_up_actions_assign_button": "Asignar seguimientos",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continuar sin asignar",
    "mobile_mobileform_follow_up_actions_dialog_title": "¿Continuar sin asignar acciones de seguimiento?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Si continúa sin asignar ninguna acción de seguimiento, no podrá añadirlas más tarde.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continuar de todos modos",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Este campo es obligatorio",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Demasiados caracteres",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Este campo no es válido",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Error al cargar ubicaciones",
    "mobile_mobileform_add_follow_up_actions_error_users": "Error al cargar usuarios",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Añadir seguimiento",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Título",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Descripción",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "La foto es obligatoria",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Fecha de vencimiento",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Actualizar seguimiento",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "¿Eliminar seguimiento?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Se eliminará y no se asignará.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Eliminar seguimiento",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "¿Está seguro que quiere eliminar este seguimiento?\n\nEsta acción no se puede deshacer.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continuar a seguimientos",
    "mobile_mobileform_follow_up_actions_completed_notification": "Acción de seguimiento completada",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Acción de seguimiento eliminada",
    "mobile_mobileform_follow_up_actions_update_notification": "Acción de seguimiento actualizada",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Añada una foto para completar la acción de seguimiento",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Ir al envío",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Ir al origen",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Origen",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Completar Seguimiento",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Si abre el envío, se perderán las fotos y notas que no haya guardado.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Si sale de esta pantalla, se perderán todas las fotos y notas que no haya guardado.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Quedarse aquí",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Abrir envío",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Código abierto",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "¿Salir de esta acción de seguimiento?",
    "mobile_mobileform_follow_up_actions_submission": "Envío",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Esta acción de Seguimiento se ha asignado a {{user}}.<br />Usted no puede completarla.",
    "mobile_mobileform_follow_up_actions_leave_description": "Si sale de esta pantalla, se perderán los cambios que no haya guardado.",
    "mobile_mobileform_follow_up_actions_leave": "Salir",
    "mobile_forms_drafts_text": "Suprimir borradores",
    "mobile_batch_estimate_user": "Usuario",
    "mobile_batch_estimate_users": "Usuarios",
    "mobile_table_of_contents": "Tabla de contenidos",
    "mobile_table_of_contents_required": "Obligatorio",
    "mobile_table_of_contents_optional": "Opcional",
    "mobile_dialog_alert_title": "Alerta",
    "mobile_dialog_alert_ok": "Aceptar",
    "mobile_windows_10_bluetherm_not_supported": "Los dispositivos Bluetooth aún no se admiten en Windows",
    "mobile_windows_deprecated_message_content_announcement": "Anuncio",
    "mobile_windows_deprecated_message_title": "Es necesario actualizar la aplicación",
    "mobile_windows_deprecated_message_description": "Instale la nueva aplicación de Zenput en Microsoft Store para asegurarse de disponer de actualizaciones de funcionalidades esenciales y una óptima experiencia de Zenput.",
    "mobile_dashboard_tcr_graph_name": "Tasa de finalización de tarea",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Últimas 4 semanas",
    "mobile_dashboard_tcr_legend_company_average": "Media de la compañía",
    "mobile_dashboard_tcr_legend_team_average": "Media del equipo",
    "mobile_dashboard_tab_title_summary": "Resumen",
    "mobile_dashboard_tab_title_activity": "Actividad",
    "mobile_dashboard_card_title_top_triggered_workflows": "Factores principales",
    "mobile_dashboard_tab_title_info": "Información",
    "mobile_dashboard_tab_project_audit": "Cumplimiento",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Semana de",
    "mobile_dashboard_card_filter_form_template_placeholder": "Todos los formularios",
    "mobile_dashboard_card_title_forms_top_nos": "Los \"No\" más frecuentes",
    "mobile_dashboard_zenput_code_no_data_in_range": "No hay datos en este intervalo de tiempo.",
    "mobile_dashboard_zenput_code_permission_denied": "No tiene permiso para ver esto.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Seleccione un formulario de los anteriores.",
    "mobile_dashboard_zenput_code_unknown_error": "No podemos mostrar los datos en este momento.",
    "mobile_dashboard_tap_to_retry": "Puntee para reintentar",
    "mobile_dashboard_reporting_delay_disclaimer": "Puede que la actualización de las tareas tarde hasta 15 minutos.",
    "mobile_dashboard_configuration_down_state_postfix_msg": "ha sido configurado por su administrador.",
    "mobile_tasks_tag": "tareas",
    "mobile_workflows_tag": "factores",
    "mobile_projects_tag": "proyectos recurrentes",
    "mobile_forms_tag": "formularios",
    "mobile_dashboard_card_ongoing_projects_title": "Proyectos en curso",
    "mobile_dashboard_card_ongoing_projects_show_more": "Mostrar más",
    "mobile_dashboard_card_ongoing_projects_show_less": "Mostrar menos",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Ir a Proyectos",
    "mobile_dashboard_card_title_recurring_projects": "Proyectos recurrentes",
    "mobile_dashboard_card_filter_daily": "Diario",
    "mobile_dashboard_card_filter_weekly": "Semanal",
    "mobile_dashboard_card_filter_monthly": "Mensual",
    "mobile_task_status_title_open": "Abrir",
    "mobile_task_status_title_upcoming": "Próximas",
    "mobile_task_status_title_complete": "Completar",
    "mobile_task_status_title_processing": "Procesando envío",
    "mobile_task_status_title_complete_with_exceptions": "Completar con alertas o tareas de seguimiento",
    "mobile_task_status_title_completed_late_with_exceptions": "Completado tarde con tareas de seguimiento o alertas",
    "mobile_task_status_title_incomplete_and_closed": "Sin completar",
    "mobile_tasks_legend_modal_title": "Leyenda",
    "mobile_tasks_legend_modal_footer_button_title": "Cerrar",
    "mobile_common_assigned_to": "Asignado a",
    "mobile_common_created_by": "Creado por",
    "mobile_common_tasks_for": "Tareas para",
    "mobile_common_go_back": "Ir atrás",
    "mobile_oh_no": "¡Oh, no!",
    "mobile_user_not_in_groups": "Lo sentimos, parece que no se le ha asignado a un equipo. Póngase en contacto con su administrador para obtener acceso al panel de información.",
    "mobile_tasks_select_followers": "Seleccionar seguidores",
    "mobile_tasks_assign_tasks": "Asignar {{count}} tareas",
    "mobile_tasks_add_followers": "Añadir seguidores",
    "mobile_tasks_followers": "Seguidores",
    "mobile_tasks_delete_task": "Eliminar tarea",
    "mobile_tasks_create_task": "Crear tareas",
    "mobile_tasks_tab_title_comments": "Comentarios",
    "mobile_tasks_see_more": "Ver más",
    "mobile_projects_create_project": "Crear proyecto",
    "mobile_common_button_send": "Enviar",
    "mobile_common_button_schedule": "Programación",
    "mobile_announcements_create": "Crear anuncio",
    "mobile_announcements_read_rate": "{{opened_count}} de {{recipients_count}} abiertos",
    "mobile_announcements_empty_message": "Todavía no ha creado ningún anuncio. Cree un anuncio a continuación para transmitir a su organización noticias, información y actualizaciones importantes.",
    "mobile_announcement_message_placeholder": "Añadir un mensaje...",
    "mobile_announcement_title_placeholder": "Título del anuncio",
    "mobile_announcement_leaving_announcement": "Abandonando anuncio",
    "mobile_announcement_confirm_recipients_team": "¿Desea difundir este anuncio a {{count}} usuario(s) de {{teams}} equipo(s) seleccionado(s)?",
    "mobile_announcement_confirm_recipients_role": "¿Desea difundir este anuncio a {{count}} usuario(s) de {{roles}} rol(es) de usuario(s) seleccionado(s)?",
    "mobile_announcement_confirm_recipients_user": "¿Desea difundir este anuncio a {{count}} usuario(s)?",
    "mobile_announcement_confirm_scheduled": "El {{timestamp}}",
    "mobile_announcement_sending_announcement": "Enviando anuncio",
    "mobile_announcement_send_to": "Enviar a",
    "mobile_announcement_sent_to": "Enviado a",
    "mobile_announcement_send_to_role": "Rol",
    "mobile_announcement_attachment_download": "Descargando {{filename}}",
    "mobile_announcement_attachment_validation_error": "No se pueden adjuntar más de {{maxCount}} archivos",
    "mobile_announcement_details_sent": "Enviado",
    "mobile_announcement_details_total_recipients": "Total de recibidos",
    "mobile_announcement_details_cancel": "Cancelar anuncio",
    "mobile_announcement_details_not_editable": "Los anuncios solo se pueden editar en la aplicación web Ops Execution. ",
    "mobile_announcement_details_not_editable_old": "Los anuncios solo se pueden editar en Zenput Web.",
    "mobile_announcement_details_open_count": "Conteo de abiertos",
    "mobile_announcement_details_open_rate": "Tasa de abiertos",
    "mobile_announcement_details_resend": "Reenviar a los que no se han abierto",
    "mobile_announcement_confirm_resend": "{{count}} usuarios no han leído el anuncio. ¿Quiere enviar un recordatorio?",
    "mobile_announcement_confirm_resend_title": "¿Enviar recordatorio?",
    "mobile_announcement_recipients_opened": "Abierto",
    "mobile_recipients_opened_empty_message": "Parece que nadie ha abierto su mensaje todavía. Vuelva más tarde para ver los resultados.",
    "mobile_announcement_recipients_unopened": "Sin abrir",
    "mobile_recipients_unopened_empty_message": "¡Buenas noticias! No tiene mensajes sin abrir.",
    "mobile_scheduled_announcements_delivery_section_header": "Hora de entrega",
    "mobile_scheduled_announcements_send_immediately_label": "Enviar de inmediato",
    "mobile_scheduled_announcements_scheduled_label": "Enviar a una hora específica",
    "mobile_scheduled_announcements_scheduled_tab_label": "Programado",
    "mobile_scheduled_announcements_dialog_header": "¿Desea cancelar el anuncio?",
    "mobile_scheduled_announcements_dialog_message": "Si cancela el anuncio, este dejará de enviarse y se eliminará de su lista. Esta acción no se podrá deshacer. Para editar el anuncio, utilice Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Actualmente no tiene ningún anuncio programado. Programe un anuncio para transmitir a su organización noticias, información y actualizaciones importantes.",
    "mobile_scheduled_announcements_validation_error": "La hora de entrega debe ser después del {{date}}.",
    "mobile_scheduled_announcements_empty_state_button": "Programar anuncio",
    "mobile_projects_auto_archive": "Archivar automáticamente",
    "mobile_common_unassigned": "Sin asignar",
    "mobile_tasks_title_placeholder": "Nueva tarea o formulario",
    "mobile_projects_leaving_project": "Abandonar proyecto",
    "mobile_projects_save_project": "Guardar proyecto",
    "mobile_top_triggers_tasks": "Principales tareas activadas",
    "mobile_top_triggers_alerts": "Principales alertas activadas",
    "mobile_projects_not_started": "Sin Iniciar",
    "mobile_empty_list_message_no_photos": "No hay fotos",
    "mobile_webfilestore_message_error": "Seleccione un tipo de archivo válido",
    "mobile_notifications_empty_title": "No hay notificaciones",
    "mobile_notifications_empty_message": "La actividad de sus tareas o de las que forma parte aparecerá aquí.",
    "mobile_comments_comment_deleted": "Este comentario se ha eliminado.",
    "mobile_comments_comment_placeholder": "Comentario",
    "mobile_comments_task_submitted_at": "Tarea enviada a {{ date }} a las {{ time }}",
    "mobile_comments_discard_comment_title": "¿Descartar comentario?",
    "mobile_comments_discard_confirm_message": "¿Está seguro? El comentario se eliminará.",
    "mobile_comments_delete_comment_title": "¿Eliminar comentario?",
    "mobile_comments_delete_confirm_message": "Esta acción no se puede deshacer.",
    "mobile_comments_delete_button": "Eliminar comentario",
    "mobile_comments_delete_success_message": "Comentario eliminado",
    "mobile_comments_empty_message_tasks": "Todavía no hay comentarios \n Inicie una conversación sobre esta tarea.",
    "mobile_comments_empty_message_submissions": "Todavía no hay comentarios \n Inicie una conversación sobre este envío.",
    "mobile_comments_empty_message_default": "Todavía no hay comentarios \n Inicie una conversación.",
    "mobile_comments_no_matching_users": "No coincide ningún usuario.",
    "mobile_comments_empty_users_to_notify": "No hay ningún usuario al que notificar.",
    "mobile_comments_users_cant_view_message": "Estos usuarios no pueden ver estos comentarios",
    "mobile_comments_users_to_notify_title": "Usuarios a los que notificar",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} usuario</a> recibirá una notificación.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} usuarios</a> recibirán una notificación.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mencione</a> más usuarios para notificarlos.",
    "mobile_comments_mark_read": "Marcar todos como leídos",
    "mobile_comments_author_mentioned_message": "le ha mencionado en",
    "mobile_comments_author_commented_message": "ha comentado sobre",
    "mobile_view_pdf": "Ver PDF",
    "mobile_no_pdf_generated_message": "No se ha encontrado ningún PDF para este envío. Le enviaremos una copia por correo electrónico pronto.",
    "mobile_clipboard_copied_success": "El enlace se ha copiado en el portapapeles.",
    "mobile_share_link": "Compartir enlace",
    "mobile_zencam_share": "Compartir",
    "mobile_zencam_view_details": "Ver detalles",
    "mobile_zencam_details_drawer_header": "Detalles",
    "mobile_zencam_submitted_by": "Enviado por ",
    "mobile_zencam_form_title": "Título de formulario",
    "mobile_zencam_date_submitted": "Fecha de envío",
    "mobile_oil_quality_warning_message": "Aceite a punto de caducar",
    "mobile_oil_quality_warning_message_subtitle": "Comience a planifcar cambiarlo pronto",
    "mobile_oil_quality_failure_message": "Calidad del aceite en riesgo",
    "mobile_oil_quality_failure_message_subtitle": "Cambie el aceite de inmediato",
    "mobile_sensors_set_up_gateway": "Configurar puerta de enlace",
    "mobile_sensors_set_up_gateway_message": "Al parecer no hay ningún dispositivo configurado. Para empezar, añada una puerta de enlace.",
    "mobile_sensors_gateway_plugged_in": "Asegúrese de que la puerta de enlace esté conectada a una toma de corriente",
    "mobile_sensors_add_device": "Añadir dispositivo",
    "mobile_sensors_name_this_gateway": "Asigne un nombre a esta puerta de enlace.",
    "mobile_sensors_name_this_sensor": "Asigne un nombre a este sensor.",
    "mobile_sensors_device_barcode_information": "Escanea el código QR o introduce el número de identificación y el número SC de la etiqueta del dispositivo",
    "mobile_sensors_device_eui_information": "Escanea el código QR o introduce el DevEUI de la etiqueta del dispositivo",
    "mobile_sensors_gateway_id_information": "Introduzca el identificador de nodo de la etiqueta de la puerta de enlace",
    "mobile_sensors_id_number": "{{untranslatedID}} Número",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Código",
    "mobile_sensors_sensors": "Sensores",
    "mobile_sensors_sensor_deveui_error": "No se pudo obtener el DevEUI con el QR. Por favor, introdúzcalo manualmente.",
    "mobile_sensors_gateways": "Puertas de enlace",
    "mobile_sensors_add_sensor": "Añadir sensor",
    "mobile_sensors_add_gateway": "Añadir puerta de enlace",
    "mobile_sensor_placement_description": "¿Qué área controlará este sensor?",
    "mobile_sensors_equipment_placement": "¿Qué área o equipo controlará este sensor?",
    "mobile_sensors_equipment": "¿Qué equipo controlará este sensor?",
    "mobile_sensors_select_gateway_type": "Seleccionar el tipo de puerta de enlace",
    "mobile_sensors_select_placement": "Seleccionar ubicación",
    "mobile_sensors_select_equipment": "Seleccionar equipo",
    "mobile_sensors_placement": "Ubicación",
    "mobile_sensors_nickname_tip": "El nombre del sensor viene determinado por los apodos asignados en la ubicación seleccionada.",
    "mobile_sensors_device_online": "Con conexión",
    "mobile_sensors_device_offline": "Sin conexión",
    "mobile_sensors_scan_qrcode": "Escanear el código de barras",
    "mobile_sensors_enter_manually": "Introducir manualmente",
    "mobile_sensors_wizard_step_one": "Paso 1",
    "mobile_sensors_wizard_step_two": "Paso 2",
    "mobile_sensors_wizard_step_three": "Paso 3",
    "mobile_sensors_wizard_step_four": "Paso 4",
    "mobile_sensors_wizard_step_five": "Paso 5",
    "mobile_sensors_wizard_step_six": "Paso 6",
    "mobile_sensors_initializing": "Iniciando...",
    "mobile_sensors_nickname": "Alias",
    "mobile_sensors_field_not_blank": "El campo {{field}} no puede dejarse en blanco.",
    "mobile_sensors_nothing_to_see_here": "Aquí no hay nada que ver",
    "mobile_sensors_missing_integration": "Falta la integración de los sensores",
    "mobile_sensors_contact_zenput_admin": "Ponte en contacto con el administrador de Ops Execution de su empresa.",
    "mobile_sensors_contact_zenput_admin_old": "Póngase en contacto con el administrador de Zenput.",
    "mobile_sensors_contact_manager": "Póngase en contacto con su gestor de cuentas para añadir sensores.",
    "mobile_sensors_device_success_message": "Puede que la carga de los datos del sensor tarde hasta 15 minutos",
    "mobile_sensors_last_reading": "Última lectura",
    "mobile_sensors_remove_device": "Suprimir dispositivo",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1S",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1A",
    "mobile_sensors_sensor_settings": "Ajustes del sensor",
    "mobile_sensors_remove_confirm_message": "¿Está seguro de que desea eliminar este dispositivo?\nEsta acción no puede deshacerse.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "No hay ningún equipo vinculado",
    "mobile_sensor_cooldown_process": "Proceso de enfriamiento",
    "mobile_sensor_last_12_hours": "Últimas 12 horas",
    "mobile_sensor_start_cooldown_process": "Iniciar nuevo proceso de enfriamiento",
    "mobile_sensor_cooldown_process_title": "Proceso de enfriamiento de dos fases",
    "mobile_sensor_cooldown_process_description": "Un proceso de enfriamiento de dos fases consiste en enfriar alimentos desde más de {{ stage1_start_temperature }} hasta los {{ stage1_end_temperature }} en dos horas o menos, y después desde los {{ stage1_end_temperature }} hasta los {{ stage2_end_temperature }} en cuatro horas o menos.",
    "mobile_sensor_cooldown_process_place_food": "Coloque el producto alimenticio en el refrigerador.",
    "mobile_sensor_cooldown_process_insert_sensor": "Introduzca una sonda del sensor en el producto alimenticio.",
    "mobile_sensor_cooldown_process_enter_information": "Introduzca la información a continuación.",
    "mobile_sensor_cooldown_process_food_product": "Producto alimenticio a enfriar",
    "mobile_sensor_cooldown_cool_down": "Enfriar",
    "mobile_sensor_cooldown_select_sensor": "Seleccionar sensor",
    "mobile_sensors_cooldown_start_cooldown": "Iniciar enfriamiento",
    "mobile_sensors_cooldown_please_enter_food": "Introduzca un alimento",
    "mobile_sensors_cooldown_please_select_sensor": "Seleccione un sensor",
    "mobile_sensors_cooldown_status_in_progress": "En curso",
    "mobile_sensors_cooldown_status_failed": "Fallido",
    "mobile_sensors_cooldown_status_success": "Correcto",
    "mobile_sensors_cooldown_stage": "Etapa",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "La temperatura de inicio está fuera del rango",
    "mobile_sensors_cooldown_failed_cooldown_process": "El proceso de enfriamiento ha fallado",
    "mobile_sensors_cooldown_cooldown_successful": "Enfriamiento correcto",
    "mobile_sensors_cooldown_started_cooldown_process": "Proceso de enfriamiento iniciado",
    "mobile_sensors_cooldown_hour": "hora",
    "mobile_sensors_cooldown_hour_plural": "horas",
    "mobile_sensors_cooldown_minute": "minuto",
    "mobile_minutes_plural": "minutos",
    "mobile_sensors_last_reading_max_date": "Hace > 1 año",
    "mobile_sensors_minute_count_ago": "Hace {{count}} minuto",
    "mobile_sensors_minute_count_ago_plural": "Hace {{count}} minutos",
    "mobile_sensors_hour_count_ago": "Hace {{count}} hora",
    "mobile_sensors_hour_count_ago_plural": "Hace {{count}} horas",
    "mobile_sensors_day_count_ago": "Hace {{count}} día",
    "mobile_sensors_day_count_ago_plural": "Hace {{count}} días",
    "mobile_sensors_chart_settings": "Ajustes del gráfico",
    "mobile_announcement_banner_continue_reading": "Continuar la lectura",
    "mobile_compliance_submissions_report": "Informe de envíos",
    "mobile_compliance_submissions_report_subtitle": "Exportar datos de finalización de proyecto para esta tienda",
    "mobile_compliance_send_submissions": "Enviar envíos",
    "mobile_compliance_completion_rate_in_last_days": "Tasa de finalización en los últimos {{ days }} días",
    "mobile_compliance_last_days": "Últimos {{ days }} días",
    "mobile_compliance_send_submissions_to": "Enviar envíos a",
    "mobile_compliance_send_to_different_email": "Enviar a un correo electrónico diferente",
    "mobile_compliance_email_input_placeholder": "Dirección de correo electrónico.",
    "mobile_compliance_send_submissions_to_legend_title": "Envíos",
    "mobile_compliance_send_submissions_to_legend_description_days": "Se enviará al correo electrónico seleccionado un informe con los envíos realizados desde esta ubicación en los últimos {{ days }} días.",
    "mobile_compliance_time_frame": "Período de tiempo",
    "mobile_compliance_sensor_temperature_log_report": "Informe de registro de la temperatura del sensor",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exportar registros de temperatura para esta tienda",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Criterios",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Defina a continuación los criterios de su informe.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Nota: En el informe no se mostrarán los sensores deshabilitados",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Seleccione un periodo de tiempo. Hay un límite máximo de 30 días para los datos de registro",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Enviar informe",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Este mes (1-Hoy)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Mes pasado",
    "mobile_compliance_sensor_temperature_log_email_title": "Enviar informe a",
    "mobile_pwa_update_prompt_title": "Actualización disponible",
    "mobile_pwa_update_prompt_description": "Está disponible una nueva versión de la aplicación. Actualice a la última versión.",
    "mobile_pwa_update_prompt_confirm": "Actualizar y recargar",
    "mobile_pwa_update_prompt_cancel": "Recordármelo más tarde",
    "notification_title_due_in_one_hour": "Vence en 1 hora",
    "task_is_due_soon": "'{{ task_title }}' está a punto de vencer. Tómese un momento para completarlo.",
    "mobile_photo_quality_warning_header": "Problema de calidad de la foto",
    "mobile_photo_quality_dialog_message": "Esta foto puede estar oscura o desenfocada. ¿Quiere hacer una foto nueva o continuar con esta?",
    "mobile_take_new_photo": "Hacer una foto nueva",
    "mobile_use_this_photo": "Usar esta foto"
}};
mobile_translations.ja_JP = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "すべて",
    "mobile_common_button_apply_filters": "フィルターを適用",
    "mobile_common_button_done": "完了",
    "mobile_common_button_edit": "編集",
    "mobile_common_button_archive": "アーカイブ",
    "mobile_common_button_save": "保存",
    "mobile_common_button_retake": "再取得",
    "mobile_common_button_save_draft": "下書きを保存",
    "mobile_common_button_discard": "破棄",
    "mobile_common_button_submit": "送信",
    "mobile_common_button_no": "いいえ",
    "mobile_common_button_yes": "はい",
    "mobile_common_button_na": "該当なし",
    "mobile_common_created_by_me": "自分が作成",
    "mobile_common_email": "会社メールアドレス",
    "mobile_common_first_name": "名",
    "mobile_common_last_name": "姓",
    "mobile_common_location": "場所",
    "mobile_common_locations": "場所",
    "mobile_common_logout_message": "ログアウトしてよろしいですか？",
    "mobile_common_password": "パスワード",
    "mobile_common_permission_required": "許可が必要です",
    "mobile_common_status": "ステータス",
    "mobile_common_task": "タスク",
    "mobile_common_tasks": "タスク",
    "mobile_common_tasks_my": "自分のタスク",
    "mobile_common_projects": "プロジェクト",
    "mobile_common_filter_team": "チーム",
    "mobile_common_filter_var_in": " {{team_or_location}}で",
    "mobile_common_filter_no_team_selected": "チームが選択されていません",
    "mobile_common_filter_no_user_selected": "ユーザーが選択されていません",
    "mobile_common_filter_no_role_selected": "ロールが選択されていません",
    "mobile_common_placeholder_date": "日付",
    "mobile_common_message_task_creator_error_save": "<b>タスクを作成できませんでした。</b>",
    "mobile_common_camera": "カメラ",
    "mobile_common_microphone": "マイク",
    "mobile_common_for": "対象：",
    "mobile_common_reload": "再読み込み",
    "mobile_common_override": "上書き",
    "mobile_common_notifications": "通知",
    "mobile_common_chat_unavailable": "チャットを利用できません。後でもう一度やり直してください。",
    "mobile_common_chat_ending_dialog_title": "この会話は終了しましたか？",
    "mobile_common_chat_ending_dialog_description": "問題が解決されたかどうか、または後で続行するかどうかをお知らせください。",
    "mobile_common_chat_ending_dialog_confirm": "はい、終了しました",
    "mobile_common_chat_ending_dialog_cancel": "また、後ほど続けます",
    "mobile_common_continue_editing": "編集を続ける",
    "mobile_privacy_policy": "プライバシーポリシー",
    "wootric_recommend_target": "業界の友人または同僚",
    "wootric_followup_detractor_question": "Zenputがどのような変更をすると次回は高く評価しようと思いますか？",
    "wootric_followup_passive_question": "ありがとうございます。ツールをさらに改善するためにZenputは何をすべきと思いますか？",
    "wootric_followup_promoter_question": "ありがとう！『Crunchtime Ops Execution』のどんなところが気に入っていますか？",
    "wootric_followup_promoter_question_old": "ありがとうございます。Zenputのどのような点がよいと思いますか？",
    "wootric_default_followup_question": "ありがとうございます。理由を教えていただけますか？",
    "wootric_default_placeholder_text": "今後の参考に、スコアについて説明していただけますか。",
    "wootric_default_thankyou_text": "回答とフィードバックをお寄せいただきありがとうございました。",
    "mobile_login_placeholder_login_as": "ユーザーIDとしてログイン",
    "mobile_login_button_forgot_password": "パスワードを忘れた場合",
    "mobile_login_button_sign_up": "アカウントを作成",
    "mobile_login_button_finish_setup": "設定の終了",
    "mobile_login_button": "ログイン",
    "mobile_login_continue_button": "続ける",
    "mobile_login_continue_transition": "組織のログインページに遷移しています...",
    "mobile_login_no_email_error": "メールアドレスは入力必須です。",
    "mobile_login_change_email": "別のメールアドレスでログイン",
    "mobile_login_with_sso": "SSOでログイン",
    "mobile_oauth_no_user_error_message": "Crunchtime Ops Executionのアカウントをお持ちではないようですね！",
    "mobile_oauth_no_user_error_message_old": "Zenputアカウントをお持ちでないようです。",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b>は、<b>Crunchtime Ops Execution</b>に名称を変更しました。",
    "mobile_rebrand_warning_banner": "{{- brand }} は9月に {{- product }} をリリースします。 {{- cta }}",
    "mobile_rebrand_warning_cta": "準備方法をご確認ください。",
    "mobile_oauth_no_user_error_sub_message": "管理者にアクセス方法を問い合わせるか、別のメールアドレスでログインを試してください。",
    "mobile_oauth_generic_error_message": "ログインに問題があるようです。もう一度お試しください。",
    "mobile_oauth_force_logout_msg": "問題が解決しない場合は、プロバイダーからログアウトするために ",
    "mobile_oauth_force_logout_click": "こちらをクリックしてください。",
    "mobile_sign_up_placeholder_phone": "携帯電話番号",
    "mobile_sign_up_placeholder_password_confirm": "パスワードの確認",
    "mobile_sign_up_button_sign_in": "サインイン",
    "mobile_sign_up_disclaimer_part_1": "「カウントを作成」をクリックすると、",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "「設定の終了」をクリックすると、",
    "mobile_sign_up_disclaimer_link_title": " 使用許諾契約書",
    "mobile_sign_up_disclaimer_part_2": "に同意したことになります。この文書にはプライバシーに関する重要な情報が記載されています。",
    "mobile_dialog_benefits_work_offline": "オフラインで作業",
    "mobile_dialog_benefits_faster_uploads": "高速アップロード",
    "mobile_dialog_benefits_better_experience": "優れたエクスペリエンス",
    "mobile_dialog_benefits_button_download": "ダウンロード",
    "mobile_dialog_benefits_button_download_bold": "のOps Execution ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput は ",
    "mobile_dialog_benefits_button_have": "すでにアプリを持っています。",
    "mobile_dialog_benefits_button_no_thanks": "今は結構です。",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "画像を読み込めませんでした。",
    "mobile_dialog_signature_sign": "ここに署名",
    "mobile_dialog_signature_button_clear": "クリア",
    "mobile_account_placeholder_name": "場所／店舗名",
    "mobile_account_placeholder_phone": "電話番号",
    "mobile_account_placeholder_address": "住所",
    "mobile_account_placeholder_city": "市区町村",
    "mobile_account_placeholder_region": "地域",
    "mobile_account_placeholder_zipcode": "郵便番号",
    "mobile_account_option_select_country": "国を選択",
    "mobile_account_oprion_us": "米国",
    "mobile_account_oprion_select_state": "州を選択",
    "mobile_account_button_create_location": "場所を作成",
    "mobile_form_message_no_form": "使用できるフォームがありません",
    "mobile_batch_task_message": "読み込んでいます...",
    "mobile_settings_profile": "プロフィール",
    "mobile_settings_profile_number": "携帯電話",
    "mobile_settings_profile_language": "言語",
    "mobile_settings_profile_temperature_unit": "温度単位",
    "mobile_settings_profile_use_company_default": "会社のデフォルトを使用する",
    "mobile_settings_profile_celsius": "摂氏",
    "mobile_settings_profile_fahrenheit": "華氏",
    "mobile_settings_notifications_option_sms": "テキストメッセージ",
    "mobile_settings_notifications_option_push": "プッシュ通知",
    "mobile_settings_notifications_option_push_email": "メール通知とプッシュ通知",
    "mobile_settings_notifications_option_do_not": "通知しない",
    "mobile_settings_notifications_category_communication": "コミュニケーション",
    "mobile_settings_notifications_category_forms_and_triggers": "フォーム&トリガー",
    "mobile_settings_devices": "デバイス",
    "mobile_settings_notifications_sub_category_alerts": "アラート",
    "mobile_settings_notifications_sub_category_new_forms_available": "新規フォームを利用できます",
    "mobile_settings_notifications_sub_category_task_assigned": "タスクが割り当てられました",
    "mobile_settings_notifications_sub_category_task_completed": "タスクを完了",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "タスク期限間近リマインダー",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "タスク期限超過リマインダー",
    "mobile_settings_notifications_sub_category_sensor_alerts": "センサーアラート",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "クリティカルセンサーアラート",
    "mobile_drafts_message": "まだ下書きがありません。",
    "mobile_drafts_button_delete": "削除",
    "mobile_tasks_filter_location_no": "場所が選択されていません",
    "mobile_tasks_filter_group_by": "グループ化条件",
    "mobile_tasks_filter_sort_by": "並べ替え条件",
    "mobile_tasks_filter_sorted_by": "並べ替え条件",
    "mobile_tasks_filter_due_time": "期限時刻",
    "mobile_tasks_filter_open_time": "開店時間",
    "mobile_tasks_bucket_due_next_24_hours": "期日は24時間後です",
    "mobile_tasks_bucket_due_next_7_days": "期日は7日後です",
    "mobile_tasks_bucket_open_tasks": "追加の進行中の{{type}}",
    "mobile_tasks_bucket_open_at": "進行中： {{- date }}、{{- time }}",
    "mobile_tasks_bucket_due_by_at": "期日： {{- date }}、{{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "1分間、利用できます",
    "mobile_tasks_bucket_available_in_one_hour": "1時間、利用できます",
    "mobile_tasks_bucket_available_in_one_day": "1日、利用できます",
    "mobile_tasks_bucket_available_in_one_week": "1週間、利用できます",
    "mobile_tasks_bucket_available_in_one_month": "1か月、利用できます",
    "mobile_tasks_bucket_available_in_one_year": "1年、利用できます",
    "mobile_tasks_bucket_available_in_minutes": "{{ minutes }}分間、利用できます",
    "mobile_tasks_bucket_available_in_hours": "{{ hours }}時間、利用できます",
    "mobile_tasks_bucket_available_in_days": "{{ days }}日、利用できます",
    "mobile_tasks_bucket_available_in_weeks": "{{ weeks }}週間、利用できます",
    "notification_task_due_in_minutes": "期限：{{ minutes }}分後",
    "mobile_tasks_bucket_available_in_months": "{{ months }}か月、利用できます",
    "mobile_tasks_bucket_available_in_years": "{{ years }}年、利用できます",
    "mobile_tasks_follow_up": "タスクのフォローアップ",
    "mobile_tasks_due_soon": "まもなく期日",
    "mobile_tasks_bucket_completed_today": "今日完了済み",
    "mobile_tasks_bucket_completed_this_week": "今週完了済み",
    "mobile_tasks_bucket_completed_last_week": "先週完了済み",
    "mobile_tasks_bucket_missed_today": "今日未完了",
    "mobile_tasks_bucket_missed_this_week": "今週未完了",
    "mobile_tasks_bucket_missed_last_week": "先週未完了",
    "mobile_tasks_bucket_no_location": "場所がありません",
    "mobile_tasks_cannot_submit_missed": "未完了のタスクを完了できません",
    "mobile_tasks_cannot_submit_missed_after": "このタスクは{{ date }}を過ぎると完了できません",
    "mobile_tasks_cannot_submit_upcoming": "タスクが開始されていません。",
    "mobile_tasks_cannot_submit_processing": "この送信は進行中です",
    "mobile_tasks_toolbarnav_header_no_due_date": "期日はありません",
    "mobile_tasks_toolbarnav_header_overdue": "期限を過ぎています",
    "mobile_tasks_toolbarnav_header_yesterday": "昨日",
    "mobile_tasks_toolbarnav_header_today": "今日",
    "mobile_tasks_toolbarnav_header_tomorrow": "明日",
    "mobile_tasks_toolbarnav_header_last_week": "先週",
    "mobile_tasks_toolbarnav_header_this_week": "今週",
    "mobile_tasks_toolbarnav_header_next_week": "来週",
    "mobile_tasks_toolbarnav_header_this_month": "今月",
    "mobile_tasks_toolbarnav_header_next_year": "来年",
    "mobile_tasks_toolbarnav_header_over_year": "1年以上先",
    "mobile_tasks_toolbarnav_title_edit_task": "タスクを編集",
    "mobile_task_placeholder_title": "タイトル*",
    "mobile_task_placeholder_description": "説明（任意）",
    "mobile_task_button_single_task": "単一のタスク",
    "mobile_task_button_project": "プロジェクト",
    "mobile_task_button_create": "作成",
    "mobile_task_tab_basic": "基本",
    "mobile_task_tab_photo": "写真",
    "mobile_task_tab_form": "フォーム",
    "mobile_task_details_description_message_please": "以下に ",
    "mobile_task_details_description_message_below": "入力してください。",
    "mobile_task_details_description_message_instructions": "このタスクで使用できる指示がありません。",
    "mobile_task_details_reason_title": "フォローアップのトリガー条件",
    "mobile_task_detials_button_goto_form": "フォームに移動",
    "mobile_task_detials_button_complete": " タスクを完了",
    "mobile_task_detials_completed": "完了済み ",
    "mobile_task_detials_completed_by": "完了者 ",
    "mobile_task_detials_completed_on": "完了日 ",
    "mobile_task_details_view_form_submission": "フォーム送信を表示",
    "mobile_task_task_updated": "タスクが更新されました",
    "mobile_task_task_archived": "タスクがアーカイブされました",
    "mobile_task_task_deleted": "タスクが削除されました",
    "mobile_task_error_archiving_task": "タスクをアーカイブできませんでした。",
    "mobile_task_error_deleting_task": "タスクを削除できませんでした。",
    "mobile_task_error_updating_task": "タスクを更新できませんでした。",
    "mobile_task_archive_task": "タスクをアーカイブ",
    "mobile_task_archive_task_confirm": "このタスクをアーカイブしてよろしいですか？\n\nアーカイブしたタスクは完了率にカウントされ、レポートに引き続き表示されます。\n\nこの操作は取り消すことができません。",
    "mobile_task_delete_task_confirm": "このタスクを削除してよろしいですか？\n\n削除したタスクは完了率にはカウントされず、レポートにも表示されません。\n\nこの操作は取り消すことができません。",
    "mobile_task_edition_already_in_progress": "このタスクには保留中の編集があります。現時点ではさらに編集することはできません。",
    "mobile_projects_filter_type": "タイプ",
    "mobile_projects_filter_status": "プロジェクトのステータス",
    "mobile_projects_filter_project_type": "プロジェクトタイプ",
    "mobile_projects_due_date_required": "期日は必須です。",
    "mobile_projects_team_required": "チームは必須です。",
    "mobile_projects_user_role_required": "割り当て先担当者は必須です。",
    "mobile_projects_title_required": "タイトルは必須です。",
    "mobile_projects_recurring_multiple_tasks_per_day": "複数のタスク／日",
    "mobile_project_tasks_complete": " 完了",
    "mobile_project_tasks_remaining": " 残り",
    "mobile_esitmate_message_tasks": "0のタスクが作成されます",
    "mobile_esitmate_message_criteria": "上記の条件を調整",
    "mobile_esitmate_message_created_for": "が次に対して作成されます：",
    "mobile_left_menu_dashboard": "ダッシュボード",
    "mobile_left_menu_my_forms": "自分のフォーム",
    "mobile_left_menu_announcements": "アナウンス",
    "mobile_left_menu_my_submissions": "自分の送信",
    "mobile_left_menu_drafts": "下書き",
    "mobile_left_menu_pending_uploads": "保留中のアップロード",
    "mobile_left_menu_open": "アプリで開く",
    "mobile_left_menu_settings": "設定",
    "mobile_left_menu_log_out": "ログアウト",
    "mobile_left_menu_debug": "デバッグ",
    "mobile_left_menu_support": "サポート",
    "mobile_left_menu_documentation": "ドキュメント",
    "mobile_left_menu_chat": "チャット",
    "mobile_field_textarea_placeholder_note": "メモ／キャプション",
    "mobile_field_option_select": "選択",
    "mobile_field_text_placeholder_text": "テキスト",
    "mobile_field_email_placehoder_email": "メールアドレス",
    "mobile_filed_number_placeholder_number": "番号",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "接続されていません",
    "mobile_field_sensor_offline_battery": "センサーオフライン：バッテリー",
    "mobile_field_video_button_add": "ビデオを追加",
    "mobile_field_video_picker_dialog_title": "次からビデオを追加：",
    "mobile_field_video_button_change": "ビデオを変更",
    "mobile_field_image_button_add": "画像を追加",
    "mobile_field_image_low_quality_warning": "暗すぎたり、ぼやけている写真がある可能性があります。強調表示されている写真を確認し、必要に応じて置き換えてください",
    "mobile_field_image_picker_dialog_title": "次から写真を追加：",
    "mobile_field_image_picker_edit_failed": "画像を保存できませんでした。もう一度やり直してください。",
    "mobile_field_signature_button_add": "署名を追加",
    "mobile_field_signature_button_change": "署名を変更",
    "mobile_field_account_select_location": "場所を選択",
    "mobile_field_account_prefill": "前回の訪問のデータをフォームに自動入力しますか？",
    "mobile_field_account_message_overwrite": "この操作により、入力済みのフィールドはすべて上書きされます。",
    "mobile_forms_task_on_behalf": "この場所で実施するタスクがあり、<b>{{user}}</b>に割り当てられています。このタスクを完了しますか？",
    "mobile_forms_complete_task": "タスクを完了しますか？",
    "mobile_field_account_prefill_button_yes": "自動入力する",
    "mobile_field_barcode_placeholder_scan": "バーコードをスキャンするか入力する",
    "mobile_field_sensor_qr_code_placeholder_scan": "コードをスキャンするか入力してください",
    "mobile_field_gateway_id_code_placeholder": "ノードIDを入力",
    "mobile_field_scan_qr_or_enter_dev_eui": "QRコードをスキャンするかDevEUIを入力してください",
    "mobile_field_scan_qr_or_enter_id": "QRコードをスキャンするかID番号を入力してください",
    "mobile_field_scan_qr_or_enter_sc": "QRコードをスキャンするかSCコードを入力してください",
    "mobile_field_barcode_select_date": "日付を選択 ",
    "mobile_field_datetime_allow_time": "時刻",
    "mobile_field_stopwatch_button_caption": "ストップウォッチ",
    "mobile_field_stopwatch_common_start": "開始",
    "mobile_field_stopwatch_common_stop": "停止",
    "mobile_field_stopwatch_common_reset": "リセット",
    "mobile_field_stopwatch_stop_stopwatches": "ストップウォッチを停止",
    "mobile_field_document_title": "ドキュメントを追加",
    "mobile_field_document_message_delete": "このドキュメントを削除してよろしいですか？",
    "mobile_field_document_alret_button_view": "表示",
    "mobile_field_document_alert_error": "このドキュメントを添付するときにエラーが発生しました。もう一度やり直してください。",
    "mobile_field_document_alert_file_size_error": "ファイルは{{count}} MB以下である必要があります。",
    "mobile_field_temperature_greater_range": "{{ temp_value }} °{{ temp_unit }}超",
    "mobile_field_temperature_greater_or_equal_range": "{{ temp_value }} °{{ temp_unit }}以上",
    "mobile_field_temperature_less_range": "{{ temp_value }} °{{ temp_unit }}未満",
    "mobile_field_temperature_less_or_equal_range": "{{ temp_value }} °{{ temp_unit }}以下",
    "mobile_field_temperature_between_range": "{{ min_temp_value }} °{{ temp_unit }}以上、{{ max_temp_value }} °{{ temp_unit }}未満",
    "mobile_field_temperature_inclusive_between_range": "{{ min_temp_value }} °{{ temp_unit }}以上、{{ max_temp_value }} °{{ temp_unit }}以下",
    "mobile_field_temperature_operators_separator": " および ",
    "mobile_field_text_limit_error": "最大文字数制限の 8000 に達しました。",
    "mobile_forms_required_questions_complete": "完了が必要",
    "mobile_forms_required_remaining": "{{count}}はまだ入力が必要",
    "mobile_forms_required_questions_back": "戻る",
    "mobile_forms_required_questions_next": "次へ",
    "mobile_forms_required_questions_skip": "スキップ",
    "mobile_forms_leaving_form": "フォームを離れる",
    "mobile_message_reordering_confirm": "新しい質問の順序を保存しますか？",
    "mobile_forms_leaving_reordering": "質問の並べ替えを離れる",
    "mobile_forms_reordering_button_save": "新しい質問の順序を保存",
    "mobile_forms_reordering_instructions": "質問やセクションを並べ替えるには、フォームで表示する場所までドラッグアンドドロップします",
    "mobile_toolbarnav_title_my_setttings": "自分の設定",
    "mobile_toolbarnav_title_profile_settings": "プロフィール設定",
    "mobile_toolbarnav_title_notification": "通知設定",
    "mobile_toolbarnav_title_form_history": "フォーム履歴",
    "mobile_toolbarnav_title_form_not_available": "フォームを使用できません",
    "mobile_toolbarnav_title_add_location": "場所を追加",
    "mobile_toolbarnav_title_add_task_or_project": "タスクまたはプロジェクトを追加",
    "mobile_toolbarnav_title_select_location": "場所を選択",
    "mobile_toolbarnav_title_select_project": "プロジェクトを選択",
    "mobile_toolbarnav_title_select_tag": "タグを選択",
    "mobile_toolbarnav_title_select_user": "ユーザーを選択",
    "mobile_toolbarnav_title_select_template": "テンプレートを選択",
    "mobile_toolbarnav_title_select_one": "1つ選択",
    "mobile_toolbarnav_title_select_multiple": "1つ以上選択",
    "mobile_toolbarnav_title_select_team": "チームを選択",
    "mobile_toolbarnav_title_select_team_or_location": "チームまたは場所を選択",
    "mobile_toolbarnav_title_filter_tasks": "タスクをフィルター",
    "mobile_toolbarnav_title_filter_projects": "プロジェクトをフィルター",
    "mobile_toolbarnav_title_filter_project_tasks": "プロジェクトタスクをフィルター",
    "mobile_placeholder_search_bar": "検索",
    "mobile_placeholder_user_select_role": "ユーザーロールを選択",
    "mobile_placeholder_filter_by_team": "チームでフィルター",
    "mobile_placeholder_assign_to_user_role": "ユーザーロールに割り当てる",
    "mobile_placeholder_select": "-- 選択 --",
    "mobile_placeholder_account_location_name": "場所名",
    "mobile_placeholder_tag_filter_by": "場所タグで絞り込む",
    "mobile_placeholder_user_type": "ユーザーに割り当てる",
    "mobile_placeholder_acount_type_loading": "読み込んでいます... ",
    "mobile_placeholder_therm_no_bluetooth": "温度",
    "mobile_placeholder_blue_therm_connecting": "デバイスに接続しています...",
    "mobile_placeholder_blue_therm_please_wait": "お待ちください...",
    "mobile_placeholder_blue_therm_tap": "読み取るにはタップしてください。",
    "mobile_placeholder_blue_therm_not_connected": "接続されていません。",
    "mobile_placeholder_testo_tap": "▼▲を長押ししてから⬆を長押ししてください",
    "mobile_message_error_create_task": "タスクを追加するにはオンラインである必要があります。",
    "mobile_message_error_fill_out_form": "フォームに入力してください。",
    "mobile_message_error_fill_require_fields": "必須フィールドに入力してください。",
    "mobile_message_error_stop_stopwatch_before_submit": "送信する前にストップウォッチを停止してください",
    "mobile_message_error_stopwatch_field_required": "ストップウォッチフィールドは必須です",
    "mobile_message_error_stopwatch_field_running": "ストップウォッチフィールドが実行中です",
    "mobile_message_error_invalid_equipment_temperature": "機器の温度が無効です",
    "mobile_message_error_invalid_ingredient_temperature": "材料の温度が無効です",
    "mobile_message_error_location_attributes_unavailable": "使用できない質問がある可能性があります。インターネットに接続してください",
    "mobile_message_alert_running_stopwatches": "ストップウォッチが実行中です。\n\nストップウォッチをクリアしますか？",
    "mobile_message_blue_therm_error": "Bluetoothデバイスへの接続が失われました",
    "mobile_message_blue_therm_no_permission_android_pre_12": "「ロケーション」へのアクセスが必要です。Androidの設定で有効にしてください。",
    "mobile_message_blue_therm_no_permission_android": "「周辺のデバイス」へのアクセスが必要です。Androidの設定で有効にしてください。",
    "mobile_message_blue_therm_error_code": "接続に失敗：",
    "mobile_message_blue_therm_error_bluetooth": "Bluetoothを有効にしてください。",
    "mobile_message_blue_therm_error_device": "デバイスが見つかりません。",
    "mobile_message_blue_therm_error_try_again": "もう一度やり直してください。",
    "mobile_message_blue_therm_success": "Bluetoothデバイスが接続されました。",
    "mobile_message_bluetooth_device_press_button_field": "デバイスのボタンを押して接続してください。",
    "mobile_message_bluetooth_device_press_button_devices_list": "ここに記載されていない場合は、<br />デバイスのボタンを押してください。",
    "mobile_bluetooth_scan": "スキャン",
    "mobile_bluetooth_scanning": "スキャン中",
    "mobile_message_drafts_confirm": "これを下書きとして保存しますか？",
    "mobile_message_drafts_toast_saved": "下書きが保存されました。",
    "mobile_message_drafts_request_update": "この下書きを更新しますか？",
    "mobile_message_drafts_form_confirm": "この下書きを削除してよろしいですか？",
    "mobile_message_drafts_confirm_delete": "下書きを削除",
    "mobile_message_streams_error_switch": "Webのストリームは変更できません",
    "mobile_message_settings_success_saved": "設定が保存されました",
    "mobile_message_settings_error": "不明なエラーが発生しました。後でもう一度やり直してください",
    "mobile_message_profile_settings_error_fields": "強調表示されているフィールドを修正してください。",
    "mobile_message_media_perimission_denied": "あなたの ",
    "mobile_message_media_perimission_denied_device": "デバイスのストレージ",
    "mobile_message_image_confirm_remove_image": "この写真を削除してよろしいですか？",
    "mobile_message_create_account_error_fields": "強調表示されているフィールドに入力してください。",
    "mobile_message_create_account_success_location_created": "場所が作成されました",
    "mobile_message_task_error_get_location": "場所を取得できませんでした。日付でソートしています。",
    "mobile_message_typehead_confirm_save_message": "これらの選択内容を保存しますか？",
    "mobile_message_typehead_confirm_save_title": "保存しますか？",
    "mobile_message_task_creator_error_save_select_form": "フォームを選択する必要があります。",
    "mobile_message_task_creator_error_save_required_fields": "必須フィールドに入力してください。",
    "mobile_message_task_creator_error_save_batch_change": "ユーザーに一致するように条件を変更してください",
    "mobile_message_task_detials_error_not_assigned_to_you": "このタスクはあなたに割り当てられていません。<br />あなたがこのタスクを完了することはできません。",
    "mobile_message_task_detials_error_assigned_to": "このタスクは{{user}}に割り当てられています。<br />あなたがこのタスクを完了することはできません。",
    "mobile_message_task_detials_confirm_title": "タスクを離れる",
    "mobile_message_task_detials_confirm_save_task": "タスクを保存",
    "mobile_message_task_detials_confirm_message": "実行してよろしいですか？変更内容は失われます。",
    "mobile_message_task_detials_error_view_account": "場所にアクセスできません。",
    "mobile_message_task_detials_error_submit_task": "このタスクを完了するには、写真を追加してください。",
    "mobile_message_task_detials_error_submit_task_project": "プロジェクトを保存できません。後でもう一度やり直してください。",
    "mobile_message_task_detials_wait_submit_task_created": "タスクを作成中です。<br />タスクに情報が入力されるまで数分お待ちください。",
    "mobile_message_task_detials_error_submit_task_pending": "エラーが発生しました。後でもう一度やり直してください",
    "mobile_message_task_detials_success_task_complete": "タスクを完了",
    "mobile_message_task_error_save_single_task": "タスクを保存できません。後でもう一度やり直してください。",
    "mobile_message_task_success_save_single_task": "タスクが作成されました。",
    "mobile_message_show_error_message": "問題が発生しました。",
    "mobile_message_show_success_message": "正常に実行されました",
    "mobile_message_show_offline_message": "現在オフラインです。",
    "mobile_message_show_permission_denied_message": "<b>アクセス許可が必要です。</b>Zenputに{{permission_name}}へのアクセス許可を付与してください。",
    "mobile_message_show_permission_denied_message_web": "<b>アクセス許可が必要です。</b>Zenputとご使用のブラウザに{{permission_name}}へのアクセス許可を付与してください。",
    "mobile_message_show_begin_uploading_message": "アップロードしています",
    "mobile_message_show_upload_in_progress_message": "アップロードがすでに進行中です",
    "mobile_message_show_form_id_error": "指定されたフォームにアクセスできません。",
    "mobile_message_show_single_task_error": "指定されたタスクにアクセスできません。",
    "mobile_message_show_submissions_error": "指定された送信にアクセスできません。",
    "mobile_message_show_submissions_access_denied": "このフォームへのアクセス権限がありません。",
    "mobile_message_send_data_success": "データのアップロードが完了しました ",
    "mobile_message_start_upload_success": "アップロード完了",
    "mobile_message_start_upload_error": "<b>アップロードを完了できませんでした。</b><br>送信は保存されました。後でもう一度やり直してください",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Playストア",
    "mobile_message_store_upgrade_confirm_title": "アップデートを利用できます",
    "mobile_message_store_upgrade_confirm_message_one": "「Ops Execution」アプリを、以下の場所から更新してください。 ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Zenputを ",
    "mobile_message_store_upgrade_confirm_message_two": " からアップデートして、すべての新機能と修正プログラムを入手してください。",
    "mobile_message_store_upgrade_confirm_now": "今すぐ",
    "mobile_message_store_upgrade_confirm_later": "後で",
    "mobile_message_redirect_confirm_message": "フォームに入力中です。続行する前に、これを下書きとして保存しますか？",
    "mobile_message_log_out_confirm_unsynced_drafts": "アップロードしていない{{count}}件の下書きがあります。続行するとこれらは失われます。よろしいですか？",
    "mobile_message_draft_override_message": "この下書きは{{date}}に別のデバイスから保存されたもので、このデバイスでの変更内容と競合しています。既存のバージョンを上書きするか、再読み込みして最新バージョンにすることができます。再読み込みすると、現在の変更内容は破棄されます。",
    "mobile_html_submitting": "送信しています...",
    "mobile_html_offline": "現在オフラインです。",
    "mobile_html_offline_try_again": "現在オフラインです。<br/><br/>接続してからやり直してください",
    "mobile_html_something_went_wrong": "問題が発生しました。",
    "mobile_html_something_went_wrong_try_again": "問題が発生しました。もう一度やり直してください。",
    "mobile_html_failed_loading_roles": "ロールを読み込めませんでした。",
    "mobile_alert_please_install_for_native": "この機能をご利用いただくには、「Ops Execution」アプリをインストールしてください。 ",
    "mobile_alert_please_install_for_native_old": "この機能を使用するには、ネイティブのZenputアプリをインストールしてください。",
    "mobile_tso_filter_all_tasks": "すべての{{type}}",
    "mobile_tso_filter_my_tasks": "自分の{{type}}",
    "mobile_tso_filter_due_date": "期日",
    "mobile_tso_filter_date_completed": "完了日",
    "mobile_tso_filter_completed": "完了済み",
    "mobile_tso_filter_completed_late": "遅れて完了",
    "mobile_tso_filter_incomplete": "未完了",
    "mobile_tso_filter_var_my_tasks": "自分の{{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "自分が作成した{{filter_type}} {{type}}",
    "mobile_tso_filter_var_all_tasks": "すべての{{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "フォローアップアクション",
    "mobile_tso_type_all": "タスクとフォローアップアクション",
    "mobile_tso_filter_var_at": " 場所：{{location}}",
    "mobile_tso_filter_group_date_due": "（期日順にソート）",
    "mobile_tso_filter_group_distance": "（場所でグループ化）",
    "mobile_tso_filter_start_date": "開始日",
    "mobile_tso_filter_none": "なし",
    "mobile_pso_filter_all_projects": "すべてのプロジェクト",
    "mobile_pso_filter_my_projects": "自分のプロジェクト",
    "mobile_pso_filter_active": "アクティブ",
    "mobile_pso_filter_archived": "アーカイブ済み",
    "mobile_pso_filter_recurring": "定期",
    "mobile_pso_filter_non_recurring": "不定期",
    "mobile_pso_filter_var_my_projects": "自分の{{project_type}} {{active_description}}プロジェクト",
    "mobile_pso_filter_var_my_created_projects": "自分が作成した{{project_type}} {{active_description}}プロジェクト",
    "mobile_pso_filter_var_all_projects": "すべての{{project_type}} {{active_description}}プロジェクト",
    "mobile_empty_list_message_must_be_online": "現在オフラインのようです。結果を見るにはオンラインである必要があります。",
    "mobile_empty_list_message_no_submissions": "送信はありません",
    "mobile_empty_list_message_no_activity": "アクティビティはありません",
    "mobile_empty_list_message_no_tasks": "タスクはありません",
    "mobile_empty_list_message_no_tasks_overdue": "期限を超過した{{type}}はありません",
    "mobile_empty_list_message_no_accounts": "場所はありません",
    "mobile_empty_list_message_no_projects": "プロジェクトはありません",
    "mobile_empty_list_message_no_results_found": "結果が見つかりませんでした",
    "mobile_empty_list_message_no_forms_available": "使用できるフォームがありません",
    "mobile_empty_list_message_connection_error": "接続エラー<br />もう一度やり直してください。",
    "mobile_empty_list_message_dashboard_error": "ダッシュボードを読み込めませんでした",
    "mobile_empty_list_message_user_offline": "現在オフラインです",
    "mobile_action_sheet_media_gallery": "ギャラリー",
    "mobile_action_sheet_cancel": "キャンセル",
    "mobile_image_preview_text": "写真を削除",
    "mobile_mobileform_text": "以前の送信",
    "mobile_mobileform_reorder_fields": "質問を並べ替える",
    "mobile_mobileform_follow_up_actions": "フォローアップアクション",
    "mobile_mobileform_follow_up_actions_assign_title": "フォローアップアクションを割り当てる",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "問題に対処するため、所見に基づいてフォローアップアクションを追加してください。",
    "mobile_mobileform_follow_up_actions_add_button": "+ フォローアップアクションを追加",
    "mobile_mobileform_follow_up_actions_assign_button": "フォローアップを割り当てる",
    "mobile_mobileform_follow_up_actions_without_assign_button": "割り当てずに続ける",
    "mobile_mobileform_follow_up_actions_dialog_title": "フォローアップアクションを割り当てずに続けますか？",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "フォローアップアクションを割り当てずに続行すると、後でアクションを割り当てることはできません。",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "そのまま続ける",
    "mobile_mobileform_add_follow_up_actions_forms_required": "このフィールドは必須です",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "文字が多すぎます",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "このフィールドは無効です",
    "mobile_mobileform_add_follow_up_actions_error_locations": "場所の読み込みエラーです",
    "mobile_mobileform_add_follow_up_actions_error_users": "ユーザーの読み込みエラーです",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "フォローアップを追加",
    "mobile_mobileform_add_follow_up_actions_forms_title": "タイトル",
    "mobile_mobileform_add_follow_up_actions_forms_description": "説明",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "写真が必要",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "期日",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "フォローアップを更新",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "フォローアップを削除しますか？",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "これは削除され、割り当てられません。",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "フォローアップを削除",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "このフォローアップを削除してよろしいですか？\n\nこの操作は取り消すことができません。",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "フォローアップを続ける",
    "mobile_mobileform_follow_up_actions_completed_notification": "フォローアップアクションが完了しました",
    "mobile_mobileform_follow_up_actions_deleted_notification": "フォローアップアクションが削除されました",
    "mobile_mobileform_follow_up_actions_update_notification": "フォローアップアクションが更新されました",
    "mobile_mobileform_follow_up_actions_required_photo_error": "このフォローアップアクションを完了するには、写真を追加してください",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "送信まで移動",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "ソースへ移動",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "ソース",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "フォローアップを完了",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "送信を開くと、保存されていない写真とメモが失われます。",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "この画面を閉じると、保存されていない写真やメモはすべて失われます。",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "ここに留まる",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "送信を開く",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "ソースを開く",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "このフォローアップアクションを残しますか？",
    "mobile_mobileform_follow_up_actions_submission": "送信",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "このフォローアップアクションは{{user}}に割り当てられています。<br />あなたが完了することはできません。",
    "mobile_mobileform_follow_up_actions_leave_description": "この画面を閉じると、保存されていない変更内容はすべて失われます。",
    "mobile_mobileform_follow_up_actions_leave": "閉じる",
    "mobile_forms_drafts_text": "下書きを削除",
    "mobile_batch_estimate_user": "ユーザー",
    "mobile_batch_estimate_users": "ユーザー",
    "mobile_table_of_contents": "目次",
    "mobile_table_of_contents_required": "必須",
    "mobile_table_of_contents_optional": "任意",
    "mobile_dialog_alert_title": "アラート",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "WindowsでまだサポートされていないBluetoothデバイス",
    "mobile_windows_deprecated_message_content_announcement": "通知",
    "mobile_windows_deprecated_message_title": "アプリの更新が必要です",
    "mobile_windows_deprecated_message_description": "Microsoft Storeから新しいZenputアプリをできるだけ早くインストールして、機能の重大なアップデートを行い、Zenputエクスペリエンスを最適化してください。",
    "mobile_dashboard_tcr_graph_name": "タスク完了率",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "過去4週間",
    "mobile_dashboard_tcr_legend_company_average": "会社の平均",
    "mobile_dashboard_tcr_legend_team_average": "チームの平均",
    "mobile_dashboard_tab_title_summary": "サマリー",
    "mobile_dashboard_tab_title_activity": "アクティビティ",
    "mobile_dashboard_card_title_top_triggered_workflows": "上位のトリガー",
    "mobile_dashboard_tab_title_info": "情報",
    "mobile_dashboard_tab_project_audit": "コンプライアンス",
    "mobile_dashboard_card_task_stats_total": "合計",
    "mobile_dashboard_top_item_header_week_of": "週の開始日",
    "mobile_dashboard_card_filter_form_template_placeholder": "すべてのフォーム",
    "mobile_dashboard_card_title_forms_top_nos": "「No」が頻繁",
    "mobile_dashboard_zenput_code_no_data_in_range": "この時間範囲にはデータがありません。",
    "mobile_dashboard_zenput_code_permission_denied": "これを表示する権限がありません。",
    "mobile_dashboard_zenput_code_no_form_template_selected": "上からフォームを選択してください。",
    "mobile_dashboard_zenput_code_unknown_error": "現時点ではデータを表示できません。",
    "mobile_dashboard_tap_to_retry": "タップして再試行",
    "mobile_dashboard_reporting_delay_disclaimer": "タスクが更新されるまで最長で15分かかる場合があります",
    "mobile_dashboard_configuration_down_state_postfix_msg": "が管理者によって設定されています。",
    "mobile_tasks_tag": "タスク",
    "mobile_workflows_tag": "トリガー",
    "mobile_projects_tag": "定期プロジェクト",
    "mobile_forms_tag": "フォーム",
    "mobile_dashboard_card_ongoing_projects_title": "進行中のプロジェクト",
    "mobile_dashboard_card_ongoing_projects_show_more": "さらに表示",
    "mobile_dashboard_card_ongoing_projects_show_less": "表示を減らす",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "プロジェクトに移動",
    "mobile_dashboard_card_title_recurring_projects": "定期プロジェクト",
    "mobile_dashboard_card_filter_daily": "毎日",
    "mobile_dashboard_card_filter_weekly": "毎週",
    "mobile_dashboard_card_filter_monthly": "毎月",
    "mobile_task_status_title_open": "進行中",
    "mobile_task_status_title_upcoming": "近日開始予定",
    "mobile_task_status_title_complete": "完了",
    "mobile_task_status_title_processing": "送信を処理しています",
    "mobile_task_status_title_complete_with_exceptions": "フォローアップタスクまたはアラートありで完了",
    "mobile_task_status_title_completed_late_with_exceptions": "フォローアップタスクまたはアラート付きで遅れて完了",
    "mobile_task_status_title_incomplete_and_closed": "未完了",
    "mobile_tasks_legend_modal_title": "凡例",
    "mobile_tasks_legend_modal_footer_button_title": "閉じる",
    "mobile_common_assigned_to": "割り当て先：",
    "mobile_common_created_by": "作成者：",
    "mobile_common_tasks_for": "タスクの対象：",
    "mobile_common_go_back": "戻る",
    "mobile_oh_no": "申し訳ありません。",
    "mobile_user_not_in_groups": "あなたはチームに割り当てられていないようです。管理者に連絡して、ダッシュボードへのアクセス権限を付与してもらってください。",
    "mobile_tasks_select_followers": "フォロワーを選択",
    "mobile_tasks_assign_tasks": "{{count}}件のタスクを割り当てる",
    "mobile_tasks_add_followers": "フォロワーを追加",
    "mobile_tasks_followers": "フォロワー",
    "mobile_tasks_delete_task": "タスクを削除",
    "mobile_tasks_create_task": "タスクを作成",
    "mobile_tasks_tab_title_comments": "コメント",
    "mobile_tasks_see_more": "さらに見る",
    "mobile_projects_create_project": "プロジェクトを作成",
    "mobile_common_button_send": "送信",
    "mobile_common_button_schedule": "スケジュール",
    "mobile_announcements_create": "アナウンスを作成",
    "mobile_announcements_read_rate": "{{recipients_count}}人中{{opened_count}}人が開封しました",
    "mobile_announcements_empty_message": "まだアナウンスを作成していません。重要なニュース、情報、アップデートを組織に配信するには、以下でアナウンスを作成してください。",
    "mobile_announcement_message_placeholder": "メッセージを追加...",
    "mobile_announcement_title_placeholder": "アナウンスのタイトル",
    "mobile_announcement_leaving_announcement": "アナウンスを離れる",
    "mobile_announcement_confirm_recipients_team": "選択した{{teams}}組のチームの{{count}}人のユーザーにこのアナウンスを配信しますか？",
    "mobile_announcement_confirm_recipients_role": "選択した{{roles}}組のユーザーロールの{{count}}人のユーザーにこのアナウンスを配信しますか？",
    "mobile_announcement_confirm_recipients_user": "{{count}}人のユーザーにこのアナウンスを配信しますか？",
    "mobile_announcement_confirm_scheduled": "日付：{{timestamp}}",
    "mobile_announcement_sending_announcement": "アナウンスを送信しています",
    "mobile_announcement_send_to": "送信先",
    "mobile_announcement_sent_to": "送信された先",
    "mobile_announcement_send_to_role": "ロール",
    "mobile_announcement_attachment_download": "{{filename}}をダウンロードしています",
    "mobile_announcement_attachment_validation_error": "ファイルは{{maxCount}}個までしか添付できません",
    "mobile_announcement_details_sent": "送信されました",
    "mobile_announcement_details_total_recipients": "総受信者数",
    "mobile_announcement_details_cancel": "アナウンスをキャンセル",
    "mobile_announcement_details_not_editable": "通知は、Ops Execution Webアプリでのみ編集可能です ",
    "mobile_announcement_details_not_editable_old": "アナウンスはZenput Webでのみ編集可能です",
    "mobile_announcement_details_open_count": "開封数",
    "mobile_announcement_details_open_rate": "開封率",
    "mobile_announcement_details_resend": "開封していない人に再送信",
    "mobile_announcement_confirm_resend": "{{count}}人のユーザーがまだアナウンスを読んでいません。リマインダーを送信しますか？",
    "mobile_announcement_confirm_resend_title": "リマインダーを送信しますか？",
    "mobile_announcement_recipients_opened": "開封済み",
    "mobile_recipients_opened_empty_message": "メッセージはまだ誰にも開封されていないようです。後でまた結果を確認してください。",
    "mobile_announcement_recipients_unopened": "未開封",
    "mobile_recipients_unopened_empty_message": "おめでとうございます！未開封のメッセージはありません。",
    "mobile_scheduled_announcements_delivery_section_header": "配信時刻",
    "mobile_scheduled_announcements_send_immediately_label": "今すぐ送信",
    "mobile_scheduled_announcements_scheduled_label": "指定時刻に送信",
    "mobile_scheduled_announcements_scheduled_tab_label": "日時設定済み",
    "mobile_scheduled_announcements_dialog_header": "アナウンスをキャンセルしますか？",
    "mobile_scheduled_announcements_dialog_message": "アナウンスをキャンセルすると送信が停止され、リストから削除されます。この操作は取り消すことができません。編集するには、Zenput Webにアクセスしてください。",
    "mobile_scheduled_announcements_empty_message": "現在、日時設定済みのアナウンスはありません。重要なニュース、情報、アップデートを組織に配信するには、アナウンスの配信日時を設定してください。",
    "mobile_scheduled_announcements_validation_error": "配信日時は{{date}}より後である必要があります",
    "mobile_scheduled_announcements_empty_state_button": "アナウンスの配信日時を設定",
    "mobile_projects_auto_archive": "自動アーカイブ",
    "mobile_common_unassigned": "未割り当て",
    "mobile_tasks_title_placeholder": "新規タスクまたは新規フォーム",
    "mobile_projects_leaving_project": "プロジェクトを離れる",
    "mobile_projects_save_project": "プロジェクトを保存",
    "mobile_top_triggers_tasks": "トリガーされた上位のタスク",
    "mobile_top_triggers_alerts": "トリガーされた上位のアラート",
    "mobile_projects_not_started": "開始されていません",
    "mobile_empty_list_message_no_photos": "写真がありません",
    "mobile_webfilestore_message_error": "有効なファイルタイプを選択してください",
    "mobile_notifications_empty_title": "通知はありません",
    "mobile_notifications_empty_message": "あなたのタスクまたはあなたが参加しているタスクのアクティビティがここに表示されます。",
    "mobile_comments_comment_deleted": "このコメントは削除されました。",
    "mobile_comments_comment_placeholder": "コメント",
    "mobile_comments_task_submitted_at": "タスクは{{ date }} {{ time }}に送信されました",
    "mobile_comments_discard_comment_title": "コメントを破棄しますか？",
    "mobile_comments_discard_confirm_message": "実行してよろしいですか？コメントは削除されます。",
    "mobile_comments_delete_comment_title": "コメントを削除しますか？",
    "mobile_comments_delete_confirm_message": "この操作は取り消すことができません。",
    "mobile_comments_delete_button": "コメントを削除",
    "mobile_comments_delete_success_message": "コメントが削除されました",
    "mobile_comments_empty_message_tasks": "まだコメントがありません\nこのタスクについての会話を始めてください。",
    "mobile_comments_empty_message_submissions": "まだコメントがありません\nこの送信についての会話を始めてください。",
    "mobile_comments_empty_message_default": "まだコメントがありません\n会話を始めてください。",
    "mobile_comments_no_matching_users": "一致するユーザーがいません。",
    "mobile_comments_empty_users_to_notify": "通知するユーザーがいません。",
    "mobile_comments_users_cant_view_message": "これらのユーザーはこれらのコメントを見ることができません。",
    "mobile_comments_users_to_notify_title": "通知するユーザー",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }}人のユーザー</a>に通知が送信されます。",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }}人のユーザー</a>に通知が送信されます。",
    "mobile_comments_mention_instructions": "他のユーザーにも通知を送信するには、それらのユーザーを<a href=\"#\" class=\"open_mention_autocomplete\">@メンション</a>してください。",
    "mobile_comments_mark_read": "すべてを既読にする",
    "mobile_comments_author_mentioned_message": "が以下であなたにメンションしました：",
    "mobile_comments_author_commented_message": "が次の時刻にコメントしました：",
    "mobile_view_pdf": "PDFを表示",
    "mobile_no_pdf_generated_message": "この送信に対するPDFが見つかりませんでした。コピーがまもなくメールで届きます。",
    "mobile_clipboard_copied_success": "リンクがクリップボードにコピーされました。",
    "mobile_share_link": "リンクをシェア",
    "mobile_zencam_share": "シェア",
    "mobile_zencam_view_details": "詳細を表示",
    "mobile_zencam_details_drawer_header": "詳細",
    "mobile_zencam_submitted_by": "送信者：",
    "mobile_zencam_form_title": "フォームのタイトル",
    "mobile_zencam_date_submitted": "送信日",
    "mobile_oil_quality_warning_message": "オイルの有効期限間近です",
    "mobile_oil_quality_warning_message_subtitle": "入れ替える計画をすぐに立ててください",
    "mobile_oil_quality_failure_message": "オイルの品質が不十分です",
    "mobile_oil_quality_failure_message_subtitle": "直ちにオイルを入れ替えてください",
    "mobile_sensors_set_up_gateway": "ゲートウェイをセットアップ",
    "mobile_sensors_set_up_gateway_message": "セットアップされたデバイスがないようです。利用を開始するにはゲートウェイを追加してください。",
    "mobile_sensors_gateway_plugged_in": "ゲートウェイが電源に接続されていることを確認してください。",
    "mobile_sensors_add_device": "デバイスを追加",
    "mobile_sensors_name_this_gateway": "このゲートウェイに名前を付けてください。",
    "mobile_sensors_name_this_sensor": "このセンサーに名前を付けてください。",
    "mobile_sensors_device_barcode_information": "デバイスのラベルからQRコードをスキャンするか、IDとSC番号を入力してください",
    "mobile_sensors_device_eui_information": "デバイスのラベルからQRコードをスキャンするか、DevEUIを入力してください",
    "mobile_sensors_gateway_id_information": "ゲートウェイラベルからノードIDを入力する",
    "mobile_sensors_id_number": "{{untranslatedID}}番号",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}}コード",
    "mobile_sensors_sensors": "センサー",
    "mobile_sensors_sensor_deveui_error": "QRからDevEUIを入手できませんでした。手動で入力してください。",
    "mobile_sensors_gateways": "ゲートウェイ",
    "mobile_sensors_add_sensor": "センサーを追加",
    "mobile_sensors_add_gateway": "ゲートウェイを追加",
    "mobile_sensor_placement_description": "このセンサーでモニタリングするエリアはどれですか？",
    "mobile_sensors_equipment_placement": "このセンサーでモニタリングするエリアまたは機器はどれですか？",
    "mobile_sensors_equipment": "このセンサーでモニタリングする機器はどれですか？",
    "mobile_sensors_select_gateway_type": "ゲートウェイのタイプを選択",
    "mobile_sensors_select_placement": "配置を選択",
    "mobile_sensors_select_equipment": "機器を選択",
    "mobile_sensors_placement": "配置",
    "mobile_sensors_nickname_tip": "センサー名は、選択した配置で割り当てられたニックネームによって決まります。",
    "mobile_sensors_device_online": "オンライン",
    "mobile_sensors_device_offline": "オフライン",
    "mobile_sensors_scan_qrcode": "QRコードをスキャン",
    "mobile_sensors_enter_manually": "手動で入力",
    "mobile_sensors_wizard_step_one": "ステップ1",
    "mobile_sensors_wizard_step_two": "ステップ2",
    "mobile_sensors_wizard_step_three": "ステップ3",
    "mobile_sensors_wizard_step_four": "ステップ4",
    "mobile_sensors_wizard_step_five": "ステップ5",
    "mobile_sensors_wizard_step_six": "ステップ6",
    "mobile_sensors_initializing": "初期化しています…",
    "mobile_sensors_nickname": "ニックネーム",
    "mobile_sensors_field_not_blank": "{{field}}を空白にすることはできません。",
    "mobile_sensors_nothing_to_see_here": "ここには特に確認するものはありません",
    "mobile_sensors_missing_integration": "センサーが統合されていません",
    "mobile_sensors_contact_zenput_admin": "所属会社のOps Execution管理者までご連絡ください。",
    "mobile_sensors_contact_zenput_admin_old": "Zenput管理者まで連絡してください。",
    "mobile_sensors_contact_manager": "センサーを追加するには、アカウントマネージャーに問い合わせてください。",
    "mobile_sensors_device_success_message": "センサーデータが読み込まれるまで最長で15分かかる場合があります",
    "mobile_sensors_last_reading": "前回の読み取り",
    "mobile_sensors_remove_device": "デバイスを削除",
    "mobile_sensors_one_day": "1日",
    "mobile_sensors_one_week": "1週間",
    "mobile_sensors_one_month": "1か月",
    "mobile_sensors_three_months": "3か月",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1年",
    "mobile_sensors_sensor_settings": "センサー設定",
    "mobile_sensors_remove_confirm_message": "このデバイスを削除してよろしいですか？\nこの操作は取り消すことができません。",
    "mobile_sensors_sensor": "センサー",
    "mobile_sensors_no_equipment_linked": "リンクされた機器がありません",
    "mobile_sensor_cooldown_process": "冷却プロセス",
    "mobile_sensor_last_12_hours": "過去12時間",
    "mobile_sensor_start_cooldown_process": "冷却プロセスを新たに開始",
    "mobile_sensor_cooldown_process_title": "2段階の冷却プロセス",
    "mobile_sensor_cooldown_process_description": "2段階の冷却プロセスは、食材を2時間以内に{{ stage1_start_temperature }}以上から{{ stage1_end_temperature }}に冷却した後に、4時間以内に{{ stage1_end_temperature }}から{{ stage2_end_temperature }}に冷却するというプロセスで構成されます。",
    "mobile_sensor_cooldown_process_place_food": "食材を冷蔵庫に入れてください。",
    "mobile_sensor_cooldown_process_insert_sensor": "食材にセンサープローブを差し込んでください。",
    "mobile_sensor_cooldown_process_enter_information": "以下に情報を入力してください。",
    "mobile_sensor_cooldown_process_food_product": "冷却する食材",
    "mobile_sensor_cooldown_cool_down": "冷却",
    "mobile_sensor_cooldown_select_sensor": "センサーを選択",
    "mobile_sensors_cooldown_start_cooldown": "冷却を開始",
    "mobile_sensors_cooldown_please_enter_food": "食材を入力してください",
    "mobile_sensors_cooldown_please_select_sensor": "センサーを選択してください",
    "mobile_sensors_cooldown_status_in_progress": "進行中",
    "mobile_sensors_cooldown_status_failed": "失敗",
    "mobile_sensors_cooldown_status_success": "成功",
    "mobile_sensors_cooldown_stage": "段階",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "開始温度が範囲外です",
    "mobile_sensors_cooldown_failed_cooldown_process": "冷却プロセスに失敗しました",
    "mobile_sensors_cooldown_cooldown_successful": "冷却が正常に行われました",
    "mobile_sensors_cooldown_started_cooldown_process": "冷却プロセスを開始しました",
    "mobile_sensors_cooldown_hour": "時間",
    "mobile_sensors_cooldown_hour_plural": "時間",
    "mobile_sensors_cooldown_minute": "分",
    "mobile_minutes_plural": "分",
    "mobile_sensors_last_reading_max_date": "1年以上前",
    "mobile_sensors_minute_count_ago": "{{count}}分前",
    "mobile_sensors_minute_count_ago_plural": "{{count}}分前",
    "mobile_sensors_hour_count_ago": "{{count}}時間前",
    "mobile_sensors_hour_count_ago_plural": "{{count}}時間前",
    "mobile_sensors_day_count_ago": "{{count}}日前",
    "mobile_sensors_day_count_ago_plural": "{{count}}日前",
    "mobile_sensors_chart_settings": "チャートの設定",
    "mobile_announcement_banner_continue_reading": "読み取りを続ける",
    "mobile_compliance_submissions_report": "送信レポート",
    "mobile_compliance_submissions_report_subtitle": "このストアのプロジェクト完了データをエクスポートする",
    "mobile_compliance_send_submissions": "送信する",
    "mobile_compliance_completion_rate_in_last_days": "過去{{ days }}日間の完了率",
    "mobile_compliance_last_days": "過去{{ days }}日間",
    "mobile_compliance_send_submissions_to": "送信先：",
    "mobile_compliance_send_to_different_email": "別のメールアドレスに送信",
    "mobile_compliance_email_input_placeholder": "メールアドレス",
    "mobile_compliance_send_submissions_to_legend_title": "送信",
    "mobile_compliance_send_submissions_to_legend_description_days": "過去{{ days }}日間のこの場所からの送信レポートは、選択したメールアドレスに送信されます。",
    "mobile_compliance_time_frame": "期間",
    "mobile_compliance_sensor_temperature_log_report": "センサー温度ログレポート",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "このストアの温度ログをエクスポートする",
    "mobile_compliance_sensor_temperature_log_criteria_title": "基準",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "レポートの基準を以下で定義します。",
    "mobile_compliance_sensor_temperature_log_criteria_note": "メモ：無効なセンサーはレポートに表示されません",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "期間を選択します。ログデータは最大30日までです。",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "レポートを送信",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "今月（1日～本日）",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "先月",
    "mobile_compliance_sensor_temperature_log_email_title": "レポートの送信先",
    "mobile_pwa_update_prompt_title": "アプリケーションのアップデート",
    "mobile_pwa_update_prompt_description": "アプリケーションの新しいバージョンを利用できます。最新のバージョンにアップデートしてください。",
    "mobile_pwa_update_prompt_confirm": "アップデートして再読み込みする",
    "mobile_pwa_update_prompt_cancel": "後で通知する",
    "notification_title_due_in_one_hour": "期限：1時間後",
    "task_is_due_soon": "'{{ task_title }}'の期限間近です。時間を取って完了してください。",
    "mobile_photo_quality_warning_header": "写真の品質に問題があります",
    "mobile_photo_quality_dialog_message": "この写真は暗すぎるか、ぼやけています。新しい写真を撮りますか、それともこの写真で続行しますか？",
    "mobile_take_new_photo": "新しい写真を撮る",
    "mobile_use_this_photo": "この写真を使う"
}};
mobile_translations.ta_IN = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "அனைத்தும்",
    "mobile_common_button_apply_filters": "வடிகட்டிகளைப் பயன்படுத்து",
    "mobile_common_button_done": "முடிந்தது",
    "mobile_common_button_edit": "திருத்து/மாற்று",
    "mobile_common_button_archive": "காப்பகப்படுத்து",
    "mobile_common_button_save": "சேமி",
    "mobile_common_button_retake": "மீண்டும்",
    "mobile_common_button_save_draft": "வரைவைச் சேமி",
    "mobile_common_button_discard": "நிராகரி",
    "mobile_common_button_submit": "சமர்ப்பி",
    "mobile_common_button_no": "இல்லை",
    "mobile_common_button_yes": "ஆம்",
    "mobile_common_button_na": "பொருந்தாது",
    "mobile_common_created_by_me": "என்னால் உருவாக்கப்பட்டது",
    "mobile_common_email": "நிறுவனத்தின் மின்னஞ்சல்",
    "mobile_common_first_name": "முதல் பெயர்",
    "mobile_common_last_name": "கடைசி பெயர்",
    "mobile_common_location": "இருப்பிடம்",
    "mobile_common_locations": "இருப்பிடங்கள்",
    "mobile_common_logout_message": "நீங்கள் நிச்சயமாக வெளியேற விரும்புகிறீர்களா?",
    "mobile_common_password": "கடவுச்சொல்",
    "mobile_common_permission_required": "அனுமதி தேவை",
    "mobile_common_status": "நிலை",
    "mobile_common_task": "பணி",
    "mobile_common_tasks": "பணிகள்",
    "mobile_common_tasks_my": "எனது பணிகள்",
    "mobile_common_projects": "திட்டங்கள்",
    "mobile_common_filter_team": "அணி",
    "mobile_common_filter_var_in": " இல் {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "எந்த அணியும் தேர்ந்தெடுக்கப்படவில்லை",
    "mobile_common_filter_no_user_selected": "எந்த பயனரும் தேர்ந்தெடுக்கப்படவில்லை",
    "mobile_common_filter_no_role_selected": "எந்த பணிப்பொறுப்பும் தேர்ந்தெடுக்கப்படவில்லை",
    "mobile_common_placeholder_date": "தேதி",
    "mobile_common_message_task_creator_error_save": "<b> பணிகளை உருவாக்க முடியவில்லை. </b>",
    "mobile_common_camera": "கேமரா",
    "mobile_common_microphone": "மைக்ரோஃபோன்",
    "mobile_common_for": "இதற்காக",
    "mobile_common_reload": "ஏற்றவும்",
    "mobile_common_override": "மீறவும்",
    "mobile_common_notifications": "அறிவிப்புகள்",
    "mobile_common_chat_unavailable": "அரட்டை கிடைக்கவில்லை. பிறகு மீண்டும் முயற்சிக்கவும்.",
    "mobile_common_chat_ending_dialog_title": "இந்த உரையாடலை நீங்கள் முடித்துவிட்டீர்களா?",
    "mobile_common_chat_ending_dialog_description": "உங்கள் சிக்கல் தீர்க்கப்பட்டதா அல்லது நீங்கள் பின்னர் தொடர விரும்பினால் எங்களுக்குத் தெரியப்படுத்தவும்.",
    "mobile_common_chat_ending_dialog_confirm": "ஆம், நான் முடித்துவிட்டேன்",
    "mobile_common_chat_ending_dialog_cancel": "பிறகு தொடர்கிறேன்",
    "mobile_common_continue_editing": "தொடர்ந்து திருத்துங்கள்",
    "mobile_privacy_policy": "தனியுரிமைக் தனியுரிமைக் கொள்கைகொள்கை",
    "wootric_recommend_target": "உங்கள் துறையிலுள்ள ஒரு நண்பர் அல்லது சக ஊழியர்",
    "wootric_followup_detractor_question": "அடுத்த முறை நீங்கள் எங்களுக்கு அதிக மதிப்பீட்டை வழங்க என்ன மாற்றங்களைச் செய்யலாம்?",
    "wootric_followup_passive_question": "நன்றி! கருவியை இன்னும் சிறப்பாக்க நாங்கள் என்ன செய்ய வேண்டும்?",
    "wootric_followup_promoter_question": "நன்றி! க்ரஞ்ச்டைம் ஆப்ஸ் எக்ஸிகியூஷன் (Crunchtime Ops Execution) குறித்து நீங்கள் விரும்புவது என்ன?",
    "wootric_followup_promoter_question_old": "நன்றி! Zenput உள்ள எதை மிகவும் விரும்புகிறீர்கள்?",
    "wootric_default_followup_question": "நன்றி! ஏன் என்று சொல்ல முடியுமா?",
    "wootric_default_placeholder_text": "உங்கள் மதிப்பெண் பற்றி எங்களுக்கு விளக்குங்கள்.",
    "wootric_default_thankyou_text": "உங்கள் பதிலுக்கும், உங்கள் கருத்துக்கும் நன்றி!",
    "mobile_login_placeholder_login_as": "பயனர் ஐடி மூலம் உள்நுழைக",
    "mobile_login_button_forgot_password": "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    "mobile_login_button_sign_up": "உங்கள் கணக்கை துவங்குங்கள்",
    "mobile_login_button_finish_setup": "அமைவை அமைவை முடிக்கவும்முடிக்கவும்",
    "mobile_login_button": "உள்நுழைக",
    "mobile_login_continue_button": "தொடரவும்",
    "mobile_login_continue_transition": "உங்கள் நிறுவனத்தின் உள்நுழைவு பக்கத்திற்கு உங்களை அழைத்துச் செல்கிறது ...",
    "mobile_login_no_email_error": "நீங்கள் ஒரு மின்னஞ்சலை உள்ளிட வேண்டும்",
    "mobile_login_change_email": "வெறொரு மின்னஞ்சலுடன் உள்நுழைக",
    "mobile_login_with_sso": "SSO மூலம் உள்நுழையவும்",
    "mobile_oauth_no_user_error_message": "உங்களிடம் க்ரஞ்ச்டைம் ஆப்ஸ் எக்ஸிகியூஷன் கணக்கு இல்லை என்று தெரிகிறது!",
    "mobile_oauth_no_user_error_message_old": "உங்களிடம் Zenput கணக்கு இல்லை என்று தெரிகிறது!",
    "mobile_rebrand_announcement_banner": "<b>சென்பட்</b> இப்போது <b>கிரன்டைம் ஆப்ஸ் எக்ஸிகியூஷன்</b> ஆக மாறியுள்ளது",
    "mobile_rebrand_warning_banner": "{{- brand }} செப்டம்பரில் {{- product }} ஆக மாறுகிறது. {{- cta }}",
    "mobile_rebrand_warning_cta": "எப்படித் தயாராவது என்று கற்றுக்கொள்ளுங்கள்.",
    "mobile_oauth_no_user_error_sub_message": "அணுகலுக்காக உங்கள் நிர்வாகியைத் தொடர்பு கொள்ளுங்கள் அல்லது வேறு மின்னஞ்சல் மூலம் உள்நுழைய முயலவும்.",
    "mobile_oauth_generic_error_message": "உள்நுழைவதில் சிக்கல் இருப்பதாகத் தெரிகிறது, தயவுசெய்து மீண்டும் முயலவும்.",
    "mobile_oauth_force_logout_msg": "உங்களுக்கு இன்னும் சிக்கல்கள் இருந்தால், இங்கே கிளிக் செய்வதன் மூலம் உங்கள் வழங்குநரிடமிருந்து வெளியேறவும் ",
    "mobile_oauth_force_logout_click": "இங்கே கிளிக் செய்க.",
    "mobile_sign_up_placeholder_phone": "செல் எண்",
    "mobile_sign_up_placeholder_password_confirm": "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    "mobile_sign_up_button_sign_in": "உள்நுழைக",
    "mobile_sign_up_disclaimer_part_1": "கணக்கை உருவாக்கு என்பதைக் கிளிக் செய்வதன் மூலம், நீங்கள் ஒப்புக்கொள்கிறீர்கள்",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "அமைவை முடி என்பதைக் கிளிக் செய்வதன் மூலம், நீங்கள் ஏற்கிறீர்கள்",
    "mobile_sign_up_disclaimer_link_title": " உரிம ஒப்பந்தத்தின்",
    "mobile_sign_up_disclaimer_part_2": ", இதில் முக்கியமான தனியுரிமை தகவல்கள் அடங்கும்",
    "mobile_dialog_benefits_work_offline": "ஆஃப்லைனில் வேலை செய்யுங்கள்",
    "mobile_dialog_benefits_faster_uploads": "விரைவான பதிவேற்றங்கள்",
    "mobile_dialog_benefits_better_experience": "சிறந்த அனுபவம்",
    "mobile_dialog_benefits_button_download": "பதிவிறக்கவும்",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution இன் நோக்கம் ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput க்கான ",
    "mobile_dialog_benefits_button_have": "என்னிடம் செயலி உள்ளது!",
    "mobile_dialog_benefits_button_no_thanks": "வேண்டாம் நன்றி, பின்னர்.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "படத்தை ஏற்றுவதில் தோல்வி.",
    "mobile_dialog_signature_sign": "இங்கே கையப்பம் இடவும்",
    "mobile_dialog_signature_button_clear": "அழி",
    "mobile_account_placeholder_name": "இருப்பிடம் / கடை பெயர்",
    "mobile_account_placeholder_phone": "தொலைபேசி",
    "mobile_account_placeholder_address": "முகவரி",
    "mobile_account_placeholder_city": "நகரம்",
    "mobile_account_placeholder_region": "பிராந்தியம்",
    "mobile_account_placeholder_zipcode": "அஞ்சல் குறியீடு / ஜிப்",
    "mobile_account_option_select_country": "நாட்டினை தேர்வுசெய்",
    "mobile_account_oprion_us": "அமெரிக்கா",
    "mobile_account_oprion_select_state": "மாநிலத்தைத் தேர்ந்தெடுக்கவும்",
    "mobile_account_button_create_location": "இருப்பிடத்தை உருவாக்கவும்",
    "mobile_form_message_no_form": "படிவங்கள் எதுவும் கிடைக்கவில்லை",
    "mobile_batch_task_message": "ஏற்றுகிறது ...",
    "mobile_settings_profile": "சுயவிவரம்",
    "mobile_settings_profile_number": "கைப்பேசி",
    "mobile_settings_profile_language": "மொழி",
    "mobile_settings_profile_temperature_unit": "வெப்பநிலை அலகு",
    "mobile_settings_profile_use_company_default": "நிறுவனத்தின் இயல்புநிலையைப் பயன்படுத்தவும்",
    "mobile_settings_profile_celsius": "செல்சியஸ்",
    "mobile_settings_profile_fahrenheit": "பாரன்ஹீட்",
    "mobile_settings_notifications_option_sms": "உரைச் செய்தி",
    "mobile_settings_notifications_option_push": "உள்வரும் அறிவிப்புகள்",
    "mobile_settings_notifications_option_push_email": "மின்னஞ்சல் & உள்வரும் அறிவிப்புகள்",
    "mobile_settings_notifications_option_do_not": "அறிவிக்க வேண்டாம்",
    "mobile_settings_notifications_category_communication": "தகவல் தொடர்பு ",
    "mobile_settings_notifications_category_forms_and_triggers": "படிவங்கள் மற்றும் தூண்டுதல்கள்",
    "mobile_settings_devices": "சாதனங்கள்",
    "mobile_settings_notifications_sub_category_alerts": "எச்சரிக்கைகள்",
    "mobile_settings_notifications_sub_category_new_forms_available": "புதிய படிவங்கள் கிடைக்கும்",
    "mobile_settings_notifications_sub_category_task_assigned": "பணி ஒதுக்கப்பட்டது",
    "mobile_settings_notifications_sub_category_task_completed": "பணி முடிந்தது",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "விரைவில் முடிக்க வேண்டிய பணிகள் நினைவூட்டல்",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "தாமதமான பணிகளை நினைவூட்டல்",
    "mobile_settings_notifications_sub_category_sensor_alerts": "சென்சார் எச்சரிக்கைகள்",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": " முக்கியமான சென்சார் எச்சரிக்கைகள்",
    "mobile_drafts_message": "உங்களிடம் இதுவரை வரைவுகள் எதுவும் இல்லை.",
    "mobile_drafts_button_delete": "அழி",
    "mobile_tasks_filter_location_no": "எந்த இடமும் தேர்ந்தெடுக்கப்படவில்லை",
    "mobile_tasks_filter_group_by": "குழுவின் படி",
    "mobile_tasks_filter_sort_by": "மூலம் மூலம் வரிசைப்படுத்துவரிசைப்படுத்து",
    "mobile_tasks_filter_sorted_by": "மூலம் மூலம் வரிசைப்படுத்தப்பட்டதுவரிசைப்படுத்தப்பட்டது",
    "mobile_tasks_filter_due_time": "உரிய உரிய நேரம்நேரம்",
    "mobile_tasks_filter_open_time": "திறக்கும் திறக்கும் நேரம்நேரம்",
    "mobile_tasks_bucket_due_next_24_hours": "அடுத்த 24 மணி நேரத்தில் முடிக்க வேண்டும்",
    "mobile_tasks_bucket_due_next_7_days": "அடுத்த 7 நாட்களில் முடிக்க  வேண்டும்",
    "mobile_tasks_bucket_open_tasks": "கூடுதல் திறப்புகள் {{type}}",
    "mobile_tasks_bucket_open_at": "திற : {{- date }} ஐ {{- time }} இல்",
    "mobile_tasks_bucket_due_by_at": "முடிக்கவேண்டிய நாள்  :  {{- date }} ஐ {{- time }} இல்",
    "mobile_tasks_bucket_available_in_one_minute": "1 நிமிடத்தில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_one_hour": "1 மணி நேரத்தில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_one_day": "1 நாளில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_one_week": "1 வாரத்தில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_one_month": "1 மாதத்தில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_one_year": "1 வருடத்தில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_minutes": "{{ minutes }} நிமிடங்களில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_hours": "{{ hours }} மணிநேரத்தில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_days": "{{ days }} நாட்களில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_weeks": "{{ weeks }} வாரத்தில் கிடைக்கும்",
    "notification_task_due_in_minutes": "{{ minutes }} நிமிடங்களில் செலுத்த வேண்டிய தேதி்",
    "mobile_tasks_bucket_available_in_months": "{{ months }} மாதத்தில் கிடைக்கும்",
    "mobile_tasks_bucket_available_in_years": "{{ years }} ஒரு வருடத்தில் கிடைக்கும்",
    "mobile_tasks_follow_up": "பின்தொடர்தல் பின்தொடர்தல் பணிபணி",
    "mobile_tasks_due_soon": "விரைவில் வரவிருக்கும்",
    "mobile_tasks_bucket_completed_today": "இன்று முடிந்தது",
    "mobile_tasks_bucket_completed_this_week": "இந்த வாரம் முடிந்தது",
    "mobile_tasks_bucket_completed_last_week": "கடந்த வாரம் முடிந்தது",
    "mobile_tasks_bucket_missed_today": "இன்று தவறவிட்டது",
    "mobile_tasks_bucket_missed_this_week": "இந்த வாரம் தவறவிட்டது",
    "mobile_tasks_bucket_missed_last_week": "கடந்த வாரம் தவறவிட்டது",
    "mobile_tasks_bucket_no_location": "இருப்பிடம் இல்லை",
    "mobile_tasks_cannot_submit_missed": "தவறவிட்ட பணிகளை முடிக்க முடியாது",
    "mobile_tasks_cannot_submit_missed_after": "{{ date }}தேதிக்குப் பிறகு இந்த பணியை முடிக்க முடியாது",
    "mobile_tasks_cannot_submit_upcoming": "இந்த பணி தொடங்கப்படவில்லை.",
    "mobile_tasks_cannot_submit_processing": "இந்த சமர்ப்பிப்பு செயல்படுத்தப்படுகிறது",
    "mobile_tasks_toolbarnav_header_no_due_date": "முடிக்கவேண்டிய தேதி இல்லை",
    "mobile_tasks_toolbarnav_header_overdue": "காலம்கடந்தவை",
    "mobile_tasks_toolbarnav_header_yesterday": "நேற்று",
    "mobile_tasks_toolbarnav_header_today": "இன்று",
    "mobile_tasks_toolbarnav_header_tomorrow": "நாளை",
    "mobile_tasks_toolbarnav_header_last_week": "கடந்த வாரம்",
    "mobile_tasks_toolbarnav_header_this_week": "இந்த வாரம்",
    "mobile_tasks_toolbarnav_header_next_week": "அடுத்த வாரம்",
    "mobile_tasks_toolbarnav_header_this_month": "இந்த மாதம்",
    "mobile_tasks_toolbarnav_header_next_year": "அடுத்த வருடம்",
    "mobile_tasks_toolbarnav_header_over_year": "ஒரு வருடத்துக்கும் மேலாக",
    "mobile_tasks_toolbarnav_title_edit_task": "பணியைத் திருத்து",
    "mobile_task_placeholder_title": "தலைப்பு *",
    "mobile_task_placeholder_description": "விளக்கம் (விரும்பினால்)",
    "mobile_task_button_single_task": "ஒற்றை பணி",
    "mobile_task_button_project": "திட்டம்",
    "mobile_task_button_create": "உருவாக்கு",
    "mobile_task_tab_basic": "அடிப்படை",
    "mobile_task_tab_photo": "புகைப்படம்",
    "mobile_task_tab_form": "படிவம்",
    "mobile_task_details_description_message_please": "நிரப்பவும் ",
    "mobile_task_details_description_message_below": "கீழே.",
    "mobile_task_details_description_message_instructions": "இந்த பணிக்கு எந்த வழிமுறைகளும் கிடைக்கவில்லை.",
    "mobile_task_details_reason_title": "ஆல் பின்தொடர்தல் தூண்டப்படுகிறது",
    "mobile_task_detials_button_goto_form": "படிவத்திற்குச் செல்லவும்",
    "mobile_task_detials_button_complete": "  பணியை முடிக்கவும்",
    "mobile_task_detials_completed": "முடிவடைந்தது ",
    "mobile_task_detials_completed_by": "இவரால் ",
    "mobile_task_detials_completed_on": "அன்று ",
    "mobile_task_details_view_form_submission": "படிவம் சமர்ப்பிப்பைக் காண்க",
    "mobile_task_task_updated": "பணி புதுப்பிக்கப்பட்டது",
    "mobile_task_task_archived": "பணி காப்பகப்படுத்தப்பட்டது",
    "mobile_task_task_deleted": "பணி நீக்கப்பட்டது",
    "mobile_task_error_archiving_task": "பணியை காப்பகப்படுத்த முடியவில்லை.",
    "mobile_task_error_deleting_task": "பணியை நீக்க முடியவில்லை.",
    "mobile_task_error_updating_task": "பணியைப் புதுப்பிக்க முடியவில்லை.",
    "mobile_task_archive_task": "காப்பக பணி",
    "mobile_task_archive_task_confirm": "இந்த பணியை காப்பகப்படுத்த விரும்புகிறீர்களா? \n \n காப்பகப்படுத்தப்பட்ட பணிகள் நிறைவு வீதங்கள் கணக்கிடப்படும், மேலும் அவை தொடர்ந்து அறிக்கையிடலில் சேர்க்கப்படும். \n \n இதை செயல்தவிர்க்க முடியாது.",
    "mobile_task_delete_task_confirm": "இந்த பணியை நீக்க விரும்புகிறீர்களா? \n \n நீக்கப்பட்ட பணிகள் நிறைவு வீதங்களை கணக்கிடாது அல்லது எந்தவொரு அறிக்கையிலும் சேர்க்கப்படாது. \n \n இதை செயல்தவிர்க்க முடியாது.",
    "mobile_task_edition_already_in_progress": "இந்த பணி நிலுவையில் உள்ளது. மேலும் திருத்துதல் தற்போது அனுமதிக்கப்படவில்லை.",
    "mobile_projects_filter_type": "வகை",
    "mobile_projects_filter_status": "திட்ட நிலை",
    "mobile_projects_filter_project_type": "திட்ட வகை",
    "mobile_projects_due_date_required": "முடிக்கவேண்டிய தேதி தேவை.",
    "mobile_projects_team_required": "குழு தேவை.",
    "mobile_projects_user_role_required": "ஒதுக்குபவர் தேவை.",
    "mobile_projects_title_required": "தலைப்பு தேவை",
    "mobile_projects_recurring_multiple_tasks_per_day": "ஒரே நாளில் பல்வேறு பணிகள்",
    "mobile_project_tasks_complete": " முடிக்கவும்",
    "mobile_project_tasks_remaining": " மீதமுள்ள",
    "mobile_esitmate_message_tasks": "0 பணிகள் உருவாக்கப்படும்",
    "mobile_esitmate_message_criteria": "மேலே வகைப்பாட்டை சரிசெய்யவும்",
    "mobile_esitmate_message_created_for": "க்கு வேண்டி உருவாக்கப்படும்",
    "mobile_left_menu_dashboard": "டாஷ்போர்டு",
    "mobile_left_menu_my_forms": "எனது படிவங்கள்",
    "mobile_left_menu_announcements": "அறிவிப்புகள்",
    "mobile_left_menu_my_submissions": "எனது சமர்ப்பிப்புகள்",
    "mobile_left_menu_drafts": "வரைவுகள்",
    "mobile_left_menu_pending_uploads": "பதிவேற்றங்கள் நிலுவையில் உள்ளன",
    "mobile_left_menu_open": "செயலியில் திறக்கவும்",
    "mobile_left_menu_settings": "அமைப்புகள்",
    "mobile_left_menu_log_out": "வெளியேறுக",
    "mobile_left_menu_debug": "பிழைத்திருத்தம்",
    "mobile_left_menu_support": "ஆதரவு",
    "mobile_left_menu_documentation": "ஆவணம்",
    "mobile_left_menu_chat": "அரட்டை",
    "mobile_field_textarea_placeholder_note": "குறிப்பு அல்லது தலைப்பு",
    "mobile_field_option_select": "தேர்ந்தெடு",
    "mobile_field_text_placeholder_text": "உரை",
    "mobile_field_email_placehoder_email": "மின்னஞ்சல்",
    "mobile_filed_number_placeholder_number": "எண்",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "இணைக்கப்படவில்லை",
    "mobile_field_sensor_offline_battery": "சென்சார் ஆஃப்லைன் - பேட்டரி",
    "mobile_field_video_button_add": "வீடியோவைச் சேர்க்கவும்",
    "mobile_field_video_picker_dialog_title": "..இலிருந்து வீடியோவை சேர்க்கவும்",
    "mobile_field_video_button_change": "வீடியோவை மாற்றவும்",
    "mobile_field_image_button_add": "படத்தைச் சேர்க்கவும்",
    "mobile_field_image_low_quality_warning": "சில புகைப்படங்கள் மிகவும் இருண்டதாகவோ அல்லது மங்கலாகவோ இருக்கலாம். சிறப்பித்துக் காட்டப்பட்டுள்ள புகைப்படங்களை ஆய்வு செய்து, தேவைப்பட்டால் அவற்றை மாற்றவும்.",
    "mobile_field_image_picker_dialog_title": "..இலிருந்து போட்டோவை சேர்க்கவும்",
    "mobile_field_image_picker_edit_failed": "எங்களுக்கு உங்களின் படத்தை சேமிக்க முடியவில்லை. மீண்டும் முயற்சியுங்கள்.",
    "mobile_field_signature_button_add": "ஒரு கையொப்பத்தைச் சேர்க்கவும்",
    "mobile_field_signature_button_change": "கையொப்பத்தை மாற்றவும்",
    "mobile_field_account_select_location": "இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்",
    "mobile_field_account_prefill": "கடைசி வருகையின் தரவைக் கொண்டு படிவத்தை நிரப்ப வேண்டுமா?",
    "mobile_field_account_message_overwrite": "இது நீங்கள் ஏற்கனவே பூர்த்தி செய்த எந்த புலங்களையும் மேலெழுதும்.",
    "mobile_forms_task_on_behalf": "<b> {{user}} </b> க்கு ஒதுக்கப்பட்டுள்ள இந்த இடத்தில் நிறைவேற்ற ஒரு பணி உள்ளது. இந்த பணியை முடிக்க விரும்புகிறீர்களா?",
    "mobile_forms_complete_task": "முழுமையான பணி?",
    "mobile_field_account_prefill_button_yes": "ஆம், முன் நிரப்பவும்",
    "mobile_field_barcode_placeholder_scan": "பார்கோடு ஸ்கேன் அல்லது தட்டச்சு செய்க",
    "mobile_field_sensor_qr_code_placeholder_scan": "குறியீட்டை ஸ்கேன் செய்யவும் அல்லது தட்டச்சு செய்யவும்",
    "mobile_field_gateway_id_code_placeholder": "Node ID 'ஐக் குறிப்பிடுங்கள்",
    "mobile_field_scan_qr_or_enter_dev_eui": "QR குறியீட்டை ஸ்கேன் செய்யவும் அல்லது DevEUI ஐ உள்ளிடவும்",
    "mobile_field_scan_qr_or_enter_id": "QR குறியீட்டை ஸ்கேன் செய்யவும் அல்லது ID எண்ணை உள்ளிடவும்",
    "mobile_field_scan_qr_or_enter_sc": "QR குறியீட்டை ஸ்கேன் செய்யவும் அல்லது SC குறியீட்டை உள்ளிடவும்",
    "mobile_field_barcode_select_date": "தேதி தேர்ந்தெடுக்கவும் ",
    "mobile_field_datetime_allow_time": "நேரம்",
    "mobile_field_stopwatch_button_caption": "ஸ்டாப்வாட்ச்",
    "mobile_field_stopwatch_common_start": "தொடங்கு",
    "mobile_field_stopwatch_common_stop": "நிறுத்து",
    "mobile_field_stopwatch_common_reset": "மீட்டமை",
    "mobile_field_stopwatch_stop_stopwatches": "ஸ்டாப்வாட்ச்களை நிறுத்துங்கள்",
    "mobile_field_document_title": "ஆவணத்தைச் சேர்க்கவும்",
    "mobile_field_document_message_delete": "இந்த ஆவணத்தை நீக்க விரும்புகிறீர்களா?",
    "mobile_field_document_alret_button_view": "காண்க",
    "mobile_field_document_alert_error": "இந்த ஆவணத்தை இணைப்பதில் பிழை ஏற்பட்டது. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "mobile_field_document_alert_file_size_error": "கோப்பு {{count}}  MB க்கு மேல் இருக்கக்கூடாது.",
    "mobile_field_temperature_greater_range": "{{ temp_value }} than {{ temp_unit }} ஐ விட அதிகமாக",
    "mobile_field_temperature_greater_or_equal_range": "{{ temp_value }} ° {{ temp_unit }} ஐ விட அதிகமாகவோ அல்லது சமமாகவோ",
    "mobile_field_temperature_less_range": "{{ temp_value }} °{{ temp_unit }} விட குறைவாக",
    "mobile_field_temperature_less_or_equal_range": "{{ temp_value }} °{{ temp_unit }} விட குறைவாக அல்லது சமமாக",
    "mobile_field_temperature_between_range": "{{ min_temp_value }} ° {{ temp_unit }} ஐ விட அதிகமாகவோ அல்லது சமமாகவோ மற்றும் {{ max_temp_value }} ° {{ temp_unit }} க்கும் குறைவாகவோ",
    "mobile_field_temperature_inclusive_between_range": "{{ min_temp_value }} °{{ temp_unit }} ஐ விட அதிகமாகவோ அல்லது சமமாகவோ மற்றும் {{ max_temp_value }} °{{ temp_unit }} ஐ விட குறைவாகவோ அல்லது சமமாகவோ ",
    "mobile_field_temperature_operators_separator": " மற்றும் ",
    "mobile_field_text_limit_error": "அதிகபட்ச எழுத்து வரம்பு 8000 -ஐ அடைந்தது.",
    "mobile_forms_required_questions_complete": "முடிக்க வேண்டியது",
    "mobile_forms_required_remaining": "{{count}} மீதமுள்ளது",
    "mobile_forms_required_questions_back": "பின்செல்",
    "mobile_forms_required_questions_next": "அடுத்தது",
    "mobile_forms_required_questions_skip": "தவிர்க்கவும்தவிர்க்கவும்",
    "mobile_forms_leaving_form": "படிவத்தை விட்டு வெளியேறுக",
    "mobile_message_reordering_confirm": "புது கேள்வி வரிசையைச் சேமிக்க விரும்புகிறீர்களா?",
    "mobile_forms_leaving_reordering": "கேள்வியை மீண்டும் வரிசைப்படுத்தலில் இருந்து விலகுதல்",
    "mobile_forms_reordering_button_save": "புது கேள்வி வரிசையைச் சேமிக்கவும்",
    "mobile_forms_reordering_instructions": "கேள்விகள் அல்லது பிரிவுகளை மறுவரிசைப்படுத்த, படிவத்தில் புலம் காண்பிக்கப்பட வேண்டிய இடத்திற்கு இழுத்து விடவும்",
    "mobile_toolbarnav_title_my_setttings": "எனது அமைப்புகள்",
    "mobile_toolbarnav_title_profile_settings": "சுயவிவர அமைப்புகள்",
    "mobile_toolbarnav_title_notification": "அறிவிப்பு அமைப்புகள்",
    "mobile_toolbarnav_title_form_history": "படிவ வரலாறு",
    "mobile_toolbarnav_title_form_not_available": "படிவம் கிடைக்கவில்லை",
    "mobile_toolbarnav_title_add_location": "இருப்பிடத்தைச் சேர்க்கவும்",
    "mobile_toolbarnav_title_add_task_or_project": "பணி அல்லது திட்டத்தைச் சேர்க்கவும்",
    "mobile_toolbarnav_title_select_location": "இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்",
    "mobile_toolbarnav_title_select_project": "செயல்திட்டத்தைத் தேர்வு செய்யவும் ",
    "mobile_toolbarnav_title_select_tag": "குறிச்சொல்லைத் தேர்ந்தெடுக்கவும்",
    "mobile_toolbarnav_title_select_user": "பயனரைத் தேர்ந்தெடுக்கவும்",
    "mobile_toolbarnav_title_select_template": "வார்ப்புருவைத் தேர்ந்தெடுக்கவும்",
    "mobile_toolbarnav_title_select_one": "ஒன்றை தேர்ந்தெடு",
    "mobile_toolbarnav_title_select_multiple": "ஒன்று அல்லது அதற்கு மேற்பட்டவற்றைத் தேர்ந்தெடுக்கவும்",
    "mobile_toolbarnav_title_select_team": "குழுவைத் தேர்ந்தெடுக்கவும்",
    "mobile_toolbarnav_title_select_team_or_location": "குழு அல்லது இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்",
    "mobile_toolbarnav_title_filter_tasks": " பணிகளை வடிகட்டவும்",
    "mobile_toolbarnav_title_filter_projects": "திட்டங்களை வடிகட்டவும்",
    "mobile_toolbarnav_title_filter_project_tasks": "திட்ட பணிகளை வடிகட்டவும்",
    "mobile_placeholder_search_bar": "தேடல்",
    "mobile_placeholder_user_select_role": "பயனர் பாத்திரத்தைத் தேர்ந்தெடுக்கவும்",
    "mobile_placeholder_filter_by_team": "ஒரு குழுவால் வடிகட்டவும்",
    "mobile_placeholder_assign_to_user_role": "பயனர் பாத்திரத்திற்கு ஒதுக்கு",
    "mobile_placeholder_select": "- தேர்ந்தெடு -",
    "mobile_placeholder_account_location_name": "இருப்பிடத்தின் பெயர்",
    "mobile_placeholder_tag_filter_by": "இருப்பிட குறிச்சொல் மூலம் வடிகட்டவும்",
    "mobile_placeholder_user_type": "பயனருக்கு ஒதுக்கு",
    "mobile_placeholder_acount_type_loading": "ஏற்றுகிறது ... ",
    "mobile_placeholder_therm_no_bluetooth": "வெப்ப நிலை",
    "mobile_placeholder_blue_therm_connecting": "சாதனத்துடன் இணைக்கிறது ...",
    "mobile_placeholder_blue_therm_please_wait": "தயவுசெய்து காத்திருங்கள் ...",
    "mobile_placeholder_blue_therm_tap": "படிக்கத் தட்டவும்.",
    "mobile_placeholder_blue_therm_not_connected": "இணைக்கப்படவில்லை",
    "mobile_placeholder_testo_tap": "காத்திரு ▼▲ தொடர்ந்து ⬆",
    "mobile_message_error_create_task": "பணிகளைச் சேர்க்க நீங்கள் ஆன்லைனில் இருக்க வேண்டும்.",
    "mobile_message_error_fill_out_form": "படிவத்தை நிரப்பவும்.",
    "mobile_message_error_fill_require_fields": "தேவையான புலங்களை நிரப்பவும்.",
    "mobile_message_error_stop_stopwatch_before_submit": "சமர்ப்பிக்கும் முன் உங்கள் ஸ்டாப்வாட்சை நிறுத்துங்கள்",
    "mobile_message_error_stopwatch_field_required": "ஸ்டாப்வாட்ச் புலம் தேவை",
    "mobile_message_error_stopwatch_field_running": "ஸ்டாப்வாட்ச் புலம் இயங்குகிறது",
    "mobile_message_error_invalid_equipment_temperature": "தவறான உபகரண வெப்பநிலை",
    "mobile_message_error_invalid_ingredient_temperature": "தவறான மூலப்பொருள் வெப்பநிலை",
    "mobile_message_error_location_attributes_unavailable": "சில கேள்விகள் கிடைக்காமல் இருக்கலாம், இணையத்துடன் இணைக்கவும் ",
    "mobile_message_alert_running_stopwatches": "நீங்கள் நிறுத்தக் கடிகாரங்களை இயக்குகிறீர்கள். \n \n அவற்றை அழிக்க விரும்புகிறீர்களா?",
    "mobile_message_blue_therm_error": "புளூடூத் சாதனத்திற்கான இணைப்பை இழந்தது",
    "mobile_message_blue_therm_no_permission_android_pre_12": "இருப்பிடம் அணுகல் தேவை. அதை உங்கள் ஆண்ட்ராய்டு அமைப்புகளில் இயக்கவும்.",
    "mobile_message_blue_therm_no_permission_android": "அருகிலுள்ள சாதனங்கள் அணுகல் தேவை. அதை உங்கள் ஆண்ட்ராய்டு (Android) அமைப்புகளில் இயக்கவும்.",
    "mobile_message_blue_therm_error_code": "இணைக்க முடியவில்லை:",
    "mobile_message_blue_therm_error_bluetooth": "புளூடூத்தை இயக்கவும்.",
    "mobile_message_blue_therm_error_device": "சாதனம் கிடைக்கவில்லை.",
    "mobile_message_blue_therm_error_try_again": "தயவுசெய்து மீண்டும் முயற்சி செய்க",
    "mobile_message_blue_therm_success": "புளூடூத் சாதனம் இணைக்கப்பட்டுள்ளது!",
    "mobile_message_bluetooth_device_press_button_field": "இணைக்க உங்கள் சாதனத்தில் உள்ள பொத்தானை அழுத்தவும்.",
    "mobile_message_bluetooth_device_press_button_devices_list": "இங்கே பட்டியலிடப்படவில்லை எனில் உங்கள் சாதனத்தில் உள்ள பொத்தானை அழுத்தவும் <br /> .",
    "mobile_bluetooth_scan": "ஸ்கேன்",
    "mobile_bluetooth_scanning": "ஸ்கேன் செய்கிறது",
    "mobile_message_drafts_confirm": "இதை ஒரு வரைவாக சேமிக்க விரும்புகிறீர்களா?",
    "mobile_message_drafts_toast_saved": "வரைவு சேமிக்கப்பட்டது.",
    "mobile_message_drafts_request_update": "இந்த வரைவை புதுப்பிக்க விரும்புகிறீர்களா?",
    "mobile_message_drafts_form_confirm": "இந்த வரைவை நீக்க விரும்புகிறீர்களா?",
    "mobile_message_drafts_confirm_delete": "வரைவை நீக்கு",
    "mobile_message_streams_error_switch": "வலையில் ஸ்ட்ரீம்களை மாற்ற முடியாது",
    "mobile_message_settings_success_saved": "அமைப்புகள் சேமிக்கப்பட்டன",
    "mobile_message_settings_error": "அறியப்படாத பிழை ஏற்பட்டது. பின்னர் மீண்டும் முயற்சிக்கவும்",
    "mobile_message_profile_settings_error_fields": "முன்னிலைப்படுத்தப்பட்ட புலங்களை சரிசெய்யவும்.",
    "mobile_message_media_perimission_denied": "உங்கள் ",
    "mobile_message_media_perimission_denied_device": "சாதன சேமிப்பு",
    "mobile_message_image_confirm_remove_image": "இந்த புகைப்படத்தை நீக்க விரும்புகிறீர்களா?",
    "mobile_message_create_account_error_fields": "முன்னிலைப்படுத்தப்பட்ட புலங்களை நிரப்பவும்.",
    "mobile_message_create_account_success_location_created": "இடம் உருவாக்கப்பட்டது",
    "mobile_message_task_error_get_location": "இருப்பிடத்தைப் பெறுவதில் தோல்வி. தேதி வாரியாக ஆர்டர்.",
    "mobile_message_typehead_confirm_save_message": "இந்த தேர்வுகளை சேமிக்க விரும்புகிறீர்களா",
    "mobile_message_typehead_confirm_save_title": "சேமிக்கவா?",
    "mobile_message_task_creator_error_save_select_form": "நீங்கள் ஒரு படிவத்தைத் தேர்ந்தெடுக்க வேண்டும்",
    "mobile_message_task_creator_error_save_required_fields": "தேவையான புலங்களை நிரப்பவும்.",
    "mobile_message_task_creator_error_save_batch_change": "ஒன்று அல்லது அதற்கு மேற்பட்ட பயனர்களுடன் பொருந்தக்கூடிய அளவுகோல்களை மாற்றவும்",
    "mobile_message_task_detials_error_not_assigned_to_you": "இந்த பணி உங்களுக்கு ஒதுக்கப்படவில்லை. <br /> நீங்கள் அதை முடிக்க முடியாது.",
    "mobile_message_task_detials_error_assigned_to": "இந்த பணி {{user}} க்கு ஒதுக்கப்பட்டுள்ளது. <br /> நீங்கள் அதை முடிக்க முடியாது.",
    "mobile_message_task_detials_confirm_title": "பணியை விட்டு விலகவும்",
    "mobile_message_task_detials_confirm_save_task": "பணியைச் சேமிக்கவும்",
    "mobile_message_task_detials_confirm_message": " உறுதி செய்கிறீர்களா? உங்கள் மாற்றங்கள் இழக்கப்படும்.",
    "mobile_message_task_detials_error_view_account": "இருப்பிடத்தை அணுக முடியவில்லை.",
    "mobile_message_task_detials_error_submit_task": "இந்த பணியை முடிக்க புகைப்படத்தைச் சேர்க்கவும்.",
    "mobile_message_task_detials_error_submit_task_project": "திட்டத்தை சேமிக்க முடியவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "mobile_message_task_detials_wait_submit_task_created": "பணிகள் உருவாக்கப்படுகின்றன. <br /> பணிகள் மக்கள்தொகை பெற சில நிமிடங்கள் காத்திருக்கவும்.",
    "mobile_message_task_detials_error_submit_task_pending": "பிழை, பின்னர் மீண்டும் முயற்சிக்கவும்",
    "mobile_message_task_detials_success_task_complete": "பணி முடிந்தது",
    "mobile_message_task_error_save_single_task": "பணியைச் சேமிக்க முடியவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "mobile_message_task_success_save_single_task": "பணி உருவாக்கப்பட்டது.",
    "mobile_message_show_error_message": "ஏதோ தவறு நடந்துவிட்டது.",
    "mobile_message_show_success_message": "வெற்றி!",
    "mobile_message_show_offline_message": "நீங்கள் தற்போது ஆஃப்லைனில் இருக்கிறீர்கள்.",
    "mobile_message_show_permission_denied_message": "<b> அனுமதி தேவை. </b> அணுக Zenputக்கு அனுமதி வழங்கவும் {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>அனுமதி தேவை.</b> அணுக Zenput மற்றும் உங்கள் உலாவிக்கு அனுமதி வழங்கவும் {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "இப்போது பதிவேற்றுகிறது",
    "mobile_message_show_upload_in_progress_message": "பதிவேற்றம் ஏற்கனவே செயலில் உள்ளது",
    "mobile_message_show_form_id_error": "குறிப்பிட்ட படிவத்தை அணுக முடியவில்லை.",
    "mobile_message_show_single_task_error": "குறிப்பிட்ட பணியை அணுக முடியவில்லை.",
    "mobile_message_show_submissions_error": "குறிப்பிட்ட சமர்ப்பிப்பை அணுக முடியவில்லை.",
    "mobile_message_show_submissions_access_denied": "மன்னிக்கவும், இந்த படிவத்தை அணுக முடியாது.",
    "mobile_message_send_data_success": "தரவு பதிவேற்றப்பட்டது ",
    "mobile_message_start_upload_success": "பதிவேற்றம் முடிந்தது",
    "mobile_message_start_upload_error": "<b> பதிவேற்றத்தை முடிக்க முடியவில்லை. </b> <br> சமர்ப்பிப்பு சேமிக்கப்பட்டது. பின்னர் மீண்டும் முயற்சிக்கவும்",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "புதுப்பிப்பு கிடைக்கிறது",
    "mobile_message_store_upgrade_confirm_message_one": "தயவுசெய்து ஓப்ஸ் எக்ஸிகியூஷன் (Ops Execution) செயலியை இருந்து புதுப்பிக்கவும் ",
    "mobile_message_store_upgrade_confirm_message_one_old": "லிருந்து Zenputடை  புதுப்பிக்கவும் ",
    "mobile_message_store_upgrade_confirm_message_two": " அனைத்து புதிய அம்சங்களையும் பிழைத் திருத்தங்களையும் பெற",
    "mobile_message_store_upgrade_confirm_now": "இப்போது",
    "mobile_message_store_upgrade_confirm_later": "பின்னர்",
    "mobile_message_redirect_confirm_message": "நீங்கள் தற்போது ஒரு படிவத்தை நிரப்புகிறீர்கள். தொடர்வதற்கு முன் அதை வரைவாக சேமிக்க விரும்புகிறீர்களா?",
    "mobile_message_log_out_confirm_unsynced_drafts": "உங்களிடம் இதுவரை பதிவேற்றப்படாத {{count}} வரைவுகள் உள்ளன. நீங்கள் தொடர்ந்தால் இவை இழக்கப்படும். உறுதிசெய்கிறீர்களா?",
    "mobile_message_draft_override_message": "இந்த வரைவு {{date}} இல் உள்ள மற்றொரு சாதனத்திலிருந்து சேமிக்கப்பட்டது, மேலும் இந்த சாதனத்தின் மாற்றங்கள் முரண்படுகின்றன. இருக்கும் பதிப்பை மேலெழுத நீங்கள் தேர்வு செய்யலாம் அல்லது மிக சமீபத்திய பதிப்பிற்கு மீண்டும் ஏற்றலாம், மேலும் உங்கள் மாற்றங்கள் நிராகரிக்கப்படும்.",
    "mobile_html_submitting": "சமர்ப்பிக்கிறது ...",
    "mobile_html_offline": "நீங்கள் தற்போது ஆஃப்லைனில் இருக்கிறீர்கள்!",
    "mobile_html_offline_try_again": "நீங்கள் தற்போது ஆஃப்லைனில் இருக்கிறீர்கள். <br/> <br/> நீங்கள் இணைக்கப்பட்டவுடன் மீண்டும் முயற்சிக்கவும்",
    "mobile_html_something_went_wrong": "அட டா. ஏதோ தவறு நடந்துவிட்டது.",
    "mobile_html_something_went_wrong_try_again": "அட டா. ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "mobile_html_failed_loading_roles": "பாத்திரங்களை ஏற்றுவதில் தோல்வி.",
    "mobile_alert_please_install_for_native": "இந்த அம்சத்தைப் பயன்படுத்த, ஓப்ஸ் எக்ஸிகியூஷன் செயலியை நிறுவவும். ",
    "mobile_alert_please_install_for_native_old": "இந்த அம்சத்தைப் பயன்படுத்த சொந்த Zenput செயலியை நிறுவவும்.",
    "mobile_tso_filter_all_tasks": "அனைத்தும் {{type}}",
    "mobile_tso_filter_my_tasks": "எனது {{type}}",
    "mobile_tso_filter_due_date": " முடிக்க வேண்டிய தேதி",
    "mobile_tso_filter_date_completed": "முடிந்த தேதி",
    "mobile_tso_filter_completed": "முடிந்ததவை",
    "mobile_tso_filter_completed_late": "தாமதமாக முடிந்தது",
    "mobile_tso_filter_incomplete": "முடிக்காதவை",
    "mobile_tso_filter_var_my_tasks": "எனது {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} என்னால் உருவாக்கப்பட்டது",
    "mobile_tso_filter_var_all_tasks": "அனைத்தும் {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "பின்தொடர் நடவடிக்கைகள்",
    "mobile_tso_type_all": "பணிகள் மற்றும் பின்தொடர் நடவடிக்கைகள்",
    "mobile_tso_filter_var_at": " {{location}} இல்",
    "mobile_tso_filter_group_date_due": ",முடிக்க வேண்டிய தேதியின் படி ஆர்டர் செய்யப்பட்டுள்ளன",
    "mobile_tso_filter_group_distance": "இருப்பிடத்தின்படி  தொகுக்கப்பட்டுள்ளன",
    "mobile_tso_filter_start_date": "தொடக்க தேதி",
    "mobile_tso_filter_none": "எதுவுமில்லை",
    "mobile_pso_filter_all_projects": "அனைத்து திட்டங்களும்",
    "mobile_pso_filter_my_projects": "எனது திட்டங்கள்",
    "mobile_pso_filter_active": "செயலில்",
    "mobile_pso_filter_archived": "காப்பகப்படுத்தப்பட்டவை",
    "mobile_pso_filter_recurring": "தொடர்ச்சியாக செய்யப்படுபவை",
    "mobile_pso_filter_non_recurring": "தொடர்ச்சியானவை அல்ல",
    "mobile_pso_filter_var_my_projects": "எனது {{project_type}} {{active_description}} திட்டங்கள்",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} நான் உருவாக்கிய திட்டங்கள்",
    "mobile_pso_filter_var_all_projects": "அனைத்து {{project_type}} {{active_description}} திட்டங்கள்",
    "mobile_empty_list_message_must_be_online": "நீங்கள் ஆஃப்லைனில் இருப்பது போல் தெரிகிறது.  முடிவுகளைக் காண ஆன்லைனில் செல்லுங்கள்.",
    "mobile_empty_list_message_no_submissions": "சமர்ப்பிப்புகள் இல்லை",
    "mobile_empty_list_message_no_activity": "செயல்பாடு இல்லை",
    "mobile_empty_list_message_no_tasks": "பணிகள் இல்லை",
    "mobile_empty_list_message_no_tasks_overdue": "நிலுவை இல்லை {{type}}",
    "mobile_empty_list_message_no_accounts": "இருப்பிடங்கள் இல்லை",
    "mobile_empty_list_message_no_projects": "திட்டங்கள் இல்லை",
    "mobile_empty_list_message_no_results_found": "முடிவுகள் எதுவும் இல்லை",
    "mobile_empty_list_message_no_forms_available": "படிவங்கள் எதுவும் கிடைக்கவில்லை",
    "mobile_empty_list_message_connection_error": "இணைப்பு பிழை <br /> தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "mobile_empty_list_message_dashboard_error": "டாஷ்போர்டை ஏற்ற முடியவில்லை",
    "mobile_empty_list_message_user_offline": "நீங்கள் தற்போது ஆஃப்லைனில் இருக்கிறீர்கள்",
    "mobile_action_sheet_media_gallery": "கேலரி",
    "mobile_action_sheet_cancel": "ரத்துசெய்",
    "mobile_image_preview_text": "புகைப்படத்தை அகற்று",
    "mobile_mobileform_text": "முந்தைய சமர்ப்பிப்புகள்",
    "mobile_mobileform_reorder_fields": "கேள்விகளை மீண்டும் வரிசைப்படுத்தவும்",
    "mobile_mobileform_follow_up_actions": "பின்தொடர்தல் நடவடிக்கைகள்",
    "mobile_mobileform_follow_up_actions_assign_title": "பின்தொடர் நடவடிக்கைகளை ஒதுக்குங்கள்",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "பிரச்சினைகள் தீர்க்கப்படுவதை உறுதிசெய்ய, உங்கள் கவனிப்புகளின் அடிப்படையில் பின்தொடர் நடவடிக்கைகளைச் சேர்க்கவும்.",
    "mobile_mobileform_follow_up_actions_add_button": "+ பின்தொடர் நடவடிக்கை ஒன்றைச் சேர்",
    "mobile_mobileform_follow_up_actions_assign_button": "பின்தொடர் நடவடிக்கைகளை ஒதுக்குங்கள்",
    "mobile_mobileform_follow_up_actions_without_assign_button": "ஒதுக்கீடு செய்யாமல் தொடரவும்",
    "mobile_mobileform_follow_up_actions_dialog_title": "பின்தொடர் நடவடிக்கைகளை ஒதுக்காமலே தொடரவா?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "எந்தவொரு பின்தொடர் நடவடிக்கைகளையும் ஒதுக்காமல் நீங்கள் தொடர்ந்தால், அவற்றை பின்னர் சேர்க்க இயலாது.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "இருப்பினும் தொடரவும்",
    "mobile_mobileform_add_follow_up_actions_forms_required": "இந்தப் புலம் கட்டாயமானது",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "மிக அதிகமான எழுத்துக்கள்",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "இந்த புலம் செல்லாதது.",
    "mobile_mobileform_add_follow_up_actions_error_locations": "இடங்களை ஏற்றுவதில் பிழை",
    "mobile_mobileform_add_follow_up_actions_error_users": "பயனர்களை ஏற்றுவதில் பிழை",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "பின்தொடர் நடவடிக்கையைச் சேர்",
    "mobile_mobileform_add_follow_up_actions_forms_title": "தலைப்பு",
    "mobile_mobileform_add_follow_up_actions_forms_description": "விளக்கம்",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "புகைப்படம் தேவை",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "கடைசித் தேதி",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "பின்தொடர்வதை புதுப்பிக்கவும்",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "பின்தொடர்வதை நீக்கவா?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "அது நீக்கப்படும், மேலும் அது ஒதுக்கீடு செய்யப்படாது.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "பின்தொடர்வதை நீக்கவும்",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "இந்தத் பின்தொடர் நடவடிக்கையை நீக்க நீங்கள் உறுதியாக உள்ளீர்களா? \n\nஇதை மாற்ற முடியாது.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "பின்தொடர் நடவடிக்கைகளைத் தொடர்க",
    "mobile_mobileform_follow_up_actions_completed_notification": "பின்தொடர் நடவடிக்கை நிறைவடைந்தது",
    "mobile_mobileform_follow_up_actions_deleted_notification": "பின்தொடர் நடவடிக்கை நீக்கப்பட்டது",
    "mobile_mobileform_follow_up_actions_update_notification": "பின்தொடர் நடவடிக்கை புதுப்பிக்கப்பட்டது",
    "mobile_mobileform_follow_up_actions_required_photo_error": "இந்தத் தொடர் நடவடிக்கையை நிறைவு செய்ய, தயவுசெய்து ஒரு புகைப்படத்தைச் சேர்க்கவும்.",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "சமர்ப்பிப்பிற்குச் செல்லவும்",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "மூலத்திற்குச் செல்க",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "மூலம்",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "பின்தொடர் நடவடிக்கையை நிறைவு செய்யவும்",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "நீங்கள் சமர்ப்பிப்பைத் திறந்தால், சேமிக்கப்படாத புகைப்படங்கள் மற்றும் குறிப்புகள் அனைத்தும் இழக்கப்படும்.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "இந்தத் திரையை விட்டு வெளியேறினால், சேமிக்கப்படாத புகைப்படங்களும் குறிப்புகளும் நீக்கப்படும்.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "இங்கே இருங்கள்.",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "சமர்ப்பிப்பைத் திறக்கவும்",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "திறந்த மூலம் (Open source)",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "இந்த பின்தொடர் நடவடிக்கையை விட்டுவிடலாமா?  ",
    "mobile_mobileform_follow_up_actions_submission": "சமர்ப்பிப்பு",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "இந்த பின்தொடர் நடவடிக்கை {{user}}க்கு ஒதுக்கப்பட்டுள்ளது.<br /> இதை உங்களால் நிறைவு செய்ய இயலாது.",
    "mobile_mobileform_follow_up_actions_leave_description": "இந்தத் திரையை விட்டு வெளியேறினால், சேமிக்கப்படாத மாற்றங்கள் அனைத்தும் இழக்கப்படும்.",
    "mobile_mobileform_follow_up_actions_leave": "வௌியேறு",
    "mobile_forms_drafts_text": "வரைவுகளை அகற்று",
    "mobile_batch_estimate_user": "பயனர்",
    "mobile_batch_estimate_users": "பயனர்கள்",
    "mobile_table_of_contents": "பொருளடக்கம்",
    "mobile_table_of_contents_required": "தேவை",
    "mobile_table_of_contents_optional": "விரும்பினால்",
    "mobile_dialog_alert_title": "எச்சரிக்கை",
    "mobile_dialog_alert_ok": "சரி",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth சாதனங்கள் Windows-இல் இன்னும் ஆதரிக்கப்படவில்லை",
    "mobile_windows_deprecated_message_content_announcement": "அறிவிப்பு",
    "mobile_windows_deprecated_message_title": "செயலியைப் புதுப்பிக்க வேண்டும்",
    "mobile_windows_deprecated_message_description": "Microsoft Store-இல் புது Zenput செயலியை உடனடியாக நிறுவி, முக்கியமான செயல்பாட்டுப் புதுப்பிப்புகள் மற்றும் உகந்த Zenput அனுபவத்தை உறுதிசெய்யவும்.",
    "mobile_dashboard_tcr_graph_name": "பணி நிறைவு விகிதம்",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "கடந்த 4 வாரங்கள்",
    "mobile_dashboard_tcr_legend_company_average": "நிறுவனத்தின் சராசரி",
    "mobile_dashboard_tcr_legend_team_average": "அணி சராசரி",
    "mobile_dashboard_tab_title_summary": "சுருக்கம்",
    "mobile_dashboard_tab_title_activity": "நடவடிக்கை",
    "mobile_dashboard_card_title_top_triggered_workflows": "சிறந்த தூண்டுதல்கள்",
    "mobile_dashboard_tab_title_info": "தகவல்",
    "mobile_dashboard_tab_project_audit": "இணக்கம்",
    "mobile_dashboard_card_task_stats_total": "மொத்தம்",
    "mobile_dashboard_top_item_header_week_of": "வாரம்",
    "mobile_dashboard_card_filter_form_template_placeholder": "அனைத்து படிவங்களும்",
    "mobile_dashboard_card_title_forms_top_nos": "அடிக்கடி \"இல்லை\" கள்",
    "mobile_dashboard_zenput_code_no_data_in_range": "இந்த நேர வரம்பில் தரவு இல்லை.",
    "mobile_dashboard_zenput_code_permission_denied": "இதைப் பார்க்க உங்களுக்கு அனுமதி இல்லை.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "மேலே இருந்து ஒரு படிவத்தைத் தேர்ந்தெடுக்கவும்.",
    "mobile_dashboard_zenput_code_unknown_error": "இந்த நேரத்தில் தரவை எங்களால் காட்ட முடியாது.",
    "mobile_dashboard_tap_to_retry": "மீண்டும் முயற்சிக்க தட்டவும்",
    "mobile_dashboard_reporting_delay_disclaimer": "பணிகள் புதுப்பிக்க 15 நிமிடங்கள் ஆகலாம்",
    "mobile_dashboard_configuration_down_state_postfix_msg": "உங்கள் நிர்வாகியால் உள்ளமைக்கப்பட்டுள்ளது",
    "mobile_tasks_tag": "பணிகள்",
    "mobile_workflows_tag": "தூண்டுகிறது",
    "mobile_projects_tag": "தொடர்ச்சியான திட்டங்கள்",
    "mobile_forms_tag": "படிவங்கள்",
    "mobile_dashboard_card_ongoing_projects_title": "முன்னேற்ற திட்டங்கள்",
    "mobile_dashboard_card_ongoing_projects_show_more": "அதிகமாகக் காட்டு",
    "mobile_dashboard_card_ongoing_projects_show_less": "குறைவாகக் காட்டு",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "திட்டங்களுக்குச் செல்லவும்",
    "mobile_dashboard_card_title_recurring_projects": "தொடர்ச்சியான திட்டங்கள்",
    "mobile_dashboard_card_filter_daily": "தினசரி",
    "mobile_dashboard_card_filter_weekly": "வாராந்திர",
    "mobile_dashboard_card_filter_monthly": "மாதாந்திர",
    "mobile_task_status_title_open": "திற",
    "mobile_task_status_title_upcoming": "வரவிருப்பவை",
    "mobile_task_status_title_complete": "முடிவடைந்தவை",
    "mobile_task_status_title_processing": "சமர்ப்பிக்கும் செயலாக்கம்",
    "mobile_task_status_title_complete_with_exceptions": "பின்தொடர்தல் பணிகள் அல்லது விழிப்பூட்டல்களுடன் முடிந்தவை",
    "mobile_task_status_title_completed_late_with_exceptions": "பின்தொடர்தல் பணிகள் அல்லது விழிப்பூட்டல்களுடன் தாமதமாக முடிக்கப்பட்டது",
    "mobile_task_status_title_incomplete_and_closed": "தவறவிட்டது",
    "mobile_tasks_legend_modal_title": "பழையது",
    "mobile_tasks_legend_modal_footer_button_title": "மூடுக",
    "mobile_common_assigned_to": "ஒதுக்கப்படும்",
    "mobile_common_created_by": "உருவாக்கியது",
    "mobile_common_tasks_for": "பணிகளுக்கான",
    "mobile_common_go_back": "பின் செல்க",
    "mobile_oh_no": "அடடா!",
    "mobile_user_not_in_groups": "மன்னிக்கவும், நீங்கள் ஒரு குழுவுக்கு ஒதுக்கப்படவில்லை என தெரிகிறது. உங்கள் டாஷ்போர்டுக்கு அணுகலைப் பெற உங்கள் நிர்வாகியைத் தொடர்பு கொள்ளுங்கள்.",
    "mobile_tasks_select_followers": "பின்தொடர்பவர்களைத் தேர்ந்தெடுக்கவும்",
    "mobile_tasks_assign_tasks": "{{count}} பணிகளை ஒதுக்கு",
    "mobile_tasks_add_followers": "பின்தொடர்பவர்களைச் சேர்க்கவும்",
    "mobile_tasks_followers": "பின்தொடர்பவர்கள்",
    "mobile_tasks_delete_task": "பணியை நீக்கு",
    "mobile_tasks_create_task": "பணிகளை உருவாக்கவும்",
    "mobile_tasks_tab_title_comments": "கருத்துரைகள்",
    "mobile_tasks_see_more": "மேலும் பார்க்க",
    "mobile_projects_create_project": "திட்டத்தை உருவாக்கவும்",
    "mobile_common_button_send": "அனுப்புக",
    "mobile_common_button_schedule": "அட்டவணை",
    "mobile_announcements_create": "அறிவிப்பை உருவாக்கவும்",
    "mobile_announcements_read_rate": "{{opened_count}} இன் {{recipients_count}} திறக்கப்பட்டது",
    "mobile_announcements_empty_message": "நீங்கள் இதுவரை எந்த அறிவிப்புகளையும் உருவாக்கவில்லை! உங்கள் நிறுவனத்திற்கு முக்கியமான செய்திகள், தகவல்கள் மற்றும் புதுப்பிப்புகளை ஒளிபரப்ப கீழே ஒரு அறிவிப்பை உருவாக்கவும்.",
    "mobile_announcement_message_placeholder": "ஒரு செய்தியைச் சேர் ...",
    "mobile_announcement_title_placeholder": "அறிவிப்பு தலைப்பு",
    "mobile_announcement_leaving_announcement": "அறிவிப்பை விட்டு வெளியேறுக",
    "mobile_announcement_confirm_recipients_team": "இந்த அறிவிப்பை {{teams}} தேர்ந்தெடுக்கப்பட்ட குழு (களில்) {{count}} பயனர் (கள்) க்கு ஒளிபரப்ப விரும்புகிறீர்களா?",
    "mobile_announcement_confirm_recipients_role": "இந்த அறிவிப்பை {{count}} தேர்ந்தெடுக்கப்பட்ட பயனர் பங்கு (களில்) {{roles}} பயனர் (கள்) க்கு ஒளிபரப்ப விரும்புகிறீர்களா?",
    "mobile_announcement_confirm_recipients_user": "இந்த அறிவிப்பை {{count}} பயனர் (களுக்கு) ஒளிபரப்ப விரும்புகிறீர்களா?",
    "mobile_announcement_confirm_scheduled": "{{timestamp}} இல்",
    "mobile_announcement_sending_announcement": "அறிவிப்பை அனுப்புகிறது",
    "mobile_announcement_send_to": "அனுப்புங்கள்",
    "mobile_announcement_sent_to": "அனுப்பப்பட்டது",
    "mobile_announcement_send_to_role": "செயல்",
    "mobile_announcement_attachment_download": "பதிவிறக்குகிறது {{filename}}",
    "mobile_announcement_attachment_validation_error": "{{maxCount}} இணைப்புகளுக்கு மேல் சேர்க்க முடியாது ",
    "mobile_announcement_details_sent": "அனுப்பப்பட்டது",
    "mobile_announcement_details_total_recipients": "மொத்த பெறுநர்கள்",
    "mobile_announcement_details_cancel": "அறிவிப்பை ரத்துசெய்",
    "mobile_announcement_details_not_editable": "அறிவிப்புகளை ஓப்ஸ் எக்ஸிகியூஷன் வலைச் செயலியில் மட்டுமே திருத்த முடியும். ",
    "mobile_announcement_details_not_editable_old": "அறிவிப்புகள் Zenput வலையில் மட்டுமே திருத்தப்படலாம்",
    "mobile_announcement_details_open_count": "திறந்த எண்ணிக்கை",
    "mobile_announcement_details_open_rate": "திறந்த வீதம்",
    "mobile_announcement_details_resend": "திறக்காதவர்களுக்கு மீண்டும் அனுப்புங்கள்",
    "mobile_announcement_confirm_resend": "{{count}} பயனர் (கள்) அறிவிப்பைப் படிக்கவில்லை. நினைவூட்டலை அனுப்ப விரும்புகிறீர்களா?",
    "mobile_announcement_confirm_resend_title": "நினைவூட்டலை அனுப்பவா?",
    "mobile_announcement_recipients_opened": "திறக்கப்பட்டது",
    "mobile_recipients_opened_empty_message": "உங்கள் செய்தியை இதுவரை யாரும் திறக்கவில்லை என்று தெரிகிறது. உங்கள் முடிவுகளைக் காண பின்னர் திரும்பி வாருங்கள்.",
    "mobile_announcement_recipients_unopened": "திறக்கப்படவில்லை",
    "mobile_recipients_unopened_empty_message": "நல்ல செய்தி! திறக்கப்படாத செய்திகள் இல்லை!",
    "mobile_scheduled_announcements_delivery_section_header": "டெலிவரி நேரம்",
    "mobile_scheduled_announcements_send_immediately_label": "உடனடியாக அனுப்புங்கள்",
    "mobile_scheduled_announcements_scheduled_label": "ஒரு குறிப்பிட்ட நேரத்தில் அனுப்புங்கள்",
    "mobile_scheduled_announcements_scheduled_tab_label": "திட்டமிடப்பட்டவை",
    "mobile_scheduled_announcements_dialog_header": "அறிவிப்பை ரத்து செய்யவா?",
    "mobile_scheduled_announcements_dialog_message": "உங்கள் அறிவிப்பை ரத்துசெய்வது அனுப்பப்படுவதைத் தடுத்து உங்கள் பட்டியலிலிருந்து நீக்கும். இதை முடிக்காமல் விட கூடாது. திருத்த Zenput வலைக்குச் செல்லவும்.",
    "mobile_scheduled_announcements_empty_message": "உங்களிடம் தற்போது திட்டமிடப்பட்ட அறிவிப்புகள் எதுவும் இல்லை. உங்கள் நிறுவனத்திற்கு முக்கியமான செய்திகள், தகவல்கள் மற்றும் புதுப்பிப்புகளை ஒளிபரப்ப ஒரு அறிவிப்பைத் திட்டமிடுங்கள்.",
    "mobile_scheduled_announcements_validation_error": "விநியோக நேரம் {{date}} க்குப் பிறகு இருக்க வேண்டும்",
    "mobile_scheduled_announcements_empty_state_button": "அட்டவணை அறிவிப்பு",
    "mobile_projects_auto_archive": "தானாக காப்பகப்படுத்து",
    "mobile_common_unassigned": "ஒதுக்கப்படாதது",
    "mobile_tasks_title_placeholder": "புதிய பணி அல்லது படிவம்",
    "mobile_projects_leaving_project": "திட்டத்தை விட்டு வெளியேறுக",
    "mobile_projects_save_project": "திட்டத்தை சேமிக்கவும்",
    "mobile_top_triggers_tasks": "சிறந்த தூண்டப்பட்ட பணிகள்",
    "mobile_top_triggers_alerts": "சிறந்த தூண்டப்பட்ட விழிப்பூட்டல்கள்",
    "mobile_projects_not_started": "துவங்கவில்லை",
    "mobile_empty_list_message_no_photos": "புகைப்படங்கள் இல்லை",
    "mobile_webfilestore_message_error": "செல்லுபடியாகும் கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
    "mobile_notifications_empty_title": "அறிவிப்புகள் இல்லை",
    "mobile_notifications_empty_message": "உங்கள் பணிகளின் செயல்பாடு அல்லது நீங்கள் ஒரு பகுதியாக இருக்கும் பணிகள் இங்கே தோன்றும்.",
    "mobile_comments_comment_deleted": "இந்த கருத்து நீக்கப்பட்டது.",
    "mobile_comments_comment_placeholder": "கருத்து",
    "mobile_comments_task_submitted_at": "{{ date }} இல் {{ time }} இல் பணி சமர்ப்பிக்கப்பட்டது",
    "mobile_comments_discard_comment_title": "கருத்தை நிராகரிக்கவா?",
    "mobile_comments_discard_confirm_message": "உறுதிசெய்கிறீர்களா? உங்கள் கருத்து நீக்கப்படும்.",
    "mobile_comments_delete_comment_title": "கருத்தை நீக்கவா?",
    "mobile_comments_delete_confirm_message": "இது முடிக்கப்படாமல் இருக்க கூடாது.",
    "mobile_comments_delete_button": "கருத்தை நீக்கு",
    "mobile_comments_delete_success_message": "கருத்து நீக்கப்பட்டது",
    "mobile_comments_empty_message_tasks": "இதுவரை கருத்துகள் எதுவும் இல்லை \n இந்த பணியில் உரையாடலைத் தொடங்கவும்.",
    "mobile_comments_empty_message_submissions": "இதுவரை கருத்துகள் எதுவும் இல்லை \n இந்த சமர்ப்பிப்பில் உரையாடலைத் தொடங்கவும்.",
    "mobile_comments_empty_message_default": "இன்னும் கருத்துகள் இல்லை \n ஒரு உரையாடலை த் தொடங்கவும்.",
    "mobile_comments_no_matching_users": "பயனர்கள் பொருந்தவில்லை.",
    "mobile_comments_empty_users_to_notify": "எந்த பயனர்களும் குறிப்பிட முடியாது.",
    "mobile_comments_users_cant_view_message": "இந்த பயனர்கள் இந்த கருத்துகளைப் பார்க்க முடியாது",
    "mobile_comments_users_to_notify_title": "அறிவிக்க வேண்டிய பயனர்கள்",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\"> {{ count }} பயனர் </a> அறிவிக்கப்படும்.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\"> {{ count }} பயனர்களுக்கு </a> அறிவிக்கப்படும்.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\"> @ குறிப்பிட்ட </a> அதிகமான பயனர்களுக்கு அறிவிக்கப்படும்",
    "mobile_comments_mark_read": "அனைத்தையும் படித்தவை என குறியிடு",
    "mobile_comments_author_mentioned_message": "உங்களைக் குறிப்பிட்டுள்ளார்",
    "mobile_comments_author_commented_message": "கருத்து தெரிவித்தார்",
    "mobile_view_pdf": "PDF ஐக் காண்க",
    "mobile_no_pdf_generated_message": "இந்த சமர்ப்பிப்புக்கு PDF எதுவும் கிடைக்கவில்லை. ஒரு நகல் விரைவில் உங்களுக்கு மின்னஞ்சல் அனுப்பப்படும்.",
    "mobile_clipboard_copied_success": "இணைப்பு உங்கள் கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது.",
    "mobile_share_link": "பகிர் இணைப்பு",
    "mobile_zencam_share": "பகிர்",
    "mobile_zencam_view_details": "விவரங்களை காண்க",
    "mobile_zencam_details_drawer_header": "விவரங்கள்",
    "mobile_zencam_submitted_by": "சமர்ப்பித்தவர்",
    "mobile_zencam_form_title": "படிவத் தலைப்பு",
    "mobile_zencam_date_submitted": "சமர்ப்பிக்கப்பட்டத் தேதி",
    "mobile_oil_quality_warning_message": "எண்ணெய் காலாவதியாகும் நிலையில் உள்ளது",
    "mobile_oil_quality_warning_message_subtitle": "விரைவில் அதை மாற்ற தயாராகுங்கள்",
    "mobile_oil_quality_failure_message": "எண்ணெய் தரம் சரிபார்க்கப்பட்டுள்ளது",
    "mobile_oil_quality_failure_message_subtitle": "உடனடியாக எண்ணெயை மாற்றவும்",
    "mobile_sensors_set_up_gateway": "நுழைவாயில் அமைக்கவும்",
    "mobile_sensors_set_up_gateway_message": "சாதனங்கள் எதுவும் அமைக்கப்படவில்லை எனத் தெரிகிறது. நுழைவாயில் சேர்ப்பதன் மூலம் தொடங்கவும்.",
    "mobile_sensors_gateway_plugged_in": "உங்கள் நுழைவாயில் ஒரு மின் நிலையத்தில் செருகப்பட்டுள்ளதா என்பதை உறுதிப்படுத்திக் கொள்ளுங்கள்",
    "mobile_sensors_add_device": "சாதனத்தைச் சேர்க்கவும்",
    "mobile_sensors_name_this_gateway": "இந்த நுழைவாயிலுக்கு பெயரிடுங்கள்.",
    "mobile_sensors_name_this_sensor": "இந்த சென்சாருக்கு பெயரிடுங்கள்.",
    "mobile_sensors_device_barcode_information": "QR குறியீட்டை ஸ்கேன் செய்யவும் அல்லது கருவியின் லேபிளில் இருந்து ID மற்றும் SC எண்ணை உள்ளிடவும்",
    "mobile_sensors_device_eui_information": "QR குறியீட்டை ஸ்கேன் செய்யவும் அல்லது கருவியின்  லேபிளில் இருந்து DevEUI ஐ உள்ளிடவும்",
    "mobile_sensors_gateway_id_information": "Gateway லேபிளில் குறிப்பிடப்பட்டுள்ள Node ID 'ஐக் குறிப்பிடுங்கள்",
    "mobile_sensors_id_number": "{{untranslatedID}} எண்",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} குறியீடு",
    "mobile_sensors_sensors": "சென்சார்கள்",
    "mobile_sensors_sensor_deveui_error": "QR இலிருந்து DevEUI ஐப் பெற முடியவில்லை. தயவுசெய்து அதை கைமுறையாக உள்ளிடவும்.",
    "mobile_sensors_gateways": "நுழைவாயில்கள்",
    "mobile_sensors_add_sensor": "சென்சார் சேர்க்கவும்",
    "mobile_sensors_add_gateway": "நுழைவாயில் சேர்க்கவும்",
    "mobile_sensor_placement_description": "இந்த சென்சார் எந்தப் பகுதியைக் கண்காணிக்கும்?",
    "mobile_sensors_equipment_placement": "இந்த சென்சார் எந்த பகுதி அல்லது உபகரணங்களை கண்காணிக்கும்?",
    "mobile_sensors_equipment": "இந்த சென்சார் எந்தச் சாதனத்தைக் கண்காணிக்கும்?",
    "mobile_sensors_select_gateway_type": "நுழைவாயில் வகையைத் நுழைவாயில் வகையைத் தேர்ந்தெடுக்கவும்தேர்ந்தெடுக்கவும்",
    "mobile_sensors_select_placement": "வேலை வாய்ப்பு என்பதைத் தேர்ந்தெடுக்கவும்",
    "mobile_sensors_select_equipment": "சாதனங்களைத் சாதனங்களைத் தேர்ந்தெடுக்கவும்தேர்ந்தெடுக்கவும்",
    "mobile_sensors_placement": "வேலை வாய்ப்பு",
    "mobile_sensors_nickname_tip": "குறிப்பிட்ட நிறுவல்களுக்கு அமைவாக இடப்பட்ட புனைப்பெயர்களால் சென்சார் பெயர்கள் நிர்ணயிக்கப்படுகிறது.",
    "mobile_sensors_device_online": "ஆன்லைன்",
    "mobile_sensors_device_offline": "ஆஃப்லைனில்",
    "mobile_sensors_scan_qrcode": "QR குறியீட்டை ஸ்கேன் செய்யவும்",
    "mobile_sensors_enter_manually": "கைமுறையாக உள்ளிடவும்",
    "mobile_sensors_wizard_step_one": "படி 1",
    "mobile_sensors_wizard_step_two": "படி 2",
    "mobile_sensors_wizard_step_three": "படி 3",
    "mobile_sensors_wizard_step_four": "செயற்படி 4",
    "mobile_sensors_wizard_step_five": "செயற்படி 5",
    "mobile_sensors_wizard_step_six": "படி 6",
    "mobile_sensors_initializing": "துவக்குகிறது…",
    "mobile_sensors_nickname": "புனைப்பெயர்",
    "mobile_sensors_field_not_blank": " {{field}} பூர்த்தி செய்யப்பட வேண்டும் ",
    "mobile_sensors_nothing_to_see_here": "இங்கே பார்க்க எதுவும் இல்லை",
    "mobile_sensors_missing_integration": "சென்சார் ஒருங்கிணைப்பு கிடைக்கவில்லை",
    "mobile_sensors_contact_zenput_admin": "தயவுசெய்து உங்கள் நிறுவனத்தின் ஓப்ஸ் எக்ஸிகியூஷன் நிர்வாகியைத் தொடர்பு கொள்ளவும்.",
    "mobile_sensors_contact_zenput_admin_old": "உங்கள் Zenput நிர்வாகியைத் தொடர்பு கொள்ளவும்",
    "mobile_sensors_contact_manager": "சென்சார்களைச் சேர்க்க உங்கள் கணக்கு நிர்வாகியைத் தொடர்பு கொள்ளுங்கள்.",
    "mobile_sensors_device_success_message": "சென்சார் தரவு ஏற்ற 15 நிமிடங்கள் ஆகலாம்",
    "mobile_sensors_last_reading": "முந்தைய ரீடிங்",
    "mobile_sensors_remove_device": "சாதனத்தை அகற்று",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1W",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1Y",
    "mobile_sensors_sensor_settings": "சென்சார் அமைப்புகள்",
    "mobile_sensors_remove_confirm_message": "இந்த சாதனத்தை நீக்க விரும்புகிறீர்களா? \n இதை செயல்தவிர்க்க முடியாது.",
    "mobile_sensors_sensor": "சென்சார்",
    "mobile_sensors_no_equipment_linked": "எந்தச் சாதனமும் எந்தச் சாதனமும் இணைக்கப்படவில்லைஇணைக்கப்படவில்லை",
    "mobile_sensor_cooldown_process": "கூல் டவுன் செயல்முறை",
    "mobile_sensor_last_12_hours": "கடைசி 12 மணி நேரம்",
    "mobile_sensor_start_cooldown_process": "புதிய கூல் டவுன் செயல்முறையைத் தொடங்கவும்",
    "mobile_sensor_cooldown_process_title": "இரண்டு-கட்ட கூல் டவுன் செயல்முறை",
    "mobile_sensor_cooldown_process_description": "இரண்டு-நிலை குளிர்விக்கும் செயல்முறையானது, உணவை {{ stage1_start_temperature }} க்கு மேல் இருந்து {{ stage1_end_temperature }} வரை இரண்டு மணிநேரம் அல்லது அதற்கும் குறைவாகவும், பின்னர் {{ stage1_end_temperature }} முதல் {{ stage2_end_temperature }} வரை நான்கு மணிநேரம் அல்லது அதற்கும் குறைவாகவும் குளிர்விக்கும் தன்மை கொண்டதாகும்.",
    "mobile_sensor_cooldown_process_place_food": "உணவுப் பொருளை குளிர்சாதன பெட்டியில் வைக்கவும்.",
    "mobile_sensor_cooldown_process_insert_sensor": "உணவு தயாரிப்புக்கு சென்சார் ஆய்வைச் செருகவும்.",
    "mobile_sensor_cooldown_process_enter_information": "கீழே உள்ள தகவலை உள்ளிடவும்.",
    "mobile_sensor_cooldown_process_food_product": " கூல் டவுன் செய்யப்பட வேண்டிய உணவு தயாரிப்பு",
    "mobile_sensor_cooldown_cool_down": "கூல் டவுன்",
    "mobile_sensor_cooldown_select_sensor": "சென்சார் தேர்ந்தெடுக்கவும்",
    "mobile_sensors_cooldown_start_cooldown": "கூல் டவுன் தொடங்கவும்",
    "mobile_sensors_cooldown_please_enter_food": "உணவு தயாரிப்பு ஒன்றை உள்ளிடவும்",
    "mobile_sensors_cooldown_please_select_sensor": "ஒரு சென்சாரைத் தேர்ந்தெடுக்கவும்",
    "mobile_sensors_cooldown_status_in_progress": "செயலில் உள்ளது",
    "mobile_sensors_cooldown_status_failed": "தோல்வியடைந்தது",
    "mobile_sensors_cooldown_status_success": "வெற்றி",
    "mobile_sensors_cooldown_stage": "நிலை",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "தொடக்க வெப்பநிலை வரம்பிற்கு வெளியே உள்ளது",
    "mobile_sensors_cooldown_failed_cooldown_process": "கூல் டவுன் செயல்முறை தோல்வியடைந்தது",
    "mobile_sensors_cooldown_cooldown_successful": "கூல் டவுன் வெற்றி",
    "mobile_sensors_cooldown_started_cooldown_process": "கூல் டவுன் செயல்முறை தொடங்கியது",
    "mobile_sensors_cooldown_hour": "மணி நேரம்",
    "mobile_sensors_cooldown_hour_plural": "மணி நேரங்கள்",
    "mobile_sensors_cooldown_minute": "நிமிடம்",
    "mobile_minutes_plural": "நிமிடங்கள்",
    "mobile_sensors_last_reading_max_date": "> 1 வருடம் முன்பு",
    "mobile_sensors_minute_count_ago": "{{count}} நிமிடத்திற்கு முன்பு",
    "mobile_sensors_minute_count_ago_plural": "{{count}} நிமிடங்களுக்கு முன்பு",
    "mobile_sensors_hour_count_ago": "{{count}} மணி நேரத்திற்கு முன்பு",
    "mobile_sensors_hour_count_ago_plural": "{{count}} மணிநேரங்களுக்கு முன்பு",
    "mobile_sensors_day_count_ago": "{{count}} நாள் முன்பு",
    "mobile_sensors_day_count_ago_plural": "{{count}} நாட்களுக்கு முன்பு",
    "mobile_sensors_chart_settings": "விளக்கப்பட அமைப்புகள்",
    "mobile_announcement_banner_continue_reading": "தொடர்ந்து தொடர்ந்து படியுங்கள்படியுங்கள்",
    "mobile_compliance_submissions_report": "சமர்ப்பிப்புகள் அறிக்கை",
    "mobile_compliance_submissions_report_subtitle": "இந்த ஸ்டோர்க்கான திட்ட நிறைவு தரவை ஏற்றுமதி செய்யவும்",
    "mobile_compliance_send_submissions": "சமர்ப்பிப்புகளை அனுப்பவும்",
    "mobile_compliance_completion_rate_in_last_days": "கடந்த {{ days }} நாட்களில் நிறைவு விகிதம்",
    "mobile_compliance_last_days": "கடந்த {{ days }} நாட்கள்",
    "mobile_compliance_send_submissions_to": "சமர்ப்பிப்புகளை இதற்கு அனுப்பவும்",
    "mobile_compliance_send_to_different_email": "வேறு ஒரு மின்னஞ்சலுக்கு அனுப்பவும்",
    "mobile_compliance_email_input_placeholder": "மின்னஞ்சல் முகவரி ",
    "mobile_compliance_send_submissions_to_legend_title": "சமர்ப்பிப்புகள்",
    "mobile_compliance_send_submissions_to_legend_description_days": "கடந்த {{ days }} நாட்களில் இந்த இடத்திலிருந்து நீங்கள் சமர்ப்பித்தவற்றின் அறிக்கை தேர்ந்தெடுக்கப்பட்ட மின்னஞ்சலுக்கு அனுப்பப்படும்.",
    "mobile_compliance_time_frame": "கால அளவு",
    "mobile_compliance_sensor_temperature_log_report": "சென்சார் வெப்பநிலை பதிவு அறிக்கை",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "இந்த ஸ்டோர்க்கான வெப்பநிலை அறிக்கைகளை ஏற்றுமதி செய்யவும்",
    "mobile_compliance_sensor_temperature_log_criteria_title": "அளவுகோல்கள்",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "உங்கள் அறிக்கைக்கான அளவுகோல்களை கீழே வரையறுக்கவும்.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "குறிப்பு: முடக்கப்பட்ட சென்சார்(கள்) அறிக்கையில் காட்டப்படாது",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "கால அளவைத் தேர்ந்தெடுக்கவும். பதிவு தரவு அதிகபட்சம் 30 நாட்களின் வரம்புக்குட்பட்டது",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "அறிக்கை அனுப்பவும்",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "இந்த மாதம் (முதல் நாள் - இன்று)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "கடந்த மாதம்",
    "mobile_compliance_sensor_temperature_log_email_title": "க்கு அறிக்கை அனுப்பவும்",
    "mobile_pwa_update_prompt_title": "செயலியை புதுப்பியுங்கள்",
    "mobile_pwa_update_prompt_description": "புதிய பதிப்பொன்று கிடைக்கிறது. பிந்திக் கிடைக்கும் பதிப்புக்கு புதுப்பியுங்கள்.",
    "mobile_pwa_update_prompt_confirm": "புதுப்பித்து மீளாக்கம் செய்யுங்கள்",
    "mobile_pwa_update_prompt_cancel": "பின்னர் நினைவுப்படுத்துங்கள்",
    "notification_title_due_in_one_hour": "1 மணி நேரத்தில் நிலுவை",
    "task_is_due_soon": "'{{ task_title }}' விரைவில் வரவுள்ளது. அதை முடிக்க சிறிது நேரம் ஒதுக்குங்கள்.",
    "mobile_photo_quality_warning_header": "புகைப்படத் தரப் பிரச்சினை",
    "mobile_photo_quality_dialog_message": "இந்தப் புகைப்படம் மிகவும் இருண்டதாகவோ அல்லது மங்கலாகவோ இருக்கலாம். நீங்கள் ஒரு புதிய புகைப்படத்தை எடுக்க விரும்புகிறீர்களா, அல்லது இதையே தொடர விரும்புகிறீர்களா?",
    "mobile_take_new_photo": "புதிய புகைப்படம் எடுக்கவும்",
    "mobile_use_this_photo": "இந்தப் புகைப்படத்தைப் பயன்படுத்துங்கள்."
}};
mobile_translations.zh_CN = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "所有",
    "mobile_common_button_apply_filters": "应用筛选器",
    "mobile_common_button_done": "完成",
    "mobile_common_button_edit": "编辑",
    "mobile_common_button_archive": "存档",
    "mobile_common_button_save": "保存",
    "mobile_common_button_retake": "重取",
    "mobile_common_button_save_draft": "保存草稿",
    "mobile_common_button_discard": "放弃",
    "mobile_common_button_submit": "提交",
    "mobile_common_button_no": "否",
    "mobile_common_button_yes": "是",
    "mobile_common_button_na": "不适用",
    "mobile_common_created_by_me": "由我创建",
    "mobile_common_email": "公司电子邮件",
    "mobile_common_first_name": "名字",
    "mobile_common_last_name": "姓氏",
    "mobile_common_location": "位置",
    "mobile_common_locations": "位置",
    "mobile_common_logout_message": "是否确实要退出登录?",
    "mobile_common_password": "密码",
    "mobile_common_permission_required": "所需权限",
    "mobile_common_status": "状态",
    "mobile_common_task": "任务",
    "mobile_common_tasks": "任务",
    "mobile_common_tasks_my": "我的任务",
    "mobile_common_projects": "项目",
    "mobile_common_filter_team": "团队",
    "mobile_common_filter_var_in": " 位于 {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "未选择团队",
    "mobile_common_filter_no_user_selected": "未选择用户",
    "mobile_common_filter_no_role_selected": "未选择角色",
    "mobile_common_placeholder_date": "日期",
    "mobile_common_message_task_creator_error_save": "<b>无法创建任务。</b>",
    "mobile_common_camera": "照相机",
    "mobile_common_microphone": "麦克风",
    "mobile_common_for": "对于",
    "mobile_common_reload": "重新加载",
    "mobile_common_override": "替代",
    "mobile_common_notifications": "通知",
    "mobile_common_chat_unavailable": "聊天不可用。请稍后再试。",
    "mobile_common_chat_ending_dialog_title": "本次对话是否已完成？",
    "mobile_common_chat_ending_dialog_description": "请告知您的问题是否已解决，或是否需要稍后继续沟通。",
    "mobile_common_chat_ending_dialog_confirm": "是的，已完成",
    "mobile_common_chat_ending_dialog_cancel": "我稍后继续",
    "mobile_common_continue_editing": "继续编辑",
    "mobile_privacy_policy": "隐私政策",
    "wootric_recommend_target": "您所在行业的朋友或同事",
    "wootric_followup_detractor_question": "我们可以为您做出哪些更改，以便下次获得更高的评级?",
    "wootric_followup_passive_question": "谢谢! 如何改进工具?",
    "wootric_followup_promoter_question": "谢谢！您最喜欢 Crunchtime Ops Execution 的哪些方面？",
    "wootric_followup_promoter_question_old": "谢谢! 您喜欢 Zenput 的哪些特点?",
    "wootric_default_followup_question": "谢谢! 能告诉我们为什么吗?",
    "wootric_default_placeholder_text": "帮助我们解读您的分数。",
    "wootric_default_thankyou_text": "感谢您的回复和反馈!",
    "mobile_login_placeholder_login_as": "以用户 ID 登录",
    "mobile_login_button_forgot_password": "忘记密码?",
    "mobile_login_button_sign_up": "创建帐户",
    "mobile_login_button_finish_setup": "完成设置",
    "mobile_login_button": "登录",
    "mobile_login_continue_button": "继续",
    "mobile_login_continue_transition": "正在转到组织的登录页...",
    "mobile_login_no_email_error": "必须输入电子邮件地址。",
    "mobile_login_change_email": "使用其他电子邮件登录",
    "mobile_login_with_sso": "使用单点登录 (SSO) 登录",
    "mobile_oauth_no_user_error_message": "您似乎还没有 Crunchtime Ops Execution 账户！",
    "mobile_oauth_no_user_error_message_old": "您似乎没有 Zenput 帐户!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> 现已更名为 <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} 将于 9 月更名为 {{- product }}。{{- cta }}",
    "mobile_rebrand_warning_cta": "了解如何做好准备。",
    "mobile_oauth_no_user_error_sub_message": "联系管理员获取访问权限或尝试使用其他电子邮件登录。",
    "mobile_oauth_generic_error_message": "登录似乎遇到问题，请重试。",
    "mobile_oauth_force_logout_msg": "如果问题仍未解决，则退出您的提供程序: ",
    "mobile_oauth_force_logout_click": "单击此处。",
    "mobile_sign_up_placeholder_phone": "手机号码",
    "mobile_sign_up_placeholder_password_confirm": "确认密码",
    "mobile_sign_up_button_sign_in": "登录",
    "mobile_sign_up_disclaimer_part_1": "单击“创建帐户”即表示您同意",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "点击“完成设置”，即表示您同意",
    "mobile_sign_up_disclaimer_link_title": " 许可协议",
    "mobile_sign_up_disclaimer_part_2": "，其中涉及重要隐私信息",
    "mobile_dialog_benefits_work_offline": "脱机工作",
    "mobile_dialog_benefits_faster_uploads": "加快上传速度",
    "mobile_dialog_benefits_better_experience": "改善体验",
    "mobile_dialog_benefits_button_download": "下载",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution 用于 ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput 适用于: ",
    "mobile_dialog_benefits_button_have": "我有这款应用!",
    "mobile_dialog_benefits_button_no_thanks": "不，谢谢，以后再说。",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "加载图像失败。",
    "mobile_dialog_signature_sign": "在此处签名",
    "mobile_dialog_signature_button_clear": "清除",
    "mobile_account_placeholder_name": "位置/存储名称",
    "mobile_account_placeholder_phone": "电话",
    "mobile_account_placeholder_address": "地址",
    "mobile_account_placeholder_city": "城市",
    "mobile_account_placeholder_region": "区域",
    "mobile_account_placeholder_zipcode": "邮政编码",
    "mobile_account_option_select_country": "选择国家/地区",
    "mobile_account_oprion_us": "美国",
    "mobile_account_oprion_select_state": "选择州",
    "mobile_account_button_create_location": "创建位置",
    "mobile_form_message_no_form": "没有可用的表单",
    "mobile_batch_task_message": "正在加载...",
    "mobile_settings_profile": "配置文件",
    "mobile_settings_profile_number": "手机",
    "mobile_settings_profile_language": "语言",
    "mobile_settings_profile_temperature_unit": "温度单位",
    "mobile_settings_profile_use_company_default": "使用公司默认值",
    "mobile_settings_profile_celsius": "摄氏度",
    "mobile_settings_profile_fahrenheit": "华氏度",
    "mobile_settings_notifications_option_sms": "短信",
    "mobile_settings_notifications_option_push": "推送通知",
    "mobile_settings_notifications_option_push_email": "电子邮件和推送通知",
    "mobile_settings_notifications_option_do_not": "不通知",
    "mobile_settings_notifications_category_communication": "通讯",
    "mobile_settings_notifications_category_forms_and_triggers": "表格和触发器",
    "mobile_settings_devices": "设备",
    "mobile_settings_notifications_sub_category_alerts": "警报",
    "mobile_settings_notifications_sub_category_new_forms_available": "可用的新表格",
    "mobile_settings_notifications_sub_category_task_assigned": "任务已分配",
    "mobile_settings_notifications_sub_category_task_completed": "任务已完成",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "任务即将到期提醒",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "逾期任务提醒",
    "mobile_settings_notifications_sub_category_sensor_alerts": "传感器警报",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "关键传感器警报",
    "mobile_drafts_message": "目前还没有任何草稿。",
    "mobile_drafts_button_delete": "删除",
    "mobile_tasks_filter_location_no": "未选择位置",
    "mobile_tasks_filter_group_by": "分组依据",
    "mobile_tasks_filter_sort_by": "排序方式",
    "mobile_tasks_filter_sorted_by": "排序方式",
    "mobile_tasks_filter_due_time": "到期时间",
    "mobile_tasks_filter_open_time": "打开时间",
    "mobile_tasks_bucket_due_next_24_hours": "未来 24 小时内到期",
    "mobile_tasks_bucket_due_next_7_days": "未来 7 天内到期",
    "mobile_tasks_bucket_open_tasks": "其他未完成 {{type}}",
    "mobile_tasks_bucket_open_at": "打开：{{- date }} {{- time }}",
    "mobile_tasks_bucket_due_by_at": "到期时间：{{- date }} {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "1 分钟内可用",
    "mobile_tasks_bucket_available_in_one_hour": "1 小时内可用",
    "mobile_tasks_bucket_available_in_one_day": "1 天内可用",
    "mobile_tasks_bucket_available_in_one_week": "1 周内可用",
    "mobile_tasks_bucket_available_in_one_month": "1 个月内可用",
    "mobile_tasks_bucket_available_in_one_year": "1 年内可用",
    "mobile_tasks_bucket_available_in_minutes": "{{ minutes }} 分钟内可用",
    "mobile_tasks_bucket_available_in_hours": "{{ hours }} 小时内可用",
    "mobile_tasks_bucket_available_in_days": "{{ days }} 天内可用",
    "mobile_tasks_bucket_available_in_weeks": "{{ weeks }} 周内可用",
    "notification_task_due_in_minutes": "{{ minutes }} 分钟后到期",
    "mobile_tasks_bucket_available_in_months": "{{ months }} 个月内可用",
    "mobile_tasks_bucket_available_in_years": "{{ years }} 年内可用",
    "mobile_tasks_follow_up": "后续任务",
    "mobile_tasks_due_soon": "即将到期",
    "mobile_tasks_bucket_completed_today": "今天完成",
    "mobile_tasks_bucket_completed_this_week": "本周完成",
    "mobile_tasks_bucket_completed_last_week": "上周完成",
    "mobile_tasks_bucket_missed_today": "今天错过",
    "mobile_tasks_bucket_missed_this_week": "本周错过",
    "mobile_tasks_bucket_missed_last_week": "上周错过",
    "mobile_tasks_bucket_no_location": "未指定位置",
    "mobile_tasks_cannot_submit_missed": "一旦错过任务，将无法完成",
    "mobile_tasks_cannot_submit_missed_after": "此任务不能在 {{ date }} 之后完成",
    "mobile_tasks_cannot_submit_upcoming": "此任务尚未启动。",
    "mobile_tasks_cannot_submit_processing": "正在处理此提交",
    "mobile_tasks_toolbarnav_header_no_due_date": "无截止日期",
    "mobile_tasks_toolbarnav_header_overdue": "过期",
    "mobile_tasks_toolbarnav_header_yesterday": "昨天",
    "mobile_tasks_toolbarnav_header_today": "今天",
    "mobile_tasks_toolbarnav_header_tomorrow": "明天",
    "mobile_tasks_toolbarnav_header_last_week": "上周",
    "mobile_tasks_toolbarnav_header_this_week": "本周",
    "mobile_tasks_toolbarnav_header_next_week": "下周",
    "mobile_tasks_toolbarnav_header_this_month": "本月",
    "mobile_tasks_toolbarnav_header_next_year": "明年",
    "mobile_tasks_toolbarnav_header_over_year": "超过 1 年",
    "mobile_tasks_toolbarnav_title_edit_task": "编辑任务",
    "mobile_task_placeholder_title": "标题*",
    "mobile_task_placeholder_description": "描述(可选)",
    "mobile_task_button_single_task": "单个任务",
    "mobile_task_button_project": "项目",
    "mobile_task_button_create": "创建",
    "mobile_task_tab_basic": "基本",
    "mobile_task_tab_photo": "照片",
    "mobile_task_tab_form": "表单",
    "mobile_task_details_description_message_please": "请在下方 ",
    "mobile_task_details_description_message_below": "填写。",
    "mobile_task_details_description_message_instructions": "没有可用于此任务的说明。",
    "mobile_task_details_reason_title": "后续活动触发者:",
    "mobile_task_detials_button_goto_form": "转到表单",
    "mobile_task_detials_button_complete": " 完成任务",
    "mobile_task_detials_completed": "已完成 ",
    "mobile_task_detials_completed_by": "完成者: ",
    "mobile_task_detials_completed_on": "完成时间: ",
    "mobile_task_details_view_form_submission": "查看表单提交",
    "mobile_task_task_updated": "任务已更新",
    "mobile_task_task_archived": "任务已存档",
    "mobile_task_task_deleted": "任务已删除",
    "mobile_task_error_archiving_task": "无法存档任务。",
    "mobile_task_error_deleting_task": "无法删除任务。",
    "mobile_task_error_updating_task": "无法更新任务。",
    "mobile_task_archive_task": "存档任务",
    "mobile_task_archive_task_confirm": "确定要存档此任务吗?\n\n存档任务将计入完成率并将继续纳入报告。\n\n此操作无法撤消。",
    "mobile_task_delete_task_confirm": "确定要删除此任务吗?\n\n删除任务将不计入完成率，也不纳入任何报告。\n\n此操作无法撤消。",
    "mobile_task_edition_already_in_progress": "此任务包含挂起的编辑。目前不允许进一步编辑。",
    "mobile_projects_filter_type": "类型",
    "mobile_projects_filter_status": "项目状态",
    "mobile_projects_filter_project_type": "项目类型",
    "mobile_projects_due_date_required": "截止日期必填。",
    "mobile_projects_team_required": "团队必填。",
    "mobile_projects_user_role_required": "被分派人必填。",
    "mobile_projects_title_required": "标题必填。",
    "mobile_projects_recurring_multiple_tasks_per_day": "每天多任务",
    "mobile_project_tasks_complete": " 完成",
    "mobile_project_tasks_remaining": " 剩余",
    "mobile_esitmate_message_tasks": "将创建 0 个任务",
    "mobile_esitmate_message_criteria": "调整以上标准",
    "mobile_esitmate_message_created_for": "创建对象:",
    "mobile_left_menu_dashboard": "仪表板",
    "mobile_left_menu_my_forms": "我的表单",
    "mobile_left_menu_announcements": "公告",
    "mobile_left_menu_my_submissions": "我提交的项目",
    "mobile_left_menu_drafts": "草稿",
    "mobile_left_menu_pending_uploads": "正在等待上载",
    "mobile_left_menu_open": "在应用中打开",
    "mobile_left_menu_settings": "设置",
    "mobile_left_menu_log_out": "注销",
    "mobile_left_menu_debug": "调试",
    "mobile_left_menu_support": "支持",
    "mobile_left_menu_documentation": "文档",
    "mobile_left_menu_chat": "聊天",
    "mobile_field_textarea_placeholder_note": "备注或字幕",
    "mobile_field_option_select": "选择",
    "mobile_field_text_placeholder_text": "文本",
    "mobile_field_email_placehoder_email": "电子邮件",
    "mobile_filed_number_placeholder_number": "编号",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "未连接",
    "mobile_field_sensor_offline_battery": "传感器离线 - 电池",
    "mobile_field_video_button_add": "添加视频",
    "mobile_field_video_picker_dialog_title": "添加来自以下出处的视频：",
    "mobile_field_video_button_change": "更改视频",
    "mobile_field_image_button_add": "添加图像",
    "mobile_field_image_low_quality_warning": "有些照片可能太暗或太模糊。请查看高亮显示的照片，并在必要时进行替换。",
    "mobile_field_image_picker_dialog_title": "添加来自以下出处的照片：",
    "mobile_field_image_picker_edit_failed": "我们无法保存图片。请重试。",
    "mobile_field_signature_button_add": "添加签名",
    "mobile_field_signature_button_change": "更改签名",
    "mobile_field_account_select_location": "选择位置",
    "mobile_field_account_prefill": "使用上次访问的数据填写表单?",
    "mobile_field_account_message_overwrite": "这将覆盖已经填写的所有字段。",
    "mobile_forms_task_on_behalf": "分配给<b>{{user}}</b>的这个位置有一项任务需要完成。是否要完成这项任务?",
    "mobile_forms_complete_task": "完成任务?",
    "mobile_field_account_prefill_button_yes": "是的，预先填写",
    "mobile_field_barcode_placeholder_scan": "扫描或输入条形码",
    "mobile_field_sensor_qr_code_placeholder_scan": "扫描或输入代码",
    "mobile_field_gateway_id_code_placeholder": "类型节点 ID",
    "mobile_field_scan_qr_or_enter_dev_eui": "扫描二维码或输入 DevEUI",
    "mobile_field_scan_qr_or_enter_id": "扫描二维码或输入 ID 编号",
    "mobile_field_scan_qr_or_enter_sc": "扫描二维码或输入 SC 代码",
    "mobile_field_barcode_select_date": "选择日期 ",
    "mobile_field_datetime_allow_time": "时间",
    "mobile_field_stopwatch_button_caption": "秒表",
    "mobile_field_stopwatch_common_start": "开始",
    "mobile_field_stopwatch_common_stop": "停止",
    "mobile_field_stopwatch_common_reset": "重置",
    "mobile_field_stopwatch_stop_stopwatches": "停止秒表",
    "mobile_field_document_title": "添加文档",
    "mobile_field_document_message_delete": "是否确实要删除此文档?",
    "mobile_field_document_alret_button_view": "查看",
    "mobile_field_document_alert_error": "附加此文档时发生错误。请重试。",
    "mobile_field_document_alert_file_size_error": "文件不能超过 {{count}} MB。",
    "mobile_field_temperature_greater_range": "大于 {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "大于或等于 {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_less_range": "小于 {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "小于或等于 {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_between_range": "大于或等于 {{ min_temp_value }}°{{ temp_unit }} 且小于 {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "高于或等于 {{ min_temp_value }} °{{ temp_unit }} 且低于或等于  {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " 和 ",
    "mobile_field_text_limit_error": "已达到 8000 个字符的最大限制。",
    "mobile_forms_required_questions_complete": "完成必填字段",
    "mobile_forms_required_remaining": "还有 {{count}} 个必填字段",
    "mobile_forms_required_questions_back": "返回",
    "mobile_forms_required_questions_next": "下一步",
    "mobile_forms_required_questions_skip": "跳过",
    "mobile_forms_leaving_form": "离开表单",
    "mobile_message_reordering_confirm": "是否要保存新的问题排序？",
    "mobile_forms_leaving_reordering": "放弃重新排列问题顺序",
    "mobile_forms_reordering_button_save": "保存新的问题排序",
    "mobile_forms_reordering_instructions": "要重新排序问题或部分，请将字段拖放到表单中应显示的位置",
    "mobile_toolbarnav_title_my_setttings": "我的设置",
    "mobile_toolbarnav_title_profile_settings": "配置文件设置",
    "mobile_toolbarnav_title_notification": "通知设置",
    "mobile_toolbarnav_title_form_history": "表单历史记录",
    "mobile_toolbarnav_title_form_not_available": "表单不可用",
    "mobile_toolbarnav_title_add_location": "添加位置",
    "mobile_toolbarnav_title_add_task_or_project": "添加任务或项目",
    "mobile_toolbarnav_title_select_location": "选择位置",
    "mobile_toolbarnav_title_select_project": "选择项目",
    "mobile_toolbarnav_title_select_tag": "选择标记",
    "mobile_toolbarnav_title_select_user": "选择用户",
    "mobile_toolbarnav_title_select_template": "选择模板",
    "mobile_toolbarnav_title_select_one": "选择一个",
    "mobile_toolbarnav_title_select_multiple": "选择一个或多个",
    "mobile_toolbarnav_title_select_team": "选择团队",
    "mobile_toolbarnav_title_select_team_or_location": "选择团队或位置",
    "mobile_toolbarnav_title_filter_tasks": "筛选任务",
    "mobile_toolbarnav_title_filter_projects": "筛选项目",
    "mobile_toolbarnav_title_filter_project_tasks": "筛选项目任务",
    "mobile_placeholder_search_bar": "搜索",
    "mobile_placeholder_user_select_role": "选择用户角色",
    "mobile_placeholder_filter_by_team": "按团队筛选",
    "mobile_placeholder_assign_to_user_role": "分配给用户角色",
    "mobile_placeholder_select": "-- 选择 --",
    "mobile_placeholder_account_location_name": "位置名称",
    "mobile_placeholder_tag_filter_by": "按位置标记筛选",
    "mobile_placeholder_user_type": "分配给用户",
    "mobile_placeholder_acount_type_loading": "正在加载... ",
    "mobile_placeholder_therm_no_bluetooth": "温度",
    "mobile_placeholder_blue_therm_connecting": "正在连接到设备...",
    "mobile_placeholder_blue_therm_please_wait": "请稍候...",
    "mobile_placeholder_blue_therm_tap": "点击以获取读数。",
    "mobile_placeholder_blue_therm_not_connected": "未连接。",
    "mobile_placeholder_testo_tap": "按住 ▼▲，然后按 ⬆",
    "mobile_message_error_create_task": "必须联机才能添加任务。",
    "mobile_message_error_fill_out_form": "请填写表单。",
    "mobile_message_error_fill_require_fields": "填写必填字段。",
    "mobile_message_error_stop_stopwatch_before_submit": "提交前，请先停止秒表",
    "mobile_message_error_stopwatch_field_required": "秒表字段为必填字段",
    "mobile_message_error_stopwatch_field_running": "秒表字段正在运行",
    "mobile_message_error_invalid_equipment_temperature": "设备温度无效",
    "mobile_message_error_invalid_ingredient_temperature": "成分温度无效",
    "mobile_message_error_location_attributes_unavailable": "有些问题可能不可用，请连接到互联网",
    "mobile_message_alert_running_stopwatches": "您的秒表仍在运行。\n\n是否要清除秒表?",
    "mobile_message_blue_therm_error": "已断开与蓝牙设备的连接",
    "mobile_message_blue_therm_no_permission_android_pre_12": "需要位置权限。请在您的 Android 设置中启用该权限。",
    "mobile_message_blue_therm_no_permission_android": "需要“附近设备”权限。请在您的 Android 设置中启用该权限。",
    "mobile_message_blue_therm_error_code": "连接失败:",
    "mobile_message_blue_therm_error_bluetooth": "请启用蓝牙。",
    "mobile_message_blue_therm_error_device": "未找到设备。",
    "mobile_message_blue_therm_error_try_again": "请重试",
    "mobile_message_blue_therm_success": "蓝牙设备已连接!",
    "mobile_message_bluetooth_device_press_button_field": "按下设备上的按钮，建立连接。",
    "mobile_message_bluetooth_device_press_button_devices_list": "如果此处未列出设备，<br />请按下设备上的按钮。",
    "mobile_bluetooth_scan": "扫描",
    "mobile_bluetooth_scanning": "正在扫描",
    "mobile_message_drafts_confirm": "是否要保存为草稿?",
    "mobile_message_drafts_toast_saved": "已保存草稿。",
    "mobile_message_drafts_request_update": "是否要更新此草稿?",
    "mobile_message_drafts_form_confirm": "是否确实要删除此草稿?",
    "mobile_message_drafts_confirm_delete": "删除草稿",
    "mobile_message_streams_error_switch": "无法更改 Web 数据流",
    "mobile_message_settings_success_saved": "已保存设置",
    "mobile_message_settings_error": "出现未知错误。稍后重试",
    "mobile_message_profile_settings_error_fields": "请更正高亮显示字段。",
    "mobile_message_media_perimission_denied": "您的 ",
    "mobile_message_media_perimission_denied_device": "设备存储",
    "mobile_message_image_confirm_remove_image": "是否确实要删除此照片?",
    "mobile_message_create_account_error_fields": "请填写高亮显示字段。",
    "mobile_message_create_account_success_location_created": "已创建位置",
    "mobile_message_task_error_get_location": "获取位置失败。按日期排序。",
    "mobile_message_typehead_confirm_save_message": "是否希望保存这些选择?",
    "mobile_message_typehead_confirm_save_title": "保存?",
    "mobile_message_task_creator_error_save_select_form": "必须选择表单。",
    "mobile_message_task_creator_error_save_required_fields": "请填写必填字段。",
    "mobile_message_task_creator_error_save_batch_change": "请更改标准，以便与一个或多个用户匹配",
    "mobile_message_task_detials_error_not_assigned_to_you": "此任务未分配给您。<br />您无法完成该任务。",
    "mobile_message_task_detials_error_assigned_to": "此任务分配给 {{user}}。<br />您无法完成该任务。",
    "mobile_message_task_detials_confirm_title": "离开任务",
    "mobile_message_task_detials_confirm_save_task": "保存任务",
    "mobile_message_task_detials_confirm_message": "确定吗? 更改将丢失。",
    "mobile_message_task_detials_error_view_account": "无法访问位置。",
    "mobile_message_task_detials_error_submit_task": "请添加照片以完成此任务。",
    "mobile_message_task_detials_error_submit_task_project": "无法保存项目。请稍后重试。",
    "mobile_message_task_detials_wait_submit_task_created": "正在创建任务。<br />请等待几分钟，以填充任务。",
    "mobile_message_task_detials_error_submit_task_pending": "错误，请稍后重试",
    "mobile_message_task_detials_success_task_complete": "任务完成",
    "mobile_message_task_error_save_single_task": "无法保存任务。请稍后重试。",
    "mobile_message_task_success_save_single_task": "已创建任务。",
    "mobile_message_show_error_message": "出现问题。",
    "mobile_message_show_success_message": "成功!",
    "mobile_message_show_offline_message": "当前处于脱机状态。",
    "mobile_message_show_permission_denied_message": "<b>所需权限。</b>请授予 Zenput 权限以访问 {{permission_name}}。",
    "mobile_message_show_permission_denied_message_web": "<b>需要权限。</b>请授予 Zenput 和您的浏览器权限以访问 {{permission_name}}。",
    "mobile_message_show_begin_uploading_message": "目前正在上传",
    "mobile_message_show_upload_in_progress_message": "上传已在进行中",
    "mobile_message_show_form_id_error": "无法访问指定的表单。",
    "mobile_message_show_single_task_error": "无法访问指定的任务。",
    "mobile_message_show_submissions_error": "无法访问指定的提交项目。",
    "mobile_message_show_submissions_access_denied": "抱歉，您无权访问此表单。",
    "mobile_message_send_data_success": "数据已上传 ",
    "mobile_message_start_upload_success": "上传完成",
    "mobile_message_start_upload_error": "<b>无法完成上传。</b><br>已保存提交项目。请稍后重试",
    "mobile_message_store_upgrade_store_ios": "应用商店",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "可用更新",
    "mobile_message_store_upgrade_confirm_message_one": "请从以下位置更新 Ops Execution 应用： ",
    "mobile_message_store_upgrade_confirm_message_one_old": "请从   更新 Zenput， ",
    "mobile_message_store_upgrade_confirm_message_two": " 以获取所有最新功能和错误修复",
    "mobile_message_store_upgrade_confirm_now": "立即更新",
    "mobile_message_store_upgrade_confirm_later": "稍后更新",
    "mobile_message_redirect_confirm_message": "当前正在填写表单。继续之前要保存为草稿吗?",
    "mobile_message_log_out_confirm_unsynced_drafts": "您有 {{count}} 个草稿还未上传。如果继续，这些草稿将丢失。确定吗?",
    "mobile_message_draft_override_message": "此草稿由 {{date}} 上的其他设备保存而来，在此设备上做出的更改存在冲突。您可以选择覆盖现有版本，也可以重新加载到最新版本，届时将放弃您所做的更改。",
    "mobile_html_submitting": "正在提交...",
    "mobile_html_offline": "当前处于脱机状态!",
    "mobile_html_offline_try_again": "当前处于脱机状态。<br/><br/>请在连接后重试",
    "mobile_html_something_went_wrong": "糟糕。出现问题。",
    "mobile_html_something_went_wrong_try_again": "糟糕。出现问题。请重试。",
    "mobile_html_failed_loading_roles": "加载角色失败。",
    "mobile_alert_please_install_for_native": "请安装 Ops Execution 应用以使用此功能。 ",
    "mobile_alert_please_install_for_native_old": "请安装本机 Zenput 应用，以使用此功能。",
    "mobile_tso_filter_all_tasks": "全部 {{type}}",
    "mobile_tso_filter_my_tasks": "我的 {{type}}",
    "mobile_tso_filter_due_date": "截止日期",
    "mobile_tso_filter_date_completed": "完成日期",
    "mobile_tso_filter_completed": "已完成",
    "mobile_tso_filter_completed_late": "延迟完成",
    "mobile_tso_filter_incomplete": "未完成",
    "mobile_tso_filter_var_my_tasks": "我的 {{filter_type}}{{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "由我创建的 {{filter_type}}{{type}}",
    "mobile_tso_filter_var_all_tasks": "全部 {{filter_type}}{{type}}",
    "mobile_tso_type_follow_up_actions": "后续操作",
    "mobile_tso_type_all": "任务和后续操作",
    "mobile_tso_filter_var_at": " 位于 {{location}}",
    "mobile_tso_filter_group_date_due": "，按截止日期排序",
    "mobile_tso_filter_group_distance": "，按位置分组",
    "mobile_tso_filter_start_date": "开始日期",
    "mobile_tso_filter_none": "无",
    "mobile_pso_filter_all_projects": "所有项目",
    "mobile_pso_filter_my_projects": "我的项目",
    "mobile_pso_filter_active": "活动",
    "mobile_pso_filter_archived": "已存档",
    "mobile_pso_filter_recurring": "定期",
    "mobile_pso_filter_non_recurring": "非定期",
    "mobile_pso_filter_var_my_projects": "我的 {{project_type}}{{active_description}} 个项目",
    "mobile_pso_filter_var_my_created_projects": "我创建了 {{project_type}}{{active_description}} 个项目",
    "mobile_pso_filter_var_all_projects": "共计 {{project_type}}{{active_description}} 个项目",
    "mobile_empty_list_message_must_be_online": "您似乎处于脱机状态。请联机以查看各项结果。",
    "mobile_empty_list_message_no_submissions": "无提交项目",
    "mobile_empty_list_message_no_activity": "无活动",
    "mobile_empty_list_message_no_tasks": "无任务",
    "mobile_empty_list_message_no_tasks_overdue": "无逾期 {{type}}",
    "mobile_empty_list_message_no_accounts": "无位置",
    "mobile_empty_list_message_no_projects": "无项目",
    "mobile_empty_list_message_no_results_found": "未找到结果",
    "mobile_empty_list_message_no_forms_available": "没有可用的表单",
    "mobile_empty_list_message_connection_error": "连接错误<br />请重试。",
    "mobile_empty_list_message_dashboard_error": "无法加载仪表板",
    "mobile_empty_list_message_user_offline": "您当前处于脱机状态",
    "mobile_action_sheet_media_gallery": "库",
    "mobile_action_sheet_cancel": "取消",
    "mobile_image_preview_text": "删除照片",
    "mobile_mobileform_text": "之前提交的项目",
    "mobile_mobileform_reorder_fields": "重新排列问题顺序",
    "mobile_mobileform_follow_up_actions": "后续行动",
    "mobile_mobileform_follow_up_actions_assign_title": "分配后续操作",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "根据观察结果添加后续操作，以确保问题得到解决。",
    "mobile_mobileform_follow_up_actions_add_button": "+ 添加后续操作",
    "mobile_mobileform_follow_up_actions_assign_button": "分配后续操作",
    "mobile_mobileform_follow_up_actions_without_assign_button": "不进行分配而继续",
    "mobile_mobileform_follow_up_actions_dialog_title": "不分配后续操作就继续？",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "如果您在未分配任何后续操作的情况下继续，以后将无法添加后续操作。",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "仍然继续",
    "mobile_mobileform_add_follow_up_actions_forms_required": "此字段为必填项",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "字符过多",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "此字段无效",
    "mobile_mobileform_add_follow_up_actions_error_locations": "加载位置时出错",
    "mobile_mobileform_add_follow_up_actions_error_users": "加载用户时出错",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "添加后续操作",
    "mobile_mobileform_add_follow_up_actions_forms_title": "标题 ",
    "mobile_mobileform_add_follow_up_actions_forms_description": "说明",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "需要照片",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "截止日期",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "更新后续操作",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "删除后续操作？",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "它将被移除，不会再被分配。",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "删除后续操作",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "您确定要删除此后续操作吗？\n\n此删除将无法撤销。",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "继续进行后续操作",
    "mobile_mobileform_follow_up_actions_completed_notification": "后续操作已完成",
    "mobile_mobileform_follow_up_actions_deleted_notification": "后续操作已删除",
    "mobile_mobileform_follow_up_actions_update_notification": "后续操作已更新",
    "mobile_mobileform_follow_up_actions_required_photo_error": "请添加照片以完成此后续操作",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "转至提交页面",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "导航至来源",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "来源",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "完成后续操作",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "如果您打开提交页面，所有未保存的照片和备注都将丢失。",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "如果您离开此屏幕，任何未保存的照片和备注都将丢失。",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "留在当前页面",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "打开提交页面",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "开源",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "要放弃此后续操作吗？",
    "mobile_mobileform_follow_up_actions_submission": "提交",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "此后续操作已分配给 {{user}}。<br />您无法完成它。",
    "mobile_mobileform_follow_up_actions_leave_description": "如果您离开此屏幕，任何未保存的更改都将丢失。",
    "mobile_mobileform_follow_up_actions_leave": "离开",
    "mobile_forms_drafts_text": "删除草稿",
    "mobile_batch_estimate_user": "用户",
    "mobile_batch_estimate_users": "用户",
    "mobile_table_of_contents": "目录",
    "mobile_table_of_contents_required": "必填",
    "mobile_table_of_contents_optional": "可选",
    "mobile_dialog_alert_title": "警报",
    "mobile_dialog_alert_ok": "确定",
    "mobile_windows_10_bluetherm_not_supported": "Windows 尚不支持 Bluetooth 设备",
    "mobile_windows_deprecated_message_content_announcement": "公告",
    "mobile_windows_deprecated_message_title": "需要更新应用",
    "mobile_windows_deprecated_message_description": "尽快在 Microsoft Store 安装新的 Zenput 应用程序，以确保关键功能的更新和最佳的 Zenput 体验。",
    "mobile_dashboard_tcr_graph_name": "任务完成率",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "过去 4 周",
    "mobile_dashboard_tcr_legend_company_average": "公司平均值",
    "mobile_dashboard_tcr_legend_team_average": "团队平均值",
    "mobile_dashboard_tab_title_summary": "摘要",
    "mobile_dashboard_tab_title_activity": "活动",
    "mobile_dashboard_card_title_top_triggered_workflows": "热门触发器",
    "mobile_dashboard_tab_title_info": "信息",
    "mobile_dashboard_tab_project_audit": "合规",
    "mobile_dashboard_card_task_stats_total": "总计",
    "mobile_dashboard_top_item_header_week_of": "周",
    "mobile_dashboard_card_filter_form_template_placeholder": "所有表单",
    "mobile_dashboard_card_title_forms_top_nos": "常用“否定理由”",
    "mobile_dashboard_zenput_code_no_data_in_range": "在此时间范围内没有数据。",
    "mobile_dashboard_zenput_code_permission_denied": "您无权查看此数据。",
    "mobile_dashboard_zenput_code_no_form_template_selected": "从上方选择一个表单。",
    "mobile_dashboard_zenput_code_unknown_error": "目前无法显示数据。",
    "mobile_dashboard_tap_to_retry": "点击以重试",
    "mobile_dashboard_reporting_delay_disclaimer": "最多可能需要 15 分钟更新任务",
    "mobile_dashboard_configuration_down_state_postfix_msg": "已经过管理员配置。",
    "mobile_tasks_tag": "任务",
    "mobile_workflows_tag": "触发器",
    "mobile_projects_tag": "定期项目",
    "mobile_forms_tag": "表单",
    "mobile_dashboard_card_ongoing_projects_title": "进行中的项目",
    "mobile_dashboard_card_ongoing_projects_show_more": "详细显示",
    "mobile_dashboard_card_ongoing_projects_show_less": "简略显示",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "转到项目",
    "mobile_dashboard_card_title_recurring_projects": "定期项目",
    "mobile_dashboard_card_filter_daily": "每天",
    "mobile_dashboard_card_filter_weekly": "每周",
    "mobile_dashboard_card_filter_monthly": "每月",
    "mobile_task_status_title_open": "打开",
    "mobile_task_status_title_upcoming": "即将开始",
    "mobile_task_status_title_complete": "完成",
    "mobile_task_status_title_processing": "正在处理提交项目",
    "mobile_task_status_title_complete_with_exceptions": "已完成，但显示跟进任务或警报",
    "mobile_task_status_title_completed_late_with_exceptions": "延迟完成，含待跟进任务或提醒",
    "mobile_task_status_title_incomplete_and_closed": "错过",
    "mobile_tasks_legend_modal_title": "图例",
    "mobile_tasks_legend_modal_footer_button_title": "关闭",
    "mobile_common_assigned_to": "分配对象",
    "mobile_common_created_by": "创建者",
    "mobile_common_tasks_for": "任务适用于",
    "mobile_common_go_back": "返回",
    "mobile_oh_no": "糟糕!",
    "mobile_user_not_in_groups": "抱歉，似乎没有为您分配团队。请联系管理员，以访问您的仪表板。",
    "mobile_tasks_select_followers": "选择关注者",
    "mobile_tasks_assign_tasks": "分配 {{count}} 个任务",
    "mobile_tasks_add_followers": "添加关注者",
    "mobile_tasks_followers": "关注者",
    "mobile_tasks_delete_task": "删除任务",
    "mobile_tasks_create_task": "创建任务",
    "mobile_tasks_tab_title_comments": "评论",
    "mobile_tasks_see_more": "查看更多",
    "mobile_projects_create_project": "创建项目",
    "mobile_common_button_send": "发送",
    "mobile_common_button_schedule": "计划",
    "mobile_announcements_create": "创建公告",
    "mobile_announcements_read_rate": "已打开 {{opened_count}} 个公告(共 {{recipients_count}} 个公告)",
    "mobile_announcements_empty_message": "尚未创建任何公告! 在下方创建公告，向您的组织广播重要新闻、信息和更新。",
    "mobile_announcement_message_placeholder": "添加消息...",
    "mobile_announcement_title_placeholder": "公告标题",
    "mobile_announcement_leaving_announcement": "离开公告",
    "mobile_announcement_confirm_recipients_team": "是否要将此公告广播给 {{teams}} 个选定团队的 {{count}} 个用户?",
    "mobile_announcement_confirm_recipients_role": "是否要将此公告广播给 {{roles}} 个用户角色的 {{count}} 个用户?",
    "mobile_announcement_confirm_recipients_user": "是否要将此公告广播给 {{count}} 个用户?",
    "mobile_announcement_confirm_scheduled": "时间: {{timestamp}}",
    "mobile_announcement_sending_announcement": "正在发送公告",
    "mobile_announcement_send_to": "发送到",
    "mobile_announcement_sent_to": "已发送到",
    "mobile_announcement_send_to_role": "角色",
    "mobile_announcement_attachment_download": "正在下载 {{filename}}",
    "mobile_announcement_attachment_validation_error": "最多只能添加 {{maxCount}} 个附件",
    "mobile_announcement_details_sent": "已发送",
    "mobile_announcement_details_total_recipients": "收件人总数",
    "mobile_announcement_details_cancel": "取消公告",
    "mobile_announcement_details_not_editable": "公告只能在 Ops Execution 网页应用中进行编辑 ",
    "mobile_announcement_details_not_editable_old": "只能在 Zenput Web 上编辑公告",
    "mobile_announcement_details_open_count": "打开计数",
    "mobile_announcement_details_open_rate": "打开率",
    "mobile_announcement_details_resend": "重新发送给未打开的用户",
    "mobile_announcement_confirm_resend": "{{count}} 个用户尚未阅读公告。您要发送提醒吗？",
    "mobile_announcement_confirm_resend_title": "发送提醒",
    "mobile_announcement_recipients_opened": "已打开",
    "mobile_recipients_opened_empty_message": "似乎还没有人打开您的消息。请稍后回来查看结果。",
    "mobile_announcement_recipients_unopened": "未打开",
    "mobile_recipients_unopened_empty_message": "好消息！没有未打开的消息！",
    "mobile_scheduled_announcements_delivery_section_header": "送达时间",
    "mobile_scheduled_announcements_send_immediately_label": "立即发送",
    "mobile_scheduled_announcements_scheduled_label": "在特定时间发送",
    "mobile_scheduled_announcements_scheduled_tab_label": "预定",
    "mobile_scheduled_announcements_dialog_header": "取消公告？",
    "mobile_scheduled_announcements_dialog_message": "取消通知将停止发送并将其从您的列表中删除。此操作不能撤消。要进行编辑，请前往 Zenput Web。",
    "mobile_scheduled_announcements_empty_message": "您目前没有预定的公告。预定公告向您的组织传达重要新闻、信息和更新。",
    "mobile_scheduled_announcements_validation_error": "送达时间必须在 {{date}} 后",
    "mobile_scheduled_announcements_empty_state_button": "预定公告",
    "mobile_projects_auto_archive": "自动存档",
    "mobile_common_unassigned": "取消分配",
    "mobile_tasks_title_placeholder": "新任务或表格",
    "mobile_projects_leaving_project": "离开项目",
    "mobile_projects_save_project": "保存项目",
    "mobile_top_triggers_tasks": "最常触发的任务",
    "mobile_top_triggers_alerts": "最常触发的警报",
    "mobile_projects_not_started": "尚未开始",
    "mobile_empty_list_message_no_photos": "无照片",
    "mobile_webfilestore_message_error": "请选择有效的文件类型",
    "mobile_notifications_empty_title": "无通知",
    "mobile_notifications_empty_message": "您的任务或您参与的任务的活动将显示在此处。",
    "mobile_comments_comment_deleted": "此评论已被删除。",
    "mobile_comments_comment_placeholder": "评论",
    "mobile_comments_task_submitted_at": "任务已于 {{ date }} {{ time }} 提交",
    "mobile_comments_discard_comment_title": "丢弃评论？",
    "mobile_comments_discard_confirm_message": "您是否确定？您的评论将被删除。",
    "mobile_comments_delete_comment_title": "删除评论？",
    "mobile_comments_delete_confirm_message": "此操作不能撤消。",
    "mobile_comments_delete_button": "删除评论",
    "mobile_comments_delete_success_message": "评论已被删除",
    "mobile_comments_empty_message_tasks": "尚无评论 \n 开始关于此任务的对话。",
    "mobile_comments_empty_message_submissions": "尚无评论 \n 开始关于此提交的对话。",
    "mobile_comments_empty_message_default": "尚无评论 \n 开始对话。",
    "mobile_comments_no_matching_users": "没有匹配的用户。",
    "mobile_comments_empty_users_to_notify": "没有要通知的用户。",
    "mobile_comments_users_cant_view_message": "这些用户无法查看这些评论",
    "mobile_comments_users_to_notify_title": "要通知的用户",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} 个用户</a>将收到通知。",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} 个用户</a>将收到通知。",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> 要通知的更多用户。",
    "mobile_comments_mark_read": "全部标记为已读",
    "mobile_comments_author_mentioned_message": "已在以下内容提及您：",
    "mobile_comments_author_commented_message": "对以下方面已进行评论：",
    "mobile_view_pdf": "查看 PDF",
    "mobile_no_pdf_generated_message": "未找到此提交的 PDF。副本将很快通过电子邮件发送给您。",
    "mobile_clipboard_copied_success": "该链接将复制到您的剪贴板。",
    "mobile_share_link": "分享链接",
    "mobile_zencam_share": "分享",
    "mobile_zencam_view_details": "查看详情",
    "mobile_zencam_details_drawer_header": "详情",
    "mobile_zencam_submitted_by": "提交者",
    "mobile_zencam_form_title": "表格标题",
    "mobile_zencam_date_submitted": "提交日期",
    "mobile_oil_quality_warning_message": "机油即将失效",
    "mobile_oil_quality_warning_message_subtitle": "尽快开始计划更换",
    "mobile_oil_quality_failure_message": "机油质量受损",
    "mobile_oil_quality_failure_message_subtitle": "立即更换机油",
    "mobile_sensors_set_up_gateway": "设置网关",
    "mobile_sensors_set_up_gateway_message": "似乎没有设置任何设备。添加网关以开始使用。",
    "mobile_sensors_gateway_plugged_in": "确保您的网关已插入电源插座",
    "mobile_sensors_add_device": "添加设备",
    "mobile_sensors_name_this_gateway": "命名此网关。",
    "mobile_sensors_name_this_sensor": "命名此传感器。",
    "mobile_sensors_device_barcode_information": "扫描二维码或输入设备标签上的 ID 编号和 SC 代码",
    "mobile_sensors_device_eui_information": "扫描二维码或输入设备标签上的 DevEUI",
    "mobile_sensors_gateway_id_information": "输入网关标签中的节点 ID",
    "mobile_sensors_id_number": "{{untranslatedID}} 编号",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} 代码",
    "mobile_sensors_sensors": "传感器",
    "mobile_sensors_sensor_deveui_error": "无法通过二维码获取 DevEUI。请手动输入。",
    "mobile_sensors_gateways": "网关",
    "mobile_sensors_add_sensor": "添加传感器",
    "mobile_sensors_add_gateway": "添加网关",
    "mobile_sensor_placement_description": "此传感器将监控哪些区域？",
    "mobile_sensors_equipment_placement": "此传感器将监控哪些区域或设备？",
    "mobile_sensors_equipment": "此传感器将监控哪些设备？",
    "mobile_sensors_select_gateway_type": "选择网关类型",
    "mobile_sensors_select_placement": "选择展示位置",
    "mobile_sensors_select_equipment": "选择设备",
    "mobile_sensors_placement": "展示位置",
    "mobile_sensors_nickname_tip": "传感器的命名由所选位置分配的昵称决定。",
    "mobile_sensors_device_online": "在线",
    "mobile_sensors_device_offline": "离线",
    "mobile_sensors_scan_qrcode": "扫描二维码",
    "mobile_sensors_enter_manually": "手动输入",
    "mobile_sensors_wizard_step_one": "步骤 1",
    "mobile_sensors_wizard_step_two": "步骤 2",
    "mobile_sensors_wizard_step_three": "步骤 3",
    "mobile_sensors_wizard_step_four": "步骤 4",
    "mobile_sensors_wizard_step_five": "步骤 5",
    "mobile_sensors_wizard_step_six": "步骤 6",
    "mobile_sensors_initializing": "正在初始化…",
    "mobile_sensors_nickname": "昵称",
    "mobile_sensors_field_not_blank": "{{field}} 字段不能为空。",
    "mobile_sensors_nothing_to_see_here": "此处无内容查看",
    "mobile_sensors_missing_integration": "缺少传感器集成",
    "mobile_sensors_contact_zenput_admin": "请联系贵公司的 Ops Execution 管理员。",
    "mobile_sensors_contact_zenput_admin_old": "请联系您的 Zenput 管理员。",
    "mobile_sensors_contact_manager": "请联系您的客户经理以添加传感器。",
    "mobile_sensors_device_success_message": "加载传感器数据最多可能需要 15 分钟",
    "mobile_sensors_last_reading": "上次阅读",
    "mobile_sensors_remove_device": "删除设备",
    "mobile_sensors_one_day": "1 天",
    "mobile_sensors_one_week": "1 周",
    "mobile_sensors_one_month": "1 个月",
    "mobile_sensors_three_months": "3 个月",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1 年",
    "mobile_sensors_sensor_settings": "传感器设置",
    "mobile_sensors_remove_confirm_message": "您确定要删除此设备吗？\n此操作不能撤销。",
    "mobile_sensors_sensor": "传感器",
    "mobile_sensors_no_equipment_linked": "无连接的设备",
    "mobile_sensor_cooldown_process": "冷却过程",
    "mobile_sensor_last_12_hours": "上个 12 小时",
    "mobile_sensor_start_cooldown_process": "开始新的冷却过程",
    "mobile_sensor_cooldown_process_title": "两阶段冷却过程",
    "mobile_sensor_cooldown_process_description": "两阶段冷却流程分为以下两部分：先在两小时内将食物从高于 {{ stage1_start_temperature }} 冷却到 {{ stage1_end_temperature }}，再在四小时内从 {{ stage1_end_temperature }} 冷却到 {{ stage2_end_temperature }}。",
    "mobile_sensor_cooldown_process_place_food": "将食品放入冰箱。",
    "mobile_sensor_cooldown_process_insert_sensor": "将传感器探针插入食品中。",
    "mobile_sensor_cooldown_process_enter_information": "在下面输入信息。",
    "mobile_sensor_cooldown_process_food_product": "食品冷却",
    "mobile_sensor_cooldown_cool_down": "冷却",
    "mobile_sensor_cooldown_select_sensor": "选择传感器",
    "mobile_sensors_cooldown_start_cooldown": "开始冷却",
    "mobile_sensors_cooldown_please_enter_food": "请输入食品",
    "mobile_sensors_cooldown_please_select_sensor": "请选择传感器",
    "mobile_sensors_cooldown_status_in_progress": "进行中",
    "mobile_sensors_cooldown_status_failed": "失败",
    "mobile_sensors_cooldown_status_success": "成功",
    "mobile_sensors_cooldown_stage": "阶段",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "启动温度超出范围",
    "mobile_sensors_cooldown_failed_cooldown_process": "冷却过程失败",
    "mobile_sensors_cooldown_cooldown_successful": "冷却成功",
    "mobile_sensors_cooldown_started_cooldown_process": "已开始冷却过程",
    "mobile_sensors_cooldown_hour": "小时",
    "mobile_sensors_cooldown_hour_plural": "小时",
    "mobile_sensors_cooldown_minute": "分钟",
    "mobile_minutes_plural": "分钟",
    "mobile_sensors_last_reading_max_date": "> 1 年前",
    "mobile_sensors_minute_count_ago": "{{count}} 分钟前",
    "mobile_sensors_minute_count_ago_plural": "{{count}} 分钟前",
    "mobile_sensors_hour_count_ago": "{{count}} 小时前",
    "mobile_sensors_hour_count_ago_plural": "{{count}} 小时前",
    "mobile_sensors_day_count_ago": "{{count}} 天前",
    "mobile_sensors_day_count_ago_plural": "{{count}} 天前",
    "mobile_sensors_chart_settings": "图表设置",
    "mobile_announcement_banner_continue_reading": "继续阅读",
    "mobile_compliance_submissions_report": "提交报告",
    "mobile_compliance_submissions_report_subtitle": "导出此商店的项目完成数据",
    "mobile_compliance_send_submissions": "发送提交",
    "mobile_compliance_completion_rate_in_last_days": "过去 {{ days }} 天的完成率",
    "mobile_compliance_last_days": "过去 {{ days }} 天",
    "mobile_compliance_send_submissions_to": "发送提交至",
    "mobile_compliance_send_to_different_email": "发送到其他电子邮件",
    "mobile_compliance_email_input_placeholder": "电子邮件地址",
    "mobile_compliance_send_submissions_to_legend_title": "提交",
    "mobile_compliance_send_submissions_to_legend_description_days": "包含您在过去 {{ days }} 天在此位置提交的报告将发送到选定的电子邮件。",
    "mobile_compliance_time_frame": "时间范围",
    "mobile_compliance_sensor_temperature_log_report": "传感器温度日志报告",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "导出此商店的温度日志",
    "mobile_compliance_sensor_temperature_log_criteria_title": "标准",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "在下面为您的报告定义标准。",
    "mobile_compliance_sensor_temperature_log_criteria_note": "注意：报告中不会显示禁用的传感器",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "选择一个时间范围。日志数据最长为 30 天",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "发送报告",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "本月（1 日 - 今天）",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "上个月",
    "mobile_compliance_sensor_temperature_log_email_title": "发送报告至",
    "mobile_pwa_update_prompt_title": "更新应用程序",
    "mobile_pwa_update_prompt_description": "应用程序有新版本可用。请更新至最新版本。",
    "mobile_pwa_update_prompt_confirm": "更新并重新加载",
    "mobile_pwa_update_prompt_cancel": "稍后提醒我",
    "notification_title_due_in_one_hour": "1 小时后到期",
    "task_is_due_soon": "“{{ task_title }}” 即将到期。请花点时间完成。",
    "mobile_photo_quality_warning_header": "照片质量问题",
    "mobile_photo_quality_dialog_message": "此照片可能太暗或太模糊。您想拍摄新照片，还是继续使用此照片？",
    "mobile_take_new_photo": "拍摄新照片",
    "mobile_use_this_photo": "使用此照片"
}};
mobile_translations.it_IT = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Tutto",
    "mobile_common_button_apply_filters": "Applica filtri",
    "mobile_common_button_done": "Fine",
    "mobile_common_button_edit": "Modifica",
    "mobile_common_button_archive": "Archivia",
    "mobile_common_button_save": "Salva",
    "mobile_common_button_retake": "Ripeti",
    "mobile_common_button_save_draft": "Salva bozza",
    "mobile_common_button_discard": "Ignora",
    "mobile_common_button_submit": "Invia",
    "mobile_common_button_no": "No",
    "mobile_common_button_yes": "Sì",
    "mobile_common_button_na": "N/D",
    "mobile_common_created_by_me": "Creati da me",
    "mobile_common_email": "Email aziendale",
    "mobile_common_first_name": "Nome",
    "mobile_common_last_name": "Cognome",
    "mobile_common_location": "Sede",
    "mobile_common_locations": "Sedi",
    "mobile_common_logout_message": "Uscire?",
    "mobile_common_password": "Password",
    "mobile_common_permission_required": "Autorizzazione necessaria",
    "mobile_common_status": "Stato",
    "mobile_common_task": "Attività",
    "mobile_common_tasks": "Attività",
    "mobile_common_tasks_my": "Le mie attività",
    "mobile_common_projects": "Progetti",
    "mobile_common_filter_team": "Team",
    "mobile_common_filter_var_in": " in {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Nessun team selezionato",
    "mobile_common_filter_no_user_selected": "Nessun utente selezionato",
    "mobile_common_filter_no_role_selected": "Nessun ruolo selezionato",
    "mobile_common_placeholder_date": "Data",
    "mobile_common_message_task_creator_error_save": "<b>Impossibile creare attività.</b>",
    "mobile_common_camera": "Fotocamera",
    "mobile_common_microphone": "Microfono",
    "mobile_common_for": "per",
    "mobile_common_reload": "Ricarica",
    "mobile_common_override": "Sostituisci",
    "mobile_common_notifications": "Notifiche",
    "mobile_common_chat_unavailable": "Chat non disponibile. Riprova più tardi.",
    "mobile_common_chat_ending_dialog_title": "Hai terminato questa conversazione?",
    "mobile_common_chat_ending_dialog_description": "Comunicaci se il tuo problema è stato risolto o se vuoi semplicemente continuare in un secondo momento.",
    "mobile_common_chat_ending_dialog_confirm": "Sì, ho finito",
    "mobile_common_chat_ending_dialog_cancel": "Continuerò più tardi",
    "mobile_common_continue_editing": "Continua a modificare",
    "mobile_privacy_policy": "Informativa sulla privacy",
    "wootric_recommend_target": "un amico o collega nel tuo settore",
    "wootric_followup_detractor_question": "Cosa dovremmo cambiare per ricevere una valutazione più alta la prossima volta?",
    "wootric_followup_passive_question": "Grazie! Cosa possiamo fare per migliorare ancora lo strumento?",
    "wootric_followup_promoter_question": "Grazie! Cosa ti piace di più di Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Grazie! Cosa ti piace di Zenput?",
    "wootric_default_followup_question": "Grazie! Come mai?",
    "wootric_default_placeholder_text": "Aiutaci condividendo il motivo del tuo punteggio.",
    "wootric_default_thankyou_text": "Grazie per la risposta e per il feedback!",
    "mobile_login_placeholder_login_as": "Accedi come ID utente",
    "mobile_login_button_forgot_password": "Password dimenticata?",
    "mobile_login_button_sign_up": "Crea account",
    "mobile_login_button_finish_setup": "Fine configurazione",
    "mobile_login_button": "Accedi",
    "mobile_login_continue_button": "Continua",
    "mobile_login_continue_transition": "stai per visualizzare la pagina di accesso della tua azienda...",
    "mobile_login_no_email_error": "Devi inserire un indirizzo email.",
    "mobile_login_change_email": "Accedi con un altro indirizzo email",
    "mobile_login_with_sso": "Accedi con SSO",
    "mobile_oauth_no_user_error_message": "A quanto pare non hai un account Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Non hai un account Zenput.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> è ora <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} a settembre diventa {{- product }}. {{- cta }}",
    "mobile_rebrand_warning_cta": "Scopri come prepararti.",
    "mobile_oauth_no_user_error_sub_message": "Contatta il tuo amministratore per l'accesso o prova ad accedere con un altro indirizzo.",
    "mobile_oauth_generic_error_message": "Si è verificato un problema di accesso. Riprova.",
    "mobile_oauth_force_logout_msg": "Se i problemi persistono, esegui la disconnessione dal provider ",
    "mobile_oauth_force_logout_click": "facendo clic qui.",
    "mobile_sign_up_placeholder_phone": "Numero di cellulare",
    "mobile_sign_up_placeholder_password_confirm": "Conferma password",
    "mobile_sign_up_button_sign_in": "Accedi",
    "mobile_sign_up_disclaimer_part_1": "Facendo clic su Crea account, accetti il",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Facendo clic su Fine configurazione, accetti:",
    "mobile_sign_up_disclaimer_link_title": " Contratto di licenza",
    "mobile_sign_up_disclaimer_part_2": "che include importanti informazioni sulla privacy",
    "mobile_dialog_benefits_work_offline": "Lavora offline",
    "mobile_dialog_benefits_faster_uploads": "Caricamenti più rapidi",
    "mobile_dialog_benefits_better_experience": "Esperienza migliorata",
    "mobile_dialog_benefits_button_download": "Download",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution per ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput per ",
    "mobile_dialog_benefits_button_have": "Ho già l'app.",
    "mobile_dialog_benefits_button_no_thanks": "No grazie, forse in futuro.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Impossibile caricare l'immagine.",
    "mobile_dialog_signature_sign": "Firma qui",
    "mobile_dialog_signature_button_clear": "Cancella",
    "mobile_account_placeholder_name": "Sede/nome negozio",
    "mobile_account_placeholder_phone": "Telefono",
    "mobile_account_placeholder_address": "Indirizzo",
    "mobile_account_placeholder_city": "Città",
    "mobile_account_placeholder_region": "Area geografica",
    "mobile_account_placeholder_zipcode": "CAP",
    "mobile_account_option_select_country": "Seleziona paese",
    "mobile_account_oprion_us": "Stati Uniti",
    "mobile_account_oprion_select_state": "Seleziona stato",
    "mobile_account_button_create_location": "Crea sede",
    "mobile_form_message_no_form": "Nessun modulo disponibile",
    "mobile_batch_task_message": "Caricamento...",
    "mobile_settings_profile": "Profilo",
    "mobile_settings_profile_number": "Telefono cellulare",
    "mobile_settings_profile_language": "Lingua",
    "mobile_settings_profile_temperature_unit": "Unità di temperatura",
    "mobile_settings_profile_use_company_default": "Usa le impostazioni predefinite dell'azienda",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "SMS",
    "mobile_settings_notifications_option_push": "Notifiche push",
    "mobile_settings_notifications_option_push_email": "Notifiche email e push",
    "mobile_settings_notifications_option_do_not": "Nessuna notifica",
    "mobile_settings_notifications_category_communication": "Comunicazione",
    "mobile_settings_notifications_category_forms_and_triggers": "Moduli e attivatori",
    "mobile_settings_devices": "Dispositivi",
    "mobile_settings_notifications_sub_category_alerts": "Avvisi",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nuovi moduli disponibili",
    "mobile_settings_notifications_sub_category_task_assigned": "Attività assegnata",
    "mobile_settings_notifications_sub_category_task_completed": "Attività completata",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Promemoria attività in scadenza",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Promemoria attività in ritardo",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Avvisi sensore",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Avvisi sensore critici",
    "mobile_drafts_message": "Non hai alcuna bozza.",
    "mobile_drafts_button_delete": "Elimina",
    "mobile_tasks_filter_location_no": "Nessuna sede selezionata",
    "mobile_tasks_filter_group_by": "Raggruppa per",
    "mobile_tasks_filter_sort_by": "Ordina per",
    "mobile_tasks_filter_sorted_by": "Ordinato per",
    "mobile_tasks_filter_due_time": "Ora termine",
    "mobile_tasks_filter_open_time": "Ora apertura",
    "mobile_tasks_bucket_due_next_24_hours": "In scadenza entro 24 ore",
    "mobile_tasks_bucket_due_next_7_days": "In scadenza entro 7 giorni",
    "mobile_tasks_bucket_open_tasks": "Altre attività aperte {{type}}",
    "mobile_tasks_bucket_open_at": "Apertura: {{- date }} alle {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Scadenza: {{- date }} alle {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponibile tra 1 minuto",
    "mobile_tasks_bucket_available_in_one_hour": "Disponibile tra 1 ora",
    "mobile_tasks_bucket_available_in_one_day": "Disponibile tra 1 giorno",
    "mobile_tasks_bucket_available_in_one_week": "Disponibile tra 1 settimana",
    "mobile_tasks_bucket_available_in_one_month": "Disponibile tra 1 mese",
    "mobile_tasks_bucket_available_in_one_year": "Disponibile tra 1 anno",
    "mobile_tasks_bucket_available_in_minutes": "Disponibile tra {{ minutes }} minuti",
    "mobile_tasks_bucket_available_in_hours": "Disponibile tra {{ hours }} ore",
    "mobile_tasks_bucket_available_in_days": "Disponibile tra {{ days }} giorni",
    "mobile_tasks_bucket_available_in_weeks": "Disponibile tra {{ weeks }} settimane",
    "notification_task_due_in_minutes": "In scadenza tra {{ minutes }} minuti",
    "mobile_tasks_bucket_available_in_months": "Disponibile tra {{ months }} mesi",
    "mobile_tasks_bucket_available_in_years": "Disponibile tra {{ years }} anni",
    "mobile_tasks_follow_up": "Attività di follow-up",
    "mobile_tasks_due_soon": "In arrivo prossimamente",
    "mobile_tasks_bucket_completed_today": "Completate oggi",
    "mobile_tasks_bucket_completed_this_week": "Completate questa settimana",
    "mobile_tasks_bucket_completed_last_week": "Completate la scorsa settimana",
    "mobile_tasks_bucket_missed_today": "Saltate oggi",
    "mobile_tasks_bucket_missed_this_week": "Saltate questa settimana",
    "mobile_tasks_bucket_missed_last_week": "Saltate la settimana scorsa",
    "mobile_tasks_bucket_no_location": "Nessuna sede",
    "mobile_tasks_cannot_submit_missed": "Le attività saltate non possono essere completate",
    "mobile_tasks_cannot_submit_missed_after": "L'attività non può essere completata dopo il giorno {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Questa attività non è iniziata.",
    "mobile_tasks_cannot_submit_processing": "Questo contenuto è in fase di elaborazione",
    "mobile_tasks_toolbarnav_header_no_due_date": "Nessuna scadenza",
    "mobile_tasks_toolbarnav_header_overdue": "Scadute",
    "mobile_tasks_toolbarnav_header_yesterday": "Ieri",
    "mobile_tasks_toolbarnav_header_today": "Oggi",
    "mobile_tasks_toolbarnav_header_tomorrow": "Domani",
    "mobile_tasks_toolbarnav_header_last_week": "La settimana scorsa",
    "mobile_tasks_toolbarnav_header_this_week": "Questa settimana",
    "mobile_tasks_toolbarnav_header_next_week": "La settimana prossima",
    "mobile_tasks_toolbarnav_header_this_month": "Questo mese",
    "mobile_tasks_toolbarnav_header_next_year": "L'anno prossimo",
    "mobile_tasks_toolbarnav_header_over_year": "Più di un anno",
    "mobile_tasks_toolbarnav_title_edit_task": "Modifica attività",
    "mobile_task_placeholder_title": "Titolo *",
    "mobile_task_placeholder_description": "Descrizione (facoltativa)",
    "mobile_task_button_single_task": "Attività singola",
    "mobile_task_button_project": "Progetto",
    "mobile_task_button_create": "Crea",
    "mobile_task_tab_basic": "Di base",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Modulo",
    "mobile_task_details_description_message_please": "Compila ",
    "mobile_task_details_description_message_below": "sotto.",
    "mobile_task_details_description_message_instructions": "Nessuna istruzione disponibile per questa attività.",
    "mobile_task_details_reason_title": "Follow-up attivato da",
    "mobile_task_detials_button_goto_form": "Vai al modulo",
    "mobile_task_detials_button_complete": " Completa attività",
    "mobile_task_detials_completed": "Completata ",
    "mobile_task_detials_completed_by": "da ",
    "mobile_task_detials_completed_on": "il giorno ",
    "mobile_task_details_view_form_submission": "Mostra modulo inviato",
    "mobile_task_task_updated": "Attività aggiornata",
    "mobile_task_task_archived": "Attività archiviata",
    "mobile_task_task_deleted": "Attività eliminata",
    "mobile_task_error_archiving_task": "Impossibile archiviare l'attività.",
    "mobile_task_error_deleting_task": "Impossibile eliminare l'attività.",
    "mobile_task_error_updating_task": "Impossibile aggiornare l'attività.",
    "mobile_task_archive_task": "Archivia attività",
    "mobile_task_archive_task_confirm": "Archiviare questa attività?\n\nLe attività archiviate vengono conteggiate nel calcolo dei tassi di completamento e continuano a essere incluse nei report.\n\nL'operazione non può essere annullata.",
    "mobile_task_delete_task_confirm": "Eliminare questa attività?\n\nLe attività eliminate non vengono conteggiate nel calcolo dei tassi di completamento e non vengono incluse nei report.\n\nL'operazione non può essere annullata.",
    "mobile_task_edition_already_in_progress": "L'attività è già in attesa di modifica. Non sono consentite ulteriori modifiche.",
    "mobile_projects_filter_type": "Tipo",
    "mobile_projects_filter_status": "Stato progetto",
    "mobile_projects_filter_project_type": "Tipo progetto",
    "mobile_projects_due_date_required": "La data di scadenza è obbligatoria.",
    "mobile_projects_team_required": "Il team è obbligatorio.",
    "mobile_projects_user_role_required": "L'incaricato è obbligatorio.",
    "mobile_projects_title_required": "Il titolo è obbligatorio",
    "mobile_projects_recurring_multiple_tasks_per_day": "Più attività per giorno",
    "mobile_project_tasks_complete": " Completa",
    "mobile_project_tasks_remaining": " Residue",
    "mobile_esitmate_message_tasks": "Verranno create 0 attività",
    "mobile_esitmate_message_criteria": "Adegua i criteri sopra",
    "mobile_esitmate_message_created_for": "verranno create per",
    "mobile_left_menu_dashboard": "Dashboard",
    "mobile_left_menu_my_forms": "I miei moduli",
    "mobile_left_menu_announcements": "Annunci",
    "mobile_left_menu_my_submissions": "I miei invii",
    "mobile_left_menu_drafts": "Bozze",
    "mobile_left_menu_pending_uploads": "Caricamenti in attesa",
    "mobile_left_menu_open": "Apri in app",
    "mobile_left_menu_settings": "Impostazioni",
    "mobile_left_menu_log_out": "Esci",
    "mobile_left_menu_debug": "Debug",
    "mobile_left_menu_support": "Assistenza",
    "mobile_left_menu_documentation": "Documentazione",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Nota o didascalia",
    "mobile_field_option_select": "Seleziona",
    "mobile_field_text_placeholder_text": "Testo",
    "mobile_field_email_placehoder_email": "Email",
    "mobile_filed_number_placeholder_number": "Numero",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Non connesso",
    "mobile_field_sensor_offline_battery": "Sensore offline - Batteria",
    "mobile_field_video_button_add": "Aggiungi video",
    "mobile_field_video_picker_dialog_title": "Aggiungi video da",
    "mobile_field_video_button_change": "Modifica video",
    "mobile_field_image_button_add": "Aggiungi immagine",
    "mobile_field_image_low_quality_warning": "Alcune foto sono troppo scure o sfuocate. Esamina le foto evidenziate e sostituiscile se necessario.",
    "mobile_field_image_picker_dialog_title": "Aggiungi foto da",
    "mobile_field_image_picker_edit_failed": "Impossibile salvare l'immagine. Riprova",
    "mobile_field_signature_button_add": "Aggiungi firma",
    "mobile_field_signature_button_change": "Modifica firma",
    "mobile_field_account_select_location": "Seleziona una sede",
    "mobile_field_account_prefill": "Precompilare il modulo con i dati dell'ultima visita?",
    "mobile_field_account_message_overwrite": "I campi già compilati verranno sostituiti.",
    "mobile_forms_task_on_behalf": "Presso questa sede è presente un'attività da completare assegnata a <b>{{user}}</b>. Completarla?",
    "mobile_forms_complete_task": "Completare l'attività?",
    "mobile_field_account_prefill_button_yes": "Sì, precompila",
    "mobile_field_barcode_placeholder_scan": "Acquisisci o digita codice a barre",
    "mobile_field_sensor_qr_code_placeholder_scan": "Acquisisci o digita codice",
    "mobile_field_gateway_id_code_placeholder": "Digita ID nodo",
    "mobile_field_scan_qr_or_enter_dev_eui": "Scansiona codice QR o inserisci DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Scansiona codice QR o inserisci numero ID",
    "mobile_field_scan_qr_or_enter_sc": "Scansiona codice QR o inserisci codice SC",
    "mobile_field_barcode_select_date": "Seleziona data ",
    "mobile_field_datetime_allow_time": "Ora",
    "mobile_field_stopwatch_button_caption": "Cronometro",
    "mobile_field_stopwatch_common_start": "Inizia",
    "mobile_field_stopwatch_common_stop": "Interrompi",
    "mobile_field_stopwatch_common_reset": "Reimposta",
    "mobile_field_stopwatch_stop_stopwatches": "Interrompi cronometro",
    "mobile_field_document_title": "Aggiungi documento",
    "mobile_field_document_message_delete": "Eliminare questo documento?",
    "mobile_field_document_alret_button_view": "Mostra",
    "mobile_field_document_alert_error": "Si è verificato un errore durante il tentativo di allegare il documento. Riprova.",
    "mobile_field_document_alert_file_size_error": "Le dimensioni del file non possono superare {{count}} MB.",
    "mobile_field_temperature_greater_range": "maggiore di {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "maggiore o uguale a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "minore di {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "minore o uguale a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "maggiore o uguale a {{ min_temp_value }} °{{ temp_unit }} e minore di {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "maggiore o uguale a {{ min_temp_value }} °{{ temp_unit }} e minore o uguale a {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " e ",
    "mobile_field_text_limit_error": "Raggiunto il limite massimo di 8000 caratteri.",
    "mobile_forms_required_questions_complete": "Obbligatori completati",
    "mobile_forms_required_remaining": "{{count}} obbligatori rimanenti",
    "mobile_forms_required_questions_back": "Indietro",
    "mobile_forms_required_questions_next": "Avanti",
    "mobile_forms_required_questions_skip": "Salta",
    "mobile_forms_leaving_form": "Abbandono modulo",
    "mobile_message_reordering_confirm": "Salvare il nuovo ordine di domande?",
    "mobile_forms_leaving_reordering": "Abbandono riordino domande",
    "mobile_forms_reordering_button_save": "Salva nuovo ordine di domande",
    "mobile_forms_reordering_instructions": "Per riordinare domande o sezioni, trascina gli elementi nel punto in cui devono essere mostrati nel modulo",
    "mobile_toolbarnav_title_my_setttings": "Le mie impostazioni",
    "mobile_toolbarnav_title_profile_settings": "Impostazioni profilo",
    "mobile_toolbarnav_title_notification": "Impostazioni di notifica",
    "mobile_toolbarnav_title_form_history": "Cronologia modulo",
    "mobile_toolbarnav_title_form_not_available": "Modulo non disponibile",
    "mobile_toolbarnav_title_add_location": "Aggiungi sede",
    "mobile_toolbarnav_title_add_task_or_project": "Aggiungi attività o progetto",
    "mobile_toolbarnav_title_select_location": "Seleziona sede",
    "mobile_toolbarnav_title_select_project": "Seleziona progetto",
    "mobile_toolbarnav_title_select_tag": "Seleziona tag",
    "mobile_toolbarnav_title_select_user": "Seleziona utente",
    "mobile_toolbarnav_title_select_template": "Seleziona modello",
    "mobile_toolbarnav_title_select_one": "Seleziona un'opzione",
    "mobile_toolbarnav_title_select_multiple": "Seleziona una o più opzioni",
    "mobile_toolbarnav_title_select_team": "Seleziona team",
    "mobile_toolbarnav_title_select_team_or_location": "Seleziona team o sede",
    "mobile_toolbarnav_title_filter_tasks": "Filtra attività",
    "mobile_toolbarnav_title_filter_projects": "Filtra progetti",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtra attività progetto",
    "mobile_placeholder_search_bar": "Cerca",
    "mobile_placeholder_user_select_role": "Seleziona ruolo utente",
    "mobile_placeholder_filter_by_team": "Filtra per team",
    "mobile_placeholder_assign_to_user_role": "Assegna a ruolo utente",
    "mobile_placeholder_select": "-- Seleziona --",
    "mobile_placeholder_account_location_name": "Nome sede",
    "mobile_placeholder_tag_filter_by": "Filtra per tag sede",
    "mobile_placeholder_user_type": "Assegna a utente",
    "mobile_placeholder_acount_type_loading": "Caricamento... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatura",
    "mobile_placeholder_blue_therm_connecting": "Connessione al dispositivo...",
    "mobile_placeholder_blue_therm_please_wait": "Attendi...",
    "mobile_placeholder_blue_therm_tap": "Tocca per leggere.",
    "mobile_placeholder_blue_therm_not_connected": "Non connesso.",
    "mobile_placeholder_testo_tap": "Tieni premuto ▼▲ seguito da ⬆",
    "mobile_message_error_create_task": "Devi essere online per aggiungere attività.",
    "mobile_message_error_fill_out_form": "Compila il modulo.",
    "mobile_message_error_fill_require_fields": "Compila i campi obbligatori.",
    "mobile_message_error_stop_stopwatch_before_submit": "Interrompi il cronometro prima di inviare",
    "mobile_message_error_stopwatch_field_required": "Il campo Cronometro è obbligatorio",
    "mobile_message_error_stopwatch_field_running": "Cronometro attivo",
    "mobile_message_error_invalid_equipment_temperature": "Temperatura apparecchiatura non valida",
    "mobile_message_error_invalid_ingredient_temperature": "Temperatura ingrediente non valida",
    "mobile_message_error_location_attributes_unavailable": "Alcune domande potrebbero non essere disponibili, collegati a Internet",
    "mobile_message_alert_running_stopwatches": "Cronometri attivi.\n\nCancellarli?",
    "mobile_message_blue_therm_error": "Connessione al dispositivo Bluetooth persa",
    "mobile_message_blue_therm_no_permission_android_pre_12": "È necessario l'accesso alla località. Abilita l'accesso nelle impostazioni di Android.",
    "mobile_message_blue_therm_no_permission_android": "È necessario l'accesso alla funzione di ricerca dispositivi nelle vicinanze. Abilita l'accesso nelle impostazioni di Android.",
    "mobile_message_blue_therm_error_code": "Impossibile stabilire la connessione:",
    "mobile_message_blue_therm_error_bluetooth": "Abilita il Bluetooth.",
    "mobile_message_blue_therm_error_device": "Dispositivo non trovato.",
    "mobile_message_blue_therm_error_try_again": "Riprova",
    "mobile_message_blue_therm_success": "Dispositivo Bluetooth connesso.",
    "mobile_message_bluetooth_device_press_button_field": "Premi il pulsante sul dispositivo per connetterlo.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Premi il pulsante sul dispositivo<br />se non lo vedi elencato qui.",
    "mobile_bluetooth_scan": "Scansiona",
    "mobile_bluetooth_scanning": "Scansione in corso",
    "mobile_message_drafts_confirm": "Salvare come bozza?",
    "mobile_message_drafts_toast_saved": "Bozza salvata.",
    "mobile_message_drafts_request_update": "Aggiornare la bozza?",
    "mobile_message_drafts_form_confirm": "Eliminare la bozza?",
    "mobile_message_drafts_confirm_delete": "Elimina bozza",
    "mobile_message_streams_error_switch": "Non modificare i flussi sul web",
    "mobile_message_settings_success_saved": "Impostazioni salvate",
    "mobile_message_settings_error": "Si è verificato un errore sconosciuto. Riprova più tardi.",
    "mobile_message_profile_settings_error_fields": "Correggi i campi evidenziati.",
    "mobile_message_media_perimission_denied": "Il tuo ",
    "mobile_message_media_perimission_denied_device": "Dispositivo di archiviazione",
    "mobile_message_image_confirm_remove_image": "Eliminare questa foto?",
    "mobile_message_create_account_error_fields": "Compila i campi evidenziati.",
    "mobile_message_create_account_success_location_created": "Sede creata.",
    "mobile_message_task_error_get_location": "Impossibile recuperare la sede. Ordinamento per data.",
    "mobile_message_typehead_confirm_save_message": "Salvare le selezioni?",
    "mobile_message_typehead_confirm_save_title": "Salvare?",
    "mobile_message_task_creator_error_save_select_form": "Seleziona un modulo.",
    "mobile_message_task_creator_error_save_required_fields": "Compila i campi obbligatori.",
    "mobile_message_task_creator_error_save_batch_change": "Modifica i criteri per trovare riscontro con uno o più utenti",
    "mobile_message_task_detials_error_not_assigned_to_you": "Questa attività non è assegnata a te.<br />Non puoi completarla.",
    "mobile_message_task_detials_error_assigned_to": "Questa attività è assegnata a {{user}}.<br />Non puoi completarla.",
    "mobile_message_task_detials_confirm_title": "Abbandono attività",
    "mobile_message_task_detials_confirm_save_task": "Salva attività",
    "mobile_message_task_detials_confirm_message": "Continuare? Le modifiche andranno perse.",
    "mobile_message_task_detials_error_view_account": "Impossibile accedere alla sede.",
    "mobile_message_task_detials_error_submit_task": "Aggiungi una foto per completare questa attività.",
    "mobile_message_task_detials_error_submit_task_project": "Impossibile salvare il progetto. Riprova più tardi.",
    "mobile_message_task_detials_wait_submit_task_created": "È in corso la creazione delle attività.<br />Attendi qualche minuto per visualizzarle.",
    "mobile_message_task_detials_error_submit_task_pending": "Errore. Riprova più tardi.",
    "mobile_message_task_detials_success_task_complete": "Attività completata",
    "mobile_message_task_error_save_single_task": "Impossibile salvare l'attività. Riprova più tardi.",
    "mobile_message_task_success_save_single_task": "Attività creata.",
    "mobile_message_show_error_message": "Si è verificato un errore.",
    "mobile_message_show_success_message": "Operazione riuscita.",
    "mobile_message_show_offline_message": "Sei offline.",
    "mobile_message_show_permission_denied_message": "<b>Autorizzazione necessaria.</b> Autorizza Zenput ad accedere a {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Autorizzazione necessaria.</b> Autorizza Zenput e il browser in uso ad accedere a {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Caricamento in corso",
    "mobile_message_show_upload_in_progress_message": "Caricamento già in corso",
    "mobile_message_show_form_id_error": "Impossibile accedere al modulo specificato.",
    "mobile_message_show_single_task_error": "Impossibile accedere all'attività specificata.",
    "mobile_message_show_submissions_error": "Impossibile accedere all'invio specificato.",
    "mobile_message_show_submissions_access_denied": "Non hai accesso a questo modulo.",
    "mobile_message_send_data_success": "Dati caricati ",
    "mobile_message_start_upload_success": "Caricamento completato",
    "mobile_message_start_upload_error": "<b>Impossibile completare il caricamento.</b><br>Invio salvato. Riprova più tardi.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Aggiornamento disponibile",
    "mobile_message_store_upgrade_confirm_message_one": "Aggiorna l'app Ops Execution da ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Aggiorna Zenput da ",
    "mobile_message_store_upgrade_confirm_message_two": " per ricevere le nuove funzionalità e correzioni",
    "mobile_message_store_upgrade_confirm_now": "Ora",
    "mobile_message_store_upgrade_confirm_later": "Più tardi",
    "mobile_message_redirect_confirm_message": "Stai compilando un modulo. Salvarlo come bozza prima di continuare?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Hai {{count}} bozze non ancora caricate. Se continui, andranno perse. Procedere?",
    "mobile_message_draft_override_message": "Questa bozza è stata salvata da un altro dispositivo il giorno {{date}} e le modifiche apportate su tale dispositivo sono in conflitto. Puoi scegliere di sostituire la versione esistente o di ricaricare quella più recente. In tal caso, le modifiche verranno ignorate.",
    "mobile_html_submitting": "Invio...",
    "mobile_html_offline": "Sei offline.",
    "mobile_html_offline_try_again": "Sei offline. <br/><br/>Riprova una volta stabilita la connessione.",
    "mobile_html_something_went_wrong": "Si è verificato un errore.",
    "mobile_html_something_went_wrong_try_again": "Si è verificato un errore. Riprova.",
    "mobile_html_failed_loading_roles": "Impossibile caricare i ruoli.",
    "mobile_alert_please_install_for_native": "Per utilizzare questa funzione, installa l'app Ops Execution. ",
    "mobile_alert_please_install_for_native_old": "Installa l'app Zenput nativa per utilizzare questa funzione.",
    "mobile_tso_filter_all_tasks": "Tutte le attività {{type}}",
    "mobile_tso_filter_my_tasks": "Le mie attività {{type}}",
    "mobile_tso_filter_due_date": "Data di scadenza",
    "mobile_tso_filter_date_completed": "Data di completamento",
    "mobile_tso_filter_completed": "Completate",
    "mobile_tso_filter_completed_late": "Completato in ritardo",
    "mobile_tso_filter_incomplete": "Non completate",
    "mobile_tso_filter_var_my_tasks": "Le mie attività {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} Create da me",
    "mobile_tso_filter_var_all_tasks": "Tutte le attività {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Attività di follow-up",
    "mobile_tso_type_all": "Attività e azioni di follow-up",
    "mobile_tso_filter_var_at": " presso {{location}}",
    "mobile_tso_filter_group_date_due": ", ordinate per data di scadenza",
    "mobile_tso_filter_group_distance": ", raggruppate per sede",
    "mobile_tso_filter_start_date": "Data di inizio",
    "mobile_tso_filter_none": "Nessuna",
    "mobile_pso_filter_all_projects": "Tutti i progetti",
    "mobile_pso_filter_my_projects": "I miei progetti",
    "mobile_pso_filter_active": "Attivi",
    "mobile_pso_filter_archived": "Archiviati",
    "mobile_pso_filter_recurring": "Ricorrenti",
    "mobile_pso_filter_non_recurring": "Non ricorrenti",
    "mobile_pso_filter_var_my_projects": "I miei progetti {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "Progetti {{project_type}} {{active_description}} creati da me",
    "mobile_pso_filter_var_all_projects": "Tutti i progetti {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Sei offline. Vai online per vedere i risultati.",
    "mobile_empty_list_message_no_submissions": "Nessun invio",
    "mobile_empty_list_message_no_activity": "Nessuna azione",
    "mobile_empty_list_message_no_tasks": "Nessuna attività",
    "mobile_empty_list_message_no_tasks_overdue": "Nessuna attività scaduta {{type}}",
    "mobile_empty_list_message_no_accounts": "Nessuna sede",
    "mobile_empty_list_message_no_projects": "Nessun progetto",
    "mobile_empty_list_message_no_results_found": "Nessun risultato trovato",
    "mobile_empty_list_message_no_forms_available": "Nessun modulo disponibile",
    "mobile_empty_list_message_connection_error": "Errore di connessione<br />Riprova.",
    "mobile_empty_list_message_dashboard_error": "Impossibile caricare il dashboard",
    "mobile_empty_list_message_user_offline": "Sei offline",
    "mobile_action_sheet_media_gallery": "Galleria",
    "mobile_action_sheet_cancel": "Annulla",
    "mobile_image_preview_text": "Rimuovi foto",
    "mobile_mobileform_text": "Invii precedenti",
    "mobile_mobileform_reorder_fields": "Riordina domande",
    "mobile_mobileform_follow_up_actions": "Azioni successive",
    "mobile_mobileform_follow_up_actions_assign_title": "Assegna azioni di follow-up",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Aggiungi azioni di follow-up in base alle tue osservazioni per dare risoluzione ai problemi.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Aggiungi attività di follow-up",
    "mobile_mobileform_follow_up_actions_assign_button": "Assegna azioni di follow-up",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continua senza assegnare",
    "mobile_mobileform_follow_up_actions_dialog_title": "Vuoi continuare senza assegnare azioni di follow-up?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Se continui senza assegnare azioni di follow-up, non potrai più aggiungerle in seguito.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continua comunque",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Questo campo è obbligatorio",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Troppi caratteri",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Questo campo non è valido",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Errore caricamento sedi",
    "mobile_mobileform_add_follow_up_actions_error_users": "Errore caricamento utenti",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Aggiungi azioni di follow-up",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Titolo",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Descrizione",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "È richiesta una foto",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Data di scadenza",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Aggiorna azioni di follow-up",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Elimina azione di follow-up?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "L'azione sarà eliminata e non sarà assegnata.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Elimina azione di follow-up",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Eliminare l'azione di follow-up?\n\nL'operazione non è annullabile.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continua fino alle azioni di follow-up",
    "mobile_mobileform_follow_up_actions_completed_notification": "Attività di follow-up completata",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Attività di follow-up eliminata",
    "mobile_mobileform_follow_up_actions_update_notification": "Attività di follow-up aggiornata",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Aggiungi una foto per completare questa azione di follow-up",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Vai alla sezione invio",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Vai all'origine dati",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Origine dati",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Completa azione di follow-up",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Se apri la sezione invio, eventuali foto e note non salvate andranno perdute.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Se esci da questa schermata, le foto e le note non salvate andranno perdute.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Resta in questa pagina",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Apri la sezione invio",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Open source",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Abbandonare questa azione di follow-up?",
    "mobile_mobileform_follow_up_actions_submission": "Invio",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Questa azione di follow-up è assegnata a {{user}}.<br />Non puoi completarla.",
    "mobile_mobileform_follow_up_actions_leave_description": "Se esci da questa schermata, le modifiche non salvate andranno perdute.",
    "mobile_mobileform_follow_up_actions_leave": "Esci",
    "mobile_forms_drafts_text": "Rimuovi bozze",
    "mobile_batch_estimate_user": "Utente",
    "mobile_batch_estimate_users": "Utenti",
    "mobile_table_of_contents": "Sommario",
    "mobile_table_of_contents_required": "Obbligatorio",
    "mobile_table_of_contents_optional": "Facoltativo",
    "mobile_dialog_alert_title": "Avviso",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Dispositivi Bluetooth non ancora supportati su Windows",
    "mobile_windows_deprecated_message_content_announcement": "Annuncio",
    "mobile_windows_deprecated_message_title": "È necessario aggiornare l'app",
    "mobile_windows_deprecated_message_description": "Installa la nuova app Zenput nel Microsoft Store il prima possibile per ottenere aggiornamenti delle funzionalità critiche e un'esperienza ottimale con Zenput.",
    "mobile_dashboard_tcr_graph_name": "Tasso di completamento attività",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Ultime 4 settimane",
    "mobile_dashboard_tcr_legend_company_average": "Media azienda",
    "mobile_dashboard_tcr_legend_team_average": "Media team",
    "mobile_dashboard_tab_title_summary": "Riepilogo",
    "mobile_dashboard_tab_title_activity": "Azione",
    "mobile_dashboard_card_title_top_triggered_workflows": "Principali attivatori",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Conformità",
    "mobile_dashboard_card_task_stats_total": "Totale",
    "mobile_dashboard_top_item_header_week_of": "Settimana del",
    "mobile_dashboard_card_filter_form_template_placeholder": "Tutti i moduli",
    "mobile_dashboard_card_title_forms_top_nos": "\"No\" frequenti",
    "mobile_dashboard_zenput_code_no_data_in_range": "Nessun dato in questo intervallo di tempo.",
    "mobile_dashboard_zenput_code_permission_denied": "Non sei autorizzato a visualizzare.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Seleziona un modulo sopra.",
    "mobile_dashboard_zenput_code_unknown_error": "Non è possibile mostrare i dati al momento.",
    "mobile_dashboard_tap_to_retry": "Tocca per riprovare",
    "mobile_dashboard_reporting_delay_disclaimer": "L'aggiornamento delle attività richiede fino a 15 minuti",
    "mobile_dashboard_configuration_down_state_postfix_msg": "configurate dal tuo amministratore.",
    "mobile_tasks_tag": "attività",
    "mobile_workflows_tag": "attivatori",
    "mobile_projects_tag": "progetti ricorrenti",
    "mobile_forms_tag": "moduli",
    "mobile_dashboard_card_ongoing_projects_title": "Progetti in corso",
    "mobile_dashboard_card_ongoing_projects_show_more": "Mostra altro",
    "mobile_dashboard_card_ongoing_projects_show_less": "Mostra meno",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Vai ai progetti",
    "mobile_dashboard_card_title_recurring_projects": "Progetti ricorrenti",
    "mobile_dashboard_card_filter_daily": "Ogni giorno",
    "mobile_dashboard_card_filter_weekly": "Ogni settimana",
    "mobile_dashboard_card_filter_monthly": "Ogni mese",
    "mobile_task_status_title_open": "Apri",
    "mobile_task_status_title_upcoming": "Imminenti",
    "mobile_task_status_title_complete": "Completi",
    "mobile_task_status_title_processing": "Elaborazione invio",
    "mobile_task_status_title_complete_with_exceptions": "Completi con attività di follow-up o avvisi",
    "mobile_task_status_title_completed_late_with_exceptions": "Completato in ritardo con attività di follow-up o avvisi",
    "mobile_task_status_title_incomplete_and_closed": "Saltati",
    "mobile_tasks_legend_modal_title": "Legenda",
    "mobile_tasks_legend_modal_footer_button_title": "Chiudi",
    "mobile_common_assigned_to": "Assegnato a",
    "mobile_common_created_by": "Creato da",
    "mobile_common_tasks_for": "Attività per",
    "mobile_common_go_back": "Torna indietro",
    "mobile_oh_no": "Errore.",
    "mobile_user_not_in_groups": "Non sei assegnato ad alcun team. Contatta l'amministratore per accedere al dashboard.",
    "mobile_tasks_select_followers": "Seleziona follower",
    "mobile_tasks_assign_tasks": "Assegna {{count}} attività",
    "mobile_tasks_add_followers": "Aggiungi follower",
    "mobile_tasks_followers": "Follower",
    "mobile_tasks_delete_task": "Elimina attività",
    "mobile_tasks_create_task": "Crea attività",
    "mobile_tasks_tab_title_comments": "Commenti",
    "mobile_tasks_see_more": "Vedi altro",
    "mobile_projects_create_project": "Crea progetto",
    "mobile_common_button_send": "Invia",
    "mobile_common_button_schedule": "Pianifica",
    "mobile_announcements_create": "Crea annuncio",
    "mobile_announcements_read_rate": "{{opened_count}} di {{recipients_count}} aperti",
    "mobile_announcements_empty_message": "Non hai creato alcun annuncio. Crea un annuncio sotto per trasmettere notizie, informazioni e aggiornamenti importanti alla tua azienda.",
    "mobile_announcement_message_placeholder": "Aggiungi un messaggio...",
    "mobile_announcement_title_placeholder": "Titolo annuncio",
    "mobile_announcement_leaving_announcement": "Abbandono annuncio",
    "mobile_announcement_confirm_recipients_team": "Trasmettere questo annuncio a {{count}} utenti in {{teams}} team selezionati?",
    "mobile_announcement_confirm_recipients_role": "Trasmettere questo annuncio a {{count}} utenti in {{roles}} ruoli selezionati?",
    "mobile_announcement_confirm_recipients_user": "Trasmettere questo annuncio a {{count}} utenti?",
    "mobile_announcement_confirm_scheduled": "Il giorno {{timestamp}}",
    "mobile_announcement_sending_announcement": "Invio annuncio",
    "mobile_announcement_send_to": "Invia a",
    "mobile_announcement_sent_to": "Inviato a",
    "mobile_announcement_send_to_role": "Ruolo",
    "mobile_announcement_attachment_download": "Download di {{filename}}",
    "mobile_announcement_attachment_validation_error": "Non è possibile aggiungere meno di {{maxCount}} allegati",
    "mobile_announcement_details_sent": "Inviato",
    "mobile_announcement_details_total_recipients": "Totale destinatari",
    "mobile_announcement_details_cancel": "Annulla annuncio",
    "mobile_announcement_details_not_editable": "È possibile modificare gli annunci solo nell'app web Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Gli annunci possono essere modificati solo su Zenput Web",
    "mobile_announcement_details_open_count": "Totale aperti",
    "mobile_announcement_details_open_rate": "Tasso di apertura",
    "mobile_announcement_details_resend": "Invia di nuovo a chi non ha aperto",
    "mobile_announcement_confirm_resend": "{{count}} utenti non hanno letto l'annuncio. Inviare un promemoria?",
    "mobile_announcement_confirm_resend_title": "Inviare promemoria",
    "mobile_announcement_recipients_opened": "Aperti",
    "mobile_recipients_opened_empty_message": "Nessuno ha ancora aperto il tuo messaggio. Torna più tardi per visualizzare i risultati.",
    "mobile_announcement_recipients_unopened": "Non aperti",
    "mobile_recipients_unopened_empty_message": "Ottime notizie. Non ci sono messaggi non aperti.",
    "mobile_scheduled_announcements_delivery_section_header": "Ora di recapito",
    "mobile_scheduled_announcements_send_immediately_label": "Invia subito",
    "mobile_scheduled_announcements_scheduled_label": "Invia a un'ora specifica",
    "mobile_scheduled_announcements_scheduled_tab_label": "Pianificato",
    "mobile_scheduled_announcements_dialog_header": "Annullare l'annuncio?",
    "mobile_scheduled_announcements_dialog_message": "Se annulli, l'annuncio non verrà inviato e sarà eliminato dall'elenco. L'operazione non può essere annullata. Per modificare vai su Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Non hai annunci pianificati. Pianifica un annuncio per trasmettere notizie, informazioni e aggiornamenti importanti alla tua azienda.",
    "mobile_scheduled_announcements_validation_error": "Il recapito deve avvenire dopo il giorno {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Pianifica annuncio",
    "mobile_projects_auto_archive": "Archiviazione automatica",
    "mobile_common_unassigned": "Non assegnato",
    "mobile_tasks_title_placeholder": "Nuova attività o nuovo modulo",
    "mobile_projects_leaving_project": "Abbandono progetto",
    "mobile_projects_save_project": "Salva progetto",
    "mobile_top_triggers_tasks": "Principali attività archiviate",
    "mobile_top_triggers_alerts": "Principali avvisi attivati",
    "mobile_projects_not_started": "Non iniziato",
    "mobile_empty_list_message_no_photos": "Nessuna foto",
    "mobile_webfilestore_message_error": "Seleziona un tipo di file valido",
    "mobile_notifications_empty_title": "Nessuna notifica",
    "mobile_notifications_empty_message": "Le azioni eseguite per le tue attività o per quelle a cui sei assegnato verranno mostrate qui.",
    "mobile_comments_comment_deleted": "Questo commento è stato aggiunto.",
    "mobile_comments_comment_placeholder": "Commento",
    "mobile_comments_task_submitted_at": "Attività inviata il giorno {{ date }} alle ore {{ time }}",
    "mobile_comments_discard_comment_title": "Ignorare il commento?",
    "mobile_comments_discard_confirm_message": "Continuare? Il commento verrà eliminato.",
    "mobile_comments_delete_comment_title": "Eliminare il commento?",
    "mobile_comments_delete_confirm_message": "L'operazione non può essere annullata.",
    "mobile_comments_delete_button": "Elimina commento",
    "mobile_comments_delete_success_message": "Commento eliminato",
    "mobile_comments_empty_message_tasks": "Nessun commento \n Inizia una conversazione su questa attività.",
    "mobile_comments_empty_message_submissions": "Nessun commento \n Inizia una conversazione su questo invio.",
    "mobile_comments_empty_message_default": "Nessun commento \n Inizia una conversazione.",
    "mobile_comments_no_matching_users": "Nessun utente corrispondente.",
    "mobile_comments_empty_users_to_notify": "Nessun utente da informare.",
    "mobile_comments_users_cant_view_message": "Questi utenti non possono vedere i commenti",
    "mobile_comments_users_to_notify_title": "Utenti da informare",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utente</a> riceverà la notifica.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utenti</a> riceveranno la notifica.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@menziona</a> altri utenti per informarli.",
    "mobile_comments_mark_read": "Segna tutti come letti",
    "mobile_comments_author_mentioned_message": "ti ha menzionato in",
    "mobile_comments_author_commented_message": "ha commentato",
    "mobile_view_pdf": "Mostra PDF",
    "mobile_no_pdf_generated_message": "Nessun PDF trovato per questo invio. Riceverai a breve una copia via email.",
    "mobile_clipboard_copied_success": "Link copiato negli appunti.",
    "mobile_share_link": "Condividi link",
    "mobile_zencam_share": "Condividi",
    "mobile_zencam_view_details": "Mostra dettagli",
    "mobile_zencam_details_drawer_header": "Dettagli",
    "mobile_zencam_submitted_by": "Inviato da",
    "mobile_zencam_form_title": "Titolo modulo",
    "mobile_zencam_date_submitted": "Data di invio",
    "mobile_oil_quality_warning_message": "Olio vicino alla scadenza",
    "mobile_oil_quality_warning_message_subtitle": "Inizia a pianificare il cambio dell'olio",
    "mobile_oil_quality_failure_message": "Qualità dell'olio compromessa",
    "mobile_oil_quality_failure_message_subtitle": "Cambia subito l'olio",
    "mobile_sensors_set_up_gateway": "Configura gateway",
    "mobile_sensors_set_up_gateway_message": "Nessun dispositivo configurato. Inizia aggiungendo un gateway.",
    "mobile_sensors_gateway_plugged_in": "Assicurati che il gateway sia collegato a una presa di corrente.",
    "mobile_sensors_add_device": "Aggiungi dispositivo",
    "mobile_sensors_name_this_gateway": "Assegna un nome al gateway.",
    "mobile_sensors_name_this_sensor": "Assegna un nome al sensore.",
    "mobile_sensors_device_barcode_information": "Scansiona il codice QR o inserisci l'ID e il numero SC dall'etichetta del dispositivo",
    "mobile_sensors_device_eui_information": "Scansiona il codice QR o inserisci il DevEUI dall'etichetta del dispositivo",
    "mobile_sensors_gateway_id_information": "Inserisci l'ID nodo dell'etichetta del gateway",
    "mobile_sensors_id_number": "Numero {{untranslatedID}}",
    "mobile_sensors_sc_code": "Codice {{untranslatedSCCode}}",
    "mobile_sensors_sensors": "Sensori",
    "mobile_sensors_sensor_deveui_error": "Non è stato possibile ottenere DevEUI da QR. Inseriscilo manualmente.",
    "mobile_sensors_gateways": "Gateway",
    "mobile_sensors_add_sensor": "Aggiungi sensore",
    "mobile_sensors_add_gateway": "Aggiungi gateway",
    "mobile_sensor_placement_description": "Quale area verrà monitorata da questo sensore?",
    "mobile_sensors_equipment_placement": "Quale area o apparecchiatura verrà monitorata da questo sensore?",
    "mobile_sensors_equipment": "Quale apparecchiatura verrà monitorata da questo sensore?",
    "mobile_sensors_select_gateway_type": "Seleziona il tipo di gateway",
    "mobile_sensors_select_placement": "Seleziona posizionamento",
    "mobile_sensors_select_equipment": "Seleziona apparecchiatura",
    "mobile_sensors_placement": "Posizionamento",
    "mobile_sensors_nickname_tip": "La denominazione del sensore dipende dai nomi alternativi assegnati nel posizionamento selezionato.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Scansione codice QR",
    "mobile_sensors_enter_manually": "Inserisci manualmente",
    "mobile_sensors_wizard_step_one": "Passaggio 1",
    "mobile_sensors_wizard_step_two": "Passaggio 2",
    "mobile_sensors_wizard_step_three": "Passaggio 3",
    "mobile_sensors_wizard_step_four": "Passaggio 4",
    "mobile_sensors_wizard_step_five": "Passaggio 5",
    "mobile_sensors_wizard_step_six": "Passaggio 6",
    "mobile_sensors_initializing": "Inizializzazione...",
    "mobile_sensors_nickname": "Pseudonimo",
    "mobile_sensors_field_not_blank": "Il campo {{field}} non può essere vuoto.",
    "mobile_sensors_nothing_to_see_here": "Nulla da vedere",
    "mobile_sensors_missing_integration": "Integrazione sensore mancante",
    "mobile_sensors_contact_zenput_admin": "Ti preghiamo di contattare l'amministratore responsabile di Ops Execution nella tua azienda.",
    "mobile_sensors_contact_zenput_admin_old": "Contatta il tuo amministratore Zenput.",
    "mobile_sensors_contact_manager": "Contatta il tuo account manager per aggiungere i sensori.",
    "mobile_sensors_device_success_message": "Il caricamento dei dati dei sensori possono richiedere fino a 15 minuti",
    "mobile_sensors_last_reading": "Ultima lettura",
    "mobile_sensors_remove_device": "Rimuovi dispositivo",
    "mobile_sensors_one_day": "1 G",
    "mobile_sensors_one_week": "1 S",
    "mobile_sensors_one_month": "1 M",
    "mobile_sensors_three_months": "3 M",
    "mobile_sensors_six_months": "6 mesi",
    "mobile_sensors_one_year": "1 A",
    "mobile_sensors_sensor_settings": "Impostazioni sensore",
    "mobile_sensors_remove_confirm_message": "Eliminare il dispositivo?\nL'operazione non può essere annullata.",
    "mobile_sensors_sensor": "Sensore",
    "mobile_sensors_no_equipment_linked": "Nessuna attrezzatura collegata",
    "mobile_sensor_cooldown_process": "Procedura di raffreddamento",
    "mobile_sensor_last_12_hours": "Ultime 12 ore",
    "mobile_sensor_start_cooldown_process": "Avvia nuova procedura di raffreddamento",
    "mobile_sensor_cooldown_process_title": "Procedura di raffreddamento in due fasi",
    "mobile_sensor_cooldown_process_description": "Una procedura di raffreddamento in due fasi consiste nel raffreddare il cibo da più di {{ stage1_start_temperature }} a {{ stage1_end_temperature }} in massimo due ore, quindi da {{ stage1_end_temperature }} a {{ stage2_end_temperature }} in massimo quattro ore.",
    "mobile_sensor_cooldown_process_place_food": "Posiziona il prodotto nel frigorifero.",
    "mobile_sensor_cooldown_process_insert_sensor": "Inserisci una sonda del sensore nel prodotto.",
    "mobile_sensor_cooldown_process_enter_information": "Inserisci le informazioni seguenti.",
    "mobile_sensor_cooldown_process_food_product": "Prodotto alimentare da raffreddare",
    "mobile_sensor_cooldown_cool_down": "Raffredda",
    "mobile_sensor_cooldown_select_sensor": "Seleziona sensore",
    "mobile_sensors_cooldown_start_cooldown": "Inizia raffreddamento",
    "mobile_sensors_cooldown_please_enter_food": "Inserisci un prodotto",
    "mobile_sensors_cooldown_please_select_sensor": "Seleziona un sensore",
    "mobile_sensors_cooldown_status_in_progress": "In corso",
    "mobile_sensors_cooldown_status_failed": "Operazione non riuscita",
    "mobile_sensors_cooldown_status_success": "Operazione riuscita",
    "mobile_sensors_cooldown_stage": "Fase",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "La temperatura di inizio è fuori intervallo",
    "mobile_sensors_cooldown_failed_cooldown_process": "Procedura di raffreddamento non riuscita",
    "mobile_sensors_cooldown_cooldown_successful": "Raffreddamento riuscito",
    "mobile_sensors_cooldown_started_cooldown_process": "Procedura di raffreddamento iniziata",
    "mobile_sensors_cooldown_hour": "ora",
    "mobile_sensors_cooldown_hour_plural": "ore",
    "mobile_sensors_cooldown_minute": "minuto",
    "mobile_minutes_plural": "minuti",
    "mobile_sensors_last_reading_max_date": "> 1 anno fa",
    "mobile_sensors_minute_count_ago": "{{count}} minuto fa",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minuti fa",
    "mobile_sensors_hour_count_ago": "{{count}} ora fa",
    "mobile_sensors_hour_count_ago_plural": "{{count}} ore fa",
    "mobile_sensors_day_count_ago": "{{count}} giorno fa",
    "mobile_sensors_day_count_ago_plural": "{{count}} giorni fa",
    "mobile_sensors_chart_settings": "Impostazioni grafico",
    "mobile_announcement_banner_continue_reading": "Continua a leggere",
    "mobile_compliance_submissions_report": "Rapporto invii",
    "mobile_compliance_submissions_report_subtitle": "Esporta dati di completamento progetto per questo negozio",
    "mobile_compliance_send_submissions": "Invia invii",
    "mobile_compliance_completion_rate_in_last_days": "Tasso di completamento negli ultimi {{ days }} giorni",
    "mobile_compliance_last_days": "Ultimi {{ days }} giorni",
    "mobile_compliance_send_submissions_to": "Invia invii a",
    "mobile_compliance_send_to_different_email": "Invia a un altro indirizzo email",
    "mobile_compliance_email_input_placeholder": "Indirizzo email",
    "mobile_compliance_send_submissions_to_legend_title": "Invii",
    "mobile_compliance_send_submissions_to_legend_description_days": "Invia un rapporto con gli invii che hai effettuato da questa posizione negli ultimi {{ days }} giorni.",
    "mobile_compliance_time_frame": "Intervallo di tempo",
    "mobile_compliance_sensor_temperature_log_report": "Rapporto registro temperature sensore",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Esporta registri temperature per questo negozio",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Criteri",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Definisci i criteri per il rapporto di seguito.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Nota: i sensori disattivati non saranno visualizzati nel rapporto",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Seleziona un intervallo di tempo. I dati del registro sono limitati a un massimo di 30 giorni",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Invia rapporto",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Questo mese (1° oggi)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Ultimo mese",
    "mobile_compliance_sensor_temperature_log_email_title": "Invia rapporto a",
    "mobile_pwa_update_prompt_title": "Aggiorna applicazione",
    "mobile_pwa_update_prompt_description": "È disponibile una nuova versione dell'applicazione. Installala.",
    "mobile_pwa_update_prompt_confirm": "Aggiorna e ricarica",
    "mobile_pwa_update_prompt_cancel": "Ricordamelo in seguito",
    "notification_title_due_in_one_hour": "In scadenza tra 1 ora",
    "task_is_due_soon": "'L'attività {{ task_title }}' è in scadenza a breve. Prenditi un momento per completarla.",
    "mobile_photo_quality_warning_header": "Problema di qualità foto",
    "mobile_photo_quality_dialog_message": "La foto è troppo scura o sfuocata. Vuoi scattare di nuovo la foto o continuare con questa?",
    "mobile_take_new_photo": "Scatta un'altra foto",
    "mobile_use_this_photo": "Usa questa foto"
}};
mobile_translations.th_TH = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "ทั้งหมด",
    "mobile_common_button_apply_filters": "ใช้ตัวกรอง",
    "mobile_common_button_done": "เสร็จสิ้น",
    "mobile_common_button_edit": "แก้ไข",
    "mobile_common_button_archive": "จัดเก็บถาวร",
    "mobile_common_button_save": "บันทึก",
    "mobile_common_button_retake": "ถ่ายอีกครั้ง",
    "mobile_common_button_save_draft": "บันทึกฉบับร่าง",
    "mobile_common_button_discard": "ทิ้ง",
    "mobile_common_button_submit": "ส่ง",
    "mobile_common_button_no": "ไม่",
    "mobile_common_button_yes": "ใช่",
    "mobile_common_button_na": "N/A",
    "mobile_common_created_by_me": "สร้างโดยฉัน",
    "mobile_common_email": "อีเมลของบริษัท",
    "mobile_common_first_name": "ชื่อ",
    "mobile_common_last_name": "นามสกุล",
    "mobile_common_location": "ตำแหน่งที่ตั้ง",
    "mobile_common_locations": "ตำแหน่งที่ตั้ง",
    "mobile_common_logout_message": "โปรดยืนยันว่าคุณต้องการออกจากระบบ",
    "mobile_common_password": "รหัสผ่าน",
    "mobile_common_permission_required": "ต้องใช้การอนุญาต",
    "mobile_common_status": "สถานะ",
    "mobile_common_task": "งาน",
    "mobile_common_tasks": "งาน",
    "mobile_common_tasks_my": "งานของฉัน",
    "mobile_common_projects": "โครงการ",
    "mobile_common_filter_team": "ทีม",
    "mobile_common_filter_var_in": " ใน {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "ไม่ได้เลือกทีม",
    "mobile_common_filter_no_user_selected": "ไม่ได้เลือกผู้ใช้",
    "mobile_common_filter_no_role_selected": "ไม่ได้เลือกบทบาท",
    "mobile_common_placeholder_date": "วันที่",
    "mobile_common_message_task_creator_error_save": "<b>สร้างงานไม่ได้</b>",
    "mobile_common_camera": "กล้องถ่ายรูป",
    "mobile_common_microphone": "ไมโครโฟน",
    "mobile_common_for": "สำหรับ",
    "mobile_common_reload": "โหลดอีกครั้ง",
    "mobile_common_override": "แทนที่",
    "mobile_common_notifications": "การแจ้งเตือน",
    "mobile_common_chat_unavailable": "การสนทนาไม่พร้อมใช้งาน โปรดลองอีกครั้งในภายหลัง",
    "mobile_common_chat_ending_dialog_title": "คุณเสร็จสิ้นการสนทนานี้แล้วหรือยัง",
    "mobile_common_chat_ending_dialog_description": "โปรดแจ้งให้เราทราบหากปัญหาของคุณได้รับการแก้ไขแล้วหรือหากคุณต้องการดําเนินการต่อในภายหลัง",
    "mobile_common_chat_ending_dialog_confirm": "ใช่ ฉันสนทนาเสร็จสิ้นแล้ว",
    "mobile_common_chat_ending_dialog_cancel": "ฉันจะดําเนินการต่อในภายหลัง",
    "mobile_common_continue_editing": "ดำเนินการแก้ไขต่อ",
    "mobile_privacy_policy": "นโยบายความเป็นส่วนตัว",
    "wootric_recommend_target": "เพื่อนหรือเพื่อนร่วมงานในอุตสาหกรรมของคุณ",
    "wootric_followup_detractor_question": "เราควรปรับปรุงสิ่งใดบ้างเพื่อที่คุณจะได้ให้คะแนนเราสูงขึ้นในครั้งถัดไป",
    "wootric_followup_passive_question": "ขอบคุณ โปรดแนะนำว่าเราควรทำสิ่งใดเพื่อพัฒนาเครื่องมือให้ดียิ่งๆ ขึ้นไป",
    "wootric_followup_promoter_question": "ขอบคุณครับ! คุณชอบอะไรเกี่ยวกับ Crunchtime Ops Execution บ้าง",
    "wootric_followup_promoter_question_old": "ขอบคุณ โปรดบอกเราหน่อยว่าคุณชอบอะไรเกี่ยวกับ Zenput",
    "wootric_default_followup_question": "ขอบคุณ บอกเราหน่อยได้ไหมว่าทำไม",
    "wootric_default_placeholder_text": "ช่วยเราด้วยการอธิบายถึงคะแนนของคุณ",
    "wootric_default_thankyou_text": "ขอบคุณสำหรับคำตอบและคำติชม",
    "mobile_login_placeholder_login_as": "เข้าสู่ระบบด้วย ID ผู้ใช้",
    "mobile_login_button_forgot_password": "ลืมรหัสผ่านใช่หรือไม่",
    "mobile_login_button_sign_up": "สร้างบัญชี",
    "mobile_login_button_finish_setup": "เสร็จสิ้นการตั้งค่า",
    "mobile_login_button": "เข้าสู่ระบบ",
    "mobile_login_continue_button": "ดำเนินการต่อ",
    "mobile_login_continue_transition": "กำลังนำคุณไปยังหน้าเข้าสู่ระบบขององค์กรของคุณ...",
    "mobile_login_no_email_error": "คุณจะต้องป้อนอีเมล",
    "mobile_login_change_email": "เข้าสู่ระบบด้วยอีเมลอื่น",
    "mobile_login_with_sso": "เข้าสู่ระบบด้วย SSO",
    "mobile_oauth_no_user_error_message": "ดูเหมือนว่าคุณยังไม่มีบัญชี Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "ดูเหมือนว่าคุณยังไม่มีบัญชี Zenput",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> เปลี่ยนชื่อเป็น <b>Crunchtime Ops Execution</b> แล้ว",
    "mobile_rebrand_warning_banner": "{{- brand }} กำลังจะกลายเป็น {{- product }} ในเดือนกันยายนนี้ {{- cta }}",
    "mobile_rebrand_warning_cta": "ดูวิธีเตรียมความพร้อม",
    "mobile_oauth_no_user_error_sub_message": "ติดต่อผู้ดูแลระบบของคุณเพื่อเข้าถึง หรือลองเข้าสู่ระบบอีกครั้งด้วยอีเมลอื่น",
    "mobile_oauth_generic_error_message": "ดูเหมือนจะมีปัญหาในการเข้าสู่ระบบ โปรดลองอีกครั้ง",
    "mobile_oauth_force_logout_msg": "หากคุณยังคงพบปัญหาอยู่ ให้ออกจากระบบของผู้ให้บริการโดย ",
    "mobile_oauth_force_logout_click": "คลิกที่นี่",
    "mobile_sign_up_placeholder_phone": "หมายเลขโทรศัพท์มือถือ",
    "mobile_sign_up_placeholder_password_confirm": "ยืนยันรหัสผ่าน",
    "mobile_sign_up_button_sign_in": "เข้าสู่ระบบ",
    "mobile_sign_up_disclaimer_part_1": "การคลิกสร้างบัญชีหมายความว่าคุณยอมรับ",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "การคลิกเสร็จสิ้นการตั้งค่าหมายความว่าคุณยอมรับ",
    "mobile_sign_up_disclaimer_link_title": " ข้อตกลงการอนุญาตใช้สิทธิ์",
    "mobile_sign_up_disclaimer_part_2": "ซึ่งรวมถึงข้อมูลความเป็นส่วนตัวที่สำคัญ",
    "mobile_dialog_benefits_work_offline": "ทำงานออฟไลน์",
    "mobile_dialog_benefits_faster_uploads": "อัปโหลดรวดเร็วกว่า",
    "mobile_dialog_benefits_better_experience": "ประสบการณ์การใช้งานที่ดีกว่า",
    "mobile_dialog_benefits_button_download": "ดาวน์โหลด",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution สำหรับ ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput สำหรับ ",
    "mobile_dialog_benefits_button_have": "ฉันมีแอปแล้ว",
    "mobile_dialog_benefits_button_no_thanks": "ไม่ ขอบคุณ อาจจะทำในภายหลัง",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "โหลดรูปภาพไม่สำเร็จ",
    "mobile_dialog_signature_sign": "เซ็นชื่อที่นี่",
    "mobile_dialog_signature_button_clear": "ล้าง",
    "mobile_account_placeholder_name": "ตำแหน่งที่ตั้ง/ชื่อร้าน",
    "mobile_account_placeholder_phone": "หมายเลขโทรศัพท์",
    "mobile_account_placeholder_address": "ที่อยู่",
    "mobile_account_placeholder_city": "เมือง",
    "mobile_account_placeholder_region": "ภูมิภาค",
    "mobile_account_placeholder_zipcode": "รหัสไปรษณีย์",
    "mobile_account_option_select_country": "เลือกประเทศ",
    "mobile_account_oprion_us": "สหรัฐอเมริกา",
    "mobile_account_oprion_select_state": "เลือกรัฐ",
    "mobile_account_button_create_location": "สร้างตำแหน่งที่ตั้ง",
    "mobile_form_message_no_form": "ไม่มีแบบฟอร์ม",
    "mobile_batch_task_message": "กำลังโหลด...",
    "mobile_settings_profile": "โปรไฟล์",
    "mobile_settings_profile_number": "หมายเลขโทรศัพท์มือถือ",
    "mobile_settings_profile_language": "ภาษา",
    "mobile_settings_profile_temperature_unit": "หน่วยอุณหภูมิ",
    "mobile_settings_profile_use_company_default": "ใช้ค่าเริ่มต้นของบริษัท",
    "mobile_settings_profile_celsius": "เซลเซียส",
    "mobile_settings_profile_fahrenheit": "ฟาเรนไฮต์",
    "mobile_settings_notifications_option_sms": "ข้อความตัวอักษร",
    "mobile_settings_notifications_option_push": "การแจ้งเตือนแบบพุช",
    "mobile_settings_notifications_option_push_email": "อีเมลและการแจ้งเตือนแบบพุช",
    "mobile_settings_notifications_option_do_not": "ไม่ต้องแจ้งเตือน",
    "mobile_settings_notifications_category_communication": "การสื่อสาร",
    "mobile_settings_notifications_category_forms_and_triggers": "แบบฟอร์มและการเริ่มต้น",
    "mobile_settings_devices": "อุปกรณ์",
    "mobile_settings_notifications_sub_category_alerts": "แจ้งเตือน",
    "mobile_settings_notifications_sub_category_new_forms_available": "แบบฟอร์มใหม่พร้อมใช้งาน",
    "mobile_settings_notifications_sub_category_task_assigned": "มอบหมายงานแล้ว",
    "mobile_settings_notifications_sub_category_task_completed": "ทำงานเสร็จสิ้น",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "การแจ้งเตือนงานที่ครบกำหนดส่งเร็วๆ นี้",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "การแจ้งเตือนงานที่เลยกำหนด",
    "mobile_settings_notifications_sub_category_sensor_alerts": "แจ้งเตือนเซ็นเซอร์",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "แจ้งเตือนเซ็นเซอร์ที่สำคัญ",
    "mobile_drafts_message": "คุณยังไม่มีฉบับร่าง",
    "mobile_drafts_button_delete": "ลบ",
    "mobile_tasks_filter_location_no": "ไม่ได้เลือกตำแหน่งที่ตั้ง",
    "mobile_tasks_filter_group_by": "จัดกลุ่มตาม",
    "mobile_tasks_filter_sort_by": "จัดเรียงตาม",
    "mobile_tasks_filter_sorted_by": "จัดเรียงตาม",
    "mobile_tasks_filter_due_time": "เวลาครบกำหนด",
    "mobile_tasks_filter_open_time": "เวลาเปิด",
    "mobile_tasks_bucket_due_next_24_hours": "ครบกำหนดใน 24 ชั่วโมงข้างหน้า",
    "mobile_tasks_bucket_due_next_7_days": "ครบกำหนดใน 7 วันข้างหน้า",
    "mobile_tasks_bucket_open_tasks": "{{type}}ที่เปิดเพิ่มเติม",
    "mobile_tasks_bucket_open_at": "เปิด: {{- date }} ในเวลา {{- time }}",
    "mobile_tasks_bucket_due_by_at": "ครบกำหนด: {{- date }} ในเวลา {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "พร้อมใช้งานใน 1 นาที",
    "mobile_tasks_bucket_available_in_one_hour": "พร้อมใช้งานใน 1 ชั่วโมง",
    "mobile_tasks_bucket_available_in_one_day": "พร้อมใช้งานใน 1 วัน",
    "mobile_tasks_bucket_available_in_one_week": "พร้อมใช้งานใน 1 สัปดาห์",
    "mobile_tasks_bucket_available_in_one_month": "พร้อมใช้งานใน 1 เดือน",
    "mobile_tasks_bucket_available_in_one_year": "พร้อมใช้งานใน 1 ปี",
    "mobile_tasks_bucket_available_in_minutes": "พร้อมใช้งานใน {{ minutes }} นาที",
    "mobile_tasks_bucket_available_in_hours": "พร้อมใช้งานใน {{ hours }} ชั่วโมง",
    "mobile_tasks_bucket_available_in_days": "พร้อมใช้งานใน {{ days }} วัน",
    "mobile_tasks_bucket_available_in_weeks": "พร้อมใช้งานใน {{ weeks }} สัปดาห์",
    "notification_task_due_in_minutes": "ครบกําหนดใน {{ minutes }} นาที",
    "mobile_tasks_bucket_available_in_months": "พร้อมใช้งานใน {{ months }} เดือน",
    "mobile_tasks_bucket_available_in_years": "พร้อมใช้งานใน {{ years }} ปี",
    "mobile_tasks_follow_up": "ติดตามงาน",
    "mobile_tasks_due_soon": "ครบกําหนดเร็วๆ นี้",
    "mobile_tasks_bucket_completed_today": "เสร็จสิ้นในวันนี้",
    "mobile_tasks_bucket_completed_this_week": "เสร็จสิ้นในสัปดาห์นี้",
    "mobile_tasks_bucket_completed_last_week": "เสร็จสิ้นในสัปดาห์ที่ผ่านมา",
    "mobile_tasks_bucket_missed_today": "ที่พลาดในวันนี้",
    "mobile_tasks_bucket_missed_this_week": "ที่พลาดในสัปดาห์นี้",
    "mobile_tasks_bucket_missed_last_week": "ที่พลาดในสัปดาห์ที่ผ่านมา",
    "mobile_tasks_bucket_no_location": "ไม่มีตำแหน่งที่ตั้ง",
    "mobile_tasks_cannot_submit_missed": "ไม่สามารถทำงานที่พลาดให้เสร็จสิ้นได้",
    "mobile_tasks_cannot_submit_missed_after": "จะดำเนินการงานนี้ให้เสร็จสิ้นหลัง {{ date }} ไม่ได้",
    "mobile_tasks_cannot_submit_upcoming": "งานนี้ยังไม่ได้เริ่ม",
    "mobile_tasks_cannot_submit_processing": "ระบบกำลังดำเนินการกับการส่งนี้",
    "mobile_tasks_toolbarnav_header_no_due_date": "ไม่มีวันที่ครบกำหนด",
    "mobile_tasks_toolbarnav_header_overdue": "เลยกำหนด",
    "mobile_tasks_toolbarnav_header_yesterday": "เมื่อวานนี้",
    "mobile_tasks_toolbarnav_header_today": "วันนี้",
    "mobile_tasks_toolbarnav_header_tomorrow": "พรุ่งนี้",
    "mobile_tasks_toolbarnav_header_last_week": "สัปดาห์ที่ผ่านมา",
    "mobile_tasks_toolbarnav_header_this_week": "สัปดาห์นี้",
    "mobile_tasks_toolbarnav_header_next_week": "สัปดาห์หน้า",
    "mobile_tasks_toolbarnav_header_this_month": "เดือนนี้",
    "mobile_tasks_toolbarnav_header_next_year": "ปีหน้า",
    "mobile_tasks_toolbarnav_header_over_year": "มากกว่าหนึ่งปี",
    "mobile_tasks_toolbarnav_title_edit_task": "แก้ไขงาน",
    "mobile_task_placeholder_title": "ชื่อ*",
    "mobile_task_placeholder_description": "คำอธิบาย (จะระบุหรือไม่ก็ได้)",
    "mobile_task_button_single_task": "งานเดียว",
    "mobile_task_button_project": "โครงการ",
    "mobile_task_button_create": "สร้าง",
    "mobile_task_tab_basic": "พื้นฐาน",
    "mobile_task_tab_photo": "รูปภาพ",
    "mobile_task_tab_form": "แบบฟอร์ม",
    "mobile_task_details_description_message_please": "โปรดกรอกข้อมูล ",
    "mobile_task_details_description_message_below": "ด้านล่าง",
    "mobile_task_details_description_message_instructions": "ไม่มีคำแนะนำสำหรับงานนี้",
    "mobile_task_details_reason_title": "เริ่มต้นการติดตามโดย",
    "mobile_task_detials_button_goto_form": "ไปที่แบบฟอร์ม",
    "mobile_task_detials_button_complete": " ทำงานให้เสร็จสิ้น",
    "mobile_task_detials_completed": "เสร็จสิ้น ",
    "mobile_task_detials_completed_by": "โดย ",
    "mobile_task_detials_completed_on": "ในวันที่ ",
    "mobile_task_details_view_form_submission": "ดูการส่งแบบฟอร์ม",
    "mobile_task_task_updated": "อัปเดตงานแล้ว",
    "mobile_task_task_archived": "จัดเก็บงานถาวรแล้ว",
    "mobile_task_task_deleted": "ลบงานแล้ว",
    "mobile_task_error_archiving_task": "จัดเก็บงานถาวรไม่ได้",
    "mobile_task_error_deleting_task": "ลบงานไม่ได้",
    "mobile_task_error_updating_task": "อัปเดตงานไม่ได้",
    "mobile_task_archive_task": "จัดเก็บงานถาวร",
    "mobile_task_archive_task_confirm": "โปรดยืนยันว่าคุณต้องการจัดเก็บงานนี้ถาวร\n\nงานที่จัดเก็บถาวรจะนับเป็นอัตราการทำเสร็จและจะรวมอยู่ในการรายงานต่อไป\n\nการดำเนินการนี้ไม่สามารถยกเลิกได้",
    "mobile_task_delete_task_confirm": "โปรดยืนยันว่าคุณต้องการลบงานนี้\n\nงานที่ลบจะไม่นับเป็นอัตราการทำเสร็จและจะไม่รวมอยู่ในการรายงานใดๆ\n\nการดำเนินการนี้ไม่สามารถยกเลิกได้",
    "mobile_task_edition_already_in_progress": "งานนี้มีการแก้ไขที่รอดำเนินการ ขณะนี้ยังไม่อนุญาตให้แก้ไขเพิ่มเติม",
    "mobile_projects_filter_type": "ประเภท",
    "mobile_projects_filter_status": "สถานะโครงการ",
    "mobile_projects_filter_project_type": "ประเภทโครงการ",
    "mobile_projects_due_date_required": "ต้องระบุวันที่ครบกำหนด",
    "mobile_projects_team_required": "ต้องระบุทีม",
    "mobile_projects_user_role_required": "ต้องระบุผู้รับมอบหมาย",
    "mobile_projects_title_required": "ต้องระบุชื่อ",
    "mobile_projects_recurring_multiple_tasks_per_day": "หลายงานต่อวัน",
    "mobile_project_tasks_complete": " เสร็จสิ้น",
    "mobile_project_tasks_remaining": " คงเหลือ",
    "mobile_esitmate_message_tasks": "ระบบจะสร้างงาน 0 รายการ",
    "mobile_esitmate_message_criteria": "ปรับเกณฑ์ด้านบน",
    "mobile_esitmate_message_created_for": "จะสร้างสำหรับ",
    "mobile_left_menu_dashboard": "แดชบอร์ด",
    "mobile_left_menu_my_forms": "แบบฟอร์มของฉัน",
    "mobile_left_menu_announcements": "การประกาศ",
    "mobile_left_menu_my_submissions": "การส่งของฉัน",
    "mobile_left_menu_drafts": "ฉบับร่าง",
    "mobile_left_menu_pending_uploads": "การอัปโหลดที่รอดำเนินการ",
    "mobile_left_menu_open": "เปิดในแอป",
    "mobile_left_menu_settings": "การตั้งค่า",
    "mobile_left_menu_log_out": "ออกจากระบบ",
    "mobile_left_menu_debug": "แก้ไขข้อบกพร่อง",
    "mobile_left_menu_support": "สนับสนุน",
    "mobile_left_menu_documentation": "เอกสาร",
    "mobile_left_menu_chat": "สนทนา",
    "mobile_field_textarea_placeholder_note": "หมายเหตุหรือคำอธิบาย",
    "mobile_field_option_select": "เลือก",
    "mobile_field_text_placeholder_text": "ข้อความ",
    "mobile_field_email_placehoder_email": "อีเมล",
    "mobile_filed_number_placeholder_number": "หมายเลข",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "ไม่ได้เชื่อมต่อ",
    "mobile_field_sensor_offline_battery": "เซ็นเซอร์ออฟไลน์ - แบตเตอรี่",
    "mobile_field_video_button_add": "เพิ่มวิดีโอ",
    "mobile_field_video_picker_dialog_title": "เพิ่มวิดีโอจาก",
    "mobile_field_video_button_change": "เปลี่ยนวิดีโอ",
    "mobile_field_image_button_add": "เพิ่มรูปภาพ",
    "mobile_field_image_low_quality_warning": "รูปภาพบางรูปอาจมืดเกินไปหรือเบลอ โปรดตรวจสอบรูปภาพที่ไฮไลต์ และเปลี่ยนรูปใหม่หากจำเป็น",
    "mobile_field_image_picker_dialog_title": "เพิ่มรูปภาพจาก",
    "mobile_field_image_picker_edit_failed": "เราไม่สามารถบันทึกภาพได้ โปรดลองอีกครั้ง",
    "mobile_field_signature_button_add": "เพิ่มลายเซ็น",
    "mobile_field_signature_button_change": "เปลี่ยนลายเซ็น",
    "mobile_field_account_select_location": "เลือกตำแหน่งที่ตั้ง",
    "mobile_field_account_prefill": "ต้องการกรอกแบบฟอร์มล่วงหน้าโดยใช้ข้อมูลจากการเข้าชมครั้งล่าสุดหรือไม่",
    "mobile_field_account_message_overwrite": "ข้อมูลนี้จะแทนที่ข้อมูลในช่องต่างๆ ที่คุณได้กรอกไว้แล้ว",
    "mobile_forms_task_on_behalf": "มีงานที่ต้องทำให้เสร็จในตำแหน่งที่ตั้งนี้ซึ่งมอบหมายให้ <b>{{user}}</b> คุณต้องการทำงานนี้ให้เสร็จหรือไม่",
    "mobile_forms_complete_task": "ต้องการทำงานให้เสร็จสิ้นหรือไม่",
    "mobile_field_account_prefill_button_yes": "ใช่ กรอกข้อมูลล่วงหน้า",
    "mobile_field_barcode_placeholder_scan": "สแกนหรือพิมพ์บาร์โค้ด",
    "mobile_field_sensor_qr_code_placeholder_scan": "สแกนหรือพิมพ์รหัส",
    "mobile_field_gateway_id_code_placeholder": "รหัสประเภทโหนด",
    "mobile_field_scan_qr_or_enter_dev_eui": "สแกนคิวอาร์โค้ดหรือป้อน DevEUI",
    "mobile_field_scan_qr_or_enter_id": "สแกนคิวอาร์โค้ดหรือป้อนหมายเลข ID",
    "mobile_field_scan_qr_or_enter_sc": "สแกนคิวอาร์โค้ดหรือป้อนรหัส SC",
    "mobile_field_barcode_select_date": "เลือกวันที่ ",
    "mobile_field_datetime_allow_time": "เวลา",
    "mobile_field_stopwatch_button_caption": "จับเวลา",
    "mobile_field_stopwatch_common_start": "เริ่ม",
    "mobile_field_stopwatch_common_stop": "หยุด",
    "mobile_field_stopwatch_common_reset": "รีเซ็ต",
    "mobile_field_stopwatch_stop_stopwatches": "หยุดจับเวลา",
    "mobile_field_document_title": "เพิ่มเอกสาร",
    "mobile_field_document_message_delete": "โปรดยืนยันว่าคุณต้องการลบเอกสารนี้",
    "mobile_field_document_alret_button_view": "ดู",
    "mobile_field_document_alert_error": "เกิดข้อผิดพลาดในการแนบเอกสารนี้ โปรดลองอีกครั้ง",
    "mobile_field_document_alert_file_size_error": "ไฟล์จะต้องมีขนาดไม่เกิน {{count}} MB",
    "mobile_field_temperature_greater_range": "มากกว่า {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "มากกว่าหรือเท่ากับ {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "น้อยกว่า {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "น้อยกว่าหรือเท่ากับ {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "มากกว่าหรือเท่ากับ ° {{ min_temp_value }} °{{ temp_unit }} และน้อยกว่า {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "มากกว่าหรือเท่ากับ {{ min_temp_value }} °{{ temp_unit }} และน้อยกว่าหรือเท่ากับ {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " และ ",
    "mobile_field_text_limit_error": "ถึงขีดจํากัดอักขระสูงสุด 8000 ตัว",
    "mobile_forms_required_questions_complete": "ต้องทำให้เสร็จ",
    "mobile_forms_required_remaining": "ยังเหลือข้อมูลที่ต้องการอีก {{count}} รายการ",
    "mobile_forms_required_questions_back": "กลับ",
    "mobile_forms_required_questions_next": "ถัดไป",
    "mobile_forms_required_questions_skip": "ข้าม",
    "mobile_forms_leaving_form": "ออกจากแบบฟอร์ม",
    "mobile_message_reordering_confirm": "คุณต้องการบันทึกลำดับคำถามใหม่หรือไม่",
    "mobile_forms_leaving_reordering": "ออกจากการจัดลำดับคำถามใหม่",
    "mobile_forms_reordering_button_save": "บันทึกลำดับคำถามใหม่",
    "mobile_forms_reordering_instructions": "ในการจัดลำดับคำถามหรือหัวข้อใหม่ ให้ลากแล้ววางในส่วนที่ฟิลด์นั้นๆ ควรปรากฏในแบบฟอร์ม",
    "mobile_toolbarnav_title_my_setttings": "การตั้งค่าของฉัน",
    "mobile_toolbarnav_title_profile_settings": "การตั้งค่าโปรไฟล์",
    "mobile_toolbarnav_title_notification": "การตั้งค่าการแจ้งเตือน",
    "mobile_toolbarnav_title_form_history": "ประวัติแบบฟอร์ม",
    "mobile_toolbarnav_title_form_not_available": "ไม่มีแบบฟอร์ม",
    "mobile_toolbarnav_title_add_location": "เพิ่มตำแหน่งที่ตั้ง",
    "mobile_toolbarnav_title_add_task_or_project": "เพิ่มงานหรือโครงการ",
    "mobile_toolbarnav_title_select_location": "เลือกตำแหน่งที่ตั้ง",
    "mobile_toolbarnav_title_select_project": "เลือกโครงการ",
    "mobile_toolbarnav_title_select_tag": "เลือกแท็ก",
    "mobile_toolbarnav_title_select_user": "เลือกผู้ใช้",
    "mobile_toolbarnav_title_select_template": "เลือกเทมเพลต",
    "mobile_toolbarnav_title_select_one": "เลือกหนึ่งรายการ",
    "mobile_toolbarnav_title_select_multiple": "เลือกหนึ่งรายการขึ้นไป",
    "mobile_toolbarnav_title_select_team": "เลือกทีม",
    "mobile_toolbarnav_title_select_team_or_location": "เลือกทีมหรือตำแหน่งที่ตั้ง",
    "mobile_toolbarnav_title_filter_tasks": "กรองงาน",
    "mobile_toolbarnav_title_filter_projects": "กรองโครงการ",
    "mobile_toolbarnav_title_filter_project_tasks": "กรองงานของโครงการ",
    "mobile_placeholder_search_bar": "ค้นหา",
    "mobile_placeholder_user_select_role": "เลือกบทบาทของผู้ใช้",
    "mobile_placeholder_filter_by_team": "กรองตามทีม",
    "mobile_placeholder_assign_to_user_role": "มอบหมายให้บทบาทของผู้ใช้",
    "mobile_placeholder_select": "-- เลือก --",
    "mobile_placeholder_account_location_name": "ชื่อตำแหน่งที่ตั้ง",
    "mobile_placeholder_tag_filter_by": "กรองตามแท็กตำแหน่งที่ตั้ง",
    "mobile_placeholder_user_type": "มอบหมายให้ผู้ใช้",
    "mobile_placeholder_acount_type_loading": "กำลังโหลด... ",
    "mobile_placeholder_therm_no_bluetooth": "อุณหภูมิ",
    "mobile_placeholder_blue_therm_connecting": "กำลังเชื่อมต่อกับอุปกรณ์...",
    "mobile_placeholder_blue_therm_please_wait": "โปรดรอสักครู่...",
    "mobile_placeholder_blue_therm_tap": "แตะเพื่ออ่าน",
    "mobile_placeholder_blue_therm_not_connected": "ไม่ได้เชื่อมต่อ",
    "mobile_placeholder_testo_tap": "กด ▼▲ ที่อยู่ด้านหลัง ⬆ ค้างไว้",
    "mobile_message_error_create_task": "คุณต้องออนไลน์ก่อนจึงจะเพิ่มงานได้",
    "mobile_message_error_fill_out_form": "โปรดกรอกข้อมูลในแบบฟอร์ม",
    "mobile_message_error_fill_require_fields": "กรอกข้อมูลในช่องที่กำหนด",
    "mobile_message_error_stop_stopwatch_before_submit": "หยุดจับเวลาก่อนส่ง",
    "mobile_message_error_stopwatch_field_required": "ต้องระบุข้อมูลในช่องจับเวลา",
    "mobile_message_error_stopwatch_field_running": "ช่องจับเวลากำลังทำงานอยู่",
    "mobile_message_error_invalid_equipment_temperature": "อุณหภูมิของอุปกรณ์ไม่ถูกต้อง",
    "mobile_message_error_invalid_ingredient_temperature": "อุณหภูมิของส่วนผสมไม่ถูกต้อง",
    "mobile_message_error_location_attributes_unavailable": "บางคำถามอาจไม่พร้อมใช้งาน โปรดเชื่อมต่ออินเทอร์เน็ต",
    "mobile_message_alert_running_stopwatches": "คุณมีนาฬิกาจับเวลาที่กำลังทำงานอยู่\n\nต้องการล้างข้อมูลหรือไม่",
    "mobile_message_blue_therm_error": "สูญเสียการเชื่อมต่อกับอุปกรณ์บลูทูธ",
    "mobile_message_blue_therm_no_permission_android_pre_12": "จำเป็นต้องเข้าถึงตำแหน่ง กรุณาเปิดใช้งานในตั้งค่า Android ของคุณ",
    "mobile_message_blue_therm_no_permission_android": "จำเป็นต้องเข้าถึงอุปกรณ์ใกล้เคียง กรุณาเปิดใช้งานในตั้งค่า Android ของคุณ",
    "mobile_message_blue_therm_error_code": "เชื่อมต่อไม่สำเร็จ:",
    "mobile_message_blue_therm_error_bluetooth": "โปรดเปิดใช้งานบลูทูธ",
    "mobile_message_blue_therm_error_device": "ไม่พบอุปกรณ์",
    "mobile_message_blue_therm_error_try_again": "โปรดลองอีกครั้ง",
    "mobile_message_blue_therm_success": "เชื่อมต่อกับอุปกรณ์บลูทูธแล้ว",
    "mobile_message_bluetooth_device_press_button_field": "กดปุ่มบนอุปกรณ์ของคุณเพื่อเชื่อมต่อ",
    "mobile_message_bluetooth_device_press_button_devices_list": "กดปุ่มบนอุปกรณ์ของคุณ<br />หากคุณไม่เห็นข้อมูลแสดงอยู่ที่นี่",
    "mobile_bluetooth_scan": "สแกน",
    "mobile_bluetooth_scanning": "กำลังสแกน",
    "mobile_message_drafts_confirm": "คุณต้องการบันทึกข้อมูลนี้เป็นฉบับร่างหรือไม่",
    "mobile_message_drafts_toast_saved": "บันทึกฉบับร่างแล้ว",
    "mobile_message_drafts_request_update": "คุณต้องการอัปเดตฉบับร่างนี้หรือไม่",
    "mobile_message_drafts_form_confirm": "โปรดยืนยันว่าคุณต้องการลบฉบับร่างนี้",
    "mobile_message_drafts_confirm_delete": "ลบฉบับร่าง",
    "mobile_message_streams_error_switch": "เปลี่ยนการสตรีมบนเว็บไซต์ไม่ได้",
    "mobile_message_settings_success_saved": "บันทึกการตั้งค่าแล้ว",
    "mobile_message_settings_error": "เกิดข้อผิดพลาดที่ไม่รู้จัก โปรดลองอีกครั้งในภายหลัง",
    "mobile_message_profile_settings_error_fields": "โปรดแก้ไขช่องที่ไฮไลต์",
    "mobile_message_media_perimission_denied": "พื้นที่จัดเก็บในอุปกรณ์ ",
    "mobile_message_media_perimission_denied_device": "ของคุณ",
    "mobile_message_image_confirm_remove_image": "โปรดยืนยันว่าคุณต้องการลบรูปภาพนี้",
    "mobile_message_create_account_error_fields": "โปรดกรอกข้อมูลในช่องที่ไฮไลต์",
    "mobile_message_create_account_success_location_created": "สร้างตำแหน่งที่ตั้งแล้ว",
    "mobile_message_task_error_get_location": "ใช้ตำแหน่งที่ตั้งไม่สำเร็จ จัดเรียงตามวันที่",
    "mobile_message_typehead_confirm_save_message": "คุณต้องการบันทึกการเลือกเหล่านี้หรือไม่",
    "mobile_message_typehead_confirm_save_title": "บันทึกหรือไม่",
    "mobile_message_task_creator_error_save_select_form": "คุณต้องเลือกแบบฟอร์ม",
    "mobile_message_task_creator_error_save_required_fields": "โปรดกรอกข้อมูลในช่องที่กำหนด",
    "mobile_message_task_creator_error_save_batch_change": "โปรดเปลี่ยนเกณฑ์เพื่อให้ตรงกับผู้ใช้อย่างน้อยหนึ่งคน",
    "mobile_message_task_detials_error_not_assigned_to_you": "งานนี้ไม่ได้ถูกมอบหมายให้คุณ<br />คุณไม่สามารถทำงานนี้ได้",
    "mobile_message_task_detials_error_assigned_to": "งานนี้ถูกมอบหมายให้กับ{{user}}<br />คุณไม่สามารถทำงานนี้ได้",
    "mobile_message_task_detials_confirm_title": "ออกจากงานนี้",
    "mobile_message_task_detials_confirm_save_task": "บันทึกงาน",
    "mobile_message_task_detials_confirm_message": "คุณจะสูญเสียการเปลี่ยนแปลงที่คุณได้ทำไว้ โปรดยืนยัน",
    "mobile_message_task_detials_error_view_account": "เข้าสู่ตำแหน่งที่ตั้งไม่ได้",
    "mobile_message_task_detials_error_submit_task": "โปรดเพิ่มรูปภาพเพื่อดำเนินงานนี้ให้เสร็จสิ้น",
    "mobile_message_task_detials_error_submit_task_project": "บันทึกโครงการไม่ได้ โปรดลองอีกครั้งในภายหลัง",
    "mobile_message_task_detials_wait_submit_task_created": "ระบบกำลังสร้างงาน<br />โปรดรอสักครู่เพื่อให้ระบบสร้างงาน",
    "mobile_message_task_detials_error_submit_task_pending": "มีข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง",
    "mobile_message_task_detials_success_task_complete": "ทำงานเสร็จสิ้น",
    "mobile_message_task_error_save_single_task": "บันทึกงานไม่ได้ โปรดลองอีกครั้งในภายหลัง",
    "mobile_message_task_success_save_single_task": "สร้างงานแล้ว",
    "mobile_message_show_error_message": "เกิดข้อผิดพลาดบางอย่าง",
    "mobile_message_show_success_message": "สำเร็จ",
    "mobile_message_show_offline_message": "ขณะนี้คุณออฟไลน์อยู่",
    "mobile_message_show_permission_denied_message": "<b>ต้องใช้การอนุญาต </b> โปรดให้สิทธิ์การเข้าถึงแก่ Zenput{{permission_name}}",
    "mobile_message_show_permission_denied_message_web": "<b>ต้องใช้การอนุญาต</b> โปรดให้สิทธิ์การเข้าถึงแก่ Zenput และเบราเซอร์ของคุณ{{permission_name}}",
    "mobile_message_show_begin_uploading_message": "กำลังอัปโหลดในขณะนี้",
    "mobile_message_show_upload_in_progress_message": "อยู่ระหว่างการอัปโหลด",
    "mobile_message_show_form_id_error": "เข้าสู่แบบฟอร์มที่ระบุไม่ได้",
    "mobile_message_show_single_task_error": "เข้าสู่งานที่ระบุไม่ได้",
    "mobile_message_show_submissions_error": "เข้าสู่การส่งที่ระบุไม่ได้",
    "mobile_message_show_submissions_access_denied": "ขออภัย คุณไม่มีสิทธิ์เข้าถึงแบบฟอร์มนี้",
    "mobile_message_send_data_success": "ข้อมูลถูกอัปโหลดแล้ว ",
    "mobile_message_start_upload_success": "อัปโหลดเสร็จสิ้น",
    "mobile_message_start_upload_error": "<b>อัปโหลดให้เสร็จสิ้นไม่ได้</b><br>บันทึกการส่งแล้ว โปรดลองอีกครั้งในภายหลัง",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "พร้อมให้อัปเดต",
    "mobile_message_store_upgrade_confirm_message_one": "กรุณาอัปเดตแอป Ops Execution จาก ",
    "mobile_message_store_upgrade_confirm_message_one_old": "โปรดอัปเดต Zenput จาก ",
    "mobile_message_store_upgrade_confirm_message_two": " เพื่อรับฟีเจอร์ใหม่ล่าสุดและการแก้ไขข้อบกพร่อง",
    "mobile_message_store_upgrade_confirm_now": "ทำตอนนี้",
    "mobile_message_store_upgrade_confirm_later": "ทำภายหลัง",
    "mobile_message_redirect_confirm_message": "ขณะนี้คุณกำลังกรอกแบบฟอร์ม คุณต้องการบันทึกแบบฟอร์มนี้เป็นฉบับร่างก่อนดำเนินการต่อหรือไม่",
    "mobile_message_log_out_confirm_unsynced_drafts": "คุณมีฉบับร่าง {{count}} รายการที่ยังไม่ได้อัปโหลด คุณจะสูญเสียฉบับร่างเหล่านี้หากดำเนินการต่อ โปรดยืนยันว่าต้องการดำเนินการต่อหรือไม่",
    "mobile_message_draft_override_message": "ฉบับร่างนี้ได้รับการบันทึกจากอุปกรณ์อื่นเมื่อ {{date}} ซึ่งการเปลี่ยนแปลงในอุปกรณ์นี้ขัดแย้งกัน คุณสามารถเลือกที่จะแทนที่กับเวอร์ชันปัจจุบัน หรือโหลดอีกครั้งให้เป็นเวอร์ชันล่าสุด และการเปลี่ยนแปลงของคุณจะถูกยกเลิก",
    "mobile_html_submitting": "กำลังส่ง...",
    "mobile_html_offline": "ขณะนี้คุณออฟไลน์อยู่",
    "mobile_html_offline_try_again": "ขณะนี้คุณออฟไลน์อยู่ <br/><br/>โปรดลองอีกครั้งเมื่อคุณได้เชื่อมต่อแล้ว",
    "mobile_html_something_went_wrong": "ขออภัย เกิดข้อผิดพลาดบางอย่าง",
    "mobile_html_something_went_wrong_try_again": "ขออภัย เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง",
    "mobile_html_failed_loading_roles": "โหลดบทบาทไม่สำเร็จ",
    "mobile_alert_please_install_for_native": "กรุณาติดตั้งแอป Ops Execution เพื่อใช้คุณสมบัตินี้ ",
    "mobile_alert_please_install_for_native_old": "โปรดติดตั้งแอป Zenput ดั้งเดิมเพื่อใช้ฟีเจอร์นี้",
    "mobile_tso_filter_all_tasks": "{{type}}ทั้งหมด",
    "mobile_tso_filter_my_tasks": "{{type}}ของฉัน",
    "mobile_tso_filter_due_date": "วันที่ครบกำหนด",
    "mobile_tso_filter_date_completed": "วันที่เสร็จสิ้น",
    "mobile_tso_filter_completed": "เสร็จสิ้น",
    "mobile_tso_filter_completed_late": "เสร็จสมบูรณ์ล่าช้า",
    "mobile_tso_filter_incomplete": "ไม่เสร็จสิ้น",
    "mobile_tso_filter_var_my_tasks": "{{filter_type}}{{type}}ของฉัน",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}}ที่สร้างโดยฉัน",
    "mobile_tso_filter_var_all_tasks": "{{filter_type}}{{type}}ทั้งหมด",
    "mobile_tso_type_follow_up_actions": "การดำเนินการติดตามงาน",
    "mobile_tso_type_all": "งานและการดำเนินการติดตามงาน",
    "mobile_tso_filter_var_at": " ที่ {{location}}",
    "mobile_tso_filter_group_date_due": "จัดลำดับตามวันที่ครบกำหนด",
    "mobile_tso_filter_group_distance": "จัดกลุ่มตามตำแหน่งที่ตั้ง",
    "mobile_tso_filter_start_date": "วันที่เริ่มต้น",
    "mobile_tso_filter_none": "ไม่มี",
    "mobile_pso_filter_all_projects": "โครงการทั้งหมด",
    "mobile_pso_filter_my_projects": "โครงการทั้งหมด",
    "mobile_pso_filter_active": "ที่ใช้งานอยู่",
    "mobile_pso_filter_archived": "ที่จัดเก็บถาวร",
    "mobile_pso_filter_recurring": "ที่เกิดซ้ำ",
    "mobile_pso_filter_non_recurring": "ที่ไม่เกิดซ้ำ",
    "mobile_pso_filter_var_my_projects": "โครงการของฉัน {{project_type}} {{active_description}} โครงการ",
    "mobile_pso_filter_var_my_created_projects": "โครงการที่ฉันสร้าง {{project_type}} {{active_description}} โครงการ",
    "mobile_pso_filter_var_all_projects": "โครงการ {{project_type}} {{active_description}} ทั้งหมด",
    "mobile_empty_list_message_must_be_online": "ดูเหมือนว่าคุณกำลังออฟไลน์อยู่ โปรดออนไลน์เพื่อดูผลลัพธ์",
    "mobile_empty_list_message_no_submissions": "ไม่มีการส่ง",
    "mobile_empty_list_message_no_activity": "ไม่มีกิจกรรม",
    "mobile_empty_list_message_no_tasks": "ไม่มีงาน",
    "mobile_empty_list_message_no_tasks_overdue": "ไม่มี{{type}}ที่เลยกำหนด",
    "mobile_empty_list_message_no_accounts": "ไม่มีตำแหน่งที่ตั้ง",
    "mobile_empty_list_message_no_projects": "ไม่มีโครงการ",
    "mobile_empty_list_message_no_results_found": "ไม่พบผลลัพธ์",
    "mobile_empty_list_message_no_forms_available": "ไม่มีแบบฟอร์ม",
    "mobile_empty_list_message_connection_error": "เกิดข้อผิดพลาดในการเชื่อมต่อ<br />โปรดลองอีกครั้ง",
    "mobile_empty_list_message_dashboard_error": "โหลดแดชบอร์ดไม่ได้",
    "mobile_empty_list_message_user_offline": "ขณะนี้คุณออฟไลน์อยู่",
    "mobile_action_sheet_media_gallery": "คลังภาพ",
    "mobile_action_sheet_cancel": "ยกเลิก",
    "mobile_image_preview_text": "นำรูปภาพออก",
    "mobile_mobileform_text": "การส่งก่อนหน้านี้",
    "mobile_mobileform_reorder_fields": "จัดลำดับคำถามใหม่",
    "mobile_mobileform_follow_up_actions": "การดําเนินการเพื่อติดตามผล",
    "mobile_mobileform_follow_up_actions_assign_title": "มอบหมายการดำเนินการติดตามงาน",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "เพิ่มการดำเนินการติดตามงานโดยอิงจากการสังเกตการณ์ของคุณ เพื่อให้มั่นใจว่าปัญหาได้รับการแก้ไขเรียบร้อยแล้ว",
    "mobile_mobileform_follow_up_actions_add_button": "+ มอบหมายการดำเนินการติดตามงาน",
    "mobile_mobileform_follow_up_actions_assign_button": "มอบหมายการติดตามงาน",
    "mobile_mobileform_follow_up_actions_without_assign_button": "ดำเนินการต่อโดยไม่มอบหมาย",
    "mobile_mobileform_follow_up_actions_dialog_title": "ดำเนินการต่อโดยไม่มอบหมายการดำเนินการติดตามงานใช่ไหม",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "หากคุณดำเนินการต่อโดยไม่มอบหมายการดำเนินการติดตามงาน คุณจะไม่สามารถเพิ่มการดำเนินการเหล่านั้นในภายหลังได้",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "ดำเนินการต่อเลย",
    "mobile_mobileform_add_follow_up_actions_forms_required": "ต้องระบุข้อมูลในช่องนี้",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "มีตัวอักษรหลายจำนวนมากเกินไป",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "ช่องนี้ไม่ถูกต้อง",
    "mobile_mobileform_add_follow_up_actions_error_locations": "เกิดข้อผิดพลาดในการโหลดตำแหน่งที่ตั้ง",
    "mobile_mobileform_add_follow_up_actions_error_users": "เกิดข้อผิดพลาดในการโหลดผู้ใช้",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "เพิ่มการติดตามงาน",
    "mobile_mobileform_add_follow_up_actions_forms_title": "ชื่อ",
    "mobile_mobileform_add_follow_up_actions_forms_description": "คำอธิบาย",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "ต้องใส่รูปภาพ",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "วันที่ครบกำหนด",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "อัปเดตการติดตามงาน",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "ลบการติดตามงานใช่ไหม",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "ระบบจะนำออกและจะไม่มีการมอบหมาย",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "ลบการติดตามงาน",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "คุณแน่ใจหรือไม่ว่าต้องการลบการติดตามงานนี้\n\nการดำเนินการนี้ไม่สามารถยกเลิกได้",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "ดำเนินการติดตามงานต่อ",
    "mobile_mobileform_follow_up_actions_completed_notification": "การดำเนินการติดตามงานเสร็จสิ้นแล้ว",
    "mobile_mobileform_follow_up_actions_deleted_notification": "ลบการดำเนินการติดตามงานแล้ว",
    "mobile_mobileform_follow_up_actions_update_notification": "อัปเดตการดำเนินการติดตามงานแล้ว",
    "mobile_mobileform_follow_up_actions_required_photo_error": "โปรดเพิ่มรูปภาพเพื่อทำการดำเนินการติดตามงานนี้ให้เสร็จสิ้น",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "ไปยังข้อมูลที่ส่ง",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "ไปที่แหล่งที่มา",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "แหล่งที่มา",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "ทำการติดตามงานให้เสร็จสิ้น",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "หากคุณเปิดข้อมูลที่ส่งมา รูปภาพและโน้ตที่ยังไม่ได้บันทึกจะสูญหาย",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "หากคุณออกจากหน้าจอนี้ รูปภาพและบันทึกที่ยังไม่ได้บันทึกจะสูญหายไป",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "อยู่ในส่วนนี้ต่อ",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "เปิดข้อมูลที่ส่ง",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "โอเพนซอร์ส",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "ออกจากการดำเนินการติดตามงานนี้ไหม",
    "mobile_mobileform_follow_up_actions_submission": "ข้อมูลที่ส่ง",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "การดำเนินการติดตามงานนี้ได้รับการมอบหมายให้กับ{{user}}<br />คุณไม่สามารถทำงานนี้ได้",
    "mobile_mobileform_follow_up_actions_leave_description": "หากคุณออกจากหน้าจอนี้ การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะสูญหาย",
    "mobile_mobileform_follow_up_actions_leave": "ออก",
    "mobile_forms_drafts_text": "นำฉบับร่างออก",
    "mobile_batch_estimate_user": "ผู้ใช้",
    "mobile_batch_estimate_users": "ผู้ใช้",
    "mobile_table_of_contents": "สารบัญ",
    "mobile_table_of_contents_required": "ที่กำหนด",
    "mobile_table_of_contents_optional": "ระบุหรือไม่ก็ได้",
    "mobile_dialog_alert_title": "แจ้งเตือน",
    "mobile_dialog_alert_ok": "ตกลง",
    "mobile_windows_10_bluetherm_not_supported": "ยังไม่รองรับอุปกรณ์บลูทูธใน Windows",
    "mobile_windows_deprecated_message_content_announcement": "ประกาศ",
    "mobile_windows_deprecated_message_title": "จำเป็นต้องอัปเดตแอป",
    "mobile_windows_deprecated_message_description": "โปรดติดตั้งแอป Zenput เวอร์ชันล่าสุดบน Microsoft Store โดยเร็วที่สุดเพื่อให้แน่ใจว่าการทำงานที่สำคัญได้รับการปรับปรุงเพื่อประสบการณ์ในการใช้งาน Zenput ที่ดีที่สุด",
    "mobile_dashboard_tcr_graph_name": "อัตราการทำงานเสร็จ",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 สัปดาห์ที่ผ่านมา",
    "mobile_dashboard_tcr_legend_company_average": "ค่าเฉลี่ยของบริษัท",
    "mobile_dashboard_tcr_legend_team_average": "ค่าเฉลี่ยของทีม",
    "mobile_dashboard_tab_title_summary": "สรุป",
    "mobile_dashboard_tab_title_activity": "กิจกรรม",
    "mobile_dashboard_card_title_top_triggered_workflows": "การเริ่มต้นลำดับต้นๆ",
    "mobile_dashboard_tab_title_info": "ข้อมูล",
    "mobile_dashboard_tab_project_audit": "การปฏิบัติตาม",
    "mobile_dashboard_card_task_stats_total": "รวมทั้งหมด",
    "mobile_dashboard_top_item_header_week_of": "สัปดาห์ของ",
    "mobile_dashboard_card_filter_form_template_placeholder": "แบบฟอร์มทั้งหมด",
    "mobile_dashboard_card_title_forms_top_nos": "\"ไม่\" ที่บ่อยครั้ง",
    "mobile_dashboard_zenput_code_no_data_in_range": "ไม่มีข้อมูลในช่วงเวลานี้",
    "mobile_dashboard_zenput_code_permission_denied": "คุณไม่ได้รับอนุญาตให้ดูข้อมูลนี้",
    "mobile_dashboard_zenput_code_no_form_template_selected": "เลือกแบบฟอร์มจากด้านบน",
    "mobile_dashboard_zenput_code_unknown_error": "เราไม่สามารถแสดงข้อมูลได้ในขณะนี้",
    "mobile_dashboard_tap_to_retry": "แตะเพื่อลองอีกครั้ง",
    "mobile_dashboard_reporting_delay_disclaimer": "อาจใช้เวลาถึง 15 นาทีเพื่อให้งานอัปเดต",
    "mobile_dashboard_configuration_down_state_postfix_msg": "ได้รับการกำหนดค่าโดยผู้ดูแลระบบของคุณ",
    "mobile_tasks_tag": "งาน",
    "mobile_workflows_tag": "การเริ่มต้น",
    "mobile_projects_tag": "โครงการที่เกิดซ้ำ",
    "mobile_forms_tag": "แบบฟอร์ม",
    "mobile_dashboard_card_ongoing_projects_title": "โครงการที่อยู่ระหว่างดำเนินการ",
    "mobile_dashboard_card_ongoing_projects_show_more": "แสดงเพิ่มเติม",
    "mobile_dashboard_card_ongoing_projects_show_less": "แสดงน้อยลง",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "ไปที่โครงการ",
    "mobile_dashboard_card_title_recurring_projects": "โครงการที่เกิดซ้ำ",
    "mobile_dashboard_card_filter_daily": "รายวัน",
    "mobile_dashboard_card_filter_weekly": "รายสัปดาห์",
    "mobile_dashboard_card_filter_monthly": "รายเดือน",
    "mobile_task_status_title_open": "เปิด",
    "mobile_task_status_title_upcoming": "ที่กำลังจะมีขึ้น",
    "mobile_task_status_title_complete": "เสร็จสิ้น",
    "mobile_task_status_title_processing": "กำลังดำเนินการกับการส่ง",
    "mobile_task_status_title_complete_with_exceptions": "ทำให้เสร็จพร้อมงานติดตามหรือการแจ้งเตือน",
    "mobile_task_status_title_completed_late_with_exceptions": "เสร็จสมบูรณ์ล่าช้าโดยมีงานหรือการแจ้งเตือนติดตาม",
    "mobile_task_status_title_incomplete_and_closed": "ที่พลาด",
    "mobile_tasks_legend_modal_title": "คำอธิบาย",
    "mobile_tasks_legend_modal_footer_button_title": "ปิด",
    "mobile_common_assigned_to": "มอบหมายให้",
    "mobile_common_created_by": "สร้างโดย",
    "mobile_common_tasks_for": "งานสำหรับ",
    "mobile_common_go_back": "ย้อนกลับ",
    "mobile_oh_no": "เกิดข้อผิดพลาด",
    "mobile_user_not_in_groups": "ขออภัย ดูเหมือนว่าคุณจะไม่ได้รับมอบหมายให้ร่วมกับทีม โปรดติดต่อผู้ดูแลระบบเพื่อขอรับสิทธิ์เข้าถึงแดชบอร์ดของคุณ",
    "mobile_tasks_select_followers": "เลือกผู้ติดตาม",
    "mobile_tasks_assign_tasks": "มอบหมาย {{count}} งาน",
    "mobile_tasks_add_followers": "เพิ่มผู้ติดตาม",
    "mobile_tasks_followers": "ผู้ติดตาม",
    "mobile_tasks_delete_task": "ลบงาน",
    "mobile_tasks_create_task": "สร้างงาน",
    "mobile_tasks_tab_title_comments": "ความคิดเห็น",
    "mobile_tasks_see_more": "ดูเพิ่มเติม",
    "mobile_projects_create_project": "สร้างโครงการ",
    "mobile_common_button_send": "ส่ง",
    "mobile_common_button_schedule": "กำหนดเวลา",
    "mobile_announcements_create": "สร้างประกาศ",
    "mobile_announcements_read_rate": "{{opened_count}} จาก {{recipients_count}} รายการเปิดอยู่",
    "mobile_announcements_empty_message": "คุณยังไม่ได้สร้างประกาศ สร้างประกาศด้านล่างเพื่อเผยแพร่ข่าวสารสำคัญ ข้อมูล และอัปเดตต่างๆ ในองค์กรของคุณ",
    "mobile_announcement_message_placeholder": "เพิ่มข้อความ...",
    "mobile_announcement_title_placeholder": "ชื่อประกาศ",
    "mobile_announcement_leaving_announcement": "กำลังออกจากประกาศ",
    "mobile_announcement_confirm_recipients_team": "คุณต้องการเผยแพร่การประกาศนี้ให้แก่ผู้ใช้ {{count}} คนใน {{teams}} ทีมที่เลือกใช่หรือไม่",
    "mobile_announcement_confirm_recipients_role": "คุณต้องการเผยแพร่การประกาศนี้ให้แก่ผู้ใช้ {{count}} คนใน {{roles}} บทบาทที่เลือกใช่หรือไม่",
    "mobile_announcement_confirm_recipients_user": "คุณต้องการเผยแพร่การประกาศนี้ให้แก่ผู้ใช้ {{count}} คนใช่หรือไม่",
    "mobile_announcement_confirm_scheduled": "ในวันที่ {{timestamp}}",
    "mobile_announcement_sending_announcement": "กำลังส่งประกาศ",
    "mobile_announcement_send_to": "ส่งถึง",
    "mobile_announcement_sent_to": "ส่งถึง",
    "mobile_announcement_send_to_role": "บทบาท",
    "mobile_announcement_attachment_download": "กำลังดาวน์โหลด {{filename}}",
    "mobile_announcement_attachment_validation_error": "เพิ่มเอกสารแนบได้ไม่เกิน {{maxCount}} รายการ",
    "mobile_announcement_details_sent": "ส่งแล้ว",
    "mobile_announcement_details_total_recipients": "ผู้รับทั้งหมด",
    "mobile_announcement_details_cancel": "ยกเลิกประกาศ",
    "mobile_announcement_details_not_editable": "ประกาศสามารถแก้ไขได้เฉพาะในแอปเว็บ Ops Execution เท่านั้น ",
    "mobile_announcement_details_not_editable_old": "สามารถแก้ไขประกาศได้ในเว็บไซต์ของ Zenput เท่านั้น",
    "mobile_announcement_details_open_count": "จำนวนการเปิด",
    "mobile_announcement_details_open_rate": "อัตราการเปิด",
    "mobile_announcement_details_resend": "ส่งอีกครั้งให้ผู้ที่ยังไม่ได้เปิด",
    "mobile_announcement_confirm_resend": "มีผู้ใช้ {{count}} คนยังไม่ได้อ่านประกาศ คุณต้องการส่งการแจ้งเตือนหรือไม่",
    "mobile_announcement_confirm_resend_title": "ต้องการส่งการแจ้งเตือนหรือไม่",
    "mobile_announcement_recipients_opened": "เปิดแล้ว",
    "mobile_recipients_opened_empty_message": "ดูเหมือนว่ายังไม่มีคนเปิดข้อความของคุณ กลับมาดูผลลัพธ์ของคุณในภายหลัง",
    "mobile_announcement_recipients_unopened": "ยังไม่ได้เปิด",
    "mobile_recipients_unopened_empty_message": "ข่าวดี ไม่มีข้อความที่ยังไม่ได้เปิด",
    "mobile_scheduled_announcements_delivery_section_header": "เวลานำส่ง",
    "mobile_scheduled_announcements_send_immediately_label": "ส่งทันที",
    "mobile_scheduled_announcements_scheduled_label": "ส่งในเวลาที่เจาะจง",
    "mobile_scheduled_announcements_scheduled_tab_label": "กำหนดเวลาแล้ว",
    "mobile_scheduled_announcements_dialog_header": "ต้องการยกเลิกประกาศหรือไม่",
    "mobile_scheduled_announcements_dialog_message": "การยกเลิกประกาศจะหยุดไม่ให้ระบบส่งออกไปและลบประกาศดังกล่าวออกจากรายการของคุณ การดำเนินการนี้ไม่สามารถยกเลิกได้ หากต้องการแก้ไข โปรดไปที่เว็บ Zenput",
    "mobile_scheduled_announcements_empty_message": "ขณะนี้คุณยังไม่มีประกาศที่กำหนดเวลา กำหนดเวลาประกาศเพื่อเผยแพร่ข่าวสารสำคัญ ข้อมูล และอัปเดตต่างๆ ในองค์กรของคุณ",
    "mobile_scheduled_announcements_validation_error": "เวลาส่งจะต้องอยู่หลังวันที่ {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "กำหนดเวลาประกาศ",
    "mobile_projects_auto_archive": "จัดเก็บถาวรอัตโนมัติ",
    "mobile_common_unassigned": "ยกเลิกการมอบหมายแล้ว",
    "mobile_tasks_title_placeholder": "งานหรือแบบฟอร์มใหม่",
    "mobile_projects_leaving_project": "กำลังออกจากโครงการ",
    "mobile_projects_save_project": "บันทึกโครงการ",
    "mobile_top_triggers_tasks": "งานที่ถูกเริ่มต้นลำดับต้นๆ",
    "mobile_top_triggers_alerts": "การแจ้งเตือนที่ถูกเริ่มต้นลำดับต้นๆ",
    "mobile_projects_not_started": "ยังไม่ได้เริ่ม",
    "mobile_empty_list_message_no_photos": "ไม่มีรูปภาพ",
    "mobile_webfilestore_message_error": "โปรดเลือกประเภทไฟล์ที่ถูกต้อง",
    "mobile_notifications_empty_title": "ไม่มีการแจ้งเตือน",
    "mobile_notifications_empty_message": "กิจกรรมในงานของคุณหรือเลือกกิจกรรมที่คุณมีส่วนร่วมจะปรากฏที่นี่",
    "mobile_comments_comment_deleted": "ความคิดเห็นนี้ถูกลบแล้ว",
    "mobile_comments_comment_placeholder": "ความคิดเห็น",
    "mobile_comments_task_submitted_at": "งานที่ส่งในวันที่ {{ date }} เวลา {{ time }}",
    "mobile_comments_discard_comment_title": "ต้องการทิ้งความคิดเห็นใช่หรือไม่",
    "mobile_comments_discard_confirm_message": "ความคิดเห็นของคุณจะถูกลบ คุณแน่ใจใช่ไหม",
    "mobile_comments_delete_comment_title": "ต้องการลบความคิดเห็นใช่หรือไม่",
    "mobile_comments_delete_confirm_message": "การดำเนินการนี้ไม่สามารถยกเลิกได้",
    "mobile_comments_delete_button": "ลบความคิดเห็น",
    "mobile_comments_delete_success_message": "ลบความคิดเห็นแล้ว",
    "mobile_comments_empty_message_tasks": "ยังไม่มีความคิดเห็น \n เริ่มการสนทนาในงานนี้",
    "mobile_comments_empty_message_submissions": "ยังไม่มีความคิดเห็น \n เริ่มการสนทนาในการส่งนี้",
    "mobile_comments_empty_message_default": "ยังไม่มีความคิดเห็น \n เริ่มการสนทนา",
    "mobile_comments_no_matching_users": "ไม่มีผู้ใช้ที่ตรงกัน",
    "mobile_comments_empty_users_to_notify": "ไม่มีผู้ใช้ให้แก้ไข",
    "mobile_comments_users_cant_view_message": "ผู้ใช้เหล่านี้ไม่สามารถดูความคิดเห็นเหล่านี้ได้",
    "mobile_comments_users_to_notify_title": "ผู้ใช้ที่จะแจ้งเตือน",
    "mobile_comments_mention_description_notifiers": "ผู้ใช้จำนวน <a href=\"#\" class=\"show_users_to_notify\">{{ count }} คน </a> จะได้รับการแจ้งเตือน",
    "mobile_comments_mention_description_notifiers_plural": "ผู้ใช้จำนวน <a href=\"#\" class=\"show_users_to_notify\">{{ count }} คน </a> จะได้รับการแจ้งเตือน",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> ผู้ใช้เพิ่มเติมเพื่อแจ้งเตือนให้พวกเขาทราบ",
    "mobile_comments_mark_read": "ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว",
    "mobile_comments_author_mentioned_message": "กล่าวถึงคุณใน",
    "mobile_comments_author_commented_message": "แสดงความคิดเห็นใน",
    "mobile_view_pdf": "ดู PDF",
    "mobile_no_pdf_generated_message": "ไม่พบ PDF สำหรับการส่งนี้ เราจะส่งสำเนาให้คุณทางอีเมลในอีกสักครู่",
    "mobile_clipboard_copied_success": "คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว",
    "mobile_share_link": "แชร์ลิงก์",
    "mobile_zencam_share": "แชร์",
    "mobile_zencam_view_details": "ดูรายละเอียด",
    "mobile_zencam_details_drawer_header": "รายละเอียด",
    "mobile_zencam_submitted_by": "ส่งโดย",
    "mobile_zencam_form_title": "ชื่อแบบฟอร์ม",
    "mobile_zencam_date_submitted": "วันที่ส่ง",
    "mobile_oil_quality_warning_message": "น้ำมันใกล้หมดอายุ",
    "mobile_oil_quality_warning_message_subtitle": "ควรทำการเปลี่ยนในเร็วๆ นี้",
    "mobile_oil_quality_failure_message": "น้ำมันมีคุณภาพลดลง",
    "mobile_oil_quality_failure_message_subtitle": "ควรเปลี่ยนน้ำมันทันที",
    "mobile_sensors_set_up_gateway": "ตั้งค่าเกตเวย์",
    "mobile_sensors_set_up_gateway_message": "ดูเหมือนว่ายังไม่ได้ตั้งค่าอุปกรณ์ เริ่มต้นใช้งานด้วยการเพิ่มเกตเวย์",
    "mobile_sensors_gateway_plugged_in": "โปรดตรวจสอบว่าคุณได้เสียบเกตเวย์เข้ากับแหล่งจ่ายไฟแล้ว",
    "mobile_sensors_add_device": "เพิ่มอุปกรณ์",
    "mobile_sensors_name_this_gateway": "ตั้งชื่อเกตเวย์นี้",
    "mobile_sensors_name_this_sensor": "ตั้งชื่อเซ็นเซอร์นี้",
    "mobile_sensors_device_barcode_information": "สแกนคิวอาร์โค้ดหรือป้อนหมายเลข ID และ SC จากป้ายอุปกรณ์",
    "mobile_sensors_device_eui_information": "สแกนคิวอาร์โค้ดหรือป้อน DevEUI จากป้ายอุปกรณ์",
    "mobile_sensors_gateway_id_information": "ป้อนรหัสโหนดจากป้ายระบุเกตเวย์",
    "mobile_sensors_id_number": "หมายเลข {{untranslatedID}}",
    "mobile_sensors_sc_code": "รหัส {{untranslatedSCCode}}",
    "mobile_sensors_sensors": "เซ็นเซอร์",
    "mobile_sensors_sensor_deveui_error": "ไม่สามารถรับ DevEUI จาก QR ได้ กรุณาป้อนด้วยตนเอง",
    "mobile_sensors_gateways": "เกตเวย์",
    "mobile_sensors_add_sensor": "เพิ่มเซ็นเซอร์",
    "mobile_sensors_add_gateway": "เพิ่มเกตเวย์",
    "mobile_sensor_placement_description": "โปรดระบุพื้นที่ที่เซ็นเซอร์นี้จะตรวจสอบ",
    "mobile_sensors_equipment_placement": "โปรดระบุพื้นที่หรืออุปกรณ์ที่เซ็นเซอร์นี้จะตรวจสอบ",
    "mobile_sensors_equipment": "โปรดระบุอุปกรณ์ที่เซ็นเซอร์นี้จะตรวจสอบ",
    "mobile_sensors_select_gateway_type": "เลือกประเภทเกตเวย์",
    "mobile_sensors_select_placement": "เลือกตำแหน่ง",
    "mobile_sensors_select_equipment": "เลือกอุปกรณ์",
    "mobile_sensors_placement": "ตำแหน่ง",
    "mobile_sensors_nickname_tip": "การตั้งชื่อเซนเซอร์จะระบุตามชื่อเล่นที่ตั้งไว้ให้กับตำแหน่งที่เลือก",
    "mobile_sensors_device_online": "ออนไลน์",
    "mobile_sensors_device_offline": "ออฟไลน์",
    "mobile_sensors_scan_qrcode": "สแกนคิวอาร์โค้ด",
    "mobile_sensors_enter_manually": "ป้อนด้วยตนเอง",
    "mobile_sensors_wizard_step_one": "ขั้นตอนที่ 1",
    "mobile_sensors_wizard_step_two": "ขั้นตอนที่ 2",
    "mobile_sensors_wizard_step_three": "ขั้นตอนที่ 3",
    "mobile_sensors_wizard_step_four": "ขั้นตอนที่ 4",
    "mobile_sensors_wizard_step_five": "ขั้นตอนที่ 5",
    "mobile_sensors_wizard_step_six": "ขั้นตอนที่ 6",
    "mobile_sensors_initializing": "กำลังเริ่มต้น ...",
    "mobile_sensors_nickname": "ชื่อเล่น",
    "mobile_sensors_field_not_blank": "{{field}} ต้องไม่ว่างเปล่า",
    "mobile_sensors_nothing_to_see_here": "ไม่มีข้อมูลใด",
    "mobile_sensors_missing_integration": "ไม่มีการผสานการทำงานเซ็นเซอร์",
    "mobile_sensors_contact_zenput_admin": "กรุณาติดต่อผู้ดูแลระบบ Ops Execution ของบริษัทคุณ",
    "mobile_sensors_contact_zenput_admin_old": "โปรดติดต่อผู้ดูแลระบบ Zenput ของคุณ",
    "mobile_sensors_contact_manager": "ติดต่อผู้จัดการบัญชีของคุณเพื่อเพิ่มเซ็นเซอร์",
    "mobile_sensors_device_success_message": "อาจใช้เวลาถึง 15 นาทีเพื่อโหลดข้อมูลเซ็นเซอร์",
    "mobile_sensors_last_reading": "ค่าสุดท้าย",
    "mobile_sensors_remove_device": "นำอุปกรณ์ออก",
    "mobile_sensors_one_day": "1 วัน",
    "mobile_sensors_one_week": "1 สัปดาห์",
    "mobile_sensors_one_month": "1 เดือน",
    "mobile_sensors_three_months": "3 เดือน",
    "mobile_sensors_six_months": "6 เดือน",
    "mobile_sensors_one_year": "1 ปี",
    "mobile_sensors_sensor_settings": "การตั้งค่าเซ็นเซอร์",
    "mobile_sensors_remove_confirm_message": "โปรดยืนยันว่าคุณต้องการลบอุปกรณ์นี้\nการดำเนินการนี้ไม่สามารถยกเลิกได้",
    "mobile_sensors_sensor": "เซ็นเซอร์",
    "mobile_sensors_no_equipment_linked": "ไม่ได้เชื่อมต่ออุปกรณ์ใด",
    "mobile_sensor_cooldown_process": "กระบวนการทำให้เย็นลง",
    "mobile_sensor_last_12_hours": "12 ชั่วโมงที่ผ่านมา",
    "mobile_sensor_start_cooldown_process": "เริ่มกระบวนการทำให้เย็นลงใหม่",
    "mobile_sensor_cooldown_process_title": "กระบวนการทำให้เย็นลงแบบ 2 ขั้นตอน",
    "mobile_sensor_cooldown_process_description": "กระบวนการทำให้เย็นลงแบบ 2 ขั้นตอนประกอบด้วยการทำให้อาหารเย็นลงจาก {{ stage1_start_temperature }} เป็น {{ stage1_end_temperature }} ในเวลาไม่เกิน 2 ชั่วโมง จากนั้นจาก {{ stage1_end_temperature }} เป็น {{ stage2_end_temperature }} ในเวลาไม่เกิน 4 ชั่วโมง",
    "mobile_sensor_cooldown_process_place_food": "เก็บผลิตภัณฑ์อาหารในตู้เย็น",
    "mobile_sensor_cooldown_process_insert_sensor": "เสียบหัววัดของเซ็นเซอร์ในผลิตภัณฑ์อาหาร",
    "mobile_sensor_cooldown_process_enter_information": "ป้อนข้อมูลด้านล่าง",
    "mobile_sensor_cooldown_process_food_product": "ผลิตภัณฑ์อาหารที่จะทำให้เย็นลง",
    "mobile_sensor_cooldown_cool_down": "ทำให้เย็นลง",
    "mobile_sensor_cooldown_select_sensor": "เลือกเซ็นเซอร์",
    "mobile_sensors_cooldown_start_cooldown": "เริ่มกระบวนการทำให้เย็นลง",
    "mobile_sensors_cooldown_please_enter_food": "โปรดป้อนผลิตภัณฑ์อาหาร",
    "mobile_sensors_cooldown_please_select_sensor": "โปรดเลือกเซ็นเซอร์",
    "mobile_sensors_cooldown_status_in_progress": "อยู่ระหว่างดำเนินการ",
    "mobile_sensors_cooldown_status_failed": "ไม่สำเร็จ",
    "mobile_sensors_cooldown_status_success": "สำเร็จ",
    "mobile_sensors_cooldown_stage": "ขั้นตอน",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "อุณหภูมิเริ่มต้นอยู่นอกช่วง",
    "mobile_sensors_cooldown_failed_cooldown_process": "กระบวนการทำให้เย็นลงที่ไม่สำเร็จ",
    "mobile_sensors_cooldown_cooldown_successful": "กระบวนการทำให้เย็นลงสำเร็จแล้ว",
    "mobile_sensors_cooldown_started_cooldown_process": "เริ่มกระบวนการทำให้เย็นลงแล้ว",
    "mobile_sensors_cooldown_hour": "ชั่วโมง",
    "mobile_sensors_cooldown_hour_plural": "ชั่วโมง",
    "mobile_sensors_cooldown_minute": "นาที",
    "mobile_minutes_plural": "นาที",
    "mobile_sensors_last_reading_max_date": "> 1 ปีที่ผ่านมา",
    "mobile_sensors_minute_count_ago": "{{count}} นาทีที่ผ่านมา",
    "mobile_sensors_minute_count_ago_plural": "{{count}} นาทีที่ผ่านมา",
    "mobile_sensors_hour_count_ago": "{{count}} ชั่วโมงที่ผ่านมา",
    "mobile_sensors_hour_count_ago_plural": "{{count}} ชั่วโมงที่ผ่านมา",
    "mobile_sensors_day_count_ago": "{{count}} วันที่ผ่านมา",
    "mobile_sensors_day_count_ago_plural": "{{count}} วันที่ผ่านมา",
    "mobile_sensors_chart_settings": "การตั้งค่าแผนภูมิ",
    "mobile_announcement_banner_continue_reading": "อ่านต่อ",
    "mobile_compliance_submissions_report": "รายงานการส่ง",
    "mobile_compliance_submissions_report_subtitle": "ส่งออกข้อมูลโครงการที่เสร็จสิ้นของร้านนี้",
    "mobile_compliance_send_submissions": "ส่งการส่ง",
    "mobile_compliance_completion_rate_in_last_days": "อัตราการทำงานเสร็จใน {{ days }} วันที่ผ่านมา",
    "mobile_compliance_last_days": "{{ days }} วันที่ผ่านมา",
    "mobile_compliance_send_submissions_to": "ส่งการส่งถึง",
    "mobile_compliance_send_to_different_email": "ส่งถึงอีเมลอื่น",
    "mobile_compliance_email_input_placeholder": "ที่อยู่อีเมล",
    "mobile_compliance_send_submissions_to_legend_title": "การส่ง",
    "mobile_compliance_send_submissions_to_legend_description_days": "ระบบจะส่งรายงานที่มีการส่งของคุณจากตำแหน่งที่ตั้งนี้ใน {{ days }} วันที่ผ่านมาไปยังอีเมลที่เลือกไว้",
    "mobile_compliance_time_frame": "กรอบเวลา",
    "mobile_compliance_sensor_temperature_log_report": "รายงานบันทึกอุณหภูมิเซ็นเซอร์",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "ส่งออกบันทึกอุณหภูมิของร้านนี้",
    "mobile_compliance_sensor_temperature_log_criteria_title": "เกณฑ์",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "กำหนดเกณฑ์สำหรับรายงานของคุณด้านล่าง",
    "mobile_compliance_sensor_temperature_log_criteria_note": "หมายเหตุ: เซ็นเซอร์ที่ปิดใช้งานอยู่จะไม่แสดงในรายงาน",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "เลือกกรอบเวลา ข้อมูลบันทึกจำกัดเวลาสูงสุด 30 วัน",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "ส่งรายงาน",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "เดือนนี้ (วันที่ 1 - วันนี้)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "เดือนที่ผ่านมา",
    "mobile_compliance_sensor_temperature_log_email_title": "ส่งรายงานไปยัง",
    "mobile_pwa_update_prompt_title": "อัปเดตแอปพลิเคชัน",
    "mobile_pwa_update_prompt_description": "แอปพลิเคชันเวอร์ชันใหม่พร้อมให้ใช้งานแล้ว โปรดอัปเดตเป็นเวอร์ชันล่าสุด",
    "mobile_pwa_update_prompt_confirm": "อัปเดตและโหลดอีกครั้ง",
    "mobile_pwa_update_prompt_cancel": "โปรดเตือนฉันภายหลัง",
    "notification_title_due_in_one_hour": "ครบกําหนดใน 1 ชั่วโมง",
    "task_is_due_soon": "'{{ task_title }}' จะครบกําหนดในไม่ช้า โปรดใช้เวลาสักครู่เพื่อทําให้เสร็จ",
    "mobile_photo_quality_warning_header": "ปัญหาด้านคุณภาพของรูปภาพ",
    "mobile_photo_quality_dialog_message": "รูปภาพนี้อาจจะมืดหรือเบลอเกินไป คุณต้องการถ่ายรูปใหม่ หรือจะดำเนินการต่อโดยใช้รูปนี้",
    "mobile_take_new_photo": "ถ่ายภาพใหม่",
    "mobile_use_this_photo": "ใช้รูปภาพนี้"
}};
mobile_translations.en_US = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "All",
    "mobile_common_button_apply_filters": "Apply Filters",
    "mobile_common_button_done": "Done",
    "mobile_common_button_edit": "Edit",
    "mobile_common_button_archive": "Archive",
    "mobile_common_button_save": "Save",
    "mobile_common_button_retake": "Retake",
    "mobile_common_button_save_draft": "Save Draft",
    "mobile_common_button_discard": "Discard",
    "mobile_common_button_submit": "Submit",
    "mobile_common_button_no": "No",
    "mobile_common_button_yes": "Yes",
    "mobile_common_button_na": "N/A",
    "mobile_common_created_by_me": "Created by Me",
    "mobile_common_email": "Company Email",
    "mobile_common_first_name": "First Name",
    "mobile_common_last_name": "Last Name",
    "mobile_common_location": "Location",
    "mobile_common_locations": "Locations",
    "mobile_common_logout_message": "Are you sure you want to log out?",
    "mobile_common_password": "Password",
    "mobile_common_permission_required": "Permission Required",
    "mobile_common_status": "Status",
    "mobile_common_task": "Task",
    "mobile_common_tasks": "Tasks",
    "mobile_common_tasks_my": "My Tasks",
    "mobile_common_projects": "Projects",
    "mobile_common_filter_team": "Team",
    "mobile_common_filter_var_in": " in {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "No team selected",
    "mobile_common_filter_no_user_selected": "No user selected",
    "mobile_common_filter_no_role_selected": "No role selected",
    "mobile_common_placeholder_date": "Date",
    "mobile_common_message_task_creator_error_save": "<b>Could not create tasks.</b>",
    "mobile_common_camera": "Camera",
    "mobile_common_microphone": "Microphone",
    "mobile_common_for": "for",
    "mobile_common_reload": "Reload",
    "mobile_common_override": "Override",
    "mobile_common_notifications": "Notifications",
    "mobile_common_chat_unavailable": "Chat Unavailable. Please try again later.",
    "mobile_common_chat_ending_dialog_title": "Are you done with this conversation?",
    "mobile_common_chat_ending_dialog_description": "Let us know if your issue has been resolved or if you just want to continue later.",
    "mobile_common_chat_ending_dialog_confirm": "Yes, I'm done",
    "mobile_common_chat_ending_dialog_cancel": "I'll continue later",
    "mobile_common_continue_editing": "Continue Editing",
    "mobile_privacy_policy": "Privacy Policy",
    "wootric_recommend_target": "a friend or colleague in your industry",
    "wootric_followup_detractor_question": "What changes can we make for you to give us a higher rating next time?",
    "wootric_followup_passive_question": "Thank you!  What could we do to make the tool even better?",
    "wootric_followup_promoter_question": "Thanks! What do you love about Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Thank you! What do you love about Zenput?",
    "wootric_default_followup_question": "Thank you! Care to tell us why?",
    "wootric_default_placeholder_text": "Help us by explaining your score.",
    "wootric_default_thankyou_text": "Thank you for your response, and your feedback!",
    "mobile_login_placeholder_login_as": "Login As User ID",
    "mobile_login_button_forgot_password": "Forgot Password?",
    "mobile_login_button_sign_up": "Create Account",
    "mobile_login_button_finish_setup": "Finish Setup",
    "mobile_login_button": "Login",
    "mobile_login_continue_button": "Continue",
    "mobile_login_continue_transition": "taking you to your organization's login page...",
    "mobile_login_no_email_error": "You must enter an email.",
    "mobile_login_change_email": "Login with different email",
    "mobile_login_with_sso": "Login with SSO",
    "mobile_oauth_no_user_error_message": "Looks like you don't have a Crunchtime Ops Execution account!",
    "mobile_oauth_no_user_error_message_old": "Looks like you don't have a Zenput Account!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> is now <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} is becoming {{- product }} in September. {{- cta }}",
    "mobile_rebrand_warning_cta": "Learn how to prepare.",
    "mobile_oauth_no_user_error_sub_message": "Contact your admin for access or try logging in with a different email.",
    "mobile_oauth_generic_error_message": "Looks like there was an issue logging in, please try again.",
    "mobile_oauth_force_logout_msg": "If you're still having issues, log out of your provider by ",
    "mobile_oauth_force_logout_click": "clicking here.",
    "mobile_sign_up_placeholder_phone": "Cell Number",
    "mobile_sign_up_placeholder_password_confirm": "Confirm Password",
    "mobile_sign_up_button_sign_in": "Sign In",
    "mobile_sign_up_disclaimer_part_1": "By clicking Create Account, you agree to the",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "By clicking Finish Setup, you agree to the",
    "mobile_sign_up_disclaimer_link_title": " License Agreement",
    "mobile_sign_up_disclaimer_part_2": ", which includes important privacy information",
    "mobile_dialog_benefits_work_offline": "Work Offline",
    "mobile_dialog_benefits_faster_uploads": "Faster Uploads",
    "mobile_dialog_benefits_better_experience": "Better Experience",
    "mobile_dialog_benefits_button_download": "Download",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution for ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput for ",
    "mobile_dialog_benefits_button_have": "I have the app!",
    "mobile_dialog_benefits_button_no_thanks": "No thanks, maybe later.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Failed to load image.",
    "mobile_dialog_signature_sign": "Sign Here",
    "mobile_dialog_signature_button_clear": "Clear",
    "mobile_account_placeholder_name": "Location/Store Name",
    "mobile_account_placeholder_phone": "Phone",
    "mobile_account_placeholder_address": "Address",
    "mobile_account_placeholder_city": "City",
    "mobile_account_placeholder_region": "Region",
    "mobile_account_placeholder_zipcode": "Postal Code/Zip",
    "mobile_account_option_select_country": "Select Country",
    "mobile_account_oprion_us": "United States",
    "mobile_account_oprion_select_state": "Select State",
    "mobile_account_button_create_location": "Create Location",
    "mobile_form_message_no_form": "No forms available",
    "mobile_batch_task_message": "Loading ...",
    "mobile_settings_profile": "Profile",
    "mobile_settings_profile_number": "Cell Phone",
    "mobile_settings_profile_language": "Language",
    "mobile_settings_profile_temperature_unit": "Temperature Unit",
    "mobile_settings_profile_use_company_default": "Use company default",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Text Message",
    "mobile_settings_notifications_option_push": "Push Notifications",
    "mobile_settings_notifications_option_push_email": "Email & Push Notifications",
    "mobile_settings_notifications_option_do_not": "Do not notify",
    "mobile_settings_notifications_category_communication": "Communication",
    "mobile_settings_notifications_category_forms_and_triggers": "Forms & Triggers",
    "mobile_settings_devices": "Devices",
    "mobile_settings_notifications_sub_category_alerts": "Alerts",
    "mobile_settings_notifications_sub_category_new_forms_available": "New Forms Available",
    "mobile_settings_notifications_sub_category_task_assigned": "Task Assigned",
    "mobile_settings_notifications_sub_category_task_completed": "Task Completed",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Tasks due soon reminder",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Overdue tasks reminder",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensor Alerts",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Critical Sensor Alerts",
    "mobile_drafts_message": "You don't have any drafts yet.",
    "mobile_drafts_button_delete": "Delete",
    "mobile_tasks_filter_location_no": "No location selected",
    "mobile_tasks_filter_group_by": "Group By",
    "mobile_tasks_filter_sort_by": "Sort By",
    "mobile_tasks_filter_sorted_by": "Sorted By",
    "mobile_tasks_filter_due_time": "Due Time",
    "mobile_tasks_filter_open_time": "Open Time",
    "mobile_tasks_bucket_due_next_24_hours": "Due in the Next 24 Hours",
    "mobile_tasks_bucket_due_next_7_days": "Due in the Next 7 Days",
    "mobile_tasks_bucket_open_tasks": "Additional Open {{type}}",
    "mobile_tasks_bucket_open_at": "Open: {{- date }} at {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Due by: {{- date }} at {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Available in 1 minute",
    "mobile_tasks_bucket_available_in_one_hour": "Available in 1 hour",
    "mobile_tasks_bucket_available_in_one_day": "Available in 1 day",
    "mobile_tasks_bucket_available_in_one_week": "Available in 1 week",
    "mobile_tasks_bucket_available_in_one_month": "Available in 1 month",
    "mobile_tasks_bucket_available_in_one_year": "Available in 1 year",
    "mobile_tasks_bucket_available_in_minutes": "Available in {{ minutes }} minutes",
    "mobile_tasks_bucket_available_in_hours": "Available in {{ hours }} hours",
    "mobile_tasks_bucket_available_in_days": "Available in {{ days }} days",
    "mobile_tasks_bucket_available_in_weeks": "Available in {{ weeks }} weeks",
    "notification_task_due_in_minutes": "Due in {{ minutes }} minutes",
    "mobile_tasks_bucket_available_in_months": "Available in {{ months }} months",
    "mobile_tasks_bucket_available_in_years": "Available in {{ years }} years",
    "mobile_tasks_follow_up": "Follow-Up Task",
    "mobile_tasks_due_soon": "Due soon",
    "mobile_tasks_bucket_completed_today": "Completed Today",
    "mobile_tasks_bucket_completed_this_week": "Completed This Week",
    "mobile_tasks_bucket_completed_last_week": "Completed Last Week",
    "mobile_tasks_bucket_missed_today": "Missed Today",
    "mobile_tasks_bucket_missed_this_week": "Missed This Week",
    "mobile_tasks_bucket_missed_last_week": "Missed Last Week",
    "mobile_tasks_bucket_no_location": "No Location",
    "mobile_tasks_cannot_submit_missed": "Missed tasks cannot be completed",
    "mobile_tasks_cannot_submit_missed_after": "This task cannot be completed after {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "This task has not started.",
    "mobile_tasks_cannot_submit_processing": "This submission is being processed",
    "mobile_tasks_toolbarnav_header_no_due_date": "No Due Date",
    "mobile_tasks_toolbarnav_header_overdue": "Overdue",
    "mobile_tasks_toolbarnav_header_yesterday": "Yesterday",
    "mobile_tasks_toolbarnav_header_today": "Today",
    "mobile_tasks_toolbarnav_header_tomorrow": "Tomorrow",
    "mobile_tasks_toolbarnav_header_last_week": "Last Week",
    "mobile_tasks_toolbarnav_header_this_week": "This Week",
    "mobile_tasks_toolbarnav_header_next_week": "Next Week",
    "mobile_tasks_toolbarnav_header_this_month": "This Month",
    "mobile_tasks_toolbarnav_header_next_year": "Next Year",
    "mobile_tasks_toolbarnav_header_over_year": "Over A Year",
    "mobile_tasks_toolbarnav_title_edit_task": "Edit Task",
    "mobile_task_placeholder_title": "Title *",
    "mobile_task_placeholder_description": "Description (optional)",
    "mobile_task_button_single_task": "Single Task",
    "mobile_task_button_project": "Project",
    "mobile_task_button_create": "Create",
    "mobile_task_tab_basic": "Basic",
    "mobile_task_tab_photo": "Photo",
    "mobile_task_tab_form": "Form",
    "mobile_task_details_description_message_please": "Please fill out ",
    "mobile_task_details_description_message_below": "below.",
    "mobile_task_details_description_message_instructions": "No instructions are available for this task.",
    "mobile_task_details_reason_title": "Follow-Up Triggered by",
    "mobile_task_detials_button_goto_form": "Go To Form",
    "mobile_task_detials_button_complete": " Complete Task",
    "mobile_task_detials_completed": "Completed ",
    "mobile_task_detials_completed_by": "by ",
    "mobile_task_detials_completed_on": "on ",
    "mobile_task_details_view_form_submission": "View Form Submission",
    "mobile_task_task_updated": "Task updated",
    "mobile_task_task_archived": "Task archived",
    "mobile_task_task_deleted": "Task deleted",
    "mobile_task_error_archiving_task": "Could not archive task.",
    "mobile_task_error_deleting_task": "Could not delete task.",
    "mobile_task_error_updating_task": "Could not update task.",
    "mobile_task_archive_task": "Archive Task",
    "mobile_task_archive_task_confirm": "Are you sure you would like to archive this Task?\n\nArchived tasks will count towards completion rates and will continue to be included in reporting.\n\nThis cannot be undone.",
    "mobile_task_delete_task_confirm": "Are you sure you would like to delete this task?\n\nDeleted tasks will not count towards completion rates nor be included in any reporting.\n\nThis cannot be undone.",
    "mobile_task_edition_already_in_progress": "This task has a pending edit. Further editing is not currently allowed.",
    "mobile_projects_filter_type": "Type",
    "mobile_projects_filter_status": "Project status",
    "mobile_projects_filter_project_type": "Project type",
    "mobile_projects_due_date_required": "Due date is required.",
    "mobile_projects_team_required": "Team is required.",
    "mobile_projects_user_role_required": "Assignee is required.",
    "mobile_projects_title_required": "Title is required.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Multiple Tasks per Day",
    "mobile_project_tasks_complete": " Complete",
    "mobile_project_tasks_remaining": " Remaining",
    "mobile_esitmate_message_tasks": "0 tasks will be created",
    "mobile_esitmate_message_criteria": "Adjust Critera Above",
    "mobile_esitmate_message_created_for": "will be created for",
    "mobile_left_menu_dashboard": "Dashboard",
    "mobile_left_menu_my_forms": "My Forms",
    "mobile_left_menu_announcements": "Announcements",
    "mobile_left_menu_my_submissions": "My Submissions",
    "mobile_left_menu_drafts": "Drafts",
    "mobile_left_menu_pending_uploads": "Pending Uploads",
    "mobile_left_menu_open": "Open In App",
    "mobile_left_menu_settings": "Settings",
    "mobile_left_menu_log_out": "Log Out",
    "mobile_left_menu_debug": "Debug",
    "mobile_left_menu_support": "Support",
    "mobile_left_menu_documentation": "Documentation",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Note or caption",
    "mobile_field_option_select": "Select",
    "mobile_field_text_placeholder_text": "Text",
    "mobile_field_email_placehoder_email": "Email",
    "mobile_filed_number_placeholder_number": "Number",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Not Connected",
    "mobile_field_sensor_offline_battery": "Sensor Offline - Battery",
    "mobile_field_video_button_add": "Add a Video",
    "mobile_field_video_picker_dialog_title": "Add video from",
    "mobile_field_video_button_change": "Change Video",
    "mobile_field_image_button_add": "Add Image",
    "mobile_field_image_low_quality_warning": "Some photos may be too dark or blurry. Review the highlighted photos and replace them if needed",
    "mobile_field_image_picker_dialog_title": "Add photo from",
    "mobile_field_image_picker_edit_failed": "We couldn't save the image. Please try again.",
    "mobile_field_signature_button_add": "Add a Signature",
    "mobile_field_signature_button_change": "Change Signature",
    "mobile_field_account_select_location": "Select A Location",
    "mobile_field_account_prefill": "Prefill form with data from the last Visit?",
    "mobile_field_account_message_overwrite": "This will overwrite any fields you have already filled out.",
    "mobile_forms_task_on_behalf": "There is a task to fulfill at this location that is assigned to <b>{{user}}</b>. Would you like to complete this task?",
    "mobile_forms_complete_task": "Complete Task?",
    "mobile_field_account_prefill_button_yes": "Yes, prefill",
    "mobile_field_barcode_placeholder_scan": "Scan or type barcode",
    "mobile_field_sensor_qr_code_placeholder_scan": "Scan or type code",
    "mobile_field_gateway_id_code_placeholder": "Type Node ID",
    "mobile_field_scan_qr_or_enter_dev_eui": "Scan QR Code or Enter DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Scan QR Code or Enter ID Number",
    "mobile_field_scan_qr_or_enter_sc": "Scan QR Code or Enter SC Code",
    "mobile_field_barcode_select_date": "Select Date ",
    "mobile_field_datetime_allow_time": "Time",
    "mobile_field_stopwatch_button_caption": "Stopwatch",
    "mobile_field_stopwatch_common_start": "Start",
    "mobile_field_stopwatch_common_stop": "Stop",
    "mobile_field_stopwatch_common_reset": "Reset",
    "mobile_field_stopwatch_stop_stopwatches": "Stop Stopwatches",
    "mobile_field_document_title": "Add Document",
    "mobile_field_document_message_delete": "Are you sure you want to delete this document?",
    "mobile_field_document_alret_button_view": "View",
    "mobile_field_document_alert_error": "There was an error attaching this document. Please try again.",
    "mobile_field_document_alert_file_size_error": "File cannot exceed {{count}} MB.",
    "mobile_field_temperature_greater_range": "greater than {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "greater than or equal to {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "less than {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "less than or equal to {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "greater than or equal to {{ min_temp_value }} °{{ temp_unit }} and less than {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "greater than or equal to {{ min_temp_value }} °{{ temp_unit }} and less than or equal to {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " and ",
    "mobile_field_text_limit_error": "Maximum character limit of 8000 reached.",
    "mobile_forms_required_questions_complete": "Required Complete",
    "mobile_forms_required_remaining": "{{count}} Required Remaining",
    "mobile_forms_required_questions_back": "Back",
    "mobile_forms_required_questions_next": "Next",
    "mobile_forms_required_questions_skip": "Skip",
    "mobile_forms_leaving_form": "Leaving Form",
    "mobile_message_reordering_confirm": "Do you want to save the new question order?",
    "mobile_forms_leaving_reordering": "Leaving Reordering Questions",
    "mobile_forms_reordering_button_save": "Save New Question Order",
    "mobile_forms_reordering_instructions": "To reorder questions or sections, drag-and-drop to where the field should show up in the form",
    "mobile_toolbarnav_title_my_setttings": "My Settings",
    "mobile_toolbarnav_title_profile_settings": "Profile Settings",
    "mobile_toolbarnav_title_notification": "Notification Settings",
    "mobile_toolbarnav_title_form_history": "Form History",
    "mobile_toolbarnav_title_form_not_available": "Form Not Available",
    "mobile_toolbarnav_title_add_location": "Add Location",
    "mobile_toolbarnav_title_add_task_or_project": "Add Task or Project",
    "mobile_toolbarnav_title_select_location": "Select Location",
    "mobile_toolbarnav_title_select_project": "Select Project",
    "mobile_toolbarnav_title_select_tag": "Select Tag",
    "mobile_toolbarnav_title_select_user": "Select User",
    "mobile_toolbarnav_title_select_template": "Select Template",
    "mobile_toolbarnav_title_select_one": "Select One",
    "mobile_toolbarnav_title_select_multiple": "Select One or More",
    "mobile_toolbarnav_title_select_team": "Select Team",
    "mobile_toolbarnav_title_select_team_or_location": "Select Team or Location",
    "mobile_toolbarnav_title_filter_tasks": "Filter Tasks",
    "mobile_toolbarnav_title_filter_projects": "Filter Projects",
    "mobile_toolbarnav_title_filter_project_tasks": "Filter Project Tasks",
    "mobile_placeholder_search_bar": "Search",
    "mobile_placeholder_user_select_role": "Select User Role",
    "mobile_placeholder_filter_by_team": "Filter by a team",
    "mobile_placeholder_assign_to_user_role": "Assign to User Role",
    "mobile_placeholder_select": "-- Select --",
    "mobile_placeholder_account_location_name": "Location Name",
    "mobile_placeholder_tag_filter_by": "Filter by Location Tag",
    "mobile_placeholder_user_type": "Assign to User",
    "mobile_placeholder_acount_type_loading": "Loading... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperature",
    "mobile_placeholder_blue_therm_connecting": "Connecting to device...",
    "mobile_placeholder_blue_therm_please_wait": "Please wait...",
    "mobile_placeholder_blue_therm_tap": "Tap for reading.",
    "mobile_placeholder_blue_therm_not_connected": "Not connected.",
    "mobile_placeholder_testo_tap": "Hold ▼▲ followed by ⬆",
    "mobile_message_error_create_task": "You must be online to add tasks.",
    "mobile_message_error_fill_out_form": "Please fill out the form.",
    "mobile_message_error_fill_require_fields": "Fill in required fields.",
    "mobile_message_error_stop_stopwatch_before_submit": "Stop your stopwatch before submitting",
    "mobile_message_error_stopwatch_field_required": "Stopwatch field is required",
    "mobile_message_error_stopwatch_field_running": "Stopwatch field is running",
    "mobile_message_error_invalid_equipment_temperature": "Invalid equipment temperature",
    "mobile_message_error_invalid_ingredient_temperature": "Invalid ingredient temperature",
    "mobile_message_error_location_attributes_unavailable": "Some questions may be unavailable, please connect to the internet",
    "mobile_message_alert_running_stopwatches": "You have running stopwatches.\n\nWould you like to clear them?",
    "mobile_message_blue_therm_error": "Lost Connection to Bluetooth Device",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Location access is required. Enable it in your Android settings.",
    "mobile_message_blue_therm_no_permission_android": "Nearby Devices access is required. Enable it in your Android settings.",
    "mobile_message_blue_therm_error_code": "Failed to Connect:",
    "mobile_message_blue_therm_error_bluetooth": "Please enable Bluetooth.",
    "mobile_message_blue_therm_error_device": "Device not found.",
    "mobile_message_blue_therm_error_try_again": "Please Try Again",
    "mobile_message_blue_therm_success": "Bluetooth Device Connected!",
    "mobile_message_bluetooth_device_press_button_field": "Press the button on your device to connect.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Press the button on your device<br />if you do not see it listed here.",
    "mobile_bluetooth_scan": "Scan",
    "mobile_bluetooth_scanning": "Scanning",
    "mobile_message_drafts_confirm": "Would you like to save this as a draft?",
    "mobile_message_drafts_toast_saved": "Draft Saved.",
    "mobile_message_drafts_request_update": "Would you like to update this draft?",
    "mobile_message_drafts_form_confirm": "Are you sure you would like to delete this draft?",
    "mobile_message_drafts_confirm_delete": "Delete Draft",
    "mobile_message_streams_error_switch": "Can't change streams on web",
    "mobile_message_settings_success_saved": "Settings Saved",
    "mobile_message_settings_error": "An unknown error occurred.  Try again later",
    "mobile_message_profile_settings_error_fields": "Please correct the highlighted fields.",
    "mobile_message_media_perimission_denied": "Your ",
    "mobile_message_media_perimission_denied_device": "Device Storage",
    "mobile_message_image_confirm_remove_image": "Are you sure that you want to delete this photo?",
    "mobile_message_create_account_error_fields": "Please fill out the highlighted fields.",
    "mobile_message_create_account_success_location_created": "Location Created",
    "mobile_message_task_error_get_location": "Failed to get location. Ordering by date.",
    "mobile_message_typehead_confirm_save_message": "Do you want to save these selections?",
    "mobile_message_typehead_confirm_save_title": "Save?",
    "mobile_message_task_creator_error_save_select_form": "You must select a form.",
    "mobile_message_task_creator_error_save_required_fields": "Please fill out the required fields.",
    "mobile_message_task_creator_error_save_batch_change": "Please change the criteria to match one or more user",
    "mobile_message_task_detials_error_not_assigned_to_you": "This task is not assigned to you.<br />You cannot complete it.",
    "mobile_message_task_detials_error_assigned_to": "This task is assigned to {{user}}.<br />You cannot complete it.",
    "mobile_message_task_detials_confirm_title": "Leaving Task",
    "mobile_message_task_detials_confirm_save_task": "Save Task",
    "mobile_message_task_detials_confirm_message": "Are you sure? Your changes will be lost.",
    "mobile_message_task_detials_error_view_account": "Unable to Access Location.",
    "mobile_message_task_detials_error_submit_task": "Please add a photo to complete this task.",
    "mobile_message_task_detials_error_submit_task_project": "Unable to save project. Please try again later.",
    "mobile_message_task_detials_wait_submit_task_created": "Tasks are being created.<br />Please wait a few minutes for tasks to be populated.",
    "mobile_message_task_detials_error_submit_task_pending": "Error, please try again later",
    "mobile_message_task_detials_success_task_complete": "Task Complete",
    "mobile_message_task_error_save_single_task": "Unable to save task. Please try again later.",
    "mobile_message_task_success_save_single_task": "Task Created.",
    "mobile_message_show_error_message": "Something went wrong.",
    "mobile_message_show_success_message": "Success!",
    "mobile_message_show_offline_message": "You are currently offline.",
    "mobile_message_show_permission_denied_message": "<b>Permission Required.</b> Please give Zenput permission to access {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Permission Required.</b> Please give Zenput and Your Browser permission to access {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Now Uploading",
    "mobile_message_show_upload_in_progress_message": "Upload already in progress",
    "mobile_message_show_form_id_error": "Unable to access specified form.",
    "mobile_message_show_single_task_error": "Unable to access specified task.",
    "mobile_message_show_submissions_error": "Unable to access specified submission.",
    "mobile_message_show_submissions_access_denied": "Sorry, you do not have access to this form.",
    "mobile_message_send_data_success": "Data uploaded ",
    "mobile_message_start_upload_success": "Upload Complete",
    "mobile_message_start_upload_error": "<b>Could not complete upload.</b><br>Submission saved. Please try again later",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Update Available",
    "mobile_message_store_upgrade_confirm_message_one": "Please update the Ops Execution app from the ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Please update Zenput from the ",
    "mobile_message_store_upgrade_confirm_message_two": " to get all the newest features and bug fixes",
    "mobile_message_store_upgrade_confirm_now": "Now",
    "mobile_message_store_upgrade_confirm_later": "Later",
    "mobile_message_redirect_confirm_message": "You are currently filling out a form. Would you like to save it as a draft before proceeding?",
    "mobile_message_log_out_confirm_unsynced_drafts": "You have {{count}} drafts that have not yet been uploaded. These will be lost if you continue. Are you sure?",
    "mobile_message_draft_override_message": "This draft was saved from another device on {{date}}, and the changes on this device are in conflict. You can choose to override the existing version, or reload to the most recent version, and your changes will be discarded.",
    "mobile_html_submitting": "Submitting...",
    "mobile_html_offline": "You are currently offline!",
    "mobile_html_offline_try_again": "You are currently offline. <br/><br/>Please try again once you are connected",
    "mobile_html_something_went_wrong": "Uh oh. Something went wrong.",
    "mobile_html_something_went_wrong_try_again": "Uh oh. Something went wrong. Please try again.",
    "mobile_html_failed_loading_roles": "Failed to load roles.",
    "mobile_alert_please_install_for_native": "Please install the Ops Execution app to use this feature. ",
    "mobile_alert_please_install_for_native_old": "Please install the native Zenput app to use this feature.",
    "mobile_tso_filter_all_tasks": "All {{type}}",
    "mobile_tso_filter_my_tasks": "My {{type}}",
    "mobile_tso_filter_due_date": "Date Due",
    "mobile_tso_filter_date_completed": "Date Completed",
    "mobile_tso_filter_completed": "Completed",
    "mobile_tso_filter_completed_late": "Completed Late",
    "mobile_tso_filter_incomplete": "Incomplete",
    "mobile_tso_filter_var_my_tasks": "My {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} Created by Me",
    "mobile_tso_filter_var_all_tasks": "All {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Follow-Up Actions",
    "mobile_tso_type_all": "Tasks and Follow-Up Actions",
    "mobile_tso_filter_var_at": " at {{location}}",
    "mobile_tso_filter_group_date_due": ", ordered by Date Due",
    "mobile_tso_filter_group_distance": ", grouped by Location",
    "mobile_tso_filter_start_date": "Start Date",
    "mobile_tso_filter_none": "None",
    "mobile_pso_filter_all_projects": "All Projects",
    "mobile_pso_filter_my_projects": "My Projects",
    "mobile_pso_filter_active": "Active",
    "mobile_pso_filter_archived": "Archived",
    "mobile_pso_filter_recurring": "Recurring",
    "mobile_pso_filter_non_recurring": "Non-Recurring",
    "mobile_pso_filter_var_my_projects": "My {{project_type}} {{active_description}} Projects",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Projects Created by Me",
    "mobile_pso_filter_var_all_projects": "All {{project_type}} {{active_description}} Projects",
    "mobile_empty_list_message_must_be_online": "Looks like you're offline. Please go online to see any results.",
    "mobile_empty_list_message_no_submissions": "No Submissions",
    "mobile_empty_list_message_no_activity": "No Activity",
    "mobile_empty_list_message_no_tasks": "No Tasks",
    "mobile_empty_list_message_no_tasks_overdue": "No Overdue {{type}}",
    "mobile_empty_list_message_no_accounts": "No Locations",
    "mobile_empty_list_message_no_projects": "No Projects",
    "mobile_empty_list_message_no_results_found": "No Results Found",
    "mobile_empty_list_message_no_forms_available": "No Forms Available",
    "mobile_empty_list_message_connection_error": "Connection Error<br />Please try again.",
    "mobile_empty_list_message_dashboard_error": "Unable to Load Dashboard",
    "mobile_empty_list_message_user_offline": "You are currently offline",
    "mobile_action_sheet_media_gallery": "Gallery",
    "mobile_action_sheet_cancel": "Cancel",
    "mobile_image_preview_text": "Remove Photo",
    "mobile_mobileform_text": "Previous Submissions",
    "mobile_mobileform_reorder_fields": "Reorder Questions",
    "mobile_mobileform_follow_up_actions": "Follow Up Actions",
    "mobile_mobileform_follow_up_actions_assign_title": "Assign follow-up actions",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Add follow-up actions based on your observations to ensure issues are addressed.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Add Follow-Up Action",
    "mobile_mobileform_follow_up_actions_assign_button": "Assign Follow-Ups",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continue Without Assigning",
    "mobile_mobileform_follow_up_actions_dialog_title": "Continue Without Assigning Follow-Up Actions?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "If you proceed without assigning any follow-up actions, you won't be able to add them later.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continue Anyway",
    "mobile_mobileform_add_follow_up_actions_forms_required": "This field is required",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Too many characters",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "This field is invalid",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Error loading locations",
    "mobile_mobileform_add_follow_up_actions_error_users": "Error loading users",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Add Follow-up",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Title",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Description",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Require Photo",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Due Date",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Update Follow-up",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Delete Follow-up?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "It will be removed and won't be assigned.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Delete Follow-up",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Are you sure you would like to delete this Follow-up?\n\nThis cannot be undone.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continue To Follow-ups",
    "mobile_mobileform_follow_up_actions_completed_notification": "Follow-Up Action Completed",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Follow-Up Action Deleted",
    "mobile_mobileform_follow_up_actions_update_notification": "Follow-Up Action Updated",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Please add a photo to complete this follow-up action",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Navigate to submission",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Navigate to source",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Source",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Complete Follow-up",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "If you open the submission, any unsaved photos and notes will be lost.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "If you leave this screen, any unsaved photos and notes will be lost.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Stay here",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Open submission",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Open source",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Leave this follow-up action?",
    "mobile_mobileform_follow_up_actions_submission": "Submission",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "This Follow-Up Action is assigned to {{user}}.<br />You cannot complete it.",
    "mobile_mobileform_follow_up_actions_leave_description": "If you leave this screen, any unsaved changes will be lost.",
    "mobile_mobileform_follow_up_actions_leave": "Leave",
    "mobile_forms_drafts_text": "Remove Drafts",
    "mobile_batch_estimate_user": "User",
    "mobile_batch_estimate_users": "Users",
    "mobile_table_of_contents": "Table of Contents",
    "mobile_table_of_contents_required": "Required",
    "mobile_table_of_contents_optional": "Optional",
    "mobile_dialog_alert_title": "Alert",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth devices not yet supported on Windows",
    "mobile_windows_deprecated_message_content_announcement": "Announcement",
    "mobile_windows_deprecated_message_title": "App update required",
    "mobile_windows_deprecated_message_description": "Install the new Zenput App in the Microsoft Store ASAP to ensure critical functionality updates and an optimal Zenput experience.",
    "mobile_dashboard_tcr_graph_name": "Task Completion Rate",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Past 4 Weeks",
    "mobile_dashboard_tcr_legend_company_average": "Company Average",
    "mobile_dashboard_tcr_legend_team_average": "Team Average",
    "mobile_dashboard_tab_title_summary": "Summary",
    "mobile_dashboard_tab_title_activity": "Activity",
    "mobile_dashboard_card_title_top_triggered_workflows": "Top Triggers",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Compliance",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Week Of",
    "mobile_dashboard_card_filter_form_template_placeholder": "All Forms",
    "mobile_dashboard_card_title_forms_top_nos": "Frequent \"No\"s",
    "mobile_dashboard_zenput_code_no_data_in_range": "There is no data in this time range.",
    "mobile_dashboard_zenput_code_permission_denied": "You do not have permission to see this.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Select a form from above.",
    "mobile_dashboard_zenput_code_unknown_error": "We cannot display the data at this time.",
    "mobile_dashboard_tap_to_retry": "Tap to Retry",
    "mobile_dashboard_reporting_delay_disclaimer": "Tasks may take up to 15 minutes to update",
    "mobile_dashboard_configuration_down_state_postfix_msg": "have been configured by your administrator.",
    "mobile_tasks_tag": "tasks",
    "mobile_workflows_tag": "triggers",
    "mobile_projects_tag": "recurring projects",
    "mobile_forms_tag": "forms",
    "mobile_dashboard_card_ongoing_projects_title": "In-Progress Projects",
    "mobile_dashboard_card_ongoing_projects_show_more": "Show More",
    "mobile_dashboard_card_ongoing_projects_show_less": "Show Less",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Go To Projects",
    "mobile_dashboard_card_title_recurring_projects": "Recurring Projects",
    "mobile_dashboard_card_filter_daily": "Daily",
    "mobile_dashboard_card_filter_weekly": "Weekly",
    "mobile_dashboard_card_filter_monthly": "Monthly",
    "mobile_task_status_title_open": "Open",
    "mobile_task_status_title_upcoming": "Upcoming",
    "mobile_task_status_title_complete": "Complete",
    "mobile_task_status_title_processing": "Submission Processing",
    "mobile_task_status_title_complete_with_exceptions": "Complete with Follow-up Tasks or Alerts",
    "mobile_task_status_title_completed_late_with_exceptions": "Completed Late with Follow-up Tasks or Alerts",
    "mobile_task_status_title_incomplete_and_closed": "Missed",
    "mobile_tasks_legend_modal_title": "Legend",
    "mobile_tasks_legend_modal_footer_button_title": "Close",
    "mobile_common_assigned_to": "Assigned To",
    "mobile_common_created_by": "Created by",
    "mobile_common_tasks_for": "Tasks for",
    "mobile_common_go_back": "Go Back",
    "mobile_oh_no": "Oh, No!",
    "mobile_user_not_in_groups": "Sorry, it looks like you are not assigned to a team. Contact your administrator to gain access to your dashboard.",
    "mobile_tasks_select_followers": "Select Followers",
    "mobile_tasks_assign_tasks": "Assign {{count}} Tasks",
    "mobile_tasks_add_followers": "Add Followers",
    "mobile_tasks_followers": "Followers",
    "mobile_tasks_delete_task": "Delete Task",
    "mobile_tasks_create_task": "Create Tasks",
    "mobile_tasks_tab_title_comments": "Comments",
    "mobile_tasks_see_more": "See more",
    "mobile_projects_create_project": "Create Project",
    "mobile_common_button_send": "Send",
    "mobile_common_button_schedule": "Schedule",
    "mobile_announcements_create": "Create Announcement",
    "mobile_announcements_read_rate": "{{opened_count}} of {{recipients_count}} Opened",
    "mobile_announcements_empty_message": "You haven’t created any announcements yet! Create an announcement below to broadcast important news, information, and updates to your organization.",
    "mobile_announcement_message_placeholder": "Add a message...",
    "mobile_announcement_title_placeholder": "Announcement Title",
    "mobile_announcement_leaving_announcement": "Leaving Announcement",
    "mobile_announcement_confirm_recipients_team": "Do you want to broadcast this announcement to {{count}} user(s) in {{teams}} selected team(s)?",
    "mobile_announcement_confirm_recipients_role": "Do you want to broadcast this announcement to {{count}} user(s) in {{roles}} selected user role(s)?",
    "mobile_announcement_confirm_recipients_user": "Do you want to broadcast this announcement to {{count}} user(s)?",
    "mobile_announcement_confirm_scheduled": "On {{timestamp}}",
    "mobile_announcement_sending_announcement": "Sending Announcement",
    "mobile_announcement_send_to": "Send To",
    "mobile_announcement_sent_to": "Sent To",
    "mobile_announcement_send_to_role": "Role",
    "mobile_announcement_attachment_download": "Downloading {{filename}}",
    "mobile_announcement_attachment_validation_error": "No more than {{maxCount}} attachments can be added",
    "mobile_announcement_details_sent": "Sent",
    "mobile_announcement_details_total_recipients": "Total Recipients",
    "mobile_announcement_details_cancel": "Cancel Announcement",
    "mobile_announcement_details_not_editable": "Announcements can only be edited in the Ops Execution web app ",
    "mobile_announcement_details_not_editable_old": "Announcements may only be edited on Zenput Web",
    "mobile_announcement_details_open_count": "Open Count",
    "mobile_announcement_details_open_rate": "Open Rate",
    "mobile_announcement_details_resend": "Resend to non-openers",
    "mobile_announcement_confirm_resend": "{{count}} user(s) have not read the announcement. Do you want to send a reminder?",
    "mobile_announcement_confirm_resend_title": "Send Reminder?",
    "mobile_announcement_recipients_opened": "Opened",
    "mobile_recipients_opened_empty_message": "It looks like no one has opened your message yet. Come back later to see your results.",
    "mobile_announcement_recipients_unopened": "Unopened",
    "mobile_recipients_unopened_empty_message": "Good news! There are no unopened messages!",
    "mobile_scheduled_announcements_delivery_section_header": "Delivery Time",
    "mobile_scheduled_announcements_send_immediately_label": "Send immediately",
    "mobile_scheduled_announcements_scheduled_label": "Send at a specific time",
    "mobile_scheduled_announcements_scheduled_tab_label": "Scheduled",
    "mobile_scheduled_announcements_dialog_header": "Cancel Announcement?",
    "mobile_scheduled_announcements_dialog_message": "Canceling your announcement will stop it from being sent and delete it from your list. This cannot be undone. To edit go to Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "You currently have no scheduled announcements. Schedule an announcement to broadcast important news, information, and updates to your organization.",
    "mobile_scheduled_announcements_validation_error": "Delivery time must be after {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Schedule Announcement",
    "mobile_projects_auto_archive": "Auto Archive",
    "mobile_common_unassigned": "Unassigned",
    "mobile_tasks_title_placeholder": "New Task Or Form",
    "mobile_projects_leaving_project": "Leaving Project",
    "mobile_projects_save_project": "Save Project",
    "mobile_top_triggers_tasks": "Top Triggered Tasks",
    "mobile_top_triggers_alerts": "Top Triggered Alerts",
    "mobile_projects_not_started": "Not Started",
    "mobile_empty_list_message_no_photos": "No Photos",
    "mobile_webfilestore_message_error": "Please select a valid file type",
    "mobile_notifications_empty_title": "No Notifications",
    "mobile_notifications_empty_message": "Activity on your tasks or those you're a part of will appear here.",
    "mobile_comments_comment_deleted": "This comment has been deleted.",
    "mobile_comments_comment_placeholder": "Comment",
    "mobile_comments_task_submitted_at": "Task submitted on {{ date }} at {{ time }}",
    "mobile_comments_discard_comment_title": "Discard Comment?",
    "mobile_comments_discard_confirm_message": "Are you sure? Your comment will be deleted.",
    "mobile_comments_delete_comment_title": "Delete Comment?",
    "mobile_comments_delete_confirm_message": "This can not be undone.",
    "mobile_comments_delete_button": "Delete Comment",
    "mobile_comments_delete_success_message": "Comment Deleted",
    "mobile_comments_empty_message_tasks": "There are no comments yet \n Start a conversation on this task.",
    "mobile_comments_empty_message_submissions": "There are no comments yet \n Start a conversation on this submission.",
    "mobile_comments_empty_message_default": "There are no comments yet \n Start a conversation.",
    "mobile_comments_no_matching_users": "No users matching.",
    "mobile_comments_empty_users_to_notify": "There are no users to notify.",
    "mobile_comments_users_cant_view_message": "These users can't view these comments",
    "mobile_comments_users_to_notify_title": "Users to Notify",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} user</a> will be notified.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} users</a> will be notified.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> more users to notify them.",
    "mobile_comments_mark_read": "Mark all as read",
    "mobile_comments_author_mentioned_message": "mentioned you in",
    "mobile_comments_author_commented_message": "commented on",
    "mobile_view_pdf": "View PDF",
    "mobile_no_pdf_generated_message": "No PDF was found for this submission. A copy will be emailed to you shortly.",
    "mobile_clipboard_copied_success": "The link is copied to your clipboard.",
    "mobile_share_link": "Share Link",
    "mobile_zencam_share": "Share",
    "mobile_zencam_view_details": "View details",
    "mobile_zencam_details_drawer_header": "Details",
    "mobile_zencam_submitted_by": "Submitted by",
    "mobile_zencam_form_title": "Form Title",
    "mobile_zencam_date_submitted": "Date Submitted",
    "mobile_oil_quality_warning_message": "Oil near expiration",
    "mobile_oil_quality_warning_message_subtitle": "Start planning to change it out soon",
    "mobile_oil_quality_failure_message": "Oil quality compromised",
    "mobile_oil_quality_failure_message_subtitle": "Change the oil immediately",
    "mobile_sensors_set_up_gateway": "Set Up Gateway",
    "mobile_sensors_set_up_gateway_message": "It looks like there are no devices set up. Get started by adding a gateway.",
    "mobile_sensors_gateway_plugged_in": "Make sure your gateway is plugged into a power outlet",
    "mobile_sensors_add_device": "Add device",
    "mobile_sensors_name_this_gateway": "Name this gateway.",
    "mobile_sensors_name_this_sensor": "Name this sensor.",
    "mobile_sensors_device_barcode_information": "Scan QR Code or enter the ID and SC number from the device label",
    "mobile_sensors_device_eui_information": "Scan the QR Code or enter the DevEUI from the device label",
    "mobile_sensors_gateway_id_information": "Enter the Node ID from the Gateway label",
    "mobile_sensors_id_number": "{{untranslatedID}} Number",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Code",
    "mobile_sensors_sensors": "Sensors",
    "mobile_sensors_sensor_deveui_error": "Couldn't get DevEUI from QR. Please enter it manually.",
    "mobile_sensors_gateways": "Gateways",
    "mobile_sensors_add_sensor": "Add Sensor",
    "mobile_sensors_add_gateway": "Add Gateway",
    "mobile_sensor_placement_description": "What area will this sensor monitor?",
    "mobile_sensors_equipment_placement": "What area or equipment will this sensor monitor?",
    "mobile_sensors_equipment": "What equipment will this sensor monitor?",
    "mobile_sensors_select_gateway_type": "Select the gateway type",
    "mobile_sensors_select_placement": "Select Placement",
    "mobile_sensors_select_equipment": "Select Equipment",
    "mobile_sensors_placement": "Placement",
    "mobile_sensors_nickname_tip": "Sensor naming is determined by the nicknames assigned in the selected placement.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Scan QR Code",
    "mobile_sensors_enter_manually": "Enter Manually",
    "mobile_sensors_wizard_step_one": "Step 1",
    "mobile_sensors_wizard_step_two": "Step 2",
    "mobile_sensors_wizard_step_three": "Step 3",
    "mobile_sensors_wizard_step_four": "Step 4",
    "mobile_sensors_wizard_step_five": "Step 5",
    "mobile_sensors_wizard_step_six": "Step 6",
    "mobile_sensors_initializing": "Initializing …",
    "mobile_sensors_nickname": "Nickname",
    "mobile_sensors_field_not_blank": "The {{field}} cannot be blank.",
    "mobile_sensors_nothing_to_see_here": "Nothing To See Here",
    "mobile_sensors_missing_integration": "Missing Sensor Integration",
    "mobile_sensors_contact_zenput_admin": "Please contact your company's Ops Execution admin.",
    "mobile_sensors_contact_zenput_admin_old": "Please contact your Zenput admin.",
    "mobile_sensors_contact_manager": "Contact your account manager to add sensors.",
    "mobile_sensors_device_success_message": "Sensor data may take up to 15 minutes to load",
    "mobile_sensors_last_reading": "Last Reading",
    "mobile_sensors_remove_device": "Remove Device",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1W",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1Y",
    "mobile_sensors_sensor_settings": "Sensor Settings",
    "mobile_sensors_remove_confirm_message": "Are you sure you want to delete this device?\nThis cannot be undone.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "No Equipment Linked",
    "mobile_sensor_cooldown_process": "Cool Down Process",
    "mobile_sensor_last_12_hours": "Last 12 Hours",
    "mobile_sensor_start_cooldown_process": "Start New Cool Down Process",
    "mobile_sensor_cooldown_process_title": "Two-Stage Cool Down Process",
    "mobile_sensor_cooldown_process_description": "A two-stage cool down process consists of cooling food from greater than {{ stage1_start_temperature }} to {{ stage1_end_temperature }} in two hours or less, and then from {{ stage1_end_temperature }} to {{ stage2_end_temperature }} in four hours or less.",
    "mobile_sensor_cooldown_process_place_food": "Place the food product in the refrigerator.",
    "mobile_sensor_cooldown_process_insert_sensor": "Insert a sensor probe in to the food product.",
    "mobile_sensor_cooldown_process_enter_information": "Enter information below.",
    "mobile_sensor_cooldown_process_food_product": "Food Product to cool down",
    "mobile_sensor_cooldown_cool_down": "Cool Down",
    "mobile_sensor_cooldown_select_sensor": "Select Sensor",
    "mobile_sensors_cooldown_start_cooldown": "Start Cool Down",
    "mobile_sensors_cooldown_please_enter_food": "Please enter a Food Product",
    "mobile_sensors_cooldown_please_select_sensor": "Please select a Sensor",
    "mobile_sensors_cooldown_status_in_progress": "In Progress",
    "mobile_sensors_cooldown_status_failed": "Failed",
    "mobile_sensors_cooldown_status_success": "Success",
    "mobile_sensors_cooldown_stage": "Stage",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Starting temperature is out of range",
    "mobile_sensors_cooldown_failed_cooldown_process": "Failed Cool Down Process",
    "mobile_sensors_cooldown_cooldown_successful": "Cool Down Successful",
    "mobile_sensors_cooldown_started_cooldown_process": "Started Cool Down Process",
    "mobile_sensors_cooldown_hour": "hour",
    "mobile_sensors_cooldown_hour_plural": "hours",
    "mobile_sensors_cooldown_minute": "minute",
    "mobile_minutes_plural": "minutes",
    "mobile_sensors_last_reading_max_date": "> 1 year ago",
    "mobile_sensors_minute_count_ago": "{{count}} minute ago",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minutes ago",
    "mobile_sensors_hour_count_ago": "{{count}} hour ago",
    "mobile_sensors_hour_count_ago_plural": "{{count}} hours ago",
    "mobile_sensors_day_count_ago": "{{count}} day ago",
    "mobile_sensors_day_count_ago_plural": "{{count}} days ago",
    "mobile_sensors_chart_settings": "Chart Settings",
    "mobile_announcement_banner_continue_reading": "Continue reading",
    "mobile_compliance_submissions_report": "Submissions Report",
    "mobile_compliance_submissions_report_subtitle": "Export project completion data for this store",
    "mobile_compliance_send_submissions": "Send Submissions",
    "mobile_compliance_completion_rate_in_last_days": "Completion Rate in the Last {{ days }} Days",
    "mobile_compliance_last_days": "Last {{ days }} Days",
    "mobile_compliance_send_submissions_to": "Send Submissions to",
    "mobile_compliance_send_to_different_email": "Send to a Different Email",
    "mobile_compliance_email_input_placeholder": "Email Address",
    "mobile_compliance_send_submissions_to_legend_title": "Submissions",
    "mobile_compliance_send_submissions_to_legend_description_days": "A report with your submissions from this location in the last {{ days }} days will be sent to the selected email.",
    "mobile_compliance_time_frame": "Time Frame",
    "mobile_compliance_sensor_temperature_log_report": "Sensor Temperature Log Report",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Export temperature logs for this store",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Criteria",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Define the criteria for your report below.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Note: Disabled sensor(s) will not be shown in the report",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Select a time frame. Log data is limited to a max of 30 days",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Send Report",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "This Month (1st-Today)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Last Month",
    "mobile_compliance_sensor_temperature_log_email_title": "Send Report To",
    "mobile_pwa_update_prompt_title": "Update Application",
    "mobile_pwa_update_prompt_description": "A new version of the application is available. Please update to the latest version.",
    "mobile_pwa_update_prompt_confirm": "Update And Reload",
    "mobile_pwa_update_prompt_cancel": "Remind Me Later",
    "notification_title_due_in_one_hour": "Due in 1 hour",
    "task_is_due_soon": "'{{ task_title }}' is due soon. Take a moment to complete it.",
    "mobile_photo_quality_warning_header": "Photo quality issue",
    "mobile_photo_quality_dialog_message": "This photo may be too dark or blurry. Would you like to take a new photo, or continue with this one?",
    "mobile_take_new_photo": "Take a new photo",
    "mobile_use_this_photo": "Use this photo"
}};
mobile_translations.vi_VN = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Tất cả",
    "mobile_common_button_apply_filters": "Áp dụng bộ lọc",
    "mobile_common_button_done": "Hoàn tất",
    "mobile_common_button_edit": "Chỉnh sửa",
    "mobile_common_button_archive": "Lưu trữ",
    "mobile_common_button_save": "Lưu",
    "mobile_common_button_retake": "Thực hiện lại",
    "mobile_common_button_save_draft": "Lưu Bản nháp",
    "mobile_common_button_discard": "Huỷ",
    "mobile_common_button_submit": "Gửi",
    "mobile_common_button_no": "Không",
    "mobile_common_button_yes": "Có",
    "mobile_common_button_na": "Không áp dụng",
    "mobile_common_created_by_me": "Tạo bởi Tôi",
    "mobile_common_email": "Email Công ty",
    "mobile_common_first_name": "Tên",
    "mobile_common_last_name": "Họ",
    "mobile_common_location": "Vị trí",
    "mobile_common_locations": "Các vị trí",
    "mobile_common_logout_message": "Bạn có chắc chắn muốn đăng xuất?",
    "mobile_common_password": "Mật khẩu",
    "mobile_common_permission_required": "Yêu cầu Quyền truy cập",
    "mobile_common_status": "Trạng thái",
    "mobile_common_task": "Tác vụ",
    "mobile_common_tasks": "Các tác vụ",
    "mobile_common_tasks_my": "Nhiệm vụ của tôi",
    "mobile_common_projects": "Các dự án",
    "mobile_common_filter_team": "Đội nhóm",
    "mobile_common_filter_var_in": " trong {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Không có đội nhóm nào được chọn",
    "mobile_common_filter_no_user_selected": "Không có người dùng nào được chọn",
    "mobile_common_filter_no_role_selected": "Không có vai trò nào được chọn",
    "mobile_common_placeholder_date": "Ngày",
    "mobile_common_message_task_creator_error_save": "<b>Không thể tạo tác vụ.</b>",
    "mobile_common_camera": "Camera",
    "mobile_common_microphone": "Micrô",
    "mobile_common_for": "dành cho",
    "mobile_common_reload": "Tải lại",
    "mobile_common_override": "Ghi đè",
    "mobile_common_notifications": "Thông báo",
    "mobile_common_chat_unavailable": "Trò chuyện không khả dụng. Hãy thử lại sau.",
    "mobile_common_chat_ending_dialog_title": "Bạn đã kết thúc cuộc trò chuyện này chưa?",
    "mobile_common_chat_ending_dialog_description": "Hãy cho chúng tôi biết nếu vấn đề của bạn đã được giải quyết hoặc nếu bạn muốn tiếp tục vào lúc khác.",
    "mobile_common_chat_ending_dialog_confirm": "Vâng, tôi đã xong",
    "mobile_common_chat_ending_dialog_cancel": "Tôi sẽ tiếp tục sau",
    "mobile_common_continue_editing": "Tiếp tục chỉnh sửa",
    "mobile_privacy_policy": "Chính sách Quyền riêng tư",
    "wootric_recommend_target": "một người bạn hoặc đồng nghiệp trong ngành của bạn",
    "wootric_followup_detractor_question": "Chúng tôi có thể thực hiện những thay đổi nào để lần sau bạn đánh giá chúng tôi cao hơn?",
    "wootric_followup_passive_question": "Cảm ơn bạn! Chúng tôi có thể làm gì để công cụ này tốt hơn nữa?",
    "wootric_followup_promoter_question": "Cảm ơn bạn! Bạn thích điều gì nhất ở Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Cảm ơn bạn! Bạn yêu thích điều gì ở Zenput?",
    "wootric_default_followup_question": "Cảm ơn bạn! Bạn có thể cho chúng tôi biết tại sao không?",
    "wootric_default_placeholder_text": "Giúp đỡ chúng tôi bằng cách giải thích việc chấm điểm của bạn.",
    "wootric_default_thankyou_text": "Cảm ơn câu trả lời và phản hồi của bạn!",
    "mobile_login_placeholder_login_as": "Đăng nhập bằng ID Người dùng",
    "mobile_login_button_forgot_password": "Quên Mật khẩu?",
    "mobile_login_button_sign_up": "Tạo Tài khoản",
    "mobile_login_button_finish_setup": "Hoàn thành Thiết lập",
    "mobile_login_button": "Đăng nhập",
    "mobile_login_continue_button": "Tiếp tục",
    "mobile_login_continue_transition": "đưa bạn đến trang đăng nhập của tổ chức của bạn...",
    "mobile_login_no_email_error": "Bạn phải nhập email.",
    "mobile_login_change_email": "Đăng nhập bằng email khác",
    "mobile_login_with_sso": "Đăng nhập bằng SSO",
    "mobile_oauth_no_user_error_message": "Có vẻ như bạn chưa có tài khoản Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Có vẻ như bạn chưa có Tài khoản Zenput!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> hiện đã chuyển thành <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} sẽ trở thành {{- product }} vào tháng 9. {{- cta }}",
    "mobile_rebrand_warning_cta": "Hãy tìm hiểu cách chuẩn bị.",
    "mobile_oauth_no_user_error_sub_message": "Hãy liên hệ với quản trị viên của bạn để có quyền truy cập hoặc thử đăng nhập bằng một email khác.",
    "mobile_oauth_generic_error_message": "Có vẻ như đã xảy ra sự cố khi đăng nhập, vui lòng thử lại.",
    "mobile_oauth_force_logout_msg": "Nếu bạn vẫn gặp sự cố, hãy đăng xuất khỏi nhà cung cấp của bạn bằng cách ",
    "mobile_oauth_force_logout_click": "nhấp vào đây.",
    "mobile_sign_up_placeholder_phone": "Số điện thoại Di động",
    "mobile_sign_up_placeholder_password_confirm": "Xác nhận Mật khẩu",
    "mobile_sign_up_button_sign_in": "Đăng nhập",
    "mobile_sign_up_disclaimer_part_1": "Bằng cách nhấp vào Tạo Tài khoản, bạn đồng ý với",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Bằng cách nhấp vào Hoàn thành Thiết lập, bạn đồng ý với",
    "mobile_sign_up_disclaimer_link_title": " Thỏa thuận Cấp phép",
    "mobile_sign_up_disclaimer_part_2": ", thoả thuận này bao gồm thông tin quan trọng về quyền riêng tư",
    "mobile_dialog_benefits_work_offline": "Làm việc Ngoại tuyến",
    "mobile_dialog_benefits_faster_uploads": "Tải lên Nhanh hơn",
    "mobile_dialog_benefits_better_experience": "Trải nghiệm Tốt hơn",
    "mobile_dialog_benefits_button_download": "Tải xuống",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution cho ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput dành cho ",
    "mobile_dialog_benefits_button_have": "Tôi có ứng dụng này!",
    "mobile_dialog_benefits_button_no_thanks": "Không, cảm ơn, có lẽ để sau.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Không thể tải hình ảnh.",
    "mobile_dialog_signature_sign": "Ký vào Đây",
    "mobile_dialog_signature_button_clear": "Xoá",
    "mobile_account_placeholder_name": "Tên Vị trí/Cửa hàng",
    "mobile_account_placeholder_phone": "Điện thoại",
    "mobile_account_placeholder_address": "Địa chỉ",
    "mobile_account_placeholder_city": "Thành phố",
    "mobile_account_placeholder_region": "Khu vực",
    "mobile_account_placeholder_zipcode": "Mã bưu chính/Zip",
    "mobile_account_option_select_country": "Chọn Quốc gia",
    "mobile_account_oprion_us": "Hoa Kỳ",
    "mobile_account_oprion_select_state": "Chọn Tiểu bang",
    "mobile_account_button_create_location": "Tạo Vị trí",
    "mobile_form_message_no_form": "Không có biểu mẫu nào khả dụng",
    "mobile_batch_task_message": "Đang tải...",
    "mobile_settings_profile": "Hồ sơ",
    "mobile_settings_profile_number": "Điện thoại Di động",
    "mobile_settings_profile_language": "Ngôn ngữ",
    "mobile_settings_profile_temperature_unit": "Đơn vị nhiệt độ",
    "mobile_settings_profile_use_company_default": "Sử dụng đơn vị mặc định của công ty",
    "mobile_settings_profile_celsius": "Độ C",
    "mobile_settings_profile_fahrenheit": "Độ F",
    "mobile_settings_notifications_option_sms": "Tin nhắn Văn bản",
    "mobile_settings_notifications_option_push": "Thông báo Đẩy",
    "mobile_settings_notifications_option_push_email": "Email & Thông báo Đẩy",
    "mobile_settings_notifications_option_do_not": "Đừng thông báo",
    "mobile_settings_notifications_category_communication": "Liên lạc",
    "mobile_settings_notifications_category_forms_and_triggers": "Biểu mẫu & Nhân tố kích hoạt",
    "mobile_settings_devices": "Thiết bị",
    "mobile_settings_notifications_sub_category_alerts": "Cảnh báo",
    "mobile_settings_notifications_sub_category_new_forms_available": "Có Biểu mẫu Mới",
    "mobile_settings_notifications_sub_category_task_assigned": "Tác vụ đã phân công",
    "mobile_settings_notifications_sub_category_task_completed": "Tác vụ đã hoàn thành",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Lời nhắc tác vụ sắp đến hạn",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Lời nhắc tác vụ quá hạn",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Cảnh báo Cảm biến",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Cảnh báo Cảm biến Quan trọng",
    "mobile_drafts_message": "Bạn chưa có bản nháp nào.",
    "mobile_drafts_button_delete": "Xoá",
    "mobile_tasks_filter_location_no": "Không có vị trí nào được chọn",
    "mobile_tasks_filter_group_by": "Nhóm Theo",
    "mobile_tasks_filter_sort_by": "Sắp xếp theo",
    "mobile_tasks_filter_sorted_by": "Đã sắp xếp theo",
    "mobile_tasks_filter_due_time": "Thời gian đến hạn",
    "mobile_tasks_filter_open_time": "Thời gian mở",
    "mobile_tasks_bucket_due_next_24_hours": "Đến hạn trong 24 Giờ",
    "mobile_tasks_bucket_due_next_7_days": "Đến hạn trong 7 Ngày",
    "mobile_tasks_bucket_open_tasks": "{{type}} mở bổ sung",
    "mobile_tasks_bucket_open_at": "Mở: {{- date }} lúc {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Đến hạn: {{- date }} lúc {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Sẵn có trong 1 phút",
    "mobile_tasks_bucket_available_in_one_hour": "Sẵn có trong 1 giờ",
    "mobile_tasks_bucket_available_in_one_day": "Sẵn có trong 1 ngày",
    "mobile_tasks_bucket_available_in_one_week": "Sẵn có trong 1 tuần",
    "mobile_tasks_bucket_available_in_one_month": "Sẵn có trong 1 tháng",
    "mobile_tasks_bucket_available_in_one_year": "Sẵn có trong 1 năm",
    "mobile_tasks_bucket_available_in_minutes": "Sẵn có trong {{ minutes }} phút",
    "mobile_tasks_bucket_available_in_hours": "Sẵn có trong {{ hours }} giờ",
    "mobile_tasks_bucket_available_in_days": "Sẵn có trong {{ days }} ngày",
    "mobile_tasks_bucket_available_in_weeks": "Sẵn có trong {{ weeks }} tuần",
    "notification_task_due_in_minutes": "Đến hạn sau {{ minutes }} phút",
    "mobile_tasks_bucket_available_in_months": "Sẵn có trong {{ months }} tháng",
    "mobile_tasks_bucket_available_in_years": "Sẵn có trong {{ years }} năm",
    "mobile_tasks_follow_up": "Tác vụ theo sát",
    "mobile_tasks_due_soon": "Sắp đến hạn",
    "mobile_tasks_bucket_completed_today": "Đã hoàn thành Hôm nay",
    "mobile_tasks_bucket_completed_this_week": "Đã hoàn thành Tuần này",
    "mobile_tasks_bucket_completed_last_week": "Đã hoàn thành Tuần trước",
    "mobile_tasks_bucket_missed_today": "Đã bỏ lỡ Hôm nay",
    "mobile_tasks_bucket_missed_this_week": "Đã bỏ lỡ Tuần này",
    "mobile_tasks_bucket_missed_last_week": "Đã bỏ lỡ Tuần trước",
    "mobile_tasks_bucket_no_location": "Không có Vị trí",
    "mobile_tasks_cannot_submit_missed": "Không thể hoàn thành tác vụ bị bỏ lỡ",
    "mobile_tasks_cannot_submit_missed_after": "Không thể hoàn thành tác vụ này sau {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Tác vụ này chưa bắt đầu.",
    "mobile_tasks_cannot_submit_processing": "Đang xử lý hoạt động gửi này",
    "mobile_tasks_toolbarnav_header_no_due_date": "Không có Ngày đến hạn",
    "mobile_tasks_toolbarnav_header_overdue": "Quá hạn",
    "mobile_tasks_toolbarnav_header_yesterday": "Hôm qua",
    "mobile_tasks_toolbarnav_header_today": "Hôm nay",
    "mobile_tasks_toolbarnav_header_tomorrow": "Ngày mai",
    "mobile_tasks_toolbarnav_header_last_week": "Tuần trước",
    "mobile_tasks_toolbarnav_header_this_week": "Tuần này",
    "mobile_tasks_toolbarnav_header_next_week": "Tuần sau",
    "mobile_tasks_toolbarnav_header_this_month": "Tháng này",
    "mobile_tasks_toolbarnav_header_next_year": "Năm sau",
    "mobile_tasks_toolbarnav_header_over_year": "Hơn một năm",
    "mobile_tasks_toolbarnav_title_edit_task": "Chỉnh sửa Tác vụ",
    "mobile_task_placeholder_title": "Tiêu đề *",
    "mobile_task_placeholder_description": "Mô tả (không bắt buộc)",
    "mobile_task_button_single_task": "Tác vụ Đơn",
    "mobile_task_button_project": "Dự án",
    "mobile_task_button_create": "Tạo",
    "mobile_task_tab_basic": "Cơ bản",
    "mobile_task_tab_photo": "Ảnh",
    "mobile_task_tab_form": "Mẫu",
    "mobile_task_details_description_message_please": "Vui lòng điền vào ",
    "mobile_task_details_description_message_below": "dưới đây.",
    "mobile_task_details_description_message_instructions": "Không có sẵn hướng dẫn cho tác vụ này.",
    "mobile_task_details_reason_title": "Theo dõi được Kích hoạt bởi",
    "mobile_task_detials_button_goto_form": "Đi đến Biểu mẫu",
    "mobile_task_detials_button_complete": " Hoàn thành Tác vụ",
    "mobile_task_detials_completed": "Đã hoàn thành ",
    "mobile_task_detials_completed_by": "bởi ",
    "mobile_task_detials_completed_on": "vào ",
    "mobile_task_details_view_form_submission": "Xem Hoạt động gửi Biểu mẫu",
    "mobile_task_task_updated": "Tác vụ đã cập nhật",
    "mobile_task_task_archived": "Tác vụ đã lưu trữ",
    "mobile_task_task_deleted": "Tác vụ đã xoá",
    "mobile_task_error_archiving_task": "Không thể lưu trữ tác vụ.",
    "mobile_task_error_deleting_task": "Không thể xoá tác vụ.",
    "mobile_task_error_updating_task": "Không thể cập nhật tác vụ.",
    "mobile_task_archive_task": "Lưu trữ Tác vụ",
    "mobile_task_archive_task_confirm": "Bạn có chắc chắn muốn lưu trữ Tác vụ này không?\n\nCác tác vụ đã lưu trữ sẽ được tính vào tỷ lệ hoàn thành và sẽ tiếp tục được đưa vào báo cáo.\n\nĐiều này không thể được hoàn tác.",
    "mobile_task_delete_task_confirm": "Bạn có chắc chắn muốn xoá Tác vụ này không?\n\nCác tác vụ đã xoá sẽ không được tính vào tỷ lệ hoàn thành và sẽ không được đưa vào bất kỳ báo cáo nào.\n\nĐiều này không thể được hoàn tác.",
    "mobile_task_edition_already_in_progress": "Tác vụ này có một chỉnh sửa đang chờ xử lý. Hiện không được phép chỉnh sửa thêm.",
    "mobile_projects_filter_type": "Loại",
    "mobile_projects_filter_status": "Trạng thái dự án",
    "mobile_projects_filter_project_type": "Loại dự án",
    "mobile_projects_due_date_required": "Ngày đến hạn là bắt buộc.",
    "mobile_projects_team_required": "Đội nhóm là bắt buộc.",
    "mobile_projects_user_role_required": "Người được giao việc là bắt buộc.",
    "mobile_projects_title_required": "Tiêu đề là bắt buộc.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Nhiều Tác vụ theo Ngày",
    "mobile_project_tasks_complete": " Hoàn thành",
    "mobile_project_tasks_remaining": " Còn lại",
    "mobile_esitmate_message_tasks": "Sẽ tạo 0 tác vụ",
    "mobile_esitmate_message_criteria": "Điều chỉnh các Tiêu chí Trên",
    "mobile_esitmate_message_created_for": "sẽ được tạo cho",
    "mobile_left_menu_dashboard": "Bảng điều khiển",
    "mobile_left_menu_my_forms": "Biểu mẫu của tôi",
    "mobile_left_menu_announcements": "Thông báo",
    "mobile_left_menu_my_submissions": "Các Hoạt động gửi của Tôi",
    "mobile_left_menu_drafts": "Bản nháp",
    "mobile_left_menu_pending_uploads": "Tải lên đang Chờ xử lý",
    "mobile_left_menu_open": "Mở trong Ứng dụng",
    "mobile_left_menu_settings": "Cài đặt",
    "mobile_left_menu_log_out": "Đăng xuất",
    "mobile_left_menu_debug": "Gỡ lỗi",
    "mobile_left_menu_support": "Hỗ trợ",
    "mobile_left_menu_documentation": "Tài liệu",
    "mobile_left_menu_chat": "Trò chuyện",
    "mobile_field_textarea_placeholder_note": "Ghi chú hoặc chú thích",
    "mobile_field_option_select": "Chọn",
    "mobile_field_text_placeholder_text": "Văn bản",
    "mobile_field_email_placehoder_email": "Email",
    "mobile_filed_number_placeholder_number": "Số",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Không có kết nối",
    "mobile_field_sensor_offline_battery": "Cảm biến ngoại tuyến - Pin",
    "mobile_field_video_button_add": "Thêm Video",
    "mobile_field_video_picker_dialog_title": "Thêm video từ",
    "mobile_field_video_button_change": "Thay đổi Video",
    "mobile_field_image_button_add": "Thêm Hình ảnh",
    "mobile_field_image_low_quality_warning": "Một số ảnh có thể quá tối hoặc bị mờ. Hãy xem lại các ảnh được đánh dấu và thay thế chúng nếu cần.",
    "mobile_field_image_picker_dialog_title": "Thêm ảnh từ",
    "mobile_field_image_picker_edit_failed": "Chúng tôi không thể lưu hình ảnh. Vui lòng thử lại.",
    "mobile_field_signature_button_add": "Thêm Chữ ký",
    "mobile_field_signature_button_change": "Thay đổi Chữ ký",
    "mobile_field_account_select_location": "Chọn một Vị trí",
    "mobile_field_account_prefill": "Điền trước biểu mẫu bằng dữ liệu từ Lần truy cập gần nhất?",
    "mobile_field_account_message_overwrite": "Điều này sẽ ghi đè lên bất kỳ trường nào bạn đã điền.",
    "mobile_forms_task_on_behalf": "Có một tác vụ cần hoàn thành tại vvị trí được chỉ định cho <b>{{user}}</b>. Bạn có muốn hoàn thành tác vụ này không?",
    "mobile_forms_complete_task": "Hoàn thành Tác vụ?",
    "mobile_field_account_prefill_button_yes": "Có, điền trước",
    "mobile_field_barcode_placeholder_scan": "Quét hoặc nhập mã vạch",
    "mobile_field_sensor_qr_code_placeholder_scan": "Quét hoặc nhập mã",
    "mobile_field_gateway_id_code_placeholder": "ID nút loại",
    "mobile_field_scan_qr_or_enter_dev_eui": "Quét Mã QR hoặc nhập DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Quét Mã QR hoặc nhập Số ID",
    "mobile_field_scan_qr_or_enter_sc": "Quét Mã QR hoặc nhập Mã SC",
    "mobile_field_barcode_select_date": "Chọn Ngày ",
    "mobile_field_datetime_allow_time": "Giờ",
    "mobile_field_stopwatch_button_caption": "Đồng hồ tính giờ",
    "mobile_field_stopwatch_common_start": "Bắt đầu",
    "mobile_field_stopwatch_common_stop": "Dừng",
    "mobile_field_stopwatch_common_reset": "Cài đặt lại",
    "mobile_field_stopwatch_stop_stopwatches": "Dừng Đồng hồ tính giờ",
    "mobile_field_document_title": "Thêm Tài liệu",
    "mobile_field_document_message_delete": "Bạn có chắc chắn muốn xóa tài liệu này?",
    "mobile_field_document_alret_button_view": "Xem",
    "mobile_field_document_alert_error": "Đã xảy ra lỗi khi đính kèm tài liệu này. Vui lòng thử lại.",
    "mobile_field_document_alert_file_size_error": "Tệp không được vượt quá {{count}} MB.",
    "mobile_field_temperature_greater_range": "lớn hơn {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "lớn hơn hoặc bằng {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "nhỏ hơn {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "nhỏ hơn hoặc bằng {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "lớn hơn hoặc bằng {{ min_temp_value }} °{{ temp_unit }} và nhỏ hơn {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "lớn hơn hoặc bằng {{ min_temp_value }} °{{ temp_unit }} và nhỏ hơn hoặc bằng {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " và ",
    "mobile_field_text_limit_error": "Đã đạt giới hạn ký tự tối đa là 8000.",
    "mobile_forms_required_questions_complete": "Bắt buộc Hoàn thành",
    "mobile_forms_required_remaining": "{{count}} Bắt buộc Còn lại",
    "mobile_forms_required_questions_back": "Quay lại",
    "mobile_forms_required_questions_next": "Tiếp",
    "mobile_forms_required_questions_skip": "Bỏ qua",
    "mobile_forms_leaving_form": "Đang rời Biểu mẫu",
    "mobile_message_reordering_confirm": "Bạn có muốn lưu thứ tự câu hỏi mới không?",
    "mobile_forms_leaving_reordering": "Bỏ đổi thứ tự câu hỏi",
    "mobile_forms_reordering_button_save": "Lưu thứ tự câu hỏi mới",
    "mobile_forms_reordering_instructions": "Để đổi thứ tự câu hỏi hoặc phần, hãy kéo và thả đến vị trí trường cần hiển thị trong biểu mẫu",
    "mobile_toolbarnav_title_my_setttings": "Cài đặt của Tôi",
    "mobile_toolbarnav_title_profile_settings": "Cài đặt Hồ sơ",
    "mobile_toolbarnav_title_notification": "Cài đặt Thông báo",
    "mobile_toolbarnav_title_form_history": "Lịch sử Biểu mẫu",
    "mobile_toolbarnav_title_form_not_available": "Biểu mẫu Không Khả dụng",
    "mobile_toolbarnav_title_add_location": "Thêm Vị trí",
    "mobile_toolbarnav_title_add_task_or_project": "Thêm Tác vụ hoặc Dự án",
    "mobile_toolbarnav_title_select_location": "Chọn Vị trí",
    "mobile_toolbarnav_title_select_project": "Chọn dự án",
    "mobile_toolbarnav_title_select_tag": "Chọn Thẻ",
    "mobile_toolbarnav_title_select_user": "Chọn Người dùng",
    "mobile_toolbarnav_title_select_template": "Chọn Mẫu",
    "mobile_toolbarnav_title_select_one": "Chọn Một",
    "mobile_toolbarnav_title_select_multiple": "Chọn Một hoặc Nhiều",
    "mobile_toolbarnav_title_select_team": "Chọn Đội nhóm",
    "mobile_toolbarnav_title_select_team_or_location": "Chọn Đội nhóm hoặc Vị trí",
    "mobile_toolbarnav_title_filter_tasks": "Lọc Tác vụ",
    "mobile_toolbarnav_title_filter_projects": "Lọc Dự án",
    "mobile_toolbarnav_title_filter_project_tasks": "Lọc Tác vụ Dự án",
    "mobile_placeholder_search_bar": "Tìm kiếm",
    "mobile_placeholder_user_select_role": "Chọn Vai trò Người dùng",
    "mobile_placeholder_filter_by_team": "Lọc theo đội nhóm",
    "mobile_placeholder_assign_to_user_role": "Chỉ định cho Vai trò Người dùng",
    "mobile_placeholder_select": "-- Chọn --",
    "mobile_placeholder_account_location_name": "Tên Vị trí",
    "mobile_placeholder_tag_filter_by": "Lọc theo Thẻ Vị trí",
    "mobile_placeholder_user_type": "Chỉ định cho Người dùng",
    "mobile_placeholder_acount_type_loading": "Đang tải... ",
    "mobile_placeholder_therm_no_bluetooth": "Nhiệt độ",
    "mobile_placeholder_blue_therm_connecting": "Đang kết nối với thiết bị...",
    "mobile_placeholder_blue_therm_please_wait": "Vui lòng đợi...",
    "mobile_placeholder_blue_therm_tap": "Nhấn để đọc.",
    "mobile_placeholder_blue_therm_not_connected": "Không có kết nối.",
    "mobile_placeholder_testo_tap": "Giữ ▼ ▲ sau đó là ⬆",
    "mobile_message_error_create_task": "Bạn phải trực tuyến để thêm tác vụ.",
    "mobile_message_error_fill_out_form": "Vui lòng điền vào biểu mẫu này.",
    "mobile_message_error_fill_require_fields": "Điền vào các trường bắt buộc.",
    "mobile_message_error_stop_stopwatch_before_submit": "Dừng đồng hồ tính giờ của bạn trước khi gửi",
    "mobile_message_error_stopwatch_field_required": "Trường đồng hồ tính giờ là bắt buộc.",
    "mobile_message_error_stopwatch_field_running": "Trường đồng hồ tính giờ đang chạy",
    "mobile_message_error_invalid_equipment_temperature": "Nhiệt độ thiết bị không hợp lệ",
    "mobile_message_error_invalid_ingredient_temperature": "Nhiệt độ thành phần không hợp lệ",
    "mobile_message_error_location_attributes_unavailable": "Một số câu hỏi có thể không có sẵn, vui lòng kết nối internet",
    "mobile_message_alert_running_stopwatches": "Các đồng hồ tính giờ của bạn đang chạy.\n\nBạn có muốn xóa chúng không?",
    "mobile_message_blue_therm_error": "Mất Kết nối với Thiết bị Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Cần có quyền truy cập vị trí. Hãy bật quyền này trong phần cài đặt Android của bạn.",
    "mobile_message_blue_therm_no_permission_android": "Cần có quyền truy cập các thiết bị lân cận. Hãy bật quyền này trong phần cài đặt Android của bạn.",
    "mobile_message_blue_therm_error_code": "Kết nối Không thành công:",
    "mobile_message_blue_therm_error_bluetooth": "Vui lòng bật Bluetooth.",
    "mobile_message_blue_therm_error_device": "Không tìm thấy thiết bị.",
    "mobile_message_blue_therm_error_try_again": "Vui lòng Thử lại",
    "mobile_message_blue_therm_success": "Đã kết nối Thiết bị Bluetooth!",
    "mobile_message_bluetooth_device_press_button_field": "Nhấn nút trên thiết bị của bạn để kết nối.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Nhấn nút trên thiết bị của bạn<br />nếu bạn không thấy thiết bị được liệt kê ở đây.",
    "mobile_bluetooth_scan": "Quét",
    "mobile_bluetooth_scanning": "Đang quét",
    "mobile_message_drafts_confirm": "Bạn có muốn lưu nội dung này dưới dạng bản nháp không?",
    "mobile_message_drafts_toast_saved": "Bản nháp đã được Lưu.",
    "mobile_message_drafts_request_update": "Bạn có muốn cập nhật bản nháp này không?",
    "mobile_message_drafts_form_confirm": "Bạn có chắc chắn muốn xóa bản nháp này không?",
    "mobile_message_drafts_confirm_delete": "Xoá Bản nháp",
    "mobile_message_streams_error_switch": "Không thể thay đổi luồng trên web",
    "mobile_message_settings_success_saved": "Cài đặt đã Lưu",
    "mobile_message_settings_error": "Đã xảy ra lỗi không xác định. Thử lại sau",
    "mobile_message_profile_settings_error_fields": "Vui lòng sửa lại các trường được tô sáng.",
    "mobile_message_media_perimission_denied": "Bộ nhớ ",
    "mobile_message_media_perimission_denied_device": "Thiết bị của Bạn",
    "mobile_message_image_confirm_remove_image": "Bạn có chắc chắn muốn xóa ảnh này không?",
    "mobile_message_create_account_error_fields": "Vui lòng điền vào các trường được tô sáng.",
    "mobile_message_create_account_success_location_created": "Vị trí đã Tạo",
    "mobile_message_task_error_get_location": "Không nhận được vị trí. Sắp xếp theo ngày.",
    "mobile_message_typehead_confirm_save_message": "Bạn có muốn lưu các lựa chọn này không?",
    "mobile_message_typehead_confirm_save_title": "Lưu?",
    "mobile_message_task_creator_error_save_select_form": "Bạn phải chọn một biểu mẫu.",
    "mobile_message_task_creator_error_save_required_fields": "Vui lòng điền vào các trường bắt buộc.",
    "mobile_message_task_creator_error_save_batch_change": "Vui lòng thay đổi các tiêu chí để phù hợp với một hoặc nhiều người dùng",
    "mobile_message_task_detials_error_not_assigned_to_you": "Tác vụ này không được giao cho bạn.<br />Bạn không thể hoàn thành tác vụ này.",
    "mobile_message_task_detials_error_assigned_to": "Tác vụ này được giao cho {{user}}.<br />Bạn không thể hoàn thành tác vụ này.",
    "mobile_message_task_detials_confirm_title": "Đang rời Tác vụ",
    "mobile_message_task_detials_confirm_save_task": "Lưu Tác vụ",
    "mobile_message_task_detials_confirm_message": "Bạn có chắc không? Các thay đổi của bạn sẽ bị mất.",
    "mobile_message_task_detials_error_view_account": "Không thể Truy cập Vị trí.",
    "mobile_message_task_detials_error_submit_task": "Vui lòng thêm một ảnh để hoàn thành tác vụ này.",
    "mobile_message_task_detials_error_submit_task_project": "Không thể lưu dự án. Vui lòng thử lại sau.",
    "mobile_message_task_detials_wait_submit_task_created": "Đang tạo các tác vụ.<br />Vui lòng đợi vài phút để các tác vụ được đưa vào.",
    "mobile_message_task_detials_error_submit_task_pending": "Lỗi, vui lòng thử lại sau",
    "mobile_message_task_detials_success_task_complete": "Hoàn thành Tác vụ",
    "mobile_message_task_error_save_single_task": "Không thể lưu tác vụ. Vui lòng thử lại sau.",
    "mobile_message_task_success_save_single_task": "Tác vụ đã Tạo.",
    "mobile_message_show_error_message": "Đã xảy ra lỗi.",
    "mobile_message_show_success_message": "Thành công!",
    "mobile_message_show_offline_message": "Bạn hiện đang ngoại tuyến.",
    "mobile_message_show_permission_denied_message": "<b>Yêu cầu Quyền truy cập.</b> Vui lòng cấp quyền truy cập cho Zenput {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Yêu cầu quyền truy cập.</b> Vui lòng cấp quyền truy cập cho Zenput và trình duyệt của bạn {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Hiện đang Tải lên",
    "mobile_message_show_upload_in_progress_message": "Đang tải lên",
    "mobile_message_show_form_id_error": "Không thể truy cập biểu mẫu đã chỉ định.",
    "mobile_message_show_single_task_error": "Không thể truy cập tác vụ đã chỉ định.",
    "mobile_message_show_submissions_error": "Không thể truy hoạt động gửi được chỉ định.",
    "mobile_message_show_submissions_access_denied": "Rất tiếc, bạn không có quyền truy cập biểu mẫu này.",
    "mobile_message_send_data_success": "Đã tải dữ liệu lên ",
    "mobile_message_start_upload_success": "Tải lên Hoàn tất",
    "mobile_message_start_upload_error": "<b>Không thể hoàn tất tải lên.</b><br>Đã lưu hoạt động gửi. Vui lòng thử lại sau",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Cập nhật Có sẵn",
    "mobile_message_store_upgrade_confirm_message_one": "Vui lòng cập nhật ứng dụng Ops Execution từ ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Vui lòng cập nhật Zenput từ ",
    "mobile_message_store_upgrade_confirm_message_two": " để nhận được tất cả các tính năng và các bản sửa lỗi mới nhất",
    "mobile_message_store_upgrade_confirm_now": "Ngay bây giờ",
    "mobile_message_store_upgrade_confirm_later": "Để sau",
    "mobile_message_redirect_confirm_message": "Bạn hiện đang điền vào một biểu mẫu. Bạn có muốn lưu nội dung này dưới dạng bản nháp trước khi tiếp tục không?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Bạn có {{count}} bản nháp chưa được tải lên. Những nội dung này sẽ bị mất nếu bạn tiếp tục. Bạn có chắc không?",
    "mobile_message_draft_override_message": "Bản nháp này đã được lưu từ một thiết bị khác trên {{date}} và các thay đổi trên thiết bị này đang xung đột. Bạn có thể chọn ghi đè phiên bản hiện có hoặc tải lại phiên bản mới nhất và các thay đổi của bạn sẽ bị hủy.",
    "mobile_html_submitting": "Đang gửi...",
    "mobile_html_offline": "Bạn hiện đang ngoại tuyến!",
    "mobile_html_offline_try_again": "Bạn hiện đang ngoại tuyến. <br/><br/>Vui lòng thử lại khi bạn đã kết nối",
    "mobile_html_something_went_wrong": "Ồ không. Đã xảy ra lỗi.",
    "mobile_html_something_went_wrong_try_again": "Ồ không. Đã xảy ra lỗi. Vui lòng thử lại.",
    "mobile_html_failed_loading_roles": "Không thể tải vai trò.",
    "mobile_alert_please_install_for_native": "Vui lòng cài đặt ứng dụng Ops Execution để sử dụng tính năng này. ",
    "mobile_alert_please_install_for_native_old": "Vui lòng cài đặt ứng dụng Zenput gốc để sử dụng tính năng này.",
    "mobile_tso_filter_all_tasks": "Tất cả {{type}}",
    "mobile_tso_filter_my_tasks": "{{type}} của tôi",
    "mobile_tso_filter_due_date": "Ngày đến hạn",
    "mobile_tso_filter_date_completed": "Ngày hoàn thành",
    "mobile_tso_filter_completed": "Đã hoàn thành",
    "mobile_tso_filter_completed_late": "Hoàn thành muộn",
    "mobile_tso_filter_incomplete": "Chưa hoàn thành",
    "mobile_tso_filter_var_my_tasks": "{{type}} {{filter_type}} của tôi",
    "mobile_tso_filter_var_tasks_created_by_me": "{{type}} {{filter_type}} do tôi tạo",
    "mobile_tso_filter_var_all_tasks": "Tất cả {{type}} {{filter_type}}",
    "mobile_tso_type_follow_up_actions": "Hành động theo sát",
    "mobile_tso_type_all": "Nhiệm vụ và hành động theo sát",
    "mobile_tso_filter_var_at": " tại {{location}}",
    "mobile_tso_filter_group_date_due": ", được sắp xếp theo Ngày đến hạn",
    "mobile_tso_filter_group_distance": ", được nhóm theo Vị trí",
    "mobile_tso_filter_start_date": "Ngày bắt đầu",
    "mobile_tso_filter_none": "Không có",
    "mobile_pso_filter_all_projects": "Tất cả Dự án",
    "mobile_pso_filter_my_projects": "Dự án của Tôi",
    "mobile_pso_filter_active": "Hoạt động",
    "mobile_pso_filter_archived": "Đã lưu trữ",
    "mobile_pso_filter_recurring": "Định kỳ",
    "mobile_pso_filter_non_recurring": "Không định kỳ",
    "mobile_pso_filter_var_my_projects": "Dự án {{project_type}} {{active_description}} của Tôi",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Dự án do Tôi Tạo",
    "mobile_pso_filter_var_all_projects": "Tất cả {{project_type}} {{active_description}} Dự án",
    "mobile_empty_list_message_must_be_online": "Có vẻ như bạn đang ngoại tuyến. Vui lòng truy cập trực tuyến để xem tất cả kết quả.",
    "mobile_empty_list_message_no_submissions": "Không có Hoạt động gửi nào",
    "mobile_empty_list_message_no_activity": "Không có Hoạt động nào",
    "mobile_empty_list_message_no_tasks": "Không có Tác vụ nào",
    "mobile_empty_list_message_no_tasks_overdue": "Không có {{type}} nào quá hạn",
    "mobile_empty_list_message_no_accounts": "Không có Vị trí nào",
    "mobile_empty_list_message_no_projects": "Không có Dự án nào",
    "mobile_empty_list_message_no_results_found": "Không Tìm thấy Kết quả nào",
    "mobile_empty_list_message_no_forms_available": "Không có Biểu mẫu nào Khả dụng",
    "mobile_empty_list_message_connection_error": "Lỗi Kết nối<br />Vui lòng thử lại sau",
    "mobile_empty_list_message_dashboard_error": "Không thể Tải Bảng điều khiển",
    "mobile_empty_list_message_user_offline": "Bạn hiện đang ngoại tuyến",
    "mobile_action_sheet_media_gallery": "Thư viện ảnh",
    "mobile_action_sheet_cancel": "Huỷ bỏ",
    "mobile_image_preview_text": "Gỡ Ảnh",
    "mobile_mobileform_text": "Các Hoạt động gửi Trước đó",
    "mobile_mobileform_reorder_fields": "Đổi thứ tự câu hỏi",
    "mobile_mobileform_follow_up_actions": "Hành động tiếp theo",
    "mobile_mobileform_follow_up_actions_assign_title": "Chỉ định hành động theo sát",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Hãy thêm hành động theo sát dựa trên quan sát của bạn để đảm bảo các sự cố được giải quyết.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Thêm hành động theo sát",
    "mobile_mobileform_follow_up_actions_assign_button": "Chỉ định hành động theo sát",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Tiếp tục mà không chỉ định",
    "mobile_mobileform_follow_up_actions_dialog_title": "Tiếp tục mà không chỉ định hành động theo sát?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Nếu tiếp tục mà không chỉ định hành động theo sát nào, thì bạn sẽ không thể thêm hành động sau này.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Vẫn tiếp tục",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Đây là trường bắt buộc",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Quá nhiều ký tự",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Trường này không hợp lệ",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Có lỗi khi tải vị trí",
    "mobile_mobileform_add_follow_up_actions_error_users": "Có lỗi khi tải người dùng",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Thêm hành động theo sát",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Tiêu đề",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Mô tả",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Yêu cầu ảnh",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Ngày đến hạn",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Cập nhật hành động theo sát",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Xóa hành động theo sát?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Hành động sẽ bị xóa và không thể chỉ định.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Xóa hành động theo sát",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Bạn có chắc chắn muốn xóa Hành động theo sát này không?\n\nKhông thể hoàn tác thao tác này.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Tiếp tục đến hành động theo sát",
    "mobile_mobileform_follow_up_actions_completed_notification": "Hành động theo sát đã hoàn thành",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Hành động theo sát đã xóa",
    "mobile_mobileform_follow_up_actions_update_notification": "Hành động theo sát đã cập nhật",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Vui lòng thêm ảnh để hoàn thành hành động theo sát này",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Chuyển đến nội dung gửi",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Chuyển đến nguồn",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Nguồn",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Hoàn thành hành động theo sát",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Nếu bạn mở nội dung gửi, mọi ảnh và ghi chú chưa lưu sẽ bị mất.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Nếu bạn rời khỏi màn hình này, mọi ảnh và ghi chú chưa lưu sẽ bị mất.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Ở lại",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Mở nội dung gửi",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Nguồn mở",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Rời khỏi hành động theo sát này?",
    "mobile_mobileform_follow_up_actions_submission": "Nội dung gửi",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Hành động theo sát này được chỉ định cho {{user}}.<br />Bạn không thể hoàn thành hành động này.",
    "mobile_mobileform_follow_up_actions_leave_description": "Nếu bạn rời khỏi màn hình này, mọi thay đổi chưa lưu sẽ bị mất.",
    "mobile_mobileform_follow_up_actions_leave": "Rời đi",
    "mobile_forms_drafts_text": "Gỡ Bản nháp",
    "mobile_batch_estimate_user": "Người dùng",
    "mobile_batch_estimate_users": "Người dùng",
    "mobile_table_of_contents": "Mục lục",
    "mobile_table_of_contents_required": "Bắt buộc",
    "mobile_table_of_contents_optional": "Không bắt buộc",
    "mobile_dialog_alert_title": "Cảnh báo",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Thiết bị Bluetooth chưa được hỗ trợ trên Windows",
    "mobile_windows_deprecated_message_content_announcement": "Thông báo",
    "mobile_windows_deprecated_message_title": "Cần cập nhật ứng dụng",
    "mobile_windows_deprecated_message_description": "Hãy cài đặt ứng dụng Zenput mới trong Microsoft Store sớm nhất có thể để đảm bảo có các bản cập nhật chức năng quan trọng và trải nghiệm tối ưu khi dùng Zenput.",
    "mobile_dashboard_tcr_graph_name": "Tỉ lệ Hoàn thành Tác vụ",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 Tuần Trước",
    "mobile_dashboard_tcr_legend_company_average": "Mức trung bình của Công ty",
    "mobile_dashboard_tcr_legend_team_average": "Mức trung bình của Đội nhóm",
    "mobile_dashboard_tab_title_summary": "Tóm tắt",
    "mobile_dashboard_tab_title_activity": "Hoạt động",
    "mobile_dashboard_card_title_top_triggered_workflows": "Nhân tố Kích hoạt Hàng đầu",
    "mobile_dashboard_tab_title_info": "Thông tin",
    "mobile_dashboard_tab_project_audit": "Tuân thủ",
    "mobile_dashboard_card_task_stats_total": "Tổng cộng",
    "mobile_dashboard_top_item_header_week_of": "Tuần",
    "mobile_dashboard_card_filter_form_template_placeholder": "Tất cả Biểu mẫu",
    "mobile_dashboard_card_title_forms_top_nos": "\"Không\" thường xuyên",
    "mobile_dashboard_zenput_code_no_data_in_range": "Không có dữ liệu trong phạm vi thời gian này.",
    "mobile_dashboard_zenput_code_permission_denied": "Bạn không có quyền xem nội dung này.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Chọn một biểu mẫu nêu trên.",
    "mobile_dashboard_zenput_code_unknown_error": "Chúng tôi không thể hiển thị dữ liệu tại thời điểm này.",
    "mobile_dashboard_tap_to_retry": "Nhấn để Thử lại",
    "mobile_dashboard_reporting_delay_disclaimer": "Có thể mất đến 15 phút để cập nhật các tác vụ",
    "mobile_dashboard_configuration_down_state_postfix_msg": "đã được quản trị viên của bạn định cấu hình.",
    "mobile_tasks_tag": "các tác vụ",
    "mobile_workflows_tag": "nhân tố kích hoạt",
    "mobile_projects_tag": "các dự án định kỳ",
    "mobile_forms_tag": "biểu mẫu",
    "mobile_dashboard_card_ongoing_projects_title": "Các dự án đang Tiến hành",
    "mobile_dashboard_card_ongoing_projects_show_more": "Hiển thị Thêm",
    "mobile_dashboard_card_ongoing_projects_show_less": "Thu gọn",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Đi đến Dự án",
    "mobile_dashboard_card_title_recurring_projects": "Các Dự án Định kỳ",
    "mobile_dashboard_card_filter_daily": "Hàng ngày",
    "mobile_dashboard_card_filter_weekly": "Hàng tuần",
    "mobile_dashboard_card_filter_monthly": "Hàng tháng",
    "mobile_task_status_title_open": "Mở",
    "mobile_task_status_title_upcoming": "Sắp tới",
    "mobile_task_status_title_complete": "Hoàn thành",
    "mobile_task_status_title_processing": "Đang xử lý Hoạt động gửi",
    "mobile_task_status_title_complete_with_exceptions": "Hoàn thành với các Tác vụ Theo dõi hoặc Cảnh báo",
    "mobile_task_status_title_completed_late_with_exceptions": "Hoàn thành muộn kèm theo các Tác vụ hoặc Cảnh báo tiếp theo",
    "mobile_task_status_title_incomplete_and_closed": "Đã bỏ lỡ",
    "mobile_tasks_legend_modal_title": "Ghi chú",
    "mobile_tasks_legend_modal_footer_button_title": "Đóng",
    "mobile_common_assigned_to": "Đã giao cho",
    "mobile_common_created_by": "Được tạo bởi",
    "mobile_common_tasks_for": "Tác vụ dành cho",
    "mobile_common_go_back": "Quay lại",
    "mobile_oh_no": "Ôi, không!",
    "mobile_user_not_in_groups": "Xin lỗi, có vẻ như bạn không được chỉ định vào một đội nhóm. Hãy liên hệ với quản trị viên của bạn để có quyền truy cập vào bảng điều khiển của bạn.",
    "mobile_tasks_select_followers": "Chọn Người theo dõi",
    "mobile_tasks_assign_tasks": "Giao {{count}} Tác vụ",
    "mobile_tasks_add_followers": "Thêm Người theo dõi",
    "mobile_tasks_followers": "Người theo dõi",
    "mobile_tasks_delete_task": "Xoá Tác vụ",
    "mobile_tasks_create_task": "Tạo Tác vụ",
    "mobile_tasks_tab_title_comments": "Bình luận",
    "mobile_tasks_see_more": "Xem thêm",
    "mobile_projects_create_project": "Tạo Dự án",
    "mobile_common_button_send": "Gửi",
    "mobile_common_button_schedule": "Lên lịch",
    "mobile_announcements_create": "Tạo Thông báo",
    "mobile_announcements_read_rate": "{{opened_count}} trên {{recipients_count}} Đã mở",
    "mobile_announcements_empty_message": "Bạn chưa tạo bất kỳ thông báo nào! Hãy tạo một thông báo dưới đây để phát các tin tức, thông tin và cập nhật quan trọng tới tổ chức của bạn.",
    "mobile_announcement_message_placeholder": "Thêm một tin nhắn...",
    "mobile_announcement_title_placeholder": "Tiêu đề Thông báo",
    "mobile_announcement_leaving_announcement": "Đang rời Thông báo",
    "mobile_announcement_confirm_recipients_team": "Bạn có muốn phát thông báo này tới {{count}} người dùng trong {{teams}} đội nhóm được chọn không?",
    "mobile_announcement_confirm_recipients_role": "Bạn có muốn phát thông báo này tới {{count}} người dùng trong {{roles}} vai trò được chọn không?",
    "mobile_announcement_confirm_recipients_user": "Bạn có muốn phát thông báo này tới {{count}} người dùng không?",
    "mobile_announcement_confirm_scheduled": "Vào {{timestamp}}",
    "mobile_announcement_sending_announcement": "Đang gửi Thông báo",
    "mobile_announcement_send_to": "Gửi Tới",
    "mobile_announcement_sent_to": "Đã gửi Tới",
    "mobile_announcement_send_to_role": "Vai trò",
    "mobile_announcement_attachment_download": "Đang tải xuống {{filename}}",
    "mobile_announcement_attachment_validation_error": "Có thể thêm không quá {{maxCount}}tệp đính kèm",
    "mobile_announcement_details_sent": "Đã gửi",
    "mobile_announcement_details_total_recipients": "Tổng số Người nhận",
    "mobile_announcement_details_cancel": "Huỷ bỏ Thông báo",
    "mobile_announcement_details_not_editable": "Các thông báo chỉ chỉnh sửa được trong ứng dụng web Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Thông báo chỉ có thể được chỉnh sửa trên Zenput Web",
    "mobile_announcement_details_open_count": "Số người đã Mở",
    "mobile_announcement_details_open_rate": "Tỷ lệ Mở",
    "mobile_announcement_details_resend": "Gửi lại đến những người chưa mở",
    "mobile_announcement_confirm_resend": "{{count}} người dùng chưa đọc thông báo này. Bạn có muốn gửi lời nhắc không?",
    "mobile_announcement_confirm_resend_title": "Gửi Lời nhắc?",
    "mobile_announcement_recipients_opened": "Đã mở",
    "mobile_recipients_opened_empty_message": "Có vẻ như chưa có ai mở tin nhắn của bạn. Hãy quay lại sau để xem kết quả của bạn.",
    "mobile_announcement_recipients_unopened": "Chưa mở",
    "mobile_recipients_unopened_empty_message": "Tin tốt! Không có tin nhắn nào chưa mở!",
    "mobile_scheduled_announcements_delivery_section_header": "Thời gian Gửi",
    "mobile_scheduled_announcements_send_immediately_label": "Gửi ngay",
    "mobile_scheduled_announcements_scheduled_label": "Gửi tại một thời điểm cụ thể",
    "mobile_scheduled_announcements_scheduled_tab_label": "Đã lên lịch",
    "mobile_scheduled_announcements_dialog_header": "Huỷ bỏ Thông báo?",
    "mobile_scheduled_announcements_dialog_message": "Việc hủy thông báo của bạn sẽ khiến thông báo không được gửi và được xóa khỏi danh sách của bạn. Điều này không thể được hoàn tác. Để chỉnh sửa, hãy truy cập Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Bạn hiện không có thông báo đã lên lịch nào. Hãy lên lịch một thông báo để phát các tin tức, thông tin và cập nhật quan trọng tới tổ chức của bạn.",
    "mobile_scheduled_announcements_validation_error": "Thời gian gửi đi phải rơi vào sau {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Lên lịch Thông báo",
    "mobile_projects_auto_archive": "Lưu trữ Tự động",
    "mobile_common_unassigned": "Chưa được giao",
    "mobile_tasks_title_placeholder": "Tác vụ hoặc Biểu mẫu Mới",
    "mobile_projects_leaving_project": "Đang rời Dự án",
    "mobile_projects_save_project": "Lưu Dự án",
    "mobile_top_triggers_tasks": "Tác vụ đã Kích hoạt Hàng đầu",
    "mobile_top_triggers_alerts": "Cảnh báo đã Kích hoạt Hàng đầu",
    "mobile_projects_not_started": "Chưa bắt đầu",
    "mobile_empty_list_message_no_photos": "Không có ảnh nào",
    "mobile_webfilestore_message_error": "Vui lòng chọn loại tệp hợp lệ",
    "mobile_notifications_empty_title": "Không có thông báo nào",
    "mobile_notifications_empty_message": "Hoạt động liên quan đến tác vụ của bạn hoặc những công việc bạn tham gia sẽ xuất hiện tại đây.",
    "mobile_comments_comment_deleted": "Bình luận này đã bị xoá.",
    "mobile_comments_comment_placeholder": "Bình luận",
    "mobile_comments_task_submitted_at": "Đã gửi nộp tác vụ vào {{ date }} lúc {{ time }}",
    "mobile_comments_discard_comment_title": "Huỷ Bình luận?",
    "mobile_comments_discard_confirm_message": "Bạn có chắc không? Bình luận của bạn sẽ bị xoá.",
    "mobile_comments_delete_comment_title": "Xoá Bình luận?",
    "mobile_comments_delete_confirm_message": "Thao tác này không thể được hoàn tác.",
    "mobile_comments_delete_button": "Xoá Bình luận",
    "mobile_comments_delete_success_message": "Bình luận đã bị Xoá.",
    "mobile_comments_empty_message_tasks": "Chưa có bình luận nào \n Hãy bắt đầu một cuộc trò chuyện về tác vụ này.",
    "mobile_comments_empty_message_submissions": "Chưa có bình luận nào \n Hãy bắt đầu một cuộc trò chuyện về hoạt động gửi này.",
    "mobile_comments_empty_message_default": "Chưa có bình luận nào \n Hãy bắt đầu một cuộc trò chuyện",
    "mobile_comments_no_matching_users": "Không có người dùng nào phù hợp.",
    "mobile_comments_empty_users_to_notify": "Không có người dùng nào cần thông báo.",
    "mobile_comments_users_cant_view_message": "Những người dùng này không thể xem các bình luận này",
    "mobile_comments_users_to_notify_title": "Những người dùng cần được Thông báo",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} người dùng</a> sẽ được thông báo.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} người dùng</a> sẽ được thông báo.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@đề cập thêm</a> người dùng nữa để có thể thông báo cho họ.",
    "mobile_comments_mark_read": "Đánh dấu tất cả là đã đọc",
    "mobile_comments_author_mentioned_message": "đã đề cập đến bạn trong",
    "mobile_comments_author_commented_message": "đã bình luận vào",
    "mobile_view_pdf": "Xem PDF",
    "mobile_no_pdf_generated_message": "Không tìm thấy tệp PDF nào cho hoạt động gửi này. Bạn sẽ sớm nhận được một bản sao qua email.",
    "mobile_clipboard_copied_success": "Liên kết này đã được sao chép vào khay nhớ tạm của bạn.",
    "mobile_share_link": "Chia sẻ Liên kết",
    "mobile_zencam_share": "Chia sẻ",
    "mobile_zencam_view_details": "Xem chi tiết",
    "mobile_zencam_details_drawer_header": "Chi tiết",
    "mobile_zencam_submitted_by": "Người gửi",
    "mobile_zencam_form_title": "Tiêu đề biểu mẫu",
    "mobile_zencam_date_submitted": "Ngày gửi",
    "mobile_oil_quality_warning_message": "Dầu sắp hết hạn",
    "mobile_oil_quality_warning_message_subtitle": "Hãy lên kế hoạch thay dầu sớm",
    "mobile_oil_quality_failure_message": "Chất lượng dầu kém",
    "mobile_oil_quality_failure_message_subtitle": "Hãy thay dầu ngay lập tức",
    "mobile_sensors_set_up_gateway": "Thiết lập Cổng",
    "mobile_sensors_set_up_gateway_message": "Có vẻ như chưa có thiết bị nào được thiết lập. Hãy bắt đầu bằng cách thêm một cổng.",
    "mobile_sensors_gateway_plugged_in": "Đảm bảo rằng cổng của bạn đã được cắm vào ổ cắm điện",
    "mobile_sensors_add_device": "Thêm thiết bị",
    "mobile_sensors_name_this_gateway": "Đặt tên cho cổng này.",
    "mobile_sensors_name_this_sensor": "Đặt tên cho cảm biến này.",
    "mobile_sensors_device_barcode_information": "Quét Mã QR hoặc nhập Số ID và SC từ nhãn thiết bị",
    "mobile_sensors_device_eui_information": "Quét Mã QR hoặc nhập DevEUI từ nhãn thiết bị",
    "mobile_sensors_gateway_id_information": "Nhập ID nút từ nhãn Cổng nối",
    "mobile_sensors_id_number": "{{untranslatedID}} Số",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Mã",
    "mobile_sensors_sensors": "Cảm biến",
    "mobile_sensors_sensor_deveui_error": "Không thể lấy DevEUI từ QR. Vui lòng nhập thủ công.",
    "mobile_sensors_gateways": "Cổng",
    "mobile_sensors_add_sensor": "Thêm Cảm biến",
    "mobile_sensors_add_gateway": "Thêm Cổng",
    "mobile_sensor_placement_description": "Cảm biến này sẽ giám sát khu vực nào?",
    "mobile_sensors_equipment_placement": "Cảm biến này sẽ giám sát khu vực hoặc thiết bị nào?",
    "mobile_sensors_equipment": "Cảm biến này sẽ giám sát thiết bị nào?",
    "mobile_sensors_select_gateway_type": "Chọn loại cổng nối",
    "mobile_sensors_select_placement": "Chọn Vị trí",
    "mobile_sensors_select_equipment": "Chọn Thiết bị",
    "mobile_sensors_placement": "Vị trí",
    "mobile_sensors_nickname_tip": "Tên cảm biến được xác định theo biệt danh được chỉ định ở vị trí đã chọn.",
    "mobile_sensors_device_online": "Trực tuyến",
    "mobile_sensors_device_offline": "Ngoại tuyến",
    "mobile_sensors_scan_qrcode": "Quét Mã QR",
    "mobile_sensors_enter_manually": "Nhập Thủ công",
    "mobile_sensors_wizard_step_one": "Bước 1",
    "mobile_sensors_wizard_step_two": "Bước 2",
    "mobile_sensors_wizard_step_three": "Bước 3",
    "mobile_sensors_wizard_step_four": "Bước 4",
    "mobile_sensors_wizard_step_five": "Bước 5",
    "mobile_sensors_wizard_step_six": "Bước 6",
    "mobile_sensors_initializing": "Đang khởi tạo…",
    "mobile_sensors_nickname": "Biệt danh",
    "mobile_sensors_field_not_blank": "{{field}} không được để trống.",
    "mobile_sensors_nothing_to_see_here": "Không có gì để xem ở đây",
    "mobile_sensors_missing_integration": "Thiếu tích hợp cảm biến",
    "mobile_sensors_contact_zenput_admin": "Vui lòng liên hệ với quản trị viên Ops Execution của công ty bạn.",
    "mobile_sensors_contact_zenput_admin_old": "Vui lòng liên hệ quản trị viên Zenput của bạn.",
    "mobile_sensors_contact_manager": "Hãy liên hệ với người quản lý tài khoản của bạn để thêm cảm biến.",
    "mobile_sensors_device_success_message": "Có thể mất đến 15 phút để tải dữ liệu cảm biến",
    "mobile_sensors_last_reading": "Lần đọc Gần nhất",
    "mobile_sensors_remove_device": "Gỡ Thiết bị",
    "mobile_sensors_one_day": "1 Ngày",
    "mobile_sensors_one_week": "1 Tuần",
    "mobile_sensors_one_month": "1 Tháng",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6 tháng",
    "mobile_sensors_one_year": "1 Năm",
    "mobile_sensors_sensor_settings": "Cài đặt Cảm biến",
    "mobile_sensors_remove_confirm_message": "Bạn có chắc chắn muốn xóa thiết bị này không?\nĐiều này không thể hoàn tác.",
    "mobile_sensors_sensor": "Cảm biến",
    "mobile_sensors_no_equipment_linked": "Không có Thiết bị nào được kết nối",
    "mobile_sensor_cooldown_process": "Quy trình Làm nguội",
    "mobile_sensor_last_12_hours": "12 giờ qua",
    "mobile_sensor_start_cooldown_process": "Bắt đầu Quy trình Làm nguội Mới",
    "mobile_sensor_cooldown_process_title": "Quy trình Làm nguội Hai Giai đoạn",
    "mobile_sensor_cooldown_process_description": "Quy trình làm nguội 2 giai đoạn bao gồm hạ nhiệt thực phẩm từ lớn hơn {{ stage1_start_temperature }} xuống {{ stage1_end_temperature }} trong 2 giờ hoặc ít hơn, sau đó từ {{ stage1_end_temperature }} xuống {{ stage2_end_temperature }} trong 4 giờ hoặc ít hơn.",
    "mobile_sensor_cooldown_process_place_food": "Đặt sản phẩm thực phẩm vào tủ lạnh.",
    "mobile_sensor_cooldown_process_insert_sensor": "Cắm đầu dò cảm biến vào sản phẩm thực phẩm.",
    "mobile_sensor_cooldown_process_enter_information": "Nhập thông tin dưới đây.",
    "mobile_sensor_cooldown_process_food_product": "Sản phẩm Thực phẩm cần làm nguội",
    "mobile_sensor_cooldown_cool_down": "Làm nguội",
    "mobile_sensor_cooldown_select_sensor": "Chọn Cảm biến",
    "mobile_sensors_cooldown_start_cooldown": "Bắt đầu Quy trình Làm nguội",
    "mobile_sensors_cooldown_please_enter_food": "Vui lòng nhập một Sản phẩm Thực phẩm",
    "mobile_sensors_cooldown_please_select_sensor": "Vui lòng chọn một Cảm biến",
    "mobile_sensors_cooldown_status_in_progress": "Đang tiến hành",
    "mobile_sensors_cooldown_status_failed": "Không thành công",
    "mobile_sensors_cooldown_status_success": "Thành công",
    "mobile_sensors_cooldown_stage": "Giai đoạn",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Nhiệt độ bắt đầu nằm ngoài phạm vi",
    "mobile_sensors_cooldown_failed_cooldown_process": "Quy trình Làm nguội Không Thành công",
    "mobile_sensors_cooldown_cooldown_successful": "Làm nguội Thành công",
    "mobile_sensors_cooldown_started_cooldown_process": "Đã bắt đầu Quy trình Làm nguội",
    "mobile_sensors_cooldown_hour": "giờ",
    "mobile_sensors_cooldown_hour_plural": "giờ",
    "mobile_sensors_cooldown_minute": "phút",
    "mobile_minutes_plural": "phút",
    "mobile_sensors_last_reading_max_date": "> 1 năm trước",
    "mobile_sensors_minute_count_ago": "{{count}} phút trước",
    "mobile_sensors_minute_count_ago_plural": "{{count}} phút trước",
    "mobile_sensors_hour_count_ago": "{{count}} giờ trước",
    "mobile_sensors_hour_count_ago_plural": "{{count}} giờ trước",
    "mobile_sensors_day_count_ago": "{{count}} ngày trước",
    "mobile_sensors_day_count_ago_plural": "{{count}} ngày trước",
    "mobile_sensors_chart_settings": "Cài đặt biểu đồ",
    "mobile_announcement_banner_continue_reading": "Tiếp tục đọc",
    "mobile_compliance_submissions_report": "Báo cáo Bài nộp",
    "mobile_compliance_submissions_report_subtitle": "Xuất dữ liệu hoàn thành dự án cho cửa hàng này",
    "mobile_compliance_send_submissions": "Gửi bài nộp",
    "mobile_compliance_completion_rate_in_last_days": "Tỷ lệ hoàn thành trong {{ days }} ngày qua",
    "mobile_compliance_last_days": "{{ days }} Ngày qua",
    "mobile_compliance_send_submissions_to": "Gửi bài nộp tới",
    "mobile_compliance_send_to_different_email": "Gửi đến địa chỉ email khác",
    "mobile_compliance_email_input_placeholder": "Địa chỉ email",
    "mobile_compliance_send_submissions_to_legend_title": "Bài nộp",
    "mobile_compliance_send_submissions_to_legend_description_days": "Báo cáo với bài nộp từ địa điểm này trong {{ days }} ngày qua sẽ được gửi tới địa chỉ email đã chọn.",
    "mobile_compliance_time_frame": "Khung thời gian",
    "mobile_compliance_sensor_temperature_log_report": "Báo cáo Nhật ký Nhiệt độ Cảm biến",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Xuất nhật ký nhiệt độ cho cửa hàng này",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Tiêu chí",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Xác định tiêu chí cho báo cáo của bạn dưới đây.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Ghi chú: (Các) cảm biến bị vô hiệu hóa sẽ không hiển thị trong báo cáo",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Chọn khung thời gian. Dữ liệu nhật ký có giới hạn tối đa 30 ngày",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Gửi Báo cáo",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Tháng này (Ngày 1-Hôm nay)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Tháng trước",
    "mobile_compliance_sensor_temperature_log_email_title": "Gửi Báo cáo Tới",
    "mobile_pwa_update_prompt_title": "Cập nhật ứng dụng",
    "mobile_pwa_update_prompt_description": "Đã có phiên bản mới của ứng dụng. Vui lòng cập nhật lên phiên bản mới nhất.",
    "mobile_pwa_update_prompt_confirm": "Cập nhật và tải lại",
    "mobile_pwa_update_prompt_cancel": "Nhắc tôi sau",
    "notification_title_due_in_one_hour": "Đến hạn sau 1 giờ",
    "task_is_due_soon": "\"{{ task_title }}\" sắp đến hạn. Hãy dành thời gian để hoàn thành tác vụ đó.",
    "mobile_photo_quality_warning_header": "Sự cố với chất lượng ảnh",
    "mobile_photo_quality_dialog_message": "Ảnh này có thể quá tối hoặc mờ. Bạn muốn chụp ảnh mới hoặc tiếp tục sử dụng ảnh này?",
    "mobile_take_new_photo": "Chụp ảnh mới",
    "mobile_use_this_photo": "Sử dụng ảnh này"
}};
mobile_translations.km_KH = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "ទាំងអស់",
    "mobile_common_button_apply_filters": "ប្រើតម្រង",
    "mobile_common_button_done": "រួចរាល់",
    "mobile_common_button_edit": "កែសម្រួល",
    "mobile_common_button_archive": "ទុកក្នុងបណ្ណសារ",
    "mobile_common_button_save": "រក្សាទុក",
    "mobile_common_button_retake": "ធ្វើឡើងវិញ",
    "mobile_common_button_save_draft": "រក្សាទុកព្រាង",
    "mobile_common_button_discard": "លុបចោល",
    "mobile_common_button_submit": "ដាក់បញ្ជូន",
    "mobile_common_button_no": "ទេ",
    "mobile_common_button_yes": "បាទ/ចាស",
    "mobile_common_button_na": "គ្មាន",
    "mobile_common_created_by_me": "បានបង្កើតដោយខ្ញុំ",
    "mobile_common_email": "អ៊ីមែលក្រុមហ៊ុន",
    "mobile_common_first_name": "នាមត្រកូល",
    "mobile_common_last_name": "នាមខ្លួន",
    "mobile_common_location": "ទីតាំង",
    "mobile_common_locations": "ទីតាំង",
    "mobile_common_logout_message": "តើអ្នកប្រាកដជាចង់ចេញមែនទេ?",
    "mobile_common_password": "ពាក្យសម្ងាត់",
    "mobile_common_permission_required": "តម្រូវឱ្យមានការអនុញ្ញាត",
    "mobile_common_status": "ស្ថានភាព",
    "mobile_common_task": "កិច្ចការ",
    "mobile_common_tasks": "កិច្ចការ",
    "mobile_common_tasks_my": "កិច្ចការរបស់ខ្ញុំ",
    "mobile_common_projects": "គម្រោង",
    "mobile_common_filter_team": "ក្រុម",
    "mobile_common_filter_var_in": " ក្នុង {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "គ្មានការជ្រើសរើសក្រុម",
    "mobile_common_filter_no_user_selected": "គ្មានការជ្រើសរើសអ្នកប្រើប្រាស់ទេ",
    "mobile_common_filter_no_role_selected": "គ្មានការជ្រើសរើសតួនាទី",
    "mobile_common_placeholder_date": "កាលបរិច្ឆេទ",
    "mobile_common_message_task_creator_error_save": "<b>មិនអាចបង្កើតកិច្ចការបានទេ។</b>",
    "mobile_common_camera": "កាមេរ៉ា",
    "mobile_common_microphone": "មីក្រូហ្វូន",
    "mobile_common_for": "សម្រាប់",
    "mobile_common_reload": "ផ្ទុកឡើងវិញ",
    "mobile_common_override": "ត្រួតលើគ្នា",
    "mobile_common_notifications": "ការជូនដំណឹង",
    "mobile_common_chat_unavailable": "មិនអាចប្រើការជជែក​បានទេ។ សូមព្យាយាមម្ដងទៀតនៅពេលក្រោយ។",
    "mobile_common_chat_ending_dialog_title": "តើអ្នកបានបញ្ចប់ការសន្ទនានេះហើយឬនៅ?",
    "mobile_common_chat_ending_dialog_description": "សូមប្រាប់ឱ្យយើងដឹង ប្រសិនបើបញ្ហារបស់អ្នកត្រូវបានដោះស្រាយរួច ឬប្រសិនបើអ្នកគ្រាន់តែចង់បន្តនៅពេលក្រោយ។",
    "mobile_common_chat_ending_dialog_confirm": "បាទ/ចាស ខ្ញុំបានបញ្ចប់ហើយ",
    "mobile_common_chat_ending_dialog_cancel": "ខ្ញុំនឹងបន្តនៅពេលក្រោយ",
    "mobile_common_continue_editing": "បន្តកែ",
    "mobile_privacy_policy": "គោលការណ៍ឯកជនភាព",
    "wootric_recommend_target": "មិត្តភ័ក្តិ ឬមិត្តរួមការងារនៅក្នុងឧស្សាហកម្មរបស់អ្នក",
    "wootric_followup_detractor_question": "តើយើងអាចធ្វើការផ្លាស់ប្តូរអ្វីខ្លះដើម្បីឱ្យអ្នកផ្តល់ឱ្យយើងនូវចំណាត់ថ្នាក់ខ្ពស់ជាងនេះនៅពេលក្រោយ?",
    "wootric_followup_passive_question": "សូមអរគុណ! តើយើងអាចធ្វើអ្វីបាន ដើម្បីធ្វើឱ្យឧបករណ៍កាន់តែប្រសើរ?",
    "wootric_followup_promoter_question": "សូមអរគុណ! តើចំណុចត្រង់ណាដែលធ្វើឱ្យអ្នកចូលចិត្ត Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "សូមអរគុណ! តើអ្នកចូលចិត្ត Zenput លើចំណុចអ្វីខ្លះ?",
    "wootric_default_followup_question": "សូមអរគុណ! សូមយកចិត្តទុកដាក់ប្រាប់យើងពីមូលហេតុ?",
    "wootric_default_placeholder_text": "ជួយយើងដោយពន្យល់ពីពិន្ទុរបស់អ្នក។",
    "wootric_default_thankyou_text": "សូមអរគុណចំពោះការឆ្លើយតប និងមតិកែលម្អរបស់អ្នក!",
    "mobile_login_placeholder_login_as": "ចូលជាលេខសម្គាល់អ្នកប្រើប្រាស់",
    "mobile_login_button_forgot_password": "ភ្លេចពាក្យសម្ងាត់ឬ?",
    "mobile_login_button_sign_up": "បង្កើតគណនី",
    "mobile_login_button_finish_setup": "បញ្ចប់ការរៀបចំ",
    "mobile_login_button": "ចូល",
    "mobile_login_continue_button": "បន្ត",
    "mobile_login_continue_transition": "កំពុងនាំអ្នកទៅទំព័រចូលរបស់ស្ថាប័នរបស់អ្នក...",
    "mobile_login_no_email_error": "អ្នកត្រូវតែបញ្ចូលអ៊ីមែល។",
    "mobile_login_change_email": "ចូលដោយប្រើអ៊ីមែលផ្សេង",
    "mobile_login_with_sso": "ចូលគណនីដោយប្រើ SSO",
    "mobile_oauth_no_user_error_message": "អ្នកហាក់ដូចជាមិនមានគណនី Crunchtime Ops Execution នោះទេ!",
    "mobile_oauth_no_user_error_message_old": "អ្នកហាក់ដូចជាមិនមានគណនី Zenput នោះទេ!",
    "mobile_rebrand_announcement_banner": "ឥឡូវនេះ <b>Zenput</b> គឺជា <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} កំពុងក្លាយជា {{- product }} ក្នុងខែកញ្ញា {{- cta }}",
    "mobile_rebrand_warning_cta": "ស្វែងយល់អំពីរបៀបរៀបចំ។",
    "mobile_oauth_no_user_error_sub_message": "ទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក ដើម្បីចូលប្រើ ឬសាកល្បងចូលដោយប្រើអ៊ីមែលផ្សេង។",
    "mobile_oauth_generic_error_message": "ហាក់បីដូចជាមានបញ្ហាក្នុងការចូល សូមព្យាយាមម្តងទៀត។",
    "mobile_oauth_force_logout_msg": "ប្រសិនបើអ្នកនៅតែមានបញ្ហា សូមចាកចេញពីអ្នកផ្តល់សេវារបស់អ្នកដោយ ",
    "mobile_oauth_force_logout_click": "ការចុចនៅទីនេះ។",
    "mobile_sign_up_placeholder_phone": "លេខទូរសព្ទ",
    "mobile_sign_up_placeholder_password_confirm": "បញ្ជាក់ពាក្យសម្ងាត់",
    "mobile_sign_up_button_sign_in": "ចូល",
    "mobile_sign_up_disclaimer_part_1": "តាមរយៈការចុចបង្កើតគណនី អ្នកយល់ព្រមតាម",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "ប្រសិនបើចុច​ \"បញ្ចប់ការរៀបចំ\" មានន័យថាអ្នកយល់ព្រមតាម",
    "mobile_sign_up_disclaimer_link_title": " កិច្ចព្រមព្រៀងអាជ្ញាបណ្ណ",
    "mobile_sign_up_disclaimer_part_2": "ដែលរួមបញ្ចូលព័ត៌មានឯកជនភាពសំខាន់ៗ",
    "mobile_dialog_benefits_work_offline": "ធ្វើការដោយគ្មានអ៊ីនធឺណិត",
    "mobile_dialog_benefits_faster_uploads": "ការបង្ហោះកាន់តែលឿន",
    "mobile_dialog_benefits_better_experience": "បទពិសោធន៍ប្រើប្រាស់កាន់តែប្រសើរ",
    "mobile_dialog_benefits_button_download": "ទាញយក",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution សម្រាប់ ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput សម្រាប់ ",
    "mobile_dialog_benefits_button_have": "ខ្ញុំមានកម្មវិធី!",
    "mobile_dialog_benefits_button_no_thanks": "ទេ អរគុណ ប្រហែលពេលក្រោយ។",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "មិនអាចផ្ទុករូបភាពបានទេ។",
    "mobile_dialog_signature_sign": "ចុះហត្ថលេខានៅទីនេះ",
    "mobile_dialog_signature_button_clear": "សម្អាត",
    "mobile_account_placeholder_name": "ទីតាំង/ឈ្មោះហាង",
    "mobile_account_placeholder_phone": "ទូរសព្ទ",
    "mobile_account_placeholder_address": "អាសយដ្ឋាន",
    "mobile_account_placeholder_city": "ទីក្រុង",
    "mobile_account_placeholder_region": "តំបន់",
    "mobile_account_placeholder_zipcode": "កូដប្រៃសណីយ៍/ហ្ស៊ីប",
    "mobile_account_option_select_country": "ជ្រើសរើសប្រទេស",
    "mobile_account_oprion_us": "សហរដ្ឋអាមេរិក",
    "mobile_account_oprion_select_state": "ជ្រើសរើសរដ្ឋ",
    "mobile_account_button_create_location": "បង្កើតទីតាំង",
    "mobile_form_message_no_form": "មិនមានទម្រង់បែបបទទេ",
    "mobile_batch_task_message": "កំពុងផ្ទុក...",
    "mobile_settings_profile": "កម្រងព័ត៌មាន",
    "mobile_settings_profile_number": "ទូរសព្ទដៃ",
    "mobile_settings_profile_language": "ភាសា",
    "mobile_settings_profile_temperature_unit": "រង្វាស់សីតុណ្ហភាព",
    "mobile_settings_profile_use_company_default": "ប្រើលំនាំដើមរបស់ក្រុមហ៊ុន",
    "mobile_settings_profile_celsius": "អង្សាសេ",
    "mobile_settings_profile_fahrenheit": "ហ្វារិនហៃ",
    "mobile_settings_notifications_option_sms": "សារជាអក្សរ",
    "mobile_settings_notifications_option_push": "ការជូនដំណឹងជំរុញ",
    "mobile_settings_notifications_option_push_email": "អ៊ីមែល និងការជូនដំណឹងជំរុញ",
    "mobile_settings_notifications_option_do_not": "កុំជូនដំណឹង",
    "mobile_settings_notifications_category_communication": "ការប្រាស្រ័យទាក់ទង",
    "mobile_settings_notifications_category_forms_and_triggers": "ទម្រង់បែបបទ និងការបិទ/បើកដំណើរការ",
    "mobile_settings_devices": "ឧបករណ៍",
    "mobile_settings_notifications_sub_category_alerts": "ការជូនដំណឹង",
    "mobile_settings_notifications_sub_category_new_forms_available": "មានទម្រង់បែបបទថ្មី",
    "mobile_settings_notifications_sub_category_task_assigned": "បានកំណត់កិច្ចការ",
    "mobile_settings_notifications_sub_category_task_completed": "បានបញ្ចប់កិច្ចការ",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "ការរំលឹកថាកិច្ចការនឹងផុតកំណត់ឆាប់ៗនេះ",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "ការរំលឹកថាកិច្ចការផុតកំណត់",
    "mobile_settings_notifications_sub_category_sensor_alerts": "ការជូនដំណឹងអំពីឧបករណ៍ចាប់សញ្ញា",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "ការជូនដំណឹងសំខាន់ខ្លាំងអំពីសិនស័រ",
    "mobile_drafts_message": "អ្នកមិនមានព្រាងណាមួយនៅឡើយទេ។",
    "mobile_drafts_button_delete": "លុប",
    "mobile_tasks_filter_location_no": "គ្មានការជ្រើសរើសទីតាំងទេ",
    "mobile_tasks_filter_group_by": "ដាក់ជាក្រុមតាម",
    "mobile_tasks_filter_sort_by": "តម្រៀបតាម",
    "mobile_tasks_filter_sorted_by": "ត្រូវបានតម្រៀបតាម",
    "mobile_tasks_filter_due_time": "ពេលកំណត់",
    "mobile_tasks_filter_open_time": "ម៉ោងបើក",
    "mobile_tasks_bucket_due_next_24_hours": "ផុតកំណត់ 24 ម៉ោងទៀត",
    "mobile_tasks_bucket_due_next_7_days": "ផុតកំណត 7 ទៀត",
    "mobile_tasks_bucket_open_tasks": "ការបើកបន្ថែម {{type}}",
    "mobile_tasks_bucket_open_at": "បើក៖ {{- date }} នៅ {{- time }}",
    "mobile_tasks_bucket_due_by_at": "ផុតកំណត់ត្រឹម៖ {{- date }} នៅ {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "អាចប្រើបានក្នុងរយៈពេល 1 នាទីទៀត",
    "mobile_tasks_bucket_available_in_one_hour": "អាចប្រើបានក្នុងរយៈពេល 1 ម៉ោងទៀត",
    "mobile_tasks_bucket_available_in_one_day": "អាចប្រើបានក្នុងរយៈពេល 1 ថ្ងៃទៀត",
    "mobile_tasks_bucket_available_in_one_week": "អាចប្រើបានក្នុងរយៈពេល 1 សប្ដាហ៍ទៀត",
    "mobile_tasks_bucket_available_in_one_month": "អាចប្រើបានក្នុងរយៈពេល 1 ខែទៀត",
    "mobile_tasks_bucket_available_in_one_year": "អាចប្រើបានក្នុងរយៈពេល 1 ឆ្នាំទៀត",
    "mobile_tasks_bucket_available_in_minutes": "អាចប្រើបានក្នុងរយៈពេល {{ minutes }} នាទីទៀត",
    "mobile_tasks_bucket_available_in_hours": "អាចប្រើបានក្នុងរយៈពេល {{ hours }} ម៉ោងទៀត",
    "mobile_tasks_bucket_available_in_days": "អាចប្រើបានក្នុងរយៈពេល {{ days }} ថ្ងៃទៀត",
    "mobile_tasks_bucket_available_in_weeks": "អាចប្រើបានក្នុងរយៈពេល {{ weeks }} សប្ដាហ៍ទៀត",
    "notification_task_due_in_minutes": "ផុតកំណត់ក្នុងរយៈពេល {{ minutes }} នាទី",
    "mobile_tasks_bucket_available_in_months": "អាចប្រើបានក្នុងរយៈពេល {{ months }} ខែទៀត",
    "mobile_tasks_bucket_available_in_years": "អាចប្រើបានក្នុងរយៈពេល {{ years }} ឆ្នាំទៀត",
    "mobile_tasks_follow_up": "តាមដានកិច្ចការ",
    "mobile_tasks_due_soon": "ផុតកំណត់ឆាប់ៗនេះ",
    "mobile_tasks_bucket_completed_today": "បានបញ្ចប់នៅថ្ងៃនេះ",
    "mobile_tasks_bucket_completed_this_week": "បានបញ្ចប់នៅសប្ដាហ៍នេះ",
    "mobile_tasks_bucket_completed_last_week": "បានបញ្ចប់នៅសប្ដាហ៍មុន",
    "mobile_tasks_bucket_missed_today": "បានខកខាននៅថ្ងៃនេះ",
    "mobile_tasks_bucket_missed_this_week": "បានខកខាននៅសប្ដាហ៍នេះ",
    "mobile_tasks_bucket_missed_last_week": "បានខកខាននៅសប្ដាហ៍មុន",
    "mobile_tasks_bucket_no_location": "គ្មានទីតាំងទេ",
    "mobile_tasks_cannot_submit_missed": "មិនអាចបញ្ចប់កិច្ចការដែលខកខានបានទេ",
    "mobile_tasks_cannot_submit_missed_after": "មិនអាចបញ្ចប់កិច្ចការនេះបន្ទាប់ពី {{ date }} បានទេ",
    "mobile_tasks_cannot_submit_upcoming": "កិច្ចការនេះមិនបានចាប់ផ្ដើមទេ។",
    "mobile_tasks_cannot_submit_processing": "ការដាក់បញ្ជូននេះកំពុងដំណើរការ",
    "mobile_tasks_toolbarnav_header_no_due_date": "គ្មានកាលបរិច្ឆេទផុតកំណត់ទេ",
    "mobile_tasks_toolbarnav_header_overdue": "ផុតកំណត់",
    "mobile_tasks_toolbarnav_header_yesterday": "ម្សិលមិញ",
    "mobile_tasks_toolbarnav_header_today": "ថ្ងៃនេះ",
    "mobile_tasks_toolbarnav_header_tomorrow": "ថ្ងៃស្អែក",
    "mobile_tasks_toolbarnav_header_last_week": "សប្ដាហ៍មុន",
    "mobile_tasks_toolbarnav_header_this_week": "សប្ដាហ៍នេះ",
    "mobile_tasks_toolbarnav_header_next_week": "សប្ដាហ៍ក្រោយ",
    "mobile_tasks_toolbarnav_header_this_month": "ខែនេះ",
    "mobile_tasks_toolbarnav_header_next_year": "ឆ្នាំក្រោយ",
    "mobile_tasks_toolbarnav_header_over_year": "លើសពីមួយឆ្នាំ",
    "mobile_tasks_toolbarnav_title_edit_task": "កែសម្រួលកិច្ចការ",
    "mobile_task_placeholder_title": "ចំណងជើង *",
    "mobile_task_placeholder_description": "ការពណ៌នា (ជាជម្រើស)",
    "mobile_task_button_single_task": "កិច្ចការតែមួយ",
    "mobile_task_button_project": "គម្រោង",
    "mobile_task_button_create": "បង្កើត",
    "mobile_task_tab_basic": "មូលដ្ឋាន",
    "mobile_task_tab_photo": "រូបថត",
    "mobile_task_tab_form": "ទម្រង់បែបបទ",
    "mobile_task_details_description_message_please": "សូមបំពេញ ",
    "mobile_task_details_description_message_below": "ខាងក្រោម។",
    "mobile_task_details_description_message_instructions": "មិនមានការណែនាំសម្រាប់កិច្ចការនេះទេ។",
    "mobile_task_details_reason_title": "ការតាមដានដែលបានបិទ/បើកដំណើរការដោយ",
    "mobile_task_detials_button_goto_form": "ចូលទៅកាន់ទម្រង់បែបបទ",
    "mobile_task_detials_button_complete": " បញ្ចប់កិច្ចការ",
    "mobile_task_detials_completed": "បានបញ្ចប់ ",
    "mobile_task_detials_completed_by": "ដោយ ",
    "mobile_task_detials_completed_on": "​នៅ ",
    "mobile_task_details_view_form_submission": "មើលការដាក់បញ្ជូនទម្រង់បែបបទ",
    "mobile_task_task_updated": "បានធ្វើបច្ចុប្បន្នភាពកិច្ចការ",
    "mobile_task_task_archived": "បានទុកកិច្ចការក្នុងបណ្ណសារ",
    "mobile_task_task_deleted": "បានលុបកិច្ចការ",
    "mobile_task_error_archiving_task": "មិនអាចរក្សាទុកកិច្ចការក្នុងបណ្ណសារបានទេ។",
    "mobile_task_error_deleting_task": "មិនអាចលុបកិច្ចការបានទេ។",
    "mobile_task_error_updating_task": "មិនអាចធ្វើបច្ចុប្បន្នភាពកិច្ចការបានទេ។",
    "mobile_task_archive_task": "កិច្ចការដែលរក្សាទុកក្នុងបណ្ណសារ",
    "mobile_task_archive_task_confirm": "តើអ្នកប្រាកដជាចង់ទុកកិច្ចការនេះក្នុងបណ្ណសារឬ?\n\nកិច្ចការដែលបានទុកក្នុងបណ្ណសារនឹងរាប់បញ្ចូលអត្រាបញ្ចប់ ហើយនឹងបន្តបញ្ចូលក្នុងរបាយការណ៍។\n\nមិនអាចត្រឡប់វិញបានទេ។",
    "mobile_task_delete_task_confirm": "តើអ្នកប្រាកដជាចង់លុបកិច្ចការនេះមែនទេ?\n\nការងារដែលត្រូវបានលុបចោលនឹងមិនរាប់បញ្ចូលអត្រាបញ្ចប់ទេ ហើយក៏មិនត្រូវរាប់បញ្ចូលក្នុងរបាយការណ៍ណាមួយឡើយ។\n\nមិនអាចត្រឡប់វិញបានទេ។",
    "mobile_task_edition_already_in_progress": "កិច្ចការនេះមានការកែសម្រួលដែលមិនទាន់សម្រេច។ បច្ចុប្បន្ន ការកែសម្រួលបន្ថែមទៀតមិនត្រូវបានអនុញ្ញាតទេ។",
    "mobile_projects_filter_type": "ប្រភេទ",
    "mobile_projects_filter_status": "ស្ថានភាពគម្រោង",
    "mobile_projects_filter_project_type": "ប្រភេទគម្រោង",
    "mobile_projects_due_date_required": "តម្រូវឱ្យមានកាលបរិច្ឆេទផុតកំណត់។",
    "mobile_projects_team_required": "តម្រូវឱ្យមានក្រុម។",
    "mobile_projects_user_role_required": "តម្រូវឱ្យមានអ្នកទទួលការចាត់តាំង។",
    "mobile_projects_title_required": "តម្រូវឱ្យមានចំណងជើង។",
    "mobile_projects_recurring_multiple_tasks_per_day": "កិច្ចការច្រើនក្នុងមួយថ្ងៃ",
    "mobile_project_tasks_complete": " បញ្ចប់",
    "mobile_project_tasks_remaining": " ដែលនៅសល់",
    "mobile_esitmate_message_tasks": "កិច្ចការ 0 នឹងត្រូវបានបង្កើត",
    "mobile_esitmate_message_criteria": "លៃតម្រូវលក្ខណៈវិនិច្ឆ័យខាងលើ",
    "mobile_esitmate_message_created_for": "នឹងត្រូវបានបង្កើតសម្រាប់",
    "mobile_left_menu_dashboard": "ផ្ទាំងគ្រប់គ្រង",
    "mobile_left_menu_my_forms": "ទម្រង់បែបបទរបស់ខ្ញុំ",
    "mobile_left_menu_announcements": "សេចក្ដីជូនដំណឹង",
    "mobile_left_menu_my_submissions": "ការដាក់បញ្ជូនរបស់ខ្ញុំ",
    "mobile_left_menu_drafts": "ព្រាង",
    "mobile_left_menu_pending_uploads": "ការបង្ហោះដែលមិនទាន់សម្រេច",
    "mobile_left_menu_open": "បើកនៅក្នុងកម្មវិធី",
    "mobile_left_menu_settings": "ការកំណត់",
    "mobile_left_menu_log_out": "ចេញ",
    "mobile_left_menu_debug": "កែកំហុស",
    "mobile_left_menu_support": "ជំនួយ",
    "mobile_left_menu_documentation": "ការចងក្រងឯកសារ",
    "mobile_left_menu_chat": "ការជជែក",
    "mobile_field_textarea_placeholder_note": "ចំណាំ ឬចំណងជើង",
    "mobile_field_option_select": "ជ្រើសរើស",
    "mobile_field_text_placeholder_text": "សារ",
    "mobile_field_email_placehoder_email": "អ៊ីមែល",
    "mobile_filed_number_placeholder_number": "លេខ",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "មិនបានភ្ជាប់",
    "mobile_field_sensor_offline_battery": "សិនស័រគ្មានអ៊ីនធឺណិត - ថ្ម",
    "mobile_field_video_button_add": "បញ្ចូលវីដេអូ",
    "mobile_field_video_picker_dialog_title": "បញ្ចូលវីដេអូពី",
    "mobile_field_video_button_change": "ផ្លាស់ប្ដូរវីដេអូ",
    "mobile_field_image_button_add": "បញ្ចូលរូបភាព",
    "mobile_field_image_low_quality_warning": "រូបថតមួយចំនួនអាចនឹងងងឹត ឬព្រិល។ សូមពិនិត្យមើលរូបថតដែលបានសម្គាល់ និងជំនួសពួកវាប្រសិនបើចាំបាច់",
    "mobile_field_image_picker_dialog_title": "បញ្ចូលរូបថតពី",
    "mobile_field_image_picker_edit_failed": "យើងមិនអាចរក្សាទុករូបភាពនេះបានទេ។ សូមព្យាយាមម្តងទៀត។",
    "mobile_field_signature_button_add": "បញ្ចូលហត្ថលេខា",
    "mobile_field_signature_button_change": "ផ្លាស់ប្ដូរហត្ថលេខា",
    "mobile_field_account_select_location": "ជ្រើសរើសទីតាំង",
    "mobile_field_account_prefill": "ទម្រង់បែបបទបំពេញជាមុនជាមួយទិន្នន័យពីការចូលមើលលើកចុងក្រោយឬ?",
    "mobile_field_account_message_overwrite": "វានឹងសរសេរជាន់លើចន្លោះបញ្ចូលដែលអ្នកបានបំពេញរួចហើយ។",
    "mobile_forms_task_on_behalf": "មានកិច្ចការដែលត្រូវបំពេញនៅទីតាំងនេះដែលត្រូវបានចាត់តាំងទៅឱ្យ <b>{{user}}</b>។ តើអ្នកចង់បញ្ចប់កិច្ចការនេះទេ?",
    "mobile_forms_complete_task": "បញ្ចប់កិច្ចការឬ?",
    "mobile_field_account_prefill_button_yes": "បាទ/ចាស៎ បំពេញជាមុន",
    "mobile_field_barcode_placeholder_scan": "ស្កេន ឬវាយបញ្ចូលបារកូដ",
    "mobile_field_sensor_qr_code_placeholder_scan": "ស្កេន ឬវាយបញ្ចូលកូដ",
    "mobile_field_gateway_id_code_placeholder": "វាយបញ្ចូលលេខសម្គាល់ណត",
    "mobile_field_scan_qr_or_enter_dev_eui": "ស្កេនកូដ QR ឬបញ្ចូល DevEUI",
    "mobile_field_scan_qr_or_enter_id": "ស្កេនកូដ QR ឬបញ្ចូលលេខ ID",
    "mobile_field_scan_qr_or_enter_sc": "ស្កេនកូដ QR ឬបញ្ចូលកូដ SC",
    "mobile_field_barcode_select_date": "ជ្រើសរើសកាលបរិច្ឆេទ ",
    "mobile_field_datetime_allow_time": "ម៉ោង",
    "mobile_field_stopwatch_button_caption": "​ម៉ោងរាប់ទៅមុខ",
    "mobile_field_stopwatch_common_start": "ចាប់ផ្តើម",
    "mobile_field_stopwatch_common_stop": "បញ្ឈប់",
    "mobile_field_stopwatch_common_reset": "កំណត់ឡើងវិញ",
    "mobile_field_stopwatch_stop_stopwatches": "បញ្ឈប់ម៉ោងរាប់ទៅមុខ",
    "mobile_field_document_title": "បញ្ចូលឯកសារ",
    "mobile_field_document_message_delete": "តើអ្នកប្រាកដជាចង់លុបឯកសារនេះចេញឬ?",
    "mobile_field_document_alret_button_view": "មើល",
    "mobile_field_document_alert_error": "មានបញ្ហាក្នុងការភ្ជាប់ឯកសារនេះ។ សូមព្យាយាមម្តងទៀត។",
    "mobile_field_document_alert_file_size_error": "ឯកសារមិនអាចលើសពី {{count}} MB ទេ។",
    "mobile_field_temperature_greater_range": "ធំជាង {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "ធំជាង ឬស្មើ {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "តិចជាង {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "តិចជាង ឬស្មើ {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "ធំជាង ឬស្មើ {{ min_temp_value }} °{{ temp_unit }} ហើយតិចជាង {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "ធំជាង ឬស្មើ {{ min_temp_value }} °{{ temp_unit }} និងតូចជាង ឬស្មើ {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " និង ",
    "mobile_field_text_limit_error": "បានឈានដល់ដែនកំណត់អក្សរអតិបរមា 8000 តួហើយ។",
    "mobile_forms_required_questions_complete": "តម្រូវឱ្យបំពេញ",
    "mobile_forms_required_remaining": "តម្រូវឱ្យបញ្ចូល {{count}} ដែលនៅសល់",
    "mobile_forms_required_questions_back": "ត្រឡប់ក្រោយ",
    "mobile_forms_required_questions_next": "បន្ទាប់",
    "mobile_forms_required_questions_skip": "រំលង",
    "mobile_forms_leaving_form": "ចាកចេញពីទម្រង់បែបបទ",
    "mobile_message_reordering_confirm": "តើអ្នកចង់រក្សាទុកលំដាប់លំដោយថ្មីនៃសំណួរទេ?",
    "mobile_forms_leaving_reordering": "កំពុងចាកចេញពីការតម្រៀបសំណួរឡើងវិញ",
    "mobile_forms_reordering_button_save": "រក្សាទុកលំដាប់លំដោយថ្មីនៃសំណួរ",
    "mobile_forms_reordering_instructions": "ដើម្បីតម្រៀបសំណួរ ឬផ្នែកឡើងវិញ ចូរអូសហើយទម្លាក់នៅកន្លែងដែលកន្លែងបញ្ចូលគួរតែបង្ហាញនៅក្នុងទម្រង់បែបបទ",
    "mobile_toolbarnav_title_my_setttings": "ការកំណត់របស់ខ្ញុំ",
    "mobile_toolbarnav_title_profile_settings": "ការកំណត់កម្រងព័ត៌មាន",
    "mobile_toolbarnav_title_notification": "ការ​កំណត់​ការ​ជូនដំណឹង",
    "mobile_toolbarnav_title_form_history": "ប្រវត្តិទម្រង់បែបបទ",
    "mobile_toolbarnav_title_form_not_available": "មិនមានទម្រង់បែបបទទេ",
    "mobile_toolbarnav_title_add_location": "បញ្ចូលទីតាំង",
    "mobile_toolbarnav_title_add_task_or_project": "បញ្ចូលកិច្ចការ ឬគម្រោង",
    "mobile_toolbarnav_title_select_location": "ជ្រើសរើសទីតាំង",
    "mobile_toolbarnav_title_select_project": "ជ្រើសរើសគម្រោង",
    "mobile_toolbarnav_title_select_tag": "ជ្រើសរើសស្លាក",
    "mobile_toolbarnav_title_select_user": "ជ្រើសរើសអ្នកប្រើប្រាស់",
    "mobile_toolbarnav_title_select_template": "ជ្រើសរើសទម្រង់គំរូ",
    "mobile_toolbarnav_title_select_one": "ជ្រើសរើសមួយ",
    "mobile_toolbarnav_title_select_multiple": "ជ្រើសរើសមួយ ឬច្រើន",
    "mobile_toolbarnav_title_select_team": "ជ្រើសរើសក្រុម",
    "mobile_toolbarnav_title_select_team_or_location": "ជ្រើសរើសក្រុម ឬទីតាំង",
    "mobile_toolbarnav_title_filter_tasks": "ត្រងកិច្ចការ",
    "mobile_toolbarnav_title_filter_projects": "ត្រងគម្រោង",
    "mobile_toolbarnav_title_filter_project_tasks": "ត្រងកិច្ចការគម្រោង",
    "mobile_placeholder_search_bar": "ស្វែងរក",
    "mobile_placeholder_user_select_role": "ជ្រើសរើសតួនាទីអ្នកប្រើប្រាស់",
    "mobile_placeholder_filter_by_team": "ត្រងតាមក្រុម",
    "mobile_placeholder_assign_to_user_role": "ចាត់តាំងទៅតួនាទីអ្នកប្រើប្រាស់",
    "mobile_placeholder_select": "-- ជ្រើសរើស --",
    "mobile_placeholder_account_location_name": "ឈ្មោះទីតាំង",
    "mobile_placeholder_tag_filter_by": "ត្រងតាមស្លាកទីតាំង",
    "mobile_placeholder_user_type": "ចាត់តាំងទៅអ្នកប្រើប្រាស់",
    "mobile_placeholder_acount_type_loading": "កំពុងផ្ទុក... ",
    "mobile_placeholder_therm_no_bluetooth": "សីតុណ្ហភាព",
    "mobile_placeholder_blue_therm_connecting": "កំពុងភ្ជាប់ទៅឧបករណ៍...",
    "mobile_placeholder_blue_therm_please_wait": "សូមរង់ចាំ...",
    "mobile_placeholder_blue_therm_tap": "ចុច ដើម្បីអាន។",
    "mobile_placeholder_blue_therm_not_connected": "មិនបានតភ្ជាប់។",
    "mobile_placeholder_testo_tap": "សង្កត់ ▼▲ បន្ទាប់មក ⬆",
    "mobile_message_error_create_task": "អ្នកត្រូវតែមានអ៊ីនធឺណិត ដើម្បីបញ្ចូលកិច្ចការ។",
    "mobile_message_error_fill_out_form": "សូមបំពេញទម្រង់បែបបទ។",
    "mobile_message_error_fill_require_fields": "បំពេញចន្លោះដែលត្រូវបំពេញ។",
    "mobile_message_error_stop_stopwatch_before_submit": "បញ្ឈប់ម៉ោងរាប់ទៅមុខរបស់អ្នកមុនពេលដាក់បញ្ជូន",
    "mobile_message_error_stopwatch_field_required": "តម្រូវឱ្យបំពេញចន្លោះម៉ោងរាប់ទៅមុខ",
    "mobile_message_error_stopwatch_field_running": "ចន្លោះម៉ោងរាប់ទៅមុខកំពុងដំណើរការ",
    "mobile_message_error_invalid_equipment_temperature": "សីតុណ្ហភាពឧបករណ៍មិនត្រឹមត្រូវ",
    "mobile_message_error_invalid_ingredient_temperature": "សីតុណ្ហភាពធាតុផ្សំមិនត្រឹមត្រូវ",
    "mobile_message_error_location_attributes_unavailable": "សំណួរមួយចំនួនប្រហែលជាមិនមានទេ សូមភ្ជាប់អ៊ីនធឺណិត",
    "mobile_message_alert_running_stopwatches": "អ្នកកំពុងដំណើរការម៉ោងរាប់ទៅមុខ។\n\nតើអ្នកចង់សម្អាតវាទេ?",
    "mobile_message_blue_therm_error": "គ្មានការតភ្ជាប់ទៅឧបករណ៍ប៊្លូ​ធូ​សទេ",
    "mobile_message_blue_therm_no_permission_android_pre_12": "តម្រូវឱ្យមានសិទ្ធិចូលប្រើលើទីតាំង។ បើកដំណើរការវានៅក្នុងការកំណត់ Android របស់អ្នក។",
    "mobile_message_blue_therm_no_permission_android": "តម្រូវឱ្យមានសិទ្ធិចូលប្រើលើឧបករណ៍នៅក្បែរ។ បើកដំណើរការវានៅក្នុងការកំណត់ Android របស់អ្នក។",
    "mobile_message_blue_therm_error_code": "មិនអាចភ្ជាប់បានទេ៖",
    "mobile_message_blue_therm_error_bluetooth": "សូមបើកប៊្លូ​ធូ​ស។",
    "mobile_message_blue_therm_error_device": "រកមិនឃើញឧបករណ៍។",
    "mobile_message_blue_therm_error_try_again": "សូមព្យាយាមម្តងទៀត",
    "mobile_message_blue_therm_success": "បានភ្ជាប់ឧបករណ៍ប៊្លូ​ធូ​ស!",
    "mobile_message_bluetooth_device_press_button_field": "ចុចប៊ូតុងលើឧបករណ៍របស់អ្នក ដើម្បីភ្ជាប់។",
    "mobile_message_bluetooth_device_press_button_devices_list": "ចុចប៊ូតុងលើឧបករណ៍<br />របស់អ្នក ប្រសិនបើអ្នកមិនឃើញមានក្នុងបញ្ជីនៅទីនេះ។",
    "mobile_bluetooth_scan": "ស្កេន",
    "mobile_bluetooth_scanning": "កំពុងស្កេន",
    "mobile_message_drafts_confirm": "តើអ្នកចង់រក្សាទុកវាជាព្រាងទេ?",
    "mobile_message_drafts_toast_saved": "បានរក្សាទុកព្រាង។",
    "mobile_message_drafts_request_update": "តើអ្នកចង់ធ្វើបច្ចុប្បន្នភាពព្រាងនេះទេ?",
    "mobile_message_drafts_form_confirm": "តើអ្នកពិតជាចង់លុបព្រាងនេះមែនឬ?",
    "mobile_message_drafts_confirm_delete": "លុបព្រាង",
    "mobile_message_streams_error_switch": "មិនអាចផ្លាស់ប្តូរកាផ្សាយនៅលើបណ្ដាញបានទេ",
    "mobile_message_settings_success_saved": "បានរក្សាទុកការកំណត់",
    "mobile_message_settings_error": "មានបញ្ហា​មិនស្គាល់បាន​កើតឡើង។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ",
    "mobile_message_profile_settings_error_fields": "សូមកែតម្រូវចន្លោះដែលបាន​រំលេច។",
    "mobile_message_media_perimission_denied": "របស់អ្នក ",
    "mobile_message_media_perimission_denied_device": "ទំហំផ្ទុកឧបករណ៍",
    "mobile_message_image_confirm_remove_image": "តើអ្នកប្រាកដជាចង់លុបរូបថតនេះចេញឬ?",
    "mobile_message_create_account_error_fields": "សូមបំពេញចន្លោះដែលបានរំលេច។",
    "mobile_message_create_account_success_location_created": "បានបង្កើតទីតាំង",
    "mobile_message_task_error_get_location": "មិនអាចយកទីតាំងបានទេ។ តម្រៀមតាមកាលបរិច្ឆេទ។",
    "mobile_message_typehead_confirm_save_message": "តើអ្នកចង់រក្សាទុកការជ្រើសរើសទាំងនេះទេ?",
    "mobile_message_typehead_confirm_save_title": "រក្សាទុកឬ?",
    "mobile_message_task_creator_error_save_select_form": "អ្នកត្រូវតែជ្រើសរើសទម្រង់បែបបទមួយ។",
    "mobile_message_task_creator_error_save_required_fields": "សូមបំពេញចន្លោះដែលត្រូវបំពេញ។",
    "mobile_message_task_creator_error_save_batch_change": "សូមប្តូរលក្ខណៈវិនិច្ឆ័យ ដើម្បីឱ្យត្រូវជាមួយអ្នកប្រើប្រាស់ម្នាក់ ឬច្រើន",
    "mobile_message_task_detials_error_not_assigned_to_you": "កិច្ចការនេះមិនត្រូវបានចាត់តាំងឱ្យអ្នកទេ។<br />អ្នកមិនអាចបញ្ចប់វាបានទេ។",
    "mobile_message_task_detials_error_assigned_to": "កិច្ចការនេះត្រូវបានចាត់តាំងឱ្យ {{user}}។<br />អ្នកមិនអាចបញ្ចប់វាបានទេ។",
    "mobile_message_task_detials_confirm_title": "កំពុងចាកចេញពីកិច្ចការ",
    "mobile_message_task_detials_confirm_save_task": "រក្សាទុកកិច្ចការ",
    "mobile_message_task_detials_confirm_message": "តើអ្នកប្រាកដហើយឬនៅ? ការផ្លាស់ប្តូររបស់អ្នកនឹងត្រូវបាត់បង់។",
    "mobile_message_task_detials_error_view_account": "មិនអាចចូលប្រើទីតាំងបានទេ។",
    "mobile_message_task_detials_error_submit_task": "សូមបញ្ចូលរូបថត ដើម្បីបញ្ចប់កិច្ចការនេះ។",
    "mobile_message_task_detials_error_submit_task_project": "មិនអាចរក្សាទុកគម្រោងនេះបានទេ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
    "mobile_message_task_detials_wait_submit_task_created": "កិច្ចការត្រូវបានបង្កើតឡើង។<br />សូមរង់ចាំពីរបីនាទី ដើម្បីបញ្ចូលកិច្ចការដោយស្វ័យប្រវត្តិ។",
    "mobile_message_task_detials_error_submit_task_pending": "មានបញ្ហា សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ",
    "mobile_message_task_detials_success_task_complete": "បញ្ចប់កិច្ចការ",
    "mobile_message_task_error_save_single_task": "មិនអាចរក្សាទុកកិច្ចការនេះបានទេ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
    "mobile_message_task_success_save_single_task": "បានបង្កើតកិច្ចការ។",
    "mobile_message_show_error_message": "មានអ្វីមួយខុសប្រក្រតី។",
    "mobile_message_show_success_message": "ជោគជ័យ!",
    "mobile_message_show_offline_message": "ថ្មីៗនេះអ្នកមិនមានអ៊ីនធឺណិតទេ។",
    "mobile_message_show_permission_denied_message": "<b>តម្រូវ​ឱ្យ​មាន​ការ​អនុញ្ញាត។</b> សូមផ្តល់ការអនុញ្ញាតឱ្យ Zenput ចូលប្រើ {{permission_name}}។",
    "mobile_message_show_permission_denied_message_web": "<b>តម្រូវ​ឱ្យ​មាន​ការ​អនុញ្ញាត។</b> សូមផ្តល់ការអនុញ្ញាតឱ្យ Zenput និងកម្មវិធីរុករកតាមអ៊ីនធឺណិតរបស់អ្នកចូលប្រើ {{permission_name}}។",
    "mobile_message_show_begin_uploading_message": "ឥឡូវកំពុងបង្ហោះ",
    "mobile_message_show_upload_in_progress_message": "ការបង្ហោះកំពុងដំណើរការរួចហើយ",
    "mobile_message_show_form_id_error": "មិនអាចចូលប្រើទម្រង់បែបបទដែលបានបញ្ជាក់នោះទេ។",
    "mobile_message_show_single_task_error": "មិនអាចចូលប្រើកិច្ចការដែលបានបញ្ជាក់នោះទេ។",
    "mobile_message_show_submissions_error": "មិនអាចចូលប្រើការដាក់បញ្ជូនដែលបានបញ្ជាក់នោះទេ។",
    "mobile_message_show_submissions_access_denied": "សូមអភ័យទោស អ្នកមិនមានសិទ្ធិចូលប្រើទម្រង់បែបបទនេះទេ។",
    "mobile_message_send_data_success": "បានបង្ហោះទិន្នន័យ ",
    "mobile_message_start_upload_success": "បញ្ចប់ការបង្ហោះ",
    "mobile_message_start_upload_error": "<b>មិនអាចបញ្ចប់ការបង្ហោះបានទេ។</b><br>បានរក្សាទុកការដាក់បញ្ជូន។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "មានការដំឡើងកំណែ",
    "mobile_message_store_upgrade_confirm_message_one": "សូមធ្វើបច្ចុប្បន្នកម្មកម្មវិធី Ops Execution ចេញពី ",
    "mobile_message_store_upgrade_confirm_message_one_old": "សូមដំឡើងកំណែ Zenput ពី ",
    "mobile_message_store_upgrade_confirm_message_two": " ដើម្បីទទួលបានលក្ខណៈពិសេសថ្មីបំផុត និងការកែកំហុសផ្សេងៗ",
    "mobile_message_store_upgrade_confirm_now": "ឥឡូវនេះ",
    "mobile_message_store_upgrade_confirm_later": "ពេលក្រោយ",
    "mobile_message_redirect_confirm_message": "ថ្មីៗនេះអ្នកបានបំពេញទម្រង់បែបបទ។ តើអ្នកចង់រក្សាទុកវាជាព្រាងមុនពេលបន្តដំណើរការទេ?",
    "mobile_message_log_out_confirm_unsynced_drafts": "អ្នកមាន {{count}} ព្រាងដែលអ្នកមិនបានបង្ហោះ។ ព្រាងទាំងនោះនឹងបាត់បង់ ប្រសិនបើអ្នកបន្ត។ តើអ្នកប្រាដកហើយឬនៅ?",
    "mobile_message_draft_override_message": "ព្រាងនេះត្រូវបានរក្សាទុកពីឧបករណ៍មួយផ្សេងទៀតលើ {{date}} ហើយមានបញ្ហាចំពោះការផ្លាស់ប្តូរនៅលើឧបករណ៍នេះ។ អ្នកអាចជ្រើសរើសបដិសេធកំណែដែលមានស្រាប់ ឬផ្ទុកឡើងវិញទៅកំណែថ្មីបំផុត នោះការផ្លាស់ប្តូររបស់អ្នកនឹងត្រូវបានលុបចោល។",
    "mobile_html_submitting": "កំពុងដាក់បញ្ជូន...",
    "mobile_html_offline": "បច្ចុប្បន្ន អ្នកមិនមានអ៊ីនធឺណិតទេ!",
    "mobile_html_offline_try_again": "បច្ចុប្បន្នអ្នកមិនមានអ៊ីនធឺណិតទេ។ <br/><br/>សូមព្យាយាមម្តងទៀតនៅពេលដែលអ្នកបានភ្ជាប់។",
    "mobile_html_something_went_wrong": "អូ។ មាន​អ្វី​មួយ​ខុស​ប្រក្រតី។",
    "mobile_html_something_went_wrong_try_again": "អូ។ មាន​អ្វី​មួយ​ខុស​ប្រក្រតី។ សូមព្យាយាមម្តងទៀត។",
    "mobile_html_failed_loading_roles": "មិនអាចផ្ទុកតួនាទីបានទេ។",
    "mobile_alert_please_install_for_native": "សូមដំឡើងកម្មវិធី Ops Execution ដើម្បីប្រើប្រាស់មុខងារនេះ។ ",
    "mobile_alert_please_install_for_native_old": "សូមដំឡើងកម្មវិធីដើម Zenput ដើម្បីប្រើប្រាស់មុខងារនេះ។",
    "mobile_tso_filter_all_tasks": "{{type}} ទាំងអស់",
    "mobile_tso_filter_my_tasks": "{{type}} របស់ខ្ញុំ",
    "mobile_tso_filter_due_date": "កាលបរិច្ឆេទផុតកំណត់",
    "mobile_tso_filter_date_completed": "កាលបរិច្ឆេទបានបញ្ចប់",
    "mobile_tso_filter_completed": "បានបញ្ចប់",
    "mobile_tso_filter_completed_late": "បានបញ្ចប់យឺតពេល",
    "mobile_tso_filter_incomplete": "មិនទាន់បញ្ចប់",
    "mobile_tso_filter_var_my_tasks": "{{filter_type}} {{type}} របស់ខ្ញុំ",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} បង្កើតដោយខ្ញុំ",
    "mobile_tso_filter_var_all_tasks": "{{filter_type}} {{type}} ទាំងអស់",
    "mobile_tso_type_follow_up_actions": "សកម្មភាពតាមដាន",
    "mobile_tso_type_all": "កិច្ចការ និងសកម្មភាពតាមដាន",
    "mobile_tso_filter_var_at": " នៅ {{location}}",
    "mobile_tso_filter_group_date_due": "បានតម្រៀបតាមកាលបរិច្ឆេទផុតកំណត់",
    "mobile_tso_filter_group_distance": "បានដាក់ជាក្រុមតាមទីតាំង",
    "mobile_tso_filter_start_date": "កាលបរិច្ឆេទចាប់ផ្តើម",
    "mobile_tso_filter_none": "មិនមាន",
    "mobile_pso_filter_all_projects": "គម្រោងទាំងអស់",
    "mobile_pso_filter_my_projects": "គម្រោងរបស់ខ្ញុំ",
    "mobile_pso_filter_active": "សកម្ម",
    "mobile_pso_filter_archived": "បាន​ទុក​ក្នុង​បណ្ណសារ",
    "mobile_pso_filter_recurring": "ជាប្រចាំ",
    "mobile_pso_filter_non_recurring": "មិនជាប្រចាំ",
    "mobile_pso_filter_var_my_projects": "គម្រោង {{project_type}} {{active_description}} របស់ខ្ញុំ",
    "mobile_pso_filter_var_my_created_projects": "គម្រោង {{project_type}} {{active_description}} ត្រូវបានបង្កើតដោយខ្ញុំ",
    "mobile_pso_filter_var_all_projects": "គម្រោង {{project_type}} {{active_description}} ទាំងអស់",
    "mobile_empty_list_message_must_be_online": "អ្នក​ហាក់​ដូចជាគ្មាន​អ៊ីនធឺណិតទេ។ សូមភ្ជាប់អ៊ីនធឺណិត ដើម្បីមើលលទ្ធផលផ្សេងៗ។",
    "mobile_empty_list_message_no_submissions": "មិនមានការដាក់បញ្ជូនទេ",
    "mobile_empty_list_message_no_activity": "មិនមានសកម្មភាពទេ",
    "mobile_empty_list_message_no_tasks": "មិនមានកិច្ចការទេ",
    "mobile_empty_list_message_no_tasks_overdue": "{{type}} ដែលមិនទាន់ដល់កំណត់",
    "mobile_empty_list_message_no_accounts": "មិនមានទីតាំងទេ",
    "mobile_empty_list_message_no_projects": "មិនមានគម្រោងទេ",
    "mobile_empty_list_message_no_results_found": "រកមិន​ឃើញ​លទ្ធផល​ទេ",
    "mobile_empty_list_message_no_forms_available": "មិនមានទម្រង់បែបបទទេ",
    "mobile_empty_list_message_connection_error": "មានបញ្ហាក្នុងការភ្ជាប់<br />សូមព្យាយាមម្តងទៀត។",
    "mobile_empty_list_message_dashboard_error": "មិនអាចផ្ទុកផ្ទាំង​គ្រប់គ្រងបានទេ",
    "mobile_empty_list_message_user_offline": "បច្ចុប្បន្នអ្នកមិនមានអ៊ីនធឺណិតទេ",
    "mobile_action_sheet_media_gallery": "សាលរូបភាព",
    "mobile_action_sheet_cancel": "បោះបង់",
    "mobile_image_preview_text": "លុបរូបថត",
    "mobile_mobileform_text": "ការដាក់បញ្ជូនពីមុន",
    "mobile_mobileform_reorder_fields": "តម្រៀបសំណួរឡើងវិញ",
    "mobile_mobileform_follow_up_actions": "តាមដានសកម្មភាព",
    "mobile_mobileform_follow_up_actions_assign_title": "កំណត់សកម្មភាពតាមដាន",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "បន្ថែមសកម្មភាពតាមដានដោយផ្អែកលើការសង្កេតរបស់អ្នកដើម្បីប្រាកដថាបញ្ហាត្រូវបានដោះស្រាយ។",
    "mobile_mobileform_follow_up_actions_add_button": "+ បន្ថែមសកម្មភាពតាមដាន",
    "mobile_mobileform_follow_up_actions_assign_button": "កំណត់ការតាមដាន",
    "mobile_mobileform_follow_up_actions_without_assign_button": "បន្តដោយមិនកំណត់",
    "mobile_mobileform_follow_up_actions_dialog_title": "បន្តដោយមិនកំណត់សកម្មភាពតាមដានមែនទេ?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "ប្រសិនបើអ្នកបន្តទៅមុខដោយមិនកំណត់សកម្មភាពតាមដានណាមួយទេ នោះអ្នកនឹងមិនអាចបន្ថែមពួកវានៅពេលក្រោយបានទេ។",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "បន្តចុះមិនថ្វីទេ",
    "mobile_mobileform_add_follow_up_actions_forms_required": "តម្រូវឱ្យបំពេញប្រឡោះនេះ",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "ច្រើនតួពេក",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "ប្រឡោះនេះមិនត្រឹមត្រូវទេ",
    "mobile_mobileform_add_follow_up_actions_error_locations": "មានបញ្ហាក្នុងការកំពុងផ្ទុកទីតាំង",
    "mobile_mobileform_add_follow_up_actions_error_users": "មានបញ្ហាក្នុងការកំពុងផ្ទុកអ្នកប្រើប្រាស់",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "បន្ថែមការតាមដាន",
    "mobile_mobileform_add_follow_up_actions_forms_title": "ចំណងជើង",
    "mobile_mobileform_add_follow_up_actions_forms_description": "ការពណ៌នា",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "តម្រូវឱ្យមានរូបថត",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "កាលបរិច្ឆេទកំណត់",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "ធ្វើបច្ចុប្បន្នភាពការតាមដាន",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "លុបការតាមដានមែនទេ?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "វានឹងត្រូវបានលុប និងមិនត្រូវបានកំណត់ទេ។",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "លុបការតាមដាន",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "តើអ្នកប្រាកដថាចង់លុបការតាមដាននេះដែរទេ?\n\nសកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "បន្តទៅកាន់ការតាមដាន",
    "mobile_mobileform_follow_up_actions_completed_notification": "បានបញ្ចប់សកម្មភាពតាមដាន",
    "mobile_mobileform_follow_up_actions_deleted_notification": "បានលុបសកម្មភាពតាមដាន",
    "mobile_mobileform_follow_up_actions_update_notification": "បានធ្វើបច្ចុប្បន្នភាពសកម្មភាពតាមដាន",
    "mobile_mobileform_follow_up_actions_required_photo_error": "សូមបន្ថែមរូបថតមួយដើម្បីបញ្ចប់សកម្មភាពតាមដាននេះ",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "បន្តទៅកាន់ការដាក់បញ្ជូន",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "ចូលទៅកាន់ប្រភព",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "ប្រភព",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "បញ្ចប់ការតាមដាន",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "ប្រសិនបើអ្នកបើកការដាក់បញ្ជូន នោះរូបថត និងកំណត់ត្រាដែលមិនបានរក្សាទុកនឹងបាត់។",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "ប្រសិនបើអ្នកចាកចេញពីអេក្រង់នេះ នោះរូបថត និងកំណត់សម្គាល់ណាដែលមិនបានរក្សាទុកនឹងត្រូវបាត់បង់។",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "នៅទីនេះ",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "បើកការដាក់បញ្ជូន",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "បើកប្រភព",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "ចាកចេញពីសកម្មភាពតាមដាននេះមែនទេ?",
    "mobile_mobileform_follow_up_actions_submission": "ការដាក់បញ្ជូន",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "សកម្មភាពតាមដាននេះត្រូវបានកំណត់ទៅឱ្យ {{user}}។<br />អ្នកមិនអាចបញ្ចប់វាបានទេ។",
    "mobile_mobileform_follow_up_actions_leave_description": "ប្រសិនបើអ្នកចាកចេញពីអេក្រង់នេះ នោះការផ្លាស់ប្ដូរណាដែលមិនបានរក្សាទុកនឹងត្រូវបាត់បង់។",
    "mobile_mobileform_follow_up_actions_leave": "ចាកចេញ",
    "mobile_forms_drafts_text": "លុបព្រាង",
    "mobile_batch_estimate_user": "អ្នកប្រើប្រាស់",
    "mobile_batch_estimate_users": "អ្នកប្រើប្រាស់",
    "mobile_table_of_contents": "តារាងមាតិកា",
    "mobile_table_of_contents_required": "តម្រូវឱ្យមាន",
    "mobile_table_of_contents_optional": "ជាជម្រើស",
    "mobile_dialog_alert_title": "ការជូនដំណឹង",
    "mobile_dialog_alert_ok": "យល់ព្រម",
    "mobile_windows_10_bluetherm_not_supported": "មិនទាន់ស្គាល់ឧបករណ៍ Bluetooth នៅលើ Windows នៅឡើយទេ",
    "mobile_windows_deprecated_message_content_announcement": "ការប្រកាសដំណឹង",
    "mobile_windows_deprecated_message_title": "តម្រូវធ្វើបច្ចុប្បន្នកម្មកម្មវិធី",
    "mobile_windows_deprecated_message_description": "ដំឡើងកម្មវិធី Zenput ថ្មីនៅក្នុង Microsoft Store ឱ្យបានឆាប់តាមដែលអាចធ្វើបាន ដើម្បីធានានូវការធ្វើបច្ចុប្បន្នភាពមុខងារសំខាន់ៗ និងបទពិសោធប្រើប្រាស់ Zenput ល្អបំផុត។",
    "mobile_dashboard_tcr_graph_name": "អត្រាបញ្ចប់កិច្ចការ",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 សប្តាហ៍មុន",
    "mobile_dashboard_tcr_legend_company_average": "មធ្យមភាគក្រុមហ៊ុន",
    "mobile_dashboard_tcr_legend_team_average": "មធ្យមភាគក្រុម",
    "mobile_dashboard_tab_title_summary": "សេចក្តីសង្ខេប",
    "mobile_dashboard_tab_title_activity": "សកម្មភាព",
    "mobile_dashboard_card_title_top_triggered_workflows": "បិទ/បើកដំណើរការច្រើនបំផុត",
    "mobile_dashboard_tab_title_info": "ព័ត៌មាន",
    "mobile_dashboard_tab_project_audit": "អនុលោមភាព",
    "mobile_dashboard_card_task_stats_total": "សរុប",
    "mobile_dashboard_top_item_header_week_of": "សប្តាហ៍",
    "mobile_dashboard_card_filter_form_template_placeholder": "ទម្រង់បែបបទទាំងអស់",
    "mobile_dashboard_card_title_forms_top_nos": "\"ទេ\" ញឹកញាប់",
    "mobile_dashboard_zenput_code_no_data_in_range": "មិនមានទិន្នន័យក្នុងចន្លោះពេលវេលានេះទេ។",
    "mobile_dashboard_zenput_code_permission_denied": "អ្នកមិនមានការអនុញ្ញាតមើលវានោះទេ។",
    "mobile_dashboard_zenput_code_no_form_template_selected": "ជ្រើសរើសទម្រង់បែបបទពីខាងលើ។",
    "mobile_dashboard_zenput_code_unknown_error": "យើងមិនអាចបង្ហាញទិន្នន័យនៅពេលនេះបានទេ។",
    "mobile_dashboard_tap_to_retry": "ចុច ដើម្បីព្យាយាមម្តងទៀត",
    "mobile_dashboard_reporting_delay_disclaimer": "ការធ្វើបច្ចុប្បន្នភាពកិច្ចការអាចនឹងចំណាយពេលប្រហែលរហូតដល់ 15 នាទី",
    "mobile_dashboard_configuration_down_state_postfix_msg": "ត្រូវបានកំណត់​រចនាសម្ព័ន្ធដោយអ្នកគ្រប់គ្រងរបស់អ្នក។",
    "mobile_tasks_tag": "កិច្ចការ",
    "mobile_workflows_tag": "បិទ/បើកដំណើរការ",
    "mobile_projects_tag": "គម្រោងជាប្រចាំ",
    "mobile_forms_tag": "ទម្រង់បែបបទ",
    "mobile_dashboard_card_ongoing_projects_title": "គម្រោងកំពុងដំណើរការ",
    "mobile_dashboard_card_ongoing_projects_show_more": "បង្ហាញច្រើនទៀត",
    "mobile_dashboard_card_ongoing_projects_show_less": "បង្ហាញ​តិចជាង",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "ចូលទៅកាន់គម្រោង",
    "mobile_dashboard_card_title_recurring_projects": "គម្រោងជាប្រចាំ",
    "mobile_dashboard_card_filter_daily": "ប្រចាំថ្ងៃ",
    "mobile_dashboard_card_filter_weekly": "ប្រចាំសប្តាហ៍",
    "mobile_dashboard_card_filter_monthly": "ប្រចាំខែ",
    "mobile_task_status_title_open": "បើក",
    "mobile_task_status_title_upcoming": "មកដល់ឆាប់ៗ",
    "mobile_task_status_title_complete": "បញ្ចប់",
    "mobile_task_status_title_processing": "ការដាក់បញ្ជូនកំពុងដំណើរការ",
    "mobile_task_status_title_complete_with_exceptions": "បញ្ចប់កិច្ចការ ឬការជូនដំណឹងដែលកំពុងតាមដាន",
    "mobile_task_status_title_completed_late_with_exceptions": "បានបញ្ចប់យឺតពេលជាមួយនឹងកិច្ចការតាមដាន ឬការជូនដំណឹង",
    "mobile_task_status_title_incomplete_and_closed": "បានខកខាន",
    "mobile_tasks_legend_modal_title": "Legend",
    "mobile_tasks_legend_modal_footer_button_title": "បិទ",
    "mobile_common_assigned_to": "បានចាត់តាំងទៅ",
    "mobile_common_created_by": "បានបង្កើតដោយ",
    "mobile_common_tasks_for": "កិច្ចការសម្រាប់",
    "mobile_common_go_back": "ត្រឡប់ក្រោយ",
    "mobile_oh_no": "អូ មិនមែនទេ!",
    "mobile_user_not_in_groups": "សូមអភ័យទោស អ្នកហាក់ដូចជាមិនបានចាត់តាំងទៅក្រុមណានោះទេ។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក ដើម្បីទទួលបានសិទ្ធិចូលប្រើផ្ទាំងគ្រប់គ្រងរបស់អ្នក។",
    "mobile_tasks_select_followers": "ជ្រើសរើសអ្នកតាម",
    "mobile_tasks_assign_tasks": "ចាត់តាំងកិច្ចការ {{count}}",
    "mobile_tasks_add_followers": "បញ្ចូលអ្នកតាម",
    "mobile_tasks_followers": "អ្នកតាម",
    "mobile_tasks_delete_task": "លុបកិច្ចការចេញ",
    "mobile_tasks_create_task": "បង្កើតកិច្ចការ",
    "mobile_tasks_tab_title_comments": "មតិ",
    "mobile_tasks_see_more": "មើលច្រើនទៀត",
    "mobile_projects_create_project": "បង្កើតគម្រោង",
    "mobile_common_button_send": "ផ្ញើ",
    "mobile_common_button_schedule": "កាលវិភាគ",
    "mobile_announcements_create": "បង្កើតសេចក្តីជូនដំណឹង",
    "mobile_announcements_read_rate": "{{opened_count}} សម្រាប់ {{recipients_count}} ដែលបានបើក",
    "mobile_announcements_empty_message": "អ្នកមិនទាន់បានបង្កើតសេចក្តីជូនដំណឹងណាមួយនៅឡើយទេ! សូមបង្កើតសេចក្តីជូនដំណឹងខាងក្រោម ដើម្បីផ្សព្វផ្សាយព័ត៌មានសំខាន់ៗ ព័ត៌មាន និងបច្ចុប្បន្នភាពដល់ស្ថាប័នរបស់អ្នក។",
    "mobile_announcement_message_placeholder": "បញ្ចូលសារ...",
    "mobile_announcement_title_placeholder": "ចំណងជើងសេចក្តីជូនដំណឹង",
    "mobile_announcement_leaving_announcement": "ចាកចេញពីសេចក្តីជូនដំណឹង",
    "mobile_announcement_confirm_recipients_team": "តើអ្នកចង់ផ្សព្វផ្សាយសេចក្តីជូនដំណឹងនេះទៅអ្នកប្រើប្រាស់ {{count}} នាក់ក្នុងក្រុមដែលអ្នកបានជ្រើសរើស {{teams}} ទេ?",
    "mobile_announcement_confirm_recipients_role": "តើអ្នកចង់ផ្សព្វផ្សាយសេចក្តីជូនដំណឹងនេះទៅអ្នកប្រើប្រាស់ {{count}} នាក់ក្នុងតួនាទីអ្នកប្រើប្រាស់ដែលអ្នកបានជ្រើសរើស {{roles}} ទេ?",
    "mobile_announcement_confirm_recipients_user": "តើអ្នកចង់ផ្សព្វផ្សាយសេចក្តីជូនដំណឹងនេះទៅអ្នកប្រើប្រាស់ {{count}} នាក់ឬ?",
    "mobile_announcement_confirm_scheduled": "នៅ {{timestamp}}",
    "mobile_announcement_sending_announcement": "កំពុងផ្ញើសេចក្ដីជូនដំណឹង",
    "mobile_announcement_send_to": "ផ្ញើទៅកាន់",
    "mobile_announcement_sent_to": "បានផ្ញើទៅកាន់",
    "mobile_announcement_send_to_role": "តួនាទី",
    "mobile_announcement_attachment_download": "កំពុងទាញយក {{filename}}",
    "mobile_announcement_attachment_validation_error": "មិនអាចបញ្ចូលឯកសារភ្ជាប់លើសពី {{maxCount}} បានទេ",
    "mobile_announcement_details_sent": "បានផ្ញើ",
    "mobile_announcement_details_total_recipients": "អ្នកទទួលសរុប",
    "mobile_announcement_details_cancel": "បោះបង់សេចក្ដីជូនដំណឹង",
    "mobile_announcement_details_not_editable": "ការប្រកាសដំណឹងអាចកែសម្រួលតែនៅក្នុងកម្មវិធីលើវេបសាយ Ops Execution ប៉ុណ្ណោះ ",
    "mobile_announcement_details_not_editable_old": "សេចក្ដីជូនដំណឹងអាចត្រូវបានកែសម្រួលតែនៅលើគេហទំព័រ Zenput ប៉ុណ្ណោះ",
    "mobile_announcement_details_open_count": "ចំនួនបើក",
    "mobile_announcement_details_open_rate": "អត្រាបើក",
    "mobile_announcement_details_resend": "ផ្ញើទៅអ្នកដែលមិនទាន់បើកឡើងវិញ",
    "mobile_announcement_confirm_resend": "អ្នកប្រើប្រាស់ {{count}} នាក់មិនបានអានសេចក្តីជូនដំណឹងទេ។ តើអ្នកចង់ផ្ញើការរំលឹកឬទេ?",
    "mobile_announcement_confirm_resend_title": "ផ្ញើការរំលឹកឬទេ?",
    "mobile_announcement_recipients_opened": "បានបើក",
    "mobile_recipients_opened_empty_message": "ហាក់បីដូចជាមិនទាន់មាននរណាម្នាក់បានបើកសាររបស់អ្នកនៅឡើយទេ។ ត្រឡប់មកមើលលទ្ធផលរបស់អ្នកវិញ។",
    "mobile_announcement_recipients_unopened": "មិនបានបើក",
    "mobile_recipients_unopened_empty_message": "ដំណឹងល្អ! មិនមានសារដែលមិនបានបើកនោះទេ!",
    "mobile_scheduled_announcements_delivery_section_header": "ពេលវេលាបញ្ជូន",
    "mobile_scheduled_announcements_send_immediately_label": "ផ្ញើភ្លាមៗ",
    "mobile_scheduled_announcements_scheduled_label": "ផ្ញើតាមពេលវេលាកំណត់",
    "mobile_scheduled_announcements_scheduled_tab_label": "តាមកាលវិភាគ",
    "mobile_scheduled_announcements_dialog_header": "បោះបង់សេចក្តីជូនដំណឹងឬ?",
    "mobile_scheduled_announcements_dialog_message": "ការបោះបង់សេចក្តីជូនដំណឹងរបស់អ្នកនឹងបញ្ឈប់ការផ្ញើ ហើយលុបវាចេញពីបញ្ជីរបស់អ្នក។ មិនអាចត្រឡប់វិញ​បានទេ។ ដើម្បីកែសម្រួល សូមចូលទៅកាន់គេហទំព័រ Zenput។",
    "mobile_scheduled_announcements_empty_message": "បច្ចុប្បន្ន អ្នកមិនមានសេចក្តីជូនដំណឹងតាមកាលវិភាគទេ។ សូមកំណត់ពេលជូនដំណឹង ដើម្បីផ្សព្វផ្សាយព័ត៌មានសំខាន់ៗ ព័ត៌មាន និងបច្ចុប្បន្នភាពដល់ស្ថាប័នរបស់អ្នក។",
    "mobile_scheduled_announcements_validation_error": "ពេលវេលាបញ្ជូនត្រូវតែបន្ទាប់ពី {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "កំណត់ពេលជូនដំណឹង",
    "mobile_projects_auto_archive": "ទុកក្នុងបណ្ណសារដោយស្វ័យប្រវត្តិ",
    "mobile_common_unassigned": "មិនបានចាត់តាំង",
    "mobile_tasks_title_placeholder": "ទម្រង់បែបបទ ឬកិច្ចការថ្មី",
    "mobile_projects_leaving_project": "ចាកចេញពីគម្រោង",
    "mobile_projects_save_project": "រក្សាទុកគម្រោង",
    "mobile_top_triggers_tasks": "កិច្ចការដែលបានបិទ/បើកច្រើនបំផុត",
    "mobile_top_triggers_alerts": "ការជូនដំណឹងដែលបានបិទ/បើកច្រើនបំផុត",
    "mobile_projects_not_started": "មិនបានចាប់ផ្តើម",
    "mobile_empty_list_message_no_photos": "មិនមានរូបថតទេ",
    "mobile_webfilestore_message_error": "សូមជ្រើសរើសប្រភេទឯកសារដែលត្រឹមត្រូវ",
    "mobile_notifications_empty_title": "មិនមានការជូនដំណឹងទេ",
    "mobile_notifications_empty_message": "សកម្មភាពនៅលើកិច្ចការរបស់អ្នក ឬសកម្មភាពផ្សេងៗដែលអ្នកធ្វើនឹងបង្ហាញនៅទីនេះ។",
    "mobile_comments_comment_deleted": "មតិនេះត្រូវបានលុបចោល។",
    "mobile_comments_comment_placeholder": "មតិ",
    "mobile_comments_task_submitted_at": "កិច្ចការដែលបានដាក់បញ្ជូននៅ {{ date }} វេលាម៉ោង {{ time }}",
    "mobile_comments_discard_comment_title": "លុបចោលមតិឬ?",
    "mobile_comments_discard_confirm_message": "តើអ្នកប្រាដកហើយឬនៅ? មតិរបស់អ្នកនឹងត្រូវលុបចោល។",
    "mobile_comments_delete_comment_title": "លុបមតិឬ?",
    "mobile_comments_delete_confirm_message": "មិនអាចត្រឡប់វិញ​បានទេ។",
    "mobile_comments_delete_button": "លុបមតិ",
    "mobile_comments_delete_success_message": "បានលុបមតិ",
    "mobile_comments_empty_message_tasks": "មិនមានមតិនៅឡើយទេ \n ចាប់ផ្តើមការសន្ទនានៅលើកិច្ចការនេះ។",
    "mobile_comments_empty_message_submissions": "មិនមានមតិនៅឡើយទេ \n ចាប់ផ្តើមការសន្ទនានៅលើការដាក់បញ្ជូននេះ។",
    "mobile_comments_empty_message_default": "មិនមានមតិនៅឡើយទេ \n ចាប់ផ្តើមការសន្ទនា។",
    "mobile_comments_no_matching_users": "មិនមានអ្នកប្រើប្រាស់ដែលត្រូវគ្នាទេ។",
    "mobile_comments_empty_users_to_notify": "មិនមានអ្នកប្រើប្រាស់ដែលត្រូវជូនដំណឹងទេ។",
    "mobile_comments_users_cant_view_message": "អ្នកប្រើប្រាស់ទាំងនេះមិនអាចមើលមតិទាំងនេះបានទេ",
    "mobile_comments_users_to_notify_title": "អ្នកប្រើប្រាស់ដែលត្រូវជូនដំណឹង",
    "mobile_comments_mention_description_notifiers": "អ្នកប្រើប្រាស់<a href=\"#\" class=\"show_users_to_notify\">{{ count }} នាក់</a> នឹងទទួលបានការជូនដំណឹង។",
    "mobile_comments_mention_description_notifiers_plural": "អ្នកប្រើប្រាស់<a href=\"#\" class=\"show_users_to_notify\">{{ count }} នាក់</a> នឹងទទួលបានការជូនដំណឹង។",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@លើកឡើងអ្នកប្រើប្រាស់</a> នាក់ទៀត ដើម្បីជូនដំណឹងដល់ពួកគេ។",
    "mobile_comments_mark_read": "សម្គាល់ថាបានអានរួចទាំងអស់",
    "mobile_comments_author_mentioned_message": "បានលើកឡើងអំពីអ្នកនៅក្នុង",
    "mobile_comments_author_commented_message": "បានផ្ដល់មតិនៅលើ",
    "mobile_view_pdf": "មើលជា PDF",
    "mobile_no_pdf_generated_message": "រកមិនឃើញ PDF សម្រាប់ការដាក់បញ្ជូននេះទេ។ ច្បាប់ចម្លងនឹងត្រូវបានផ្ញើអ៊ីមែលទៅអ្នកក្នុងពេលឆាប់ៗនេះ។",
    "mobile_clipboard_copied_success": "តំណត្រូវបានចម្លងទៅឃ្លីបបតរបស់អ្នក។",
    "mobile_share_link": "ចែករំលែកតំណ",
    "mobile_zencam_share": "ចែករំលែក",
    "mobile_zencam_view_details": "មើលព័ត៌មានលម្អិត",
    "mobile_zencam_details_drawer_header": "ព័ត៌មានលម្អិត",
    "mobile_zencam_submitted_by": "បានដាក់បញ្ជូនដោយ",
    "mobile_zencam_form_title": "ចំណងជើងទម្រង់បែបបទ",
    "mobile_zencam_date_submitted": "កាលបរិច្ឆេទដែលបានដាក់បញ្ជូន",
    "mobile_oil_quality_warning_message": "ប្រេងជិតផុតកំណត់ហើយ",
    "mobile_oil_quality_warning_message_subtitle": "ចាប់ផ្ដើមរៀបគម្រោងប្ដូរវាក្នុងពេលឆាប់ៗនេះ",
    "mobile_oil_quality_failure_message": "ប្រេងខូចគុណភាពហើយ",
    "mobile_oil_quality_failure_message_subtitle": "ប្ដូរប្រេងនេះជាបន្ទាន់",
    "mobile_sensors_set_up_gateway": "រៀបចំច្រក",
    "mobile_sensors_set_up_gateway_message": "មើលទៅដូចជាគ្មានឧបករណ៍ណាត្រូវបានរៀបចំទេ។ ចាប់ផ្តើមដោយបញ្ចូលច្រក។",
    "mobile_sensors_gateway_plugged_in": "ត្រូវប្រាកដថាច្រករបស់អ្នកត្រូវបានដោតចូលក្នុងព្រីភ្លើង",
    "mobile_sensors_add_device": "បញ្ចូលឧបករណ៍",
    "mobile_sensors_name_this_gateway": "ដាក់ឈ្មោះច្រកនេះ។",
    "mobile_sensors_name_this_sensor": "ដាក់ឈ្មោះឧបករណ៍ចាប់សញ្ញានេះ។",
    "mobile_sensors_device_barcode_information": "ស្កេនកូដ QR ឬបញ្ចូលលេខ SC និង ID ពីស្លាកឧបករណ៍",
    "mobile_sensors_device_eui_information": "ស្កេនកូដ QR ឬបញ្ចូល DevEUI ពីស្លាកឧបករណ៍",
    "mobile_sensors_gateway_id_information": "បញ្ចូលលេខសម្គាល់ណតពីស្លាកច្រកចេញចូល",
    "mobile_sensors_id_number": "លេខ {{untranslatedID}}",
    "mobile_sensors_sc_code": "លេខកូដ {{untranslatedSCCode}}",
    "mobile_sensors_sensors": "ឧបករណ៍ចាប់សញ្ញា",
    "mobile_sensors_sensor_deveui_error": "មិនអាចទទួលបាន DevEUI ពី QR បានទេ។ សូមបញ្ចូលវាដោយផ្ទាល់។",
    "mobile_sensors_gateways": "ច្រក",
    "mobile_sensors_add_sensor": "បញ្ចូលឧបករណ៍ចាប់សញ្ញា",
    "mobile_sensors_add_gateway": "បញ្ចូលច្រក",
    "mobile_sensor_placement_description": "តើកន្លែងណាដែលឧបករណ៍ចាប់សញ្ញានេះនឹងត្រួតពិនិត្យ?",
    "mobile_sensors_equipment_placement": "តើឧបករណ៍ចាប់សញ្ញានឹងគ្រប់គ្រងលើតំបន់ ឬឧបករណ៏អ្វីខ្លះ?",
    "mobile_sensors_equipment": "តើឧបករណ៍អ្វីដែលឧបករណ៍ចាប់សញ្ញានេះនឹងត្រួតពិនិត្យ?",
    "mobile_sensors_select_gateway_type": "ជ្រើសរើសប្រភេទច្រក",
    "mobile_sensors_select_placement": "ជ្រើសរើសការដាក់តាមកន្លែង",
    "mobile_sensors_select_equipment": "ជ្រើសរើសឧបករណ៍",
    "mobile_sensors_placement": "ការដាក់តាមកន្លែង",
    "mobile_sensors_nickname_tip": "ការដាក់ឈ្មោះសិនស័រត្រូវបានកំណត់ដោយឈ្មោះហៅក្រៅ ដែលបានកំណត់ដោយការដាក់ដែលបានជ្រើសរើស។",
    "mobile_sensors_device_online": "លើអ៊ីនធឺណិត",
    "mobile_sensors_device_offline": "គ្មានអ៊ីនធឺណិត",
    "mobile_sensors_scan_qrcode": "ស្កេនកូដ QR",
    "mobile_sensors_enter_manually": "បញ្ចូល​ដោយ​ដៃ",
    "mobile_sensors_wizard_step_one": "ជំហានទី 1",
    "mobile_sensors_wizard_step_two": "ជំហានទី 2",
    "mobile_sensors_wizard_step_three": "ជំហានទី 3",
    "mobile_sensors_wizard_step_four": "ជំហានទី 4",
    "mobile_sensors_wizard_step_five": "ជំហានទី 5",
    "mobile_sensors_wizard_step_six": "ជំហានទី 6",
    "mobile_sensors_initializing": "កំពុង​ចាប់ផ្តើម…",
    "mobile_sensors_nickname": "ឈ្មោះ​ហៅ​ក្រៅ",
    "mobile_sensors_field_not_blank": "មិនអាចទុក {{field}} ឱ្យនៅទទេបានទេ។",
    "mobile_sensors_nothing_to_see_here": "នៅ​ទីនេះ គ្មាន​អ្វីដែល​ត្រូវ​មើលទេ",
    "mobile_sensors_missing_integration": "ខ្វះការរួមបញ្ចូលសិនស័រ",
    "mobile_sensors_contact_zenput_admin": "សូមទាក់ទងអ្នកគ្រប់គ្រង Ops Execution នៃក្រុមហ៊ុនរបស់អ្នក។",
    "mobile_sensors_contact_zenput_admin_old": "សូមទាក់ទងទៅអ្នកគ្រប់គ្រង Zenput របស់អ្នក។",
    "mobile_sensors_contact_manager": "ទាក់ទងអ្នកគ្រប់គ្រងគណនីរបស់អ្នក ដើម្បីបញ្ចូលឧបករណ៍​ចាប់សញ្ញា។",
    "mobile_sensors_device_success_message": "ការផ្ទុកទិន្នន័យឧបករណ៍​ចាប់សញ្ញាអាចនឹងចំណាយពេលរហូតដល់ 15 នាទី",
    "mobile_sensors_last_reading": "ការអានចុងក្រោយ",
    "mobile_sensors_remove_device": "ដកឧបករណ៍ចេញ",
    "mobile_sensors_one_day": "1 ថ្ងៃ",
    "mobile_sensors_one_week": "1 សប្តាហ៍",
    "mobile_sensors_one_month": "1 ខែ",
    "mobile_sensors_three_months": "3 លាន",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1 ឆ្នាំ",
    "mobile_sensors_sensor_settings": "ការកំណត់ឧបករណ៍ចាប់សញ្ញា",
    "mobile_sensors_remove_confirm_message": "តើអ្នកប្រាកដជាចង់លុបឧបករណ៍នេះចេញឬ?\nមិនអាចត្រឡប់វិញ​បានទេ។",
    "mobile_sensors_sensor": "ឧបករណ៍ចាប់សញ្ញា",
    "mobile_sensors_no_equipment_linked": "មិនបានភ្ជាប់ឧបករណ៍ទេ",
    "mobile_sensor_cooldown_process": "ដំណើរការធ្វើឱ្យចុះត្រជាក់",
    "mobile_sensor_last_12_hours": "12 ម៉ោងមុន",
    "mobile_sensor_start_cooldown_process": "ចាប់ផ្តើមដំណើរការធ្វើឱ្យចុះត្រជាក់ថ្មី",
    "mobile_sensor_cooldown_process_title": "ដំណើរការធ្វើឱ្យចុះត្រជាក់ពីរដំណាក់កាល",
    "mobile_sensor_cooldown_process_description": "ដំណើរការធ្វើឱ្យចុះត្រជាក់ពីរដំណាក់កាលរួមមាន ការធ្វើឱ្យអាហារត្រជាក់ពីសីតុណ្ហភាពខ្ពស់ជាង {{ stage1_start_temperature }} ដល់ {{ stage1_end_temperature }} ក្នុងរយៈពេលពីរម៉ោង ឬតិចជាងនេះ ហើយបន្ទាប់មកពី {{ stage1_end_temperature }} ដល់ {{ stage2_end_temperature }} ក្នុងរយៈពេលបួនម៉ោង ឬតិចជាងនេះ។",
    "mobile_sensor_cooldown_process_place_food": "ដាក់ផលិតផលម្ហូបអាហារនៅក្នុងទូទឹកកក។",
    "mobile_sensor_cooldown_process_insert_sensor": "បញ្ចូលឧបករណ៍ចាប់សញ្ញាដើម្បីរាវរកផលិតផលម្ហូបអាហារ។",
    "mobile_sensor_cooldown_process_enter_information": "បញ្ចូលព័ត៌មានខាងក្រោម។",
    "mobile_sensor_cooldown_process_food_product": "ផលិតផលម្ហូបអាហារ ដើម្បីធ្វើឱ្យចុះត្រជាក់",
    "mobile_sensor_cooldown_cool_down": "ធ្វើឱ្យចុះត្រជាក់",
    "mobile_sensor_cooldown_select_sensor": "ជ្រើសរើសឧបករណ៍ចាប់សញ្ញា",
    "mobile_sensors_cooldown_start_cooldown": "ចាប់ផ្តើមធ្វើឱ្យចុះត្រជាក់",
    "mobile_sensors_cooldown_please_enter_food": "សូមបញ្ចូលផលិតផលម្ហូបអាហារ",
    "mobile_sensors_cooldown_please_select_sensor": "សូមជ្រើសរើសឧបករណ៍ចាប់សញ្ញា",
    "mobile_sensors_cooldown_status_in_progress": "កំពុងដំណើរការ",
    "mobile_sensors_cooldown_status_failed": "មិនបានសម្រេច",
    "mobile_sensors_cooldown_status_success": "ជោគជ័យ",
    "mobile_sensors_cooldown_stage": "ដំណាក់កាល",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "សីតុណ្ហភាពចាប់ផ្តើមនៅក្រៅដែនកំណត់",
    "mobile_sensors_cooldown_failed_cooldown_process": "ដំណើរការធ្វើឱ្យចុះត្រជាក់ដែលមិនបានសម្រេច",
    "mobile_sensors_cooldown_cooldown_successful": "ដំណើរការធ្វើឱ្យចុះត្រជាក់ទទួលបានជោគជ័យ",
    "mobile_sensors_cooldown_started_cooldown_process": "បានចាប់ផ្តើមដំណើរការធ្វើឱ្យចុះត្រជាក់",
    "mobile_sensors_cooldown_hour": "ម៉ោង",
    "mobile_sensors_cooldown_hour_plural": "ម៉ោង",
    "mobile_sensors_cooldown_minute": "នាទី",
    "mobile_minutes_plural": "នាទី",
    "mobile_sensors_last_reading_max_date": "> 1 ឆ្នាំមុន",
    "mobile_sensors_minute_count_ago": "{{count}} នាទីមុន",
    "mobile_sensors_minute_count_ago_plural": "{{count}} នាទីមុន",
    "mobile_sensors_hour_count_ago": "{{count}} ម៉ោងមុន",
    "mobile_sensors_hour_count_ago_plural": "{{count}} ម៉ោងមុន",
    "mobile_sensors_day_count_ago": "{{count}} ថ្ងៃមុន",
    "mobile_sensors_day_count_ago_plural": "{{count}} ថ្ងៃមុន",
    "mobile_sensors_chart_settings": "ការកំណត់តារាង",
    "mobile_announcement_banner_continue_reading": "បន្តអាន",
    "mobile_compliance_submissions_report": "របាយការណ៍អំពីការដាក់បញ្ជូន",
    "mobile_compliance_submissions_report_subtitle": "នាំចេញទិន្នន័យនៃការបញ្ចប់គម្រោងសម្រាប់ហាងនេះ",
    "mobile_compliance_send_submissions": "ផ្ញើការដាក់បញ្ជូន",
    "mobile_compliance_completion_rate_in_last_days": "អត្រាបញ្ចប់ក្នុងរយៈពេល {{ days }} ថ្ងៃចុងក្រោយ",
    "mobile_compliance_last_days": "{{ days }} ថ្ងៃចុងក្រោយ",
    "mobile_compliance_send_submissions_to": "ផ្ញើការដាក់បញ្ជូនទៅ",
    "mobile_compliance_send_to_different_email": "ផ្ញើទៅអ៊ីមែលផ្សេង",
    "mobile_compliance_email_input_placeholder": "អាសយដ្ឋានអ៊ីមែល",
    "mobile_compliance_send_submissions_to_legend_title": "ការដាក់បញ្ជូន",
    "mobile_compliance_send_submissions_to_legend_description_days": "របាយការណ៍ជាមួយនឹងការដាក់បញ្ជូនរបស់អ្នកពីទីតាំងនេះក្នុងរយៈពេល {{ days }} ថ្ងៃចុងក្រោយនឹងត្រូវបានផ្ញើទៅអ៊ីមែលដែលបានជ្រើសរើស។",
    "mobile_compliance_time_frame": "រយៈពេល",
    "mobile_compliance_sensor_temperature_log_report": "របាយការណ៍អំពីកំណត់​ហេតុនៃសីតុណ្ហភាពរបស់ឧបករណ៍ចាប់សញ្ញា",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "នាំចេញកំណត់ហេតុអាកាសធាតុសម្រាប់ហាងនេះ",
    "mobile_compliance_sensor_temperature_log_criteria_title": "លក្ខខណ្ឌ",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "កំណត់និយមន័យលក្ខខណ្ឌសម្រាប់របាយការណ៍របស់អ្នកខាងក្រោម។",
    "mobile_compliance_sensor_temperature_log_criteria_note": "កំណត់សម្គាល់៖ ឧបករណ៍ចាប់សញ្ញាដែលបានបិទនឹងមិនបង្ហាញនៅក្នុងរបាយការណ៍ទេ",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "ជ្រើសរើសចន្លោះ​ពេលវេលា។ ទិន្នន័យនៃកំណត់ហេតុមានរយៈពេលច្រើនបំផុត 30 ថ្ងៃ",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "ផ្ញើរបាយការណ៍",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "ខែនេះ (ទី 1-ថ្ងៃនេះ)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "ខែមុន",
    "mobile_compliance_sensor_temperature_log_email_title": "ផ្ញើរបាយការណ៍ទៅ",
    "mobile_pwa_update_prompt_title": "ដំឡើងកំណែកម្មវិធី",
    "mobile_pwa_update_prompt_description": "មានកំណែកម្មវិធីថ្មី។ សូមដំឡើងកំណែទៅកំណែចុងក្រោយបំផុត។",
    "mobile_pwa_update_prompt_confirm": "ដំឡើងកំណែ ហើយផ្ទុកឡើងវិញ",
    "mobile_pwa_update_prompt_cancel": "រំលឹកខ្ញុំនៅពេលក្រោយ",
    "notification_title_due_in_one_hour": "ផុតកំណត់ក្នុងរយៈពេល 1 ម៉ោង",
    "task_is_due_soon": "'{{ task_title }}' នឹងផុតកំណត់ឆាប់ៗនេះ។ សូមចំណាយពេលបន្តិចដើម្បីបញ្ចប់វា។",
    "mobile_photo_quality_warning_header": "បញ្ហាគុណភាពរូបថត",
    "mobile_photo_quality_dialog_message": "រូបថតនេះអាចនឹងងងឹត ឬព្រិលពេក។ តើអ្នកចង់ថតរូបថ្មី ឬបន្តប្រើរូបថតនេះដែរទេ?",
    "mobile_take_new_photo": "ថតរូបថ្មី",
    "mobile_use_this_photo": "ប្រើរូបថតនេះ"
}};
mobile_translations.es_CO = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Todo",
    "mobile_common_button_apply_filters": "Aplicar filtros",
    "mobile_common_button_done": "Listo",
    "mobile_common_button_edit": "Editar",
    "mobile_common_button_archive": "Archivo",
    "mobile_common_button_save": "Guardar",
    "mobile_common_button_retake": "Volver a tomar",
    "mobile_common_button_save_draft": "Guardar borrador",
    "mobile_common_button_discard": "Descartar",
    "mobile_common_button_submit": "Enviar",
    "mobile_common_button_no": "No",
    "mobile_common_button_yes": "Sí",
    "mobile_common_button_na": "N/D",
    "mobile_common_created_by_me": "Creado por mí",
    "mobile_common_email": "Correo electrónico de empresa",
    "mobile_common_first_name": "Nombre",
    "mobile_common_last_name": "Apellido",
    "mobile_common_location": "Ubicación",
    "mobile_common_locations": "Ubicaciones",
    "mobile_common_logout_message": "¿Seguro que desea cerrar sesión?",
    "mobile_common_password": "Contraseña",
    "mobile_common_permission_required": "Permiso requerido",
    "mobile_common_status": "Estado",
    "mobile_common_task": "Tarea",
    "mobile_common_tasks": "Tareas",
    "mobile_common_tasks_my": "Mis tareas",
    "mobile_common_projects": "Proyectos",
    "mobile_common_filter_team": "Equipo",
    "mobile_common_filter_var_in": " en {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Ningún equipo seleccionado",
    "mobile_common_filter_no_user_selected": "Ningún usuario seleccionado",
    "mobile_common_filter_no_role_selected": "Ningún rol seleccionado",
    "mobile_common_placeholder_date": "Fecha",
    "mobile_common_message_task_creator_error_save": "<b>No se pudieron crear tareas.</b>",
    "mobile_common_camera": "Cámara",
    "mobile_common_microphone": "Micrófono",
    "mobile_common_for": "para",
    "mobile_common_reload": "Volver a cargar",
    "mobile_common_override": "Reemplazar",
    "mobile_common_notifications": "Notificaciones",
    "mobile_common_chat_unavailable": "Chat no disponible. Intente de nuevo más tarde.",
    "mobile_common_chat_ending_dialog_title": "¿Ha finalizado con la conversación?",
    "mobile_common_chat_ending_dialog_description": "Háganos saber si su problema se ha resuelto o si simplemente desea continuar más tarde.",
    "mobile_common_chat_ending_dialog_confirm": "Sí, ya terminé",
    "mobile_common_chat_ending_dialog_cancel": "Continuaré más tarde",
    "mobile_common_continue_editing": "Continuar editando",
    "mobile_privacy_policy": "Política de privacidad",
    "wootric_recommend_target": "un amigo o compañero dentro de su industria",
    "wootric_followup_detractor_question": "¿Qué cambios podemos hacer para que usted nos califique mejor la próxima vez?",
    "wootric_followup_passive_question": "¡Gracias! ¿Qué podemos hacer para que esta herramienta sea mucho mejor?",
    "wootric_followup_promoter_question": "¡Gracias! ¿Qué es lo que más le gusta de Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "¡Gracias! ¿Qué es lo que le gusta más de Zenput?",
    "wootric_default_followup_question": "¡Gracias! ¿Nos puede indicar por qué?",
    "wootric_default_placeholder_text": "Ayúdenos con explicarnos la razón de su calificación.",
    "wootric_default_thankyou_text": "¡Gracias por su respuesta y comentarios!",
    "mobile_login_placeholder_login_as": "Iniciar sesión Como usuario",
    "mobile_login_button_forgot_password": "¿Ha olvidado la contraseña?",
    "mobile_login_button_sign_up": "Crear cuenta",
    "mobile_login_button_finish_setup": "Finalizar configuración",
    "mobile_login_button": "Iniciar sesión",
    "mobile_login_continue_button": "Continuar",
    "mobile_login_continue_transition": "dirigiéndolo a la página de inicio de su organización...",
    "mobile_login_no_email_error": "Deberá ingresar un correo electrónico.",
    "mobile_login_change_email": "Iniciar sesión con un correo electrónico diferente",
    "mobile_login_with_sso": "Iniciar sesión con SSO",
    "mobile_oauth_no_user_error_message": "¡Parece que no tiene una cuenta de Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "¡Parece que no tiene una cuenta de Zenput!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> ahora se llama <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }}se convertirá en {{- product }} en septiembre. {{- cta }}",
    "mobile_rebrand_warning_cta": "Descubre cómo prepararte.",
    "mobile_oauth_no_user_error_sub_message": "Comuníquese con el administrador para obtener acceso o intente iniciar sesión con un correo electrónico diferente.",
    "mobile_oauth_generic_error_message": "Parece que existe un problema para iniciar sesión. Intente nuevamente.",
    "mobile_oauth_force_logout_msg": "Si aún tiene problemas, cierre sesión en su proveedor ",
    "mobile_oauth_force_logout_click": "haciendo clic aquí.",
    "mobile_sign_up_placeholder_phone": "Número de celular",
    "mobile_sign_up_placeholder_password_confirm": "Confirmar contraseña",
    "mobile_sign_up_button_sign_in": "Ingresar",
    "mobile_sign_up_disclaimer_part_1": "Al hacer clic en Crear cuenta, acepta el",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Al hacer clic en Finalizar configuración, acepta el",
    "mobile_sign_up_disclaimer_link_title": " Acuerdo de Licencia",
    "mobile_sign_up_disclaimer_part_2": ", que incluye importante información de privacidad",
    "mobile_dialog_benefits_work_offline": "Trabajar sin conexión",
    "mobile_dialog_benefits_faster_uploads": "Subidas más rápidas",
    "mobile_dialog_benefits_better_experience": "Mejor experiencia",
    "mobile_dialog_benefits_button_download": "Descarga",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution para ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput para ",
    "mobile_dialog_benefits_button_have": "¡Tengo la app!",
    "mobile_dialog_benefits_button_no_thanks": "No gracias, quizás más tarde.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Error al cargar la imagen.",
    "mobile_dialog_signature_sign": "Firme aquí",
    "mobile_dialog_signature_button_clear": "Borrar",
    "mobile_account_placeholder_name": "Ubicación/Nombre de la tienda",
    "mobile_account_placeholder_phone": "Teléfono",
    "mobile_account_placeholder_address": "Dirección",
    "mobile_account_placeholder_city": "Ciudad",
    "mobile_account_placeholder_region": "Región",
    "mobile_account_placeholder_zipcode": "Código postal",
    "mobile_account_option_select_country": "Seleccionar país",
    "mobile_account_oprion_us": "Estados Unidos",
    "mobile_account_oprion_select_state": "Seleccionar estado",
    "mobile_account_button_create_location": "Crear ubicación",
    "mobile_form_message_no_form": "No hay formularios disponibles",
    "mobile_batch_task_message": "Cargando…",
    "mobile_settings_profile": "Perfil",
    "mobile_settings_profile_number": "Teléfono celular",
    "mobile_settings_profile_language": "Idioma",
    "mobile_settings_profile_temperature_unit": "Unidad de temperatura",
    "mobile_settings_profile_use_company_default": "Utilizar la configuración predeterminada de la empresa",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Mensaje de texto",
    "mobile_settings_notifications_option_push": "Notificaciones Push",
    "mobile_settings_notifications_option_push_email": "Correo electrónico y notificaciones Push",
    "mobile_settings_notifications_option_do_not": "No notificar",
    "mobile_settings_notifications_category_communication": "Comunicación",
    "mobile_settings_notifications_category_forms_and_triggers": "Formularios y Activadores",
    "mobile_settings_devices": "Dispositivos",
    "mobile_settings_notifications_sub_category_alerts": "Alertas",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nuevos formularios disponibles",
    "mobile_settings_notifications_sub_category_task_assigned": "Tarea asignada",
    "mobile_settings_notifications_sub_category_task_completed": "Tarea completada",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Recordatorio de tareas por vencer",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Recordatorio de tareas vencidas",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensor de alertas",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alertas críticas del sensor",
    "mobile_drafts_message": "Todavía no tiene borradores.",
    "mobile_drafts_button_delete": "Borrar",
    "mobile_tasks_filter_location_no": "Ninguna ubicación seleccionada",
    "mobile_tasks_filter_group_by": "Agrupar por",
    "mobile_tasks_filter_sort_by": "Ordenar por",
    "mobile_tasks_filter_sorted_by": "Ordenado por",
    "mobile_tasks_filter_due_time": "Hora de vencimiento",
    "mobile_tasks_filter_open_time": "Hora de apertura",
    "mobile_tasks_bucket_due_next_24_hours": "Se vence en las próximas 24 horas",
    "mobile_tasks_bucket_due_next_7_days": "Se vence en los próximos 7 días",
    "mobile_tasks_bucket_open_tasks": "{{type}} abierta(s) adicional(es)",
    "mobile_tasks_bucket_open_at": "Abierto: {{- date }} a las {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Se vence: {{- date }} a las {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponible en 1 minuto",
    "mobile_tasks_bucket_available_in_one_hour": "Disponible en 1 hora",
    "mobile_tasks_bucket_available_in_one_day": "Disponible en 1 día",
    "mobile_tasks_bucket_available_in_one_week": "Disponible en 1 semana",
    "mobile_tasks_bucket_available_in_one_month": "Disponible en 1 mes",
    "mobile_tasks_bucket_available_in_one_year": "Disponible en 1 año",
    "mobile_tasks_bucket_available_in_minutes": "Disponible en {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_hours": "Disponible en {{ hours }} horas",
    "mobile_tasks_bucket_available_in_days": "Disponible en {{ days }} días",
    "mobile_tasks_bucket_available_in_weeks": "Disponible en {{ weeks }} semanas",
    "notification_task_due_in_minutes": "Fecha de entrega en {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_months": "Disponible en {{ months }} meses",
    "mobile_tasks_bucket_available_in_years": "Disponible en {{ years }} años",
    "mobile_tasks_follow_up": "Tarea de seguimiento",
    "mobile_tasks_due_soon": "Vence pronto",
    "mobile_tasks_bucket_completed_today": "Terminadas hoy",
    "mobile_tasks_bucket_completed_this_week": "Terminadas esta semana",
    "mobile_tasks_bucket_completed_last_week": "Terminadas la semana pasada",
    "mobile_tasks_bucket_missed_today": "Vencidas hoy",
    "mobile_tasks_bucket_missed_this_week": "Vencidas esta semana",
    "mobile_tasks_bucket_missed_last_week": "Vencidas la semana pasada",
    "mobile_tasks_bucket_no_location": "Sin ubicación",
    "mobile_tasks_cannot_submit_missed": "Las tareas vencidas no se pueden terminar",
    "mobile_tasks_cannot_submit_missed_after": "Esta tarea no se puede terminar después de {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Esta tarea no ha iniciado.",
    "mobile_tasks_cannot_submit_processing": "Esta entrega está en proceso",
    "mobile_tasks_toolbarnav_header_no_due_date": "Sin fecha de vencimiento",
    "mobile_tasks_toolbarnav_header_overdue": "Atrasado",
    "mobile_tasks_toolbarnav_header_yesterday": "Ayer",
    "mobile_tasks_toolbarnav_header_today": "Hoy",
    "mobile_tasks_toolbarnav_header_tomorrow": "Mañana",
    "mobile_tasks_toolbarnav_header_last_week": "La semana pasada",
    "mobile_tasks_toolbarnav_header_this_week": "Esta semana",
    "mobile_tasks_toolbarnav_header_next_week": "La próxima semana",
    "mobile_tasks_toolbarnav_header_this_month": "Este mes",
    "mobile_tasks_toolbarnav_header_next_year": "El próximo año",
    "mobile_tasks_toolbarnav_header_over_year": "Más de un año",
    "mobile_tasks_toolbarnav_title_edit_task": "Editar tarea",
    "mobile_task_placeholder_title": "Título *",
    "mobile_task_placeholder_description": "Descripción (opcional)",
    "mobile_task_button_single_task": "Tarea sencilla",
    "mobile_task_button_project": "Proyecto",
    "mobile_task_button_create": "Crear",
    "mobile_task_tab_basic": "Básico",
    "mobile_task_tab_photo": "Fotografía",
    "mobile_task_tab_form": "Formulario",
    "mobile_task_details_description_message_please": "Por favor, rellene ",
    "mobile_task_details_description_message_below": "abajo.",
    "mobile_task_details_description_message_instructions": "No hay instrucciones disponibles para esta tarea.",
    "mobile_task_details_reason_title": "Seguimiento desencadenado por",
    "mobile_task_detials_button_goto_form": "Ir al Formulario",
    "mobile_task_detials_button_complete": " Completar tarea",
    "mobile_task_detials_completed": "Completado ",
    "mobile_task_detials_completed_by": "por ",
    "mobile_task_detials_completed_on": "en ",
    "mobile_task_details_view_form_submission": "Ver presentación de Formularios",
    "mobile_task_task_updated": "Tarea actualizada",
    "mobile_task_task_archived": "Tarea archivada",
    "mobile_task_task_deleted": "Tarea eliminada",
    "mobile_task_error_archiving_task": "No se pudo archivar la tarea.",
    "mobile_task_error_deleting_task": "No se pudo eliminar la tarea.",
    "mobile_task_error_updating_task": "No se pudo actualizar la tarea.",
    "mobile_task_archive_task": "Archivar tarea",
    "mobile_task_archive_task_confirm": "¿Está seguro de que desea archivar esta tarea?\n\nLas tareas archivadas se tendrán en cuenta para las tasas de cumplimiento y seguirán incluyéndose en los informes.\n\nEsta acción no se puede deshacer.",
    "mobile_task_delete_task_confirm": "¿Está seguro de que desea eliminar esta tarea?\n\nLas tareas eliminadas no se tendrán en cuenta para las tasas de cumplimiento ni se incluirán en ningún informe.\n\nEsta acción no se puede deshacer.",
    "mobile_task_edition_already_in_progress": "Esta tarea tiene una edición pendiente. No está permitido hacer más ediciones.",
    "mobile_projects_filter_type": "Tipo",
    "mobile_projects_filter_status": "Estado del proyecto",
    "mobile_projects_filter_project_type": "Tipo de proyecto",
    "mobile_projects_due_date_required": "Se requiere la fecha de vencimiento.",
    "mobile_projects_team_required": "Se requiere un equipo.",
    "mobile_projects_user_role_required": "Se requiere un cesionario.",
    "mobile_projects_title_required": "Se requiere un título.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Multiples tareas por día",
    "mobile_project_tasks_complete": " Completo",
    "mobile_project_tasks_remaining": " Restante",
    "mobile_esitmate_message_tasks": "Se crearán 0 tareas",
    "mobile_esitmate_message_criteria": "Ajustar criterio arriba",
    "mobile_esitmate_message_created_for": "Será creada por",
    "mobile_left_menu_dashboard": "Tablero",
    "mobile_left_menu_my_forms": "Mis formularios",
    "mobile_left_menu_announcements": "Anuncios",
    "mobile_left_menu_my_submissions": "Mis entregas",
    "mobile_left_menu_drafts": "Borradores",
    "mobile_left_menu_pending_uploads": "Subidas pendientes",
    "mobile_left_menu_open": "Abrir en aplicación",
    "mobile_left_menu_settings": "Ajustes",
    "mobile_left_menu_log_out": "Cerrar sesión",
    "mobile_left_menu_debug": "Depurar",
    "mobile_left_menu_support": "Asistencia",
    "mobile_left_menu_documentation": "Documentación",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Nota o subtítulo",
    "mobile_field_option_select": "Seleccionar",
    "mobile_field_text_placeholder_text": "Texto",
    "mobile_field_email_placehoder_email": "Correo electrónico",
    "mobile_filed_number_placeholder_number": "Número",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "No está conectado.",
    "mobile_field_sensor_offline_battery": "Sensor sin conexión - Batería",
    "mobile_field_video_button_add": "Añadir un vídeo",
    "mobile_field_video_picker_dialog_title": "Agregar video desde",
    "mobile_field_video_button_change": "Cambiar vídeo",
    "mobile_field_image_button_add": "Añadir imagen",
    "mobile_field_image_low_quality_warning": "Algunas fotos pueden verse oscuras o borrosas. Revisa las fotos resaltadas y reemplázalas si es necesario.",
    "mobile_field_image_picker_dialog_title": "Agregar fotografía desde",
    "mobile_field_image_picker_edit_failed": "No pudimos guardar la imagen. Intente nuevamente.",
    "mobile_field_signature_button_add": "Añadir una firma",
    "mobile_field_signature_button_change": "Cambiar firma",
    "mobile_field_account_select_location": "Seleccionar una ubicación",
    "mobile_field_account_prefill": "¿Completar automáticamente formulario con datos de la última visita?",
    "mobile_field_account_message_overwrite": "Esto sobreescribirá todos los campos que ya haya completado.",
    "mobile_forms_task_on_behalf": "Existe una tarea para completar en esta ubicación que está asignada a <b>{{user}}</b>. ¿Desea completar esta tarea?",
    "mobile_forms_complete_task": "¿Completar tarea?",
    "mobile_field_account_prefill_button_yes": "Sí, completar automáticamente",
    "mobile_field_barcode_placeholder_scan": "Escanear o escribir código de barras",
    "mobile_field_sensor_qr_code_placeholder_scan": "Escanear o escribir código",
    "mobile_field_gateway_id_code_placeholder": "ID del tipo de nodo",
    "mobile_field_scan_qr_or_enter_dev_eui": "Escanear código QR o ingresar DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Escanear código QR o ingresar ID",
    "mobile_field_scan_qr_or_enter_sc": "Escanear código QR o ingresar código SC",
    "mobile_field_barcode_select_date": "Seleccionar fecha ",
    "mobile_field_datetime_allow_time": "Tiempo",
    "mobile_field_stopwatch_button_caption": "Cronómetro",
    "mobile_field_stopwatch_common_start": "Comenzar",
    "mobile_field_stopwatch_common_stop": "Parar",
    "mobile_field_stopwatch_common_reset": "Reiniciar",
    "mobile_field_stopwatch_stop_stopwatches": "Parar cronómetros",
    "mobile_field_document_title": "Agregar documento",
    "mobile_field_document_message_delete": "¿Está seguro de que desea eliminar este documento?",
    "mobile_field_document_alret_button_view": "Ver",
    "mobile_field_document_alert_error": "Ocurrió un error al adjuntar este documento. Intente nuevamente.",
    "mobile_field_document_alert_file_size_error": "El tamaño del archivo no puede ser superior a {{count}} MB.",
    "mobile_field_temperature_greater_range": "mayor que {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "mayor que o igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "menor que {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "menor que o igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "mayor que o igual a {{ min_temp_value }} °{{ temp_unit }} y menor que {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "mayor que o igual a {{ min_temp_value }} °{{ temp_unit }} y menor que o igual a{{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " y ",
    "mobile_field_text_limit_error": "Se alcanzó el límite de 8000 caracteres.",
    "mobile_forms_required_questions_complete": "Requeridas completadas",
    "mobile_forms_required_remaining": "{{count}} requeridas restantes",
    "mobile_forms_required_questions_back": "Atrás",
    "mobile_forms_required_questions_next": "Siguiente",
    "mobile_forms_required_questions_skip": "Saltar",
    "mobile_forms_leaving_form": "Dejando el formulario",
    "mobile_message_reordering_confirm": "¿Desea guardar el nuevo orden de preguntas?",
    "mobile_forms_leaving_reordering": "Saliendo del orden de preguntas",
    "mobile_forms_reordering_button_save": "Guardar nuevo orden de preguntas",
    "mobile_forms_reordering_instructions": "Para reordenar preguntas o secciones, arrastre a la zona en la que debería aparecer el campo en el formulario.",
    "mobile_toolbarnav_title_my_setttings": "Mis ajustes",
    "mobile_toolbarnav_title_profile_settings": "Configuración de perfil",
    "mobile_toolbarnav_title_notification": "Configuración de notificaciones",
    "mobile_toolbarnav_title_form_history": "Historia del formulario",
    "mobile_toolbarnav_title_form_not_available": "Formulario no disponible",
    "mobile_toolbarnav_title_add_location": "Añadir ubicación",
    "mobile_toolbarnav_title_add_task_or_project": "Añadir tarea o proyecto",
    "mobile_toolbarnav_title_select_location": "Seleccionar una ubicación",
    "mobile_toolbarnav_title_select_project": "Seleccionar proyecto",
    "mobile_toolbarnav_title_select_tag": "Seleccionar etiqueta",
    "mobile_toolbarnav_title_select_user": "Seleccionar usuario",
    "mobile_toolbarnav_title_select_template": "Seleccionar plantilla",
    "mobile_toolbarnav_title_select_one": "Seleccionar uno",
    "mobile_toolbarnav_title_select_multiple": "Seleccione una o más opciones",
    "mobile_toolbarnav_title_select_team": "Seleccionar equipo",
    "mobile_toolbarnav_title_select_team_or_location": "Seleccionar equipo o ubicación",
    "mobile_toolbarnav_title_filter_tasks": "Filtrar tareas",
    "mobile_toolbarnav_title_filter_projects": "Filtrar proyectos",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrar tareas de proyecto",
    "mobile_placeholder_search_bar": "Buscar",
    "mobile_placeholder_user_select_role": "Seleccionar rol de usuario",
    "mobile_placeholder_filter_by_team": "Filtrar por un equipo",
    "mobile_placeholder_assign_to_user_role": "Asignar al rol de usuario",
    "mobile_placeholder_select": "— Seleccionar —",
    "mobile_placeholder_account_location_name": "Nombre de la ubicación",
    "mobile_placeholder_tag_filter_by": "Filtrar por etiqueta de ubicación",
    "mobile_placeholder_user_type": "Asignar al usuario",
    "mobile_placeholder_acount_type_loading": "Cargando… ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatura",
    "mobile_placeholder_blue_therm_connecting": "Conectándose a dispositivo...",
    "mobile_placeholder_blue_therm_please_wait": "Espere...",
    "mobile_placeholder_blue_therm_tap": "Toque para leer.",
    "mobile_placeholder_blue_therm_not_connected": "No conectado.",
    "mobile_placeholder_testo_tap": "Mantenga oprimido ▼▲ y luego ⬆",
    "mobile_message_error_create_task": "Debe estar con conexión para añadir tareas.",
    "mobile_message_error_fill_out_form": "Rellene el formulario.",
    "mobile_message_error_fill_require_fields": "Rellene los campos obligatorios.",
    "mobile_message_error_stop_stopwatch_before_submit": "Pare su cronómetro antes de entregar",
    "mobile_message_error_stopwatch_field_required": "El campo de cronómetro es obligatorio",
    "mobile_message_error_stopwatch_field_running": "El campo de cronómetro está corriendo",
    "mobile_message_error_invalid_equipment_temperature": "Temperatura del equipo no válida",
    "mobile_message_error_invalid_ingredient_temperature": "Temperatura del ingrediente no válida",
    "mobile_message_error_location_attributes_unavailable": "Puede que algunas preguntas no estén disponibles, por favor conéctese a Internet.",
    "mobile_message_alert_running_stopwatches": "Usted tiene cronómetros corriendo.\n\n¿Desea restablecerlos?",
    "mobile_message_blue_therm_error": "Conexión perdida con dispositivo Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Se requiere acceso a la ubicación. Actívelo en la configuración de su dispositivo Android.",
    "mobile_message_blue_therm_no_permission_android": "Se requiere acceso a Dispositivos cercanos. Actívelo en la configuración de su dispositivo Android.",
    "mobile_message_blue_therm_error_code": "Fallo al conectar:",
    "mobile_message_blue_therm_error_bluetooth": "Active Bluetooth.",
    "mobile_message_blue_therm_error_device": "Dispositivo no encontrado.",
    "mobile_message_blue_therm_error_try_again": "Intente nuevamente",
    "mobile_message_blue_therm_success": "¡Dispositivo Bluetooth conectado!",
    "mobile_message_bluetooth_device_press_button_field": "Presione el botón en el dispositivo para conectar.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Presione el botón en el dispositivo<br />si no aparece en la lista.",
    "mobile_bluetooth_scan": "Escanear",
    "mobile_bluetooth_scanning": "Escaneando",
    "mobile_message_drafts_confirm": "¿Desea guardarlo como borrador?",
    "mobile_message_drafts_toast_saved": "Borrador guardado.",
    "mobile_message_drafts_request_update": "¿Le gustaría actualizar este borrador?",
    "mobile_message_drafts_form_confirm": "¿Está seguro de que desea eliminar este borrador?",
    "mobile_message_drafts_confirm_delete": "Eliminar borrador",
    "mobile_message_streams_error_switch": "No se pueden cambiar los flujos en la web",
    "mobile_message_settings_success_saved": "Ajustes guardados",
    "mobile_message_settings_error": "Error desconocido. Inténtelo de nuevo más tarde",
    "mobile_message_profile_settings_error_fields": "Corrija los campos marcados.",
    "mobile_message_media_perimission_denied": "Su ",
    "mobile_message_media_perimission_denied_device": "Almacenamiento de dispositivo",
    "mobile_message_image_confirm_remove_image": "¿Está seguro de que desea eliminar esta imagen?",
    "mobile_message_create_account_error_fields": "Rellene los campos marcados.",
    "mobile_message_create_account_success_location_created": "Ubicación creada",
    "mobile_message_task_error_get_location": "Error al obtener la ubicación. Ordenar por fecha.",
    "mobile_message_typehead_confirm_save_message": "¿Desea guardar estas selecciones?",
    "mobile_message_typehead_confirm_save_title": "¿Guardar?",
    "mobile_message_task_creator_error_save_select_form": "Debe seleccionar un formulario.",
    "mobile_message_task_creator_error_save_required_fields": "Rellene los campos requeridos.",
    "mobile_message_task_creator_error_save_batch_change": "Modifique los criterios para que coincidan con uno o más usuarios",
    "mobile_message_task_detials_error_not_assigned_to_you": "Esta tarea no está asignada a usted.<br />No puede completarla.",
    "mobile_message_task_detials_error_assigned_to": "Esta tarea está asignada a {{user}} .<br />No puede completarla.",
    "mobile_message_task_detials_confirm_title": "Dejando la tarea",
    "mobile_message_task_detials_confirm_save_task": "Guardar tarea",
    "mobile_message_task_detials_confirm_message": "¿Está seguro? Sus cambios se perderán.",
    "mobile_message_task_detials_error_view_account": "No se puede acceder a la ubicación.",
    "mobile_message_task_detials_error_submit_task": "Añada una fotografía para completar esta tarea.",
    "mobile_message_task_detials_error_submit_task_project": "No se puede guardar el proyecto, Intente más tarde.",
    "mobile_message_task_detials_wait_submit_task_created": "Se están creando tareas.<br />Espere unos minutos para que las tareas se completen.",
    "mobile_message_task_detials_error_submit_task_pending": "Error, intente más tarde",
    "mobile_message_task_detials_success_task_complete": "Tarea completada",
    "mobile_message_task_error_save_single_task": "No se puede guardar la tarea. Inténtelo de nuevo más tarde.",
    "mobile_message_task_success_save_single_task": "Tarea creada.",
    "mobile_message_show_error_message": "Uh oh. Algo fue mal.",
    "mobile_message_show_success_message": "¡Éxito!",
    "mobile_message_show_offline_message": "Está desconectado.",
    "mobile_message_show_permission_denied_message": "<b>Permiso requerido.</b> Otorgue a Zenput permiso para acceder a {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Permiso requerido.</b> Otorgue a Zenput y a su navegador permiso para acceder a {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Subiendo ahora",
    "mobile_message_show_upload_in_progress_message": "La carga ya se encuentra en progreso",
    "mobile_message_show_form_id_error": "No se puede acceder al formulario especificado.",
    "mobile_message_show_single_task_error": "No se puede acceder a la tarea especificada.",
    "mobile_message_show_submissions_error": "No se puede acceder a la entrega especificada.",
    "mobile_message_show_submissions_access_denied": "Disculpe, no tiene acceso a este formulario.",
    "mobile_message_send_data_success": "Datos cargados ",
    "mobile_message_start_upload_success": "Subida completada",
    "mobile_message_start_upload_error": "<b>No se pudo completar la subida.</b><br>Entrega guardada. Intente más tarde",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Actualización disponible",
    "mobile_message_store_upgrade_confirm_message_one": "Actualice la aplicación Ops Execution desde ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Actualice Zenput desde ",
    "mobile_message_store_upgrade_confirm_message_two": " para tener las características más recientes y los bugs arreglados",
    "mobile_message_store_upgrade_confirm_now": "Ahora",
    "mobile_message_store_upgrade_confirm_later": "Después",
    "mobile_message_redirect_confirm_message": "Actualmente, está rellenando un formulario. ¿Le gustaría guardarlo como borrador antes de continuar?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Aún tiene {{count}} borradores que no se cargaron. Si continúa, estos se perderán. ¿Está seguro?",
    "mobile_message_draft_override_message": "Este borrador se guardó desde otro dispositivo el {{date}}, y los cambios en este dispositivo están en conflicto. Puede elegir reemplazar la versión existente o volver a cargar la versión más reciente, y los cambios se descartarán.",
    "mobile_html_submitting": "Entregando…",
    "mobile_html_offline": "¡Está desconectado!",
    "mobile_html_offline_try_again": "Actualmente está desconectado. <br/><br/>Intente una vez conectado",
    "mobile_html_something_went_wrong": "Uh oh. Algo fue mal.",
    "mobile_html_something_went_wrong_try_again": "Uh oh. Algo fue mal. Intente de nuevo.",
    "mobile_html_failed_loading_roles": "Error al cargar roles",
    "mobile_alert_please_install_for_native": "Instale la aplicación Ops Execution para usar esta función. ",
    "mobile_alert_please_install_for_native_old": "Instale la aplicación nativa de Zenput para usar esta característica.",
    "mobile_tso_filter_all_tasks": "Todas {{type}}",
    "mobile_tso_filter_my_tasks": "Mis {{type}}",
    "mobile_tso_filter_due_date": "Fecha de vencimiento",
    "mobile_tso_filter_date_completed": "Fecha de terminación",
    "mobile_tso_filter_completed": "Completado",
    "mobile_tso_filter_completed_late": "Completado tarde",
    "mobile_tso_filter_incomplete": "Incompleto",
    "mobile_tso_filter_var_my_tasks": "Mis {{filter_type}}{{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} creadas por mí",
    "mobile_tso_filter_var_all_tasks": "Todas las {{filter_type}}{{type}}",
    "mobile_tso_type_follow_up_actions": "Acciones de seguimiento",
    "mobile_tso_type_all": "Tareas y acciones de seguimiento",
    "mobile_tso_filter_var_at": " en {{location}}",
    "mobile_tso_filter_group_date_due": ", ordenar por Fecha de vencimiento",
    "mobile_tso_filter_group_distance": ", agrupado por Ubicación",
    "mobile_tso_filter_start_date": "Fecha de Inicio",
    "mobile_tso_filter_none": "Ninguno",
    "mobile_pso_filter_all_projects": "Todos los proyectos",
    "mobile_pso_filter_my_projects": "Mis proyectos",
    "mobile_pso_filter_active": "Activo",
    "mobile_pso_filter_archived": "Archivado",
    "mobile_pso_filter_recurring": "Periódico",
    "mobile_pso_filter_non_recurring": "No periódico",
    "mobile_pso_filter_var_my_projects": "Mis {{project_type}} {{active_description}} proyectos",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Proyectos creados por mí",
    "mobile_pso_filter_var_all_projects": "Todos los {{project_type}} {{active_description}} proyectos",
    "mobile_empty_list_message_must_be_online": "Parece que está sin conexión. Conéctese para ver cualquier resultado.",
    "mobile_empty_list_message_no_submissions": "Sin entregas",
    "mobile_empty_list_message_no_activity": "Sin actividad",
    "mobile_empty_list_message_no_tasks": "Sin tareas",
    "mobile_empty_list_message_no_tasks_overdue": "Sin {{type}} vencidas ",
    "mobile_empty_list_message_no_accounts": "Sin ubicaciones",
    "mobile_empty_list_message_no_projects": "Sin proyectos",
    "mobile_empty_list_message_no_results_found": "No hay resultados encontrados",
    "mobile_empty_list_message_no_forms_available": "No hay formularios disponibles",
    "mobile_empty_list_message_connection_error": "Error de conexión<br />Intente nuevamente.",
    "mobile_empty_list_message_dashboard_error": "No se puede cargar el panel de control",
    "mobile_empty_list_message_user_offline": "Está desconectado",
    "mobile_action_sheet_media_gallery": "Galería",
    "mobile_action_sheet_cancel": "Cancelar",
    "mobile_image_preview_text": "Eliminar foto",
    "mobile_mobileform_text": "Envíos anteriores",
    "mobile_mobileform_reorder_fields": "Reordenar preguntas",
    "mobile_mobileform_follow_up_actions": "Acciones de seguimiento",
    "mobile_mobileform_follow_up_actions_assign_title": "Asignar acciones de seguimiento",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Agrega acciones de seguimiento basadas en tus observaciones para asegurar que se resuelvan los problemas.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Agregar acción de seguimiento",
    "mobile_mobileform_follow_up_actions_assign_button": "Asignar seguimientos",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continuar sin asignar",
    "mobile_mobileform_follow_up_actions_dialog_title": "¿Continuar sin asignar acciones de seguimiento?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Si continúas sin asignar acciones de seguimiento, no podrás añadirlas más tarde.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continuar de todos modos",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Este campo es obligatorio",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Demasiados caracteres",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Este campo no es válido",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Error al cargar ubicaciones",
    "mobile_mobileform_add_follow_up_actions_error_users": "Error al cargar usuarios",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Agregar seguimiento",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Título",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Descripción",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Requerir foto",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Fecha de vencimiento",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Actualizar seguimiento",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "¿Eliminar seguimiento?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Se eliminará y no será asignado.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Eliminar seguimiento",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "¿Con seguridad quieres eliminar este seguimiento?\n\nEsta acción no se puede deshacer.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continuar a seguimientos",
    "mobile_mobileform_follow_up_actions_completed_notification": "Acción de seguimiento completada",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Acción de seguimiento eliminada",
    "mobile_mobileform_follow_up_actions_update_notification": "Acción de seguimiento actualizada",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Agrega una foto para completar esta acción de seguimiento",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Ir al envío",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Ir al origen",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Origen",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Completar seguimiento",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Si abres el envío, se perderán las fotos y notas que no hayas guardado.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Si sale de esta pantalla, se perderán las fotos y notas que no haya guardado.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Quedarse aquí",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Abrir envío",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Código abierto",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "¿Salir de esta acción de seguimiento?",
    "mobile_mobileform_follow_up_actions_submission": "Envío",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Esta acción de seguimiento está asignada a {{user}}.<br />No puedes completarla.",
    "mobile_mobileform_follow_up_actions_leave_description": "Si sale de esta pantalla, se perderán los cambios que no haya guardado.",
    "mobile_mobileform_follow_up_actions_leave": "Salir",
    "mobile_forms_drafts_text": "Eliminar borradores",
    "mobile_batch_estimate_user": "Usuario",
    "mobile_batch_estimate_users": "Usuarios",
    "mobile_table_of_contents": "Tabla de contenido",
    "mobile_table_of_contents_required": "Requerido",
    "mobile_table_of_contents_optional": "Opcional",
    "mobile_dialog_alert_title": "Alerta",
    "mobile_dialog_alert_ok": "Aceptar",
    "mobile_windows_10_bluetherm_not_supported": "Dispositivos Bluetooth aún no admitidos en Windows",
    "mobile_windows_deprecated_message_content_announcement": "Anuncio",
    "mobile_windows_deprecated_message_title": "Es necesario actualizar la aplicación",
    "mobile_windows_deprecated_message_description": "Instale la nueva aplicación Zenput en Microsoft Store para asegurarse de contar con actualizaciones en funciones clave y la mejor experiencia Zenput.",
    "mobile_dashboard_tcr_graph_name": "Tasa de finalización de tareas",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Últimas 4 semanas",
    "mobile_dashboard_tcr_legend_company_average": "Promedio de la empresa",
    "mobile_dashboard_tcr_legend_team_average": "Promedio del equipo",
    "mobile_dashboard_tab_title_summary": "Resumen",
    "mobile_dashboard_tab_title_activity": "Actividad",
    "mobile_dashboard_card_title_top_triggered_workflows": "Activadores principales",
    "mobile_dashboard_tab_title_info": "Información",
    "mobile_dashboard_tab_project_audit": "Conformidad",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Semana de",
    "mobile_dashboard_card_filter_form_template_placeholder": "Todos los formularios",
    "mobile_dashboard_card_title_forms_top_nos": "\"No\" frecuentes",
    "mobile_dashboard_zenput_code_no_data_in_range": "No existen datos en este rango de tiempo.",
    "mobile_dashboard_zenput_code_permission_denied": "No tiene permiso para ver esto.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Seleccione un formulario desde arriba.",
    "mobile_dashboard_zenput_code_unknown_error": "No podemos mostrar los datos en este momento.",
    "mobile_dashboard_tap_to_retry": "Toque para reintentar",
    "mobile_dashboard_reporting_delay_disclaimer": "Las tareas pueden tardar hasta 15 minutos en actualizarse",
    "mobile_dashboard_configuration_down_state_postfix_msg": "configurados por el administrador.",
    "mobile_tasks_tag": "tareas",
    "mobile_workflows_tag": "activadores",
    "mobile_projects_tag": "proyectos recurrentes",
    "mobile_forms_tag": "formularios",
    "mobile_dashboard_card_ongoing_projects_title": "Proyectos en progreso",
    "mobile_dashboard_card_ongoing_projects_show_more": "Mostrar más",
    "mobile_dashboard_card_ongoing_projects_show_less": "Mostrar menos",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Ir a Proyectos",
    "mobile_dashboard_card_title_recurring_projects": "Proyectos recurrentes",
    "mobile_dashboard_card_filter_daily": "Diario",
    "mobile_dashboard_card_filter_weekly": "Semanal",
    "mobile_dashboard_card_filter_monthly": "Mensual",
    "mobile_task_status_title_open": "Abierto",
    "mobile_task_status_title_upcoming": "Próximas",
    "mobile_task_status_title_complete": "Completo",
    "mobile_task_status_title_processing": "Entrega en proceso",
    "mobile_task_status_title_complete_with_exceptions": "Completado con alertas o tareas de seguimiento",
    "mobile_task_status_title_completed_late_with_exceptions": "Completado tarde con tareas de seguimiento o alertas",
    "mobile_task_status_title_incomplete_and_closed": "Vencidas",
    "mobile_tasks_legend_modal_title": "Leyenda",
    "mobile_tasks_legend_modal_footer_button_title": "Cerrar",
    "mobile_common_assigned_to": "Asignado a",
    "mobile_common_created_by": "Creado por",
    "mobile_common_tasks_for": "Tareas para",
    "mobile_common_go_back": "Volver",
    "mobile_oh_no": "¡Oh, no!",
    "mobile_user_not_in_groups": "Parece que no está asignado a un equipo. Comuníquese con su administrador para obtener acceso a su panel de control.",
    "mobile_tasks_select_followers": "Seleccionar seguidores",
    "mobile_tasks_assign_tasks": "Asignar {{count}} tareas",
    "mobile_tasks_add_followers": "Agregar seguidores",
    "mobile_tasks_followers": "Seguidores",
    "mobile_tasks_delete_task": "Eliminar tarea",
    "mobile_tasks_create_task": "Crear tarea",
    "mobile_tasks_tab_title_comments": "Comentarios",
    "mobile_tasks_see_more": "Ver más",
    "mobile_projects_create_project": "Crear proyecto",
    "mobile_common_button_send": "Enviar",
    "mobile_common_button_schedule": "Programa",
    "mobile_announcements_create": "Crear anuncio",
    "mobile_announcements_read_rate": "{{opened_count}} de {{recipients_count}} abierto",
    "mobile_announcements_empty_message": "¡Todavía no ha creado ningún anuncio! Cree un anuncio a continuación para difundir noticias, información y actualizaciones importantes para su organización.",
    "mobile_announcement_message_placeholder": "Añadir un mensaje...",
    "mobile_announcement_title_placeholder": "Título del anuncio",
    "mobile_announcement_leaving_announcement": "Salir del anuncio",
    "mobile_announcement_confirm_recipients_team": "¿Quiere transmitir este anuncio a {{count}} usuario(s) en {{teams}} equipo(s) seleccionado(s)?",
    "mobile_announcement_confirm_recipients_role": "¿Quiere transmitir este anuncio a {{count}} usuario(s) en {{roles}} rol(es) de usuario(s) seleccionado(s)?",
    "mobile_announcement_confirm_recipients_user": "¿Quiere transmitir este anuncio a {{count}} usuario(s)?",
    "mobile_announcement_confirm_scheduled": "En {{timestamp}}",
    "mobile_announcement_sending_announcement": "Enviando anuncio",
    "mobile_announcement_send_to": "Enviar a",
    "mobile_announcement_sent_to": "Enviado a",
    "mobile_announcement_send_to_role": "Rol",
    "mobile_announcement_attachment_download": "Descargando {{filename}}",
    "mobile_announcement_attachment_validation_error": "No es posible añadir más de {{maxCount}} archivos adjuntos",
    "mobile_announcement_details_sent": "Enviado",
    "mobile_announcement_details_total_recipients": "Total de destinatarios",
    "mobile_announcement_details_cancel": "Cancelar anuncio",
    "mobile_announcement_details_not_editable": "Los anuncios solo se pueden editar en la aplicación web Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Los anuncios sólo pueden editarse en Zenput Web",
    "mobile_announcement_details_open_count": "Conteo abierto",
    "mobile_announcement_details_open_rate": "Tasa de apertura",
    "mobile_announcement_details_resend": "Reenviar a los que no han abierto",
    "mobile_announcement_confirm_resend": "{{count}} El usuario o usuarios no han leído el anuncio. ¿Quiere enviar un recordatorio?",
    "mobile_announcement_confirm_resend_title": "¿Enviar un recordatorio?",
    "mobile_announcement_recipients_opened": "Abierto",
    "mobile_recipients_opened_empty_message": "Parece que nadie ha abierto su mensaje todavía. Vuelva más tarde para ver sus resultados.",
    "mobile_announcement_recipients_unopened": "Sin abrir",
    "mobile_recipients_unopened_empty_message": "¡Buenas noticias! ¡No hay mensajes sin abrir!",
    "mobile_scheduled_announcements_delivery_section_header": "Tiempo de entrega",
    "mobile_scheduled_announcements_send_immediately_label": "Enviar inmediatamente",
    "mobile_scheduled_announcements_scheduled_label": "Enviar a una hora específica",
    "mobile_scheduled_announcements_scheduled_tab_label": "Programado",
    "mobile_scheduled_announcements_dialog_header": "¿Cancelar anuncio?",
    "mobile_scheduled_announcements_dialog_message": "Cancelar su anuncio impedirá que se envíe y lo eliminará de su lista. Esto no se puede deshacer. Para editarlo vaya a Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Todavía no ha programado ningún anuncio. Programe un anuncio para difundir noticias, información y actualizaciones importantes para su organización.",
    "mobile_scheduled_announcements_validation_error": "Tiempo de entrega debe ser después {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Programar anuncio",
    "mobile_projects_auto_archive": "Archivar automáticamente",
    "mobile_common_unassigned": "Sin asignar",
    "mobile_tasks_title_placeholder": "Tarea o formulario nuevo",
    "mobile_projects_leaving_project": "Dejando el proyecto",
    "mobile_projects_save_project": "Guardar proyecto",
    "mobile_top_triggers_tasks": "Tareas desencadenadas principales",
    "mobile_top_triggers_alerts": "Alertas desencadenadas principales",
    "mobile_projects_not_started": "No Iniciado",
    "mobile_empty_list_message_no_photos": "Sin fotografías",
    "mobile_webfilestore_message_error": "Seleccione un tipo de archivo válido",
    "mobile_notifications_empty_title": "No hay notificaciones",
    "mobile_notifications_empty_message": "Aquí encontrará la actividad de sus tareas o de aquellas en las que participa.",
    "mobile_comments_comment_deleted": "Este comentario ha sido eliminado.",
    "mobile_comments_comment_placeholder": "Comentario",
    "mobile_comments_task_submitted_at": "Tarea enviada el día {{ date }} a las {{ time }}",
    "mobile_comments_discard_comment_title": "¿Desea descartar el comentario?",
    "mobile_comments_discard_confirm_message": "¿Está seguro? Su comentario se eliminará.",
    "mobile_comments_delete_comment_title": "¿Desea eliminar el comentario?",
    "mobile_comments_delete_confirm_message": "Esta acción no se puede deshacer.",
    "mobile_comments_delete_button": "Eliminar el comentario",
    "mobile_comments_delete_success_message": "Comentario eliminado",
    "mobile_comments_empty_message_tasks": "Aún no hay comentarios \n Inicie una conversación sobre esta tarea.",
    "mobile_comments_empty_message_submissions": "Aún no hay comentarios \n Inicie una conversación sobre esta entrega.",
    "mobile_comments_empty_message_default": "Aún no hay comentarios \n Inicie una conversación.",
    "mobile_comments_no_matching_users": "No hay usuarios que coincidan.",
    "mobile_comments_empty_users_to_notify": "No hay usuarios que notificar.",
    "mobile_comments_users_cant_view_message": "Estos usuarios no pueden ver estos comentarios.",
    "mobile_comments_users_to_notify_title": "Usuarios que serán notificados.",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} usuario</a> recibirá la notificación.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} usuarios</a> recibirán la notificación.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> más usuarios para enviarles una notficación.",
    "mobile_comments_mark_read": "Marque todo como leído",
    "mobile_comments_author_mentioned_message": "lo mencionó en",
    "mobile_comments_author_commented_message": "comentado en",
    "mobile_view_pdf": "Ver PDF",
    "mobile_no_pdf_generated_message": "No se encontró ningún PDF para enviar. Recibirá una copia en su correo electrónico en poco tiempo.",
    "mobile_clipboard_copied_success": "El enlace se copió al portapapeles",
    "mobile_share_link": "Compartir enlace",
    "mobile_zencam_share": "Compartir",
    "mobile_zencam_view_details": "Ver detalles",
    "mobile_zencam_details_drawer_header": "Detalles",
    "mobile_zencam_submitted_by": "Enviado por",
    "mobile_zencam_form_title": "Título del formulario",
    "mobile_zencam_date_submitted": "Fecha de envío",
    "mobile_oil_quality_warning_message": "Aceite a punto de expirar",
    "mobile_oil_quality_warning_message_subtitle": "Empiece a planear un cambio pronto",
    "mobile_oil_quality_failure_message": "Calidad del aceite en riesgo",
    "mobile_oil_quality_failure_message_subtitle": "Cambie el aceite de inmediato",
    "mobile_sensors_set_up_gateway": "Configurar la puerta de enlace",
    "mobile_sensors_set_up_gateway_message": "Parece que no hay ningún dispositivo configurado. Empiece añadiendo una puerta de enlace.",
    "mobile_sensors_gateway_plugged_in": "Asegúrese de que su puerta de enlace esté conectada a una toma de corriente",
    "mobile_sensors_add_device": "Añadir dispositivo",
    "mobile_sensors_name_this_gateway": "Nombrar esta puerta de enlace",
    "mobile_sensors_name_this_sensor": "Nombrar este sensor",
    "mobile_sensors_device_barcode_information": "Escanear código QR o ingresar el ID y número SC de la etiqueta del dispositivo",
    "mobile_sensors_device_eui_information": "Escanear código QR o ingresar el DevEUI de la etiqueta del dispositivo",
    "mobile_sensors_gateway_id_information": "Ingrese el ID de nodo de la etiqueta de puerta de enlace",
    "mobile_sensors_id_number": "{{untranslatedID}} Número",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Código",
    "mobile_sensors_sensors": "Sensores",
    "mobile_sensors_sensor_deveui_error": "No se pude conseguir el DevEUI del código QR. Ingréselo manualmente.",
    "mobile_sensors_gateways": "Puertas de enlace",
    "mobile_sensors_add_sensor": "Añadir sensor",
    "mobile_sensors_add_gateway": "Añadir puerta de enlace",
    "mobile_sensor_placement_description": "¿Qué área monitoreará este sensor?",
    "mobile_sensors_equipment_placement": "¿Qué área o equipo monitoreará este sensor?",
    "mobile_sensors_equipment": "¿Qué equipo monitoreará este sensor?",
    "mobile_sensors_select_gateway_type": "Seleccionar el tipo de puerta de enlace",
    "mobile_sensors_select_placement": "Seleccionar Ubicación",
    "mobile_sensors_select_equipment": "Seleccionar Equipo",
    "mobile_sensors_placement": "Ubicación",
    "mobile_sensors_nickname_tip": "Los nombres de los sensores se determinan por los apodos asignados en la ubicación seleccionada.",
    "mobile_sensors_device_online": "En línea",
    "mobile_sensors_device_offline": "Sin conexión",
    "mobile_sensors_scan_qrcode": "Escanear código QR",
    "mobile_sensors_enter_manually": "Ingresar manualmente",
    "mobile_sensors_wizard_step_one": "Paso 1",
    "mobile_sensors_wizard_step_two": "Paso 2",
    "mobile_sensors_wizard_step_three": "Paso 3",
    "mobile_sensors_wizard_step_four": "Paso 4",
    "mobile_sensors_wizard_step_five": "Paso 5",
    "mobile_sensors_wizard_step_six": "Paso 6",
    "mobile_sensors_initializing": "Inicializando...",
    "mobile_sensors_nickname": "Apodo",
    "mobile_sensors_field_not_blank": "El {{field}} no puede estar vacío.",
    "mobile_sensors_nothing_to_see_here": "No hay resultados que mostrar",
    "mobile_sensors_missing_integration": "Falta la integración del sensor",
    "mobile_sensors_contact_zenput_admin": "Póngase en contacto con el administrador de Ops Execution para su empresa.",
    "mobile_sensors_contact_zenput_admin_old": "Por favor, póngase en contacto con el administrador de Zenput. ",
    "mobile_sensors_contact_manager": "Comuníquese con su administrador de cuentas para agregar sensores.",
    "mobile_sensors_device_success_message": "Los datos de los sensores pueden tardar hasta 15 minutos en cargarse",
    "mobile_sensors_last_reading": "Última lectura",
    "mobile_sensors_remove_device": "Eliminar dispositivo",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1S",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1A",
    "mobile_sensors_sensor_settings": "Ajustes del dispositivo",
    "mobile_sensors_remove_confirm_message": "¿Está seguro de que desea eliminar este dispositivo?\nEsta operación no se puede deshacer.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "No hay equipo vinculado",
    "mobile_sensor_cooldown_process": "Proceso de enfriamiento",
    "mobile_sensor_last_12_hours": "Últimas 12 Horas",
    "mobile_sensor_start_cooldown_process": "Comenzar nuevo proceso de enfriamiento",
    "mobile_sensor_cooldown_process_title": "Proceso de enfriamiento de dos etapas",
    "mobile_sensor_cooldown_process_description": "Un proceso de enfriamiento de dos etapas consiste en enfriar los alimentos desde más de {{ stage1_start_temperature }} hasta {{ stage1_end_temperature }} en dos horas o menos, y luego desde {{ stage1_end_temperature }} hasta {{ stage2_end_temperature }} en cuatro horas o menos.",
    "mobile_sensor_cooldown_process_place_food": "Ponga el producto alimenticio en el refrigerador.",
    "mobile_sensor_cooldown_process_insert_sensor": "Inserte una sonda de sensor en el producto alimenticio.",
    "mobile_sensor_cooldown_process_enter_information": "Ingrese la información a continuación.",
    "mobile_sensor_cooldown_process_food_product": "Producto alimenticio a enfriar",
    "mobile_sensor_cooldown_cool_down": "Enfriamiento",
    "mobile_sensor_cooldown_select_sensor": "Seleccionar Sensor",
    "mobile_sensors_cooldown_start_cooldown": "Empezar el enfriamiento",
    "mobile_sensors_cooldown_please_enter_food": "Ingrese un producto alimenticio",
    "mobile_sensors_cooldown_please_select_sensor": "Seleccione un sensor",
    "mobile_sensors_cooldown_status_in_progress": "En Progreso",
    "mobile_sensors_cooldown_status_failed": "Fallido",
    "mobile_sensors_cooldown_status_success": "Éxito",
    "mobile_sensors_cooldown_stage": "Etapa",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "La temperatura inicial está fuera de rango",
    "mobile_sensors_cooldown_failed_cooldown_process": "Falló el proceso de enfriamiento",
    "mobile_sensors_cooldown_cooldown_successful": "Enfriamiento exitoso",
    "mobile_sensors_cooldown_started_cooldown_process": "Comenzó el proceso de enfriamiento",
    "mobile_sensors_cooldown_hour": "hora",
    "mobile_sensors_cooldown_hour_plural": "horas",
    "mobile_sensors_cooldown_minute": "minuto",
    "mobile_minutes_plural": "minutos",
    "mobile_sensors_last_reading_max_date": "Hace > de 1 año",
    "mobile_sensors_minute_count_ago": "Hace {{count}} minuto",
    "mobile_sensors_minute_count_ago_plural": "Hace {{count}} minutos",
    "mobile_sensors_hour_count_ago": "Hace {{count}} hora",
    "mobile_sensors_hour_count_ago_plural": "Hace {{count}} horas",
    "mobile_sensors_day_count_ago": "Hace {{count}} día",
    "mobile_sensors_day_count_ago_plural": "Hace {{count}} días",
    "mobile_sensors_chart_settings": "Ajustes del gráfico",
    "mobile_announcement_banner_continue_reading": "Continuar leyendo",
    "mobile_compliance_submissions_report": "Reporte de entregas",
    "mobile_compliance_submissions_report_subtitle": "Exportar datos de finalización de proyectos para esta tienda",
    "mobile_compliance_send_submissions": "Enviar entregas",
    "mobile_compliance_completion_rate_in_last_days": "Tasa de finalización en los últimos {{ days }} días",
    "mobile_compliance_last_days": "Últimos {{ days }} días",
    "mobile_compliance_send_submissions_to": "Enviar entregas a",
    "mobile_compliance_send_to_different_email": "Enviar a un correo electrónico diferente",
    "mobile_compliance_email_input_placeholder": "Correo electrónico",
    "mobile_compliance_send_submissions_to_legend_title": "Entregas",
    "mobile_compliance_send_submissions_to_legend_description_days": "Se enviará al correo seleccionado un reporte con sus entregas de esta ubicación en los últimos {{ days }} días. ",
    "mobile_compliance_time_frame": "Rango de tiempo",
    "mobile_compliance_sensor_temperature_log_report": "Registro de temperatura del sensor",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exportar registros de temperatura para esta tienda",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Criterio",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Defina abajo el criterio para el informe.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Nota: Los sensores desactivados no aparecerán en el informe",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Seleccione un rango de tiempo. Los datos de registro están limitados a un máximo de 30 días.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Enviar informe",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Este mes (Primero-Hoy)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Último mes",
    "mobile_compliance_sensor_temperature_log_email_title": "Enviar informe a",
    "mobile_pwa_update_prompt_title": "Actualizar aplicación",
    "mobile_pwa_update_prompt_description": "Ya se encuentra disponible una nueva versión de la aplicación. Actualícela a la versión más reciente.",
    "mobile_pwa_update_prompt_confirm": "Actualizar y volver a cargar",
    "mobile_pwa_update_prompt_cancel": "Recordármelo más tarde",
    "notification_title_due_in_one_hour": "Vence en 1 hora",
    "task_is_due_soon": "'{{ task_title }}' vence pronto. Tómase un momento para completarlo.",
    "mobile_photo_quality_warning_header": "Problema de calidad de la foto",
    "mobile_photo_quality_dialog_message": "Esta foto puede verse demasiado oscura o borrosa. ¿Quieres tomar una foto nueva o continuar con esta?",
    "mobile_take_new_photo": "Tomar una foto nueva",
    "mobile_use_this_photo": "Usar esta foto"
}};
mobile_translations.ru_RU = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Все",
    "mobile_common_button_apply_filters": "Применить фильтры",
    "mobile_common_button_done": "Готово",
    "mobile_common_button_edit": "Изменить",
    "mobile_common_button_archive": "Архивировать",
    "mobile_common_button_save": "Сохранить",
    "mobile_common_button_retake": "Переснять",
    "mobile_common_button_save_draft": "Сохранить черновик",
    "mobile_common_button_discard": "Отменить",
    "mobile_common_button_submit": "Отправить",
    "mobile_common_button_no": "Нет",
    "mobile_common_button_yes": "Да",
    "mobile_common_button_na": "Н/Д",
    "mobile_common_created_by_me": "Создано мной",
    "mobile_common_email": "Корпоративный эл. адрес",
    "mobile_common_first_name": "Имя",
    "mobile_common_last_name": "Фамилия",
    "mobile_common_location": "Локация",
    "mobile_common_locations": "Локации",
    "mobile_common_logout_message": "Вы уверены что хотите выйти?",
    "mobile_common_password": "Пароль",
    "mobile_common_permission_required": "Требуется разрешение",
    "mobile_common_status": "Статус",
    "mobile_common_task": "Задача",
    "mobile_common_tasks": "Задачи",
    "mobile_common_tasks_my": "Мои задачи",
    "mobile_common_projects": "Проекты",
    "mobile_common_filter_team": "Команда",
    "mobile_common_filter_var_in": " в {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Команда не выбрана",
    "mobile_common_filter_no_user_selected": "Пользователь не выбран",
    "mobile_common_filter_no_role_selected": "Роль не выбрана",
    "mobile_common_placeholder_date": "Дата",
    "mobile_common_message_task_creator_error_save": "<b>Не удалось создать задачи.</b>",
    "mobile_common_camera": "Камера",
    "mobile_common_microphone": "Микрофон",
    "mobile_common_for": "для",
    "mobile_common_reload": "Перезагрузить",
    "mobile_common_override": "Переопределить",
    "mobile_common_notifications": "Уведомления",
    "mobile_common_chat_unavailable": "Чат недоступен. Повторите попытку позже.",
    "mobile_common_chat_ending_dialog_title": "Завершить эту беседу?",
    "mobile_common_chat_ending_dialog_description": "Сообщите нам, устранена ли ваша проблема, или вы хотите продолжить позже.",
    "mobile_common_chat_ending_dialog_confirm": "Да, завершить",
    "mobile_common_chat_ending_dialog_cancel": "Продолжить позже",
    "mobile_common_continue_editing": "Продолжить редактирование",
    "mobile_privacy_policy": "Политика конфиденциальности",
    "wootric_recommend_target": "друг или коллега из вашей сферы деятельности",
    "wootric_followup_detractor_question": "Что мы можем изменить, чтобы в следующий раз получить от вас более высокую оценку?",
    "wootric_followup_passive_question": "Спасибо! Как еще мы можем улучшить инструмент?",
    "wootric_followup_promoter_question": "Спасибо! Что вам нравится в Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Спасибо! Что вам нравится в Zenput?",
    "wootric_default_followup_question": "Спасибо! Можете рассказать нам, почему вы поставили такую оценку?",
    "wootric_default_placeholder_text": "Вы нам очень поможете, если объясните, почему поставили такую оценку.",
    "wootric_default_thankyou_text": "Благодарим вас за ответ и за обратную связь!",
    "mobile_login_placeholder_login_as": "Вход по ID пользователя",
    "mobile_login_button_forgot_password": "Забыли пароль?",
    "mobile_login_button_sign_up": "Создать учетную запись",
    "mobile_login_button_finish_setup": "Закончить настройку",
    "mobile_login_button": "Вход",
    "mobile_login_continue_button": "Продолжить",
    "mobile_login_continue_transition": "переход на страницу входа для компании...",
    "mobile_login_no_email_error": "Введите адрес эл. почты.",
    "mobile_login_change_email": "Использовать для входа другой адрес эл. почты",
    "mobile_login_with_sso": "Вход SSO",
    "mobile_oauth_no_user_error_message": "Похоже, у вас нет учетной записи Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Похоже, у вас нет учетной записи Zenput.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> — это теперь <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "С сентября {{- brand }} становится {{- product }}. {{- cta }}",
    "mobile_rebrand_warning_cta": "Узнайте, как подготовиться к изменениям.",
    "mobile_oauth_no_user_error_sub_message": "Для получения доступа свяжитесь с администратором или попробуйте войти, указав другой адрес эл. почты.",
    "mobile_oauth_generic_error_message": "Похоже, при входе в систему возникла ошибка, повторите попытку.",
    "mobile_oauth_force_logout_msg": "Если проблемы возникают снова, выйдите из системы поставщика услуг, ",
    "mobile_oauth_force_logout_click": "нажав здесь.",
    "mobile_sign_up_placeholder_phone": "Номер моб. телефона",
    "mobile_sign_up_placeholder_password_confirm": "Подтвердите пароль",
    "mobile_sign_up_button_sign_in": "Войти",
    "mobile_sign_up_disclaimer_part_1": "Нажимая кнопку «Создать учетную запись», вы принимаете условия",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Нажимая кнопку «Закончить настройку», вы принимаете условия",
    "mobile_sign_up_disclaimer_link_title": " Лицензионного соглашения",
    "mobile_sign_up_disclaimer_part_2": ", в том числе важные положения о конфиденциальности",
    "mobile_dialog_benefits_work_offline": "Работа в автономном режиме",
    "mobile_dialog_benefits_faster_uploads": "Более быстрая загрузка",
    "mobile_dialog_benefits_better_experience": "Удобство использования",
    "mobile_dialog_benefits_button_download": "Скачать",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution для ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput для ",
    "mobile_dialog_benefits_button_have": "У меня есть приложение.",
    "mobile_dialog_benefits_button_no_thanks": "Нет, спасибо. Возможно, позже.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Не удалось загрузить изображение.",
    "mobile_dialog_signature_sign": "Место для подписи",
    "mobile_dialog_signature_button_clear": "Очистить",
    "mobile_account_placeholder_name": "Локация/название магазина",
    "mobile_account_placeholder_phone": "Телефон",
    "mobile_account_placeholder_address": "Адрес",
    "mobile_account_placeholder_city": "Город",
    "mobile_account_placeholder_region": "Регион",
    "mobile_account_placeholder_zipcode": "Почтовый индекс",
    "mobile_account_option_select_country": "Выбрать страну",
    "mobile_account_oprion_us": "США",
    "mobile_account_oprion_select_state": "Выбрать штат",
    "mobile_account_button_create_location": "Создать локацию",
    "mobile_form_message_no_form": "Нет доступных форм",
    "mobile_batch_task_message": "Загрузка ...",
    "mobile_settings_profile": "Профиль",
    "mobile_settings_profile_number": "Моб. телефон",
    "mobile_settings_profile_language": "Язык",
    "mobile_settings_profile_temperature_unit": "Единица измерения температуры",
    "mobile_settings_profile_use_company_default": "Использовать стандарт компании",
    "mobile_settings_profile_celsius": "Цельсий",
    "mobile_settings_profile_fahrenheit": "Фаренгейт",
    "mobile_settings_notifications_option_sms": "Текстовое сообщение",
    "mobile_settings_notifications_option_push": "Push-уведомления",
    "mobile_settings_notifications_option_push_email": "Уведомления по эл. почте и push-уведомления",
    "mobile_settings_notifications_option_do_not": "Без уведомлений",
    "mobile_settings_notifications_category_communication": "Общение",
    "mobile_settings_notifications_category_forms_and_triggers": "Формы и триггеры",
    "mobile_settings_devices": "Устройства",
    "mobile_settings_notifications_sub_category_alerts": "Оповещения",
    "mobile_settings_notifications_sub_category_new_forms_available": "Доступны новые формы",
    "mobile_settings_notifications_sub_category_task_assigned": "Задача присвоена",
    "mobile_settings_notifications_sub_category_task_completed": "Задача завершена",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Напоминание о задачах для исполнения",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Напоминание о просроченных задачах",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Оповещения датчика",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Оповещения аварийных датчиков",
    "mobile_drafts_message": "У вас пока нет черновиков.",
    "mobile_drafts_button_delete": "Удалить",
    "mobile_tasks_filter_location_no": "Локация не выбрана",
    "mobile_tasks_filter_group_by": "Группировать по",
    "mobile_tasks_filter_sort_by": "Сортировать по",
    "mobile_tasks_filter_sorted_by": "Отсортировано по",
    "mobile_tasks_filter_due_time": "Установленное время",
    "mobile_tasks_filter_open_time": "Открытое время",
    "mobile_tasks_bucket_due_next_24_hours": "Ожидается в следующие 24 часа",
    "mobile_tasks_bucket_due_next_7_days": "Ожидается в следующие 7 дней",
    "mobile_tasks_bucket_open_tasks": "Дополнительные открытые {{type}}",
    "mobile_tasks_bucket_open_at": "Открытые: {{- date }} в {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Оплатить до: {{- date }} в {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Доступны через 1 минуту",
    "mobile_tasks_bucket_available_in_one_hour": "Доступны через 1 час",
    "mobile_tasks_bucket_available_in_one_day": "Доступны через 1 день",
    "mobile_tasks_bucket_available_in_one_week": "Доступны через 1 неделю",
    "mobile_tasks_bucket_available_in_one_month": "Доступны через 1 месяц",
    "mobile_tasks_bucket_available_in_one_year": "Доступны через 1 год",
    "mobile_tasks_bucket_available_in_minutes": "Доступны через {{ minutes }} мин.",
    "mobile_tasks_bucket_available_in_hours": "Доступны через {{ hours }} час.",
    "mobile_tasks_bucket_available_in_days": "Доступны через {{ days }} дн.",
    "mobile_tasks_bucket_available_in_weeks": "Доступны через {{ weeks }} нед.",
    "notification_task_due_in_minutes": "Срок: {{ minutes }} мин.",
    "mobile_tasks_bucket_available_in_months": "Доступны через {{ months }} мес.",
    "mobile_tasks_bucket_available_in_years": "Доступны через {{ years }} лет",
    "mobile_tasks_follow_up": "Дальнейшая задача",
    "mobile_tasks_due_soon": "Скоро",
    "mobile_tasks_bucket_completed_today": "Завершено сегодня",
    "mobile_tasks_bucket_completed_this_week": "Завершено на этой неделе",
    "mobile_tasks_bucket_completed_last_week": "Завершено на прошлой неделе",
    "mobile_tasks_bucket_missed_today": "Пропущено сегодня",
    "mobile_tasks_bucket_missed_this_week": "Пропущено на этой неделе",
    "mobile_tasks_bucket_missed_last_week": "Пропущено на прошлой неделе",
    "mobile_tasks_bucket_no_location": "Без локации",
    "mobile_tasks_cannot_submit_missed": "Пропущенные задачи завершить невозможно",
    "mobile_tasks_cannot_submit_missed_after": "Эту задачу невозможно завершить после {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Эта задача не начата.",
    "mobile_tasks_cannot_submit_processing": "Эта отправка обрабатывается",
    "mobile_tasks_toolbarnav_header_no_due_date": "Срок выполнения отсутствует",
    "mobile_tasks_toolbarnav_header_overdue": "Просрочено",
    "mobile_tasks_toolbarnav_header_yesterday": "Вчера",
    "mobile_tasks_toolbarnav_header_today": "Сегодня",
    "mobile_tasks_toolbarnav_header_tomorrow": "Завтра",
    "mobile_tasks_toolbarnav_header_last_week": "На прошлой неделе",
    "mobile_tasks_toolbarnav_header_this_week": "На этой неделе",
    "mobile_tasks_toolbarnav_header_next_week": "На следующей неделе",
    "mobile_tasks_toolbarnav_header_this_month": "В этом месяце",
    "mobile_tasks_toolbarnav_header_next_year": "В следующем году",
    "mobile_tasks_toolbarnav_header_over_year": "Больше года",
    "mobile_tasks_toolbarnav_title_edit_task": "Изменить задачу",
    "mobile_task_placeholder_title": "Название *",
    "mobile_task_placeholder_description": "Описание (необязательно)",
    "mobile_task_button_single_task": "Одиночная задача",
    "mobile_task_button_project": "Проект",
    "mobile_task_button_create": "Создать",
    "mobile_task_tab_basic": "Базовый",
    "mobile_task_tab_photo": "Фото",
    "mobile_task_tab_form": "Форма",
    "mobile_task_details_description_message_please": "Необходимо заполнить ",
    "mobile_task_details_description_message_below": "ниже.",
    "mobile_task_details_description_message_instructions": "Инструкции для этой задачи недоступны.",
    "mobile_task_details_reason_title": "Проверка исполнения с инициализацией по",
    "mobile_task_detials_button_goto_form": "Перейти к форме",
    "mobile_task_detials_button_complete": " Завершить задачу",
    "mobile_task_detials_completed": "Завершено ",
    "mobile_task_detials_completed_by": "— ",
    "mobile_task_detials_completed_on": "— ",
    "mobile_task_details_view_form_submission": "Смотреть отправленную форму",
    "mobile_task_task_updated": "Задача обновлена",
    "mobile_task_task_archived": "Задача архивирована",
    "mobile_task_task_deleted": "Задача удалена",
    "mobile_task_error_archiving_task": "Не удалось архивировать задачу.",
    "mobile_task_error_deleting_task": "Не удалось удалить задачу.",
    "mobile_task_error_updating_task": "Не удалось обновить задачу.",
    "mobile_task_archive_task": "Архивировать задачу",
    "mobile_task_archive_task_confirm": "Архивировать эту задачу?\n\nАрхивированные задачи учитываются в проценте выполнения работ и включаются в отчеты.\n\nЭто действие невозможно отменить.",
    "mobile_task_delete_task_confirm": "Удалить эту задачу?\n\nУдаленные задачи не учитываются в проценте выполнения работ и не включаются в отчеты.\n\nЭто действие невозможно отменить.",
    "mobile_task_edition_already_in_progress": "В этой задаче есть незавершенные правки. В настоящее время дальнейшее редактирование запрещено.",
    "mobile_projects_filter_type": "Тип",
    "mobile_projects_filter_status": "Статус проекта",
    "mobile_projects_filter_project_type": "Тип проекта",
    "mobile_projects_due_date_required": "Необходимо указать срок исполнения.",
    "mobile_projects_team_required": "Необходимо указать команду.",
    "mobile_projects_user_role_required": "Необходимо указать назначенное лицо.",
    "mobile_projects_title_required": "Необходимо указать заголовок.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Несколько задач в день",
    "mobile_project_tasks_complete": " Завершить",
    "mobile_project_tasks_remaining": " Остается",
    "mobile_esitmate_message_tasks": "Будет создано 0 задач",
    "mobile_esitmate_message_criteria": "Скорректировать критерии выше",
    "mobile_esitmate_message_created_for": "будет создано для",
    "mobile_left_menu_dashboard": "Информационная панель",
    "mobile_left_menu_my_forms": "Мои формы",
    "mobile_left_menu_announcements": "Объявления",
    "mobile_left_menu_my_submissions": "Мои отправления",
    "mobile_left_menu_drafts": "Черновики",
    "mobile_left_menu_pending_uploads": "Загрузки в ожидании",
    "mobile_left_menu_open": "Открыть в приложении",
    "mobile_left_menu_settings": "Настройки",
    "mobile_left_menu_log_out": "Выйти",
    "mobile_left_menu_debug": "Отладить",
    "mobile_left_menu_support": "Поддержка",
    "mobile_left_menu_documentation": "Документация",
    "mobile_left_menu_chat": "Чат",
    "mobile_field_textarea_placeholder_note": "Примечание или подпись",
    "mobile_field_option_select": "Выбрать",
    "mobile_field_text_placeholder_text": "Текст",
    "mobile_field_email_placehoder_email": "Электронная почта",
    "mobile_filed_number_placeholder_number": "Номер",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Не подключено",
    "mobile_field_sensor_offline_battery": "Датчик не в сети - аккумулятор",
    "mobile_field_video_button_add": "Добавить видео",
    "mobile_field_video_picker_dialog_title": "Добавить видео из",
    "mobile_field_video_button_change": "Изменить видео",
    "mobile_field_image_button_add": "Добавить изображение",
    "mobile_field_image_low_quality_warning": "Возможно, некоторые фотографии слишком темные или нечеткие. Проверьте выделенные фотографии и замените их при необходимости.",
    "mobile_field_image_picker_dialog_title": "Добавить фото из",
    "mobile_field_image_picker_edit_failed": "Не удалось сохранить изображение. Повторите попытку.",
    "mobile_field_signature_button_add": "Добавить подпись",
    "mobile_field_signature_button_change": "Изменить подпись",
    "mobile_field_account_select_location": "Выбрать локацию",
    "mobile_field_account_prefill": "Заполнить форму данными, введенными при прошлом посещении?",
    "mobile_field_account_message_overwrite": "При этом значения в уже заполненных полях будут перезаписаны.",
    "mobile_forms_task_on_behalf": "В этой локации есть задача, назначенная пользователю <b>{{user}}</b>. Завершить эту задачу?",
    "mobile_forms_complete_task": "Завершить задачу?",
    "mobile_field_account_prefill_button_yes": "Да, заполнить",
    "mobile_field_barcode_placeholder_scan": "Сканируйте или введите штрихкод",
    "mobile_field_sensor_qr_code_placeholder_scan": "Сканировать или ввести код",
    "mobile_field_gateway_id_code_placeholder": "Введите идентификатор узла",
    "mobile_field_scan_qr_or_enter_dev_eui": "Сканировать QR-код или ввести DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Сканировать QR-код или ввести номер ID",
    "mobile_field_scan_qr_or_enter_sc": "Сканировать QR-код или ввести код SC",
    "mobile_field_barcode_select_date": "Выберите дату ",
    "mobile_field_datetime_allow_time": "Время",
    "mobile_field_stopwatch_button_caption": "Секундомер",
    "mobile_field_stopwatch_common_start": "Пуск",
    "mobile_field_stopwatch_common_stop": "Стоп",
    "mobile_field_stopwatch_common_reset": "Сброс",
    "mobile_field_stopwatch_stop_stopwatches": "Остановить секундомер",
    "mobile_field_document_title": "Добавить документ",
    "mobile_field_document_message_delete": "Удалить этот документ?",
    "mobile_field_document_alret_button_view": "Смотреть",
    "mobile_field_document_alert_error": "При вложении этого документа произошла ошибка. Повторите попытку.",
    "mobile_field_document_alert_file_size_error": "Размер файла не должен превышать {{count}} МБ.",
    "mobile_field_temperature_greater_range": "больше {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "больше или равно {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "меньше {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "меньше или равно {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "больше или равно {{ min_temp_value }} °{{ temp_unit }} и меньше {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "больше или равно {{ min_temp_value }} °{{ temp_unit }} и меньше или равно {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " и ",
    "mobile_field_text_limit_error": "Достигнуто максимальное количество символов (8000).",
    "mobile_forms_required_questions_complete": "обязательных завершено",
    "mobile_forms_required_remaining": "{{count}} обязательных остается",
    "mobile_forms_required_questions_back": "Назад",
    "mobile_forms_required_questions_next": "Далее",
    "mobile_forms_required_questions_skip": "Пропустить",
    "mobile_forms_leaving_form": "Выполняется выход из формы",
    "mobile_message_reordering_confirm": "Сохранить новый порядок вопросов?",
    "mobile_forms_leaving_reordering": "Выход из вопросов об изменении порядка",
    "mobile_forms_reordering_button_save": "Сохранить новый порядок вопросов",
    "mobile_forms_reordering_instructions": "Чтобы упорядочить вопросы или разделы, перетащите поле в нужное место на форме",
    "mobile_toolbarnav_title_my_setttings": "Мои настройки",
    "mobile_toolbarnav_title_profile_settings": "Настройки профиля",
    "mobile_toolbarnav_title_notification": "Настройки уведомлений",
    "mobile_toolbarnav_title_form_history": "Журнал формы",
    "mobile_toolbarnav_title_form_not_available": "Форма недоступна",
    "mobile_toolbarnav_title_add_location": "Добавить локацию",
    "mobile_toolbarnav_title_add_task_or_project": "Добавить задачу или проект",
    "mobile_toolbarnav_title_select_location": "Выбрать локацию",
    "mobile_toolbarnav_title_select_project": "Выбрать проект",
    "mobile_toolbarnav_title_select_tag": "Выбрать метку",
    "mobile_toolbarnav_title_select_user": "Выбрать пользователя",
    "mobile_toolbarnav_title_select_template": "Выбрать шаблон",
    "mobile_toolbarnav_title_select_one": "Выбрать один",
    "mobile_toolbarnav_title_select_multiple": "Выбрать один или несколько",
    "mobile_toolbarnav_title_select_team": "Выбрать команду",
    "mobile_toolbarnav_title_select_team_or_location": "Выбрать команду или локацию",
    "mobile_toolbarnav_title_filter_tasks": "Фильтровать задачи",
    "mobile_toolbarnav_title_filter_projects": "Фильтровать проекты",
    "mobile_toolbarnav_title_filter_project_tasks": "Фильтровать задачи по проектам",
    "mobile_placeholder_search_bar": "Поиск",
    "mobile_placeholder_user_select_role": "Выбрать роль пользователя",
    "mobile_placeholder_filter_by_team": "Фильтровать по команде",
    "mobile_placeholder_assign_to_user_role": "Назначить роли пользователя",
    "mobile_placeholder_select": "-- Выбрать --",
    "mobile_placeholder_account_location_name": "Название локации",
    "mobile_placeholder_tag_filter_by": "Фильтровать по метке локации",
    "mobile_placeholder_user_type": "Назначить пользователю",
    "mobile_placeholder_acount_type_loading": "Загрузка... ",
    "mobile_placeholder_therm_no_bluetooth": "Температура",
    "mobile_placeholder_blue_therm_connecting": "Подключение к устройству...",
    "mobile_placeholder_blue_therm_please_wait": "Подождите...",
    "mobile_placeholder_blue_therm_tap": "Нажмите, чтобы прочитать.",
    "mobile_placeholder_blue_therm_not_connected": "Не подключено.",
    "mobile_placeholder_testo_tap": "Удерживать ▼▲, а затем нажать ⬆",
    "mobile_message_error_create_task": "Для добавления задач необходимо подключение к сети.",
    "mobile_message_error_fill_out_form": "Необходимо заполнить форму.",
    "mobile_message_error_fill_require_fields": "Заполните обязательные поля.",
    "mobile_message_error_stop_stopwatch_before_submit": "Перед отправкой остановите секундомер",
    "mobile_message_error_stopwatch_field_required": "Необходимо заполнить поле «Секундомер»",
    "mobile_message_error_stopwatch_field_running": "Значение в поле «Секундомер» не остановлено",
    "mobile_message_error_invalid_equipment_temperature": "Недопустимая температура оборудования",
    "mobile_message_error_invalid_ingredient_temperature": "Недопустимая температура ингредиента",
    "mobile_message_error_location_attributes_unavailable": "Некоторые вопросы недоступны, подключитесь к интернету",
    "mobile_message_alert_running_stopwatches": "Секундомеры не остановлены.\n\nОчистить значения?",
    "mobile_message_blue_therm_error": "Подключение к устройству через Bluetooth потеряно",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Требуется доступ к местоположению. Включите его в настройках Android.",
    "mobile_message_blue_therm_no_permission_android": "Требуется доступ к устройствам поблизости. Включите его в настройках Android.",
    "mobile_message_blue_therm_error_code": "Ошибка подключения:",
    "mobile_message_blue_therm_error_bluetooth": "Включите Bluetooth.",
    "mobile_message_blue_therm_error_device": "Устройство не найдено.",
    "mobile_message_blue_therm_error_try_again": "Повторите попытку",
    "mobile_message_blue_therm_success": "Устройство подключено через Bluetooth.",
    "mobile_message_bluetooth_device_press_button_field": "Для подключения нажмите кнопку на устройстве.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Если устройство не отображается в этом списке,<br />нажмите кнопку на устройстве.",
    "mobile_bluetooth_scan": "Сканировать",
    "mobile_bluetooth_scanning": "Сканирование",
    "mobile_message_drafts_confirm": "Сохранить как черновик?",
    "mobile_message_drafts_toast_saved": "Черновик сохранен.",
    "mobile_message_drafts_request_update": "Обновить этот черновик?",
    "mobile_message_drafts_form_confirm": "Удалить этот черновик?",
    "mobile_message_drafts_confirm_delete": "Удалить черновик",
    "mobile_message_streams_error_switch": "Невозможно изменить трансляции в сети",
    "mobile_message_settings_success_saved": "Настройки сохранены",
    "mobile_message_settings_error": "Произошла неизвестная ошибка. Повторите попытку позже.",
    "mobile_message_profile_settings_error_fields": "Исправьте значения в выделенных полях.",
    "mobile_message_media_perimission_denied": "Ваше ",
    "mobile_message_media_perimission_denied_device": "Хранилище устройства",
    "mobile_message_image_confirm_remove_image": "Удалить эту фотографию?",
    "mobile_message_create_account_error_fields": "Заполните значения в выделенных полях.",
    "mobile_message_create_account_success_location_created": "Локация создана",
    "mobile_message_task_error_get_location": "Сбой при получении расположения. Упорядочение по дате.",
    "mobile_message_typehead_confirm_save_message": "Сохранить выбранные значения?",
    "mobile_message_typehead_confirm_save_title": "Сохранить?",
    "mobile_message_task_creator_error_save_select_form": "Необходимо выбрать форму.",
    "mobile_message_task_creator_error_save_required_fields": "Заполните обязательные поля.",
    "mobile_message_task_creator_error_save_batch_change": "Измените критерии, чтобы сопоставить одного или нескольких пользователей",
    "mobile_message_task_detials_error_not_assigned_to_you": "Эта задача назначена не вам.<br />Вы не можете ее завершить.",
    "mobile_message_task_detials_error_assigned_to": "Эта задача назначена пользователю {{user}}.<br />Вы не можете ее завершить.",
    "mobile_message_task_detials_confirm_title": "Выполняется выход из задачи",
    "mobile_message_task_detials_confirm_save_task": "Сохранить задачу",
    "mobile_message_task_detials_confirm_message": "Вы уверены? Изменения будут утеряны.",
    "mobile_message_task_detials_error_view_account": "Невозможно получить доступ к локации.",
    "mobile_message_task_detials_error_submit_task": "Добавьте фото, чтобы завершить эту задачу.",
    "mobile_message_task_detials_error_submit_task_project": "Не удается сохранить проект. Повторите попытку позже.",
    "mobile_message_task_detials_wait_submit_task_created": "Выполняется создание задач.<br />Подождите несколько минут, пока в задачи вносятся данные.",
    "mobile_message_task_detials_error_submit_task_pending": "Ошибка. Повторите попытку позже.",
    "mobile_message_task_detials_success_task_complete": "Задача завершена",
    "mobile_message_task_error_save_single_task": "Не удается сохранить задачу. Повторите попытку позже.",
    "mobile_message_task_success_save_single_task": "Задача создана.",
    "mobile_message_show_error_message": "Что-то пошло не так.",
    "mobile_message_show_success_message": "Успешно!",
    "mobile_message_show_offline_message": "Вы не подключены к сети.",
    "mobile_message_show_permission_denied_message": "<b>Требуется разрешение.</b> Предоставьте Zenput разрешение на доступ к {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Требуется разрешение.</b> Предоставьте Zenput и используемому браузеру разрешение на доступ к {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Выполняется загрузка",
    "mobile_message_show_upload_in_progress_message": "Загрузка уже выполняется",
    "mobile_message_show_form_id_error": "Невозможно получить доступ к указанной форме.",
    "mobile_message_show_single_task_error": "Невозможно получить доступ к указанной задаче.",
    "mobile_message_show_submissions_error": "Невозможно получить доступ к указанной отправке.",
    "mobile_message_show_submissions_access_denied": "К сожалению, у вас нет доступа к этой форме.",
    "mobile_message_send_data_success": "Данные загружены ",
    "mobile_message_start_upload_success": "Загрузка завершена",
    "mobile_message_start_upload_error": "<b>Не удалось завершить загрузку.</b><br>Отправка сохранена. Повторите попытку позже.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Доступно обновление",
    "mobile_message_store_upgrade_confirm_message_one": "Обновите приложение Ops Execution из ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Выполните обновление Zenput в ",
    "mobile_message_store_upgrade_confirm_message_two": " для получения всех последних функций и исправления ошибок",
    "mobile_message_store_upgrade_confirm_now": "Сейчас",
    "mobile_message_store_upgrade_confirm_later": "Позже",
    "mobile_message_redirect_confirm_message": "В настоящее время вы заполняете форму. Сохранить ее как черновик, перед тем как продолжить?",
    "mobile_message_log_out_confirm_unsynced_drafts": "У вас есть незагруженные черновики ({{count}}). Если продолжить, они будут утеряны. Вы уверены?",
    "mobile_message_draft_override_message": "Этот черновик был сохранен на другом устройстве {{date}}. Изменения, вносимые на этом устройстве, приводят к конфликту. Можно перезаписать существующую версию или загрузить актуальную версию, и все изменения будут отменены.",
    "mobile_html_submitting": "Отправка...",
    "mobile_html_offline": "Вы не подключены к сети.",
    "mobile_html_offline_try_again": "Вы не подключены к сети. <br/><br/>Повторите попытку, восстановив подключение.",
    "mobile_html_something_went_wrong": "К сожалению, что-то пошло не так.",
    "mobile_html_something_went_wrong_try_again": "К сожалению, что-то пошло не так. Повторите попытку.",
    "mobile_html_failed_loading_roles": "Не удалось загрузить роли.",
    "mobile_alert_please_install_for_native": "Чтобы использовать эту функцию, установите приложение Ops Execution. ",
    "mobile_alert_please_install_for_native_old": "Установите приложение Zenput, чтобы воспользоваться этой функцией.",
    "mobile_tso_filter_all_tasks": "Все {{type}}",
    "mobile_tso_filter_my_tasks": "Мои {{type}}",
    "mobile_tso_filter_due_date": "Срок исполнения",
    "mobile_tso_filter_date_completed": "Дата указана",
    "mobile_tso_filter_completed": "Завершено",
    "mobile_tso_filter_completed_late": "Завершено с опозданием",
    "mobile_tso_filter_incomplete": "Не завершено",
    "mobile_tso_filter_var_my_tasks": "Мои {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "Созданные мной {{filter_type}} {{type}}",
    "mobile_tso_filter_var_all_tasks": "Все {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Дальнейшие действия",
    "mobile_tso_type_all": "Задачи и дальнейшие действия",
    "mobile_tso_filter_var_at": " в {{location}}",
    "mobile_tso_filter_group_date_due": ", упорядоченные по дате исполнения",
    "mobile_tso_filter_group_distance": ", сгруппированные по Локациям",
    "mobile_tso_filter_start_date": "Дата начала",
    "mobile_tso_filter_none": "Нет",
    "mobile_pso_filter_all_projects": "Все проекты",
    "mobile_pso_filter_my_projects": "Мои проекты",
    "mobile_pso_filter_active": "Активные",
    "mobile_pso_filter_archived": "В архиве",
    "mobile_pso_filter_recurring": "Повторяющиеся",
    "mobile_pso_filter_non_recurring": "Неповторяющиеся",
    "mobile_pso_filter_var_my_projects": "Мои проекты {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "Созданные мной проекты {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_all_projects": "Все проекты {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Похоже, вы не подключены к сети. Подключитесь, чтобы увидеть результаты.",
    "mobile_empty_list_message_no_submissions": "Нет отправлений",
    "mobile_empty_list_message_no_activity": "Нет активности",
    "mobile_empty_list_message_no_tasks": "Нет задач",
    "mobile_empty_list_message_no_tasks_overdue": "Нет просроченных {{type}}",
    "mobile_empty_list_message_no_accounts": "Нет локаций",
    "mobile_empty_list_message_no_projects": "Нет проектов",
    "mobile_empty_list_message_no_results_found": "Результаты не найдены",
    "mobile_empty_list_message_no_forms_available": "Нет доступных форм",
    "mobile_empty_list_message_connection_error": "Ошибка подключения<br />Повторите попытку позже.",
    "mobile_empty_list_message_dashboard_error": "Невозможно загрузить информационную панель",
    "mobile_empty_list_message_user_offline": "Вы не подключены к сети",
    "mobile_action_sheet_media_gallery": "Галерея",
    "mobile_action_sheet_cancel": "Отмена",
    "mobile_image_preview_text": "Удалить фотографию",
    "mobile_mobileform_text": "Предыдущие отправления",
    "mobile_mobileform_reorder_fields": "Вопросы об изменении порядка",
    "mobile_mobileform_follow_up_actions": "Последующие действия",
    "mobile_mobileform_follow_up_actions_assign_title": "Назначить дальнейшие действия",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Добавьте дальнейшие действия на основе своих наблюдений, чтобы гарантировать решение проблем.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Добавить дальнейшее действие",
    "mobile_mobileform_follow_up_actions_assign_button": "Назначить дальнейшие действия",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Продолжить без назначения",
    "mobile_mobileform_follow_up_actions_dialog_title": "Продолжить без назначения дальнейших действий?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Если вы продолжите без назначения дальнейших действий, вы не сможете добавить их позже.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Все равно продолжить",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Это обязательное поле",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Слишком много символов",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Недействительное поле",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Ошибка загрузки локаций",
    "mobile_mobileform_add_follow_up_actions_error_users": "Ошибка загрузки пользователей",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Добавить дальнейшее действие",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Заголовок",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Описание",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Требовать фото",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Срок выполнения",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Обновить дальнейшее действие",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Удалить дальнейшее действие?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Оно будет удалено и не будет назначено.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Удалить дальнейшее действие",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Удалить это дальнейшее действие?\n\nЭто будет невозможно отменить.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Перейти к дальнейшим действиям",
    "mobile_mobileform_follow_up_actions_completed_notification": "Дальнейшее действие завершено",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Дальнейшее действие удалено",
    "mobile_mobileform_follow_up_actions_update_notification": "Дальнейшее действие обновлено",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Добавьте фото, чтобы завершить это дальнейшее действие",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Перейти к отправке",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Перейти к источнику",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Источник",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Завершить дальнейшее действие",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Если вы открыли отправку, несохраненные фотографии и заметки будут утеряны.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Если вы покинете этот экран, все несохраненные фотографии и заметки будут утеряны.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Остаться",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Открыть отправку",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Открыть источник",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Выйти из этого дальнейшего действия?",
    "mobile_mobileform_follow_up_actions_submission": "Отправка",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Это дальнейшее действие назначено пользователю {{user}}.<br />Вы не можете его завершить.",
    "mobile_mobileform_follow_up_actions_leave_description": "Если вы покинете этот экран, все несохраненные изменения будут утеряны.",
    "mobile_mobileform_follow_up_actions_leave": "Выйти",
    "mobile_forms_drafts_text": "Удалить черновики",
    "mobile_batch_estimate_user": "Пользователь",
    "mobile_batch_estimate_users": "Пользователи",
    "mobile_table_of_contents": "Содержание",
    "mobile_table_of_contents_required": "Обязательные",
    "mobile_table_of_contents_optional": "Необязательные",
    "mobile_dialog_alert_title": "Оповещение",
    "mobile_dialog_alert_ok": "ОК",
    "mobile_windows_10_bluetherm_not_supported": "Устройства Bluetooth пока не поддерживаются в Windows",
    "mobile_windows_deprecated_message_content_announcement": "Объявление",
    "mobile_windows_deprecated_message_title": "Требуется обновить приложение",
    "mobile_windows_deprecated_message_description": "Как можно скорее установите новое приложение Zenput из магазина Microsoft Store, чтобы повысить удобство работы и регулярно получать обновления важных функций.",
    "mobile_dashboard_tcr_graph_name": "Процент выполнения задач",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "За последние 4 недели",
    "mobile_dashboard_tcr_legend_company_average": "Среднее для компании",
    "mobile_dashboard_tcr_legend_team_average": "Среднее для команды",
    "mobile_dashboard_tab_title_summary": "Сводка",
    "mobile_dashboard_tab_title_activity": "Активность",
    "mobile_dashboard_card_title_top_triggered_workflows": "Основные триггеры",
    "mobile_dashboard_tab_title_info": "Сведения",
    "mobile_dashboard_tab_project_audit": "Соблюдение требований",
    "mobile_dashboard_card_task_stats_total": "Итого",
    "mobile_dashboard_top_item_header_week_of": "Неделя",
    "mobile_dashboard_card_filter_form_template_placeholder": "Все формы",
    "mobile_dashboard_card_title_forms_top_nos": "Частые \"Нет\"s",
    "mobile_dashboard_zenput_code_no_data_in_range": "В этом диапазоне времени данные отсутствуют.",
    "mobile_dashboard_zenput_code_permission_denied": "У вас нет прав для просмотра этих материалов.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Выберите форму выше.",
    "mobile_dashboard_zenput_code_unknown_error": "В настоящее время невозможно показать эти данные.",
    "mobile_dashboard_tap_to_retry": "Нажмите, чтобы повторить попытку",
    "mobile_dashboard_reporting_delay_disclaimer": "Обновление задач может занять до 15 минут",
    "mobile_dashboard_configuration_down_state_postfix_msg": "настроено администратором.",
    "mobile_tasks_tag": "задачи",
    "mobile_workflows_tag": "триггеры",
    "mobile_projects_tag": "повторяющиеся проекты",
    "mobile_forms_tag": "формы",
    "mobile_dashboard_card_ongoing_projects_title": "Проекты в процессе выполнения",
    "mobile_dashboard_card_ongoing_projects_show_more": "Показать больше",
    "mobile_dashboard_card_ongoing_projects_show_less": "Показать меньше",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Перейти к проектам",
    "mobile_dashboard_card_title_recurring_projects": "Повторяющиеся проекты",
    "mobile_dashboard_card_filter_daily": "Ежедневно",
    "mobile_dashboard_card_filter_weekly": "Еженедельно",
    "mobile_dashboard_card_filter_monthly": "Ежемесячно",
    "mobile_task_status_title_open": "Открытые",
    "mobile_task_status_title_upcoming": "Предстоящие",
    "mobile_task_status_title_complete": "Завершенные",
    "mobile_task_status_title_processing": "Обработка отправления",
    "mobile_task_status_title_complete_with_exceptions": "Завершенные с задачами проверки исполнения или оповещениями",
    "mobile_task_status_title_completed_late_with_exceptions": "Завершено с опозданием с задачами проверки исполнения или оповещениями",
    "mobile_task_status_title_incomplete_and_closed": "Пропущенные",
    "mobile_tasks_legend_modal_title": "Условные обозначения",
    "mobile_tasks_legend_modal_footer_button_title": "Закрыть",
    "mobile_common_assigned_to": "Назначено",
    "mobile_common_created_by": "Создано",
    "mobile_common_tasks_for": "Задачи для",
    "mobile_common_go_back": "Назад",
    "mobile_oh_no": "Ой.",
    "mobile_user_not_in_groups": "Похоже, вы не назначены в эту команду. Обратитесь к администратору, чтобы получить доступ к информационной панели.",
    "mobile_tasks_select_followers": "Выбрать отслеживающие лица",
    "mobile_tasks_assign_tasks": "Назначить {{count}} задач",
    "mobile_tasks_add_followers": "Добавить отслеживающих лиц",
    "mobile_tasks_followers": "Отслеживающие лица",
    "mobile_tasks_delete_task": "Удалить задачу",
    "mobile_tasks_create_task": "Создать задачи",
    "mobile_tasks_tab_title_comments": "Комментарии",
    "mobile_tasks_see_more": "Смотреть больше",
    "mobile_projects_create_project": "Создать проект",
    "mobile_common_button_send": "Отправить",
    "mobile_common_button_schedule": "Расписание",
    "mobile_announcements_create": "Создать объявление",
    "mobile_announcements_read_rate": "Открыто {{opened_count}} из {{recipients_count}}",
    "mobile_announcements_empty_message": "Вы пока не создали ни одного объявления. Создайте объявление ниже, чтобы транслировать важные новости, информацию и обновления для своей организации.",
    "mobile_announcement_message_placeholder": "Добавить сообщение...",
    "mobile_announcement_title_placeholder": "Заголовок объявления",
    "mobile_announcement_leaving_announcement": "Выход из объявления",
    "mobile_announcement_confirm_recipients_team": "Транслировать это объявление пользователям ({{count}}) в выбранных командах ({{teams}})?",
    "mobile_announcement_confirm_recipients_role": "Транслировать это объявление пользователям ({{count}}) в выбранных ролях ({{roles}})?",
    "mobile_announcement_confirm_recipients_user": "Транслировать это объявление пользователям ({{count}})?",
    "mobile_announcement_confirm_scheduled": "Дата: {{timestamp}}",
    "mobile_announcement_sending_announcement": "Отправка объявления",
    "mobile_announcement_send_to": "Отправить",
    "mobile_announcement_sent_to": "Отправлено",
    "mobile_announcement_send_to_role": "Роль",
    "mobile_announcement_attachment_download": "Скачивание {{filename}}",
    "mobile_announcement_attachment_validation_error": "Можно добавить не больше {{maxCount}} вложений",
    "mobile_announcement_details_sent": "Отправлено",
    "mobile_announcement_details_total_recipients": "Всего получателей",
    "mobile_announcement_details_cancel": "Отменить объявление",
    "mobile_announcement_details_not_editable": "Объявления можно редактировать только в веб-приложении Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Объявления можно редактировать только в веб-версии Zenput",
    "mobile_announcement_details_open_count": "Количество открытых",
    "mobile_announcement_details_open_rate": "Количество открытых в процентах",
    "mobile_announcement_details_resend": "Отправить повторно пользователям, которые не открывали",
    "mobile_announcement_confirm_resend": "Некоторые пользователи ({{count}}) не прочитали объявление. Отправить им напоминание?",
    "mobile_announcement_confirm_resend_title": "Отправить напоминание?",
    "mobile_announcement_recipients_opened": "Открыто",
    "mobile_recipients_opened_empty_message": "Похоже, пока никто не открывал ваше сообщение. Попробуйте проверить результаты позже.",
    "mobile_announcement_recipients_unopened": "Не открыто",
    "mobile_recipients_unopened_empty_message": "Отличные новости! У вас нет непрочитанных сообщений!",
    "mobile_scheduled_announcements_delivery_section_header": "Время доставки",
    "mobile_scheduled_announcements_send_immediately_label": "Отправить сразу",
    "mobile_scheduled_announcements_scheduled_label": "Отправить в конкретное время",
    "mobile_scheduled_announcements_scheduled_tab_label": "Запланировано",
    "mobile_scheduled_announcements_dialog_header": "Отменить объявление?",
    "mobile_scheduled_announcements_dialog_message": "При отмене объявления оно не будет отправлено и будет удалено из списка. Это действие невозможно отменить. Чтобы внести изменения, перейдите в веб-версию Zenput.",
    "mobile_scheduled_announcements_empty_message": "В настоящее время вы не запланировали ни одного объявления. Запланируйте объявление, чтобы транслировать важные новости, информацию и обновления для своей организации.",
    "mobile_scheduled_announcements_validation_error": "Время доставки должно наступать позже {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Запланировать объявление",
    "mobile_projects_auto_archive": "Архивировать автоматически",
    "mobile_common_unassigned": "Не назначено",
    "mobile_tasks_title_placeholder": "Создать задачу или форму",
    "mobile_projects_leaving_project": "Выполняется выход из проекта",
    "mobile_projects_save_project": "Сохранить проект",
    "mobile_top_triggers_tasks": "Задачи с основными триггерами",
    "mobile_top_triggers_alerts": "Оповещения с основными триггерами",
    "mobile_projects_not_started": "Не начато",
    "mobile_empty_list_message_no_photos": "Нет фотографий",
    "mobile_webfilestore_message_error": "Выберите допустимый тип файла",
    "mobile_notifications_empty_title": "Нет уведомлений",
    "mobile_notifications_empty_message": "Действия, связанные с вашими задачами или с задачами, в которых вы заняты, будут отображаться здесь.",
    "mobile_comments_comment_deleted": "Этот комментарий был удален.",
    "mobile_comments_comment_placeholder": "Комментарий",
    "mobile_comments_task_submitted_at": "Задача отправлена {{ date }} в {{ time }}",
    "mobile_comments_discard_comment_title": "Отменить комментарий?",
    "mobile_comments_discard_confirm_message": "Вы уверены? Комментарий будет удален.",
    "mobile_comments_delete_comment_title": "Удалить комментарий?",
    "mobile_comments_delete_confirm_message": "Это действие невозможно отменить.",
    "mobile_comments_delete_button": "Удалить комментарий",
    "mobile_comments_delete_success_message": "Комментарий удален",
    "mobile_comments_empty_message_tasks": "Комментариев пока нет \n Начните общение в рамках этой задачи.",
    "mobile_comments_empty_message_submissions": "Комментариев пока нет \n Начните общение в рамках этого отправления.",
    "mobile_comments_empty_message_default": "Комментариев пока нет \n Начните общение.",
    "mobile_comments_no_matching_users": "Соответствие пользователей не обнаружено",
    "mobile_comments_empty_users_to_notify": "Нет пользователей для отправки уведомлений.",
    "mobile_comments_users_cant_view_message": "Эти пользователи не могут просматривать эти комментарии",
    "mobile_comments_users_to_notify_title": "Пользователи для отправки уведомлений",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">Уведомление будет отправлено {{ count }} пользователю</a>.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">Уведомление будет отправлено нескольким пользователям ({{ count }})</a>.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@упомяните</a> больше пользователей для отправки им уведомлений.",
    "mobile_comments_mark_read": "Пометить все как прочитанные",
    "mobile_comments_author_mentioned_message": "упомянул(а) вас в",
    "mobile_comments_author_commented_message": "оставил(а) комментарий",
    "mobile_view_pdf": "Смотреть PDF",
    "mobile_no_pdf_generated_message": "Файл PDF для этой отправки не найден. В ближайшее время вы получите копию по эл. почте.",
    "mobile_clipboard_copied_success": "Ссылка скопирована в буфер обмена.",
    "mobile_share_link": "Поделиться ссылкой",
    "mobile_zencam_share": "Общий доступ",
    "mobile_zencam_view_details": "Смотреть подробности",
    "mobile_zencam_details_drawer_header": "Подробности",
    "mobile_zencam_submitted_by": "Отправлено",
    "mobile_zencam_form_title": "Заголовок формы",
    "mobile_zencam_date_submitted": "Дата отправки",
    "mobile_oil_quality_warning_message": "Масло скоро закончится",
    "mobile_oil_quality_warning_message_subtitle": "Поменяйте масло в ближайшее время",
    "mobile_oil_quality_failure_message": "Качество масла снизилось",
    "mobile_oil_quality_failure_message_subtitle": "Поменяйте масло немедленно",
    "mobile_sensors_set_up_gateway": "Настроить шлюз",
    "mobile_sensors_set_up_gateway_message": "Похоже, настроенные устройства отсутствуют. Начните работу, добавив шлюз.",
    "mobile_sensors_gateway_plugged_in": "Убедитесь, что ваш шлюз подключен к сети электропитания",
    "mobile_sensors_add_device": "Добавить устройство",
    "mobile_sensors_name_this_gateway": "Задайте имя для шлюза.",
    "mobile_sensors_name_this_sensor": "Задайте имя для датчика.",
    "mobile_sensors_device_barcode_information": "Сканируйте QR-код или введите ID и номер SC с метки устройства",
    "mobile_sensors_device_eui_information": "Сканируйте QR-код или введите DevEUI с метки устройства",
    "mobile_sensors_gateway_id_information": "Введите идентификатор узла из метки шлюза",
    "mobile_sensors_id_number": "{{untranslatedID}} номер",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} код",
    "mobile_sensors_sensors": "Датчики",
    "mobile_sensors_sensor_deveui_error": "Ошибка чтения QR-кода. Введите DevEUI вручную.",
    "mobile_sensors_gateways": "Шлюзы",
    "mobile_sensors_add_sensor": "Добавить датчик",
    "mobile_sensors_add_gateway": "Добавить шлюз",
    "mobile_sensor_placement_description": "Какую область контролирует этот датчик?",
    "mobile_sensors_equipment_placement": "Какую область или какое оборудование контролирует этот датчик?",
    "mobile_sensors_equipment": "Какое оборудование контролирует этот датчик?",
    "mobile_sensors_select_gateway_type": "Выберите тип шлюза",
    "mobile_sensors_select_placement": "Выбрать размещение",
    "mobile_sensors_select_equipment": "Выберите оборудование",
    "mobile_sensors_placement": "Выбрать размещение",
    "mobile_sensors_nickname_tip": "Название датчика определяется псевдонимами, предназначенными для данного размещения.",
    "mobile_sensors_device_online": "В сети",
    "mobile_sensors_device_offline": "Не в сети",
    "mobile_sensors_scan_qrcode": "Сканировать QR-код",
    "mobile_sensors_enter_manually": "Ввести вручную",
    "mobile_sensors_wizard_step_one": "Шаг 1",
    "mobile_sensors_wizard_step_two": "Шаг 2",
    "mobile_sensors_wizard_step_three": "Шаг 3",
    "mobile_sensors_wizard_step_four": "Шаг 4",
    "mobile_sensors_wizard_step_five": "Шаг 5",
    "mobile_sensors_wizard_step_six": "Шаг 6",
    "mobile_sensors_initializing": "Инициализация...",
    "mobile_sensors_nickname": "Псевдоним",
    "mobile_sensors_field_not_blank": "{{field}} не может быть пустым.",
    "mobile_sensors_nothing_to_see_here": "Здесь нет данных",
    "mobile_sensors_missing_integration": "Отсутствует интеграция датчика",
    "mobile_sensors_contact_zenput_admin": "Обратитесь к администратору Ops Execution в вашей компании.",
    "mobile_sensors_contact_zenput_admin_old": "Обратитесь к своему администратору Zenput.",
    "mobile_sensors_contact_manager": "Для добавления датчиков свяжитесь с ответственным за учетную запись.",
    "mobile_sensors_device_success_message": "Загрузка данных датчиков может занять 15 минут",
    "mobile_sensors_last_reading": "Последние показания",
    "mobile_sensors_remove_device": "Удалить устройство",
    "mobile_sensors_one_day": "1 д.",
    "mobile_sensors_one_week": "1 нед.",
    "mobile_sensors_one_month": "1 мес.",
    "mobile_sensors_three_months": "3 мес.",
    "mobile_sensors_six_months": "6 мес.",
    "mobile_sensors_one_year": "1 г.",
    "mobile_sensors_sensor_settings": "Настройки датчика",
    "mobile_sensors_remove_confirm_message": "Удалить это устройство?\nЭто действие невозможно отменить.",
    "mobile_sensors_sensor": "Датчик",
    "mobile_sensors_no_equipment_linked": "Нет связанного оборудования",
    "mobile_sensor_cooldown_process": "Процесс охлаждения",
    "mobile_sensor_last_12_hours": "Последние 12 часов",
    "mobile_sensor_start_cooldown_process": "Начать новый процесс охлаждения",
    "mobile_sensor_cooldown_process_title": "Двухэтапный процесс охлаждения",
    "mobile_sensor_cooldown_process_description": "Двухэтапный процесс охлаждения предусматривает охлаждение пищи с {{ stage1_start_temperature }} до {{ stage1_end_temperature }} максимум за два часа, а затем с {{ stage1_end_temperature }} до {{ stage2_end_temperature }} максимум за четыре часа.",
    "mobile_sensor_cooldown_process_place_food": "Поместите пищевой продукт в холодильник.",
    "mobile_sensor_cooldown_process_insert_sensor": "Вставьте зонд датчика в пищевой продукт.",
    "mobile_sensor_cooldown_process_enter_information": "Укажите сведения ниже.",
    "mobile_sensor_cooldown_process_food_product": "Пищевой продукт для охлаждения",
    "mobile_sensor_cooldown_cool_down": "Охлаждение",
    "mobile_sensor_cooldown_select_sensor": "Выбрать датчик",
    "mobile_sensors_cooldown_start_cooldown": "Начать охлаждение",
    "mobile_sensors_cooldown_please_enter_food": "Укажите пищевой продукт",
    "mobile_sensors_cooldown_please_select_sensor": "Выберите датчик",
    "mobile_sensors_cooldown_status_in_progress": "В процессе выполнения",
    "mobile_sensors_cooldown_status_failed": "Сбой",
    "mobile_sensors_cooldown_status_success": "Успешно",
    "mobile_sensors_cooldown_stage": "Этап",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Начальная температура находится за пределом диапазона",
    "mobile_sensors_cooldown_failed_cooldown_process": "Сбой процесс охлаждения",
    "mobile_sensors_cooldown_cooldown_successful": "Процесс охлаждения прошел успешно",
    "mobile_sensors_cooldown_started_cooldown_process": "Процесс охлаждения запущен",
    "mobile_sensors_cooldown_hour": "час",
    "mobile_sensors_cooldown_hour_plural": "ч",
    "mobile_sensors_cooldown_minute": "минута",
    "mobile_minutes_plural": "мин",
    "mobile_sensors_last_reading_max_date": "> 1 года назад",
    "mobile_sensors_minute_count_ago": "{{count}} минуту назад",
    "mobile_sensors_minute_count_ago_plural": "{{count}} мин назад",
    "mobile_sensors_hour_count_ago": "{{count}} час назад",
    "mobile_sensors_hour_count_ago_plural": "{{count}} ч назад",
    "mobile_sensors_day_count_ago": "{{count}} день назад",
    "mobile_sensors_day_count_ago_plural": "{{count}} дн. назад",
    "mobile_sensors_chart_settings": "Настройки таблицы",
    "mobile_announcement_banner_continue_reading": "Продолжить читать",
    "mobile_compliance_submissions_report": "Отчет об отправках",
    "mobile_compliance_submissions_report_subtitle": "Экспортировать дату завершения проекта для этого магазина",
    "mobile_compliance_send_submissions": "Отправить отправки",
    "mobile_compliance_completion_rate_in_last_days": "Процент выполнения за последние {{ days }} дней",
    "mobile_compliance_last_days": "Последние {{ days }} дней",
    "mobile_compliance_send_submissions_to": "Отправить отправки",
    "mobile_compliance_send_to_different_email": "Отправить на другой адрес эл. почты",
    "mobile_compliance_email_input_placeholder": "Адрес эл. почты.",
    "mobile_compliance_send_submissions_to_legend_title": "Отправки",
    "mobile_compliance_send_submissions_to_legend_description_days": "Отчет с вашими отправками с этой локации за последние {{ days }} дней будет отправлен на выбранный адрес эл. почты.",
    "mobile_compliance_time_frame": "Интервал времени",
    "mobile_compliance_sensor_temperature_log_report": "Отчет о регистрации температуры датчика",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Экспортировать журналы температуры для этого магазина",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Критерии",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Определите критерии для отчета ниже.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Примечание: отключенные датчики в отчете не указываются",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Выберите интервал времени. Данные регистрации ограничены макс. 30 днями",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Отправить отчет",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "В этом месяце (с 1 по текущий день)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "В прошлом месяце",
    "mobile_compliance_sensor_temperature_log_email_title": "Отправить отчет",
    "mobile_pwa_update_prompt_title": "Обновите приложение",
    "mobile_pwa_update_prompt_description": "Доступна новая версия приложения. Выполните обновление до последней версии.",
    "mobile_pwa_update_prompt_confirm": "Обновить и перезагрузить",
    "mobile_pwa_update_prompt_cancel": "Напомнить позже",
    "notification_title_due_in_one_hour": "Срок: 1 час",
    "task_is_due_soon": "Подходит срок задачи «{{ task_title }}». Завершите ее.",
    "mobile_photo_quality_warning_header": "Проблема с качеством фото",
    "mobile_photo_quality_dialog_message": "Возможно, это фото слишком темное или нечеткое. Вы хотите сделать новое фото или использовать это?",
    "mobile_take_new_photo": "Сделать новое фото",
    "mobile_use_this_photo": "Использовать это фото"
}};
mobile_translations.si_LK = { translation: {
    "mobile_common_zenput": "Zenput (සෙන්පුට්)",
    "mobile_common_all": "සියලුම",
    "mobile_common_button_apply_filters": "පෙරහන් යොදන්න",
    "mobile_common_button_done": "කරන ලදී",
    "mobile_common_button_edit": "සංස්කරණය කරන්න",
    "mobile_common_button_archive": "සංරක්ෂණය කරන්න",
    "mobile_common_button_save": "සුරකින්න",
    "mobile_common_button_retake": "නැවත ගන්න",
    "mobile_common_button_save_draft": "කෙටුම්පත සුරකින්න",
    "mobile_common_button_discard": "ඉවත දමන්න",
    "mobile_common_button_submit": "ඉදිරිපත් කරන්න",
    "mobile_common_button_no": "නැත",
    "mobile_common_button_yes": "ඔව්",
    "mobile_common_button_na": "අදාල නැත",
    "mobile_common_created_by_me": "මා විසින් නිර්මාණය කෙරිණ",
    "mobile_common_email": "සමාගමේ ඊමේලය",
    "mobile_common_first_name": "මුල් නම",
    "mobile_common_last_name": "අවසන් නම",
    "mobile_common_location": "ස්ථානය",
    "mobile_common_locations": "ස්ථාන",
    "mobile_common_logout_message": "ඔබට ඉවත් වීමට අවශ්﻿ය බව ඔබට සහතික ද?",
    "mobile_common_password": "මුරපදය",
    "mobile_common_permission_required": "අවසර අවශ්﻿යයි",
    "mobile_common_status": "තත්ත්වය",
    "mobile_common_task": "කාර්ය",
    "mobile_common_tasks": "කාර්යයන්",
    "mobile_common_tasks_my": "මගේ කාර්යයන්",
    "mobile_common_projects": "ව්﻿යාපෘති",
    "mobile_common_filter_team": "කණ්ඩායම",
    "mobile_common_filter_var_in": " තුළ {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "කණ්ඩායමක් තෝරා ගෙන නොමැත",
    "mobile_common_filter_no_user_selected": "පරිශීලකයෙකු තෝරා ගෙන නොමැත",
    "mobile_common_filter_no_role_selected": "භූමිකාවක් තෝරා ගෙන නොමැත",
    "mobile_common_placeholder_date": "දිනය",
    "mobile_common_message_task_creator_error_save": "<b>කාර්යයන් නිර්මාණය කිරීමට නොහැකි විය.</b>",
    "mobile_common_camera": "කැමරාව",
    "mobile_common_microphone": "මයික්‍රොෆෝනය",
    "mobile_common_for": "සඳහා",
    "mobile_common_reload": "නැවත පටවන්න",
    "mobile_common_override": "අභිබවා යන්න",
    "mobile_common_notifications": "දැනුම් දීම්",
    "mobile_common_chat_unavailable": "කථාබස් (chat) නොමැත. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
    "mobile_common_chat_ending_dialog_title": "මේ සංවාදය ඉවරද?",
    "mobile_common_chat_ending_dialog_description": "ඔබේ ගැටලුව විසඳී ඇත්ද නැතහොත් පසුව ඉදිරියට යාමට අවශ්‍ය නම් අපට දන්වන්න.",
    "mobile_common_chat_ending_dialog_confirm": "ඔව්, මම ඉවරයි",
    "mobile_common_chat_ending_dialog_cancel": "මම පසුව දිගටම කරගෙන යන්නම්",
    "mobile_common_continue_editing": "දිගටම සංස්කරණය කරන්න",
    "mobile_privacy_policy": "රහස්‍යතා ප්‍රතිපත්තිය",
    "wootric_recommend_target": "ඔබේ කර්මාන්තයේ මිතුරෙකු හෝ සගයකු",
    "wootric_followup_detractor_question": "ඊළඟ වතාවේ අපට ඉහළ අගයක් ලබා දීම සඳහා ඔබ වෙනුවෙන් කළ හැකි වෙනස්කම් මොනවා ද?",
    "wootric_followup_passive_question": "ඔබට ස්තුතියි! මෙවලම වඩාත් හොඳ කිරීමට අපට කුමක් කළ හැකි ද?",
    "wootric_followup_promoter_question": "ස්තුතියි! Crunchtime Ops Execution ගැන ඔබේ කැමැත්ත ඇතිවීමට හේතුව කුමක්ද?",
    "wootric_followup_promoter_question_old": "ඔබට ස්තුතියි! Zenput ගැන ඔබ කැමති කුමකට ද?",
    "wootric_default_followup_question": "ඔබට ස්තුතියි! ඒ ඇයි දැයි අපට පැවසීමට සැලකිලිමත් ද?",
    "wootric_default_placeholder_text": "ඔබගේ ලකුණු පැහැදිලි කිරීමෙන් අපට උදව් කරන්න.",
    "wootric_default_thankyou_text": "ඔබගේ ප්﻿රතිචාරයට, සහ ඔබගේ අදහසට ස්තූතියි!",
    "mobile_login_placeholder_login_as": "පරිශීලක හැඳුනුමක් ලෙස පිවිසෙන්න",
    "mobile_login_button_forgot_password": "මුරපදය අමතක වුණා ද?",
    "mobile_login_button_sign_up": "ගිණුම තනන්න",
    "mobile_login_button_finish_setup": "පිහිටුවීම අවසන් කරන්න",
    "mobile_login_button": "ලොගින් වන්න",
    "mobile_login_continue_button": "දිගටම කර ගෙන යන්න",
    "mobile_login_continue_transition": "ඔබේ සංවිධානයේ ලොගින් වන පිටුවට ඔබ ගෙන යයි...",
    "mobile_login_no_email_error": "ඔබ ඊමේල් ලිපිනයක් ඇතුළත් කළ යුතුය.",
    "mobile_login_change_email": "වෙනස් ඊමේල් ලිපිනයකින් ලොගින් වන්න",
    "mobile_login_with_sso": "SSO සමඟ පිවිසෙන්න",
    "mobile_oauth_no_user_error_message": "ඔබට Crunchtime Ops Execution ගිණුමක් නොමැති බව පෙනේ!",
    "mobile_oauth_no_user_error_message_old": "ඔබට Zenput ගිණුමක් නොමැති බව පෙනේ!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> දැන් <b>Crunchtime Ops Execution</b> ලෙස වෙනස් වී ඇත",
    "mobile_rebrand_warning_banner": "සැප්තැම්බරයේ දී {{- brand }} {{- product }} බවට පත්වෙමින් තිබේ. {{- cta }}",
    "mobile_rebrand_warning_cta": "සූදානම් වන ආකාරය ඉගෙන ගන්න.",
    "mobile_oauth_no_user_error_sub_message": "ප්﻿රවේශය සඳහා ඔබේ පරිපාලක අමතන්න, නැති නම් වෙනත් ඊමේල් ලිපිනයක් සමග ලොග් වීමට උත්සාහ කරන්න.",
    "mobile_oauth_generic_error_message": "ලොගින් වීමේ ගැටළුවක් ඇති බව පෙනේ, කරුණාකර නැවත උත්සාහ කරන්න.",
    "mobile_oauth_force_logout_msg": "ඔබට තවමත් ගැටළු තිබේ නම්, ඔබේ සැපයුම්කරුගෙන් ඉවත් වන්න ",
    "mobile_oauth_force_logout_click": "මෙතැන ක්ලික් කිරීම.",
    "mobile_sign_up_placeholder_phone": "සෙල් අංකය",
    "mobile_sign_up_placeholder_password_confirm": "මුරපදය තහවුරු කරන්න",
    "mobile_sign_up_button_sign_in": "ඇතුළු වන්න",
    "mobile_sign_up_disclaimer_part_1": "ගිණුමක් සාදන්න ක්ලික් කිරීමෙන්, ඔබ එකඟ වන්නේ",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "පිහිටුවීම අවසන් කරන්න ක්ලික් කිරීමෙන්, ඔබ එකඟ වේ",
    "mobile_sign_up_disclaimer_link_title": " බලපත්﻿ර ගිවිසුමටය",
    "mobile_sign_up_disclaimer_part_2": ", එහි වැදගත් රහස්﻿යතා තොරතුරු ඇතුළත් වේ",
    "mobile_dialog_benefits_work_offline": "ඕෆ්ලයින් වැඩ කරන්න",
    "mobile_dialog_benefits_faster_uploads": "වේගවත් උඩුගත කිරීම්",
    "mobile_dialog_benefits_better_experience": "වඩා හොඳ අත්දැකීමක්",
    "mobile_dialog_benefits_button_download": "බා ගන්න",
    "mobile_dialog_benefits_button_download_bold": "ස්ථාන ප්‍රවේශය සඳහා Ops Execution අවශ්‍ය වේ. ",
    "mobile_dialog_benefits_button_download_bold_old": "... සඳහා Zenput ",
    "mobile_dialog_benefits_button_have": "මට යෙදුම තිබේ!",
    "mobile_dialog_benefits_button_no_thanks": "නැහැ ස්තූතියි, සමහර විට පසුව.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "රූපය පැටවීමට අපොහොසත් විය.",
    "mobile_dialog_signature_sign": "මෙතැන අත්සන් කරන්න",
    "mobile_dialog_signature_button_clear": "පිරිසිදු කරන්න",
    "mobile_account_placeholder_name": "ස්ථානය/ගබඩාවේ නම",
    "mobile_account_placeholder_phone": "දුරකථනය",
    "mobile_account_placeholder_address": "ලිපිනය",
    "mobile_account_placeholder_city": "නගරය",
    "mobile_account_placeholder_region": "කලාපය",
    "mobile_account_placeholder_zipcode": "තැපැල් කේතය/ZIP",
    "mobile_account_option_select_country": "රට තෝරන්න",
    "mobile_account_oprion_us": "එක්සත් ජනපදය",
    "mobile_account_oprion_select_state": "ප්﻿රාන්තය තෝරන්න",
    "mobile_account_button_create_location": "ස්ථානය සාදන්න",
    "mobile_form_message_no_form": "පෝරම නොමැත",
    "mobile_batch_task_message": "පැටවෙමින් ...",
    "mobile_settings_profile": "පැතිකඩ",
    "mobile_settings_profile_number": "සෙල් දුරකථනය",
    "mobile_settings_profile_language": "භාෂාව",
    "mobile_settings_profile_temperature_unit": "උෂ්ණත්ව ඒකකය",
    "mobile_settings_profile_use_company_default": "සමාගම් පෙරනිමිය භාවිතා කරන්න",
    "mobile_settings_profile_celsius": "සෙල්සියස්",
    "mobile_settings_profile_fahrenheit": "ෆැරන්හයිට්",
    "mobile_settings_notifications_option_sms": "පාඨ පණිවුඩය",
    "mobile_settings_notifications_option_push": "පුෂ් නිවේදන",
    "mobile_settings_notifications_option_push_email": "ඊමේල් සහ පුෂ් නිවේදන",
    "mobile_settings_notifications_option_do_not": "දැනුම් නොදෙන්න",
    "mobile_settings_notifications_category_communication": "සන්නිවේදනය",
    "mobile_settings_notifications_category_forms_and_triggers": "ආකෘති සහ උත්ප්‍රේරක",
    "mobile_settings_devices": "මෙවලම්",
    "mobile_settings_notifications_sub_category_alerts": "සෝදිසි",
    "mobile_settings_notifications_sub_category_new_forms_available": "නව ආකෘති පත්‍ර ලද හැකිය",
    "mobile_settings_notifications_sub_category_task_assigned": "කාර්යය පවරා ඇත",
    "mobile_settings_notifications_sub_category_task_completed": "කාර්යය සම්පූර්ණ කර ඇත",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "ඉක්මනින් කිරීමට නියමිත කාර්යයන් මතක් කිරීම",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "කල් ඉකුත් වූ කාර්යයන් මතක් කිරීම",
    "mobile_settings_notifications_sub_category_sensor_alerts": "සංවේදක ඇඟවීම්",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "තීරණාත්මක සංවේදක සෝදිසිය",
    "mobile_drafts_message": "ඔබට තවම කිසිදු කෙටුම්පතක් නොමැත.",
    "mobile_drafts_button_delete": "මකන්න",
    "mobile_tasks_filter_location_no": "ස්ථානයක් තෝරා ගෙන නොමැත",
    "mobile_tasks_filter_group_by": "සමූහය මගින්",
    "mobile_tasks_filter_sort_by": "අනුව වර්ග කිරීම",
    "mobile_tasks_filter_sorted_by": "අනුව වර්ග කර ඇත",
    "mobile_tasks_filter_due_time": "නියමිත වේලාව",
    "mobile_tasks_filter_open_time": "විවෘත වේලාව",
    "mobile_tasks_bucket_due_next_24_hours": "ඊළඟ පැය 24 තුළ නියමිතයි",
    "mobile_tasks_bucket_due_next_7_days": "ඊළඟ දින 7 තුළ නියමිතයි",
    "mobile_tasks_bucket_open_tasks": "අතිරේක විවෘතය {{type}}",
    "mobile_tasks_bucket_open_at": "විවෘත කරන්න: {{- date }}, {{- time }}හි",
    "mobile_tasks_bucket_due_by_at": "නියමිතයි: {{- date }}, {{- time }} හි",
    "mobile_tasks_bucket_available_in_one_minute": "මිනිත්තු 1 ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_one_hour": "පැය 1 ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_one_day": "දින 1 ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_one_week": "සති 1 ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_one_month": "මාස 1 ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_one_year": "වර්ෂ 1 ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_minutes": "මිනිත්තු {{ minutes }} ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_hours": "පැය {{ hours }} ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_days": "දින {{ days }} ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_weeks": "සති {{ weeks }} ක් තුළ ලද හැකිය",
    "notification_task_due_in_minutes": "මිනිත්තු {{ minutes }}කින් අවසන් වේ",
    "mobile_tasks_bucket_available_in_months": "මාස {{ months }} ක් තුළ ලද හැකිය",
    "mobile_tasks_bucket_available_in_years": "වර්ෂ {{ years }} ක් තුළ ලද හැකිය",
    "mobile_tasks_follow_up": "පසු විපරම කාර්යය",
    "mobile_tasks_due_soon": "ළඟදීම නියමිතයි",
    "mobile_tasks_bucket_completed_today": "අද සම්පූර්ණ කෙරිණ",
    "mobile_tasks_bucket_completed_this_week": "මෙම සතියේ සම්පූර්ණ කෙරිණ",
    "mobile_tasks_bucket_completed_last_week": "පසු ගිය සතියේ සම්පූර්ණ කෙරිණ",
    "mobile_tasks_bucket_missed_today": "අද මග හැරුණි",
    "mobile_tasks_bucket_missed_this_week": "මේ සතියේ මග හැරුණි",
    "mobile_tasks_bucket_missed_last_week": "පසු ගිය සතියේ මඟ හැරුණි",
    "mobile_tasks_bucket_no_location": "ස්ථානයක් නැත",
    "mobile_tasks_cannot_submit_missed": "මඟ හැරුණු කාර්යයන් සම්පූර්ණ කළ නොහැක",
    "mobile_tasks_cannot_submit_missed_after": "... පසු මෙම කාර්යය සම්පූර්ණ කළ නොහැක {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "මෙම කාර්යය ආරම්භ කර නැත.",
    "mobile_tasks_cannot_submit_processing": "මෙම ඉදිරිපත් කිරීම සිදු කෙරෙමින් පවතී",
    "mobile_tasks_toolbarnav_header_no_due_date": "නියමිත දිනයක් නොමැත",
    "mobile_tasks_toolbarnav_header_overdue": "කල් ඉකුත් වීම",
    "mobile_tasks_toolbarnav_header_yesterday": "ඊයේ",
    "mobile_tasks_toolbarnav_header_today": "අද",
    "mobile_tasks_toolbarnav_header_tomorrow": "හෙට",
    "mobile_tasks_toolbarnav_header_last_week": "ගිය සතිය",
    "mobile_tasks_toolbarnav_header_this_week": "මේ සතිය",
    "mobile_tasks_toolbarnav_header_next_week": "ඊළඟ සතිය",
    "mobile_tasks_toolbarnav_header_this_month": "මේ මාසය",
    "mobile_tasks_toolbarnav_header_next_year": "ඊළඟ වසර",
    "mobile_tasks_toolbarnav_header_over_year": "වසරකට වැඩි",
    "mobile_tasks_toolbarnav_title_edit_task": "කාර්යය සංස්කරණය කරන්න",
    "mobile_task_placeholder_title": "මාතෘකාව *",
    "mobile_task_placeholder_description": "විස්තරය (විකල්ප)",
    "mobile_task_button_single_task": "තනි කාර්යය",
    "mobile_task_button_project": "ව්﻿යාපෘතිය",
    "mobile_task_button_create": "සාදන්න",
    "mobile_task_tab_basic": "මූලික",
    "mobile_task_tab_photo": "ඡායාරූපය",
    "mobile_task_tab_form": "පෝරමය",
    "mobile_task_details_description_message_please": "කරුණාකර පුරවන්න ",
    "mobile_task_details_description_message_below": "පහත.",
    "mobile_task_details_description_message_instructions": "මෙම කාර්යය සඳහා උපදෙස් නොමැත.",
    "mobile_task_details_reason_title": "... අවුළුවන ලද පසු-විපරම",
    "mobile_task_detials_button_goto_form": "පෝරමයට යන්න",
    "mobile_task_detials_button_complete": " කාර්යය සම්පූර්ණ කරන්න",
    "mobile_task_detials_completed": "සම්පුර්ණ කෙරිණ ",
    "mobile_task_detials_completed_by": "විසින් ",
    "mobile_task_detials_completed_on": "මත ",
    "mobile_task_details_view_form_submission": "පෝරම ඉදිරිපත් කිරීම බලන්න",
    "mobile_task_task_updated": "කාර්යය යාවත්කාලීන කෙරිණ",
    "mobile_task_task_archived": "කාර්යය සංරක්ෂණය කෙරිණ",
    "mobile_task_task_deleted": "කාර්යය මකා දැමිණ",
    "mobile_task_error_archiving_task": "කාර්යය සංරක්ෂණය කිරීමට නොහැකි විය.",
    "mobile_task_error_deleting_task": "කාර්යය මකා දැමිමට නොහැකි විය.",
    "mobile_task_error_updating_task": "කාර්යය යාවත්කාලීන කිරීමට නොහැකි විය.",
    "mobile_task_archive_task": "කාර්යය සංරක්ෂණ කරන්න",
    "mobile_task_archive_task_confirm": "මෙම කාර්යය සංරක්ෂණය කිරීමට ඔබ කැමති බව ඔබට සහතික ද?\n\nසම්පුර්ණ කිරීමේ අගය සඳහා සංරක්ෂිත කාර්යයන් ගණන් ගනු ඇති අතර, වාර්තාකරණයට දිගටම ඇතුළත් වේ.\n\nමෙය ආපසු හැරවීමට නොහැක.",
    "mobile_task_delete_task_confirm": "මෙම කාර්යය මකා දැමීමට ඔබ කැමති බව ඔබට සහතික ද?\n\nමකා දැමූ කාර්යයන් සම්පූර්ණ කිරීමේ අගයන් සඳහා ගණන් නොගනු ඇති අතර කිසිදු වාර්තාකරණයකට ඇතුළත් නොවේ.\n\nමෙය ආපසු හැරවීමට නොහැක.",
    "mobile_task_edition_already_in_progress": "මෙම කාර්යය සඳහා සංස්කරණයක් ඉතිරිව ඇත. වැඩි දුර සංස්කරණය කිරීමට දැනට අවසර නැත.",
    "mobile_projects_filter_type": "වර්ගය",
    "mobile_projects_filter_status": "ව්﻿යාපෘති තත්ත්වය",
    "mobile_projects_filter_project_type": "ව්﻿යාපෘති වර්ගය",
    "mobile_projects_due_date_required": "නියමිත දිනය අවශ්﻿ය වේ.",
    "mobile_projects_team_required": "කණ්ඩායම අවශ්﻿යයි.",
    "mobile_projects_user_role_required": "පැවරුම්ලාභියා අවශ්﻿යයි.",
    "mobile_projects_title_required": "මාතෘකාව අවශ්﻿යයි.",
    "mobile_projects_recurring_multiple_tasks_per_day": "දවසකට කාර්යයන් ගණනාවක්",
    "mobile_project_tasks_complete": " සම්පූර්ණ කරන්න",
    "mobile_project_tasks_remaining": " ඉතිරි",
    "mobile_esitmate_message_tasks": "කාර්යයන් 0 ක් නිර්මාණය වනු ඇත",
    "mobile_esitmate_message_criteria": "ඉහත නිර්ණායකය සකස් කරන්න",
    "mobile_esitmate_message_created_for": "... සඳහා නිර්මාණය වනු ඇත",
    "mobile_left_menu_dashboard": "පාලන පුවරුව",
    "mobile_left_menu_my_forms": "මගේ පෝරම",
    "mobile_left_menu_announcements": "නිවේදන",
    "mobile_left_menu_my_submissions": "මගේ ඉදිරිපත් කිරීම්",
    "mobile_left_menu_drafts": "කෙටුම්පත්",
    "mobile_left_menu_pending_uploads": "පවතින උඩුගත කිරීම්",
    "mobile_left_menu_open": "යෙදුම තුළ විවෘත කරන්න",
    "mobile_left_menu_settings": "සැකසුම්",
    "mobile_left_menu_log_out": "පිටවන්න",
    "mobile_left_menu_debug": "නිදොස්කරණය",
    "mobile_left_menu_support": "සහාය",
    "mobile_left_menu_documentation": "ලේඛනකරණය",
    "mobile_left_menu_chat": "කතාබහ",
    "mobile_field_textarea_placeholder_note": "සටහන හෝ මාතෘකාව",
    "mobile_field_option_select": "තෝරන්න",
    "mobile_field_text_placeholder_text": "පාඨ",
    "mobile_field_email_placehoder_email": "ඊමේලය",
    "mobile_filed_number_placeholder_number": "ගණන",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "සම්බන්ධ වී නැත",
    "mobile_field_sensor_offline_battery": "සංවේදකය නොබැඳියි - බැටරිය",
    "mobile_field_video_button_add": "වීඩියෝවක් එක් කරන්න",
    "mobile_field_video_picker_dialog_title": "වීඩියෝව එක් කරන්න",
    "mobile_field_video_button_change": "වීඩියෝව වෙනස් කරන්න",
    "mobile_field_image_button_add": "රූපය එක් කරන්න",
    "mobile_field_image_low_quality_warning": "ඇතැම් ඡායාරූප අවශ්‍යයට වඩා අඳුරු හෝ නොපැහැදිලි විය හැක. උද්දීපනය කළ ඡායාරූප සමාලෝචනය කර අවශ්‍ය නම් ඒවා ආදේශ කරන්න.",
    "mobile_field_image_picker_dialog_title": "ඡායාරූපයක් එක් කරන්න",
    "mobile_field_image_picker_edit_failed": "අපට රූපය සුරැකීමට නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "mobile_field_signature_button_add": "අත්සනක් එක් කරන්න",
    "mobile_field_signature_button_change": "අත්සන වෙනස් කරන්න",
    "mobile_field_account_select_location": "ස්ථානයක් තෝරන්න",
    "mobile_field_account_prefill": "අවසාන සංචාරයේ දත්තවලින් ආකෘති පත්﻿රය පුරවන්න?",
    "mobile_field_account_message_overwrite": "මෙය ඔබ දැනටමත් පුරවා ඇති ඕනෑම ක්ෂේත්﻿රයක් මකා දමනු ඇත.",
    "mobile_forms_task_on_behalf": "... වෙත පවරා ඇති මෙම ස්ථානයේ දී ඉටු කිරීමට නියමිත කාර්යයක් ඇත <b>{{user}}</b>. මෙම කාර්යය සම්පූර්ණ කිරීමට ඔබ කැමති ද?",
    "mobile_forms_complete_task": "කාර්යය සම්පූර්ණ කරන්න?",
    "mobile_field_account_prefill_button_yes": "ඔව්, කලින් පුරවන්න",
    "mobile_field_barcode_placeholder_scan": "ස්කෑන් කරන්න, නැති නම් තීරු කේතය ටයිප් කරන්න",
    "mobile_field_sensor_qr_code_placeholder_scan": "කේතය ස්කෑන් කිරීම හෝ ටයිප් කිරීම කරන්න",
    "mobile_field_gateway_id_code_placeholder": "නෝඩ් හැඳුනුම්පත ටයිප් කරන්න",
    "mobile_field_scan_qr_or_enter_dev_eui": "QR කේතය ස්කෑන් කිරීම හෝ DevEUI ඇතුල් කිරීම කරන්න",
    "mobile_field_scan_qr_or_enter_id": "QR කේතය ස්කෑන් කිරීම හෝ ID අංකය ඇතුල් කිරීම කරන්න",
    "mobile_field_scan_qr_or_enter_sc": "QR කේතය ස්කෑන් කිරීම හෝ SC කේතය ඇතුල් කිරීම කරන්න",
    "mobile_field_barcode_select_date": "දිනය තෝරන්න ",
    "mobile_field_datetime_allow_time": "වේලාව",
    "mobile_field_stopwatch_button_caption": "නැවතුම් ඔරලෝසුව",
    "mobile_field_stopwatch_common_start": "ආරම්භ කරන්න",
    "mobile_field_stopwatch_common_stop": "නවත්වන්න",
    "mobile_field_stopwatch_common_reset": "නැවත සකසන්න",
    "mobile_field_stopwatch_stop_stopwatches": "නැවතුම් ඔරලෝසු නවත්වන්න",
    "mobile_field_document_title": "ලේඛනය එක් කරන්න",
    "mobile_field_document_message_delete": "ඔබට මෙම ලේඛනය මකා දැමීමට අවශ්﻿ය බව සහතික ද?",
    "mobile_field_document_alret_button_view": "පෙනීම",
    "mobile_field_document_alert_error": "මෙම ලේඛනය අමුණා ගැනීමේ දෝෂයක් ඇති විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "mobile_field_document_alert_file_size_error": "ගොනුව MB {{count}} ඉක්මවිය නොහැක.",
    "mobile_field_temperature_greater_range": "{{ temp_value }} °{{ temp_unit }} ට වඩා වැඩි",
    "mobile_field_temperature_greater_or_equal_range": "{{ temp_value }} °{{ temp_unit }} ට වඩා වැඩි හෝ සමාන",
    "mobile_field_temperature_less_range": "{{ temp_value }} °{{ temp_unit }} ට වඩා අඩු",
    "mobile_field_temperature_less_or_equal_range": "{{ temp_value }} °{{ temp_unit }} ට වඩා අඩු හෝ සමාන",
    "mobile_field_temperature_between_range": "{{ min_temp_value }} °{{ temp_unit }} ට වඩා වැඩි හෝ සමාන සහ {{ max_temp_value }} °{{ temp_unit }} ට වඩා අඩු",
    "mobile_field_temperature_inclusive_between_range": "{{ min_temp_value }} °{{ temp_unit }} ට සමාන හෝ විශාල සහ {{ max_temp_value }} °{{ temp_unit }} ට සමාන හෝ අඩු",
    "mobile_field_temperature_operators_separator": " සහ ",
    "mobile_field_text_limit_error": "8000 ක උපරිම අක්ෂර සීමාවට ළඟා විය.",
    "mobile_forms_required_questions_complete": "සම්පූර්ණ කිරීම අවශ්﻿යයි",
    "mobile_forms_required_remaining": "{{count}} අවශ්‍ය ඉතිරිව තිබීම",
    "mobile_forms_required_questions_back": "ආපසු",
    "mobile_forms_required_questions_next": "ඊළඟ",
    "mobile_forms_required_questions_skip": "නොසලකා හරින්න",
    "mobile_forms_leaving_form": "පෝරමයෙන් ඉවත් වීම",
    "mobile_message_reordering_confirm": "ඔබට නව ප්රශ්න අනුපිළිවෙල සුරැකීමට අවශ්යද?",
    "mobile_forms_leaving_reordering": "ප්රශ්න නැවත අනුපිළිවෙලගත කිරීමෙන් ඉවත්වෙමින්   ",
    "mobile_forms_reordering_button_save": "නව ප්රශ්න අනුපිළිවෙල සුරකින්න   ",
    "mobile_forms_reordering_instructions": "ප්‍රශ්න හෝ අංශ පිළිවෙල නැවත සැකසීමට, ආකෘතිය තුළ පෙන්විය යුතු ක්ෂේත්‍රය කරා ඇදගෙන විත් අතහරින්න",
    "mobile_toolbarnav_title_my_setttings": "මගේ සැකසුම්",
    "mobile_toolbarnav_title_profile_settings": "පැතිකඩ සැකසුම්",
    "mobile_toolbarnav_title_notification": "දැනුම් දීම් සැකසුම්",
    "mobile_toolbarnav_title_form_history": "පෝරම ඉතිහාසය",
    "mobile_toolbarnav_title_form_not_available": "පෝරමය නොමැත",
    "mobile_toolbarnav_title_add_location": "ස්ථානය එක් කරන්න",
    "mobile_toolbarnav_title_add_task_or_project": "කාර්යය හෝ ව්﻿යාපෘතිය එකතු කරන්න",
    "mobile_toolbarnav_title_select_location": "ස්ථානය තෝරන්න",
    "mobile_toolbarnav_title_select_project": "ව්යාපෘතිය තෝරන්න   ",
    "mobile_toolbarnav_title_select_tag": "ටැගය තෝරන්න",
    "mobile_toolbarnav_title_select_user": "පරිශීලකයා තෝරන්න",
    "mobile_toolbarnav_title_select_template": "ආකෘතිය තෝරන්න",
    "mobile_toolbarnav_title_select_one": "එකක් තෝරන්න",
    "mobile_toolbarnav_title_select_multiple": "එකක් හෝ වැඩි ගණනක් තෝරන්න",
    "mobile_toolbarnav_title_select_team": "කණ්ඩායම තෝරන්න",
    "mobile_toolbarnav_title_select_team_or_location": "කණ්ඩායම හෝ ස්ථානය තෝරන්න",
    "mobile_toolbarnav_title_filter_tasks": "කාර්යයන් පෙරන්න",
    "mobile_toolbarnav_title_filter_projects": "ව්﻿යාපෘති පෙරන්න",
    "mobile_toolbarnav_title_filter_project_tasks": "ව්﻿යාපෘති කාර්යයන් පෙරන්න",
    "mobile_placeholder_search_bar": "සොයන්න",
    "mobile_placeholder_user_select_role": "පරිශීලක භූමිකාව තෝරන්න",
    "mobile_placeholder_filter_by_team": "කණ්ඩායම අනුව පෙරන්න",
    "mobile_placeholder_assign_to_user_role": "පරිශීලක භූමිකාවට පවරන්න",
    "mobile_placeholder_select": "-- තෝරන්න --",
    "mobile_placeholder_account_location_name": "ස්ථානයේ නම",
    "mobile_placeholder_tag_filter_by": "ස්ථාන ටැගය අනුව පෙරන්න",
    "mobile_placeholder_user_type": "පරිශීලකයාට පවරන්න",
    "mobile_placeholder_acount_type_loading": "පැට වෙමින්... ",
    "mobile_placeholder_therm_no_bluetooth": "උෂ්ණත්වය",
    "mobile_placeholder_blue_therm_connecting": "උපාංගයට සම්බන්ධ වෙමින්...",
    "mobile_placeholder_blue_therm_please_wait": "කරුණාකර රැඳී සිටින්න...",
    "mobile_placeholder_blue_therm_tap": "කියවීම සඳහා තට්ටු කරන්න.",
    "mobile_placeholder_blue_therm_not_connected": "සම්බන්ධ වී නැත.",
    "mobile_placeholder_testo_tap": "▼▲ඔබා ගෙන පසුව ⬆ තද කරන්න",
    "mobile_message_error_create_task": "කාර්යයන් එක් කිරීමට ඔබ ඔන්ලයින් සිටිය යුතුය.",
    "mobile_message_error_fill_out_form": "කරුණාකර පෝරමය පුරවන්න.",
    "mobile_message_error_fill_require_fields": "අවශ්﻿ය ක්ෂේත්﻿ර පුරවන්න.",
    "mobile_message_error_stop_stopwatch_before_submit": "ඉදිරිපත් කිරීමට පෙර ඔබේ නැවතුම් ඔරලෝසුව නවත්වන්න",
    "mobile_message_error_stopwatch_field_required": "නැවතුම් ඔරලෝසු ක්ෂේත්﻿රය අවශ්﻿ය වේ",
    "mobile_message_error_stopwatch_field_running": "Stopwatch ක්ෂේත්﻿රය ක්﻿රියාත්මකයි",
    "mobile_message_error_invalid_equipment_temperature": "අවලංගු උපකරණ උෂ්ණත්වය",
    "mobile_message_error_invalid_ingredient_temperature": "අවලංගු කොටස් උෂ්ණත්වය",
    "mobile_message_error_location_attributes_unavailable": "සමහර ප්‍රශ්න ලද නොහැකි විය හැකිය, කරුණාකර අන්තර්ජාලයට සම්බන්ධවන්න",
    "mobile_message_alert_running_stopwatches": "ඔබට ක්﻿රියාත්මක නැවතුම් ඔරලෝසු තිබේ.\n\nඒවා ඉවත් කිරීමට ඔබ කැමති ද?",
    "mobile_message_blue_therm_error": "බ්ලූටූත් උපාංගයට සම්බන්ධතාවය නැති විය",
    "mobile_message_blue_therm_no_permission_android_pre_12": "ඔබගේ Android සැකසුම් තුළ එය සබල කරන්න.",
    "mobile_message_blue_therm_no_permission_android": "අවට උපාංග ප්‍රවේශය අවශ්‍ය වේ. ඔබගේ Android සැකසුම් තුළ එය සබල කරන්න.",
    "mobile_message_blue_therm_error_code": "සම්බන්ධ වීමට අපොහොසත් විය:",
    "mobile_message_blue_therm_error_bluetooth": "කරුණාකර බ්ලූටූත් සක්﻿රීය කරන්න.",
    "mobile_message_blue_therm_error_device": "උපාංගය හමු නොවිණ.",
    "mobile_message_blue_therm_error_try_again": "කරුණාකර නැවත උත්සාහ කරන්න",
    "mobile_message_blue_therm_success": "බ්ලූටූත් උපාංගය සම්බන්ධ විය!",
    "mobile_message_bluetooth_device_press_button_field": "සම්බන්ධ වීමට ඔබගේ උපාංගයේ බොත්තම ඔබන්න.",
    "mobile_message_bluetooth_device_press_button_devices_list": "ඔබගේ උපාංගයේ බොත්තම ඔබන්න.<br />එය මෙහි ලැයිස්තුගත කර නොමැති බව ඔබට පෙනේ නම්.",
    "mobile_bluetooth_scan": "ස්කෑන් කරන්න",
    "mobile_bluetooth_scanning": "ස්කෑන් කිරීම",
    "mobile_message_drafts_confirm": "මෙය කෙටුම්පතක් ලෙස සුරැකීමට ඔබ කැමති ද?",
    "mobile_message_drafts_toast_saved": "කෙටුම්පත සුරැකිණ.",
    "mobile_message_drafts_request_update": "මෙම කෙටුම්පත යාවත්කාලීන කිරීමට ඔබ කැමති ද?",
    "mobile_message_drafts_form_confirm": "මෙම කෙටුම්පත මකා දැමීමට ඔබ කැමති බව ඔබට සහතික ද?",
    "mobile_message_drafts_confirm_delete": "කෙටුම්පත මකන්න",
    "mobile_message_streams_error_switch": "වෙබ් අඩවියේ ධාරා වෙනස් කළ නොහැක",
    "mobile_message_settings_success_saved": "සැකසුම් සුරැකිණ",
    "mobile_message_settings_error": "නොදන්නා දෝෂයක් සිදු විය. පසුව නැවත උත්සාහ කරන්න",
    "mobile_message_profile_settings_error_fields": "ඉස්මතු කළ ක්ෂේත්﻿ර නිවැරදි කරන්න.",
    "mobile_message_media_perimission_denied": "ඔබගේ ",
    "mobile_message_media_perimission_denied_device": "උපාංග ගබඩාව",
    "mobile_message_image_confirm_remove_image": "මෙම ඡායාරූපය මකා දැමීමට ඔබට අවශ්﻿ය බව ඔබට සහතික ද?",
    "mobile_message_create_account_error_fields": "කරුණාකර ඉස්මතු කළ ක්ෂේත්﻿ර පුරවන්න.",
    "mobile_message_create_account_success_location_created": "පිහිටීම නිර්මාණය කෙරිණ",
    "mobile_message_task_error_get_location": "ස්ථානය දැන ගැනීමට අපොහොසත් විය. දිනය මගින් තේරීම.",
    "mobile_message_typehead_confirm_save_message": "ඔබට මෙම තේරීම් සුරැකීමට අවශ්﻿ය ද?",
    "mobile_message_typehead_confirm_save_title": "සුරකින්න?",
    "mobile_message_task_creator_error_save_select_form": "ඔබ පෝරමයක් තෝරා ගත යුතුය.",
    "mobile_message_task_creator_error_save_required_fields": "කරුණාකර අවශ්﻿ය ක්ෂේත්﻿ර පුරවන්න.",
    "mobile_message_task_creator_error_save_batch_change": "එක් පරිශීලකයෙකු හෝ වැඩි ගණනක් ගැලපීමට කරුණාකර නිර්ණායක වෙනස් කරන්න",
    "mobile_message_task_detials_error_not_assigned_to_you": "මෙම කාර්යය ඔබට පවරා නොමැත.<br />ඔබට එය සම්පූර්ණ කළ නොහැක.",
    "mobile_message_task_detials_error_assigned_to": "මෙම කාර්යය වෙත පවරා ඇත {{user}}.<br />ඔබට එය සම්පූර්ණ කළ නොහැක.",
    "mobile_message_task_detials_confirm_title": "කාර්යය අත්හැරීම",
    "mobile_message_task_detials_confirm_save_task": "කාර්යය සුරකින්න",
    "mobile_message_task_detials_confirm_message": "ඔබට සහතික ද? ඔබගේ වෙනස් කිරීම් නැති වී යයි.",
    "mobile_message_task_detials_error_view_account": "ස්ථානයට ප්﻿රවේශ විය නොහැක.",
    "mobile_message_task_detials_error_submit_task": "මෙම කාර්යය සම්පූර්ණ කිරීම සඳහා කරුණාකර ඡායාරූපයක් එක් කරන්න.",
    "mobile_message_task_detials_error_submit_task_project": "ව්﻿යාපෘතිය සුරැකිය නොහැක. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
    "mobile_message_task_detials_wait_submit_task_created": "කාර්යයන් නිර්මාණය වෙමින් පවතී.<br />කාර්යයන් වැඩි වන තෙක් කරුණාකර විනාඩි කිහිපයක් රැඳී සිටින්න.",
    "mobile_message_task_detials_error_submit_task_pending": "දෝෂයක්, කරුණාකර පසුව නැවත උත්සාහ කරන්න",
    "mobile_message_task_detials_success_task_complete": "කාර්යය සම්පූර්ණයි",
    "mobile_message_task_error_save_single_task": "කාර්යය සුරැකිය නොහැක. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
    "mobile_message_task_success_save_single_task": "කාර්යය නිර්මාණය කෙරිණ",
    "mobile_message_show_error_message": "කුමක් හෝ වැරැද්දක් සිදුව ඇත.",
    "mobile_message_show_success_message": "සාර්ථකයි!",
    "mobile_message_show_offline_message": "ඔබ දැනට ඕෆ්ලයින්.",
    "mobile_message_show_permission_denied_message": "<b>අවසර අවශ්﻿යයි.</b> කරුණාකර Zenput වෙත ප්﻿රවේශ වීමට අවසර දෙන්න {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>අවසරය අවශ්‍යයි.</b> කරුණාකර {{permission_name}} වෙත ප්‍රවේශ වීමට Zenput සහ ඔබේ බ්‍රව්සරයට අවසර දෙන්න.",
    "mobile_message_show_begin_uploading_message": "දැන් උඩුගත වෙමින් පවතී",
    "mobile_message_show_upload_in_progress_message": "මාරු වීම දැනටම සිදු වෙමින් ඇත.",
    "mobile_message_show_form_id_error": "නිශ්චිත පෝරමයට ප්﻿රවේශ විය නොහැක.",
    "mobile_message_show_single_task_error": "නිශ්චිත කාර්යයට ප්﻿රවේශ විය නොහැක.",
    "mobile_message_show_submissions_error": "නිශ්චිත ඉදිරිපත් කිරීමට ප්﻿රවේශ විය නොහැක.",
    "mobile_message_show_submissions_access_denied": "කණගාටුයි, ඔබට මෙම පෝරමයට ප්﻿රවේශය නොමැත.",
    "mobile_message_send_data_success": "දත්ත උඩුගත කරන ලදී ",
    "mobile_message_start_upload_success": "උඩුගත කිරීම සම්පූර්ණයි",
    "mobile_message_start_upload_error": "<b>උඩුගත කිරීම සම්පූර්ණ කළ නොහැක.</b><br>ඉදිරිපත් කිරීම සුරැකිණ. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "යාවත්කාලීන කිරීම් තිබේ",
    "mobile_message_store_upgrade_confirm_message_one": "මෙයින් Ops Execution යෙදුම යාවත්කාලීන කරන්න ",
    "mobile_message_store_upgrade_confirm_message_one_old": "සියලුම නවතම විශේෂාංග සහ දෝෂහරණ ලබා ගැනීම සඳහා ",
    "mobile_message_store_upgrade_confirm_message_two": " කරුණාකර... වෙතින් Zenput යාවත්කාලීන කරන්න",
    "mobile_message_store_upgrade_confirm_now": "දැන්",
    "mobile_message_store_upgrade_confirm_later": "පසුව",
    "mobile_message_redirect_confirm_message": "ඔබ දැනට පෝරමයක් පුරවමින් සිටී. ඉදිරියට යාමට පෙර එය කෙටුම්පතක් ලෙස සුරැකීමට ඔබ කැමති ද?",
    "mobile_message_log_out_confirm_unsynced_drafts": "ඔබ සතුව තවමත් උඩුගත කර නොමැති {{count}} කෙටුම්පත් ඇත. ඔබ දිගටම කර ගෙන ගියහොත් ඒවා නැති වී යයි. ඔබට සහතික ද?",
    "mobile_message_draft_override_message": "මෙම කෙටුම්පත වෙනත් උපාංගයකින් {{date}} සුරකින ලද අතර මෙම උපාංගයේ වෙනස්කම් ගැටුම්කාරී වේ. ඔබට පවතින අනුවාදය අභිබවා යාම තෝරා ගත හැකිය, නැති නම් නවතම අනුවාදයට නැවත පටවන්න, එවිට ඔබගේ වෙනස්කම් ඉවත ලනු ඇත.",
    "mobile_html_submitting": "ඉදිරිපත් කිරීම...",
    "mobile_html_offline": "ඔබ දැනට ඕෆ්ලයින්!",
    "mobile_html_offline_try_again": "ඔබ දැනට ඕෆ්ලයින්. <br/><br/>ඔබ සම්බන්ධ වූ පසු කරුණාකර නැවත උත්සාහ කරන්න",
    "mobile_html_something_went_wrong": "ආහ්. කුමක් හෝ වරදක් සිදුව ඇත.",
    "mobile_html_something_went_wrong_try_again": "ආහ්. කුමක් හෝ වරදක් සිදුව ඇත. කරුණාකර නැවත උත්සාහ කරන්න.",
    "mobile_html_failed_loading_roles": "භූමිකා පැටවීමට අපොහොසත් විය.",
    "mobile_alert_please_install_for_native": "මෙම විශේෂාංගය භාවිතා කිරීමට Ops Execution යෙදුම ස්ථාපනය කරන්න. ",
    "mobile_alert_please_install_for_native_old": "මෙම විශේෂාංගය භාවිතා කිරීමට කරුණාකර ස්වදේශීය Zenput යෙදුම ස්ථාපනය කරන්න.",
    "mobile_tso_filter_all_tasks": "සියල්ල {{type}}",
    "mobile_tso_filter_my_tasks": "මගේ {{type}}",
    "mobile_tso_filter_due_date": "නියමිත දිනය",
    "mobile_tso_filter_date_completed": "සම්පූර්ණ කළ දිනය",
    "mobile_tso_filter_completed": "සම්පුර්ණ කෙරිණ",
    "mobile_tso_filter_completed_late": "ප්‍රමාද වී සම්පූර්ණ කරන ලදී",
    "mobile_tso_filter_incomplete": "අසම්පූර්ණයි",
    "mobile_tso_filter_var_my_tasks": "මගේ {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} මා විසින් නිර්මාණය කරන ලදී",
    "mobile_tso_filter_var_all_tasks": "සියල්ල {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "පසු විපරම් ක්‍රියා",
    "mobile_tso_type_all": "කාර්යයන් සහ පසු විපරම් ක්‍රියා",
    "mobile_tso_filter_var_at": " {{location}} දී",
    "mobile_tso_filter_group_date_due": ", නියමිත දිනය අනුව ඇණවුම් කෙරිණ",
    "mobile_tso_filter_group_distance": ", ස්ථානය අනුව කාණ්ඩ කෙරිණ",
    "mobile_tso_filter_start_date": "ආරම්භක දිනය",
    "mobile_tso_filter_none": "කිසිවක් නැත",
    "mobile_pso_filter_all_projects": "සියලුම ව්﻿යාපෘති",
    "mobile_pso_filter_my_projects": "මගේ ව්﻿යාපෘති",
    "mobile_pso_filter_active": "සක්﻿රීයයි",
    "mobile_pso_filter_archived": "සංරක්ෂිත කෙරිණ",
    "mobile_pso_filter_recurring": "පුනරාවර්තනය වීම",
    "mobile_pso_filter_non_recurring": "පුනරාවර්තනය නොවීම",
    "mobile_pso_filter_var_my_projects": "මගේ {{project_type}} {{active_description}} ව්﻿යාපෘති",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} මා විසින් නිර්මාණය කරන ලද ව්﻿යාපෘති",
    "mobile_pso_filter_var_all_projects": "සියලුම {{project_type}} {{active_description}} ව්﻿යාපෘති",
    "mobile_empty_list_message_must_be_online": "ඔබ ඕෆ්ලයින් බව පෙනේ. යම් ප්﻿රතිඵලයක් බැලීමට නම් කරුණාකර ඔන්ලයින් වන්න.",
    "mobile_empty_list_message_no_submissions": "ඉදිරිපත් කිරීම් නොමැත",
    "mobile_empty_list_message_no_activity": "ක්﻿රියාකාරකමක් නැත",
    "mobile_empty_list_message_no_tasks": "කාර්යයන් නොමැත",
    "mobile_empty_list_message_no_tasks_overdue": "කල් ඉකුත් වී නැත {{type}}",
    "mobile_empty_list_message_no_accounts": "ස්ථාන නොමැත",
    "mobile_empty_list_message_no_projects": "ව්﻿යාපෘති නොමැත",
    "mobile_empty_list_message_no_results_found": "ප්﻿රතිඵල හමු නොවිණ",
    "mobile_empty_list_message_no_forms_available": "පෝරම නොමැත",
    "mobile_empty_list_message_connection_error": "සම්බන්ධතා දෝෂය<br />කරුණාකර නැ වත උත්සාහ කරන්න.",
    "mobile_empty_list_message_dashboard_error": "පාලන පුවරුව පැටවීමට නොහැක",
    "mobile_empty_list_message_user_offline": "ඔබ දැනට ඉන්නේ ඕෆ්ලයින්ය",
    "mobile_action_sheet_media_gallery": "ගැලරිය",
    "mobile_action_sheet_cancel": "අවලංගු කරන්න",
    "mobile_image_preview_text": "ඡායාරූපය ඉවත් කරන්න",
    "mobile_mobileform_text": "පෙර ඉදිරිපත් කිරීම්",
    "mobile_mobileform_reorder_fields": "ප්රශ්න නැවත අනුපිළිවෙලට සකසන්න   ",
    "mobile_mobileform_follow_up_actions": "පසු විපරම් ක්‍රියාමාර්ග",
    "mobile_mobileform_follow_up_actions_assign_title": "පසු විපරම් ක්‍රියා පවරන්න",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "ගැටළු විසඳා ඇති බව සහතික කිරීම සඳහා ඔබේ නිරීක්ෂණ මත පදනම්ව පසු විපරම් ක්‍රියාමාර්ග එක් කරන්න.",
    "mobile_mobileform_follow_up_actions_add_button": "+ පසු විපරම් ක්‍රියාවක් එක් කරන්න",
    "mobile_mobileform_follow_up_actions_assign_button": "පසු විපරම් පවරන්න",
    "mobile_mobileform_follow_up_actions_without_assign_button": "පැවරීමකින් තොරව ඉදිරියට යන්න",
    "mobile_mobileform_follow_up_actions_dialog_title": "පසු විපරම් ක්‍රියාමාර්ග පැවරීමකින් තොරව ඉදිරියට යන්න ද?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "ඔබ කිසිදු පසු විපරම් ක්‍රියාමාර්ගයක් පැවරීමකින් තොරව ඉදිරියට ගියහොත්, ඔබට ඒවා පසුව එක් කිරීමට නොහැකි වනු ඇත.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "කෙසේ හෝ ඉදිරියට යන්න",
    "mobile_mobileform_add_follow_up_actions_forms_required": "මෙම ක්ෂේත්‍රය අවශ්‍ය වේ",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "අනුලකුණුු වැඩියි",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "මෙම ක්ෂේත්‍රය නිශ්ක්‍රීයයි",
    "mobile_mobileform_add_follow_up_actions_error_locations": "ස්ථාන පූරණය කිරීමේදී දෝෂයකි",
    "mobile_mobileform_add_follow_up_actions_error_users": "පරිශීලකයින් පූරණය කිරීමේ දෝෂයකි",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "පසු විපරමක් එක් කරන්න",
    "mobile_mobileform_add_follow_up_actions_forms_title": "මාතෘකාව",
    "mobile_mobileform_add_follow_up_actions_forms_description": "විස්තර",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "ඡායාරූපය අවශ්‍යයි",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "ගෙවිය යුතු දිනය",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "පසු විපරම් යාවත්කාලීන කරන්න",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "පසු විපරම් මකන්න ද?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "එය ඉවත් කරනු ලබන අතර පවරනු නොලැබේ.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "පසු විපරම් මකන්න",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "මෙම පසු විපරම මකා දැමීමට ඔබට අවශ්‍ය බව ඔබට විශ්වාස ද?\n\nමෙය අහෝසි කළ නොහැක.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "පසු විපරම් සඳහා ඉදිරියට යන්න",
    "mobile_mobileform_follow_up_actions_completed_notification": "පසු විපරම් ක්‍රියාමාර්ගය සම්පූර්ණ කරන ලදී",
    "mobile_mobileform_follow_up_actions_deleted_notification": "පසු විපරම් ක්‍රියාව මකා දමන ලදී",
    "mobile_mobileform_follow_up_actions_update_notification": "පසු විපරම් ක්‍රියාව යාවත්කාලීන කරන ලදී",
    "mobile_mobileform_follow_up_actions_required_photo_error": "මෙම පසු විපරම් ක්‍රියාව සම්පූර්ණ කිරීමට කරුණාකර ඡායාරූපයක් එක් කරන්න.",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "ඉදිරිපත් කිරීමට සංචාලනය කරන්න",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "මූලාශ්‍රය වෙත සංචාලනය කරන්න",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "මූලාශ්‍රය",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "සම්පූර්ණ පසු විපරම",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "ඔබ ඉදිරිපත් කිරීම විවෘත කළහොත්, සුරකින ලද ඡායාරූප සහ සටහන් නැති වී යනු ඇත.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "ඔබ මෙම තිරය හැර ගියහොත්, නොසුරකින ලද ඡායාරූප සහ සටහන් නැති වනු ඇත.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "මෙතන ඉන්න",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "ඉදිරිපත් කිරීම විවෘත කරන්න",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Open source",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "මෙම පසු විපරම් ක්‍රියාවෙන් ඉවත් වන්න ද?",
    "mobile_mobileform_follow_up_actions_submission": "ඉදිරිපත් කිරීම",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "මෙම පසු විපරම් ක්‍රියාව {{user}} වෙත පවරා ඇත.<br />ඔබට එය සම්පූර්ණ කළ නොහැක.",
    "mobile_mobileform_follow_up_actions_leave_description": "ඔබ මෙම තිරය හැර ගියහොත්, නොසුරකින ලද වෙනස්කම් නැති වනු ඇත.",
    "mobile_mobileform_follow_up_actions_leave": "පිටත් වන්න",
    "mobile_forms_drafts_text": "කෙටුම්පත් ඉවත් කරන්න",
    "mobile_batch_estimate_user": "පරිශීලකයා",
    "mobile_batch_estimate_users": "පරිශීලකයන්",
    "mobile_table_of_contents": "අන්තර්ගත වගුව",
    "mobile_table_of_contents_required": "අවශ්﻿යයි",
    "mobile_table_of_contents_optional": "විකල්ප",
    "mobile_dialog_alert_title": "ඇඟවීම",
    "mobile_dialog_alert_ok": "ඔක්කොම හරි",
    "mobile_windows_10_bluetherm_not_supported": "බ්ලූටූත් උපාංග තවමත් Windows මත සහාය නොදක්වයි",
    "mobile_windows_deprecated_message_content_announcement": "නිවේදනය",
    "mobile_windows_deprecated_message_title": "යෙදුම් යාවත්කාලීන කිරීම අවශ්‍යයි",
    "mobile_windows_deprecated_message_description": "තීරණාත්මක ක්‍රියාකාරීත්ව යාවත්කාලීන කිරීම් සහ ප්‍රශස්ත Zenput අත්දැකීමක් සහතික කිරීම සඳහා ASAP Microsoft Store හි නව Zenput යෙදුම ස්ථාපනය කරන්න.",
    "mobile_dashboard_tcr_graph_name": "කාර්ය සම්පූර්ණ කිරීමේ වේගය",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "පසු ගිය සති 4",
    "mobile_dashboard_tcr_legend_company_average": "සමාගමේ සාමාන්﻿යය",
    "mobile_dashboard_tcr_legend_team_average": "කණ්ඩායම් සාමාන්﻿යය",
    "mobile_dashboard_tab_title_summary": "සාරාංශය",
    "mobile_dashboard_tab_title_activity": "ක්﻿රියාකාරකම",
    "mobile_dashboard_card_title_top_triggered_workflows": "ඉහළම ප්﻿රේරක",
    "mobile_dashboard_tab_title_info": "තොරතුරු",
    "mobile_dashboard_tab_project_audit": "අනුකූලතාව",
    "mobile_dashboard_card_task_stats_total": "සමස්ත",
    "mobile_dashboard_top_item_header_week_of": "... සතිය",
    "mobile_dashboard_card_filter_form_template_placeholder": "සියලුම පෝරම",
    "mobile_dashboard_card_title_forms_top_nos": "නිතර \"නැත\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "මෙම කාල පරාසය තුළ දත්ත නොමැත.",
    "mobile_dashboard_zenput_code_permission_denied": "මෙය බැලීමට ඔබට අවසර නැත.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "ඉහළින් පෝරමයක් තෝරන්න.",
    "mobile_dashboard_zenput_code_unknown_error": "අපට මේ අවස්ථාවේ දත්ත ප්﻿රදර්ශනය කළ නොහැක.",
    "mobile_dashboard_tap_to_retry": "නැවත උත්සහ කිරීම සඳහා තට්ටු කරන්න",
    "mobile_dashboard_reporting_delay_disclaimer": "කාර්යයන් යාවත්කාලීන කිරීමට විනාඩි 15 ක් ගත වනු ඇත",
    "mobile_dashboard_configuration_down_state_postfix_msg": "ඔබගේ පරිපාලක විසින් වින්﻿යාස කර ඇත.",
    "mobile_tasks_tag": "කාර්යයන්",
    "mobile_workflows_tag": "ප්﻿රේරක",
    "mobile_projects_tag": "පුනරාවර්තන ව්﻿යාපෘති",
    "mobile_forms_tag": "පෝරම",
    "mobile_dashboard_card_ongoing_projects_title": "ප්﻿රගති ව්﻿යාපෘති",
    "mobile_dashboard_card_ongoing_projects_show_more": "තවත් පෙන්වන්න",
    "mobile_dashboard_card_ongoing_projects_show_less": "අඩුවෙන් පෙන්වන්න",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "ව්﻿යාපෘති වෙත යන්න",
    "mobile_dashboard_card_title_recurring_projects": "පුනරාවර්තන ව්﻿යාපෘති",
    "mobile_dashboard_card_filter_daily": "දිනපතා",
    "mobile_dashboard_card_filter_weekly": "සතිපතා",
    "mobile_dashboard_card_filter_monthly": "මාස්පතා",
    "mobile_task_status_title_open": "විවෘත",
    "mobile_task_status_title_upcoming": "ඉදිරි",
    "mobile_task_status_title_complete": "සම්පූර්ණ කරන්න",
    "mobile_task_status_title_processing": "ඉදිරිපත් කිරීම සැකසීම",
    "mobile_task_status_title_complete_with_exceptions": "පසු-විපරම් කාර්යයන් හෝ ඇඟවීම් සමග සම්පූර්ණ කරන්න",
    "mobile_task_status_title_completed_late_with_exceptions": "පසු විපරම් කාර්යයන් හෝ ඇඟවීම් සමඟ ප්‍රමාද වී සම්පූර්ණ කරන ලදී",
    "mobile_task_status_title_incomplete_and_closed": "මග හැරුණි",
    "mobile_tasks_legend_modal_title": "පුරාවෘත්තය",
    "mobile_tasks_legend_modal_footer_button_title": "වසන්න",
    "mobile_common_assigned_to": "... වෙත පවරා ඇත",
    "mobile_common_created_by": "නිර්මාණය කළේ",
    "mobile_common_tasks_for": "... සඳහා කාර්යයන්",
    "mobile_common_go_back": "ආපසු යන්න",
    "mobile_oh_no": "ඔහ්, නෑ!",
    "mobile_user_not_in_groups": "කණගාටුයි, ඔබ කණ්ඩායමකට අනුයුක්ත කර නොමැති බව පෙනේ. ඔබගේ පාලන පුවරුවට ප්﻿රවේශය ලබා ගැනීම සඳහා ඔබේ පරිපාලක අමතන්න.",
    "mobile_tasks_select_followers": "අනුගාමිකයන් තෝරන්න",
    "mobile_tasks_assign_tasks": "කාර්යයන් {{count}} පවරන්න",
    "mobile_tasks_add_followers": "අනුගාමිකයන් එක් කරන්න",
    "mobile_tasks_followers": "අනුගාමිකයන්",
    "mobile_tasks_delete_task": "කාර්යය මකන්න",
    "mobile_tasks_create_task": "කාර්යයන් සාදන්න",
    "mobile_tasks_tab_title_comments": "අදහස්",
    "mobile_tasks_see_more": "තවත් බලන්න",
    "mobile_projects_create_project": "ව්﻿යාපෘතියක් සාදන්න",
    "mobile_common_button_send": "යවන්න",
    "mobile_common_button_schedule": "උපලේඛනය",
    "mobile_announcements_create": "නිවේදනය සාදන්න",
    "mobile_announcements_read_rate": "{{opened_count}} හි {{recipients_count}} විවෘත කෙරිණ",
    "mobile_announcements_empty_message": "ඔබ තවම නිවේදන කිසිවක් නිර්මාණය කර නැත! ඔබේ සංවිධානයට වැදගත් ප්﻿රවෘත්ති, තොරතුරු සහ යාවත්කාලීන කිරීම් විකාශ කිරීමට පහත නිවේදනයක් සාදන්න.",
    "mobile_announcement_message_placeholder": "පණිවිඩයක් එක් කරන්න ...",
    "mobile_announcement_title_placeholder": "නිවේදන මාතෘකාව",
    "mobile_announcement_leaving_announcement": "නිවේදනය අත්හැරීම",
    "mobile_announcement_confirm_recipients_team": "{{count}} තෝරාගත් කණ්ඩායමේ {{teams}} පරිශීලකයාට මෙම නිවේදනය විකාශනය කිරීමට ඔබට අවශ්﻿ය ද?",
    "mobile_announcement_confirm_recipients_role": "{{count}} තෝරාගත් පරිශීලක භූමිකාවේ {{roles}} පරිශීලකයාට මෙම නිවේදනය විකාශනය කිරීමට ඔබට අවශ්﻿ය ද?",
    "mobile_announcement_confirm_recipients_user": "ඔබට මෙම නිවේදනය {{count}} පරිශීලකයාට විකාශනය කිරීමට අවශ්﻿ය ද?",
    "mobile_announcement_confirm_scheduled": "මත {{timestamp}}",
    "mobile_announcement_sending_announcement": "නිවේදනය යැවීම",
    "mobile_announcement_send_to": "... වෙත යවන්න",
    "mobile_announcement_sent_to": "... වෙත යැවිණ",
    "mobile_announcement_send_to_role": "කාර්යභාරය",
    "mobile_announcement_attachment_download": "බා ගැනීම {{filename}}",
    "mobile_announcement_attachment_validation_error": "එක් කළ හැක්කේ {{maxCount}} කට වැඩි නොවන ඇමුණුම් ගණනකි ",
    "mobile_announcement_details_sent": "යැවිණ",
    "mobile_announcement_details_total_recipients": "මුළු ලබන්නන්",
    "mobile_announcement_details_cancel": "නිවේදනය අවලංගු කරන්න",
    "mobile_announcement_details_not_editable": "නිවේදන සංස්කරණය කළ හැක්කේ Ops Execution වෙබ් යෙදුම තුළ පමණි ",
    "mobile_announcement_details_not_editable_old": "නිවේදන සංස්කරණය කළ හැක්කේ Zenput වෙබ් අඩවියේ පමණි",
    "mobile_announcement_details_open_count": "ගණන විවෘත කරන්න",
    "mobile_announcement_details_open_rate": "අගය විවෘත කරන්න",
    "mobile_announcement_details_resend": "විවෘත නොකරන අයට නැවත යවන්න",
    "mobile_announcement_confirm_resend": "{{count}} පරිශීලකයා නිවේදනය කියවා නැත. මතක් කිරීමක් යැවීමට ඔබට අවශ්﻿ය ද?",
    "mobile_announcement_confirm_resend_title": "මතක් කිරීම යවන්න ද?",
    "mobile_announcement_recipients_opened": "විවෘත විය",
    "mobile_recipients_opened_empty_message": "ඔබගේ පණිවිඩය තවමත් කිසිවෙකු විවෘත කර නැති බව පෙනේ. ඔබගේ ප්﻿රතිඵල බැලීමට පසුව නැවත එන්න.",
    "mobile_announcement_recipients_unopened": "විවෘත නොකළ",
    "mobile_recipients_unopened_empty_message": "ශුභාරංචිය! විවෘත නොකළ පණිවුඩ නොමැත!",
    "mobile_scheduled_announcements_delivery_section_header": "බෙදා හැරීමේ කාලය",
    "mobile_scheduled_announcements_send_immediately_label": "වහාම යවන්න",
    "mobile_scheduled_announcements_scheduled_label": "නිශ්චිත වේලාවක යවන්න",
    "mobile_scheduled_announcements_scheduled_tab_label": "උපලේඛනගත කෙරිණ",
    "mobile_scheduled_announcements_dialog_header": "නිවේදනය අවලංගු කරන්න?",
    "mobile_scheduled_announcements_dialog_message": "ඔබගේ නිවේදනය අවලංගු කිරීමෙන් එහි යැවීම නවත්වන අතර එය ඔබගේ ලැයිස්තුවෙන් මකා දමනු ඇත. මෙය අහෝසි කළ නොහැක. සංස්කරණය කිරීමට Zenput වෙබ් වෙත යන්න.",
    "mobile_scheduled_announcements_empty_message": "ඔබට දැනට නියමිත නිවේදන නොමැත. ඔබේ සංවිධානයට වැදගත් ප්﻿රවෘත්ති, තොරතුරු සහ යාවත්කාලීන කිරීම් විකාශනය කිරීමට නිවේදනයක් සැලසුම් කරන්න.",
    "mobile_scheduled_announcements_validation_error": "බෙදා හැරීමේ කාලය {{date}} ට පසුව විය යුතුය",
    "mobile_scheduled_announcements_empty_state_button": "උපලේඛන නිවේදනය",
    "mobile_projects_auto_archive": "ස්වයංක්﻿රීය ලේඛනාගාරය",
    "mobile_common_unassigned": "නියම කර නොමැත",
    "mobile_tasks_title_placeholder": "නව කාර්යයන් හෝ පෝරමය",
    "mobile_projects_leaving_project": "ව්﻿යාපෘතිය හැර යාම",
    "mobile_projects_save_project": "ව්﻿යාපෘතිය සුරකින්න",
    "mobile_top_triggers_tasks": "ඉහළම ප්﻿රේරක කාර්යයන්",
    "mobile_top_triggers_alerts": "ඉහළම ප්﻿රේරක ඇඟවීම්",
    "mobile_projects_not_started": "ආරම්භ කර නැත",
    "mobile_empty_list_message_no_photos": "ඡායාරූප නැත",
    "mobile_webfilestore_message_error": "කරුණාකර වලංගු ගොනු වර්ගයක් තෝරන්න",
    "mobile_notifications_empty_title": "දැනුම්දීම් නොමැත",
    "mobile_notifications_empty_message": "ඔබගේ හෝ කොටස්කරුවන්ගේ ක්﻿රියාකාරකම් කාර්යයන් හෝ ඔබ මෙහි දිස්වනු ඇත.",
    "mobile_comments_comment_deleted": "මෙම අදහස මකා දමා ඇත.",
    "mobile_comments_comment_placeholder": "අදහස",
    "mobile_comments_task_submitted_at": "{{ date }} හි {{ time }} ඉදිරිපත් කරන ලද කාර්යය",
    "mobile_comments_discard_comment_title": "අදහස ඉවත දමන්න ද?",
    "mobile_comments_discard_confirm_message": "ඔබට සහතික ද? ඔබගේ අදහස මකා දැමෙනු ඇත.",
    "mobile_comments_delete_comment_title": "අදහස් මකන්න?",
    "mobile_comments_delete_confirm_message": "මෙය ආපසු හැරවිය නොහැක.",
    "mobile_comments_delete_button": "අදහස මකන්න",
    "mobile_comments_delete_success_message": "අදහස් මකා දැමිණ",
    "mobile_comments_empty_message_tasks": "තවම අදහස් නොමැත, \n මෙම කාර්යය පිළිබඳ සංවාදයක් ආරම්භ කරන්න.",
    "mobile_comments_empty_message_submissions": "තවම අදහස් නොමැත, \n මෙම ඉදිරිපත් කිරීම පිළිබඳ සංවාදයක් ආරම්භ කරන්න.",
    "mobile_comments_empty_message_default": "තවම අදහස් නොමැත, \n සංවාදයක් ආරම්භ කරන්න.",
    "mobile_comments_no_matching_users": "ගැලපෙන පරිශීලකයින් නොමැත.",
    "mobile_comments_empty_users_to_notify": "දැනුම් දීමට පරිශීලකයින් නොමැත.",
    "mobile_comments_users_cant_view_message": "මෙම පරිශීලකයින්ට මෙම අදහස් බැලීමට නොහැක",
    "mobile_comments_users_to_notify_title": "දැනුම් දිය යුතු පරිශීලකයින්",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} පරිශීලකයාට</a> දැනුම් දෙනු ලැබේ.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} පරිශීලකයින්ට</a> දැනුම් දෙනු ලැබේ.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> තවත් පරිශීලකයින්ට දැනුම් දීම.",
    "mobile_comments_mark_read": "සියල්ල කියවූ ලෙස සලකුණු කරන්න",
    "mobile_comments_author_mentioned_message": "… තුළ ඔබ ගැන සඳහන් කෙරිණ",
    "mobile_comments_author_commented_message": "... ගැන අදහස් දැක්විණ",
    "mobile_view_pdf": "PDF බලන්න",
    "mobile_no_pdf_generated_message": "මෙම ඉදිරිපත් කිරීම සඳහා PDF කිසිවක් හමු නොවීය. ඉක්මනින්ම ඔබට පිටපතක් ඊමේල් කරනු ලැබේ.",
    "mobile_clipboard_copied_success": "සබැඳිය ඔබගේ ක්ලිප් පුවරුවට කොපි කර ඇත.",
    "mobile_share_link": "සබැඳිය බෙදාහදා ගන්න",
    "mobile_zencam_share": "බෙදාහදා ගන්න",
    "mobile_zencam_view_details": "තොරතුරු තොරතුරු පෙන්වන්නපෙන්වන්න",
    "mobile_zencam_details_drawer_header": "තොරතුරු",
    "mobile_zencam_submitted_by": "ඉදිරිපත් කර ඇත්තේ",
    "mobile_zencam_form_title": "පෝරමයේ පෝරමයේ මාතෘකාවමාතෘකාව",
    "mobile_zencam_date_submitted": "ඉදිරිපත් කළ දිනය",
    "mobile_oil_quality_warning_message": "කල් ඉකුත් වීමට ආසන්න තෙල්",
    "mobile_oil_quality_warning_message_subtitle": "ඉක්මනින් එය වෙනස් කිරීමට සැලසුම් කරන්න",
    "mobile_oil_quality_failure_message": "තෙල්වල ගුණාත්මකභාවය අඩාල වී ඇත",
    "mobile_oil_quality_failure_message_subtitle": "වහාම තෙල් මාරු කරන්න",
    "mobile_sensors_set_up_gateway": "Gateway සකසන්න",
    "mobile_sensors_set_up_gateway_message": "සැකසූ උපාංග කිසිවක් නැති බව පෙනේ. ද්වාරයක් එකතු කිරීමෙන් ආරම්භ කරන්න.",
    "mobile_sensors_gateway_plugged_in": "ඔබේ ද්වාරය විදුලි පේනුවකට සම්බන්ධ කර ඇති බවට සහතික වන්න",
    "mobile_sensors_add_device": "උපාංගය එක් කරන්න",
    "mobile_sensors_name_this_gateway": "මෙම ද්වාරය නම් කරන්න.",
    "mobile_sensors_name_this_sensor": "මෙම සෙන්සරය නම් කරන්න.",
    "mobile_sensors_device_barcode_information": "QR කේතය ස්කෑන් කිරීම හෝ උපාංග ලේබලයෙන් ගෙන ID සහ SC අංක ඇතුල් කිරීම කරන්න",
    "mobile_sensors_device_eui_information": "QR කේතය ස්කෑන් කිරීම හෝ උපාංග ලේබලයෙන් ගෙන DevEUI එක ඇතුල් කිරීම කරන්න",
    "mobile_sensors_gateway_id_information": "ද්වාර ලේබලයෙන් නෝඩ් හැඳුනුම්පත ඇතුළත් කරන්න",
    "mobile_sensors_id_number": "{{untranslatedID}} අංකය",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} කේතය",
    "mobile_sensors_sensors": "සංවේදක",
    "mobile_sensors_sensor_deveui_error": "QR වෙතින් DevEUI ලබා ගැනීමට නොහැකි විය. කරුණාකර එය අතින් ඇතුළු කරන්න.",
    "mobile_sensors_gateways": "Gateways",
    "mobile_sensors_add_sensor": "සංවේදකය එක් කරන්න",
    "mobile_sensors_add_gateway": "Gateway එක් කරන්න",
    "mobile_sensor_placement_description": "මෙම සසෙන්සරය නිරීක්ෂණය කරන්නේ කුමන ප්‍රදේශයද?",
    "mobile_sensors_equipment_placement": "මෙම සංවේදකය නිරීක්ෂණය කරන්නේ කුමන ප්﻿රදේශය හෝ උපකරණ ද?",
    "mobile_sensors_equipment": "මෙම සෙන්සරය නිරීක්ෂණය කරන්නේ කුමන උපකරණයද?",
    "mobile_sensors_select_gateway_type": "වෙබ්ද්වාරය වර්ගය තෝරන්න",
    "mobile_sensors_select_placement": "ස්ථානගත කිරීම තෝරන්න",
    "mobile_sensors_select_equipment": "උපකරණය තෝරන්න",
    "mobile_sensors_placement": "ස්ථානගත කිරීම",
    "mobile_sensors_nickname_tip": "සංවේදක නම් කිරීම තෝරාගත් ස්ථානගත කිරීමේදී පවරා ඇති අන්වර්ථ නාම මඟින් තීරණය වේ.",
    "mobile_sensors_device_online": "ඔන්ලයින්",
    "mobile_sensors_device_offline": "ඕෆ්ලයින්",
    "mobile_sensors_scan_qrcode": "QR කේතය පරිලෝකනය කරන්න",
    "mobile_sensors_enter_manually": "අතින් ඇතුල් කරන්න",
    "mobile_sensors_wizard_step_one": "පියවර 1",
    "mobile_sensors_wizard_step_two": "පියවර 2",
    "mobile_sensors_wizard_step_three": "පියවර 3",
    "mobile_sensors_wizard_step_four": "4 වන පියවර",
    "mobile_sensors_wizard_step_five": "5 වන පියවර",
    "mobile_sensors_wizard_step_six": "පියවර 6",
    "mobile_sensors_initializing": "ආරම්භ කිරීම …",
    "mobile_sensors_nickname": "විකට නාමය",
    "mobile_sensors_field_not_blank": "{{field}} හිස්ව තැබිය නොහැකිය.",
    "mobile_sensors_nothing_to_see_here": "මෙහි බැලීමට කිසිවක් නැත",
    "mobile_sensors_missing_integration": "සංවේදක ඒකාබද්ධ කිරීම මගහැරිණි",
    "mobile_sensors_contact_zenput_admin": "ඔබේ සමාගමේ Ops Execution පරිපාලක අමතන්න.",
    "mobile_sensors_contact_zenput_admin_old": "කරුණාකර ඔබගේ Zenput පරිපාලක අමතන්න.",
    "mobile_sensors_contact_manager": "සෙන්සර එක් කිරීමට ඔබගේ ගිණුම් කළමනාකරු අමතන්න.",
    "mobile_sensors_device_success_message": "සෙන්සර දත්ත පැටවීමට විනාඩි 15 ක් ගත වනු ඇත",
    "mobile_sensors_last_reading": "අවසන් කියවීම",
    "mobile_sensors_remove_device": "උපාංගය ඉවත් කරන්න",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1W",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1Y",
    "mobile_sensors_sensor_settings": "සෙන්සර සැකසුම්",
    "mobile_sensors_remove_confirm_message": "ඔබට මෙම උපාංගය මකා දැමීමට අවශ්﻿ය බව සහතික ද?\nමෙය ආපසු හැරවිය නොහැක.",
    "mobile_sensors_sensor": "සෙන්සරය",
    "mobile_sensors_no_equipment_linked": "උපකරණ කිසිවක් සම්බන්ධ කර නැත",
    "mobile_sensor_cooldown_process": "සිසිල් කිරීමේ ක්﻿රියාවලිය",
    "mobile_sensor_last_12_hours": "අවසන් පැය 12",
    "mobile_sensor_start_cooldown_process": "නව සිසිල් කිරීමේ ක්﻿රියාවලිය ආරම්භ කරන්න",
    "mobile_sensor_cooldown_process_title": "ද්වි-අදියර සිසිල් කිරීමේ ක්﻿රියාවලිය",
    "mobile_sensor_cooldown_process_description": "අදියර දෙකක සිසිල් කිරීමේ ක්‍රියාවලිය ආහාර {{ stage1_start_temperature }} සිට {{ stage1_end_temperature }} දක්වා පැය දෙකකින් හෝ ඊට අඩු කාලයකින් සහ පසුව {{ stage1_end_temperature }} සිට {{ stage2_end_temperature }} දක්වා පැය හතරකින් හෝ ඊට අඩු කාලයකදී සිසිල් කිරීමකින් සමන්විත වෙයි.",
    "mobile_sensor_cooldown_process_place_food": "ආහාර නිෂ්පාදිතය ශීතකරණය තුළ තබන්න.",
    "mobile_sensor_cooldown_process_insert_sensor": "ආහාර නිෂ්පාදිතයට සෙන්සර පරීක්ෂණයක් ඇතුළු කරන්න.",
    "mobile_sensor_cooldown_process_enter_information": "පහත තොරතුරු ඇතුළත් කරන්න.",
    "mobile_sensor_cooldown_process_food_product": "සිසිල් කිරීම සඳහා ආහාර නිෂ්පාදිතය",
    "mobile_sensor_cooldown_cool_down": "සිසිල් කරන්න",
    "mobile_sensor_cooldown_select_sensor": "සෙන්සරය තෝරන්න",
    "mobile_sensors_cooldown_start_cooldown": "සිසිල් කිරීම ආරම්භ කරන්න",
    "mobile_sensors_cooldown_please_enter_food": "කරුණාකර ආහාර නිෂ්පාදිතයක් ඇතුළත් කරන්න",
    "mobile_sensors_cooldown_please_select_sensor": "කරුණාකර සෙන්සරයක් තෝරන්න",
    "mobile_sensors_cooldown_status_in_progress": "ඉදිරියට යමින්",
    "mobile_sensors_cooldown_status_failed": "අසමත් විය",
    "mobile_sensors_cooldown_status_success": "සාර්ථකයි",
    "mobile_sensors_cooldown_stage": "අදියර",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "ආරම්භක උෂ්ණත්වය පරාසය ඉක්මවා ඇත",
    "mobile_sensors_cooldown_failed_cooldown_process": "සිසිල් කිරීමේ ක්﻿රියාවලිය අසාර්ථක විය",
    "mobile_sensors_cooldown_cooldown_successful": "සිසිල් කිරීම සාර්ථකයි",
    "mobile_sensors_cooldown_started_cooldown_process": "සිසිල් කිරීමේ ක්﻿රියාවලිය ආරම්භ කෙරිණ",
    "mobile_sensors_cooldown_hour": "පැය",
    "mobile_sensors_cooldown_hour_plural": "පෑ",
    "mobile_sensors_cooldown_minute": "විනාඩිය",
    "mobile_minutes_plural": "විනාඩි",
    "mobile_sensors_last_reading_max_date": "> වසර 1 කට පෙර",
    "mobile_sensors_minute_count_ago": "{{count}} විනාඩියකට පෙර",
    "mobile_sensors_minute_count_ago_plural": "{{count}} විනාඩි කිහිපයකට පෙර",
    "mobile_sensors_hour_count_ago": "{{count}} පැයකට පෙර",
    "mobile_sensors_hour_count_ago_plural": "{{count}} පැය කිහිපයකට පෙර",
    "mobile_sensors_day_count_ago": "{{count}} දිනකට පෙර",
    "mobile_sensors_day_count_ago_plural": "{{count}} දින කිහිපයකට පෙර",
    "mobile_sensors_chart_settings": "ප්‍රස්තාර​ සැකසුම්",
    "mobile_announcement_banner_continue_reading": "කියවීම අඛණ්ඩව කරගෙන යන්න",
    "mobile_compliance_submissions_report": "යොමු කිරීම් වාර්තාව",
    "mobile_compliance_submissions_report_subtitle": "මෙම ගබඩාව සඳහා අපනයන ව්‍යාපෘති සම්පූර්ණත්ව දත්ත",
    "mobile_compliance_send_submissions": "ඉදිරිපත් කිරීම් යවන්න",
    "mobile_compliance_completion_rate_in_last_days": "පසුගිය දින {{ days }} තුළ සම්පූර්ණ කිරීමේ අනුපාතය",
    "mobile_compliance_last_days": "පසුගිය දින {{ days }}",
    "mobile_compliance_send_submissions_to": "වෙත ඉදිරිපත් කිරීම් යවන්න",
    "mobile_compliance_send_to_different_email": "වෙනස් විද්﻿යුත් ලිපිනයකට යවන්න",
    "mobile_compliance_email_input_placeholder": "විද්﻿යුත් ලිපිනය",
    "mobile_compliance_send_submissions_to_legend_title": "ඉදිරිපත් කිරීම්",
    "mobile_compliance_send_submissions_to_legend_description_days": "පසුගිය දින {{ days }} තතුළ මෙම ස්ථානයේ සිට ඔබ කළ ඉදිරිපත් කිරීම් සහිත වාර්තාවක් තෝරාගත් ඊමේල් ලිපිනය වෙත යවනු ලැබේ.",
    "mobile_compliance_time_frame": "කාල රාමුව",
    "mobile_compliance_sensor_temperature_log_report": "සංවේදක උෂ්ණත්ව ලොග් වාර්තාව",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "මෙම ගබඩාව සඳහා අපනයන උෂ්ණත්ව ලොග් සටහන්",
    "mobile_compliance_sensor_temperature_log_criteria_title": "නිර්ණායක",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "ඔබගේ වාර්තාව සඳහා නිර්ණායක පහතින් නිර්වචනය කරන්න.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "සටහන: අක්‍රීය වූ සංවේදක(ය) වාර්තාවේ නොපෙන්වනු ඇත",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "කාල රාමුවක් තෝරන්න. ලොග් දත්ත, උපරිම දින 30කට සීමා වේ",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "වාර්තාව යවන්න",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "මේ මාසය (අද 1 වන අද)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "පසුගිය මාසය",
    "mobile_compliance_sensor_temperature_log_email_title": "වෙත වාර්තාව යවන්න",
    "mobile_pwa_update_prompt_title": "යෙදුම යාවත්කාලීන කරන්න",
    "mobile_pwa_update_prompt_description": "යෙදුමේ නව අනුවාදයක් තිබේ. කරුණාකර නවතම අනුවාදයට යාවත්කාලීන කරන්න.",
    "mobile_pwa_update_prompt_confirm": "යාවත්කාලීන කර නැවත පූරණය කරන්න",
    "mobile_pwa_update_prompt_cancel": "මට පසුව මතක් කරන්න",
    "notification_title_due_in_one_hour": "1 පැයකින් අවසන් වේ",
    "task_is_due_soon": "'{{ task_title }}' ඉක්මනින් අවසන් වීමට නියමිතයි. එය සම්පූර්ණ කිරීමට මොහොතක් ගත කරන්න.",
    "mobile_photo_quality_warning_header": "ඡායාරූප ගුණාත්මක ගැටලුවකි",
    "mobile_photo_quality_dialog_message": "මෙම ඡායාරූපය ඉතා අඳුරු හෝ නොපැහැදිලි විය හැක. ඔබ නව ඡායාරූපයක් ගැනීමට කැමති ද, නැතහොත් මෙය දිගටම කරගෙන යාමට කැමතියිද?",
    "mobile_take_new_photo": "නව ඡායාරූපයක් ගන්න",
    "mobile_use_this_photo": "මෙම ඡායාරූපය භාවිත කරන්න"
}};
mobile_translations.nl_NL = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Alle",
    "mobile_common_button_apply_filters": "Filters toepassen",
    "mobile_common_button_done": "Gereed",
    "mobile_common_button_edit": "Bewerken",
    "mobile_common_button_archive": "Archiveren",
    "mobile_common_button_save": "Opslaan",
    "mobile_common_button_retake": "Opnieuw maken",
    "mobile_common_button_save_draft": "Concept opslaan",
    "mobile_common_button_discard": "Afwijzen",
    "mobile_common_button_submit": "Inzenden",
    "mobile_common_button_no": "Nee",
    "mobile_common_button_yes": "Ja",
    "mobile_common_button_na": "N.v.t.",
    "mobile_common_created_by_me": "Door mij gemaakt",
    "mobile_common_email": "Zakelijk e-mailadres",
    "mobile_common_first_name": "Voornaam",
    "mobile_common_last_name": "Achternaam",
    "mobile_common_location": "Locatie",
    "mobile_common_locations": "Locaties",
    "mobile_common_logout_message": "Weet u zeker dat u zich wilt afmelden?",
    "mobile_common_password": "Wachtwoord",
    "mobile_common_permission_required": "Toestemming vereist",
    "mobile_common_status": "Status",
    "mobile_common_task": "Taak",
    "mobile_common_tasks": "Taken",
    "mobile_common_tasks_my": "Mijn taken",
    "mobile_common_projects": "Projecten",
    "mobile_common_filter_team": "Team",
    "mobile_common_filter_var_in": " in {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Geen team geselecteerd",
    "mobile_common_filter_no_user_selected": "Geen gebruiker geselecteerd",
    "mobile_common_filter_no_role_selected": "Geen rol geselecteerd",
    "mobile_common_placeholder_date": "Datum",
    "mobile_common_message_task_creator_error_save": "<b>Er kunnen geen taken worden gemaakt.</b>",
    "mobile_common_camera": "Camera",
    "mobile_common_microphone": "Microfoon",
    "mobile_common_for": "voor",
    "mobile_common_reload": "Opnieuw laden",
    "mobile_common_override": "Overschrijven",
    "mobile_common_notifications": "Berichten",
    "mobile_common_chat_unavailable": "Chat niet beschikbaar. Probeer het later opnieuw.",
    "mobile_common_chat_ending_dialog_title": "Ben je klaar met dit gesprek?",
    "mobile_common_chat_ending_dialog_description": "Laat ons weten of het probleem is opgelost, of dat je later gewoon verder wilt gaan.",
    "mobile_common_chat_ending_dialog_confirm": "Ja, ik ben klaar",
    "mobile_common_chat_ending_dialog_cancel": "Ik ga later verder",
    "mobile_common_continue_editing": "Doorgaan met bewerken",
    "mobile_privacy_policy": "Privacybeleid",
    "wootric_recommend_target": "een vriend of collega in uw sector",
    "wootric_followup_detractor_question": "Wat kunnen we veranderen zodat u ons de volgende keer een betere beoordeling geeft?",
    "wootric_followup_passive_question": "Bedankt. Wat kunnen we doen om de tool nog beter te maken?",
    "wootric_followup_promoter_question": "Bedankt! Wat vindt u goed aan Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Bedankt. Wat vindt u prettig aan Zenput?",
    "wootric_default_followup_question": "Bedank. Kunt u uitleggen waarom?",
    "wootric_default_placeholder_text": "Help ons door uw beoordeling uit te leggen.",
    "wootric_default_thankyou_text": "Bedankt voor uw reactie en uw feedback.",
    "mobile_login_placeholder_login_as": "Aanmelden met gebruikers-ID",
    "mobile_login_button_forgot_password": "Wachtwoord vergeten?",
    "mobile_login_button_sign_up": "Account maken",
    "mobile_login_button_finish_setup": "Configuratie voltooien",
    "mobile_login_button": "Aanmelden",
    "mobile_login_continue_button": "Doorgaan",
    "mobile_login_continue_transition": "naar de aanmeldingspagina van uw organisatie...",
    "mobile_login_no_email_error": "U moet een e-mailadres invoeren.",
    "mobile_login_change_email": "Aanmelden met een ander e-mailadres",
    "mobile_login_with_sso": "Inloggen met SSO",
    "mobile_oauth_no_user_error_message": "Zo te zien hebt u nog geen Crunchtime Ops Execution-account!",
    "mobile_oauth_no_user_error_message_old": "Waarschijnlijk hebt u geen Zenput-account.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> is nu <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} wordt {{- product }} in september. {{- cta }}",
    "mobile_rebrand_warning_cta": "Lees nu hoe u zich kunt voorbereiden.",
    "mobile_oauth_no_user_error_sub_message": "Neem contact op met de beheerder of probeer aan te melden met een ander e-mailadres.",
    "mobile_oauth_generic_error_message": "Er is een probleem opgetreden bij het aanmelden. Probeer het opnieuw.",
    "mobile_oauth_force_logout_msg": "Als u nog steeds problemen ondervindt, meld u dan af bij uw provider door ",
    "mobile_oauth_force_logout_click": "hier te klikken.",
    "mobile_sign_up_placeholder_phone": "Mobiel nummer",
    "mobile_sign_up_placeholder_password_confirm": "Wachtwoord bevestigen",
    "mobile_sign_up_button_sign_in": "Registreren",
    "mobile_sign_up_disclaimer_part_1": "Door op Creëer Account te klikken, gaat u akkoord met de",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Als u op Configuratie voltooien klikt, gaat u akkoord met de",
    "mobile_sign_up_disclaimer_link_title": " Licentieovereenkomst",
    "mobile_sign_up_disclaimer_part_2": ". Hierin staat belangrijke informatie over privacy.",
    "mobile_dialog_benefits_work_offline": "Offline werken",
    "mobile_dialog_benefits_faster_uploads": "Sneller uploaden",
    "mobile_dialog_benefits_better_experience": "Betere ervaring",
    "mobile_dialog_benefits_button_download": "Downloaden",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution voor ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput voor ",
    "mobile_dialog_benefits_button_have": "Ik heb de app.",
    "mobile_dialog_benefits_button_no_thanks": "Nee bedankt, misschien later.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Afbeelding kan niet worden geladen.",
    "mobile_dialog_signature_sign": "Hier tekenen",
    "mobile_dialog_signature_button_clear": "Wissen",
    "mobile_account_placeholder_name": "Locatie-/winkelnaam",
    "mobile_account_placeholder_phone": "Telefoon",
    "mobile_account_placeholder_address": "Adres",
    "mobile_account_placeholder_city": "Plaats",
    "mobile_account_placeholder_region": "Regio",
    "mobile_account_placeholder_zipcode": "Postcode",
    "mobile_account_option_select_country": "Land selecteren",
    "mobile_account_oprion_us": "Verenigde Staten",
    "mobile_account_oprion_select_state": "Staat selecteren",
    "mobile_account_button_create_location": "Locatie maken",
    "mobile_form_message_no_form": "Geen formulieren beschikbaar",
    "mobile_batch_task_message": "Laden...",
    "mobile_settings_profile": "Profiel",
    "mobile_settings_profile_number": "Mobiele telefoon",
    "mobile_settings_profile_language": "Taal",
    "mobile_settings_profile_temperature_unit": "Temperatuureenheid",
    "mobile_settings_profile_use_company_default": "Bedrijfsstandaard gebruiken",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Sms",
    "mobile_settings_notifications_option_push": "Pushberichten",
    "mobile_settings_notifications_option_push_email": "E-mail & pushberichten",
    "mobile_settings_notifications_option_do_not": "Geen bericht verzenden",
    "mobile_settings_notifications_category_communication": "Communicatie",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulieren en triggers",
    "mobile_settings_devices": "Apparaten",
    "mobile_settings_notifications_sub_category_alerts": "Meldingen",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nieuwe formulieren beschikbaar",
    "mobile_settings_notifications_sub_category_task_assigned": "Taak toegewezen",
    "mobile_settings_notifications_sub_category_task_completed": "Taak voltooid",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Herinnering aanstaande taken",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Herinnering te late taken",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensormeldingen",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Belangrijke sensormeldingen",
    "mobile_drafts_message": "U hebt nog geen concepten.",
    "mobile_drafts_button_delete": "Verwijderen",
    "mobile_tasks_filter_location_no": "Geen locatie geselecteerd",
    "mobile_tasks_filter_group_by": "Groeperen op",
    "mobile_tasks_filter_sort_by": "Sorteren op",
    "mobile_tasks_filter_sorted_by": "Gesorteerd op",
    "mobile_tasks_filter_due_time": "Eindtijd",
    "mobile_tasks_filter_open_time": "Opentijd",
    "mobile_tasks_bucket_due_next_24_hours": "Deadline in de komende 24 uur",
    "mobile_tasks_bucket_due_next_7_days": "Deadline in de komende 7 dagen",
    "mobile_tasks_bucket_open_tasks": "Aanvullend open {{type}}",
    "mobile_tasks_bucket_open_at": "Open: {{- date }} om {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Deadline: {{- date }} om {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Beschikbaar over 1 minuut",
    "mobile_tasks_bucket_available_in_one_hour": "Beschikbaar over 1 uur",
    "mobile_tasks_bucket_available_in_one_day": "Beschikbaar over 1 dag",
    "mobile_tasks_bucket_available_in_one_week": "Beschikbaar over 1 week",
    "mobile_tasks_bucket_available_in_one_month": "Beschikbaar over 1 maand",
    "mobile_tasks_bucket_available_in_one_year": "Beschikbaar over 1 jaar",
    "mobile_tasks_bucket_available_in_minutes": "Beschikbaar over {{ minutes }} minuten",
    "mobile_tasks_bucket_available_in_hours": "Beschikbaar over {{ hours }} uur",
    "mobile_tasks_bucket_available_in_days": "Beschikbaar over {{ days }} dagen",
    "mobile_tasks_bucket_available_in_weeks": "Beschikbaar over {{ weeks }} weken",
    "notification_task_due_in_minutes": "Deadline over {{ minutes }} minuten",
    "mobile_tasks_bucket_available_in_months": "Beschikbaar over {{ months }} maanden",
    "mobile_tasks_bucket_available_in_years": "Beschikbaar over {{ years }} jaar",
    "mobile_tasks_follow_up": "Follow-uptaak",
    "mobile_tasks_due_soon": "Binnenkort verschuldigd",
    "mobile_tasks_bucket_completed_today": "Vandaag voltooid",
    "mobile_tasks_bucket_completed_this_week": "Deze week voltooid",
    "mobile_tasks_bucket_completed_last_week": "Vorige week voltooid",
    "mobile_tasks_bucket_missed_today": "Vandaag gemist",
    "mobile_tasks_bucket_missed_this_week": "Deze week gemist",
    "mobile_tasks_bucket_missed_last_week": "Vorige week gemist",
    "mobile_tasks_bucket_no_location": "Geen locatie",
    "mobile_tasks_cannot_submit_missed": "Gemiste taken kunnen niet worden voltooid",
    "mobile_tasks_cannot_submit_missed_after": "Deze taak kan niet worden voltooid na {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Deze taak is niet gestart.",
    "mobile_tasks_cannot_submit_processing": "Deze inzending wordt verwerkt.",
    "mobile_tasks_toolbarnav_header_no_due_date": "Geen vervaldatum",
    "mobile_tasks_toolbarnav_header_overdue": "Te laat",
    "mobile_tasks_toolbarnav_header_yesterday": "Gisteren",
    "mobile_tasks_toolbarnav_header_today": "Vandaag",
    "mobile_tasks_toolbarnav_header_tomorrow": "Morgen",
    "mobile_tasks_toolbarnav_header_last_week": "Vorige week",
    "mobile_tasks_toolbarnav_header_this_week": "Deze week",
    "mobile_tasks_toolbarnav_header_next_week": "Volgende week",
    "mobile_tasks_toolbarnav_header_this_month": "Deze maand",
    "mobile_tasks_toolbarnav_header_next_year": "Volgend jaar",
    "mobile_tasks_toolbarnav_header_over_year": "Gedurende een jaar",
    "mobile_tasks_toolbarnav_title_edit_task": "Taak bewerken",
    "mobile_task_placeholder_title": "Titel *",
    "mobile_task_placeholder_description": "Beschrijving (optioneel)",
    "mobile_task_button_single_task": "Eén taak",
    "mobile_task_button_project": "Project",
    "mobile_task_button_create": "Maken",
    "mobile_task_tab_basic": "Basis",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formulier",
    "mobile_task_details_description_message_please": "Vul de velden in ",
    "mobile_task_details_description_message_below": "hieronder.",
    "mobile_task_details_description_message_instructions": "Er zijn geen instructies beschikbaar voor deze taak.",
    "mobile_task_details_reason_title": "Vervolg in gang gezet door",
    "mobile_task_detials_button_goto_form": "Ga naar formulier",
    "mobile_task_detials_button_complete": " Taak voltooien",
    "mobile_task_detials_completed": "Voltooid ",
    "mobile_task_detials_completed_by": "door ",
    "mobile_task_detials_completed_on": "op ",
    "mobile_task_details_view_form_submission": "Ingezonden formulieren weergeven",
    "mobile_task_task_updated": "Taak bijgewerkt",
    "mobile_task_task_archived": "Taak gearchiveerd",
    "mobile_task_task_deleted": "Taak verwijderd",
    "mobile_task_error_archiving_task": "Kan taak niet archiveren.",
    "mobile_task_error_deleting_task": "Kon taak niet verwijderen.",
    "mobile_task_error_updating_task": "Kan taak niet bijwerken.",
    "mobile_task_archive_task": "Taak archiveren",
    "mobile_task_archive_task_confirm": "Weet u zeker dat u deze taak wilt archiveren?\n\nGearchiveerd taken tellen mee voor de voltooiingspercentages en zullen in de rapportage worden opgenomen.\n\nDit kan niet ongedaan worden gemaakt.",
    "mobile_task_delete_task_confirm": "Weet u zeker dat u deze taak wilt verwijderen?\n\nVerwijderde taken tellen niet mee voor de voltooiingspercentages en zullen niet in een rapportage worden opgenomen.\n\nDit kan niet ongedaan worden gemaakt.",
    "mobile_task_edition_already_in_progress": "Deze taak heeft een bewerking in behandeling. U mag de taak momenteel niet verder bewerken.",
    "mobile_projects_filter_type": "Type",
    "mobile_projects_filter_status": "Projectstatus",
    "mobile_projects_filter_project_type": "Projecttype",
    "mobile_projects_due_date_required": "Vervaldatum is verplicht.",
    "mobile_projects_team_required": "Team is verplicht.",
    "mobile_projects_user_role_required": "Verkrijger is verplicht.",
    "mobile_projects_title_required": "Titel is verplicht.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Meerdere taken per dag",
    "mobile_project_tasks_complete": " Volledig",
    "mobile_project_tasks_remaining": " Resterend",
    "mobile_esitmate_message_tasks": "Er worden 0 taken gemaakt",
    "mobile_esitmate_message_criteria": "Bovenstaande criteria aanpassen",
    "mobile_esitmate_message_created_for": "worden gemaakt voor",
    "mobile_left_menu_dashboard": "Dashboard",
    "mobile_left_menu_my_forms": "Mijn formulieren",
    "mobile_left_menu_announcements": "Aankondigingen",
    "mobile_left_menu_my_submissions": "Mijn inzendingen",
    "mobile_left_menu_drafts": "Concepten",
    "mobile_left_menu_pending_uploads": "Uploads in behandeling",
    "mobile_left_menu_open": "Openen in app",
    "mobile_left_menu_settings": "Instellingen",
    "mobile_left_menu_log_out": "Afmelden",
    "mobile_left_menu_debug": "Debuggen",
    "mobile_left_menu_support": "Ondersteuning",
    "mobile_left_menu_documentation": "Documentatie",
    "mobile_left_menu_chat": "Chatten",
    "mobile_field_textarea_placeholder_note": "Opmerking of bijschrift",
    "mobile_field_option_select": "Selecteren",
    "mobile_field_text_placeholder_text": "Tekst",
    "mobile_field_email_placehoder_email": "E-mailadres",
    "mobile_filed_number_placeholder_number": "Nummer",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Niet verbonden",
    "mobile_field_sensor_offline_battery": "Sensor offline: batterij",
    "mobile_field_video_button_add": "Een video toevoegen",
    "mobile_field_video_picker_dialog_title": "Video toevoegen vanuit",
    "mobile_field_video_button_change": "Video wijzigen",
    "mobile_field_image_button_add": "Afbeelding toevoegen",
    "mobile_field_image_low_quality_warning": "Sommige foto's zijn mogelijk te donker of onscherp. Bekijk de gemarkeerde foto's en vervang ze indien nodig.",
    "mobile_field_image_picker_dialog_title": "Foto toevoegen vanuit",
    "mobile_field_image_picker_edit_failed": "We kunnen de afbeelding niet opslaan. Probeer het opnieuw.",
    "mobile_field_signature_button_add": "Een handtekening toevoegen",
    "mobile_field_signature_button_change": "Handtekening wijzigen",
    "mobile_field_account_select_location": "Een locatie selecteren",
    "mobile_field_account_prefill": "Formulier invullen met gegevens van de vorige sessie?",
    "mobile_field_account_message_overwrite": "Hiermee worden alle velden overschreven die u al hebt ingevuld.",
    "mobile_forms_task_on_behalf": "Er moet op deze locatie een taak worden uitgevoerd die is toegewezen aan <b>{{user}}</b>. Wilt u deze taak voltooien?",
    "mobile_forms_complete_task": "Taak voltooien?",
    "mobile_field_account_prefill_button_yes": "Ja, alvast invullen",
    "mobile_field_barcode_placeholder_scan": "Streepjescode scannen of typen",
    "mobile_field_sensor_qr_code_placeholder_scan": "Code scannen of typen",
    "mobile_field_gateway_id_code_placeholder": "Type knooppunt-ID",
    "mobile_field_scan_qr_or_enter_dev_eui": "QR-code scannen of DevEUI invoeren",
    "mobile_field_scan_qr_or_enter_id": "QR-code scannen of ID-nummer invoeren",
    "mobile_field_scan_qr_or_enter_sc": "QR-code scannen of SC-code invoeren",
    "mobile_field_barcode_select_date": "Datum selecteren ",
    "mobile_field_datetime_allow_time": "Tijd",
    "mobile_field_stopwatch_button_caption": "Stopwatch",
    "mobile_field_stopwatch_common_start": "Starten",
    "mobile_field_stopwatch_common_stop": "Stoppen",
    "mobile_field_stopwatch_common_reset": "Opnieuw instellen",
    "mobile_field_stopwatch_stop_stopwatches": "Stopwatches stoppen",
    "mobile_field_document_title": "Document toevoegen",
    "mobile_field_document_message_delete": "Weet u zeker dat u dit document wilt verwijderen?",
    "mobile_field_document_alret_button_view": "Bekijken",
    "mobile_field_document_alert_error": "Er is een fout opgetreden bij het toevoegen van dit document. Probeer het opnieuw.",
    "mobile_field_document_alert_file_size_error": "Bestand mag niet groter zijn dan {{count}} MB.",
    "mobile_field_temperature_greater_range": "groter dan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "groter dan of gelijk aan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "kleiner dan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "kleiner dan of gelijk aan {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "groter dan of gelijk aan {{ min_temp_value }}°{{ temp_unit }} en kleiner dan  {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "groter dan of gelijk aan {{ min_temp_value }}°{{ temp_unit }} en kleiner dan of gelijk aan {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " en ",
    "mobile_field_text_limit_error": "Tekenlimiet van 8000 tekens bereikt.",
    "mobile_forms_required_questions_complete": "Verplicht aantal voltooid",
    "mobile_forms_required_remaining": "{{count}} resterend aantal verplicht",
    "mobile_forms_required_questions_back": "Terug",
    "mobile_forms_required_questions_next": "Volgende",
    "mobile_forms_required_questions_skip": "Overslaan",
    "mobile_forms_leaving_form": "Formulier sluiten",
    "mobile_message_reordering_confirm": "Wilt u de nieuwe vraagvolgorde opslaan?",
    "mobile_forms_leaving_reordering": "Wijzigen van vraagvolgorde verlaten",
    "mobile_forms_reordering_button_save": "Nieuwe vraagvolgorde opslaan",
    "mobile_forms_reordering_instructions": "Als u de volgorde van vragen of secties wilt wijzigen, sleept u deze naar waar het veld moet worden weergegeven op het formulier",
    "mobile_toolbarnav_title_my_setttings": "Mijn instellingen",
    "mobile_toolbarnav_title_profile_settings": "Profielinstellingen",
    "mobile_toolbarnav_title_notification": "Berichtinstellingen",
    "mobile_toolbarnav_title_form_history": "Formuliergeschiedenis",
    "mobile_toolbarnav_title_form_not_available": "Formulier niet beschikbaar",
    "mobile_toolbarnav_title_add_location": "Locatie toevoegen",
    "mobile_toolbarnav_title_add_task_or_project": "Taak of project toevoegen",
    "mobile_toolbarnav_title_select_location": "Locatie selecteren",
    "mobile_toolbarnav_title_select_project": "Project selecteren",
    "mobile_toolbarnav_title_select_tag": "Code selecteren",
    "mobile_toolbarnav_title_select_user": "Gebruiker selecteren",
    "mobile_toolbarnav_title_select_template": "Sjabloon selecteren",
    "mobile_toolbarnav_title_select_one": "Eén selecteren",
    "mobile_toolbarnav_title_select_multiple": "Eén of meer selecteren",
    "mobile_toolbarnav_title_select_team": "Team selecteren",
    "mobile_toolbarnav_title_select_team_or_location": "Team of locatie selecteren",
    "mobile_toolbarnav_title_filter_tasks": "Taken filteren",
    "mobile_toolbarnav_title_filter_projects": "Projecten filteren",
    "mobile_toolbarnav_title_filter_project_tasks": "Projecttaken filteren",
    "mobile_placeholder_search_bar": "Zoeken",
    "mobile_placeholder_user_select_role": "Gebruikersrol selecteren",
    "mobile_placeholder_filter_by_team": "Filteren op een team",
    "mobile_placeholder_assign_to_user_role": "Toewijzen aan gebruikersrol",
    "mobile_placeholder_select": "-- Selecteren --",
    "mobile_placeholder_account_location_name": "Locatienaam",
    "mobile_placeholder_tag_filter_by": "Filteren op locatiecode",
    "mobile_placeholder_user_type": "Toewijzen aan gebruiker",
    "mobile_placeholder_acount_type_loading": "Laden... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatuur",
    "mobile_placeholder_blue_therm_connecting": "Verbinding maken met apparaat...",
    "mobile_placeholder_blue_therm_please_wait": "Een ogenblik geduld.",
    "mobile_placeholder_blue_therm_tap": "Tik om te lezen.",
    "mobile_placeholder_blue_therm_not_connected": "Niet verbonden.",
    "mobile_placeholder_testo_tap": "Houd ▼▲ ingedrukt, gevolgd door ⬆",
    "mobile_message_error_create_task": "U moet online zijn om taken toe te voegen.",
    "mobile_message_error_fill_out_form": "Vul het formulier in.",
    "mobile_message_error_fill_require_fields": "Vul de verplichte velden in.",
    "mobile_message_error_stop_stopwatch_before_submit": "Vóór het inzenden moet u de stopwatch stoppen",
    "mobile_message_error_stopwatch_field_required": "Stopwatchveld is verplicht",
    "mobile_message_error_stopwatch_field_running": "Stopwatchveld is actief",
    "mobile_message_error_invalid_equipment_temperature": "Ongeldige apparatuurtemperatuur",
    "mobile_message_error_invalid_ingredient_temperature": "Ongeldige ingrediënttemperatuur",
    "mobile_message_error_location_attributes_unavailable": "Sommige vragen zijn mogelijk niet beschikbaar. Maak verbinding met internet",
    "mobile_message_alert_running_stopwatches": "Er lopen stopwatches.\n\nWilt u deze op nul zetten?",
    "mobile_message_blue_therm_error": "Verbinding met Bluetooth-apparaat is verbroken.",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Toegang tot locatie is vereist. Schakel deze functie in via de instellingen van uw Android-apparaat.",
    "mobile_message_blue_therm_no_permission_android": "Toegang tot apparaten in de buurt is vereist. Schakel deze functie in via uw Android-instellingen.",
    "mobile_message_blue_therm_error_code": "Verbinding maken mislukt:",
    "mobile_message_blue_therm_error_bluetooth": "Schakel Bluetooth in.",
    "mobile_message_blue_therm_error_device": "Apparaat niet gevonden.",
    "mobile_message_blue_therm_error_try_again": "Probeer het opnieuw.",
    "mobile_message_blue_therm_success": "Verbinding gemaakt met Bluetooth-apparaat.",
    "mobile_message_bluetooth_device_press_button_field": "Druk op de knop op het apparaat om verbinding te maken.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Druk op de knop op het apparaat<br />als het hier niet wordt vermeld.",
    "mobile_bluetooth_scan": "Scannen",
    "mobile_bluetooth_scanning": "Scannen",
    "mobile_message_drafts_confirm": "Wilt u dit opslaan als concept?",
    "mobile_message_drafts_toast_saved": "Concept opgeslagen.",
    "mobile_message_drafts_request_update": "Wilt u dit concept bijwerken?",
    "mobile_message_drafts_form_confirm": "Weet u zeker dat u dit concept wilt verwijderen?",
    "mobile_message_drafts_confirm_delete": "Concept verwijderen",
    "mobile_message_streams_error_switch": "Streams op internet kunnen niet worden gewijzigd.",
    "mobile_message_settings_success_saved": "Instellingen opgeslagen",
    "mobile_message_settings_error": "Er is een onbekende fout opgetreden. Probeer het later opnieuw.",
    "mobile_message_profile_settings_error_fields": "Corrigeer de gemarkeerde velden.",
    "mobile_message_media_perimission_denied": "Uw ",
    "mobile_message_media_perimission_denied_device": "Apparaatopslag",
    "mobile_message_image_confirm_remove_image": "Weet u zeker dat u deze foto wilt verwijderen?",
    "mobile_message_create_account_error_fields": "Vul de gemarkeerde velden in.",
    "mobile_message_create_account_success_location_created": "Locatie gemaakt",
    "mobile_message_task_error_get_location": "Locatie is niet gevonden. Er wordt op datum gesorteerd.",
    "mobile_message_typehead_confirm_save_message": "Wilt u deze selecties opslaan?",
    "mobile_message_typehead_confirm_save_title": "Opslaan?",
    "mobile_message_task_creator_error_save_select_form": "U moet een formulier selecteren.",
    "mobile_message_task_creator_error_save_required_fields": "Vul de verplichte velden in.",
    "mobile_message_task_creator_error_save_batch_change": "Wijzig de criteria zodat een of meer gebruikers hieraan voldoen.",
    "mobile_message_task_detials_error_not_assigned_to_you": "Deze taak is niet aan u toegewezen.<br />U kunt deze taak niet voltooien.",
    "mobile_message_task_detials_error_assigned_to": "Deze taak is toegewezen aan {{user}}.<br />U kunt deze taak niet voltooien.",
    "mobile_message_task_detials_confirm_title": "Taak sluiten",
    "mobile_message_task_detials_confirm_save_task": "Taak opslaan",
    "mobile_message_task_detials_confirm_message": "Weet u het zeker? De wijzigingen gaan verloren.",
    "mobile_message_task_detials_error_view_account": "Locatie kan niet worden geopend.",
    "mobile_message_task_detials_error_submit_task": "Voeg een foto toe om deze taak te voltooien.",
    "mobile_message_task_detials_error_submit_task_project": "Project kan niet worden opgeslagen. Probeer het later opnieuw.",
    "mobile_message_task_detials_wait_submit_task_created": "De taken worden gemaakt.<br />Wacht een paar minuten tot de taken zijn ingevuld.",
    "mobile_message_task_detials_error_submit_task_pending": "Fout. Probeer het later opnieuw.",
    "mobile_message_task_detials_success_task_complete": "Taak voltooid",
    "mobile_message_task_error_save_single_task": "Taak kan niet worden opgeslagen. Probeer het later opnieuw.",
    "mobile_message_task_success_save_single_task": "Taak gemaakt.",
    "mobile_message_show_error_message": "Er is iets misgegaan.",
    "mobile_message_show_success_message": "Gelukt!",
    "mobile_message_show_offline_message": "U bent momenteel offline.",
    "mobile_message_show_permission_denied_message": "<b>Toestemming vereist.</b> Geef Zenput toestemming voor toegang tot {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Toestemming vereist.</b> Geef Zenput en uw browser toestemming voor toegang tot {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Nu uploaden",
    "mobile_message_show_upload_in_progress_message": "Upload reeds bezig",
    "mobile_message_show_form_id_error": "Het opgegeven formulier kan niet worden geopend.",
    "mobile_message_show_single_task_error": "De opgegeven taak kan niet worden geopend.",
    "mobile_message_show_submissions_error": "De opgegeven inzending kan niet worden geopend.",
    "mobile_message_show_submissions_access_denied": "U hebt helaas geen toegang tot dit formulier.",
    "mobile_message_send_data_success": "Gegevens geüpload ",
    "mobile_message_start_upload_success": "Uploaden voltooid",
    "mobile_message_start_upload_error": "<b>Upload kan niet worden voltooid.</b><br>De inzending is opgeslagen. Probeer het later opnieuw.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Update beschikbaar",
    "mobile_message_store_upgrade_confirm_message_one": "Werk de Ops Execution-app bij via de ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Voer een update van Zenput uit via de ",
    "mobile_message_store_upgrade_confirm_message_two": " voor alle nieuwste functies en oplossingen van fouten",
    "mobile_message_store_upgrade_confirm_now": "Nu",
    "mobile_message_store_upgrade_confirm_later": "Later",
    "mobile_message_redirect_confirm_message": "U vult momenteel een formulier in. Wilt u het opslaan als concept voordat u doorgaat?",
    "mobile_message_log_out_confirm_unsynced_drafts": "U heeft {{count}} concepten die nog niet geüpload zijn. Deze gaan verloren als u verder gaat. Weet u dit zeker?",
    "mobile_message_draft_override_message": "Dit concept is opgeslagen op een ander apparaat op {{date}}, en de wijzigingen op dit apparaat zijn conflicterend. U kunt de bestaande versie overschrijven, maar u kunt ook de meest recente versie opnieuw laden; uw wijzigingen worden genegeerd.",
    "mobile_html_submitting": "Inzenden...",
    "mobile_html_offline": "U bent momenteel offline.",
    "mobile_html_offline_try_again": "U bent momenteel offline. <br/><br/>Probeer het opnieuw zodra u weer verbinding hebt.",
    "mobile_html_something_went_wrong": "Er is helaas iets misgegaan.",
    "mobile_html_something_went_wrong_try_again": "Er is helaas iets misgegaan. Probeer het opnieuw.",
    "mobile_html_failed_loading_roles": "Rollen kunnen niet worden geladen.",
    "mobile_alert_please_install_for_native": "Installeer de Ops Execution-app om deze functie te kunnen gebruiken. ",
    "mobile_alert_please_install_for_native_old": "Installeer de app van Zenput om deze functie te gebruiken.",
    "mobile_tso_filter_all_tasks": "Alle {{type}}",
    "mobile_tso_filter_my_tasks": "Mijn {{type}}",
    "mobile_tso_filter_due_date": "Vervaldatum",
    "mobile_tso_filter_date_completed": "Voltooiingsdatum",
    "mobile_tso_filter_completed": "Voltooid",
    "mobile_tso_filter_completed_late": "Te laat voltooid",
    "mobile_tso_filter_incomplete": "Onvolledig",
    "mobile_tso_filter_var_my_tasks": "Mijn {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} door mij gemaakt",
    "mobile_tso_filter_var_all_tasks": "Alle {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Follow-upacties",
    "mobile_tso_type_all": "Taken en follow-upacties",
    "mobile_tso_filter_var_at": " om {{location}}",
    "mobile_tso_filter_group_date_due": ", gesorteerd op vervaldatum",
    "mobile_tso_filter_group_distance": ", gegroepeerd op locatie",
    "mobile_tso_filter_start_date": "Startdatum",
    "mobile_tso_filter_none": "Geen",
    "mobile_pso_filter_all_projects": "Alle projecten",
    "mobile_pso_filter_my_projects": "Mijn projecten",
    "mobile_pso_filter_active": "Actief",
    "mobile_pso_filter_archived": "Gearchiveerd",
    "mobile_pso_filter_recurring": "Periodiek",
    "mobile_pso_filter_non_recurring": "Niet-periodiek",
    "mobile_pso_filter_var_my_projects": "Mijn {{project_type}} {{active_description}} projecten",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} door mij gemaakte projecten",
    "mobile_pso_filter_var_all_projects": "Alle {{project_type}} {{active_description}} projecten",
    "mobile_empty_list_message_must_be_online": "Waarschijnlijk bent u offline. Ga online om resultaten te bekijken.",
    "mobile_empty_list_message_no_submissions": "Geen inzendingen",
    "mobile_empty_list_message_no_activity": "Geen activiteit",
    "mobile_empty_list_message_no_tasks": "Geen taken",
    "mobile_empty_list_message_no_tasks_overdue": "Geen achterstallige {{type}}",
    "mobile_empty_list_message_no_accounts": "Geen locaties",
    "mobile_empty_list_message_no_projects": "Geen projecten",
    "mobile_empty_list_message_no_results_found": "Geen resultaten gevonden",
    "mobile_empty_list_message_no_forms_available": "Geen formulieren beschikbaar",
    "mobile_empty_list_message_connection_error": "Verbindingsfout.<br />Probeer het opnieuw.",
    "mobile_empty_list_message_dashboard_error": "Dashboard kan niet worden geladen",
    "mobile_empty_list_message_user_offline": "U bent momenteel offline",
    "mobile_action_sheet_media_gallery": "Galerij",
    "mobile_action_sheet_cancel": "Annuleren",
    "mobile_image_preview_text": "Foto verwijderen",
    "mobile_mobileform_text": "Eerdere inzendingen",
    "mobile_mobileform_reorder_fields": "Vraagvolgorde wijzigen",
    "mobile_mobileform_follow_up_actions": "Vervolgacties",
    "mobile_mobileform_follow_up_actions_assign_title": "Follow-upacties toewijzen",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Voeg follow-upacties toe op basis van uw bevindingen zodat problemen kunnen worden aangepakt.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Follow-upactie toevoegen",
    "mobile_mobileform_follow_up_actions_assign_button": "Follow-ups toewijzen",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Doorgaan zonder toewijzen",
    "mobile_mobileform_follow_up_actions_dialog_title": "Doorgaan zonder follow-upacties toe te wijzen?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Als u verdergaat zonder follow-upacties toe te wijzen, kunt u deze later niet meer toevoegen.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Toch doorgaan",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Dit veld is verplicht",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Te veel tekens",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Dit veld is ongeldig",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Fout bij laden van locaties",
    "mobile_mobileform_add_follow_up_actions_error_users": "Fout bij laden van gebruikers",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Follow-up toevoegen",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Titel",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Beschrijving",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Foto vereisen",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Vervaldatum",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Follow-up bijwerken",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Follow-up verwijderen?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Deze wordt verwijderd en wordt niet toegewezen.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Follow-up verwijderen",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Weet u zeker dat u deze follow-up wilt verwijderen?\n\nDit kan niet ongedaan worden gemaakt.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Doorgaan naar follow-ups",
    "mobile_mobileform_follow_up_actions_completed_notification": "Follow-upactie voltooid",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Follow-upactie verwijderd",
    "mobile_mobileform_follow_up_actions_update_notification": "Follow-upactie bijgewerkt",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Voeg een foto toe om deze follow-upactie te voltooien",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Navigeren naar inzending",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Navigeren naar bron",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Bron",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Follow-up voltooien",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Als u de inzending opent, gaan alle niet-opgeslagen foto's en notities verloren.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Als u dit scherm verlaat, gaan eventuele niet-opgeslagen foto's en notities verloren.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Hier blijven",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Inzending openen",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Bron openen",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Deze follow-upactie verlaten?",
    "mobile_mobileform_follow_up_actions_submission": "Inzending",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Deze follow-upactie is toegewezen aan {{user}}.<br />U kunt deze niet voltooien.",
    "mobile_mobileform_follow_up_actions_leave_description": "Als u dit scherm verlaat, gaan eventuele niet-opgeslagen wijzigingen verloren.",
    "mobile_mobileform_follow_up_actions_leave": "Verlaten",
    "mobile_forms_drafts_text": "Concepten verwijderen",
    "mobile_batch_estimate_user": "Gebruiker",
    "mobile_batch_estimate_users": "Gebruikers",
    "mobile_table_of_contents": "Inhoudsopgave",
    "mobile_table_of_contents_required": "Verplicht",
    "mobile_table_of_contents_optional": "Optioneel",
    "mobile_dialog_alert_title": "Alert",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth-apparaten worden nog niet ondersteund op Windows",
    "mobile_windows_deprecated_message_content_announcement": "Aankondiging",
    "mobile_windows_deprecated_message_title": "App-update vereist",
    "mobile_windows_deprecated_message_description": "Installeer de nieuwe Zenput-app zo snel mogelijk via de Microsoft Store zodat kritieke functionaliteiten worden bijgewerkt en uw ervaring met Zenput optimaal blijft.",
    "mobile_dashboard_tcr_graph_name": "Voltooiingspercentage van taak",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Afgelopen 4 weken",
    "mobile_dashboard_tcr_legend_company_average": "Gemiddelde van bedrijf",
    "mobile_dashboard_tcr_legend_team_average": "Gemiddelde van team",
    "mobile_dashboard_tab_title_summary": "Samenvatting",
    "mobile_dashboard_tab_title_activity": "Activiteit",
    "mobile_dashboard_card_title_top_triggered_workflows": "Belangrijkste triggers",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Compliance",
    "mobile_dashboard_card_task_stats_total": "Totaal",
    "mobile_dashboard_top_item_header_week_of": "Week van",
    "mobile_dashboard_card_filter_form_template_placeholder": "Alle formulieren",
    "mobile_dashboard_card_title_forms_top_nos": "Veelvoorkomende “Nee\"s",
    "mobile_dashboard_zenput_code_no_data_in_range": "Er zijn geen gegevens in deze periode.",
    "mobile_dashboard_zenput_code_permission_denied": "U hebt geen toestemming om dit te bekijken.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Selecteer hierboven een formulier.",
    "mobile_dashboard_zenput_code_unknown_error": "De gegevens kunnen momenteel niet worden weergegeven.",
    "mobile_dashboard_tap_to_retry": "Tik om het opnieuw te proberen",
    "mobile_dashboard_reporting_delay_disclaimer": "Het bijwerken van taken kan tot wel 15 minuten duren.",
    "mobile_dashboard_configuration_down_state_postfix_msg": "door de beheerder geconfigureerd.",
    "mobile_tasks_tag": "taken",
    "mobile_workflows_tag": "triggers",
    "mobile_projects_tag": "periodieke projecten",
    "mobile_forms_tag": "formulieren",
    "mobile_dashboard_card_ongoing_projects_title": "Projecten in uitvoering",
    "mobile_dashboard_card_ongoing_projects_show_more": "Meer weergeven",
    "mobile_dashboard_card_ongoing_projects_show_less": "Minder weergeven",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Ga naar projecten",
    "mobile_dashboard_card_title_recurring_projects": "Periodieke projecten",
    "mobile_dashboard_card_filter_daily": "Dagelijks",
    "mobile_dashboard_card_filter_weekly": "Wekelijks",
    "mobile_dashboard_card_filter_monthly": "Maandelijks",
    "mobile_task_status_title_open": "Open",
    "mobile_task_status_title_upcoming": "Aankomend",
    "mobile_task_status_title_complete": "Volledig",
    "mobile_task_status_title_processing": "Inzending verwerken",
    "mobile_task_status_title_complete_with_exceptions": "Volledig met vervolgtaken of alerts",
    "mobile_task_status_title_completed_late_with_exceptions": "Te laat voltooid met vervolgtaken of waarschuwingen",
    "mobile_task_status_title_incomplete_and_closed": "Gemist",
    "mobile_tasks_legend_modal_title": "Legenda",
    "mobile_tasks_legend_modal_footer_button_title": "Sluiten",
    "mobile_common_assigned_to": "Toegewezen aan",
    "mobile_common_created_by": "Gemaakt door",
    "mobile_common_tasks_for": "Taken voor",
    "mobile_common_go_back": "Terug",
    "mobile_oh_no": "Oei.",
    "mobile_user_not_in_groups": "Helaas. U bent waarschijnlijk niet aan een team toegewezen. Neem contact op met de beheerder voor toegang tot uw dashboard.",
    "mobile_tasks_select_followers": "Volgers selecteren",
    "mobile_tasks_assign_tasks": "{{count}} taken toewijzen",
    "mobile_tasks_add_followers": "Volgers toevoegen",
    "mobile_tasks_followers": "Volgers",
    "mobile_tasks_delete_task": "Taak verwijderen",
    "mobile_tasks_create_task": "Taken maken",
    "mobile_tasks_tab_title_comments": "Opmerkingen",
    "mobile_tasks_see_more": "Meer weergeven",
    "mobile_projects_create_project": "Project maken",
    "mobile_common_button_send": "Verzenden",
    "mobile_common_button_schedule": "Planning",
    "mobile_announcements_create": "Aankondiging opstellen",
    "mobile_announcements_read_rate": "{{opened_count}} van {{recipients_count}} geopend",
    "mobile_announcements_empty_message": "U heeft nog geen aankondigingen gemaakt! Maak hieronder een aankondiging voor het uitzenden van belangrijk nieuws, informatie en updates in uw organisatie.",
    "mobile_announcement_message_placeholder": "Een bericht toevoegen...",
    "mobile_announcement_title_placeholder": "Titel aankondiging",
    "mobile_announcement_leaving_announcement": "Aankondiging wordt afgesloten",
    "mobile_announcement_confirm_recipients_team": "Wilt u deze aankondiging naar {{count}} gebruiker(s) in {{teams}} geselecteerde team(s) sturen?",
    "mobile_announcement_confirm_recipients_role": "Wilt u deze aankondiging naar {{count}} gebruiker(s) in {{roles}} geselecteerde team(s) gebruikersrol(len) sturen?",
    "mobile_announcement_confirm_recipients_user": "Wilt u deze aankondiging naar {{count}} gebruiker(s) sturen?",
    "mobile_announcement_confirm_scheduled": "Op {{timestamp}}",
    "mobile_announcement_sending_announcement": "Aankondiging wordt verzonden",
    "mobile_announcement_send_to": "Verzenden naar",
    "mobile_announcement_sent_to": "Verzonden naar",
    "mobile_announcement_send_to_role": "Rol",
    "mobile_announcement_attachment_download": "Wordt gedownload {{filename}}",
    "mobile_announcement_attachment_validation_error": "U kunt hoogstens {{maxCount}} bijlagen toevoegen",
    "mobile_announcement_details_sent": "Verzonden",
    "mobile_announcement_details_total_recipients": "Totaal aantal ontvangers",
    "mobile_announcement_details_cancel": "Aankondiging annuleren",
    "mobile_announcement_details_not_editable": "Aankondigingen kunnen alleen worden bewerkt in de Ops Execution-webapp ",
    "mobile_announcement_details_not_editable_old": "Aankondigingen kunnen alleen op Zenput Web worden bewerkt",
    "mobile_announcement_details_open_count": "Open telling",
    "mobile_announcement_details_open_rate": "Open tarief",
    "mobile_announcement_details_resend": "Opnieuw verzenden naar personen die niet geopend hebben",
    "mobile_announcement_confirm_resend": "{{count}} gebruiker(s) hebben de aankondiging niet gelezen. Wilt u een herinnering sturen?",
    "mobile_announcement_confirm_resend_title": "Herinnering sturen?",
    "mobile_announcement_recipients_opened": "Geopend",
    "mobile_recipients_opened_empty_message": "Het lijkt erop dat nog niemand je bericht heeft geopend. Kom later terug om je resultaten te bekijken.",
    "mobile_announcement_recipients_unopened": "Ongeopend",
    "mobile_recipients_unopened_empty_message": "Goed nieuws! Er zijn geen ongeopende berichten!",
    "mobile_scheduled_announcements_delivery_section_header": "Levertijd",
    "mobile_scheduled_announcements_send_immediately_label": "Onmiddellijk verzenden",
    "mobile_scheduled_announcements_scheduled_label": "Op een specifiek tijdstip verzenden",
    "mobile_scheduled_announcements_scheduled_tab_label": "Gepland",
    "mobile_scheduled_announcements_dialog_header": "Aankondiging annuleren?",
    "mobile_scheduled_announcements_dialog_message": "Door uw aankondiging te annuleren wordt deze niet verzonden en uit uw lijst verwijderd. Dit kan niet ongedaan worden gemaakt. Ga naar Zenput Web om te bewerken.",
    "mobile_scheduled_announcements_empty_message": "U heeft nog geen geplande aankondigingen. Plan een aankondiging voor het uitzenden van belangrijk nieuws, informatie, en updates in uw organisatie.",
    "mobile_scheduled_announcements_validation_error": "De levertijd moet liggen na {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Aankondiging plannen",
    "mobile_projects_auto_archive": "Automatisch archiveren",
    "mobile_common_unassigned": "Niet-toegewezen",
    "mobile_tasks_title_placeholder": "Nieuw taak of nieuw formulier",
    "mobile_projects_leaving_project": "Project sluiten",
    "mobile_projects_save_project": "Project opslaan",
    "mobile_top_triggers_tasks": "Belangrijkste gestarte taken",
    "mobile_top_triggers_alerts": "Belangrijkste gestarte alert",
    "mobile_projects_not_started": "Niet Gestart",
    "mobile_empty_list_message_no_photos": "Geen foto's",
    "mobile_webfilestore_message_error": "Selecteer een geldig bestandstype",
    "mobile_notifications_empty_title": "Geen berichten",
    "mobile_notifications_empty_message": "Hier wordt de activiteit voor uw taken of degene waaraan u deelneemt weergegeven.",
    "mobile_comments_comment_deleted": "Deze opmerking is verwijderd.",
    "mobile_comments_comment_placeholder": "Opmerking",
    "mobile_comments_task_submitted_at": "Taak ingezonden op {{ date }} om {{ time }}",
    "mobile_comments_discard_comment_title": "Opmerking negeren?",
    "mobile_comments_discard_confirm_message": "Weet u het zeker? Uw opmerking zal worden verwijderd.",
    "mobile_comments_delete_comment_title": "Opmerking verwijderen?",
    "mobile_comments_delete_confirm_message": "Dit kan niet ongedaan worden gemaakt.",
    "mobile_comments_delete_button": "Opmerking verwijderen",
    "mobile_comments_delete_success_message": "Opmerking verwijderd",
    "mobile_comments_empty_message_tasks": "Er zijn nog geen opmerkingen \n Begin een gesprek over deze taak.",
    "mobile_comments_empty_message_submissions": "Er zijn nog geen opmerkingen \n Begin een gesprek over deze inzending.",
    "mobile_comments_empty_message_default": "Er zijn nog geen opmerkingen \n Begin een gesprek.",
    "mobile_comments_no_matching_users": "Geen overeenkomende gebruikers",
    "mobile_comments_empty_users_to_notify": "Er zijn geen gebruikers om op de hoogte te brengen.",
    "mobile_comments_users_cant_view_message": "Deze gebruikers kunnen deze opmerkingen niet bekijken",
    "mobile_comments_users_to_notify_title": "Gebruikers om op de hoogte te brengen",
    "mobile_comments_mention_description_notifiers": "Er zal <a href=\"#\" class=\"show_users_to_notify\">{{ count }} gebruiker</a> op de hoogte worden gebracht.",
    "mobile_comments_mention_description_notifiers_plural": "Er zullen <a href=\"#\" class=\"show_users_to_notify\">{{ count }} gebruikers</a> op de hoogte worden gebracht.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@Noem</a> meer gebruikers om ze op de hoogte te brengen.",
    "mobile_comments_mark_read": "Alles als gelezen aanmerken",
    "mobile_comments_author_mentioned_message": "heeft u genoemd in",
    "mobile_comments_author_commented_message": "heeft commentaar geleverd op",
    "mobile_view_pdf": "PDF weergeven",
    "mobile_no_pdf_generated_message": "Er is geen PDF gevonden voor deze inzending. U ontvangt binnenkort een exemplaar via e-mail.",
    "mobile_clipboard_copied_success": "De link is naar uw klembord gekopieerd.",
    "mobile_share_link": "Link delen",
    "mobile_zencam_share": "Delen",
    "mobile_zencam_view_details": "Details bekijken",
    "mobile_zencam_details_drawer_header": "Details",
    "mobile_zencam_submitted_by": "Ingediend door",
    "mobile_zencam_form_title": "Formuliertitel",
    "mobile_zencam_date_submitted": "Datum ingediend",
    "mobile_oil_quality_warning_message": "De olie is oud",
    "mobile_oil_quality_warning_message_subtitle": "Maak een plan om deze te verwisselen",
    "mobile_oil_quality_failure_message": "De kwaliteit van de olie is problematisch",
    "mobile_oil_quality_failure_message_subtitle": "Verwissel de olie meteen",
    "mobile_sensors_set_up_gateway": "Gateway instellen",
    "mobile_sensors_set_up_gateway_message": "Er zijn waarschijnlijk geen apparaten ingesteld. Ga aan de slag door een gateway toe te voegen.",
    "mobile_sensors_gateway_plugged_in": "Controleer of de gateway is aangesloten op een stopcontact.",
    "mobile_sensors_add_device": "Apparaat toevoegen",
    "mobile_sensors_name_this_gateway": "Geef een naam op voor deze gateway.",
    "mobile_sensors_name_this_sensor": "Geef een naam op voor deze sensor.",
    "mobile_sensors_device_barcode_information": "QR-code scannen of het ID- en SC-nummer invoeren via het apparaatlabel",
    "mobile_sensors_device_eui_information": "QR-code scannen of het DevEUI invoeren via het apparaatlabel",
    "mobile_sensors_gateway_id_information": "Voer de knooppunt-ID in van het gatewaylabel",
    "mobile_sensors_id_number": "{{untranslatedID}}-nummer",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}}-code",
    "mobile_sensors_sensors": "Sensoren",
    "mobile_sensors_sensor_deveui_error": "Kan DevEUI niet via QR ophalen. Voer dit handmatig in.",
    "mobile_sensors_gateways": "Gateways",
    "mobile_sensors_add_sensor": "Sensor toevoegen",
    "mobile_sensors_add_gateway": "Gateway toevoegen",
    "mobile_sensor_placement_description": "Welk gebied wordt door deze sensor bewaakt?",
    "mobile_sensors_equipment_placement": "Welk gebied of welke apparatuur wordt door deze sensor bewaakt?",
    "mobile_sensors_equipment": "Welke apparatuur wordt door deze sensor bewaakt?",
    "mobile_sensors_select_gateway_type": "Het type gateway selecteren",
    "mobile_sensors_select_placement": "Plaatsing selecteren",
    "mobile_sensors_select_equipment": "Apparatuur selecteren",
    "mobile_sensors_placement": "Plaatsing",
    "mobile_sensors_nickname_tip": "De naam van sensoren wordt bepaald door de bijnamen die aan de geselecteerde plaatsing zijn toegewezen.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "QR-scode scannen",
    "mobile_sensors_enter_manually": "Handmatig invoeren",
    "mobile_sensors_wizard_step_one": "Stap 1",
    "mobile_sensors_wizard_step_two": "Stap 2",
    "mobile_sensors_wizard_step_three": "Stap 3",
    "mobile_sensors_wizard_step_four": "Stap 4",
    "mobile_sensors_wizard_step_five": "Stap 5",
    "mobile_sensors_wizard_step_six": "Stap 6",
    "mobile_sensors_initializing": "Initialiseren…",
    "mobile_sensors_nickname": "Bijnaam",
    "mobile_sensors_field_not_blank": "{{field}} mag niet leeg zijn.",
    "mobile_sensors_nothing_to_see_here": "Niets om hier weer te geven",
    "mobile_sensors_missing_integration": "Sensorintegratie ontbreekt",
    "mobile_sensors_contact_zenput_admin": "Neem contact op met de Ops Execution-beheerder van uw bedrijf.",
    "mobile_sensors_contact_zenput_admin_old": "Neem contact op met de Zenput-beheerder.",
    "mobile_sensors_contact_manager": "Neem contact op met de accountmanager om sensoren toe te voegen.",
    "mobile_sensors_device_success_message": "Het laden van sensorgegevens kan tot wel 15 minuten duren.",
    "mobile_sensors_last_reading": "Laatste lezing",
    "mobile_sensors_remove_device": "Apparaat verwijderen",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1W",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1J",
    "mobile_sensors_sensor_settings": "Instellingen voor sensor",
    "mobile_sensors_remove_confirm_message": "Weet u zeker dat u dit apparaat wilt verwijderen?\nDit kan niet ongedaan worden gemaakt.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Geen apparatuur gekoppeld",
    "mobile_sensor_cooldown_process": "Koelproces",
    "mobile_sensor_last_12_hours": "Afgelopen 12 uur",
    "mobile_sensor_start_cooldown_process": "Nieuw koelproces starten",
    "mobile_sensor_cooldown_process_title": "Koelproces in twee fasen",
    "mobile_sensor_cooldown_process_description": "Bij een koelproces in twee fasen wordt voedsel in uiterlijk twee uur afgekoeld van meer dan{{ stage1_start_temperature }} naar {{ stage1_end_temperature }} en vervolgens in uiterlijk vier uur van {{ stage1_end_temperature }} naar {{ stage2_end_temperature }}.",
    "mobile_sensor_cooldown_process_place_food": "Zet het voedingsmiddel in de koeling.",
    "mobile_sensor_cooldown_process_insert_sensor": "Plaats een sensorsonde in het voedingsmiddel.",
    "mobile_sensor_cooldown_process_enter_information": "Voer de informatie hieronder in.",
    "mobile_sensor_cooldown_process_food_product": "Voedingsmiddel dat gekoeld moet worden",
    "mobile_sensor_cooldown_cool_down": "Koelen",
    "mobile_sensor_cooldown_select_sensor": "Sensor selecteren",
    "mobile_sensors_cooldown_start_cooldown": "Het afkoelen starten",
    "mobile_sensors_cooldown_please_enter_food": "Vul een voedselproduct in",
    "mobile_sensors_cooldown_please_select_sensor": "Selecteer een sensor",
    "mobile_sensors_cooldown_status_in_progress": "Voortgang",
    "mobile_sensors_cooldown_status_failed": "Mislukt",
    "mobile_sensors_cooldown_status_success": "Gelukt",
    "mobile_sensors_cooldown_stage": "Fase",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "De starttemperatuur ligt buiten bereik",
    "mobile_sensors_cooldown_failed_cooldown_process": "Koelproces is mislukt",
    "mobile_sensors_cooldown_cooldown_successful": "Koelproces gelukt",
    "mobile_sensors_cooldown_started_cooldown_process": "Koelproces gestart",
    "mobile_sensors_cooldown_hour": "uur",
    "mobile_sensors_cooldown_hour_plural": "uren",
    "mobile_sensors_cooldown_minute": "minuut",
    "mobile_minutes_plural": "minuten",
    "mobile_sensors_last_reading_max_date": "> 1 jaar geleden",
    "mobile_sensors_minute_count_ago": "{{count}} minuut geleden",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minuten geleden",
    "mobile_sensors_hour_count_ago": "{{count}} uur geleden",
    "mobile_sensors_hour_count_ago_plural": "{{count}} uren geleden",
    "mobile_sensors_day_count_ago": "{{count}} dag geleden",
    "mobile_sensors_day_count_ago_plural": "{{count}} dagen geleden",
    "mobile_sensors_chart_settings": "Instellingen chat",
    "mobile_announcement_banner_continue_reading": "Doorgaan met lezen",
    "mobile_compliance_submissions_report": "Rapport over inzendingen",
    "mobile_compliance_submissions_report_subtitle": "Voltooiingsgegevens van project voor deze winkel exporteren",
    "mobile_compliance_send_submissions": "Inzendingen verzenden",
    "mobile_compliance_completion_rate_in_last_days": "Voltooiingspercentage in afgelopen {{ days }} dagen",
    "mobile_compliance_last_days": "Afgelopen {{ days }} dagen",
    "mobile_compliance_send_submissions_to": "Inzendingen verzenden naar",
    "mobile_compliance_send_to_different_email": "Verzenden naar ander e-mailadres",
    "mobile_compliance_email_input_placeholder": "E-mailadres",
    "mobile_compliance_send_submissions_to_legend_title": "Inzendingen",
    "mobile_compliance_send_submissions_to_legend_description_days": "Een rapport met uw inzendingen vanaf deze locatie in de {{ days }} afgelopen dagen wordt verzonden naar het geselecteerde e-mailadres.",
    "mobile_compliance_time_frame": "Termijn",
    "mobile_compliance_sensor_temperature_log_report": "Lograpport sensortemperatuur",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Temperatuurlogboeken van deze winkel exporteren",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Criteria",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Definieer hieronder de criteria voor uw rapport.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Opmerking: uitgeschakelde sensoren worden niet in het rapport weergegeven",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Selecteer een termijn. Loggegevens hebben een limiet van 30 dagen",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Rapport verzenden",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Deze maand (1e – vandaag)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Vorige maand",
    "mobile_compliance_sensor_temperature_log_email_title": "Rapport verzenden naar",
    "mobile_pwa_update_prompt_title": "Toepassing bijwerken",
    "mobile_pwa_update_prompt_description": "Er is een nieuwe versie van de toepassing beschikbaar. Werk bij naar de nieuwste versie.",
    "mobile_pwa_update_prompt_confirm": "Bijwerken en opnieuw laden",
    "mobile_pwa_update_prompt_cancel": "Me later hieraan herinneren",
    "notification_title_due_in_one_hour": "Deadline over 1 uur",
    "task_is_due_soon": "{{ task_title }} wordt binnenkort verwacht. Neem even de tijd om dit af te ronden.",
    "mobile_photo_quality_warning_header": "Probleem met fotokwaliteit",
    "mobile_photo_quality_dialog_message": "Deze foto is mogelijk te donker of onscherp. Wilt u een nieuwe foto maken of doorgaan met deze?",
    "mobile_take_new_photo": "Een nieuwe foto maken",
    "mobile_use_this_photo": "Deze foto gebruiken"
}};
mobile_translations.da_DK = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Alle",
    "mobile_common_button_apply_filters": "Anvend filtre",
    "mobile_common_button_done": "Færdig",
    "mobile_common_button_edit": "Rediger",
    "mobile_common_button_archive": "Arkivér",
    "mobile_common_button_save": "Gem",
    "mobile_common_button_retake": "Gentag",
    "mobile_common_button_save_draft": "Gem udkast",
    "mobile_common_button_discard": "Kassér",
    "mobile_common_button_submit": "Aflever",
    "mobile_common_button_no": "Nej",
    "mobile_common_button_yes": "Ja",
    "mobile_common_button_na": "N/A",
    "mobile_common_created_by_me": "Oprettet af mig",
    "mobile_common_email": "Firma-e-mail",
    "mobile_common_first_name": "Fornavn",
    "mobile_common_last_name": "Efternavn",
    "mobile_common_location": "Sted",
    "mobile_common_locations": "Steder",
    "mobile_common_logout_message": "Er du sikker på, at du ønsker at logge ud?",
    "mobile_common_password": "Adgangskode",
    "mobile_common_permission_required": "Tilladelse påkrævet",
    "mobile_common_status": "Status",
    "mobile_common_task": "Opgave",
    "mobile_common_tasks": "Opgaver",
    "mobile_common_tasks_my": "Mine opgaver",
    "mobile_common_projects": "Projekter",
    "mobile_common_filter_team": "Team",
    "mobile_common_filter_var_in": " i {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Intet team valgt",
    "mobile_common_filter_no_user_selected": "Ingen bruger valgt",
    "mobile_common_filter_no_role_selected": "Ingen rolle valgt",
    "mobile_common_placeholder_date": "Dato",
    "mobile_common_message_task_creator_error_save": "<b>Kunne ikke oprette opgaver.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "til",
    "mobile_common_reload": "Genindlæs",
    "mobile_common_override": "Overskriv",
    "mobile_common_notifications": "Meddelelser",
    "mobile_common_chat_unavailable": "Chat ikke tilgængelig. Prøv igen senere.",
    "mobile_common_chat_ending_dialog_title": "Er du færdig med denne samtale?",
    "mobile_common_chat_ending_dialog_description": "Fortæl os, om dit problem blev løst, eller om du bare ønsker at fortsætte senere.",
    "mobile_common_chat_ending_dialog_confirm": "Ja, jeg er færdig",
    "mobile_common_chat_ending_dialog_cancel": "Jeg fortsætter senere",
    "mobile_common_continue_editing": "Fortsæt med at redigere",
    "mobile_privacy_policy": "Privatlivspolitik",
    "wootric_recommend_target": "en ven eller kollega i din branche",
    "wootric_followup_detractor_question": "Hvilke ændringer kan vi lave for at du giver os en højere rating næste gang?",
    "wootric_followup_passive_question": "Tak! Hvad kan vi gøre for at gøre tjenesten /værktøjet endnu bedre?",
    "wootric_followup_promoter_question": "Tak! Hvad er det, du sætter pris på ved Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Tak! Hvad er det, du elsker ved Zenput?",
    "wootric_default_followup_question": "Tak! Vil du fortælle os hvorfor?",
    "wootric_default_placeholder_text": "Hjælp os ved at forklare din score.",
    "wootric_default_thankyou_text": "Tak for dit svar, og din feedback!",
    "mobile_login_placeholder_login_as": "Login med bruger-id",
    "mobile_login_button_forgot_password": "Har du glem adgangskoden?",
    "mobile_login_button_sign_up": "Opret konto",
    "mobile_login_button_finish_setup": "Afslut opsætning",
    "mobile_login_button": "Log ind",
    "mobile_login_continue_button": "Fortsæt",
    "mobile_login_continue_transition": "fører dig til din organisations login-side...",
    "mobile_login_no_email_error": "Du skal indtaste en e-mail.",
    "mobile_login_change_email": "Log ind med anden e-mail",
    "mobile_login_with_sso": "Log ind med SSO",
    "mobile_oauth_no_user_error_message": "Det ser ud til, at du ikke har en Crunchtime Ops Execution-konto!",
    "mobile_oauth_no_user_error_message_old": "Det ser ud som om, du ikke har en Zenput-konto!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> er nu <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} bliver til {{- product }} i september. {{- cta }}",
    "mobile_rebrand_warning_cta": "Se, hvordan du kan forberede dig.",
    "mobile_oauth_no_user_error_sub_message": "Kontakt din administrator for at få adgang, eller prøv at logge ind med en anden e-mail.",
    "mobile_oauth_generic_error_message": "Det ser ud som, der opstod et problem med at logge ind, prøv venligst igen.",
    "mobile_oauth_force_logout_msg": "Hvis du stadig har problemer, så log ud ved at ",
    "mobile_oauth_force_logout_click": "klikke her.",
    "mobile_sign_up_placeholder_phone": "Cellenummer",
    "mobile_sign_up_placeholder_password_confirm": "Bekræft adgangskode",
    "mobile_sign_up_button_sign_in": "Log ind",
    "mobile_sign_up_disclaimer_part_1": "Ved at klikke Opret konto, accepterer du",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Ved at klikke på Afslut opsætning accepterer du",
    "mobile_sign_up_disclaimer_link_title": " Licensaftalen",
    "mobile_sign_up_disclaimer_part_2": ", der inkluderer vigtige private informationer",
    "mobile_dialog_benefits_work_offline": "Arbejd offline",
    "mobile_dialog_benefits_faster_uploads": "Hurtigere uploads",
    "mobile_dialog_benefits_better_experience": "Bedre oplevelse",
    "mobile_dialog_benefits_button_download": "Download",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution for ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput til ",
    "mobile_dialog_benefits_button_have": "Jeg har appen!",
    "mobile_dialog_benefits_button_no_thanks": "Nej tak, måske senere.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Kunne ikke indlæse billedet.",
    "mobile_dialog_signature_sign": "Skriv under her",
    "mobile_dialog_signature_button_clear": "Ryd",
    "mobile_account_placeholder_name": "Sted/butiksnavn",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Adresse",
    "mobile_account_placeholder_city": "By",
    "mobile_account_placeholder_region": "Region",
    "mobile_account_placeholder_zipcode": "Postnummer",
    "mobile_account_option_select_country": "Vælg land",
    "mobile_account_oprion_us": "USA",
    "mobile_account_oprion_select_state": "Vælg stat",
    "mobile_account_button_create_location": "Opret sted",
    "mobile_form_message_no_form": "Ingen tilgængelige formularer",
    "mobile_batch_task_message": "Indlæser ...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Mobiltelefon",
    "mobile_settings_profile_language": "Sprog",
    "mobile_settings_profile_temperature_unit": "Temperaturenhed",
    "mobile_settings_profile_use_company_default": "Brug virksomhedens standard",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Tekstmeddelelse",
    "mobile_settings_notifications_option_push": "Push-meddelelser",
    "mobile_settings_notifications_option_push_email": "E-mail og push-meddelelser",
    "mobile_settings_notifications_option_do_not": "Meddel ikke",
    "mobile_settings_notifications_category_communication": "Kommunikation",
    "mobile_settings_notifications_category_forms_and_triggers": "Formularer og triggere",
    "mobile_settings_devices": "Enheder",
    "mobile_settings_notifications_sub_category_alerts": "Advarsler",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nye formularer tilgængelige",
    "mobile_settings_notifications_sub_category_task_assigned": "Opgave tildelt",
    "mobile_settings_notifications_sub_category_task_completed": "Opgave afsluttet",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Påmindelse om opgaver, der snart forfalder",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Påmindelse om udløbne opgaver",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensoradvarsler",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Kritiske sensoradvarsler",
    "mobile_drafts_message": "Du har endnu ingen udkast.",
    "mobile_drafts_button_delete": "Slet",
    "mobile_tasks_filter_location_no": "Intet sted valgt",
    "mobile_tasks_filter_group_by": "Gruppe af",
    "mobile_tasks_filter_sort_by": "Sortér efter",
    "mobile_tasks_filter_sorted_by": "Sorteret efter",
    "mobile_tasks_filter_due_time": "Forfaldsdato",
    "mobile_tasks_filter_open_time": "Tid åbnet",
    "mobile_tasks_bucket_due_next_24_hours": "Deadline i løbet af de næste 24 timer",
    "mobile_tasks_bucket_due_next_7_days": "Deadline i løbet af de næste 7 dage",
    "mobile_tasks_bucket_open_tasks": "Yderligere åbne {{type}}",
    "mobile_tasks_bucket_open_at": "Åbningstidspunkt: {{- date }} kl. {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Deadline: {{- date }} kl. {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Tilgængelig om 1 minut",
    "mobile_tasks_bucket_available_in_one_hour": "Tilgængelig om 1 time",
    "mobile_tasks_bucket_available_in_one_day": "Tilgængelig om 1 dag",
    "mobile_tasks_bucket_available_in_one_week": "Tilgængelig om 1 uge",
    "mobile_tasks_bucket_available_in_one_month": "Tilgængelig om 1 måned",
    "mobile_tasks_bucket_available_in_one_year": "Tilgængelig om 1 år",
    "mobile_tasks_bucket_available_in_minutes": "Tilgængelig om {{ minutes }} minutter",
    "mobile_tasks_bucket_available_in_hours": "Tilgængelig om {{ hours }} timer",
    "mobile_tasks_bucket_available_in_days": "Tilgængelig om {{ days }} dage",
    "mobile_tasks_bucket_available_in_weeks": "Tilgængelig om {{ weeks }} uger",
    "notification_task_due_in_minutes": "Forfalder om {{ minutes }} minutter",
    "mobile_tasks_bucket_available_in_months": "Tilgængelig om {{ months }} måneder",
    "mobile_tasks_bucket_available_in_years": "Tilgængelig om {{ years }} år",
    "mobile_tasks_follow_up": "Opfølgning på opgave",
    "mobile_tasks_due_soon": "Forfalder snart",
    "mobile_tasks_bucket_completed_today": "Afsluttet i dag",
    "mobile_tasks_bucket_completed_this_week": "Afsluttet denne uge",
    "mobile_tasks_bucket_completed_last_week": "Afsluttet sidste uge",
    "mobile_tasks_bucket_missed_today": "Ikke nået i dag",
    "mobile_tasks_bucket_missed_this_week": "Ikke nået denne uge",
    "mobile_tasks_bucket_missed_last_week": "Ikke nået sidste uge",
    "mobile_tasks_bucket_no_location": "Intet sted",
    "mobile_tasks_cannot_submit_missed": "Ikke nåede opgaver kan ikke udføres",
    "mobile_tasks_cannot_submit_missed_after": "Denne opgave kan ikke udføres efter {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Denne opgave er ikke påbegyndt.",
    "mobile_tasks_cannot_submit_processing": "Fremsendelsen behandles",
    "mobile_tasks_toolbarnav_header_no_due_date": "Ingen udløbsdato",
    "mobile_tasks_toolbarnav_header_overdue": "Udløbet",
    "mobile_tasks_toolbarnav_header_yesterday": "I går",
    "mobile_tasks_toolbarnav_header_today": "I dag",
    "mobile_tasks_toolbarnav_header_tomorrow": "I morgen",
    "mobile_tasks_toolbarnav_header_last_week": "Sidste uge",
    "mobile_tasks_toolbarnav_header_this_week": "Denne uge",
    "mobile_tasks_toolbarnav_header_next_week": "Næste uge",
    "mobile_tasks_toolbarnav_header_this_month": "Denne måned",
    "mobile_tasks_toolbarnav_header_next_year": "Næste år",
    "mobile_tasks_toolbarnav_header_over_year": "Mere end et år",
    "mobile_tasks_toolbarnav_title_edit_task": "Redigér opgave",
    "mobile_task_placeholder_title": "Titel *",
    "mobile_task_placeholder_description": "Beskrivelse (valgfrit)",
    "mobile_task_button_single_task": "Enkelt opgave",
    "mobile_task_button_project": "Projekt",
    "mobile_task_button_create": "Opret",
    "mobile_task_tab_basic": "Basis",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formular",
    "mobile_task_details_description_message_please": "Udfyld venligst ",
    "mobile_task_details_description_message_below": "nedenfor.",
    "mobile_task_details_description_message_instructions": "Der er ingen tilgængelige anvisninger til denne opgave.",
    "mobile_task_details_reason_title": "Opfølgning foretaget af",
    "mobile_task_detials_button_goto_form": "Gå til formular",
    "mobile_task_detials_button_complete": " Afslut opgave",
    "mobile_task_detials_completed": "Afsluttet ",
    "mobile_task_detials_completed_by": "af ",
    "mobile_task_detials_completed_on": "d. ",
    "mobile_task_details_view_form_submission": "Se indsendt formular",
    "mobile_task_task_updated": "Opgave opdateret",
    "mobile_task_task_archived": "Opgave arkiveret",
    "mobile_task_task_deleted": "Opgave slettet",
    "mobile_task_error_archiving_task": "Kunne ikke arkivere opgaven.",
    "mobile_task_error_deleting_task": "Kunne ikke slette opgaven.",
    "mobile_task_error_updating_task": "Kunne ikke opdatere opgaven.",
    "mobile_task_archive_task": "Arkivér opgave",
    "mobile_task_archive_task_confirm": "Er du sikker på, du vil arkivere denne opgave?\n\nArkiverede opgaver tæller i forhold til afslutningsraterne og vil fortsætte med at blive inkluderet i rapporteringen.\n\nDette kan ikke laves om.",
    "mobile_task_delete_task_confirm": "Er du sikker på, du ønsker at slette denne opgave?\n\nSlettede opgaver tæller ikke i forhold til afslutningsraterne, ej heller inkluderes de i nogen rapportering.\n\nDette kan ikke laves om.",
    "mobile_task_edition_already_in_progress": "Denne opgave venter på at blive redigeret. Yderligere redigering er ikke tilladt nu.",
    "mobile_projects_filter_type": "Type",
    "mobile_projects_filter_status": "Projektstatus",
    "mobile_projects_filter_project_type": "Projekttype",
    "mobile_projects_due_date_required": "Forfaldsdato er påkrævet.",
    "mobile_projects_team_required": "Team er påkrævet.",
    "mobile_projects_user_role_required": "Tildelt person er påkrævet.",
    "mobile_projects_title_required": "Titel er påkrævet.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Flere opgaver pr. dag",
    "mobile_project_tasks_complete": " Afsluttet",
    "mobile_project_tasks_remaining": " Resterende",
    "mobile_esitmate_message_tasks": "0 opgaver vil blive oprettet",
    "mobile_esitmate_message_criteria": "Justér kriterierne ovenfor",
    "mobile_esitmate_message_created_for": "vil blive oprettet for",
    "mobile_left_menu_dashboard": "Dashboard",
    "mobile_left_menu_my_forms": "Mine formularer",
    "mobile_left_menu_announcements": "Bekendtgørelser",
    "mobile_left_menu_my_submissions": "Mine indsendelser",
    "mobile_left_menu_drafts": "Udkast",
    "mobile_left_menu_pending_uploads": "Uploads i venteposition",
    "mobile_left_menu_open": "Åbn i app",
    "mobile_left_menu_settings": "Indstillinger",
    "mobile_left_menu_log_out": "Log ud",
    "mobile_left_menu_debug": "Ret fejl",
    "mobile_left_menu_support": "Support",
    "mobile_left_menu_documentation": "Dokumentation",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Note eller billedtekst",
    "mobile_field_option_select": "Vælg",
    "mobile_field_text_placeholder_text": "Tekst",
    "mobile_field_email_placehoder_email": "E-mail",
    "mobile_filed_number_placeholder_number": "Nummer",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Ikke tilsluttet",
    "mobile_field_sensor_offline_battery": "Sensor er offline – batteri",
    "mobile_field_video_button_add": "Tilføj en video",
    "mobile_field_video_picker_dialog_title": "Tilføj video fra",
    "mobile_field_video_button_change": "Skift video",
    "mobile_field_image_button_add": "Tilføj billede",
    "mobile_field_image_low_quality_warning": "Nogle billeder kan være for mørke eller slørede. Gennemgå de fremhævede billeder, og erstat dem om nødvendigt.",
    "mobile_field_image_picker_dialog_title": "Tilføj foto fra",
    "mobile_field_image_picker_edit_failed": "Vi kunne ikke gemme billedet. Prøv igen.",
    "mobile_field_signature_button_add": "Tilføj en signatur",
    "mobile_field_signature_button_change": "Skift signatur",
    "mobile_field_account_select_location": "Vælg et sted",
    "mobile_field_account_prefill": "Udfyld formularen med data fra sidste besøg?",
    "mobile_field_account_message_overwrite": "Dette vil overskrive alle felter, du allerede har udfyldt.",
    "mobile_forms_task_on_behalf": "Der er en opgave at udføre på dette sted, som er tildelt <b>{{user}}</b>. Ønsker du at afslutte denne opgave?",
    "mobile_forms_complete_task": "Afslut opgave?",
    "mobile_field_account_prefill_button_yes": "Ja, genbrug data",
    "mobile_field_barcode_placeholder_scan": "Scan eller indtast stregkode",
    "mobile_field_sensor_qr_code_placeholder_scan": "Scan eller indtast kode",
    "mobile_field_gateway_id_code_placeholder": "Indtast node-id",
    "mobile_field_scan_qr_or_enter_dev_eui": "Scan QR-kode, eller indtast DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Scan QR-kode, eller indtast id-nummer",
    "mobile_field_scan_qr_or_enter_sc": "Scan QR-kode, eller indtast SC-kode",
    "mobile_field_barcode_select_date": "Vælg dato ",
    "mobile_field_datetime_allow_time": "Tid",
    "mobile_field_stopwatch_button_caption": "Stopur",
    "mobile_field_stopwatch_common_start": "Start",
    "mobile_field_stopwatch_common_stop": "Stop",
    "mobile_field_stopwatch_common_reset": "Nulstil",
    "mobile_field_stopwatch_stop_stopwatches": "Stop stopure",
    "mobile_field_document_title": "Tilføj dokument",
    "mobile_field_document_message_delete": "Er du sikker på, du ønsker at slette dette dokument?",
    "mobile_field_document_alret_button_view": "Se",
    "mobile_field_document_alert_error": "Der opstod en fejl under vedhæftningen af dette dokument. Prøv venligst igen.",
    "mobile_field_document_alert_file_size_error": "Filen må ikke overskride {{count}} MB.",
    "mobile_field_temperature_greater_range": "større end {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "større end eller lig med {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "mindre end {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "mindre end eller lig med {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "større end eller lig med {{ min_temp_value }} °{{ temp_unit }} og mindre end {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "større end eller lig med {{ min_temp_value }} °{{ temp_unit }} og mindre end eller lig med {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " og ",
    "mobile_field_text_limit_error": "Maksimal tegngrænse på 8.000 er nået.",
    "mobile_forms_required_questions_complete": "Afslutning påkrævet",
    "mobile_forms_required_remaining": "{{count}} Resterende påkrævede (opgaver)",
    "mobile_forms_required_questions_back": "Tilbage",
    "mobile_forms_required_questions_next": "Næste",
    "mobile_forms_required_questions_skip": "Spring over",
    "mobile_forms_leaving_form": "Forlad formularen",
    "mobile_message_reordering_confirm": "Vil du gemme den nye spørgsmålsrækkefølge?",
    "mobile_forms_leaving_reordering": "Forlader omorganisering af spørgsmål",
    "mobile_forms_reordering_button_save": "Gem ny spørgsmålsrækkefølge",
    "mobile_forms_reordering_instructions": "For at omorganisere spørgsmål eller afsnit skal du trække og slippe der, hvor feltet skal vises i formularen",
    "mobile_toolbarnav_title_my_setttings": "Mine indstillinger",
    "mobile_toolbarnav_title_profile_settings": "Profilindstillinger",
    "mobile_toolbarnav_title_notification": "Meddelelsesindstillinger",
    "mobile_toolbarnav_title_form_history": "Formularhistorik",
    "mobile_toolbarnav_title_form_not_available": "Formularen er ikke tilgængelig",
    "mobile_toolbarnav_title_add_location": "Tilføj sted",
    "mobile_toolbarnav_title_add_task_or_project": "Tilføj opgave eller projekt",
    "mobile_toolbarnav_title_select_location": "Vælg sted",
    "mobile_toolbarnav_title_select_project": "Vælg projekt",
    "mobile_toolbarnav_title_select_tag": "Vælg tag",
    "mobile_toolbarnav_title_select_user": "Vælg bruger",
    "mobile_toolbarnav_title_select_template": "Vælg skabelon",
    "mobile_toolbarnav_title_select_one": "Vælg en",
    "mobile_toolbarnav_title_select_multiple": "Vælg en eller flere",
    "mobile_toolbarnav_title_select_team": "Vælg team",
    "mobile_toolbarnav_title_select_team_or_location": "Vælg team eller sted",
    "mobile_toolbarnav_title_filter_tasks": "Filtrér opgaver",
    "mobile_toolbarnav_title_filter_projects": "Filtrér projekter",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrér projektopgaver",
    "mobile_placeholder_search_bar": "Søg",
    "mobile_placeholder_user_select_role": "Vælg brugerrolle",
    "mobile_placeholder_filter_by_team": "Filtrér af fra hold",
    "mobile_placeholder_assign_to_user_role": "Tildel til brugerrolle",
    "mobile_placeholder_select": "– Vælg --",
    "mobile_placeholder_account_location_name": "Stednavn",
    "mobile_placeholder_tag_filter_by": "Filtrér ud fra sted-tag",
    "mobile_placeholder_user_type": "Tildel bruger",
    "mobile_placeholder_acount_type_loading": "Indlæser ... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatur",
    "mobile_placeholder_blue_therm_connecting": "Forbinder til enhed...",
    "mobile_placeholder_blue_therm_please_wait": "Vent venligst...",
    "mobile_placeholder_blue_therm_tap": "Klik for at læse.",
    "mobile_placeholder_blue_therm_not_connected": "Ikke tilsluttet.",
    "mobile_placeholder_testo_tap": "Hold på ▼▲ efterfulgt af ⬆",
    "mobile_message_error_create_task": "Du skal være online for at tilføje opgaver.",
    "mobile_message_error_fill_out_form": "Udfyld venligst formularen.",
    "mobile_message_error_fill_require_fields": "Udfyld påkrævede felter.",
    "mobile_message_error_stop_stopwatch_before_submit": "Stop dit stopur, før du afsender",
    "mobile_message_error_stopwatch_field_required": "Stopursfelt er påkrævet",
    "mobile_message_error_stopwatch_field_running": "Stopursfelt er i gang",
    "mobile_message_error_invalid_equipment_temperature": "Ugyldig udstyrstemperatur",
    "mobile_message_error_invalid_ingredient_temperature": "Ugyldig ingredienstemperatur",
    "mobile_message_error_location_attributes_unavailable": "Nogle spørgsmål kan være utilgængelige, prøv at oprette forbindelse til internettet",
    "mobile_message_alert_running_stopwatches": "Du har stopure i gang.\n\nVil du rydde dem?",
    "mobile_message_blue_therm_error": "Mistede forbindelsen til Bluetooth-enhed",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Placeringsadgang er påkrævet. Aktivér denne funktion i dine Android-indstillinger.",
    "mobile_message_blue_therm_no_permission_android": "Adgang til enheder i nærheden er påkrævet. Aktivér denne funktion i dine Android-indstillinger.",
    "mobile_message_blue_therm_error_code": "Kunne ikke oprette forbindelse:",
    "mobile_message_blue_therm_error_bluetooth": "Aktivér venligst Bluetooth.",
    "mobile_message_blue_therm_error_device": "Enhed ikke fundet.",
    "mobile_message_blue_therm_error_try_again": "Prøv igen",
    "mobile_message_blue_therm_success": "Bluetooth-enhed forbundet!",
    "mobile_message_bluetooth_device_press_button_field": "Tryk på knappen på din enhed for at forbinde.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Tryk på knappen på din enhed<br />, hvis du ikke kan se den på listen her.",
    "mobile_bluetooth_scan": "Scan",
    "mobile_bluetooth_scanning": "Scanner",
    "mobile_message_drafts_confirm": "Ønsker du at gemme denne som et udkast?",
    "mobile_message_drafts_toast_saved": "Udkast gemt.",
    "mobile_message_drafts_request_update": "Ønsker du at opdatere dette udkast?",
    "mobile_message_drafts_form_confirm": "Er du sikker på, du ønsker at slette dette udkast?",
    "mobile_message_drafts_confirm_delete": "Slet udkast",
    "mobile_message_streams_error_switch": "Kan ikke ændre streams på nettet",
    "mobile_message_settings_success_saved": "Indstillinger gemt",
    "mobile_message_settings_error": "En ukendt fejl opstod. Prøv igen senere",
    "mobile_message_profile_settings_error_fields": "Ret venligst de markerede felter.",
    "mobile_message_media_perimission_denied": "Din ",
    "mobile_message_media_perimission_denied_device": "Lagringsenhed",
    "mobile_message_image_confirm_remove_image": "Er du sikker på, du ønsker at slette dette foto?",
    "mobile_message_create_account_error_fields": "Udfyld venligst de markerede felter.",
    "mobile_message_create_account_success_location_created": "Sted oprettet",
    "mobile_message_task_error_get_location": "Stedet kunne ikke findes. Sorterer efter dato.",
    "mobile_message_typehead_confirm_save_message": "Ønsker du at gemme disse valg?",
    "mobile_message_typehead_confirm_save_title": "Gem?",
    "mobile_message_task_creator_error_save_select_form": "Du skal vælge en formular.",
    "mobile_message_task_creator_error_save_required_fields": "Udfyld venligst de påkrævede felter.",
    "mobile_message_task_creator_error_save_batch_change": "Ændr venligst kriterierne, så en eller flere brugere kan matche",
    "mobile_message_task_detials_error_not_assigned_to_you": "Denne opgave er ikke tildelt dig.<br />Du kan ikke afslutte den.",
    "mobile_message_task_detials_error_assigned_to": "Denne opgave er tildelt til {{user}}.<br />Du kan ikke afslutte den.",
    "mobile_message_task_detials_confirm_title": "Forlader opgaven",
    "mobile_message_task_detials_confirm_save_task": "Gem opgaven",
    "mobile_message_task_detials_confirm_message": "Er du sikker? Dine ændringer vil ikke blive gemt.",
    "mobile_message_task_detials_error_view_account": "Ingen adgang til stedet.",
    "mobile_message_task_detials_error_submit_task": "Tilføj venligst et foto for at afslutte denne opgave.",
    "mobile_message_task_detials_error_submit_task_project": "Projektet kunne ikke gemmes. Prøv venligst senere.",
    "mobile_message_task_detials_wait_submit_task_created": "Opgaverne oprettes.<br />Vent venligst et par minutter til opgaverne udfyldes.",
    "mobile_message_task_detials_error_submit_task_pending": "Fejl, prøv igen senere",
    "mobile_message_task_detials_success_task_complete": "Opgave afsluttet",
    "mobile_message_task_error_save_single_task": "Opgaven kunne ikke gemmes. Prøv venligst senere.",
    "mobile_message_task_success_save_single_task": "Opgaven er oprettet.",
    "mobile_message_show_error_message": "Der gik noget galt.",
    "mobile_message_show_success_message": "Det lykkedes!",
    "mobile_message_show_offline_message": "Du er nu offline.",
    "mobile_message_show_permission_denied_message": "<b>Tilladelse påkrævet.</b> Giv venligst Zenput tilladelse til at få adgang {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Tilladelse påkrævet.</b> Giv venligst Zenput og din browser tilladelse til at få adgang til {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Uploader nu",
    "mobile_message_show_upload_in_progress_message": "Upload allerede i gang",
    "mobile_message_show_form_id_error": "Ingen adgang til den specifikke formular.",
    "mobile_message_show_single_task_error": "Ingen adgang til den specifikke opgave.",
    "mobile_message_show_submissions_error": "Ingen adgang til den specifikke indsendelse.",
    "mobile_message_show_submissions_access_denied": "Beklager, du har ikke adgang til denne form.",
    "mobile_message_send_data_success": "Data uploadet ",
    "mobile_message_start_upload_success": "Upload afsluttet",
    "mobile_message_start_upload_error": "<b>Kunne ikke afslutte upload.</b><br>Indsendelse gemt. Prøv venligst senere",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Opdatering tilgængelig",
    "mobile_message_store_upgrade_confirm_message_one": "Opdater venligst Ops Execution-appen fra ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Opdatér venligst Zenput fra ",
    "mobile_message_store_upgrade_confirm_message_two": " for at få alle de nyeste funktioner og bug-fixes",
    "mobile_message_store_upgrade_confirm_now": "Nu",
    "mobile_message_store_upgrade_confirm_later": "Senere",
    "mobile_message_redirect_confirm_message": "Du er nu i gang med at udfylde en formular. Ønsker du at gemme den som et udkast, inden du fortsætter?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Du har {{count}} udkast, som endnu ikke er blevet uploadet. De vil gå tabt, hvis du fortsætter. Er du sikker?",
    "mobile_message_draft_override_message": "Dette udkast blev gemt fra en anden enhed på {{date}}, og ændringerne på denne enhed stemmer ikke overens. Du kan vælge at overskride den eksisterende version eller genindlæse den seneste version, hvorved dine ændringer vil blive kasseret.",
    "mobile_html_submitting": "Indsender...",
    "mobile_html_offline": "Du er nu offline!",
    "mobile_html_offline_try_again": "Du er nu offline. <br/><br/>Prøv venligst igen, når du er forbundet",
    "mobile_html_something_went_wrong": "Ups. Noget gik galt",
    "mobile_html_something_went_wrong_try_again": "Ups. Noget gik galt. Prøv venligst igen.",
    "mobile_html_failed_loading_roles": "Kunne ikke indlæse rollerne.",
    "mobile_alert_please_install_for_native": "Du skal installere Ops Execution-appen for at kunne bruge denne funktion. ",
    "mobile_alert_please_install_for_native_old": "Installér venligst Zenput-appen på originalsproget for at bruge denne funktion.",
    "mobile_tso_filter_all_tasks": "Alle {{type}}",
    "mobile_tso_filter_my_tasks": "Min {{type}}",
    "mobile_tso_filter_due_date": "Forfaldsdato",
    "mobile_tso_filter_date_completed": "Afslutningsdato",
    "mobile_tso_filter_completed": "Afsluttet",
    "mobile_tso_filter_completed_late": "Afsluttet for sent",
    "mobile_tso_filter_incomplete": "Uafsluttet",
    "mobile_tso_filter_var_my_tasks": "Mine {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} oprettet af mig",
    "mobile_tso_filter_var_all_tasks": "Alle {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Opfølgningshandlinger",
    "mobile_tso_type_all": "Opgaver og opfølgningshandlinger",
    "mobile_tso_filter_var_at": " hos {{location}}",
    "mobile_tso_filter_group_date_due": ", bestilt ud fra forfaldsdato",
    "mobile_tso_filter_group_distance": ", grupperet efter sted",
    "mobile_tso_filter_start_date": "Startdato",
    "mobile_tso_filter_none": "Ingen",
    "mobile_pso_filter_all_projects": "Alle projekter",
    "mobile_pso_filter_my_projects": "Mine projekter",
    "mobile_pso_filter_active": "Aktiv",
    "mobile_pso_filter_archived": "Arkiveret",
    "mobile_pso_filter_recurring": "Tilbagevendende",
    "mobile_pso_filter_non_recurring": "Ikke-tilbagevendende",
    "mobile_pso_filter_var_my_projects": "Mine {{project_type}} {{active_description}} projekter",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Projekter oprettet af mig",
    "mobile_pso_filter_var_all_projects": "Alle {{project_type}} {{active_description}} projekter",
    "mobile_empty_list_message_must_be_online": "Det ser ud som om, du er offline. Gå venligst online for at se nogen resultater.",
    "mobile_empty_list_message_no_submissions": "Ingen indsendelser",
    "mobile_empty_list_message_no_activity": "Ingen aktivitet",
    "mobile_empty_list_message_no_tasks": "Ingen opgaver",
    "mobile_empty_list_message_no_tasks_overdue": "Ingen udløbne {{type}}",
    "mobile_empty_list_message_no_accounts": "Ingen steder",
    "mobile_empty_list_message_no_projects": "Ingen projekter",
    "mobile_empty_list_message_no_results_found": "Ingen fundne resultater",
    "mobile_empty_list_message_no_forms_available": "Ingen tilgængelige formularer",
    "mobile_empty_list_message_connection_error": "Fejl ved forbindelsen<br />Prøv venligst igen.",
    "mobile_empty_list_message_dashboard_error": "Dashboardet kunne ikke indlæses",
    "mobile_empty_list_message_user_offline": "Du er nu offline",
    "mobile_action_sheet_media_gallery": "Galleri",
    "mobile_action_sheet_cancel": "Annullér",
    "mobile_image_preview_text": "Fjern foto",
    "mobile_mobileform_text": "Seneste indsendelser",
    "mobile_mobileform_reorder_fields": "Omorganiser spørgsmål",
    "mobile_mobileform_follow_up_actions": "Opfølgende handlinger",
    "mobile_mobileform_follow_up_actions_assign_title": "Tildel opfølgningshandlinger",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Tilføj opfølgende handlinger baseret på dine observationer for at sikre, at problemerne bliver løst.",
    "mobile_mobileform_follow_up_actions_add_button": "+ tilføj opfølgningshandling",
    "mobile_mobileform_follow_up_actions_assign_button": "Tildel opfølgninger",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Fortsæt med at tildele",
    "mobile_mobileform_follow_up_actions_dialog_title": "Vil du fortsætte uden at tildele opfølgningshandlinger?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Hvis du fortsætter uden at tildele opfølgningshandlinger, kan du ikke tilføje dem senere.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Fortsæt alligevel",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Dette felt er påkrævet",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "For mange tegn",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Dette felt er ugyldigt",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Fejl ved indlæsning af lokaliteter",
    "mobile_mobileform_add_follow_up_actions_error_users": "Fejl ved indlæsning af brugere",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Tilføj opfølgning",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Titel",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Beskrivelse",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Kræv foto",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Forfaldsdato",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Opdater opfølgning",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Slet opfølgning?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Den vil blive fjernet og vil ikke blive tildelt.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Slet opfølgning",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Er du sikker på, du ønsker at slette denne opfølgning?\n\nDette kan ikke fortrydes.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Fortsæt til Opfølgninger",
    "mobile_mobileform_follow_up_actions_completed_notification": "Opfølgningshandling afsluttet",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Opfølgningshandling slettet",
    "mobile_mobileform_follow_up_actions_update_notification": "Opfølgningshandling opdateret",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Tilføj et foto for at afslutte denne opfølgningshandling",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Gå til indsendelse.",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Gå til kilde",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Kilde",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Afslut opfølgning",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Hvis du åbner indsendelsen, vil alle ikke-gemte billeder og noter gå tabt.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Hvis du forlader denne skærm, går alle ikke-gemte fotos og noter tabt.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Bliv her",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Åbn indsendelse",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Open source",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Vil du forlade denne opfølgningshandling?",
    "mobile_mobileform_follow_up_actions_submission": "Indsendelse",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Denne opfølgningshandling er tildelt {{user}}.<br />Du kan ikke afslutte den.",
    "mobile_mobileform_follow_up_actions_leave_description": "Hvis du forlader denne skærm, går eventuelle ikke-gemte ændringer tabt.",
    "mobile_mobileform_follow_up_actions_leave": "Forlad",
    "mobile_forms_drafts_text": "Fjern udkast",
    "mobile_batch_estimate_user": "Bruger",
    "mobile_batch_estimate_users": "Brugere",
    "mobile_table_of_contents": "Indholdsoversigt",
    "mobile_table_of_contents_required": "Påkrævet",
    "mobile_table_of_contents_optional": "Valgfrit",
    "mobile_dialog_alert_title": "Advarsel",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth-enheder er ikke understøttet på Windows endnu",
    "mobile_windows_deprecated_message_content_announcement": "Annoncering",
    "mobile_windows_deprecated_message_title": "Opdatering af app påkrævet",
    "mobile_windows_deprecated_message_description": "Installer den nye Zenput-app i Microsoft Store hurtigst muligt for at sikre vigtige funktionsopdateringer og en optimal Zenput-oplevelse.",
    "mobile_dashboard_tcr_graph_name": "Afslutningsrate for opgaver",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Seneste 4 uger",
    "mobile_dashboard_tcr_legend_company_average": "Firmagennemsnit",
    "mobile_dashboard_tcr_legend_team_average": "Teamgennemsnit",
    "mobile_dashboard_tab_title_summary": "Opsummering",
    "mobile_dashboard_tab_title_activity": "Aktivitet",
    "mobile_dashboard_card_title_top_triggered_workflows": "Mest sete",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Overholdelse",
    "mobile_dashboard_card_task_stats_total": "I alt",
    "mobile_dashboard_top_item_header_week_of": "Uge (the preposition cannot be translated without further information)",
    "mobile_dashboard_card_filter_form_template_placeholder": "Alle formularer",
    "mobile_dashboard_card_title_forms_top_nos": "Hyppige afslag",
    "mobile_dashboard_zenput_code_no_data_in_range": "Der er ingen data inden for denne periode.",
    "mobile_dashboard_zenput_code_permission_denied": "Du har ikke adgang til at se dette.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Vælg en formular ovenfor.",
    "mobile_dashboard_zenput_code_unknown_error": "Vi kan ikke vise dataene på nuværende tidspunkt.",
    "mobile_dashboard_tap_to_retry": "Klik for at prøve igen",
    "mobile_dashboard_reporting_delay_disclaimer": "Det kan tage op til 15 minutter at opdatere opgaver",
    "mobile_dashboard_configuration_down_state_postfix_msg": "er blevet konfigureret af din administrator.",
    "mobile_tasks_tag": "opgaver",
    "mobile_workflows_tag": "triggere",
    "mobile_projects_tag": "tilbagevendende projekter",
    "mobile_forms_tag": "formularer",
    "mobile_dashboard_card_ongoing_projects_title": "Projekter i gang",
    "mobile_dashboard_card_ongoing_projects_show_more": "Vis mere",
    "mobile_dashboard_card_ongoing_projects_show_less": "Vis mindre",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Gå Til projekter",
    "mobile_dashboard_card_title_recurring_projects": "Tilbagevende projekter",
    "mobile_dashboard_card_filter_daily": "Daglig",
    "mobile_dashboard_card_filter_weekly": "Ugentlig",
    "mobile_dashboard_card_filter_monthly": "Månedlig",
    "mobile_task_status_title_open": "Åben",
    "mobile_task_status_title_upcoming": "Kommende",
    "mobile_task_status_title_complete": "Afslut",
    "mobile_task_status_title_processing": "Behandling af fremsendelse",
    "mobile_task_status_title_complete_with_exceptions": "Afslut med opfølgende opgaver eller advarsler",
    "mobile_task_status_title_completed_late_with_exceptions": "Afsluttet for sent med opfølgningsopgaver eller advarsler",
    "mobile_task_status_title_incomplete_and_closed": "Ikke nået",
    "mobile_tasks_legend_modal_title": "Figurtekst",
    "mobile_tasks_legend_modal_footer_button_title": "Luk",
    "mobile_common_assigned_to": "Tildelt",
    "mobile_common_created_by": "Oprettet af",
    "mobile_common_tasks_for": "Opgaver til",
    "mobile_common_go_back": "Gå tilbage",
    "mobile_oh_no": "Åh, Nej!",
    "mobile_user_not_in_groups": "Beklager, det ser ud som om, du ikke er medlem af et team. Kontakt din administrator for at få adgang til dit dashboard.",
    "mobile_tasks_select_followers": "Vælg følgere",
    "mobile_tasks_assign_tasks": "Tildel {{count}} opgaver",
    "mobile_tasks_add_followers": "Tilføj følgere",
    "mobile_tasks_followers": "Følgere",
    "mobile_tasks_delete_task": "Slet opgave",
    "mobile_tasks_create_task": "Opret opgaver",
    "mobile_tasks_tab_title_comments": "Kommentarer",
    "mobile_tasks_see_more": "Se mere",
    "mobile_projects_create_project": "Opret projekt",
    "mobile_common_button_send": "Send",
    "mobile_common_button_schedule": "Planlæg",
    "mobile_announcements_create": "Opret bekendtgørelse",
    "mobile_announcements_read_rate": "{{opened_count}} af {{recipients_count}} åbnet",
    "mobile_announcements_empty_message": "Du har endnu ikke oprettet bekendtgørelser! Opret en bekendtgørelse herunder for at udsende vigtige nyheder, oplysninger og opdateringer til din organisation.",
    "mobile_announcement_message_placeholder": "Tilføj en meddelelse ...",
    "mobile_announcement_title_placeholder": "Titel på bekendtgørelse",
    "mobile_announcement_leaving_announcement": "Forlader bekendtgørelse",
    "mobile_announcement_confirm_recipients_team": "Vil du udsende denne bekendtgørelse til {{count}} bruger(e) i {{teams}} valgt(e) team(s)?",
    "mobile_announcement_confirm_recipients_role": "Vil du udsende denne bekendtgørelse til {{count}} bruger(e) i {{roles}} valgt(e) brugerrolle(r)?",
    "mobile_announcement_confirm_recipients_user": "Vil du udsende denne bekendtgørelse til {{count}} bruger(e)",
    "mobile_announcement_confirm_scheduled": "Pr. {{timestamp}}",
    "mobile_announcement_sending_announcement": "Sender bekendtgørelse",
    "mobile_announcement_send_to": "Send til",
    "mobile_announcement_sent_to": "Sendt til",
    "mobile_announcement_send_to_role": "Rolle",
    "mobile_announcement_attachment_download": "Downloader {{filename}}",
    "mobile_announcement_attachment_validation_error": "Der kan ikke tilføjes mere end {{maxCount}} vedhæftninger",
    "mobile_announcement_details_sent": "Sendt",
    "mobile_announcement_details_total_recipients": "Samlet antal modtagere",
    "mobile_announcement_details_cancel": "Annuller bekendtgørelse",
    "mobile_announcement_details_not_editable": "Meddelelser kan kun redigeres i Ops Execution-webappen ",
    "mobile_announcement_details_not_editable_old": "Bekendtgørelser kan kun redigeres på Zenput Web",
    "mobile_announcement_details_open_count": "Antal åbnet",
    "mobile_announcement_details_open_rate": "Andel åbnet",
    "mobile_announcement_details_resend": "Send igen til personer, som ikke har åbnet",
    "mobile_announcement_confirm_resend": "{{count}} bruger(e) har ikke læst bekendtgørelsen. Vil du sende en påmindelse?",
    "mobile_announcement_confirm_resend_title": "Send påmindelse?",
    "mobile_announcement_recipients_opened": "Åbnet",
    "mobile_recipients_opened_empty_message": "Det ser ud til, at ingen har åbnet din meddelelse endnu. Vend tilbage senere for at se resultatet.",
    "mobile_announcement_recipients_unopened": "Uåbnet",
    "mobile_recipients_unopened_empty_message": "Godt nyt! Der er ingen uåbnede meddelelser!",
    "mobile_scheduled_announcements_delivery_section_header": "Leveringstid",
    "mobile_scheduled_announcements_send_immediately_label": "Send omgående",
    "mobile_scheduled_announcements_scheduled_label": "Send på et bestemt tidspunkt",
    "mobile_scheduled_announcements_scheduled_tab_label": "Planlagt",
    "mobile_scheduled_announcements_dialog_header": "Annuller bekendtgørelse?",
    "mobile_scheduled_announcements_dialog_message": "Annullering af din bekendtgørelse vil forhindre den i at blive sendt og slette den fra din liste. Dette kan ikke fortrydes. Du kan redigere via Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Du har øjeblikket ingen planlagte bekendtgørelser. Planlæg en bekendtgørelse for at udsende vigtige nyheder, oplysninger og opdateringer til din organisation.",
    "mobile_scheduled_announcements_validation_error": "Leveringstiden skal være efter {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Planlæg bekendtgørelse",
    "mobile_projects_auto_archive": "Auto-arkivér",
    "mobile_common_unassigned": "Ikke tildelt",
    "mobile_tasks_title_placeholder": "Ny opgave eller formular",
    "mobile_projects_leaving_project": "Forlader projekt",
    "mobile_projects_save_project": "Gem projekt",
    "mobile_top_triggers_tasks": "Mest sete opgaver",
    "mobile_top_triggers_alerts": "Mest sete advarsler",
    "mobile_projects_not_started": "Ikke påbegyndt",
    "mobile_empty_list_message_no_photos": "Ingen fotos",
    "mobile_webfilestore_message_error": "Vælg venligst en gyldig filtype",
    "mobile_notifications_empty_title": "Ingen meddelelser",
    "mobile_notifications_empty_message": "Aktivitet omkring dine opgaver eller dem, du er en del af vises her.",
    "mobile_comments_comment_deleted": "Denne kommentar er blevet slettet.",
    "mobile_comments_comment_placeholder": "Kommentar",
    "mobile_comments_task_submitted_at": "Opgave sendt pr. {{ date }} kl. {{ time }}",
    "mobile_comments_discard_comment_title": "Kassér kommentar?",
    "mobile_comments_discard_confirm_message": "Er du sikker? Din kommentar vil blive slettet.",
    "mobile_comments_delete_comment_title": "Slet kommentar?",
    "mobile_comments_delete_confirm_message": "Dette kan ikke laves om.",
    "mobile_comments_delete_button": "Slet kommentar",
    "mobile_comments_delete_success_message": "Kommentar slettet",
    "mobile_comments_empty_message_tasks": "Der er ingen kommentarer endnu \n Start en samtale om denne opgave.",
    "mobile_comments_empty_message_submissions": "Der er ingen kommentarer endnu \n Start en samtale om denne indlevering.",
    "mobile_comments_empty_message_default": "Der er ingen kommentarer endnu \n Start en samtale.",
    "mobile_comments_no_matching_users": "Ingen brugere matcher",
    "mobile_comments_empty_users_to_notify": "Ingen brugere kunne identificeres",
    "mobile_comments_users_cant_view_message": "Disse brugere kan ikke se disse meddelelser",
    "mobile_comments_users_to_notify_title": "Brugere, der skal have besked",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} bruger</a> vil få besked.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} brugere</a> vil få besked.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> flere brugere for at give dem besked.",
    "mobile_comments_mark_read": "Markér alt som læst",
    "mobile_comments_author_mentioned_message": "nævnte dig i",
    "mobile_comments_author_commented_message": "kommenterede på",
    "mobile_view_pdf": "Vis PDF",
    "mobile_no_pdf_generated_message": "Der blev ikke fundet en PDF. Du vil modtage en kopi via e-mail snarest.",
    "mobile_clipboard_copied_success": "Linket er kopieret til din udklipsholder.",
    "mobile_share_link": "Del link",
    "mobile_zencam_share": "Del",
    "mobile_zencam_view_details": "Se detaljer",
    "mobile_zencam_details_drawer_header": "Detaljer",
    "mobile_zencam_submitted_by": "Indsendt af",
    "mobile_zencam_form_title": "Formulartitel",
    "mobile_zencam_date_submitted": "Indsendelsesdato",
    "mobile_oil_quality_warning_message": "Olie tæt på udløb",
    "mobile_oil_quality_warning_message_subtitle": "Du bør planlægge en snarlig udskiftning",
    "mobile_oil_quality_failure_message": "Oliekvalitet ikke tilfredsstillende",
    "mobile_oil_quality_failure_message_subtitle": "Skift olien omgående",
    "mobile_sensors_set_up_gateway": "Konfigurer gateway",
    "mobile_sensors_set_up_gateway_message": "Der ser ikke ud til at være konfigurerede enheder. Begynd med at tilføje en gateway.",
    "mobile_sensors_gateway_plugged_in": "Sørg for, at din gateway er forbundet til en stikkontakt.",
    "mobile_sensors_add_device": "Tilføj enhed",
    "mobile_sensors_name_this_gateway": "Navngiv denne gateway.",
    "mobile_sensors_name_this_sensor": "Navngiv denne sensor.",
    "mobile_sensors_device_barcode_information": "Scan QR-koden, eller indtast id- og SC-nummeret fra enhedsetiketten",
    "mobile_sensors_device_eui_information": "Scan QR-koden, eller indtast DevEUI fra enhedsetiketten",
    "mobile_sensors_gateway_id_information": "Indtast node-id'et fra gateway-etiketten",
    "mobile_sensors_id_number": "{{untranslatedID}} Nummer",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Kode",
    "mobile_sensors_sensors": "Sensorer",
    "mobile_sensors_sensor_deveui_error": "Kunne ikke få DevEUI fra QR. Indtast det venligst manuelt.",
    "mobile_sensors_gateways": "Gateways",
    "mobile_sensors_add_sensor": "Tilføj sensor",
    "mobile_sensors_add_gateway": "Tilføj gateway",
    "mobile_sensor_placement_description": "Hvilket område vil denne sensor overvåge?",
    "mobile_sensors_equipment_placement": "Hvilket område eller udstyr vil denne sensor overvåge?",
    "mobile_sensors_equipment": "Hvilket udstyr vil denne sensor overvåge?",
    "mobile_sensors_select_gateway_type": "Vælg typen af gateway",
    "mobile_sensors_select_placement": "Vælg placering",
    "mobile_sensors_select_equipment": "Vælg udstyr",
    "mobile_sensors_placement": "Placering",
    "mobile_sensors_nickname_tip": "Navn på sensor fastlægges ud fra det kaldenavn, der er valgt til det pågældende sted.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Scan QR-kode",
    "mobile_sensors_enter_manually": "Indtast manuelt",
    "mobile_sensors_wizard_step_one": "Trin 1",
    "mobile_sensors_wizard_step_two": "Trin 2",
    "mobile_sensors_wizard_step_three": "Trin 3",
    "mobile_sensors_wizard_step_four": "Trin 4",
    "mobile_sensors_wizard_step_five": "Trin 5",
    "mobile_sensors_wizard_step_six": "Trin 6",
    "mobile_sensors_initializing": "Initialiserer ...",
    "mobile_sensors_nickname": "Kaldenavn",
    "mobile_sensors_field_not_blank": "{{field}} må ikke være tom.",
    "mobile_sensors_nothing_to_see_here": "Der er intet at se her",
    "mobile_sensors_missing_integration": "Manglende sensorintegration",
    "mobile_sensors_contact_zenput_admin": "Kontakt din virksomheds Ops Execution-administrator.",
    "mobile_sensors_contact_zenput_admin_old": "Kontakt din Zenput-administrator.",
    "mobile_sensors_contact_manager": "Kontakt din account manager for at tilføje sensorer.",
    "mobile_sensors_device_success_message": "Sensordata kan tage op til 15 minutter at indlæse",
    "mobile_sensors_last_reading": "Seneste aflæsning",
    "mobile_sensors_remove_device": "Fjern enhed",
    "mobile_sensors_one_day": "1 d",
    "mobile_sensors_one_week": "1 u",
    "mobile_sensors_one_month": "1 m",
    "mobile_sensors_three_months": "3 m",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1 å",
    "mobile_sensors_sensor_settings": "Sensorindstillinger",
    "mobile_sensors_remove_confirm_message": "Er du sikker på, at du vil slette denne enhed?\nDet kan ikke fortrydes.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Intet udstyr tilknyttet",
    "mobile_sensor_cooldown_process": "Afkølingsproces",
    "mobile_sensor_last_12_hours": "Seneste 12 timer",
    "mobile_sensor_start_cooldown_process": "Start ny afkølingsproces",
    "mobile_sensor_cooldown_process_title": "To-trins afkølingsproces",
    "mobile_sensor_cooldown_process_description": "En to-trins nedkølingsproces består af afkøling af madvarer fra mere end {{ stage1_start_temperature }} til {{ stage1_end_temperature }} på to timer eller mindre og derefter fra {{ stage1_end_temperature }} til {{ stage2_end_temperature }} på fire timer eller mindre.",
    "mobile_sensor_cooldown_process_place_food": "Placer fødevareproduktet i køleskabet.",
    "mobile_sensor_cooldown_process_insert_sensor": "Indsæt en sensorprobe i fødevareproduktet.",
    "mobile_sensor_cooldown_process_enter_information": "Angiv oplysninger nedenfor.",
    "mobile_sensor_cooldown_process_food_product": "Fødevareprodukt, der skal afkøles",
    "mobile_sensor_cooldown_cool_down": "Afkøl",
    "mobile_sensor_cooldown_select_sensor": "Vælg sensor",
    "mobile_sensors_cooldown_start_cooldown": "Begynd afkøling",
    "mobile_sensors_cooldown_please_enter_food": "Angiv en fødevare",
    "mobile_sensors_cooldown_please_select_sensor": "Vælg en sensor",
    "mobile_sensors_cooldown_status_in_progress": "I gang",
    "mobile_sensors_cooldown_status_failed": "Mislykket",
    "mobile_sensors_cooldown_status_success": "Gennemført",
    "mobile_sensors_cooldown_stage": "Trin",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Starttemperaturen ligger uden for området",
    "mobile_sensors_cooldown_failed_cooldown_process": "Mislykket afkølingsproces",
    "mobile_sensors_cooldown_cooldown_successful": "Afkøling gennemført",
    "mobile_sensors_cooldown_started_cooldown_process": "Startet afkølingsproces",
    "mobile_sensors_cooldown_hour": "time",
    "mobile_sensors_cooldown_hour_plural": "timer",
    "mobile_sensors_cooldown_minute": "minut",
    "mobile_minutes_plural": "minutter",
    "mobile_sensors_last_reading_max_date": "> 1 år siden",
    "mobile_sensors_minute_count_ago": "{{count}} minut siden",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minutter siden",
    "mobile_sensors_hour_count_ago": "{{count}} time siden",
    "mobile_sensors_hour_count_ago_plural": "{{count}} timer siden",
    "mobile_sensors_day_count_ago": "{{count}} dag siden",
    "mobile_sensors_day_count_ago_plural": "{{count}} dage siden",
    "mobile_sensors_chart_settings": "Indstillinger for indkøbskurv",
    "mobile_announcement_banner_continue_reading": "Fortsæt med at læse",
    "mobile_compliance_submissions_report": "Indsendelsesrapport",
    "mobile_compliance_submissions_report_subtitle": "Eksportér data om projektgennemførsel for denne butik",
    "mobile_compliance_send_submissions": "Send indsendelser",
    "mobile_compliance_completion_rate_in_last_days": "Fuldførelsesrate for de seneste {{ days }} dage",
    "mobile_compliance_last_days": "Seneste {{ days }} dage",
    "mobile_compliance_send_submissions_to": "Send indsendelser til",
    "mobile_compliance_send_to_different_email": "Send til en anden e-mail",
    "mobile_compliance_email_input_placeholder": "E-mailadresse",
    "mobile_compliance_send_submissions_to_legend_title": "Indsendelser",
    "mobile_compliance_send_submissions_to_legend_description_days": "En rapport med dine indsendelser fra denne lokalitet for de seneste {{ days }} dage vil blive sendt til den valgte e-mail.",
    "mobile_compliance_time_frame": "Tidsramme",
    "mobile_compliance_sensor_temperature_log_report": "Lograpport over sensortemperatur",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Eksportér temperaturlogfiler for denne butik",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kriterium",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Definér kriteriet for din rapport nedenfor.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Bemærk: Deaktiveret/deaktiverede sensor(er) vil ikke blive vist i rapporten",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Vælg en tidsramme. Logdata er begrænset til maks. 30 dage",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Send rapport",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Denne måned (1. til i dag)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Sidste måned",
    "mobile_compliance_sensor_temperature_log_email_title": "Send rapport til",
    "mobile_pwa_update_prompt_title": "Opdater applikation",
    "mobile_pwa_update_prompt_description": "En ny version af applikationen er tilgængelig. Opdater til den seneste version.",
    "mobile_pwa_update_prompt_confirm": "Opdater, og genindlæs",
    "mobile_pwa_update_prompt_cancel": "Påmind mig senere",
    "notification_title_due_in_one_hour": "Forfalder om 1 time",
    "task_is_due_soon": "\"{{ task_title }}\" forfalder snart. Brug et øjeblik på at færdiggøre den.",
    "mobile_photo_quality_warning_header": "Problem med fotokvalitet",
    "mobile_photo_quality_dialog_message": "Dette billede er muligvis for mørkt eller sløret. Vil du tage et nyt billede, eller fortsætte med dette?",
    "mobile_take_new_photo": "Tage et nyt billede",
    "mobile_use_this_photo": "Navngiv dette billede"
}};
mobile_translations.de_DE = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Alle",
    "mobile_common_button_apply_filters": "Filter anwenden",
    "mobile_common_button_done": "Fertig",
    "mobile_common_button_edit": "Bearbeiten",
    "mobile_common_button_archive": "Archiv",
    "mobile_common_button_save": "Speichern",
    "mobile_common_button_retake": "Wiederholen",
    "mobile_common_button_save_draft": "Entwurf speichern",
    "mobile_common_button_discard": "Verwerfen",
    "mobile_common_button_submit": "Einreichen",
    "mobile_common_button_no": "Nein",
    "mobile_common_button_yes": "Ja",
    "mobile_common_button_na": "Nicht zutreffend",
    "mobile_common_created_by_me": "Von mir erstellt",
    "mobile_common_email": "E-Mail des Unternehmens",
    "mobile_common_first_name": "Vorname",
    "mobile_common_last_name": "Nachname",
    "mobile_common_location": "Standort",
    "mobile_common_locations": "Standorte",
    "mobile_common_logout_message": "Sind Sie sicher, dass Sie sich abmelden möchten?",
    "mobile_common_password": "Passwort",
    "mobile_common_permission_required": "Genehmigung erforderlich",
    "mobile_common_status": "Status",
    "mobile_common_task": "Aufgabe",
    "mobile_common_tasks": "Aufgaben",
    "mobile_common_tasks_my": "Meine Aufgaben",
    "mobile_common_projects": "Projekte",
    "mobile_common_filter_team": "Team",
    "mobile_common_filter_var_in": " in {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Kein Team ausgewählt",
    "mobile_common_filter_no_user_selected": "Kein Nutzer ausgewählt",
    "mobile_common_filter_no_role_selected": "Keine Rolle ausgewählt",
    "mobile_common_placeholder_date": "Datum",
    "mobile_common_message_task_creator_error_save": "<b>Aufgaben konnten nicht erstellt werden.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "für",
    "mobile_common_reload": "Erneut laden",
    "mobile_common_override": "Überschreiben",
    "mobile_common_notifications": "Benachrichtigungen",
    "mobile_common_chat_unavailable": "Der Chat steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.",
    "mobile_common_chat_ending_dialog_title": "Sind Sie fertig mit diesem Gespräch?",
    "mobile_common_chat_ending_dialog_description": "Bitte teilen Sie uns mit, ob Ihr Problem behoben wurde oder ob Sie später fortfahren möchten.",
    "mobile_common_chat_ending_dialog_confirm": "Ja, ich bin fertig",
    "mobile_common_chat_ending_dialog_cancel": "Ich fahre später fort",
    "mobile_common_continue_editing": "Weiter editieren",
    "mobile_privacy_policy": "Datenschutzrichtlinie",
    "wootric_recommend_target": "ein Freund oder Kollege aus Ihrer Branche",
    "wootric_followup_detractor_question": "Was könnten wir ändern, damit Sie uns das nächste Mal eine bessere Wertung geben?",
    "wootric_followup_passive_question": "Danke! Wie könnten wir das Tool eventuell sogar noch besser machen?",
    "wootric_followup_promoter_question": "Danke! Was gefällt dir an „Crunchtime Ops Execution“ besonders gut?",
    "wootric_followup_promoter_question_old": "Danke! Was gefällt Ihnen an Zenput besonders gut?",
    "wootric_default_followup_question": "Danke? Würden Sie uns verraten weshalb?",
    "wootric_default_placeholder_text": "Helfen Sie uns, indem Sie Ihre Wertung erläutern.",
    "wootric_default_thankyou_text": "Danke für Ihre Antwort und Ihr Feedback.",
    "mobile_login_placeholder_login_as": "Mit Benutzer-ID anmelden",
    "mobile_login_button_forgot_password": "Passwort vergessen?",
    "mobile_login_button_sign_up": "Konto erstellen",
    "mobile_login_button_finish_setup": "Einrichtung abschließen",
    "mobile_login_button": "Anmelden",
    "mobile_login_continue_button": "Fortfahren",
    "mobile_login_continue_transition": "Sie werden zur Anmeldeseite der Organisation weitergeleitet ...",
    "mobile_login_no_email_error": "Sie müssen eine E-Mail-Adresse eingeben.",
    "mobile_login_change_email": "Mit anderer E-Mail-Adresse anmelden",
    "mobile_login_with_sso": "Mit SSO anmelden",
    "mobile_oauth_no_user_error_message": "Es sieht so aus, als hättest du kein Crunchtime Ops Execution-Konto!",
    "mobile_oauth_no_user_error_message_old": "Anscheinend haben Sie kein Zenput-Konto!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> heißt jetzt <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} wird im September zu {{- product }}. {{- cta }}",
    "mobile_rebrand_warning_cta": "Erfahre, wie du dich vorbereiten kannst.",
    "mobile_oauth_no_user_error_sub_message": "Wenden Sie sich an Ihren Administrator, um Zugriff zu erhalten, oder versuchen Sie, sich mit einer anderen E-Mail-Adresse anzumelden.",
    "mobile_oauth_generic_error_message": "Anscheinend ist ein Problem beim Anmelden aufgetreten. Bitte versuchen Sie es erneut.",
    "mobile_oauth_force_logout_msg": "Wenn nach wie vor Probleme auftreten, melden Sie sich bitte bei Ihrem Anbieter ab, indem Sie ",
    "mobile_oauth_force_logout_click": "hier klicken.",
    "mobile_sign_up_placeholder_phone": "Handynummer",
    "mobile_sign_up_placeholder_password_confirm": "Passwort bestätigen",
    "mobile_sign_up_button_sign_in": "Registrieren",
    "mobile_sign_up_disclaimer_part_1": "Indem Sie „Konto einrichten“ auswählen, erklären Sie sich einverstanden mit den",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Indem Sie „Einrichtung abschließen“ auswählen, erklären Sie sich einverstanden mit den",
    "mobile_sign_up_disclaimer_link_title": " Lizenzvereinbarung",
    "mobile_sign_up_disclaimer_part_2": ", das wichtige private Informationen enthält",
    "mobile_dialog_benefits_work_offline": "Funktioniert offline",
    "mobile_dialog_benefits_faster_uploads": "Schnellere Uploads",
    "mobile_dialog_benefits_better_experience": "Besseres Erlebnis",
    "mobile_dialog_benefits_button_download": "Herunterladen",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution für ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput für ",
    "mobile_dialog_benefits_button_have": "Ich habe die App!",
    "mobile_dialog_benefits_button_no_thanks": "Nein, danke. Vielleicht später.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Bild konnte nicht geladen werden.",
    "mobile_dialog_signature_sign": "Hier unterzeichnen",
    "mobile_dialog_signature_button_clear": "Gelöscht",
    "mobile_account_placeholder_name": "Name des Standorts/Geschäfts",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Adresse",
    "mobile_account_placeholder_city": "Stadt",
    "mobile_account_placeholder_region": "Region",
    "mobile_account_placeholder_zipcode": "Postleitzahl",
    "mobile_account_option_select_country": "Land auswählen",
    "mobile_account_oprion_us": "USA",
    "mobile_account_oprion_select_state": "Staat auswählen",
    "mobile_account_button_create_location": "Standort erstellen",
    "mobile_form_message_no_form": "Keine Formulare verfügbar",
    "mobile_batch_task_message": "Wird geladen ...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Handynummer",
    "mobile_settings_profile_language": "Sprache",
    "mobile_settings_profile_temperature_unit": "Temperatureinheit",
    "mobile_settings_profile_use_company_default": "Unternehmensstandard verwenden",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Textnachricht",
    "mobile_settings_notifications_option_push": "Push-Benachrichtigungen",
    "mobile_settings_notifications_option_push_email": "E-Mail/Push-Benachrichtigungen",
    "mobile_settings_notifications_option_do_not": "Nicht benachrichtigen",
    "mobile_settings_notifications_category_communication": "Kommunikation",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulare & Trigger",
    "mobile_settings_devices": "Geräte",
    "mobile_settings_notifications_sub_category_alerts": "Warnungen",
    "mobile_settings_notifications_sub_category_new_forms_available": "Neue Formulare verfügbar",
    "mobile_settings_notifications_sub_category_task_assigned": "Aufgabe zugewiesen",
    "mobile_settings_notifications_sub_category_task_completed": "Aufgabe abgeschlossen",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Erinnerung: Aufgabe ist bald fällig",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Erinnerung: überfällige Aufgaben",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Sensor-Warnungen",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Kritische Sensorwarnungen",
    "mobile_drafts_message": "Sie haben noch keine Entwürfe.",
    "mobile_drafts_button_delete": "Löschen",
    "mobile_tasks_filter_location_no": "Kein Standort ausgewählt",
    "mobile_tasks_filter_group_by": "Zusammenfassen nach",
    "mobile_tasks_filter_sort_by": "Sortieren nach",
    "mobile_tasks_filter_sorted_by": "Sortiert nach",
    "mobile_tasks_filter_due_time": "Fälligkeitszeit",
    "mobile_tasks_filter_open_time": "Offener Zeitpunkt",
    "mobile_tasks_bucket_due_next_24_hours": "Fällig in den nächsten 24 Stunden",
    "mobile_tasks_bucket_due_next_7_days": "Fällig in den nächsten 7 Tagen",
    "mobile_tasks_bucket_open_tasks": "Zusätzliche nicht erledigte {{type}}",
    "mobile_tasks_bucket_open_at": "Nicht erledigt: {{- date }} um {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Fällig am: {{- date }} um {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Verfügbar in 1 Minute",
    "mobile_tasks_bucket_available_in_one_hour": "Verfügbar in 1 Stunde",
    "mobile_tasks_bucket_available_in_one_day": "Verfügbar in 1 Tag",
    "mobile_tasks_bucket_available_in_one_week": "Verfügbar in 1 Woche",
    "mobile_tasks_bucket_available_in_one_month": "Verfügbar in 1 Monat",
    "mobile_tasks_bucket_available_in_one_year": "Verfügbar in 1 Jahr",
    "mobile_tasks_bucket_available_in_minutes": "Verfügbar in {{ minutes }} Minuten",
    "mobile_tasks_bucket_available_in_hours": "Verfügbar in {{ hours }} Stunden",
    "mobile_tasks_bucket_available_in_days": "Verfügbar in {{ days }} Tagen",
    "mobile_tasks_bucket_available_in_weeks": "Verfügbar in {{ weeks }} Wochen",
    "notification_task_due_in_minutes": "Fällig in {{ minutes }} Minuten",
    "mobile_tasks_bucket_available_in_months": "Verfügbar in {{ months }} Monaten",
    "mobile_tasks_bucket_available_in_years": "Verfügbar in {{ years }} Jahren",
    "mobile_tasks_follow_up": "Follow-Up-Aufgabe",
    "mobile_tasks_due_soon": "In Kürze fällig",
    "mobile_tasks_bucket_completed_today": "Heute abgeschlossen",
    "mobile_tasks_bucket_completed_this_week": "Diese Woche abgeschlossen",
    "mobile_tasks_bucket_completed_last_week": "Letzte Woche abgeschlossen",
    "mobile_tasks_bucket_missed_today": "Heute verpasst",
    "mobile_tasks_bucket_missed_this_week": "Diese Woche verpasst",
    "mobile_tasks_bucket_missed_last_week": "Letzte Woche verpasst",
    "mobile_tasks_bucket_no_location": "Kein Standort",
    "mobile_tasks_cannot_submit_missed": "Verpasste Aufgaben können nicht abgeschlossen werden",
    "mobile_tasks_cannot_submit_missed_after": "Verpasste Aufgaben können nach dem {{ date }} nicht mehr abgeschlossen werden",
    "mobile_tasks_cannot_submit_upcoming": "Diese Aufgabe hat noch nicht begonnen.",
    "mobile_tasks_cannot_submit_processing": "Diese Einreichung wird bearbeitet",
    "mobile_tasks_toolbarnav_header_no_due_date": "Kein Fälligkeitsdatum",
    "mobile_tasks_toolbarnav_header_overdue": "Überfällig",
    "mobile_tasks_toolbarnav_header_yesterday": "Gestern",
    "mobile_tasks_toolbarnav_header_today": "Heute",
    "mobile_tasks_toolbarnav_header_tomorrow": "Morgen",
    "mobile_tasks_toolbarnav_header_last_week": "Letzte Woche",
    "mobile_tasks_toolbarnav_header_this_week": "Diese Woche",
    "mobile_tasks_toolbarnav_header_next_week": "Nächste Woche",
    "mobile_tasks_toolbarnav_header_this_month": "Dieser Monat",
    "mobile_tasks_toolbarnav_header_next_year": "Nächstes Jahr",
    "mobile_tasks_toolbarnav_header_over_year": "Mehr als ein Jahr",
    "mobile_tasks_toolbarnav_title_edit_task": "Aufgabe bearbeiten",
    "mobile_task_placeholder_title": "Titel *",
    "mobile_task_placeholder_description": "Beschreibung (optional)",
    "mobile_task_button_single_task": "Einzelne Aufgabe",
    "mobile_task_button_project": "Projekt",
    "mobile_task_button_create": "Erstellen",
    "mobile_task_tab_basic": "Regulär",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formular",
    "mobile_task_details_description_message_please": "Bitte ausfüllen ",
    "mobile_task_details_description_message_below": "unten.",
    "mobile_task_details_description_message_instructions": "Für diese Aufgabe stehen keine Anweisungen zur Verfügung.",
    "mobile_task_details_reason_title": "Follow-up, ausgelöst durch",
    "mobile_task_detials_button_goto_form": "Zugriff auf das Formular",
    "mobile_task_detials_button_complete": " Aufgabe abgeschlossen",
    "mobile_task_detials_completed": "Abgeschlossen ",
    "mobile_task_detials_completed_by": "nach ",
    "mobile_task_detials_completed_on": "ein ",
    "mobile_task_details_view_form_submission": "Formulareinreichung anzeigen",
    "mobile_task_task_updated": "Aufgabe wurde aktualisiert",
    "mobile_task_task_archived": "Aufgabe wurde archiviert.",
    "mobile_task_task_deleted": "Aufgabe wurde gelöscht",
    "mobile_task_error_archiving_task": "Aufgabe konnte nicht archiviert werden.",
    "mobile_task_error_deleting_task": "Aufgabe konnte nicht gelöscht werden.",
    "mobile_task_error_updating_task": "Aufgabe konnte nicht aktualisiert werden.",
    "mobile_task_archive_task": "Aufgabe archivieren",
    "mobile_task_archive_task_confirm": "Sind Sie sicher, dass Sie diesen Entwurf archivieren möchten?\n\nArchivierte Aufgaben werden zu den Abschlussquoten hinzugerechnet und erscheinen in den Berichten.\n\nDies lässt sich nicht rückgängig machen. ",
    "mobile_task_delete_task_confirm": "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?\n\nGelöschte Aufgaben werden nicht zu den Abschlussquoten hinzugerechnet und erscheinen nicht in den Berichten.\n\nDies lässt sich nicht rückgängig machen. ",
    "mobile_task_edition_already_in_progress": "Diese Aufgabe hat eine anstehende Änderung. Ein weiteres Bearbeiten ist derzeit nicht möglich.",
    "mobile_projects_filter_type": "Art",
    "mobile_projects_filter_status": "Projektstatus",
    "mobile_projects_filter_project_type": "Projekttyp",
    "mobile_projects_due_date_required": "Fälligkeitsdatum erforderlich.",
    "mobile_projects_team_required": "Team erforderlich.",
    "mobile_projects_user_role_required": "Beauftragte/r erforderlich.",
    "mobile_projects_title_required": "Titel erforderlich.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Mehrere Aufgaben pro Tag",
    "mobile_project_tasks_complete": " Abgeschlossen",
    "mobile_project_tasks_remaining": " Verbleibend",
    "mobile_esitmate_message_tasks": "0 Aufgaben werden erstellt",
    "mobile_esitmate_message_criteria": "Obige Kriterien anpassen",
    "mobile_esitmate_message_created_for": "wird erstellt für",
    "mobile_left_menu_dashboard": "Dashboard",
    "mobile_left_menu_my_forms": "Meine Formulare",
    "mobile_left_menu_announcements": "Mitteilungen",
    "mobile_left_menu_my_submissions": "Meine Eingaben",
    "mobile_left_menu_drafts": "Entwürfe",
    "mobile_left_menu_pending_uploads": "Geplante Uploads",
    "mobile_left_menu_open": "In der App öffnen",
    "mobile_left_menu_settings": "Einstellungen",
    "mobile_left_menu_log_out": "Abmelden",
    "mobile_left_menu_debug": "Fehlerbehebung",
    "mobile_left_menu_support": "Support",
    "mobile_left_menu_documentation": "Dokumentation",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Notiz oder Überschrift",
    "mobile_field_option_select": "Auswählen",
    "mobile_field_text_placeholder_text": "Text",
    "mobile_field_email_placehoder_email": "E-Mail",
    "mobile_filed_number_placeholder_number": "Nummer",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Nicht verbunden",
    "mobile_field_sensor_offline_battery": "Sensor offline – Batterie",
    "mobile_field_video_button_add": "Video hinzufügen",
    "mobile_field_video_picker_dialog_title": "Video hinzufügen von",
    "mobile_field_video_button_change": "Video ändern",
    "mobile_field_image_button_add": "Bild hinzufügen",
    "mobile_field_image_low_quality_warning": "Einige Fotos sind möglicherweise zu dunkel oder unscharf. Überprüfen Sie die hervorgehobenen Fotos und ersetzen Sie sie gegebenenfalls",
    "mobile_field_image_picker_dialog_title": "Foto hinzufügen von",
    "mobile_field_image_picker_edit_failed": "Wir konnten das Bild nicht speichern. Bitte versuchen Sie es erneut.",
    "mobile_field_signature_button_add": "Unterschrift hinzufügen",
    "mobile_field_signature_button_change": "Unterschrift ändern",
    "mobile_field_account_select_location": "Standort auswählen",
    "mobile_field_account_prefill": "Formular mit den Daten aus dem letzten Besuch vorausfüllen?",
    "mobile_field_account_message_overwrite": "Dies wird alle von Ihnen bereits ausgefüllten Felder überschreiben.",
    "mobile_forms_task_on_behalf": "Es gibt eine zu erledigende Aufgabe an diesem Standort, die zugeordnet ist zu <b>{{user}}</b>. Möchten Sie diese Aufgabe abschließen?",
    "mobile_forms_complete_task": "Aufgabe abschließen?",
    "mobile_field_account_prefill_button_yes": "Ja, bitte vorausfüllen",
    "mobile_field_barcode_placeholder_scan": "Scannen oder Barcode eingeben",
    "mobile_field_sensor_qr_code_placeholder_scan": "Code scannen oder eingeben",
    "mobile_field_gateway_id_code_placeholder": "Knoten-ID eingeben",
    "mobile_field_scan_qr_or_enter_dev_eui": "QR-Code scannen oder DevEUI eingeben",
    "mobile_field_scan_qr_or_enter_id": "QR-Code scannen oder ID-Nummer eingeben",
    "mobile_field_scan_qr_or_enter_sc": "QR-Code scannen oder SC-Code eingeben",
    "mobile_field_barcode_select_date": "Datum auswählen ",
    "mobile_field_datetime_allow_time": "Zeit",
    "mobile_field_stopwatch_button_caption": "Stoppuhr",
    "mobile_field_stopwatch_common_start": "Start",
    "mobile_field_stopwatch_common_stop": "Stop",
    "mobile_field_stopwatch_common_reset": "Zurücksetzen",
    "mobile_field_stopwatch_stop_stopwatches": "Stoppuhren anhalten",
    "mobile_field_document_title": "Dokument hinzufügen",
    "mobile_field_document_message_delete": "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
    "mobile_field_document_alret_button_view": "Ansicht",
    "mobile_field_document_alert_error": "Beim Anhängen dieses Dokuments ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "mobile_field_document_alert_file_size_error": "Datei darf nicht größer als {{count}} MB sein.",
    "mobile_field_temperature_greater_range": "größer als {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "größer als oder gleich {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "kleiner als {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "kleiner als oder gleich {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "größer als oder gleich {{ min_temp_value }} °{{ temp_unit }} und kleiner als {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "größer als oder gleich {{ min_temp_value }} °{{ temp_unit }} und kleiner als oder gleich{{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " und ",
    "mobile_field_text_limit_error": "Maximale Zeichenbeschränkung von 8000 erreicht.",
    "mobile_forms_required_questions_complete": "Erforderliche abgeschlossen",
    "mobile_forms_required_remaining": "{{count}} Verbleibende Pflichtfelder",
    "mobile_forms_required_questions_back": "Zurück",
    "mobile_forms_required_questions_next": "Weiter",
    "mobile_forms_required_questions_skip": "Überspringen",
    "mobile_forms_leaving_form": "Formular verlassen",
    "mobile_message_reordering_confirm": "Möchten Sie die neue Anordnung der Fragen speichern?",
    "mobile_forms_leaving_reordering": "Neuanordnung der Fragen verlassen",
    "mobile_forms_reordering_button_save": "Neuanordnung der Fragen speichern",
    "mobile_forms_reordering_instructions": "Zum Neuanordnen von Fragen oder Abschnitten das Formularfeld klicken und an die gewünschte Stelle ziehen",
    "mobile_toolbarnav_title_my_setttings": "Meine Einstellungen",
    "mobile_toolbarnav_title_profile_settings": "Profileinstellungen",
    "mobile_toolbarnav_title_notification": "Benachrichtigungs-Einstellungen",
    "mobile_toolbarnav_title_form_history": "Formularverlauf",
    "mobile_toolbarnav_title_form_not_available": "Formular nicht verfügbar",
    "mobile_toolbarnav_title_add_location": "Standort hinzufügen",
    "mobile_toolbarnav_title_add_task_or_project": "Aufgabe oder Projekt hinzufügen",
    "mobile_toolbarnav_title_select_location": "Standort auswählen",
    "mobile_toolbarnav_title_select_project": "Projekt auswählen",
    "mobile_toolbarnav_title_select_tag": "Etikett auswählen",
    "mobile_toolbarnav_title_select_user": "Benutzer auswählen",
    "mobile_toolbarnav_title_select_template": "Vorlage auswählen",
    "mobile_toolbarnav_title_select_one": "Eine auswählen",
    "mobile_toolbarnav_title_select_multiple": "Eine oder mehrere auswählen",
    "mobile_toolbarnav_title_select_team": "Team auswählen",
    "mobile_toolbarnav_title_select_team_or_location": "Team oder Standort auswählen",
    "mobile_toolbarnav_title_filter_tasks": "Aufgaben filtern",
    "mobile_toolbarnav_title_filter_projects": "Projekte filtern",
    "mobile_toolbarnav_title_filter_project_tasks": "Projekt-Aufgaben filtern",
    "mobile_placeholder_search_bar": "Suche",
    "mobile_placeholder_user_select_role": "Aufgabenbereich des Benutzers auswählen",
    "mobile_placeholder_filter_by_team": "Nach Team filtern",
    "mobile_placeholder_assign_to_user_role": "Dem Aufgabenbereich des Benutzers zuordnen",
    "mobile_placeholder_select": "-- Auswählen --",
    "mobile_placeholder_account_location_name": "Name des Standorts",
    "mobile_placeholder_tag_filter_by": "Nach Standortmarkierung filtern",
    "mobile_placeholder_user_type": "Einem Benutzer zuordnen",
    "mobile_placeholder_acount_type_loading": "Laden ... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatur",
    "mobile_placeholder_blue_therm_connecting": "Wird mit Gerät verbunden ...",
    "mobile_placeholder_blue_therm_please_wait": "Bitte warten ...",
    "mobile_placeholder_blue_therm_tap": "Zum Lesen antippen.",
    "mobile_placeholder_blue_therm_not_connected": "Nicht verbunden.",
    "mobile_placeholder_testo_tap": "Gehalten ▼▲ gefolgt von ⬆",
    "mobile_message_error_create_task": "Sie müssen online sein, um Aufgaben hinzufügen zu können.",
    "mobile_message_error_fill_out_form": "Füllen Sie bitte das Formular aus.",
    "mobile_message_error_fill_require_fields": "Pflichtfelder ausfüllen.",
    "mobile_message_error_stop_stopwatch_before_submit": "Halten Sie Ihre Stoppuhr vor dem Einreichen an",
    "mobile_message_error_stopwatch_field_required": "Stoppuhr-Feld erforderlich",
    "mobile_message_error_stopwatch_field_running": "Stoppuhr-Feld läuft",
    "mobile_message_error_invalid_equipment_temperature": "Ungültige Temperatur der Geräte",
    "mobile_message_error_invalid_ingredient_temperature": "Ungültige Temperatur der Inhaltsstoffe",
    "mobile_message_error_location_attributes_unavailable": "Einige Fragen sind möglicherweise nicht abrufbar, verbinden Sie sich bitte mit dem Internet",
    "mobile_message_alert_running_stopwatches": "Sie haben laufende Stoppuhren.\n\nMöchten Sie diese löschen?",
    "mobile_message_blue_therm_error": "Verbindung mit Bluetooth-Gerät abgebrochen",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Der Zugriff auf den Standort ist erforderlich. Aktiviere ihn in deinen Android-Einstellungen.",
    "mobile_message_blue_therm_no_permission_android": "Der Zugriff auf „Geräte in der Nähe“ ist erforderlich. Aktiviere ihn in deinen Android-Einstellungen.",
    "mobile_message_blue_therm_error_code": "Verbindung fehlgeschlagen:",
    "mobile_message_blue_therm_error_bluetooth": "Bitte Bluetooth aktivieren.",
    "mobile_message_blue_therm_error_device": "Gerät nicht gefunden.",
    "mobile_message_blue_therm_error_try_again": "Bitte versuchen Sie es erneut",
    "mobile_message_blue_therm_success": "Bluetooth-Gerät verbunden!",
    "mobile_message_bluetooth_device_press_button_field": "Drücken Sie die Taste an Ihrem Gerät, um die Verbindung herzustellen.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Drücken Sie die Taste an Ihrem Gerät,<br />wenn es hier nicht angezeigt wird.",
    "mobile_bluetooth_scan": "Scannen",
    "mobile_bluetooth_scanning": "Scanvorgang läuft",
    "mobile_message_drafts_confirm": "Möchten Sie dies als Entwurf speichern?",
    "mobile_message_drafts_toast_saved": "Entwurf gespeichert.",
    "mobile_message_drafts_request_update": "Möchten Sie diesen Entwurf aktualisieren?",
    "mobile_message_drafts_form_confirm": "Sind Sie sicher, dass Sie diesen Entwurf löschen möchten?",
    "mobile_message_drafts_confirm_delete": "Entwurf löschen",
    "mobile_message_streams_error_switch": "Streams im Internet können nicht geändert werden",
    "mobile_message_settings_success_saved": "Einstellungen gespeichert",
    "mobile_message_settings_error": "Ein unbekannter Fehler ist aufgetreten. Versuchen Sie es später erneut.",
    "mobile_message_profile_settings_error_fields": "Korrigieren Sie bitte die hervorgehobenen Felder.",
    "mobile_message_media_perimission_denied": "Ihr ",
    "mobile_message_media_perimission_denied_device": "Gerätespeicher",
    "mobile_message_image_confirm_remove_image": "Sind Sie sicher, dass Sie dieses Foto löschen möchten?",
    "mobile_message_create_account_error_fields": "Füllen Sie bitte die hervorgehobenen Felder aus.",
    "mobile_message_create_account_success_location_created": "Standort erstellt",
    "mobile_message_task_error_get_location": "Standort konnte nicht ermittelt werden. Sortierung nach Datum.",
    "mobile_message_typehead_confirm_save_message": "Möchten Sie diese Auswahl speichern?",
    "mobile_message_typehead_confirm_save_title": "Speichern?",
    "mobile_message_task_creator_error_save_select_form": "Sie müssen ein Formular auswählen.",
    "mobile_message_task_creator_error_save_required_fields": "Füllen Sie bitte die Pflichtfelder aus.",
    "mobile_message_task_creator_error_save_batch_change": "Bitte Kriterien ändern, bis sie auf einen oder mehrere Benutzer zutreffen",
    "mobile_message_task_detials_error_not_assigned_to_you": "Diese Aufgabe wurde Ihnen nicht zugewiesen.<br />Sie können sie nicht erledigen.",
    "mobile_message_task_detials_error_assigned_to": "Diese Aufgabe wurde {{user}} zugewiesen.<br />Sie können Sie nicht erledigen.",
    "mobile_message_task_detials_confirm_title": "Aufgabe verlassen",
    "mobile_message_task_detials_confirm_save_task": "Aufgabe speichern",
    "mobile_message_task_detials_confirm_message": "Sind Sie sicher? Alle Änderungen gehen verloren.",
    "mobile_message_task_detials_error_view_account": "Kein Zugriff auf den Standort möglich.",
    "mobile_message_task_detials_error_submit_task": "Bitte Foto hinzufügen, um die Aufgabe abzuschließen.",
    "mobile_message_task_detials_error_submit_task_project": "Projekt kann nicht gespeichert werden. Bitte versuchen Sie es später erneut.",
    "mobile_message_task_detials_wait_submit_task_created": "Aufgaben werden erstellt.<br />Warten Sie bitte einige Minuten, bis die Aufgaben eingepflegt wurden.",
    "mobile_message_task_detials_error_submit_task_pending": "Fehler. Bitte versuchen Sie es später erneut.",
    "mobile_message_task_detials_success_task_complete": "Aufgabe abgeschlossen",
    "mobile_message_task_error_save_single_task": "Aufgabe kann nicht gespeichert werden. Bitte versuchen Sie es später erneut.",
    "mobile_message_task_success_save_single_task": "Aufgabe wurde erstellt.",
    "mobile_message_show_error_message": "Leider ist etwas schiefgegangen.",
    "mobile_message_show_success_message": "Fertig!",
    "mobile_message_show_offline_message": "Sie sind derzeit offline.",
    "mobile_message_show_permission_denied_message": "<b>Genehmigung erforderlich.</b> Bitte erteilen Sie Zenput eine Zugriffsberechtigung {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Genehmigung erforderlich.</b> Bitte erteilen Sie Zenput und Ihrem Browser eine Zugriffsberechtigung {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Upload läuft",
    "mobile_message_show_upload_in_progress_message": "Wird bereits hochgeladen",
    "mobile_message_show_form_id_error": "Kein Zugriff auf das ausgewählte Formular möglich.",
    "mobile_message_show_single_task_error": "Kein Zugriff auf die ausgewählte Aufgabe möglich.",
    "mobile_message_show_submissions_error": "Kein Zugriff auf den ausgewählten Eintrag möglich.",
    "mobile_message_show_submissions_access_denied": "Sie haben leider keinen Zugriff auf dieses Formular.",
    "mobile_message_send_data_success": "Daten hochgeladen ",
    "mobile_message_start_upload_success": "Upload abgeschlossen",
    "mobile_message_start_upload_error": "<b>Upload konnte nicht abgeschlossen werden.</b><br>Eintrag gespeichert. Bitte versuchen Sie es später erneut.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Update erhältlich",
    "mobile_message_store_upgrade_confirm_message_one": "Bitte aktualisiere die Ops Execution-App über die ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Bitte aktualisieren Sie Zenput von der ",
    "mobile_message_store_upgrade_confirm_message_two": " um die neuesten Funktionen und Fehlerbehebungen zu erhalten",
    "mobile_message_store_upgrade_confirm_now": "Jetzt",
    "mobile_message_store_upgrade_confirm_later": "Später",
    "mobile_message_redirect_confirm_message": "Sie füllen derzeit ein Formular aus. Möchten Sie dieses als Entwurf speichern, ehe Sie fortfahren?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Sie haben {{count}} Entwürfe, die noch nicht hochgeladen wurden. Wenn Sie fortfahren, gehen diese verloren. Sind Sie sicher?",
    "mobile_message_draft_override_message": "Dieser Entwurf wurde von einem anderen Gerät auf {{date}} gespeichert und die Änderungen auf diesem Gerät stehen in Konflikt hierzu. Sie können wählen, ob Sie die vorhandene Version überschreiben möchten oder die neueste Version erneut laden möchten, sodass Ihre Änderungen verworfen werden.",
    "mobile_html_submitting": "Wird eingereicht ...",
    "mobile_html_offline": "Sie sind derzeit offline.",
    "mobile_html_offline_try_again": "Sie sind derzeit offline. <br/><br/>Versuchen Sie es bitte erneut, wenn Sie verbunden sind.",
    "mobile_html_something_went_wrong": "Leider ist etwas schiefgegangen.",
    "mobile_html_something_went_wrong_try_again": "Leider ist etwas schiefgegangen. Versuchen Sie es bitte erneut.",
    "mobile_html_failed_loading_roles": "Aufgabenbereiche konnten nicht geladen werden.",
    "mobile_alert_please_install_for_native": "Bitte installiere die Ops Execution-App, um diese Funktion nutzen zu können. ",
    "mobile_alert_please_install_for_native_old": "Bitte installieren Sie die native Zenput-App, um diese Funktion zu nutzen.",
    "mobile_tso_filter_all_tasks": "Alle {{type}}",
    "mobile_tso_filter_my_tasks": "Meine {{type}}",
    "mobile_tso_filter_due_date": "Fälligkeitsdatum",
    "mobile_tso_filter_date_completed": "Datum abgeschlossen",
    "mobile_tso_filter_completed": "Abgeschlossen",
    "mobile_tso_filter_completed_late": "Verspätet abgeschlossen",
    "mobile_tso_filter_incomplete": "Unvollständig",
    "mobile_tso_filter_var_my_tasks": "Meine {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} Von mir erstellt",
    "mobile_tso_filter_var_all_tasks": "Alle {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Follow-up-Aktionen",
    "mobile_tso_type_all": "Aufgaben und Follow-up-Aktionen",
    "mobile_tso_filter_var_at": " um {{location}}",
    "mobile_tso_filter_group_date_due": ", sortiert nach Fälligkeitsdatum",
    "mobile_tso_filter_group_distance": ", zusammengefasst nach Standort",
    "mobile_tso_filter_start_date": "Startdatum",
    "mobile_tso_filter_none": "Nicht zutreffend",
    "mobile_pso_filter_all_projects": "Alle Projekte",
    "mobile_pso_filter_my_projects": "Meine Projekte",
    "mobile_pso_filter_active": "Aktiv",
    "mobile_pso_filter_archived": "Archiviert",
    "mobile_pso_filter_recurring": "Wiederkehrend",
    "mobile_pso_filter_non_recurring": "Nicht wiederkehrend",
    "mobile_pso_filter_var_my_projects": "Meine {{project_type}} {{active_description}} Projekte",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Von mir erstellte Projekte",
    "mobile_pso_filter_var_all_projects": "Alle {{project_type}} {{active_description}} Projekte",
    "mobile_empty_list_message_must_be_online": "Anscheinend sind Sie offline. Bitte gehen Sie online, um Ergebnisse zu sehen.",
    "mobile_empty_list_message_no_submissions": "Keine Einträge",
    "mobile_empty_list_message_no_activity": "Keine Aktivität",
    "mobile_empty_list_message_no_tasks": "Keine Aufgaben",
    "mobile_empty_list_message_no_tasks_overdue": "Keine überfälligen {{type}}",
    "mobile_empty_list_message_no_accounts": "Keine Standorte",
    "mobile_empty_list_message_no_projects": "Keine Projekte",
    "mobile_empty_list_message_no_results_found": "Keine Ergebnisse gefunden",
    "mobile_empty_list_message_no_forms_available": "Keine Formulare verfügbar",
    "mobile_empty_list_message_connection_error": "Verbindungsfehler.<br />Bitte versuchen Sie es erneut.",
    "mobile_empty_list_message_dashboard_error": "Dashboard konnte nicht geladen werden",
    "mobile_empty_list_message_user_offline": "Sie sind derzeit offline",
    "mobile_action_sheet_media_gallery": "Galerie",
    "mobile_action_sheet_cancel": "Abbrechen",
    "mobile_image_preview_text": "Foto entfernen",
    "mobile_mobileform_text": "Vorherige Einträge",
    "mobile_mobileform_reorder_fields": "Fragen neu anordnen",
    "mobile_mobileform_follow_up_actions": "Folgemaßnahmen",
    "mobile_mobileform_follow_up_actions_assign_title": "Follow-up-Aktionen zuweisen",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Fügen Sie auf der Grundlage Ihrer Beobachtungen Follow-up-Aktionen hinzu, um die Lösung der Probleme sicherzustellen.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Follow-up-Aktion hinzufügen",
    "mobile_mobileform_follow_up_actions_assign_button": "Follow-ups zuweisen",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Ohne Zuweisung fortfahren",
    "mobile_mobileform_follow_up_actions_dialog_title": "Ohne Zuweisung von Follow-up-Aktionen fortfahren?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Wenn Sie ohne Zuweisung von Follow-up-Aktionen fortfahren, können Sie diese später nicht mehr hinzufügen.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Trotzdem fortfahren",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Dieses Feld ist erforderlich",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Zu viele Zeichen",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Dieses Feld ist ungültig",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Fehler beim Laden von Standorten",
    "mobile_mobileform_add_follow_up_actions_error_users": "Fehler beim Laden von Benutzern",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Follow-up hinzufügen",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Titel",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Beschreibung",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Foto erforderlich",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Fälligkeitsdatum",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Follow-up aktualisieren",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Follow-up löschen",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Es wird entfernt und nicht zugewiesen.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Follow-up löschen",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Möchten Sie dieses Follow-up wirklich löschen?\n\nDieser Vorgang kann nicht rückgängig gemacht werden.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Weiter zu den Follow-ups",
    "mobile_mobileform_follow_up_actions_completed_notification": "Follow-up-Aktion abgeschlossen",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Follow-up-Aktion gelöscht",
    "mobile_mobileform_follow_up_actions_update_notification": "Follow-up-Aktion aktualisiert",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Bitte Foto hinzufügen, um diese Follow-up-Aktion abzuschließen",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Zur Einreichung navigieren",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Zur Quelle navigieren",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Quelle",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Follow-up abschließen",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Beim Öffnen der Einreichung gehen alle nicht gespeicherten Fotos und Notizen verloren.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Wenn du diesen Bildschirm verlässt, gehen alle nicht gespeicherten Fotos und Notizen verloren.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Hier bleiben",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Einreichung öffnen",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Open Source",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Diese Follow-up-Aktion beenden?",
    "mobile_mobileform_follow_up_actions_submission": "Einreichung",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Diese Follow-up-Aktion wurde {{user}} zugewiesen.<br />Sie können Sie nicht abschließen.",
    "mobile_mobileform_follow_up_actions_leave_description": "Wenn du diesen Bildschirm verlässt, gehen alle nicht gespeicherten Änderungen verloren.",
    "mobile_mobileform_follow_up_actions_leave": "Verlassen",
    "mobile_forms_drafts_text": "Entwürfe entfernen",
    "mobile_batch_estimate_user": "Benutzer",
    "mobile_batch_estimate_users": "Benutzer",
    "mobile_table_of_contents": "Inhaltsverzeichnis",
    "mobile_table_of_contents_required": "Erforderlich",
    "mobile_table_of_contents_optional": "Optional",
    "mobile_dialog_alert_title": "Warnung",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Bluetooth-Geräte werden unter Windows noch nicht unterstützt",
    "mobile_windows_deprecated_message_content_announcement": "Ankündigung",
    "mobile_windows_deprecated_message_title": "App-Update erforderlich",
    "mobile_windows_deprecated_message_description": "Installieren Sie die neue Zenput-App im Microsoft Store so schnell wie möglich, um wichtige Funktionen zu aktualisieren und ein optimales Zenput-Erlebnis sicherzustellen.",
    "mobile_dashboard_tcr_graph_name": "Anteil abgeschlossener Aufgaben",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Letzte 4 Wochen",
    "mobile_dashboard_tcr_legend_company_average": "Durchschnitt Unternehmen",
    "mobile_dashboard_tcr_legend_team_average": "Durchschnitt Team",
    "mobile_dashboard_tab_title_summary": "Zusammenfassung",
    "mobile_dashboard_tab_title_activity": "Aktivität",
    "mobile_dashboard_card_title_top_triggered_workflows": "Top-Trigger",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Konformität",
    "mobile_dashboard_card_task_stats_total": "Gesamt",
    "mobile_dashboard_top_item_header_week_of": "Woche vom",
    "mobile_dashboard_card_filter_form_template_placeholder": "Alle Formulare",
    "mobile_dashboard_card_title_forms_top_nos": "Häufige \"Neins\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "Keine Daten in diesem Zeitraum.",
    "mobile_dashboard_zenput_code_permission_denied": "Sie sind nicht dazu berechtigt, dies anzuzeigen.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Wählen Sie eines der obigen Formulare aus.",
    "mobile_dashboard_zenput_code_unknown_error": "Wir können die Daten derzeit nicht anzeigen.",
    "mobile_dashboard_tap_to_retry": "Antippen, um es erneut zu versuchen",
    "mobile_dashboard_reporting_delay_disclaimer": "Das Aktualisieren von Aufgaben kann bis zu 15 Minuten dauern",
    "mobile_dashboard_configuration_down_state_postfix_msg": "wurden von Ihrem Administrator konfiguriert.",
    "mobile_tasks_tag": "Aufgaben",
    "mobile_workflows_tag": "Trigger",
    "mobile_projects_tag": "wiederkehrende Projekte",
    "mobile_forms_tag": "Formulare",
    "mobile_dashboard_card_ongoing_projects_title": "Laufende Projekte",
    "mobile_dashboard_card_ongoing_projects_show_more": "Mehr anzeigen",
    "mobile_dashboard_card_ongoing_projects_show_less": "Weniger anzeigen",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Zu Projekten gehen",
    "mobile_dashboard_card_title_recurring_projects": "Wiederkehrende Projekte",
    "mobile_dashboard_card_filter_daily": "Täglich",
    "mobile_dashboard_card_filter_weekly": "Wöchentlich",
    "mobile_dashboard_card_filter_monthly": "Monatlich",
    "mobile_task_status_title_open": "Offen",
    "mobile_task_status_title_upcoming": "Anstehend",
    "mobile_task_status_title_complete": "Abgeschlossen",
    "mobile_task_status_title_processing": "Die Einreichung wird bearbeitet",
    "mobile_task_status_title_complete_with_exceptions": "Abgeschlossen mit Follow-up-Aufgaben oder Warnungen",
    "mobile_task_status_title_completed_late_with_exceptions": "Mit Folgeaufgaben oder Benachrichtigungen verspätet abgeschlossen",
    "mobile_task_status_title_incomplete_and_closed": "Verpasst ",
    "mobile_tasks_legend_modal_title": "Legende",
    "mobile_tasks_legend_modal_footer_button_title": "Schließen",
    "mobile_common_assigned_to": "Zugewiesen an",
    "mobile_common_created_by": "Erstellt von",
    "mobile_common_tasks_for": "Aufgaben für",
    "mobile_common_go_back": "Zurück",
    "mobile_oh_no": "Oh nein!",
    "mobile_user_not_in_groups": "Anscheinend wurden Sie keinem Team zugeordnet. Wenden Sie sich an Ihren Administrator, um Zugriff auf Ihr Dashboard zu erhalten.",
    "mobile_tasks_select_followers": "Follower auswählen",
    "mobile_tasks_assign_tasks": "{{count}} Aufgaben zuordnen",
    "mobile_tasks_add_followers": "Follower hinzufügen",
    "mobile_tasks_followers": "Follower",
    "mobile_tasks_delete_task": "Aufgabe löschen",
    "mobile_tasks_create_task": "Aufgaben erstellen",
    "mobile_tasks_tab_title_comments": "Kommentare",
    "mobile_tasks_see_more": "Mehr anzeigen",
    "mobile_projects_create_project": "Projekt erstellen",
    "mobile_common_button_send": "Senden",
    "mobile_common_button_schedule": "Plan",
    "mobile_announcements_create": "Mitteilung erstellen",
    "mobile_announcements_read_rate": "{{opened_count}} of {{recipients_count}} geöffnet",
    "mobile_announcements_empty_message": "Sie haben noch keine Mitteilungen erstellt! Erstellen Sie unten eine Mitteilung, um wichtige Nachrichten, Informationen und Aktualisierungen an Ihre Organisation zu senden.",
    "mobile_announcement_message_placeholder": "Nachricht hinzufügen ...",
    "mobile_announcement_title_placeholder": "Titel der Mitteilung",
    "mobile_announcement_leaving_announcement": "Mitteilung verlassen",
    "mobile_announcement_confirm_recipients_team": "Möchten Sie diese Mitteilung an {{count}} Nutzer in {{teams}} ausgewählten Teams senden?",
    "mobile_announcement_confirm_recipients_role": "Möchten Sie diese Mitteilung an {{count}} Nutzer in {{roles}} ausgewählten Rollen senden?",
    "mobile_announcement_confirm_recipients_user": "Möchten Sie diese Mitteilung an {{count}} Nutzer senden?",
    "mobile_announcement_confirm_scheduled": "Am {{timestamp}}",
    "mobile_announcement_sending_announcement": "Mitteilung wird gesendet",
    "mobile_announcement_send_to": "Senden an",
    "mobile_announcement_sent_to": "Gesendet an",
    "mobile_announcement_send_to_role": "Rolle",
    "mobile_announcement_attachment_download": "{{filename}} herunterladen",
    "mobile_announcement_attachment_validation_error": "Es können nicht mehr als {{maxCount}}Anhänge beigefügt werden",
    "mobile_announcement_details_sent": "Gesendet",
    "mobile_announcement_details_total_recipients": "Empfänger insgesamt",
    "mobile_announcement_details_cancel": "Mitteilung stornieren",
    "mobile_announcement_details_not_editable": "Ankündigungen können nur in der Ops Execution-Web-App bearbeitet werden ",
    "mobile_announcement_details_not_editable_old": "Mitteilungen können nur auf Zenput Web bearbeitet werden",
    "mobile_announcement_details_open_count": "Offene Anzahl",
    "mobile_announcement_details_open_rate": "Offene Quote",
    "mobile_announcement_details_resend": "An nicht-öffnende erneut senden",
    "mobile_announcement_confirm_resend": "{{count}} Nutzer hat/haben die Mitteilung nicht gelesen. Möchten Sie eine Erinnerung senden?",
    "mobile_announcement_confirm_resend_title": "Erinnerung senden?",
    "mobile_announcement_recipients_opened": "Geöffnet",
    "mobile_recipients_opened_empty_message": "Scheinbar hat noch niemand Ihre Nachricht geöffnet. Kommen Sie später wieder, um Ihre Ergebnisse einzusehen.",
    "mobile_announcement_recipients_unopened": "Ungeöffnet",
    "mobile_recipients_unopened_empty_message": "Gute Neuigkeiten! Sie haben keine ungeöffneten Nachrichten!",
    "mobile_scheduled_announcements_delivery_section_header": "Zustellungszeit",
    "mobile_scheduled_announcements_send_immediately_label": "Sofort senden",
    "mobile_scheduled_announcements_scheduled_label": "Zu einem bestimmten Zeitpunkt senden",
    "mobile_scheduled_announcements_scheduled_tab_label": "Geplant",
    "mobile_scheduled_announcements_dialog_header": "Mitteilung stornieren?",
    "mobile_scheduled_announcements_dialog_message": "Wenn Sie Ihre Mitteilung stornieren, wird sie nicht mehr gesendet und aus Ihrer Liste gelöscht. Dies kann nicht rückgängig gemacht werden. Zum Bearbeiten gehen Sie zu Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Sie haben derzeit keine geplanten Mitteilungen! Planen Sie eine Mitteilung, um wichtige Nachrichten, Informationen und Aktualisierungen an Ihre Organisation zu senden.",
    "mobile_scheduled_announcements_validation_error": "Zustellungszeit muss nach {{date}} sein",
    "mobile_scheduled_announcements_empty_state_button": "Mitteilung planen",
    "mobile_projects_auto_archive": "Automatisch archivieren",
    "mobile_common_unassigned": "Nicht zugeordnet",
    "mobile_tasks_title_placeholder": "Neue Aufgabe oder Formular",
    "mobile_projects_leaving_project": "Projekt verlassen",
    "mobile_projects_save_project": "Projekt speichern",
    "mobile_top_triggers_tasks": "Ausgelöste Top-Aufgaben",
    "mobile_top_triggers_alerts": "Ausgelöste Top-Warnungen",
    "mobile_projects_not_started": "Nicht Gestartet",
    "mobile_empty_list_message_no_photos": "Keine Fotos",
    "mobile_webfilestore_message_error": "Bitte wählen Sie einen gültigen Dateityp aus",
    "mobile_notifications_empty_title": "Keine Benachrichtigungen",
    "mobile_notifications_empty_message": "Aktivität für Ihre Aufgaben oder solche, an denen Sie beteiligt sind, erscheint hier.",
    "mobile_comments_comment_deleted": "Dieser Kommentar wurde gelöscht.",
    "mobile_comments_comment_placeholder": "Kommentar",
    "mobile_comments_task_submitted_at": "Aufgabe um {{ date }} am {{ time }} eingereicht",
    "mobile_comments_discard_comment_title": "Kommentar verwerfen?",
    "mobile_comments_discard_confirm_message": "Sind Sie sicher? Ihr Kommentar wird gelöscht.",
    "mobile_comments_delete_comment_title": "Kommentare löschen?",
    "mobile_comments_delete_confirm_message": "Dies kann nicht rückgängig gemacht werden.",
    "mobile_comments_delete_button": "Kommentar löschen",
    "mobile_comments_delete_success_message": "Kommentar gelöscht",
    "mobile_comments_empty_message_tasks": "Es sind noch keine Kommentare vorhanden \n Unterhaltung über diese Aufgabe starten.",
    "mobile_comments_empty_message_submissions": "Es sind noch keine Kommentare vorhanden \n Unterhaltung über diese Aufgabe starten.",
    "mobile_comments_empty_message_default": "Es sind noch keine Kommentare vorhanden \n Unterhaltung über diese Aufgabe starten.",
    "mobile_comments_no_matching_users": "Keine übereinstimmenden Nutzer.",
    "mobile_comments_empty_users_to_notify": "Es müssen keine Nutzer benachrichtigt werden.",
    "mobile_comments_users_cant_view_message": "Diese Nutzer können diese Kommentare nicht sehen",
    "mobile_comments_users_to_notify_title": "Zu benachrichtigende Nutzer",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }}Nutzer</a> wird benachrichtigt.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }}Nutzer</a> werden benachrichtigt.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a>weitere zu benachrichtigende Nutzer.",
    "mobile_comments_mark_read": "Alle als gelesen markieren",
    "mobile_comments_author_mentioned_message": "hat Sie erwähnt in",
    "mobile_comments_author_commented_message": "hat (...) kommentiert",
    "mobile_view_pdf": "PDF ansehen",
    "mobile_no_pdf_generated_message": "Für diesen Eintrag wurde keine PDF gefunden. Eine Kopie wird Ihnen in Kürze per E-Mail geschickt.",
    "mobile_clipboard_copied_success": "Der Link wurde in Ihre Zwischenablage kopiert.",
    "mobile_share_link": "Link teilen",
    "mobile_zencam_share": "Teilen",
    "mobile_zencam_view_details": "Details anzeigen",
    "mobile_zencam_details_drawer_header": "Details",
    "mobile_zencam_submitted_by": "Eingereicht von",
    "mobile_zencam_form_title": "Formulartitel",
    "mobile_zencam_date_submitted": "Datum der Einreichung",
    "mobile_oil_quality_warning_message": "Öl fast abgelaufen",
    "mobile_oil_quality_warning_message_subtitle": "Planen Sie einen baldigen Ölwechsel",
    "mobile_oil_quality_failure_message": "Ölqualität beeinträchtigt",
    "mobile_oil_quality_failure_message_subtitle": "Wechseln Sie umgehend das Öl",
    "mobile_sensors_set_up_gateway": "Zugang einrichten",
    "mobile_sensors_set_up_gateway_message": "Scheinbar sind keine Geräte eingerichtet. Beginnen Sie, indem Sie einen Zugang hinzufügen.",
    "mobile_sensors_gateway_plugged_in": "Stellen Sie sicher, dass Ihr Zugang mit Strom versorgt wird",
    "mobile_sensors_add_device": "Gerät hinzufügen",
    "mobile_sensors_name_this_gateway": "Zugang benennen.",
    "mobile_sensors_name_this_sensor": "Sensor benennen.",
    "mobile_sensors_device_barcode_information": "QR-Code scannen oder ID- und SC-Nummer vom Etikett des Geräts eingeben",
    "mobile_sensors_device_eui_information": "QR-Code scannen oder DevEUI vom Etikett des Geräts eingeben",
    "mobile_sensors_gateway_id_information": "Geben Sie die Knoten-ID vom Gateway-Etikett ein",
    "mobile_sensors_id_number": "{{untranslatedID}} Nummer",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Code",
    "mobile_sensors_sensors": "Sensoren",
    "mobile_sensors_sensor_deveui_error": "DevEUI konnte nicht aus dem QR-Code abgerufen werden. Bitte geben Sie ihn manuell ein.",
    "mobile_sensors_gateways": "Zugänge",
    "mobile_sensors_add_sensor": "Sensor hinzufügen",
    "mobile_sensors_add_gateway": "Zugang hinzufügen",
    "mobile_sensor_placement_description": "Welchen Bereich überwacht dieser Sensor?",
    "mobile_sensors_equipment_placement": "Welchen Bereich oder welche Gerätschaften wird dieser Sensor überwachen?",
    "mobile_sensors_equipment": "Welche Geräte überwacht dieser Sensor?",
    "mobile_sensors_select_gateway_type": "Wählen Sie den Gateway-Typ aus",
    "mobile_sensors_select_placement": "Platzierung auswählen",
    "mobile_sensors_select_equipment": "Wählen Sie die Geräte aus",
    "mobile_sensors_placement": "Platzierung",
    "mobile_sensors_nickname_tip": "Die Benennung der Sensoren erfolgt anhand der Nicknames, die bei der ausgewählten Platzierung vergeben wurden.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "QR-Code scannen",
    "mobile_sensors_enter_manually": "Manuell eingeben",
    "mobile_sensors_wizard_step_one": "Schritt 1",
    "mobile_sensors_wizard_step_two": "Schritt 2",
    "mobile_sensors_wizard_step_three": "Schritt 3",
    "mobile_sensors_wizard_step_four": "Schritt 4",
    "mobile_sensors_wizard_step_five": "Schritt 5",
    "mobile_sensors_wizard_step_six": "Schritt 6",
    "mobile_sensors_initializing": "Wird vorbereitet ...",
    "mobile_sensors_nickname": "Spitzname",
    "mobile_sensors_field_not_blank": "Das {{field}} darf nicht leer sein.",
    "mobile_sensors_nothing_to_see_here": "Hier gibt es nichts zu sehen",
    "mobile_sensors_missing_integration": "Fehlende Sensorintegration",
    "mobile_sensors_contact_zenput_admin": "Bitte wende dich an den Ops Execution-Administrator deines Unternehmens.",
    "mobile_sensors_contact_zenput_admin_old": "Bitte kontaktieren Sie Ihren Zenput-Administrator.",
    "mobile_sensors_contact_manager": "Kontaktieren Sie Ihren Kontomanager, um Sensoren hinzuzufügen.",
    "mobile_sensors_device_success_message": "Das Laden der Sensordaten kann bis zu 15 Minuten dauern",
    "mobile_sensors_last_reading": "Letzte Woche",
    "mobile_sensors_remove_device": "Gerät entfernen",
    "mobile_sensors_one_day": "1T",
    "mobile_sensors_one_week": "1W",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1J",
    "mobile_sensors_sensor_settings": "Sensor-Einstellungen",
    "mobile_sensors_remove_confirm_message": "Sind Sie sicher, dass Sie dieses Gerät löschen möchten?\nDies lässt sich nicht rückgängig machen.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Keine verknüpften Geräte",
    "mobile_sensor_cooldown_process": "Abkühlungsvorgang",
    "mobile_sensor_last_12_hours": "Letzte 12 Stunden",
    "mobile_sensor_start_cooldown_process": "Neuen Abkühlungsvorgang starten",
    "mobile_sensor_cooldown_process_title": "Neuen Abkühlungsvorgang starten",
    "mobile_sensor_cooldown_process_description": "Bei einer zweistufigen Abkühlung werden Lebensmittel in zwei Stunden oder weniger von mehr als {{ stage1_start_temperature }} auf {{ stage1_end_temperature }} und dann in vier Stunden oder weniger von {{ stage1_end_temperature }} auf {{ stage2_end_temperature }} abgekühlt.",
    "mobile_sensor_cooldown_process_place_food": "Legen Sie das Lebensmittel ins Kühlfach.",
    "mobile_sensor_cooldown_process_insert_sensor": "Führen Sie eine Sensorsonde in das Lebensmittel ein.",
    "mobile_sensor_cooldown_process_enter_information": "Geben Sie die Informationen unten ein.",
    "mobile_sensor_cooldown_process_food_product": "Lebensmittel zum Abkühlen",
    "mobile_sensor_cooldown_cool_down": "Abkühlung",
    "mobile_sensor_cooldown_select_sensor": "Sensor auswählen",
    "mobile_sensors_cooldown_start_cooldown": "Abkühlung starten",
    "mobile_sensors_cooldown_please_enter_food": "Bitte geben Sie ein Nahrungsmittelprodukt ein",
    "mobile_sensors_cooldown_please_select_sensor": "Bitte wählen Sie einen Sensor aus",
    "mobile_sensors_cooldown_status_in_progress": "Wird ausgeführt",
    "mobile_sensors_cooldown_status_failed": "Fehlgeschlagen",
    "mobile_sensors_cooldown_status_success": "Erfolg",
    "mobile_sensors_cooldown_stage": "Phase",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Die Starttemperatur liegt außerhalb des Bereichs",
    "mobile_sensors_cooldown_failed_cooldown_process": "Abkühlungsvorgang fehlgeschlagen",
    "mobile_sensors_cooldown_cooldown_successful": "Abkühlungsvorgang erfolgreich",
    "mobile_sensors_cooldown_started_cooldown_process": "Abkühlungsvorgang gestartet",
    "mobile_sensors_cooldown_hour": "Stunde",
    "mobile_sensors_cooldown_hour_plural": "Stunden",
    "mobile_sensors_cooldown_minute": "Minute",
    "mobile_minutes_plural": "Minuten",
    "mobile_sensors_last_reading_max_date": "Vor mehr als einem Jahr",
    "mobile_sensors_minute_count_ago": "Vor {{count}} Minute",
    "mobile_sensors_minute_count_ago_plural": "Vor {{count}} Minuten",
    "mobile_sensors_hour_count_ago": "Vor {{count}} Stunde",
    "mobile_sensors_hour_count_ago_plural": "Vor {{count}} Stunden",
    "mobile_sensors_day_count_ago": "Vor {{count}} Tag",
    "mobile_sensors_day_count_ago_plural": "Vor {{count}} Tagen",
    "mobile_sensors_chart_settings": "Diagrammeinstellungen",
    "mobile_announcement_banner_continue_reading": "Weiter lesen",
    "mobile_compliance_submissions_report": "Bericht zu Einträgen",
    "mobile_compliance_submissions_report_subtitle": "Projektabschlussdaten für diese Filiale exportieren",
    "mobile_compliance_send_submissions": "Einträge senden",
    "mobile_compliance_completion_rate_in_last_days": "Erfüllungsquote in den letzten {{ days }} Tagen",
    "mobile_compliance_last_days": "Letzte {{ days }} Tage",
    "mobile_compliance_send_submissions_to": "Einträge senden an",
    "mobile_compliance_send_to_different_email": "An andere E-Mail-Adresse senden",
    "mobile_compliance_email_input_placeholder": "E-Mail-Adressen",
    "mobile_compliance_send_submissions_to_legend_title": "Einträge",
    "mobile_compliance_send_submissions_to_legend_description_days": "Ein Bericht mit Ihren Einträgen der letzten {{ days }} Tage von diesem Standort aus wird an die ausgewählte E-Mail-Adresse gesendet.",
    "mobile_compliance_time_frame": "Zeitrahmen",
    "mobile_compliance_sensor_temperature_log_report": "Sensortemperatur-Protokollbericht",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Temperaturprotokolle für diese Filiale exportieren",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kriterien",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Definieren Sie unten die Kriterien für Ihren Bericht.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Hinweis: Deaktivierte Sensoren werden nicht im Bericht angezeigt",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Wählen Sie einen Zeitrahmen. Die Protokolldaten sind auf maximal 30 Tage begrenzt.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Bericht senden",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Dieser Monat (1. ist heute)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Letzter Monat",
    "mobile_compliance_sensor_temperature_log_email_title": "Bericht senden an",
    "mobile_pwa_update_prompt_title": "Anwendung aktualisieren",
    "mobile_pwa_update_prompt_description": "Eine neue Version der Anwendung ist verfügbar. Bitte führen Sie ein Update auf die neueste Version durch.",
    "mobile_pwa_update_prompt_confirm": "Aktualisieren und neu laden",
    "mobile_pwa_update_prompt_cancel": "Später erinnern",
    "notification_title_due_in_one_hour": "Fällig in 1 Stunde",
    "task_is_due_soon": "'{{ task_title }}' ist in Kürze fällig. Bitte nehmen Sie sich einen Moment Zeit zum Ausfüllen.",
    "mobile_photo_quality_warning_header": "Problem mit der Fotoqualität",
    "mobile_photo_quality_dialog_message": "Dieses Foto ist möglicherweise zu dunkel oder unscharf. Möchten Sie ein neues Foto aufnehmen oder mit diesem fortfahren?",
    "mobile_take_new_photo": "Neues Foto aufnehmen",
    "mobile_use_this_photo": "Dieses Foto verwenden"
}};
mobile_translations.pt_BR = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Tudo",
    "mobile_common_button_apply_filters": "Aplicar filtros",
    "mobile_common_button_done": "Pronto",
    "mobile_common_button_edit": "Editar",
    "mobile_common_button_archive": "Arquivo",
    "mobile_common_button_save": "Salvar",
    "mobile_common_button_retake": "Retomar",
    "mobile_common_button_save_draft": "Salvar rascunho",
    "mobile_common_button_discard": "Descartar",
    "mobile_common_button_submit": "Enviar",
    "mobile_common_button_no": "Não",
    "mobile_common_button_yes": "Sim",
    "mobile_common_button_na": "N/D",
    "mobile_common_created_by_me": "Criados por mim",
    "mobile_common_email": "Email da empresa",
    "mobile_common_first_name": "Nome",
    "mobile_common_last_name": "Sobrenome",
    "mobile_common_location": "Local",
    "mobile_common_locations": "Locais",
    "mobile_common_logout_message": "Quer mesmo sair?",
    "mobile_common_password": "Senha",
    "mobile_common_permission_required": "Permissão necessária",
    "mobile_common_status": "Status",
    "mobile_common_task": "Tarefa",
    "mobile_common_tasks": "Tarefas",
    "mobile_common_tasks_my": "Minhas tarefas",
    "mobile_common_projects": "Projetos",
    "mobile_common_filter_team": "Equipe",
    "mobile_common_filter_var_in": " em {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Nenhuma equipe selecionada",
    "mobile_common_filter_no_user_selected": "Nenhum usuário selecionado",
    "mobile_common_filter_no_role_selected": "Nenhuma função selecionada",
    "mobile_common_placeholder_date": "Data",
    "mobile_common_message_task_creator_error_save": "<b>Não foi possível criar tarefas.</b>",
    "mobile_common_camera": "Câmera",
    "mobile_common_microphone": "Microfone",
    "mobile_common_for": "por",
    "mobile_common_reload": "Recarregar",
    "mobile_common_override": "Substituir",
    "mobile_common_notifications": "Notificações",
    "mobile_common_chat_unavailable": "Chat indisponível. Tente de novo mais tarde.",
    "mobile_common_chat_ending_dialog_title": "Você terminou esta conversa?",
    "mobile_common_chat_ending_dialog_description": "Informe se o problema foi resolvido ou se você deseja continuar mais tarde.",
    "mobile_common_chat_ending_dialog_confirm": "Sim, terminei",
    "mobile_common_chat_ending_dialog_cancel": "Vou continuar mais tarde",
    "mobile_common_continue_editing": "Continuar a editar",
    "mobile_privacy_policy": "Política de privacidade",
    "wootric_recommend_target": "indústriaindústriaindústriaindústriaum amigo ou colega do seu setor de mercado",
    "wootric_followup_detractor_question": "O que poderíamos mudar para que você atribua uma classificação melhor na próxima vez?",
    "wootric_followup_passive_question": "Obrigado! O que poderíamos fazer para tornar a ferramenta ainda melhor?",
    "wootric_followup_promoter_question": "Obrigado! O que você mais gosta no Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Obrigado! O que você adora no Zenput?",
    "wootric_default_followup_question": "Obrigado! Você poderia nos dizer por quê?",
    "wootric_default_placeholder_text": "Ajude-nos explicando sua pontuação.",
    "wootric_default_thankyou_text": "Obrigado por sua resposta e seu comentário!",
    "mobile_login_placeholder_login_as": "Entrar com ID de usuário",
    "mobile_login_button_forgot_password": "Esqueceu a senha?",
    "mobile_login_button_sign_up": "Criar conta",
    "mobile_login_button_finish_setup": "Finalizar configuração",
    "mobile_login_button": "Logon",
    "mobile_login_continue_button": "Continuar",
    "mobile_login_continue_transition": "levando você para a página de login da organização...",
    "mobile_login_no_email_error": "É necessário inserir um email.",
    "mobile_login_change_email": "Login com email diferente",
    "mobile_login_with_sso": "Logon com SSO",
    "mobile_oauth_no_user_error_message": "Parece que você não tem uma conta no Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Parece que você não tem uma Conta Zenput!",
    "mobile_rebrand_announcement_banner": "O <b>Zenput</b> agora é <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} vai se tornar {{- product }} em setembro. {{- cta }}",
    "mobile_rebrand_warning_cta": "Saiba como se preparar.",
    "mobile_oauth_no_user_error_sub_message": "Entre em contato com seu administrador para acessar ou tentar fazer login com um email diferente.",
    "mobile_oauth_generic_error_message": "Parece que houve um problema ao fazer o login, tente novamente.",
    "mobile_oauth_force_logout_msg": "Se você ainda estiver com problemas, saia do seu provedor ",
    "mobile_oauth_force_logout_click": "clicando aqui.",
    "mobile_sign_up_placeholder_phone": "Celular",
    "mobile_sign_up_placeholder_password_confirm": "Confirmar senha",
    "mobile_sign_up_button_sign_in": "Entrar",
    "mobile_sign_up_disclaimer_part_1": "Ao clicar em Criar conta, você concorda com o",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Ao clicar em Finalizar configuração, você concorda com o",
    "mobile_sign_up_disclaimer_link_title": " Acordo de licença",
    "mobile_sign_up_disclaimer_part_2": ", que inclui dados de privacidade importantes",
    "mobile_dialog_benefits_work_offline": "Trabalhar offline",
    "mobile_dialog_benefits_faster_uploads": "Uploads mais rápidos",
    "mobile_dialog_benefits_better_experience": "Melhor experiência",
    "mobile_dialog_benefits_button_download": "Baixar",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution para ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput para ",
    "mobile_dialog_benefits_button_have": "Tenho o aplicativo!",
    "mobile_dialog_benefits_button_no_thanks": "Não, talvez mais tarde.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Falha no carregamento da imagem.",
    "mobile_dialog_signature_sign": "Assine aqui",
    "mobile_dialog_signature_button_clear": "Limpar",
    "mobile_account_placeholder_name": "Nome do local/loja",
    "mobile_account_placeholder_phone": "Telefone",
    "mobile_account_placeholder_address": "Endereço",
    "mobile_account_placeholder_city": "Cidade",
    "mobile_account_placeholder_region": "Região",
    "mobile_account_placeholder_zipcode": "Código postal/CEP",
    "mobile_account_option_select_country": "Selecionar país",
    "mobile_account_oprion_us": "Estados Unidos",
    "mobile_account_oprion_select_state": "Selecionar estado",
    "mobile_account_button_create_location": "Criar Local",
    "mobile_form_message_no_form": "Nenhum formulário disponível",
    "mobile_batch_task_message": "Carregando...",
    "mobile_settings_profile": "Perfil",
    "mobile_settings_profile_number": "Celular",
    "mobile_settings_profile_language": "Idioma",
    "mobile_settings_profile_temperature_unit": "Unidade de temperatura",
    "mobile_settings_profile_use_company_default": "Use padrão da empresa",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Mensagem de texto",
    "mobile_settings_notifications_option_push": "Notificações por push",
    "mobile_settings_notifications_option_push_email": "Notificações por email ou push",
    "mobile_settings_notifications_option_do_not": "Não notificar",
    "mobile_settings_notifications_category_communication": "Comunicação",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulários e acionadores",
    "mobile_settings_devices": "Dispositivos",
    "mobile_settings_notifications_sub_category_alerts": "Alertas",
    "mobile_settings_notifications_sub_category_new_forms_available": "Novos formulários disponíveis",
    "mobile_settings_notifications_sub_category_task_assigned": "Tarefas atribuídas",
    "mobile_settings_notifications_sub_category_task_completed": "Tarefa concluída",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Lembrete de tarefas com prazo próximo",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Lembrete de tarefas atrasadas",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Alertas do sensor",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alertas críticos do sensor",
    "mobile_drafts_message": "Você não tem nenhum rascunho.",
    "mobile_drafts_button_delete": "Excluir",
    "mobile_tasks_filter_location_no": "Nenhum local selecionado",
    "mobile_tasks_filter_group_by": "Agrupar por",
    "mobile_tasks_filter_sort_by": "Ordenar por",
    "mobile_tasks_filter_sorted_by": "Ordenado por",
    "mobile_tasks_filter_due_time": "Prazo (Horário)",
    "mobile_tasks_filter_open_time": "Horário de abertura",
    "mobile_tasks_bucket_due_next_24_hours": "Vence nas próximas 24 horas",
    "mobile_tasks_bucket_due_next_7_days": "Vence nos próximos 7 dias",
    "mobile_tasks_bucket_open_tasks": "Outras {{type}} abertas",
    "mobile_tasks_bucket_open_at": "Abertura: {{- date }} às {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Vencimento: {{- date }} às {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponível em 1 minuto",
    "mobile_tasks_bucket_available_in_one_hour": "Disponível em 1 hora",
    "mobile_tasks_bucket_available_in_one_day": "Disponível em 1 dia",
    "mobile_tasks_bucket_available_in_one_week": "Disponível em 1 semana",
    "mobile_tasks_bucket_available_in_one_month": "Disponível em 1 mês",
    "mobile_tasks_bucket_available_in_one_year": "Disponível em 1 ano",
    "mobile_tasks_bucket_available_in_minutes": "Disponível em {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_hours": "Disponível em {{ hours }} horas",
    "mobile_tasks_bucket_available_in_days": "Disponível em {{ days }} dias",
    "mobile_tasks_bucket_available_in_weeks": "Disponível em {{ weeks }} semanas",
    "notification_task_due_in_minutes": "Entrega em {{ minutes }} minutos",
    "mobile_tasks_bucket_available_in_months": "Disponível em {{ months }} meses",
    "mobile_tasks_bucket_available_in_years": "Disponível em {{ years }} anos",
    "mobile_tasks_follow_up": "Tarefa de acompanhamento",
    "mobile_tasks_due_soon": "Prazo em breve",
    "mobile_tasks_bucket_completed_today": "Concluídas hoje",
    "mobile_tasks_bucket_completed_this_week": "Concluídas esta semana",
    "mobile_tasks_bucket_completed_last_week": "Concluídas semana passada",
    "mobile_tasks_bucket_missed_today": "Perdidas hoje",
    "mobile_tasks_bucket_missed_this_week": "Perdidas esta semana",
    "mobile_tasks_bucket_missed_last_week": "Perdidas semana passada",
    "mobile_tasks_bucket_no_location": "Sem local",
    "mobile_tasks_cannot_submit_missed": "Tarefas perdidas não podem ser concluídas",
    "mobile_tasks_cannot_submit_missed_after": "Esta tarefa não pode ser concluída após {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Esta tarefa não teve início.",
    "mobile_tasks_cannot_submit_processing": "Este envio está sendo processado",
    "mobile_tasks_toolbarnav_header_no_due_date": "Sem prazo",
    "mobile_tasks_toolbarnav_header_overdue": "Atrasados",
    "mobile_tasks_toolbarnav_header_yesterday": "Ontem",
    "mobile_tasks_toolbarnav_header_today": "Hoje",
    "mobile_tasks_toolbarnav_header_tomorrow": "Amanhã",
    "mobile_tasks_toolbarnav_header_last_week": "Semana passada",
    "mobile_tasks_toolbarnav_header_this_week": "Esta semana",
    "mobile_tasks_toolbarnav_header_next_week": "Semana que vem",
    "mobile_tasks_toolbarnav_header_this_month": "Este mês",
    "mobile_tasks_toolbarnav_header_next_year": "Ano que vem",
    "mobile_tasks_toolbarnav_header_over_year": "Mais de um ano",
    "mobile_tasks_toolbarnav_title_edit_task": "Editar tarefa",
    "mobile_task_placeholder_title": "Título *",
    "mobile_task_placeholder_description": "Descrição (opcional)",
    "mobile_task_button_single_task": "Tarefa única",
    "mobile_task_button_project": "Projeto",
    "mobile_task_button_create": "Criar",
    "mobile_task_tab_basic": "Básico",
    "mobile_task_tab_photo": "Foto",
    "mobile_task_tab_form": "Formulário",
    "mobile_task_details_description_message_please": "Preencha ",
    "mobile_task_details_description_message_below": "abaixo.",
    "mobile_task_details_description_message_instructions": "Nenhuma instrução disponível para esta tarefa.",
    "mobile_task_details_reason_title": "Acompanhamento acionado por",
    "mobile_task_detials_button_goto_form": "Ir para Formulário",
    "mobile_task_detials_button_complete": " Concluir tarefa",
    "mobile_task_detials_completed": "Concluídas ",
    "mobile_task_detials_completed_by": "por ",
    "mobile_task_detials_completed_on": "em ",
    "mobile_task_details_view_form_submission": "Visualizar envio do formulário",
    "mobile_task_task_updated": "Tarefa atualizada",
    "mobile_task_task_archived": "Tarefa arquivada",
    "mobile_task_task_deleted": "Tarefa excluída",
    "mobile_task_error_archiving_task": "Não foi possível arquivar a tarefa.",
    "mobile_task_error_deleting_task": "Não foi possível excluir a tarefa.",
    "mobile_task_error_updating_task": "Não foi possível atualizar a tarefa.",
    "mobile_task_archive_task": "Tarefa de arquivo",
    "mobile_task_archive_task_confirm": "Tem certeza de que deseja arquivar esta tarefa?\n\nTarefas arquivadas contarão para taxas de conclusão e continuarão a ser incluídas nos relatórios.\n\nNão é possível desfazer esta ação.",
    "mobile_task_delete_task_confirm": "Tem certeza de que deseja excluir esta tarefa?\n\nTarefas excluídas não contarão para taxas de conclusão e não continuarão a ser incluídas nos relatórios.\n\nNão é possível desfazer esta ação.",
    "mobile_task_edition_already_in_progress": "Esta tarefa possui uma edição pendente. Não é possível realizar edições adicionais.",
    "mobile_projects_filter_type": "Tipo",
    "mobile_projects_filter_status": "Status do projeto",
    "mobile_projects_filter_project_type": "Tipo de projeto",
    "mobile_projects_due_date_required": "O prazo é obrigatório.",
    "mobile_projects_team_required": "A equipe é obrigatória.",
    "mobile_projects_user_role_required": "O cessionário é obrigatório.",
    "mobile_projects_title_required": "O título é obrigatório.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Múltiplas tarefas por dia",
    "mobile_project_tasks_complete": " Concluído",
    "mobile_project_tasks_remaining": " Restantes",
    "mobile_esitmate_message_tasks": "0 tarefas serão criadas",
    "mobile_esitmate_message_criteria": "Ajustar critérios acima",
    "mobile_esitmate_message_created_for": "será criado(a) para",
    "mobile_left_menu_dashboard": "Painel",
    "mobile_left_menu_my_forms": "Meus formulários",
    "mobile_left_menu_announcements": "Anúncios",
    "mobile_left_menu_my_submissions": "Meus envios",
    "mobile_left_menu_drafts": "Rascunhos",
    "mobile_left_menu_pending_uploads": "Uploads pendentes",
    "mobile_left_menu_open": "Abrir no aplicativo",
    "mobile_left_menu_settings": "Configurações",
    "mobile_left_menu_log_out": "Sair",
    "mobile_left_menu_debug": "Depurar",
    "mobile_left_menu_support": "Suporte",
    "mobile_left_menu_documentation": "Documentação",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Nota ou legenda",
    "mobile_field_option_select": "Selecionar",
    "mobile_field_text_placeholder_text": "Texto",
    "mobile_field_email_placehoder_email": "Email",
    "mobile_filed_number_placeholder_number": "Número",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Não conectado",
    "mobile_field_sensor_offline_battery": "Sensor offline - Bateria",
    "mobile_field_video_button_add": "Adicionar um vídeo",
    "mobile_field_video_picker_dialog_title": "Adicionar vídeo de",
    "mobile_field_video_button_change": "Trocar o vídeo",
    "mobile_field_image_button_add": "Adicionar imagem",
    "mobile_field_image_low_quality_warning": "Algumas fotos podem estar escuras demais ou borradas. Confira as fotos em destaque e substitua, se necessário",
    "mobile_field_image_picker_dialog_title": "Adicionar foto de",
    "mobile_field_image_picker_edit_failed": "Não foi possível salvar a imagem. Tente outra vez.",
    "mobile_field_signature_button_add": "Adicionar assinatura",
    "mobile_field_signature_button_change": "Alterar a assinatura",
    "mobile_field_account_select_location": "Selecionar local",
    "mobile_field_account_prefill": "Preencher formulário com os dados da última visita?",
    "mobile_field_account_message_overwrite": "Os campos que você já tiver preenchido serão substituídos.",
    "mobile_forms_task_on_behalf": "Há uma tarefa a ser realizada neste local que está atribuída a <b>{{user}}</b>. Você gostaria de concluir esta tarefa?",
    "mobile_forms_complete_task": "Concluir tarefa?",
    "mobile_field_account_prefill_button_yes": "Sim, preencher",
    "mobile_field_barcode_placeholder_scan": "Ler ou digitar código de barras",
    "mobile_field_sensor_qr_code_placeholder_scan": "Ler ou digitar código",
    "mobile_field_gateway_id_code_placeholder": "Tipo de ID de nó",
    "mobile_field_scan_qr_or_enter_dev_eui": "Ler código QR ou inserir DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Ler código QR ou inserir número de ID",
    "mobile_field_scan_qr_or_enter_sc": "Ler código QR ou inserir código SC",
    "mobile_field_barcode_select_date": "Selecionar data ",
    "mobile_field_datetime_allow_time": "Horário",
    "mobile_field_stopwatch_button_caption": "Cronômetro",
    "mobile_field_stopwatch_common_start": "Iniciar",
    "mobile_field_stopwatch_common_stop": "Parar",
    "mobile_field_stopwatch_common_reset": "Redefinir",
    "mobile_field_stopwatch_stop_stopwatches": "Parar cronômetros",
    "mobile_field_document_title": "Adicionar documento",
    "mobile_field_document_message_delete": "Tem certeza de que deseja excluir este documento?",
    "mobile_field_document_alret_button_view": "Exibir",
    "mobile_field_document_alert_error": "Ocorreu um erro ao anexar este documento. Tente novamente.",
    "mobile_field_document_alert_file_size_error": "O tamanho do arquivo não pode ser superior a {{count}} MB.",
    "mobile_field_temperature_greater_range": "superior a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "superior ou igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "inferior a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "inferior ou igual a {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "superior ou igual a {{ min_temp_value }} °{{ temp_unit }} e inferior a {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "superior ou igual a {{ min_temp_value }} °{{ temp_unit }} e inferior ou igual a {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " e ",
    "mobile_field_text_limit_error": "Limite máximo de caracteres de 8000 atingido.",
    "mobile_forms_required_questions_complete": "Conclusão obrigatória",
    "mobile_forms_required_remaining": "Restam {{count}} obrigatórios",
    "mobile_forms_required_questions_back": "Voltar",
    "mobile_forms_required_questions_next": "Avançar",
    "mobile_forms_required_questions_skip": "Ignorar",
    "mobile_forms_leaving_form": "Saindo do formulário",
    "mobile_message_reordering_confirm": "Deseja salvar a nova ordem de perguntas?",
    "mobile_forms_leaving_reordering": "Saindo de reordenação de perguntas",
    "mobile_forms_reordering_button_save": "Salvar nova ordem de perguntas",
    "mobile_forms_reordering_instructions": "Para reordenar as perguntas ou seções, arraste e solte onde o campo deve aparecer no formulário.",
    "mobile_toolbarnav_title_my_setttings": "Minhas configurações",
    "mobile_toolbarnav_title_profile_settings": "Configurações do perfil",
    "mobile_toolbarnav_title_notification": "Configurações de notificação",
    "mobile_toolbarnav_title_form_history": "Histórico do formulário",
    "mobile_toolbarnav_title_form_not_available": "Formulário não disponível",
    "mobile_toolbarnav_title_add_location": "Adicionar local",
    "mobile_toolbarnav_title_add_task_or_project": "Adicionar tarefa ou projeto",
    "mobile_toolbarnav_title_select_location": "Selecionar local",
    "mobile_toolbarnav_title_select_project": "Selecionar projeto",
    "mobile_toolbarnav_title_select_tag": "Selecionar tag",
    "mobile_toolbarnav_title_select_user": "Selecionar usuário",
    "mobile_toolbarnav_title_select_template": "Selecionar modelo",
    "mobile_toolbarnav_title_select_one": "Selecione um",
    "mobile_toolbarnav_title_select_multiple": "Selecione um ou mais",
    "mobile_toolbarnav_title_select_team": "Selecionar equipe",
    "mobile_toolbarnav_title_select_team_or_location": "Selecionar equipe ou local",
    "mobile_toolbarnav_title_filter_tasks": "Filtrar tarefas",
    "mobile_toolbarnav_title_filter_projects": "Filtrar projetos",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrar tarefas do projeto",
    "mobile_placeholder_search_bar": "Pesquisar",
    "mobile_placeholder_user_select_role": "Selecionar função do usuário",
    "mobile_placeholder_filter_by_team": "Filtrar por equipe",
    "mobile_placeholder_assign_to_user_role": "Atribuir à função do usuário",
    "mobile_placeholder_select": "-- Selecionar --",
    "mobile_placeholder_account_location_name": "Nome do local",
    "mobile_placeholder_tag_filter_by": "Filtrar por Tag de local",
    "mobile_placeholder_user_type": "Atribuir a usuário",
    "mobile_placeholder_acount_type_loading": "Carregando... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatura",
    "mobile_placeholder_blue_therm_connecting": "Conectando ao dispositivo...",
    "mobile_placeholder_blue_therm_please_wait": "Aguarde...",
    "mobile_placeholder_blue_therm_tap": "Toque para ler.",
    "mobile_placeholder_blue_therm_not_connected": "Não conectado.",
    "mobile_placeholder_testo_tap": "Segure ▼▲ seguido por ⬆",
    "mobile_message_error_create_task": "Você precisa estar online para adicionar tarefas",
    "mobile_message_error_fill_out_form": "Preencha o formulário.",
    "mobile_message_error_fill_require_fields": "Preencha os campos obrigatórios.",
    "mobile_message_error_stop_stopwatch_before_submit": "Pare o cronômetro antes de enviar",
    "mobile_message_error_stopwatch_field_required": "O campo do cronômetro é obrigatório",
    "mobile_message_error_stopwatch_field_running": "O campo do cronômetro está em execução",
    "mobile_message_error_invalid_equipment_temperature": "Temperatura do equipamento inválida",
    "mobile_message_error_invalid_ingredient_temperature": "Temperatura do ingrediente inválida",
    "mobile_message_error_location_attributes_unavailable": "Algumas perguntas podem estar indisponíveis. Conecte-se à internet",
    "mobile_message_alert_running_stopwatches": "Há cronômetros em execução.\n\nDeseja cancelá-los?",
    "mobile_message_blue_therm_error": "A conexão com o dispositivo Bluetooth caiu",
    "mobile_message_blue_therm_no_permission_android_pre_12": "É necessário o acesso à localização. Habilite-o nas configurações do seu Android.",
    "mobile_message_blue_therm_no_permission_android": "É necessário ter acesso aos dispositivos próximos. Ative essa função nas configurações do seu Android.",
    "mobile_message_blue_therm_error_code": "Falha na conexão:",
    "mobile_message_blue_therm_error_bluetooth": "Ative o Bluetooth.",
    "mobile_message_blue_therm_error_device": "Dispositivo não encontrado.",
    "mobile_message_blue_therm_error_try_again": "Tente outra vez",
    "mobile_message_blue_therm_success": "Dispositivo Bluetooth conectado!",
    "mobile_message_bluetooth_device_press_button_field": "Pressione o botão em seu dispositivo para conectar.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Pressione o botão em seu dispositivo<br />se ele não aparecer listado aqui.",
    "mobile_bluetooth_scan": "Ler",
    "mobile_bluetooth_scanning": "Lendo",
    "mobile_message_drafts_confirm": "Gostaria de salvar como rascunho?",
    "mobile_message_drafts_toast_saved": "Rascunho salvo.",
    "mobile_message_drafts_request_update": "Gostaria de atualizar este rascunho?",
    "mobile_message_drafts_form_confirm": "Tem certeza de que deseja excluir este rascunho?",
    "mobile_message_drafts_confirm_delete": "Excluir rascunho",
    "mobile_message_streams_error_switch": "Não é possível alterar transmissões no modo web",
    "mobile_message_settings_success_saved": "Configurações salvas",
    "mobile_message_settings_error": "Erro desconhecido. Tente mais tarde.",
    "mobile_message_profile_settings_error_fields": "Corrija os campos destacados.",
    "mobile_message_media_perimission_denied": "Suas ",
    "mobile_message_media_perimission_denied_device": "Armazenamento do dispositivo",
    "mobile_message_image_confirm_remove_image": "Tem certeza de que deseja excluir esta foto?",
    "mobile_message_create_account_error_fields": "Preencha os campos destacados.",
    "mobile_message_create_account_success_location_created": "Local criado",
    "mobile_message_task_error_get_location": "Local não acessado. Ordenando por data.",
    "mobile_message_typehead_confirm_save_message": "Deseja salvar essas seleções?",
    "mobile_message_typehead_confirm_save_title": "Salvar?",
    "mobile_message_task_creator_error_save_select_form": "Selecione um formulário.",
    "mobile_message_task_creator_error_save_required_fields": "Preencha os campos obrigatórios.",
    "mobile_message_task_creator_error_save_batch_change": "Mude os critérios para enquadrar um ou mais usuários",
    "mobile_message_task_detials_error_not_assigned_to_you": "A tarefa não está atribuída a você.<br />Você não pode realizá-la.",
    "mobile_message_task_detials_error_assigned_to": "A tarefa está atribuída a {{user}}.<br />Você não pode realizá-la.",
    "mobile_message_task_detials_confirm_title": "Saindo da tarefa",
    "mobile_message_task_detials_confirm_save_task": "Salvar tarefa",
    "mobile_message_task_detials_confirm_message": "Tem certeza? Suas mudanças não serão salvas.",
    "mobile_message_task_detials_error_view_account": "Não foi possível acessar o local.",
    "mobile_message_task_detials_error_submit_task": "Adicione uma foto para concluir esta tarefa.",
    "mobile_message_task_detials_error_submit_task_project": "Não foi possível salvar o projeto. Tente mais tarde.",
    "mobile_message_task_detials_wait_submit_task_created": "Tarefas sendo criadas.<br />Aguarde alguns minutos para que elas sejam preenchidas.",
    "mobile_message_task_detials_error_submit_task_pending": "Erro, tente mais tarde",
    "mobile_message_task_detials_success_task_complete": "Tarefa concluída",
    "mobile_message_task_error_save_single_task": "Não foi possível salvar a tarefa. Tente mais tarde.",
    "mobile_message_task_success_save_single_task": "Tarefa criada.",
    "mobile_message_show_error_message": "Houve um problema.",
    "mobile_message_show_success_message": "Pronto!",
    "mobile_message_show_offline_message": "Você está offline.",
    "mobile_message_show_permission_denied_message": "<b>Permissão necessária.</b> Autorize o Zenput a acessar {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Permissão necessária.</b> Autorize o Zenput e o seu navegador a acessar {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Agora carregando",
    "mobile_message_show_upload_in_progress_message": "Upload já em progresso",
    "mobile_message_show_form_id_error": "Não foi possível acessar o formulário especificado.",
    "mobile_message_show_single_task_error": "Não foi possível acessar a tarefa especificada.",
    "mobile_message_show_submissions_error": "Não foi possível acessar o envio especificado.",
    "mobile_message_show_submissions_access_denied": "Infelizmente você não tem acesso a este formulário.",
    "mobile_message_send_data_success": "Dados enviados ",
    "mobile_message_start_upload_success": "Carregamento concluído",
    "mobile_message_start_upload_error": "<b>Upload não concluído.</b><br>Envio salvo. Tente de novo mais tarde",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Atualização disponível",
    "mobile_message_store_upgrade_confirm_message_one": "Atualize o app Ops Execution em ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Atualize o Zenput a partir de ",
    "mobile_message_store_upgrade_confirm_message_two": " para receber todos os recursos e correções mais recentes",
    "mobile_message_store_upgrade_confirm_now": "Agora",
    "mobile_message_store_upgrade_confirm_later": "Depois",
    "mobile_message_redirect_confirm_message": "Você está preenchendo um formulário. Gostaria de salvar como rascunho antes de continuar?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Você tem {{count}} rascunhos que ainda não foram carregados. Eles serão perdidos se você continuar. Tem certeza?",
    "mobile_message_draft_override_message": "Este rascunho foi salvo de outro dispositivo em {{date}}, e as alterações neste dispositivo são conflitantes. Você pode optar por substituir a versão existente ou recarregar a versão mais recente e suas alterações serão descartadas.",
    "mobile_html_submitting": "Enviando...",
    "mobile_html_offline": "Você está offline!",
    "mobile_html_offline_try_again": "Você está offline. <br/><br/>Tente outra vez quando estiver conectado",
    "mobile_html_something_went_wrong": "Ops. Houve um erro.",
    "mobile_html_something_went_wrong_try_again": "Ops. Houve um erro. Tente outra vez.",
    "mobile_html_failed_loading_roles": "Funções não carregadas.",
    "mobile_alert_please_install_for_native": "Instale o app Ops Execution para usar esse recurso. ",
    "mobile_alert_please_install_for_native_old": "Instale o aplicativo nativo do Zenput para usar este recurso.",
    "mobile_tso_filter_all_tasks": "Todas as {{type}}",
    "mobile_tso_filter_my_tasks": "Minhas {{type}}",
    "mobile_tso_filter_due_date": "Prazo",
    "mobile_tso_filter_date_completed": "Data de conclusão",
    "mobile_tso_filter_completed": "Concluídas",
    "mobile_tso_filter_completed_late": "Concluído com atraso",
    "mobile_tso_filter_incomplete": "Incompletas",
    "mobile_tso_filter_var_my_tasks": "Minhas {{type}} {{filter_type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{type}} {{filter_type}} criadas por mim",
    "mobile_tso_filter_var_all_tasks": "Todas as {{type}} {{filter_type}}",
    "mobile_tso_type_follow_up_actions": "Ações de acompanhamento",
    "mobile_tso_type_all": "Tarefas e ações de acompanhamento",
    "mobile_tso_filter_var_at": " em {{location}}",
    "mobile_tso_filter_group_date_due": ", ordenados por Prazo",
    "mobile_tso_filter_group_distance": ", agrupados por Local",
    "mobile_tso_filter_start_date": "Data de Início",
    "mobile_tso_filter_none": "Nenhuma",
    "mobile_pso_filter_all_projects": "Todos os projetos",
    "mobile_pso_filter_my_projects": "Meus projetos",
    "mobile_pso_filter_active": "Ativos",
    "mobile_pso_filter_archived": "Arquivado",
    "mobile_pso_filter_recurring": "Recorrente",
    "mobile_pso_filter_non_recurring": "Não recorrente",
    "mobile_pso_filter_var_my_projects": "Meus {{project_type}} {{active_description}} projetos",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Projetos criados por mim",
    "mobile_pso_filter_var_all_projects": "Todos os {{project_type}} {{active_description}} projetos",
    "mobile_empty_list_message_must_be_online": "Parece que você está offline. Conecte-se para ver resultados.",
    "mobile_empty_list_message_no_submissions": "Nenhum envio",
    "mobile_empty_list_message_no_activity": "Nenhuma atividade",
    "mobile_empty_list_message_no_tasks": "Nenhuma tarefa",
    "mobile_empty_list_message_no_tasks_overdue": "Nenhuma {{type}} atrasada",
    "mobile_empty_list_message_no_accounts": "Nenhum local",
    "mobile_empty_list_message_no_projects": "Nenhum projeto",
    "mobile_empty_list_message_no_results_found": "Nenhum resultado",
    "mobile_empty_list_message_no_forms_available": "Nenhum formulário disponível",
    "mobile_empty_list_message_connection_error": "Erro de conexão<br />Tente outra vez.",
    "mobile_empty_list_message_dashboard_error": "Não foi possível carregar o Painel",
    "mobile_empty_list_message_user_offline": "Você está offline",
    "mobile_action_sheet_media_gallery": "Galeria",
    "mobile_action_sheet_cancel": "Cancelar",
    "mobile_image_preview_text": "Remover foto",
    "mobile_mobileform_text": "Envios anteriores",
    "mobile_mobileform_reorder_fields": "Reordenar perguntas",
    "mobile_mobileform_follow_up_actions": "Ações de acompanhamento",
    "mobile_mobileform_follow_up_actions_assign_title": "Atribuir ações de acompanhamento",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Adicione ações de acompanhamento com base em suas observações para garantir que problemas sejam resolvidos.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Adicionar ação de acompanhamento",
    "mobile_mobileform_follow_up_actions_assign_button": "Atribuir acompanhamentos",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continuar sem atribuir",
    "mobile_mobileform_follow_up_actions_dialog_title": "Continuar sem atribuir ações de acompanhamento?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Se você prosseguir sem atribuir ações de acompanhamento, não poderá adicioná-las posteriormente.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continuar mesmo assim",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Este campo é obrigatório",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Caracteres em excesso",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Este campo é inválido",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Erro ao carregar locais",
    "mobile_mobileform_add_follow_up_actions_error_users": "Erro ao carregar usuários",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Adicionar acompanhamento",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Título",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Descrição",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Requer foto",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Data de vencimento",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Atualizar acompanhamento",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Excluir acompanhamento?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Ele será removido e não será atribuído.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Excluir acompanhamento",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Tem certeza de que deseja excluir este acompanhamento?\n\nEsta ação não pode ser desfeita.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continuar para acompanhamentos",
    "mobile_mobileform_follow_up_actions_completed_notification": "Ação de acompanhamento concluída",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Ação de acompanhamento excluída",
    "mobile_mobileform_follow_up_actions_update_notification": "Ação de acompanhamento atualizada",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Adicione uma foto para concluir esta ação de acompanhamento",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Navegar até o envio",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Navegue até a origem",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Origem",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Concluir acompanhamento",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Se você abrir o envio, as fotos e observações não salvas serão perdidas.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Se você sair desta tela, todas as fotos e anotações não salvas serão perdidas.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Ficar aqui",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Abrir envio",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Código aberto",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Sair desta ação de acompanhamento?",
    "mobile_mobileform_follow_up_actions_submission": "Envio",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Esta ação de acompanhamento está atribuída a {{user}}.<br />Você não pode concluí-la.",
    "mobile_mobileform_follow_up_actions_leave_description": "Se você sair desta tela, todas as alterações não salvas serão perdidas.",
    "mobile_mobileform_follow_up_actions_leave": "Sair",
    "mobile_forms_drafts_text": "Remover rascunhos",
    "mobile_batch_estimate_user": "Usuário",
    "mobile_batch_estimate_users": "Usuários",
    "mobile_table_of_contents": "Índice",
    "mobile_table_of_contents_required": "Obrigatório",
    "mobile_table_of_contents_optional": "Opcional",
    "mobile_dialog_alert_title": "Alerta",
    "mobile_dialog_alert_ok": "Ok",
    "mobile_windows_10_bluetherm_not_supported": "Dispositivos Bluetooth ainda sem suporte no Windows",
    "mobile_windows_deprecated_message_content_announcement": "Comunicado",
    "mobile_windows_deprecated_message_title": "É necessário atualizar o app",
    "mobile_windows_deprecated_message_description": "Instale imediatamente o novo app Zenput na Microsoft Store para garantir atualizações críticas de funcionalidade e a experiência ideal do Zenput.",
    "mobile_dashboard_tcr_graph_name": "Taxa de tarefas concluídas",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Últimas 4 semanas",
    "mobile_dashboard_tcr_legend_company_average": "Média da empresa",
    "mobile_dashboard_tcr_legend_team_average": "Média da equipe",
    "mobile_dashboard_tab_title_summary": "Resumo",
    "mobile_dashboard_tab_title_activity": "Atividade",
    "mobile_dashboard_card_title_top_triggered_workflows": "Principais acionadores",
    "mobile_dashboard_tab_title_info": "Informações",
    "mobile_dashboard_tab_project_audit": "Conformidade",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Semana de",
    "mobile_dashboard_card_filter_form_template_placeholder": "Todos os formulários",
    "mobile_dashboard_card_title_forms_top_nos": "“Nºs” frequentes",
    "mobile_dashboard_zenput_code_no_data_in_range": "Não há dados neste intervalo de tempo.",
    "mobile_dashboard_zenput_code_permission_denied": "Você ainda não tem permissão para ver isto.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Selecione um formulário acima.",
    "mobile_dashboard_zenput_code_unknown_error": "Não é possível exibir os dados neste momento.",
    "mobile_dashboard_tap_to_retry": "Toque para tentar novamente",
    "mobile_dashboard_reporting_delay_disclaimer": "As tarefas podem demorar até 15 minutos para serem atualizadas",
    "mobile_dashboard_configuration_down_state_postfix_msg": "foi configurado por seu administrador.",
    "mobile_tasks_tag": "tarefas",
    "mobile_workflows_tag": "acionadores",
    "mobile_projects_tag": "projetos recorrentes",
    "mobile_forms_tag": "formulários",
    "mobile_dashboard_card_ongoing_projects_title": "Projetos em andamento",
    "mobile_dashboard_card_ongoing_projects_show_more": "Exibir mais",
    "mobile_dashboard_card_ongoing_projects_show_less": "Exibir menos",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Ir para Projetos",
    "mobile_dashboard_card_title_recurring_projects": "Projetos recorrentes",
    "mobile_dashboard_card_filter_daily": "Diariamente",
    "mobile_dashboard_card_filter_weekly": "Semanalmente",
    "mobile_dashboard_card_filter_monthly": "Mensalmente",
    "mobile_task_status_title_open": "Aberto",
    "mobile_task_status_title_upcoming": "Próximas",
    "mobile_task_status_title_complete": "Concluído",
    "mobile_task_status_title_processing": "Processamento do envio",
    "mobile_task_status_title_complete_with_exceptions": "Concluído com tarefas de acompanhamento ou alertas",
    "mobile_task_status_title_completed_late_with_exceptions": "Concluído com atraso com tarefas de acompanhamento ou alertas",
    "mobile_task_status_title_incomplete_and_closed": "Perdidas",
    "mobile_tasks_legend_modal_title": "Legenda",
    "mobile_tasks_legend_modal_footer_button_title": "Fechar",
    "mobile_common_assigned_to": "Atribuído a",
    "mobile_common_created_by": "Criado por",
    "mobile_common_tasks_for": "Tarefas para",
    "mobile_common_go_back": "Voltar",
    "mobile_oh_no": "Oh, não!",
    "mobile_user_not_in_groups": "Infelizmente parece que você não está atribuído a uma equipe. Entre em contato com seu administrador para obter acesso ao seu painel.",
    "mobile_tasks_select_followers": "Selecionar seguidores",
    "mobile_tasks_assign_tasks": "Atribuir {{count}} tarefas",
    "mobile_tasks_add_followers": "Adicionar seguidores",
    "mobile_tasks_followers": "Seguidores",
    "mobile_tasks_delete_task": "Excluir tarefa",
    "mobile_tasks_create_task": "Criar tarefas",
    "mobile_tasks_tab_title_comments": "Comentários",
    "mobile_tasks_see_more": "Ver mais",
    "mobile_projects_create_project": "Criar projeto",
    "mobile_common_button_send": "Enviar",
    "mobile_common_button_schedule": "Cronograma",
    "mobile_announcements_create": "Criar anúncio",
    "mobile_announcements_read_rate": "{{opened_count}} de {{recipients_count}} abertos",
    "mobile_announcements_empty_message": "Você ainda não criou anúncios! Crie um anúncio abaixo para transmitir notícias, informações e atualizações importantes à sua organização.",
    "mobile_announcement_message_placeholder": "Adicionar uma mensagem...",
    "mobile_announcement_title_placeholder": "Título do anúncio",
    "mobile_announcement_leaving_announcement": "Saindo do anúncio",
    "mobile_announcement_confirm_recipients_team": "Deseja transmitir este anúncio para {{count}} usuário(s) em {{teams}} equipe(s) selecionada(s)?",
    "mobile_announcement_confirm_recipients_role": "Deseja transmitir este anúncio para {{count}} usuário(s) em {{roles}} função(ões) do usuário selecionado?",
    "mobile_announcement_confirm_recipients_user": "Deseja transmitir este anúncio para {{count}} usuário(s)?",
    "mobile_announcement_confirm_scheduled": "Em {{timestamp}}",
    "mobile_announcement_sending_announcement": "Enviando anúncio",
    "mobile_announcement_send_to": "Enviar para",
    "mobile_announcement_sent_to": "Enviado para",
    "mobile_announcement_send_to_role": "Função",
    "mobile_announcement_attachment_download": "Baixando {{filename}}",
    "mobile_announcement_attachment_validation_error": "É possível adicional até {{maxCount}} anexos",
    "mobile_announcement_details_sent": "Enviado",
    "mobile_announcement_details_total_recipients": "Destinatários totais",
    "mobile_announcement_details_cancel": "Cancelar anúncio",
    "mobile_announcement_details_not_editable": "Comunicados só podem ser editados no app web do Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Os anúncios somente podem ser editados na Zenput Web",
    "mobile_announcement_details_open_count": "Contagem aberta",
    "mobile_announcement_details_open_rate": "Taxa aberta",
    "mobile_announcement_details_resend": "Reenviar a quem não abriu",
    "mobile_announcement_confirm_resend": "{{count}} usuários não leram o anúncio. Deseja enviar um lembrete?",
    "mobile_announcement_confirm_resend_title": "Enviar lembrete?",
    "mobile_announcement_recipients_opened": "Aberta",
    "mobile_recipients_opened_empty_message": "Parece que ninguém abriu sua mensagem ainda. Volte mais tarde para ver os seus resultados.",
    "mobile_announcement_recipients_unopened": "Não aberta",
    "mobile_recipients_unopened_empty_message": "Boas notícias! Não há mensagens não abertas!",
    "mobile_scheduled_announcements_delivery_section_header": "Horário da entrega",
    "mobile_scheduled_announcements_send_immediately_label": "Enviar imediatamente",
    "mobile_scheduled_announcements_scheduled_label": "Enviar em um horário específico",
    "mobile_scheduled_announcements_scheduled_tab_label": "Agendado",
    "mobile_scheduled_announcements_dialog_header": "Cancelar anúncio?",
    "mobile_scheduled_announcements_dialog_message": "Cancelar o anúncio o impedirá de ser enviado e excluído da sua lista. Esta ação não pode ser desfeita. Para editar, vá para a Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "No momento, você não tem anúncios agendados. Agende um anúncio para transmitir notícias, informações e novidades importantes à sua organização.",
    "mobile_scheduled_announcements_validation_error": "O horário de entrega deverá ser após {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Agendar anúncio",
    "mobile_projects_auto_archive": "Arquivar automaticamente",
    "mobile_common_unassigned": "Não atribuído",
    "mobile_tasks_title_placeholder": "Nova tarefa ou formulário",
    "mobile_projects_leaving_project": "Saindo do projeto",
    "mobile_projects_save_project": "Salvar projeto",
    "mobile_top_triggers_tasks": "Principais tarefas acionadas",
    "mobile_top_triggers_alerts": "Principais alertas acionados",
    "mobile_projects_not_started": "Não Iniciado",
    "mobile_empty_list_message_no_photos": "Nenhuma foto",
    "mobile_webfilestore_message_error": "Selecione um tipo de arquivo válido",
    "mobile_notifications_empty_title": "Nenhuma notificação",
    "mobile_notifications_empty_message": "A atividade em suas tarefas ou naquelas das quais você faz parte aparecerão aqui.",
    "mobile_comments_comment_deleted": "Este comentário foi excluído.",
    "mobile_comments_comment_placeholder": "Comentário",
    "mobile_comments_task_submitted_at": "Tarefa enviada em {{ date }} às {{ time }}",
    "mobile_comments_discard_comment_title": "Descartar comentário?",
    "mobile_comments_discard_confirm_message": "Tem certeza? Seu comentário será excluído.",
    "mobile_comments_delete_comment_title": "Excluir comentário?",
    "mobile_comments_delete_confirm_message": "Esta ação não poderá ser desfeita.",
    "mobile_comments_delete_button": "Excluir comentário",
    "mobile_comments_delete_success_message": "Comentário excluído",
    "mobile_comments_empty_message_tasks": "Ainda não há comentários \n Inicie uma conversa sobre esta tarefa.",
    "mobile_comments_empty_message_submissions": "Ainda não há comentários \n Inicie uma conversa sobre este envio.",
    "mobile_comments_empty_message_default": "Ainda não há comentários \n Inicie uma conversa.",
    "mobile_comments_no_matching_users": "Nenhum usuário correspondente.",
    "mobile_comments_empty_users_to_notify": "Não há usuários para notificar.",
    "mobile_comments_users_cant_view_message": "Esses usuários não podem visualizar esses comentários",
    "mobile_comments_users_to_notify_title": "Usuários para notificar",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} usuário</a> será notificado.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} usuários</a> serão notificados.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@menção</a> mais usuários para notificá-los.",
    "mobile_comments_mark_read": "Marcar todos como lidos",
    "mobile_comments_author_mentioned_message": "mencionou você em",
    "mobile_comments_author_commented_message": "comentou em",
    "mobile_view_pdf": "Exibir PDF",
    "mobile_no_pdf_generated_message": "Nenhum PDF foi encontrado para este envio. Uma cópia será enviada por email a você em breve.",
    "mobile_clipboard_copied_success": "O link está copiado para a área de transferência.",
    "mobile_share_link": "Compartilhar link",
    "mobile_zencam_share": "Compartilhar",
    "mobile_zencam_view_details": "Exibir detalhes",
    "mobile_zencam_details_drawer_header": "Detalhes",
    "mobile_zencam_submitted_by": "Enviado por",
    "mobile_zencam_form_title": "Título do formulário",
    "mobile_zencam_date_submitted": "Data de envio",
    "mobile_oil_quality_warning_message": "Óleo próximo da validade",
    "mobile_oil_quality_warning_message_subtitle": "Comece logo a planejar a troca",
    "mobile_oil_quality_failure_message": "Qualidade do óleo comprometida",
    "mobile_oil_quality_failure_message_subtitle": "Troque o óleo imediatamente",
    "mobile_sensors_set_up_gateway": "Configurar gateway",
    "mobile_sensors_set_up_gateway_message": "Parece que não há dispositivos configurados. Comece ao adicionar um gateway.",
    "mobile_sensors_gateway_plugged_in": "Certifique-se de seu gateway esteja conectado a uma tomada elétrica",
    "mobile_sensors_add_device": "Adicionar dispositivo",
    "mobile_sensors_name_this_gateway": "Nomeie este gateway.",
    "mobile_sensors_name_this_sensor": "Nomeie este sensor.",
    "mobile_sensors_device_barcode_information": "Leia o código QR ou insira o número de ID e SC da etiqueta do dispositivo",
    "mobile_sensors_device_eui_information": "Leia o código QR ou insira o DevEUI da etiqueta do dispositivo",
    "mobile_sensors_gateway_id_information": "Inserir a ID de nó a partir da etiqueta do gateway",
    "mobile_sensors_id_number": "{{untranslatedID}} Número",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Código",
    "mobile_sensors_sensors": "Sensores",
    "mobile_sensors_sensor_deveui_error": "Não consegui obter DevEUI pelo QR. Insira manualmente.",
    "mobile_sensors_gateways": "Gateways",
    "mobile_sensors_add_sensor": "Adicionar sensor",
    "mobile_sensors_add_gateway": "Adicionar gateway",
    "mobile_sensor_placement_description": "Que área esse sensor monitorará?",
    "mobile_sensors_equipment_placement": "Qual área ou equipamento esse sensor monitorará?",
    "mobile_sensors_equipment": "Que equipamento esse sensor monitorará?",
    "mobile_sensors_select_gateway_type": "Selecione o tipo de gateway",
    "mobile_sensors_select_placement": "Selecionar localização",
    "mobile_sensors_select_equipment": "Selecionar equipamento",
    "mobile_sensors_placement": "Localização",
    "mobile_sensors_nickname_tip": "A definição do nome do sensor é determinada pelos apelidos atribuídos na localização selecionada.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Ler código QR",
    "mobile_sensors_enter_manually": "Inserir manualmente",
    "mobile_sensors_wizard_step_one": "Passo 1",
    "mobile_sensors_wizard_step_two": "Passo 2",
    "mobile_sensors_wizard_step_three": "Passo 3",
    "mobile_sensors_wizard_step_four": "Passo 4",
    "mobile_sensors_wizard_step_five": "Passo 5",
    "mobile_sensors_wizard_step_six": "Passo 6",
    "mobile_sensors_initializing": "Inicializando...",
    "mobile_sensors_nickname": "Apelido",
    "mobile_sensors_field_not_blank": "O campo {{field}} não pode ficar em branco.",
    "mobile_sensors_nothing_to_see_here": "Nada para ver aqui",
    "mobile_sensors_missing_integration": "Integração com sensor ausente",
    "mobile_sensors_contact_zenput_admin": "Entre em contato com o administrador do Ops Execution da sua empresa.",
    "mobile_sensors_contact_zenput_admin_old": "Entre em contato com o administrador do Zenput.",
    "mobile_sensors_contact_manager": "Entre em contato com seu gerente de contas para adicionar sensores.",
    "mobile_sensors_device_success_message": "Os dados dos sensores podem demorar até 15 minutos para carregar",
    "mobile_sensors_last_reading": "Última leitura",
    "mobile_sensors_remove_device": "Dispositivo remoto",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1S",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1A",
    "mobile_sensors_sensor_settings": "Configurações do sensor",
    "mobile_sensors_remove_confirm_message": "Tem certeza de que deseja excluir este dispositivo?\nEsta ação não poderá ser desfeita.",
    "mobile_sensors_sensor": "Sensor",
    "mobile_sensors_no_equipment_linked": "Nenhum equipamento vinculado",
    "mobile_sensor_cooldown_process": "Processo de resfriamento",
    "mobile_sensor_last_12_hours": "Últimas 12 horas",
    "mobile_sensor_start_cooldown_process": "Iniciar novo processo de resfriamento",
    "mobile_sensor_cooldown_process_title": "Processo de resfriamento de duas etapas",
    "mobile_sensor_cooldown_process_description": "Um processo de resfriamento de duas etapas consiste em resfriar alimentos com mais de {{ stage1_start_temperature }} para {{ stage1_end_temperature }} em duas horas ou menos, e depois de {{ stage1_end_temperature }} para {{ stage2_end_temperature }} em quatro horas ou menos.",
    "mobile_sensor_cooldown_process_place_food": "Coloque o produto alimentício no refrigerador.",
    "mobile_sensor_cooldown_process_insert_sensor": "Insira uma sonda sensora no produto alimentício.",
    "mobile_sensor_cooldown_process_enter_information": "Insira as informações abaixo.",
    "mobile_sensor_cooldown_process_food_product": "Produto alimentício para resfriamento",
    "mobile_sensor_cooldown_cool_down": "Resfriar",
    "mobile_sensor_cooldown_select_sensor": "Selecionar sensor",
    "mobile_sensors_cooldown_start_cooldown": "Iniciar resfriamento",
    "mobile_sensors_cooldown_please_enter_food": "Insira um produto alimentício",
    "mobile_sensors_cooldown_please_select_sensor": "Selecione um sensor",
    "mobile_sensors_cooldown_status_in_progress": "Em andamento",
    "mobile_sensors_cooldown_status_failed": "Malsucedido",
    "mobile_sensors_cooldown_status_success": "Bem-sucedido",
    "mobile_sensors_cooldown_stage": "Etapa",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "A temperatura inicial está fora do intervalo",
    "mobile_sensors_cooldown_failed_cooldown_process": "Processo de resfriamento malsucedido",
    "mobile_sensors_cooldown_cooldown_successful": "Resfriamento bem-sucedido",
    "mobile_sensors_cooldown_started_cooldown_process": "Processo de resfriamento iniciado",
    "mobile_sensors_cooldown_hour": "hora",
    "mobile_sensors_cooldown_hour_plural": "horas",
    "mobile_sensors_cooldown_minute": "minuto",
    "mobile_minutes_plural": "minutos",
    "mobile_sensors_last_reading_max_date": "> de 1 ano atrás",
    "mobile_sensors_minute_count_ago": "{{count}} minuto atrás",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minutos atrás",
    "mobile_sensors_hour_count_ago": "{{count}} hora atrás",
    "mobile_sensors_hour_count_ago_plural": "{{count}} horas atrás",
    "mobile_sensors_day_count_ago": "{{count}} dia atrás",
    "mobile_sensors_day_count_ago_plural": "{{count}} dias atrás",
    "mobile_sensors_chart_settings": "Configurações do gráfico",
    "mobile_announcement_banner_continue_reading": "Continuar leitura",
    "mobile_compliance_submissions_report": "Relatório de envios",
    "mobile_compliance_submissions_report_subtitle": "Exportar dados de conclusão do projeto desta loja",
    "mobile_compliance_send_submissions": "Enviar envios",
    "mobile_compliance_completion_rate_in_last_days": "Taxa de conclusão dos últimos {{ days }} dias",
    "mobile_compliance_last_days": "Últimos {{ days }} dias",
    "mobile_compliance_send_submissions_to": "Enviar envios para",
    "mobile_compliance_send_to_different_email": "Enviar para email diferente",
    "mobile_compliance_email_input_placeholder": "Endereço de email",
    "mobile_compliance_send_submissions_to_legend_title": "Envios",
    "mobile_compliance_send_submissions_to_legend_description_days": "Um relatório com os envios dos últimos {{ days }} dias deste local será enviado para o email selecionado.",
    "mobile_compliance_time_frame": "Período",
    "mobile_compliance_sensor_temperature_log_report": "Relatório de registro da temperatura do sensor",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exportar registros de temperatura desta loja",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Critérios",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Defina os critérios do seu relatório abaixo.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Nota: os sensores desativados não aparecerão no relatório",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Selecione um período. Os dados dos registros têm um limite de 30 dias",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Enviar relatório",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Este mês (1º - Hoje)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Mês anterior",
    "mobile_compliance_sensor_temperature_log_email_title": "Enviar relatório para",
    "mobile_pwa_update_prompt_title": "Atualizar aplicativo",
    "mobile_pwa_update_prompt_description": "Uma nova versão do aplicativo está disponível. Atualize para a versão mais recente.",
    "mobile_pwa_update_prompt_confirm": "Atualizar e recarregar",
    "mobile_pwa_update_prompt_cancel": "Lembrar-me mais tarde",
    "notification_title_due_in_one_hour": "Entrega em 1 hora",
    "task_is_due_soon": "“{{ task_title }}” está previsto em breve. Reserve um momento para concluir.",
    "mobile_photo_quality_warning_header": "Problema de qualidade da foto",
    "mobile_photo_quality_dialog_message": "Esta foto pode estar escura demais ou borrada. Quer tirar uma nova foto ou prosseguir com esta?",
    "mobile_take_new_photo": "Tirar nova foto",
    "mobile_use_this_photo": "Usar esta foto"
}};
mobile_translations.fr_FR = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Tous",
    "mobile_common_button_apply_filters": "Appliquer des filtres",
    "mobile_common_button_done": "Terminé",
    "mobile_common_button_edit": "Modifier",
    "mobile_common_button_archive": "Archiver",
    "mobile_common_button_save": "Enregistrer",
    "mobile_common_button_retake": "Reprendre",
    "mobile_common_button_save_draft": "Enregistrer l'ébauche",
    "mobile_common_button_discard": "Ignorer",
    "mobile_common_button_submit": "Envoyer",
    "mobile_common_button_no": "Non",
    "mobile_common_button_yes": "Oui",
    "mobile_common_button_na": "Sans objet",
    "mobile_common_created_by_me": "Créé par moi",
    "mobile_common_email": "E-mail de l'entreprise",
    "mobile_common_first_name": "Prénom",
    "mobile_common_last_name": "Nom",
    "mobile_common_location": "Emplacement",
    "mobile_common_locations": "Emplacements",
    "mobile_common_logout_message": "Souhaitez-vous réellement vous déconnecter ?",
    "mobile_common_password": "Mot de passe",
    "mobile_common_permission_required": "Autorisation requise",
    "mobile_common_status": "Statut",
    "mobile_common_task": "Tâche",
    "mobile_common_tasks": "Tâches",
    "mobile_common_tasks_my": "Mes tâches",
    "mobile_common_projects": "Projets",
    "mobile_common_filter_team": "Équipe",
    "mobile_common_filter_var_in": " en {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Aucune équipe sélectionnée",
    "mobile_common_filter_no_user_selected": "Aucun utilisateur sélectionné",
    "mobile_common_filter_no_role_selected": "Aucun rôle sélectionné",
    "mobile_common_placeholder_date": "Date",
    "mobile_common_message_task_creator_error_save": "<b>Impossible de créer des tâches.</b>",
    "mobile_common_camera": "Appareil photo",
    "mobile_common_microphone": "Micro",
    "mobile_common_for": "pour",
    "mobile_common_reload": "Recharger",
    "mobile_common_override": "Écraser",
    "mobile_common_notifications": "Notifications",
    "mobile_common_chat_unavailable": "Chat non disponible. Réessayez plus tard.",
    "mobile_common_chat_ending_dialog_title": "Avez-vous terminé cette conversation ?",
    "mobile_common_chat_ending_dialog_description": "Dites-nous si votre problème a été résolu ou si vous souhaitez simplement continuer plus tard.",
    "mobile_common_chat_ending_dialog_confirm": "Oui, j’ai terminé",
    "mobile_common_chat_ending_dialog_cancel": "Je continuerai plus tard",
    "mobile_common_continue_editing": "Continuer à modifier",
    "mobile_privacy_policy": "Politique de confidentialité",
    "wootric_recommend_target": "un ami ou un collègue de votre secteur d'activité",
    "wootric_followup_detractor_question": "Que pouvons-nous modifier pour que vous nous accordiez une meilleure note la prochaine fois ?",
    "wootric_followup_passive_question": "Merci ! Que pouvons-nous faire pour améliorer notre outil ?",
    "wootric_followup_promoter_question": "Merci ! Qu'est-ce que vous appréciez dans « Crunchtime Ops Execution » ?",
    "wootric_followup_promoter_question_old": "Merci ! Qu'appréciez-vous dans Zenput ?",
    "wootric_default_followup_question": "Merci ! Auriez-vous l'amabilité de nous dire pourquoi ?",
    "wootric_default_placeholder_text": "Aidez-nous en donnant les raisons de votre évaluation.",
    "wootric_default_thankyou_text": "Merci de votre réponse et de vos commentaires !",
    "mobile_login_placeholder_login_as": "Se connecter avec l'ID utilisateur",
    "mobile_login_button_forgot_password": "Mot de passe oublié ?",
    "mobile_login_button_sign_up": "Créer le compte",
    "mobile_login_button_finish_setup": "Terminer la configuration",
    "mobile_login_button": "Se connecter",
    "mobile_login_continue_button": "Continuer",
    "mobile_login_continue_transition": "accès à la page d'accueil de votre organisation...",
    "mobile_login_no_email_error": "Vous devez saisir un e-mail.",
    "mobile_login_change_email": "Se connecter avec un autre e-mail",
    "mobile_login_with_sso": "Se connecter avec SSO",
    "mobile_oauth_no_user_error_message": "Il semblerait que vous n'avez pas de compte Crunchtime Ops Execution !",
    "mobile_oauth_no_user_error_message_old": "Il semble que vous ne possédez pas de compte Zenput !",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> s'appelle désormais <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "En septembre, {{- brand }} devient {{- product }}. {{- cta }}",
    "mobile_rebrand_warning_cta": "Découvrez comment vous y préparer.",
    "mobile_oauth_no_user_error_sub_message": "Contactez votre administrateur pour disposer d'un accès ou essayez de vous connecter avec un autre e-mail.",
    "mobile_oauth_generic_error_message": "Il semble qu'il existait un problème de connexion. Veuillez réessayer.",
    "mobile_oauth_force_logout_msg": "Si vous rencontrez encore des problèmes, déconnectez-vous de votre fournisseur en ",
    "mobile_oauth_force_logout_click": "cliquant ici.",
    "mobile_sign_up_placeholder_phone": "Numéro de téléphone mobile",
    "mobile_sign_up_placeholder_password_confirm": "Confirmer le mot de passe",
    "mobile_sign_up_button_sign_in": "S'identifier",
    "mobile_sign_up_disclaimer_part_1": "En cliquant sur Créer le compte, vous acceptez les",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "En cliquant sur Terminer la configuration, vous acceptez la",
    "mobile_sign_up_disclaimer_link_title": " Contrat de licence",
    "mobile_sign_up_disclaimer_part_2": ", qui contient d'importantes informations personnelles",
    "mobile_dialog_benefits_work_offline": "Travailler hors ligne",
    "mobile_dialog_benefits_faster_uploads": "Chargements plus rapides",
    "mobile_dialog_benefits_better_experience": "Meilleure expérience",
    "mobile_dialog_benefits_button_download": "Télécharger",
    "mobile_dialog_benefits_button_download_bold": "Crunchtime Ops Execution pour ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput pour ",
    "mobile_dialog_benefits_button_have": "J'ai l'application !",
    "mobile_dialog_benefits_button_no_thanks": "Non merci. Peut-être plus tard.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Échec du chargement de l'image.",
    "mobile_dialog_signature_sign": "Signer ici",
    "mobile_dialog_signature_button_clear": "Effacer",
    "mobile_account_placeholder_name": "Nom de l'emplacement/du magasin",
    "mobile_account_placeholder_phone": "Téléphone",
    "mobile_account_placeholder_address": "Adresse",
    "mobile_account_placeholder_city": "Ville",
    "mobile_account_placeholder_region": "Région",
    "mobile_account_placeholder_zipcode": "Code postal",
    "mobile_account_option_select_country": "Sélectionner le pays",
    "mobile_account_oprion_us": "États-Unis",
    "mobile_account_oprion_select_state": "Sélectionner l'État",
    "mobile_account_button_create_location": "Créer l'emplacement",
    "mobile_form_message_no_form": "Aucun formulaire disponible",
    "mobile_batch_task_message": "Chargement…",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Téléphone mobile",
    "mobile_settings_profile_language": "Langue",
    "mobile_settings_profile_temperature_unit": "Unité de température",
    "mobile_settings_profile_use_company_default": "Utiliser la valeur par défaut de l’entreprise",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Message texte",
    "mobile_settings_notifications_option_push": "Notifications « push »",
    "mobile_settings_notifications_option_push_email": "E-mail et notifications « push »",
    "mobile_settings_notifications_option_do_not": "Ne pas notifier",
    "mobile_settings_notifications_category_communication": "Communication",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulaires et déclencheurs",
    "mobile_settings_devices": "Appareils",
    "mobile_settings_notifications_sub_category_alerts": "Alertes",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nouveaux formulaires disponibles",
    "mobile_settings_notifications_sub_category_task_assigned": "Tâche affectée",
    "mobile_settings_notifications_sub_category_task_completed": "Tâche terminée",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Rappel des tâches à échéance prochaine",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Rappel des tâches en retard",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Alertes de capteur",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alertes de capteur critiques",
    "mobile_drafts_message": "Vous n'avez pas encore d'ébauches.",
    "mobile_drafts_button_delete": "Supprimer",
    "mobile_tasks_filter_location_no": "Aucun emplacement sélectionné",
    "mobile_tasks_filter_group_by": "Regrouper par",
    "mobile_tasks_filter_sort_by": "Trier par",
    "mobile_tasks_filter_sorted_by": "Trié(s) par",
    "mobile_tasks_filter_due_time": "Heure d'échéance",
    "mobile_tasks_filter_open_time": "Heure d'ouverture",
    "mobile_tasks_bucket_due_next_24_hours": "Échéance dans 24 heures",
    "mobile_tasks_bucket_due_next_7_days": "Échéance dans 7 jours",
    "mobile_tasks_bucket_open_tasks": "Autres {{type}} ouverts",
    "mobile_tasks_bucket_open_at": "Ouvert : {{- date }} à {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Échéance le : {{- date }} à {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponible dans 1 minute",
    "mobile_tasks_bucket_available_in_one_hour": "Disponible dans 1 heure",
    "mobile_tasks_bucket_available_in_one_day": "Disponible dans 1 jour",
    "mobile_tasks_bucket_available_in_one_week": "Disponible dans 1 semaine",
    "mobile_tasks_bucket_available_in_one_month": "Disponible dans 1 mois",
    "mobile_tasks_bucket_available_in_one_year": "Disponible dans 1 an",
    "mobile_tasks_bucket_available_in_minutes": "Disponible dans {{ minutes }} minutes",
    "mobile_tasks_bucket_available_in_hours": "Disponible dans {{ hours }} heures",
    "mobile_tasks_bucket_available_in_days": "Disponible dans {{ days }} jours",
    "mobile_tasks_bucket_available_in_weeks": "Disponible dans {{ weeks }} semaines",
    "notification_task_due_in_minutes": "Attendu dans {{ minutes }} minutes",
    "mobile_tasks_bucket_available_in_months": "Disponible dans {{ months }} mois",
    "mobile_tasks_bucket_available_in_years": "Disponible dans {{ years }} ans",
    "mobile_tasks_follow_up": "Tâche de suivi",
    "mobile_tasks_due_soon": "Sous peu",
    "mobile_tasks_bucket_completed_today": "Effectuée aujourd'hui",
    "mobile_tasks_bucket_completed_this_week": "Effectuée cette semaine",
    "mobile_tasks_bucket_completed_last_week": "Effectuée la semaine dernière",
    "mobile_tasks_bucket_missed_today": "Manquée aujourd'hui",
    "mobile_tasks_bucket_missed_this_week": "Manquée cette semaine",
    "mobile_tasks_bucket_missed_last_week": "Manquée la semaine dernière",
    "mobile_tasks_bucket_no_location": "Aucun emplacement",
    "mobile_tasks_cannot_submit_missed": "Les tâches manquées ne peuvent être effectuées.",
    "mobile_tasks_cannot_submit_missed_after": "Cette tâche ne peut être effectuée après le {{ date }}.",
    "mobile_tasks_cannot_submit_upcoming": "Cette tâche n'a pas démarré.",
    "mobile_tasks_cannot_submit_processing": "Cet envoi est en cours de traitement.",
    "mobile_tasks_toolbarnav_header_no_due_date": "Aucune date d'échéance",
    "mobile_tasks_toolbarnav_header_overdue": "En retard",
    "mobile_tasks_toolbarnav_header_yesterday": "Hier",
    "mobile_tasks_toolbarnav_header_today": "Aujourd'hui",
    "mobile_tasks_toolbarnav_header_tomorrow": "Demain",
    "mobile_tasks_toolbarnav_header_last_week": "La semaine dernière",
    "mobile_tasks_toolbarnav_header_this_week": "Cette semaine",
    "mobile_tasks_toolbarnav_header_next_week": "La semaine prochaine",
    "mobile_tasks_toolbarnav_header_this_month": "Ce mois",
    "mobile_tasks_toolbarnav_header_next_year": "L'année prochaine",
    "mobile_tasks_toolbarnav_header_over_year": "Plus d'un an",
    "mobile_tasks_toolbarnav_title_edit_task": "Modifier la tâche",
    "mobile_task_placeholder_title": "Titre *",
    "mobile_task_placeholder_description": "Description (facultatif)",
    "mobile_task_button_single_task": "Tâche unique",
    "mobile_task_button_project": "Projet",
    "mobile_task_button_create": "Créer",
    "mobile_task_tab_basic": "Élémentaire",
    "mobile_task_tab_photo": "Photo",
    "mobile_task_tab_form": "Formulaire",
    "mobile_task_details_description_message_please": "Veuillez remplir ",
    "mobile_task_details_description_message_below": "ci-dessous.",
    "mobile_task_details_description_message_instructions": "Aucune instruction n'est disponible pour cette tâche.",
    "mobile_task_details_reason_title": "Suivi déclenché par",
    "mobile_task_detials_button_goto_form": "Accéder au formulaire",
    "mobile_task_detials_button_complete": " Effectuer la tâche",
    "mobile_task_detials_completed": "Effectué ",
    "mobile_task_detials_completed_by": "par ",
    "mobile_task_detials_completed_on": "le ",
    "mobile_task_details_view_form_submission": "Afficher l'envoi de formulaire",
    "mobile_task_task_updated": "Tâche mise à jour",
    "mobile_task_task_archived": "Tâche archivée",
    "mobile_task_task_deleted": "Tâche supprimée",
    "mobile_task_error_archiving_task": "Impossible d'archiver la tâche.",
    "mobile_task_error_deleting_task": "Impossible de supprimer la tâche.",
    "mobile_task_error_updating_task": "Impossible de mettre à jour la tâche.",
    "mobile_task_archive_task": "Archiver la tâche",
    "mobile_task_archive_task_confirm": "Souhaitez-vous réellement archiver cette tâche ?\n\nLes tâches archivées seront prises en compte dans le calcul des taux d'avancement et continueront à figurer dans le reporting.\n\nCette opération ne pourra pas être annulée.",
    "mobile_task_delete_task_confirm": "Souhaitez-vous réellement clôturer cette tâche ?\n\nLes tâches supprimées ne seront pas prises en compte dans le calcul des taux d'avancement et ne figureront pas dans le reporting.\n\nCette opération ne pourra pas être annulée.",
    "mobile_task_edition_already_in_progress": "Une modification est en attente pour cette tâche. Aucune autre modification n'est actuellement autorisée.",
    "mobile_projects_filter_type": "Type",
    "mobile_projects_filter_status": "Statut du projet",
    "mobile_projects_filter_project_type": "Type de projet",
    "mobile_projects_due_date_required": "La date d'échéance est obligatoire.",
    "mobile_projects_team_required": "L'équipe est obligatoire.",
    "mobile_projects_user_role_required": "La personne affectée est obligatoire.",
    "mobile_projects_title_required": "Le titre est obligatoire.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Plusieurs tâches par jour",
    "mobile_project_tasks_complete": " Effectuer",
    "mobile_project_tasks_remaining": " Restantes",
    "mobile_esitmate_message_tasks": "Aucune tâche ne sera créée",
    "mobile_esitmate_message_criteria": "Ajuster le critère ci-dessus",
    "mobile_esitmate_message_created_for": "sera créé pour",
    "mobile_left_menu_dashboard": "Tableau de bord",
    "mobile_left_menu_my_forms": "Mes formulaires",
    "mobile_left_menu_announcements": "Annonces",
    "mobile_left_menu_my_submissions": "Mes envois",
    "mobile_left_menu_drafts": "Ébauches",
    "mobile_left_menu_pending_uploads": "Chargements en attente",
    "mobile_left_menu_open": "Ouvrir le mode « In-app »",
    "mobile_left_menu_settings": "Réglages",
    "mobile_left_menu_log_out": "Se déconnecter",
    "mobile_left_menu_debug": "Déboguer",
    "mobile_left_menu_support": "Support",
    "mobile_left_menu_documentation": "Documentation",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Note ou légende",
    "mobile_field_option_select": "Sélectionner",
    "mobile_field_text_placeholder_text": "Texte",
    "mobile_field_email_placehoder_email": "L'e-mail",
    "mobile_filed_number_placeholder_number": "Numéro",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Non connecté",
    "mobile_field_sensor_offline_battery": "Capteur hors ligne - Batterie",
    "mobile_field_video_button_add": "Ajouter une vidéo",
    "mobile_field_video_picker_dialog_title": "Ajouter une vidéo à partir de",
    "mobile_field_video_button_change": "Modifier la vidéo",
    "mobile_field_image_button_add": "Ajouter l'image",
    "mobile_field_image_low_quality_warning": "Certaines photos peuvent être trop sombres ou trop floues. Vérifiez les photos mises en avant et remplacez-les si nécessaire.",
    "mobile_field_image_picker_dialog_title": "Ajouter une photo à partir de",
    "mobile_field_image_picker_edit_failed": "Impossible d'enregistrer l'image. Veuillez réessayer.",
    "mobile_field_signature_button_add": "Ajouter une signature",
    "mobile_field_signature_button_change": "Modifier la signature",
    "mobile_field_account_select_location": "Sélectionner un emplacement",
    "mobile_field_account_prefill": "Pré-remplir le formulaire avec les données de la dernière visite ?",
    "mobile_field_account_message_overwrite": "Cette action va écraser tous les champs déjà renseignés.",
    "mobile_forms_task_on_behalf": "Une tâche affectée à <b>{{user}}</b> doit être accomplie à cet emplacement. Souhaitez-vous accomplir cette tâche ?",
    "mobile_forms_complete_task": "Accomplir la tâche ?",
    "mobile_field_account_prefill_button_yes": "Oui, pré-remplir",
    "mobile_field_barcode_placeholder_scan": "Scanner ou saisir le code-barres",
    "mobile_field_sensor_qr_code_placeholder_scan": "Scanner ou saisir le code",
    "mobile_field_gateway_id_code_placeholder": "ID de nœud de type",
    "mobile_field_scan_qr_or_enter_dev_eui": "Scanner le code QR ou saisir le DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Scanner le code QR ou saisir l'ID",
    "mobile_field_scan_qr_or_enter_sc": "Scanner le code QR ou saisir le code SC",
    "mobile_field_barcode_select_date": "Sélectionner la date ",
    "mobile_field_datetime_allow_time": "Temps",
    "mobile_field_stopwatch_button_caption": "Chronomètre",
    "mobile_field_stopwatch_common_start": "Démarrer",
    "mobile_field_stopwatch_common_stop": "Arrêter",
    "mobile_field_stopwatch_common_reset": "Réinitialiser",
    "mobile_field_stopwatch_stop_stopwatches": "Arrêter les chronomètres",
    "mobile_field_document_title": "Ajouter le document",
    "mobile_field_document_message_delete": "Souhaitez-vous réellement supprimer ce document ?",
    "mobile_field_document_alret_button_view": "Afficher",
    "mobile_field_document_alert_error": "Une erreur s'est produite lors de la mise en pièce jointe de ce document. Veuillez réessayer.",
    "mobile_field_document_alert_file_size_error": "Le fichier ne peut pas dépasser {{count}} Mo.",
    "mobile_field_temperature_greater_range": "supérieur(e) à {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "supérieur(e) ou égal(e) à {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "inférieur(e) à {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "inférieur(e) ou égal(e) à {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "supérieur(e) ou égal(e) à {{ min_temp_value }} °{{ temp_unit }} et inférieur(e) à {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "supérieur(e) ou égal(e) à {{ min_temp_value }} °{{ temp_unit }} et inférieur(e) ou égal(e) à {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " et ",
    "mobile_field_text_limit_error": "Limite maximale de 8 000 caractères atteinte.",
    "mobile_forms_required_questions_complete": "Questions obligatoires complétées",
    "mobile_forms_required_remaining": "{{count}} obligatoires restants",
    "mobile_forms_required_questions_back": "Retour",
    "mobile_forms_required_questions_next": "Suivant",
    "mobile_forms_required_questions_skip": "Ignorer",
    "mobile_forms_leaving_form": "Sortie du formulaire",
    "mobile_message_reordering_confirm": "Voulez-vous enregistrer le nouvel ordre des questions ?",
    "mobile_forms_leaving_reordering": "Sortie de la réorganisation des questions",
    "mobile_forms_reordering_button_save": "Enregistrer le nouvel ordre des questions",
    "mobile_forms_reordering_instructions": "Pour réorganiser les questions ou sections, faites glisser le champ à l'emplacement désiré",
    "mobile_toolbarnav_title_my_setttings": "Mes réglages",
    "mobile_toolbarnav_title_profile_settings": "Réglages du profil",
    "mobile_toolbarnav_title_notification": "Réglages des notifications",
    "mobile_toolbarnav_title_form_history": "Historique du formulaire",
    "mobile_toolbarnav_title_form_not_available": "Formulaire non disponible",
    "mobile_toolbarnav_title_add_location": "Ajouter l'emplacement",
    "mobile_toolbarnav_title_add_task_or_project": "Ajouter la tâche ou le projet",
    "mobile_toolbarnav_title_select_location": "Sélectionner l'emplacement",
    "mobile_toolbarnav_title_select_project": "Sélectionner le projet",
    "mobile_toolbarnav_title_select_tag": "Sélectionner l'étiquette",
    "mobile_toolbarnav_title_select_user": "Sélectionner l'utilisateur",
    "mobile_toolbarnav_title_select_template": "Sélectionner le modèle",
    "mobile_toolbarnav_title_select_one": "Faire une sélection",
    "mobile_toolbarnav_title_select_multiple": "Sélectionner un ou plusieurs éléments",
    "mobile_toolbarnav_title_select_team": "Sélectionner l'équipe",
    "mobile_toolbarnav_title_select_team_or_location": "Sélectionner l'équipe ou l'emplacement",
    "mobile_toolbarnav_title_filter_tasks": "Filtrer les tâches",
    "mobile_toolbarnav_title_filter_projects": "Filtrer les projets",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrer les tâches du projet",
    "mobile_placeholder_search_bar": "Rechercher",
    "mobile_placeholder_user_select_role": "Sélectionner le rôle d'utilisateur",
    "mobile_placeholder_filter_by_team": "Filtrer selon une équipe",
    "mobile_placeholder_assign_to_user_role": "Affecter au rôle d'utilisateur",
    "mobile_placeholder_select": "-- Sélectionner --",
    "mobile_placeholder_account_location_name": "Nom de l'emplacement",
    "mobile_placeholder_tag_filter_by": "Filtrer par étiquette d'emplacement",
    "mobile_placeholder_user_type": "Affecter à l'utilisateur",
    "mobile_placeholder_acount_type_loading": "Chargement… ",
    "mobile_placeholder_therm_no_bluetooth": "Température",
    "mobile_placeholder_blue_therm_connecting": "Connexion à l'appareil…",
    "mobile_placeholder_blue_therm_please_wait": "Veuillez patienter…",
    "mobile_placeholder_blue_therm_tap": "Touchez pour lire.",
    "mobile_placeholder_blue_therm_not_connected": "Non connecté.",
    "mobile_placeholder_testo_tap": "Maintenir ▼▲ suivi par ⬆",
    "mobile_message_error_create_task": "Vous devez être en ligne pour ajouter des tâches.",
    "mobile_message_error_fill_out_form": "Veuillez remplir le formulaire.",
    "mobile_message_error_fill_require_fields": "Renseignez les champs obligatoires.",
    "mobile_message_error_stop_stopwatch_before_submit": "Arrêtez votre chronomètre avant l'envoi",
    "mobile_message_error_stopwatch_field_required": "Le champ Chronomètre est obligatoire",
    "mobile_message_error_stopwatch_field_running": "Le champ Chronomètre est actif",
    "mobile_message_error_invalid_equipment_temperature": "Température de l'équipement non valide",
    "mobile_message_error_invalid_ingredient_temperature": "Température de l'ingrédient non valide",
    "mobile_message_error_location_attributes_unavailable": "Certaines questions ne seront peut-être pas disponibles. Veuillez vous connecter à Internet.",
    "mobile_message_alert_running_stopwatches": "Vous avez des chronomètres actifs.\n\nSouhaitez-vous les effacer ?",
    "mobile_message_blue_therm_error": "Connexion perdue avec l'appareil Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "L'accès à l'emplacement est requis. Activez cette option dans les paramètres de votre appareil Android.",
    "mobile_message_blue_therm_no_permission_android": "L'accès à la fonction « Appareils à proximité » est requis. Activez cette option dans les paramètres de votre appareil Android.",
    "mobile_message_blue_therm_error_code": "Échec de la connexion :",
    "mobile_message_blue_therm_error_bluetooth": "Veuillez activer le Bluetooth.",
    "mobile_message_blue_therm_error_device": "Appareil introuvable.",
    "mobile_message_blue_therm_error_try_again": "Veuillez réessayer",
    "mobile_message_blue_therm_success": "Connecté à l'appareil Bluetooth !",
    "mobile_message_bluetooth_device_press_button_field": "Appuyez sur le bouton de votre appareil pour vous connecter.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Appuyez sur le bouton de votre appareil<br />si vous ne le voyez pas sur cette liste.",
    "mobile_bluetooth_scan": "Scanner",
    "mobile_bluetooth_scanning": "Scan",
    "mobile_message_drafts_confirm": "Souhaitez-vous l'enregistrer en tant qu'ébauche ?",
    "mobile_message_drafts_toast_saved": "Ébauche enregistrée.",
    "mobile_message_drafts_request_update": "Souhaitez-vous mettre à jour cette ébauche ?",
    "mobile_message_drafts_form_confirm": "Souhaitez-vous réellement supprimer cette ébauche ?",
    "mobile_message_drafts_confirm_delete": "Supprimer l'ébauche",
    "mobile_message_streams_error_switch": "Impossible de modifier les flux sur le Web",
    "mobile_message_settings_success_saved": "Réglages enregistrés",
    "mobile_message_settings_error": "Une erreur inconnue est survenue. Réessayez ultérieurement",
    "mobile_message_profile_settings_error_fields": "Veuillez corriger les champs surlignés.",
    "mobile_message_media_perimission_denied": "Votre ",
    "mobile_message_media_perimission_denied_device": "Stockage de l'appareil",
    "mobile_message_image_confirm_remove_image": "Souhaitez-vous réellement supprimer cette photo ?",
    "mobile_message_create_account_error_fields": "Veuillez renseigner les champs surlignés.",
    "mobile_message_create_account_success_location_created": "Emplacement créé",
    "mobile_message_task_error_get_location": "Échec de l'obtention de l'emplacement. Classement par date.",
    "mobile_message_typehead_confirm_save_message": "Souhaitez-vous enregistrer ces sélections ?",
    "mobile_message_typehead_confirm_save_title": "Enregistrer ?",
    "mobile_message_task_creator_error_save_select_form": "Vous devez sélectionner un formulaire.",
    "mobile_message_task_creator_error_save_required_fields": "Veuillez renseigner les champs obligatoires.",
    "mobile_message_task_creator_error_save_batch_change": "Veuillez modifier les critères pour qu'ils correspondent à un ou plusieurs utilisateurs",
    "mobile_message_task_detials_error_not_assigned_to_you": "Cette tâche ne vous est pas affectée.<br />Vous ne pouvez pas l'effectuer.",
    "mobile_message_task_detials_error_assigned_to": "Cette tâche est affectée à {{user}}.<br />Vous ne pouvez pas l'effectuer.",
    "mobile_message_task_detials_confirm_title": "Sortie de la tâche",
    "mobile_message_task_detials_confirm_save_task": "Enregistrer la tâche",
    "mobile_message_task_detials_confirm_message": "Vos modifications seront perdues. Souhaitez-vous réellement continuer ?",
    "mobile_message_task_detials_error_view_account": "Impossible d'accéder à l'emplacement.",
    "mobile_message_task_detials_error_submit_task": "Veuillez ajouter une photo pour effectuer cette tâche.",
    "mobile_message_task_detials_error_submit_task_project": "Impossible d'enregistrer le projet. Veuillez réessayer ultérieurement.",
    "mobile_message_task_detials_wait_submit_task_created": "Des tâches sont en cours de création.<br />Patientez quelques minutes pour que ces tâches soient renseignées.",
    "mobile_message_task_detials_error_submit_task_pending": "Erreur, veuillez réessayer ultérieurement",
    "mobile_message_task_detials_success_task_complete": "Tâche effectuée",
    "mobile_message_task_error_save_single_task": "Impossible d'enregistrer la tâche. Veuillez réessayer ultérieurement.",
    "mobile_message_task_success_save_single_task": "Tâche créée.",
    "mobile_message_show_error_message": "Un problème est survenu.",
    "mobile_message_show_success_message": "Opération réussie !",
    "mobile_message_show_offline_message": "Vous êtes actuellement hors ligne.",
    "mobile_message_show_permission_denied_message": "<b>Autorisation requise.</b> Veuillez accorder à Zenput l'autorisation d'accès à {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Autorisation requise.</b> Veuillez accorder à Zenput et à votre navigateur l'autorisation d'accès à {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "En cours de chargement",
    "mobile_message_show_upload_in_progress_message": "Téléchargement déjà en cours",
    "mobile_message_show_form_id_error": "Impossible d'accéder au formulaire spécifié.",
    "mobile_message_show_single_task_error": "Impossible d'accéder à la tâche spécifiée.",
    "mobile_message_show_submissions_error": "Impossible d'accéder à l'envoi spécifié.",
    "mobile_message_show_submissions_access_denied": "Désolé, mais vous n'avez pas accès à ce formulaire.",
    "mobile_message_send_data_success": "Données téléchargées ",
    "mobile_message_start_upload_success": "Chargement terminé",
    "mobile_message_start_upload_error": "<b>Impossible d'effectuer le chargement.</b><br>Envoi enregistré. Réessayez ultérieurement",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Mise à jour disponible",
    "mobile_message_store_upgrade_confirm_message_one": "Veuillez mettre à jour l'application « Ops Execution » depuis le ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Veuillez mettre à jour Zenput depuis le ",
    "mobile_message_store_upgrade_confirm_message_two": " pour obtenir les nouvelles fonctionnalités et les correctifs",
    "mobile_message_store_upgrade_confirm_now": "Maintenant",
    "mobile_message_store_upgrade_confirm_later": "Plus tard",
    "mobile_message_redirect_confirm_message": "Vous remplissez actuellement un formulaire. Souhaitez-vous l'enregistrer en tant qu'ébauche avant de poursuivre ?",
    "mobile_message_log_out_confirm_unsynced_drafts": "{{count}} de vos ébauches n'ont pas encore été téléchargées. Elles seront perdues si vous continuez. Souhaitez-vous réellement continuer ?",
    "mobile_message_draft_override_message": "Ce brouillon a été enregistré depuis un autre appareil sur {{date}} et les modifications sur cet appareil sont en conflit. Vous pouvez choisir d'écraser la version existante ou de recharger la version la plus récente. Vos modifications seront alors ignorées.",
    "mobile_html_submitting": "Envoi…",
    "mobile_html_offline": "Vous êtes actuellement hors ligne !",
    "mobile_html_offline_try_again": "Vous êtes actuellement hors ligne. <br/><br/>Veuillez réessayer après vous être connecté",
    "mobile_html_something_went_wrong": "Hum. Un problème est survenu.",
    "mobile_html_something_went_wrong_try_again": "Hum. Un problème est survenu. Veuillez réessayer.",
    "mobile_html_failed_loading_roles": "Échec du chargement des rôles.",
    "mobile_alert_please_install_for_native": "Veuillez installer l'application Ops Execution pour pouvoir utiliser cette fonctionnalité. ",
    "mobile_alert_please_install_for_native_old": "Installez l'application Zenput native pour utiliser cette fonctionnalité.",
    "mobile_tso_filter_all_tasks": "Tous les {{type}}",
    "mobile_tso_filter_my_tasks": "Mon {{type}}",
    "mobile_tso_filter_due_date": "Date d'échéance",
    "mobile_tso_filter_date_completed": "Date d'achèvement",
    "mobile_tso_filter_completed": "Effectué",
    "mobile_tso_filter_completed_late": "Terminé en retard",
    "mobile_tso_filter_incomplete": "Incomplet",
    "mobile_tso_filter_var_my_tasks": "Mon {{filter_type}} - {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} - {{type}} Créé par moi",
    "mobile_tso_filter_var_all_tasks": "Tous les {{filter_type}} - {{type}}",
    "mobile_tso_type_follow_up_actions": "Actions de suivi",
    "mobile_tso_type_all": "Tâches et actions de suivi",
    "mobile_tso_filter_var_at": " à {{location}}",
    "mobile_tso_filter_group_date_due": ", classé par date d'échéance",
    "mobile_tso_filter_group_distance": ", groupé par emplacement",
    "mobile_tso_filter_start_date": "Date de Début",
    "mobile_tso_filter_none": "Aucun",
    "mobile_pso_filter_all_projects": "Tous les projets",
    "mobile_pso_filter_my_projects": "Mes projets",
    "mobile_pso_filter_active": "Actif",
    "mobile_pso_filter_archived": "Archivé",
    "mobile_pso_filter_recurring": "Récurrent",
    "mobile_pso_filter_non_recurring": "Non récurrent",
    "mobile_pso_filter_var_my_projects": "Mes {{project_type}} projets {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} projets créés par moi",
    "mobile_pso_filter_var_all_projects": "Tous les {{project_type}} projets {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Vous semblez être hors ligne. Mettez-vous en ligne pour consulter les résultats.",
    "mobile_empty_list_message_no_submissions": "Aucun envoi",
    "mobile_empty_list_message_no_activity": "Aucune activité",
    "mobile_empty_list_message_no_tasks": "Aucune tâche",
    "mobile_empty_list_message_no_tasks_overdue": "Aucun {{type}} en retard",
    "mobile_empty_list_message_no_accounts": "Aucun emplacement",
    "mobile_empty_list_message_no_projects": "Aucun projet",
    "mobile_empty_list_message_no_results_found": "Aucun résultat trouvé",
    "mobile_empty_list_message_no_forms_available": "Aucun formulaire disponible",
    "mobile_empty_list_message_connection_error": "Erreur de connexion<br />Veuillez réessayer.",
    "mobile_empty_list_message_dashboard_error": "Impossible de charger le tableau de bord",
    "mobile_empty_list_message_user_offline": "Vous êtes actuellement hors ligne.",
    "mobile_action_sheet_media_gallery": "Galerie",
    "mobile_action_sheet_cancel": "Annuler",
    "mobile_image_preview_text": "Supprimer la photo",
    "mobile_mobileform_text": "Envois précédents",
    "mobile_mobileform_reorder_fields": "Réorganiser les questions",
    "mobile_mobileform_follow_up_actions": "Actions de suivi",
    "mobile_mobileform_follow_up_actions_assign_title": "Affecter les actions de suivi",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Ajoutez les actions de suivi en fonction de vos observations, de manière à vous assurer que les problèmes soient traités.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Ajouter une action de suivi",
    "mobile_mobileform_follow_up_actions_assign_button": "Affecter les suivis",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continuer sans affecter",
    "mobile_mobileform_follow_up_actions_dialog_title": "Voulez-vous continuer sans affecter les actions de suivi ?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Si vous continuez sans affecter d'actions de suivi, vous ne pourrez plus en ajouter ultérieurement.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continuer malgré tout",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Ce champ est obligatoire",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Trop de caractères",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Ce champ n'est pas valide",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Erreur lors du chargement des emplacements",
    "mobile_mobileform_add_follow_up_actions_error_users": "Erreur lors du chargement des utilisateurs",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Ajouter le suivi",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Titre",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Description",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Exiger une photo",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Date d'échéance",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Mettre à jour le suivi",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Supprimer le suivi ?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Il sera supprimé et ne sera pas affecté.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Supprimer le suivi",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Souhaitez-vous réellement supprimer ce suivi ?\n\nCette action ne pourra être annulée.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Poursuivre jusqu'aux suivis",
    "mobile_mobileform_follow_up_actions_completed_notification": "Action de suivi terminée",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Action de suivi supprimée",
    "mobile_mobileform_follow_up_actions_update_notification": "Action de suivi mise à jour",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Veuillez ajouter une photo pour terminer cette action de suivi.",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Naviguer jusqu'à l'envoi",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Accéder à la source",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Source",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Terminer le suivi",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Si vous ouvrez l'envoi, toutes les photos et notes non enregistrées seront perdues.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Si vous quittez cet écran, toutes les photos et notes non enregistrées seront perdues.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Rester ici",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Ouvrir l'envoi",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Ouvrir la source",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Quitter cette action de suivi ?",
    "mobile_mobileform_follow_up_actions_submission": "Envoi",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Cette action de suivi est affectée à {{user}}.<br />Vous ne pouvez pas la terminer.",
    "mobile_mobileform_follow_up_actions_leave_description": "Si vous quittez cet écran, toutes les modifications non enregistrées seront perdues.",
    "mobile_mobileform_follow_up_actions_leave": "Quitter",
    "mobile_forms_drafts_text": "Supprimer les ébauches",
    "mobile_batch_estimate_user": "Utilisateur",
    "mobile_batch_estimate_users": "Utilisateurs",
    "mobile_table_of_contents": "Table des matières",
    "mobile_table_of_contents_required": "Obligatoire",
    "mobile_table_of_contents_optional": "Facultatif",
    "mobile_dialog_alert_title": "Alerte",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Les appareils Bluetooth ne sont pas encore pris en charge sur Windows",
    "mobile_windows_deprecated_message_content_announcement": "Annonce",
    "mobile_windows_deprecated_message_title": "Mise à jour de l'application requise",
    "mobile_windows_deprecated_message_description": "Installez la nouvelle application Zenput dans le Microsoft Store dès que possible pour profiter des mises à jour de fonctionnalités critiques et d'une expérience optimale sur Zenput.",
    "mobile_dashboard_tcr_graph_name": "Taux d'avancement de la tâche",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 dernières semaines",
    "mobile_dashboard_tcr_legend_company_average": "Moyenne de l'entreprise",
    "mobile_dashboard_tcr_legend_team_average": "Moyenne de l'équipe",
    "mobile_dashboard_tab_title_summary": "Récapitulatif",
    "mobile_dashboard_tab_title_activity": "Activité",
    "mobile_dashboard_card_title_top_triggered_workflows": "Principaux déclencheurs",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Conformité",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Semaine de",
    "mobile_dashboard_card_filter_form_template_placeholder": "Tous les formulaires",
    "mobile_dashboard_card_title_forms_top_nos": "« Non » fréquents",
    "mobile_dashboard_zenput_code_no_data_in_range": "Il n'existe aucune donnée dans cette plage de temps.",
    "mobile_dashboard_zenput_code_permission_denied": "Vous n'avez pas l'autorisation de consulter cet élément.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Sélectionnez un formulaire dans la liste ci-dessus.",
    "mobile_dashboard_zenput_code_unknown_error": "Nous ne pouvons pas afficher les données pour le moment.",
    "mobile_dashboard_tap_to_retry": "Touchez pour réessayer.",
    "mobile_dashboard_reporting_delay_disclaimer": "Le mise à jour des tâches peut prendre jusqu'à 15 minutes.",
    "mobile_dashboard_configuration_down_state_postfix_msg": "n'ont été configurés par votre administrateur.",
    "mobile_tasks_tag": "tâches",
    "mobile_workflows_tag": "déclencheurs",
    "mobile_projects_tag": "projets récurrents",
    "mobile_forms_tag": "formulaires",
    "mobile_dashboard_card_ongoing_projects_title": "Projets en cours",
    "mobile_dashboard_card_ongoing_projects_show_more": "Afficher plus",
    "mobile_dashboard_card_ongoing_projects_show_less": "Afficher moins",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Accéder aux projets",
    "mobile_dashboard_card_title_recurring_projects": "Projets récurrents",
    "mobile_dashboard_card_filter_daily": "Quotidien",
    "mobile_dashboard_card_filter_weekly": "Hebdomadaire",
    "mobile_dashboard_card_filter_monthly": "Mensuel",
    "mobile_task_status_title_open": "Ouvert",
    "mobile_task_status_title_upcoming": "À venir",
    "mobile_task_status_title_complete": "Effectuer",
    "mobile_task_status_title_processing": "Envoi en cours de traitement",
    "mobile_task_status_title_complete_with_exceptions": "Effectuer avec les alertes ou les tâches de suivi",
    "mobile_task_status_title_completed_late_with_exceptions": "Terminé en retard avec des tâches de suivi ou des alertes",
    "mobile_task_status_title_incomplete_and_closed": "Manquée",
    "mobile_tasks_legend_modal_title": "Légende",
    "mobile_tasks_legend_modal_footer_button_title": "Fermer",
    "mobile_common_assigned_to": "Affecté à",
    "mobile_common_created_by": "Créé par",
    "mobile_common_tasks_for": "Tâches pour",
    "mobile_common_go_back": "Retour",
    "mobile_oh_no": "Oh, non !",
    "mobile_user_not_in_groups": "Désolé, mais il semble que vous n'êtes pas affecté à une équipe. Contactez vous administrateur pour pouvoir accéder à votre tableau de bord.",
    "mobile_tasks_select_followers": "Sélectionner les followers",
    "mobile_tasks_assign_tasks": "Affecter {{count}} tâches",
    "mobile_tasks_add_followers": "Ajouter des followers",
    "mobile_tasks_followers": "Followers",
    "mobile_tasks_delete_task": "Supprimer la tâche",
    "mobile_tasks_create_task": "Créer des tâches",
    "mobile_tasks_tab_title_comments": "Commentaires",
    "mobile_tasks_see_more": "Afficher davantage",
    "mobile_projects_create_project": "Créer le projet",
    "mobile_common_button_send": "Envoyer",
    "mobile_common_button_schedule": "Planifier",
    "mobile_announcements_create": "Créer l'annonce",
    "mobile_announcements_read_rate": "{{opened_count}} sur {{recipients_count}} ouvert(s)",
    "mobile_announcements_empty_message": "Vous n'avez pas encore créé d'annonces ! Créez une annonce ci-dessous pour diffuser au sein de votre organisation des nouvelles, informations et mises à jour importantes.",
    "mobile_announcement_message_placeholder": "Ajouter un message...",
    "mobile_announcement_title_placeholder": "Titre de l'annonce",
    "mobile_announcement_leaving_announcement": "Sortie de l'annonce",
    "mobile_announcement_confirm_recipients_team": "Souhaitez-vous diffuser cette annonce à {{count}} utilisateur(s) répartis dans {{teams}} équipe(s) sélectionnée(s) ?",
    "mobile_announcement_confirm_recipients_role": "Souhaitez-vous diffuser cette annonce à {{count}} utilisateur(s) répartis dans {{roles}} rôle(s) d'utilisateur sélectionné(s) ?",
    "mobile_announcement_confirm_recipients_user": "Souhaitez-vous diffuser cette annonce à {{count}} utilisateur(s) ?",
    "mobile_announcement_confirm_scheduled": "Le {{timestamp}}",
    "mobile_announcement_sending_announcement": "Envoi de l'annonce",
    "mobile_announcement_send_to": "Envoyer à",
    "mobile_announcement_sent_to": "Envoyé à",
    "mobile_announcement_send_to_role": "Rôle",
    "mobile_announcement_attachment_download": "Téléchargement de {{filename}}",
    "mobile_announcement_attachment_validation_error": "Vous ne pouvez pas ajouter plus de {{maxCount}} pièces jointes",
    "mobile_announcement_details_sent": "Envoyé",
    "mobile_announcement_details_total_recipients": "Nombre total de destinataires",
    "mobile_announcement_details_cancel": "Annuler l'annonce",
    "mobile_announcement_details_not_editable": "Les annonces peuvent être modifiées uniquement dans l'application web « Ops Execution ». ",
    "mobile_announcement_details_not_editable_old": "Les annonces peuvent être modifiées uniquement sur Zenput Web.",
    "mobile_announcement_details_open_count": "Nombre de messages ouverts",
    "mobile_announcement_details_open_rate": "Taux de messages ouverts",
    "mobile_announcement_details_resend": "Envoyer à nouveau aux personnes qui n'ont pas ouvert de messages.",
    "mobile_announcement_confirm_resend": "{{count}} utilisateur(s) n'ont pas lu l'annonce. Souhaitez-vous envoyer un rappel ?",
    "mobile_announcement_confirm_resend_title": "Envoyer un rappel ?",
    "mobile_announcement_recipients_opened": "Ouvert(s)",
    "mobile_recipients_opened_empty_message": "Il semble que personne n'a encore ouvert votre message. Revenez ultérieurement pour consulter vos résultats.",
    "mobile_announcement_recipients_unopened": "Non Ouvert(s)",
    "mobile_recipients_unopened_empty_message": "Bonne nouvelle ! Tous les messages ont été ouverts !",
    "mobile_scheduled_announcements_delivery_section_header": "Heure de remise",
    "mobile_scheduled_announcements_send_immediately_label": "Envoyer immédiatement",
    "mobile_scheduled_announcements_scheduled_label": "Envoyer à une heure spécifique",
    "mobile_scheduled_announcements_scheduled_tab_label": "Planifié",
    "mobile_scheduled_announcements_dialog_header": "Annuler l'annonce ?",
    "mobile_scheduled_announcements_dialog_message": "L'annulation de votre annonce bloquera l'envoi de celle-ci et la supprimera de votre liste. Cette opération ne pourra pas être annulée. Pour modifier votre annonce, accédez à Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Vous n'avez pas actuellement d'annonces planifiées. Planifiez une annonce pour diffuser au sein de votre organisation des nouvelles, informations et mises à jour importantes.",
    "mobile_scheduled_announcements_validation_error": "L'heure de remise doit être postérieure au {{date}}.",
    "mobile_scheduled_announcements_empty_state_button": "Planifier une annonce",
    "mobile_projects_auto_archive": "Auto-archiver",
    "mobile_common_unassigned": "Non affecté",
    "mobile_tasks_title_placeholder": "Nouvelle tâche ou nouveau formulaire",
    "mobile_projects_leaving_project": "Sortie du projet",
    "mobile_projects_save_project": "Enregistrer le projet",
    "mobile_top_triggers_tasks": "Principales tâches déclenchées",
    "mobile_top_triggers_alerts": "Principales alertes déclenchées",
    "mobile_projects_not_started": "Non Démarré",
    "mobile_empty_list_message_no_photos": "Pas de photos",
    "mobile_webfilestore_message_error": "Veuillez sélectionner un type de fichier valide.",
    "mobile_notifications_empty_title": "Aucune notification",
    "mobile_notifications_empty_message": "Les activités qui dépendent de vos tâches ou auxquelles vous contribuez apparaissent ici.",
    "mobile_comments_comment_deleted": "Ce commentaire a été supprimé.",
    "mobile_comments_comment_placeholder": "Commentaire",
    "mobile_comments_task_submitted_at": "Tâche envoyée le {{ date }} à {{ time }}",
    "mobile_comments_discard_comment_title": "Ignorer le commentaire ?",
    "mobile_comments_discard_confirm_message": "Souhaitez-vous réellement continuer ? Votre commentaire sera supprimé.",
    "mobile_comments_delete_comment_title": "Supprimer le commentaire ?",
    "mobile_comments_delete_confirm_message": "Cette action ne peut pas être annulée.",
    "mobile_comments_delete_button": "Supprimer le commentaire",
    "mobile_comments_delete_success_message": "Commentaire supprimé",
    "mobile_comments_empty_message_tasks": "Il n'y a pas encore de commentaire. \n Débutez une conversation sur cette tâche.",
    "mobile_comments_empty_message_submissions": "Il n'y a pas encore de commentaire. \n Débutez une conversation sur cet envoi.",
    "mobile_comments_empty_message_default": "Il n'y a pas encore de commentaire. \n Débutez une conversation.",
    "mobile_comments_no_matching_users": "Aucun utilisateur ne correspond.",
    "mobile_comments_empty_users_to_notify": "Aucun utilisateur ne doit être notifié.",
    "mobile_comments_users_cant_view_message": "Ces utilisateurs ne peuvent pas voir ces commentaires",
    "mobile_comments_users_to_notify_title": "Utilisateur à notifier",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilisateur</a> sera notifié.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilisateurs</a> seront notifiés.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mentionnez</a> d'autres utilisateurs pour les notifier.",
    "mobile_comments_mark_read": "Tout marquer comme lu",
    "mobile_comments_author_mentioned_message": "vous a mentionné dans",
    "mobile_comments_author_commented_message": "a exprimé un commentaire sur",
    "mobile_view_pdf": "Afficher le fichier PDF",
    "mobile_no_pdf_generated_message": "Aucun fichier PDF n'a été trouvé pour cet envoi. Une copie vous sera prochainement envoyée par e-mail.",
    "mobile_clipboard_copied_success": "Le lien est copié dans votre presse-papiers.",
    "mobile_share_link": "Partager le lien",
    "mobile_zencam_share": "Partager",
    "mobile_zencam_view_details": "Afficher les détails",
    "mobile_zencam_details_drawer_header": "Détails",
    "mobile_zencam_submitted_by": "Soumis par",
    "mobile_zencam_form_title": "Titre du formulaire",
    "mobile_zencam_date_submitted": "Date de soumission",
    "mobile_oil_quality_warning_message": "L'huile arrive à expiration",
    "mobile_oil_quality_warning_message_subtitle": "Prévoyez de la changer bientôt",
    "mobile_oil_quality_failure_message": "Qualité de l'huile compromise",
    "mobile_oil_quality_failure_message_subtitle": "Changez l'huile immédiatement",
    "mobile_sensors_set_up_gateway": "Configurer la passerelle",
    "mobile_sensors_set_up_gateway_message": "Aucun appareil ne semble configuré. Commencez par ajouter une passerelle.",
    "mobile_sensors_gateway_plugged_in": "Vérifiez que votre passerelle est branchée sur une prise électrique.",
    "mobile_sensors_add_device": "Ajouter l'appareil",
    "mobile_sensors_name_this_gateway": "Nommez cette passerelle.",
    "mobile_sensors_name_this_sensor": "Nommez ce capteur.",
    "mobile_sensors_device_barcode_information": "Scanner le code QR ou saisir l'ID et numéro SC de l'étiquette de l'appareil",
    "mobile_sensors_device_eui_information": "Scanner le code QR ou saisir le DevEUI de l'étiquette de l'appareil",
    "mobile_sensors_gateway_id_information": "Saisir l'ID de nœud de l'étiquette Passerelle",
    "mobile_sensors_id_number": "{{untranslatedID}} - Numéro",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} - Code",
    "mobile_sensors_sensors": "Capteurs",
    "mobile_sensors_sensor_deveui_error": "Impossible d’obtenir le DevEUI à partir du code QR. Veuillez le saisir manuellement.",
    "mobile_sensors_gateways": "Passerelles",
    "mobile_sensors_add_sensor": "Ajouter le capteur",
    "mobile_sensors_add_gateway": "Ajouter la passerelle",
    "mobile_sensor_placement_description": "Quelle zone ce capteur surveillera-t-il ?",
    "mobile_sensors_equipment_placement": "Quelle zone ou quel équipement ce capteur surveillera-t-il ?",
    "mobile_sensors_equipment": "Quel équipement ce capteur surveillera-t-il ?",
    "mobile_sensors_select_gateway_type": "Sélectionner le type de passerelle",
    "mobile_sensors_select_placement": "Sélectionner le positionnement",
    "mobile_sensors_select_equipment": "Sélectionner l'équipement",
    "mobile_sensors_placement": "Positionnement",
    "mobile_sensors_nickname_tip": "Les surnoms donnés à l'emplacement sélectionné déterminent les noms des capteurs.",
    "mobile_sensors_device_online": "En ligne",
    "mobile_sensors_device_offline": "Hors ligne",
    "mobile_sensors_scan_qrcode": "Scanner un code QR",
    "mobile_sensors_enter_manually": "Saisir manuellement",
    "mobile_sensors_wizard_step_one": "Étape 1",
    "mobile_sensors_wizard_step_two": "Étape 2",
    "mobile_sensors_wizard_step_three": "Étape 3",
    "mobile_sensors_wizard_step_four": "Étape 4",
    "mobile_sensors_wizard_step_five": "Étape 5",
    "mobile_sensors_wizard_step_six": "Étape 6",
    "mobile_sensors_initializing": "Initialisation...",
    "mobile_sensors_nickname": "Surnom",
    "mobile_sensors_field_not_blank": "Le champ {{field}} doit être renseigné.",
    "mobile_sensors_nothing_to_see_here": "Il n'y rien à voir ici.",
    "mobile_sensors_missing_integration": "Intégration de capteur manquante",
    "mobile_sensors_contact_zenput_admin": "Veuillez contacter l'administrateur Ops Execution de votre entreprise.",
    "mobile_sensors_contact_zenput_admin_old": "Veuillez contacter votre administrateur Zenput.",
    "mobile_sensors_contact_manager": "Contactez votre gestionnaire de compte pour ajouter des capteurs.",
    "mobile_sensors_device_success_message": "Le chargement des données du capteur peut prendre jusqu'à 15 minutes.",
    "mobile_sensors_last_reading": "Dernière lecture",
    "mobile_sensors_remove_device": "Supprimer l'appareil",
    "mobile_sensors_one_day": "1J",
    "mobile_sensors_one_week": "1S",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1A",
    "mobile_sensors_sensor_settings": "Réglages du capteur",
    "mobile_sensors_remove_confirm_message": "Souhaitez-vous réellement supprimer cet appareil ?\nCette opération ne pourra pas être annulée.",
    "mobile_sensors_sensor": "Capteur",
    "mobile_sensors_no_equipment_linked": "Pas d'équipement lié",
    "mobile_sensor_cooldown_process": "Processus de refroidissement",
    "mobile_sensor_last_12_hours": "12 dernières heures",
    "mobile_sensor_start_cooldown_process": "Démarrer un nouveau processus de refroidissement",
    "mobile_sensor_cooldown_process_title": "Processus de refroidissement en deux étapes",
    "mobile_sensor_cooldown_process_description": "Un processus de refroidissement en 2 étapes consiste à refroidir l'aliment en le faisant passer de plus de {{ stage1_start_temperature }} à {{ stage1_end_temperature }} en 2 h ou moins, puis de {{ stage1_end_temperature }} à {{ stage2_end_temperature }} en 4 h ou moins.",
    "mobile_sensor_cooldown_process_place_food": "Mettez le produit alimentaire au réfrigérateur.",
    "mobile_sensor_cooldown_process_insert_sensor": "Insérez une sonde dans le produit alimentaire.",
    "mobile_sensor_cooldown_process_enter_information": "Saisissez les informations ci-dessous.",
    "mobile_sensor_cooldown_process_food_product": "Produit alimentaire à faire refroidir",
    "mobile_sensor_cooldown_cool_down": "Faire refroidir",
    "mobile_sensor_cooldown_select_sensor": "Sélectionner la sonde",
    "mobile_sensors_cooldown_start_cooldown": "Démarrer le refroidissement",
    "mobile_sensors_cooldown_please_enter_food": "Veuillez saisir un produit alimentaire.",
    "mobile_sensors_cooldown_please_select_sensor": "Veuillez sélectionner un capteur.",
    "mobile_sensors_cooldown_status_in_progress": "En cours",
    "mobile_sensors_cooldown_status_failed": "Échec",
    "mobile_sensors_cooldown_status_success": "Réussite",
    "mobile_sensors_cooldown_stage": "Phase",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "La température de départ est en dehors de la plage.",
    "mobile_sensors_cooldown_failed_cooldown_process": "Échec du processus de refroidissement",
    "mobile_sensors_cooldown_cooldown_successful": "Réussite du processus de refroidissement",
    "mobile_sensors_cooldown_started_cooldown_process": "Processus de refroidissement démarré",
    "mobile_sensors_cooldown_hour": "heure",
    "mobile_sensors_cooldown_hour_plural": "heures",
    "mobile_sensors_cooldown_minute": "minute",
    "mobile_minutes_plural": "minutes",
    "mobile_sensors_last_reading_max_date": "Il y a plus d'1 an",
    "mobile_sensors_minute_count_ago": "Il y a {{count}} minute",
    "mobile_sensors_minute_count_ago_plural": "Il y a {{count}} minutes",
    "mobile_sensors_hour_count_ago": "Il y a {{count}} heure",
    "mobile_sensors_hour_count_ago_plural": "Il y a {{count}} heures",
    "mobile_sensors_day_count_ago": "Il y a {{count}} jour",
    "mobile_sensors_day_count_ago_plural": "Il y a {{count}} jours",
    "mobile_sensors_chart_settings": "Paramètres de graphique",
    "mobile_announcement_banner_continue_reading": "Continuer à lire",
    "mobile_compliance_submissions_report": "Rapport des envois",
    "mobile_compliance_submissions_report_subtitle": "Exporter les données de projets terminés de ce magasin",
    "mobile_compliance_send_submissions": "Soumettre les envois",
    "mobile_compliance_completion_rate_in_last_days": "Taux d'avancement au cours des {{ days }} derniers jours",
    "mobile_compliance_last_days": "{{ days }} derniers jours",
    "mobile_compliance_send_submissions_to": "Soumettre les envois à",
    "mobile_compliance_send_to_different_email": "Envoyer à une autre adresse e-mail",
    "mobile_compliance_email_input_placeholder": "Adresse e-mail",
    "mobile_compliance_send_submissions_to_legend_title": "Envois",
    "mobile_compliance_send_submissions_to_legend_description_days": "L'adresse e-mail sélectionnée recevra un rapport incluant les envois effectués à partir de ce lieu au cours des {{ days }} derniers jours.",
    "mobile_compliance_time_frame": "Période",
    "mobile_compliance_sensor_temperature_log_report": "Rapport des températures du capteur",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exporter les journaux de température de ce magasin",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Critères",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Définissez ci-dessous les critères de votre rapport.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Remarque : les capteurs désactivés ne figureront pas dans le rapport",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Sélectionnez une période. Les données du journal sont limitées à 30 jours.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Envoyer le rapport",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Ce mois (1er-aujourd'hui)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Le mois dernier",
    "mobile_compliance_sensor_temperature_log_email_title": "Envoyer le rapport à",
    "mobile_pwa_update_prompt_title": "Mettre l'application à jour",
    "mobile_pwa_update_prompt_description": "Une nouvelle version de l'application est disponible. Veuillez mettre à jour vers la dernière version.",
    "mobile_pwa_update_prompt_confirm": "Mettre à jour et recharger",
    "mobile_pwa_update_prompt_cancel": "Me le rappeler plus tard",
    "notification_title_due_in_one_hour": "Attendu dans 1 heure",
    "task_is_due_soon": "« {{ task_title }} » est prévu pour bientôt. Prenez un moment pour le terminer.",
    "mobile_photo_quality_warning_header": "Problème de qualité photo",
    "mobile_photo_quality_dialog_message": "Cette photo est peut être trop sombre ou trop floue. Souhaitez-vous prendre une nouvelle photo ou poursuivre avec celle-ci ?",
    "mobile_take_new_photo": "Prendre une nouvelle photo",
    "mobile_use_this_photo": "Utiliser cette photo"
}};
mobile_translations.cs_CZ = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Vše",
    "mobile_common_button_apply_filters": "Použít filtry",
    "mobile_common_button_done": "Hotovo",
    "mobile_common_button_edit": "Upravit",
    "mobile_common_button_archive": "Archivovat",
    "mobile_common_button_save": "Uložit",
    "mobile_common_button_retake": "Opakovat",
    "mobile_common_button_save_draft": "Uložit koncept",
    "mobile_common_button_discard": "Zahodit",
    "mobile_common_button_submit": "Odeslat",
    "mobile_common_button_no": "Ne",
    "mobile_common_button_yes": "Ano",
    "mobile_common_button_na": "Nepoužívá se",
    "mobile_common_created_by_me": "Vytvořeno mnou",
    "mobile_common_email": "Firemní e-mail",
    "mobile_common_first_name": "Jméno",
    "mobile_common_last_name": "Příjmení",
    "mobile_common_location": "Umístění",
    "mobile_common_locations": "Umístění",
    "mobile_common_logout_message": "Opravdu se chcete odhlásit?",
    "mobile_common_password": "Heslo",
    "mobile_common_permission_required": "Požadováno oprávnění",
    "mobile_common_status": "Stav",
    "mobile_common_task": "Úkol",
    "mobile_common_tasks": "Úkoly",
    "mobile_common_tasks_my": "Moje úkoly",
    "mobile_common_projects": "Projekty",
    "mobile_common_filter_team": "Tým",
    "mobile_common_filter_var_in": " v {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Není vybrán tým.",
    "mobile_common_filter_no_user_selected": "Není vybrán uživatel.",
    "mobile_common_filter_no_role_selected": "Není vybrána role.",
    "mobile_common_placeholder_date": "Datum",
    "mobile_common_message_task_creator_error_save": "<b>Úkoly nebylo možné vytvořit.</b>",
    "mobile_common_camera": "Kamera",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "pro",
    "mobile_common_reload": "Znovu načíst",
    "mobile_common_override": "Přepsat",
    "mobile_common_notifications": "Oznámení",
    "mobile_common_chat_unavailable": "Chat není k dispozici. Zkuste to znovu později.",
    "mobile_common_chat_ending_dialog_title": "Skončili jste s tímto rozhovorem?",
    "mobile_common_chat_ending_dialog_description": "Dejte nám vědět, zda byl váš problém vyřešen, nebo zda chcete pokračovat později.",
    "mobile_common_chat_ending_dialog_confirm": "Ano, skončil(a) jsem",
    "mobile_common_chat_ending_dialog_cancel": "Budu pokračovat později",
    "mobile_common_continue_editing": "Pokračovat v úpravách",
    "mobile_privacy_policy": "Zásady ochrany osobních údajů",
    "wootric_recommend_target": "přítel nebo kolega z oboru",
    "wootric_followup_detractor_question": "Jaké změny můžeme udělat, abyste nám příště udělili vyšší hodnocení?",
    "wootric_followup_passive_question": "Děkujeme! Jak můžeme nástroj ještě vylepšit?",
    "wootric_followup_promoter_question": "Díky! Co se vám na Crunchtime Ops Execution líbí nejvíc?",
    "wootric_followup_promoter_question_old": "Děkujeme! Co se vám na společnosti Zenput líbí?",
    "wootric_default_followup_question": "Děkujeme! Můžete nám říct proč?",
    "wootric_default_placeholder_text": "Pomozte nám tím, že své hodnocení vysvětlíte.",
    "wootric_default_thankyou_text": "Děkujeme za vaši odpověď a zpětnou vazbu.",
    "mobile_login_placeholder_login_as": "Přihlásit se pomocí ID uživatele",
    "mobile_login_button_forgot_password": "Zapomněli jste heslo?",
    "mobile_login_button_sign_up": "Vytvořit účet",
    "mobile_login_button_finish_setup": "Dokončit nastavení",
    "mobile_login_button": "Přihlásit se",
    "mobile_login_continue_button": "Pokračovat",
    "mobile_login_continue_transition": "Probíhá přesměrování na přihlašovací stránku organizace...",
    "mobile_login_no_email_error": "Je třeba zadat e-mail.",
    "mobile_login_change_email": "Přihlásit se pod jiným e-mailem",
    "mobile_login_with_sso": "Přihlásit se pomocí SSO",
    "mobile_oauth_no_user_error_message": "Vypadá to, že nemáte účet v Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Zdá se, že nemáte účet Zenput.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> se nyní jmenuje <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} se v září změní na {{- product }}. {{- cta }}",
    "mobile_rebrand_warning_cta": "Podívejte se, jak se na to připravit.",
    "mobile_oauth_no_user_error_sub_message": "Ohledně přístupu kontaktujte správce nebo se zkuste přihlásit pod jiným e-mailem.",
    "mobile_oauth_generic_error_message": "Zdá se, že během přihlášení došlo k problému, zkuste to znovu.",
    "mobile_oauth_force_logout_msg": "Pokud problémy přetrvávají, odhlaste se od svého poskytovatele ",
    "mobile_oauth_force_logout_click": "kliknutím sem.",
    "mobile_sign_up_placeholder_phone": "Číslo mobilního telefonu",
    "mobile_sign_up_placeholder_password_confirm": "Potvrdit heslo",
    "mobile_sign_up_button_sign_in": "Přihlásit se",
    "mobile_sign_up_disclaimer_part_1": "Kliknutím na možnost Vytvořit účet, souhlasíte",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Kliknutím na „Dokončit nastavení“ souhlasíte s dokumentem",
    "mobile_sign_up_disclaimer_link_title": " s licenční smlouvou,",
    "mobile_sign_up_disclaimer_part_2": "která zahrnuje důležité informace o ochraně osobních údajů.",
    "mobile_dialog_benefits_work_offline": "Pracovat offline",
    "mobile_dialog_benefits_faster_uploads": "Rychlejší nahrávání",
    "mobile_dialog_benefits_better_experience": "Lepší zážitky",
    "mobile_dialog_benefits_button_download": "Stáhnout",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution pro ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput pro ",
    "mobile_dialog_benefits_button_have": "Mám aplikaci.",
    "mobile_dialog_benefits_button_no_thanks": "Ne, díky. Možná později.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Obrázek se nenačetl.",
    "mobile_dialog_signature_sign": "Přihlásit se zde",
    "mobile_dialog_signature_button_clear": "Vymazat",
    "mobile_account_placeholder_name": "Umístění / název obchodu",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Adresa",
    "mobile_account_placeholder_city": "Město",
    "mobile_account_placeholder_region": "Region",
    "mobile_account_placeholder_zipcode": "PSČ",
    "mobile_account_option_select_country": "Vybrat zemi",
    "mobile_account_oprion_us": "Spojené státy americké",
    "mobile_account_oprion_select_state": "Vybrat stát",
    "mobile_account_button_create_location": "Vytvořit umístění",
    "mobile_form_message_no_form": "Žádné dostupné formuláře",
    "mobile_batch_task_message": "Načítání...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Mobilní telefon",
    "mobile_settings_profile_language": "Jazyk",
    "mobile_settings_profile_temperature_unit": "Jednotka teploty",
    "mobile_settings_profile_use_company_default": "Použijte firemní výchozí nastavení",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Textová zpráva",
    "mobile_settings_notifications_option_push": "Oznámení ze serveru",
    "mobile_settings_notifications_option_push_email": "E-mailová oznámení a oznámení ze serveru",
    "mobile_settings_notifications_option_do_not": "Neupozorňovat",
    "mobile_settings_notifications_category_communication": "Komunikace",
    "mobile_settings_notifications_category_forms_and_triggers": "Formuláře a spouštěče",
    "mobile_settings_devices": "Zařízení",
    "mobile_settings_notifications_sub_category_alerts": "Upozornění",
    "mobile_settings_notifications_sub_category_new_forms_available": "Jsou dostupné nové formuláře",
    "mobile_settings_notifications_sub_category_task_assigned": "Úkol přiřazen",
    "mobile_settings_notifications_sub_category_task_completed": "Úkol dokončen",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Upozornění na blížící se termín úkolů",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Upozornění na úkoly po termínu",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Upozornění snímače",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Kritická upozornění snímače",
    "mobile_drafts_message": "Zatím nemáte žádné koncepty.",
    "mobile_drafts_button_delete": "Odstranit",
    "mobile_tasks_filter_location_no": "Není vybráno umístění.",
    "mobile_tasks_filter_group_by": "Seskupit podle",
    "mobile_tasks_filter_sort_by": "Seřadit podle",
    "mobile_tasks_filter_sorted_by": "Seřazeno podle",
    "mobile_tasks_filter_due_time": "Termín",
    "mobile_tasks_filter_open_time": "Čas otevření",
    "mobile_tasks_bucket_due_next_24_hours": "Termín během dalších 24 hodin",
    "mobile_tasks_bucket_due_next_7_days": "Termín během dalších 7 dnů",
    "mobile_tasks_bucket_open_tasks": "Další otevřené {{type}}",
    "mobile_tasks_bucket_open_at": "Otevřeno: {{- date }} v {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Termín: {{- date }} v {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Dostupné za 1 minutu",
    "mobile_tasks_bucket_available_in_one_hour": "Dostupné za 1 hodinu",
    "mobile_tasks_bucket_available_in_one_day": "Dostupné za 1 den",
    "mobile_tasks_bucket_available_in_one_week": "Dostupné za 1 týden",
    "mobile_tasks_bucket_available_in_one_month": "Dostupné za 1 měsíc",
    "mobile_tasks_bucket_available_in_one_year": "Dostupné za 1 rok",
    "mobile_tasks_bucket_available_in_minutes": "Dostupné za {{ minutes }} min.",
    "mobile_tasks_bucket_available_in_hours": "Dostupné za {{ hours }} hod.",
    "mobile_tasks_bucket_available_in_days": "Dostupné za {{ days }} dny/ů",
    "mobile_tasks_bucket_available_in_weeks": "Dostupné za {{ weeks }} týdny/ů",
    "notification_task_due_in_minutes": "Termín za {{ minutes }} minut",
    "mobile_tasks_bucket_available_in_months": "Dostupné za {{ months }} měsíce/ů",
    "mobile_tasks_bucket_available_in_years": "Dostupné za {{ years }} roky/ů",
    "mobile_tasks_follow_up": "Následující úloha",
    "mobile_tasks_due_soon": "Již brzy",
    "mobile_tasks_bucket_completed_today": "Dokončeno dnes",
    "mobile_tasks_bucket_completed_this_week": "Dokončeno tento týden",
    "mobile_tasks_bucket_completed_last_week": "Dokončeno minulý týden",
    "mobile_tasks_bucket_missed_today": "Zmeškáno dnes",
    "mobile_tasks_bucket_missed_this_week": "Zmeškáno v tomto týdnu",
    "mobile_tasks_bucket_missed_last_week": "Zmeškáno v minulém týdnu",
    "mobile_tasks_bucket_no_location": "Žádné umístění",
    "mobile_tasks_cannot_submit_missed": "Zmeškané úkoly nelze dokončit.",
    "mobile_tasks_cannot_submit_missed_after": "Úkol nelze dokončit po {{ date }}.",
    "mobile_tasks_cannot_submit_upcoming": "Úkol nebyl zahájen.",
    "mobile_tasks_cannot_submit_processing": "Probíhá zpracování požadavku.",
    "mobile_tasks_toolbarnav_header_no_due_date": "Žádný termín",
    "mobile_tasks_toolbarnav_header_overdue": "Po termínu",
    "mobile_tasks_toolbarnav_header_yesterday": "Včera",
    "mobile_tasks_toolbarnav_header_today": "Dnes",
    "mobile_tasks_toolbarnav_header_tomorrow": "Zítra",
    "mobile_tasks_toolbarnav_header_last_week": "Minulý týden",
    "mobile_tasks_toolbarnav_header_this_week": "Tento týden",
    "mobile_tasks_toolbarnav_header_next_week": "Následující týden",
    "mobile_tasks_toolbarnav_header_this_month": "Tento měsíc",
    "mobile_tasks_toolbarnav_header_next_year": "Následující rok",
    "mobile_tasks_toolbarnav_header_over_year": "Více než rok",
    "mobile_tasks_toolbarnav_title_edit_task": "Upravit úkol",
    "mobile_task_placeholder_title": "Titul *",
    "mobile_task_placeholder_description": "Popis (nepovinný)",
    "mobile_task_button_single_task": "Jeden úkol",
    "mobile_task_button_project": "Projekt",
    "mobile_task_button_create": "Vytvořit",
    "mobile_task_tab_basic": "Základní",
    "mobile_task_tab_photo": "Fotografie",
    "mobile_task_tab_form": "Formulář",
    "mobile_task_details_description_message_please": "Vyplňte ",
    "mobile_task_details_description_message_below": "níže.",
    "mobile_task_details_description_message_instructions": "K úkolu nejsou k dispozici žádné pokyny.",
    "mobile_task_details_reason_title": "Navazující akci spustil/a",
    "mobile_task_detials_button_goto_form": "Přejít na formulář",
    "mobile_task_detials_button_complete": " Dokončit úkol",
    "mobile_task_detials_completed": "Dokončeno ",
    "mobile_task_detials_completed_by": "do ",
    "mobile_task_detials_completed_on": "v ",
    "mobile_task_details_view_form_submission": "Zobrazit odeslaný formulář",
    "mobile_task_task_updated": "Úkol aktualizován",
    "mobile_task_task_archived": "Úkol archivován",
    "mobile_task_task_deleted": "Úkol odstraněn",
    "mobile_task_error_archiving_task": "Úkol nelze archivovat.",
    "mobile_task_error_deleting_task": "Úkol nelze odstranit.",
    "mobile_task_error_updating_task": "Úkol nelze aktualizovat.",
    "mobile_task_archive_task": "Archivovat úkol",
    "mobile_task_archive_task_confirm": "Opravdu chcete tento úkol archivovat?\n\nArchivované úkoly se započítávají do úrovně dokončení a budou nadále zahrnovány do vykazování.\n\nTuto akci nelze vrátit zpět.",
    "mobile_task_delete_task_confirm": "Opravdu chcete tento úkol odstranit?\n\nOdstraněné úkoly se nezapočítávají do úrovně dokončení a nebudou ani zahrnuty do vykazování.\n\nTuto akci nelze vrátit zpět.",
    "mobile_task_edition_already_in_progress": "Tento úkol obsahuje nevyřízenou úpravu. Další úpravy momentálně nejsou povoleny.",
    "mobile_projects_filter_type": "Typ",
    "mobile_projects_filter_status": "Stav projektu",
    "mobile_projects_filter_project_type": "Typ projektu",
    "mobile_projects_due_date_required": "Termín je povinný.",
    "mobile_projects_team_required": "Tým je povinný.",
    "mobile_projects_user_role_required": "Postupník je povinný.",
    "mobile_projects_title_required": "Titul je povinný.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Více úkolů za den",
    "mobile_project_tasks_complete": " Dokončit",
    "mobile_project_tasks_remaining": " Zbývá",
    "mobile_esitmate_message_tasks": "Nebude vytvořen žádný úkol.",
    "mobile_esitmate_message_criteria": "Upravit výše uvedená kritéria",
    "mobile_esitmate_message_created_for": "bude vytvořeno pro",
    "mobile_left_menu_dashboard": "Ovládací panel",
    "mobile_left_menu_my_forms": "Moje formuláře",
    "mobile_left_menu_announcements": "Oznámení",
    "mobile_left_menu_my_submissions": "Moje žádosti",
    "mobile_left_menu_drafts": "Koncepty",
    "mobile_left_menu_pending_uploads": "Nahrávání čekající na vyřízení",
    "mobile_left_menu_open": "Otevřít v aplikaci",
    "mobile_left_menu_settings": "Nastavení",
    "mobile_left_menu_log_out": "Odhlásit se",
    "mobile_left_menu_debug": "Ladit (debug)",
    "mobile_left_menu_support": "Podpora",
    "mobile_left_menu_documentation": "Dokumentace",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Poznámka nebo popisek",
    "mobile_field_option_select": "Vybrat",
    "mobile_field_text_placeholder_text": "Text",
    "mobile_field_email_placehoder_email": "E-mail",
    "mobile_filed_number_placeholder_number": "Číslo",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Nepřipojeno",
    "mobile_field_sensor_offline_battery": "Snímač je offline – baterie",
    "mobile_field_video_button_add": "Přidat video",
    "mobile_field_video_picker_dialog_title": "Přidat video ze zdroje",
    "mobile_field_video_button_change": "Změnit video",
    "mobile_field_image_button_add": "Přidat obrázek",
    "mobile_field_image_low_quality_warning": "Některé fotografie mohou být příliš tmavé nebo rozmazané. Zkontrolujte vyznačené fotografie a podle potřeby je nahraďte",
    "mobile_field_image_picker_dialog_title": "Přidat fotografii ze zdroje",
    "mobile_field_image_picker_edit_failed": "Obrázek se nepodařilo uložit. Zkuste to znovu.",
    "mobile_field_signature_button_add": "Přidat podpis",
    "mobile_field_signature_button_change": "Změnit podpis",
    "mobile_field_account_select_location": "Vybrat Umístění",
    "mobile_field_account_prefill": "Předvyplnit formulář daty z poslední návštěvy?",
    "mobile_field_account_message_overwrite": "Tím se přepíší všechna již vyplněná pole.",
    "mobile_forms_task_on_behalf": "V tomto umístění existuje úkol ke splnění, který je přiřazen uživateli <b>{{user}}</b>. Chcete tento úkol dokončit?",
    "mobile_forms_complete_task": "Dokončit úkol?",
    "mobile_field_account_prefill_button_yes": "Ano, předvyplnit",
    "mobile_field_barcode_placeholder_scan": "Naskenujte nebo zadejte čárový kód.",
    "mobile_field_sensor_qr_code_placeholder_scan": "Naskenujte nebo zadejte kód",
    "mobile_field_gateway_id_code_placeholder": "ID uzlu typu",
    "mobile_field_scan_qr_or_enter_dev_eui": "Naskenujte QR kód nebo zadejte DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Naskenujte QR kód nebo zadejte číslo ID",
    "mobile_field_scan_qr_or_enter_sc": "Naskenujte QR kód nebo zadejte SC kód",
    "mobile_field_barcode_select_date": "Vybrat datum ",
    "mobile_field_datetime_allow_time": "Čas",
    "mobile_field_stopwatch_button_caption": "Stopky",
    "mobile_field_stopwatch_common_start": "Spustit",
    "mobile_field_stopwatch_common_stop": "Zastavit",
    "mobile_field_stopwatch_common_reset": "Vynulovat",
    "mobile_field_stopwatch_stop_stopwatches": "Zastavit stopky",
    "mobile_field_document_title": "Přidat dokument",
    "mobile_field_document_message_delete": "Opravdu chcete tento dokument odstranit?",
    "mobile_field_document_alret_button_view": "Zobrazit",
    "mobile_field_document_alert_error": "Během připojování tohoto dokumentu došlo k chybě. Zkuste to znovu.",
    "mobile_field_document_alert_file_size_error": "Velikost souboru nesmí překročit {{count}} MB.",
    "mobile_field_temperature_greater_range": "větší než {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "větší než nebo rovno {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "menší než {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "menší než nebo rovno {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "větší než nebo rovno {{ min_temp_value }} °{{ temp_unit }} a menší než {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "větší než nebo rovno {{ min_temp_value }} °{{ temp_unit }} a menší než nebo rovno {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " a ",
    "mobile_field_text_limit_error": "Dosažen maximální limit 8000 znaků.",
    "mobile_forms_required_questions_complete": "Dokončení povinné",
    "mobile_forms_required_remaining": "Počet zbývajících povinných polí: {{count}}",
    "mobile_forms_required_questions_back": "Zpět",
    "mobile_forms_required_questions_next": "Další",
    "mobile_forms_required_questions_skip": "Přeskočit",
    "mobile_forms_leaving_form": "Opouštění formuláře",
    "mobile_message_reordering_confirm": "Chcete uložit nové pořadí otázek?",
    "mobile_forms_leaving_reordering": "Opouštíte proces změny pořadí otázek",
    "mobile_forms_reordering_button_save": "Uložit nové pořadí otázek",
    "mobile_forms_reordering_instructions": "Pokud chcete přeuspořádat otázky nebo sekce, přetáhněte je do pozice, ve které je chcete mít ve formuláři",
    "mobile_toolbarnav_title_my_setttings": "Moje nastavení",
    "mobile_toolbarnav_title_profile_settings": "Nastavení profilu",
    "mobile_toolbarnav_title_notification": "Nastavení oznámení",
    "mobile_toolbarnav_title_form_history": "Historie formuláře",
    "mobile_toolbarnav_title_form_not_available": "Formulář není dostupný.",
    "mobile_toolbarnav_title_add_location": "Přidat umístění",
    "mobile_toolbarnav_title_add_task_or_project": "Přidat úkol nebo projekt",
    "mobile_toolbarnav_title_select_location": "Vybrat umístění",
    "mobile_toolbarnav_title_select_project": "Vybrat projekt",
    "mobile_toolbarnav_title_select_tag": "Vybrat štítek",
    "mobile_toolbarnav_title_select_user": "Vybrat uživatele",
    "mobile_toolbarnav_title_select_template": "Vybrat šablonu",
    "mobile_toolbarnav_title_select_one": "Vybrat jednu možnost",
    "mobile_toolbarnav_title_select_multiple": "Vybrat jednu nebo více možností",
    "mobile_toolbarnav_title_select_team": "Vybrat tým",
    "mobile_toolbarnav_title_select_team_or_location": "Vybrat tým nebo umístění",
    "mobile_toolbarnav_title_filter_tasks": "Filtrovat úkoly",
    "mobile_toolbarnav_title_filter_projects": "Filtrovat projekty",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrovat úkoly projektu",
    "mobile_placeholder_search_bar": "Hledat",
    "mobile_placeholder_user_select_role": "Vybrat roli uživatele",
    "mobile_placeholder_filter_by_team": "Filtrovat podle týmu",
    "mobile_placeholder_assign_to_user_role": "Přiřadit roli uživatele",
    "mobile_placeholder_select": "-- Vybrat --",
    "mobile_placeholder_account_location_name": "Název umístění",
    "mobile_placeholder_tag_filter_by": "Filtrovat podle štítku umístění",
    "mobile_placeholder_user_type": "Přiřadit uživateli",
    "mobile_placeholder_acount_type_loading": "Načítání... ",
    "mobile_placeholder_therm_no_bluetooth": "Teplota",
    "mobile_placeholder_blue_therm_connecting": "Připojování k zařízení...",
    "mobile_placeholder_blue_therm_please_wait": "Čekejte prosím...",
    "mobile_placeholder_blue_therm_tap": "Klepnutím můžete číst.",
    "mobile_placeholder_blue_therm_not_connected": "Nepřipojeno.",
    "mobile_placeholder_testo_tap": "Držet ▼▲ a poté ⬆",
    "mobile_message_error_create_task": "Chcete-li přidávat úkoly, musíte být online.",
    "mobile_message_error_fill_out_form": "Vyplňte formulář.",
    "mobile_message_error_fill_require_fields": "Vyplňte povinná pole.",
    "mobile_message_error_stop_stopwatch_before_submit": "Před odesláním zastavte stopky.",
    "mobile_message_error_stopwatch_field_required": "Pole Stopky je povinné.",
    "mobile_message_error_stopwatch_field_running": "Pole Stopky je spuštěno.",
    "mobile_message_error_invalid_equipment_temperature": "Neplatná teplota zařízení",
    "mobile_message_error_invalid_ingredient_temperature": "Neplatná teplota přísady",
    "mobile_message_error_location_attributes_unavailable": "Některé otázky nemusí být dostupné, připojte se k internetu",
    "mobile_message_alert_running_stopwatches": "Běží vám stopky.\n\nChcete je vymazat?",
    "mobile_message_blue_therm_error": "Připojení Bluetooth zařízení ztraceno",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Je vyžadován přístup k poloze. Povolte jej v nastavení systému Android.",
    "mobile_message_blue_therm_no_permission_android": "Je vyžadován přístup k okolním zařízením. Povolte jej v nastavení systému Android.",
    "mobile_message_blue_therm_error_code": "Připojení se nezdařilo:",
    "mobile_message_blue_therm_error_bluetooth": "Povolte připojení Bluetooth.",
    "mobile_message_blue_therm_error_device": "Zařízení nebylo nalezeno.",
    "mobile_message_blue_therm_error_try_again": "Zkuste to znovu.",
    "mobile_message_blue_therm_success": "Zařízení Bluetooth připojeno!",
    "mobile_message_bluetooth_device_press_button_field": "Připojte se stisknutím tlačítka na zařízení.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Stiskněte tlačítko na zařízení,<br />pokud není uvedeno zde.",
    "mobile_bluetooth_scan": "Skenovat",
    "mobile_bluetooth_scanning": "Skenování",
    "mobile_message_drafts_confirm": "Chcete tento dokument uložit jako koncept?",
    "mobile_message_drafts_toast_saved": "Koncept uložen.",
    "mobile_message_drafts_request_update": "Chcete tento koncept aktualizovat?",
    "mobile_message_drafts_form_confirm": "Opravdu chcete tento koncept odstranit?",
    "mobile_message_drafts_confirm_delete": "Odstranit koncept",
    "mobile_message_streams_error_switch": "Kanály na webu nelze změnit.",
    "mobile_message_settings_success_saved": "Nastavení uložena",
    "mobile_message_settings_error": "Došlo k neznámé chybě. Zkuste to znovu později.",
    "mobile_message_profile_settings_error_fields": "Opravte zvýrazněná pole.",
    "mobile_message_media_perimission_denied": "Vaše ",
    "mobile_message_media_perimission_denied_device": "Úložiště zařízení",
    "mobile_message_image_confirm_remove_image": "Opravdu chcete tuto fotografii odstranit?",
    "mobile_message_create_account_error_fields": "Vyplňte zvýrazněná pole.",
    "mobile_message_create_account_success_location_created": "Umístění vytvořeno",
    "mobile_message_task_error_get_location": "Umístění se nepodařilo získat. Řazení podle data.",
    "mobile_message_typehead_confirm_save_message": "Chcete tento výběr uložit?",
    "mobile_message_typehead_confirm_save_title": "Uložit?",
    "mobile_message_task_creator_error_save_select_form": "Je třeba vybrat formulář.",
    "mobile_message_task_creator_error_save_required_fields": "Vyplňte povinná pole.",
    "mobile_message_task_creator_error_save_batch_change": "Změňte kritéria, aby odpovídala jednomu nebo více uživatelům.",
    "mobile_message_task_detials_error_not_assigned_to_you": "Tento úkol vám není přiřazen.<br />Nemůžete jej dokončit.",
    "mobile_message_task_detials_error_assigned_to": "Tento úkol je přiřazen uživateli {{user}}.<br />Nemůžete jej dokončit.",
    "mobile_message_task_detials_confirm_title": "Opouštění úkolu",
    "mobile_message_task_detials_confirm_save_task": "Uložit úkol",
    "mobile_message_task_detials_confirm_message": "Jste si jistí? Vaše změny budou ztraceny.",
    "mobile_message_task_detials_error_view_account": "K umístění nelze získat přístup.",
    "mobile_message_task_detials_error_submit_task": "Chcete-li tento úkol dokončit, přidejte fotografii.",
    "mobile_message_task_detials_error_submit_task_project": "Projekt nelze uložit. Zkuste to znovu později.",
    "mobile_message_task_detials_wait_submit_task_created": "Probíhá vytváření úkolů.<br />Počkejte několik minut, než budou úkoly vyplněny.",
    "mobile_message_task_detials_error_submit_task_pending": "Chyba, zkuste to znovu později.",
    "mobile_message_task_detials_success_task_complete": "Úkol dokončen",
    "mobile_message_task_error_save_single_task": "Úkol nelze uložit. Zkuste to znovu později.",
    "mobile_message_task_success_save_single_task": "Úkol vytvořen.",
    "mobile_message_show_error_message": "Něco se pokazilo.",
    "mobile_message_show_success_message": "V pořádku!",
    "mobile_message_show_offline_message": "Momentálně jste offline.",
    "mobile_message_show_permission_denied_message": "<b>Je požadováno oprávnění.</b> Udělte společnosti Zenput oprávnění pro přístup k {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Je požadováno oprávnění.</b> Udělte společnosti Zenput a svému prohlížeči oprávnění pro přístup k {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Právě se nahrává",
    "mobile_message_show_upload_in_progress_message": "Probíhá nahrávání.",
    "mobile_message_show_form_id_error": "K danému formuláři nelze přejít.",
    "mobile_message_show_single_task_error": "K danému úkolu nelze přejít.",
    "mobile_message_show_submissions_error": "K dané žádosti nelze přejít.",
    "mobile_message_show_submissions_access_denied": "K tomuto formuláři bohužel nemáte přístup.",
    "mobile_message_send_data_success": "Nahraná data ",
    "mobile_message_start_upload_success": "Nahrávání dokončeno",
    "mobile_message_start_upload_error": "<b>Nahrávání nebylo možné dokončit.</b><br>Žádost uložena. Zkuste to znovu později.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Obchod Play",
    "mobile_message_store_upgrade_confirm_title": "Dostupná aktualizace",
    "mobile_message_store_upgrade_confirm_message_one": "Aktualizujte prosím aplikaci Ops Execution z ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Aktualizujte aplikaci Zenput z obchodu ",
    "mobile_message_store_upgrade_confirm_message_two": " a získejte nejnovější funkce a opravy chyb.",
    "mobile_message_store_upgrade_confirm_now": "Nyní",
    "mobile_message_store_upgrade_confirm_later": "Později",
    "mobile_message_redirect_confirm_message": "Momentálně vyplňujete formulář. Než budete pokračovat, chcete ho uložit jako koncept?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Máte několik ({{count}}) konceptů, které jste zatím nenahráli. Pokud budete pokračovat, přijdete o ně. Chcete pokračovat?",
    "mobile_message_draft_override_message": "Tento koncept byl uložen z jiného zařízení v {{date}} a změny provedené na tomto zařízení se liší. Můžete se rozhodnout přepsat existující verzi, nebo znovu načíst poslední verzi a přijít o provedené změny.",
    "mobile_html_submitting": "Odesílání...",
    "mobile_html_offline": "Momentálně jste offline!",
    "mobile_html_offline_try_again": "Momentálně jste offline. <br/><br/>Zkuste znovu, jakmile se připojíte.",
    "mobile_html_something_went_wrong": "Ale ne. Něco se pokazilo.",
    "mobile_html_something_went_wrong_try_again": "Ale ne. Něco se pokazilo. Zkuste to znovu.",
    "mobile_html_failed_loading_roles": "Role se nenačetly.",
    "mobile_alert_please_install_for_native": "Chcete-li tuto funkci používat, nainstalujte si prosím aplikaci Ops Execution. ",
    "mobile_alert_please_install_for_native_old": "Chcete-li používat tuto funkci, nainstalujte nativní aplikaci Zenput.",
    "mobile_tso_filter_all_tasks": "Všechny {{type}}",
    "mobile_tso_filter_my_tasks": "Moje {{type}}",
    "mobile_tso_filter_due_date": "Termín",
    "mobile_tso_filter_date_completed": "Datum dokončení",
    "mobile_tso_filter_completed": "Dokončeno",
    "mobile_tso_filter_completed_late": "Dokončeno pozdě",
    "mobile_tso_filter_incomplete": "Nedokončeno",
    "mobile_tso_filter_var_my_tasks": "Moje {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "Vytvořeno mnou – {{filter_type}} {{type}}",
    "mobile_tso_filter_var_all_tasks": "Všechny {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Následující akce",
    "mobile_tso_type_all": "Úlohy a následující akce",
    "mobile_tso_filter_var_at": " pro: {{location}}",
    "mobile_tso_filter_group_date_due": ", seřazené dle termínu",
    "mobile_tso_filter_group_distance": ", seřazené dle umístění",
    "mobile_tso_filter_start_date": "Datum zahájení",
    "mobile_tso_filter_none": "Žádné",
    "mobile_pso_filter_all_projects": "Všechny projekty",
    "mobile_pso_filter_my_projects": "Moje projekty",
    "mobile_pso_filter_active": "Aktivní",
    "mobile_pso_filter_archived": "Archivováno",
    "mobile_pso_filter_recurring": "Opakující se",
    "mobile_pso_filter_non_recurring": "Neopakující se",
    "mobile_pso_filter_var_my_projects": "Moje projekty {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "Projekty {{project_type}} {{active_description}}, které jsem vytvořil/a",
    "mobile_pso_filter_var_all_projects": "Všechny projekty {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Zdá se, že jste offline. Chcete-li zobrazit výsledky, připojte se.",
    "mobile_empty_list_message_no_submissions": "Žádné žádosti",
    "mobile_empty_list_message_no_activity": "Žádná aktivita",
    "mobile_empty_list_message_no_tasks": "Žádné úkoly",
    "mobile_empty_list_message_no_tasks_overdue": "Žádné {{type}} po termínu",
    "mobile_empty_list_message_no_accounts": "Žádná umístění",
    "mobile_empty_list_message_no_projects": "Žádné projekty",
    "mobile_empty_list_message_no_results_found": "Nebyly nalezeny žádné výsledky",
    "mobile_empty_list_message_no_forms_available": "Žádné dostupné formuláře",
    "mobile_empty_list_message_connection_error": "Chyba připojení.<br />Zkuste to znovu.",
    "mobile_empty_list_message_dashboard_error": "Ovládací panel nelze načíst.",
    "mobile_empty_list_message_user_offline": "Momentálně jste offline.",
    "mobile_action_sheet_media_gallery": "Galerie",
    "mobile_action_sheet_cancel": "Zrušit",
    "mobile_image_preview_text": "Odebrat fotografii",
    "mobile_mobileform_text": "Předchozí žádosti",
    "mobile_mobileform_reorder_fields": "Změnit pořadí otázek",
    "mobile_mobileform_follow_up_actions": "Následné kroky",
    "mobile_mobileform_follow_up_actions_assign_title": "Přiřadit následující akce",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Přidejte následující akce na základě vašich pozorování pro vyřešení problémů.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Přidat následující akci",
    "mobile_mobileform_follow_up_actions_assign_button": "Přiřadit následující akce",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Pokračovat bez přiřazení",
    "mobile_mobileform_follow_up_actions_dialog_title": "Pokračovat bez přiřazení následujících akcí?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Budete-li pokračovat bez přiřazení jakýchkoli následujících akcí, později je nebude možné přidat.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "I tak pokračovat",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Toto pole je povinné",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Příliš mnoho znaků",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Toto pole je neplatné",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Chyba během načítání umístění",
    "mobile_mobileform_add_follow_up_actions_error_users": "Chyba během načítání uživatelů",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Přidat následující akci",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Název",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Popis",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Vyžadovat fotografii",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Termín dokončení",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Aktualizovat následující akci",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Odstranit následující akci?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Odstraní se a nebude přiřazena.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Odstranit následující akci",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Opravdu chcete tuto následující akci odstranit?\n\nTento krok nelze vrátit zpět.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Pokračovat na následující akce",
    "mobile_mobileform_follow_up_actions_completed_notification": "Následující akce byla dokončena",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Následující akce byla odstraněna",
    "mobile_mobileform_follow_up_actions_update_notification": "Následující akce byla aktualizována",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Chcete-li tuto následující akci dokončit, přidejte fotografii.",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Přejít na žádost",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Přejít ke zdroji",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Zdroj",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Dokončit následující akci",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Pokud otevřete žádost, všechny neuložené fotografie a poznámky se zruší.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Pokud tuto obrazovku opustíte, všechny neuložené fotografie a poznámky budou ztraceny.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Zůstat zde",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Otevřít žádost",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Otevřený zdrojový kód",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Ukončit tuto následující akci?",
    "mobile_mobileform_follow_up_actions_submission": "Žádost",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Tato následující akce je přiřazena uživateli {{user}}.<br />Nemůžete ji dokončit.",
    "mobile_mobileform_follow_up_actions_leave_description": "Pokud tuto obrazovku opustíte, všechny neuložené změny budou ztraceny.",
    "mobile_mobileform_follow_up_actions_leave": "Odejít",
    "mobile_forms_drafts_text": "Odebrat koncepty",
    "mobile_batch_estimate_user": "Uživatel",
    "mobile_batch_estimate_users": "Uživatelé",
    "mobile_table_of_contents": "Obsah",
    "mobile_table_of_contents_required": "Povinné",
    "mobile_table_of_contents_optional": "Nepovinné",
    "mobile_dialog_alert_title": "Upozornění",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Zařízení Bluetooth nejsou zatím v systému Windows podporována.",
    "mobile_windows_deprecated_message_content_announcement": "Oznámení",
    "mobile_windows_deprecated_message_title": "Je nutná aktualizace aplikace",
    "mobile_windows_deprecated_message_description": "Co nejdříve si nainstalujte novou aplikaci Zenput App z obchodu Microsoft Store, aby byly zajištěny aktualizace důležitých funkcí a optimalizováno prostředí Zenput.",
    "mobile_dashboard_tcr_graph_name": "Míra dokončení úkolů",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Poslední 4 týdny",
    "mobile_dashboard_tcr_legend_company_average": "Firemní průměr",
    "mobile_dashboard_tcr_legend_team_average": "Týmový průměr",
    "mobile_dashboard_tab_title_summary": "Souhrn",
    "mobile_dashboard_tab_title_activity": "Aktivita",
    "mobile_dashboard_card_title_top_triggered_workflows": "Největší spouštěče",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Soulad",
    "mobile_dashboard_card_task_stats_total": "Celkem",
    "mobile_dashboard_top_item_header_week_of": "Týden z",
    "mobile_dashboard_card_filter_form_template_placeholder": "Všechny formuláře",
    "mobile_dashboard_card_title_forms_top_nos": "Častá „Ne“",
    "mobile_dashboard_zenput_code_no_data_in_range": "V tomto časovém rozmezí nejsou žádná data.",
    "mobile_dashboard_zenput_code_permission_denied": "Ke zobrazení nemáte oprávnění.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Z výše uvedených vyberte formulář.",
    "mobile_dashboard_zenput_code_unknown_error": "Data nelze momentálně zobrazit.",
    "mobile_dashboard_tap_to_retry": "Klepnutím zopakovat",
    "mobile_dashboard_reporting_delay_disclaimer": "Aktualizace úkolů může trvat až 15 minut.",
    "mobile_dashboard_configuration_down_state_postfix_msg": "nakonfigurovány správcem.",
    "mobile_tasks_tag": "úkoly",
    "mobile_workflows_tag": "spouštěče",
    "mobile_projects_tag": "opakující se projekty",
    "mobile_forms_tag": "formuláře",
    "mobile_dashboard_card_ongoing_projects_title": "Probíhající projekty",
    "mobile_dashboard_card_ongoing_projects_show_more": "Zobrazit více",
    "mobile_dashboard_card_ongoing_projects_show_less": "Zobrazit méně",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Přejít na projekty",
    "mobile_dashboard_card_title_recurring_projects": "Opakující se projekty",
    "mobile_dashboard_card_filter_daily": "Denní",
    "mobile_dashboard_card_filter_weekly": "Týdenní",
    "mobile_dashboard_card_filter_monthly": "Měsíční",
    "mobile_task_status_title_open": "Otevřít",
    "mobile_task_status_title_upcoming": "Nadcházející",
    "mobile_task_status_title_complete": "Dokončit",
    "mobile_task_status_title_processing": "Zpracování žádosti",
    "mobile_task_status_title_complete_with_exceptions": "Dokončit s navazujícími akcemi nebo upozorněními",
    "mobile_task_status_title_completed_late_with_exceptions": "Dokončeno pozdě s následnými úkoly nebo upozorněními",
    "mobile_task_status_title_incomplete_and_closed": "Zmeškáno",
    "mobile_tasks_legend_modal_title": "Legenda",
    "mobile_tasks_legend_modal_footer_button_title": "Zavřít",
    "mobile_common_assigned_to": "Přiřazeno k",
    "mobile_common_created_by": "Vytvořil/a",
    "mobile_common_tasks_for": "Úkoly pro",
    "mobile_common_go_back": "Vrátit se",
    "mobile_oh_no": "Ale ne!",
    "mobile_user_not_in_groups": "Bohužel se zdá, že nejste přiřazeni k týmu. Chcete-li získat přístup k ovládacímu panelu, obraťte se na správce.",
    "mobile_tasks_select_followers": "Vybrat fanoušky",
    "mobile_tasks_assign_tasks": "Přiřadit úkoly: {{count}}",
    "mobile_tasks_add_followers": "Přidat sledující",
    "mobile_tasks_followers": "Sledující",
    "mobile_tasks_delete_task": "Odstranit úkol",
    "mobile_tasks_create_task": "Vytvořit úkoly",
    "mobile_tasks_tab_title_comments": "Komentáře",
    "mobile_tasks_see_more": "Zobrazit více",
    "mobile_projects_create_project": "Vytvořit projekt",
    "mobile_common_button_send": "Odeslat",
    "mobile_common_button_schedule": "Naplánovat",
    "mobile_announcements_create": "Vytvořit oznámení",
    "mobile_announcements_read_rate": "Počet otevřených: {{opened_count}} ze {{recipients_count}}",
    "mobile_announcements_empty_message": "Zatím jste nevytvořili žádná oznámení. Chcete-li vysílat důležité novinky, informace a aktuality ze své organizace, vytvořte oznámení.",
    "mobile_announcement_message_placeholder": "Přidat zprávu...",
    "mobile_announcement_title_placeholder": "Nadpis oznámení",
    "mobile_announcement_leaving_announcement": "Opouštění oznámení",
    "mobile_announcement_confirm_recipients_team": "Chcete toto oznámení vysílat pro uživatele ({{count}}) ve vybraných týmech {{teams}}?",
    "mobile_announcement_confirm_recipients_role": "Chcete toto oznámení vysílat pro uživatele ({{count}}) ve vybraných rolích ({{roles}})?",
    "mobile_announcement_confirm_recipients_user": "Chcete toto oznámení vysílat pro daný počet uživatelů ({{count}})?",
    "mobile_announcement_confirm_scheduled": "V {{timestamp}}",
    "mobile_announcement_sending_announcement": "Odesílání oznámení",
    "mobile_announcement_send_to": "Odeslat (komu)",
    "mobile_announcement_sent_to": "Odesláno (komu)",
    "mobile_announcement_send_to_role": "Role",
    "mobile_announcement_attachment_download": "Stahování souboru {{filename}}",
    "mobile_announcement_attachment_validation_error": "Nelze přidat více než {{maxCount}} příloh",
    "mobile_announcement_details_sent": "Odesláno",
    "mobile_announcement_details_total_recipients": "Celkový počet příjemců",
    "mobile_announcement_details_cancel": "Zrušit oznámení",
    "mobile_announcement_details_not_editable": "Oznámení lze upravovat pouze ve webové aplikaci Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Oznámení lze upravit pouze na webu Zenput.",
    "mobile_announcement_details_open_count": "Počet otevřených",
    "mobile_announcement_details_open_rate": "Míra otevřených",
    "mobile_announcement_details_resend": "Znovu zaslat pro ty, kteří je neotevřeli",
    "mobile_announcement_confirm_resend": "Uživatelé ({{count}}) si oznámení nepřečetli. Chcete odeslat připomenutí?",
    "mobile_announcement_confirm_resend_title": "Odeslat připomenutí?",
    "mobile_announcement_recipients_opened": "Otevřeno",
    "mobile_recipients_opened_empty_message": "Zdá se, že vaši zprávu zatím nikdo neotevřel. Chcete-li zobrazit výsledky, vraťte se zpět později.",
    "mobile_announcement_recipients_unopened": "Neotevřeno",
    "mobile_recipients_unopened_empty_message": "Skvělé novinky! Nemáte žádné neotevřené zprávy!",
    "mobile_scheduled_announcements_delivery_section_header": "Čas doručení",
    "mobile_scheduled_announcements_send_immediately_label": "Odeslat hned",
    "mobile_scheduled_announcements_scheduled_label": "Odeslat v určitou dobu",
    "mobile_scheduled_announcements_scheduled_tab_label": "Naplánováno",
    "mobile_scheduled_announcements_dialog_header": "Zrušit oznámení?",
    "mobile_scheduled_announcements_dialog_message": "Pokud oznámení zrušíte, nebude už zasíláno a bude odstraněno z vašeho seznamu. Tuto akci nelze vrátit. Chcete-li jej upravit, přejděte na web Zenput.",
    "mobile_scheduled_announcements_empty_message": "Zatím nemáte naplánovaná žádná oznámení. Chcete-li vysílat důležité novinky, informace a aktuality ze své organizace, vyberte oznámení.",
    "mobile_scheduled_announcements_validation_error": "Čas doručení musí být po {{date}}.",
    "mobile_scheduled_announcements_empty_state_button": "Naplánovat oznámení",
    "mobile_projects_auto_archive": "Automaticky archivovat",
    "mobile_common_unassigned": "Nepřiřazeno",
    "mobile_tasks_title_placeholder": "Nový úkol nebo formulář",
    "mobile_projects_leaving_project": "Opouštění projektu",
    "mobile_projects_save_project": "Uložit projekt",
    "mobile_top_triggers_tasks": "Nejvíce spouštěné úkoly",
    "mobile_top_triggers_alerts": "Nejvíce spouštěná upozornění",
    "mobile_projects_not_started": "Nezahájeno",
    "mobile_empty_list_message_no_photos": "Žádné fotografie",
    "mobile_webfilestore_message_error": "Vyberte platný typ souboru.",
    "mobile_notifications_empty_title": "Žádná oznámení",
    "mobile_notifications_empty_message": "Zde se zobrazí aktivita u vašich úkolů nebo úkolů, jichž jste součástí.",
    "mobile_comments_comment_deleted": "Tento komentář byl odstraněn.",
    "mobile_comments_comment_placeholder": "Komentář",
    "mobile_comments_task_submitted_at": "Úkol odeslán dne {{ date }} v {{ time }}",
    "mobile_comments_discard_comment_title": "Zahodit komentář?",
    "mobile_comments_discard_confirm_message": "Jste si jistí? Váš komentář bude odstraněn.",
    "mobile_comments_delete_comment_title": "Odstranit komentář?",
    "mobile_comments_delete_confirm_message": "Tuto akci nelze vrátit.",
    "mobile_comments_delete_button": "Odstranit komentář",
    "mobile_comments_delete_success_message": "Komentář byl odstraněn.",
    "mobile_comments_empty_message_tasks": "Zatím zde nejsou žádné komentáře. \n Zahajte konverzaci k tomuto úkolu.",
    "mobile_comments_empty_message_submissions": "Zatím zde nejsou žádné komentáře. \n Zahajte konverzaci k této žádosti.",
    "mobile_comments_empty_message_default": "Zatím zde nejsou žádné komentáře. \n Zahajte konverzaci.",
    "mobile_comments_no_matching_users": "Nevyhovují žádní uživatelé.",
    "mobile_comments_empty_users_to_notify": "Nejsou zde žádní uživatelé, které můžete informovat.",
    "mobile_comments_users_cant_view_message": "Tito uživatelé nemohou zobrazit tyto komentáře.",
    "mobile_comments_users_to_notify_title": "Uživatelé, kteří mají být informováni",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} uživatel</a> bude informován.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">Počet uživatelů, kteří budou informováni: {{ count }}</a>.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@zmiňte</a> další uživatele, kteří mají být informováni.",
    "mobile_comments_mark_read": "Označit vše jako přečtené",
    "mobile_comments_author_mentioned_message": "vás zmínil/a v",
    "mobile_comments_author_commented_message": "okomentovaném dne",
    "mobile_view_pdf": "Zobrazit PDF",
    "mobile_no_pdf_generated_message": "Pro tuto žádost nebyl nalezen žádný soubor PDF. Brzy vám bude e-mailem zaslána kopie.",
    "mobile_clipboard_copied_success": "Odkaz byl zkopírován do vaší schránky.",
    "mobile_share_link": "Sdílet odkaz",
    "mobile_zencam_share": "Sdílet",
    "mobile_zencam_view_details": "Zobrazit podrobnosti",
    "mobile_zencam_details_drawer_header": "Podrobnosti",
    "mobile_zencam_submitted_by": "Odeslal/a",
    "mobile_zencam_form_title": "Název formuláře",
    "mobile_zencam_date_submitted": "Datum odeslání",
    "mobile_oil_quality_warning_message": "Brzy vyprší interval výměny oleje",
    "mobile_oil_quality_warning_message_subtitle": "Co nejdříve naplánujte výměnu oleje",
    "mobile_oil_quality_failure_message": "Kvalita oleje se zhoršila",
    "mobile_oil_quality_failure_message_subtitle": "Neprodleně olej vyměňte",
    "mobile_sensors_set_up_gateway": "Nastavit bránu",
    "mobile_sensors_set_up_gateway_message": "Zdá se, že zde nejsou nastavena žádná zařízení. Začněte přidáním brány.",
    "mobile_sensors_gateway_plugged_in": "Ujistěte se, že brána je zapojena do zásuvky.",
    "mobile_sensors_add_device": "Přidat zařízení",
    "mobile_sensors_name_this_gateway": "Zadejte název brány.",
    "mobile_sensors_name_this_sensor": "Zadejte název snímače.",
    "mobile_sensors_device_barcode_information": "Naskenujte QR kód nebo zadejte ID a SC číslo ze štítku zařízení",
    "mobile_sensors_device_eui_information": "Naskenujte QR kód nebo zadejte DevEUI ze štítku zařízení",
    "mobile_sensors_gateway_id_information": "Zadejte ID uzlu ze štítku brány",
    "mobile_sensors_id_number": "Číslo {{untranslatedID}}",
    "mobile_sensors_sc_code": "Kód {{untranslatedSCCode}}",
    "mobile_sensors_sensors": "Snímače",
    "mobile_sensors_sensor_deveui_error": "Nepodařilo se mi získat DevEUI z QR. Zadejte jej ručně.",
    "mobile_sensors_gateways": "Brány",
    "mobile_sensors_add_sensor": "Přidat snímač",
    "mobile_sensors_add_gateway": "Přidat bránu",
    "mobile_sensor_placement_description": "Jakou oblast bude tento snímač monitorovat?",
    "mobile_sensors_equipment_placement": "Jakou oblast nebo zařízení bude tento snímač monitorovat?",
    "mobile_sensors_equipment": "Jaké zařízení bude tento snímač monitorovat?",
    "mobile_sensors_select_gateway_type": "Vybrat typ brány",
    "mobile_sensors_select_placement": "Vybrat umístění",
    "mobile_sensors_select_equipment": "Vybrat zařízení",
    "mobile_sensors_placement": "Umístění",
    "mobile_sensors_nickname_tip": "Pojmenování snímačů je určováno přezdívkami přiřazenými ve vybraném umístění.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Naskenovat QR kód",
    "mobile_sensors_enter_manually": "Zadat ručně",
    "mobile_sensors_wizard_step_one": "Krok 1",
    "mobile_sensors_wizard_step_two": "Krok 2",
    "mobile_sensors_wizard_step_three": "Krok 3",
    "mobile_sensors_wizard_step_four": "Krok 4",
    "mobile_sensors_wizard_step_five": "Krok 5",
    "mobile_sensors_wizard_step_six": "Krok 6",
    "mobile_sensors_initializing": "Inicializace...",
    "mobile_sensors_nickname": "Přezdívka",
    "mobile_sensors_field_not_blank": "Pole {{field}} nesmí zůstat nevyplněno.",
    "mobile_sensors_nothing_to_see_here": "Tady nic není.",
    "mobile_sensors_missing_integration": "Chybí integrace snímače",
    "mobile_sensors_contact_zenput_admin": "Obraťte se prosím na správce aplikace Ops Execution ve vaší společnosti.",
    "mobile_sensors_contact_zenput_admin_old": "Obraťte se na svého správce Zenput.",
    "mobile_sensors_contact_manager": "Chcete-li přidat snímače, obraťte se na správce účtu.",
    "mobile_sensors_device_success_message": "Načtení dat ze snímače může trvat až 15 minut.",
    "mobile_sensors_last_reading": "Poslední čtení",
    "mobile_sensors_remove_device": "Odebrat zařízení",
    "mobile_sensors_one_day": "1 den",
    "mobile_sensors_one_week": "1 týden",
    "mobile_sensors_one_month": "1 měsíc",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1 rok",
    "mobile_sensors_sensor_settings": "Nastavení snímače",
    "mobile_sensors_remove_confirm_message": "Opravdu chcete toto zařízení odstranit?\nTuto akci nelze vrátit.",
    "mobile_sensors_sensor": "Snímač",
    "mobile_sensors_no_equipment_linked": "Není svázáno žádné zařízení",
    "mobile_sensor_cooldown_process": "Proces chlazení",
    "mobile_sensor_last_12_hours": "Posledních 12 hodin",
    "mobile_sensor_start_cooldown_process": "Zahájit nový proces chlazení",
    "mobile_sensor_cooldown_process_title": "Dvoufázový proces chlazení",
    "mobile_sensor_cooldown_process_description": "Dvoufázový proces chlazení sestává z chlazení potravin z teploty vyšší než {{ stage1_start_temperature }} na teplotu {{ stage1_end_temperature }} za dvě nebo méně hodin a poté z teploty {{ stage1_end_temperature }} na teplotu {{ stage2_end_temperature }} za čtyři nebo méně hodin.",
    "mobile_sensor_cooldown_process_place_food": "Vložte potraviny do chladničky.",
    "mobile_sensor_cooldown_process_insert_sensor": "Vložte sondu snímače do potraviny.",
    "mobile_sensor_cooldown_process_enter_information": "Níže zadejte informace.",
    "mobile_sensor_cooldown_process_food_product": "Potraviny ke zchlazení",
    "mobile_sensor_cooldown_cool_down": "Zchladit",
    "mobile_sensor_cooldown_select_sensor": "Vybrat snímač",
    "mobile_sensors_cooldown_start_cooldown": "Zahájit chlazení",
    "mobile_sensors_cooldown_please_enter_food": "Vložte potraviny.",
    "mobile_sensors_cooldown_please_select_sensor": "Vyberte snímač.",
    "mobile_sensors_cooldown_status_in_progress": "Probíhá",
    "mobile_sensors_cooldown_status_failed": "Neúspěch",
    "mobile_sensors_cooldown_status_success": "Úspěch",
    "mobile_sensors_cooldown_stage": "Fáze",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Počáteční teplota je mimo rozmezí.",
    "mobile_sensors_cooldown_failed_cooldown_process": "Proces chlazení se nezdařil.",
    "mobile_sensors_cooldown_cooldown_successful": "Proces chlazení proběhl úspěšně.",
    "mobile_sensors_cooldown_started_cooldown_process": "Proces chlazení zahájen",
    "mobile_sensors_cooldown_hour": "hod",
    "mobile_sensors_cooldown_hour_plural": "hod",
    "mobile_sensors_cooldown_minute": "min",
    "mobile_minutes_plural": "min",
    "mobile_sensors_last_reading_max_date": "> před více než 1 rokem",
    "mobile_sensors_minute_count_ago": "Před {{count}} min",
    "mobile_sensors_minute_count_ago_plural": "Před {{count}} min",
    "mobile_sensors_hour_count_ago": "Před {{count}} hod",
    "mobile_sensors_hour_count_ago_plural": "Před {{count}} hod",
    "mobile_sensors_day_count_ago": "Před {{count}} d",
    "mobile_sensors_day_count_ago_plural": "Před {{count}} d",
    "mobile_sensors_chart_settings": "Nastavení grafu",
    "mobile_announcement_banner_continue_reading": "Pokračovat ve čtení",
    "mobile_compliance_submissions_report": "Výkaz s žádostí",
    "mobile_compliance_submissions_report_subtitle": "Exportovat data o dokončení projektů pro tento obchod",
    "mobile_compliance_send_submissions": "Odeslat žádosti",
    "mobile_compliance_completion_rate_in_last_days": "Míra dokončení za poslední {{ days }} dny/dnů",
    "mobile_compliance_last_days": "Poslední {{ days }} dny/dnů",
    "mobile_compliance_send_submissions_to": "Příjemce odeslané žádosti:",
    "mobile_compliance_send_to_different_email": "Odeslat na jiný e-mail",
    "mobile_compliance_email_input_placeholder": "E-mailová adresa",
    "mobile_compliance_send_submissions_to_legend_title": "Žádosti",
    "mobile_compliance_send_submissions_to_legend_description_days": "Na zvolený e-mail bude odeslán výkaz s údaji odeslanými za poslední {{ days }} dny/dnů z tohoto umístění.",
    "mobile_compliance_time_frame": "Časový rámec",
    "mobile_compliance_sensor_temperature_log_report": "Výkaz s protokolem teploty ze snímače",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exportovat protokoly teploty pro tento obchod",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Podmínky",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "V následující části definujte podmínky výkazu.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Poznámka: deaktivované snímače nebudou ve výkazu uvedeny",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Vyberte časový úsek. Limit pro data protokolu je 30 dnů.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Odeslat výkaz",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Tento měsíc (1. až dnes)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Minulý měsíc",
    "mobile_compliance_sensor_temperature_log_email_title": "Příjemce odeslaného výkazu",
    "mobile_pwa_update_prompt_title": "Aktualizovat aplikaci",
    "mobile_pwa_update_prompt_description": "K dispozici je nová verze aplikace. Aktualizujte aplikaci na nejnovější verzi.",
    "mobile_pwa_update_prompt_confirm": "Aktualizovat a znovu načíst",
    "mobile_pwa_update_prompt_cancel": "Připomenout později",
    "notification_title_due_in_one_hour": "Termín za 1 hodinu",
    "task_is_due_soon": "'{{ task_title }}' má brzy termín. Věnujte chvíli jeho dokončení.",
    "mobile_photo_quality_warning_header": "Problém s kvalitou fotografie",
    "mobile_photo_quality_dialog_message": "Tato fotografie může být příliš tmavá nebo rozmazaná. Chcete zhotovit novou fotografii nebo pokračovat se stávající fotografií?",
    "mobile_take_new_photo": "Zhotovit novou fotografii",
    "mobile_use_this_photo": "Použít tuto fotografii"
}};
mobile_translations.uk_UA = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Усі",
    "mobile_common_button_apply_filters": "Застосувати фільтри",
    "mobile_common_button_done": "Готово",
    "mobile_common_button_edit": "Редагувати",
    "mobile_common_button_archive": "Архівувати",
    "mobile_common_button_save": "Зберегти",
    "mobile_common_button_retake": "Змінити",
    "mobile_common_button_save_draft": "Зберегти чернетку",
    "mobile_common_button_discard": "Скасувати",
    "mobile_common_button_submit": "Надіслати",
    "mobile_common_button_no": "Ні",
    "mobile_common_button_yes": "Так",
    "mobile_common_button_na": "н/д",
    "mobile_common_created_by_me": "Створено мною",
    "mobile_common_email": "Електронна адреса компанії",
    "mobile_common_first_name": "Ім'я",
    "mobile_common_last_name": "Прізвище",
    "mobile_common_location": "Локація",
    "mobile_common_locations": "Локації",
    "mobile_common_logout_message": "Ви дійсно хочете вийти?",
    "mobile_common_password": "Пароль",
    "mobile_common_permission_required": "Потрібен дозвіл",
    "mobile_common_status": "Стан",
    "mobile_common_task": "Завдання",
    "mobile_common_tasks": "Завдання",
    "mobile_common_tasks_my": "Мої завдання",
    "mobile_common_projects": "Проєкти",
    "mobile_common_filter_team": "Команда",
    "mobile_common_filter_var_in": " в {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Не вибрано команду",
    "mobile_common_filter_no_user_selected": "Не вибрано користувача",
    "mobile_common_filter_no_role_selected": "Не вибрано роль",
    "mobile_common_placeholder_date": "Дата",
    "mobile_common_message_task_creator_error_save": "<b>Неможливо створити завдання.</b>",
    "mobile_common_camera": "Камера",
    "mobile_common_microphone": "Мікрофон",
    "mobile_common_for": "для",
    "mobile_common_reload": "Перезавантажити",
    "mobile_common_override": "Перевизначити",
    "mobile_common_notifications": "Сповіщення",
    "mobile_common_chat_unavailable": "Чат недоступний. Повторіть спробу пізніше.",
    "mobile_common_chat_ending_dialog_title": "Цю розмову завершено?",
    "mobile_common_chat_ending_dialog_description": "Повідомте нам, чи вашу проблему вирішено або ви просто хочете продовжити пізніше.",
    "mobile_common_chat_ending_dialog_confirm": "Так, завершено",
    "mobile_common_chat_ending_dialog_cancel": "Я продовжу пізніше",
    "mobile_common_continue_editing": "Продовжуйте редагування",
    "mobile_privacy_policy": "Політика конфіденційності",
    "wootric_recommend_target": "друг або колега у вашій галузі",
    "wootric_followup_detractor_question": "Що нам потрібно змінити, щоб наступного разу ви нас краще оцінили?",
    "wootric_followup_passive_question": "Дякуємо! Що ще нам потрібно зробити для покращення цього засобу?",
    "wootric_followup_promoter_question": "Дякуємо! Що вам подобається в Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Дякуємо! Що вам подобається в Zenput?",
    "wootric_default_followup_question": "Дякуємо! Бажаєте розказати, чому?",
    "wootric_default_placeholder_text": "Ви нам допоможете, якщо поясните свою оцінку.",
    "wootric_default_thankyou_text": "Дякуємо за відповідь і відгук!",
    "mobile_login_placeholder_login_as": "Вхід у систему за допомогою ідентифікатора користувача",
    "mobile_login_button_forgot_password": "Забули пароль?",
    "mobile_login_button_sign_up": "Створити обліковий запис",
    "mobile_login_button_finish_setup": "Завершити налаштування",
    "mobile_login_button": "Вхід у систему",
    "mobile_login_continue_button": "Продовжити",
    "mobile_login_continue_transition": "перехід на сторінку входу вашої організації…",
    "mobile_login_no_email_error": "Потрібно ввести адресу електронної пошти.",
    "mobile_login_change_email": "Вхід у систему з іншою адресою електронної пошти",
    "mobile_login_with_sso": "Вхід за допомогою технології єдиного входу",
    "mobile_oauth_no_user_error_message": "Схоже, у вас немає облікового запису Crunchtime Ops Execution.",
    "mobile_oauth_no_user_error_message_old": "Схоже, що у вас немає облікового запису Zenput!",
    "mobile_rebrand_announcement_banner": "Програма <b>Zenput</b> стала <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} стає {{- product }} у вересні. {{- cta }}",
    "mobile_rebrand_warning_cta": "Дізнайтеся, як підготуватися.",
    "mobile_oauth_no_user_error_sub_message": "Зверніться до адміністратора, щоб отримати доступ, або спробуйте ввійти в систему з іншою адресою електронної пошти.",
    "mobile_oauth_generic_error_message": "Схоже, під час входу в систему виникла проблема. Спробуйте ще раз.",
    "mobile_oauth_force_logout_msg": "Якщо у вас все ще є проблеми, вийдіть із сеансу свого постачальника, ",
    "mobile_oauth_force_logout_click": "натиснувши тут.",
    "mobile_sign_up_placeholder_phone": "Номер мобільного телефону",
    "mobile_sign_up_placeholder_password_confirm": "Підтвердьте пароль",
    "mobile_sign_up_button_sign_in": "Вхід",
    "mobile_sign_up_disclaimer_part_1": "Натиснувши \"Створити обліковий запис\", ви приймаєте умови",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Натиснувши «Завершити налаштування», ви приймаєте умови",
    "mobile_sign_up_disclaimer_link_title": " Ліцензійної угоди",
    "mobile_sign_up_disclaimer_part_2": ", яка містить важливу інформацію про конфіденційність",
    "mobile_dialog_benefits_work_offline": "Робота в режимі офлайн",
    "mobile_dialog_benefits_faster_uploads": "Швидше передавання",
    "mobile_dialog_benefits_better_experience": "Зручніше користування",
    "mobile_dialog_benefits_button_download": "Завантажити",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution для ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput для ",
    "mobile_dialog_benefits_button_have": "У мене є додаток!",
    "mobile_dialog_benefits_button_no_thanks": "Ні, дякую, можливо пізніше.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Не вдалося завантажити зображення.",
    "mobile_dialog_signature_sign": "Підпишіть тут",
    "mobile_dialog_signature_button_clear": "Очистити",
    "mobile_account_placeholder_name": "Назва локації/магазина",
    "mobile_account_placeholder_phone": "Телефон",
    "mobile_account_placeholder_address": "Адреса",
    "mobile_account_placeholder_city": "Місто",
    "mobile_account_placeholder_region": "Область",
    "mobile_account_placeholder_zipcode": "Поштовий індекс",
    "mobile_account_option_select_country": "Виберіть країну",
    "mobile_account_oprion_us": "Сполучені Штати",
    "mobile_account_oprion_select_state": "Виберіть регіон",
    "mobile_account_button_create_location": "Створити локацію",
    "mobile_form_message_no_form": "Немає доступних форм",
    "mobile_batch_task_message": "Завантаження…",
    "mobile_settings_profile": "Профіль",
    "mobile_settings_profile_number": "Мобільний телефон",
    "mobile_settings_profile_language": "Мова",
    "mobile_settings_profile_temperature_unit": "Одиниця вимірювання температури",
    "mobile_settings_profile_use_company_default": "Використовуйте одиницю компанії за замовчуванням",
    "mobile_settings_profile_celsius": "Градуси за Цельсієм",
    "mobile_settings_profile_fahrenheit": "Градуси за Фаренгейтом",
    "mobile_settings_notifications_option_sms": "Текстове повідомлення",
    "mobile_settings_notifications_option_push": "Push-сповіщення",
    "mobile_settings_notifications_option_push_email": "Повідомлення електронною поштою та push-сповіщення",
    "mobile_settings_notifications_option_do_not": "Не повідомляти",
    "mobile_settings_notifications_category_communication": "Спілкування",
    "mobile_settings_notifications_category_forms_and_triggers": "Форми і тригери",
    "mobile_settings_devices": "Пристрої",
    "mobile_settings_notifications_sub_category_alerts": "Оповіщення",
    "mobile_settings_notifications_sub_category_new_forms_available": "Доступні нові форми",
    "mobile_settings_notifications_sub_category_task_assigned": "Завдання призначено",
    "mobile_settings_notifications_sub_category_task_completed": "Завдання завершено",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Нагадування про наближення терміну здачі завдань",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Нагадування про простроченні завдання",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Оповіщення датчика",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Критичні оповіщення датчика",
    "mobile_drafts_message": "У вас ще немає чернеток.",
    "mobile_drafts_button_delete": "Видалити",
    "mobile_tasks_filter_location_no": "Не вибрано локацію",
    "mobile_tasks_filter_group_by": "Групувати за",
    "mobile_tasks_filter_sort_by": "Сортувати за",
    "mobile_tasks_filter_sorted_by": "Відсортовано за",
    "mobile_tasks_filter_due_time": "Час за розкладом",
    "mobile_tasks_filter_open_time": "Час відкриття",
    "mobile_tasks_bucket_due_next_24_hours": "Завершується протягом наступних 24 год",
    "mobile_tasks_bucket_due_next_7_days": "Завершується протягом наступних 7 днів",
    "mobile_tasks_bucket_open_tasks": "Додаткові відкриті {{type}}",
    "mobile_tasks_bucket_open_at": "Відкрито: {{- date }} о {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Завершення до: {{- date }} о {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Доступно через 1 хвилину",
    "mobile_tasks_bucket_available_in_one_hour": "Доступно через 1 годину",
    "mobile_tasks_bucket_available_in_one_day": "Доступно через 1 день",
    "mobile_tasks_bucket_available_in_one_week": "Доступно через 1 тиждень",
    "mobile_tasks_bucket_available_in_one_month": "Доступно через 1 місяць",
    "mobile_tasks_bucket_available_in_one_year": "Доступно через 1 рік",
    "mobile_tasks_bucket_available_in_minutes": "Доступно через {{ minutes }} хв",
    "mobile_tasks_bucket_available_in_hours": "Доступно через {{ hours }} год",
    "mobile_tasks_bucket_available_in_days": "Доступно через {{ days }} дн.",
    "mobile_tasks_bucket_available_in_weeks": "Доступно через {{ weeks }} тижн.",
    "notification_task_due_in_minutes": "Термін закінчується через {{ minutes }} хвилин",
    "mobile_tasks_bucket_available_in_months": "Доступно через {{ months }} міс.",
    "mobile_tasks_bucket_available_in_years": "Доступно через {{ years }} р.",
    "mobile_tasks_follow_up": "Подальше завдання",
    "mobile_tasks_due_soon": "Термін скоро",
    "mobile_tasks_bucket_completed_today": "Завершено сьогодні",
    "mobile_tasks_bucket_completed_this_week": "Завершено цього тижня",
    "mobile_tasks_bucket_completed_last_week": "Завершено минулого тижня",
    "mobile_tasks_bucket_missed_today": "Пропущено сьогодні",
    "mobile_tasks_bucket_missed_this_week": "Пропущено цього тижня",
    "mobile_tasks_bucket_missed_last_week": "Пропущено минулого тижня",
    "mobile_tasks_bucket_no_location": "Без Локації",
    "mobile_tasks_cannot_submit_missed": "Пропущені завдання неможливо завершити",
    "mobile_tasks_cannot_submit_missed_after": "Це завдання неможливо завершити після {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Це завдання не розпочато.",
    "mobile_tasks_cannot_submit_processing": "Це надсилання обробляється",
    "mobile_tasks_toolbarnav_header_no_due_date": "Без терміну виконання",
    "mobile_tasks_toolbarnav_header_overdue": "Прострочено",
    "mobile_tasks_toolbarnav_header_yesterday": "Учора",
    "mobile_tasks_toolbarnav_header_today": "Сьогодні",
    "mobile_tasks_toolbarnav_header_tomorrow": "Завтра",
    "mobile_tasks_toolbarnav_header_last_week": "Минулого тижня",
    "mobile_tasks_toolbarnav_header_this_week": "Цього тижня",
    "mobile_tasks_toolbarnav_header_next_week": "Наступного тижня",
    "mobile_tasks_toolbarnav_header_this_month": "Цього місяця",
    "mobile_tasks_toolbarnav_header_next_year": "Наступного року",
    "mobile_tasks_toolbarnav_header_over_year": "Більше року",
    "mobile_tasks_toolbarnav_title_edit_task": "Редагувати завдання",
    "mobile_task_placeholder_title": "Назва *",
    "mobile_task_placeholder_description": "Опис (необов'язково)",
    "mobile_task_button_single_task": "Окреме завдання",
    "mobile_task_button_project": "Проєкт",
    "mobile_task_button_create": "Створити",
    "mobile_task_tab_basic": "Базовий",
    "mobile_task_tab_photo": "Фото",
    "mobile_task_tab_form": "Форма",
    "mobile_task_details_description_message_please": "Будь ласка, заповніть ",
    "mobile_task_details_description_message_below": "нижче.",
    "mobile_task_details_description_message_instructions": "Для цього завдання немає інструкцій.",
    "mobile_task_details_reason_title": "Подальші дії ініційовано",
    "mobile_task_detials_button_goto_form": "Перейти до форми",
    "mobile_task_detials_button_complete": " Завершити завдання",
    "mobile_task_detials_completed": "Завершено ",
    "mobile_task_detials_completed_by": "— ",
    "mobile_task_detials_completed_on": "на ",
    "mobile_task_details_view_form_submission": "Перегляд надсилання форми",
    "mobile_task_task_updated": "Завдання оновлено",
    "mobile_task_task_archived": "Завдання заархівовано",
    "mobile_task_task_deleted": "Завдання видалено",
    "mobile_task_error_archiving_task": "Неможливо заархівувати завдання.",
    "mobile_task_error_deleting_task": "Неможливо видалити завдання.",
    "mobile_task_error_updating_task": "Неможливо оновити завдання.",
    "mobile_task_archive_task": "Архівувати завдання",
    "mobile_task_archive_task_confirm": "Справді заархівувати це завдання?\n\nЗаархівовані завдання враховуватимуться у відсотках завершення та надалі будуть у звітності.\n\nЦе неможливо скасувати.",
    "mobile_task_delete_task_confirm": "Справді видалити це завдання?\n\nВидалені завдання не враховуватимуться у відсотках завершення та не будуть у звітності.\n\nЦе неможливо скасувати.",
    "mobile_task_edition_already_in_progress": "Це завдання очікує розгляду для редагування. Подальше редагування зараз заборонено.",
    "mobile_projects_filter_type": "Тип",
    "mobile_projects_filter_status": "Стан проєкту",
    "mobile_projects_filter_project_type": "Тип проєкту",
    "mobile_projects_due_date_required": "Потрібен термін виконання.",
    "mobile_projects_team_required": "Потрібна команда.",
    "mobile_projects_user_role_required": "Потрібен виконавець.",
    "mobile_projects_title_required": "Потрібна назва.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Кілька завдань за день",
    "mobile_project_tasks_complete": " Завершити",
    "mobile_project_tasks_remaining": " Залишилося",
    "mobile_esitmate_message_tasks": "Буде створено 0 завдань",
    "mobile_esitmate_message_criteria": "Налаштуйте критерії вище",
    "mobile_esitmate_message_created_for": "буде створено для",
    "mobile_left_menu_dashboard": "Інформаційна панель",
    "mobile_left_menu_my_forms": "Мої форми",
    "mobile_left_menu_announcements": "Оголошення",
    "mobile_left_menu_my_submissions": "Мої надсилання",
    "mobile_left_menu_drafts": "Чернетки",
    "mobile_left_menu_pending_uploads": "Очікування на передавання",
    "mobile_left_menu_open": "Відкрити в додатку",
    "mobile_left_menu_settings": "Налаштування",
    "mobile_left_menu_log_out": "Вийти",
    "mobile_left_menu_debug": "Налагодити",
    "mobile_left_menu_support": "Підтримка",
    "mobile_left_menu_documentation": "Документація",
    "mobile_left_menu_chat": "Чат",
    "mobile_field_textarea_placeholder_note": "Примітка або підпис",
    "mobile_field_option_select": "Вибрати",
    "mobile_field_text_placeholder_text": "Текст",
    "mobile_field_email_placehoder_email": "Eлектронна пошта",
    "mobile_filed_number_placeholder_number": "Число",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Не підключено",
    "mobile_field_sensor_offline_battery": "Датчик не в мережі — батарея",
    "mobile_field_video_button_add": "Додати відео",
    "mobile_field_video_picker_dialog_title": "Додати відео з",
    "mobile_field_video_button_change": "Змінити відео",
    "mobile_field_image_button_add": "Додати зображення",
    "mobile_field_image_low_quality_warning": "Деякі фото можуть виглядати занадто темними або нечіткими. Перегляньте виділені фото та за потреби замініть їх",
    "mobile_field_image_picker_dialog_title": "Додати фото з",
    "mobile_field_image_picker_edit_failed": "Не вдалося зберегти зображення. Спробуйте ще раз.",
    "mobile_field_signature_button_add": "Додати підпис",
    "mobile_field_signature_button_change": "Додати підпис",
    "mobile_field_account_select_location": "Вибрати локацію",
    "mobile_field_account_prefill": "Попередньо заповнити форму даними останнього відвідування?",
    "mobile_field_account_message_overwrite": "Буде перезаписано всі поля, які ви вже заповнили.",
    "mobile_forms_task_on_behalf": "У цій локації має бути виконано завдання, яке призначено користувачу <b>{{user}}</b>. Ви хочете завершити це завдання?",
    "mobile_forms_complete_task": "Завершити завдання?",
    "mobile_field_account_prefill_button_yes": "Так, попередньо заповнити",
    "mobile_field_barcode_placeholder_scan": "Відскануйте або введіть штрих-код",
    "mobile_field_sensor_qr_code_placeholder_scan": "Відскануйте або введіть код",
    "mobile_field_gateway_id_code_placeholder": "Введіть ідентифікатор вузла",
    "mobile_field_scan_qr_or_enter_dev_eui": "Відскануйте QR-код або введіть ідентифікатор DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Відскануйте QR-код або введіть ідентифікаційний номер",
    "mobile_field_scan_qr_or_enter_sc": "Відскануйте QR-код або введіть код SC",
    "mobile_field_barcode_select_date": "Виберіть дату ",
    "mobile_field_datetime_allow_time": "Час",
    "mobile_field_stopwatch_button_caption": "Секундомір",
    "mobile_field_stopwatch_common_start": "Почати",
    "mobile_field_stopwatch_common_stop": "Зупинити",
    "mobile_field_stopwatch_common_reset": "Скинути",
    "mobile_field_stopwatch_stop_stopwatches": "Зупинити секундомір",
    "mobile_field_document_title": "Додати документ",
    "mobile_field_document_message_delete": "Справді видалити цей документ?",
    "mobile_field_document_alret_button_view": "Переглянути",
    "mobile_field_document_alert_error": "Під час додавання цього документа сталася помилка. Спробуйте ще раз.",
    "mobile_field_document_alert_file_size_error": "Файл не може перевищувати {{count}} МБ.",
    "mobile_field_temperature_greater_range": "більше за {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "не менше за {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "менше за {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "не більше за {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "не менше за {{ min_temp_value }} °{{ temp_unit }} і не більше за {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "щонайменше {{ min_temp_value }} °{{ temp_unit }} і щонайбільше {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " і ",
    "mobile_field_text_limit_error": "Досягнуто максимального ліміту символів, що становить 8000.",
    "mobile_forms_required_questions_complete": "Обов'язкові заповнено",
    "mobile_forms_required_remaining": "Залишилось обов’язкових: {{count}}",
    "mobile_forms_required_questions_back": "Назад",
    "mobile_forms_required_questions_next": "Далі",
    "mobile_forms_required_questions_skip": "Пропустити",
    "mobile_forms_leaving_form": "Залишити форму",
    "mobile_message_reordering_confirm": "Зберегти новий порядок запитань?",
    "mobile_forms_leaving_reordering": "Триває вихід із перевпорядкування запитань",
    "mobile_forms_reordering_button_save": "Зберегти новий порядок запитань",
    "mobile_forms_reordering_instructions": "Щоб перевпорядкувати запитання чи розділи, перетягніть поле туди, де воно має відображатись у формі",
    "mobile_toolbarnav_title_my_setttings": "Мої налаштування",
    "mobile_toolbarnav_title_profile_settings": "Налаштування профілю",
    "mobile_toolbarnav_title_notification": "Налаштування сповіщень",
    "mobile_toolbarnav_title_form_history": "Історія форми",
    "mobile_toolbarnav_title_form_not_available": "Форма недоступна",
    "mobile_toolbarnav_title_add_location": "Додати локацію",
    "mobile_toolbarnav_title_add_task_or_project": "Додати завдання або проєкт",
    "mobile_toolbarnav_title_select_location": "Вибрати локацію",
    "mobile_toolbarnav_title_select_project": "Вибрати проєкт",
    "mobile_toolbarnav_title_select_tag": "Вибрати тег",
    "mobile_toolbarnav_title_select_user": "Вибрати користувача",
    "mobile_toolbarnav_title_select_template": "Вибрати шаблон",
    "mobile_toolbarnav_title_select_one": "Виберіть один варіант",
    "mobile_toolbarnav_title_select_multiple": "Виберіть один або більше варіантів",
    "mobile_toolbarnav_title_select_team": "Вибрати команду",
    "mobile_toolbarnav_title_select_team_or_location": "Вибрати команду або локацію",
    "mobile_toolbarnav_title_filter_tasks": "Фільтрувати завдання",
    "mobile_toolbarnav_title_filter_projects": "Фільтрувати проєкти",
    "mobile_toolbarnav_title_filter_project_tasks": "Фільтрувати завдання проєкту",
    "mobile_placeholder_search_bar": "Пошук",
    "mobile_placeholder_user_select_role": "Вибрати роль користувача",
    "mobile_placeholder_filter_by_team": "Фільтрувати за командою",
    "mobile_placeholder_assign_to_user_role": "Призначити на певну роль",
    "mobile_placeholder_select": "-- Вибрати --",
    "mobile_placeholder_account_location_name": "Назва локації",
    "mobile_placeholder_tag_filter_by": "Фільтрувати за тегом локації",
    "mobile_placeholder_user_type": "Призначити користувачу",
    "mobile_placeholder_acount_type_loading": "Завантаження… ",
    "mobile_placeholder_therm_no_bluetooth": "Температура",
    "mobile_placeholder_blue_therm_connecting": "Підключення до пристрою…",
    "mobile_placeholder_blue_therm_please_wait": "Зачекайте…",
    "mobile_placeholder_blue_therm_tap": "Торкніться, щоб прочитати.",
    "mobile_placeholder_blue_therm_not_connected": "Не підключено.",
    "mobile_placeholder_testo_tap": "Утримуйте ▼▲, а потім ⬆",
    "mobile_message_error_create_task": "Щоб додати завдання, вам потрібно бути онлайн.",
    "mobile_message_error_fill_out_form": "Заповніть форму.",
    "mobile_message_error_fill_require_fields": "Заповніть обов'язкові поля.",
    "mobile_message_error_stop_stopwatch_before_submit": "Зупиніть свій секундомір перед надсиланням",
    "mobile_message_error_stopwatch_field_required": "Поле секундоміра обов'язкове",
    "mobile_message_error_stopwatch_field_running": "Поле секундоміра запущено",
    "mobile_message_error_invalid_equipment_temperature": "Температура обладнання неправильна",
    "mobile_message_error_invalid_ingredient_temperature": "Температура інгредієнта неправильна",
    "mobile_message_error_location_attributes_unavailable": "Деякі запитання можуть бути недоступні, підключіться до Інтернету.",
    "mobile_message_alert_running_stopwatches": "У вас запущено секундоміри.\n\nВи хочете їх очистити?",
    "mobile_message_blue_therm_error": "Підключення з пристроєм Bluetooth втрачено",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Потрібен доступ до даних про локацію. Увімкніть його в налаштуваннях Android.",
    "mobile_message_blue_therm_no_permission_android": "Потрібен доступ до пристроїв поруч. Увімкніть його в налаштуваннях Android.",
    "mobile_message_blue_therm_error_code": "Не вдалося встановити підключення:",
    "mobile_message_blue_therm_error_bluetooth": "Увімкніть Bluetooth.",
    "mobile_message_blue_therm_error_device": "Пристрій не знайдено.",
    "mobile_message_blue_therm_error_try_again": "Спробуйте ще раз",
    "mobile_message_blue_therm_success": "Пристрій Bluetooth підключено!",
    "mobile_message_bluetooth_device_press_button_field": "Для підключення натисніть кнопку на своєму пристрої.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Натисніть кнопку на своєму пристрої,<br />якщо його тут немає.",
    "mobile_bluetooth_scan": "Сканувати",
    "mobile_bluetooth_scanning": "Сканування",
    "mobile_message_drafts_confirm": "Зберегти це як чернетку?",
    "mobile_message_drafts_toast_saved": "Чернетку збережено.",
    "mobile_message_drafts_request_update": "Оновити цю чернетку?",
    "mobile_message_drafts_form_confirm": "Ви дійсно хочете видалити цю чернетку?",
    "mobile_message_drafts_confirm_delete": "Видалити чернетку",
    "mobile_message_streams_error_switch": "Не можна змінити потоки в мережі",
    "mobile_message_settings_success_saved": "Настройки збережено",
    "mobile_message_settings_error": "Сталася невідома помилка. Спробуйте ще раз пізніше",
    "mobile_message_profile_settings_error_fields": "Виправте виділені поля.",
    "mobile_message_media_perimission_denied": "Ваш ",
    "mobile_message_media_perimission_denied_device": "Сховище пристрою",
    "mobile_message_image_confirm_remove_image": "Справді видалити цю фотографію?",
    "mobile_message_create_account_error_fields": "Заповніть виділені поля.",
    "mobile_message_create_account_success_location_created": "Локацію створено",
    "mobile_message_task_error_get_location": "Не вдалось отримати розташування. Упорядкування за датою.",
    "mobile_message_typehead_confirm_save_message": "Зберегти вибрані?",
    "mobile_message_typehead_confirm_save_title": "Зберегти?",
    "mobile_message_task_creator_error_save_select_form": "Вам потрібно вибрати форму.",
    "mobile_message_task_creator_error_save_required_fields": "Заповніть обов'язкові поля.",
    "mobile_message_task_creator_error_save_batch_change": "Змініть умови, щоб вони відповідали одному або кільком користувачам",
    "mobile_message_task_detials_error_not_assigned_to_you": "Це завдання не призначено вам.<br />Ви не можете його завершити.",
    "mobile_message_task_detials_error_assigned_to": "Це завдання не призначено {{user}}.<br />Ви не можете його завершити.",
    "mobile_message_task_detials_confirm_title": "Залишити завдання",
    "mobile_message_task_detials_confirm_save_task": "Зберегти завдання",
    "mobile_message_task_detials_confirm_message": "Упевнені? Ваші зміни буде втрачено.",
    "mobile_message_task_detials_error_view_account": "Не вдалось отримати доступ до даних про розташування.",
    "mobile_message_task_detials_error_submit_task": "Додайте фотографію, щоб завершити це завдання.",
    "mobile_message_task_detials_error_submit_task_project": "Не вдалося зберегти проєкт. Спробуйте ще раз пізніше.",
    "mobile_message_task_detials_wait_submit_task_created": "Завдання створюються.<br />Зачекайте кілька хвилин, поки вони загрузяться.",
    "mobile_message_task_detials_error_submit_task_pending": "Помилка, спробуйте ще раз пізніше",
    "mobile_message_task_detials_success_task_complete": "Завдання завершено",
    "mobile_message_task_error_save_single_task": "Не вдалося зберегти завдання. Спробуйте ще раз пізніше.",
    "mobile_message_task_success_save_single_task": "Завдання створено.",
    "mobile_message_show_error_message": "Сталася помилка.",
    "mobile_message_show_success_message": "Успішно",
    "mobile_message_show_offline_message": "Ви зараз офлайн.",
    "mobile_message_show_permission_denied_message": "<b>Потрібен дозвіл.</b> Надайте Zenput дозвіл для доступу до {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Потрібен дозвіл.</b> Надайте Zenput і браузеру дозвіл для доступу до: {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Передавання триває",
    "mobile_message_show_upload_in_progress_message": "Передавання вже виконується",
    "mobile_message_show_form_id_error": "Не вдалось отримати доступ до вказаної форми.",
    "mobile_message_show_single_task_error": "Не вдалось отримати доступ до вказаного завдання.",
    "mobile_message_show_submissions_error": "Не вдалось отримати доступ до вказаного надсилання.",
    "mobile_message_show_submissions_access_denied": "Ви не маєте доступу до цієї форми.",
    "mobile_message_send_data_success": "Дані завантажено ",
    "mobile_message_start_upload_success": "Передавання завершено",
    "mobile_message_start_upload_error": "<b>Не вдалося завершити передавання.</b><br>Надсилання збережено. Спробуйте ще раз пізніше",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Доступне оновлення",
    "mobile_message_store_upgrade_confirm_message_one": "Оновіть додаток Ops Execution з ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Оновіть Zenput з ",
    "mobile_message_store_upgrade_confirm_message_two": " щоб отримати всі найновіші функції та виправлення помилок",
    "mobile_message_store_upgrade_confirm_now": "Зараз",
    "mobile_message_store_upgrade_confirm_later": "Потім",
    "mobile_message_redirect_confirm_message": "Ви зараз заповнюєте форму. Зберегти її як чернетку перед тим, як продовжити?",
    "mobile_message_log_out_confirm_unsynced_drafts": "У вас є чернетки {{count}}, які ще не передано. Їх буде втрачено, якщо продовжити. Упевнені?",
    "mobile_message_draft_override_message": "Цей проєкт збережено з іншого пристрою на {{date}}, тому зміни на цьому пристрої конфліктують. Ви можете замінити наявну версію або перезавантажити до останньої версії, і ваші зміни буде скасовано.",
    "mobile_html_submitting": "Надсилання…",
    "mobile_html_offline": "Ви зараз офлайн!",
    "mobile_html_offline_try_again": "Ви зараз офлайн. <br/><br/>Спробуйте ще раз, щойно буде підключення",
    "mobile_html_something_went_wrong": "Ой. Сталася помилка.",
    "mobile_html_something_went_wrong_try_again": "Ой. Сталася помилка. Спробуйте ще раз.",
    "mobile_html_failed_loading_roles": "Не вдалося завантажити ролі.",
    "mobile_alert_please_install_for_native": "Щоб скористатися цією функцією, установіть додаток Ops Execution. ",
    "mobile_alert_please_install_for_native_old": "Встановіть власну програму Zenput, щоб використовувати цю функцію.",
    "mobile_tso_filter_all_tasks": "Усі {{type}}",
    "mobile_tso_filter_my_tasks": "Мої {{type}}",
    "mobile_tso_filter_due_date": "Дата виконання",
    "mobile_tso_filter_date_completed": "Дата завершення",
    "mobile_tso_filter_completed": "Завершено",
    "mobile_tso_filter_completed_late": "Завершено із запізненням",
    "mobile_tso_filter_incomplete": "Незавершено",
    "mobile_tso_filter_var_my_tasks": "Мої {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "Створені мною {{filter_type}} {{type}}",
    "mobile_tso_filter_var_all_tasks": "Усі {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Подальші дії",
    "mobile_tso_type_all": "Завдання й подальші дії",
    "mobile_tso_filter_var_at": " в {{location}}",
    "mobile_tso_filter_group_date_due": ", упорядковано за датою виконання",
    "mobile_tso_filter_group_distance": ", згруповано за локаціями",
    "mobile_tso_filter_start_date": "Дата початку",
    "mobile_tso_filter_none": "Немає",
    "mobile_pso_filter_all_projects": "Усі проєкти",
    "mobile_pso_filter_my_projects": "Мої проєкти",
    "mobile_pso_filter_active": "Активні",
    "mobile_pso_filter_archived": "Заархівовані",
    "mobile_pso_filter_recurring": "Повторювані",
    "mobile_pso_filter_non_recurring": "Неповторювані",
    "mobile_pso_filter_var_my_projects": "Мої проєкти {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "Створені мною проєкти {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_all_projects": "Усі проєкти {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Схоже, ви офлайн. Перейдіть в онлайн для перегляду результатів.",
    "mobile_empty_list_message_no_submissions": "Мої надсилання",
    "mobile_empty_list_message_no_activity": "Немає дій",
    "mobile_empty_list_message_no_tasks": "Немає завдань",
    "mobile_empty_list_message_no_tasks_overdue": "Немає прострочених {{type}}",
    "mobile_empty_list_message_no_accounts": "Немає локацій",
    "mobile_empty_list_message_no_projects": "Немає проєктів",
    "mobile_empty_list_message_no_results_found": "Нічого не знайдено",
    "mobile_empty_list_message_no_forms_available": "Доступні форми відсутні",
    "mobile_empty_list_message_connection_error": "Помилка підключення.<br />Спробуйте ще раз.",
    "mobile_empty_list_message_dashboard_error": "Не вдається завантажити інформаційну панель",
    "mobile_empty_list_message_user_offline": "Ви зараз офлайн",
    "mobile_action_sheet_media_gallery": "Галерея",
    "mobile_action_sheet_cancel": "Скасувати",
    "mobile_image_preview_text": "Вилучити фото",
    "mobile_mobileform_text": "Попередні надсилання",
    "mobile_mobileform_reorder_fields": "Перевпорядкувати запитання",
    "mobile_mobileform_follow_up_actions": "Подальші дії",
    "mobile_mobileform_follow_up_actions_assign_title": "Призначити подальші дії",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Додайте подальші дії на основі своїх спостережень, щоб забезпечити розв’язання проблем.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Додати подальшу дію",
    "mobile_mobileform_follow_up_actions_assign_button": "Призначити подальші дії",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Продовжити без призначення",
    "mobile_mobileform_follow_up_actions_dialog_title": "Продовжити без призначення подальших дій?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Якщо ви продовжите без призначення подальших дій, ви не зможете додати їх пізніше.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Усе одно продовжити",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Це обов’язкове поле",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Забагато символів",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Це недійсне поле",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Помилка завантаження локацій",
    "mobile_mobileform_add_follow_up_actions_error_users": "Помилка завантаження користувачів",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Додати подальшу дію",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Назва",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Опис",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Вимагати фото",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Дата виконання",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Оновити подальшу дію",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Видалити подальшу дію?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Її буде вилучено й не буде призначено.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Видалити подальшу дію",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Справді видалити цю подальшу дію?\n\nЦю дію неможливо скасувати.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Перейти до подальших дій",
    "mobile_mobileform_follow_up_actions_completed_notification": "Подальшу дію завершено",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Подальшу дію видалено",
    "mobile_mobileform_follow_up_actions_update_notification": "Подальшу дію оновлено",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Додайте фото, щоб завершити цю подальшу дію",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Перейти до надсилання",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Перейти до джерела",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Джерело",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Завершити подальшу дію",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Якщо ви відкриєте надсилання, незбережені фото й нотатки буде втрачено.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Якщо ви залишите цей екран, усі незбережені фотографії та нотатки буде втрачено.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Залишитися на цій сторінці",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Відкрити надсилання",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Відкрити джерело",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Вийти із цієї подальшої дії?",
    "mobile_mobileform_follow_up_actions_submission": "Надсилання",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Цю подальшу дію призначено користувачу {{user}}.<br />Ви не можете її завершити.",
    "mobile_mobileform_follow_up_actions_leave_description": "Якщо ви залишите цей екран, усі незбережені зміни буде втрачено.",
    "mobile_mobileform_follow_up_actions_leave": "Вийти",
    "mobile_forms_drafts_text": "Вилучити чернетку",
    "mobile_batch_estimate_user": "Користувач",
    "mobile_batch_estimate_users": "Користувачі",
    "mobile_table_of_contents": "Зміст",
    "mobile_table_of_contents_required": "Обов'язково",
    "mobile_table_of_contents_optional": "Необов'язково",
    "mobile_dialog_alert_title": "Оповіщення",
    "mobile_dialog_alert_ok": "ОК",
    "mobile_windows_10_bluetherm_not_supported": "Пристрої Bluetooth, які Windows ще не підтримує",
    "mobile_windows_deprecated_message_content_announcement": "Оголошення",
    "mobile_windows_deprecated_message_title": "Потрібно оновити додаток",
    "mobile_windows_deprecated_message_description": "Якнайшвидше встановіть новий додаток Zenput із магазину Microsoft Store, щоб забезпечити оновлення важливих функцій і підвищити зручність роботи в Zenput.",
    "mobile_dashboard_tcr_graph_name": "Відсоток виконання завдання",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Минулі 4 тижні",
    "mobile_dashboard_tcr_legend_company_average": "Середній показник компанії",
    "mobile_dashboard_tcr_legend_team_average": "Середній показник команди",
    "mobile_dashboard_tab_title_summary": "Зведення",
    "mobile_dashboard_tab_title_activity": "Дії",
    "mobile_dashboard_card_title_top_triggered_workflows": "Найпопулярніші тригери",
    "mobile_dashboard_tab_title_info": "Інформація",
    "mobile_dashboard_tab_project_audit": "Згода",
    "mobile_dashboard_card_task_stats_total": "Усього",
    "mobile_dashboard_top_item_header_week_of": "Тиждень",
    "mobile_dashboard_card_filter_form_template_placeholder": "Усі форми",
    "mobile_dashboard_card_title_forms_top_nos": "Часті \"Ні\"",
    "mobile_dashboard_zenput_code_no_data_in_range": "За цей проміжок часу дані відсутні.",
    "mobile_dashboard_zenput_code_permission_denied": "У вас відсутній дозвіл для перегляду цього.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Виберіть форму вище.",
    "mobile_dashboard_zenput_code_unknown_error": "Зараз ми не можемо відобразити дані.",
    "mobile_dashboard_tap_to_retry": "Торкніться, щоб спробувати ще раз",
    "mobile_dashboard_reporting_delay_disclaimer": "Для оновлення завдань необхідно до 15 хвилин",
    "mobile_dashboard_configuration_down_state_postfix_msg": "налаштовано вашим адміністратором.",
    "mobile_tasks_tag": "кілька завдань",
    "mobile_workflows_tag": "тригери",
    "mobile_projects_tag": "повторювані проєкти",
    "mobile_forms_tag": "форми",
    "mobile_dashboard_card_ongoing_projects_title": "Проєкти, що виконуються",
    "mobile_dashboard_card_ongoing_projects_show_more": "Більше",
    "mobile_dashboard_card_ongoing_projects_show_less": "Менше",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Перейти до проєктів",
    "mobile_dashboard_card_title_recurring_projects": "Повторювані проєкти",
    "mobile_dashboard_card_filter_daily": "Щоденно",
    "mobile_dashboard_card_filter_weekly": "Щотижнево",
    "mobile_dashboard_card_filter_monthly": "Щомісячно",
    "mobile_task_status_title_open": "Відкрити",
    "mobile_task_status_title_upcoming": "Майбутні",
    "mobile_task_status_title_complete": "Завершити",
    "mobile_task_status_title_processing": "Обробка надсилання.",
    "mobile_task_status_title_complete_with_exceptions": "Завершити з подальшими завданнями або оповіщеннями",
    "mobile_task_status_title_completed_late_with_exceptions": "Завершено із запізненням із подальшими завданнями або сповіщеннями",
    "mobile_task_status_title_incomplete_and_closed": "Пропущено",
    "mobile_tasks_legend_modal_title": "Легенда",
    "mobile_tasks_legend_modal_footer_button_title": "Закрити",
    "mobile_common_assigned_to": "Призначено",
    "mobile_common_created_by": "Створено",
    "mobile_common_tasks_for": "Завдання для",
    "mobile_common_go_back": "Назад",
    "mobile_oh_no": "О ні!",
    "mobile_user_not_in_groups": "Схоже, вас не призначено в команду. Зверніться до вашого адміністратора, щоб отримати доступ до приладної дошки.",
    "mobile_tasks_select_followers": "Вибрати підписників",
    "mobile_tasks_assign_tasks": "Призначити завдання {{count}}",
    "mobile_tasks_add_followers": "Додати підписників",
    "mobile_tasks_followers": "Підписники",
    "mobile_tasks_delete_task": "Видалити завдання",
    "mobile_tasks_create_task": "Створити завдання",
    "mobile_tasks_tab_title_comments": "Коментарі",
    "mobile_tasks_see_more": "Побачити більше",
    "mobile_projects_create_project": "Створити проєкт",
    "mobile_common_button_send": "Надіслати",
    "mobile_common_button_schedule": "Запланувати",
    "mobile_announcements_create": "Створити оголошення",
    "mobile_announcements_read_rate": "{{opened_count}} з {{recipients_count}} відкрито",
    "mobile_announcements_empty_message": "Ви не створили жодного оголошення! Створіть його нижче, щоб транслювати важливі новини, інформацію та оновлення для вашої організації.",
    "mobile_announcement_message_placeholder": "Додати повідомлення…",
    "mobile_announcement_title_placeholder": "Заголовок оголошення",
    "mobile_announcement_leaving_announcement": "Залишити оголошення",
    "mobile_announcement_confirm_recipients_team": "Транслювати це оголошення для {{count}} користувачів у вибраних командах {{teams}}?",
    "mobile_announcement_confirm_recipients_role": "Транслювати це оголошення для {{count}} користувачів із вибраними ролями користувача {{roles}}?",
    "mobile_announcement_confirm_recipients_user": "Транслювати це оголошення для {{count}} користувачів?",
    "mobile_announcement_confirm_scheduled": "У {{timestamp}}",
    "mobile_announcement_sending_announcement": "Надсилання оголошення",
    "mobile_announcement_send_to": "Надіслати до",
    "mobile_announcement_sent_to": "Надіслано до",
    "mobile_announcement_send_to_role": "Роль",
    "mobile_announcement_attachment_download": "Завантаження {{filename}}",
    "mobile_announcement_attachment_validation_error": "Можна додати не більш як стільки вкладень: {{maxCount}}",
    "mobile_announcement_details_sent": "Надіслано",
    "mobile_announcement_details_total_recipients": "Усього одержувачів",
    "mobile_announcement_details_cancel": "Скасувати оголошення",
    "mobile_announcement_details_not_editable": "Оголошення можна редагувати лише у вебдодатку Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Оголошення можна редагувати лише на веб-сайті Zenput",
    "mobile_announcement_details_open_count": "Кількість прочитаних",
    "mobile_announcement_details_open_rate": "Відсоток прочитаних",
    "mobile_announcement_details_resend": "Повторно надіслати тим, хто не прочитав",
    "mobile_announcement_confirm_resend": "{{count}} користувачі не прочитали оголошення. Надіслати нагадування?",
    "mobile_announcement_confirm_resend_title": "Надіслати нагадування?",
    "mobile_announcement_recipients_opened": "Відкрито",
    "mobile_recipients_opened_empty_message": "Схоже, ще ніхто не прочитав ваше повідомлення. Поверніться пізніше, щоб побачити результати.",
    "mobile_announcement_recipients_unopened": "Непрочитано",
    "mobile_recipients_unopened_empty_message": "Гарні новини! Непрочитаних повідомлень немає!",
    "mobile_scheduled_announcements_delivery_section_header": "Час доставки",
    "mobile_scheduled_announcements_send_immediately_label": "Надіслати негайно",
    "mobile_scheduled_announcements_scheduled_label": "Надіслати у визначений час",
    "mobile_scheduled_announcements_scheduled_tab_label": "Заплановано",
    "mobile_scheduled_announcements_dialog_header": "Скасувати оголошення?",
    "mobile_scheduled_announcements_dialog_message": "Скасування оголошення зупинить його надсилання та видалить його з вашого списку. Це неможливо скасувати. Щоб редагувати, перейдіть на веб-сайт Zenput.",
    "mobile_scheduled_announcements_empty_message": "Ви не створили жодного запланованого оголошення! Призначте його нижче, щоб транслювати важливі новини, інформацію та оновлення для вашої організації.",
    "mobile_scheduled_announcements_validation_error": "Час доставки має бути після {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Запланувати оголошення",
    "mobile_projects_auto_archive": "Автоматично архівувати",
    "mobile_common_unassigned": "Не призначено",
    "mobile_tasks_title_placeholder": "Нове завдання або форма",
    "mobile_projects_leaving_project": "Залишити проєкт",
    "mobile_projects_save_project": "Зберегти проєкт",
    "mobile_top_triggers_tasks": "Найчастіші ініційовані завдання",
    "mobile_top_triggers_alerts": "Найчастіші ініційовані оповіщення",
    "mobile_projects_not_started": "Не розпочато",
    "mobile_empty_list_message_no_photos": "Немає фотографій",
    "mobile_webfilestore_message_error": "Виберіть дозволений тип файлу",
    "mobile_notifications_empty_title": "Немає сповіщень",
    "mobile_notifications_empty_message": "Тут з'являтимуться дії щодо ваших завдань або тих, учасником яких ви є.",
    "mobile_comments_comment_deleted": "Цей коментар видалено.",
    "mobile_comments_comment_placeholder": "Коментар",
    "mobile_comments_task_submitted_at": "Завдання надіслано {{ date }} в {{ time }}",
    "mobile_comments_discard_comment_title": "Скасувати коментар?",
    "mobile_comments_discard_confirm_message": "Упевнені? Ваш коментар буде видалено.",
    "mobile_comments_delete_comment_title": "Видалити коментар?",
    "mobile_comments_delete_confirm_message": "Це неможливо скасувати.",
    "mobile_comments_delete_button": "Видалити коментар",
    "mobile_comments_delete_success_message": "Коментар видалено",
    "mobile_comments_empty_message_tasks": "Ще немає коментарів. \n Почніть розмову щодо цього завдання.",
    "mobile_comments_empty_message_submissions": "Ще немає коментарів. \n Почніть розмову щодо цього надсилання.",
    "mobile_comments_empty_message_default": "Ще немає коментарів. \n Почніть розмову.",
    "mobile_comments_no_matching_users": "Немає відповідних користувачів.",
    "mobile_comments_empty_users_to_notify": "Немає користувачів для повідомлення.",
    "mobile_comments_users_cant_view_message": "Такі користувачі не можуть переглядати ці коментарі",
    "mobile_comments_users_to_notify_title": "Користувачі для повідомлення",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} користувача</a> буде повідомлено.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} користувачів</a> буде повідомлено.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> користувачів для повідомлення.",
    "mobile_comments_mark_read": "Позначити все як прочитане",
    "mobile_comments_author_mentioned_message": "вас згадали в",
    "mobile_comments_author_commented_message": "прокоментовано",
    "mobile_view_pdf": "Переглянути PDF-файл",
    "mobile_no_pdf_generated_message": "Для цього надсилання не знайдено жодного PDF-файлу. Незабаром вам надішлють копію.",
    "mobile_clipboard_copied_success": "Посилання скопійовано в буфер обміну.",
    "mobile_share_link": "Поділитися посиланням",
    "mobile_zencam_share": "Поділитися",
    "mobile_zencam_view_details": "Переглянути відомості",
    "mobile_zencam_details_drawer_header": "Відомості",
    "mobile_zencam_submitted_by": "Надіслано",
    "mobile_zencam_form_title": "Назва форми",
    "mobile_zencam_date_submitted": "Дата надсилання",
    "mobile_oil_quality_warning_message": "Термін дії мастила добігає кінця",
    "mobile_oil_quality_warning_message_subtitle": "Почніть планувати його заміну незабаром",
    "mobile_oil_quality_failure_message": "Якість мастила порушено",
    "mobile_oil_quality_failure_message_subtitle": "Негайно змініть мастило",
    "mobile_sensors_set_up_gateway": "Налаштувати шлюз",
    "mobile_sensors_set_up_gateway_message": "Схоже, немає налаштованих пристроїв. Спочатку додайте шлюз.",
    "mobile_sensors_gateway_plugged_in": "Переконайтеся, що ваш шлюз підключено до розетки",
    "mobile_sensors_add_device": "Додати пристрій",
    "mobile_sensors_name_this_gateway": "Задайте ім'я для шлюзу",
    "mobile_sensors_name_this_sensor": "Задайте ім'я для датчика",
    "mobile_sensors_device_barcode_information": "Відскануйте QR-код або введіть ідентифікаційний номер чи номер SC з таблички пристрою",
    "mobile_sensors_device_eui_information": "Відскануйте QR-код або введіть ідентифікатор DevEUI з таблички пристрою",
    "mobile_sensors_gateway_id_information": "Введіть ідентифікатор вузла з мітки шлюзу",
    "mobile_sensors_id_number": "{{untranslatedID}} номер",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} код",
    "mobile_sensors_sensors": "Датчики",
    "mobile_sensors_sensor_deveui_error": "Не вдалося отримати DevEUI від QR. Введіть інформацію вручну.",
    "mobile_sensors_gateways": "Шлюзи",
    "mobile_sensors_add_sensor": "Додати датчик",
    "mobile_sensors_add_gateway": "Додати шлюз",
    "mobile_sensor_placement_description": "Яку ділянку буде відстежувати цей датчик?",
    "mobile_sensors_equipment_placement": "Яку ділянку чи обладнання буде відстежувати цей датчик?",
    "mobile_sensors_equipment": "Яке обладнання буде відстежувати цей датчик?",
    "mobile_sensors_select_gateway_type": "Виберіть тип шлюзу",
    "mobile_sensors_select_placement": "Вибрати розташування",
    "mobile_sensors_select_equipment": "Виберіть обладнання",
    "mobile_sensors_placement": "Розташування",
    "mobile_sensors_nickname_tip": "Назви датчиків визначаються псевдонімами, призначеними у вибраному розташуванні.",
    "mobile_sensors_device_online": "Онлайн",
    "mobile_sensors_device_offline": "Офлайн",
    "mobile_sensors_scan_qrcode": "Сканувати QR-код",
    "mobile_sensors_enter_manually": "Ввести вручну",
    "mobile_sensors_wizard_step_one": "Крок 1",
    "mobile_sensors_wizard_step_two": "Крок 2",
    "mobile_sensors_wizard_step_three": "Крок 3",
    "mobile_sensors_wizard_step_four": "Крок 4",
    "mobile_sensors_wizard_step_five": "Крок 5",
    "mobile_sensors_wizard_step_six": "Крок 6",
    "mobile_sensors_initializing": "Ініціалізація …",
    "mobile_sensors_nickname": "Псевдонім",
    "mobile_sensors_field_not_blank": "Поле {{field}} не може бути пустим.",
    "mobile_sensors_nothing_to_see_here": "Тут нічого немає.",
    "mobile_sensors_missing_integration": "Інтеграція датчика відсутня",
    "mobile_sensors_contact_zenput_admin": "Зверніться до адміністратора Ops Execution у вашій компанії.",
    "mobile_sensors_contact_zenput_admin_old": "Зверніться до свого адміністратора Zenput.",
    "mobile_sensors_contact_manager": "Зв'яжіться зі своїм менеджером із роботи з клієнтами, щоб додати датчики.",
    "mobile_sensors_device_success_message": "Для завантаження даних з датчика необхідно до 15 хвилин",
    "mobile_sensors_last_reading": "Останнє зчитування",
    "mobile_sensors_remove_device": "Видалити пристрій",
    "mobile_sensors_one_day": "1 доба",
    "mobile_sensors_one_week": "1 тиждень",
    "mobile_sensors_one_month": "1 місяць",
    "mobile_sensors_three_months": "3 місяці",
    "mobile_sensors_six_months": "6 місяців",
    "mobile_sensors_one_year": "1 рік",
    "mobile_sensors_sensor_settings": "Налаштування датчика",
    "mobile_sensors_remove_confirm_message": "Справді видалити цей пристрій?\nЦе неможливо скасувати.",
    "mobile_sensors_sensor": "Датчик",
    "mobile_sensors_no_equipment_linked": "Жодного обладнання не зв’язано",
    "mobile_sensor_cooldown_process": "Процес охолодження",
    "mobile_sensor_last_12_hours": "Останні 12 годин",
    "mobile_sensor_start_cooldown_process": "Почати новий процес охолодження",
    "mobile_sensor_cooldown_process_title": "Двоетапний процес охолодження",
    "mobile_sensor_cooldown_process_description": "Двоетапний процес охолодження складається з охолодження їжі від {{ stage1_start_temperature }} до {{ stage1_end_temperature }} (триває до двох годин), а потім від {{ stage1_end_temperature }} до {{ stage2_end_temperature }} (триває до чотирьох годин).",
    "mobile_sensor_cooldown_process_place_food": "Помістіть продукт харчування в холодильник.",
    "mobile_sensor_cooldown_process_insert_sensor": "Вставте зонд датчика в продукт харчування.",
    "mobile_sensor_cooldown_process_enter_information": "Введіть інформацію нижче.",
    "mobile_sensor_cooldown_process_food_product": "Продукт харчування для охолодження",
    "mobile_sensor_cooldown_cool_down": "Охолодження",
    "mobile_sensor_cooldown_select_sensor": "Вибрати датчик",
    "mobile_sensors_cooldown_start_cooldown": "Почати охолодження",
    "mobile_sensors_cooldown_please_enter_food": "Введіть продукт",
    "mobile_sensors_cooldown_please_select_sensor": "Виберіть датчик",
    "mobile_sensors_cooldown_status_in_progress": "Виконується",
    "mobile_sensors_cooldown_status_failed": "Не виконано",
    "mobile_sensors_cooldown_status_success": "Успішно",
    "mobile_sensors_cooldown_stage": "Етап",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Початкова температура виходить за межі діапазону",
    "mobile_sensors_cooldown_failed_cooldown_process": "Процес охолодження не виконано",
    "mobile_sensors_cooldown_cooldown_successful": "Процес охолодження виконано успішно",
    "mobile_sensors_cooldown_started_cooldown_process": "Почати процес охолодження",
    "mobile_sensors_cooldown_hour": "година",
    "mobile_sensors_cooldown_hour_plural": "години",
    "mobile_sensors_cooldown_minute": "хвилина",
    "mobile_minutes_plural": "хвилини",
    "mobile_sensors_last_reading_max_date": "> 1 року тому",
    "mobile_sensors_minute_count_ago": "{{count}} хв тому",
    "mobile_sensors_minute_count_ago_plural": "{{count}} хв тому",
    "mobile_sensors_hour_count_ago": "{{count}} год тому",
    "mobile_sensors_hour_count_ago_plural": "{{count}} год тому",
    "mobile_sensors_day_count_ago": "{{count}} доба тому",
    "mobile_sensors_day_count_ago_plural": "{{count}} доби тому",
    "mobile_sensors_chart_settings": "Налаштування діаграми",
    "mobile_announcement_banner_continue_reading": "Продовжити читання",
    "mobile_compliance_submissions_report": "Звіт про подання",
    "mobile_compliance_submissions_report_subtitle": "Експортувати дані завершення проєкту для цього магазину",
    "mobile_compliance_send_submissions": "Надіслати подання",
    "mobile_compliance_completion_rate_in_last_days": "Відсоток виконання за останні {{ days }} дн.",
    "mobile_compliance_last_days": "Останні {{ days }} дн.",
    "mobile_compliance_send_submissions_to": "Надіслати подання:",
    "mobile_compliance_send_to_different_email": "Надіслати на іншу адресу електронної пошти",
    "mobile_compliance_email_input_placeholder": "Адреса електронної пошти",
    "mobile_compliance_send_submissions_to_legend_title": "Подання",
    "mobile_compliance_send_submissions_to_legend_description_days": "Звіт із вашими поданнями із цієї локації за останні {{ days }} дн. буде надіслано на вибрану адресу електронної пошти.",
    "mobile_compliance_time_frame": "Період",
    "mobile_compliance_sensor_temperature_log_report": "Звіт про журнал температури датчика",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Експортувати журнал температур для цього магазину",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Критерії",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Визначте критерії для свого звіту нижче.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Примітка. Вимкнені датчики не відображатимуться у звіті.",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Виберіть часовий проміжок. Дані журналу мають термін дії щонайбільше 30 днів.",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Надіслати звіт",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Цього місяця (перше – сьогодні))",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Минулого місяця",
    "mobile_compliance_sensor_temperature_log_email_title": "Надіслати звіт до",
    "mobile_pwa_update_prompt_title": "Оновіть програму",
    "mobile_pwa_update_prompt_description": "Нова версія програми доступна. Оновіть до останньої версії.",
    "mobile_pwa_update_prompt_confirm": "Оновити й перезавантажити",
    "mobile_pwa_update_prompt_cancel": "Нагадати мені пізніше",
    "notification_title_due_in_one_hour": "Термін закінчується через 1 годину",
    "task_is_due_soon": "Термін для завершення '{{ task_title }}' скоро закінчиться. Виділіть хвилинку, щоб завершити завдання.",
    "mobile_photo_quality_warning_header": "Проблема з якістю фото",
    "mobile_photo_quality_dialog_message": "Це фото може виглядати занадто темним або нечітким. Бажаєте зробити нове фото або продовжити з наявним?",
    "mobile_take_new_photo": "Зробити нове фото",
    "mobile_use_this_photo": "Використати це фото"
}};
mobile_translations.ro_RO = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Toate",
    "mobile_common_button_apply_filters": "Aplicați filtre",
    "mobile_common_button_done": "Terminat",
    "mobile_common_button_edit": "Editați",
    "mobile_common_button_archive": "Arhivați",
    "mobile_common_button_save": "Salvați",
    "mobile_common_button_retake": "Reluați",
    "mobile_common_button_save_draft": "Salvați schița",
    "mobile_common_button_discard": "Renunțați",
    "mobile_common_button_submit": "Trimiteți",
    "mobile_common_button_no": "Nu",
    "mobile_common_button_yes": "Da",
    "mobile_common_button_na": "Nu este cazul",
    "mobile_common_created_by_me": "Creat de mine",
    "mobile_common_email": "E-mail companie",
    "mobile_common_first_name": "Prenume",
    "mobile_common_last_name": "Nume de familie",
    "mobile_common_location": "Locație",
    "mobile_common_locations": "Locații",
    "mobile_common_logout_message": "Sigur doriți să vă deconectați?",
    "mobile_common_password": "Parolă",
    "mobile_common_permission_required": "Permisiune necesară",
    "mobile_common_status": "Stare",
    "mobile_common_task": "Activitate",
    "mobile_common_tasks": "Activități",
    "mobile_common_tasks_my": "Activitățile mele",
    "mobile_common_projects": "Proiecte",
    "mobile_common_filter_team": "Echipă",
    "mobile_common_filter_var_in": " în {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Nicio echipă selectată",
    "mobile_common_filter_no_user_selected": "Niciun utilizator selectat",
    "mobile_common_filter_no_role_selected": "Niciun rol selectat",
    "mobile_common_placeholder_date": "Dată",
    "mobile_common_message_task_creator_error_save": "<b>Nu s-au putut crea activități.</b>",
    "mobile_common_camera": "Cameră foto",
    "mobile_common_microphone": "Microfon",
    "mobile_common_for": "pentru",
    "mobile_common_reload": "Reîncărcați",
    "mobile_common_override": "Înlocuiți",
    "mobile_common_notifications": "Notificări",
    "mobile_common_chat_unavailable": "Chat indisponibil. Încercați din nou mai târziu.",
    "mobile_common_chat_ending_dialog_title": "Ați terminat cu această conversație?",
    "mobile_common_chat_ending_dialog_description": "Spuneți-ne dacă problema dvs. a fost rezolvată sau dacă vreți doar să continuați mai târziu.",
    "mobile_common_chat_ending_dialog_confirm": "Da, am terminat",
    "mobile_common_chat_ending_dialog_cancel": "Voi continua mai târziu",
    "mobile_common_continue_editing": "Continuați editarea",
    "mobile_privacy_policy": "Politică de confidențialitate",
    "wootric_recommend_target": "un prieten sau coleg din industria dvs.",
    "wootric_followup_detractor_question": "Ce modificări putem face ca să ne oferiți un rating mai mare data viitoare?",
    "wootric_followup_passive_question": "Vă mulțumim! Ce am putea face pentru a îmbunătăți și mai mult instrumentul?",
    "wootric_followup_promoter_question": "Mulțumim! Ce îți place cel mai mult la Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Vă mulțumim! Ce vă place la Zenput?",
    "wootric_default_followup_question": "Vă mulțumim! Ne puteți spune de ce?",
    "wootric_default_placeholder_text": "Ajutați-ne explicându-ne punctajul dvs.",
    "wootric_default_thankyou_text": "Vă mulțumim pentru răspuns și pentru feedback!",
    "mobile_login_placeholder_login_as": "Conectați-vă ca ID de utilizator",
    "mobile_login_button_forgot_password": "Ați uitat parola?",
    "mobile_login_button_sign_up": "Creați un cont",
    "mobile_login_button_finish_setup": "Finalizați configurarea",
    "mobile_login_button": "Conectați-vă",
    "mobile_login_continue_button": "Continuați",
    "mobile_login_continue_transition": "vă direcționăm către pagina de conectare a organizației dvs...",
    "mobile_login_no_email_error": "Trebuie să introduceți o adresă de e-mail.",
    "mobile_login_change_email": "Conectați-vă cu o altă adresă de e-mail",
    "mobile_login_with_sso": "Conectare cu SSO",
    "mobile_oauth_no_user_error_message": "Se pare că nu ai un cont Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Se pare că nu aveți un cont Zenput!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> este acum <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} devine {{- product }} în septembrie. {{- cta }}",
    "mobile_rebrand_warning_cta": "Află cum să te pregătești.",
    "mobile_oauth_no_user_error_sub_message": "Contactați-vă administratorul pentru acces sau încercați să vă conectați cu o altă adresă de e-mail.",
    "mobile_oauth_generic_error_message": "Se pare că a apărut o problemă la conectare, încercați din nou.",
    "mobile_oauth_force_logout_msg": "Dacă întâmpinați probleme în continuare, deconectați-vă de la furnizorul dvs. ",
    "mobile_oauth_force_logout_click": "apăsând aici.",
    "mobile_sign_up_placeholder_phone": "Număr de telefon mobil",
    "mobile_sign_up_placeholder_password_confirm": "Confirmați parola",
    "mobile_sign_up_button_sign_in": "Înregistrați-vă",
    "mobile_sign_up_disclaimer_part_1": "Apăsând pe Creați un cont, sunteți de acord cu",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Apăsând pe Finalizați configurarea, sunteți de acord cu",
    "mobile_sign_up_disclaimer_link_title": " Contractul de licență",
    "mobile_sign_up_disclaimer_part_2": ", care conține informații importante privind confidențialitatea",
    "mobile_dialog_benefits_work_offline": "Lucrați offline",
    "mobile_dialog_benefits_faster_uploads": "Încărcări mai rapide",
    "mobile_dialog_benefits_better_experience": "Experiență îmbunătățită",
    "mobile_dialog_benefits_button_download": "Descărcați",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution pentru ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput pentru ",
    "mobile_dialog_benefits_button_have": "Am aplicația!",
    "mobile_dialog_benefits_button_no_thanks": "Nu, mulțumesc, poate mai târziu.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Imaginea nu s-a putut încărca.",
    "mobile_dialog_signature_sign": "Semnați aici",
    "mobile_dialog_signature_button_clear": "Goliți",
    "mobile_account_placeholder_name": "Locație/Numele magazinului",
    "mobile_account_placeholder_phone": "Telefon",
    "mobile_account_placeholder_address": "Adresă",
    "mobile_account_placeholder_city": "Oraș",
    "mobile_account_placeholder_region": "Regiune",
    "mobile_account_placeholder_zipcode": "Cod poștal",
    "mobile_account_option_select_country": "Selectați țara",
    "mobile_account_oprion_us": "Statele Unite",
    "mobile_account_oprion_select_state": "Selectați statul/județul",
    "mobile_account_button_create_location": "Creați o locație",
    "mobile_form_message_no_form": "Niciun formular disponibil",
    "mobile_batch_task_message": "Se încarcă...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Telefon mobil",
    "mobile_settings_profile_language": "Limbă",
    "mobile_settings_profile_temperature_unit": "Unitate de temperatură",
    "mobile_settings_profile_use_company_default": "Folosiți opțiunea implicită a companiei",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Mesaj text",
    "mobile_settings_notifications_option_push": "Notificări push",
    "mobile_settings_notifications_option_push_email": "Notificări push și prin e-mail",
    "mobile_settings_notifications_option_do_not": "Fără notificări",
    "mobile_settings_notifications_category_communication": "Comunicare",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulare și declanșatoare",
    "mobile_settings_devices": "Dispozitive",
    "mobile_settings_notifications_sub_category_alerts": "Alerte",
    "mobile_settings_notifications_sub_category_new_forms_available": "Formulare noi disponibile",
    "mobile_settings_notifications_sub_category_task_assigned": "Sarcină atribuită",
    "mobile_settings_notifications_sub_category_task_completed": "Sarcină finalizată",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Memento sarcini scadente curând",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Memento sarcini cu termen depășit",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Alerte senzor",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alerte senzor critice",
    "mobile_drafts_message": "Nu aveți nicio schiță încă.",
    "mobile_drafts_button_delete": "Ștergeți",
    "mobile_tasks_filter_location_no": "Nicio locație selectată",
    "mobile_tasks_filter_group_by": "Grupați după",
    "mobile_tasks_filter_sort_by": "Sortați după",
    "mobile_tasks_filter_sorted_by": "Sortat după",
    "mobile_tasks_filter_due_time": "Ora scadenței",
    "mobile_tasks_filter_open_time": "Ora deschiderii",
    "mobile_tasks_bucket_due_next_24_hours": "Expiră în următoarele 24 de ore",
    "mobile_tasks_bucket_due_next_7_days": "Expiră în următoarele 7 zile",
    "mobile_tasks_bucket_open_tasks": "Suplimentar deschis {{type}}",
    "mobile_tasks_bucket_open_at": "Deschis: {{- date }} la {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Expiră la: {{- date }} la {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponibil în 1 minut",
    "mobile_tasks_bucket_available_in_one_hour": "Disponibil în 1 oră",
    "mobile_tasks_bucket_available_in_one_day": "Disponibil în 1 zi",
    "mobile_tasks_bucket_available_in_one_week": "Disponibil în 1 săptămână",
    "mobile_tasks_bucket_available_in_one_month": "Disponibil în 1 lună",
    "mobile_tasks_bucket_available_in_one_year": "Disponibil în 1 an",
    "mobile_tasks_bucket_available_in_minutes": "Disponibil în {{ minutes }} minute",
    "mobile_tasks_bucket_available_in_hours": "Disponibil în {{ hours }} ore",
    "mobile_tasks_bucket_available_in_days": "Disponibil în {{ days }} zile",
    "mobile_tasks_bucket_available_in_weeks": "Disponibil în {{ weeks }} săptămâni",
    "notification_task_due_in_minutes": "Livrare în {{ minutes }} minute",
    "mobile_tasks_bucket_available_in_months": "Disponibil în {{ months }} luni",
    "mobile_tasks_bucket_available_in_years": "Disponibil în {{ years }} ani",
    "mobile_tasks_follow_up": "Sarcină de monitorizare ulterioară",
    "mobile_tasks_due_soon": "Scadent în curând",
    "mobile_tasks_bucket_completed_today": "Finalizate astăzi",
    "mobile_tasks_bucket_completed_this_week": "Finalizate săptămâna aceasta",
    "mobile_tasks_bucket_completed_last_week": "Finalizate săptămâna trecută",
    "mobile_tasks_bucket_missed_today": "Pierdute astăzi",
    "mobile_tasks_bucket_missed_this_week": "Pierdute săptămâna aceasta",
    "mobile_tasks_bucket_missed_last_week": "Pierdute săptămâna trecută",
    "mobile_tasks_bucket_no_location": "Nicio locație",
    "mobile_tasks_cannot_submit_missed": "Activitățile pierdute nu pot fi finalizate",
    "mobile_tasks_cannot_submit_missed_after": "Această activitate nu poate fi finalizată după {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Această activitate nu a început.",
    "mobile_tasks_cannot_submit_processing": "Această trimitere este în curs de procesare",
    "mobile_tasks_toolbarnav_header_no_due_date": "Nicio dată limită",
    "mobile_tasks_toolbarnav_header_overdue": "Termen depășit",
    "mobile_tasks_toolbarnav_header_yesterday": "Ieri",
    "mobile_tasks_toolbarnav_header_today": "Astăzi",
    "mobile_tasks_toolbarnav_header_tomorrow": "Mâine",
    "mobile_tasks_toolbarnav_header_last_week": "Săptămâna trecută",
    "mobile_tasks_toolbarnav_header_this_week": "Săptămâna aceasta",
    "mobile_tasks_toolbarnav_header_next_week": "Săptămâna viitoare",
    "mobile_tasks_toolbarnav_header_this_month": "Luna aceasta",
    "mobile_tasks_toolbarnav_header_next_year": "Anul viitor",
    "mobile_tasks_toolbarnav_header_over_year": "Peste un an",
    "mobile_tasks_toolbarnav_title_edit_task": "Editați activitatea",
    "mobile_task_placeholder_title": "Titlu *",
    "mobile_task_placeholder_description": "Descriere (opțional)",
    "mobile_task_button_single_task": "Activitate unică",
    "mobile_task_button_project": "Proiect",
    "mobile_task_button_create": "Creați",
    "mobile_task_tab_basic": "De bază",
    "mobile_task_tab_photo": "Fotografie",
    "mobile_task_tab_form": "Formular",
    "mobile_task_details_description_message_please": "Completați ",
    "mobile_task_details_description_message_below": "mai jos.",
    "mobile_task_details_description_message_instructions": "Nu sunt disponibile instrucțiuni pentru această activitate.",
    "mobile_task_details_reason_title": "Urmărire declanșată de",
    "mobile_task_detials_button_goto_form": "Salt la formular",
    "mobile_task_detials_button_complete": " Finalizați activitatea",
    "mobile_task_detials_completed": "Finalizat ",
    "mobile_task_detials_completed_by": "de ",
    "mobile_task_detials_completed_on": "la ",
    "mobile_task_details_view_form_submission": "Vedeți trimiterea formularului",
    "mobile_task_task_updated": "Activitate actualizată",
    "mobile_task_task_archived": "Activitate arhivată",
    "mobile_task_task_deleted": "Activitate ștearsă",
    "mobile_task_error_archiving_task": "Nu s-a putut arhiva activitatea.",
    "mobile_task_error_deleting_task": "Nu s-a putut șterge activitatea.",
    "mobile_task_error_updating_task": "Nu s-a putut actualiza activitatea.",
    "mobile_task_archive_task": "Arhivați Activitatea",
    "mobile_task_archive_task_confirm": "Sigur doriți să arhivați această Activitate?\n\nActivitățile arhivate vor fi luate în considerare la ratele de finalizare și vor fi incluse în continuare în raportare.\n\nAceastă acțiune nu poate fi anulată.",
    "mobile_task_delete_task_confirm": "Sigur doriți să ștergeți această activitate?\n\nActivitățile șterse nu vor fi luate în considerare la ratele de finalizare și nu vor fi incluse în raportare.\n\nAceastă acțiune nu poate fi anulată.",
    "mobile_task_edition_already_in_progress": "Această activitate conține o editare în așteptare. Editarea ulterioară nu este permisă în prezent.",
    "mobile_projects_filter_type": "Tip",
    "mobile_projects_filter_status": "Starea proiectului",
    "mobile_projects_filter_project_type": "Tipul proiectului",
    "mobile_projects_due_date_required": "Data limită este obligatorie.",
    "mobile_projects_team_required": "Echipa este obligatorie.",
    "mobile_projects_user_role_required": "Responsabilul este obligatoriu.",
    "mobile_projects_title_required": "Titlul este obligatoriu.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Sarcini multiple pe zi",
    "mobile_project_tasks_complete": " Finalizați",
    "mobile_project_tasks_remaining": " Rămase",
    "mobile_esitmate_message_tasks": "Vor fi create 0 activități",
    "mobile_esitmate_message_criteria": "Ajustați criteriile de mai sus",
    "mobile_esitmate_message_created_for": "vor fi create pentru",
    "mobile_left_menu_dashboard": "Tablou de bord",
    "mobile_left_menu_my_forms": "Formularele mele",
    "mobile_left_menu_announcements": "Anunțuri",
    "mobile_left_menu_my_submissions": "Trimiterile mele",
    "mobile_left_menu_drafts": "Schițe",
    "mobile_left_menu_pending_uploads": "Încărcări în așteptare",
    "mobile_left_menu_open": "Deschideți în aplicație",
    "mobile_left_menu_settings": "Setări",
    "mobile_left_menu_log_out": "Deconectați-vă",
    "mobile_left_menu_debug": "Depanare",
    "mobile_left_menu_support": "Asistență",
    "mobile_left_menu_documentation": "Documentație",
    "mobile_left_menu_chat": "Chat",
    "mobile_field_textarea_placeholder_note": "Notă sau subtitrare",
    "mobile_field_option_select": "Selectați",
    "mobile_field_text_placeholder_text": "Text",
    "mobile_field_email_placehoder_email": "Adresa de e-mail",
    "mobile_filed_number_placeholder_number": "Număr",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Neconectat",
    "mobile_field_sensor_offline_battery": "Senzor offline - Baterie",
    "mobile_field_video_button_add": "Adăugați un clip video",
    "mobile_field_video_picker_dialog_title": "Adăugare video de la",
    "mobile_field_video_button_change": "Schimbați clipul video",
    "mobile_field_image_button_add": "Adăugați imagine",
    "mobile_field_image_low_quality_warning": "Unele fotografii pot fi prea întunecate sau neclare. Verificați fotografiile evidențiate și înlocuiți-le dacă este necesar",
    "mobile_field_image_picker_dialog_title": "Adăugare fotografie de la",
    "mobile_field_image_picker_edit_failed": "Nu am putut salva imaginea. Încercați din nou.",
    "mobile_field_signature_button_add": "Adăugați o semnătură",
    "mobile_field_signature_button_change": "Schimbați semnătura",
    "mobile_field_account_select_location": "Selectați o locație",
    "mobile_field_account_prefill": "Completați automat formularul cu datele ultimei Vizite?",
    "mobile_field_account_message_overwrite": "Această acțiune va suprascrie orice câmpuri deja completate.",
    "mobile_forms_task_on_behalf": "Există o activitate de îndeplinit în această locație care este atribuită către <b>{{user}}</b>. Doriți să finalizați această activitate?",
    "mobile_forms_complete_task": "Finalizați activitatea?",
    "mobile_field_account_prefill_button_yes": "Da, completează automat",
    "mobile_field_barcode_placeholder_scan": "Scanați sau introduceți codul de bare",
    "mobile_field_sensor_qr_code_placeholder_scan": "Scanați sau introduceți codul",
    "mobile_field_gateway_id_code_placeholder": "ID nod tip",
    "mobile_field_scan_qr_or_enter_dev_eui": "Scanați codul QR sau introduceți DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Scanați codul QR sau introduceți numărul ID",
    "mobile_field_scan_qr_or_enter_sc": "Scanați codul QR sau introduceți codul SC",
    "mobile_field_barcode_select_date": "Selectați data ",
    "mobile_field_datetime_allow_time": "Ora",
    "mobile_field_stopwatch_button_caption": "Cronometru",
    "mobile_field_stopwatch_common_start": "Porniți",
    "mobile_field_stopwatch_common_stop": "Opriți",
    "mobile_field_stopwatch_common_reset": "Resetați",
    "mobile_field_stopwatch_stop_stopwatches": "Resetați cronometrele",
    "mobile_field_document_title": "Adăugați un document",
    "mobile_field_document_message_delete": "Sigur doriți să ștergeți acest document?",
    "mobile_field_document_alret_button_view": "Vizualizare",
    "mobile_field_document_alert_error": "A apărut o eroare la atașarea acestui document. Încercați din nou.",
    "mobile_field_document_alert_file_size_error": "Fișierul nu trebuie să depășească {{count}} MB.",
    "mobile_field_temperature_greater_range": "mai mare decât {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "mai mare decât sau egal cu {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "mai mic decât {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "mai mic decât sau egal cu {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "mai mare decât sau egal cu {{ min_temp_value }} °{{ temp_unit }} și mai mic decât {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "mai mare decât sau egal cu {{ min_temp_value }} °{{ temp_unit }} și mai mic decât sau egal cu {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " și ",
    "mobile_field_text_limit_error": "S-a atins limita maximă de caractere de 8000.",
    "mobile_forms_required_questions_complete": "Necesare finalizate",
    "mobile_forms_required_remaining": "{{count}} necesare rămase",
    "mobile_forms_required_questions_back": "Înapoi",
    "mobile_forms_required_questions_next": "Înainte",
    "mobile_forms_required_questions_skip": "Omiteți",
    "mobile_forms_leaving_form": "Se iese din formular",
    "mobile_message_reordering_confirm": "Doriți să salvați noua ordine a întrebărilor?",
    "mobile_forms_leaving_reordering": "Se iese din reordonarea întrebărilor",
    "mobile_forms_reordering_button_save": "Salvați noua ordine a întrebărilor",
    "mobile_forms_reordering_instructions": "Pentru a reordona întrebările sau secțiunile, glisați și plasați în locul în care ar trebui să apară câmpul în formular",
    "mobile_toolbarnav_title_my_setttings": "Setările mele",
    "mobile_toolbarnav_title_profile_settings": "Setări de profil",
    "mobile_toolbarnav_title_notification": "Setări pentru notificări",
    "mobile_toolbarnav_title_form_history": "Istoric formulare",
    "mobile_toolbarnav_title_form_not_available": "Formularul nu este disponibil",
    "mobile_toolbarnav_title_add_location": "Adăugați locație",
    "mobile_toolbarnav_title_add_task_or_project": "Adăugați activitate sau proiect",
    "mobile_toolbarnav_title_select_location": "Selectați locația",
    "mobile_toolbarnav_title_select_project": "Selectați proiectul",
    "mobile_toolbarnav_title_select_tag": "Selectați eticheta",
    "mobile_toolbarnav_title_select_user": "Selectați utilizatorul",
    "mobile_toolbarnav_title_select_template": "Selectați șablonul",
    "mobile_toolbarnav_title_select_one": "Selectați unul",
    "mobile_toolbarnav_title_select_multiple": "Selectați unul sau mai multe",
    "mobile_toolbarnav_title_select_team": "Selectați echipa",
    "mobile_toolbarnav_title_select_team_or_location": "Selectați echipa sau locația",
    "mobile_toolbarnav_title_filter_tasks": "Filtrați activitățile",
    "mobile_toolbarnav_title_filter_projects": "Filtrați proiectele",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrați activitățile proiectului",
    "mobile_placeholder_search_bar": "Căutați",
    "mobile_placeholder_user_select_role": "Selectați rolul de utilizator",
    "mobile_placeholder_filter_by_team": "Filtrați după echipă",
    "mobile_placeholder_assign_to_user_role": "Atribuiți către rolul de utilizator",
    "mobile_placeholder_select": "-- Selectați --",
    "mobile_placeholder_account_location_name": "Numele locației",
    "mobile_placeholder_tag_filter_by": "Filtrați după eticheta locației",
    "mobile_placeholder_user_type": "Atribuiți către utilizator",
    "mobile_placeholder_acount_type_loading": "Se încarcă... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatură",
    "mobile_placeholder_blue_therm_connecting": "Se conectează la dispozitiv...",
    "mobile_placeholder_blue_therm_please_wait": "Așteptați...",
    "mobile_placeholder_blue_therm_tap": "Atingeți pentru citire.",
    "mobile_placeholder_blue_therm_not_connected": "Neconectat.",
    "mobile_placeholder_testo_tap": "Țineți apăsat ▼▲ urmat de ⬆",
    "mobile_message_error_create_task": "Trebuie să fiți online pentru a adăuga activități.",
    "mobile_message_error_fill_out_form": "Completați formularul.",
    "mobile_message_error_fill_require_fields": "Completați câmpurile obligatorii.",
    "mobile_message_error_stop_stopwatch_before_submit": "Opriți-vă cronometrul înainte să trimiteți",
    "mobile_message_error_stopwatch_field_required": "Câmpul cronometru este obligatoriu",
    "mobile_message_error_stopwatch_field_running": "Câmpul cronometru este în execuție",
    "mobile_message_error_invalid_equipment_temperature": "Temperatură echipament nevalidă",
    "mobile_message_error_invalid_ingredient_temperature": "Temperatură ingredient nevalidă",
    "mobile_message_error_location_attributes_unavailable": "Unele întrebări pot fi indisponibile, vă rugăm să vă conectați la internet",
    "mobile_message_alert_running_stopwatches": "Aveți cronometre în execuție.\n\nDoriți să le ștergeți?",
    "mobile_message_blue_therm_error": "S-a pierdut conexiunea la dispozitivul Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Ai nevoie de acces la locație. Activează această opțiune din setările dispozitivului tău Android.",
    "mobile_message_blue_therm_no_permission_android": "Ai nevoie de acces la dispozitivele din apropiere. Activează această opțiune din setările dispozitivului tău Android.",
    "mobile_message_blue_therm_error_code": "Conexiunea nu a reușit:",
    "mobile_message_blue_therm_error_bluetooth": "Activați funcția Bluetooth.",
    "mobile_message_blue_therm_error_device": "Dispozitivul nu a fost găsit.",
    "mobile_message_blue_therm_error_try_again": "Încercați din nou",
    "mobile_message_blue_therm_success": "Dispozitiv Bluetooth conectat!",
    "mobile_message_bluetooth_device_press_button_field": "Apăsați pe butonul dispozitivului dvs. pentru a vă conecta.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Apăsați pe butonul dispozitivului dvs.<br />dacă nu îl vedeți în lista de aici.",
    "mobile_bluetooth_scan": "Scanați",
    "mobile_bluetooth_scanning": "Se scanează",
    "mobile_message_drafts_confirm": "Doriți să salvați acest document ca schiță?",
    "mobile_message_drafts_toast_saved": "Schiță salvată.",
    "mobile_message_drafts_request_update": "Doriți să actualizați această schiță?",
    "mobile_message_drafts_form_confirm": "Sigur doriți să ștergeți această schiță?",
    "mobile_message_drafts_confirm_delete": "Ștergeți schița",
    "mobile_message_streams_error_switch": "Nu se pot modifica fluxuri de pe web",
    "mobile_message_settings_success_saved": "Setări salvate",
    "mobile_message_settings_error": "A apărut o eroare necunoscută. Încercați din nou mai târziu",
    "mobile_message_profile_settings_error_fields": "Corectați câmpurile evidențiate.",
    "mobile_message_media_perimission_denied": "Al dvs. ",
    "mobile_message_media_perimission_denied_device": "Dispozitivul de stocare",
    "mobile_message_image_confirm_remove_image": "Sigur doriți să ștergeți această fotografie?",
    "mobile_message_create_account_error_fields": "Completați câmpurile evidențiate.",
    "mobile_message_create_account_success_location_created": "Locație creată",
    "mobile_message_task_error_get_location": "Nu s-a putut obține locația. Ordonare după dată.",
    "mobile_message_typehead_confirm_save_message": "Doriți să salvați aceste selecții?",
    "mobile_message_typehead_confirm_save_title": "Salvați?",
    "mobile_message_task_creator_error_save_select_form": "Trebuie să selectați un formular.",
    "mobile_message_task_creator_error_save_required_fields": "Completați toate câmpurile obligatorii.",
    "mobile_message_task_creator_error_save_batch_change": "Schimbați criteriile pentru a se potrivi cu unul sau mai mulți utilizatori",
    "mobile_message_task_detials_error_not_assigned_to_you": "Această activitate nu vă este atribuită.<br />Nu o puteți finaliza.",
    "mobile_message_task_detials_error_assigned_to": "Această activitate este atribuită către {{user}}.<br />Nu o puteți finaliza.",
    "mobile_message_task_detials_confirm_title": "Se iese din activitate",
    "mobile_message_task_detials_confirm_save_task": "Salvați activitatea",
    "mobile_message_task_detials_confirm_message": "Sunteți sigur(ă)? Modificările dvs. se vor pierde.",
    "mobile_message_task_detials_error_view_account": "Nu se poate accesa locația.",
    "mobile_message_task_detials_error_submit_task": "Adăugați o fotografie pentru a finaliza această activitate.",
    "mobile_message_task_detials_error_submit_task_project": "Nu se poate salva proiectul. Încercați din nou mai târziu.",
    "mobile_message_task_detials_wait_submit_task_created": "Activități în curs de creare.<br />Așteptați câteva minute pentru ca activitățile să fie completate.",
    "mobile_message_task_detials_error_submit_task_pending": "Eroare, încercați din nou mai târziu",
    "mobile_message_task_detials_success_task_complete": "Activitate finalizată",
    "mobile_message_task_error_save_single_task": "Nu se poate salva activitatea. Încercați din nou mai târziu.",
    "mobile_message_task_success_save_single_task": "Activitate creată.",
    "mobile_message_show_error_message": "Ceva nu a funcționat corect.",
    "mobile_message_show_success_message": "Acțiune finalizată cu succes!",
    "mobile_message_show_offline_message": "Momentan sunteți offline.",
    "mobile_message_show_permission_denied_message": "<b>Permisiune necesară.</b> Acordați aplicației Zenput permisiunea de a accesa {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Permisiune necesară.</b> Acordați aplicației Zenput și browserului dvs. permisiunea de a accesa {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Se încarcă acum",
    "mobile_message_show_upload_in_progress_message": "Încărcare deja în desfășurare",
    "mobile_message_show_form_id_error": "Nu se poate accesa formularul specificat.",
    "mobile_message_show_single_task_error": "Nu se poate accesa activitatea specificată.",
    "mobile_message_show_submissions_error": "Nu se poate accesa trimiterea specificată.",
    "mobile_message_show_submissions_access_denied": "Ne pare rău, nu aveți acces la acest formular.",
    "mobile_message_send_data_success": "Date încărcate ",
    "mobile_message_start_upload_success": "Încărcare finalizată",
    "mobile_message_start_upload_error": "<b>Nu s-a putut finaliza încărcarea.</b><br>Trimitere salvată. Încercați din nou mai târziu",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Actualizare disponibilă",
    "mobile_message_store_upgrade_confirm_message_one": "Te rugăm să actualizezi Ops Execution app din ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Actualizați aplicația Zenput din ",
    "mobile_message_store_upgrade_confirm_message_two": " pentru a avea cele mai noi caracteristici și remedieri de erori",
    "mobile_message_store_upgrade_confirm_now": "Acum",
    "mobile_message_store_upgrade_confirm_later": "Mai târziu",
    "mobile_message_redirect_confirm_message": "În prezent completați un formular. Doriți să îl salvați ca schiță înainte de a continua?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Aveți {{count}} schițe care nu au fost încărcate încă. Dacă continuați, acestea vor fi pierdute. Sunteți sigur(ă)?",
    "mobile_message_draft_override_message": "Această schiță a fost salvată de pe un alt dispozitiv la {{date}} și modificările de pe acest dispozitiv sunt în conflict. Puteți alege să înlocuiți versiunea existentă sau să reîncărcați cea mai recentă versiune, iar modificările dvs. vor fi anulate.",
    "mobile_html_submitting": "Se trimite...",
    "mobile_html_offline": "Momentan sunteți offline!",
    "mobile_html_offline_try_again": "Momentan sunteți offline. <br/><br/>Încercați din nou după ce vă conectați",
    "mobile_html_something_went_wrong": "Ups! Ceva nu a funcționat corect.",
    "mobile_html_something_went_wrong_try_again": "Ups! Ceva nu a funcționat corect. Încercați din nou.",
    "mobile_html_failed_loading_roles": "Nu s-au putut încărca rolurile.",
    "mobile_alert_please_install_for_native": "Te rugăm să instalezi Ops Execution app pentru a putea utiliza această funcție. ",
    "mobile_alert_please_install_for_native_old": "Instalați aplicația Zenput nativă pentru a utiliza această caracteristică.",
    "mobile_tso_filter_all_tasks": "Toate {{type}}",
    "mobile_tso_filter_my_tasks": "{{type}} mele",
    "mobile_tso_filter_due_date": "Dată scadentă",
    "mobile_tso_filter_date_completed": "Dată finalizată",
    "mobile_tso_filter_completed": "Finalizat",
    "mobile_tso_filter_completed_late": "Finalizat cu întârziere",
    "mobile_tso_filter_incomplete": "Incomplet",
    "mobile_tso_filter_var_my_tasks": "{{filter_type}} {{type}} mele",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} create de mine",
    "mobile_tso_filter_var_all_tasks": "Toate {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Acțiuni de monitorizare ulterioară",
    "mobile_tso_type_all": "Activități și acțiuni de monitorizare ulterioară",
    "mobile_tso_filter_var_at": " la {{location}}",
    "mobile_tso_filter_group_date_due": ", ordonate după Data scadentă",
    "mobile_tso_filter_group_distance": ", grupate după Locație",
    "mobile_tso_filter_start_date": "Data de început",
    "mobile_tso_filter_none": "Niciuna",
    "mobile_pso_filter_all_projects": "Toate proiectele",
    "mobile_pso_filter_my_projects": "Proiectele mele",
    "mobile_pso_filter_active": "Active",
    "mobile_pso_filter_archived": "Arhivate",
    "mobile_pso_filter_recurring": "Recurente",
    "mobile_pso_filter_non_recurring": "Nerecurente",
    "mobile_pso_filter_var_my_projects": "Proiectele mele {{project_type}} {{active_description}}",
    "mobile_pso_filter_var_my_created_projects": "Proiecte {{project_type}} {{active_description}} create de mine",
    "mobile_pso_filter_var_all_projects": "Toate proiectele {{project_type}} {{active_description}}",
    "mobile_empty_list_message_must_be_online": "Se pare că sunteți offline. Treceți online pentru a vedea rezultatele.",
    "mobile_empty_list_message_no_submissions": "Nicio trimitere",
    "mobile_empty_list_message_no_activity": "Nicio operațiune",
    "mobile_empty_list_message_no_tasks": "Nicio activitate",
    "mobile_empty_list_message_no_tasks_overdue": "Nicio {{type}} cu termen depășit",
    "mobile_empty_list_message_no_accounts": "Nicio locație",
    "mobile_empty_list_message_no_projects": "Niciun proiect",
    "mobile_empty_list_message_no_results_found": "Niciun rezultat găsit",
    "mobile_empty_list_message_no_forms_available": "Niciun formular disponibil",
    "mobile_empty_list_message_connection_error": "Eroare de conexiune<br />Încercați din nou.",
    "mobile_empty_list_message_dashboard_error": "Nu se poate încărca Tabloul de bord",
    "mobile_empty_list_message_user_offline": "Momentan sunteți offline",
    "mobile_action_sheet_media_gallery": "Galerie",
    "mobile_action_sheet_cancel": "Anulați",
    "mobile_image_preview_text": "Eliminați fotografia",
    "mobile_mobileform_text": "Trimiteri anterioare",
    "mobile_mobileform_reorder_fields": "Reordonați întrebările",
    "mobile_mobileform_follow_up_actions": "Acțiuni ulterioare",
    "mobile_mobileform_follow_up_actions_assign_title": "Atribuiți acțiuni de monitorizare ulterioară",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Adăugați acțiuni de monitorizare ulterioară pe baza observațiilor dumneavoastră pentru a vă asigura că problemele sunt rezolvate.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Adăugați acțiune de monitorizare ulterioară",
    "mobile_mobileform_follow_up_actions_assign_button": "Atribuiți monitorizare ulterioară",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continuați fără atribuire",
    "mobile_mobileform_follow_up_actions_dialog_title": "Doriți să continuați fără a atribui acțiuni de monitorizare ulterioară?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Dacă veți continua fără a atribui nicio acțiune de monitorizare, nu veți mai putea să le adăugați ulterior.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continuați oricum",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Câmpul acesta este obligatoriu",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Prea multe caractere",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Câmpul nu este valabil",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Eroare la încărcarea locațiilor",
    "mobile_mobileform_add_follow_up_actions_error_users": "Eroare la încărcarea utilizatorilor",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Adăugați monitorizare ulterioară",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Titlu",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Descriere",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Este necesară o fotografie",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Termen limită",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Actualizați monitorizare ulterioară",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Ștergeți monitorizarea ulterioară?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Va fi eliminată și nu va fi atribuită.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Ștergeți monitorizarea ulterioară",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Sigur doriți să ștergeți această monitorizare ulterioară?\n\nAceastă acțiune nu poate fi anulată.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continuați cu monitorizările ulterioare",
    "mobile_mobileform_follow_up_actions_completed_notification": "Acțiunea de monitorizare ulterioară a fost finalizată",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Acțiunea de monitorizare ulterioară a fost ștearsă",
    "mobile_mobileform_follow_up_actions_update_notification": "Acțiunea de monitorizare ulterioară a fost actualizată",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Adăugați o fotografie pentru a finaliza această acțiune de monitorizare ulterioară",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Accesați pagina de trimitere",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Mergi la sursă",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Sursă",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Finalizați monitorizarea ulterioară",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Dacă deschideți formularul de trimitere, toate fotografiile și notele nesalvate se vor pierde.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Dacă părăsești acest ecran, vei pierde toate fotografiile și notițele nesalvate.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Rămâneți aici",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Deschideți trimitere",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Deschide sursa",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Păstrați această acțiune de monitorizare ulterioară?",
    "mobile_mobileform_follow_up_actions_submission": "Trimitere",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Această acțiune de monitorizare ulterioară este atribuită către {{user}}.<br />Nu o puteți finaliza.",
    "mobile_mobileform_follow_up_actions_leave_description": "Dacă părăsești acest ecran, vei pierde toate modificările nesalvate.",
    "mobile_mobileform_follow_up_actions_leave": "Ieși",
    "mobile_forms_drafts_text": "Eliminați schițele",
    "mobile_batch_estimate_user": "Utilizator",
    "mobile_batch_estimate_users": "Utilizatori",
    "mobile_table_of_contents": "Cuprins",
    "mobile_table_of_contents_required": "Obligatoriu",
    "mobile_table_of_contents_optional": "Opțional",
    "mobile_dialog_alert_title": "Alertă",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Dispozitivele Bluetooth nu sunt încă acceptate pe Windows",
    "mobile_windows_deprecated_message_content_announcement": "Anunț",
    "mobile_windows_deprecated_message_title": "Este necesară actualizarea aplicației",
    "mobile_windows_deprecated_message_description": "Instalați aplicația Zenput din Microsoft Store cât mai curând posibil pentru a vă asigura că beneficiați de actualizările critice de funcționalitate și de o experiență Zenput optimă.",
    "mobile_dashboard_tcr_graph_name": "Rata de finalizare a activității",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Ultimele 4 săptămâni",
    "mobile_dashboard_tcr_legend_company_average": "Media companiei",
    "mobile_dashboard_tcr_legend_team_average": "Media echipei",
    "mobile_dashboard_tab_title_summary": "Rezumat",
    "mobile_dashboard_tab_title_activity": "Operațiune",
    "mobile_dashboard_card_title_top_triggered_workflows": "Top declanșatoare",
    "mobile_dashboard_tab_title_info": "Informații",
    "mobile_dashboard_tab_project_audit": "Conformitate",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Săptămâna",
    "mobile_dashboard_card_filter_form_template_placeholder": "Toate formularele",
    "mobile_dashboard_card_title_forms_top_nos": "„Nu” frecvente",
    "mobile_dashboard_zenput_code_no_data_in_range": "Nu există date în acest interval de timp.",
    "mobile_dashboard_zenput_code_permission_denied": "Nu aveți permisiunea de a vedea acest lucru.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Selectați un formular de mai sus.",
    "mobile_dashboard_zenput_code_unknown_error": "Nu putem afișa datele în acest moment.",
    "mobile_dashboard_tap_to_retry": "Atingeți pentru a reîncerca",
    "mobile_dashboard_reporting_delay_disclaimer": "Actualizarea activităților poate dura până la 15 minute",
    "mobile_dashboard_configuration_down_state_postfix_msg": "au fost configurate de către administratorul dvs.",
    "mobile_tasks_tag": "activități",
    "mobile_workflows_tag": "declanșatoare",
    "mobile_projects_tag": "proiecte recurente",
    "mobile_forms_tag": "formulare",
    "mobile_dashboard_card_ongoing_projects_title": "Proiecte în desfășurare",
    "mobile_dashboard_card_ongoing_projects_show_more": "Afișați mai mult",
    "mobile_dashboard_card_ongoing_projects_show_less": "Afișați mai puțin",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Salt la Proiecte",
    "mobile_dashboard_card_title_recurring_projects": "Proiecte recurente",
    "mobile_dashboard_card_filter_daily": "Zilnic",
    "mobile_dashboard_card_filter_weekly": "Săptămânal",
    "mobile_dashboard_card_filter_monthly": "Lunar",
    "mobile_task_status_title_open": "Deschise",
    "mobile_task_status_title_upcoming": "Viitoare",
    "mobile_task_status_title_complete": "Finalizați",
    "mobile_task_status_title_processing": "Se procesează trimiterea",
    "mobile_task_status_title_complete_with_exceptions": "Finalizați cu Urmărire activități sau Alerte",
    "mobile_task_status_title_completed_late_with_exceptions": "Finalizat cu întârziere cu sarcini de urmărire sau alerte",
    "mobile_task_status_title_incomplete_and_closed": "Pierdute",
    "mobile_tasks_legend_modal_title": "Legendă",
    "mobile_tasks_legend_modal_footer_button_title": "Închideți",
    "mobile_common_assigned_to": "Atribuit către",
    "mobile_common_created_by": "Creat de",
    "mobile_common_tasks_for": "Activități pentru",
    "mobile_common_go_back": "Înapoi",
    "mobile_oh_no": "Ups!",
    "mobile_user_not_in_groups": "Ne pare rău, se pare că nu sunteți atribuit unei echipe. Contactați-vă administratorul pentru a obține acces la tabloul de bord.",
    "mobile_tasks_select_followers": "Selectați urmăritori",
    "mobile_tasks_assign_tasks": "Atribuiți activități {{count}}",
    "mobile_tasks_add_followers": "Adăugați urmăritori",
    "mobile_tasks_followers": "Urmăritori",
    "mobile_tasks_delete_task": "Ștergeți activitatea",
    "mobile_tasks_create_task": "Creați activități",
    "mobile_tasks_tab_title_comments": "Comentarii",
    "mobile_tasks_see_more": "Vedeți mai mult",
    "mobile_projects_create_project": "Creați un proiect",
    "mobile_common_button_send": "Trimiteți",
    "mobile_common_button_schedule": "Program",
    "mobile_announcements_create": "Creați anunț",
    "mobile_announcements_read_rate": "{{opened_count}} din {{recipients_count}} deschise",
    "mobile_announcements_empty_message": "Nu ați creat niciun anunț încă! Creați un anunț mai jos pentru a transmite organizației dvs. știri, informații și actualizări importante.",
    "mobile_announcement_message_placeholder": "Adăugați un mesaj...",
    "mobile_announcement_title_placeholder": "Titlul anunțului",
    "mobile_announcement_leaving_announcement": "Se iese din anunț",
    "mobile_announcement_confirm_recipients_team": "Doriți să transmiteți acest anunț către {{count}} utilizator(i) din {{teams}} echipa(e) selectată(e)?",
    "mobile_announcement_confirm_recipients_role": "Doriți să transmiteți acest anunț către {{count}} utilizator(i) din {{roles}} rolul(uri) selectat(e)?",
    "mobile_announcement_confirm_recipients_user": "Doriți să transmiteți acest anunț către {{count}} utilizator(i)?",
    "mobile_announcement_confirm_scheduled": "La {{timestamp}}",
    "mobile_announcement_sending_announcement": "Se trimite anunțul",
    "mobile_announcement_send_to": "Trimiteți către",
    "mobile_announcement_sent_to": "Trimis către",
    "mobile_announcement_send_to_role": "Rol",
    "mobile_announcement_attachment_download": "Se descarcă {{filename}}",
    "mobile_announcement_attachment_validation_error": "Nu se pot adăuga mai mult de {{maxCount}} atașări",
    "mobile_announcement_details_sent": "Trimis",
    "mobile_announcement_details_total_recipients": "Totalul destinatarilor",
    "mobile_announcement_details_cancel": "Anulați anunțul",
    "mobile_announcement_details_not_editable": "Anunțurile pot fi editate numai în Ops Execution web app ",
    "mobile_announcement_details_not_editable_old": "Anunțurile pot fi editate pe site-ul web Zenput",
    "mobile_announcement_details_open_count": "Numărul deschiderilor",
    "mobile_announcement_details_open_rate": "Rata deschiderilor",
    "mobile_announcement_details_resend": "Retrimiteți către cei care nu au citit",
    "mobile_announcement_confirm_resend": "{{count}} utilizator(i) nu a/au citit anunțul. Doriți să trimiteți un memento?",
    "mobile_announcement_confirm_resend_title": "Trimiteți memento?",
    "mobile_announcement_recipients_opened": "Deschise",
    "mobile_recipients_opened_empty_message": "Se pare că nimeni nu a deschis mesajul încă. Reveniți mai târziu pentru a vedea rezultatele.",
    "mobile_announcement_recipients_unopened": "Nedeschise",
    "mobile_recipients_unopened_empty_message": "Vești bune! Nu există mesaje nedeschise!",
    "mobile_scheduled_announcements_delivery_section_header": "Ora livrării",
    "mobile_scheduled_announcements_send_immediately_label": "Trimiteți imediat",
    "mobile_scheduled_announcements_scheduled_label": "Trimiteți la o anumită oră",
    "mobile_scheduled_announcements_scheduled_tab_label": "Programat",
    "mobile_scheduled_announcements_dialog_header": "Anulați anunțul?",
    "mobile_scheduled_announcements_dialog_message": "Anularea anunțului va împiedica trimiterea acestuia și îl va șterge din listă. Această acțiune nu poate fi anulată. Pentru a edita, accesați site-ul web Zenput.",
    "mobile_scheduled_announcements_empty_message": "Momentan nu aveți anunțuri programate! Programați un anunț pentru a transmite organizației dvs. știri, informații și actualizări importante.",
    "mobile_scheduled_announcements_validation_error": "Ora livrării trebuie să fie după {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Programați anunțul",
    "mobile_projects_auto_archive": "Arhivare automată",
    "mobile_common_unassigned": "Neatribuit",
    "mobile_tasks_title_placeholder": "Activitate sau formular nou",
    "mobile_projects_leaving_project": "Se iese din proiect",
    "mobile_projects_save_project": "Salvați proiectul",
    "mobile_top_triggers_tasks": "Top activități declanșate",
    "mobile_top_triggers_alerts": "Top alerte declanșate",
    "mobile_projects_not_started": "Nu a început",
    "mobile_empty_list_message_no_photos": "Nicio fotografie",
    "mobile_webfilestore_message_error": "Selectați un tip de fișier valid",
    "mobile_notifications_empty_title": "Nicio notificare",
    "mobile_notifications_empty_message": "Operațiunile din cadrul activităților dvs. sau a celor la care participați vor apărea aici.",
    "mobile_comments_comment_deleted": "Acest comentariu a fost șters.",
    "mobile_comments_comment_placeholder": "Comentariu",
    "mobile_comments_task_submitted_at": "Activitate trimisă pe {{ date }} la {{ time }}",
    "mobile_comments_discard_comment_title": "Renunțați la comentariu?",
    "mobile_comments_discard_confirm_message": "Sunteți sigur(ă)? Comentariul va fi șters.",
    "mobile_comments_delete_comment_title": "Ștergeți comentariul?",
    "mobile_comments_delete_confirm_message": "Această acțiune nu poate fi anulată.",
    "mobile_comments_delete_button": "Ștergeți comentariul",
    "mobile_comments_delete_success_message": "Comentariul a fost șters",
    "mobile_comments_empty_message_tasks": "Nu există comentarii încă \n Începeți o conversație despre această activitate.",
    "mobile_comments_empty_message_submissions": "Nu există comentarii încă \n Începeți o conversație despre această trimitere.",
    "mobile_comments_empty_message_default": "Nu există comentarii încă \n Începeți o conversație.",
    "mobile_comments_no_matching_users": "Nu se potrivește niciun utilizator.",
    "mobile_comments_empty_users_to_notify": "Nu există niciun utilizator de notificat.",
    "mobile_comments_users_cant_view_message": "Acești utilizatori nu pot vedea aceste comentarii",
    "mobile_comments_users_to_notify_title": "Utilizatori de notificat",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilizator</a> va fi notificat.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilizatori</a> vor fi notificați.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> mai mulți utilizatori de notificat.",
    "mobile_comments_mark_read": "Marcați-le pe toate ca citite",
    "mobile_comments_author_mentioned_message": "v-a menționat în",
    "mobile_comments_author_commented_message": "a adăugat un comentariu pe",
    "mobile_view_pdf": "Vedeți fișierul PDF",
    "mobile_no_pdf_generated_message": "Niciun fișier PDF nu a fost găsit pentru această trimitere. O copie vă va fi trimisă prin e-mail în curând.",
    "mobile_clipboard_copied_success": "Linkul este copiat în clipboardul dvs.",
    "mobile_share_link": "Distribuiți linkul",
    "mobile_zencam_share": "Distribuiți",
    "mobile_zencam_view_details": "Vedeți detaliile",
    "mobile_zencam_details_drawer_header": "Detalii",
    "mobile_zencam_submitted_by": "Trimis de",
    "mobile_zencam_form_title": "Titlu formular",
    "mobile_zencam_date_submitted": "Data trimiterii",
    "mobile_oil_quality_warning_message": "Uleiul se apropie de termenul de expirare",
    "mobile_oil_quality_warning_message_subtitle": "Începeți să planificați schimbarea în curând",
    "mobile_oil_quality_failure_message": "Calitatea uleiului este compromisă",
    "mobile_oil_quality_failure_message_subtitle": "Schimbați uleiul imediat",
    "mobile_sensors_set_up_gateway": "Configurați gateway",
    "mobile_sensors_set_up_gateway_message": "Se pare că nu există dispozitive configurate. Începeți prin adăugarea unui gateway.",
    "mobile_sensors_gateway_plugged_in": "Asigurați-vă că gateway-ul este conectat la o priză",
    "mobile_sensors_add_device": "Adăugați dispozitiv",
    "mobile_sensors_name_this_gateway": "Denumiți acest gateway.",
    "mobile_sensors_name_this_sensor": "Denumiți acest senzor.",
    "mobile_sensors_device_barcode_information": "Scanați codul QR sau introduceți numărul ID și SC din eticheta dispozitivului",
    "mobile_sensors_device_eui_information": "Scanați codul QR sau introduceți codul DevEUI din eticheta dispozitivului",
    "mobile_sensors_gateway_id_information": "Introduceți ID-ul de nod din eticheta Portal",
    "mobile_sensors_id_number": "Număr {{untranslatedID}}",
    "mobile_sensors_sc_code": "Cod {{untranslatedSCCode}}",
    "mobile_sensors_sensors": "Senzori",
    "mobile_sensors_sensor_deveui_error": "Nu am putut obține DevEUI din QR. Introduceți-l manual.",
    "mobile_sensors_gateways": "Gateway-uri",
    "mobile_sensors_add_sensor": "Adăugați senzor",
    "mobile_sensors_add_gateway": "Adăugați gateway",
    "mobile_sensor_placement_description": "Ce zonă va monitoriza acest senzor?",
    "mobile_sensors_equipment_placement": "Ce zonă sau echipament va monitoriza acest senzor?",
    "mobile_sensors_equipment": "Ce echipament va monitoriza acest senzor?",
    "mobile_sensors_select_gateway_type": "Selectați tipul de portal",
    "mobile_sensors_select_placement": "Selectați poziționarea",
    "mobile_sensors_select_equipment": "Selectați echipamentul",
    "mobile_sensors_placement": "Poziționare",
    "mobile_sensors_nickname_tip": "Denumirea senzorului este determinată de numele atribuite în poziționarea selectată.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Scanați codul QR",
    "mobile_sensors_enter_manually": "Introduceți manual",
    "mobile_sensors_wizard_step_one": "Pasul 1",
    "mobile_sensors_wizard_step_two": "Pasul 2",
    "mobile_sensors_wizard_step_three": "Pasul 3",
    "mobile_sensors_wizard_step_four": "Pasul 4",
    "mobile_sensors_wizard_step_five": "Pasul 5",
    "mobile_sensors_wizard_step_six": "Pasul 6",
    "mobile_sensors_initializing": "Se inițializează...",
    "mobile_sensors_nickname": "Poreclă",
    "mobile_sensors_field_not_blank": "Câmpul {{field}} nu poate fi necompletat.",
    "mobile_sensors_nothing_to_see_here": "Nimic de văzut aici",
    "mobile_sensors_missing_integration": "Lipsește integrarea senzorului",
    "mobile_sensors_contact_zenput_admin": "Te rugăm să contactezi administratorul Ops Execution din cadrul companiei tale.",
    "mobile_sensors_contact_zenput_admin_old": "Contactați administratorul Zenput.",
    "mobile_sensors_contact_manager": "Contactați-vă managerul de cont pentru a adăuga senzori.",
    "mobile_sensors_device_success_message": "Încărcarea datelor de la senzori poate dura până la 15 minute",
    "mobile_sensors_last_reading": "Ultima citire",
    "mobile_sensors_remove_device": "Eliminați dispozitivul",
    "mobile_sensors_one_day": "1Z",
    "mobile_sensors_one_week": "1S",
    "mobile_sensors_one_month": "1L",
    "mobile_sensors_three_months": "3L",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1A",
    "mobile_sensors_sensor_settings": "Setările senzorului",
    "mobile_sensors_remove_confirm_message": "Sigur doriți să ștergeți acest dispozitiv?\nAceastă acțiune nu poate fi anulată.",
    "mobile_sensors_sensor": "Senzor",
    "mobile_sensors_no_equipment_linked": "Niciun echipament legat",
    "mobile_sensor_cooldown_process": "Proces de răcire",
    "mobile_sensor_last_12_hours": "Ultimele 12 ore",
    "mobile_sensor_start_cooldown_process": "Începeți un nou proces de răcire",
    "mobile_sensor_cooldown_process_title": "Proces de răcire în două etape",
    "mobile_sensor_cooldown_process_description": "Un proces de răcire în două etape constă în răcirea alimentelor de la mai mult de {{ stage1_start_temperature }} la {{ stage1_end_temperature }} în două ore sau mai puțin, iar apoi de la {{ stage1_end_temperature }} la {{ stage2_end_temperature }} în patru ore sau mai puțin.",
    "mobile_sensor_cooldown_process_place_food": "Puneți produsul alimentar în frigider.",
    "mobile_sensor_cooldown_process_insert_sensor": "Introduceți o sondă cu senzor în produsul alimentar.",
    "mobile_sensor_cooldown_process_enter_information": "Introduceți informațiile mai jos.",
    "mobile_sensor_cooldown_process_food_product": "Produs alimentar de răcit",
    "mobile_sensor_cooldown_cool_down": "Răcire",
    "mobile_sensor_cooldown_select_sensor": "Selectați senzorul",
    "mobile_sensors_cooldown_start_cooldown": "Începeți răcirea",
    "mobile_sensors_cooldown_please_enter_food": "Introduceți un Produs alimentar",
    "mobile_sensors_cooldown_please_select_sensor": "Selectați un Senzor",
    "mobile_sensors_cooldown_status_in_progress": "În desfășurare",
    "mobile_sensors_cooldown_status_failed": "Nereușit",
    "mobile_sensors_cooldown_status_success": "Reușit",
    "mobile_sensors_cooldown_stage": "Etapă",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Temperatura de început este în afara intervalului",
    "mobile_sensors_cooldown_failed_cooldown_process": "Proces de răcire nereușit",
    "mobile_sensors_cooldown_cooldown_successful": "Proces de răcire reușit",
    "mobile_sensors_cooldown_started_cooldown_process": "Procesul de răcire a început",
    "mobile_sensors_cooldown_hour": "oră",
    "mobile_sensors_cooldown_hour_plural": "ore",
    "mobile_sensors_cooldown_minute": "minut",
    "mobile_minutes_plural": "minute",
    "mobile_sensors_last_reading_max_date": "> 1 an în urmă",
    "mobile_sensors_minute_count_ago": "{{count}} minut în urmă",
    "mobile_sensors_minute_count_ago_plural": "{{count}} minute în urmă",
    "mobile_sensors_hour_count_ago": "{{count}} oră în urmă",
    "mobile_sensors_hour_count_ago_plural": "{{count}} ore în urmă",
    "mobile_sensors_day_count_ago": "{{count}} zi în urmă",
    "mobile_sensors_day_count_ago_plural": "{{count}} zile în urmă",
    "mobile_sensors_chart_settings": "Setări diagramă",
    "mobile_announcement_banner_continue_reading": "Continuați citirea",
    "mobile_compliance_submissions_report": "Raport remiteri",
    "mobile_compliance_submissions_report_subtitle": "Exportați datele de finalizare a proiectului pentru acest magazin",
    "mobile_compliance_send_submissions": "Trimiteți remiterile",
    "mobile_compliance_completion_rate_in_last_days": "Rata de finalizare din ultimele {{ days }} zile",
    "mobile_compliance_last_days": "Ultimele {{ days }} zile",
    "mobile_compliance_send_submissions_to": "Trimiteți remiterile la",
    "mobile_compliance_send_to_different_email": "Trimiteți către altă adresă de e-mail",
    "mobile_compliance_email_input_placeholder": "Adresă de e-mail",
    "mobile_compliance_send_submissions_to_legend_title": "Remiteri",
    "mobile_compliance_send_submissions_to_legend_description_days": "La adresa de e-mail selectată va fi trimis un raport cu remiterile dvs. din această locație, din ultimele {{ days }} zile.",
    "mobile_compliance_time_frame": "Interval de timp",
    "mobile_compliance_sensor_temperature_log_report": "Raport jurnal temperatură senzor",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exportați jurnalele de temperatură pentru acest magazin",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Criterii",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Definiți mai jos criteriile pentru raport.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Notă: senzorii dezactivați nu apar în raport",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Selectați un interval de timp. Datele din jurnal sunt limitate la maximum 30 de zile",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Trimiteți raportul",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Luna aceasta (1 azi)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Luna trecută",
    "mobile_compliance_sensor_temperature_log_email_title": "Trimiteți raportul către",
    "mobile_pwa_update_prompt_title": "Actualizați aplicația",
    "mobile_pwa_update_prompt_description": "Este disponibilă o nouă versiune a aplicației. Vă rugăm să actualizați la cea mai recentă versiune.",
    "mobile_pwa_update_prompt_confirm": "Actualizați și reîncărcați",
    "mobile_pwa_update_prompt_cancel": "Amintiți-mi mai târziu",
    "notification_title_due_in_one_hour": "Livrare în 1 oră",
    "task_is_due_soon": "„{{ task_title }}” trebuie livrată curând. Luați-vă un moment pentru a o finaliza.",
    "mobile_photo_quality_warning_header": "Problemă legată de calitatea fotografiei",
    "mobile_photo_quality_dialog_message": "Această fotografie ar putea fi prea întunecată sau neclară. Doriți să faceți o nouă fotografie sau să continuați cu aceasta?",
    "mobile_take_new_photo": "Faceți o nouă fotografie",
    "mobile_use_this_photo": "Utilizați această fotografie"
}};
mobile_translations.mn_MN = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Бүгд",
    "mobile_common_button_apply_filters": "Шүүлтийг хэрэглэх",
    "mobile_common_button_done": "Болсон",
    "mobile_common_button_edit": "Засах",
    "mobile_common_button_archive": "Архив",
    "mobile_common_button_save": "Хадгалах",
    "mobile_common_button_retake": "Дахин авах",
    "mobile_common_button_save_draft": "Ноорог Хадгалах",
    "mobile_common_button_discard": "Татгалзах",
    "mobile_common_button_submit": "Оруулах",
    "mobile_common_button_no": "Үгүй",
    "mobile_common_button_yes": "Тийм",
    "mobile_common_button_na": "Үгүй",
    "mobile_common_created_by_me": "Миний бүтээсэн",
    "mobile_common_email": "Компанийн имэйл",
    "mobile_common_first_name": "Нэр",
    "mobile_common_last_name": "Овог",
    "mobile_common_location": "Байршил",
    "mobile_common_locations": "Байршлууд",
    "mobile_common_logout_message": "Та гармаар байгаадаа итгэлтэй байна уу?",
    "mobile_common_password": "Нууц үг",
    "mobile_common_permission_required": "Зөвшөөрөл шаардлагатай",
    "mobile_common_status": "Төлөв",
    "mobile_common_task": "Даалгавар",
    "mobile_common_tasks": "Даалгаврууд",
    "mobile_common_tasks_my": "Миний даалгаврууд",
    "mobile_common_projects": "Төслүүд",
    "mobile_common_filter_team": "Баг",
    "mobile_common_filter_var_in": " {{team_or_location}} -д",
    "mobile_common_filter_no_team_selected": "Баг сонгоогүй байна",
    "mobile_common_filter_no_user_selected": "Хэрэглэгч сонгоогүй байна",
    "mobile_common_filter_no_role_selected": "Үүрэг сонгоогүй байна",
    "mobile_common_placeholder_date": "Огноо",
    "mobile_common_message_task_creator_error_save": "<b>Даалгаврыг үүсгэж чадсангүй.</b>",
    "mobile_common_camera": "Камер",
    "mobile_common_microphone": "Микрофон",
    "mobile_common_for": "д",
    "mobile_common_reload": "Дахин ачаалах",
    "mobile_common_override": "Хоосон ажиллагаа",
    "mobile_common_notifications": "Мэдэгдлүүд",
    "mobile_common_chat_unavailable": "அரட்டை கிடைக்கவில்லை. பிறகு மீண்டும் முயற்சிக்கவும்.",
    "mobile_common_chat_ending_dialog_title": "Та энэ яриагаа дуусгасан уу?",
    "mobile_common_chat_ending_dialog_description": "Таны асуудал шийдэгдсэн эсвэл дараа үргэлжлүүлэхийг хүсвэл бидэнд мэдэгдээрэй.",
    "mobile_common_chat_ending_dialog_confirm": "Тийм ээ, би дууслаа",
    "mobile_common_chat_ending_dialog_cancel": "Би дараа нь үргэлжлүүлье",
    "mobile_common_continue_editing": "Үргэлжлүүлэн засах",
    "mobile_privacy_policy": "Нууцлалын бодлого",
    "wootric_recommend_target": "танай салбарын найз эсвэл хамтран ажиллагч",
    "wootric_followup_detractor_question": "Дараагийн удаа бидэнд илүү өндөр үнэлгээ өгөхийн тулд бид танд зориулж ямар өөрчлөлт хийж чадах вэ?",
    "wootric_followup_passive_question": "Баярлалаа! Хэрэгслийг улам сайжруулахын тулд бид юу хийж чадах вэ?",
    "wootric_followup_promoter_question": "Баярлалаа! Та Crunchtime Ops Execution-д юуг хамгийн ихээр дуртай вэ?",
    "wootric_followup_promoter_question_old": "Баярлалаа! Та Zenput-н юунд нь дуртай вэ?",
    "wootric_default_followup_question": "Баярлалаа! Яагаад гэдгийг нь хэлэхдээ анхааралтай байна уу?",
    "wootric_default_placeholder_text": "Оноогоо тайлбарлаж бидэнд туслаарай.",
    "wootric_default_thankyou_text": "Таны хариулт, санал хүсэлтэд баярлалаа!",
    "mobile_login_placeholder_login_as": "Хэрэглэгчийн ID-р нэвтрэх",
    "mobile_login_button_forgot_password": "Нууц үгээ мартсан уу?",
    "mobile_login_button_sign_up": "Бүртгэл үүсгэх",
    "mobile_login_button_finish_setup": "Тохиргоог дуусгах",
    "mobile_login_button": "Нэвтрэх",
    "mobile_login_continue_button": "Үргэлжлүүлэх",
    "mobile_login_continue_transition": "танай байгууллагын нэвтрэх хуудас руу таныг хөтөлж байна...",
    "mobile_login_no_email_error": "Та имэйл оруулах ёстой.",
    "mobile_login_change_email": "Өөр имэйлээр нэвтрэх",
    "mobile_login_with_sso": "SSO-оор нэвтрэх",
    "mobile_oauth_no_user_error_message": "Та Cunchtime Ops Execution дансгүй бололтой!",
    "mobile_oauth_no_user_error_message_old": "Танд Zenput бүртгэл байхгүй бололтой!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> одоо <b>Crunchtime Ops Execution боллоо</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} нь 9-р сард {{- product }} болж байна. {{- cta }}",
    "mobile_rebrand_warning_cta": "Хэрхэн бэлтгэхээ сур.",
    "mobile_oauth_no_user_error_sub_message": "Нэвтрэхийн тулд админтай холбоо барих эсвэл өөр имэйлээр нэвтрэхээр оролдоорой.",
    "mobile_oauth_generic_error_message": "Нэвтрэхэд асуудал гарсан бололтой, та дахин оролдоно уу.",
    "mobile_oauth_force_logout_msg": "Хэрэв та асуудалтай хэвээр байгаа бол ",
    "mobile_oauth_force_logout_click": "энд дарж үйлчилгээ үзүүлэгчээсээ гарна уу.",
    "mobile_sign_up_placeholder_phone": "Утасны дугаар",
    "mobile_sign_up_placeholder_password_confirm": "Нууц үгээ баталгаажуулна уу",
    "mobile_sign_up_button_sign_in": "Нэвтрэх",
    "mobile_sign_up_disclaimer_part_1": "Бүртгэл үүсгэх товчийг дарснаар та",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Та Тохиргоог дуусгах дээр дарснаар дараахыг зөвшөөрч байна",
    "mobile_sign_up_disclaimer_link_title": " Бүртгэл үүсгэх товчийг дарснаар та",
    "mobile_sign_up_disclaimer_part_2": "Тусгай зөвшөөрлийн гэрээг зөвшөөрч байгаа болно",
    "mobile_dialog_benefits_work_offline": "Оффлайнаар ажиллах",
    "mobile_dialog_benefits_faster_uploads": "Илүү хурдан байршуулах",
    "mobile_dialog_benefits_better_experience": "Илүү сайн туршлага",
    "mobile_dialog_benefits_button_download": "Татаж авах",
    "mobile_dialog_benefits_button_download_bold": "Гүйцэтгэх үйл ажиллагаа ",
    "mobile_dialog_benefits_button_download_bold_old": "-д зориулсан Zenput ",
    "mobile_dialog_benefits_button_have": "Надад апп байна!",
    "mobile_dialog_benefits_button_no_thanks": "Үгүй ээ баярлалаа, магадгүй дараа нь.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Зургийг ачаалж чадсангүй.",
    "mobile_dialog_signature_sign": "Энд бүртгүүл",
    "mobile_dialog_signature_button_clear": "Арилгах",
    "mobile_account_placeholder_name": "Байршил/Дэлгүүрийн нэр",
    "mobile_account_placeholder_phone": "Утас",
    "mobile_account_placeholder_address": "Хаяг",
    "mobile_account_placeholder_city": "Хот",
    "mobile_account_placeholder_region": "Бүс",
    "mobile_account_placeholder_zipcode": "Шуудангийн код/Zip код",
    "mobile_account_option_select_country": "Улсаа сонгоно уу",
    "mobile_account_oprion_us": "Америкийн Нэгдсэн Улс",
    "mobile_account_oprion_select_state": "Мужаа сонгоно уу",
    "mobile_account_button_create_location": "Байршил үүсгэх",
    "mobile_form_message_no_form": "Маягт байхгүй байна",
    "mobile_batch_task_message": "Ачаалж байна...",
    "mobile_settings_profile": "Профайл",
    "mobile_settings_profile_number": "Гар утас",
    "mobile_settings_profile_language": "Хэл",
    "mobile_settings_profile_temperature_unit": "Температурын нэгж",
    "mobile_settings_profile_use_company_default": "Компанийн анхдагч ашиглах",
    "mobile_settings_profile_celsius": "Цельсий",
    "mobile_settings_profile_fahrenheit": "Фаренгейт",
    "mobile_settings_notifications_option_sms": "Текст зурвас",
    "mobile_settings_notifications_option_push": "Түлхэх мэдэгдлүүд",
    "mobile_settings_notifications_option_push_email": "Имэйл ба Түлхэх мэдэгдлүүд",
    "mobile_settings_notifications_option_do_not": "Мэдэгдэх хэрэггүй",
    "mobile_settings_notifications_category_communication": "Харилцаа холбоо",
    "mobile_settings_notifications_category_forms_and_triggers": "Маягтууд & Идэвхжүүлэлтүүд",
    "mobile_settings_devices": "Төхөөрөмжүүд",
    "mobile_settings_notifications_sub_category_alerts": "Сануулга",
    "mobile_settings_notifications_sub_category_new_forms_available": "Шинэ Маягт Боломжтой Байна",
    "mobile_settings_notifications_sub_category_task_assigned": "Даалгаврыг Өгсөн",
    "mobile_settings_notifications_sub_category_task_completed": "Даалгаврыг Дуусгасан",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Удахгүй хугацаа нь дуусах даалгавруудын сануулагч",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Хугацаа хэтэрсэн даалгавруудын сануулагч",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Мэдрэгчийн Сануулга",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Чухал мэдрэгчийн дохиолол",
    "mobile_drafts_message": "Танд одоогоор ноорог байхгүй байна.",
    "mobile_drafts_button_delete": "Устгах",
    "mobile_tasks_filter_location_no": "Байршил сонгоогүй байна",
    "mobile_tasks_filter_group_by": "Бүлгээр",
    "mobile_tasks_filter_sort_by": "Дараахаар эрэмбэлэх",
    "mobile_tasks_filter_sorted_by": "Дараахаар эрэмблэгдсэн",
    "mobile_tasks_filter_due_time": "Дуусах цаг",
    "mobile_tasks_filter_open_time": "Нээх цаг",
    "mobile_tasks_bucket_due_next_24_hours": "Дараагийн 24 цагийн дотор шаардлагатай",
    "mobile_tasks_bucket_due_next_7_days": "Дараагийн 7 хоногийн дотор шаардлагатай",
    "mobile_tasks_bucket_open_tasks": "Нэмэлт нээлттэй {{type}}",
    "mobile_tasks_bucket_open_at": "Нээх: {{- date }}-д {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Эцсийн хугацаа: {{- date }}-д {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "1 минутад бэлэн",
    "mobile_tasks_bucket_available_in_one_hour": "1 цагт бэлэн",
    "mobile_tasks_bucket_available_in_one_day": "1 өдөрт бэлэн",
    "mobile_tasks_bucket_available_in_one_week": "1 долоо хоногт бэлэн",
    "mobile_tasks_bucket_available_in_one_month": "1 сард бэлэн",
    "mobile_tasks_bucket_available_in_one_year": "1 жилд бэлэн",
    "mobile_tasks_bucket_available_in_minutes": "{{ minutes }} минутад бэлэн",
    "mobile_tasks_bucket_available_in_hours": "{{ hours }} цагт бэлэн",
    "mobile_tasks_bucket_available_in_days": "{{ days }} өдөрт бэлэн",
    "mobile_tasks_bucket_available_in_weeks": "{{ weeks }} долоо хоногт бэлэн",
    "notification_task_due_in_minutes": "{{ minutes }} минутын дараа дуусна",
    "mobile_tasks_bucket_available_in_months": "{{ months }} сард бэлэн",
    "mobile_tasks_bucket_available_in_years": "{{ years }} жилд бэлэн",
    "mobile_tasks_follow_up": "Даалгаврыг дагах",
    "mobile_tasks_due_soon": "Удахгүй ирнэ",
    "mobile_tasks_bucket_completed_today": "Өнөөдөр дууссан",
    "mobile_tasks_bucket_completed_this_week": "Энэ долоо хоногт дууссан",
    "mobile_tasks_bucket_completed_last_week": "Өнгөрсөн долоо хоногт дууссан",
    "mobile_tasks_bucket_missed_today": "Өнөөдөр орхигдсон",
    "mobile_tasks_bucket_missed_this_week": "Энэ долоо хоногт орхигдсон",
    "mobile_tasks_bucket_missed_last_week": "Өнгөрсөн долоо хоногт алга орхигдсон",
    "mobile_tasks_bucket_no_location": "Байршил алга",
    "mobile_tasks_cannot_submit_missed": "Орхигдсон ажлуудыг гүйцээх боломжгүй",
    "mobile_tasks_cannot_submit_missed_after": "Энэ даалгаврыг {{ date }} с хойш дуусах боломжгүй",
    "mobile_tasks_cannot_submit_upcoming": "Энэ даалгавар эхлээгүй байна.",
    "mobile_tasks_cannot_submit_processing": "Энэхүү мэдүүлгийг боловсруулж байна",
    "mobile_tasks_toolbarnav_header_no_due_date": "Дуусах хугацаа байхгүй",
    "mobile_tasks_toolbarnav_header_overdue": "Хугацаа хэтэрсэн",
    "mobile_tasks_toolbarnav_header_yesterday": "Өчигдөр",
    "mobile_tasks_toolbarnav_header_today": "Өнөөдөр",
    "mobile_tasks_toolbarnav_header_tomorrow": "Маргааш",
    "mobile_tasks_toolbarnav_header_last_week": "Өнгөрсөн долоо хоног",
    "mobile_tasks_toolbarnav_header_this_week": "Энэ долоо хоног",
    "mobile_tasks_toolbarnav_header_next_week": "Дараа долоо хоног",
    "mobile_tasks_toolbarnav_header_this_month": "Энэ сар",
    "mobile_tasks_toolbarnav_header_next_year": "Дараа жил",
    "mobile_tasks_toolbarnav_header_over_year": "Жил гаруй",
    "mobile_tasks_toolbarnav_title_edit_task": "Даалгаврыг засах",
    "mobile_task_placeholder_title": "Гарчиг *",
    "mobile_task_placeholder_description": "Тайлбар (заавал биш)",
    "mobile_task_button_single_task": "Нэг даалгавар",
    "mobile_task_button_project": "Төсөл",
    "mobile_task_button_create": "Үүсгэх",
    "mobile_task_tab_basic": "Үндсэн",
    "mobile_task_tab_photo": "Зураг",
    "mobile_task_tab_form": "Маягт",
    "mobile_task_details_description_message_please": "Доор ",
    "mobile_task_details_description_message_below": "бөглөнө үү.",
    "mobile_task_details_description_message_instructions": "Энэ даалгаварт зориулсан заавар байхгүй байна.",
    "mobile_task_details_reason_title": "Хяналт-шинжилгээг идэвхжүүлсэн",
    "mobile_task_detials_button_goto_form": "Маягт руу очих",
    "mobile_task_detials_button_complete": " Даалгаврыг дуусгах",
    "mobile_task_detials_completed": "Дууссан ",
    "mobile_task_detials_completed_by": "ээр ",
    "mobile_task_detials_completed_on": "дээр ",
    "mobile_task_details_view_form_submission": "Маягтын мэдүүлгийг үзэх",
    "mobile_task_task_updated": "Даалгаврыг шинэчилсэн",
    "mobile_task_task_archived": "Даалгаврыг архивласан",
    "mobile_task_task_deleted": "Даалгаврыг устгасан",
    "mobile_task_error_archiving_task": "Даалгаврыг архивлаж чадсангүй.",
    "mobile_task_error_deleting_task": "Даалгаврыг устгаж чадсангүй.",
    "mobile_task_error_updating_task": "Даалгаврыг шинэчилж чадсангүй.",
    "mobile_task_archive_task": "Архивын даалгавар",
    "mobile_task_archive_task_confirm": "Та энэ даалгаврыг архивлахыг хүсэж байгаадаа итгэлтэй байна уу?\n\nАрхивлагдсан ажлууд нь гүйцэтгэлийн түвшинд тооцогдох бөгөөд тайланд үргэлжлүүлэн оруулах болно.\n\nҮүнийг буцаах боломжгүй.",
    "mobile_task_delete_task_confirm": "Та энэ даалгаврыг устгахдаа итгэлтэй байна уу?\n\nУстгасан ажлууд гүйцэтгэлийн түвшинд тооцогдохгүй бөгөөд ямар ч тайланд оруулахгүй.\n\nҮүнийг буцаах боломжгүй.",
    "mobile_task_edition_already_in_progress": "Энэ даалгавар хүлээгдэж буй засвартай байна. Цаашид засварлахыг одоогоор зөвшөөрөөгүй байна.",
    "mobile_projects_filter_type": "Төрөл",
    "mobile_projects_filter_status": "Төслийн байдал",
    "mobile_projects_filter_project_type": "Төслийн төрөл",
    "mobile_projects_due_date_required": "Дуусах хугацаа шаардлагатай.",
    "mobile_projects_team_required": "Баг шаардлагатай.",
    "mobile_projects_user_role_required": "Томилогч шаардлагатай.",
    "mobile_projects_title_required": "Гарчиг шаардлагатай.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Өдөрт хэд хэдэн даалгавар",
    "mobile_project_tasks_complete": " Дууссан",
    "mobile_project_tasks_remaining": " Үлдсэн",
    "mobile_esitmate_message_tasks": "0 даалгавар бий болно",
    "mobile_esitmate_message_criteria": "Дээрх шалгуурыг тохируулна уу",
    "mobile_esitmate_message_created_for": "зориулж бүтээх болно",
    "mobile_left_menu_dashboard": "Хяналтын самбар",
    "mobile_left_menu_my_forms": "Миний маягтууд",
    "mobile_left_menu_announcements": "Зарлал",
    "mobile_left_menu_my_submissions": "Миний мэдүүлгүүд",
    "mobile_left_menu_drafts": "Ноорог",
    "mobile_left_menu_pending_uploads": "Хүлээгдэж буй байршуулалт",
    "mobile_left_menu_open": "Апп-д нээх",
    "mobile_left_menu_settings": "Тохиргоо",
    "mobile_left_menu_log_out": "Гарах",
    "mobile_left_menu_debug": "Алдаа согогийг засах",
    "mobile_left_menu_support": "Дэмжлэг",
    "mobile_left_menu_documentation": "Баримтжуулалт",
    "mobile_left_menu_chat": "Чат",
    "mobile_field_textarea_placeholder_note": "Тэмдэглэл эсвэл тайлбар",
    "mobile_field_option_select": "Сонгох",
    "mobile_field_text_placeholder_text": "Текст",
    "mobile_field_email_placehoder_email": "Имэйл",
    "mobile_filed_number_placeholder_number": "Дугаар",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Холбогдоогүй",
    "mobile_field_sensor_offline_battery": "Мэдрэгч офлайн - Батарей",
    "mobile_field_video_button_add": "Видео нэмэх",
    "mobile_field_video_picker_dialog_title": "Дараахаас видео оруулах",
    "mobile_field_video_button_change": "Видео өөрчлөх",
    "mobile_field_image_button_add": "Зураг нэмэх",
    "mobile_field_image_low_quality_warning": "Зарим зураг хэт хар эсвэл бүдэг байж магадгүй. Тодруулсан зургуудыг хянаад шаардлагатай бол солино уу",
    "mobile_field_image_picker_dialog_title": "Дараахаас зураг оруулах",
    "mobile_field_image_picker_edit_failed": "Бид зургийг хадгалж чадсангүй. Дахин оролдоно уу",
    "mobile_field_signature_button_add": "Гарын үсэг нэмэх",
    "mobile_field_signature_button_change": "Гарын үсэг солих",
    "mobile_field_account_select_location": "Байршлаа сонгоно уу",
    "mobile_field_account_prefill": "Сүүлчийн айлчлалын өгөгдлөөр маягтыг урьдчилан бөглөх үү?",
    "mobile_field_account_message_overwrite": "Энэ нь таны аль хэдийн бөглөсөн талбаруудыг дарж бичих болно.",
    "mobile_forms_task_on_behalf": "<b>{{user}}</b>-д хуваарилагдсан энэ байршилд хийх даалгавар байна. Та энэ даалгаврыг гүйцээхийг хүсэж байна уу?",
    "mobile_forms_complete_task": "Даалгавраа дуусгах уу?",
    "mobile_field_account_prefill_button_yes": "Тиймээ, урьдчилж бөглөөрэй",
    "mobile_field_barcode_placeholder_scan": "Баркод сканнердах эсвэл бичих",
    "mobile_field_sensor_qr_code_placeholder_scan": "Кодыг унших эсвэл бичих",
    "mobile_field_gateway_id_code_placeholder": "Node ID-г бичих",
    "mobile_field_scan_qr_or_enter_dev_eui": "QR кодыг унших эсвэл DEVUI оруулах",
    "mobile_field_scan_qr_or_enter_id": "QR кодыг унших эсвэл ID дугаарыг оруулах",
    "mobile_field_scan_qr_or_enter_sc": "QR кодыг унших эсвэл SC код оруулах",
    "mobile_field_barcode_select_date": "Огноо сонгоно уу ",
    "mobile_field_datetime_allow_time": "Хугацаа",
    "mobile_field_stopwatch_button_caption": "Секундомер",
    "mobile_field_stopwatch_common_start": "Эхлэх",
    "mobile_field_stopwatch_common_stop": "Зогсох",
    "mobile_field_stopwatch_common_reset": "Дахин тохируулах",
    "mobile_field_stopwatch_stop_stopwatches": "Секундомерыг зогсоох",
    "mobile_field_document_title": "Баримт бичиг нэмэх",
    "mobile_field_document_message_delete": "Та энэ баримт бичгийг устгахдаа итгэлтэй байна уу?",
    "mobile_field_document_alret_button_view": "Үзэх",
    "mobile_field_document_alert_error": "Энэ баримт бичгийг хавсаргахад алдаа гарав. Дахин оролдоно уу.",
    "mobile_field_document_alert_file_size_error": "Файл нь {{count}} МБ-аас хэтрэхгүй байна.",
    "mobile_field_temperature_greater_range": "{{ temp_value }} °{{ temp_unit }}-ээс их",
    "mobile_field_temperature_greater_or_equal_range": "{{ temp_value }} °{{ temp_unit }}-ээс их эсвэл тэнцүү",
    "mobile_field_temperature_less_range": "{{ temp_value }} °{{ temp_unit }}-ээс бага",
    "mobile_field_temperature_less_or_equal_range": "{{ temp_value }} °{{ temp_unit }}-ээс бага эсвэл тэнцүү",
    "mobile_field_temperature_between_range": "{{ min_temp_value }} °{{ temp_unit }}-ээс их эсвэл тэнцүү мөн {{ max_temp_value }} °{{ temp_unit }}-ээс бага",
    "mobile_field_temperature_inclusive_between_range": "{{ min_temp_value }} °{{ temp_unit }}-с их эсвэл тэнцүү ба {{ max_temp_value }} °{{ temp_unit }}-с бага эсвэл тэнцүү",
    "mobile_field_temperature_operators_separator": " ба ",
    "mobile_field_text_limit_error": "8000 тэмдэгтийн дээд хязгаарт хүрсэн.",
    "mobile_forms_required_questions_complete": "Бүрэн шаардлагатай",
    "mobile_forms_required_remaining": "{{count}} Үлдэх шаардлагатай",
    "mobile_forms_required_questions_back": "Буцах",
    "mobile_forms_required_questions_next": "Дараагийнх",
    "mobile_forms_required_questions_skip": "Алгасах",
    "mobile_forms_leaving_form": "Маягтыг орхиж байна",
    "mobile_message_reordering_confirm": "Та шинэ асуултын эрэмбийг хадгалахыг хүсэж байна уу?",
    "mobile_forms_leaving_reordering": "Дахин эрэмбэлэх асуултуудыг үлдээж байна",
    "mobile_forms_reordering_button_save": "Шинэ асуултын эрэмбийг хадгалах",
    "mobile_forms_reordering_instructions": "Асуулт эсвэл хэсгүүдийн дарааллыг өөрчлөхийн тулд маягтын харагдах талбар руу чирж, буулгана уу",
    "mobile_toolbarnav_title_my_setttings": "Миний тохиргоо",
    "mobile_toolbarnav_title_profile_settings": "Профайлын тохиргоо",
    "mobile_toolbarnav_title_notification": "Мэдэгдлийн тохиргоо",
    "mobile_toolbarnav_title_form_history": "Маягтын түүх",
    "mobile_toolbarnav_title_form_not_available": "Маягт боломжгүй байна",
    "mobile_toolbarnav_title_add_location": "Байршил нэмэх",
    "mobile_toolbarnav_title_add_task_or_project": "Даалгавар эсвэл төсөл нэмэх",
    "mobile_toolbarnav_title_select_location": "Байршлыг сонгох",
    "mobile_toolbarnav_title_select_project": "Төсөл сонгох",
    "mobile_toolbarnav_title_select_tag": "Шошгыг сонгоно уу",
    "mobile_toolbarnav_title_select_user": "Хэрэглэгчийг сонгох",
    "mobile_toolbarnav_title_select_template": "Загвар сонгох",
    "mobile_toolbarnav_title_select_one": "Нэгийг нь сонгох",
    "mobile_toolbarnav_title_select_multiple": "Нэг эсвэл хэдийг сонгох",
    "mobile_toolbarnav_title_select_team": "Баг сонгох",
    "mobile_toolbarnav_title_select_team_or_location": "Баг эсвэл Байршил сонгох",
    "mobile_toolbarnav_title_filter_tasks": "Даалгавруудыг шүүх",
    "mobile_toolbarnav_title_filter_projects": "Төслүүдийг шүүх",
    "mobile_toolbarnav_title_filter_project_tasks": "Төслийн даалгавруудыг шүүх",
    "mobile_placeholder_search_bar": "Хайх",
    "mobile_placeholder_user_select_role": "Хэрэглэгчийн үүргийг сонгоно уу",
    "mobile_placeholder_filter_by_team": "Багаар нь шүүх",
    "mobile_placeholder_assign_to_user_role": "Хэрэглэгчийн үүрэг рүү оноох",
    "mobile_placeholder_select": "-- Сонгох--",
    "mobile_placeholder_account_location_name": "Байршлын нэр",
    "mobile_placeholder_tag_filter_by": "Байршлын шошгоор шүүх",
    "mobile_placeholder_user_type": "Хэрэглэгчид оноох",
    "mobile_placeholder_acount_type_loading": "Ачаалж байна... ",
    "mobile_placeholder_therm_no_bluetooth": "Температур",
    "mobile_placeholder_blue_therm_connecting": "Төхөөрөмжтэй холбогдож байна...",
    "mobile_placeholder_blue_therm_please_wait": "Түр хүлээнэ үү...",
    "mobile_placeholder_blue_therm_tap": "Уншихын тулд товшино уу.",
    "mobile_placeholder_blue_therm_not_connected": "Холбогдоогүй.",
    "mobile_placeholder_testo_tap": "⬆ дагалдсан ▼▲ барина уу",
    "mobile_message_error_create_task": "Даалгавар нэмэхийн тулд та онлайн байх ёстой.",
    "mobile_message_error_fill_out_form": "Маягтыг бөглөнө үү.",
    "mobile_message_error_fill_require_fields": "Шаардлагатай талбаруудыг бөглөнө үү.",
    "mobile_message_error_stop_stopwatch_before_submit": "Илгээхээсээ өмнө секундомероо зогсоо",
    "mobile_message_error_stopwatch_field_required": "Секундомерын талбар шаардлагатай",
    "mobile_message_error_stopwatch_field_running": "Секундомерын талбар ажиллаж байна",
    "mobile_message_error_invalid_equipment_temperature": "Тоног төхөөрөмжийн температур буруу байна",
    "mobile_message_error_invalid_ingredient_temperature": "Буруу найрлагын температур",
    "mobile_message_error_location_attributes_unavailable": "Зарим асуултууд байхгүй байж болно, интернетэд холбогдоно уу",
    "mobile_message_alert_running_stopwatches": "Танд секундомер ажиллуулж байна.\n\nТа тэдгээрийг арилгахыг хүсэж байна уу?",
    "mobile_message_blue_therm_error": "Блютүүт төхөөрөмжийн холболт тасарсан",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Байршлын мэдээлэлд хандах эрх шаардлагатай. Android тохиргоондоо үүнийг идэвхжүүлнэ үү.",
    "mobile_message_blue_therm_no_permission_android": "Ойролцоох төхөөрөмжүүдэд хандах эрх шаардлагатай. Android тохиргоондоо үүнийг идэвхжүүлнэ үү.",
    "mobile_message_blue_therm_error_code": "Холбогдож чадсангүй:",
    "mobile_message_blue_therm_error_bluetooth": "Блютүүтийг идэвхжүүлнэ үү.",
    "mobile_message_blue_therm_error_device": "Төхөөрөмж олдсонгүй.",
    "mobile_message_blue_therm_error_try_again": "Дахин оролдоно уу",
    "mobile_message_blue_therm_success": "Блютүүт төхөөрөмж холбогдсон!",
    "mobile_message_bluetooth_device_press_button_field": "Холбогдохын тулд төхөөрөмж дээрх товчлуурыг дарна уу.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Өөрийн төхөөрөмж дээрх товчлуурыг дарна уу<br />Хэрэв та үүнийг энд жагсаалтад хараагүй бол.",
    "mobile_bluetooth_scan": "Скан хийх",
    "mobile_bluetooth_scanning": "Скан хийж байна",
    "mobile_message_drafts_confirm": "Та үүнийг ноорог болгон хадгалмаар байна уу?",
    "mobile_message_drafts_toast_saved": "Ноорог хадгалагдсан",
    "mobile_message_drafts_request_update": "Та энэ нооргийг шинэчлэхийг хүсэж байна уу?",
    "mobile_message_drafts_form_confirm": "Та энэ нооргийг устгахдаа итгэлтэй байна уу?",
    "mobile_message_drafts_confirm_delete": "Ноорог устгах",
    "mobile_message_streams_error_switch": "Вэб дээрх дамжуулалтыг өөрчлөх боломжгүй",
    "mobile_message_settings_success_saved": "Тохиргоог хадгалсан",
    "mobile_message_settings_error": "Үл мэдэгдэх алдаа гарлаа. Дараа дахин оролдоорой",
    "mobile_message_profile_settings_error_fields": "Тодруулсан талбаруудыг засна уу.",
    "mobile_message_media_perimission_denied": "Таны ",
    "mobile_message_media_perimission_denied_device": "Төхөөрөмжийн хадгалах сан",
    "mobile_message_image_confirm_remove_image": "Та энэ зургийг устгахдаа итгэлтэй байна уу?",
    "mobile_message_create_account_error_fields": "Тодруулсан талбаруудыг бөглөнө үү.",
    "mobile_message_create_account_success_location_created": "Байршил үүсгэсэн",
    "mobile_message_task_error_get_location": "Байршлыг авч чадсангүй. Огноогоор захиалж байна.",
    "mobile_message_typehead_confirm_save_message": "Та эдгээр сонголтыг хадгалахыг хүсэж байна уу?",
    "mobile_message_typehead_confirm_save_title": "Хадгалах уу?",
    "mobile_message_task_creator_error_save_select_form": "Та маягт сонгох ёстой.",
    "mobile_message_task_creator_error_save_required_fields": "Шаардлагатай талбаруудыг бөглөнө үү.",
    "mobile_message_task_creator_error_save_batch_change": "Нэг эсвэл хэд хэдэн хэрэглэгчид тохирохоор шалгуурыг өөрчилнө үү",
    "mobile_message_task_detials_error_not_assigned_to_you": "Энэ даалгавар танд оноогдоогүй байна.<br />Та үүнийг гүйцээж чадахгүй.",
    "mobile_message_task_detials_error_assigned_to": "Энэ даалгаврыг {{user}}-д оноосон.<br />Та үүнийг гүйцээж чадахгүй.",
    "mobile_message_task_detials_confirm_title": "Даалгаврыг орхиж байна",
    "mobile_message_task_detials_confirm_save_task": "Даалгаврыг хадгалах",
    "mobile_message_task_detials_confirm_message": "Та итгэлтэй байна уу? Таны өөрчлөлтүүд устах болно.",
    "mobile_message_task_detials_error_view_account": "Байршилд хандах боломжгүй байна.",
    "mobile_message_task_detials_error_submit_task": "Энэ даалгаврыг биелүүлэхийн тулд зураг нэмнэ үү.",
    "mobile_message_task_detials_error_submit_task_project": "Төслийг хадгалах боломжгүй байна. Дараа дахин оролдож үзнэ үү.",
    "mobile_message_task_detials_wait_submit_task_created": "Даалгавруудыг хийж байна.<br />Даалгавруудыг дүүргэх хүртэл хэдэн минут хүлээнэ үү.",
    "mobile_message_task_detials_error_submit_task_pending": "Алдаа, дараа дахин оролдоно уу",
    "mobile_message_task_detials_success_task_complete": "Даалгавар дууссан",
    "mobile_message_task_error_save_single_task": "Даалгаврыг хадгалах боломжгүй байна. Дараа дахин оролдож үзнэ үү.",
    "mobile_message_task_success_save_single_task": "Даалгаврыг үүсгэсэн.",
    "mobile_message_show_error_message": "Ямар нэгэн зүйл буруугаар эргэсэн.",
    "mobile_message_show_success_message": "Амжилттай!",
    "mobile_message_show_offline_message": "Та одоогоор оффлайн байна.",
    "mobile_message_show_permission_denied_message": "<b>Зөвшөөрөл шаардлагатай.</b> {{permission_name}}-д хандах эрхийг Zenput-д өгнө үү.",
    "mobile_message_show_permission_denied_message_web": "<b>Зөвшөөрөл шаардлагатай.</b> Zenput болон Хөтөчдөө {{permission_name}}-д хандах зөвшөөрөл өгнө үү.",
    "mobile_message_show_begin_uploading_message": "Одоо байршуулж байна",
    "mobile_message_show_upload_in_progress_message": "Байршуулалт аль хэдийн явагдаж байна",
    "mobile_message_show_form_id_error": "Заасан маягт руу нэвтрэх боломжгүй байна.",
    "mobile_message_show_single_task_error": "Заасан даалгаварт хандах боломжгүй байна.",
    "mobile_message_show_submissions_error": "Заасан мэдүүлгүүдэд хандах боломжгүй байна.",
    "mobile_message_show_submissions_access_denied": "Уучлаарай, танд энэ маягтад нэвтрэх эрх байхгүй байна.",
    "mobile_message_send_data_success": "Өгөгдөл байршуулсан ",
    "mobile_message_start_upload_success": "Байршуулалт дууссан",
    "mobile_message_start_upload_error": "<b>Байршуулалтыг дуусгаж чадсангүй.</b><br>Мэдүүлгүүдийг хадгалсан. Дараа дахин оролдож үзнэ үү",
    "mobile_message_store_upgrade_store_ios": "Апп дэлгүүр",
    "mobile_message_store_upgrade_store_android": "Тоглоомын дэлгүүр",
    "mobile_message_store_upgrade_confirm_title": "Шинэчлэх боломжтой",
    "mobile_message_store_upgrade_confirm_message_one": "Үйлдлийн гүйцэтгэлийн аппликейшнийг ...-аас шинэчлээрэй ",
    "mobile_message_store_upgrade_confirm_message_one_old": "-аас Zenput-г шинэчилнэ үү ",
    "mobile_message_store_upgrade_confirm_message_two": " хамгийн сүүлийн үеийн бүх функцууд болон алдааны засваруудыг авах",
    "mobile_message_store_upgrade_confirm_now": "Одоо",
    "mobile_message_store_upgrade_confirm_later": "Дараа нь",
    "mobile_message_redirect_confirm_message": "Та одоо маягт бөглөж байна. Үргэлжлүүлэхээсээ өмнө ноорог болгон хадгалмаар байна уу?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Танд хараахан байршуулагдаагүй {{count}} ноорог байна. Хэрэв та үргэлжлүүлбэл эдгээр нь алдагдах болно. Та итгэлтэй байна уу?",
    "mobile_message_draft_override_message": "Энэ нооргийг {{date}}-нд өөр төхөөрөмжөөс хадгалсан, мөн энэ төхөөрөмж дээрх өөрчлөлтүүд зөрчилдөж байна. Та одоо байгаа хувилбарыг хүчингүй болгох эсвэл хамгийн сүүлийн хувилбар руу дахин ачаалахаар сонгож болох бөгөөд ингэснээр таны өөрчлөлтүүд устгагдах болно.",
    "mobile_html_submitting": "Оруулж байна...",
    "mobile_html_offline": "Та одоогоор оффлайн байна!",
    "mobile_html_offline_try_again": "Та одоогоор оффлайн байна. <br/><br/>Холбогдсоны дараа дахин оролдоно уу",
    "mobile_html_something_went_wrong": "Өө өө. Ямар нэгэн зүйл буруугаар эргэсэн байна.",
    "mobile_html_something_went_wrong_try_again": "Өө өө. Ямар нэгэн зүйл буруугаар эргэсэн байна. Дахин оролдоно уу.",
    "mobile_html_failed_loading_roles": "Үүргийг ачаалж чадсангүй.",
    "mobile_alert_please_install_for_native": "Энэ боломжийг ашиглахын тулд Ops Execution аппликейшнийг суулгана уу. ",
    "mobile_alert_please_install_for_native_old": "Энэ онцлогийг ашиглахын тулд төрөлх Zenput програмыг суулгана уу.",
    "mobile_tso_filter_all_tasks": "Бүгд {{type}}",
    "mobile_tso_filter_my_tasks": "Миний {{type}}",
    "mobile_tso_filter_due_date": "Дуусах огноо",
    "mobile_tso_filter_date_completed": "Дууссан огноо",
    "mobile_tso_filter_completed": "Дууссан",
    "mobile_tso_filter_completed_late": "Оройтож дууссан",
    "mobile_tso_filter_incomplete": "Дутуу",
    "mobile_tso_filter_var_my_tasks": "Миний {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} Миний бүтээсэн",
    "mobile_tso_filter_var_all_tasks": "Бүгд {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Дараагийн үйлдлүүд",
    "mobile_tso_type_all": "Даалгавар ба дараагийн үйлдлүүд",
    "mobile_tso_filter_var_at": " {{location}}-д",
    "mobile_tso_filter_group_date_due": ", Дуусах огноогоор захиалсан",
    "mobile_tso_filter_group_distance": ", Байршлаар нь бүлэглэсэн",
    "mobile_tso_filter_start_date": "Эхлэх өдөр",
    "mobile_tso_filter_none": "Аль нь ч биш",
    "mobile_pso_filter_all_projects": "Бүх төслүүд",
    "mobile_pso_filter_my_projects": "Миний төслүүд",
    "mobile_pso_filter_active": "Идэвхтэй",
    "mobile_pso_filter_archived": "Архивлагдсан",
    "mobile_pso_filter_recurring": "Давтагдаж байна",
    "mobile_pso_filter_non_recurring": "Давтагддаг бус",
    "mobile_pso_filter_var_my_projects": "Миний {{project_type}} {{active_description}} Төслүүд",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} Миний бүтээсэн төслүүд",
    "mobile_pso_filter_var_all_projects": "Бүх {{project_type}} {{active_description}} Төслүүд",
    "mobile_empty_list_message_must_be_online": "Та оффлайн байгаа бололтой. Аливаа үр дүнг үзэхийн тулд онлайнд холбогдоорой.",
    "mobile_empty_list_message_no_submissions": "Мэдүүлэг байхгүй",
    "mobile_empty_list_message_no_activity": "Үйл ажиллагаа байхгүй",
    "mobile_empty_list_message_no_tasks": "Даалгавар байхгүй",
    "mobile_empty_list_message_no_tasks_overdue": "Хугацаа хэтэрсэн {{type}} байхгүй",
    "mobile_empty_list_message_no_accounts": "Байршил байхгүй",
    "mobile_empty_list_message_no_projects": "Төсөл байхгүй",
    "mobile_empty_list_message_no_results_found": "Үр дүн олдсонгүй",
    "mobile_empty_list_message_no_forms_available": "Маягт байхгүй байна",
    "mobile_empty_list_message_connection_error": "Холболтын алдаа<br />Дахин оролдоно уу.",
    "mobile_empty_list_message_dashboard_error": "Хяналтын самбарыг ачаалах боломжгүй байна",
    "mobile_empty_list_message_user_offline": "Та одоогоор оффлайн байна",
    "mobile_action_sheet_media_gallery": "Галерей",
    "mobile_action_sheet_cancel": "Цуцлах",
    "mobile_image_preview_text": "Зургийг устгах",
    "mobile_mobileform_text": "Өмнөх мэдүүлгүүд",
    "mobile_mobileform_reorder_fields": "Асуултуудыг дахин эрэмбэлэх",
    "mobile_mobileform_follow_up_actions": "Дараагийн үйлдлүүд",
    "mobile_mobileform_follow_up_actions_assign_title": "Дараагийн үйлдлүүдийг оноох",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Асуудлыг шийдвэрлэсэн эсэхийг баталгаажуулахын тулд ажиглалт дээрээ үндэслэн дараагийн алхмуудыг нэмж оруулна уу.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Дараагийн үйлдлүүд нэмэх",
    "mobile_mobileform_follow_up_actions_assign_button": "Дараагийнхыг оноох",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Оноолгүй үргэлжлүүлэх",
    "mobile_mobileform_follow_up_actions_dialog_title": "Дараагийн үйлдлүүдийг оноолгүй үргэлжлүүлэх үү?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Хэрэв та ямар нэгэн дараагийн үйлдлийг оноохгүйгээр үргэлжлүүлбэл дараа нь тэдгээрийг нэмэх боломжгүй болно.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Ямар ч байсан үргэлжлүүлэх",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Энэ талбар шаардлагатай",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Хэт олон тэмдэгт байна",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Энэ талбар хүчингүй",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Байршил ачаалах алдаа",
    "mobile_mobileform_add_follow_up_actions_error_users": "Хэрэглэгч ачаалах алдаа",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Дараахыг нэмэх",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Гарчиг",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Тайлбар",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Зураг шаардах",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Дуусах хугацаа",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Дараахыг шинэчлэх",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Дараахыг устгах уу?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Үүнийг хасах ба оноохгүй.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Дараахыг устгах",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Та энэ дагалтыг устгахдаа итгэлтэй байна уу?\n\nҮүнийг буцаах боломжгүй.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Дараахыг үргэлжлүүлэх",
    "mobile_mobileform_follow_up_actions_completed_notification": "Дараах үйлдлүүдийг дуусгасан",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Дараах үйлдлүүдийг устгасан",
    "mobile_mobileform_follow_up_actions_update_notification": "Дараах үйлдлүүдийг шинэчилсэн",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Энэ дараах үйлдлийг гүйцээхийн тулд зураг нэмнэ үү",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Илгээх хэсэг рүү очих",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Эх сурвалж руу шилжих",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Эх сурвалж",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Дараахыг дуусгах",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Хэрэв та илгээснийг нээвэл хадгалаагүй зураг болон тэмдэглэл алдагдах болно.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Хэрэв та энэ дэлгэцийг орхивол хадгалагдаагүй зураг, тэмдэглэлүүд устана.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Энд үлдэх",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Илгээснийг нээх",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Нээлттэй эх сурвалж",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Энэ дараагийн үйлдлийг орхих уу?",
    "mobile_mobileform_follow_up_actions_submission": "Илгээсэн зүйлс",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Энэ даалгаврыг {{user}}-д оноосон.<br />Та үүнийг дуусгаж чадахгүй.",
    "mobile_mobileform_follow_up_actions_leave_description": "Хэрэв та энэ дэлгэцийг орхивол хадгалагдаагүй өөрчлөлтүүд устана.",
    "mobile_mobileform_follow_up_actions_leave": "Явах",
    "mobile_forms_drafts_text": "Нооргийг устгах",
    "mobile_batch_estimate_user": "Хэрэглэгч",
    "mobile_batch_estimate_users": "Хэрэглэгчид",
    "mobile_table_of_contents": "Агуулга",
    "mobile_table_of_contents_required": "Шаардлагатай",
    "mobile_table_of_contents_optional": "Нэмэлт",
    "mobile_dialog_alert_title": "Анхааруулга",
    "mobile_dialog_alert_ok": "Болно",
    "mobile_windows_10_bluetherm_not_supported": "Windows дээр Bluetooth төхөөрөмжийг хараахан дэмжээгүй байна",
    "mobile_windows_deprecated_message_content_announcement": "Мэдээлэл",
    "mobile_windows_deprecated_message_title": "Аппликейшний шинэчлэлт шаардлагатай",
    "mobile_windows_deprecated_message_description": "Zenput -н хэрэглээг сайжруулж, үндсэн үйл ажиллагааг нь шинэчлэхийн тулд Microsoft Store руу орж Zenput App -н шинэ хувилбарыг нэн дариу суулгана уу.",
    "mobile_dashboard_tcr_graph_name": "Даалгаврын гүйцэтгэлийн түвшин",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Өнгөрсөн 4 долоо хоног",
    "mobile_dashboard_tcr_legend_company_average": "Компанийн дундаж",
    "mobile_dashboard_tcr_legend_team_average": "Багийн дундаж",
    "mobile_dashboard_tab_title_summary": "Хураангуй",
    "mobile_dashboard_tab_title_activity": "Үйл ажиллагаа",
    "mobile_dashboard_card_title_top_triggered_workflows": "Шилдэг идэвхжүүлэлтүүд",
    "mobile_dashboard_tab_title_info": "Мэдээлэл",
    "mobile_dashboard_tab_project_audit": "Нийцэл",
    "mobile_dashboard_card_task_stats_total": "Нийт",
    "mobile_dashboard_top_item_header_week_of": "Долоо хоног",
    "mobile_dashboard_card_filter_form_template_placeholder": "Бүх маягтууд",
    "mobile_dashboard_card_title_forms_top_nos": "«Үгүй» гэсэн давтамжтай",
    "mobile_dashboard_zenput_code_no_data_in_range": "Энэ хугацааны хязгаарт мэдээлэл алга байна.",
    "mobile_dashboard_zenput_code_permission_denied": "Танд үүнийг үзэх зөвшөөрөл байхгүй байна.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Дээрээс маягт сонгоно уу.",
    "mobile_dashboard_zenput_code_unknown_error": "Бид одоогоор өгөгдлийг харуулах боломжгүй байна.",
    "mobile_dashboard_tap_to_retry": "Дахин оролдохын тулд товшино уу",
    "mobile_dashboard_reporting_delay_disclaimer": "Даалгавруудыг шинэчлэхэд 15 хүртэл минут шаардагдаж магадгүй юм",
    "mobile_dashboard_configuration_down_state_postfix_msg": "таны администратор тохируулсан байна.",
    "mobile_tasks_tag": "даалгаврууд",
    "mobile_workflows_tag": "идэвхжүүлэлтүүд",
    "mobile_projects_tag": "давтагдах төслүүд",
    "mobile_forms_tag": "маягтууд",
    "mobile_dashboard_card_ongoing_projects_title": "Ажиллаж буй төслүүд",
    "mobile_dashboard_card_ongoing_projects_show_more": "Дэлгэрэнгүй харуулах",
    "mobile_dashboard_card_ongoing_projects_show_less": "Бага харуулах",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Төслүүд рүү очих",
    "mobile_dashboard_card_title_recurring_projects": "Давтагдах төслүүд",
    "mobile_dashboard_card_filter_daily": "Өдөр бүр",
    "mobile_dashboard_card_filter_weekly": "Долоо хоног бүр",
    "mobile_dashboard_card_filter_monthly": "Сар бүр",
    "mobile_task_status_title_open": "Нээх",
    "mobile_task_status_title_upcoming": "Удахгүй болох",
    "mobile_task_status_title_complete": "Дууссан",
    "mobile_task_status_title_processing": "Мэдүүлэх үйл явц",
    "mobile_task_status_title_complete_with_exceptions": "Дараагийн даалгавар эсвэл анхааруулгуудтай гүйцээгээрэй",
    "mobile_task_status_title_completed_late_with_exceptions": "Дагаж мөрдөх даалгавар эсвэл сэрэмжлүүлэгтэй хоцорч дууссан",
    "mobile_task_status_title_incomplete_and_closed": "Орхигдсон",
    "mobile_tasks_legend_modal_title": "Домог",
    "mobile_tasks_legend_modal_footer_button_title": "Хаах",
    "mobile_common_assigned_to": "Оноосон",
    "mobile_common_created_by": "Бүтээсэн",
    "mobile_common_tasks_for": "Зориулсан даалгаврууд",
    "mobile_common_go_back": "Буцах",
    "mobile_oh_no": "Өө үгүй ээ!",
    "mobile_user_not_in_groups": "Уучлаарай, таныг багт томилоогүй юм шиг байна. Хяналтын самбартаа нэвтрэхийн тулд администратортойгоо холбоо бариарай.",
    "mobile_tasks_select_followers": "Дагагчдаа сонгоно уу",
    "mobile_tasks_assign_tasks": "Даалгаврууд {{count}} Оноох",
    "mobile_tasks_add_followers": "Дагагчдыг нэмэх",
    "mobile_tasks_followers": "Дагагчид",
    "mobile_tasks_delete_task": "Даалгаврыг устгах",
    "mobile_tasks_create_task": "Даалгавар үүсгэх",
    "mobile_tasks_tab_title_comments": "Сэтгэгдлүүд",
    "mobile_tasks_see_more": "Дэлгэрэнгүйг үзэх",
    "mobile_projects_create_project": "Төсөл үүсгэх",
    "mobile_common_button_send": "Илгээх",
    "mobile_common_button_schedule": "Хуваарь",
    "mobile_announcements_create": "Зарлал үүсгэх",
    "mobile_announcements_read_rate": "{{recipients_count}}-н {{opened_count}} нь нээгдэв",
    "mobile_announcements_empty_message": "Та одоогоор ямар ч зарлал хийгээгүй байна! Байгууллагынхаа чухал мэдээ, мэдээлэл, шинэчлэлтийг цацахын тулд доорхи зарыг үүсгээрэй.",
    "mobile_announcement_message_placeholder": "Зурвас нэмэх...",
    "mobile_announcement_title_placeholder": "Зарлалын гарчиг",
    "mobile_announcement_leaving_announcement": "Зарлалаас гарах",
    "mobile_announcement_confirm_recipients_team": "Та энэ зарыг {{teams}} сонгогдсон баг(ууд)-ын {{count}} хэрэглэгч(дэд) дамжуулахыг хүсэж байна уу?",
    "mobile_announcement_confirm_recipients_role": "Та энэ зарыг {{roles}} сонгогдсон үүрэг(үүд)-ийн {{count}} хэрэглэгч(дэд) дамжуулахыг хүсэж байна уу?",
    "mobile_announcement_confirm_recipients_user": "Та энэ зарыг {{count}} хэрэглэгч(дэд) дамжуулахыг хүсэж байна уу?",
    "mobile_announcement_confirm_scheduled": "{{timestamp}} дээр",
    "mobile_announcement_sending_announcement": "Зарлал илгээх",
    "mobile_announcement_send_to": "Илгээх",
    "mobile_announcement_sent_to": "руу илгээсэн",
    "mobile_announcement_send_to_role": "Үүрэг",
    "mobile_announcement_attachment_download": "{{filename}} Татаж байна",
    "mobile_announcement_attachment_validation_error": "{{maxCount}}-с илүү хавсралт нэмж болохгүй",
    "mobile_announcement_details_sent": "Илгээсэн",
    "mobile_announcement_details_total_recipients": "Нийт хүлээн авагч",
    "mobile_announcement_details_cancel": "Зарлал цуцлах",
    "mobile_announcement_details_not_editable": "Зар мэдэгдлийг зөвхөн Ops Execution вэб аппликейшнд засварлаж болно. ",
    "mobile_announcement_details_not_editable_old": "Зарлалыг зөвхөн Zenput вэб дээр засах боломжтой",
    "mobile_announcement_details_open_count": "Тооллоого нээх",
    "mobile_announcement_details_open_rate": "Үнэлгээ нээх",
    "mobile_announcement_details_resend": "Нээгдээгүй хүмүүст дахин илгээнэ үү",
    "mobile_announcement_confirm_resend": "{{count}} хэрэглэгчид зараа уншаагүй байна. Та сануулагч илгээхийг хүсэж байна уу?",
    "mobile_announcement_confirm_resend_title": "Сануулагч илгээх үү?",
    "mobile_announcement_recipients_opened": "Нээгдсэн",
    "mobile_recipients_opened_empty_message": "Таны зурвасыг одоогоор хэн ч нээгээгүй бололтой. Үр дүнгээ харахын тулд дараа эргэж ирээрэй.",
    "mobile_announcement_recipients_unopened": "Нээгдээгүй",
    "mobile_recipients_unopened_empty_message": "Сайн мэдээ! Нээгдээгүй мессеж байхгүй байна!",
    "mobile_scheduled_announcements_delivery_section_header": "Хүргэгдэх хугацаа",
    "mobile_scheduled_announcements_send_immediately_label": "Яаралтай илгээх",
    "mobile_scheduled_announcements_scheduled_label": "Тодорхой цагт илгээнэ үү",
    "mobile_scheduled_announcements_scheduled_tab_label": "Хуваарьтай",
    "mobile_scheduled_announcements_dialog_header": "Зарлал цуцлах уу?",
    "mobile_scheduled_announcements_dialog_message": "Таны зарыг цуцалснаар илгээгдэхээ больж, жагсаалтаас тань устгах болно. Үүнийг буцаах боломжгүй. Засахын тулд Zenput Вэб рүү очно уу.",
    "mobile_scheduled_announcements_empty_message": "Танд одоогоор төлөвлөсөн зар байхгүй байна. Байгууллагадаа чухал мэдээ, мэдээлэл, шинэчлэлтүүдийг цацахын тулд зарлалын хуваарь гаргаарай.",
    "mobile_scheduled_announcements_validation_error": "Хүргэлтийн хугацаа {{date}}-ээс хойш байх ёстой",
    "mobile_scheduled_announcements_empty_state_button": "Зарлалын хуваарь",
    "mobile_projects_auto_archive": "Авто архив",
    "mobile_common_unassigned": "Оноогоогүй",
    "mobile_tasks_title_placeholder": "Шинэ даалгаврууд эсвэл маягт",
    "mobile_projects_leaving_project": "Төслөөс гарах",
    "mobile_projects_save_project": "Төслийг хадгалах",
    "mobile_top_triggers_tasks": "Шилдэг идэвхжүүлэлттэй даалгаврууд",
    "mobile_top_triggers_alerts": "Шилдэг идэвхжүүлэлттэй анхааруулга",
    "mobile_projects_not_started": "Эхлээгүй",
    "mobile_empty_list_message_no_photos": "Зураг алга",
    "mobile_webfilestore_message_error": "Зөв файлын төрлийг сонгоно уу",
    "mobile_notifications_empty_title": "Мэдэгдэл алга",
    "mobile_notifications_empty_message": "Таны даалгавар эсвэл тантай холбоотой таны оролцоотой үйл ажиллагаа энд харагдах болно.",
    "mobile_comments_comment_deleted": "Энэ сэтгэгдлийг устгасан.",
    "mobile_comments_comment_placeholder": "Сэтгэгдэл",
    "mobile_comments_task_submitted_at": "Даалгаврыг {{ date }}-ний {{ time }} цагт ирүүлсэн",
    "mobile_comments_discard_comment_title": "Сэтгэгдлээс татгалзах уу?",
    "mobile_comments_discard_confirm_message": "Та итгэлтэй байна уу? Таны сэтгэгдэл устах болно.",
    "mobile_comments_delete_comment_title": "Сэтгэгдлийг устгах уу?",
    "mobile_comments_delete_confirm_message": "Үүнийг буцаах боломжгүй.",
    "mobile_comments_delete_button": "Сэтгэгдлийг устгах",
    "mobile_comments_delete_success_message": "Сэтгэгдлийг устгасан",
    "mobile_comments_empty_message_tasks": "Одоогоор сэтгэгдэл алга байна \n Энэ даалгаврын талаар яриа эхлүүлээрэй.",
    "mobile_comments_empty_message_submissions": "Одоогоор сэтгэгдэл алга байна \n Энэ мэдүүлгийн талаар яриа эхлүүлээрэй.",
    "mobile_comments_empty_message_default": "Одоогоор сэтгэгдэл алга байна \n Яриа эхлүүлээрэй.",
    "mobile_comments_no_matching_users": "Таарах хэрэглэгч алга.",
    "mobile_comments_empty_users_to_notify": "Мэдэгдэх хэрэглэгч байхгүй байна.",
    "mobile_comments_users_cant_view_message": "Эдгээр хэрэглэгчид дараах сэтгэгдлийг үзэх боломжгүй",
    "mobile_comments_users_to_notify_title": "Мэдэгдэх хэрэглэгчид",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} хэрэглэгчидэд</a> мэдэгдэх болно.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} хэрэглэгчидэд</a> мэдэгдэх болно.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@дурдаж</a> илүү олон хэрэглэгчдэд мэдэгдээрэй.",
    "mobile_comments_mark_read": "Бүгдийг уншсан гэж тэмдэглэх",
    "mobile_comments_author_mentioned_message": "таныг дурдсан",
    "mobile_comments_author_commented_message": "сэтгэгдэл хийсэн",
    "mobile_view_pdf": "PDF үзэх",
    "mobile_no_pdf_generated_message": "Энэхүү мэдүүлэгт PDF олдсонгүй. Хуулбарыг удахгүй танд имэйлээр илгээх болно.",
    "mobile_clipboard_copied_success": "Холбоосыг таны санах ойд хуулсан болно.",
    "mobile_share_link": "Холбоосыг хуваалцах",
    "mobile_zencam_share": "Хуваалцах",
    "mobile_zencam_view_details": "Дэлгэрэнгүйг харах",
    "mobile_zencam_details_drawer_header": "Дэлгэрэнгүй",
    "mobile_zencam_submitted_by": "Илгээсэн",
    "mobile_zencam_form_title": "Маягтын нэр",
    "mobile_zencam_date_submitted": "Илгээсэн огноо",
    "mobile_oil_quality_warning_message": "எண்ணெய் காலாவதியாகும் நிலையில் உள்ளது",
    "mobile_oil_quality_warning_message_subtitle": "விரைவில் அதை மாற்ற திட்டமிடுங்கள்",
    "mobile_oil_quality_failure_message": "எண்ணைய் தரம் சமரசம் செய்யப்பட்டுள்ளது",
    "mobile_oil_quality_failure_message_subtitle": "உடனடியாக எண்ணெயை மாற்றவும்",
    "mobile_sensors_set_up_gateway": "Гарцыг тохируулах",
    "mobile_sensors_set_up_gateway_message": "Төхөөрөмжүүдийг тохируулаагүй юм шиг байна. Гарцыг нэмж эхлүүлээрэй.",
    "mobile_sensors_gateway_plugged_in": "Таны гарцыг цахилгаан залгуурт залгасан эсэхийг шалгаарай",
    "mobile_sensors_add_device": "Төхөөрөмж нэмэх",
    "mobile_sensors_name_this_gateway": "Энэ гарцыг нэрлээрэй.",
    "mobile_sensors_name_this_sensor": "Энэ мэдрэгчийг нэрлээрэй.",
    "mobile_sensors_device_barcode_information": "QR кодыг унших эсвэл ID болон SC дугаарыг төхөөрөмжийн шошгоноос оруулах",
    "mobile_sensors_device_eui_information": "QR кодыг унших эсвэл DevEUI-г төхөөрөмжийн шошгоноос оруулах",
    "mobile_sensors_gateway_id_information": "Node ID-г Протоколын шошгоос оруулах",
    "mobile_sensors_id_number": "{{untranslatedID}} Дугаар",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Код",
    "mobile_sensors_sensors": "Мэдрэгчид",
    "mobile_sensors_sensor_deveui_error": "QR-аас DevEUI-г авч чадаагүй. Гараар оруулна уу.",
    "mobile_sensors_gateways": "Гарцууд",
    "mobile_sensors_add_sensor": "Мэдрэгч нэмэх",
    "mobile_sensors_add_gateway": "Гарцууд нэмэх",
    "mobile_sensor_placement_description": "Энэ мэдрэгч ямар талбайг хянах вэ?",
    "mobile_sensors_equipment_placement": "Энэ мэдрэгч ямар талбай эсвэл тоног төхөөрөмжийг хянах вэ?",
    "mobile_sensors_equipment": "Энэ мэдрэгч ямар төхөөрөмжийг хянах вэ?",
    "mobile_sensors_select_gateway_type": "Гаралтын төрлийг сонгоно уу",
    "mobile_sensors_select_placement": "Байрлуулалтыг сонгоорой",
    "mobile_sensors_select_equipment": "Төхөөрөмж сонгох",
    "mobile_sensors_placement": "Байрлуулах",
    "mobile_sensors_nickname_tip": "தேர்ந்தெடுக்கப்பட்ட இடத்தில் ஒதுக்கப்பட்ட புனைப்பெயர்களால் சென்சார் பெயரிடல் தீர்மானிக்கப்படுகிறது.",
    "mobile_sensors_device_online": "Онлайн",
    "mobile_sensors_device_offline": "Оффлайн",
    "mobile_sensors_scan_qrcode": "QR код скандах",
    "mobile_sensors_enter_manually": "Гараар оруулна уу",
    "mobile_sensors_wizard_step_one": "Алхам 1",
    "mobile_sensors_wizard_step_two": "Алхам 2",
    "mobile_sensors_wizard_step_three": "Алхам 3",
    "mobile_sensors_wizard_step_four": "Алхам 4",
    "mobile_sensors_wizard_step_five": "Алхам 5",
    "mobile_sensors_wizard_step_six": "6-р алхам",
    "mobile_sensors_initializing": "Эхлүүлж байна...",
    "mobile_sensors_nickname": "Хоч",
    "mobile_sensors_field_not_blank": "{{field}} хоосон байж болохгүй.",
    "mobile_sensors_nothing_to_see_here": "Энд харах зүйл алга",
    "mobile_sensors_missing_integration": "Мэдрэгчийн интеграци байхгүй байна",
    "mobile_sensors_contact_zenput_admin": "Та компанийнхаа үйл ажиллагааны гүйцэтгэлийн администратортай холбогдоно уу.",
    "mobile_sensors_contact_zenput_admin_old": "Zenput-н админд хандана уу.",
    "mobile_sensors_contact_manager": "Мэдрэгч нэмэхийн тулд бүртгэлийн менежертэйгээ холбоо бариарай.",
    "mobile_sensors_device_success_message": "Мэдрэгчийн өгөгдлийг ачаалахад 15 минут шаардагдаж магадгүй",
    "mobile_sensors_last_reading": "Сүүлийн уншилт",
    "mobile_sensors_remove_device": "Төхөөрөмжийг устгах",
    "mobile_sensors_one_day": "1Ө",
    "mobile_sensors_one_week": "1Д/Х",
    "mobile_sensors_one_month": "1С",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6М",
    "mobile_sensors_one_year": "1Ж",
    "mobile_sensors_sensor_settings": "Мэдрэгчийн тохиргоо",
    "mobile_sensors_remove_confirm_message": "Та энэ төхөөрөмжийг устгахдаа итгэлтэй байна уу?\nҮүнийг буцаах боломжгүй.",
    "mobile_sensors_sensor": "Мэдрэгч",
    "mobile_sensors_no_equipment_linked": "Төхөөрөмж холбогдоогүй байна",
    "mobile_sensor_cooldown_process": "Хөргөх процесс",
    "mobile_sensor_last_12_hours": "Сүүлийн 12 цаг",
    "mobile_sensor_start_cooldown_process": "Шинэ хөргөх процессыг эхлүүлэх",
    "mobile_sensor_cooldown_process_title": "Хоёр үе шаттай хөргөх процесс",
    "mobile_sensor_cooldown_process_description": "இரண்டு-நிலை குளிர்விக்கும் செயல்முறையானது உணவை {{ stage1_start_temperature }} க்கு மேல் இருந்து {{ stage1_end_temperature }} வரை இரண்டு மணிநேரம் அல்லது அதற்கும் குறைவாகவும், பின்னர் {{ stage1_end_temperature }} முதல் {{ stage2_end_temperature }} வரை நான்கு மணிநேரம் அல்லது அதற்கும் குறைவாகவும் குளிர்விக்கும்.",
    "mobile_sensor_cooldown_process_place_food": "Хүнсний бүтээгдэхүүнийг хөргөгчинд байрлуулаарай.",
    "mobile_sensor_cooldown_process_insert_sensor": "Хүнсний бүтээгдэхүүнд мэдрэгчийн датчик оруулна уу.",
    "mobile_sensor_cooldown_process_enter_information": "Доорх мэдээллийг оруулна уу.",
    "mobile_sensor_cooldown_process_food_product": "Хөргөх хүнсний бүтээгдэхүүн",
    "mobile_sensor_cooldown_cool_down": "Хөргөх",
    "mobile_sensor_cooldown_select_sensor": "Мэдрэгчийг сонгоно уу",
    "mobile_sensors_cooldown_start_cooldown": "Хөргөх ажлыг эхлүүлээрэй",
    "mobile_sensors_cooldown_please_enter_food": "Хүнсний бүтээгдэхүүнийг оруулна уу",
    "mobile_sensors_cooldown_please_select_sensor": "Мэдрэгчийг сонгоно уу",
    "mobile_sensors_cooldown_status_in_progress": "Явагдаж байна",
    "mobile_sensors_cooldown_status_failed": "Амжилтгүй боллоо",
    "mobile_sensors_cooldown_status_success": "Амжилттай",
    "mobile_sensors_cooldown_stage": "Үе шат",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Эхлэх температур хязгаараас хэтрэв",
    "mobile_sensors_cooldown_failed_cooldown_process": "Хөргөх процесс амжилтгүй боллоо",
    "mobile_sensors_cooldown_cooldown_successful": "Хөргөлт амжилттай",
    "mobile_sensors_cooldown_started_cooldown_process": "Хөргөх процессыг эхлүүлсэн",
    "mobile_sensors_cooldown_hour": "цаг",
    "mobile_sensors_cooldown_hour_plural": "цагууд",
    "mobile_sensors_cooldown_minute": "минут",
    "mobile_minutes_plural": "минутууд",
    "mobile_sensors_last_reading_max_date": "> 1 жилийн өмнө",
    "mobile_sensors_minute_count_ago": "{{count}} минутын өмнө",
    "mobile_sensors_minute_count_ago_plural": "{{count}} минутын өмнө",
    "mobile_sensors_hour_count_ago": "{{count}} цагийн өмнө",
    "mobile_sensors_hour_count_ago_plural": "{{count}} цагийн өмнө",
    "mobile_sensors_day_count_ago": "{{count}} өдрийн өмнө",
    "mobile_sensors_day_count_ago_plural": "{{count}} өдрийн өмнө",
    "mobile_sensors_chart_settings": "விளக்கப்பட அமைப்புகள்",
    "mobile_announcement_banner_continue_reading": "Цааш унших",
    "mobile_compliance_submissions_report": "Илгээсэн Тайлан",
    "mobile_compliance_submissions_report_subtitle": "Энэ дэлгүүрийн төсөл дуусгасан датаг экспортлох",
    "mobile_compliance_send_submissions": "Оруулсан зүйлсийг илгээх",
    "mobile_compliance_completion_rate_in_last_days": "Сүүлийн {{ days }} хоногт дуусгасан хурд",
    "mobile_compliance_last_days": "Сүүлийн {{ days }} хоног",
    "mobile_compliance_send_submissions_to": "Оруулсан зүйлсийг дараах руу илгээх",
    "mobile_compliance_send_to_different_email": "Өөр э-мэйл рүү илгээх",
    "mobile_compliance_email_input_placeholder": "Э-мэйл хаяг",
    "mobile_compliance_send_submissions_to_legend_title": "Оруулсан зүйлс",
    "mobile_compliance_send_submissions_to_legend_description_days": "Сүүлийн {{ days }} хоногт энэ байрлалаас таны илгээсэн тайланг сонгосон имэйл рүү илгээнэ.",
    "mobile_compliance_time_frame": "Цаг хугацааны хамрах хүрээ",
    "mobile_compliance_sensor_temperature_log_report": "Мэдрэгчийн Температурын Бүртгэлийн Тайлан",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Энэ дэлгүүрийн температурын бүртгэлийг экспортлох",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Шалгуур",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Өөрийн доорх тайланд зориулж шалгуурыг тодорхойлно уу.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Тэмдэглэл: Идэвхгүй болсон мэдрэгчүүдийг уг тайланд харуулахгүй",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Хугацааг сонгоно уу. Бүртгэлийн өгөгдөл нь хамгийн ихдээ 30 өдрөөр хязгаарлагдана",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Тайланг Илгээх",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Энэ сар (1-р-Өнөөдөр)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Өнгөрсөн Сар",
    "mobile_compliance_sensor_temperature_log_email_title": "Тайланг Дараах руу Илгээх",
    "mobile_pwa_update_prompt_title": "Аппликэйшн шинэчлэх",
    "mobile_pwa_update_prompt_description": "Аппликэйшний шинэ хувилбар байна. Хамгийн сүүлийн үеийн хувилбараар шинэчилнэ үү.",
    "mobile_pwa_update_prompt_confirm": "Шинэчлээд дахин ачаалах",
    "mobile_pwa_update_prompt_cancel": "Надад дараа сануулах",
    "notification_title_due_in_one_hour": "1 цагийн дараа ирэх ёстой",
    "task_is_due_soon": "'{{ task_title }}' удахгүй төрөх ёстой. Дуусгахад жаахан хугацаа гарга.",
    "mobile_photo_quality_warning_header": "Зургийн чанарын асуудал",
    "mobile_photo_quality_dialog_message": "Энэ зураг хэт хар эсвэл бүдэг байж магадгүй. Та шинэ зураг авах уу, эсвэл үүгээр үргэлжлүүлэх үү?",
    "mobile_take_new_photo": "Шинэ зураг авах",
    "mobile_use_this_photo": "Энэ зургийг ашиглах"
}};
mobile_translations.fr_CA = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Tous",
    "mobile_common_button_apply_filters": "Appliquer les filtres",
    "mobile_common_button_done": "Terminé",
    "mobile_common_button_edit": "Modifier",
    "mobile_common_button_archive": "Archiver",
    "mobile_common_button_save": "Enregistrer",
    "mobile_common_button_retake": "Reprendre",
    "mobile_common_button_save_draft": "Enregistrer l'ébauche",
    "mobile_common_button_discard": "Supprimer",
    "mobile_common_button_submit": "Soumettre",
    "mobile_common_button_no": "Non",
    "mobile_common_button_yes": "Oui",
    "mobile_common_button_na": "S.O.",
    "mobile_common_created_by_me": "Créé par moi",
    "mobile_common_email": "Adresse courriel de la société",
    "mobile_common_first_name": "Prénom",
    "mobile_common_last_name": "Nom de famille",
    "mobile_common_location": "Lieu",
    "mobile_common_locations": "Lieux",
    "mobile_common_logout_message": "Êtes-vous sûr de vouloir vous déconnecter?",
    "mobile_common_password": "Mot de passe",
    "mobile_common_permission_required": "Autorisation requise",
    "mobile_common_status": "État",
    "mobile_common_task": "Tâche",
    "mobile_common_tasks": "Tâches",
    "mobile_common_tasks_my": "Mes tâches",
    "mobile_common_projects": "Projets",
    "mobile_common_filter_team": "Équipe",
    "mobile_common_filter_var_in": " dans {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Aucune équipe sélectionnée",
    "mobile_common_filter_no_user_selected": "Aucun utilisateur sélectionné",
    "mobile_common_filter_no_role_selected": "Aucun rôle sélectionné",
    "mobile_common_placeholder_date": "Date",
    "mobile_common_message_task_creator_error_save": "<b>Les tâches n'ont pu être créées.</b>",
    "mobile_common_camera": "Caméra",
    "mobile_common_microphone": "Microphone",
    "mobile_common_for": "pour",
    "mobile_common_reload": "Recharger",
    "mobile_common_override": "Outrepasser",
    "mobile_common_notifications": "Notifications",
    "mobile_common_chat_unavailable": "Le clavardage n’est pas disponible. Veuillez réessayer plus tard.",
    "mobile_common_chat_ending_dialog_title": "Avez-vous terminé cette conversation?",
    "mobile_common_chat_ending_dialog_description": "Indiquez-nous si votre problème a été résolu ou si vous souhaitez simplement continuer plus tard.",
    "mobile_common_chat_ending_dialog_confirm": "Oui, j’ai terminé",
    "mobile_common_chat_ending_dialog_cancel": "Je continuerai plus tard",
    "mobile_common_continue_editing": "Poursuivre les modifications",
    "mobile_privacy_policy": "Politique de confidentialité",
    "wootric_recommend_target": "un ami ou un collègue dans votre industrie",
    "wootric_followup_detractor_question": "Quelles modifications pouvons-nous faire pour que vous nous accordiez une meilleure note la prochaine fois?",
    "wootric_followup_passive_question": "Merci! Que pouvons-nous faire pour rendre l'outil encore meilleur?",
    "wootric_followup_promoter_question": "Merci! Qu'aimez-vous de Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Merci! Qu'est-ce que vous aimez de Zenput?",
    "wootric_default_followup_question": "Merci! Pourriez-vous nous dire pourquoi?",
    "wootric_default_placeholder_text": "Aidez-nous en expliquant votre note.",
    "wootric_default_thankyou_text": "Merci pour votre réponse et vos commentaires!",
    "mobile_login_placeholder_login_as": "Me connecter avec l'identifiant d'utilisateur",
    "mobile_login_button_forgot_password": "Mot de passe oublié?",
    "mobile_login_button_sign_up": "Créer un compte",
    "mobile_login_button_finish_setup": "Terminer la configuration",
    "mobile_login_button": "Me connecter",
    "mobile_login_continue_button": "Continuer",
    "mobile_login_continue_transition": "vous êtes redirigé vers la page de connexion de votre organisation...",
    "mobile_login_no_email_error": "Vous devez saisir une adresse courriel.",
    "mobile_login_change_email": "Me connecter avec une adresse courriel différente",
    "mobile_login_with_sso": "Connexion par authentification unique",
    "mobile_oauth_no_user_error_message": "On dirait que vous n'avez pas de compte Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Il semble que vous n'avez pas de compte Zenput!",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> s'appelle désormais <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} devient {{- product }} en septembre. {{- cta }}",
    "mobile_rebrand_warning_cta": "Apprenez comment vous préparer.",
    "mobile_oauth_no_user_error_sub_message": "Contactez votre administrateur pour accéder à un compte ou essayez de vous connecter avec une autre adresse courriel.",
    "mobile_oauth_generic_error_message": "Vous semblez avoir de la difficulté à vous connecter; veuillez réessayer.",
    "mobile_oauth_force_logout_msg": "Si vous avez toujours de la difficulté, déconnectez-vous de votre fournisseur en ",
    "mobile_oauth_force_logout_click": "cliquant ici.",
    "mobile_sign_up_placeholder_phone": "Numéro de téléphone cellulaire",
    "mobile_sign_up_placeholder_password_confirm": "Confirmer le mot de passe",
    "mobile_sign_up_button_sign_in": "Ouvrir une session",
    "mobile_sign_up_disclaimer_part_1": "En cliquant sur Créer un compte, vous acceptez ",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "En cliquant sur Terminer la configuration, vous acceptez la",
    "mobile_sign_up_disclaimer_link_title": " le contrat de licence",
    "mobile_sign_up_disclaimer_part_2": ", qui comprend de l'information importante sur la protection des renseignements personnels",
    "mobile_dialog_benefits_work_offline": "Travailler hors ligne",
    "mobile_dialog_benefits_faster_uploads": "Téléversements plus rapides",
    "mobile_dialog_benefits_better_experience": "Une meilleure expérience",
    "mobile_dialog_benefits_button_download": "Télécharger",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution pour ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput pour ",
    "mobile_dialog_benefits_button_have": "J'ai l'application!",
    "mobile_dialog_benefits_button_no_thanks": "Non merci, peut-être plus tard.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Échec du téléversement de l'image.",
    "mobile_dialog_signature_sign": "Signer ici",
    "mobile_dialog_signature_button_clear": "Effacer",
    "mobile_account_placeholder_name": "Lieu/Nom du magasin",
    "mobile_account_placeholder_phone": "Numéro de téléphone",
    "mobile_account_placeholder_address": "Adresse",
    "mobile_account_placeholder_city": "Ville",
    "mobile_account_placeholder_region": "Région",
    "mobile_account_placeholder_zipcode": "Code postal",
    "mobile_account_option_select_country": "Sélectionner le pays",
    "mobile_account_oprion_us": "États-Unis",
    "mobile_account_oprion_select_state": "Sélectionner l'État",
    "mobile_account_button_create_location": "Créer un lieu",
    "mobile_form_message_no_form": "Aucun formulaire disponible",
    "mobile_batch_task_message": "Chargement en cours...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Numéro de téléphone cellulaire",
    "mobile_settings_profile_language": "Langue",
    "mobile_settings_profile_temperature_unit": "Unité de température",
    "mobile_settings_profile_use_company_default": "Utiliser la valeur par défaut de l’entreprise",
    "mobile_settings_profile_celsius": "Celsius",
    "mobile_settings_profile_fahrenheit": "Fahrenheit",
    "mobile_settings_notifications_option_sms": "Message texte",
    "mobile_settings_notifications_option_push": "Notifications poussées",
    "mobile_settings_notifications_option_push_email": "Courriel et notifications poussées",
    "mobile_settings_notifications_option_do_not": "Ne pas envoyer de notifications",
    "mobile_settings_notifications_category_communication": "Communication",
    "mobile_settings_notifications_category_forms_and_triggers": "Formulaires et déclencheurs",
    "mobile_settings_devices": "Appareils",
    "mobile_settings_notifications_sub_category_alerts": "Alertes",
    "mobile_settings_notifications_sub_category_new_forms_available": "Nouveaux formulaires disponibles",
    "mobile_settings_notifications_sub_category_task_assigned": "Tâche assignée",
    "mobile_settings_notifications_sub_category_task_completed": "Tâche effectuée",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Rappel : tâches bientôt à échéance",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Rappel : tâches en retard",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Alertes du capteur",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alertes critiques du capteur",
    "mobile_drafts_message": "Vous n'avez pas encore d'ébauche.",
    "mobile_drafts_button_delete": "Supprimer",
    "mobile_tasks_filter_location_no": "Aucun lieu sélectionné",
    "mobile_tasks_filter_group_by": "Grouper par",
    "mobile_tasks_filter_sort_by": "Trier par",
    "mobile_tasks_filter_sorted_by": "Trié par",
    "mobile_tasks_filter_due_time": "Heure d’échéance",
    "mobile_tasks_filter_open_time": "Heure d’ouverture",
    "mobile_tasks_bucket_due_next_24_hours": "Échéance d’ici 24 heures",
    "mobile_tasks_bucket_due_next_7_days": "Échéance d’ici 7 jours",
    "mobile_tasks_bucket_open_tasks": "{{type}} ouverts supplémentaires",
    "mobile_tasks_bucket_open_at": "Ouvert : {{- date }} à {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Échéance : {{- date }} à {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Disponible dans 1 minute",
    "mobile_tasks_bucket_available_in_one_hour": "Disponible dans 1 heure",
    "mobile_tasks_bucket_available_in_one_day": "Disponible dans 1 jour",
    "mobile_tasks_bucket_available_in_one_week": "Disponible dans 1 semaine",
    "mobile_tasks_bucket_available_in_one_month": "Disponible dans 1 mois",
    "mobile_tasks_bucket_available_in_one_year": "Disponible dans 1 an",
    "mobile_tasks_bucket_available_in_minutes": "Disponible dans {{ minutes }} minutes",
    "mobile_tasks_bucket_available_in_hours": "Disponible dans {{ hours }} heures",
    "mobile_tasks_bucket_available_in_days": "Disponible dans {{ days }} jours",
    "mobile_tasks_bucket_available_in_weeks": "Disponible dans {{ weeks }} semaines",
    "notification_task_due_in_minutes": "Échéance dans {{ minutes }} minutes",
    "mobile_tasks_bucket_available_in_months": "Disponible dans {{ months }} mois",
    "mobile_tasks_bucket_available_in_years": "Disponible dans {{ years }} ans",
    "mobile_tasks_follow_up": "Tâche de suivi",
    "mobile_tasks_due_soon": "Bientôt à échéance",
    "mobile_tasks_bucket_completed_today": "Achevé aujourd'hui",
    "mobile_tasks_bucket_completed_this_week": "Achevé cette semaine",
    "mobile_tasks_bucket_completed_last_week": "Achevé la semaine dernière",
    "mobile_tasks_bucket_missed_today": "Manqué aujourd'hui",
    "mobile_tasks_bucket_missed_this_week": "Manqué cette semaine",
    "mobile_tasks_bucket_missed_last_week": "Manqué la semaine dernière",
    "mobile_tasks_bucket_no_location": "Aucun lieu",
    "mobile_tasks_cannot_submit_missed": "Les tâches manquées ne peuvent être achevées",
    "mobile_tasks_cannot_submit_missed_after": "Cette tâche ne peut être achevée après le {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Cette tâche n'est pas commencée.",
    "mobile_tasks_cannot_submit_processing": "Le traitement de cette soumission est en cours",
    "mobile_tasks_toolbarnav_header_no_due_date": "Aucune date d'échéance",
    "mobile_tasks_toolbarnav_header_overdue": "En retard",
    "mobile_tasks_toolbarnav_header_yesterday": "Hier",
    "mobile_tasks_toolbarnav_header_today": "Aujourd'hui",
    "mobile_tasks_toolbarnav_header_tomorrow": "Demain",
    "mobile_tasks_toolbarnav_header_last_week": "La semaine dernière",
    "mobile_tasks_toolbarnav_header_this_week": "Cette semaine",
    "mobile_tasks_toolbarnav_header_next_week": "La semaine prochaine",
    "mobile_tasks_toolbarnav_header_this_month": "Ce mois-ci",
    "mobile_tasks_toolbarnav_header_next_year": "L'an prochain",
    "mobile_tasks_toolbarnav_header_over_year": "Plus d'un an",
    "mobile_tasks_toolbarnav_title_edit_task": "Modifier la tâche",
    "mobile_task_placeholder_title": "Titre *",
    "mobile_task_placeholder_description": "Description (facultatif)",
    "mobile_task_button_single_task": "Tâche unique",
    "mobile_task_button_project": "Projet",
    "mobile_task_button_create": "Créer",
    "mobile_task_tab_basic": "Élémentaire",
    "mobile_task_tab_photo": "Photo",
    "mobile_task_tab_form": "Formulaire",
    "mobile_task_details_description_message_please": "Veuillez remplir ",
    "mobile_task_details_description_message_below": "ci-dessous.",
    "mobile_task_details_description_message_instructions": "Aucune consigne n'est disponible pour cette tâche.",
    "mobile_task_details_reason_title": "Suivi déclenché par",
    "mobile_task_detials_button_goto_form": "Aller au formulaire",
    "mobile_task_detials_button_complete": " Achever la tâche",
    "mobile_task_detials_completed": "Achevée ",
    "mobile_task_detials_completed_by": "par ",
    "mobile_task_detials_completed_on": "le ",
    "mobile_task_details_view_form_submission": "Voir la soumission du formulaire",
    "mobile_task_task_updated": "Tâche mise à jour",
    "mobile_task_task_archived": "Tâche archivée",
    "mobile_task_task_deleted": "Tâche supprimée",
    "mobile_task_error_archiving_task": "La tâche n'a pu être archivée.",
    "mobile_task_error_deleting_task": "La tâche n'a pu être supprimée.",
    "mobile_task_error_updating_task": "La tâche n'a pu être mise à jour.",
    "mobile_task_archive_task": "Archiver la tâche",
    "mobile_task_archive_task_confirm": "Êtes-vous sûr de vouloir archiver cette tâche?\n\nLes tâches archivées comptent dans le calcul des taux d'achèvement et continueront d'être incluses dans les rapports.\n\nCeci ne peut être annulé.",
    "mobile_task_delete_task_confirm": "Êtes-vous sûr de vouloir supprimer cette tâche?\n\nLes tâches supprimées ne comptent pas le calcul des taux d'achèvement et ne sont pas incluses dans les rapports.\n\nCeci ne peut être annulé.",
    "mobile_task_edition_already_in_progress": "Cette tâche comporte une modification en attente. Il est interdit de procéder à d'autres modifications pour l'instant.",
    "mobile_projects_filter_type": "Type",
    "mobile_projects_filter_status": "État du projet",
    "mobile_projects_filter_project_type": "Type de projet",
    "mobile_projects_due_date_required": "Date d'échéance obligatoire.",
    "mobile_projects_team_required": "Équipe obligatoire.",
    "mobile_projects_user_role_required": "Personne en affectation obligatoire.",
    "mobile_projects_title_required": "Titre obligatoire.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Plusieurs tâches par jour",
    "mobile_project_tasks_complete": " Achever",
    "mobile_project_tasks_remaining": " Restant",
    "mobile_esitmate_message_tasks": "Aucune tâche ne sera créée",
    "mobile_esitmate_message_criteria": "Modifier le critère ci-dessus",
    "mobile_esitmate_message_created_for": "sera créé pour",
    "mobile_left_menu_dashboard": "Tableau de bord",
    "mobile_left_menu_my_forms": "Mes formulaires",
    "mobile_left_menu_announcements": "Annonces",
    "mobile_left_menu_my_submissions": "Mes soumissions",
    "mobile_left_menu_drafts": "Ébauches",
    "mobile_left_menu_pending_uploads": "Téléversements en attente",
    "mobile_left_menu_open": "Ouvrir dans l'appli",
    "mobile_left_menu_settings": "Paramètres",
    "mobile_left_menu_log_out": "Se déconnecter",
    "mobile_left_menu_debug": "Déboguer",
    "mobile_left_menu_support": "Soutien",
    "mobile_left_menu_documentation": "Documentation",
    "mobile_left_menu_chat": "Clavarder",
    "mobile_field_textarea_placeholder_note": "Note ou légende",
    "mobile_field_option_select": "Sélectionner",
    "mobile_field_text_placeholder_text": "Texte",
    "mobile_field_email_placehoder_email": "L'adresse courriel",
    "mobile_filed_number_placeholder_number": "Numéro",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Non connecté",
    "mobile_field_sensor_offline_battery": "Capteur hors ligne — Batterie",
    "mobile_field_video_button_add": "Ajouter une vidéo",
    "mobile_field_video_picker_dialog_title": "Ajouter une vidéo à partir de",
    "mobile_field_video_button_change": "Changer la vidéo",
    "mobile_field_image_button_add": "Ajouter une image",
    "mobile_field_image_low_quality_warning": "Certaines photos pourraient être trop sombres ou floues. Passez en revue les photos en surbrillance et remplacez-les au besoin.",
    "mobile_field_image_picker_dialog_title": "Ajouter une photo à partir de",
    "mobile_field_image_picker_edit_failed": "L’image n’a pas pu être enregistrée. Veuillez réessayer.",
    "mobile_field_signature_button_add": "Ajouter une signature",
    "mobile_field_signature_button_change": "Changer la signature",
    "mobile_field_account_select_location": "Choisir un lieu",
    "mobile_field_account_prefill": "Voulez-vous pré-remplir le formulaire avec les données de votre dernière visite?",
    "mobile_field_account_message_overwrite": "Le contenu de tous les champs que vous avez déjà remplis sera ainsi remplacé.",
    "mobile_forms_task_on_behalf": "Il y a une tâche à accomplir dans ce lieu qui a été confiée à <b>{{user}}</b>. Désirez-vous achever cette tâche?",
    "mobile_forms_complete_task": "Achever cette tâche?",
    "mobile_field_account_prefill_button_yes": "Oui, pré-remplir.",
    "mobile_field_barcode_placeholder_scan": "Scanner ou saisir le code à barres",
    "mobile_field_sensor_qr_code_placeholder_scan": "Scanner ou saisir le code",
    "mobile_field_gateway_id_code_placeholder": "Saisir un identifiant de nœud",
    "mobile_field_scan_qr_or_enter_dev_eui": "Scanner le code QR ou saisir le code DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Scanner le code QR ou saisir le numéro d’identification",
    "mobile_field_scan_qr_or_enter_sc": "Scanner le code QR ou saisir le code SC",
    "mobile_field_barcode_select_date": "Sélectionner la date ",
    "mobile_field_datetime_allow_time": "Heure",
    "mobile_field_stopwatch_button_caption": "Chronomètre",
    "mobile_field_stopwatch_common_start": "Démarrer",
    "mobile_field_stopwatch_common_stop": "Arrêter",
    "mobile_field_stopwatch_common_reset": "Réinitialiser",
    "mobile_field_stopwatch_stop_stopwatches": "Arrêter les chronomètres",
    "mobile_field_document_title": "Ajouter un document",
    "mobile_field_document_message_delete": "Êtes-vous sûr de vouloir supprimer ce document?",
    "mobile_field_document_alret_button_view": "Visualiser",
    "mobile_field_document_alert_error": "Il y a eu une erreur au moment de joindre ce document. Veuillez réessayer.",
    "mobile_field_document_alert_file_size_error": "Le fichier ne peut dépasser {{count}} Mo.",
    "mobile_field_temperature_greater_range": "plus grand que {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "plus grand que ou égal à {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_range": "plus petit que {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "plus petit que ou égal à {{ temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_between_range": "plus grand que ou égal à {{ min_temp_value }} °{{ temp_unit }} et plus petit que {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "plus grand que ou égal à {{ min_temp_value }} °{{ temp_unit }} et plus petit que ou égal à {{ max_temp_value }} °{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " et ",
    "mobile_field_text_limit_error": "La limite maximale de 8000 caractères a été atteinte.",
    "mobile_forms_required_questions_complete": "Achèvement obligatoire",
    "mobile_forms_required_remaining": "{{count}} restant obligatoire",
    "mobile_forms_required_questions_back": "Retour",
    "mobile_forms_required_questions_next": "Suivant",
    "mobile_forms_required_questions_skip": "Sauter",
    "mobile_forms_leaving_form": "Quitter le formulaire",
    "mobile_message_reordering_confirm": "Voulez-vous enregistrer le nouvel ordre des questions?",
    "mobile_forms_leaving_reordering": "Vous quittez la réorganisation des questions",
    "mobile_forms_reordering_button_save": "Enregistrer le nouvel ordre des questions",
    "mobile_forms_reordering_instructions": "Pour réorganiser des questions ou des sections, faites un glisser-déposer pour déplacer le champ dans le formulaire",
    "mobile_toolbarnav_title_my_setttings": "Mes paramètres",
    "mobile_toolbarnav_title_profile_settings": "Paramètres du profil",
    "mobile_toolbarnav_title_notification": "Paramètres de notification",
    "mobile_toolbarnav_title_form_history": "Historique du formulaire",
    "mobile_toolbarnav_title_form_not_available": "Formulaire non disponible",
    "mobile_toolbarnav_title_add_location": "Ajouter un lieu",
    "mobile_toolbarnav_title_add_task_or_project": "Ajouter une tâche ou un projet",
    "mobile_toolbarnav_title_select_location": "Sélectionner un lieu",
    "mobile_toolbarnav_title_select_project": "Sélectionner le projet",
    "mobile_toolbarnav_title_select_tag": "Sélectionner un mot-clé",
    "mobile_toolbarnav_title_select_user": "Sélectionner un utilisateur",
    "mobile_toolbarnav_title_select_template": "Sélectionner un modèle",
    "mobile_toolbarnav_title_select_one": "Sélectionner un",
    "mobile_toolbarnav_title_select_multiple": "Sélectionner un ou plus",
    "mobile_toolbarnav_title_select_team": "Sélectionner une équipe",
    "mobile_toolbarnav_title_select_team_or_location": "Sélectionner une équipe ou un lieu",
    "mobile_toolbarnav_title_filter_tasks": "Filtrer les tâches",
    "mobile_toolbarnav_title_filter_projects": "Filtrer les projets",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtrer les tâches de projet",
    "mobile_placeholder_search_bar": "Rechercher",
    "mobile_placeholder_user_select_role": "Sélectionner un rôle d'utilisateur",
    "mobile_placeholder_filter_by_team": "Filtrer par équipe",
    "mobile_placeholder_assign_to_user_role": "Attribuer un rôle d'utilisateur",
    "mobile_placeholder_select": "-- Sélectionner --",
    "mobile_placeholder_account_location_name": "Nom du lieu",
    "mobile_placeholder_tag_filter_by": "Filtrer par mot-clé de lieu",
    "mobile_placeholder_user_type": "Attribuer à l'utilisateur",
    "mobile_placeholder_acount_type_loading": "Chargement... ",
    "mobile_placeholder_therm_no_bluetooth": "Température",
    "mobile_placeholder_blue_therm_connecting": "Connexion à l'appareil...",
    "mobile_placeholder_blue_therm_please_wait": "Veuillez attendre...",
    "mobile_placeholder_blue_therm_tap": "Touchez pour lire.",
    "mobile_placeholder_blue_therm_not_connected": "Non connecté.",
    "mobile_placeholder_testo_tap": "Appuyez sur ▼▲ et maintenez enfoncé, suivi de ⬆",
    "mobile_message_error_create_task": "Vous devez être en ligne pour ajouter des tâches",
    "mobile_message_error_fill_out_form": "Veuillez remplir le formulaire.",
    "mobile_message_error_fill_require_fields": "Remplissez les champs obligatoires.",
    "mobile_message_error_stop_stopwatch_before_submit": "Arrêtez votre chronomètre avant de soumettre",
    "mobile_message_error_stopwatch_field_required": "Le champ Chronomètre est obligatoire",
    "mobile_message_error_stopwatch_field_running": "Le champ Chronomètre est en marche",
    "mobile_message_error_invalid_equipment_temperature": "Température de l'équipement non valide",
    "mobile_message_error_invalid_ingredient_temperature": "Température de l'ingrédient non valide",
    "mobile_message_error_location_attributes_unavailable": "Certaines questions peuvent ne pas être disponibles; veuillez vous connecter à Internet",
    "mobile_message_alert_running_stopwatches": "Vos chronomètres sont en marche.\n\nDésirez-vous les retirer?",
    "mobile_message_blue_therm_error": "Perte de connexion à l'appareil Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "L'accès à la localisation est requis. Activez-le dans les paramètres de votre appareil Android.",
    "mobile_message_blue_therm_no_permission_android": "L'accès aux appareils à proximité est requis. Activez-le dans les paramètres de votre appareil Android.",
    "mobile_message_blue_therm_error_code": "Échec de la connexion :",
    "mobile_message_blue_therm_error_bluetooth": "Veuillez activer le Bluetooth.",
    "mobile_message_blue_therm_error_device": "Appareil non trouvé.",
    "mobile_message_blue_therm_error_try_again": "Veuillez réessayer",
    "mobile_message_blue_therm_success": "Appareil Bluetooth connecté!",
    "mobile_message_bluetooth_device_press_button_field": "Appuyez sur le bouton de votre appareil pour vous connecter.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Appuyez sur le bouton de votre appareil<br />s'il ne figure pas sur cette liste.",
    "mobile_bluetooth_scan": "Scanner",
    "mobile_bluetooth_scanning": "Scan en cours",
    "mobile_message_drafts_confirm": "Désirez-vous sauvegarder ceci en tant qu'ébauche?",
    "mobile_message_drafts_toast_saved": "Ébauche sauvegardée.",
    "mobile_message_drafts_request_update": "Désirez-vous mettre à jour cette ébauche?",
    "mobile_message_drafts_form_confirm": "Êtes-vous sûr de vouloir supprimer cette ébauche?",
    "mobile_message_drafts_confirm_delete": "Supprimer l'ébauche",
    "mobile_message_streams_error_switch": "Incapable de modifier les flux sur le Web",
    "mobile_message_settings_success_saved": "Paramètres sauvegardés",
    "mobile_message_settings_error": "Une erreur inconnue est survenue. Veuillez réessayer plus tard",
    "mobile_message_profile_settings_error_fields": "Veuillez corriger les champs surlignés.",
    "mobile_message_media_perimission_denied": "Votre ",
    "mobile_message_media_perimission_denied_device": "mémoire d'appareil",
    "mobile_message_image_confirm_remove_image": "Êtes-vous sûr de vouloir supprimer cette photo?",
    "mobile_message_create_account_error_fields": "Veuillez remplir les champs surlignés.",
    "mobile_message_create_account_success_location_created": "Lieu créé",
    "mobile_message_task_error_get_location": "Incapable d'obtenir le lieu. Commande par date.",
    "mobile_message_typehead_confirm_save_message": "Désirez-vous sauvegarder ces sélections?",
    "mobile_message_typehead_confirm_save_title": "Sauvegarder?",
    "mobile_message_task_creator_error_save_select_form": "Vous devez sélectionner un formulaire.",
    "mobile_message_task_creator_error_save_required_fields": "Veuillez remplir les champs obligatoires.",
    "mobile_message_task_creator_error_save_batch_change": "Veuillez modifier les critères pour les associer à un ou plusieurs utilisateurs",
    "mobile_message_task_detials_error_not_assigned_to_you": "Cette tâche ne vous a pas été assignée.<br />Vous ne pouvez l'achever.",
    "mobile_message_task_detials_error_assigned_to": "Cette tâche a été assignée à {{user}}.<br />Vous ne pouvez l'achever.",
    "mobile_message_task_detials_confirm_title": "Quitter la tâche",
    "mobile_message_task_detials_confirm_save_task": "Sauvegarder la tâche",
    "mobile_message_task_detials_confirm_message": "Êtes-vous sûr? Vos modifications seront perdues.",
    "mobile_message_task_detials_error_view_account": "Incapable d'accéder au lieu.",
    "mobile_message_task_detials_error_submit_task": "Veuillez ajouter une photo pour achever cette tâche.",
    "mobile_message_task_detials_error_submit_task_project": "Incapable de sauvegarder le projet. Veuillez réessayer plus tard.",
    "mobile_message_task_detials_wait_submit_task_created": "Les tâches sont en cours de création.<br />Veuillez attendre quelques minutes pour que les données s'affichent.",
    "mobile_message_task_detials_error_submit_task_pending": "Erreur, veuillez réessayer plus tard",
    "mobile_message_task_detials_success_task_complete": "Tâche achevée",
    "mobile_message_task_error_save_single_task": "Incapable de sauvegarder la tâche. Veuillez réessayer plus tard.",
    "mobile_message_task_success_save_single_task": "Tâche créée.",
    "mobile_message_show_error_message": "Quelque chose a mal fonctionné.",
    "mobile_message_show_success_message": "Réussi!",
    "mobile_message_show_offline_message": "Vous êtes actuellement hors ligne.",
    "mobile_message_show_permission_denied_message": "<b>Autorisation requise.</b> Veuillez autoriser Zenput à accéder à {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Autorisation requise.</b> Veuillez autoriser Zenput et votre navigateur à accéder à {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Téléversement en cours",
    "mobile_message_show_upload_in_progress_message": "Téléversement déjà en cours",
    "mobile_message_show_form_id_error": "Incapable d'accéder au formulaire spécifié.",
    "mobile_message_show_single_task_error": "Incapable d'accéder à la tâche spécifiée.",
    "mobile_message_show_submissions_error": "Incapable d'accéder à la soumission spécifiée.",
    "mobile_message_show_submissions_access_denied": "Désolé, vous n'avez pas accès à ce formulaire.",
    "mobile_message_send_data_success": "Données téléversées ",
    "mobile_message_start_upload_success": "Téléversement terminé",
    "mobile_message_start_upload_error": "<b>Le téléversement n'a pu être effectué.</b><br>Soumission sauvegardée. Veuillez réessayer plus tard",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Play Store",
    "mobile_message_store_upgrade_confirm_title": "Mise à jour disponible",
    "mobile_message_store_upgrade_confirm_message_one": "Veuillez mettre à jour l'appli Ops Execution à partir de ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Veuillez mettre à jour Zenput à partir de ",
    "mobile_message_store_upgrade_confirm_message_two": " pour obtenir les plus récentes fonctionnalités et corrections de bogues",
    "mobile_message_store_upgrade_confirm_now": "Maintenant",
    "mobile_message_store_upgrade_confirm_later": "Plus tard",
    "mobile_message_redirect_confirm_message": "Vous êtes en train de remplir un formulaire. Désirez-vous le sauvegarder en tant qu'ébauche avant de procéder?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Vous avez {{count}} ébauches qui n'ont pas encore été téléversées. Elles seront perdues si vous continuez. Êtes-vous sûr?",
    "mobile_message_draft_override_message": "Cette ébauche a été sauvegardée à partir d'un autre appareil sur {{date}}, et les modifications apportées sur cet appareil ne coïncident pas. Vous pouvez outrepasser la version actuelle, ou recharger la plus récente version, et vos modifications seront rejetées.",
    "mobile_html_submitting": "Soumettre...",
    "mobile_html_offline": "Vous êtes actuellement hors ligne!",
    "mobile_html_offline_try_again": "Vous êtes actuellement hors ligne. <br/><br/>Veuillez réessayer lorsque vous serez connecté",
    "mobile_html_something_went_wrong": "Oups! Quelque chose n'a pas fonctionné.",
    "mobile_html_something_went_wrong_try_again": "Oups! Quelque chose n'a pas fonctionné. Veuillez réessayer.",
    "mobile_html_failed_loading_roles": "Incapable de charger les rôles.",
    "mobile_alert_please_install_for_native": "Veuillez installer l'appli Ops Execution pour utiliser cette fonctionnalité. ",
    "mobile_alert_please_install_for_native_old": "Veuillez installer l'application Zenput native pour utiliser cette fonctionnalité.",
    "mobile_tso_filter_all_tasks": "Toutes les {{type}}",
    "mobile_tso_filter_my_tasks": "Mes {{type}}",
    "mobile_tso_filter_due_date": "Date d'échéance",
    "mobile_tso_filter_date_completed": "Date d'achèvement",
    "mobile_tso_filter_completed": "Achevée",
    "mobile_tso_filter_completed_late": "Terminé en retard",
    "mobile_tso_filter_incomplete": "Incomplète",
    "mobile_tso_filter_var_my_tasks": "Mes {{type}} {{filter_type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{type}} {{filter_type}} créées par moi",
    "mobile_tso_filter_var_all_tasks": "Toutes les {{type}} {{filter_type}}",
    "mobile_tso_type_follow_up_actions": "Actions de suivi",
    "mobile_tso_type_all": "Tâches et actions de suivi",
    "mobile_tso_filter_var_at": " à {{location}}",
    "mobile_tso_filter_group_date_due": ", classées par date d'échéance",
    "mobile_tso_filter_group_distance": ", groupées par lieu",
    "mobile_tso_filter_start_date": "Date de début",
    "mobile_tso_filter_none": "Aucun",
    "mobile_pso_filter_all_projects": "Tous les projets",
    "mobile_pso_filter_my_projects": "Mes projets",
    "mobile_pso_filter_active": "Actif",
    "mobile_pso_filter_archived": "Archivé",
    "mobile_pso_filter_recurring": "Récurrent",
    "mobile_pso_filter_non_recurring": "Non récurrent",
    "mobile_pso_filter_var_my_projects": "Mes {{project_type}} {{active_description}} projets",
    "mobile_pso_filter_var_my_created_projects": "{{project_type}} {{active_description}} projets créés par moi",
    "mobile_pso_filter_var_all_projects": "Tous les {{project_type}} {{active_description}} projets",
    "mobile_empty_list_message_must_be_online": "Il semble que vous êtes hors ligne. Veuillez aller en ligne pour voir les résultats.",
    "mobile_empty_list_message_no_submissions": "Aucune soumission",
    "mobile_empty_list_message_no_activity": "Aucune activité",
    "mobile_empty_list_message_no_tasks": "Aucune tâche",
    "mobile_empty_list_message_no_tasks_overdue": "Aucune {{type}} en retard",
    "mobile_empty_list_message_no_accounts": "Aucun lieu",
    "mobile_empty_list_message_no_projects": "Aucun projet",
    "mobile_empty_list_message_no_results_found": "Aucun résultat trouvé",
    "mobile_empty_list_message_no_forms_available": "Aucun formulaire disponible",
    "mobile_empty_list_message_connection_error": "Erreur de connexion<br />Veuillez réessayer.",
    "mobile_empty_list_message_dashboard_error": "Incapable de charger le tableau de bord",
    "mobile_empty_list_message_user_offline": "Vous êtes actuellement hors ligne",
    "mobile_action_sheet_media_gallery": "Galerie",
    "mobile_action_sheet_cancel": "Annuler",
    "mobile_image_preview_text": "Supprimer la photo",
    "mobile_mobileform_text": "Soumissions précédentes",
    "mobile_mobileform_reorder_fields": "Réorganiser les questions",
    "mobile_mobileform_follow_up_actions": "Actions de suivi",
    "mobile_mobileform_follow_up_actions_assign_title": "Assigner des actions de suivi",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Ajoutez des actions de suivi basées sur vos observations pour vous assurer que les problèmes sont réglés.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Ajouter une action de suivi",
    "mobile_mobileform_follow_up_actions_assign_button": "Assigner les suivis",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Continuer sans assigner",
    "mobile_mobileform_follow_up_actions_dialog_title": "Continuer sans assigner d’actions de suivi?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "Si vous continuez sans assigner d’actions de suivi, vous ne pourrez plus en ajouter plus tard.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Continuer quand même",
    "mobile_mobileform_add_follow_up_actions_forms_required": "Ce champ est obligatoire",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Trop de caractères",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "Ce champ est invalide",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Erreur lors du chargement des lieux",
    "mobile_mobileform_add_follow_up_actions_error_users": "Erreur lors du chargement des utilisateurs",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Ajouter un suivi",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Titre",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Description",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Exiger une photo",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Date d’échéance",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Mettre à jour le suivi",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Supprimer le suivi?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Il sera supprimé et ne sera pas assigné.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Supprimer le suivi",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Voulez-vous vraiment supprimer ce suivi?\n\nCette action est irréversible.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Continuer vers les suivis",
    "mobile_mobileform_follow_up_actions_completed_notification": "Action de suivi terminée",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Action de suivi supprimée",
    "mobile_mobileform_follow_up_actions_update_notification": "Action de suivi mise à jour",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Veuillez ajouter une photo pour terminer cette action de suivi",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Aller à la soumission",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Accéder à la source",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Source",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Terminer le suivi",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Si vous ouvrez la soumission, toutes les photos et notes non enregistrées seront perdues.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Si vous quittez cet écran, toutes les photos et les notes non enregistrées seront perdues.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Rester ici",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Ouvrir la soumission",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Ouvrir la source",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Quitter cette action de suivi?",
    "mobile_mobileform_follow_up_actions_submission": "Soumission",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Cette action de suivi est assignée à {{user}}.<br />Vous ne pouvez pas la terminer.",
    "mobile_mobileform_follow_up_actions_leave_description": "Si vous quittez cet écran, toutes les modifications non enregistrées seront perdues.",
    "mobile_mobileform_follow_up_actions_leave": "Quitter",
    "mobile_forms_drafts_text": "Supprimer les ébauches",
    "mobile_batch_estimate_user": "Utilisateur",
    "mobile_batch_estimate_users": "Utilisateurs",
    "mobile_table_of_contents": "Table des matières",
    "mobile_table_of_contents_required": "Obligatoire",
    "mobile_table_of_contents_optional": "Facultatif",
    "mobile_dialog_alert_title": "Alerte",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Les appareils Bluetooth ne sont pas encore pris en charge sur Windows",
    "mobile_windows_deprecated_message_content_announcement": "Annonce",
    "mobile_windows_deprecated_message_title": "Mise à jour de l'appli requise",
    "mobile_windows_deprecated_message_description": "Installez la nouvelle appli Zenput à partir de Microsoft Store dès que possible pour obtenir des mises à jour de fonctionnalités critiques et pour optimiser votre expérience Zenput.",
    "mobile_dashboard_tcr_graph_name": "Taux d'achèvement de tâche",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "4 dernières semaines",
    "mobile_dashboard_tcr_legend_company_average": "Moyenne de l'entreprise",
    "mobile_dashboard_tcr_legend_team_average": "Moyenne de l'équipe",
    "mobile_dashboard_tab_title_summary": "Sommaire",
    "mobile_dashboard_tab_title_activity": "Activité",
    "mobile_dashboard_card_title_top_triggered_workflows": "Principaux déclencheurs",
    "mobile_dashboard_tab_title_info": "Info",
    "mobile_dashboard_tab_project_audit": "Conformité",
    "mobile_dashboard_card_task_stats_total": "Total",
    "mobile_dashboard_top_item_header_week_of": "Semaine du",
    "mobile_dashboard_card_filter_form_template_placeholder": "Tous les formulaires",
    "mobile_dashboard_card_title_forms_top_nos": "Non fréquents",
    "mobile_dashboard_zenput_code_no_data_in_range": "Il n'y a pas de données dans cette plage horaire.",
    "mobile_dashboard_zenput_code_permission_denied": "Vous n'êtes pas autorisée à voir cette information.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Sélectionnez un formulaire ci-dessus.",
    "mobile_dashboard_zenput_code_unknown_error": "Nous ne pouvons afficher les données en ce moment.",
    "mobile_dashboard_tap_to_retry": "Touchez pour réessayer",
    "mobile_dashboard_reporting_delay_disclaimer": "La mise à jour des tâches peut prendre jusqu'à 15 minutes",
    "mobile_dashboard_configuration_down_state_postfix_msg": "ont été configuré(e)s par votre administrateur.",
    "mobile_tasks_tag": "tâches",
    "mobile_workflows_tag": "déclencheurs",
    "mobile_projects_tag": "projets récurrents",
    "mobile_forms_tag": "formulaires",
    "mobile_dashboard_card_ongoing_projects_title": "Projets en cours",
    "mobile_dashboard_card_ongoing_projects_show_more": "Afficher davantage",
    "mobile_dashboard_card_ongoing_projects_show_less": "Afficher moins",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Aller à Projets",
    "mobile_dashboard_card_title_recurring_projects": "Projets récurrents",
    "mobile_dashboard_card_filter_daily": "Quotidien",
    "mobile_dashboard_card_filter_weekly": "Hebdomadaire",
    "mobile_dashboard_card_filter_monthly": "Mensuel",
    "mobile_task_status_title_open": "Ouvert",
    "mobile_task_status_title_upcoming": "À venir",
    "mobile_task_status_title_complete": "Achever",
    "mobile_task_status_title_processing": "Traitement de la soumission en cours",
    "mobile_task_status_title_complete_with_exceptions": "Terminer avec les alertes ou les tâches de suivi",
    "mobile_task_status_title_completed_late_with_exceptions": "Terminé en retard avec des tâches de suivi ou des alertes",
    "mobile_task_status_title_incomplete_and_closed": "Manqué",
    "mobile_tasks_legend_modal_title": "Légende",
    "mobile_tasks_legend_modal_footer_button_title": "Fermer",
    "mobile_common_assigned_to": "Assigné à",
    "mobile_common_created_by": "Créé par",
    "mobile_common_tasks_for": "Tâches pour",
    "mobile_common_go_back": "Retour",
    "mobile_oh_no": "Oh non!",
    "mobile_user_not_in_groups": "Désolé, il semble que vous n'avez pas été affecté à une équipe. Contactez votre administrateur pour accéder au tableau de bord.",
    "mobile_tasks_select_followers": "Sélectionner les abonnés",
    "mobile_tasks_assign_tasks": "Assigner les {{count}} tâches",
    "mobile_tasks_add_followers": "Ajouter des abonnés",
    "mobile_tasks_followers": "Abonnés",
    "mobile_tasks_delete_task": "Supprimer la tâche",
    "mobile_tasks_create_task": "Créer des tâches",
    "mobile_tasks_tab_title_comments": "Commentaires",
    "mobile_tasks_see_more": "Voir davantage",
    "mobile_projects_create_project": "Créer un projet",
    "mobile_common_button_send": "Envoyer",
    "mobile_common_button_schedule": "Calendrier",
    "mobile_announcements_create": "Créer une annonce",
    "mobile_announcements_read_rate": "{{opened_count}} de {{recipients_count}} ouverte",
    "mobile_announcements_empty_message": "Vous n'avez pas encore créé d'annonces! Créez une annonce pour diffuser des renseignements importants, des nouvelles et des mises à jour concernant votre organisation.",
    "mobile_announcement_message_placeholder": "Ajouter un message...",
    "mobile_announcement_title_placeholder": "Titre de l'annonce",
    "mobile_announcement_leaving_announcement": "Quitter l'annonce",
    "mobile_announcement_confirm_recipients_team": "Désirez-vous diffuser cette annonce aux {{count}} utilisateurs des {{teams}} équipes sélectionnées?",
    "mobile_announcement_confirm_recipients_role": "Désirez-vous diffuser cette annonce aux {{count}} utilisateurs des {{roles}} rôles d'utilisateur sélectionnés?",
    "mobile_announcement_confirm_recipients_user": "Désirez-vous diffuser cette annonce aux {{count}} utilisateurs?",
    "mobile_announcement_confirm_scheduled": "Le {{timestamp}}",
    "mobile_announcement_sending_announcement": "Envoyer l'annonce",
    "mobile_announcement_send_to": "Envoyer à",
    "mobile_announcement_sent_to": "Envoyée à",
    "mobile_announcement_send_to_role": "Rôle",
    "mobile_announcement_attachment_download": "Téléchargement en cours {{filename}}",
    "mobile_announcement_attachment_validation_error": "Au plus {{maxCount}} pièces jointes peuvent être ajoutées",
    "mobile_announcement_details_sent": "Envoyée",
    "mobile_announcement_details_total_recipients": "Nombre total de destinataires",
    "mobile_announcement_details_cancel": "Annuler l'annonce",
    "mobile_announcement_details_not_editable": "Les annonces peuvent uniquement être modifiées dans l'appli Web Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Les annonces peuvent être modifiées uniquement dans Zenput Web",
    "mobile_announcement_details_open_count": "Nombre de consultations",
    "mobile_announcement_details_open_rate": "Taux de consultation",
    "mobile_announcement_details_resend": "Envoyer de nouveau à ceux qui ne l'ont pas consulté",
    "mobile_announcement_confirm_resend": "{{count}} utilisateurs n'ont pas lu l'annonce. Désirez-vous envoyer un rappel?",
    "mobile_announcement_confirm_resend_title": "Envoyer un rappel?",
    "mobile_announcement_recipients_opened": "Annonce consultée",
    "mobile_recipients_opened_empty_message": "Il semble que personne n'a encore ouvert votre message. Revenez plus tard pour voir les résultats.",
    "mobile_announcement_recipients_unopened": "Non ouvert",
    "mobile_recipients_unopened_empty_message": "Bonne nouvelle! Tous les destinataires ont ouvert le message!",
    "mobile_scheduled_announcements_delivery_section_header": "Heure de livraison",
    "mobile_scheduled_announcements_send_immediately_label": "Envoyer immédiatement",
    "mobile_scheduled_announcements_scheduled_label": "Envoyer à une heure déterminée",
    "mobile_scheduled_announcements_scheduled_tab_label": "Programmé",
    "mobile_scheduled_announcements_dialog_header": "Annuler l'annonce?",
    "mobile_scheduled_announcements_dialog_message": "L'annulation de votre annonce fera en sorte qu'elle ne sera plus envoyée et sera supprimée de votre liste. Cela ne peut être annulé. Pour modifier, visitez Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Vous n'avez pas d'annonce programmée. Programmez une annonce pour diffuser des renseignements importants, des nouvelles et des mises à jour concernant votre organisation.",
    "mobile_scheduled_announcements_validation_error": "Le moment de livraison doit être après {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Programmer une annonce",
    "mobile_projects_auto_archive": "Archiver automatiquement",
    "mobile_common_unassigned": "Non assigné",
    "mobile_tasks_title_placeholder": "Nouveau formulaire ou nouvelle tâche",
    "mobile_projects_leaving_project": "Quitter le projet",
    "mobile_projects_save_project": "Sauvegarder le projet",
    "mobile_top_triggers_tasks": "Principales tâches déclenchées",
    "mobile_top_triggers_alerts": "Principales alertes déclenchées",
    "mobile_projects_not_started": "Pas encore commencé",
    "mobile_empty_list_message_no_photos": "Aucune photo",
    "mobile_webfilestore_message_error": "Veuillez sélectionner un type de fichier valide",
    "mobile_notifications_empty_title": "Aucune notification",
    "mobile_notifications_empty_message": "Vos tâches ou celles auxquelles vous participez seront affichées ici.",
    "mobile_comments_comment_deleted": "Ce commentaire a été supprimé.",
    "mobile_comments_comment_placeholder": "Commentaire",
    "mobile_comments_task_submitted_at": "Tâche soumise le {{ date }} à {{ time }}",
    "mobile_comments_discard_comment_title": "Rejeter le commentaire?",
    "mobile_comments_discard_confirm_message": "Êtes-vous sûr? Votre commentaire sera supprimé.",
    "mobile_comments_delete_comment_title": "Supprimer le commentaire?",
    "mobile_comments_delete_confirm_message": "Ceci ne peut être annulé.",
    "mobile_comments_delete_button": "Supprimer le commentaire",
    "mobile_comments_delete_success_message": "Commentaire supprimé",
    "mobile_comments_empty_message_tasks": "Il n'y a pas encore de commentaire \n Commencez une conversation sur cette tâche.",
    "mobile_comments_empty_message_submissions": "Il n'y a pas encore de commentaire \n Commencez une conversation sur cette soumission.",
    "mobile_comments_empty_message_default": "Il n'y a pas encore de commentaire \n Commencez une conversation.",
    "mobile_comments_no_matching_users": "Aucun utilisateur ne peut être associé.",
    "mobile_comments_empty_users_to_notify": "Il n'y a pas d'utilisateur à aviser.",
    "mobile_comments_users_cant_view_message": "Ces utilisateurs ne peuvent voir les commentaires.",
    "mobile_comments_users_to_notify_title": "Utilisateurs à aviser",
    "mobile_comments_mention_description_notifiers": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilisateur</a> sera avisé.",
    "mobile_comments_mention_description_notifiers_plural": "<a href=\"#\" class=\"show_users_to_notify\">{{ count }} utilisateurs</a> seront avisés.",
    "mobile_comments_mention_instructions": "<a href=\"#\" class=\"open_mention_autocomplete\">@mention</a> plus d'utilisateurs pour les aviser.",
    "mobile_comments_mark_read": "Tout marquer comme lu.",
    "mobile_comments_author_mentioned_message": "vous a mentionné dans",
    "mobile_comments_author_commented_message": "a commenté sur",
    "mobile_view_pdf": "Voir le PDF",
    "mobile_no_pdf_generated_message": "Aucun PDF n'a été trouvé pour cette soumission. Une copie vous sera envoyée par courriel sous peu.",
    "mobile_clipboard_copied_success": "Le lien a été copié sur votre presse-papiers.",
    "mobile_share_link": "Partager le lien",
    "mobile_zencam_share": "Partager",
    "mobile_zencam_view_details": "Visualiser les détails",
    "mobile_zencam_details_drawer_header": "Détails",
    "mobile_zencam_submitted_by": "Soumis par",
    "mobile_zencam_form_title": "Titre du formulaire",
    "mobile_zencam_date_submitted": "Date de soumission",
    "mobile_oil_quality_warning_message": "Huile presque expirée",
    "mobile_oil_quality_warning_message_subtitle": "Songez à la remplacer bientôt",
    "mobile_oil_quality_failure_message": "Qualité de l’huile compromise",
    "mobile_oil_quality_failure_message_subtitle": "Remplacez l’huile immédiatement",
    "mobile_sensors_set_up_gateway": "Établir une passerelle",
    "mobile_sensors_set_up_gateway_message": "Il semble qu'aucun appareil n'a été établi. Commencez en ajoutant une passerelle.",
    "mobile_sensors_gateway_plugged_in": "Veillez à ce que votre passerelle soit branchée à une prise de courant",
    "mobile_sensors_add_device": "Ajouter un appareil",
    "mobile_sensors_name_this_gateway": "Nommez cette passerelle.",
    "mobile_sensors_name_this_sensor": "Nommez ce capteur.",
    "mobile_sensors_device_barcode_information": "Scanner le code QR ou saisir le numéro d’identification et le code SC figurant sur l’étiquette de l’appareil",
    "mobile_sensors_device_eui_information": "Scanner le code QR ou saisir le code DevEUI figurant sur l’étiquette de l’appareil",
    "mobile_sensors_gateway_id_information": "Saisir l’identifiant de nœud figurant sur l’étiquette de la passerelle.",
    "mobile_sensors_id_number": "{{untranslatedID}} Numéro",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} Code",
    "mobile_sensors_sensors": "Capteurs",
    "mobile_sensors_sensor_deveui_error": "Impossible d’obtenir DevEUI à partir du code QR. Veuillez le saisir manuellement.",
    "mobile_sensors_gateways": "Passerelles",
    "mobile_sensors_add_sensor": "Ajouter un capteur",
    "mobile_sensors_add_gateway": "Ajouter une passerelle",
    "mobile_sensor_placement_description": "Quel secteur ce capteur surveillera-t-il?",
    "mobile_sensors_equipment_placement": "Quel secteur ou équipement ce capteur surveillera-t-il?",
    "mobile_sensors_equipment": "Quel équipement ce capteur surveillera-t-il?",
    "mobile_sensors_select_gateway_type": "Sélectionner le type de passerelle",
    "mobile_sensors_select_placement": "Sélectionner l'emplacement",
    "mobile_sensors_select_equipment": "Sélectionner l’équipement",
    "mobile_sensors_placement": "Emplacement",
    "mobile_sensors_nickname_tip": "Le nom d’un capteur dépend des surnoms attribués à l’emplacement sélectionné.",
    "mobile_sensors_device_online": "En ligne",
    "mobile_sensors_device_offline": "Hors ligne",
    "mobile_sensors_scan_qrcode": "Scanner le code QR",
    "mobile_sensors_enter_manually": "Saisir manuellement",
    "mobile_sensors_wizard_step_one": "Étape 1",
    "mobile_sensors_wizard_step_two": "Étape 2",
    "mobile_sensors_wizard_step_three": "Étape 3",
    "mobile_sensors_wizard_step_four": "Étape 4",
    "mobile_sensors_wizard_step_five": "Étape 5",
    "mobile_sensors_wizard_step_six": "Étape 6",
    "mobile_sensors_initializing": "Initialisation en cours...",
    "mobile_sensors_nickname": "Pseudonyme",
    "mobile_sensors_field_not_blank": "Le champ {{field}} ne peut pas être vide.",
    "mobile_sensors_nothing_to_see_here": "Rien à voir ici",
    "mobile_sensors_missing_integration": "Intégration de capteur manquante",
    "mobile_sensors_contact_zenput_admin": "Veuillez contacter l'administrateur Ops Execution de votre entreprise.",
    "mobile_sensors_contact_zenput_admin_old": "Contactez l’admin Zenput.",
    "mobile_sensors_contact_manager": "Contactez votre gestionnaire de compte pour ajouter des capteurs.",
    "mobile_sensors_device_success_message": "Cela peut prendre jusqu'à 15 minutes avant que les données du capteur soient téléchargées",
    "mobile_sensors_last_reading": "Dernière lecture",
    "mobile_sensors_remove_device": "Retirer l'appareil",
    "mobile_sensors_one_day": "1J",
    "mobile_sensors_one_week": "1S",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6 M",
    "mobile_sensors_one_year": "1A",
    "mobile_sensors_sensor_settings": "Paramètres du capteur",
    "mobile_sensors_remove_confirm_message": "Êtes-vous sûr de vouloir supprimer cet appareil?\nCeci ne peut être annulé.",
    "mobile_sensors_sensor": "Capteur",
    "mobile_sensors_no_equipment_linked": "Aucun équipement lié",
    "mobile_sensor_cooldown_process": "Processus de refroidissement",
    "mobile_sensor_last_12_hours": "12 dernières heures",
    "mobile_sensor_start_cooldown_process": "Commencer le nouveau processus de refroidissement",
    "mobile_sensor_cooldown_process_title": "Processus de refroidissement en deux étapes",
    "mobile_sensor_cooldown_process_description": "Le processus de refroidissement en deux étapes consiste à refroidir un aliment de plus de {{ stage1_start_temperature }} à {{ stage1_end_temperature }} en deux heures ou moins, puis de {{ stage1_end_temperature }} à {{ stage2_end_temperature }} en quatre heures ou moins.",
    "mobile_sensor_cooldown_process_place_food": "Placez l'aliment dans le réfrigérateur.",
    "mobile_sensor_cooldown_process_insert_sensor": "Insérez une sonde de capteur dans l'aliment.",
    "mobile_sensor_cooldown_process_enter_information": "Saisissez les renseignements ci-dessous.",
    "mobile_sensor_cooldown_process_food_product": "Aliment à refroidir",
    "mobile_sensor_cooldown_cool_down": "Refroidir",
    "mobile_sensor_cooldown_select_sensor": "Sélectionner le capteur",
    "mobile_sensors_cooldown_start_cooldown": "Commencer le refroidissement",
    "mobile_sensors_cooldown_please_enter_food": "Entrer un aliment",
    "mobile_sensors_cooldown_please_select_sensor": "Sélectionner un capteur",
    "mobile_sensors_cooldown_status_in_progress": "En cours",
    "mobile_sensors_cooldown_status_failed": "Échec",
    "mobile_sensors_cooldown_status_success": "Réussite",
    "mobile_sensors_cooldown_stage": "Étape",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "La température de départ est hors de la plage",
    "mobile_sensors_cooldown_failed_cooldown_process": "Échec du processus de refroidissement",
    "mobile_sensors_cooldown_cooldown_successful": "Processus de refroidissement réussi",
    "mobile_sensors_cooldown_started_cooldown_process": "Le processus de refroidissement a débuté",
    "mobile_sensors_cooldown_hour": "heure",
    "mobile_sensors_cooldown_hour_plural": "heures",
    "mobile_sensors_cooldown_minute": "minute",
    "mobile_minutes_plural": "minutes",
    "mobile_sensors_last_reading_max_date": " > d'un an",
    "mobile_sensors_minute_count_ago": "il y a {{count}} minute",
    "mobile_sensors_minute_count_ago_plural": "il y a {{count}} minutes",
    "mobile_sensors_hour_count_ago": "il y a {{count}} heure",
    "mobile_sensors_hour_count_ago_plural": "il y a {{count}} heures",
    "mobile_sensors_day_count_ago": "il y a {{count}} jour",
    "mobile_sensors_day_count_ago_plural": "il y a {{count}} jours",
    "mobile_sensors_chart_settings": "Paramètres du diagramme",
    "mobile_announcement_banner_continue_reading": "Poursuivre la lecture",
    "mobile_compliance_submissions_report": "Rapport des soumissions",
    "mobile_compliance_submissions_report_subtitle": "Exporter les données d’achèvement de projet de ce magasin",
    "mobile_compliance_send_submissions": "Envoyer les soumissions",
    "mobile_compliance_completion_rate_in_last_days": "Taux d’achèvement dans les derniers {{ days }} jours",
    "mobile_compliance_last_days": "Derniers {{ days }} jours",
    "mobile_compliance_send_submissions_to": "Envoyer les soumissions à",
    "mobile_compliance_send_to_different_email": "Envoyer à une autre adresse courriel",
    "mobile_compliance_email_input_placeholder": "Adresse courriel",
    "mobile_compliance_send_submissions_to_legend_title": "Soumissions",
    "mobile_compliance_send_submissions_to_legend_description_days": "Un rapport recensant vos soumissions des {{ days }} derniers jours à partir de ce lieu sera envoyé à l’adresse courriel sélectionnée.",
    "mobile_compliance_time_frame": "Plage horaire",
    "mobile_compliance_sensor_temperature_log_report": "Rapport de température du capteur",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Exporter l’historique de température de ce magasin",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Critère",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Définir le critère du rapport ci-dessous.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Remarque : Le rapport omet les capteurs désactivés",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Sélectionner une plage horaire. L’historique est limité à 30 jours",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Envoyer le rapport",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "Ce mois-ci (1er à aujourd’hui)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Mois dernier",
    "mobile_compliance_sensor_temperature_log_email_title": "Envoyer le rapport à",
    "mobile_pwa_update_prompt_title": "Mettre l’application à jour",
    "mobile_pwa_update_prompt_description": "Une nouvelle version de l’application est disponible. Veuillez la mettre à jour.",
    "mobile_pwa_update_prompt_confirm": "Mettre à jour et réinitialiser",
    "mobile_pwa_update_prompt_cancel": "Me le rappeler plus tard",
    "notification_title_due_in_one_hour": "Échéance dans 1 heure",
    "task_is_due_soon": "L’échéance de '{{ task_title }}' est bientôt. Prenez un moment pour le remplir.",
    "mobile_photo_quality_warning_header": "Problème de qualité de la photo",
    "mobile_photo_quality_dialog_message": "Cette photo pourrait être trop sombre ou floue. Souhaitez-vous prendre une nouvelle photo ou conserver celle-ci?",
    "mobile_take_new_photo": "Prendre une nouvelle photo",
    "mobile_use_this_photo": "Utiliser cette photo"
}};
mobile_translations.pl_PL = { translation: {
    "mobile_common_zenput": "Zenput",
    "mobile_common_all": "Wszystko",
    "mobile_common_button_apply_filters": "Zastosuj filtry",
    "mobile_common_button_done": "Gotowe",
    "mobile_common_button_edit": "Edytuj",
    "mobile_common_button_archive": "Archiwizuj",
    "mobile_common_button_save": "Zapisz",
    "mobile_common_button_retake": "Powtórz",
    "mobile_common_button_save_draft": "Zapisz wersję roboczą",
    "mobile_common_button_discard": "Odrzuć",
    "mobile_common_button_submit": "Prześlij",
    "mobile_common_button_no": "Nie",
    "mobile_common_button_yes": "Tak",
    "mobile_common_button_na": "Nie dot.",
    "mobile_common_created_by_me": "Utworzone przeze mnie",
    "mobile_common_email": "Firmowy adres e-mail",
    "mobile_common_first_name": "Imię",
    "mobile_common_last_name": "Nazwisko",
    "mobile_common_location": "Lokalizacja",
    "mobile_common_locations": "Lokalizacje",
    "mobile_common_logout_message": "Czy na pewno wylogować?",
    "mobile_common_password": "Hasło",
    "mobile_common_permission_required": "Wymagane uprawnienia",
    "mobile_common_status": "Status",
    "mobile_common_task": "Zadanie",
    "mobile_common_tasks": "Zadania",
    "mobile_common_tasks_my": "Moje zadania",
    "mobile_common_projects": "Projekty",
    "mobile_common_filter_team": "Zespół",
    "mobile_common_filter_var_in": " za {{team_or_location}}",
    "mobile_common_filter_no_team_selected": "Nie wybrano zespołu",
    "mobile_common_filter_no_user_selected": "Nie wybrano użytkownika",
    "mobile_common_filter_no_role_selected": "Nie wybrano roli",
    "mobile_common_placeholder_date": "Data",
    "mobile_common_message_task_creator_error_save": "<b>Nie udało się utworzyć zadań.</b>",
    "mobile_common_camera": "Aparat",
    "mobile_common_microphone": "Mikrofon",
    "mobile_common_for": "do",
    "mobile_common_reload": "Załaduj ponownie",
    "mobile_common_override": "Zastąp",
    "mobile_common_notifications": "Powiadomienia",
    "mobile_common_chat_unavailable": "Czat niedostępny. Spróbuj ponownie później.",
    "mobile_common_chat_ending_dialog_title": "Czy ta rozmowa została już zakończona?",
    "mobile_common_chat_ending_dialog_description": "Daj nam znać, czy Twój problem został rozwiązany, czy po prostu chcesz kontynuować później.",
    "mobile_common_chat_ending_dialog_confirm": "Tak, rozmowa została zakończona",
    "mobile_common_chat_ending_dialog_cancel": "Będę kontynuować później",
    "mobile_common_continue_editing": "Kontynuuj edycję",
    "mobile_privacy_policy": "Polityka prywatności",
    "wootric_recommend_target": "znajomy lub kolega z branży",
    "wootric_followup_detractor_question": "Co możemy zmienić, aby następnym razem otrzymać wyższą ocenę?",
    "wootric_followup_passive_question": "Dziękujemy! Co możemy zrobić, aby udoskonalić nasze narzędzie?",
    "wootric_followup_promoter_question": "Dziękujemy! Co najbardziej podoba Ci się w Crunchtime Ops Execution?",
    "wootric_followup_promoter_question_old": "Dziękujemy! Co szczególnie podoba Ci się w Zenput?",
    "wootric_default_followup_question": "Dziękujemy! Czy możesz powiedzieć, dlaczego?",
    "wootric_default_placeholder_text": "Wyjaśnij swoją ocenę. Będzie to dla nas bardzo pomocne.",
    "wootric_default_thankyou_text": "Dziękujemy za odpowiedź i opinię!",
    "mobile_login_placeholder_login_as": "Zaloguj jako ident. użytkownika",
    "mobile_login_button_forgot_password": "Nie pamiętasz hasła?",
    "mobile_login_button_sign_up": "Utwórz konto",
    "mobile_login_button_finish_setup": "Zakończ konfigurację",
    "mobile_login_button": "Zaloguj się",
    "mobile_login_continue_button": "Kontynuuj",
    "mobile_login_continue_transition": "przekierowanie na stronę logowania Twojej organizacji...",
    "mobile_login_no_email_error": "Wprowadź adres e-mail.",
    "mobile_login_change_email": "Zaloguj się innym adresem e-mail",
    "mobile_login_with_sso": "Logowanie za pomocą SSO",
    "mobile_oauth_no_user_error_message": "Wygląda na to, że nie masz konta w Crunchtime Ops Execution!",
    "mobile_oauth_no_user_error_message_old": "Wygląda na to, że nie masz jeszcze konta Zenput.",
    "mobile_rebrand_announcement_banner": "<b>Zenput</b> to teraz <b>Crunchtime Ops Execution</b>",
    "mobile_rebrand_warning_banner": "{{- brand }} staje się {{- product }} we wrześniu. {{- cta }}",
    "mobile_rebrand_warning_cta": "Dowiedz się, jak się przygotować.",
    "mobile_oauth_no_user_error_sub_message": "Skontaktuj się ze swoim administratorem, aby uzyskać dostęp, albo zaloguj się innym adresem e-mail.",
    "mobile_oauth_generic_error_message": "Wygląda na to, że podczas logowania wystąpił błąd. Spróbuj ponownie.",
    "mobile_oauth_force_logout_msg": "Jeśli problem nie ustąpił, wyloguj się z konta dostawcy, ",
    "mobile_oauth_force_logout_click": "klikając tutaj.",
    "mobile_sign_up_placeholder_phone": "Nr tel. kom.",
    "mobile_sign_up_placeholder_password_confirm": "Potwierdź hasło",
    "mobile_sign_up_button_sign_in": "Zarejestruj się",
    "mobile_sign_up_disclaimer_part_1": "Klikając opcję Utwórz konto, akceptujesz",
    "mobile_sign_up_disclaimer_finish_setup_part_1": "Klikając opcję Zakończ konfigurację, akceptujesz",
    "mobile_sign_up_disclaimer_link_title": " Umowę licencyjną",
    "mobile_sign_up_disclaimer_part_2": "zawierającą ważne informacje o ochronie prywatności",
    "mobile_dialog_benefits_work_offline": "Pracuj offline",
    "mobile_dialog_benefits_faster_uploads": "Szybsze wysyłanie",
    "mobile_dialog_benefits_better_experience": "Większa wygoda użytkowania",
    "mobile_dialog_benefits_button_download": "Pobierz",
    "mobile_dialog_benefits_button_download_bold": "Ops Execution dla ",
    "mobile_dialog_benefits_button_download_bold_old": "Zenput dla ",
    "mobile_dialog_benefits_button_have": "Mam aplikację.",
    "mobile_dialog_benefits_button_no_thanks": "Nie, dziękuję, może innym razem.",
    "mobile_dialog_benefits_button_ios": "iOS",
    "mobile_dialog_benefits_button_android": "Android",
    "mobile_dialog_image_preview_message": "Nie można załadować obrazu.",
    "mobile_dialog_signature_sign": "Podpisz tutaj",
    "mobile_dialog_signature_button_clear": "Wyczyść",
    "mobile_account_placeholder_name": "Lokalizacja/Nazwa sklepu",
    "mobile_account_placeholder_phone": "Nr tel.",
    "mobile_account_placeholder_address": "Adres",
    "mobile_account_placeholder_city": "Miasto",
    "mobile_account_placeholder_region": "Region",
    "mobile_account_placeholder_zipcode": "Kod pocztowy",
    "mobile_account_option_select_country": "Wybierz kraj",
    "mobile_account_oprion_us": "Stany Zjednoczone",
    "mobile_account_oprion_select_state": "Wybierz stan",
    "mobile_account_button_create_location": "Utwórz lokalizację",
    "mobile_form_message_no_form": "Brak dostępnych formularzy",
    "mobile_batch_task_message": "Ładowanie...",
    "mobile_settings_profile": "Profil",
    "mobile_settings_profile_number": "Nr tel. kom.",
    "mobile_settings_profile_language": "Język",
    "mobile_settings_profile_temperature_unit": "Jednostka temperatury",
    "mobile_settings_profile_use_company_default": "Użyj ustawień domyślnych firmy",
    "mobile_settings_profile_celsius": "Stopnie Celsjusza",
    "mobile_settings_profile_fahrenheit": "Stopnie Fahrenheita",
    "mobile_settings_notifications_option_sms": "Wiadomość tekstowa",
    "mobile_settings_notifications_option_push": "Powiadomienia push",
    "mobile_settings_notifications_option_push_email": "Powiadomienia e-mail i push",
    "mobile_settings_notifications_option_do_not": "Nie powiadamiaj",
    "mobile_settings_notifications_category_communication": "Komunikacja",
    "mobile_settings_notifications_category_forms_and_triggers": "Formularze i wyzwalacze",
    "mobile_settings_devices": "Urządzenia",
    "mobile_settings_notifications_sub_category_alerts": "Alerty",
    "mobile_settings_notifications_sub_category_new_forms_available": "Dostępne nowe formularze",
    "mobile_settings_notifications_sub_category_task_assigned": "Zadanie przypisane",
    "mobile_settings_notifications_sub_category_task_completed": "Zadanie ukończone",
    "mobile_settings_notifications_sub_category_tasks_due_soon_reminder": "Przypomnienie o terminie realizacji zadania",
    "mobile_settings_notifications_sub_category_overdue_tasks_reminder": "Przypomnienie o zaległych zadaniach",
    "mobile_settings_notifications_sub_category_sensor_alerts": "Alerty czujnika",
    "mobile_settings_notifications_sub_category_critical_sensor_alerts": "Alerty krytyczne czujnika",
    "mobile_drafts_message": "Nie masz wersji roboczych.",
    "mobile_drafts_button_delete": "Usuń",
    "mobile_tasks_filter_location_no": "Nie wybrano lokalizacji",
    "mobile_tasks_filter_group_by": "Grupuj wg",
    "mobile_tasks_filter_sort_by": "Sortuj wg",
    "mobile_tasks_filter_sorted_by": "Posortowane wg",
    "mobile_tasks_filter_due_time": "Termin realizacji",
    "mobile_tasks_filter_open_time": "Termin otwarty",
    "mobile_tasks_bucket_due_next_24_hours": "Z terminem w ciągu najbliższych 24 godzin",
    "mobile_tasks_bucket_due_next_7_days": "Z terminem w ciągu najbliższych 7 dni",
    "mobile_tasks_bucket_open_tasks": "Dodatkowe otwarte {{type}}",
    "mobile_tasks_bucket_open_at": "Otwarte: {{- date }} o godzinie {{- time }}",
    "mobile_tasks_bucket_due_by_at": "Z terminem do: {{- date }} o godzinie {{- time }}",
    "mobile_tasks_bucket_available_in_one_minute": "Dostępne w ciągu 1 minuty",
    "mobile_tasks_bucket_available_in_one_hour": "Dostępne w ciągu 1 godziny",
    "mobile_tasks_bucket_available_in_one_day": "Dostępne w ciągu 1 dnia",
    "mobile_tasks_bucket_available_in_one_week": "Dostępne w ciągu 1 tygodnia",
    "mobile_tasks_bucket_available_in_one_month": "Dostępne w ciągu 1 miesiąca",
    "mobile_tasks_bucket_available_in_one_year": "Dostępne w ciągu 1 roku",
    "mobile_tasks_bucket_available_in_minutes": "Dostępne w ciągu {{ minutes }} minut",
    "mobile_tasks_bucket_available_in_hours": "Dostępne w ciągu {{ hours }} godzin",
    "mobile_tasks_bucket_available_in_days": "Dostępne w ciągu {{ days }} dni",
    "mobile_tasks_bucket_available_in_weeks": "Dostępne w ciągu {{ weeks }} tygodni",
    "notification_task_due_in_minutes": "Termin za {{ minutes }} minut(y)",
    "mobile_tasks_bucket_available_in_months": "Dostępne w ciągu {{ months }} miesięcy",
    "mobile_tasks_bucket_available_in_years": "Dostępne w ciągu {{ years }} lat",
    "mobile_tasks_follow_up": "Kolejne zadanie",
    "mobile_tasks_due_soon": "Termin wkrótce",
    "mobile_tasks_bucket_completed_today": "Ukończone dzisiaj",
    "mobile_tasks_bucket_completed_this_week": "Ukończone w tym tygodniu",
    "mobile_tasks_bucket_completed_last_week": "Ukończone w ubiegłym tygodniu",
    "mobile_tasks_bucket_missed_today": "Pominięte dzisiaj",
    "mobile_tasks_bucket_missed_this_week": "Pominięte w tym tygodniu",
    "mobile_tasks_bucket_missed_last_week": "Pominięte w ubiegłym tygodniu",
    "mobile_tasks_bucket_no_location": "Brak lokalizacji",
    "mobile_tasks_cannot_submit_missed": "Pominięte zadania nie mogą zostać ukończone",
    "mobile_tasks_cannot_submit_missed_after": "To zadanie nie może zostać ukończone po {{ date }}",
    "mobile_tasks_cannot_submit_upcoming": "Nie rozpoczęto realizacji zadania.",
    "mobile_tasks_cannot_submit_processing": "Zgłoszenie jest w trakcie przetwarzania",
    "mobile_tasks_toolbarnav_header_no_due_date": "Brak terminu realizacji",
    "mobile_tasks_toolbarnav_header_overdue": "Zaległe",
    "mobile_tasks_toolbarnav_header_yesterday": "Wczoraj",
    "mobile_tasks_toolbarnav_header_today": "Dzisiaj",
    "mobile_tasks_toolbarnav_header_tomorrow": "Jutro",
    "mobile_tasks_toolbarnav_header_last_week": "W ubiegłym tygodniu",
    "mobile_tasks_toolbarnav_header_this_week": "W tym tygodniu",
    "mobile_tasks_toolbarnav_header_next_week": "W przyszłym tygodniu",
    "mobile_tasks_toolbarnav_header_this_month": "W tym miesiącu",
    "mobile_tasks_toolbarnav_header_next_year": "W przyszłym roku",
    "mobile_tasks_toolbarnav_header_over_year": "W ciągu roku",
    "mobile_tasks_toolbarnav_title_edit_task": "Edytuj zadanie",
    "mobile_task_placeholder_title": "Tytuł *",
    "mobile_task_placeholder_description": "Opis (opcjonalnie)",
    "mobile_task_button_single_task": "Pojedyncze zadanie",
    "mobile_task_button_project": "Projekt",
    "mobile_task_button_create": "Utwórz",
    "mobile_task_tab_basic": "Podstawowy",
    "mobile_task_tab_photo": "Zdjęcie",
    "mobile_task_tab_form": "Formularz",
    "mobile_task_details_description_message_please": "Wypełnij ",
    "mobile_task_details_description_message_below": "poniżej.",
    "mobile_task_details_description_message_instructions": "Brak instrukcji do tego zadania.",
    "mobile_task_details_reason_title": "Kolejne działanie inicjowane przez",
    "mobile_task_detials_button_goto_form": "Przejdź do formularza",
    "mobile_task_detials_button_complete": " Zakończ zadanie",
    "mobile_task_detials_completed": "Ukończone ",
    "mobile_task_detials_completed_by": "przez ",
    "mobile_task_detials_completed_on": "dnia ",
    "mobile_task_details_view_form_submission": "Wyświetl formularz zgłoszenia",
    "mobile_task_task_updated": "Zaktualizowano zadanie",
    "mobile_task_task_archived": "Zarchiwizowano zadanie",
    "mobile_task_task_deleted": "Usunięto zadanie",
    "mobile_task_error_archiving_task": "Nie udało się zarchiwizować zadania.",
    "mobile_task_error_deleting_task": "Nie udało się usunąć zadania.",
    "mobile_task_error_updating_task": "Nie udało się zaktualizować zadania.",
    "mobile_task_archive_task": "Archiwizuj zadanie",
    "mobile_task_archive_task_confirm": "Czy na pewno zarchiwizować zadanie?\n\nZarchiwizowane zadania zostaną uwzględnione we wskaźnikach ukończenia i w raportach.\n\nTej operacji nie można cofnąć.",
    "mobile_task_delete_task_confirm": "Czy na pewno usunąć zadanie?\n\nUsunięte zadania nie zostaną uwzględnione we wskaźnikach ukończenia i w raportach.\n\nTej operacji nie można cofnąć.",
    "mobile_task_edition_already_in_progress": "To zadanie jest w trakcie edycji. Dalsze zmiany nie są obecnie możliwe.",
    "mobile_projects_filter_type": "Rodzaj",
    "mobile_projects_filter_status": "Status projektu",
    "mobile_projects_filter_project_type": "Rodzaj projektu",
    "mobile_projects_due_date_required": "Termin jest wymagany.",
    "mobile_projects_team_required": "Zespół jest wymagany.",
    "mobile_projects_user_role_required": "Osoba przypisana jest wymagana.",
    "mobile_projects_title_required": "Tytuł jest wymagany.",
    "mobile_projects_recurring_multiple_tasks_per_day": "Wiele zadań na dzień",
    "mobile_project_tasks_complete": " Zakończ",
    "mobile_project_tasks_remaining": " Pozostało",
    "mobile_esitmate_message_tasks": "Utworzymy 0 zadań",
    "mobile_esitmate_message_criteria": "Dostosuj kryteria powyżej",
    "mobile_esitmate_message_created_for": "do utworzenia dla",
    "mobile_left_menu_dashboard": "Pulpit",
    "mobile_left_menu_my_forms": "Moje formularze",
    "mobile_left_menu_announcements": "Ogłoszenia",
    "mobile_left_menu_my_submissions": "Moje zgłoszenia",
    "mobile_left_menu_drafts": "Wersje robocze",
    "mobile_left_menu_pending_uploads": "Przesyłanie w trakcie",
    "mobile_left_menu_open": "Otwórz w aplikacji",
    "mobile_left_menu_settings": "Ustawienia",
    "mobile_left_menu_log_out": "Wyloguj się",
    "mobile_left_menu_debug": "Debuguj",
    "mobile_left_menu_support": "Wsparcie",
    "mobile_left_menu_documentation": "Dokumentacja",
    "mobile_left_menu_chat": "Czat",
    "mobile_field_textarea_placeholder_note": "Notatka lub podpis",
    "mobile_field_option_select": "Wybierz",
    "mobile_field_text_placeholder_text": "Tekst",
    "mobile_field_email_placehoder_email": "Adres e-mail",
    "mobile_filed_number_placeholder_number": "Numer",
    "mobile_field_temprature_f": "F",
    "mobile_field_temprature_c": "C",
    "mobile_field_sensor_not_connected": "Brak połączenia",
    "mobile_field_sensor_offline_battery": "Czujnik offline - bateria",
    "mobile_field_video_button_add": "Dodaj wideo",
    "mobile_field_video_picker_dialog_title": "Dodaj wideo z",
    "mobile_field_video_button_change": "Zmień wideo",
    "mobile_field_image_button_add": "Dodaj obraz",
    "mobile_field_image_low_quality_warning": "Niektóre zdjęcia mogą być zbyt ciemne lub nieostre. Sprawdź wyróżnione zdjęcia i zastąp je w razie potrzeby.",
    "mobile_field_image_picker_dialog_title": "Dodaj zdjęcie z",
    "mobile_field_image_picker_edit_failed": "Nie można było zapisać obrazu. Spróbuj ponownie.",
    "mobile_field_signature_button_add": "Dodaj podpis",
    "mobile_field_signature_button_change": "Zmień podpis",
    "mobile_field_account_select_location": "Wybierz lokalizację",
    "mobile_field_account_prefill": "Uzupełnić formularz danymi z ostatniej wizyty?",
    "mobile_field_account_message_overwrite": "Wszystkie wypełnione pola zostaną nadpisane.",
    "mobile_forms_task_on_behalf": "Zadanie do wykonania w tej lokalizacji jest przypisane do użytkownika <b>{{user}}</b>. Czy chcesz zakończyć to zadanie?",
    "mobile_forms_complete_task": "Zakończyć zadanie?",
    "mobile_field_account_prefill_button_yes": "Tak, uzupełnij",
    "mobile_field_barcode_placeholder_scan": "Zeskanuj lub wpisz kod kreskowy",
    "mobile_field_sensor_qr_code_placeholder_scan": "Zeskanuj lub wpisz kod",
    "mobile_field_gateway_id_code_placeholder": "Wpisz ID węzła",
    "mobile_field_scan_qr_or_enter_dev_eui": "Zeskanuj kod QR lub wprowadź DevEUI",
    "mobile_field_scan_qr_or_enter_id": "Zeskanuj kod QR lub wprowadź nr ID",
    "mobile_field_scan_qr_or_enter_sc": "Zeskanuj kod QR lub wprowadź kod SC",
    "mobile_field_barcode_select_date": "Wybierz datę ",
    "mobile_field_datetime_allow_time": "Godzina",
    "mobile_field_stopwatch_button_caption": "Stoper",
    "mobile_field_stopwatch_common_start": "Start",
    "mobile_field_stopwatch_common_stop": "Stop",
    "mobile_field_stopwatch_common_reset": "Resetuj",
    "mobile_field_stopwatch_stop_stopwatches": "Zatrzymaj stopery",
    "mobile_field_document_title": "Dodaj dokument",
    "mobile_field_document_message_delete": "Czy na pewno usunąć dokument?",
    "mobile_field_document_alret_button_view": "Wyświetl",
    "mobile_field_document_alert_error": "Podczas załączania dokumentu wystąpił błąd. Spróbuj ponownie.",
    "mobile_field_document_alert_file_size_error": "Maksymalny rozmiar pliku to {{count}} MB.",
    "mobile_field_temperature_greater_range": "wyższa niż {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_greater_or_equal_range": "wyższa lub równa {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_less_range": "niższa niż {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_less_or_equal_range": "niższa lub równa {{ temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_between_range": "wyższa lub równa {{ min_temp_value }}°{{ temp_unit }} ale niższa niż {{ max_temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_inclusive_between_range": "wyższa lub równa {{ min_temp_value }}°{{ temp_unit }} ale niższa lub równa{{ max_temp_value }}°{{ temp_unit }}",
    "mobile_field_temperature_operators_separator": " i ",
    "mobile_field_text_limit_error": "Osiągnięto maksymalny limit znaków wynoszący 8000.",
    "mobile_forms_required_questions_complete": "Ukończenie wymagane",
    "mobile_forms_required_remaining": "Pozostało wymaganych: {{count}}",
    "mobile_forms_required_questions_back": "Wstecz",
    "mobile_forms_required_questions_next": "Dalej",
    "mobile_forms_required_questions_skip": "Pomiń",
    "mobile_forms_leaving_form": "Zamykanie formularza",
    "mobile_message_reordering_confirm": "Czy chcesz zapisać nową kolejność pytań?",
    "mobile_forms_leaving_reordering": "Opuszczanie zmiany kolejności pytań",
    "mobile_forms_reordering_button_save": "Zapisz nową kolejność pytań",
    "mobile_forms_reordering_instructions": "Aby zmienić kolejność pytań lub sekcji, przeciągnij pole w miejsce, w którym powinno się pojawić w formularzu",
    "mobile_toolbarnav_title_my_setttings": "Moje ustawienia",
    "mobile_toolbarnav_title_profile_settings": "Ustawienia profilu",
    "mobile_toolbarnav_title_notification": "Ustawienia powiadomień",
    "mobile_toolbarnav_title_form_history": "Historia formularza",
    "mobile_toolbarnav_title_form_not_available": "Formularz niedostępny",
    "mobile_toolbarnav_title_add_location": "Dodaj lokalizację",
    "mobile_toolbarnav_title_add_task_or_project": "Dodaj zadanie lub projekt",
    "mobile_toolbarnav_title_select_location": "Wybierz lokalizację",
    "mobile_toolbarnav_title_select_project": "Wybierz projekt",
    "mobile_toolbarnav_title_select_tag": "Wybierz znacznik",
    "mobile_toolbarnav_title_select_user": "Wybierz użytkownika",
    "mobile_toolbarnav_title_select_template": "Wybierz szablon",
    "mobile_toolbarnav_title_select_one": "Wybierz jeden",
    "mobile_toolbarnav_title_select_multiple": "Wybierz jeden lub więcej",
    "mobile_toolbarnav_title_select_team": "Wybierz zespół",
    "mobile_toolbarnav_title_select_team_or_location": "Wybierz zespół lub lokalizację",
    "mobile_toolbarnav_title_filter_tasks": "Filtruj zadania",
    "mobile_toolbarnav_title_filter_projects": "Filtruj projekty",
    "mobile_toolbarnav_title_filter_project_tasks": "Filtruj zadania projektowe",
    "mobile_placeholder_search_bar": "Szukaj",
    "mobile_placeholder_user_select_role": "Wybierz rolę użytkownika",
    "mobile_placeholder_filter_by_team": "Filtruj wg zespołu",
    "mobile_placeholder_assign_to_user_role": "Przypisz do roli użytkownika",
    "mobile_placeholder_select": "-- Wybierz --",
    "mobile_placeholder_account_location_name": "Nazwa lokalizacji",
    "mobile_placeholder_tag_filter_by": "Filtruj wg znacznika lokalizacji",
    "mobile_placeholder_user_type": "Przypisz użytkownikowi",
    "mobile_placeholder_acount_type_loading": "Ładowanie... ",
    "mobile_placeholder_therm_no_bluetooth": "Temperatura",
    "mobile_placeholder_blue_therm_connecting": "Łączenie z urządzeniem...",
    "mobile_placeholder_blue_therm_please_wait": "Proszę czekać...",
    "mobile_placeholder_blue_therm_tap": "Stuknij, aby przeczytać.",
    "mobile_placeholder_blue_therm_not_connected": "Brak połączenia.",
    "mobile_placeholder_testo_tap": "Przytrzymaj ▼▲, a następnie ⬆",
    "mobile_message_error_create_task": "Aby dodać zadanie, musisz być online.",
    "mobile_message_error_fill_out_form": "Wypełnij formularz.",
    "mobile_message_error_fill_require_fields": "Wypełnij wymagane pola.",
    "mobile_message_error_stop_stopwatch_before_submit": "Zatrzymaj stoper przed przesłaniem",
    "mobile_message_error_stopwatch_field_required": "Pole stopera jest wymagane",
    "mobile_message_error_stopwatch_field_running": "Pole stopera jest aktywne",
    "mobile_message_error_invalid_equipment_temperature": "Nieprawidłowa temperatura sprzętu",
    "mobile_message_error_invalid_ingredient_temperature": "Nieprawidłowa temperatura składnika",
    "mobile_message_error_location_attributes_unavailable": "Niektóre pytania mogą być niedostępne, połącz się z Internetem",
    "mobile_message_alert_running_stopwatches": "Masz aktywne stopery.\n\nCzy chcesz je zatrzymać?",
    "mobile_message_blue_therm_error": "Utracono połączenie z urządzeniem Bluetooth",
    "mobile_message_blue_therm_no_permission_android_pre_12": "Wymagany jest dostęp do lokalizacji. Włącz tę opcję w ustawieniach systemu Android.",
    "mobile_message_blue_therm_no_permission_android": "Wymagany jest dostęp do urządzeń w pobliżu. Włącz tę opcję w ustawieniach Androida.",
    "mobile_message_blue_therm_error_code": "Nie udało się połączyć:",
    "mobile_message_blue_therm_error_bluetooth": "Włącz Bluetooth.",
    "mobile_message_blue_therm_error_device": "Nie znaleziono urządzenia.",
    "mobile_message_blue_therm_error_try_again": "Spróbuj ponownie",
    "mobile_message_blue_therm_success": "Urządzenie Bluetooth połączone",
    "mobile_message_bluetooth_device_press_button_field": "Naciśnij przycisk na urządzeniu, aby połączyć.",
    "mobile_message_bluetooth_device_press_button_devices_list": "Naciśnij przycisk na urządzeniu,<br />jeśli nie ma go na liście.",
    "mobile_bluetooth_scan": "Skanuj",
    "mobile_bluetooth_scanning": "Skanowanie",
    "mobile_message_drafts_confirm": "Czy chcesz zapisać wersję roboczą?",
    "mobile_message_drafts_toast_saved": "Zapisano wersję roboczą.",
    "mobile_message_drafts_request_update": "Czy chcesz zaktualizować wersję roboczą?",
    "mobile_message_drafts_form_confirm": "Czy na pewno usunąć wersję roboczą?",
    "mobile_message_drafts_confirm_delete": "Usuń wersję roboczą",
    "mobile_message_streams_error_switch": "Nie można zmienić strumieni w sieci Web",
    "mobile_message_settings_success_saved": "Zapisano ustawienia",
    "mobile_message_settings_error": "Wystąpił nieznany błąd. Spróbuj ponownie później.",
    "mobile_message_profile_settings_error_fields": "Popraw błędy w podświetlonych polach.",
    "mobile_message_media_perimission_denied": "Twoje ",
    "mobile_message_media_perimission_denied_device": "Pamięć urządzenia",
    "mobile_message_image_confirm_remove_image": "Czy na pewno usunąć zdjęcie?",
    "mobile_message_create_account_error_fields": "Wypełnij podświetlone pola.",
    "mobile_message_create_account_success_location_created": "Utworzono lokalizację",
    "mobile_message_task_error_get_location": "Nie udało się uzyskać lokalizacji. Porządkowanie wg daty.",
    "mobile_message_typehead_confirm_save_message": "Czy chcesz zapisać te wybory?",
    "mobile_message_typehead_confirm_save_title": "Zapisać?",
    "mobile_message_task_creator_error_save_select_form": "Wybierz formularz.",
    "mobile_message_task_creator_error_save_required_fields": "Wypełnij wymagane pola.",
    "mobile_message_task_creator_error_save_batch_change": "Zmień kryteria, aby dopasować do jednego lub większej liczby użytkowników.",
    "mobile_message_task_detials_error_not_assigned_to_you": "Nie przypisano Ci tego zadania.<br />Nie możesz go ukończyć.",
    "mobile_message_task_detials_error_assigned_to": "To zadanie jest przypisane do użytkownika {{user}}.<br />Nie możesz go ukończyć.",
    "mobile_message_task_detials_confirm_title": "Zamykanie zadania",
    "mobile_message_task_detials_confirm_save_task": "Zapisz zadanie",
    "mobile_message_task_detials_confirm_message": "Czy na pewno? Twoje zmiany zostaną utracone.",
    "mobile_message_task_detials_error_view_account": "Nie można uzyskać dostępu do lokalizacji.",
    "mobile_message_task_detials_error_submit_task": "Dodaj zdjęcie, aby ukończyć to zadanie.",
    "mobile_message_task_detials_error_submit_task_project": "Nie można zapisać projektu. Spróbuj ponownie później.",
    "mobile_message_task_detials_wait_submit_task_created": "Trwa tworzenie zadań.<br />Poczekaj kilka minut na wypełnienie wartości.",
    "mobile_message_task_detials_error_submit_task_pending": "Wystąpił błąd. Spróbuj ponownie później.",
    "mobile_message_task_detials_success_task_complete": "Zadanie wykonane",
    "mobile_message_task_error_save_single_task": "Nie można zapisać zadania. Spróbuj ponownie później.",
    "mobile_message_task_success_save_single_task": "Utworzono zadanie.",
    "mobile_message_show_error_message": "Coś poszło nie tak.",
    "mobile_message_show_success_message": "Powodzenie!",
    "mobile_message_show_offline_message": "Jesteś obecnie offline.",
    "mobile_message_show_permission_denied_message": "<b>Wymagane uprawnienia.</b> Nadaj Zenput uprawnienia dostępu do {{permission_name}}.",
    "mobile_message_show_permission_denied_message_web": "<b>Wymagane uprawnienia.</b> Zezwól Zenput i swojej przeglądarce na dostęp do {{permission_name}}.",
    "mobile_message_show_begin_uploading_message": "Trwa wysyłanie",
    "mobile_message_show_upload_in_progress_message": "Wysyłanie w toku",
    "mobile_message_show_form_id_error": "Nie można uzyskać dostępu do formularza.",
    "mobile_message_show_single_task_error": "Nie można uzyskać dostępu do zadania.",
    "mobile_message_show_submissions_error": "Nie można uzyskać dostępu do zgłoszenia.",
    "mobile_message_show_submissions_access_denied": "Przepraszamy, nie masz dostępu do tego formularza.",
    "mobile_message_send_data_success": "Dane przesłane ",
    "mobile_message_start_upload_success": "Wysyłanie zakończone",
    "mobile_message_start_upload_error": "<b>Nie można zakończyć wysyłania.</b><br>Zgłoszenie zapisane. Spróbuj ponownie później.",
    "mobile_message_store_upgrade_store_ios": "App Store",
    "mobile_message_store_upgrade_store_android": "Sklep Play",
    "mobile_message_store_upgrade_confirm_title": "Dostępna aktualizacja",
    "mobile_message_store_upgrade_confirm_message_one": "Zaktualizuj aplikację Ops Execution ",
    "mobile_message_store_upgrade_confirm_message_one_old": "Zaktualizuj Zenput w ",
    "mobile_message_store_upgrade_confirm_message_two": " i skorzystaj z najnowszych funkcji i poprawek.",
    "mobile_message_store_upgrade_confirm_now": "Teraz",
    "mobile_message_store_upgrade_confirm_later": "Później",
    "mobile_message_redirect_confirm_message": "Jesteś w trakcie wypełniania formularza. Czy chcesz go zapisać jako wersję roboczą zanim przejdziesz dalej?",
    "mobile_message_log_out_confirm_unsynced_drafts": "Masz niewysłane wersje robocze ({{count}}). Jeśli przejdziesz dalej, zostaną utracone. Czy potwierdzasz?",
    "mobile_message_draft_override_message": "Tę wersję roboczą zapisano na innym urządzeniu w dniu {{date}}. Zmiany dokonane na tym urządzeniu są niezgodne z tą wersją roboczą. Możesz nadpisać istniejącą wersję lub załadować najnowszą wersję, jednak wtedy Twoje zmiany zostaną odrzucone.",
    "mobile_html_submitting": "Przesyłanie...",
    "mobile_html_offline": "Jesteś obecnie offline.",
    "mobile_html_offline_try_again": "Jesteś obecnie offline.<br/><br/>Połącz się i spróbuj ponownie.",
    "mobile_html_something_went_wrong": "Oj, coś poszło nie tak.",
    "mobile_html_something_went_wrong_try_again": "Oj, coś poszło nie tak. Spróbuj ponownie.",
    "mobile_html_failed_loading_roles": "Nie można załadować ról.",
    "mobile_alert_please_install_for_native": "Aby skorzystać z tej funkcji, zainstaluj aplikację Ops Execution. ",
    "mobile_alert_please_install_for_native_old": "Zainstaluj natywną wersję aplikacji Zenput, aby skorzystać z tej funkcji.",
    "mobile_tso_filter_all_tasks": "Wszystkie {{type}}",
    "mobile_tso_filter_my_tasks": "Moje {{type}}",
    "mobile_tso_filter_due_date": "Termin realizacji",
    "mobile_tso_filter_date_completed": "Termin ukończenia",
    "mobile_tso_filter_completed": "Ukończone",
    "mobile_tso_filter_completed_late": "Ukończono z opóźnieniem",
    "mobile_tso_filter_incomplete": "Nieukończone",
    "mobile_tso_filter_var_my_tasks": "Moje {{filter_type}} {{type}}",
    "mobile_tso_filter_var_tasks_created_by_me": "{{filter_type}} {{type}} utworzone przeze mnie",
    "mobile_tso_filter_var_all_tasks": "Wszystkie {{filter_type}} {{type}}",
    "mobile_tso_type_follow_up_actions": "Kolejne czynności",
    "mobile_tso_type_all": "Zadania i kolejne czynności",
    "mobile_tso_filter_var_at": " w {{location}}",
    "mobile_tso_filter_group_date_due": ", uporządkowane wg Terminu realizacji",
    "mobile_tso_filter_group_distance": ", zgrupowane wg Lokalizacji",
    "mobile_tso_filter_start_date": "Data rozpoczęcia",
    "mobile_tso_filter_none": "Brak",
    "mobile_pso_filter_all_projects": "Wszystkie projekty",
    "mobile_pso_filter_my_projects": "Moje projekty",
    "mobile_pso_filter_active": "Aktywne",
    "mobile_pso_filter_archived": "Zarchiwizowane",
    "mobile_pso_filter_recurring": "Cykliczne",
    "mobile_pso_filter_non_recurring": "Niecykliczne",
    "mobile_pso_filter_var_my_projects": "Moje projekty ({{project_type}} {{active_description}})",
    "mobile_pso_filter_var_my_created_projects": "Projekty utworzone przeze mnie ({{project_type}} {{active_description}})",
    "mobile_pso_filter_var_all_projects": "Wszystkie projekty ({{project_type}} {{active_description}})",
    "mobile_empty_list_message_must_be_online": "Wygląda na to, że jesteś offline. Połącz się, aby wyświetlić wyniki.",
    "mobile_empty_list_message_no_submissions": "Brak zgłoszeń",
    "mobile_empty_list_message_no_activity": "Brak aktywności",
    "mobile_empty_list_message_no_tasks": "Brak zadań",
    "mobile_empty_list_message_no_tasks_overdue": "Brak zaległych {{type}}",
    "mobile_empty_list_message_no_accounts": "Brak lokalizacji",
    "mobile_empty_list_message_no_projects": "Brak projektów",
    "mobile_empty_list_message_no_results_found": "Nie znaleziono wyników",
    "mobile_empty_list_message_no_forms_available": "Brak dostępnych formularzy",
    "mobile_empty_list_message_connection_error": "Błąd połączenia.<br />Spróbuj ponownie później.",
    "mobile_empty_list_message_dashboard_error": "Nie można załadować pulpitu",
    "mobile_empty_list_message_user_offline": "Jesteś obecnie offline.",
    "mobile_action_sheet_media_gallery": "Galeria",
    "mobile_action_sheet_cancel": "Anuluj",
    "mobile_image_preview_text": "Usuń zdjęcie",
    "mobile_mobileform_text": "Poprzednie zgłoszenia",
    "mobile_mobileform_reorder_fields": "Zmień kolejność pytań",
    "mobile_mobileform_follow_up_actions": "Dalsze czynności",
    "mobile_mobileform_follow_up_actions_assign_title": "Przypisz kolejne czynności",
    "mobile_mobileform_follow_up_actions_assign_subtitle": "Dodaj kolejne czynności na podstawie swoich obserwacji, aby zapewnić podjęcie odpowiednich działań wobec zidentyfikowanych problemów.",
    "mobile_mobileform_follow_up_actions_add_button": "+ Dodaj kolejną czynność",
    "mobile_mobileform_follow_up_actions_assign_button": "Przypisz kolejne czynności",
    "mobile_mobileform_follow_up_actions_without_assign_button": "Kontynuuj bez przypisywania",
    "mobile_mobileform_follow_up_actions_dialog_title": "Czy kontynuować bez przypisywania kolejnych czynności?",
    "mobile_mobileform_follow_up_actions_dialog_subtitle": "W przypadku kontynuacji bez przypisania kolejnych czynności nie będzie można ich dodać później.",
    "mobile_mobileform_follow_up_actions_dialog_continue_button": "Kontynuuj mimo to",
    "mobile_mobileform_add_follow_up_actions_forms_required": "To pole jest wymagane",
    "mobile_mobileform_add_follow_up_actions_forms_too_many_characters": "Za dużo znaków",
    "mobile_mobileform_add_follow_up_actions_forms_generic": "To pole jest nieprawidłowe",
    "mobile_mobileform_add_follow_up_actions_error_locations": "Błąd ładowania lokalizacji",
    "mobile_mobileform_add_follow_up_actions_error_users": "Błąd ładowania użytkowników",
    "mobile_mobileform_add_follow_up_actions_add_follow_up": "Dodaj kolejną czynność",
    "mobile_mobileform_add_follow_up_actions_forms_title": "Tytuł",
    "mobile_mobileform_add_follow_up_actions_forms_description": "Opis",
    "mobile_mobileform_add_follow_up_actions_forms_photo": "Wymagaj zdjęcia",
    "mobile_mobileform_add_follow_up_actions_forms_due_date": "Termin realizacji",
    "mobile_mobileform_add_follow_up_actions_forms_update_button": "Aktualizuj kolejną czynność",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_title": "Czy usunąć kolejną czynność?",
    "mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle": "Zostanie ona usunięta i nie będzie przypisana.",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_title": "Usuń kolejną czynność",
    "mobile_mobileform_follow_up_actions_forms_delete_modal_subtitle": "Czy na pewno usunąć tę kolejną czynność?\n\nTej operacji nie można cofnąć.",
    "mobile_mobileform_continue_with_follow_up_actions_btn": "Przejdź do kolejnych czynności",
    "mobile_mobileform_follow_up_actions_completed_notification": "Kolejna czynność zakończona",
    "mobile_mobileform_follow_up_actions_deleted_notification": "Kolejna czynność usunięta",
    "mobile_mobileform_follow_up_actions_update_notification": "Kolejna czynność zaktualizowana",
    "mobile_mobileform_follow_up_actions_required_photo_error": "Dodaj zdjęcie, aby zakończyć tę kolejną czynność",
    "mobile_mobileform_follow_up_actions_navigate_to_submission": "Przejdź do zgłoszenia",
    "mobile_mobileform_follow_up_actions_navigate_to_source": "Przejdź do źródła",
    "mobile_mobileform_follow_up_actions_navigate_to_source_title": "Źródło",
    "mobile_mobileform_follow_up_actions_complete_follow_up_action": "Zakończ kolejną czynność",
    "mobile_mobileform_follow_up_actions_submission_dialog_description": "Jeśli otworzysz zgłoszenie, wszelkie niezapisane zdjęcia lub uwagi zostaną utracone.",
    "mobile_mobileform_follow_up_actions_source_dialog_description": "Jeśli opuścisz ten ekran, wszelkie niezapisane zdjęcia i uwagi zostaną utracone.",
    "mobile_mobileform_follow_up_actions_submission_dialog_stay": "Pozostań tutaj",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_submission": "Otwórz zgłoszenie",
    "mobile_mobileform_follow_up_actions_submission_dialog_open_source": "Otwórz źródło",
    "mobile_mobileform_follow_up_actions_submission_dialog_title": "Czy opuścić tę kolejną czynność?",
    "mobile_mobileform_follow_up_actions_submission": "Zgłoszenie",
    "mobile_mobileform_follow_up_actions_error_not_assigned_to_you": "Ta kolejna czynność jest przypisana do {{user}}.<br />Nie możesz jej zakończyć.",
    "mobile_mobileform_follow_up_actions_leave_description": "Jeśli opuścisz ten ekran, wszelkie niezapisane zmiany zostaną utracone.",
    "mobile_mobileform_follow_up_actions_leave": "Wyjdź",
    "mobile_forms_drafts_text": "Usuń wersje robocze",
    "mobile_batch_estimate_user": "Użytkownik",
    "mobile_batch_estimate_users": "Użytkownicy",
    "mobile_table_of_contents": "Spis treści",
    "mobile_table_of_contents_required": "Wymagane",
    "mobile_table_of_contents_optional": "Opcjonalne",
    "mobile_dialog_alert_title": "Alert",
    "mobile_dialog_alert_ok": "OK",
    "mobile_windows_10_bluetherm_not_supported": "Urządzenia Bluetooth jeszcze nieobsługiwane w systemie Windows",
    "mobile_windows_deprecated_message_content_announcement": "Ogłoszenie",
    "mobile_windows_deprecated_message_title": "Wymagana jest aktualizacja aplikacji",
    "mobile_windows_deprecated_message_description": "Zainstaluj jak najszybciej nową aplikację Zenput z Microsoft Store, aby zapewnić kluczowe aktualizacje funkcjonalności i optymalne środowisko Zenput.",
    "mobile_dashboard_tcr_graph_name": "Wskaźnik ukończenia zadań",
    "mobile_dashboard_tcr_graph_query_timerange_desc": "Ostatnie 4 tygodnie",
    "mobile_dashboard_tcr_legend_company_average": "Średnia firmy",
    "mobile_dashboard_tcr_legend_team_average": "Średnia zespołu",
    "mobile_dashboard_tab_title_summary": "Podsumowanie",
    "mobile_dashboard_tab_title_activity": "Aktywność",
    "mobile_dashboard_card_title_top_triggered_workflows": "Najważniejsze wyzwalacze",
    "mobile_dashboard_tab_title_info": "Informacje",
    "mobile_dashboard_tab_project_audit": "Zgodność",
    "mobile_dashboard_card_task_stats_total": "Łącznie",
    "mobile_dashboard_top_item_header_week_of": "Tydzień",
    "mobile_dashboard_card_filter_form_template_placeholder": "Wszystkie formularze",
    "mobile_dashboard_card_title_forms_top_nos": "Częste odmowy",
    "mobile_dashboard_zenput_code_no_data_in_range": "Brak danych dla tego zakresu czasowego.",
    "mobile_dashboard_zenput_code_permission_denied": "Nie masz uprawnień, by to wyświetlić.",
    "mobile_dashboard_zenput_code_no_form_template_selected": "Wybierz formularz powyżej.",
    "mobile_dashboard_zenput_code_unknown_error": "Nie można obecnie wyświetlić danych.",
    "mobile_dashboard_tap_to_retry": "Stuknij, aby ponowić",
    "mobile_dashboard_reporting_delay_disclaimer": "Aktualizacja zadań może zająć do 15 minut",
    "mobile_dashboard_configuration_down_state_postfix_msg": "skonfigurowane przez administratora",
    "mobile_tasks_tag": "zadania",
    "mobile_workflows_tag": "wyzwalacze",
    "mobile_projects_tag": "projekty cykliczne",
    "mobile_forms_tag": "formularze",
    "mobile_dashboard_card_ongoing_projects_title": "Projekty w toku",
    "mobile_dashboard_card_ongoing_projects_show_more": "Pokaż więcej",
    "mobile_dashboard_card_ongoing_projects_show_less": "Pokaż mniej",
    "mobile_dashboard_card_ongoing_projects_go_to_projects": "Przejdź do projektów",
    "mobile_dashboard_card_title_recurring_projects": "Projekty cykliczne",
    "mobile_dashboard_card_filter_daily": "Codziennie",
    "mobile_dashboard_card_filter_weekly": "Co tydzień",
    "mobile_dashboard_card_filter_monthly": "Co miesiąc",
    "mobile_task_status_title_open": "Otwarte",
    "mobile_task_status_title_upcoming": "Nadchodzące",
    "mobile_task_status_title_complete": "Zakończone",
    "mobile_task_status_title_processing": "Przetwarzanie zgłoszenia",
    "mobile_task_status_title_complete_with_exceptions": "Ukończone z kolejnymi działaniami lub alertami",
    "mobile_task_status_title_completed_late_with_exceptions": "Ukończono z opóźnieniem z kolejnymi zadaniami lub alertami",
    "mobile_task_status_title_incomplete_and_closed": "Pominięte",
    "mobile_tasks_legend_modal_title": "Legenda",
    "mobile_tasks_legend_modal_footer_button_title": "Zamknij",
    "mobile_common_assigned_to": "Przypisane użytkownikowi",
    "mobile_common_created_by": "Utworzone przez:",
    "mobile_common_tasks_for": "Zadania dla:",
    "mobile_common_go_back": "Wstecz",
    "mobile_oh_no": "O, nie!",
    "mobile_user_not_in_groups": "Niestety, wygląda na to, że nie przypisano Cię do zespołu. Skontaktuj się ze swoim administratorem, aby uzyskać dostęp do pulpitu.",
    "mobile_tasks_select_followers": "Wybierz obserwujących",
    "mobile_tasks_assign_tasks": "Przypisz zadania ({{count}})",
    "mobile_tasks_add_followers": "Dodaj obserwujących",
    "mobile_tasks_followers": "Obserwujący",
    "mobile_tasks_delete_task": "Usuń zadanie",
    "mobile_tasks_create_task": "Utwórz zadania",
    "mobile_tasks_tab_title_comments": "Komentarze",
    "mobile_tasks_see_more": "Zobacz więcej",
    "mobile_projects_create_project": "Utwórz projekt",
    "mobile_common_button_send": "Wyślij",
    "mobile_common_button_schedule": "Zaplanuj",
    "mobile_announcements_create": "Utwórz ogłoszenie",
    "mobile_announcements_read_rate": "Otwarte: {{opened_count}} z {{recipients_count}}",
    "mobile_announcements_empty_message": "Nie utworzono jeszcze żadnych ogłoszeń! Utwórz ogłoszenie poniżej, aby rozsyłać ważne wiadomości, informacje i aktualizacje w swojej organizacji.",
    "mobile_announcement_message_placeholder": "Dodaj wiadomość...",
    "mobile_announcement_title_placeholder": "Tytuł ogłoszenia",
    "mobile_announcement_leaving_announcement": "Zamykanie ogłoszenia",
    "mobile_announcement_confirm_recipients_team": "Czy chcesz rozesłać o ogłoszenie do użytkowników ({{count}}) w następującej liczbie wybranych zespołów: {{teams}}?",
    "mobile_announcement_confirm_recipients_role": "Czy chcesz rozesłać o ogłoszenie do użytkowników ({{count}}) w następującej liczbie wybranych roli użytkowników: {{roles}}?",
    "mobile_announcement_confirm_recipients_user": "Czy chcesz rozesłać o ogłoszenie do następującej liczby użytkowników: {{count}}?",
    "mobile_announcement_confirm_scheduled": "Dnia {{timestamp}}",
    "mobile_announcement_sending_announcement": "Wysyłanie ogłoszenia",
    "mobile_announcement_send_to": "Wyślij do",
    "mobile_announcement_sent_to": "Wysłano do",
    "mobile_announcement_send_to_role": "Rola",
    "mobile_announcement_attachment_download": "Pobieranie pliku {{filename}}",
    "mobile_announcement_attachment_validation_error": "Można dodać maksymalnie {{maxCount}} załączniki(-ów)",
    "mobile_announcement_details_sent": "Wysłano",
    "mobile_announcement_details_total_recipients": "Odbiorcy łącznie",
    "mobile_announcement_details_cancel": "Anuluj ogłoszenie",
    "mobile_announcement_details_not_editable": "Ogłoszenia można edytować wyłącznie w aplikacji internetowej Ops Execution ",
    "mobile_announcement_details_not_editable_old": "Ogłoszenia można edytować tylko w Zenput Web",
    "mobile_announcement_details_open_count": "Liczba otwartych",
    "mobile_announcement_details_open_rate": "Wskaźnik otwarcia",
    "mobile_announcement_details_resend": "Wyślij ponownie do osób, które nie otworzyły",
    "mobile_announcement_confirm_resend": "Następująca liczba użytkowników nie przeczytała ogłoszenia: {{count}}. Czy chcesz wysłać przypomnienie?",
    "mobile_announcement_confirm_resend_title": "Wysłać przypomnienie?",
    "mobile_announcement_recipients_opened": "Otwarte",
    "mobile_recipients_opened_empty_message": "Wygląda na to, że nikt jeszcze nie otworzył Twojej wiadomości. Wróć później, żeby wyświetlić wyniki.",
    "mobile_announcement_recipients_unopened": "Nieotwarte",
    "mobile_recipients_unopened_empty_message": "Dobre wieści! Nie ma żadnych nieotwartych wiadomości!",
    "mobile_scheduled_announcements_delivery_section_header": "Czas dostarczenia",
    "mobile_scheduled_announcements_send_immediately_label": "Wyślij natychmiast",
    "mobile_scheduled_announcements_scheduled_label": "Wyślij w określonym czasie",
    "mobile_scheduled_announcements_scheduled_tab_label": "Zaplanowane",
    "mobile_scheduled_announcements_dialog_header": "Anulować ogłoszenie?",
    "mobile_scheduled_announcements_dialog_message": "Anulowanie ogłoszenia zatrzyma jego wysłanie i usunie go z listy. Nie można cofnąć tej operacji. Aby edytować, przejdź do Zenput Web.",
    "mobile_scheduled_announcements_empty_message": "Obecnie nie masz żadnych zaplanowanych ogłoszeń. Zaplanuj ogłoszenie, aby rozsyłać ważne wiadomości, informacje i aktualizacje w swojej organizacji.",
    "mobile_scheduled_announcements_validation_error": "Czas dostarczenia musi wypadać po {{date}}",
    "mobile_scheduled_announcements_empty_state_button": "Zaplanuj ogłoszenie",
    "mobile_projects_auto_archive": "Automatycznie archiwizuj",
    "mobile_common_unassigned": "Nieprzypisane",
    "mobile_tasks_title_placeholder": "Nowe zadanie lub nowy formularz",
    "mobile_projects_leaving_project": "Zamknij projekt",
    "mobile_projects_save_project": "Zapisz projekt",
    "mobile_top_triggers_tasks": "Najczęściej rozpoczynane zadania",
    "mobile_top_triggers_alerts": "Najczęściej wyzwalane alerty",
    "mobile_projects_not_started": "Nie rozpoczęto",
    "mobile_empty_list_message_no_photos": "Brak zdjęć",
    "mobile_webfilestore_message_error": "Wybierz prawidłowy rodzaj pliku",
    "mobile_notifications_empty_title": "Brak powiadomień",
    "mobile_notifications_empty_message": "Tutaj będzie widoczna aktywność dot. Twoich zadań lub zadań, w których uczestniczysz.",
    "mobile_comments_comment_deleted": "Ten komentarz został usunięty.",
    "mobile_comments_comment_placeholder": "Komentarz",
    "mobile_comments_task_submitted_at": "Zadanie przesłane w dniu {{ date }} o godzinie {{ time }}",
    "mobile_comments_discard_comment_title": "Odrzucić komentarz?",
    "mobile_comments_discard_confirm_message": "Czy na pewno? Twój komentarz zostanie usunięty.",
    "mobile_comments_delete_comment_title": "Usunąć komentarz?",
    "mobile_comments_delete_confirm_message": "Tej operacji nie będzie można cofnąć.",
    "mobile_comments_delete_button": "Usuń komentarz",
    "mobile_comments_delete_success_message": "Usunięto komentarz",
    "mobile_comments_empty_message_tasks": "Nie ma jeszcze komentarzy \n Rozpocznij rozmowę na temat tego zadania.",
    "mobile_comments_empty_message_submissions": "Nie ma jeszcze komentarzy \n Rozpocznij rozmowę na temat tego zgłoszenia.",
    "mobile_comments_empty_message_default": "Nie ma jeszcze komentarzy \n Rozpocznij rozmowę.",
    "mobile_comments_no_matching_users": "Brak pasujących użytkowników.",
    "mobile_comments_empty_users_to_notify": "Brak użytkowników do powiadomienia.",
    "mobile_comments_users_cant_view_message": "Ci użytkownicy nie mogą wyświetlić tych komentarzy.",
    "mobile_comments_users_to_notify_title": "Użytkownicy do powiadomienia",
    "mobile_comments_mention_description_notifiers": "Powiadomimy <a href=\"#\" class=\"show_users_to_notify\">{{ count }} użytkownika</a>.",
    "mobile_comments_mention_description_notifiers_plural": "Powiadomimy <a href=\"#\" class=\"show_users_to_notify\">{{ count }} użytkowników</a>.",
    "mobile_comments_mention_instructions": "Powiadom innych użytkowników za pomocą <a href=\"#\" class=\"open_mention_autocomplete\">@wzmianki</a>.",
    "mobile_comments_mark_read": "Oznacz wszystkie jako przeczytane",
    "mobile_comments_author_mentioned_message": "wspomniał Cię w",
    "mobile_comments_author_commented_message": "skomentował",
    "mobile_view_pdf": "Wyświetl plik PDF",
    "mobile_no_pdf_generated_message": "Nie znaleziono pliku PDF do tego zgłoszenia. Kopia zostanie wkrótce przesłana pocztą elektroniczną.",
    "mobile_clipboard_copied_success": "Link skopiowany do schowka.",
    "mobile_share_link": "Udostępnij link",
    "mobile_zencam_share": "Udostępnij",
    "mobile_zencam_view_details": "Wyświetl szczegóły",
    "mobile_zencam_details_drawer_header": "Szczegóły",
    "mobile_zencam_submitted_by": "Przesłane przez",
    "mobile_zencam_form_title": "Tytuł formularza",
    "mobile_zencam_date_submitted": "Data przesłania",
    "mobile_oil_quality_warning_message": "Termin ważności oleju niedługo wygaśnie",
    "mobile_oil_quality_warning_message_subtitle": "Zaplanuj jego wymianę wkrótce",
    "mobile_oil_quality_failure_message": "Obniżona jakość oleju",
    "mobile_oil_quality_failure_message_subtitle": "Wymień olej natychmiast",
    "mobile_sensors_set_up_gateway": "Skonfiguruj bramkę",
    "mobile_sensors_set_up_gateway_message": "Wygląda na to, że nie ma skonfigurowanych żadnych urządzeń. Zacznij od dodania bramki.",
    "mobile_sensors_gateway_plugged_in": "Upewnij się, że bramka jest podłączona do gniazdka elektrycznego.",
    "mobile_sensors_add_device": "Dodaj urządzenie",
    "mobile_sensors_name_this_gateway": "Nazwij tę bramkę.",
    "mobile_sensors_name_this_sensor": "Nazwij ten czujnik.",
    "mobile_sensors_device_barcode_information": "Zeskanuj kod QR lub wprowadź ID i numer SC z etykiety urządzenia",
    "mobile_sensors_device_eui_information": "Zeskanuj kod QR lub wprowadź DevEUI z etykiety urządzenia",
    "mobile_sensors_gateway_id_information": "Wprowadź ID węzła z etykiety bramki",
    "mobile_sensors_id_number": "{{untranslatedID}} — numer",
    "mobile_sensors_sc_code": "{{untranslatedSCCode}} — kod",
    "mobile_sensors_sensors": "Czujniki",
    "mobile_sensors_sensor_deveui_error": "Nie udało się pozyskać DevEUI z QR. Wprowadź ręcznie.",
    "mobile_sensors_gateways": "Bramki",
    "mobile_sensors_add_sensor": "Dodaj czujnik",
    "mobile_sensors_add_gateway": "Dodaj bramkę",
    "mobile_sensor_placement_description": "Jaki obszar będzie monitorował ten czujnik?",
    "mobile_sensors_equipment_placement": "Jaki obszar lub sprzęt będzie monitorował ten czujnik?",
    "mobile_sensors_equipment": "Jaki sprzęt będzie monitorował ten czujnik?",
    "mobile_sensors_select_gateway_type": "Wybierz typ bramy",
    "mobile_sensors_select_placement": "Wybierz miejsce",
    "mobile_sensors_select_equipment": "Wybierz sprzęt",
    "mobile_sensors_placement": "Miejsce",
    "mobile_sensors_nickname_tip": "Nazewnictwo czujników jest określane przez nicki przypisane w wybranym miejscu.",
    "mobile_sensors_device_online": "Online",
    "mobile_sensors_device_offline": "Offline",
    "mobile_sensors_scan_qrcode": "Zeskanuj kod QR",
    "mobile_sensors_enter_manually": "Wprowadź ręcznie",
    "mobile_sensors_wizard_step_one": "Krok 1",
    "mobile_sensors_wizard_step_two": "Krok 2",
    "mobile_sensors_wizard_step_three": "Krok 3",
    "mobile_sensors_wizard_step_four": "Krok 4",
    "mobile_sensors_wizard_step_five": "Krok 5",
    "mobile_sensors_wizard_step_six": "Krok 6",
    "mobile_sensors_initializing": "Inicjowanie...",
    "mobile_sensors_nickname": "Nick",
    "mobile_sensors_field_not_blank": "Pole {{field}} nie może być puste.",
    "mobile_sensors_nothing_to_see_here": "Niczego tu nie ma",
    "mobile_sensors_missing_integration": "Brak integracji czujnika",
    "mobile_sensors_contact_zenput_admin": "Prosimy o kontakt z administratorem ds. Ops Execution w Twojej firmie.",
    "mobile_sensors_contact_zenput_admin_old": "Skontaktuj się ze swoim administratorem Zenput.",
    "mobile_sensors_contact_manager": "Skontaktuj się z administratorem konta, aby dodać czujniki.",
    "mobile_sensors_device_success_message": "Ładowanie danych czujnika może zająć do 15 minut.",
    "mobile_sensors_last_reading": "Ostatni odczyt",
    "mobile_sensors_remove_device": "Usuń urządzenie",
    "mobile_sensors_one_day": "1D",
    "mobile_sensors_one_week": "1T",
    "mobile_sensors_one_month": "1M",
    "mobile_sensors_three_months": "3M",
    "mobile_sensors_six_months": "6M",
    "mobile_sensors_one_year": "1R",
    "mobile_sensors_sensor_settings": "Ustawienia czujnika",
    "mobile_sensors_remove_confirm_message": "Czy na pewno usunąć to urządzenie?\nTej czynności nie można cofnąć.",
    "mobile_sensors_sensor": "Czujnik",
    "mobile_sensors_no_equipment_linked": "Nie połączono ze sprzętem",
    "mobile_sensor_cooldown_process": "Proces chłodzenia",
    "mobile_sensor_last_12_hours": "Ostatnie 12 godzin",
    "mobile_sensor_start_cooldown_process": "Rozpocznij nowy proces chłodzenia",
    "mobile_sensor_cooldown_process_title": "Proces chłodzenia dwustopniowego",
    "mobile_sensor_cooldown_process_description": "Proces chłodzenia dwustopniowego polega na schłodzeniu żywności od temperatury wyższej niż {{ stage1_start_temperature }} do {{ stage1_end_temperature }} w ciągu maksymalnie dwóch godzin, a następnie od temperatury {{ stage1_end_temperature }} do {{ stage2_end_temperature }} w ciągu maksymalnie czterech godzin.",
    "mobile_sensor_cooldown_process_place_food": "Umieść produkt spożywczy w lodówce.",
    "mobile_sensor_cooldown_process_insert_sensor": "Włóż sondę czujnika do produktu spożywczego.",
    "mobile_sensor_cooldown_process_enter_information": "Wprowadź informacje poniżej.",
    "mobile_sensor_cooldown_process_food_product": "Produkt spożywczy do schłodzenia",
    "mobile_sensor_cooldown_cool_down": "Chłodzenie",
    "mobile_sensor_cooldown_select_sensor": "Wybierz czujnik",
    "mobile_sensors_cooldown_start_cooldown": "Rozpocznij chłodzenie",
    "mobile_sensors_cooldown_please_enter_food": "Wprowadź produkt spożywczy",
    "mobile_sensors_cooldown_please_select_sensor": "Wybierz czujnik",
    "mobile_sensors_cooldown_status_in_progress": "W toku",
    "mobile_sensors_cooldown_status_failed": "Niepowodzenie",
    "mobile_sensors_cooldown_status_success": "Powodzenie",
    "mobile_sensors_cooldown_stage": "Etap",
    "mobile_sensors_cooldown_starting_temperature_out_of_range": "Temperatura początkowa jest poza zakresem",
    "mobile_sensors_cooldown_failed_cooldown_process": "Proces chłodzenia zakończony niepowodzeniem",
    "mobile_sensors_cooldown_cooldown_successful": "Proces chłodzenia zakończony pomyślnie",
    "mobile_sensors_cooldown_started_cooldown_process": "Rozpoczęto proces chłodzenia",
    "mobile_sensors_cooldown_hour": "godz.",
    "mobile_sensors_cooldown_hour_plural": "godz.",
    "mobile_sensors_cooldown_minute": "min",
    "mobile_minutes_plural": "min",
    "mobile_sensors_last_reading_max_date": "ponad rok temu",
    "mobile_sensors_minute_count_ago": "{{count}} minutę temu",
    "mobile_sensors_minute_count_ago_plural": "{{count}} min temu",
    "mobile_sensors_hour_count_ago": "{{count}} godzinę temu",
    "mobile_sensors_hour_count_ago_plural": "{{count}} godz. temu",
    "mobile_sensors_day_count_ago": "{{count}} dzień temu",
    "mobile_sensors_day_count_ago_plural": "{{count}} dni temu",
    "mobile_sensors_chart_settings": "Ustawienia wykresu",
    "mobile_announcement_banner_continue_reading": "Kontynuuj czytanie",
    "mobile_compliance_submissions_report": "Raport zgłoszeń",
    "mobile_compliance_submissions_report_subtitle": "Eksportuj dane ukończenia projektu dla tego sklepu",
    "mobile_compliance_send_submissions": "Wyślij zgłoszenia",
    "mobile_compliance_completion_rate_in_last_days": "Wskaźnik ukończenia z ostatnich {{ days }} dni",
    "mobile_compliance_last_days": "Ostatnie {{ days }} dni",
    "mobile_compliance_send_submissions_to": "Wyślij zgłoszenia do",
    "mobile_compliance_send_to_different_email": "Wyślij na inny adres e-mail",
    "mobile_compliance_email_input_placeholder": "Adres e-mail",
    "mobile_compliance_send_submissions_to_legend_title": "Zgłoszenia",
    "mobile_compliance_send_submissions_to_legend_description_days": "Raport ze zgłoszeniami z tej lokalizacji z ostatnich {{ days }} dni zostanie wysłany na wybrany adres e-mail.",
    "mobile_compliance_time_frame": "Przedział czasu",
    "mobile_compliance_sensor_temperature_log_report": "Raport logu temperatury czujnika",
    "mobile_compliance_sensor_temperature_log_report_subtitle": "Eksportuj logi temperatury dla tego sklepu",
    "mobile_compliance_sensor_temperature_log_criteria_title": "Kryteria",
    "mobile_compliance_sensor_temperature_log_criteria_instructions": "Zdefiniuj kryteria dla poniższego raportu.",
    "mobile_compliance_sensor_temperature_log_criteria_note": "Uwaga: Wyłączone czujniki nie będą wyświetlane w raporcie.",
    "mobile_compliance_sensor_temperature_log_criteria_time_frame": "Wybierz przedział czasu. Dane logu są ograniczone do maks. 30 dni",
    "mobile_compliance_sensor_temperature_log_criteria_submit_button": "Wyślij raport",
    "mobile_compliance_sensor_temperature_log_criteria_this_month": "W tym miesiącu (od 1. do dziś)",
    "mobile_compliance_sensor_temperature_log_criteria_last_month": "Ostatni miesiąc",
    "mobile_compliance_sensor_temperature_log_email_title": "Wyślij raport do",
    "mobile_pwa_update_prompt_title": "Zaktualizuj aplikację",
    "mobile_pwa_update_prompt_description": "Dostępna jest nowa wersja aplikacji. Zaktualizuj do najnowszej wersji.",
    "mobile_pwa_update_prompt_confirm": "Zaktualizuj i załaduj ponownie",
    "mobile_pwa_update_prompt_cancel": "Przypomnij mi później",
    "notification_title_due_in_one_hour": "Termin za godzinę",
    "task_is_due_soon": "Termin '{{ task_title }}' wkrótce minie. Poświęć chwilę, by dokończyć zadanie.",
    "mobile_photo_quality_warning_header": "Problem dotyczący jakości zdjęcia",
    "mobile_photo_quality_dialog_message": "To zdjęcie może być zbyt ciemne lub nieostre. Chcesz zrobić nowe zdjęcie, czy kontynuować z tym?",
    "mobile_take_new_photo": "Zrób nowe zdjęcie",
    "mobile_use_this_photo": "Użyj tego zdjęcia"
}};
export default mobile_translations;
